/* eslint-disable */
// @ts-nocheck
// @generated
// This file was automatically generated and should not be edited.
/**
 * @anchorage/graphql-types
 *
 * Centralized GraphQL types generated from backend schema and shared queries.
 * This package contains base types from the supergraph schema and hooks for shared queries.
 */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * AnyDestinationScopeInput is the input form of AnyDestinationScope and accepts the same values.
   * It binds to schema.AnyDestinationScope, whose UnmarshalGQL rejects an unsupported scope.
   */
  AnyDestinationScopeInput: { input: AnyDestinationScope; output: AnyDestinationScope; }
  /** AssetTypeID represents one of the asset types we support */
  AssetTypeID: { input: string; output: string; }
  /**
   * Define a Relay CursorType type:
   * https://relay.dev/graphql/connections.htm#sec-CursorType
   */
  CursorType: { input: string; output: string; }
  /**
   * YYYY-MM-DD
   * 2006-02-01
   * UTC business day
   */
  Date: { input: string; output: string; }
  /** An ISO-8601 encoded UTC date string */
  DateTime: { input: string; output: string; }
  /**
   * range [0,MAX_VALUE decimal type golang]
   * decimal separator `.`
   * eg: 1.11312123
   */
  Decimal: { input: string; output: string; }
  /**
   * DisplayPage is an ID for the page where the widget should be displayed on:
   *   - dashboard
   *   - vault
   *   - wallet_list
   *   - wallet_detail
   */
  DisplayPage: { input: string; output: string; }
  Email: { input: string; output: string; }
  /**
   * IndividualID identifies an institutional user
   * It may not be a user of the final organization
   */
  IndividualID: { input: string; output: string; }
  /** JSON is a raw JSON scalar type, used for JSON Schema and UI Schema payloads. */
  JSON: { input: unknown; output: unknown; }
  /**
   * A map type that can store key-value pairs where keys are strings and values can be any type.
   * In this case, maps AssetTypeID to a list of AssetTypeIDs.
   */
  Map: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** NetworkID represents a network we support, like BITCOIN_MAINNET, and BITCOIN_TESTNET */
  NetworkID: { input: string; output: string; }
  /** OperationIAMChanges contains the JSON encoded IAM changes that will be applied with an operation. */
  OperationIAMChanges: { input: string; output: string; }
  /** OperationID is a unique ID for an operation */
  OperationID: { input: string; output: string; }
  /**
   * range [0, 100]
   * decimal separator `.`
   * Precision up to 2 decimal places
   * eg: 0, 1.2, 2.53, 35.67, 100
   */
  Percent: { input: string; output: string; }
  /** PublicKeyID is the public key id for public key. This is usually a user's public key id */
  PublicKeyID: { input: string; output: string; }
  /**
   * RoleActionInput is the input-side counterpart to RoleAction. Only InputRolePermission, the
   * input to the changeRole mutation, uses it, and authorization is the only subgraph that
   * declares InputRolePermission.
   *
   * Authorization, custody, organization and graphqlmonolith all declare RoleAction, and
   * federation composes an enum used in both input and output position by exact match, so no
   * declarer can add a value on its own. Accepting the input through a scalar leaves RoleAction
   * output-only, where values compose by union and each declarer moves independently; see
   * source/go/service/apollorouter/cmd/gqlgen-enum-composition.
   *
   * The scalar binds to schema.RoleAction, whose UnmarshalGQL accepts the actions registered by
   * registerRoleAction in lib/dataprovider/schema/roles.go, rather than a second hand-written list.
   * An action missing from the HSM's api_permission_t enum is marked unsupportedByHSM there and is
   * rejected here, because naming it would create a role change that could never be signed.
   */
  RoleActionInput: { input: string; output: string; }
  /** The builtin Time type */
  Time: { input: string; output: string; }
  /**
   * Timestamp is serialized as a unix nanoseconds string.
   * Ex: {"Timestamp": "1257894021098046017"}
   */
  Timestamp: { input: string; output: string; }
  /** Uint64 represents an unsigned 64bit integer */
  Uint64: { input: string; output: string; }
  /**
   * Type of the key id
   * This can be a `USER` key id, a `API` key id, or a `SYSTEM` key id
   */
  UserKeyIDType: { input: string; output: string; }
  join__DirectiveArguments: { input: string; output: string; }
  join__FieldSet: { input: string; output: string; }
  join__FieldValue: { input: string; output: string; }
  link__Import: { input: string; output: string; }
};

/** Counterparty balance connection */
export type A1BalancesConnection = {
  __typename: 'A1BalancesConnection';
  /** List of edges containing balance entries and cursor information */
  edges: Array<A1BalancesEdge>;
  /** Page details for the associated list of balance entries */
  pageInfo: PageInfo;
};

/** Balance pagination edge */
export type A1BalancesEdge = {
  __typename: 'A1BalancesEdge';
  /** Cursor for the associated balance entry */
  cursor: Scalars['String']['output'];
  /** Balance entry */
  node: A1BalancesEntry;
};

/** A counterparty balance entry representing balances per counterparty and asset */
export type A1BalancesEntry = {
  __typename: 'A1BalancesEntry';
  /** Balance amount as a decimal string */
  amount: Scalars['String']['output'];
  /** Asset symbol */
  asset: Scalars['String']['output'];
  /** UUID of the counterparty account */
  counterpartyAccountId: Scalars['ID']['output'];
  /** Name of the counterparty account */
  counterpartyAccountName: Scalars['String']['output'];
  /** UUID of the counterparty */
  counterpartyId: Scalars['ID']['output'];
  /** Name of the counterparty */
  counterpartyName: Scalars['String']['output'];
  /** Time at which the entry was created */
  createdAt: Scalars['Timestamp']['output'];
  /** UUID keying the balance entry */
  id: Scalars['ID']['output'];
  /** Kind/type of the entry */
  kind: Scalars['String']['output'];
  /** Time at which the entry was last updated */
  updatedAt: Scalars['Timestamp']['output'];
};

/** Filter criteria for listing balance entries */
export type A1BalancesFilter = {
  /** List of asset symbols to filter by */
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of counterparty account IDs to filter by */
  counterpartyAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of counterparty IDs to filter by */
  counterpartyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of kinds to filter by */
  kinds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type A1TradeSubscription = {
  __typename: 'A1TradeSubscription';
  amount: Scalars['Decimal']['output'];
  assetTypeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  orgId: Scalars['ID']['output'];
  programCustomerId: Scalars['ID']['output'];
  rosterId: Scalars['String']['output'];
  subaccountId: Scalars['ID']['output'];
};

/** ACHCheck names a member of the ACH authorize step */
export enum ACHCheck {
  /** BALANCE is the source account balance check */
  BALANCE = 'BALANCE',
  /** NAME_MATCH is Plaid's identity match on the source account holder */
  NAME_MATCH = 'NAME_MATCH',
  /** SIGNAL is Plaid's return-risk check */
  SIGNAL = 'SIGNAL'
}

/** ACHCheckOutcome is the result of one authorize check that ran */
export type ACHCheckOutcome = {
  __typename: 'ACHCheckOutcome';
  /** check names the authorize check */
  check: ACHCheck;
  /** checkedAt is when the check ran */
  checkedAt: Scalars['Timestamp']['output'];
  /** isBusinessNameDetected is Plaid's business-name-detected flag. Set only on a NAME_MATCH entry. */
  isBusinessNameDetected: Maybe<Scalars['Boolean']['output']>;
  /** isFirstNameOrLastNameMatch is Plaid's first-or-last-name-match flag. Set only on a NAME_MATCH entry. */
  isFirstNameOrLastNameMatch: Maybe<Scalars['Boolean']['output']>;
  /** isNicknameMatch is Plaid's nickname-match flag. Set only on a NAME_MATCH entry. */
  isNicknameMatch: Maybe<Scalars['Boolean']['output']>;
  /** passed is true when the check passed */
  passed: Scalars['Boolean']['output'];
  /** score is Plaid's identity-match score. Set only on a NAME_MATCH entry, where null is a recorded reject. */
  score: Maybe<Scalars['Int']['output']>;
};

export type AMLBlockchainAddress = {
  __typename: 'AMLBlockchainAddress';
  /** address which was provided */
  address: BlockchainAddress;
  addressKey: Scalars['ID']['output'];
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** id is the unique key for this AMLBlockchainAddress (orgKeyID:network:address), equal to addressKey */
  id: Scalars['ID']['output'];
};

/** Previously submitted AML answers for prefilling new questionnaire flow */
export type AMLPrefillAnswers = {
  __typename: 'AMLPrefillAnswers';
  /** List of answers to use for prefilling */
  answers: Array<QuestionnaireAnswer>;
  /**
   * If a banner should be shown to the user, given on first new questionnaire
   * when the org has previously submitted AML records on any address,
   * for the first 6 months after launching the new questionnaire
   */
  showBanner: Scalars['Boolean']['output'];
};

/** AMLRecord stores responses to AMLQuestions for an operation */
export type AMLRecord = {
  __typename: 'AMLRecord';
  /** The list of responses */
  entries: Array<AMLRecordEntry>;
  /** Unique identifier for this AML record (submissionID or composite key) */
  id: Scalars['ID']['output'];
  /** Whether this AML record uses the legacy questionnaire format */
  isLegacy: Scalars['Boolean']['output'];
  /** Submission on the questionnaire flow (federated reference to graphqlmonolith) */
  submission: Maybe<QuestionnaireSubmission>;
};

/** AMLRecordEntry stores a single AMLQuestion and its response */
export type AMLRecordEntry = {
  __typename: 'AMLRecordEntry';
  /** The text for this question */
  question: Scalars['String']['output'];
  /** The ID for this question */
  questionID: Scalars['String']['output'];
  /** Short label for the question (shown in review) */
  questionLabel: Scalars['String']['output'];
  /** The subtitle for this question (if any) */
  questionSubtitle: Scalars['String']['output'];
  /** The response for this question */
  response: Maybe<AMLRecordEntryResponse>;
};

/** AMLRecordEntryResponse contains the response to a single AMLQuestion */
export type AMLRecordEntryResponse = {
  __typename: 'AMLRecordEntryResponse';
  /** The ID for this choice */
  choiceID: Scalars['String']['output'];
  /** Combined value and/or freeFormValue for display in a single field */
  combinedDisplayValue: Scalars['String']['output'];
  /** The value, if present, of a freeform response */
  freeFormValue: Maybe<Scalars['String']['output']>;
  /** The text for this possible answer choice displayed in a list of possible answers */
  value: Scalars['String']['output'];
};

/**
 * Type that holds metadata referring to a REST API key.
 * The key itself should never be shared through this type,
 * since it is effectively a password.
 */
export type APIKey = {
  __typename: 'APIKey';
  /**
   * Indicates if this API key can still be used.
   * @deprecated Use status because it includes more detailed information.
   */
  active: Scalars['Boolean']['output'];
  /** Version of API key is valid for */
  apiVersion: Scalars['String']['output'];
  /** Creation date with nano precision. */
  createdAt: Scalars['String']['output'];
  /** The anchorage user that created this key */
  creator: User;
  /** Description given to the key at the time of creation. */
  description: Scalars['String']['output'];
  /** Unique key ID */
  keyID: Scalars['String']['output'];
  /**
   * Last used date with nano precision.
   * If it is not present it means the key was never used.
   */
  lastUsed: Maybe<Scalars['String']['output']>;
  /** Organization of the API key */
  organization: Organization;
  /**
   * The email of the individual associated with this key.
   * This serves as the point of contact if there are any issues
   * related to this key, such as, but not limited to, API abuse,
   * schema updates, maintenance windows, etc.
   */
  ownerEmail: Scalars['String']['output'];
  /** Public key ID. */
  publicKeyID: Scalars['String']['output'];
  /** Public key */
  publicKeyString: Scalars['String']['output'];
  /** Indicates if the key can be revoked. */
  revocable: Scalars['Boolean']['output'];
  /**
   * Role is present only for APIv2 keys where the key's role has
   * not been deleted
   */
  role: Maybe<Role>;
  /**
   * The permission details of the role associated with the API key.
   *
   * The data is present only for APIv2 keys where the key's role has
   * not been deleted
   *
   * The changeType will be UNCHANGED.
   */
  rolePermissionDetails: Maybe<RolePermissionDetails>;
  /** Indicates the status of this API key */
  status: APIKeyStatus;
};

/** Enumeration of the possible statuses of an API key. */
export enum APIKeyStatus {
  /** Active indicates the API key is active and can be used. */
  ACTIVE = 'ACTIVE',
  /** Pending indicates the API key will become active after some required action. It cannot be used while pending. */
  PENDING = 'PENDING',
  /** Revoked indicates the API key has been revoked and cannot be used. */
  REVOKED = 'REVOKED',
  /** Unused indicates the API key is active but has not been used. */
  UNUSED = 'UNUSED'
}

/** Details about an API key. */
export type APIKeyV2 = Actor & Key & Node & {
  __typename: 'APIKeyV2';
  /** Actor information. */
  actorInfo: ActorInfo;
  /** Unique identifier of this API key. */
  id: Scalars['ID']['output'];
  /** Key details. */
  keyInfo: KeyInfo;
  /**
   * Detail of a permission group (role) associated with this key. Details are
   * composed for the user interface.
   */
  permissionGroupDetails: Maybe<RolePermissionDetails>;
  /** Subtitle for the associated permission group (role) associated with this key. */
  permissionGroupSubtitle: Maybe<Scalars['String']['output']>;
  /** Name of the associated permission group (role) associated with this key. */
  permissionGroupTitle: Maybe<Scalars['String']['output']>;
  /**
   * Role is present only for APIv2 keys where the key's role has
   * not been deleted.
   */
  role: Maybe<Role>;
  /**
   * The permission details of the role associated with the API key.
   *
   * The data is present only for APIv2 keys where the key's role has
   * not been deleted.
   *
   * The changeType will be UNCHANGED.
   */
  rolePermissionDetails: Maybe<RolePermissionDetails>;
  /** Version of API this key is valid for. */
  supportedAPIVersion: Scalars['String']['output'];
};

/** Represents a user that is in the process of being added to an organization */
export type APIStagedUser = StagedUser & {
  __typename: 'APIStagedUser';
  /**
   * The algorithm for the user's public key. This should match the value in the organization change.
   *
   * For backward compatibility with older iOS releases, nil is returned for the default algorithm (ecdsap256). In this case, an algorithm field is not included in the endorsement.
   */
  algorithm: Maybe<Scalars['String']['output']>;
  /** Email of the staged user, if known */
  email: Maybe<Scalars['String']['output']>;
  /** The only possible value for now is eciesEncryptionCofactorSHA512IVAESGCM or null */
  encryptionAlgorithm: Maybe<Scalars['String']['output']>;
  /** Set iff publicKeyID is set */
  encryptionPublicKey: Maybe<Scalars['String']['output']>;
  /**
   * Same as publicKeyID but used for encryption
   * This is set iff encryptionAlgorithm is set
   */
  encryptionPublicKeyID: Maybe<Scalars['PublicKeyID']['output']>;
  /** Enroll token, which is a field of StagedUser. API keys don't have enroll tokens, so the result will be empty. */
  enrollToken: Scalars['String']['output'];
  /** exemptPiis returns list of PII types that the user is exempt from providing. Not applicable to APIStagedUser but required by risk dashboard. */
  exemptPiis: Array<IndividualInformationType>;
  /** keyID contains the API key unique ID */
  keyID: Maybe<Scalars['String']['output']>;
  /** PII information known. Not applicable to APIStagedUser but required by risk dashboard. */
  knownInformation: Array<KnownInformation>;
  /** Last login information. Will be empty if never logged in. */
  lastLogin: Maybe<Login>;
  /** Name of the API key */
  name: Maybe<Scalars['String']['output']>;
  /** permissionGroupDetails contains detail of a permission group (role) associated with this user. Details are composed for the user interface. */
  permissionGroupDetails: Maybe<RolePermissionDetails>;
  /** permissionGroupSubtitle contains a subtitle for the associated permission group (role) associated with this user. */
  permissionGroupSubtitle: Maybe<Scalars['String']['output']>;
  /** permissionGroupTitle contains the name of the associated permission group (role) associated with this user. */
  permissionGroupTitle: Maybe<Scalars['String']['output']>;
  /** Hex encoded representation of the public key. Always present for API users which are added to an organization, but not necessarily for read-only API users. */
  publicKey: Maybe<Scalars['String']['output']>;
  /** Public key ID of the user. Always present for API users which are added to an organization, but not necessarily for read-only API users. */
  publicKeyID: Maybe<Scalars['PublicKeyID']['output']>;
  /** The type of user that the enrollment will create in the organization */
  userType: UserType;
};

/** AbiVerificationProvider defines the supported verification providers */
export enum AbiVerificationProvider {
  /** Blockscout */
  BLOCKSCOUT = 'BLOCKSCOUT',
  /** Etherscan */
  ETHERSCAN = 'ETHERSCAN',
  /** Sourcify */
  SOURCIFY = 'SOURCIFY'
}

export type AcceleratedMarginCall = {
  action?: InputMaybe<StateAction>;
  curePeriod?: InputMaybe<Scalars['String']['input']>;
  ltv?: InputMaybe<Scalars['String']['input']>;
};

export type Account = {
  __typename: 'Account';
  accountID: Scalars['String']['output'];
  /** The date the account was approved */
  approvedAt: Maybe<Scalars['Time']['output']>;
  /** AssetsBalance returns a list of amount objects representing the balance breakdown per asset for this account */
  assetsBalance: Array<Amount>;
  /**
   * The date the account was created. Use approvedAt instead.
   * @deprecated Use approvedAt. createdAt currently aliases approvedAt as a stopgap.
   */
  createdAt: Maybe<Scalars['Time']['output']>;
  /** The display name of the account */
  displayName: Scalars['String']['output'];
  /** The Anchorage entity associated with the account */
  entity: AnchorageEntity;
  /** The unique identifier of the account */
  id: Scalars['ID']['output'];
  /**
   * The ID of the AffiliateKYCProfile directly linked to this account. Empty if
   * not yet populated.
   */
  kycProfileID: Scalars['String']['output'];
  /** The name of the account */
  name: Scalars['String']['output'];
  organization: Organization;
  /** The organizations associated with the account */
  organizations: Array<Organization>;
  /** Restrictions applied to the account (freeze withdrawal, close, etc.) */
  restrictions: Array<Restriction>;
  /** Settlement network participant, if one has been created for this account */
  snParticipant: Maybe<SNParticipant>;
  /**
   * StakingAssets represents the aggregated staking info for all assets in this account that support staking. This includes:
   * - Totals for each asset type
   * - Total USD values across all assets
   * Total amounts includes:
   * - Amount available to stake
   * - Totals for each staking position state (staked, staking, unstaking, unclaimed rewards)
   */
  stakingAssets: StakingAssets;
  /** TotalBalance returns an amount object representing the total usd value of assets in this account */
  totalBalance: Amount;
  /** List of vaults associated with this account */
  vaults: Array<Vault>;
};


export type AccounttotalBalanceArgs = {
  forceRunBlockedQuery?: Scalars['Boolean']['input'];
};


export type AccountvaultsArgs = {
  filterCurrentUserIsVaultMember?: InputMaybe<Scalars['Boolean']['input']>;
  filterStates?: InputMaybe<Array<VaultState>>;
  forceRunBlockedQuery?: Scalars['Boolean']['input'];
};

export type AccountCSAFilter = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  csaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input for closing an account */
export type AccountClosure = {
  /** Account ID */
  accountID: Scalars['String']['input'];
  /** BSA recommended date account has to be closed by */
  bsaRecommendedDate?: InputMaybe<Scalars['Date']['input']>;
  /** Date account was closed */
  closureDate: Scalars['Date']['input'];
  /** Initiated by — e.g. Compliance */
  initiatedBy: Scalars['String']['input'];
  /** MSA Signed */
  msaSigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** MSA termination date */
  msaTerminationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Reasoning */
  reason: Scalars['String']['input'];
};

export type AccountConstraint = Node & {
  __typename: 'AccountConstraint';
  accountConstraintGroups: AccountConstraintGroupConnection;
  accountConstraintStates: AccountConstraintStateConnection;
  createdAt: Scalars['Time']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  deletedBy: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type AccountConstraintaccountConstraintGroupsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountConstraintGroupWhereInput>;
};


export type AccountConstraintaccountConstraintStatesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountConstraintStateWhereInput>;
};

/** A connection to a list of items. */
export type AccountConstraintConnection = {
  __typename: 'AccountConstraintConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AccountConstraintEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountConstraintEdge = {
  __typename: 'AccountConstraintEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AccountConstraint>;
};

export type AccountConstraintGroup = Node & {
  __typename: 'AccountConstraintGroup';
  accountConstraints: AccountConstraintConnection;
  createdAt: Scalars['Time']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  deletedBy: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type AccountConstraintGroupaccountConstraintsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountConstraintWhereInput>;
};

/** A connection to a list of items. */
export type AccountConstraintGroupConnection = {
  __typename: 'AccountConstraintGroupConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AccountConstraintGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountConstraintGroupEdge = {
  __typename: 'AccountConstraintGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AccountConstraintGroup>;
};

/**
 * AccountConstraintGroupWhereInput is used for filtering AccountConstraintGroup objects.
 * Input was generated by ent.
 */
export type AccountConstraintGroupWhereInput = {
  and?: InputMaybe<Array<AccountConstraintGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_by field predicates */
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByContains?: InputMaybe<Scalars['String']['input']>;
  deletedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deletedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deletedByGT?: InputMaybe<Scalars['String']['input']>;
  deletedByGTE?: InputMaybe<Scalars['String']['input']>;
  deletedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deletedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deletedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLT?: InputMaybe<Scalars['String']['input']>;
  deletedByLTE?: InputMaybe<Scalars['String']['input']>;
  deletedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deletedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** account_constraints edge predicates */
  hasAccountConstraints?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountConstraintsWith?: InputMaybe<Array<AccountConstraintWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AccountConstraintGroupWhereInput>;
  or?: InputMaybe<Array<AccountConstraintGroupWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type AccountConstraintState = Node & {
  __typename: 'AccountConstraintState';
  accountConstraints: Maybe<AccountConstraint>;
  accounts: Maybe<AccountV2>;
  createdAt: Scalars['Time']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['Time']['output']>;
  deletedBy: Maybe<Scalars['String']['output']>;
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  metadata: Maybe<Scalars['Map']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type AccountConstraintStateConnection = {
  __typename: 'AccountConstraintStateConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AccountConstraintStateEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountConstraintStateEdge = {
  __typename: 'AccountConstraintStateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AccountConstraintState>;
};

/**
 * AccountConstraintStateWhereInput is used for filtering AccountConstraintState objects.
 * Input was generated by ent.
 */
export type AccountConstraintStateWhereInput = {
  and?: InputMaybe<Array<AccountConstraintStateWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_by field predicates */
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByContains?: InputMaybe<Scalars['String']['input']>;
  deletedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deletedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deletedByGT?: InputMaybe<Scalars['String']['input']>;
  deletedByGTE?: InputMaybe<Scalars['String']['input']>;
  deletedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deletedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deletedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLT?: InputMaybe<Scalars['String']['input']>;
  deletedByLTE?: InputMaybe<Scalars['String']['input']>;
  deletedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deletedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** fulfilled field predicates */
  fulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  fulfilledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** account_constraints edge predicates */
  hasAccountConstraints?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountConstraintsWith?: InputMaybe<Array<AccountConstraintWhereInput>>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountV2WhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AccountConstraintStateWhereInput>;
  or?: InputMaybe<Array<AccountConstraintStateWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * AccountConstraintWhereInput is used for filtering AccountConstraint objects.
 * Input was generated by ent.
 */
export type AccountConstraintWhereInput = {
  and?: InputMaybe<Array<AccountConstraintWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_by field predicates */
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByContains?: InputMaybe<Scalars['String']['input']>;
  deletedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deletedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deletedByGT?: InputMaybe<Scalars['String']['input']>;
  deletedByGTE?: InputMaybe<Scalars['String']['input']>;
  deletedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deletedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deletedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLT?: InputMaybe<Scalars['String']['input']>;
  deletedByLTE?: InputMaybe<Scalars['String']['input']>;
  deletedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deletedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** account_constraint_groups edge predicates */
  hasAccountConstraintGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountConstraintGroupsWith?: InputMaybe<Array<AccountConstraintGroupWhereInput>>;
  /** account_constraint_states edge predicates */
  hasAccountConstraintStates?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountConstraintStatesWith?: InputMaybe<Array<AccountConstraintStateWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AccountConstraintWhereInput>;
  or?: InputMaybe<Array<AccountConstraintWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** AccountFreezeWithdrawalInput to be updated */
export type AccountFreezeWithdrawalInput = {
  /** account ID */
  accountID: Scalars['ID']['input'];
  /** Indicates if we are turning the restriction on or off */
  enabled: Scalars['Boolean']['input'];
  /** Indicates why restriction is being updated */
  reason: Scalars['String']['input'];
};

export type AccountNettingSetFilter = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  nettingSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AccountOrganizations = Node & {
  __typename: 'AccountOrganizations';
  accountV2ID: Scalars['ID']['output'];
  accounts: AccountV2;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  deletedBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organizationKeyID: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type AccountOrganizationsConnection = {
  __typename: 'AccountOrganizationsConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AccountOrganizationsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountOrganizationsEdge = {
  __typename: 'AccountOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AccountOrganizations>;
};

/**
 * AccountOrganizationsWhereInput is used for filtering AccountOrganizations objects.
 * Input was generated by ent.
 */
export type AccountOrganizationsWhereInput = {
  /** account_v2_id field predicates */
  accountV2ID?: InputMaybe<Scalars['ID']['input']>;
  accountV2IDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  accountV2IDNEQ?: InputMaybe<Scalars['ID']['input']>;
  accountV2IDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  and?: InputMaybe<Array<AccountOrganizationsWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_by field predicates */
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByContains?: InputMaybe<Scalars['String']['input']>;
  deletedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deletedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deletedByGT?: InputMaybe<Scalars['String']['input']>;
  deletedByGTE?: InputMaybe<Scalars['String']['input']>;
  deletedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deletedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deletedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLT?: InputMaybe<Scalars['String']['input']>;
  deletedByLTE?: InputMaybe<Scalars['String']['input']>;
  deletedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deletedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountV2WhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AccountOrganizationsWhereInput>;
  or?: InputMaybe<Array<AccountOrganizationsWhereInput>>;
  /** organization_key_id field predicates */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDContains?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDGT?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDGTE?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationKeyIDLT?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDLTE?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A PDF download response including the base64 encoded PDF as well as the filename */
export type AccountStatementPdf = {
  __typename: 'AccountStatementPdf';
  /** The filename */
  filename: Scalars['String']['output'];
  /** The base64 encoded PDF */
  pdf: Scalars['String']['output'];
};

export type AccountV2 = Node & {
  __typename: 'AccountV2';
  accountConstraintStates: AccountConstraintStateConnection;
  accountOrganizations: AccountOrganizationsConnection;
  affiliateAnchorageRelationships: Maybe<AffiliateAnchorageRelationship>;
  createdAt: Scalars['Time']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  deletedBy: Maybe<Scalars['String']['output']>;
  /**
   * Fee agreements covering this account, optionally narrowed to the given statuses.
   *
   * Only versions that list this account in accountIds are considered at all. If latestVersion is
   * true, every other filter (this account's covering rows, then statuses) is applied first, and the
   * result is then narrowed to the single highest-version row per parentId among what's left.
   */
  feesAgreements: Maybe<FeesAgreementConnection>;
  id: Scalars['ID']['output'];
  kycProfileID: Scalars['String']['output'];
  serviceFeeTerms: Maybe<ServiceFeeTermsConnection>;
  updatedAt: Scalars['Time']['output'];
};


export type AccountV2accountConstraintStatesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountConstraintStateWhereInput>;
};


export type AccountV2accountOrganizationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountOrganizationsWhereInput>;
};


export type AccountV2feesAgreementsArgs = {
  latestVersion?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<AgreementStatus>>;
};


export type AccountV2serviceFeeTermsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  statuses?: InputMaybe<Array<ServiceFeeTermsStatus>>;
};

/** A connection to a list of items. */
export type AccountV2Connection = {
  __typename: 'AccountV2Connection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AccountV2Edge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountV2Edge = {
  __typename: 'AccountV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AccountV2>;
};

/**
 * AccountV2WhereInput is used for filtering AccountV2 objects.
 * Input was generated by ent.
 */
export type AccountV2WhereInput = {
  and?: InputMaybe<Array<AccountV2WhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_by field predicates */
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByContains?: InputMaybe<Scalars['String']['input']>;
  deletedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deletedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deletedByGT?: InputMaybe<Scalars['String']['input']>;
  deletedByGTE?: InputMaybe<Scalars['String']['input']>;
  deletedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deletedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deletedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLT?: InputMaybe<Scalars['String']['input']>;
  deletedByLTE?: InputMaybe<Scalars['String']['input']>;
  deletedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deletedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** account_constraint_states edge predicates */
  hasAccountConstraintStates?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountConstraintStatesWith?: InputMaybe<Array<AccountConstraintStateWhereInput>>;
  /** account_organizations edge predicates */
  hasAccountOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountOrganizationsWith?: InputMaybe<Array<AccountOrganizationsWhereInput>>;
  /** affiliate_anchorage_relationships edge predicates */
  hasAffiliateAnchorageRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasAffiliateAnchorageRelationshipsWith?: InputMaybe<Array<AffiliateAnchorageRelationshipWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kyc_profile_id field predicates */
  kycProfileID?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDContains?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDGT?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDGTE?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  kycProfileIDLT?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDLTE?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDNEQ?: InputMaybe<Scalars['String']['input']>;
  kycProfileIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AccountV2WhereInput>;
  or?: InputMaybe<Array<AccountV2WhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * One account as it is stored, for staff. Unlike SubaccountV2 it reads an account
 * of any type (FBO, OMNIBUS or SEGREGATED), and it shows the stored status and the
 * staff and client freezes separately, where the public API folds them into one
 * FROZEN status.
 */
export type AccountV4 = {
  __typename: 'AccountV4';
  /**
   * Set only for a SEGREGATED account under an FBO, or one created through the
   * older v2 API: the only accounts that can have beneficiaries. Null for any
   * other account.
   */
  beneficiaries: Maybe<AccountV4Beneficiaries>;
  /**
   * When the client froze the account through the public API. Null when it is
   * not frozen by the client.
   */
  clientFrozenAt: Maybe<Scalars['Time']['output']>;
  closedAt: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  externalID: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Whether the account's customers are disclosed. An FBO or OMNIBUS account has
   * its own value. A SEGREGATED account shows its parent's, and null when it has
   * no parent.
   */
  isDisclosed: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the account is enrolled in interest. Null when the account has no
   * interest setting, as for an account created through the v4 API.
   */
  isInterestEnrolled: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the account's balances match its wallets on chain. Null for an FBO
   * or OMNIBUS account, which has no wallets of its own.
   */
  isOnChainSegregated: Maybe<Scalars['Boolean']['output']>;
  /** Where an OMNIBUS account's balances are ledgered. Null for any other type. */
  ledgering: Maybe<AccountV4Ledgering>;
  name: Maybe<Scalars['String']['output']>;
  orgID: Scalars['String']['output'];
  organization: Maybe<SubaccountOrg>;
  /**
   * The FBO or OMNIBUS account a SEGREGATED account sits under. Null when no
   * parent is stored: for an FBO, an OMNIBUS, and an account created through the
   * older v2 API that has not been given a parent yet.
   */
  parentID: Maybe<Scalars['ID']['output']>;
  /**
   * When Anchorage Digital's compliance program froze the account. Null when it
   * is not frozen by staff.
   */
  staffFrozenAt: Maybe<Scalars['Time']['output']>;
  status: AccountV4Status;
  /**
   * Null only for an account created through the older v2 API that has not been
   * given a type yet.
   */
  type: Maybe<AccountV4Type>;
  updatedAt: Scalars['Time']['output'];
};

export type AccountV4Beneficiaries = {
  __typename: 'AccountV4Beneficiaries';
  contingent: Array<SubaccountBeneficiary>;
  primary: Array<SubaccountBeneficiary>;
};

export type AccountV4Connection = {
  __typename: 'AccountV4Connection';
  edges: Array<AccountV4Edge>;
  pageInfo: PageInfo;
};

export type AccountV4Edge = {
  __typename: 'AccountV4Edge';
  cursor: Scalars['String']['output'];
  /**
   * Null when the account has a stored value this read cannot show; an error on
   * the query names the account. The cursor is still valid, so paging continues
   * past it.
   */
  node: Maybe<AccountV4>;
};

/**
 * Every field is optional; when more than one is set, an account must match all
 * of them.
 */
export type AccountV4Filter = {
  /**
   * Only the accounts with these ids, 1 to 100 of them. An id that matches no
   * account is left out of the page; it is not an error.
   */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only the accounts directly under this parent. */
  parentID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AccountV4Type>;
};

export enum AccountV4Ledgering {
  /** Balances are ledgered on each SEGREGATED account under it. */
  SEGREGATED = 'SEGREGATED',
  /** Balances are ledgered on the omnibus account itself. */
  SELF = 'SELF'
}

export enum AccountV4Status {
  BLOCKED = 'BLOCKED',
  CLOSED = 'CLOSED',
  CLOSING = 'CLOSING',
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  OPENING = 'OPENING',
  SUBMITTED = 'SUBMITTED'
}

export enum AccountV4Type {
  FBO = 'FBO',
  OMNIBUS = 'OMNIBUS',
  SEGREGATED = 'SEGREGATED'
}

/** Action being taken to remediate a liquidation obligation */
export enum Action {
  /** All of the collateral is liquidated on the market */
  FULL_LIQUIDATION = 'FULL_LIQUIDATION',
  /** A portion of the collateral is liquidated on the market */
  PARTIAL_LIQUIDATION = 'PARTIAL_LIQUIDATION',
  /** Ownership of the collateral assets is transferred to the secured party */
  SWEEP = 'SWEEP'
}

/** ActionDomain categorizes actions by their business domain. */
export enum ActionDomain {
  STAKING = 'STAKING'
}

/** ActionScope indicates the entity type that an actionForms query is scoped to. */
export enum ActionScope {
  ASSET = 'ASSET',
  STAKING_POSITION = 'STAKING_POSITION'
}

/**
 * ActionTarget identifies the entity an action applies to.
 * The scope field determines which ID field is relevant:
 * ASSET scope requires assetID, STAKING_POSITION scope requires stakingPositionID.
 * The resolver validates that exactly the right ID is provided for the given scope.
 */
export type ActionTarget = {
  assetID?: InputMaybe<Scalars['String']['input']>;
  scope: ActionScope;
  stakingPositionID?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateReportScheduleInput = {
  reportScheduleID: Scalars['ID']['input'];
};

/**
 * The Actor interface should be implemented by entities that can change some
 * state in our platform, initiate operations or actions (e.g., organization change,
 * transactions, trades, etc).
 */
export type Actor = {
  /** Basic information about the actor. */
  actorInfo: ActorInfo;
};

/**
 * ActorInfo contains basic display information about an actor in our platform.
 * An actor is someone or something that may endorse, initiate operations, perform
 * actions, change settings, and fiddle with knobs.
 */
export type ActorInfo = {
  __typename: 'ActorInfo';
  /** Optional description about the actor in a format suitable for displaying in UIs. */
  displayDescription: Maybe<Scalars['String']['output']>;
  /** Name of the actor in a format suitable for displaying in UIs. */
  displayName: Scalars['String']['output'];
};

/**
 * AddAssetSupportInput represents the input needed to add support for a new asset
 * like an ERC-20 or Solana SPL token.
 */
export type AddAssetSupportInput = {
  /**
   * The abbreviation of the asset to add support for.
   * Example: "MKR" as a short form of the token name
   */
  abbrev: Scalars['String']['input'];
  /**
   * The desired asset type ID of the asset to add support for.
   * Example: "MKR" the Maker assetTypeID
   */
  assetTypeID: Scalars['String']['input'];
  /**
   * The asset type ID of the clear asset a confidential asset pairs with.
   * Setting it makes the asset confidential.
   */
  clearAssetTypeID?: InputMaybe<Scalars['String']['input']>;
  /**
   * The divisibility of the asset to add support for.
   * Example: "18" indicating MKR's divisibility
   */
  decimals: Scalars['String']['input'];
  /**
   * The name of asset to add support for.
   * Example: "Maker"
   */
  name: Scalars['String']['input'];
  /**
   * The network ID of the asset to add support for.
   * Example: "ETHEREUM_MAINNET" for Ethereum Mainnet
   */
  networkID: Scalars['NetworkID']['input'];
  /**
   * The on chain identifier for the asset.
   * Example: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2" for MKR's contract address on Ethereum
   * Example: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v" for an SPL token mint address
   */
  onChainIdentifier: Scalars['String']['input'];
  /**
   * The symbol of the asset to add support for.
   * Example: "MKR" as the token symbol
   */
  symbol?: InputMaybe<Scalars['String']['input']>;
  /**
   * The token type to add support for.
   * Example: "ERC-20" representing Ethereum tokens aka ERC-20
   * Example: "SPL" representing a Solana program library
   */
  tokenType: Scalars['String']['input'];
};

/** AddAssetsToProgramResult type represents the result of adding assets to a program. */
export type AddAssetsToStablecoinRewardsProgramResult = {
  __typename: 'AddAssetsToStablecoinRewardsProgramResult';
  /** Unique identifier for the updated program */
  programID: Scalars['String']['output'];
};

/** AddBootMeasurementSetInput represents the input needed to add a boot measurement set for a service. */
export type AddBootMeasurementSetInput = {
  /** The boot measurement set data. */
  bootMeasurementSet: BootMeasurementSetInput;
  /** The service name identifier (e.g., "hsm-native"). */
  serviceName: Scalars['String']['input'];
};

export type AddDvStatementFileSettingInput = {
  accountId: Scalars['ID']['input'];
  /**
   * Defaults to true. Adding a disabled setting is how a file is turned off for
   * an account that has none yet.
   */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fileType: DvStatementFileType;
  statementType: DvStatementType;
};

/** AddOrganizationOperation represents an operation that bootstraps a brand new organization */
export type AddOrganizationOperation = Operation & {
  __typename: 'AddOrganizationOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** Organization that is being added */
  newOrganization: StagedOrganization;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * This will always return an empty organization for this operation,
   * since it is not related to any one organization.
   * @deprecated use operationInfo
   */
  organization: Maybe<Organization>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
};


/** AddOrganizationOperation represents an operation that bootstraps a brand new organization */
export type AddOrganizationOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/**
 * AddQuorumRecoveryInput represents the input needed to add a quorum recovery
 * entry.
 */
export type AddQuorumRecoveryInput = {
  /**
   * The IDs of the lost user keys. These keys will be able to be replaced by the
   * super user.
   */
  lostUserKeyIDs: Array<Scalars['String']['input']>;
  /** The ID of the organization for which the quorum recovery is being added. */
  organizationKeyID: Scalars['String']['input'];
  /**
   * The ID of the user key that will be considered the super user. The super user
   * will be able to replace lost user keys with only one endorsement.
   */
  superUserKeyID: Scalars['String']['input'];
};

/** AddRelatedPartyAndRelationshipsInput is used to add a new related party to an affiliate. */
export type AddRelatedPartyAndRelationshipsInput = {
  /** The affiliate KYC profile ID to add the related party to */
  affiliateKYCProfileID: Scalars['ID']['input'];
  /** Email address */
  email: Scalars['String']['input'];
  /** Additional PII entries */
  entries?: InputMaybe<Array<InputIndividualInformation>>;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Job title (required for control persons and other) */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** KYC roles for this relationship */
  kycRoles: Array<KYCRoleType>;
  /** KYC screening audit information */
  kycScreening?: InputMaybe<KYCScreeningInput>;
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Middle name (can be empty string if none) */
  middleName: Scalars['String']['input'];
  /** Ownership percentage (required for beneficial owners, 0-100%) */
  ownershipPercentage?: InputMaybe<Scalars['String']['input']>;
  /**
   * The representative for form submission. Preferred over the deprecated
   * representativeEmail/representativeName fields.
   */
  representative?: InputMaybe<RepresentativeInput>;
  /**
   * Representative email for form submission
   * @deprecated Use the representative input instead.
   */
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  /**
   * Representative name for form submission
   * @deprecated Use the representative input instead.
   */
  representativeName?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send email notification to the related party */
  shouldSendEmail: Scalars['Boolean']['input'];
};

/**
 * AddRelatedPartyKycProfileInput is used to add a new related party (individual or institutional) to an affiliate.
 *
 * For individuals: Provide EITHER fullName OR (firstName + lastName). If both are provided,
 * firstName/lastName are used to construct the fullName.
 *
 * For institutions: fullName is required.
 */
export type AddRelatedPartyKycProfileInput = {
  /** The affiliate KYC profile ID to add the related party to */
  affiliateKYCProfileID: Scalars['ID']['input'];
  /**
   * Country code (e.g., 'US', 'GB')
   * - For institutions: Optional (aligns with existing addRelatedPartyRelationships)
   * - For individuals: Optional
   */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Email address
   * - For individuals: REQUIRED
   * - For institutions: Optional (relationship contact)
   */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Additional profile information as key-value pairs */
  entries?: InputMaybe<Array<InputInfoType>>;
  /** First name (for individuals only, used to construct fullName if provided) */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Full name of the related party.
   * - For individuals: Provide EITHER this OR firstName+lastName
   * - For institutions: REQUIRED
   * - If firstName+lastName are provided, fullName will be auto-constructed
   */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Job title (required for control persons and other roles) */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** KYC roles for this relationship */
  kycRoles: Array<KYCRoleType>;
  /** KYC screening audit information */
  kycScreening?: InputMaybe<KYCScreeningInput>;
  /** Last name (for individuals only, used to construct fullName if provided) */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Middle name (for individuals only, can be empty string if none) */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership percentage (required for beneficial owners, 0-100%) */
  ownershipPercentage?: InputMaybe<Scalars['String']['input']>;
  /** Type of related party (INDIVIDUAL or INSTITUTION) - REQUIRED */
  relatedPartyType: RelatedPartyType;
  /**
   * The representative for form submission (individuals only). Preferred over the
   * deprecated representativeEmail/representativeName fields.
   */
  representative?: InputMaybe<RepresentativeInput>;
  /**
   * Representative email for form submission (individuals only)
   * @deprecated Use the representative input instead.
   */
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  /**
   * Representative name for form submission (individuals only)
   * @deprecated Use the representative input instead.
   */
  representativeName?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send email notification to the related party (individuals only) */
  shouldSendEmail: Scalars['Boolean']['input'];
};

/** AddTrustedDestinationOperation represents an operation where a user is added to the organization */
export type AddTrustedDestinationOperation = Operation & {
  __typename: 'AddTrustedDestinationOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** Trusted destination being added to the organization */
  destination: TrustedDestination;
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** riskAnalysis is the collected risk information for this address if we have any */
  riskAnalysis: Maybe<TransactionRiskAnalysis>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
};


/** AddTrustedDestinationOperation represents an operation where a user is added to the organization */
export type AddTrustedDestinationOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** AddTrustedDestinationOperation represents an operation where a user is added to the organization */
export type AddTrustedDestinationOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** AddTrustedDestinationsInput represents the input needed to add a new trusted destination */
export type AddTrustedDestinationsInput = {
  /** amlRecord returns the associated AML record */
  amlQuestionnaire?: InputMaybe<InputQuestionnaireSubmission>;
  /** Further information regarding this asset type */
  assetTypeID: Scalars['AssetTypeID']['input'];
  /** Description of the trusted address */
  description: Scalars['String']['input'];
  /** The address */
  destination: Scalars['String']['input'];
  /**
   * isAtNetworkLevel denotes whether the trusted destination is used as network level or asset level
   * true: network level, false: asset level
   */
  isAtNetworkLevel: Scalars['Boolean']['input'];
  /** Name of the trusted address */
  name: Scalars['String']['input'];
  /** ExtraParams for trusted destinations, depending on the asset being used */
  trustedDestinationExtraParams?: InputMaybe<InputTrustedDestinationExtraParams>;
};

/**
 * AddTrustedSmartContractInput represents the input needed to add a new trusted
 * smart contract.
 */
export type AddTrustedSmartContractInput = {
  /** The contract address. */
  address: Scalars['String']['input'];
  /**
   * Asset type ID of the contract address.
   * @deprecated Use networkID instead
   */
  assetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  /** Description of the trusted smart contract. */
  description: Scalars['String']['input'];
  /** Name of the trusted smart contract. */
  name: Scalars['String']['input'];
  /** Network ID of the contract address. */
  networkID?: Scalars['NetworkID']['input'];
  /** List of vault sub IDs that the smart contract is trusted for. */
  vaultSubIDs: Array<Scalars['String']['input']>;
};

/** AddTurnkeyBinaryConfigInput represents the input needed to approve a Turnkey binary config for a deployment. */
export type AddTurnkeyBinaryConfigInput = {
  /** The deployment/service name identifier (e.g., "turnkey-signer"). */
  serviceName: Scalars['String']['input'];
  /** The Turnkey binary config to approve. */
  turnkeyBinaryConfig: TurnkeyBinaryConfigInput;
};

/**
 * AddUserAndPoliciesOperation represents an operation where a user is added to the organization
 * and its policies
 */
export type AddUserAndPoliciesOperation = Operation & {
  __typename: 'AddUserAndPoliciesOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** iamChanges represents the JSON encoded IAM changes that will be applied with this operation. */
  iamChanges: Maybe<Scalars['OperationIAMChanges']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** The key that will be added to the organization */
  key: Key;
  /** The key ID of the key that will be added to the organization */
  keyID: Scalars['String']['output'];
  /** The name of the key that will be added to the organization */
  keyName: Scalars['String']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * policyContainerUpdate represents the bindings that will be applied
   * to the org policy container
   */
  policyContainerUpdate: Maybe<PolicyContainerUpdate>;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /**
   * role enables adding an API public key id to the matching role
   * Role is only used when creating an API Key where we need the role to be updated with the new public key id
   */
  role: Maybe<Role>;
  /** roleChanges represents the IAM role changes that will be applied with this operation. */
  roleChanges: Maybe<IAMRoleChanges>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * Policies the user is being added to
   * @deprecated use policyContainerUpdate
   */
  updatedOrgPolicies: Array<PolicyUpdate>;
  /**
   * Vault policies the user is being added to
   * @deprecated use vaultPolicyContainerUpdate
   */
  updatedVaultPolicies: Array<VaultPolicyUpdate>;
  /** The user being added to the organization */
  user: StagedUser;
  /**
   * vaultPolicyContainerUpdate represents the bindings that will be applied
   * to the vault policy container
   */
  vaultPolicyContainerUpdate: Maybe<VaultPolicyContainerUpdate>;
};


/**
 * AddUserAndPoliciesOperation represents an operation where a user is added to the organization
 * and its policies
 */
export type AddUserAndPoliciesOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/**
 * AddUserAndPoliciesOperation represents an operation where a user is added to the organization
 * and its policies
 */
export type AddUserAndPoliciesOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** Represents the state and result of an address attestation request. */
export type AddressAttestation = {
  __typename: 'AddressAttestation';
  address: Scalars['String']['output'];
  assetTypeID: Scalars['AssetTypeID']['output'];
  message: Scalars['String']['output'];
  payload: Scalars['String']['output'];
  publicKey: Maybe<Scalars['String']['output']>;
  signature: Maybe<Scalars['String']['output']>;
  state: AddressAttestationState;
};

/** Queue status of an address attestation request. */
export enum AddressAttestationState {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  QUEUED = 'QUEUED'
}

/** AddressBalance represents a single balance of a particular assetType held by a particular blockchainAddress */
export type AddressBalance = Node & {
  __typename: 'AddressBalance';
  /** Balance returns an amount corresponding to the complete balance of funds of a particular asset type held by this address */
  balance: Amount;
  /** BlockchainAddress returns an object of type BlockchainAddress representing the address associated with this addressBalance */
  blockchainAddress: BlockchainAddress;
  /** The ID of the AddressBalance. Combination of the address string, assetTypeID, and tokenID (when applicable for NFT/token balances) */
  id: Scalars['ID']['output'];
  /**
   * utxoExclusionSummary is the UTXO exclusion summary for this address. Null for assets that are not
   * UTXO-based and while the exclusion feature is off for the organization, so existing consumers
   * of balancesByAddress see no change.
   */
  utxoExclusionSummary: Maybe<AddressUtxoExclusionSummary>;
};

/** AddressBalanceConnection represents a page of AddressBalances based on the parameters of pagination used, defined by a pageInfo object. Implements the connections spec for pagination */
export type AddressBalanceConnection = {
  __typename: 'AddressBalanceConnection';
  /** Edges contains a list of AddressBalanceEdge objects representing a page of AddressBalance data. Implements the connections spec for pagination. */
  edges: Array<AddressBalanceEdge>;
  /** pageInfo returns information about the page returned above. implements the connections spec for pagination */
  pageInfo: PageInfo;
};

/** AddressBalanceEdge contains an AddressBalance and the cursor representing the same AddressBalance - implements the connections spec for pagination */
export type AddressBalanceEdge = {
  __typename: 'AddressBalanceEdge';
  /** Cursor implements the connections spec for pagination */
  cursor: Scalars['ID']['output'];
  /** Node implements the connections spec for pagination */
  node: AddressBalance;
};

/** IP Address family */
export enum AddressFamily {
  /** IPv4 family */
  IPV4 = 'IPV4',
  /** IPv6 family */
  IPV6 = 'IPV6'
}

/** An enum representing the type of address to generate. */
export enum AddressGenerationType {
  /** A Bitcoin-like P2PKH address. */
  BITCOINLIKE_P2PKH = 'BITCOINLIKE_P2PKH',
  /** A Bitcoin-like P2SH-P2WPKH address. */
  BITCOINLIKE_P2SH_P2WPKH = 'BITCOINLIKE_P2SH_P2WPKH',
  /** A Bitcoin-like Taproot address. */
  BITCOINLIKE_P2TR = 'BITCOINLIKE_P2TR',
  /** The default address format for the network. */
  DEFAULT = 'DEFAULT'
}

/** An AddressID uniquely identifies an address Anchorage controls. */
export type AddressID = {
  __typename: 'AddressID';
  /** addressSubID is the id of the address within the context of this asset */
  addressSubID: Scalars['String']['output'];
  /** assetID is the AssetID this address belongs to */
  assetID: AssetID;
  /**
   * ID uniquely identifies an address managed by Anchorage.
   * ID is a hash derived solely from: org/vault/wallet/address-SubID.
   * ID is not *directly* related to: network, address string.
   * ID is indirectly related to network: it is derived from (network's native) asset type.
   */
  id: Scalars['ID']['output'];
};

/**
 * AddressInputStep is a step that allows the user to input a plain blockchain address.
 *
 * IMPORTANT: This step only currently supports generic operations (prepareGenericOperation) where
 * the address will be embedded in a JSON payload with a custom field name. It should NOT
 * be used with prepareDelegation forms, which have a fixed schema. For validator addresses
 * in prepareDelegation forms, use ValidatorInputStep instead (which maps to the 'destination'
 * parameter).
 */
export type AddressInputStep = StakingStep & {
  __typename: 'AddressInputStep';
  /** A regex for the UI to validate the input address in real time. */
  addressRegex: Scalars['String']['output'];
  /** The error message to show when the addressRegex fails. */
  addressRegexError: Scalars['String']['output'];
  /** The default value to pre-populate in the input field. */
  defaultValue: Maybe<Scalars['String']['output']>;
  /**
   * Description is the label shown on the UI.
   * @deprecated Use label instead.
   * @deprecated use the field 'label' instead
   */
  description: Scalars['String']['output'];
  /** Editable should disable the input if false. */
  editable: Scalars['Boolean']['output'];
  /**
   * Instructs the UI what field name to use when embedding this address in the JSON
   * payload for prepareGenericOperation. This field is REQUIRED when using AddressInputStep
   * with generic operations, and the form will be disabled if it is not provided (enforced
   * by ValidateStepsForGenericOperation).
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /** A hint to show under the input field. */
  hint: Maybe<Scalars['String']['output']>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Allows the backend to provide info banners to be shown above the step */
  infoItems: Maybe<Array<InfoItem>>;
  /** The label shown on the UI next to the input field. */
  label: Scalars['String']['output'];
  /**
   * The text shown in the input field before the user types anything. If this
   * field is null, the input field should be empty.
   */
  placeholderText: Maybe<Scalars['String']['output']>;
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
};

/** AddressPoisoningRisk */
export type AddressPoisoningRisk = {
  __typename: 'AddressPoisoningRisk';
  /** When the address was first scanned for similarity risk */
  firstSeen: Scalars['Time']['output'];
  /**
   * Returns true if we indicated a deposit as risky but the client told us it's safe, otherwise false
   * If true, the UI should not show warnings for this address
   */
  manuallyDeclaredSafe: Scalars['Boolean']['output'];
  /** The risk that this address is poisoned */
  similarityLevel: AddressSimilarityLevel;
  /** similarityRiskReason optionally explains why an address is considered similar */
  similarityRiskReason: Scalars['String']['output'];
};

/** AddressRiskMetadata of a BlockchainAddress */
export type AddressRiskMetadata = {
  __typename: 'AddressRiskMetadata';
  /**
   * Whether this address is off-curve (has no valid Ed25519 private key, so no one can sign for it).
   * Computed on read; null means the address is on-curve or off-curve is not applicable (non-Solana network).
   * The client owns the warning copy — the backend only reports the boolean verdict.
   */
  offCurveRisk: Maybe<OffCurveRisk>;
  /**
   * Contains information about this address' similarity to any other addresses the client has interacted with
   * If it is similar to one, it's likely someone is trying to get our client to accidentally transfer funds to their poisoned address instead of the legitimate one
   */
  poisoningRisk: AddressPoisoningRisk;
};

/** AddressSimilarityLevel */
export enum AddressSimilarityLevel {
  /** An error occurred while assessing the similarity of this address */
  ERRORRED = 'ERRORRED',
  /**
   * This address is similar to another one the client has interacted with.
   * It is likely owned by someone attempting a poisoning attack, and is dangerous for the user to copy
   * Our UI should show a prominent warning to the client if they view this address (eg in Deposit details)
   */
  HIGH = 'HIGH',
  /**
   * This address isn't similar to any others the client has interacted with
   *
   * This doesn't currently account for the possibility of an attacker frontrunning a legitimate test deposit with a poisoned one
   * If an attacker successfully gets their deposit in before the one they're pretending to be, we have no way to detect it	at the moment
   * Therefore we should be careful not to indicate "no risk" on deposit addresses, simply "low risk"
   */
  LOW = 'LOW',
  /** We know this address has no risk of being malicious, eg because it's an Anchorage address */
  NONE = 'NONE',
  /**
   * A poisoning/similarity assessment was not performed for this address, because it was surfaced
   * only for a different risk dimension (e.g. an off-curve transfer destination, which is not
   * deposit-scanned for poisoning). Distinct from UNKNOWN, which means an assessment was attempted
   * but is in progress or could not complete. Clients render no poisoning warning for this value.
   */
  NOT_ASSESSED = 'NOT_ASSESSED',
  /** A similarity assessment has not occurred on this address or could not be completed */
  UNKNOWN = 'UNKNOWN'
}

/** Address's status is based on the associated wallet's archived status */
export enum AddressStatus {
  /** Wallets that are not archived (wallets.is_archived = 0) */
  ACTIVE = 'ACTIVE',
  /** All wallets (both archived and not archived) */
  ALL = 'ALL',
  /** Wallets that are archived (wallets.is_archived = 1) */
  ARCHIVED = 'ARCHIVED'
}

/** AddressUtxoExclusionSummary summarizes one pooled address's UTXO exclusion state. */
export type AddressUtxoExclusionSummary = {
  __typename: 'AddressUtxoExclusionSummary';
  state: PooledAddressExclusionState;
};

/**
 * AddressUtxoPage follows the v2 page.next convention: next carries the afterId for the following
 * call and is null on the last page.
 */
export type AddressUtxoPage = {
  __typename: 'AddressUtxoPage';
  next: Maybe<Scalars['ID']['output']>;
};

/**
 * AddressUtxoResult is a page of one address's UTXOs plus whole-address aggregates for the
 * drill-in header, independent of the filter and the page. The UTXO count is
 * includedCount + excludedCount.
 */
export type AddressUtxoResult = {
  __typename: 'AddressUtxoResult';
  data: Array<UtxoExclusionEntry>;
  excludedCount: Scalars['Int']['output'];
  includedCount: Scalars['Int']['output'];
  page: AddressUtxoPage;
  totalBalance: Amount;
};

/** AdvancedTradingConfig holds the configuration for advanced trading */
export type AdvancedTradingConfig = {
  __typename: 'AdvancedTradingConfig';
  /** URL to enter the advanced trading dashboard */
  advancedTradingURL: Maybe<Scalars['String']['output']>;
};

/** Represents an affiliate */
export type Affiliate = {
  __typename: 'Affiliate';
  /** Identifier of the affiliate */
  affiliateID: Scalars['String']['output'];
  /** Role of the affiliate */
  role: Scalars['String']['output'];
};

export type AffiliateAnchorageRelationship = Node & {
  __typename: 'AffiliateAnchorageRelationship';
  accounts: AccountV2Connection;
  affiliates: AffiliateV2;
  anchorageLegalEntities: AnchorageLegalEntity;
  createdAt: Scalars['Time']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  deletedBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type AffiliateAnchorageRelationshipaccountsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountV2WhereInput>;
};

/** A connection to a list of items. */
export type AffiliateAnchorageRelationshipConnection = {
  __typename: 'AffiliateAnchorageRelationshipConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AffiliateAnchorageRelationshipEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AffiliateAnchorageRelationshipEdge = {
  __typename: 'AffiliateAnchorageRelationshipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AffiliateAnchorageRelationship>;
};

/**
 * AffiliateAnchorageRelationshipWhereInput is used for filtering AffiliateAnchorageRelationship objects.
 * Input was generated by ent.
 */
export type AffiliateAnchorageRelationshipWhereInput = {
  and?: InputMaybe<Array<AffiliateAnchorageRelationshipWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_by field predicates */
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByContains?: InputMaybe<Scalars['String']['input']>;
  deletedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deletedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deletedByGT?: InputMaybe<Scalars['String']['input']>;
  deletedByGTE?: InputMaybe<Scalars['String']['input']>;
  deletedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deletedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deletedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLT?: InputMaybe<Scalars['String']['input']>;
  deletedByLTE?: InputMaybe<Scalars['String']['input']>;
  deletedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deletedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountV2WhereInput>>;
  /** affiliates edge predicates */
  hasAffiliates?: InputMaybe<Scalars['Boolean']['input']>;
  hasAffiliatesWith?: InputMaybe<Array<AffiliateV2WhereInput>>;
  /** anchorage_legal_entities edge predicates */
  hasAnchorageLegalEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasAnchorageLegalEntitiesWith?: InputMaybe<Array<AnchorageLegalEntityWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AffiliateAnchorageRelationshipWhereInput>;
  or?: InputMaybe<Array<AffiliateAnchorageRelationshipWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** AffiliateFreezeWithdrawalInput to be updated */
export type AffiliateFreezeWithdrawalInput = {
  /** affiliate ID */
  affiliateID: Scalars['ID']['input'];
  /** Indicates if we are turning the restriction on or off */
  enabled: Scalars['Boolean']['input'];
  /** Indicates why restriction is being updated */
  reason: Scalars['String']['input'];
};

/** Type of information and reason rejected */
export type AffiliateInformationRejection = {
  __typename: 'AffiliateInformationRejection';
  /** Type of information */
  informationType: AffiliateInformationType;
  /** Reason the information was rejected */
  rejectionReason: Scalars['String']['output'];
};

/** Enum of information that may be provided by institutional affiliates */
export enum AffiliateInformationType {
  /** ACCEPT_INVESTOR_FUNDS */
  ACCEPT_INVESTOR_FUNDS = 'ACCEPT_INVESTOR_FUNDS',
  /** ACCOUNT_ACTIVITY ... */
  ACCOUNT_ACTIVITY = 'ACCOUNT_ACTIVITY',
  /** ACCOUNT_ACTIVITY_BORROWING */
  ACCOUNT_ACTIVITY_BORROWING = 'ACCOUNT_ACTIVITY_BORROWING',
  /** ACCOUNT_ACTIVITY_CUSTODY */
  ACCOUNT_ACTIVITY_CUSTODY = 'ACCOUNT_ACTIVITY_CUSTODY',
  /** ACCOUNT_ACTIVITY_INVESTMENTS ... */
  ACCOUNT_ACTIVITY_INVESTMENTS = 'ACCOUNT_ACTIVITY_INVESTMENTS',
  /** ACCOUNT_ACTIVITY_LENDING */
  ACCOUNT_ACTIVITY_LENDING = 'ACCOUNT_ACTIVITY_LENDING',
  /** ACCOUNT_ACTIVITY_MINING ... */
  ACCOUNT_ACTIVITY_MINING = 'ACCOUNT_ACTIVITY_MINING',
  /** ACCOUNT_ACTIVITY_STAKING */
  ACCOUNT_ACTIVITY_STAKING = 'ACCOUNT_ACTIVITY_STAKING',
  /** ACCOUNT_ACTIVITY_TRADING */
  ACCOUNT_ACTIVITY_TRADING = 'ACCOUNT_ACTIVITY_TRADING',
  /** ACCOUNT_BANK_ACTIVITY */
  ACCOUNT_BANK_ACTIVITY = 'ACCOUNT_BANK_ACTIVITY',
  /** ACCOUNT_BANK_ACTIVITY_CUSTODY */
  ACCOUNT_BANK_ACTIVITY_CUSTODY = 'ACCOUNT_BANK_ACTIVITY_CUSTODY',
  /** ACCOUNT_BANK_ACTIVITY_STAKING */
  ACCOUNT_BANK_ACTIVITY_STAKING = 'ACCOUNT_BANK_ACTIVITY_STAKING',
  /** ACCOUNT_NAME ... */
  ACCOUNT_NAME = 'ACCOUNT_NAME',
  /** ACCOUNT_PURPOSE */
  ACCOUNT_PURPOSE = 'ACCOUNT_PURPOSE',
  /** ACCOUNT_REGISTRATION ... */
  ACCOUNT_REGISTRATION = 'ACCOUNT_REGISTRATION',
  /** ACCOUNT_REGISTRATION_CORPORATION ... */
  ACCOUNT_REGISTRATION_CORPORATION = 'ACCOUNT_REGISTRATION_CORPORATION',
  /** ACCOUNT_REGISTRATION_LLC ... */
  ACCOUNT_REGISTRATION_LLC = 'ACCOUNT_REGISTRATION_LLC',
  /** ACCOUNT_REGISTRATION_OTHER ... */
  ACCOUNT_REGISTRATION_OTHER = 'ACCOUNT_REGISTRATION_OTHER',
  /** ACCOUNT_REGISTRATION_PARTNERSHIP ... */
  ACCOUNT_REGISTRATION_PARTNERSHIP = 'ACCOUNT_REGISTRATION_PARTNERSHIP',
  /** ACCOUNT_REGISTRATION_SOLE_PROPRIETOR ... */
  ACCOUNT_REGISTRATION_SOLE_PROPRIETOR = 'ACCOUNT_REGISTRATION_SOLE_PROPRIETOR',
  /** ACCOUNT_SOURCE_OF_FUNDS ... */
  ACCOUNT_SOURCE_OF_FUNDS = 'ACCOUNT_SOURCE_OF_FUNDS',
  /** ACKNOWLEDGE_EMAIL ... */
  ACKNOWLEDGE_EMAIL = 'ACKNOWLEDGE_EMAIL',
  /** ACKNOWLEDGE_FIRST_NAME ... */
  ACKNOWLEDGE_FIRST_NAME = 'ACKNOWLEDGE_FIRST_NAME',
  /** ACKNOWLEDGE_LAST_NAME ... */
  ACKNOWLEDGE_LAST_NAME = 'ACKNOWLEDGE_LAST_NAME',
  /** ACKNOWLEDGE_MIDDLE_NAME ... */
  ACKNOWLEDGE_MIDDLE_NAME = 'ACKNOWLEDGE_MIDDLE_NAME',
  /** ACKNOWLEDGE_NAME ... */
  ACKNOWLEDGE_NAME = 'ACKNOWLEDGE_NAME',
  /** ACKNOWLEDGE_TITLE ... */
  ACKNOWLEDGE_TITLE = 'ACKNOWLEDGE_TITLE',
  /** ADB_INVESTMENT_MANAGER_AFFILIATE_SUBMISSION_ID ... */
  ADB_INVESTMENT_MANAGER_AFFILIATE_SUBMISSION_ID = 'ADB_INVESTMENT_MANAGER_AFFILIATE_SUBMISSION_ID',
  /** ADB_MANAGED_FUND_AFFILIATE_SUBMISSION_ID ... */
  ADB_MANAGED_FUND_AFFILIATE_SUBMISSION_ID = 'ADB_MANAGED_FUND_AFFILIATE_SUBMISSION_ID',
  /** ADDITIONAL_DOCUMENT */
  ADDITIONAL_DOCUMENT = 'ADDITIONAL_DOCUMENT',
  /** ADDITIONAL_DOCUMENT_ACCOUNT_USAGE ... */
  ADDITIONAL_DOCUMENT_ACCOUNT_USAGE = 'ADDITIONAL_DOCUMENT_ACCOUNT_USAGE',
  /** ADDITIONAL_DOCUMENT_AML ... */
  ADDITIONAL_DOCUMENT_AML = 'ADDITIONAL_DOCUMENT_AML',
  /** ADDITIONAL_DOCUMENT_AUTHORIZED_SIGNATORIES ... */
  ADDITIONAL_DOCUMENT_AUTHORIZED_SIGNATORIES = 'ADDITIONAL_DOCUMENT_AUTHORIZED_SIGNATORIES',
  /** ADDITIONAL_DOCUMENT_AUTHORIZED_USERS ... */
  ADDITIONAL_DOCUMENT_AUTHORIZED_USERS = 'ADDITIONAL_DOCUMENT_AUTHORIZED_USERS',
  /** ADDITIONAL_DOCUMENT_BASIC_INFO ... */
  ADDITIONAL_DOCUMENT_BASIC_INFO = 'ADDITIONAL_DOCUMENT_BASIC_INFO',
  /** ADDITIONAL_DOCUMENT_BENEFICIAL_OWNERSHIP ... */
  ADDITIONAL_DOCUMENT_BENEFICIAL_OWNERSHIP = 'ADDITIONAL_DOCUMENT_BENEFICIAL_OWNERSHIP',
  /** ADDITIONAL_DOCUMENT_CONNECTED_PARTIES ... */
  ADDITIONAL_DOCUMENT_CONNECTED_PARTIES = 'ADDITIONAL_DOCUMENT_CONNECTED_PARTIES',
  /** ADDITIONAL_DOCUMENT_CONTROL_PERSON ... */
  ADDITIONAL_DOCUMENT_CONTROL_PERSON = 'ADDITIONAL_DOCUMENT_CONTROL_PERSON',
  /** ADDITIONAL_DOCUMENT_DIGITAL_ASSETS_CUSTODY ... */
  ADDITIONAL_DOCUMENT_DIGITAL_ASSETS_CUSTODY = 'ADDITIONAL_DOCUMENT_DIGITAL_ASSETS_CUSTODY',
  /** ADDITIONAL_DOCUMENT_ECP ... */
  ADDITIONAL_DOCUMENT_ECP = 'ADDITIONAL_DOCUMENT_ECP',
  /** ADDITIONAL_DOCUMENT_ESTIMATED_DEPOSITS_DA ... */
  ADDITIONAL_DOCUMENT_ESTIMATED_DEPOSITS_DA = 'ADDITIONAL_DOCUMENT_ESTIMATED_DEPOSITS_DA',
  /** ADDITIONAL_DOCUMENT_ESTIMATED_DEPOSITS_FIAT ... */
  ADDITIONAL_DOCUMENT_ESTIMATED_DEPOSITS_FIAT = 'ADDITIONAL_DOCUMENT_ESTIMATED_DEPOSITS_FIAT',
  /** ADDITIONAL_DOCUMENT_ESTIMATED_WITHDRAWALS_DA ... */
  ADDITIONAL_DOCUMENT_ESTIMATED_WITHDRAWALS_DA = 'ADDITIONAL_DOCUMENT_ESTIMATED_WITHDRAWALS_DA',
  /** ADDITIONAL_DOCUMENT_ESTIMATED_WITHDRAWALS_FIAT ... */
  ADDITIONAL_DOCUMENT_ESTIMATED_WITHDRAWALS_FIAT = 'ADDITIONAL_DOCUMENT_ESTIMATED_WITHDRAWALS_FIAT',
  /** ADDITIONAL_DOCUMENT_LEI ... */
  ADDITIONAL_DOCUMENT_LEI = 'ADDITIONAL_DOCUMENT_LEI',
  /** ADDITIONAL_DOCUMENT_OPERATIONAL_DETAILS ... */
  ADDITIONAL_DOCUMENT_OPERATIONAL_DETAILS = 'ADDITIONAL_DOCUMENT_OPERATIONAL_DETAILS',
  /** ADDITIONAL_DOCUMENT_PRINCIPAL_PLACE_OF_BUSINESS ... */
  ADDITIONAL_DOCUMENT_PRINCIPAL_PLACE_OF_BUSINESS = 'ADDITIONAL_DOCUMENT_PRINCIPAL_PLACE_OF_BUSINESS',
  /** ADDITIONAL_DOCUMENT_REGISTERED_ADDRESS ... */
  ADDITIONAL_DOCUMENT_REGISTERED_ADDRESS = 'ADDITIONAL_DOCUMENT_REGISTERED_ADDRESS',
  /** ADDITIONAL_DOCUMENT_TRADING_SUPERVISORS ... */
  ADDITIONAL_DOCUMENT_TRADING_SUPERVISORS = 'ADDITIONAL_DOCUMENT_TRADING_SUPERVISORS',
  /** ADDITIONAL_DOCUMENT_US_REGULATORY_STATUS ... */
  ADDITIONAL_DOCUMENT_US_REGULATORY_STATUS = 'ADDITIONAL_DOCUMENT_US_REGULATORY_STATUS',
  /** ADDRESS ... */
  ADDRESS = 'ADDRESS',
  /** ADDRESS2 ... */
  ADDRESS2 = 'ADDRESS2',
  /** ADMIN_ISSUE ... */
  ADMIN_ISSUE = 'ADMIN_ISSUE',
  /** ADMIN_ISSUE_CATEGORY ... */
  ADMIN_ISSUE_CATEGORY = 'ADMIN_ISSUE_CATEGORY',
  /** ADMIN_ISSUE_ISSUE_DETAIL ... */
  ADMIN_ISSUE_ISSUE_DETAIL = 'ADMIN_ISSUE_ISSUE_DETAIL',
  /** ADMIN_ISSUE_KYC_ANALYST_COMMENT ... */
  ADMIN_ISSUE_KYC_ANALYST_COMMENT = 'ADMIN_ISSUE_KYC_ANALYST_COMMENT',
  /** ADMIN_ISSUE_VALID_OR_INVALID ... */
  ADMIN_ISSUE_VALID_OR_INVALID = 'ADMIN_ISSUE_VALID_OR_INVALID',
  /** ADS_KYC_AFFILIATE_FORM_SUBMISSION_ID ... */
  ADS_KYC_AFFILIATE_FORM_SUBMISSION_ID = 'ADS_KYC_AFFILIATE_FORM_SUBMISSION_ID',
  /** AFFILIATE_TYPE ... */
  AFFILIATE_TYPE = 'AFFILIATE_TYPE',
  /** AFFILIATE_WEBSITE_URL */
  AFFILIATE_WEBSITE_URL = 'AFFILIATE_WEBSITE_URL',
  /** AIA_AUTHORIZED_PERSON_NAME ... */
  AIA_AUTHORIZED_PERSON_NAME = 'AIA_AUTHORIZED_PERSON_NAME',
  /** AIA_DATE ... */
  AIA_DATE = 'AIA_DATE',
  /** AIA_ELIGIBILITY_CATEGORY ... */
  AIA_ELIGIBILITY_CATEGORY = 'AIA_ELIGIBILITY_CATEGORY',
  /** AIA_FINANCIAL_ASSETS_DOC ... */
  AIA_FINANCIAL_ASSETS_DOC = 'AIA_FINANCIAL_ASSETS_DOC',
  /** AIA_PERSONAL_ASSETS_DOC ... */
  AIA_PERSONAL_ASSETS_DOC = 'AIA_PERSONAL_ASSETS_DOC',
  /** AIA_PERSONAL_INCOME_DOC ... */
  AIA_PERSONAL_INCOME_DOC = 'AIA_PERSONAL_INCOME_DOC',
  /** AIA_SIGNATURE ... */
  AIA_SIGNATURE = 'AIA_SIGNATURE',
  /** AIA_TITLE ... */
  AIA_TITLE = 'AIA_TITLE',
  /** ALTERNATIVE_PAYMENT_METHODS ... */
  ALTERNATIVE_PAYMENT_METHODS = 'ALTERNATIVE_PAYMENT_METHODS',
  /** AML_AUDIT_REPORTS ... */
  AML_AUDIT_REPORTS = 'AML_AUDIT_REPORTS',
  /** AML_ELEMENTE_SUSPICIOUS_ACTIVITY ... */
  AML_ELEMENTE_SUSPICIOUS_ACTIVITY = 'AML_ELEMENTE_SUSPICIOUS_ACTIVITY',
  /** AML_ELEMENT_INDIVIDUALS ... */
  AML_ELEMENT_INDIVIDUALS = 'AML_ELEMENT_INDIVIDUALS',
  /** AML_ELEMENT_ONGOING_SANCTIONS ... */
  AML_ELEMENT_ONGOING_SANCTIONS = 'AML_ELEMENT_ONGOING_SANCTIONS',
  /** AML_ELEMENT_ONGOING_VERIFICATION ... */
  AML_ELEMENT_ONGOING_VERIFICATION = 'AML_ELEMENT_ONGOING_VERIFICATION',
  /** AML_ELEMENT_POLICIES ... */
  AML_ELEMENT_POLICIES = 'AML_ELEMENT_POLICIES',
  /** AML_ELEMENT_RETAIN_RECORDS ... */
  AML_ELEMENT_RETAIN_RECORDS = 'AML_ELEMENT_RETAIN_RECORDS',
  /** AML_ELEMENT_SCREENING_OFAC ... */
  AML_ELEMENT_SCREENING_OFAC = 'AML_ELEMENT_SCREENING_OFAC',
  /** AML_ELEMENT_SCREENING_PEP ... */
  AML_ELEMENT_SCREENING_PEP = 'AML_ELEMENT_SCREENING_PEP',
  /** AML_ELEMENT_TESTING ... */
  AML_ELEMENT_TESTING = 'AML_ELEMENT_TESTING',
  /** AML_EXEMPTION_REASON ... */
  AML_EXEMPTION_REASON = 'AML_EXEMPTION_REASON',
  /** AML_FINDING ... */
  AML_FINDING = 'AML_FINDING',
  /** AML_FINDING_CATEGORY ... */
  AML_FINDING_CATEGORY = 'AML_FINDING_CATEGORY',
  /** AML_FINDING_ISSUE_DETAIL ... */
  AML_FINDING_ISSUE_DETAIL = 'AML_FINDING_ISSUE_DETAIL',
  /** AML_FINDING_KYC_ANALYST_COMMENT ... */
  AML_FINDING_KYC_ANALYST_COMMENT = 'AML_FINDING_KYC_ANALYST_COMMENT',
  /** AML_FINDING_VALID_OR_INVALID ... */
  AML_FINDING_VALID_OR_INVALID = 'AML_FINDING_VALID_OR_INVALID',
  /** AML_KYC_PROGRAM_REVIEW */
  AML_KYC_PROGRAM_REVIEW = 'AML_KYC_PROGRAM_REVIEW',
  /** AML_OFFICER_NAME ... */
  AML_OFFICER_NAME = 'AML_OFFICER_NAME',
  /** AML_POLICIES ... */
  AML_POLICIES = 'AML_POLICIES',
  /** AML_POLICY_DOCUMENT ... */
  AML_POLICY_DOCUMENT = 'AML_POLICY_DOCUMENT',
  /** AML_PROGRAM_COMPONENT ... */
  AML_PROGRAM_COMPONENT = 'AML_PROGRAM_COMPONENT',
  /** AML_PROGRAM_ELEMENTS ... */
  AML_PROGRAM_ELEMENTS = 'AML_PROGRAM_ELEMENTS',
  /** AML_QUESTIONNAIRE_DOCUMENT ... */
  AML_QUESTIONNAIRE_DOCUMENT = 'AML_QUESTIONNAIRE_DOCUMENT',
  /** ANCHORAGE_ENTITY_TYPE ... */
  ANCHORAGE_ENTITY_TYPE = 'ANCHORAGE_ENTITY_TYPE',
  /** ANNUAL_REPORT */
  ANNUAL_REPORT = 'ANNUAL_REPORT',
  /** APPOINTMENT_OF_TRUSTEES ... */
  APPOINTMENT_OF_TRUSTEES = 'APPOINTMENT_OF_TRUSTEES',
  /** ARE_AUTHORIZED_SIGNATORIES_APPOINTED ... */
  ARE_AUTHORIZED_SIGNATORIES_APPOINTED = 'ARE_AUTHORIZED_SIGNATORIES_APPOINTED',
  /** ARE_CLIENTS_FATF ... */
  ARE_CLIENTS_FATF = 'ARE_CLIENTS_FATF',
  /** ARTICLES_OF_ASSOCIATION ... */
  ARTICLES_OF_ASSOCIATION = 'ARTICLES_OF_ASSOCIATION',
  /** ASSET_CLASSES_EXPERIENCE ... */
  ASSET_CLASSES_EXPERIENCE = 'ASSET_CLASSES_EXPERIENCE',
  /** ASSET_CLASSES_EXPERIENCE_COMMODITIES ... */
  ASSET_CLASSES_EXPERIENCE_COMMODITIES = 'ASSET_CLASSES_EXPERIENCE_COMMODITIES',
  /** ASSET_CLASSES_EXPERIENCE_DIGITAL_ASSETS ... */
  ASSET_CLASSES_EXPERIENCE_DIGITAL_ASSETS = 'ASSET_CLASSES_EXPERIENCE_DIGITAL_ASSETS',
  /** ASSET_CLASSES_EXPERIENCE_DIGITAL_ASSETS_MINING */
  ASSET_CLASSES_EXPERIENCE_DIGITAL_ASSETS_MINING = 'ASSET_CLASSES_EXPERIENCE_DIGITAL_ASSETS_MINING',
  /** ASSET_CLASSES_EXPERIENCE_EQUITIES ... */
  ASSET_CLASSES_EXPERIENCE_EQUITIES = 'ASSET_CLASSES_EXPERIENCE_EQUITIES',
  /** ASSET_CLASSES_EXPERIENCE_FIXED_INCOME ... */
  ASSET_CLASSES_EXPERIENCE_FIXED_INCOME = 'ASSET_CLASSES_EXPERIENCE_FIXED_INCOME',
  /** ASSET_DEPOSIT_AMOUNT_PER_MONTH ... */
  ASSET_DEPOSIT_AMOUNT_PER_MONTH = 'ASSET_DEPOSIT_AMOUNT_PER_MONTH',
  /** ASSET_DEPOSIT_FREQUENCY_PER_MONTH ... */
  ASSET_DEPOSIT_FREQUENCY_PER_MONTH = 'ASSET_DEPOSIT_FREQUENCY_PER_MONTH',
  /** ASSET_WITHDRAWAL_AMOUNT_PER_MONTH ... */
  ASSET_WITHDRAWAL_AMOUNT_PER_MONTH = 'ASSET_WITHDRAWAL_AMOUNT_PER_MONTH',
  /** ASSET_WITHDRAWAL_FREQUENCY_PER_MONTH ... */
  ASSET_WITHDRAWAL_FREQUENCY_PER_MONTH = 'ASSET_WITHDRAWAL_FREQUENCY_PER_MONTH',
  /** ASSUMED_NAME_CERT ... */
  ASSUMED_NAME_CERT = 'ASSUMED_NAME_CERT',
  /** AUDITED_FINANCIALS ... */
  AUDITED_FINANCIALS = 'AUDITED_FINANCIALS',
  /** AUTHORIZED_MSB_AGENTS ... */
  AUTHORIZED_MSB_AGENTS = 'AUTHORIZED_MSB_AGENTS',
  /** AUTHORIZED_PERSONS_GROUP ... */
  AUTHORIZED_PERSONS_GROUP = 'AUTHORIZED_PERSONS_GROUP',
  /** AUTHORIZED_SIGNATORIES_DOCUMENT ... */
  AUTHORIZED_SIGNATORIES_DOCUMENT = 'AUTHORIZED_SIGNATORIES_DOCUMENT',
  /** AUTHORIZED_SIGNATORY_GROUP ... */
  AUTHORIZED_SIGNATORY_GROUP = 'AUTHORIZED_SIGNATORY_GROUP',
  /** AVG_DIGITAL_ASSET_DEPOSIT_VALUE_RANGE ... */
  AVG_DIGITAL_ASSET_DEPOSIT_VALUE_RANGE = 'AVG_DIGITAL_ASSET_DEPOSIT_VALUE_RANGE',
  /** AVG_DIGITAL_ASSET_DEPOSIT_VOLUME_RANGE ... */
  AVG_DIGITAL_ASSET_DEPOSIT_VOLUME_RANGE = 'AVG_DIGITAL_ASSET_DEPOSIT_VOLUME_RANGE',
  /** AVG_DIGITAL_ASSET_WITHDRAWAL_VALUE_RANGE ... */
  AVG_DIGITAL_ASSET_WITHDRAWAL_VALUE_RANGE = 'AVG_DIGITAL_ASSET_WITHDRAWAL_VALUE_RANGE',
  /** AVG_DIGITAL_ASSET_WITHDRAWAL_VOLUME_RANGE ... */
  AVG_DIGITAL_ASSET_WITHDRAWAL_VOLUME_RANGE = 'AVG_DIGITAL_ASSET_WITHDRAWAL_VOLUME_RANGE',
  /** AVG_FIAT_DEPOSIT_VALUE_RANGE ... */
  AVG_FIAT_DEPOSIT_VALUE_RANGE = 'AVG_FIAT_DEPOSIT_VALUE_RANGE',
  /** AVG_FIAT_DEPOSIT_VOLUME_RANGE ... */
  AVG_FIAT_DEPOSIT_VOLUME_RANGE = 'AVG_FIAT_DEPOSIT_VOLUME_RANGE',
  /** AVG_FIAT_WITHDRAWAL_VALUE_RANGE ... */
  AVG_FIAT_WITHDRAWAL_VALUE_RANGE = 'AVG_FIAT_WITHDRAWAL_VALUE_RANGE',
  /** AVG_FIAT_WITHDRAWAL_VOLUME_RANGE ... */
  AVG_FIAT_WITHDRAWAL_VOLUME_RANGE = 'AVG_FIAT_WITHDRAWAL_VOLUME_RANGE',
  /** AVG_TOTAL_TRANSACTION_VOLUME_RANGE ... */
  AVG_TOTAL_TRANSACTION_VOLUME_RANGE = 'AVG_TOTAL_TRANSACTION_VOLUME_RANGE',
  /** BANKING_RELATIONSHIP ... */
  BANKING_RELATIONSHIP = 'BANKING_RELATIONSHIP',
  /** BANKING_RELATIONSHIP_EXPLANATION ... */
  BANKING_RELATIONSHIP_EXPLANATION = 'BANKING_RELATIONSHIP_EXPLANATION',
  /** BENEFICIAL_AND_CONTROL_EXEMPT */
  BENEFICIAL_AND_CONTROL_EXEMPT = 'BENEFICIAL_AND_CONTROL_EXEMPT',
  /** BENEFICIAL_AND_CONTROL_EXEMPT_REASON */
  BENEFICIAL_AND_CONTROL_EXEMPT_REASON = 'BENEFICIAL_AND_CONTROL_EXEMPT_REASON',
  /** BENEFICIAL_OWNERS_REQUIRED */
  BENEFICIAL_OWNERS_REQUIRED = 'BENEFICIAL_OWNERS_REQUIRED',
  /** BENEFICIAL_OWNER_GROUP ... */
  BENEFICIAL_OWNER_GROUP = 'BENEFICIAL_OWNER_GROUP',
  /** BENEFICIARIES_GROUP ... */
  BENEFICIARIES_GROUP = 'BENEFICIARIES_GROUP',
  /** BLOCKCHAIN_TRANSACTION_MONITORING_VENDOR ... */
  BLOCKCHAIN_TRANSACTION_MONITORING_VENDOR = 'BLOCKCHAIN_TRANSACTION_MONITORING_VENDOR',
  /** BOARD_RESOLUTION ... */
  BOARD_RESOLUTION = 'BOARD_RESOLUTION',
  /** BO_AUTHORIZED_PERSON_NAME ... */
  BO_AUTHORIZED_PERSON_NAME = 'BO_AUTHORIZED_PERSON_NAME',
  /** BO_DATE ... */
  BO_DATE = 'BO_DATE',
  /** BO_SIGNATURE ... */
  BO_SIGNATURE = 'BO_SIGNATURE',
  /** BO_TITLE ... */
  BO_TITLE = 'BO_TITLE',
  /** BUSINESS_DESCRIPTION ... */
  BUSINESS_DESCRIPTION = 'BUSINESS_DESCRIPTION',
  /** BUSINESS_ENGAGEMENT_DOCUMENT */
  BUSINESS_ENGAGEMENT_DOCUMENT = 'BUSINESS_ENGAGEMENT_DOCUMENT',
  /** BUSINESS_FUND_PAYMENTS ... */
  BUSINESS_FUND_PAYMENTS = 'BUSINESS_FUND_PAYMENTS',
  /** BUSINESS_REGISTRATION_CERTIFICATE ... */
  BUSINESS_REGISTRATION_CERTIFICATE = 'BUSINESS_REGISTRATION_CERTIFICATE',
  /** BUSINESS_REGISTRATION_NUMBER ... */
  BUSINESS_REGISTRATION_NUMBER = 'BUSINESS_REGISTRATION_NUMBER',
  /** BUSINESS_RESTRICT_WITHDRAWALS ... */
  BUSINESS_RESTRICT_WITHDRAWALS = 'BUSINESS_RESTRICT_WITHDRAWALS',
  /** CEA_SECTION_18 ... */
  CEA_SECTION_18 = 'CEA_SECTION_18',
  /** CERTIFICATE_OF_GOOD_STANDING */
  CERTIFICATE_OF_GOOD_STANDING = 'CERTIFICATE_OF_GOOD_STANDING',
  /** CERTIFICATE_OF_INCORPORATION ... */
  CERTIFICATE_OF_INCORPORATION = 'CERTIFICATE_OF_INCORPORATION',
  /** CERTIFICATE_OF_INCUMBENCY ... */
  CERTIFICATE_OF_INCUMBENCY = 'CERTIFICATE_OF_INCUMBENCY',
  /** CERTIFICATE_OF_REGISTRATION ... */
  CERTIFICATE_OF_REGISTRATION = 'CERTIFICATE_OF_REGISTRATION',
  /** CERTIFY_OF_INFORMATION_PROVIDED ... */
  CERTIFY_OF_INFORMATION_PROVIDED = 'CERTIFY_OF_INFORMATION_PROVIDED',
  /** CIP_VERIFICATION ... */
  CIP_VERIFICATION = 'CIP_VERIFICATION',
  /** CITY */
  CITY = 'CITY',
  /** CLIENT_BASE ... */
  CLIENT_BASE = 'CLIENT_BASE',
  /** CLIENT_BASE_ACCREDITED_INVESTORS ... */
  CLIENT_BASE_ACCREDITED_INVESTORS = 'CLIENT_BASE_ACCREDITED_INVESTORS',
  /** CLIENT_BASE_CRYPTO ... */
  CLIENT_BASE_CRYPTO = 'CLIENT_BASE_CRYPTO',
  /** CLIENT_BASE_FAMILY ... */
  CLIENT_BASE_FAMILY = 'CLIENT_BASE_FAMILY',
  /** CLIENT_BASE_HEDGE_FUND ... */
  CLIENT_BASE_HEDGE_FUND = 'CLIENT_BASE_HEDGE_FUND',
  /** CLIENT_BASE_INSTITUTIONAL_TRUST ... */
  CLIENT_BASE_INSTITUTIONAL_TRUST = 'CLIENT_BASE_INSTITUTIONAL_TRUST',
  /** CLIENT_BASE_NONE ... */
  CLIENT_BASE_NONE = 'CLIENT_BASE_NONE',
  /** CLIENT_BASE_PRIVATE_CAPITAL ... */
  CLIENT_BASE_PRIVATE_CAPITAL = 'CLIENT_BASE_PRIVATE_CAPITAL',
  /** CLIENT_BASE_VENTURE_CAPITAL ... */
  CLIENT_BASE_VENTURE_CAPITAL = 'CLIENT_BASE_VENTURE_CAPITAL',
  /** COMPANY_NAME ... */
  COMPANY_NAME = 'COMPANY_NAME',
  /** CONFIDENTIALITY_OF_OWNERSHIP_EXPLANATION ... */
  CONFIDENTIALITY_OF_OWNERSHIP_EXPLANATION = 'CONFIDENTIALITY_OF_OWNERSHIP_EXPLANATION',
  /** CONSTITUTION_BY_LAWS ... */
  CONSTITUTION_BY_LAWS = 'CONSTITUTION_BY_LAWS',
  /** CONSTITUTION_DOCUMENT ... */
  CONSTITUTION_DOCUMENT = 'CONSTITUTION_DOCUMENT',
  /** CONTROL_PERSON_CIP_VERIFIED ... */
  CONTROL_PERSON_CIP_VERIFIED = 'CONTROL_PERSON_CIP_VERIFIED',
  /** CONTROL_PERSON_FIRST_NAME ... */
  CONTROL_PERSON_FIRST_NAME = 'CONTROL_PERSON_FIRST_NAME',
  /** CONTROL_PERSON_GROUP ... */
  CONTROL_PERSON_GROUP = 'CONTROL_PERSON_GROUP',
  /** CONTROL_PERSON_LAST_NAME ... */
  CONTROL_PERSON_LAST_NAME = 'CONTROL_PERSON_LAST_NAME',
  /** CONTROL_PERSON_MIDDLE_NAME ... */
  CONTROL_PERSON_MIDDLE_NAME = 'CONTROL_PERSON_MIDDLE_NAME',
  /** CONTROL_STRUCTURE ... */
  CONTROL_STRUCTURE = 'CONTROL_STRUCTURE',
  /** COUNTRIES_TO_DO_BUSINESS_IN */
  COUNTRIES_TO_DO_BUSINESS_IN = 'COUNTRIES_TO_DO_BUSINESS_IN',
  /** COUNTRIES_TO_TRANSFER_ASSETS */
  COUNTRIES_TO_TRANSFER_ASSETS = 'COUNTRIES_TO_TRANSFER_ASSETS',
  /** COUNTRY */
  COUNTRY = 'COUNTRY',
  /** COUNTRY_OF_OPERATION ... */
  COUNTRY_OF_OPERATION = 'COUNTRY_OF_OPERATION',
  /** COUNTRY_OF_OPERATION_GROUP ... */
  COUNTRY_OF_OPERATION_GROUP = 'COUNTRY_OF_OPERATION_GROUP',
  /** CURRENCIES_LIST ... */
  CURRENCIES_LIST = 'CURRENCIES_LIST',
  /** DATE_OF_BIRTH ... */
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  /** DBA_NAME ... */
  DBA_NAME = 'DBA_NAME',
  /** Optional DBA or Trade names */
  DBA_NAMES = 'DBA_NAMES',
  /** DBA_PROOF_DOCUMENT ... */
  DBA_PROOF_DOCUMENT = 'DBA_PROOF_DOCUMENT',
  /** DECLARATION_OF_TRUST ... */
  DECLARATION_OF_TRUST = 'DECLARATION_OF_TRUST',
  /** DELIVERY_PREFERENCE ... */
  DELIVERY_PREFERENCE = 'DELIVERY_PREFERENCE',
  /** DELIVERY_PREFERENCE_CONTRACT_NOTIFICATIONS_GROUP ... */
  DELIVERY_PREFERENCE_CONTRACT_NOTIFICATIONS_GROUP = 'DELIVERY_PREFERENCE_CONTRACT_NOTIFICATIONS_GROUP',
  /** DELIVERY_PREFERENCE_DEFAULT_GROUP ... */
  DELIVERY_PREFERENCE_DEFAULT_GROUP = 'DELIVERY_PREFERENCE_DEFAULT_GROUP',
  /** DELIVERY_PREFERENCE_DEPOSIT_ATTRIBUTION_GROUP ... */
  DELIVERY_PREFERENCE_DEPOSIT_ATTRIBUTION_GROUP = 'DELIVERY_PREFERENCE_DEPOSIT_ATTRIBUTION_GROUP',
  /** DELIVERY_PREFERENCE_INVOICES_GROUP ... */
  DELIVERY_PREFERENCE_INVOICES_GROUP = 'DELIVERY_PREFERENCE_INVOICES_GROUP',
  /** DELIVERY_PREFERENCE_KYC_INQUIRY_GROUP ... */
  DELIVERY_PREFERENCE_KYC_INQUIRY_GROUP = 'DELIVERY_PREFERENCE_KYC_INQUIRY_GROUP',
  /** DELIVERY_PREFERENCE_OTHER_GROUP ... */
  DELIVERY_PREFERENCE_OTHER_GROUP = 'DELIVERY_PREFERENCE_OTHER_GROUP',
  /** DELIVERY_PREFERENCE_PLATFORM_UPDATES_GROUP ... */
  DELIVERY_PREFERENCE_PLATFORM_UPDATES_GROUP = 'DELIVERY_PREFERENCE_PLATFORM_UPDATES_GROUP',
  /** DELIVERY_PREFERENCE_SETTLEMENT_NETWORK_GROUP ... */
  DELIVERY_PREFERENCE_SETTLEMENT_NETWORK_GROUP = 'DELIVERY_PREFERENCE_SETTLEMENT_NETWORK_GROUP',
  /** DELIVERY_PREFERENCE_TAX_DOCUMENTS_GROUP ... */
  DELIVERY_PREFERENCE_TAX_DOCUMENTS_GROUP = 'DELIVERY_PREFERENCE_TAX_DOCUMENTS_GROUP',
  /** DELIVERY_PREFERENCE_TRADE_CONFIRMATIONS_GROUP ... */
  DELIVERY_PREFERENCE_TRADE_CONFIRMATIONS_GROUP = 'DELIVERY_PREFERENCE_TRADE_CONFIRMATIONS_GROUP',
  /** DEPOSIT_FUNDING_WALLET_ADDRESSES ... */
  DEPOSIT_FUNDING_WALLET_ADDRESSES = 'DEPOSIT_FUNDING_WALLET_ADDRESSES',
  /** DEPOSIT_FUNDING_WALLET_DO_OWN_WALLET ... */
  DEPOSIT_FUNDING_WALLET_DO_OWN_WALLET = 'DEPOSIT_FUNDING_WALLET_DO_OWN_WALLET',
  /** DEPOSIT_FUNDING_WALLET_GROUP ... */
  DEPOSIT_FUNDING_WALLET_GROUP = 'DEPOSIT_FUNDING_WALLET_GROUP',
  /** DEPOSIT_FUNDING_WALLET_ORIGINATOR_COUNTRY ... */
  DEPOSIT_FUNDING_WALLET_ORIGINATOR_COUNTRY = 'DEPOSIT_FUNDING_WALLET_ORIGINATOR_COUNTRY',
  /** DEPOSIT_FUNDING_WALLET_ORIGINATOR_NAME ... */
  DEPOSIT_FUNDING_WALLET_ORIGINATOR_NAME = 'DEPOSIT_FUNDING_WALLET_ORIGINATOR_NAME',
  /** DEPOSIT_FUNDING_WIRE_INSTITUTION ... */
  DEPOSIT_FUNDING_WIRE_INSTITUTION = 'DEPOSIT_FUNDING_WIRE_INSTITUTION',
  /** DERIVATIVES_TRADING_AUTH ... */
  DERIVATIVES_TRADING_AUTH = 'DERIVATIVES_TRADING_AUTH',
  /** DIRECTORS */
  DIRECTORS = 'DIRECTORS',
  /** DOCUMENT_LINK ... */
  DOCUMENT_LINK = 'DOCUMENT_LINK',
  /** DOCUMENT_MONEY_TRANSMITTER_LICENSE ... */
  DOCUMENT_MONEY_TRANSMITTER_LICENSE = 'DOCUMENT_MONEY_TRANSMITTER_LICENSE',
  /** DOCUMENT_PREFERENCE ... */
  DOCUMENT_PREFERENCE = 'DOCUMENT_PREFERENCE',
  /** DOCUMENT_PREFERENCE_ADDRESS_DEFAULT_EMAIL ... */
  DOCUMENT_PREFERENCE_ADDRESS_DEFAULT_EMAIL = 'DOCUMENT_PREFERENCE_ADDRESS_DEFAULT_EMAIL',
  /** DOCUMENT_PREFERENCE_ADDRESS_INVOICE ... */
  DOCUMENT_PREFERENCE_ADDRESS_INVOICE = 'DOCUMENT_PREFERENCE_ADDRESS_INVOICE',
  /** DOCUMENT_PREFERENCE_ADDRESS_INVOICE_NAME ... */
  DOCUMENT_PREFERENCE_ADDRESS_INVOICE_NAME = 'DOCUMENT_PREFERENCE_ADDRESS_INVOICE_NAME',
  /** DOCUMENT_PREFERENCE_ADDRESS_KYC_INQUIRY ... */
  DOCUMENT_PREFERENCE_ADDRESS_KYC_INQUIRY = 'DOCUMENT_PREFERENCE_ADDRESS_KYC_INQUIRY',
  /** DOCUMENT_PREFERENCE_ADDRESS_KYC_INQUIRY_NAME ... */
  DOCUMENT_PREFERENCE_ADDRESS_KYC_INQUIRY_NAME = 'DOCUMENT_PREFERENCE_ADDRESS_KYC_INQUIRY_NAME',
  /** DOCUMENT_PREFERENCE_ADDRESS_TAX_DOCUMENTS ... */
  DOCUMENT_PREFERENCE_ADDRESS_TAX_DOCUMENTS = 'DOCUMENT_PREFERENCE_ADDRESS_TAX_DOCUMENTS',
  /** DOCUMENT_PREFERENCE_ADDRESS_TAX_DOCUMENTS_NAME ... */
  DOCUMENT_PREFERENCE_ADDRESS_TAX_DOCUMENTS_NAME = 'DOCUMENT_PREFERENCE_ADDRESS_TAX_DOCUMENTS_NAME',
  /** DOCUMENT_PREFERENCE_ADDRESS_TRADE_CONFIRMATIONS ... */
  DOCUMENT_PREFERENCE_ADDRESS_TRADE_CONFIRMATIONS = 'DOCUMENT_PREFERENCE_ADDRESS_TRADE_CONFIRMATIONS',
  /** DOCUMENT_PREFERENCE_DEPOSIT_ATTRIBUTION ... */
  DOCUMENT_PREFERENCE_DEPOSIT_ATTRIBUTION = 'DOCUMENT_PREFERENCE_DEPOSIT_ATTRIBUTION',
  /** DOCUMENT_PREFERENCE_DEPOSIT_ATTRIBUTION_NAME ... */
  DOCUMENT_PREFERENCE_DEPOSIT_ATTRIBUTION_NAME = 'DOCUMENT_PREFERENCE_DEPOSIT_ATTRIBUTION_NAME',
  /** DOCUMENT_PREFERENCE_PLATFORM_SERVICES_UPDATE ... */
  DOCUMENT_PREFERENCE_PLATFORM_SERVICES_UPDATE = 'DOCUMENT_PREFERENCE_PLATFORM_SERVICES_UPDATE',
  /** DOCUMENT_PREFERENCE_PLATFORM_SERVICES_UPDATE_NAME ... */
  DOCUMENT_PREFERENCE_PLATFORM_SERVICES_UPDATE_NAME = 'DOCUMENT_PREFERENCE_PLATFORM_SERVICES_UPDATE_NAME',
  /** DOCUMENT_SOURCE_OF_WEALTH ... */
  DOCUMENT_SOURCE_OF_WEALTH = 'DOCUMENT_SOURCE_OF_WEALTH',
  /** DOCUMENT_SOURCE_OF_WEALTH_BO ... */
  DOCUMENT_SOURCE_OF_WEALTH_BO = 'DOCUMENT_SOURCE_OF_WEALTH_BO',
  /** DOCUMENT_TITLE ... */
  DOCUMENT_TITLE = 'DOCUMENT_TITLE',
  /** DOCUMENT_TYPE ... */
  DOCUMENT_TYPE = 'DOCUMENT_TYPE',
  /** DOC_PREF_ADDRESS_CONTRACTUAL_NOTIFICATIONS ... */
  DOC_PREF_ADDRESS_CONTRACTUAL_NOTIFICATIONS = 'DOC_PREF_ADDRESS_CONTRACTUAL_NOTIFICATIONS',
  /** DOC_PREF_ADDRESS_CONTRACTUAL_NOTIFICATIONS_NAME ... */
  DOC_PREF_ADDRESS_CONTRACTUAL_NOTIFICATIONS_NAME = 'DOC_PREF_ADDRESS_CONTRACTUAL_NOTIFICATIONS_NAME',
  /** DOC_PREF_SETTLEMENT_NETWORK_NOTIFICATIONS ... */
  DOC_PREF_SETTLEMENT_NETWORK_NOTIFICATIONS = 'DOC_PREF_SETTLEMENT_NETWORK_NOTIFICATIONS',
  /** DOC_PREF_SETTLEMENT_NETWORK_NOTIFICATIONS_NAME ... */
  DOC_PREF_SETTLEMENT_NETWORK_NOTIFICATIONS_NAME = 'DOC_PREF_SETTLEMENT_NETWORK_NOTIFICATIONS_NAME',
  /** DONORS_AND_BENEFICIARIES */
  DONORS_AND_BENEFICIARIES = 'DONORS_AND_BENEFICIARIES',
  /** ECP_AUTHORIZED_PERSON_NAME ... */
  ECP_AUTHORIZED_PERSON_NAME = 'ECP_AUTHORIZED_PERSON_NAME',
  /** ECP_CUSTOMER_TYPE ... */
  ECP_CUSTOMER_TYPE = 'ECP_CUSTOMER_TYPE',
  /** ECP_DATE ... */
  ECP_DATE = 'ECP_DATE',
  /** ECP_FINANCIAL_STATEMENTS ... */
  ECP_FINANCIAL_STATEMENTS = 'ECP_FINANCIAL_STATEMENTS',
  /** ECP_ORGANIZATION_NAME ... */
  ECP_ORGANIZATION_NAME = 'ECP_ORGANIZATION_NAME',
  /** ECP_TITLE ... */
  ECP_TITLE = 'ECP_TITLE',
  /** EMAIL ... */
  EMAIL = 'EMAIL',
  /** EMPLOYER ... */
  EMPLOYER = 'EMPLOYER',
  /** EMPLOYMENT_STATUS ... */
  EMPLOYMENT_STATUS = 'EMPLOYMENT_STATUS',
  /** ENGAGED_ACTIVITIES_OR_INDUSTRIES ... */
  ENGAGED_ACTIVITIES_OR_INDUSTRIES = 'ENGAGED_ACTIVITIES_OR_INDUSTRIES',
  /** ENTITY_INTERMEDIARY_LAYERS ... */
  ENTITY_INTERMEDIARY_LAYERS = 'ENTITY_INTERMEDIARY_LAYERS',
  /** Full legal entity name */
  ENTITY_NAME = 'ENTITY_NAME',
  /** EXCHANGE ... */
  EXCHANGE = 'EXCHANGE',
  /** EXCHANGE_COUNTRY ... */
  EXCHANGE_COUNTRY = 'EXCHANGE_COUNTRY',
  /** FEIN ... */
  FEIN = 'FEIN',
  /** FIAT_DEPOSIT_FREQUENCY_PER_MONTH */
  FIAT_DEPOSIT_FREQUENCY_PER_MONTH = 'FIAT_DEPOSIT_FREQUENCY_PER_MONTH',
  /** FIAT_DEPOSIT_FREQUENCY_PER_YEAR ... */
  FIAT_DEPOSIT_FREQUENCY_PER_YEAR = 'FIAT_DEPOSIT_FREQUENCY_PER_YEAR',
  /** FIAT_WITHDRAWAL_FREQUENCY ... */
  FIAT_WITHDRAWAL_FREQUENCY = 'FIAT_WITHDRAWAL_FREQUENCY',
  /** FIAT_WITHDRAWAL_FREQUENCY_PER_MONTH */
  FIAT_WITHDRAWAL_FREQUENCY_PER_MONTH = 'FIAT_WITHDRAWAL_FREQUENCY_PER_MONTH',
  /** FINANCIALS_DOCUMENT ... */
  FINANCIALS_DOCUMENT = 'FINANCIALS_DOCUMENT',
  /** FINANCIAL_ACTION_TASK_FORCE ... */
  FINANCIAL_ACTION_TASK_FORCE = 'FINANCIAL_ACTION_TASK_FORCE',
  /** FINANCIAL_ACTION_TASK_FORCE_EXPLANATION ... */
  FINANCIAL_ACTION_TASK_FORCE_EXPLANATION = 'FINANCIAL_ACTION_TASK_FORCE_EXPLANATION',
  /** FINANCIAL_ACTION_TASK_FORCE_FIELDS ... */
  FINANCIAL_ACTION_TASK_FORCE_FIELDS = 'FINANCIAL_ACTION_TASK_FORCE_FIELDS',
  /** FINCEN_STATUS ... */
  FINCEN_STATUS = 'FINCEN_STATUS',
  /** FIRM_TRADING_AUTHORIZATION_FORM ... */
  FIRM_TRADING_AUTHORIZATION_FORM = 'FIRM_TRADING_AUTHORIZATION_FORM',
  /** FIRST_NAME ... */
  FIRST_NAME = 'FIRST_NAME',
  /** FOREIGN_BANK_CERTIFICATION */
  FOREIGN_BANK_CERTIFICATION = 'FOREIGN_BANK_CERTIFICATION',
  /** FOREIGN_BANK_CERTIFICATION_ACKNOWLEDGEMENT */
  FOREIGN_BANK_CERTIFICATION_ACKNOWLEDGEMENT = 'FOREIGN_BANK_CERTIFICATION_ACKNOWLEDGEMENT',
  /** FOREIGN_BANK_CERTIFICATION_AUTHORIZED_PERSON */
  FOREIGN_BANK_CERTIFICATION_AUTHORIZED_PERSON = 'FOREIGN_BANK_CERTIFICATION_AUTHORIZED_PERSON',
  /** FOREIGN_CORRESPONDENT_ACCOUNT ... */
  FOREIGN_CORRESPONDENT_ACCOUNT = 'FOREIGN_CORRESPONDENT_ACCOUNT',
  /** FOREIGN_FINANCIAL_INSTITUTION */
  FOREIGN_FINANCIAL_INSTITUTION = 'FOREIGN_FINANCIAL_INSTITUTION',
  /** FORMATION_DOCUMENT */
  FORMATION_DOCUMENT = 'FORMATION_DOCUMENT',
  /** FORM_990_DOCUMENT ... */
  FORM_990_DOCUMENT = 'FORM_990_DOCUMENT',
  /** FORM_5500 ... */
  FORM_5500 = 'FORM_5500',
  /** FULL_NAMES_OF_AUTHORIZED_SIGNATORIES ... */
  FULL_NAMES_OF_AUTHORIZED_SIGNATORIES = 'FULL_NAMES_OF_AUTHORIZED_SIGNATORIES',
  /** FUNDING_DEPOSIT_ADDRESS */
  FUNDING_DEPOSIT_ADDRESS = 'FUNDING_DEPOSIT_ADDRESS',
  /** FUNDING_WIRE_INSTITUTION */
  FUNDING_WIRE_INSTITUTION = 'FUNDING_WIRE_INSTITUTION',
  /** FUND_STRUCTURE_CHART ... */
  FUND_STRUCTURE_CHART = 'FUND_STRUCTURE_CHART',
  /** GRANTORS_GROUP ... */
  GRANTORS_GROUP = 'GRANTORS_GROUP',
  /** GROUP_HEADQUARTERS_COUNTRY ... */
  GROUP_HEADQUARTERS_COUNTRY = 'GROUP_HEADQUARTERS_COUNTRY',
  /** HAS_AGENT ... */
  HAS_AGENT = 'HAS_AGENT',
  /** HAS_BENEFICIAL_OWNERS ... */
  HAS_BENEFICIAL_OWNERS = 'HAS_BENEFICIAL_OWNERS',
  /** HAS_BLOCKCHAIN_TRANSACTION_MONITORING ... */
  HAS_BLOCKCHAIN_TRANSACTION_MONITORING = 'HAS_BLOCKCHAIN_TRANSACTION_MONITORING',
  /** HAS_CONFIDENTIALITY_OF_OWNERSHIP ... */
  HAS_CONFIDENTIALITY_OF_OWNERSHIP = 'HAS_CONFIDENTIALITY_OF_OWNERSHIP',
  /** HAS_DBA_NAME ... */
  HAS_DBA_NAME = 'HAS_DBA_NAME',
  /** HAS_INDIRECT_ENTITIES ... */
  HAS_INDIRECT_ENTITIES = 'HAS_INDIRECT_ENTITIES',
  /** HAS_MULTISTATE_MSB_LICENSE ... */
  HAS_MULTISTATE_MSB_LICENSE = 'HAS_MULTISTATE_MSB_LICENSE',
  /** HAS_NON_CUSTODIAL_WALLETS */
  HAS_NON_CUSTODIAL_WALLETS = 'HAS_NON_CUSTODIAL_WALLETS',
  /** HAS_PENSION_ERISA ... */
  HAS_PENSION_ERISA = 'HAS_PENSION_ERISA',
  /** HAS_PROOF_OF_ADDRESS ... */
  HAS_PROOF_OF_ADDRESS = 'HAS_PROOF_OF_ADDRESS',
  /** HAS_PROOF_OF_ADDRESS_CONTEXT ... */
  HAS_PROOF_OF_ADDRESS_CONTEXT = 'HAS_PROOF_OF_ADDRESS_CONTEXT',
  /** HAS_SEC_CFTC_RIA ... */
  HAS_SEC_CFTC_RIA = 'HAS_SEC_CFTC_RIA',
  /** HAS_TOKEN_ASSOCIATED_PROJ_CENTRALIZED_EXCHANGES ... */
  HAS_TOKEN_ASSOCIATED_PROJ_CENTRALIZED_EXCHANGES = 'HAS_TOKEN_ASSOCIATED_PROJ_CENTRALIZED_EXCHANGES',
  /** HAS_TOKEN_BLOCKCHAIN_ANALYTICS ... */
  HAS_TOKEN_BLOCKCHAIN_ANALYTICS = 'HAS_TOKEN_BLOCKCHAIN_ANALYTICS',
  /** HAS_TOKEN_BLOCKCHAIN_ANONYMITY ... */
  HAS_TOKEN_BLOCKCHAIN_ANONYMITY = 'HAS_TOKEN_BLOCKCHAIN_ANONYMITY',
  /** HAS_TOKEN_BLOCKCHAIN_BLOCK_EXPLORER ... */
  HAS_TOKEN_BLOCKCHAIN_BLOCK_EXPLORER = 'HAS_TOKEN_BLOCKCHAIN_BLOCK_EXPLORER',
  /** HAS_TOKEN_BLOCKCHAIN_INDEPENDENT_AUDIT ... */
  HAS_TOKEN_BLOCKCHAIN_INDEPENDENT_AUDIT = 'HAS_TOKEN_BLOCKCHAIN_INDEPENDENT_AUDIT',
  /** HAS_TOKEN_BLOCKCHAIN_SUFFICIENT_LIQUIDITY ... */
  HAS_TOKEN_BLOCKCHAIN_SUFFICIENT_LIQUIDITY = 'HAS_TOKEN_BLOCKCHAIN_SUFFICIENT_LIQUIDITY',
  /** HAS_TOKEN_BLOCKCHANIN_SIGNIFICANT_MARKET_ACTIVITY ... */
  HAS_TOKEN_BLOCKCHANIN_SIGNIFICANT_MARKET_ACTIVITY = 'HAS_TOKEN_BLOCKCHANIN_SIGNIFICANT_MARKET_ACTIVITY',
  /** HAS_US_TAXPAYER ... */
  HAS_US_TAXPAYER = 'HAS_US_TAXPAYER',
  /** HELD_ASSET_CLASSES ... */
  HELD_ASSET_CLASSES = 'HELD_ASSET_CLASSES',
  /** HELD_ASSET_CLASSES_COMMODITIES ... */
  HELD_ASSET_CLASSES_COMMODITIES = 'HELD_ASSET_CLASSES_COMMODITIES',
  /** HELD_ASSET_CLASSES_DIGITAL_ASSETS ... */
  HELD_ASSET_CLASSES_DIGITAL_ASSETS = 'HELD_ASSET_CLASSES_DIGITAL_ASSETS',
  /** HELD_ASSET_CLASSES_EQUITIES ... */
  HELD_ASSET_CLASSES_EQUITIES = 'HELD_ASSET_CLASSES_EQUITIES',
  /** HELD_ASSET_CLASSES_FIXED_INCOME ... */
  HELD_ASSET_CLASSES_FIXED_INCOME = 'HELD_ASSET_CLASSES_FIXED_INCOME',
  /** HIGH_RISK_COUNTRIES ... */
  HIGH_RISK_COUNTRIES = 'HIGH_RISK_COUNTRIES',
  /** HOW_MAINTAIN_AML ... */
  HOW_MAINTAIN_AML = 'HOW_MAINTAIN_AML',
  /** ID_CARD_BACK ... */
  ID_CARD_BACK = 'ID_CARD_BACK',
  /** ID_CARD_FRONT ... */
  ID_CARD_FRONT = 'ID_CARD_FRONT',
  /** INCORPORATION_COUNTRY ... */
  INCORPORATION_COUNTRY = 'INCORPORATION_COUNTRY',
  /** INCORPORATION_DATE ... */
  INCORPORATION_DATE = 'INCORPORATION_DATE',
  /** INDIRECT_OWNERS ... */
  INDIRECT_OWNERS = 'INDIRECT_OWNERS',
  /** INDIVIDUALS_CERTIFICATION */
  INDIVIDUALS_CERTIFICATION = 'INDIVIDUALS_CERTIFICATION',
  /** INDIVIDUALS_CERTIFICATION_CONFIRMATION */
  INDIVIDUALS_CERTIFICATION_CONFIRMATION = 'INDIVIDUALS_CERTIFICATION_CONFIRMATION',
  /** INDIVIDUALS_NUMBER ... */
  INDIVIDUALS_NUMBER = 'INDIVIDUALS_NUMBER',
  /** INITIAL FUNDING */
  INITIAL_FUNDING = 'INITIAL_FUNDING',
  /** INITIAL_FUNDING_WALLET_ADDRESSES ... */
  INITIAL_FUNDING_WALLET_ADDRESSES = 'INITIAL_FUNDING_WALLET_ADDRESSES',
  /** INITIAL_FUNDING_WALLET_DO_OWN_WALLET ... */
  INITIAL_FUNDING_WALLET_DO_OWN_WALLET = 'INITIAL_FUNDING_WALLET_DO_OWN_WALLET',
  /** INITIAL_FUNDING_WALLET_GROUP ... */
  INITIAL_FUNDING_WALLET_GROUP = 'INITIAL_FUNDING_WALLET_GROUP',
  /** INITIAL_FUNDING_WALLET_ORIGINATOR_COUNTRY ... */
  INITIAL_FUNDING_WALLET_ORIGINATOR_COUNTRY = 'INITIAL_FUNDING_WALLET_ORIGINATOR_COUNTRY',
  /** INITIAL_FUNDING_WALLET_ORIGINATOR_NAME ... */
  INITIAL_FUNDING_WALLET_ORIGINATOR_NAME = 'INITIAL_FUNDING_WALLET_ORIGINATOR_NAME',
  /** INVESTABLE_ASSETS ... */
  INVESTABLE_ASSETS = 'INVESTABLE_ASSETS',
  /** INVESTABLE_ASSETS_AT_ANCHORAGE */
  INVESTABLE_ASSETS_AT_ANCHORAGE = 'INVESTABLE_ASSETS_AT_ANCHORAGE',
  /** INVESTABLE_ASSETS_AT_ANCHORAGE_SGD ... */
  INVESTABLE_ASSETS_AT_ANCHORAGE_SGD = 'INVESTABLE_ASSETS_AT_ANCHORAGE_SGD',
  /** INVESTABLE_ASSETS_AT_ANCHORAGE_USD */
  INVESTABLE_ASSETS_AT_ANCHORAGE_USD = 'INVESTABLE_ASSETS_AT_ANCHORAGE_USD',
  /** INVESTABLE_ASSETS_CRYPTO_PERCENTAGE ... */
  INVESTABLE_ASSETS_CRYPTO_PERCENTAGE = 'INVESTABLE_ASSETS_CRYPTO_PERCENTAGE',
  /** INVESTABLE_ASSETS_CUSTODY ... */
  INVESTABLE_ASSETS_CUSTODY = 'INVESTABLE_ASSETS_CUSTODY',
  /** INVESTMENT_ADVISER_REGISTRATION ... */
  INVESTMENT_ADVISER_REGISTRATION = 'INVESTMENT_ADVISER_REGISTRATION',
  /** INVESTMENT_ADVISER_REGISTRATION_IARD ... */
  INVESTMENT_ADVISER_REGISTRATION_IARD = 'INVESTMENT_ADVISER_REGISTRATION_IARD',
  /** INVESTMENT_ADVISER_REGISTRATION_PRIMARY_STATE ... */
  INVESTMENT_ADVISER_REGISTRATION_PRIMARY_STATE = 'INVESTMENT_ADVISER_REGISTRATION_PRIMARY_STATE',
  /** INVESTMENT_ADVISOR_REGISTRATION ... */
  INVESTMENT_ADVISOR_REGISTRATION = 'INVESTMENT_ADVISOR_REGISTRATION',
  /** INVESTMENT_MANAGER_NAME ... */
  INVESTMENT_MANAGER_NAME = 'INVESTMENT_MANAGER_NAME',
  /** IS_BEARER_OR_REGISTERED_SHARES ... */
  IS_BEARER_OR_REGISTERED_SHARES = 'IS_BEARER_OR_REGISTERED_SHARES',
  /** IS_CHARITABLE_ORGANIZATION */
  IS_CHARITABLE_ORGANIZATION = 'IS_CHARITABLE_ORGANIZATION',
  /** IS_CUSTOMER_PRINCIPLE_OR_AGENT ... */
  IS_CUSTOMER_PRINCIPLE_OR_AGENT = 'IS_CUSTOMER_PRINCIPLE_OR_AGENT',
  /** IS_ECP ... */
  IS_ECP = 'IS_ECP',
  /** IS_PUBLIC_COMPANY ... */
  IS_PUBLIC_COMPANY = 'IS_PUBLIC_COMPANY',
  /** IS_REGISTERED_AS_MSB */
  IS_REGISTERED_AS_MSB = 'IS_REGISTERED_AS_MSB',
  /** IS_SUBSIDIARY_PUBLICLY_COMPANY ... */
  IS_SUBSIDIARY_PUBLICLY_COMPANY = 'IS_SUBSIDIARY_PUBLICLY_COMPANY',
  /** IS_TOKEN_BLOCKCHAIN_IN_PRODUCTION ... */
  IS_TOKEN_BLOCKCHAIN_IN_PRODUCTION = 'IS_TOKEN_BLOCKCHAIN_IN_PRODUCTION',
  /** IS_US_CFTC ... */
  IS_US_CFTC = 'IS_US_CFTC',
  /** JURISDICTIONS_TO_CONDUCT_INTERNATIONAL_WIRE */
  JURISDICTIONS_TO_CONDUCT_INTERNATIONAL_WIRE = 'JURISDICTIONS_TO_CONDUCT_INTERNATIONAL_WIRE',
  /** KYC_AFFILIATE_FORM_SUBMISSION_ID ... */
  KYC_AFFILIATE_FORM_SUBMISSION_ID = 'KYC_AFFILIATE_FORM_SUBMISSION_ID',
  /** LAST_NAME ... */
  LAST_NAME = 'LAST_NAME',
  /** LAW_ABIDING_CONFIRMATION ... */
  LAW_ABIDING_CONFIRMATION = 'LAW_ABIDING_CONFIRMATION',
  /** LEGAL_CITY */
  LEGAL_CITY = 'LEGAL_CITY',
  /** LEGAL_COUNTRY */
  LEGAL_COUNTRY = 'LEGAL_COUNTRY',
  /** LEGAL_REGIST_ADDR_DIF_PRINC_PLACE ... */
  LEGAL_REGIST_ADDR_DIF_PRINC_PLACE = 'LEGAL_REGIST_ADDR_DIF_PRINC_PLACE',
  /** LEGAL_STATE */
  LEGAL_STATE = 'LEGAL_STATE',
  /** LEGAL_STREET_ADDRESS */
  LEGAL_STREET_ADDRESS = 'LEGAL_STREET_ADDRESS',
  /** LEGAL_STREET_ADDRESS_SECOND ... */
  LEGAL_STREET_ADDRESS_SECOND = 'LEGAL_STREET_ADDRESS_SECOND',
  /** LEGAL_ZIP_CODE */
  LEGAL_ZIP_CODE = 'LEGAL_ZIP_CODE',
  /** LEGITIMACY_OF_ENTITY_ASSOCIATED ... */
  LEGITIMACY_OF_ENTITY_ASSOCIATED = 'LEGITIMACY_OF_ENTITY_ASSOCIATED',
  /** LICENSED_MSB_STATES ... */
  LICENSED_MSB_STATES = 'LICENSED_MSB_STATES',
  /** LICENSE_DATE_OF_REGISTRATION ... */
  LICENSE_DATE_OF_REGISTRATION = 'LICENSE_DATE_OF_REGISTRATION',
  /** LICENSE_DOCUMENT ... */
  LICENSE_DOCUMENT = 'LICENSE_DOCUMENT',
  /** LICENSE_EVIDENCE_REGISTRATION ... */
  LICENSE_EVIDENCE_REGISTRATION = 'LICENSE_EVIDENCE_REGISTRATION',
  /** LICENSE_REGISTRATION_NO ... */
  LICENSE_REGISTRATION_NO = 'LICENSE_REGISTRATION_NO',
  /** LICENSE_REGULATORY_AUTHORITY ... */
  LICENSE_REGULATORY_AUTHORITY = 'LICENSE_REGULATORY_AUTHORITY',
  /** LICENSE_TYPE ... */
  LICENSE_TYPE = 'LICENSE_TYPE',
  /** LICENSE_VALIDITY_FROM ... */
  LICENSE_VALIDITY_FROM = 'LICENSE_VALIDITY_FROM',
  /** LICENSE_VALIDITY_TO ... */
  LICENSE_VALIDITY_TO = 'LICENSE_VALIDITY_TO',
  /** LIST_OF_ATMS */
  LIST_OF_ATMS = 'LIST_OF_ATMS',
  /** MAILING_ADDRESS ... */
  MAILING_ADDRESS = 'MAILING_ADDRESS',
  /** MAILING_ADDRESS2 ... */
  MAILING_ADDRESS2 = 'MAILING_ADDRESS2',
  /** MAILING_CITY */
  MAILING_CITY = 'MAILING_CITY',
  /** MAILING_COUNTRY */
  MAILING_COUNTRY = 'MAILING_COUNTRY',
  /** MAILING_DIF_PRINCIPAL_PLACE ... */
  MAILING_DIF_PRINCIPAL_PLACE = 'MAILING_DIF_PRINCIPAL_PLACE',
  /** MAILING_STATE */
  MAILING_STATE = 'MAILING_STATE',
  /** MAILING_STREET_ADDRESS */
  MAILING_STREET_ADDRESS = 'MAILING_STREET_ADDRESS',
  /** MAILING_STREET_ADDRESS_SECOND ... */
  MAILING_STREET_ADDRESS_SECOND = 'MAILING_STREET_ADDRESS_SECOND',
  /** MAILING_ZIP_CODE */
  MAILING_ZIP_CODE = 'MAILING_ZIP_CODE',
  /** MAINTAIN_AML ... */
  MAINTAIN_AML = 'MAINTAIN_AML',
  /** MAINTAIN_AML_EVIDENCE_AML_ATTESTATION */
  MAINTAIN_AML_EVIDENCE_AML_ATTESTATION = 'MAINTAIN_AML_EVIDENCE_AML_ATTESTATION',
  /** MAINTAIN_AML_EXPLAIN_IF_NO ... */
  MAINTAIN_AML_EXPLAIN_IF_NO = 'MAINTAIN_AML_EXPLAIN_IF_NO',
  /** MANAGER_KYC_JIRA_LINK ... */
  MANAGER_KYC_JIRA_LINK = 'MANAGER_KYC_JIRA_LINK',
  /** MANAGER_LINKAGE_DOCUMENT ... */
  MANAGER_LINKAGE_DOCUMENT = 'MANAGER_LINKAGE_DOCUMENT',
  /** MANAGER_MEMBER ... */
  MANAGER_MEMBER = 'MANAGER_MEMBER',
  /** MATERIAL_NEWS ... */
  MATERIAL_NEWS = 'MATERIAL_NEWS',
  /** MIDDLE_NAME ... */
  MIDDLE_NAME = 'MIDDLE_NAME',
  /** MINING_COUNTRIES */
  MINING_COUNTRIES = 'MINING_COUNTRIES',
  /** MINING_DIGITAL_ASSETS */
  MINING_DIGITAL_ASSETS = 'MINING_DIGITAL_ASSETS',
  /** MINING_DIGITAL_ASSETS_AMOUNT */
  MINING_DIGITAL_ASSETS_AMOUNT = 'MINING_DIGITAL_ASSETS_AMOUNT',
  /** MINING_HASH_POWER */
  MINING_HASH_POWER = 'MINING_HASH_POWER',
  /** MINING_POWER_CONSUMPTION */
  MINING_POWER_CONSUMPTION = 'MINING_POWER_CONSUMPTION',
  /** MINING_STATES */
  MINING_STATES = 'MINING_STATES',
  /** MSB_AML_PROGRAM_DATE ... */
  MSB_AML_PROGRAM_DATE = 'MSB_AML_PROGRAM_DATE',
  /** MSB_LOCATION ... */
  MSB_LOCATION = 'MSB_LOCATION',
  /** MSB_REGISTRATION_AGENCY */
  MSB_REGISTRATION_AGENCY = 'MSB_REGISTRATION_AGENCY',
  /** MSB_REGISTRATION_DATE ... */
  MSB_REGISTRATION_DATE = 'MSB_REGISTRATION_DATE',
  /** MSB_REGISTRATION_NUMBER */
  MSB_REGISTRATION_NUMBER = 'MSB_REGISTRATION_NUMBER',
  /** MSB_TYPES ... */
  MSB_TYPES = 'MSB_TYPES',
  /** NAME ... */
  NAME = 'NAME',
  /** NATURE_OF_BUSINESS */
  NATURE_OF_BUSINESS = 'NATURE_OF_BUSINESS',
  /** NAV_REPORT ... */
  NAV_REPORT = 'NAV_REPORT',
  /** NON_CUSTODIAL_WALLET_ADDRESSES */
  NON_CUSTODIAL_WALLET_ADDRESSES = 'NON_CUSTODIAL_WALLET_ADDRESSES',
  /** NON_MATERIAL_NEWS ... */
  NON_MATERIAL_NEWS = 'NON_MATERIAL_NEWS',
  /** NYC_OFFICE */
  NYC_OFFICE = 'NYC_OFFICE',
  /** OCCUPATION ... */
  OCCUPATION = 'OCCUPATION',
  /** OFFERING_DOCUMENT ... */
  OFFERING_DOCUMENT = 'OFFERING_DOCUMENT',
  /** OFFER_ALTERNATIVE_PAYMENT_METHOD ... */
  OFFER_ALTERNATIVE_PAYMENT_METHOD = 'OFFER_ALTERNATIVE_PAYMENT_METHOD',
  /** OFFER_CRYPTO_TRADE_TPF ... */
  OFFER_CRYPTO_TRADE_TPF = 'OFFER_CRYPTO_TRADE_TPF',
  /** ONBOARDING_API_SUBMISSION_ID */
  ONBOARDING_API_SUBMISSION_ID = 'ONBOARDING_API_SUBMISSION_ID',
  /** ONLY_DEALS_WITH_CLIENTS ... */
  ONLY_DEALS_WITH_CLIENTS = 'ONLY_DEALS_WITH_CLIENTS',
  /** OPERATING_AGREEMENT ... */
  OPERATING_AGREEMENT = 'OPERATING_AGREEMENT',
  /** ORGANIZATIONAL_OWNERSHIP_CHART */
  ORGANIZATIONAL_OWNERSHIP_CHART = 'ORGANIZATIONAL_OWNERSHIP_CHART',
  /** ORGANIZATIONAL_STRUCTURE_DOCUMENT */
  ORGANIZATIONAL_STRUCTURE_DOCUMENT = 'ORGANIZATIONAL_STRUCTURE_DOCUMENT',
  /** ORGANIZATION_CHART ... */
  ORGANIZATION_CHART = 'ORGANIZATION_CHART',
  /** OUTSOURCED_ENTITY_INFORMATION */
  OUTSOURCED_ENTITY_INFORMATION = 'OUTSOURCED_ENTITY_INFORMATION',
  /** OUTSOURCE_AML_REQUIREMENTS */
  OUTSOURCE_AML_REQUIREMENTS = 'OUTSOURCE_AML_REQUIREMENTS',
  /** OWNERSHIP_CHART ... */
  OWNERSHIP_CHART = 'OWNERSHIP_CHART',
  /** OWNERSHIP_INDIVIDUAL_SSN_OR_PASSPORT_NO ... */
  OWNERSHIP_INDIVIDUAL_SSN_OR_PASSPORT_NO = 'OWNERSHIP_INDIVIDUAL_SSN_OR_PASSPORT_NO',
  /** OWNERSHIP_PERCENTAGE ... */
  OWNERSHIP_PERCENTAGE = 'OWNERSHIP_PERCENTAGE',
  /** PARENT_FUND_FINANCIALS_DOCUMENT ... */
  PARENT_FUND_FINANCIALS_DOCUMENT = 'PARENT_FUND_FINANCIALS_DOCUMENT',
  /** PARTNERSHIP_AGREEMENT ... */
  PARTNERSHIP_AGREEMENT = 'PARTNERSHIP_AGREEMENT',
  /** PATRIOT_ACT_CERTIFICATION */
  PATRIOT_ACT_CERTIFICATION = 'PATRIOT_ACT_CERTIFICATION',
  /** PENSION_SUBFUNDS ... */
  PENSION_SUBFUNDS = 'PENSION_SUBFUNDS',
  /** PEP ... */
  PEP = 'PEP',
  /** PEP_INDIVIDUALS */
  PEP_INDIVIDUALS = 'PEP_INDIVIDUALS',
  /** PHONE ... */
  PHONE = 'PHONE',
  /** POOLED_VEHICLE ... */
  POOLED_VEHICLE = 'POOLED_VEHICLE',
  /** PPM_OR_OM ... */
  PPM_OR_OM = 'PPM_OR_OM',
  /** PRIMARY_ACCOUNT_OBJECTIVE ... */
  PRIMARY_ACCOUNT_OBJECTIVE = 'PRIMARY_ACCOUNT_OBJECTIVE',
  /** PRIMARY_ACCOUNT_OBJECTIVE_DEADLINE ... */
  PRIMARY_ACCOUNT_OBJECTIVE_DEADLINE = 'PRIMARY_ACCOUNT_OBJECTIVE_DEADLINE',
  /** PRINCIPAL_PLACE_OF_BUSINESS ... */
  PRINCIPAL_PLACE_OF_BUSINESS = 'PRINCIPAL_PLACE_OF_BUSINESS',
  /** PROGRAM_CUSTOMER_EMAIL ... */
  PROGRAM_CUSTOMER_EMAIL = 'PROGRAM_CUSTOMER_EMAIL',
  /** PROGRAM_CUSTOMER_NAME ... */
  PROGRAM_CUSTOMER_NAME = 'PROGRAM_CUSTOMER_NAME',
  /** PROGRAM_SIGNER_EMAIL ... */
  PROGRAM_SIGNER_EMAIL = 'PROGRAM_SIGNER_EMAIL',
  /** PROGRAM_SIGNER_FIRST_NAME ... */
  PROGRAM_SIGNER_FIRST_NAME = 'PROGRAM_SIGNER_FIRST_NAME',
  /** PROGRAM_SIGNER_GROUP ... */
  PROGRAM_SIGNER_GROUP = 'PROGRAM_SIGNER_GROUP',
  /** PROGRAM_SIGNER_LAST_NAME ... */
  PROGRAM_SIGNER_LAST_NAME = 'PROGRAM_SIGNER_LAST_NAME',
  /** PROOF_OF_ADDRESS ... */
  PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
  /** PROOF_OF_IDENTITY ... */
  PROOF_OF_IDENTITY = 'PROOF_OF_IDENTITY',
  /** PUBLICLY_TRADED_STOCK_EXCHANGES ... */
  PUBLICLY_TRADED_STOCK_EXCHANGES = 'PUBLICLY_TRADED_STOCK_EXCHANGES',
  /** QC_ADDITIONAL_NOTES ... */
  QC_ADDITIONAL_NOTES = 'QC_ADDITIONAL_NOTES',
  /** QC_FINAL_CHECK ... */
  QC_FINAL_CHECK = 'QC_FINAL_CHECK',
  /** RECIPIENT_EMAIL ... */
  RECIPIENT_EMAIL = 'RECIPIENT_EMAIL',
  /** RECIPIENT_NAME ... */
  RECIPIENT_NAME = 'RECIPIENT_NAME',
  /** REGISTRATION_AGENCY ... */
  REGISTRATION_AGENCY = 'REGISTRATION_AGENCY',
  /** REGULATED_STATUS */
  REGULATED_STATUS = 'REGULATED_STATUS',
  /** RELATED_PARTY ... */
  RELATED_PARTY = 'RELATED_PARTY',
  /** RELATED_PARTY_GROUP ... */
  RELATED_PARTY_GROUP = 'RELATED_PARTY_GROUP',
  /** RELATED_PARTY_NAME ... */
  RELATED_PARTY_NAME = 'RELATED_PARTY_NAME',
  /** RELATED_PARTY_SCREENED ... */
  RELATED_PARTY_SCREENED = 'RELATED_PARTY_SCREENED',
  /** RELATED_PARTY_TYPE ... */
  RELATED_PARTY_TYPE = 'RELATED_PARTY_TYPE',
  /** RESTRICTED_ACTIVITIES */
  RESTRICTED_ACTIVITIES = 'RESTRICTED_ACTIVITIES',
  /** RESTRICTED_ACTIVITIES_ADULT_ENTERTAINMENT */
  RESTRICTED_ACTIVITIES_ADULT_ENTERTAINMENT = 'RESTRICTED_ACTIVITIES_ADULT_ENTERTAINMENT',
  /** RESTRICTED_ACTIVITIES_DRUGS */
  RESTRICTED_ACTIVITIES_DRUGS = 'RESTRICTED_ACTIVITIES_DRUGS',
  /** RESTRICTED_ACTIVITIES_FIREARMS */
  RESTRICTED_ACTIVITIES_FIREARMS = 'RESTRICTED_ACTIVITIES_FIREARMS',
  /** RESTRICTED_ACTIVITIES_GAMBLING */
  RESTRICTED_ACTIVITIES_GAMBLING = 'RESTRICTED_ACTIVITIES_GAMBLING',
  /** RESTRICTED_ACTIVITIES_MARIJUANA */
  RESTRICTED_ACTIVITIES_MARIJUANA = 'RESTRICTED_ACTIVITIES_MARIJUANA',
  /** RESTRICTED_ACTIVITIES_NONE */
  RESTRICTED_ACTIVITIES_NONE = 'RESTRICTED_ACTIVITIES_NONE',
  /** RESTRICTED_ACTIVITIES_TUMBLING */
  RESTRICTED_ACTIVITIES_TUMBLING = 'RESTRICTED_ACTIVITIES_TUMBLING',
  /** REVENUE_PERCENTAGE ... */
  REVENUE_PERCENTAGE = 'REVENUE_PERCENTAGE',
  /** REVENUE_SHARE_DOMESTIC ... */
  REVENUE_SHARE_DOMESTIC = 'REVENUE_SHARE_DOMESTIC',
  /** RIA_IND_AFFILIATE_ONBOARDING_API_SUBMISSION_ID ... */
  RIA_IND_AFFILIATE_ONBOARDING_API_SUBMISSION_ID = 'RIA_IND_AFFILIATE_ONBOARDING_API_SUBMISSION_ID',
  /** RIA_INST_AFFILIATE_ONBOARDING_API_SUBMISSION_ID ... */
  RIA_INST_AFFILIATE_ONBOARDING_API_SUBMISSION_ID = 'RIA_INST_AFFILIATE_ONBOARDING_API_SUBMISSION_ID',
  /** RP_INCORPORATION_DATE ... */
  RP_INCORPORATION_DATE = 'RP_INCORPORATION_DATE',
  /** RP_INCORPORATION_PLACE ... */
  RP_INCORPORATION_PLACE = 'RP_INCORPORATION_PLACE',
  /** RP_INVESTMENT_ADVISOR_NUMBER ... */
  RP_INVESTMENT_ADVISOR_NUMBER = 'RP_INVESTMENT_ADVISOR_NUMBER',
  /** SERVICE_TYPE_TO_TRANSACT_WITH */
  SERVICE_TYPE_TO_TRANSACT_WITH = 'SERVICE_TYPE_TO_TRANSACT_WITH',
  /** SETTLOR ... */
  SETTLOR = 'SETTLOR',
  /** SETTLORS_GROUP ... */
  SETTLORS_GROUP = 'SETTLORS_GROUP',
  /** SFPF_INDIVIDUALS ... */
  SFPF_INDIVIDUALS = 'SFPF_INDIVIDUALS',
  /** SGD_DEPOSIT_AMOUNT ... */
  SGD_DEPOSIT_AMOUNT = 'SGD_DEPOSIT_AMOUNT',
  /** SGD_WITHDRAWAL_AMOUNT ... */
  SGD_WITHDRAWAL_AMOUNT = 'SGD_WITHDRAWAL_AMOUNT',
  /** SHAREHOLDING_STRUCTURE ... */
  SHAREHOLDING_STRUCTURE = 'SHAREHOLDING_STRUCTURE',
  /** SHARES_HELD_PERCENT ... */
  SHARES_HELD_PERCENT = 'SHARES_HELD_PERCENT',
  /** SIGNATURE ... */
  SIGNATURE = 'SIGNATURE',
  /** SIGNED_TERMS_AGREEMENT_DOCUMENT ... */
  SIGNED_TERMS_AGREEMENT_DOCUMENT = 'SIGNED_TERMS_AGREEMENT_DOCUMENT',
  /** SOURCE_OF_FUNDS ... */
  SOURCE_OF_FUNDS = 'SOURCE_OF_FUNDS',
  /** SOURCE_OF_WEALTH */
  SOURCE_OF_WEALTH = 'SOURCE_OF_WEALTH',
  /** SOURCE_OF_WEALTH_DESCRIPTION ... */
  SOURCE_OF_WEALTH_DESCRIPTION = 'SOURCE_OF_WEALTH_DESCRIPTION',
  /** SPLIT_OF_TOTAL_TRANSACTION ... */
  SPLIT_OF_TOTAL_TRANSACTION = 'SPLIT_OF_TOTAL_TRANSACTION',
  /** SPONSOR_CLIENT_TYPE ... */
  SPONSOR_CLIENT_TYPE = 'SPONSOR_CLIENT_TYPE',
  /** State */
  STATE = 'STATE',
  /** STATEMENTS_PREFERENCE ... */
  STATEMENTS_PREFERENCE = 'STATEMENTS_PREFERENCE',
  /** STREET_ADDRESS */
  STREET_ADDRESS = 'STREET_ADDRESS',
  /** STREET_ADDRESS_SECOND ... */
  STREET_ADDRESS_SECOND = 'STREET_ADDRESS_SECOND',
  /** SUSPICIOUS_ACTIVITY ... */
  SUSPICIOUS_ACTIVITY = 'SUSPICIOUS_ACTIVITY',
  /** TAX_EXEMPTION_CERT ... */
  TAX_EXEMPTION_CERT = 'TAX_EXEMPTION_CERT',
  /** TERMS_AGREEMENT_ID ... */
  TERMS_AGREEMENT_ID = 'TERMS_AGREEMENT_ID',
  /** TICKER_SYMBOL ... */
  TICKER_SYMBOL = 'TICKER_SYMBOL',
  /** TITLE ... */
  TITLE = 'TITLE',
  /** TOKEN_TYPE ... */
  TOKEN_TYPE = 'TOKEN_TYPE',
  /** TOP_FIVE_DEPOSIT_WALLET ... */
  TOP_FIVE_DEPOSIT_WALLET = 'TOP_FIVE_DEPOSIT_WALLET',
  /** TOP_FIVE_DEPOSIT_WALLET_ADDRESS ... */
  TOP_FIVE_DEPOSIT_WALLET_ADDRESS = 'TOP_FIVE_DEPOSIT_WALLET_ADDRESS',
  /** TOP_FIVE_DEPOSIT_WALLET_NAME ... */
  TOP_FIVE_DEPOSIT_WALLET_NAME = 'TOP_FIVE_DEPOSIT_WALLET_NAME',
  /** TOP_FIVE_WITHDRAWAL_WALLET ... */
  TOP_FIVE_WITHDRAWAL_WALLET = 'TOP_FIVE_WITHDRAWAL_WALLET',
  /** TOP_FIVE_WITHDRAWAL_WALLET_ADDRESS ... */
  TOP_FIVE_WITHDRAWAL_WALLET_ADDRESS = 'TOP_FIVE_WITHDRAWAL_WALLET_ADDRESS',
  /** TOP_FIVE_WITHDRAWAL_WALLET_NAME ... */
  TOP_FIVE_WITHDRAWAL_WALLET_NAME = 'TOP_FIVE_WITHDRAWAL_WALLET_NAME',
  /** TOTAL_ASSETS_MANAGED */
  TOTAL_ASSETS_MANAGED = 'TOTAL_ASSETS_MANAGED',
  /** TOTAL_TRANSACTION_VALUE ... */
  TOTAL_TRANSACTION_VALUE = 'TOTAL_TRANSACTION_VALUE',
  /** TOTAL_VALUE_ASSETS_UNDER_CUSTODY ... */
  TOTAL_VALUE_ASSETS_UNDER_CUSTODY = 'TOTAL_VALUE_ASSETS_UNDER_CUSTODY',
  /** TRADING_ACTIVITY_JURISDICTION */
  TRADING_ACTIVITY_JURISDICTION = 'TRADING_ACTIVITY_JURISDICTION',
  /** TRADING_FREQUENCY_PER_MONTH */
  TRADING_FREQUENCY_PER_MONTH = 'TRADING_FREQUENCY_PER_MONTH',
  /** TRANSACTIONS_MONTHLY_IN_SGD ... */
  TRANSACTIONS_MONTHLY_IN_SGD = 'TRANSACTIONS_MONTHLY_IN_SGD',
  /** TRANSACTIONS_MONTHLY_IN_USD */
  TRANSACTIONS_MONTHLY_IN_USD = 'TRANSACTIONS_MONTHLY_IN_USD',
  /** TRANSACTION_FREQUENCY */
  TRANSACTION_FREQUENCY = 'TRANSACTION_FREQUENCY',
  /** TRANSACT_AT_FUND_OR_INVESTMENT_MANAGER_LEVEL ... */
  TRANSACT_AT_FUND_OR_INVESTMENT_MANAGER_LEVEL = 'TRANSACT_AT_FUND_OR_INVESTMENT_MANAGER_LEVEL',
  /** TRANSFERING_METHOD ... */
  TRANSFERING_METHOD = 'TRANSFERING_METHOD',
  /** TRANSFERRING_METHOD */
  TRANSFERRING_METHOD = 'TRANSFERRING_METHOD',
  /** TRANSFERRING_METHOD_DIGITAL_ASSETS */
  TRANSFERRING_METHOD_DIGITAL_ASSETS = 'TRANSFERRING_METHOD_DIGITAL_ASSETS',
  /** TRANSFERRING_METHOD_OTHER ... */
  TRANSFERRING_METHOD_OTHER = 'TRANSFERRING_METHOD_OTHER',
  /** TRANSFERRING_METHOD_SEN */
  TRANSFERRING_METHOD_SEN = 'TRANSFERRING_METHOD_SEN',
  /** TRANSFERRING_METHOD_WIRE */
  TRANSFERRING_METHOD_WIRE = 'TRANSFERRING_METHOD_WIRE',
  /** TRUSTEES_GROUP ... */
  TRUSTEES_GROUP = 'TRUSTEES_GROUP',
  /** TRUSTEE_GROUP ... */
  TRUSTEE_GROUP = 'TRUSTEE_GROUP',
  /** TRUST_AGREEMENT ... */
  TRUST_AGREEMENT = 'TRUST_AGREEMENT',
  /** TYPE_CUSTOMERS ... */
  TYPE_CUSTOMERS = 'TYPE_CUSTOMERS',
  /** TYPE_CUSTOMERS_MSB ... */
  TYPE_CUSTOMERS_MSB = 'TYPE_CUSTOMERS_MSB',
  /** TYPE_OF_BUSINESS ... */
  TYPE_OF_BUSINESS = 'TYPE_OF_BUSINESS',
  /** TYPE_OF_BUSINESS_SECOND ... */
  TYPE_OF_BUSINESS_SECOND = 'TYPE_OF_BUSINESS_SECOND',
  /** TYPE_OF_CUSTOMER */
  TYPE_OF_CUSTOMER = 'TYPE_OF_CUSTOMER',
  /** TYPE_OF_CUSTOMER_OTHER */
  TYPE_OF_CUSTOMER_OTHER = 'TYPE_OF_CUSTOMER_OTHER',
  /** TYPE_OF_CUSTOMER_SECOND ... */
  TYPE_OF_CUSTOMER_SECOND = 'TYPE_OF_CUSTOMER_SECOND',
  /** TYPE_OF_PIV ... */
  TYPE_OF_PIV = 'TYPE_OF_PIV',
  /** ULTIMATE_OWNERSHIP_PERSON ... */
  ULTIMATE_OWNERSHIP_PERSON = 'ULTIMATE_OWNERSHIP_PERSON',
  /** USAGE_OF_TRADING_PROCEEDS */
  USAGE_OF_TRADING_PROCEEDS = 'USAGE_OF_TRADING_PROCEEDS',
  /** USD_DEPOSIT_AMOUNT ... */
  USD_DEPOSIT_AMOUNT = 'USD_DEPOSIT_AMOUNT',
  /** USD_DEPOSIT_AMOUNT_PER_MONTH */
  USD_DEPOSIT_AMOUNT_PER_MONTH = 'USD_DEPOSIT_AMOUNT_PER_MONTH',
  /** USD_WITHDRAWAL_AMOUNT ... */
  USD_WITHDRAWAL_AMOUNT = 'USD_WITHDRAWAL_AMOUNT',
  /** USD_WITHDRAWAL_AMOUNT_PER_MONTH */
  USD_WITHDRAWAL_AMOUNT_PER_MONTH = 'USD_WITHDRAWAL_AMOUNT_PER_MONTH',
  /** VENDORS_AND_COUNTERPARTIES_COUNTRY_LIST */
  VENDORS_AND_COUNTERPARTIES_COUNTRY_LIST = 'VENDORS_AND_COUNTERPARTIES_COUNTRY_LIST',
  /** VENDORS_AND_COUNTERPARTIES_LIST */
  VENDORS_AND_COUNTERPARTIES_LIST = 'VENDORS_AND_COUNTERPARTIES_LIST',
  /** VENDOR_AND_COUNTERPARTY_COUNTRY_LIST ... */
  VENDOR_AND_COUNTERPARTY_COUNTRY_LIST = 'VENDOR_AND_COUNTERPARTY_COUNTRY_LIST',
  /** VENDOR_AND_COUNTERPARTY_LIST ... */
  VENDOR_AND_COUNTERPARTY_LIST = 'VENDOR_AND_COUNTERPARTY_LIST',
  /** VERIFICATION_BENEFICIAL_OWNER_COUNT */
  VERIFICATION_BENEFICIAL_OWNER_COUNT = 'VERIFICATION_BENEFICIAL_OWNER_COUNT',
  /** VERIFICATION_CONTROL_PERSON_COUNT */
  VERIFICATION_CONTROL_PERSON_COUNT = 'VERIFICATION_CONTROL_PERSON_COUNT',
  /** VERIFY_BENEFICIAL_OWNERS ... */
  VERIFY_BENEFICIAL_OWNERS = 'VERIFY_BENEFICIAL_OWNERS',
  /** W8_BEN_FORM ... */
  W8_BEN_FORM = 'W8_BEN_FORM',
  /** W8_OR_W9 ... */
  W8_OR_W9 = 'W8_OR_W9',
  /** W9_BEN_FORM ... */
  W9_BEN_FORM = 'W9_BEN_FORM',
  /** W9_TAX_DOCUMENT ... */
  W9_TAX_DOCUMENT = 'W9_TAX_DOCUMENT',
  /** WHITE_PAPER */
  WHITE_PAPER = 'WHITE_PAPER',
  /** WILL_CONDUCT_INTERNATIONAL_WIRE */
  WILL_CONDUCT_INTERNATIONAL_WIRE = 'WILL_CONDUCT_INTERNATIONAL_WIRE',
  /** WOLFSBERG_FCCQ ... */
  WOLFSBERG_FCCQ = 'WOLFSBERG_FCCQ',
  /** WOLFSBERG_QUESTIONNAIRE */
  WOLFSBERG_QUESTIONNAIRE = 'WOLFSBERG_QUESTIONNAIRE',
  /** Zip code */
  ZIP_CODE = 'ZIP_CODE'
}

/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfile = KYCProfile & {
  __typename: 'AffiliateKYCProfile';
  /** Accounts associated with the affiliate */
  accounts: Array<Account>;
  /** List of the deposit attributions associated with the affiliate */
  affiliateDepositAttributions: DepositAttributionConnectionV2;
  /** AffiliateStatus of the affiliate if it's OPEN or CLOSE (depends on account constraints) */
  affiliateStatus: AffiliateStatus;
  /** Affiliate type */
  affiliateType: Maybe<AffiliateType>;
  /** List of alert totals by type and age */
  alertTotals: Array<ComplianceAlertTotals>;
  /** List of the alerts associated with the affiliate KYC profile */
  alerts: AlertConnection;
  /** List of the alerts associated with the affiliate KYC profile in CSV format */
  alertsCSV: Scalars['String']['output'];
  /** Number of alerts created over time */
  alertsOverTime: Array<AlertsAtTime>;
  /** Anchorage entity associated with this profile */
  anchorageEntity: Maybe<AnchorageEntity>;
  /** List of case totals by type and age */
  caseTotals: Array<ComplianceCaseTotals>;
  /** List of the cases associated with the affiliate KYC profile */
  cases: CaseConnection;
  /** List of the cases associated with the affiliate KYC profile in CSV format */
  casesCSV: Scalars['String']['output'];
  /** Number of cases created over time */
  casesOverTime: Array<CasesAtTime>;
  /** Metadata associated with Affiliate closure */
  closureMetadata: Maybe<ClosureMetadata>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** CRR outcome is the accepted CRR value for the affiliate */
  crrScoreOutcome: Maybe<CRRScoreOutcome>;
  /** Customer type classification */
  customerType: Maybe<KYCProfileCustomerType>;
  /** Anchorage entities associated with this affiliate */
  entities: Array<AnchorageEntity>;
  /**
   * The underlying entity identifier (institutional affiliate id) this KYC profile is associated with.
   * Used by federation extensions in other subgraphs to look up affiliate-keyed data via @requires(fields: "entityID").
   */
  entityID: Scalars['String']['output'];
  /** Exemptions for this KYC profile - information types that are exempt from collection */
  exemptions: Array<Scalars['String']['output']>;
  /** Unique identifier for the KYC profile */
  id: Scalars['ID']['output'];
  /** KYC-related flags for compliance and risk assessment */
  kycFlags: Maybe<KYCProfileFlags>;
  /** Key-value information associated with this KYC profile */
  kycProfileInfos: Array<KYCProfileInfo>;
  /** KYC refresh date information */
  kycRefresh: Maybe<KYCProfileRefresh>;
  /** KYC legacy questionnaire for direct edit */
  legacyQuestionnaire: Maybe<Questionnaire>;
  /** Name of the affiliate */
  name: Scalars['String']['output'];
  numberOfSubaccounts: Maybe<Scalars['Int']['output']>;
  /** Onboarding Date is the date when the affiliate was fully onboarded at Anchorage */
  onboardingDate: Maybe<Scalars['Date']['output']>;
  /** Organization KYC profiles associated with this affiliate (can belong to multiple organizations) */
  organizationKYCProfiles: OrganizationKYCProfileConnection;
  /** Portfolio is an affiliate level summary of holdings */
  portfolio: Portfolio;
  postedBalance: Maybe<Scalars['String']['output']>;
  /** Program customers (child affiliates) associated with this parent RIA affiliate */
  programCustomers: ProgramCustomerKYCProfileConnection;
  /** Related party KYC profiles associated with this affiliate */
  relatedPartyKYCProfiles: RelatedPartyKYCProfileRelationConnection;
  /** Representatives associated with this KYC profile */
  representatives: RepresentativeConnection;
  /** Settings returns this affiliate specific settings */
  settings: Maybe<Array<Setting>>;
  /** Current status of the KYC profile */
  status: KYCStatus;
  /** withdrawalFrozen indicates whether the affiliate has or not withdrawal frozen */
  withdrawalFrozen: Scalars['Boolean']['output'];
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfileaffiliateDepositAttributionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DepositAttributionOrder>;
  sourceAddressesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<DepositAttributionPrivateWhereInput>;
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfilealertsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  alertID?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<AlertStatus>;
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfilealertsCSVArgs = {
  alertID?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<AlertStatus>;
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfilealertsOverTimeArgs = {
  aggregatedBy: AggregationFilterType;
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfilecasesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  caseID?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CaseStatusEnum>;
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfilecasesCSVArgs = {
  caseID?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CaseStatusEnum>;
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfilecasesOverTimeArgs = {
  aggregatedBy: AggregationFilterType;
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfilelegacyQuestionnaireArgs = {
  questionnaireType?: InputMaybe<Scalars['String']['input']>;
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfileorganizationKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfileprogramCustomersArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProgramCustomerKYCProfileWhereInput>;
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfilerelatedPartyKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relatedPartyType?: InputMaybe<RelatedPartyType>;
  rolesIn?: InputMaybe<Array<KYCRoleType>>;
  statusIn?: InputMaybe<Array<KYCStatus>>;
};


/** AffiliateKYCProfile represents KYC profile data for an affiliate entity */
export type AffiliateKYCProfilerepresentativesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Connection for AffiliateKYCProfile type */
export type AffiliateKYCProfileConnection = {
  __typename: 'AffiliateKYCProfileConnection';
  /** List of edges */
  edges: Array<AffiliateKYCProfileEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge for AffiliateKYCProfile type */
export type AffiliateKYCProfileEdge = {
  __typename: 'AffiliateKYCProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge */
  node: AffiliateKYCProfile;
};

/**
 * AffiliateKYCProfileRelatedPartyAudit represents a historical audit entry for affiliate - related party relationship changes.
 * Maps to underlying KYCProfileRelationAudit model in the logic layer.
 */
export type AffiliateKYCProfileRelatedPartyAudit = {
  __typename: 'AffiliateKYCProfileRelatedPartyAudit';
  /** The affiliate KYC profile (source) in this relationship. */
  affiliateKYCProfile: Maybe<AffiliateKYCProfile>;
  /** The action performed (CREATE, UPDATE, DELETE) */
  auditAction: Scalars['String']['output'];
  /** Unique identifier for this audit record */
  auditId: Scalars['ID']['output'];
  /** Optional notes about the audit action */
  auditNotes: Maybe<Scalars['String']['output']>;
  /** When the action was performed */
  auditTimestamp: Scalars['Timestamp']['output'];
  /** The user who performed the action */
  auditUser: Scalars['String']['output'];
  /** The related party KYC profile (destination) in this relationship. */
  relatedPartyKYCProfile: Maybe<RelatedPartyKYCProfile>;
  /** Role information for this relationship at the time of the audit. */
  relationRole: Maybe<KYCProfileRelationAuditRole>;
};

/** A connection to a list of AffiliateKYCProfileRelatedPartyAudit items. */
export type AffiliateKYCProfileRelatedPartyAuditConnection = {
  __typename: 'AffiliateKYCProfileRelatedPartyAuditConnection';
  /** A list of edges. */
  edges: Array<AffiliateKYCProfileRelatedPartyAuditEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in an AffiliateKYCProfileRelatedPartyAudit connection. */
export type AffiliateKYCProfileRelatedPartyAuditEdge = {
  __typename: 'AffiliateKYCProfileRelatedPartyAuditEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: AffiliateKYCProfileRelatedPartyAudit;
};

/**
 * AffiliateKYCProfileRelation represents the relationship between a related party and an affiliate
 * This type contains both the affiliate KYC profile and the metadata about their relationship
 */
export type AffiliateKYCProfileRelation = KYCProfileRelation & {
  __typename: 'AffiliateKYCProfileRelation';
  /** The affiliate KYC profile */
  affiliate: AffiliateKYCProfile;
  /** Ownership percentage in this relationship (for beneficial owners) */
  ownershipPercentage: Maybe<Scalars['String']['output']>;
  /** Role description (e.g., CEO, CFO, Board Member) */
  roleDescription: Maybe<Scalars['String']['output']>;
  /** Types of relationship (e.g., BENEFICIAL_OWNER, CONTROL_PERSON, AUTHORIZED_REPRESENTATIVE) */
  roles: Maybe<Array<KYCRoleType>>;
};

/** Connection for AffiliateKYCProfileRelation type */
export type AffiliateKYCProfileRelationConnection = {
  __typename: 'AffiliateKYCProfileRelationConnection';
  /** List of edges */
  edges: Array<AffiliateKYCProfileRelationEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge for AffiliateKYCProfileRelation type */
export type AffiliateKYCProfileRelationEdge = {
  __typename: 'AffiliateKYCProfileRelationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge */
  node: AffiliateKYCProfileRelation;
};

/** Ordering options for affiliate KYC profile relation connections */
export type AffiliateKYCProfileRelationOrder = {
  /** The ordering direction */
  direction?: OrderDirection;
  /** The field by which to order affiliate KYC profile relations */
  field: AffiliateKYCProfileRelationOrderField;
};

/** Properties by which affiliate KYC profile relation connections can be ordered */
export enum AffiliateKYCProfileRelationOrderField {
  /** Order by affiliate name */
  NAME = 'NAME'
}

/** AffiliateStatus represents the status of the affiliate based on account constraints */
export enum AffiliateStatus {
  /** CLOSED represents an affiliate where all accounts have been closed */
  CLOSED = 'CLOSED',
  /** OPEN represents an affiliate with at least one non-closed account */
  OPEN = 'OPEN'
}

/** Specifies the type of affiliate */
export enum AffiliateType {
  /** All other affiliate types. */
  ANCHORAGE_INSTITUTION = 'ANCHORAGE_INSTITUTION',
  /** ARMADA_INSTITUTION is the affiliate type for an institution onboarding to Anchorage Armada, ADB's agentic banking/payments product. Its onboarding rules are defined on institutional.AffiliateTypeArmadaInstitution. */
  ARMADA_INSTITUTION = 'ARMADA_INSTITUTION',
  /** INVESTMENT_MANAGER is the affiliate type fund managers */
  INVESTMENT_MANAGER = 'INVESTMENT_MANAGER',
  /** MANAGED_FUND is the affiliate type for funds managed by an investment fund */
  MANAGED_FUND = 'MANAGED_FUND',
  /** Affiliate that is an RIA parent affiliate. */
  REGISTERED_INVESTMENT_ADVISOR = 'REGISTERED_INVESTMENT_ADVISOR',
  /** RIA_PC_ACCOUNT is the affiliate type for holding the RIA subaccounting KnownInformation that needs kyc screening */
  RIA_PC_ACCOUNT = 'RIA_PC_ACCOUNT',
  /** Affiliate that is an RIA individual. */
  RIA_PC_INDIVIDUAL = 'RIA_PC_INDIVIDUAL',
  /** Affiliate that is an RIA institution. */
  RIA_PC_INSTITUTION = 'RIA_PC_INSTITUTION',
  /** STABLECOIN_SETTLEMENT_ACCOUNT is the affiliate type for a stablecoin settlement account. */
  STABLECOIN_SETTLEMENT_ACCOUNT = 'STABLECOIN_SETTLEMENT_ACCOUNT',
  /** Affiliate that is a Virtual Account owner individual. */
  VA_INDIVIDUAL = 'VA_INDIVIDUAL',
  /** Affiliate that is a Virtual Account owner institution. */
  VA_INSTITUTION = 'VA_INSTITUTION'
}

/** A top level affiliate */
export type AffiliateV2 = Node & {
  __typename: 'AffiliateV2';
  KYCApplications: Maybe<Array<Maybe<InstitutionalAffiliate>>>;
  affiliateAnchorageRelationships: AffiliateAnchorageRelationshipConnection;
  /** Affiliate KYC profiles associated with this affiliate */
  affiliateKYCProfiles: AffiliateKYCProfileConnection;
  createdAt: Scalars['Time']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  deletedBy: Maybe<Scalars['String']['output']>;
  /** Unique affiliate identifier */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Status of the affiliate based on account close constraints.
   * If all accounts for this affiliate have the close account constraint fulfilled, the status is CLOSED.
   * Otherwise, the status is OPEN.
   */
  status: AffiliateStatus;
  updatedAt: Scalars['Time']['output'];
};


/** A top level affiliate */
export type AffiliateV2KYCApplicationsArgs = {
  filter?: InputMaybe<KYCApplicationFilter>;
};


/** A top level affiliate */
export type AffiliateV2affiliateAnchorageRelationshipsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AffiliateAnchorageRelationshipWhereInput>;
};


/** A top level affiliate */
export type AffiliateV2affiliateKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type AffiliateV2Connection = {
  __typename: 'AffiliateV2Connection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AffiliateV2Edge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AffiliateV2Edge = {
  __typename: 'AffiliateV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AffiliateV2>;
};

/** Ordering options for AffiliateV2 connections */
export type AffiliateV2Order = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AffiliateV2s. */
  field: AffiliateV2OrderField;
};

/** Properties by which AffiliateV2 connections can be ordered. */
export enum AffiliateV2OrderField {
  NAME = 'NAME'
}

/**
 * AffiliateV2WhereInput is used for filtering AffiliateV2 objects.
 * Input was generated by ent.
 */
export type AffiliateV2WhereInput = {
  and?: InputMaybe<Array<AffiliateV2WhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_by field predicates */
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByContains?: InputMaybe<Scalars['String']['input']>;
  deletedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deletedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deletedByGT?: InputMaybe<Scalars['String']['input']>;
  deletedByGTE?: InputMaybe<Scalars['String']['input']>;
  deletedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deletedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deletedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLT?: InputMaybe<Scalars['String']['input']>;
  deletedByLTE?: InputMaybe<Scalars['String']['input']>;
  deletedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deletedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** affiliate_anchorage_relationships edge predicates */
  hasAffiliateAnchorageRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasAffiliateAnchorageRelationshipsWith?: InputMaybe<Array<AffiliateAnchorageRelationshipWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AffiliateV2WhereInput>;
  or?: InputMaybe<Array<AffiliateV2WhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** AggregatedByCountryTransaction the aggregated total value of transactions be country */
export type AggregatedByCountryTransaction = {
  __typename: 'AggregatedByCountryTransaction';
  /** Code for country */
  countryCode: Scalars['String']['output'];
  /** Numbers of deposits */
  depositsCount: Scalars['Int']['output'];
  /** Value of deposits in USD */
  depositsValueInUsd: Scalars['String']['output'];
  /** Label for country */
  label: Scalars['String']['output'];
  /** Number of withdrawals\transfers */
  withdrawalsCount: Scalars['Int']['output'];
  /** Value of withdrawals\transfers in USD */
  withdrawalsValueInUsd: Scalars['String']['output'];
};

/** AggregatedTransactionVolume the aggregated total value of transactions in a time period */
export type AggregatedTransactionVolume = {
  __typename: 'AggregatedTransactionVolume';
  /** Numbers of deposits */
  depositsCount: Scalars['Int']['output'];
  /** Value of deposits in USD */
  depositsValueInUsd: Scalars['String']['output'];
  /** Label for the aggregated transaction volume */
  label: Scalars['String']['output'];
  /** Order of the aggregated data */
  order: Scalars['Int']['output'];
  /** Number of withdrawals\transfers */
  withdrawalsCount: Scalars['Int']['output'];
  /** Value of withdrawals\transfers in USD */
  withdrawalsValueInUsd: Scalars['String']['output'];
};

/** AggregationFilterType represents the time frame aggregation for a dataset */
export enum AggregationFilterType {
  /** Data will be aggregated per day */
  DAY = 'DAY',
  /** Data will be aggregated per month */
  MONTH = 'MONTH',
  /** Data will be aggregated per week */
  WEEK = 'WEEK'
}

export type AgreementPrefill = {
  __typename: 'AgreementPrefill';
  /** Whether the agreement renews automatically after the renewal term. */
  autoRenewalEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Billing cadence for this agreement. */
  billingFrequency: Maybe<BillingFrequency>;
  /** Date after which fees are accrued. */
  feeAccrualDate: Maybe<Scalars['Date']['output']>;
  /** Per-fee-type prefill metadata extracted from the agreement. */
  feePrefills: Maybe<Array<Maybe<FeePrefillMetadata>>>;
  /** Number of months after which the agreement is auto renewed, if set. */
  renewalTermMonths: Maybe<Scalars['Int']['output']>;
  /** Date when the agreement starts taking effect. */
  startDate: Maybe<Scalars['Date']['output']>;
};

export type AgreementPrefillPayload = {
  __typename: 'AgreementPrefillPayload';
  agreementPrefill: Maybe<AgreementPrefill>;
  warnings: Array<Scalars['String']['output']>;
};

export enum AgreementStatus {
  ACTIVE = 'ACTIVE',
  AMENDED = 'AMENDED',
  CANCELED = 'CANCELED',
  NEW = 'NEW',
  PENDING = 'PENDING',
  TERMINATED = 'TERMINATED',
  TERMINATION_IN_REVIEW = 'TERMINATION_IN_REVIEW',
  TERMINATION_UPCOMING = 'TERMINATION_UPCOMING'
}

export enum AgreementsFeeApproach {
  FIXED_FEE = 'FIXED_FEE',
  FIXED_FEE_PER_GROUP = 'FIXED_FEE_PER_GROUP',
  MINIMUM_FEE = 'MINIMUM_FEE',
  MINIMUM_FEE_PER_GROUP = 'MINIMUM_FEE_PER_GROUP'
}

/**
 * AUC_BASED and SURCHARGE are deprecated in favor of GREATER_VALUE. They remain accepted on
 * feeTypeUpdate for existing agreements/fee types migrated to the generic schema; the frontend
 * only sends GREATER_VALUE for new fee types, so no server-side restriction is enforced here.
 */
export enum AgreementsMinimumFeeType {
  AUC_BASED = 'AUC_BASED',
  GREATER_VALUE = 'GREATER_VALUE',
  SURCHARGE = 'SURCHARGE'
}

export type Alert = {
  __typename: 'Alert';
  accountID: Scalars['String']['output'];
  affiliateKYCProfileID: Maybe<Scalars['String']['output']>;
  /** Internal ID of the alert */
  alertID: Scalars['String']['output'];
  alertType: Maybe<AlertType>;
  /** Jira Case info (if the alert is associated to one) */
  associatedCase: Maybe<JiraComplianceIssue>;
  clientType: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  crr: Maybe<CRRScoreOutcome>;
  description: Maybe<Scalars['String']['output']>;
  extAssignee: Maybe<Scalars['String']['output']>;
  extInvestigator: Maybe<Scalars['String']['output']>;
  extTrackingID: Maybe<Scalars['String']['output']>;
  extTrackingLink: Maybe<Scalars['String']['output']>;
  /** Total amount flagged by the alert in USD */
  flaggedAmount: Amount;
  /** id is the unique identifier of the alert, equal to alertID */
  id: Scalars['ID']['output'];
  /** Get the list of operations in this alert with the Connection spec */
  operations: OperationConnection;
  orgKeyID: Scalars['String']['output'];
  status: Maybe<AlertStatus>;
  summary: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};


export type AlertoperationsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterActions?: InputMaybe<Array<OperationAction>>;
  filterCreatedSince?: InputMaybe<Scalars['String']['input']>;
  filterCreatedUntil?: InputMaybe<Scalars['String']['input']>;
  filterStates?: InputMaybe<Array<OperationState>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeChange?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<OperationSortFields>;
};

/** AlertConnection implements the connections spec */
export type AlertConnection = {
  __typename: 'AlertConnection';
  /** edges implements the connections spec */
  edges: Array<AlertEdge>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
};

/** AlertEdge implements the connections spec */
export type AlertEdge = {
  __typename: 'AlertEdge';
  /** cursor implements the connections spec */
  cursor: Scalars['String']['output'];
  /** node implements the connections spec */
  node: Alert;
};

export enum AlertStatus {
  /** CANCELED an alert that has been canceled */
  CANCELED = 'CANCELED',
  /** ESCALATED_TO_CASE an alert that has been escalated to a case */
  ESCALATED_TO_CASE = 'ESCALATED_TO_CASE',
  /** IN_REVIEW the alert is under review */
  IN_REVIEW = 'IN_REVIEW',
  /** MANAGER_REVIEW -the alert is under management review */
  MANAGER_REVIEW = 'MANAGER_REVIEW',
  /** NEW represents a new alert in Jira */
  NEW = 'NEW',
  /** PENDING represents a pending alert in Jira */
  PENDING = 'PENDING',
  /** QC_REVIEW is a alert where QC is reviewing */
  QC_REVIEW = 'QC_REVIEW',
  /** READY_QC is a alert ready for QC */
  READY_QC = 'READY_QC',
  /** RESOLVED an alert that has resolved */
  RESOLVED = 'RESOLVED'
}

/** AlertType are the possible types of jira alerts */
export enum AlertType {
  /** ADHOC_KYC represents an alert manually created via centralized client view */
  ADHOC_KYC = 'ADHOC_KYC',
  /** ATTRIBUTION_MONITORING_MISMATCH represents the attribution monitoring mismatch alert type */
  ATTRIBUTION_MONITORING_MISMATCH = 'ATTRIBUTION_MONITORING_MISMATCH',
  /** DORMANT_ACCOUNT represents the dormant account TM alert type */
  DORMANT_ACCOUNT = 'DORMANT_ACCOUNT',
  /** FIAT_FLOW_THROUGH represents the dormant account TM alert type */
  FIAT_FLOW_THROUGH = 'FIAT_FLOW_THROUGH',
  /** FIAT_HIGH_RISK_JURISDICTION represents the dormant account TM alert type */
  FIAT_HIGH_RISK_JURISDICTION = 'FIAT_HIGH_RISK_JURISDICTION',
  /** FIAT_HIGH_VALUE represents the dormant account TM alert type */
  FIAT_HIGH_VALUE = 'FIAT_HIGH_VALUE',
  /** FIAT_HIGH_VOLUME represents the dormant account TM alert type */
  FIAT_HIGH_VOLUME = 'FIAT_HIGH_VOLUME',
  /** FIAT_REPORTING_EVASION represents the dormant account TM alert type */
  FIAT_REPORTING_EVASION = 'FIAT_REPORTING_EVASION',
  /** FLOW_THROUGH represents the flow through alert type */
  FLOW_THROUGH = 'FLOW_THROUGH',
  /** FULL_KYC_REVIEW represents and alert generated by crr model, period refresh, initial onboarding, ownership change, or manual review */
  FULL_KYC_REVIEW = 'FULL_KYC_REVIEW',
  /** FUND_CLIENTS represents the fund clients TM alert type */
  FUND_CLIENTS = 'FUND_CLIENTS',
  /** HIGH_RISK_JURISDICTION represents the hrj alert type */
  HIGH_RISK_JURISDICTION = 'HIGH_RISK_JURISDICTION',
  /** HIGH_VOLUME_CLIENTS represents the high volume clients TM alert type */
  HIGH_VOLUME_CLIENTS = 'HIGH_VOLUME_CLIENTS',
  /** HISTORICAL_DEVIATIONS represents the historical deviations TM alert type */
  HISTORICAL_DEVIATIONS = 'HISTORICAL_DEVIATIONS',
  /** HUB_SPOKE_MULTI represents the hub and spoke multi alert type */
  HUB_SPOKE_MULTI = 'HUB_SPOKE_MULTI',
  /** HUB_SPOKE_SINGLE represents the hub and spoke single alert type */
  HUB_SPOKE_SINGLE = 'HUB_SPOKE_SINGLE',
  /** KYC_CRR_UPDATE represents an alert manually created via centralized client view */
  KYC_CRR_UPDATE = 'KYC_CRR_UPDATE',
  /** LOW_ACTIVITY_CLIENTS represents the low activity clients TM alert type */
  LOW_ACTIVITY_CLIENTS = 'LOW_ACTIVITY_CLIENTS',
  /** MINING_CLIENTS represents the mining clients TM alert type */
  MINING_CLIENTS = 'MINING_CLIENTS',
  /** NBFI_CLIENTS represents the nbfi clients TM alert type */
  NBFI_CLIENTS = 'NBFI_CLIENTS',
  /** NEGATIVE_NEWS represents the negative news issue type */
  NEGATIVE_NEWS = 'NEGATIVE_NEWS',
  /** NEGATIVE_NEWS_SCREENING represents the negative news screening alert type */
  NEGATIVE_NEWS_SCREENING = 'NEGATIVE_NEWS_SCREENING',
  /** OFAC_REPORTING represents the ofac reporting issue type */
  OFAC_REPORTING = 'OFAC_REPORTING',
  /** OFAC_REPORTING_SCREENING represents the ofac reporting screening alert type */
  OFAC_REPORTING_SCREENING = 'OFAC_REPORTING_SCREENING',
  /** PEP represents the pep issue type */
  PEP = 'PEP',
  /** PEP_SCREENING represents the pep screening alert type */
  PEP_SCREENING = 'PEP_SCREENING',
  /** REFERRAL represents the referral issue type */
  REFERRAL = 'REFERRAL',
  /** REPORTING_EVASION represents the TM reporting evasion alert type */
  REPORTING_EVASION = 'REPORTING_EVASION',
  /** UNHOSTED_WALLET represents the unhosted wallet alert type */
  UNHOSTED_WALLET = 'UNHOSTED_WALLET'
}

export type AlertsAtTime = {
  __typename: 'AlertsAtTime';
  alertType: Maybe<AlertType>;
  createdAt: Scalars['Date']['output'];
  numberOfAlerts: Scalars['Int']['output'];
};

/**
 * AllowedAsset represents an asset that needs to be authorized before receiving deposits.
 * This is primarily used for blockchains like Stellar where assets must be allowed before receiving the assets.
 */
export type AllowedAsset = {
  __typename: 'AllowedAsset';
  /** Information about the asset type for this asset */
  assetTypeInfo: AssetTypeInfo;
  /** The authorization status of this allowed asset */
  status: AllowedAssetStatus;
};

/** AllowedAssetStatus represents the authorization status of an asset. */
export enum AllowedAssetStatus {
  /** The asset is authorized and active */
  AUTHORIZED = 'AUTHORIZED',
  /** The asset is not authorized */
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  /** The asset authorization is pending */
  PENDING_AUTHORIZATION = 'PENDING_AUTHORIZATION',
  /** The asset deauthorization is pending */
  PENDING_DEAUTHORIZATION = 'PENDING_DEAUTHORIZATION'
}

/** AllowedAssetsInfo contains allowed asset information for an asset type */
export type AllowedAssetsInfo = {
  __typename: 'AllowedAssetsInfo';
  /** The operation type used to authorize/deauthorize this asset */
  operationType: Scalars['String']['output'];
  /** Whether asset authorization is required for this asset type */
  required: Scalars['Boolean']['output'];
  /** The required amount to authorize the asset */
  requiredAmount: Maybe<Amount>;
  /** UserIntentType is the ubiquitous-language intent type the FE should use instead of operationType. */
  userIntentType: Maybe<Scalars['String']['output']>;
};

/**
 * AllowlistedValidator is a validator that clients are permitted to stake to. It either applies to
 * all organizations or is scoped to the listed ones.
 */
export type AllowlistedValidator = {
  __typename: 'AllowlistedValidator';
  address: Scalars['String']['output'];
  appliesToAll: Scalars['Boolean']['output'];
  assetTypeID: Scalars['AssetTypeID']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationKeyIDs: Array<Scalars['String']['output']>;
};

/**
 * AllowlistedValidatorInput describes a validator to allowlist. Exactly one of appliesToAll or a
 * non-empty organizationKeyIDs must be set.
 */
export type AllowlistedValidatorInput = {
  address: Scalars['String']['input'];
  appliesToAll: Scalars['Boolean']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationKeyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * AllowlistedValidatorPublicInfo is the publicly shareable information about a validator an
 * organization is permitted to stake to. It deliberately omits the internal allowlisting policy
 * (whether it applies to all organizations and which ones) so callers only learn that they may stake
 * to it, not how the allowlisting was configured.
 */
export type AllowlistedValidatorPublicInfo = {
  __typename: 'AllowlistedValidatorPublicInfo';
  address: Scalars['String']['output'];
  assetTypeID: Scalars['AssetTypeID']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** AmdSevSnpMeasurementsInput represents AMD SEV-SNP boot measurements. */
export type AmdSevSnpMeasurementsInput = {
  /** AMD SEV-SNP measurement (48 bytes, 96 hex characters). */
  measurement: Scalars['String']['input'];
};

export type AmendDvTradeInput = {
  /** Additional IM amount */
  additionalImAmount?: InputMaybe<Scalars['String']['input']>;
  /** Additional IM asset ID */
  additionalImAssetId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Telegram @username of the Affiliated Person who agreed the swap with the client, like
   * @name: 5 to 32 letters, digits or underscores after the @. Only amendable while the trade
   * is STAGED.
   */
  affiliatedPerson?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: allocation indicator (4-char code) */
  allocationIndicator?: InputMaybe<Scalars['String']['input']>;
  /** Barrier level -- required for EKO/EKI options, must be absent otherwise */
  barrier?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: cleared flag (e.g. "N" for uncleared swaps) */
  cleared?: InputMaybe<Scalars['String']['input']>;
  /** Trading direction (BUY/SELL) */
  direction?: InputMaybe<TradeSideEnum>;
  /** Effective as at time */
  effectiveAsAt?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Derivatives trading entity (A1, Swap Dealer, HedgeCo) faced by this trade.
   * Nullable until DERSWP-50 wires the write path.
   */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** Execution time */
  execTime?: InputMaybe<Scalars['Time']['input']>;
  /** Expiration time if applicable */
  expiration?: InputMaybe<Scalars['Time']['input']>;
  /** Fee amount is the amount to be paid in fees for the trade */
  feeAmount?: InputMaybe<Scalars['String']['input']>;
  /** Fee asset ID */
  feeAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** Fee direction */
  feeDirection?: InputMaybe<DVFeeDirection>;
  /**
   * Marks this amendment as supplying the determined price of a post-priced swap (strike for
   * forwards/swaps, premium for options). Reported to the SDR as a non-correction modification
   * (CFTC §43.3(a)(4)). Rejected on a package leg: a post-priced package finalizes as a unit
   * through dvFinalizePackagePrice.
   */
  finalizesPostPricedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fixed quanto rate (for quanto products) */
  fixedQuantoRate?: InputMaybe<Scalars['String']['input']>;
  /** Fixing source */
  fixingSource?: InputMaybe<Scalars['String']['input']>;
  /** Optional group ID for trade grouping */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** Initial margin amount */
  initialMarginAmount?: InputMaybe<Scalars['String']['input']>;
  /** Initial margin asset ID */
  initialMarginAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** Initial margin direction */
  initialMarginDirection?: InputMaybe<Scalars['String']['input']>;
  /** Initial margin method (SIMPLE/RISK_FACTOR/NONE) */
  initialMarginMethod?: InputMaybe<DVInitialMarginMethod>;
  /** Initial margin override flag */
  initialMarginOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** CFTC reporting: jurisdiction tag (e.g. "CFTC") */
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  /** Optional memo */
  memo?: InputMaybe<Scalars['String']['input']>;
  /**
   * Netting set the trade books into. Only amendable while the trade is STAGED; must belong to
   * one of the account's CSAs.
   */
  nettingSetId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * New per-package price. Only legal on a package leg; propagates to every sibling leg. Supply
   * the full trio; a package cannot switch between price and spread by amendment. Signed, net of
   * premium legs: may be negative.
   */
  packageTransactionPrice?: InputMaybe<Scalars['String']['input']>;
  /** 3-char ISO currency for the package price. Required when packageTransactionPrice is set. */
  packageTransactionPriceCurrency?: InputMaybe<Scalars['String']['input']>;
  /** 1-char notation code for the package price. Required when packageTransactionPrice is set. */
  packageTransactionPriceNotation?: InputMaybe<Scalars['String']['input']>;
  /**
   * New per-package spread (alternative to price). Only legal on a package leg; propagates to
   * every sibling leg.
   */
  packageTransactionSpread?: InputMaybe<Scalars['String']['input']>;
  /** 3-char ISO currency for the package spread. Required when packageTransactionSpread is set. */
  packageTransactionSpreadCurrency?: InputMaybe<Scalars['String']['input']>;
  /** 1-char notation code for the package spread. Required when packageTransactionSpread is set. */
  packageTransactionSpreadNotation?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: platform/execution facility identifier (4-char code) */
  platformIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The mid market mark price at the time of the trade */
  preTradeMidMarketMark?: InputMaybe<Scalars['String']['input']>;
  /** The price of the underlying spot market product at the time of the trade */
  preTradeSpotReference?: InputMaybe<Scalars['String']['input']>;
  /** Premium timing type (UPFRONT/AT_EXPIRY) */
  premiumCurrencyTimingType?: InputMaybe<Scalars['String']['input']>;
  /** Premium currency type (BASE/QUOTE/QUANTO) */
  premiumCurrencyType?: InputMaybe<Scalars['String']['input']>;
  /** Premium delivery time */
  premiumDeliveryTime?: InputMaybe<Scalars['Time']['input']>;
  /** Premium per base unit */
  premiumPerBaseUnit?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: prime brokerage transaction indicator */
  primeBrokerageTransactionIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  /** Quantity closed out in base asset */
  quantityClosedOutBase?: InputMaybe<Scalars['String']['input']>;
  /** Total quantity in base asset */
  quantityTotalBase?: InputMaybe<Scalars['String']['input']>;
  /** Quanto asset ID (for quanto products) */
  quantoAssetId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Corrects a post-priced flag that should never have been set: the trade and its lifecycle
   * events drop the flag and any finalization, so the booked price stands as the transaction
   * price. A previously reported trade re-reports to the SDR as a correction; a STAGED trade was
   * never reported and does not. Rejected on a package leg: a post-priced package reverts as a
   * unit through dvRevertPackagePostPriced.
   */
  revertsPostPriced?: InputMaybe<Scalars['Boolean']['input']>;
  /** Settlement time */
  settlementTime?: InputMaybe<Scalars['Time']['input']>;
  /** Settlement type (PHYSICAL/CASH) */
  settlementType?: InputMaybe<Scalars['String']['input']>;
  /** Strike price for the trade */
  strike?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: strike-price currency (3-char ISO code) */
  strikePriceCurrency?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: strike-price notation (1-char code) */
  strikePriceNotation?: InputMaybe<Scalars['String']['input']>;
  /** Variation margin asset ID */
  variationMarginAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** Variation margin override flag */
  variationMarginOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Amount = _commonAmount & {
  __typename: 'Amount';
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Further information regarding this asset type */
  assetTypeInfo: AssetTypeInfo;
  /**
   * The value for this amount formatted for display to a user, in the US format.
   * Includes commas, dollar sign for USD, but no unit type for non-USD amounts.
   */
  displayValue: Scalars['String']['output'];
  /**
   * The USD value for this amount formatted for display to a user, including commas
   * and the preceding dollar sign. Ex: $1,234.56
   */
  displayValueInUSD: Scalars['String']['output'];
  /**
   * The value for this amount, rounded to 4 decimal places without trailing zeros,
   * in the US format.
   * Includes commas, dollar sign for USD, but no unit type for non-USD amounts.
   */
  displayValueShort: Scalars['String']['output'];
  tokenID: Maybe<Scalars['String']['output']>;
  /** Information for Token like assets */
  tokenInfo: Maybe<TokenInfo>;
  /** The unit type for this amount */
  unitType: Scalars['String']['output'];
  value: Scalars['String']['output'];
  /** The value for this amount with full precision, may exceed asset max precision */
  valueFullPrecision: Scalars['String']['output'];
  /** The value in USD at the current exchange rate */
  valueInUSD: Scalars['String']['output'];
  /** The value for this amount, rounded to 4 decimal places */
  valueShort: Scalars['String']['output'];
};

/** AmountConnection implements the connections spec */
export type AmountConnection = {
  __typename: 'AmountConnection';
  /** edges implements the connections spec */
  edges: Array<AmountEdge>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
};

/** AmountDuration is a combination of a USD amount with a duration window. */
export type AmountDuration = {
  __typename: 'AmountDuration';
  /** amount is a decimal amount of USD. */
  amount: Scalars['Decimal']['output'];
  /** seconds indicates a length of time window. */
  seconds: Scalars['Int']['output'];
};

/** AmountEdge implements the connections spec */
export type AmountEdge = {
  __typename: 'AmountEdge';
  /** cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** node implements the connections spec */
  node: Amount;
};

/** AmountInput represents a graphql input representation of an value with a unit and asset type */
export type AmountInput = {
  /** The asset type id for this amount */
  assetTypeID: Scalars['AssetTypeID']['input'];
  /** The value for this amount */
  value: Scalars['String']['input'];
};

/**
 * AmountInputStep allows the user to input an arbitrary amount following some type rules.
 * Number types are typically absolute asset amounts, but can also represent percentages or shares.
 */
export type AmountInputStep = StakingStep & {
  __typename: 'AmountInputStep';
  /** DefaultAmount is the initial value this input will have, the input should default to 0 if none is provided here. */
  defaultAmount: Maybe<Amount>;
  /** Editable should disable the input if false. */
  editable: Scalars['Boolean']['output'];
  /**
   * Used to instruct the UI the name of the field that should be used to store the user's input for this step.
   * This value must be provided on all input steps when using PrepareGenericOperation
   * It can also be used to instruct the UI to send in a non-default field when using PrepareDelegation, but the string value must exactly match the GQL field name to work.
   * When this value is empty, a default value will be used by the UI based on the staking step type
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /**
   * GasStationButton allows the user to choose if the transaction will use the Anchorage gas station
   * to pay gas fees, for supported asset types and organizations with the gas station org module.
   */
  gasStationButton: Maybe<BooleanButton>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Allows the backend to provide info banners to be shown above the step */
  infoItems: Maybe<Array<InfoItem>>;
  /** The InputType represents whether this is quantifying an amount of an asset or a share. */
  inputType: StakingStepInputType;
  /** MaxAmount is the maximum amount the user should be allowed to enter. */
  maxAmount: Maybe<Scalars['String']['output']>;
  /**
   * MaxAmountOnUseGasStation is the maximum amount the user should be allowed to enter when using the gas station.
   * It can be higher than MaxAmount because the gas station will cover any required transaction fees.
   */
  maxAmountOnUseGasStation: Maybe<Scalars['String']['output']>;
  /** MinAmount is minimum amount the user should be allowed to enter. */
  minAmount: Maybe<Scalars['String']['output']>;
  /** NumberType represents whether the number is an absolute amount or a percentage. */
  numberType: StakingStepNumberType;
  /** ReserveAmount is the amount that should be left behind for fees and other reasons. */
  reserveAmount: Maybe<Scalars['String']['output']>;
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
};

/** AmountListStep allows the user to see multiple amounts on one screen without being able to edit them. */
export type AmountListStep = StakingStep & {
  __typename: 'AmountListStep';
  /** The list of the amounts to be shown */
  amounts: Array<Amount>;
  /**
   * Used to instruct the UI the name of the field that should be used to store the user's input for this step.
   * This value must be provided on all input steps when using PrepareGenericOperation
   * It can also be used to instruct the UI to send in a non-default field when using PrepareDelegation, but the string value must exactly match the GQL field name to work.
   * When this value is empty, a default value will be used by the UI based on the staking step type
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Allows the backend to provide info banners to be shown above the step */
  infoItems: Maybe<Array<InfoItem>>;
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
};

/**
 * This type is used to convey that the actor (i.e., initiator) of an
 * operation/action is an Anchorage employee or process.
 */
export type AnchorageActor = Actor & {
  __typename: 'AnchorageActor';
  /** Information about the actor. */
  actorInfo: ActorInfo;
};

/**
 * Resolver for Anchorage Entities
 *
 * Keyed on name: the only unique field that does not reference AnchorageEntityType,
 * which is the value being decoupled (ONMON-5357). cliententities owns reference
 * resolution; kyc and graphqlmonolith key the same field as non-resolvable so the
 * router can jump from their instances to here.
 *
 * type is now AnchorageEntityTypeOutput with cliententities its sole declarer, leaving
 * AnchorageEntityType input-only so it composes by intersection instead of exact match.
 * The retype is wire-invisible: selection sets name fields, not types, and the values
 * serialize identically.
 */
export type AnchorageEntity = {
  __typename: 'AnchorageEntity';
  /** Name of the Anchorage Entity */
  name: Scalars['String']['output'];
  /** Shorter name. May be an abbreviation */
  shortname: Scalars['String']['output'];
  /** Type of the Anchorage Entity */
  type: AnchorageEntityTypeOutput;
};

/** Different types of Anchorage Entities */
export enum AnchorageEntityType {
  /** A1 */
  A1 = 'A1',
  /** Anchorage Digital NY */
  ADNY = 'ADNY',
  /** Anchorage Digital Swap Dealer */
  ADSD = 'ADSD',
  /** AURORA */
  AURORA = 'AURORA',
  /** Anchorage Hold */
  HOLD = 'HOLD',
  /** Singapore */
  SINGAPORE = 'SINGAPORE',
  /** Anchorage Trust Company */
  TRUST_COMPANY = 'TRUST_COMPANY'
}

/**
 * Anchorage entity types in output positions. Kept separate from AnchorageEntityType
 * (which remains the input vocabulary) so this enum never spans both input and output
 * positions across the supergraph: output-only enums union-merge during composition,
 * letting new values roll out without lockstep deploys (ONMON-5231).
 */
export enum AnchorageEntityTypeOutput {
  /** A1 */
  A1 = 'A1',
  /** Anchorage Digital NY */
  ADNY = 'ADNY',
  /** Anchorage Digital Swap Dealer */
  ADSD = 'ADSD',
  /** AURORA */
  AURORA = 'AURORA',
  /** Anchorage Hold */
  HOLD = 'HOLD',
  /** Singapore */
  SINGAPORE = 'SINGAPORE',
  /** Anchorage Trust Company */
  TRUST_COMPANY = 'TRUST_COMPANY'
}

export type AnchorageLegalEntity = Node & {
  __typename: 'AnchorageLegalEntity';
  affiliateAnchorageRelationships: AffiliateAnchorageRelationshipConnection;
  createdAt: Scalars['Time']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  deletedBy: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type AnchorageLegalEntityaffiliateAnchorageRelationshipsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AffiliateAnchorageRelationshipWhereInput>;
};

/** A connection to a list of items. */
export type AnchorageLegalEntityConnection = {
  __typename: 'AnchorageLegalEntityConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AnchorageLegalEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AnchorageLegalEntityEdge = {
  __typename: 'AnchorageLegalEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AnchorageLegalEntity>;
};

/**
 * AnchorageLegalEntityWhereInput is used for filtering AnchorageLegalEntity objects.
 * Input was generated by ent.
 */
export type AnchorageLegalEntityWhereInput = {
  and?: InputMaybe<Array<AnchorageLegalEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_by field predicates */
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByContains?: InputMaybe<Scalars['String']['input']>;
  deletedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deletedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deletedByGT?: InputMaybe<Scalars['String']['input']>;
  deletedByGTE?: InputMaybe<Scalars['String']['input']>;
  deletedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deletedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deletedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLT?: InputMaybe<Scalars['String']['input']>;
  deletedByLTE?: InputMaybe<Scalars['String']['input']>;
  deletedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deletedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** affiliate_anchorage_relationships edge predicates */
  hasAffiliateAnchorageRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasAffiliateAnchorageRelationshipsWith?: InputMaybe<Array<AffiliateAnchorageRelationshipWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AnchorageLegalEntityWhereInput>;
  or?: InputMaybe<Array<AnchorageLegalEntityWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Answer is the type that represents an answer for a question */
export type Answer = {
  __typename: 'Answer';
  /** freeformText is the freeform text entered for the question when the question allows */
  freeformText: Scalars['String']['output'];
  /** options is the list of options selected for the question */
  options: Array<Scalars['String']['output']>;
  /** questionID is the ID of the question */
  questionID: Scalars['String']['output'];
};

/** Scope of an Any Destination grant. */
export enum AnyDestinationScope {
  FIAT = 'FIAT'
}

/** Represents a user that is in the process of being added to an organization */
export type AppStagedUser = StagedUser & {
  __typename: 'AppStagedUser';
  /**
   * The algorithm for the user's public key. This should match the value in the organization change.
   *
   * For backward compatibility with older iOS releases, nil is returned for the default algorithm (ecdsap256). In this case, an algorithm field is not included in the endorsement.
   */
  algorithm: Maybe<Scalars['String']['output']>;
  /** Email of the staged user, if known */
  email: Maybe<Scalars['String']['output']>;
  /** The only possible value for now is eciesEncryptionCofactorSHA512IVAESGCM or null */
  encryptionAlgorithm: Maybe<Scalars['String']['output']>;
  /** Set iff publicKeyID is set */
  encryptionPublicKey: Maybe<Scalars['String']['output']>;
  /**
   * Same as publicKeyID but used for encryption
   * This is set iff encryptionAlgorithm is set
   */
  encryptionPublicKeyID: Maybe<Scalars['PublicKeyID']['output']>;
  /** Enroll token of the user */
  enrollToken: Scalars['String']['output'];
  /** Name from enrollment table (overrides the piiName) */
  enrollmentName: Maybe<Scalars['String']['output']>;
  /** exemptPiis returns list of PII types that the user is exempt from providing */
  exemptPiis: Array<IndividualInformationType>;
  /** id is the unique identifier of the staged user, equal to enrollToken */
  id: Scalars['ID']['output'];
  /**
   * institutionalIndividual returns the institutional individual associated with
   * this staged user
   */
  institutionalIndividual: Maybe<InstitutionalIndividual>;
  /** PII information known */
  knownInformation: Array<KnownInformation>;
  /** Last login information. Will be empty if never logged in. */
  lastLogin: Maybe<Login>;
  /** missingPiis returns list of PII types that the user still needs to fill */
  missingPiis: Array<IndividualInformationType>;
  /** Name of the staged user, if known; comes from either of piiName or enrollmentName */
  name: Maybe<Scalars['String']['output']>;
  /** onboardingStatus signals the state of onboarding that the user is at */
  onboardingStatus: OnboardingStatus;
  /**
   * ID of the personally identifiable information.
   * Needed to generate the address for the blobs.
   */
  piiID: Scalars['String']['output'];
  /** Name from KYC */
  piiName: Maybe<Scalars['String']['output']>;
  /** Hex encoded representation of the public key, if known. If the user did not enroll yet this field will be null */
  publicKey: Maybe<Scalars['String']['output']>;
  /** Public key ID of the user, if known. If the user did not enroll yet this field will be null */
  publicKeyID: Maybe<Scalars['PublicKeyID']['output']>;
  /** The type of user that the enrollment will create in the organization */
  userType: UserType;
  /**
   * The encrypted shares of the wallet recovery key associated with this user, if any.
   * This only applies for Porto orgs with the WALLET_RECOVERY_KEY strategy.
   */
  walletRecoveryKeyShares: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * AppStatus is the simplified, app-facing state of the operation as it is processed by our system
 * These are not code-gen'd right now but they really should be
 */
export enum AppStatus {
  /** AWAITING_DEPOSIT is when the deposit address is ready and the user needs to deposit funds */
  AWAITING_DEPOSIT = 'AWAITING_DEPOSIT',
  /** CANCELED is the state when the operation has been canceled. */
  CANCELED = 'CANCELED',
  /** COMPLETE is the state when the action is complete */
  COMPLETE = 'COMPLETE',
  /** COMPLETING is when a relevant transaction is on the blockchain but not yet fully confirmed */
  COMPLETING = 'COMPLETING',
  /** EXPIRED is the state when the action has timed out */
  EXPIRED = 'EXPIRED',
  /** FAILED is the state when action could not be completed due to an error */
  FAILED = 'FAILED',
  /** AppStatusFailureCommitted represents an operation that has failed on the blockchain */
  FAILURE_COMMITTED = 'FAILURE_COMMITTED',
  /** GATHERING_APPROVALS is when the user already endorsed the operation but other singatures are being collected */
  GATHERING_APPROVALS = 'GATHERING_APPROVALS',
  /** GENERATING_ADDRESS is when the deposit address is being generated */
  GENERATING_ADDRESS = 'GENERATING_ADDRESS',
  /** IN_REVIEW is when the action is in risk review but can still be canceled */
  IN_REVIEW = 'IN_REVIEW',
  /** NEEDS_APPROVAL is when the action is collecting signatures for quorum */
  NEEDS_APPROVAL = 'NEEDS_APPROVAL',
  /** PREPARING is when the action has been created in the request state but is not ready to be signed */
  PREPARING = 'PREPARING',
  /** PROCESSING is when the organization change is post-risk review but not yet complete */
  PROCESSING = 'PROCESSING',
  /** REJECTED is the state when the customer or risk team has rejected the operation */
  REJECTED = 'REJECTED',
  /** SENDING is when the withdraw is post-risk review but not yet complete */
  SENDING = 'SENDING',
  /** SIGNING SENDING is when the operation is in HSM-signing state */
  SIGNING = 'SIGNING',
  /** WAITING_FOR_INITIATOR is the state when the action is staged, before being created */
  WAITING_FOR_INITIATOR = 'WAITING_FOR_INITIATOR'
}

/**
 * AppliedPolicy wraps the rule that applied to an operation together with its
 * owning policy's identity and name.
 */
export type AppliedPolicy = {
  __typename: 'AppliedPolicy';
  /** decision is the evaluator's verdict for the applied rule; null means unknown, not authorized. */
  decision: Maybe<PolicyDecision>;
  /** id is the policy container group ID — the policy's durable identity. */
  id: Scalars['ID']['output'];
  /**
   * name is the policy's current name (from the policy container group). It is only
   * populated while the operation is awaiting its initiator (INITIATOR_PREPARED); for
   * every other state it is null, since the name is current (not snapshotted) and may
   * no longer match what applied. Also null if the policy was renamed away or deleted.
   */
  name: Maybe<Scalars['String']['output']>;
  /** rule is the applied rule: its conditions and outcome (quorum or block). */
  rule: PolicyRuleV2;
};

export type ApplyLifecycleEventInput = {
  /** Event details as JSON */
  details: Scalars['String']['input'];
  /** The type of lifecycle event */
  eventType: LifecycleEventType;
  /** The trade ID to apply the event to */
  tradeId: Scalars['ID']['input'];
};

export type ApplyRestrictionsInput = {
  reason: RestrictionFreezeReason;
  /** 1 to 500 targets, none twice. */
  targets: Array<RestrictionTargetInput>;
};

export type ApplyTagsInput = {
  entityID: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type ApplyTagsPayload = {
  __typename: 'ApplyTagsPayload';
  entityID: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  tags: Array<TagResult>;
};

export type ApproveDelegationActivityResponse = {
  __typename: 'ApproveDelegationActivityResponse';
  /** Whether the approval signal was successfully sent. */
  success: Scalars['Boolean']['output'];
};

export type ApproveServiceFeeTermsTerminationInput = {
  /** Agreement id associated to the terms to be approved */
  agreementId: Scalars['ID']['input'];
  /** Date at which the service fee terms should be terminated */
  terminationDate: Scalars['Date']['input'];
};

/** ApprovedCountry type represents a country approved for fiat transactions. */
export type ApprovedCountry = {
  __typename: 'ApprovedCountry';
  /** Two-letter country code (ISO 3166-1 alpha-2) */
  countryCode: Scalars['String']['output'];
  /** Full name of the country */
  countryName: Scalars['String']['output'];
  /** Unique identifier for the country */
  id: Scalars['Int']['output'];
};

/** AptosBuyIns is the map of addresses and coins for the new vesting contract */
export type AptosBuyIns = {
  __typename: 'AptosBuyIns';
  /** address is the address of the buy ins the new vesting contract */
  address: Scalars['String']['output'];
  /** coin are the tokens of the buy in for the new vesting contract */
  coin: Scalars['Decimal']['output'];
};

/** Extra parameters for aptos */
export type AptosExtraParams = {
  __typename: 'AptosExtraParams';
  /** buyIns are percentages and addresses for the new vesting contract */
  buyIns: Maybe<Array<AptosBuyIns>>;
  /** commission is the operator's commission */
  commission: Maybe<Scalars['Int']['output']>;
  /** shareholders are the addresses of the vesting contract shareholders */
  shareholders: Maybe<Array<Scalars['String']['output']>>;
  /** vestingSchedule is the vesting schedule for the new vesting contract */
  vestingSchedule: Maybe<AptosVestingSchedule>;
  /** voterAddress is the account's voter address */
  voterAddress: Maybe<Scalars['String']['output']>;
  /** withdrawalAddress is the address to which the vested tokens will be withdrawn to */
  withdrawalAddress: Maybe<Scalars['String']['output']>;
};

/** AptosVestingSchedule has the properties of the vesting schedule for the new vesting contract */
export type AptosVestingSchedule = {
  __typename: 'AptosVestingSchedule';
  /** periodDuration is the duration of the new vesting contract */
  periodDuration: Scalars['Int']['output'];
  /** schedule is the vesting schedule for the new vesting contract */
  schedule: Array<Fraction>;
  /** startTimestampSecs is the start date of the new vesting contract */
  startTimestampSecs: Scalars['String']['output'];
};

/** Response for archiveWallets and unarchiveWallets mutations. */
export type ArchiveWalletsResponse = {
  __typename: 'ArchiveWalletsResponse';
  /** How many wallets were affected by the mutation API call. */
  numberOfWalletsAffected: Scalars['Int']['output'];
};

export enum ArchivedByType {
  /** The wallet was archived by an Anchorage admin. */
  ANCHORAGE_ADMIN = 'ANCHORAGE_ADMIN',
  /**
   * The wallet was archived automatically by the system because it was created as a side effect
   * when another wallet was created for a network sharing the same addressProvisioningGroupID.
   */
  SYSTEM = 'SYSTEM',
  /** The wallet was archived by a user in the organization. */
  USER = 'USER'
}

/** Information about assets */
export type Asset = {
  __typename: 'Asset';
  actionForms: Array<JsonForm>;
  /** Addresses associated with this asset */
  addresses: Array<Scalars['String']['output']>;
  /** ID of the asset */
  assetID: AssetID;
  /** Further information regarding this asset type */
  assetTypeInfo: AssetTypeInfo;
  /**
   * The amount of the asset available to perform operations with
   * Set debug to true to enable more logging.
   */
  availableBalance: Scalars['String']['output'];
  /**
   * Get the list of available balances by tokenID in this asset
   * first and after implement the connections spec
   * Set debug to true to enable more logging.
   */
  availableBalances: AmountConnection;
  /**
   * Balance at end of day (midnight UTC) over the last (optional) number of days.
   * When omitted, defaults to the organization's full age (its creation date through today).
   * Set debug to true to enable more logging.
   */
  balanceHistory: Array<Scalars['String']['output']>;
  /** A list of all hold amounts aggregated by hold type for a given asset. The available balance is also returned with all holds already subtracted from it. */
  balanceWithHolds: Array<Hold>;
  /**
   * Returns all active (queued) Celo proposals.
   * Deprecated: Celo governance is no longer supported. Retained for backward
   * compatibility with older iOS clients; always returns an empty list. Safe
   * to delete once the minimum supported iOS version is v2.111.0.
   * @deprecated Celo governance has been removed. This field always returns an empty list.
   */
  celoActiveProposals: Array<CeloProposal>;
  /**
   * A list of all holds for a given asset that are client-visible. If the visibleForPurpose is not set all holds will be returned.
   * Set debug to true to enable more logging.
   */
  clientVisibleHolds: Array<Hold>;
  /**
   * completedBalance is the raw asset amount held (in raw asset units) when considering all completed transactions
   * @deprecated Use completedTotalBalance for asset balance and USD value
   */
  completedBalance: Scalars['String']['output'];
  /**
   * Get the list of completed balances by tokenID in this asset
   * first and after implement the connections spec
   * Set debug to true to enable more logging.
   */
  completedBalances: AmountConnection;
  /**
   * completedTotalBalance contains information about the asset, the raw amount of the asset,
   * and the USD value of the asset amount
   */
  completedTotalBalance: AssetAmount;
  /** An ongoing withdrawal that is blocking new withdrawals from this asset */
  conflictingWithdraw: Maybe<Operation>;
  /** Where this asset is currently delegated to if it was previously delegated */
  delegationAddress: Maybe<DelegationAddress>;
  /** List of delegation addresses allowed for this assetID and delegated by the assetID */
  delegationAddresses: Array<DelegationAddress>;
  /**
   * Description of the asset
   * @deprecated Use wallet names
   */
  description: Scalars['String']['output'];
  /** ethereumEigenLayerInfo returns information about the EigenPod for this asset if it's an Ethereum asset. Otherwise it will be null. */
  ethereumEigenLayerInfo: Maybe<EthereumEigenLayerInfo>;
  /**
   * Returns the current active Maker governance executive vote ballot, if one exists.
   * Deprecated: Maker governance is no longer supported. Retained for backward
   * compatibility with older iOS clients; always returns null. Safe to delete
   * once the minimum supported iOS version is v2.111.0.
   * @deprecated Maker governance has been removed. This field always returns null.
   */
  executiveMakerGovernanceBallot: Maybe<MakerGovernanceBallot>;
  /**
   * This is a status for whether the asset supports governance and whether setup has been completed.
   * See governanceSetupSteps for detail on the individual setup steps.
   * DEPRECATED: Governance is no longer supported. Retained for backward compatibility with iOS.
   */
  governanceSetupStatus: GovernanceSetupStatus;
  /**
   * Details on the specific steps required to setup this asset for participation in governance,
   * if this asset supports governance. Results will be sorted by the order in which they should be
   * completed.
   * DEPRECATED: Governance is no longer supported. Retained for backward compatibility with iOS.
   */
  governanceSetupSteps: Array<GovernanceSetupStep>;
  /**
   * Returns all active MKR polls.
   * Deprecated: Maker governance is no longer supported. Retained for backward
   * compatibility with older iOS clients; always returns an empty list. Safe
   * to delete once the minimum supported iOS version is v2.111.0.
   * @deprecated Maker governance has been removed. This field always returns an empty list.
   */
  makerPolls: Array<MakerPoll>;
  /**
   * Name of the asset
   * @deprecated Use wallet names
   */
  name: Scalars['String']['output'];
  /** List of notices to be shown to the user for this asset */
  notices: Maybe<Array<Notice>>;
  /**
   * Get the list of operations in this asset
   * first and after implement the connections spec
   */
  operations: OperationConnection;
  /** Amount that has been deposited but not confirmed yet */
  pendingBalanceIn: Scalars['String']['output'];
  /** Amount that has been withdrawn but not confirmed yet */
  pendingBalanceOut: Scalars['String']['output'];
  /**
   * Staking information
   * If present it means this asset supports staking and this object contains all necessary information
   * to present to users and to manage operations
   */
  staking: Maybe<StakingInfo>;
  /** Unique ID of the asset */
  uniqueID: Scalars['String']['output'];
  /** The vault that holds this asset */
  vault: Vault;
  /** VestingContractAddress returns the address of the vesting contract if there is one for this asset */
  vestingContractAddress: Maybe<Scalars['String']['output']>;
  /** VestingInfo returns vesting info for the asset */
  vestingInfo: Maybe<VestingInfo>;
  /** The wallet that holds this asset */
  wallet: Wallet;
  /** Whether a withdrawal can be made or not due to conflicting operations in progress */
  withdrawPossible: Maybe<Scalars['Boolean']['output']>;
};


/** Information about assets */
export type AssetactionFormsArgs = {
  domain?: InputMaybe<ActionDomain>;
};


/** Information about assets */
export type AssetavailableBalanceArgs = {
  availableForPurpose?: InputMaybe<AvailableForPurpose>;
  debug?: Scalars['Boolean']['input'];
};


/** Information about assets */
export type AssetavailableBalancesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  availableForPurpose?: InputMaybe<AvailableForPurpose>;
  before?: InputMaybe<Scalars['ID']['input']>;
  debug?: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tokenID?: InputMaybe<Scalars['String']['input']>;
};


/** Information about assets */
export type AssetbalanceHistoryArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  debug?: Scalars['Boolean']['input'];
};


/** Information about assets */
export type AssetclientVisibleHoldsArgs = {
  debug?: Scalars['Boolean']['input'];
  visibleForPurpose?: InputMaybe<VisibleForPurpose>;
};


/** Information about assets */
export type AssetcompletedBalancesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  debug?: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tokenID?: InputMaybe<Scalars['String']['input']>;
};


/** Information about assets */
export type AssetoperationsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterActions?: InputMaybe<Array<OperationAction>>;
  filterCreatedSince?: InputMaybe<Scalars['String']['input']>;
  filterCreatedUntil?: InputMaybe<Scalars['String']['input']>;
  filterRequiresDecision?: InputMaybe<Scalars['Boolean']['input']>;
  filterStates?: InputMaybe<Array<OperationState>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeChange?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<OperationSortFields>;
};

/**
 * AssetAmount contains information about the asset, the raw amount of the asset,
 * and the USD value of the asset amount.
 */
export type AssetAmount = {
  __typename: 'AssetAmount';
  /** Asset type Info contains information about the asset */
  assetTypeInfo: AssetTypeInfo;
  /** The USD value formatted for display to a user, including commas and the preceding dollar sign. Ex: $1,234.56 */
  displayValueInUSD: Scalars['String']['output'];
  /** USD value of the asset amount */
  usdValue: Scalars['String']['output'];
  /** The raw amount of the asset */
  value: Scalars['String']['output'];
};

/** Type of action performed in audit log */
export enum AssetAuditAction {
  /** Asset was created */
  CREATE = 'CREATE',
  /** Asset was deleted */
  DELETE = 'DELETE',
  /** Asset was updated */
  UPDATE = 'UPDATE'
}

/** Represents a single field change in an audit entry */
export type AssetAuditChange = {
  __typename: 'AssetAuditChange';
  /** Name of the field that changed */
  fieldName: Scalars['String']['output'];
  /** New value of the field (JSON string) */
  value: Scalars['String']['output'];
};

/** Asset audit log entry showing a historical change to an asset */
export type AssetAuditLogEntry = {
  __typename: 'AssetAuditLogEntry';
  /** Action performed (CREATE, UPDATE, DELETE) */
  auditAction: AssetAuditAction;
  /** List of field changes (field_name -> value as JSON string) */
  auditChanges: Array<AssetAuditChange>;
  /** ID of the entity that was audited */
  auditEntryID: Scalars['String']['output'];
  /** Unique audit entry ID */
  auditID: Scalars['String']['output'];
  /** When the audit event occurred */
  auditTimestamp: Scalars['Timestamp']['output'];
  /** Type of entity being audited (e.g., "AssetType") */
  auditType: Scalars['String']['output'];
  /** User who performed the action (if available) */
  auditUser: Maybe<Scalars['String']['output']>;
};

/** Sort order for audit log results */
export enum AssetAuditSortOrder {
  /** Sort by timestamp ascending (oldest first) */
  TIMESTAMP_ASC = 'TIMESTAMP_ASC',
  /** Sort by timestamp descending (most recent first) */
  TIMESTAMP_DESC = 'TIMESTAMP_DESC'
}

export type AssetBalance = {
  __typename: 'AssetBalance';
  /** Asset type Info contains information about the asset */
  assetTypeInfo: AssetTypeInfo;
  /** Description and amount for each balance type */
  balances: Array<Maybe<BalanceDescription>>;
  /** Total amount for this asset */
  totalAmount: Amount;
};

/** Per-asset-type breakdown element: total delegated amount for a single asset type. */
export type AssetBreakdownElement = {
  __typename: 'AssetBreakdownElement';
  /** The total delegated amount for this asset type, in native units. */
  amount: Amount;
};

export type AssetConfig = {
  abbreviation: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** AssetEnablementInfo contains the enablement rules for an asset type */
export type AssetEnablementInfo = {
  __typename: 'AssetEnablementInfo';
  /** assetTypeInfo is the information about the asset type */
  assetTypeInfo: AssetTypeInfo;
  /** entities is the enablement rules of the asset type for entities */
  entities: Array<AssetEntityEnablementStatus>;
  /** overrides is the enablement rules of the asset type for organizations */
  overrides: Array<AssetEnablementStatusOverride>;
};

/**
 * AssetEnablementStatusOverride is the enablement status rule of an asset type for an organization.
 * Overrides are used to enable or disable an asset type for an organization regardless of the default/entity enablement rule.
 */
export type AssetEnablementStatusOverride = {
  __typename: 'AssetEnablementStatusOverride';
  /** enabled is the enablement status of the asset type for the organization */
  enabled: Scalars['Boolean']['output'];
  /** entity is the entity for which the enablement status is being provided */
  entity: AnchorageEntityTypeOutput;
  /** organizationKeyID is the organization for which the enablement status is being provided */
  organizationKeyID: Scalars['String']['output'];
};

/** AssetEntityEnablementStatus is the enablement status rule of an asset type for an entity */
export type AssetEntityEnablementStatus = {
  __typename: 'AssetEntityEnablementStatus';
  /** enabled is the enablement status of the asset type for the entity */
  enabled: Scalars['Boolean']['output'];
  /** entity is the entity for which the enablement status is being provided */
  entity: AnchorageEntityTypeOutput;
};

/** Extra parameters for assets */
export type AssetExtraParams = {
  __typename: 'AssetExtraParams';
  /**
   * For a Solana Token-2022 mint that withholds a transfer fee, the fee the mint
   * withholds from the transferred amount, as in force when the operation was
   * created and endorsed. The recipient receives the amount less this fee. Null
   * for assets that withhold no transfer fee, and for every asset while the
   * solana-transfer-fee flag is off.
   */
  tokenTransferFee: Maybe<Amount>;
  /** value of the extra parameter */
  value: Maybe<Scalars['String']['output']>;
};

export type AssetFilter = {
  /** Filter by specific asset IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by specific symbols */
  symbols?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** AssetID is the ID of an asset within a vault */
export type AssetID = {
  __typename: 'AssetID';
  /** assetSubID is used to differentiate between multiple assets of the same type within a vault */
  assetSubID: Scalars['String']['output'];
  /** assetTypeID is the type of asset being held */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Further information regarding this asset type */
  assetTypeInfo: AssetTypeInfo;
  /** vaultID is the ID of the vault this asset is in */
  vaultID: VaultID;
};

/** AssetStakingFees represents the staking fee configuration for a specific asset */
export type AssetStakingFees = {
  __typename: 'AssetStakingFees';
  assetAbbreviation: Scalars['String']['output'];
  assetId: Scalars['ID']['output'];
  externalValidatorRate: Scalars['Float']['output'];
  fullCommissionValidatorRate: Scalars['Float']['output'];
  internalValidatorRate: Scalars['Float']['output'];
};

export type AssetStakingFeesConnection = {
  __typename: 'AssetStakingFeesConnection';
  edges: Maybe<Array<AssetStakingFeesEdge>>;
  pageInfo: Maybe<PageInfo>;
};

export type AssetStakingFeesEdge = {
  __typename: 'AssetStakingFeesEdge';
  cursor: Scalars['ID']['output'];
  node: Maybe<AssetStakingFees>;
};

/** Filter for asset staking fees */
export type AssetStakingFeesFilter = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A single asset support request. This is the main "node" in the connection. */
export type AssetSupportRequest = {
  __typename: 'AssetSupportRequest';
  /** AssetDecimals of Asset Support Request */
  assetDecimals: Maybe<Scalars['Int']['output']>;
  /** AssetName of Asset Support Request */
  assetName: Scalars['String']['output'];
  /** AssetRiskLevel of Asset Support Request */
  assetRiskLevel: Scalars['String']['output'];
  /** AssetTypeID of Asset Support Request */
  assetTypeId: Scalars['String']['output'];
  /** ContractAddress of Asset Support Request */
  contractAddress: Scalars['String']['output'];
  /** CreatedAt of Asset Support Request */
  createdAt: Scalars['Time']['output'];
  /** ID of Asset Support Request */
  id: Scalars['ID']['output'];
  /** NetworkID of Asset Support Request */
  networkId: Scalars['String']['output'];
  /** OrgID of Asset Support Request */
  orgId: Scalars['String']['output'];
  /** UserID of Asset Support Request */
  userId: Scalars['String']['output'];
};

/**
 * The "connection" object that holds the list of edges and the page info.
 * This is what is returned by the query.
 */
export type AssetSupportRequestConnection = {
  __typename: 'AssetSupportRequestConnection';
  /** Edges is a list of items on a current page */
  edges: Array<AssetSupportRequestEdge>;
  /** PageInfo gives pagination results */
  pageInfo: PageInfo;
};

/** An "edge" in the paginated list, containing the node and its unique cursor. */
export type AssetSupportRequestEdge = {
  __typename: 'AssetSupportRequestEdge';
  /** Cursor is an identifier of a node */
  cursor: Scalars['String']['output'];
  /** Node is a data item from AssetSupportRequest */
  node: AssetSupportRequest;
};

/** Definition of an asset tag with its metadata */
export type AssetTagDefinition = {
  __typename: 'AssetTagDefinition';
  /** Human-readable description of what this tag represents */
  description: Scalars['String']['output'];
  /** The tag identifier (e.g., "STABLE", "REBASING") */
  tag: Scalars['String']['output'];
};

/**
 * Same as AssetTrackingInput, for create paths only: priceSource/priceSourceProvider are
 * required — there's no more fallback default for a package/exposure created without one.
 */
export type AssetTrackingCreateInput = {
  asset: AssetConfig;
  /** The asset's backup price feed. Omit to inherit the service default. */
  backupPriceFeed?: InputMaybe<CmPriceFeedInput>;
  disbursementWalletId?: InputMaybe<Scalars['String']['input']>;
  liquidationPriority?: InputMaybe<Scalars['Int']['input']>;
  maxStalenessMinutes?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pledgorWalletId?: InputMaybe<Scalars['String']['input']>;
  priceSource: PriceSource;
  priceSourceProvider: Scalars['String']['input'];
  /** The asset's primary pricing strategy. Required on packages. Not supported on exposures. */
  pricingStrategy?: InputMaybe<CmPriceStrategies>;
  walletId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type AssetTrackingInput = {
  asset: AssetConfig;
  /** Replaces the asset's backup price feed. Omit to leave it unchanged. */
  backupPriceFeed?: InputMaybe<CmPriceFeedInput>;
  /** Clears the asset's backup price feed so it inherits the service default. Cannot be combined with backupPriceFeed. */
  clearBackupPriceFeed?: InputMaybe<Scalars['Boolean']['input']>;
  disbursementWalletId?: InputMaybe<Scalars['String']['input']>;
  liquidationPriority?: InputMaybe<Scalars['Int']['input']>;
  maxStalenessMinutes?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pledgorWalletId?: InputMaybe<Scalars['String']['input']>;
  priceSource?: InputMaybe<PriceSource>;
  priceSourceProvider?: InputMaybe<Scalars['String']['input']>;
  /** Replaces the asset's primary pricing strategy. Omit to keep it. Required when the update adds the asset to a package. */
  pricingStrategy?: InputMaybe<CmPriceStrategies>;
  walletId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** Additional information about an asset type */
export type AssetTypeInfo = _commonAssetTypeInfo & {
  __typename: 'AssetTypeInfo';
  /** Abbreviation of the asset type */
  abbreviation: Scalars['String']['output'];
  /** The regex used to test for a valid address */
  addressValidationRegex: Scalars['String']['output'];
  /** Allowed asset information for this asset type, containing whether asset authorization is required and the required amount */
  allowedAssetsInfo: AllowedAssetsInfo;
  /** The ID of the asset type */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** The blockchain name of the asset group */
  blockchainName: Scalars['String']['output'];
  /** The contract address for this asset type */
  contractAddress: Maybe<Scalars['String']['output']>;
  /** Percent day change of the asset type */
  dayChange: Scalars['String']['output'];
  /** List of delegation addresses allowed for this asset type */
  delegationAddresses: Array<DelegationAddress>;
  /**
   * Value of the asset type, formatted for display (rounded, with USD hard-coded to "1"). Reflects
   * the price at the time of operation completion when resolved through a completed operation's
   * amount, and the live price otherwise.
   */
  displayValue: Scalars['String']['output'];
  /** The max amount we can expect to withdraw for fees, used for checking balances prior to making a transfer and erroring sooner */
  feeThreshold: Amount;
  /**
   * iconURL returns the url for fetching the icon for this asset.
   * If the type is SVG, the size is ignored.
   * Icons are square.
   * The size is in pixels.
   */
  iconURL: Scalars['String']['output'];
  /** id is the unique identifier of the asset type, equal to assetTypeID */
  id: Scalars['ID']['output'];
  /** Identifies if the asset is Fiat */
  isFiat: Scalars['Boolean']['output'];
  /** Identifies if the asset is fungible */
  isFungible: Scalars['Boolean']['output'];
  /** Current, non-cached value of the asset type (formatted for display) */
  liveDisplayValue: Scalars['String']['output'];
  /** Current, non-cached value of the asset type (as a raw decimal value) */
  liveValue: Scalars['String']['output'];
  /** The number of decimal places allowed for this asset type */
  maxPrecision: Scalars['String']['output'];
  /** The minimum possible balance that can be held in a wallet for this asset type. This is usually imposed by the protocol. */
  minReserveRequirement: Maybe<Amount>;
  /** Name of the asset type */
  name: Scalars['String']['output'];
  /** NetworkInfo returns information about the blockchain network on which units of this assetTypeID are transacted - nullable in case asset type does not have a network */
  networkInfo: Maybe<NetworkInfo>;
  /** The ID of the parent asset type if it exists */
  parentAssetTypeID: Maybe<Scalars['AssetTypeID']['output']>;
  /** The info of the parent asset type if it exists */
  parentAssetTypeInfo: Maybe<AssetTypeInfo>;
  /**
   * If the asset is popular, this will return the order that it should be shown in a "popular" section of an asset type list
   * Otherwise, nothing will be returned
   */
  popularityIndex: Maybe<Scalars['Int']['output']>;
  /** The source used in pricing the asset. */
  priceSource: Scalars['String']['output'];
  /** Whether memo field is required in withdrawal for this asset */
  requiresMemo: Scalars['Boolean']['output'];
  /** standardizedStakingInfo returns the standardized staking information for this asset type. */
  standardizedStakingInfo: StandardizedStakingInfo;
  /** Whether asset requires additional extra params */
  supportedExtraParams: SupportedExtraParamsTypes;
  /** Whether the Anchorage gas station is supported on this asset to pay gas fees */
  supportsGasStation: Scalars['Boolean']['output'];
  /** Identifies whether assets of this AssetType support multiple addresses (true for UTXO based, false for account based) */
  supportsMultipleAddresses: Scalars['Boolean']['output'];
  /**
   * Whether this asset type supports withdrawals.
   * Returns false when withdrawals are disabled for this asset type (e.g. gmFLOCK,
   * which is non-transferable). Clients should hide or disable the withdrawal flow
   * when this field is false.
   */
  supportsWithdrawals: Scalars['Boolean']['output'];
  /**
   * The chain-neutral on-chain token identifier: the ERC-20 contract address,
   * SPL token mint, Sui coin type, etc. Null for native assets.
   */
  tokenOnChainIdentifier: Maybe<Scalars['String']['output']>;
  /** Identifier of token type e.g. ERC-20, ERC-721, SLP */
  tokenType: Scalars['String']['output'];
  /**
   * Raw, unformatted value of the asset type (unlike displayValue, USD is not short-circuited).
   * Reflects the price at the time of operation completion when resolved through a completed
   * operation's amount, and the live price otherwise.
   */
  value: Scalars['String']['output'];
  /**
   * Value history of the asset type in the past "days" days (optional). Defaults to 90 days and is
   * capped at 3650 days. One request may use at most 6 different "days" values.
   */
  valueHistory: Array<Scalars['String']['output']>;
};


/** Additional information about an asset type */
export type AssetTypeInfoiconURLArgs = {
  iconType?: IconType;
  size?: Scalars['Int']['input'];
};


/** Additional information about an asset type */
export type AssetTypeInfovalueHistoryArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};

/** AssetTypeTeamGroup maps a Protocols team to its owned asset type IDs. */
export type AssetTypeTeamGroup = {
  __typename: 'AssetTypeTeamGroup';
  /** Asset type IDs owned by this team, sorted alphabetically. */
  assetTypeIDs: Array<Scalars['String']['output']>;
  /** Short team label: "A", "B", "C", "D", "E", "F", or "Other" */
  teamLabel: Scalars['String']['output'];
  /** Full team name: "Protocols A", "Protocols B", ..., or "Other" */
  teamName: Scalars['String']['output'];
};

/** Represents an attachment, including its MIME type, filename, and Base64-encoded data. */
export type AttachmentContent = {
  __typename: 'AttachmentContent';
  /** The MIME type of the attachment, e.g., application/pdf or image/png. */
  contentType: Scalars['String']['output'];
  /** The Base64-encoded data of the attachment. */
  data: Scalars['String']['output'];
  /** The name of the file. */
  filename: Scalars['String']['output'];
};

/** Request an attestation of an address. */
export type AttestAddressRequest = {
  /** Address related to the attestation key. */
  address: Scalars['String']['input'];
  /** AssetTypeID to use. */
  assetTypeID: Scalars['AssetTypeID']['input'];
  /** Message to sign. */
  challenge?: InputMaybe<Scalars['String']['input']>;
};

/** Result of triggering the organization legacy fields audit workflow. */
export type AuditOrganizationLegacyFieldsResult = {
  __typename: 'AuditOrganizationLegacyFieldsResult';
  /** The Temporal workflow ID for tracking the audit progress. */
  workflowId: Scalars['String']['output'];
};

/** AuthorizeSpenderOperation represents an AuthorizeSpender operation */
export type AuthorizeSpenderOperation = Operation & {
  __typename: 'AuthorizeSpenderOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /**
   * amountAuthorized is the amount the spender is authorized to spend. A null value indicates unlimited spending
   * authority
   */
  amountAuthorized: Maybe<Amount>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** asset id from with the authorization was made */
  assetID: AssetID;
  /** Further information regarding this asset type associated with this operation */
  assetTypeInfo: AssetTypeInfo;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** canonicalOperationVersion is the version of the canonical authorization that must be used to sign this authorization */
  canonicalOperationVersion: Scalars['Int']['output'];
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** confirmations returns how many confirmations the transaction associated with this authorization has received */
  confirmations: Maybe<Scalars['Int']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * extraParams are additional asset type specific parameters that were set for this transaction
   * When constructing the canonical operation for signing, the extra params go in the ExtraParams field
   * as a map from asset type id (usually, parent asset type id) to params object. The convention of extra
   * params is to omit all empty fields, and if no extra params are set for an asset type, to omit the asset
   * type from the map entirely. Note that for legacy reasons this convention
   * is the opposite of the normal CanonicalOperation convention, where no fields are ever omitted.
   */
  extraParams: Maybe<ExtraParams>;
  /** final transaction fee charged for the authorization, detected on the blockchain */
  finalFee: Maybe<Amount>;
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** max transaction fee charged for the authorization */
  maxFee: Maybe<Amount>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /**
   * replayProtectionParams are the parameters to be sent to the HSM for creating and signing
   * the transactions required to effect this ExecuteOperation. The user *is not* expected
   * to review the contents of this field. However it may contain information necessary to prevent
   * replays and must be included in the payload signed by the user. Format is a hex-encoded
   * byte array.
   */
  replayProtectionParams: Maybe<Scalars['String']['output']>;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** sendingBlockchainAddresses is a list of addresses from which an authorize spender operation is sent */
  sendingBlockchainAddresses: Array<BlockchainAddress>;
  /** signedTransaction is the blockchain transaction to be broadcast to the network */
  signedTransaction: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /**
   * sources are the originating addresses for the authorization
   * @deprecated use sendingBlockchainAddresses
   */
  sources: Array<Source>;
  /** spender is the address authorized to spend on this asset's behalf */
  spender: Scalars['String']['output'];
  /** transactionID is the blockchain transaction id once available */
  transactionID: Maybe<Scalars['String']['output']>;
  /** transactionSuccess indicates if the blockchain transaction succeeded */
  transactionSuccess: Maybe<Scalars['Boolean']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * usdValueFee is the USD value of the fee (finalFee if known, otherwise maxFee).
   * If both the finalFee and maxFee are not yet known, this field will be null
   */
  usdValueFee: Maybe<Scalars['String']['output']>;
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
};


/** AuthorizeSpenderOperation represents an AuthorizeSpender operation */
export type AuthorizeSpenderOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** AuthorizeSpenderOperation represents an AuthorizeSpender operation */
export type AuthorizeSpenderOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** AutoCompoundStep represents a step to ask a user if they want to enable auto-compounding for the positions in this asset. */
export type AutoCompoundStep = StakingStep & {
  __typename: 'AutoCompoundStep';
  /** List of buttons associated with this step */
  buttons: Array<BooleanButton>;
  /** Text of the step with the icons and text information */
  content: Array<Paragraph>;
  /**
   * Ignore this field, since AutoCompound step doesn't send anything in the Mutation
   * If we later decide to send this as a part of the mutation, it will function like the other fieldNames
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Allows the backend to provide info banners to be shown above the step */
  infoItems: Maybe<Array<InfoItem>>;
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
  /** The subtitle of the step */
  subtitle: Maybe<Scalars['String']['output']>;
  /** The title of the step */
  title: Scalars['String']['output'];
};

export type AutoDeleveraging = {
  levels: Array<InputMaybe<DeleveragingLevel>>;
};

export type AutoDeleveragingResult = {
  __typename: 'AutoDeleveragingResult';
  success: Scalars['Boolean']['output'];
};

/** AvailableForPurpose determines what purpose the amount of asset returned should be available for, ie a withdrawal, delegation, or unbond. */
export enum AvailableForPurpose {
  /** CLAIM is for claiming from a Vesting Contract */
  CLAIM = 'CLAIM',
  /** DELEGATE is for delegation operation delegate type */
  DELEGATE = 'DELEGATE',
  /** LOCK is for lock operation */
  LOCK = 'LOCK',
  /** UNLOCK is for unlock operation */
  UNLOCK = 'UNLOCK',
  /** VOTE is for vote operation */
  VOTE = 'VOTE',
  /** WITHDRAW is for withdraw operation */
  WITHDRAW = 'WITHDRAW'
}

/** Extra parameters for Avalanche Staking operations */
export type AvalanchePChainExtraParams = {
  __typename: 'AvalanchePChainExtraParams';
  /** Action type is used to decide which fields should be used. */
  actionType: ExtraParamsActionType;
  /** DelegationShares represents the commission that the validator takes from the rewards of the delegators */
  delegationShares: Maybe<Scalars['Int']['output']>;
  /** Address where the rewards from delegation will be sent to */
  delegatorRewardsAddress: Maybe<Scalars['String']['output']>;
  /** Optional delegation duration */
  duration: Maybe<Scalars['String']['output']>;
  /** Staking/Delegation position end time in RFC3339 format */
  endTime: Scalars['String']['output'];
  /** Node's Proof of Possession Public Key */
  nodePublicKey: Maybe<Scalars['String']['output']>;
  /** Node's Proof of Possession Signature */
  nodeSignature: Maybe<Scalars['String']['output']>;
  /** Staking/Delegation position start time in RFC3339 format */
  startTime: Scalars['String']['output'];
  /** Address where the staking rewards will be sent to */
  validatorRewardsAddress: Maybe<Scalars['String']['output']>;
};

/**
 * One relation found inside an allow-listed dataset.
 *
 * It carries no columns: listing is the browsing step, and the columns of the one
 * relation an operator then picks are a schema read's question, not this one's.
 */
export type BQRelation = {
  __typename: 'BQRelation';
  /**
   * Whether a VIEW-backed report type could name this relation — the same
   * managed-source predicate createReportTypeDefinition applies, answered here so
   * a form can grey out what a create would refuse. It is a HINT: the create
   * re-decides it, and a true here is never the reason a write is accepted.
   */
  canBackReportType: Scalars['Boolean']['output'];
  /**
   * The relation's id inside the dataset, as BigQuery spells it. BigQuery
   * identifiers are case-sensitive, so this is the spelling a registration must
   * use — even when the filter that found it matched case-insensitively.
   */
  name: Scalars['String']['output'];
  type: BQRelationType;
};

/**
 * Narrows a relation listing by name. Both fields are optional and an omitted
 * filter matches everything; supplying both means both must hold.
 *
 * Matching is case-insensitive, deliberately looser than BigQuery's own
 * case-sensitive identifiers: this is a search box an operator is guessing into,
 * and hiding `RPT_Foo` because they typed `rpt_` helps nobody. The exact spelling
 * still has to be right at registration, where the case-sensitive rules apply.
 */
export type BQRelationFilterInput = {
  /** Keeps relations whose name contains it anywhere. */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Keeps relations whose name starts with it. */
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One page-less answer to a relation listing: what was found, and whether the
 * caller is seeing all of it.
 */
export type BQRelationListing = {
  __typename: 'BQRelationListing';
  /** The matches, in the order BigQuery reported them, capped at 20. */
  relations: Array<BQRelation>;
  /**
   * True when at least one further match exists beyond those returned. It is a
   * flag, not a cursor: the move is to narrow the filter, not to ask for the next
   * page — there is no next page to ask for.
   */
  truncated: Scalars['Boolean']['output'];
};

/**
 * What a relation inside an allow-listed dataset is. The set is closed: a relation
 * kind BigQuery grows later is reported as OTHER rather than failing the listing,
 * so one exotic relation can never hide every sound one beside it.
 */
export enum BQRelationType {
  EXTERNAL = 'EXTERNAL',
  MATERIALIZED_VIEW = 'MATERIALIZED_VIEW',
  OTHER = 'OTHER',
  SNAPSHOT = 'SNAPSHOT',
  TABLE = 'TABLE',
  VIEW = 'VIEW'
}

/**
 * One BigQuery (project, dataset) pair a report type may be registered against.
 *
 * The dataset — never the project alone — is the contract boundary the allow-list
 * grants against, so the pair is what a source IS here. There is no view in it:
 * which relations live inside a pair is bqSourceRelations' question.
 */
export type BQSource = {
  __typename: 'BQSource';
  dataset: Scalars['String']['output'];
  project: Scalars['String']['output'];
};

/**
 * A BigQuery view's live column schema, read without a report type definition
 * existing. Nothing here is persisted: it is what createReportTypeDefinition WOULD
 * store as discoveredSchema if the type were registered against this source now.
 */
export type BQViewSchemaPreview = {
  __typename: 'BQViewSchemaPreview';
  /**
   * Every column of the view, in the view's own column order, under standard-SQL
   * type spellings (INT64, not INTEGER) and synthesized modes. Every column is
   * reported whatever its type — whether a type can be projected is decided where
   * a header or a filter names it, which is the create's job and not this read's.
   */
  columns: Array<DiscoveredSchemaColumn>;
  dataset: Scalars['String']['output'];
  /**
   * The source that was read, echoed back as it was asked for. BigQuery
   * identifiers are case-sensitive, so the exact spelling matters.
   */
  project: Scalars['String']['output'];
  view: Scalars['String']['output'];
};

/** Extra parameters for BSC staking operations. */
export type BSCExtraParams = {
  __typename: 'BSCExtraParams';
  /**
   * delegateVotePower indicates whether governance voting power was also delegated.
   * Populated for DELEGATE and REDELEGATE operations; absent for UNDELEGATE.
   */
  delegateVotePower: Maybe<Scalars['Boolean']['output']>;
  /** redelegateSrc is the source validator address for redelegate operations. */
  redelegateSrc: Maybe<Scalars['String']['output']>;
  /** shares is the number of shares delegated/undelegated/redelegated. */
  shares: Maybe<Scalars['String']['output']>;
};

/** This list loosely corresponds to user types in lib/auth/user.go but groups together into categories. */
export enum BackendUserType {
  /** Corresponds to a user who is going through the KYC process. */
  KYC_USER = 'KYC_USER',
  /** Corresponds to a user who is associated with an existing organization. */
  ORG_USER = 'ORG_USER',
  /** Corresponds to StaffUser type defined in user.go. */
  STAFF = 'STAFF'
}

/** Represents a balance adjustment */
export type BalanceAdjustmentOperation = Operation & {
  __typename: 'BalanceAdjustmentOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** adjustmentType is the class of adjustment. */
  adjustmentType: Scalars['String']['output'];
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount is the total balance change */
  amount: Amount;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation. Can be used to provide more context to the operation. */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** externalAddress is the address outside the asset affected by the adjustment (or empty for fee/mint/burn) */
  externalAddress: Scalars['String']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** transactionID is the blockchain transaction receipt id */
  transactionID: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
  /** The wallet associated with this operation */
  wallet: Wallet;
};


/** Represents a balance adjustment */
export type BalanceAdjustmentOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** Types of BalanceAdjustment. */
export enum BalanceAdjustmentType {
  ASSOCIATED_CONTRACT = 'ASSOCIATED_CONTRACT',
  CELO_REVOKE_CONTRACT = 'CELO_REVOKE_CONTRACT',
  FIAT_MANUAL_WITHDRAWAL = 'FIAT_MANUAL_WITHDRAWAL',
  FIAT_RETURN = 'FIAT_RETURN',
  INX_REVOKE_TOKEN = 'INX_REVOKE_TOKEN',
  OTHER = 'OTHER',
  RIA_FBO_MIGRATION = 'RIA_FBO_MIGRATION',
  UNSUPPORTED_TENDERMINT_TX = 'UNSUPPORTED_TENDERMINT_TX'
}

/** BalanceAllocation represents the allocations for the FIAT asset (Custody, Trading, etc) */
export type BalanceAllocation = {
  __typename: 'BalanceAllocation';
  /** Amount of the balance allocation */
  amount: Amount;
  /** Percentage of the balance allocation */
  holdingPercentage: Scalars['String']['output'];
  /** Name of the balance allocation */
  name: Scalars['String']['output'];
};

export type BalanceDescription = {
  __typename: 'BalanceDescription';
  /** Amount represents the amount of the balance type */
  amount: Amount;
  /** The ledger balance type for the balance */
  balanceType: Scalars['String']['output'];
  /** Description represents the presentable name of the balance type */
  description: Scalars['String']['output'];
  /** Info provides a more detailed explanation of what the balance type represents */
  info: Maybe<Scalars['String']['output']>;
};

/** BalanceDiscrepancyReport contains all balance discrepancies with their sources */
export type BalanceDiscrepancyReport = {
  __typename: 'BalanceDiscrepancyReport';
  /** discrepancies is the list of all balance discrepancies found */
  discrepancies: Array<BalanceDiscrepancyWithSources>;
};

/** BalanceDiscrepancyWithSources represents a single balance discrepancy with all its balance sources */
export type BalanceDiscrepancyWithSources = {
  __typename: 'BalanceDiscrepancyWithSources';
  /** address is the blockchain address */
  address: Scalars['String']['output'];
  /** assetSubID is the asset sub ID */
  assetSubID: Scalars['Int']['output'];
  /** assetType is the asset type ID */
  assetType: Scalars['String']['output'];
  /** balanceSources is the list of all balance sources for this discrepancy */
  balanceSources: Array<BalanceSourceEntry>;
  /** balanceSourcesMaxBalanceDifference is the maximum difference between any two balance sources */
  balanceSourcesMaxBalanceDifference: Scalars['String']['output'];
  /** balanceType is the type of balance (e.g., "COMPLETE", "AVAILABLE", etc.) */
  balanceType: Scalars['String']['output'];
  /** createdAt is when the discrepancy was first detected */
  createdAt: Scalars['String']['output'];
  /** organizationKeyID is the organization ID */
  organizationKeyID: Scalars['String']['output'];
  /** tokenID is the token ID for NFTs */
  tokenID: Scalars['String']['output'];
  /** updatedAt is when the discrepancy was last updated */
  updatedAt: Scalars['String']['output'];
  /** vaultSubID is the vault sub ID */
  vaultSubID: Scalars['Int']['output'];
};

/** BalanceFundingStatus describes the aggregate funding readiness of a balance group */
export enum BalanceFundingStatus {
  /** No underlying payments are funded */
  NOT_READY = 'NOT_READY',
  /** Some payments are funded, some are not */
  PARTIALLY_READY = 'PARTIALLY_READY',
  /** All underlying payments are funded */
  READY = 'READY'
}

/** BalanceSourceEntry represents a single balance source and its amount */
export type BalanceSourceEntry = {
  __typename: 'BalanceSourceEntry';
  /** amount is the balance amount for this source */
  amount: Scalars['String']['output'];
  /** source is the name of the balance source (e.g., OperationsDB, Blockchain, UBB) */
  source: Scalars['String']['output'];
};

/** Represents the type of balance of a transaction entry */
export enum BalanceType {
  /** Represents balance that cannot be used (HOLD) */
  HOLD = 'HOLD',
  /** Represents pending balance of a transaction */
  PENDING = 'PENDING',
  /** Represents type POSTED */
  POSTED = 'POSTED'
}

/** BankDirectoryEntry type represents a bank with it's corresponding information. */
export type BankDirectoryEntry = {
  __typename: 'BankDirectoryEntry';
  /** Name of the bank */
  bankName: Scalars['String']['output'];
  /** Branch name for the bank */
  branchName: Maybe<Scalars['String']['output']>;
  /** City part of the bank address */
  city: Scalars['String']['output'];
  /** Country code of the bank address */
  countryCode: Maybe<Scalars['String']['output']>;
  /** Routing number or SWIFT code used for querying the bank */
  financialInstitutionID: Scalars['String']['output'];
  /** Postal code of the bank address */
  postalCode: Maybe<Scalars['String']['output']>;
  /** State or province part of the bank address */
  state: Scalars['String']['output'];
  /** Street address part of the bank address */
  streetAddress: Maybe<Scalars['String']['output']>;
};

/** BankInfoForOrg is one fiat.bank_info row for an organization: a wallet's bank relationship. */
export type BankInfoForOrg = {
  __typename: 'BankInfoForOrg';
  /** The bank name */
  bankName: BankName;
  /** When the account was closed, if it has been. */
  closedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The bank's own identifier for this customer/account. */
  customerIdentifier: Scalars['String']['output'];
  /** When the account was frozen, if it has been. */
  frozenAt: Maybe<Scalars['Timestamp']['output']>;
  /**
   * The fiat.bank_info row's own id - pass this as virtualAccountID to virtualAccountAddress /
   * updateVirtualAccountAddress.
   */
  id: Scalars['String']['output'];
  /** The wallet ID */
  walletID: Scalars['String']['output'];
};

/** BankName enum represents the bank names for fiat operations */
export enum BankName {
  /** BNY - Bank of New York Mellon */
  BNY = 'BNY',
  /** CB - Customers Bank */
  CB = 'CB',
  /** CRB - Cross River Bank */
  CRB = 'CRB',
  /** JPM - JPMorgan Chase Bank */
  JPM = 'JPM',
  /** SCB - Standard Chartered Bank */
  SCB = 'SCB'
}

/**
 * BaseFeePerGasMultiplierLevel defines the level at which funds will be reserved as transaction fee.
 * It can be used to cap the max amount transaction fee.
 * Internally the setting is currently translated to different BaseFeeMultiplier values being used.
 * BaseFeeMultiplier controls what multiplier to use when calculating "max base fee".
 * Currently this is only applicable to transaction for ETH and ERC20 tokens.
 *
 * This type has to match schema.FeeReservationLevel.
 */
export enum BaseFeePerGasMultiplierLevel {
  /**
   * ECONOMY level means to reserve the least funds as transaction fee, thus increasing the chance
   * of the transaction being stuck waiting for actual network fee to come below the reserve.
   * This option is best suited when user wants to wait when actual network fee is high.
   * Note that if actual network fee never becomes low enough, then the transaction could be stuck
   * forever (until canceled.)
   */
  ECONOMY = 'ECONOMY',
  /**
   * GENEROUS level means to reserve the most funds as transaction fee, thus mimizing the chance
   * of the transaction being stuck waiting for actual network fee to come below the reserve.
   * This option is best suited when user still wants to execute the transaction even when network
   * fee is high.
   * Note that actual transaction fee spent is still determined by the network at the time of
   * transaction execution.
   */
  GENEROUS = 'GENEROUS',
  /** MEDIUM level strikes a balance between GENEROUS and ECONOMY. */
  MEDIUM = 'MEDIUM',
  /** UNSPECIFIED means no value specificed, and default behavior will be used. */
  UNSPECIFIED = 'UNSPECIFIED'
}

export type BespokeStakingFeeTermsDetail = {
  __typename: 'BespokeStakingFeeTermsDetail';
  fees: Array<AssetStakingFees>;
};

/** BidAskOutput defines the expected fields for both bid & ask RFQ's */
export type BidAskOutput = {
  __typename: 'BidAskOutput';
  /** Volatility premium in basis points */
  volatilityPremiumBps: Scalars['String']['output'];
  /** Volatility premium for the market */
  volatilityPremiumMarket: Scalars['String']['output'];
  /** Volume-weighted average price for the market */
  vwapMarket: Scalars['String']['output'];
  /** VWAP spread in basis points */
  vwapSpreadBps: Scalars['String']['output'];
};

export type BillingEntitiesConnection = {
  __typename: 'BillingEntitiesConnection';
  /** Edges contains a list of BillingEntityEdge objects representing a page of billing entities data. */
  edges: Array<BillingEntityEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

export type BillingEntitiesFilterInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  entityStatuses?: InputMaybe<Array<BillingEntityStatus>>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
};

/** BillingEntity represents a customer in Netsuite used to track invoices and payment transaction */
export type BillingEntity = {
  __typename: 'BillingEntity';
  /** Top level account IDs associated to the terms */
  accountIds: Array<Scalars['ID']['output']>;
  accounts: Maybe<Array<Maybe<AccountV2>>>;
  /** Currency used for the invoices of a billing entity */
  billingCurrency: Scalars['String']['output'];
  /** Frequency at which the billing entity entity will be billed */
  billingFrequency: BillingFrequency;
  /** Date when the billing entity were created */
  createdAt: Scalars['Date']['output'];
  /** User who created the billing entity */
  createdBy: Scalars['String']['output'];
  /** Status of the billing entity */
  entityStatus: BillingEntityStatus;
  /** Internal ID */
  id: Scalars['ID']['output'];
  /** Name of the billing entity */
  name: Scalars['String']['output'];
  /** customerID of the billing entity in Netsuite */
  netsuiteCustomerID: Maybe<Scalars['String']['output']>;
  /** Date at which the billing entity was updated recently */
  updatedAt: Maybe<Scalars['Date']['output']>;
  /** User who made the recent update to the billing entity */
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type BillingEntityEdge = {
  __typename: 'BillingEntityEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a ServiceBillingEntityFeeTerms entry */
  node: BillingEntity;
};

/** BillingEntityStatus represents the possible states of a billing entity */
export enum BillingEntityStatus {
  ACTIVE = 'ACTIVE'
}

/** BillingFrequency represents the cadence at which a billing entity or a fees agreement is billed */
export enum BillingFrequency {
  ANNUAL = 'ANNUAL',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY'
}

export enum BillingTerms {
  NET15 = 'NET15',
  NET30 = 'NET30',
  NET45 = 'NET45',
  NET60 = 'NET60'
}

/** BinaryAttestationResult is the HSM result for a completed BinaryAttestation ceremony. */
export type BinaryAttestationResult = {
  __typename: 'BinaryAttestationResult';
  attestationEnvelopeSHA384: Maybe<Scalars['String']['output']>;
  attestationEnvelopeSignature: Maybe<Scalars['String']['output']>;
  attestationEnvelopeSignatureR: Maybe<Scalars['String']['output']>;
  attestationEnvelopeSignatureS: Maybe<Scalars['String']['output']>;
  binaryHash: Scalars['String']['output'];
  binarySHA256: Scalars['String']['output'];
  codeSignMessage: Scalars['String']['output'];
  codeSignMessageSHA384: Scalars['String']['output'];
  domainTag: Scalars['String']['output'];
  endorserKeyIDs: Array<Scalars['String']['output']>;
  gitCommit: Scalars['String']['output'];
  hsmKeyID: Scalars['String']['output'];
  pubkeyX: Scalars['String']['output'];
  pubkeyY: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  signatureMechanism: Scalars['String']['output'];
  signatureR: Scalars['String']['output'];
  signatureS: Scalars['String']['output'];
  signedAt: Scalars['String']['output'];
  signingPubkey: Scalars['String']['output'];
};

/** Bio challenge requirements */
export type BioChallenge = {
  __typename: 'BioChallenge';
  /** Are gestures required */
  gesture: Scalars['Boolean']['output'];
  /** Phrase needed to kick off the process */
  voicePhrase: Array<Scalars['String']['output']>;
  /** List of needed words */
  voiceWords: Array<Scalars['String']['output']>;
};

/** Extra parameters for Bitcoin Babylon Claim operations. */
export type BitcoinBabylonClaimExtraParams = {
  __typename: 'BitcoinBabylonClaimExtraParams';
  /** Babylon Staking Version. */
  babylonStakingVersion: Scalars['Int']['output'];
  /** ID of the delegate operation that the claim operation is associated with. */
  delegateOperationID: Scalars['String']['output'];
  /** The public key of the finality provider encoded in hex. */
  finalityProviderPublicKey: Scalars['String']['output'];
  /** The relative lock-time in blocks. */
  timelockBlocks: Scalars['Int']['output'];
};

/** Extra parameters for Bitcoin Babylon Delegate operations. */
export type BitcoinBabylonDelegateExtraParams = {
  __typename: 'BitcoinBabylonDelegateExtraParams';
  /** Babylon address for rewards. */
  babylonAddressForRewards: Scalars['String']['output'];
  /** Babylon Staking Version. */
  babylonStakingVersion: Scalars['Int']['output'];
  /** The public key of the finality provider encoded in hex. */
  finalityProviderPublicKey: Scalars['String']['output'];
  /** The relative lock-time in blocks. */
  timelockBlocks: Scalars['Int']['output'];
};

/** Extra parameters for Bitcoin Babylon Early Unbond operations. */
export type BitcoinBabylonEarlyUnbondExtraParams = {
  __typename: 'BitcoinBabylonEarlyUnbondExtraParams';
  /** Babylon Staking Version. */
  babylonStakingVersion: Scalars['Int']['output'];
  /** ID of the delegate operation that the early unbond operation is associated with. */
  delegateOperationID: Scalars['String']['output'];
  /** The public key of the finality provider encoded in hex. */
  finalityProviderPublicKey: Scalars['String']['output'];
  /** The relative lock-time in blocks. */
  timelockBlocks: Scalars['Int']['output'];
};

/** Extra parameters for Bitcoin Babylon Spend Unbond Expired Timelock operations. */
export type BitcoinBabylonSpendUnbondExpiredTimelockExtraParams = {
  __typename: 'BitcoinBabylonSpendUnbondExpiredTimelockExtraParams';
  /** Babylon Staking Version. */
  babylonStakingVersion: Scalars['Int']['output'];
  /** delegateOperationID is the ID of the delegate operation that the spend unbond expired timelock operation is associated with. */
  delegateOperationID: Scalars['String']['output'];
  /** The public key of the finality provider encoded in hex. */
  finalityProviderPublicKey: Scalars['String']['output'];
  /** The relative lock-time in blocks for the unbond tx */
  unbondTimelockBlocks: Scalars['Int']['output'];
  /** Unbond TxID broadcast by the covenant committee. */
  unbondTxID: Scalars['String']['output'];
  /** unbond Vout index to spend */
  unbondVout: Scalars['Int']['output'];
};

/** Extra parameters for Bitcoin operations. */
export type BitcoinExtraParams = {
  __typename: 'BitcoinExtraParams';
  /** Action type is used to decide which fields should be used. */
  actionType: ExtraParamsActionType;
  /** Bitcoin Babylon Claim extra parameters. */
  babylonClaimExtraParams: Maybe<BitcoinBabylonClaimExtraParams>;
  /** Bitcoin Babylon Delegate extra parameters. */
  babylonDelegateExtraParams: Maybe<BitcoinBabylonDelegateExtraParams>;
  /** Bitcoin Babylon Early Unbond extra parameters. */
  babylonEarlyUnbondExtraParams: Maybe<BitcoinBabylonEarlyUnbondExtraParams>;
  /** Bitcoin Babylon Spend Unbond Expired Timelock extra parameters. */
  babylonSpendUnbondExpiredTimelockExtraParams: Maybe<BitcoinBabylonSpendUnbondExpiredTimelockExtraParams>;
};

export type BlockOutcome = {
  __typename: 'BlockOutcome';
  isBlock: Scalars['Boolean']['output'];
};

export type BlockOutcomeAvailability = {
  __typename: 'BlockOutcomeAvailability';
  isBlock: Scalars['Boolean']['output'];
};

export type BlockOutcomeInput = {
  isBlock: Scalars['Boolean']['input'];
};

/** BlockPricerTradingAsset contains the code and decimal precision length for a tradable asset */
export type BlockPricerTradingAsset = {
  __typename: 'BlockPricerTradingAsset';
  /** Code is the unique identifier for a trading asset, is not mutable */
  code: Scalars['String']['output'];
  /** Precision is the maximum number of decimal places available for a given asset */
  precision: Scalars['Int']['output'];
};

/** BlockchainAddress contains information about an Address */
export type BlockchainAddress = Node & {
  __typename: 'BlockchainAddress';
  /**
   * Canonical text representation of the address. Returns an empty string instead of the real
   * address for Porto orgs whose wallet key backup has not been confirmed.
   */
  address: Scalars['String']['output'];
  addressRiskMetadata: Maybe<AddressRiskMetadata>;
  /**
   * URL to a 3rd Party service or website that displays all relevant blockchain data for the address.
   *
   * Null when `address` is hidden, since the explorer URL embeds the address.
   */
  blockchainExplorerURL: Maybe<Scalars['String']['output']>;
  /** ID uniquely identifies the object so it can be looked up later. */
  id: Scalars['ID']['output'];
  /**
   * ManagedAddress contains information for legacy addresses managed by Anchorage.
   * Returns null for when managedAddressV2 is present.
   *
   * DEPRECATED: Use managedAddressV2  instead, which supports both signature versions.
   * @deprecated Use managedAddressV2 instead, which supports both signature versions.
   */
  managedAddress: Maybe<ManagedAddress>;
  /**
   * managedAddressV2 contains information for addresses managed by Anchorage.
   * Supports both signature version 1 (EDDSA-based) and signature version 2 (certificate-based).
   * Returns null for addresses not managed by Anchorage or if access is not authorized.
   */
  managedAddressV2: Maybe<ManagedAddressV2>;
  /** NetworkInfo object returns information about the Blockchain Network for this address - nullable in case the asset type of this blockchain does not have a network */
  networkInfo: Maybe<NetworkInfo>;
};

/** This type is meaningful only in the context of an operation. It identifies additional, settlement network specific, data about the source or destination of the funds and provides the address data. */
export type BlockchainAddressWithParticipant = {
  __typename: 'BlockchainAddressWithParticipant';
  /** The data about the blockchain address */
  blockchainAddress: BlockchainAddress;
  /** Data about the participant - always available when a participant is used, even when they are not a trusted counterparty */
  participant: Maybe<SNParticipant>;
  /** null if the participant is not a trusted counterparty, otherwise the trusted counterpraty object */
  trustedCounterparty: Maybe<SNTrustedCounterparty>;
};

/** Blockchain Analysis (TRM_WalletScreening,TRM_AlertsCheck) */
export type BlockchainAnalysis = {
  __typename: 'BlockchainAnalysis';
  /** score represents the risk assessment of the address */
  score: TransactionRiskScore;
  /** status is the status of the request (e.g: PENDING,UNSUPPORTED,FAILURE) */
  status: RiskRequestStatus;
  /** analysisType is the type of analysis (e.g: WalletScreening, AlertCheck) */
  type: RiskAnalysisType;
  /** url is an URL for an external chain analysis dashboard */
  url: Scalars['String']['output'];
  /** vendor is the enum value for the analysis vendor (e.g: TRM) */
  vendor: RiskAnalysisVendor;
};

/** Represents a blockchain asset within the ledger. */
export type BlockchainAsset = {
  __typename: 'BlockchainAsset';
  /** Identifier for the wallet within the vault (aka wallet sub id) used to differentiate between wallets of the same asset type */
  assetSubID: Scalars['Int']['output'];
  /** The AssetTypeID associated with the blockchain asset */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Network ID */
  networkID: Scalars['String']['output'];
  /** Organization key ID */
  organizationKeyID: Scalars['String']['output'];
  /** Identifier for the vault within the organization */
  vaultSubID: Scalars['Int']['output'];
};

/** A blockchain screening queue row. */
export type BlockchainScreeningRecord = {
  __typename: 'BlockchainScreeningRecord';
  /** Analysis type. */
  analysisType: Scalars['String']['output'];
  /** Asset type ID. */
  assetTypeID: Scalars['String']['output'];
  /** Created timestamp (UnixNano), if set. */
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  /** Identifier (address or tx hash). */
  identifier: Scalars['String']['output'];
  /** Network ID, if set. */
  networkID: Maybe<Scalars['String']['output']>;
  /** Operation ID. */
  operationID: Scalars['String']['output'];
  /** Organization key ID, if set. */
  orgID: Maybe<Scalars['String']['output']>;
  /** Request status. */
  requestStatus: Scalars['String']['output'];
  /** Raw vendor response body, if set. */
  responseBody: Maybe<Scalars['String']['output']>;
  /** Risk score. */
  score: Scalars['String']['output'];
  /** Analysis source/provider. */
  source: Scalars['String']['output'];
  /** Vendor-side identifier for the analysis. */
  sourceIdentifier: Scalars['String']['output'];
  /** Updated timestamp (UnixNano), if set. */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** Bluetooth information */
export type Bluetooth = {
  __typename: 'Bluetooth';
  /** Visible peripherals */
  peripherals: Array<BluetoothPeripheral>;
  /** The state of the bluetooth capabilities on the device */
  state: BluetoothState;
};


/** Bluetooth information */
export type BluetoothperipheralsArgs = {
  state?: InputMaybe<BluetoothPeripheralState>;
};

/** A specific bluetooth peripheral */
export type BluetoothPeripheral = {
  __typename: 'BluetoothPeripheral';
  /** Date in nanoseconds */
  discoveredAt: Scalars['String']['output'];
  /** Identifier of the peripheral */
  identifier: Scalars['String']['output'];
  /** Name of the peripheral */
  name: Scalars['String']['output'];
  /** Received Signal Strength Indication */
  rssi: Scalars['String']['output'];
  /** State of the peripheral */
  state: BluetoothPeripheralState;
};

/** Possible states of bluetooth peripherals */
export enum BluetoothPeripheralState {
  /** Peripheral is connected */
  CONNECTED = 'CONNECTED',
  /** Peripheral is connecting */
  CONNECTING = 'CONNECTING',
  /** Peripheral is disconnected */
  DISCONNECTED = 'DISCONNECTED',
  /** Peripheral is disconnecting */
  DISCONNECTING = 'DISCONNECTING',
  /** We failed to parse the status */
  UNKNOWN = 'UNKNOWN'
}

/** Possible bluetooth states */
export enum BluetoothState {
  /** The capability is OFF */
  POWEREDOFF = 'POWEREDOFF',
  /** The capability is ON */
  POWEREDON = 'POWEREDON',
  /** Bluetooth is resetting */
  RESETTING = 'RESETTING',
  /** Not allowed to use this capability */
  UNAUTHORIZED = 'UNAUTHORIZED',
  /** Unknown state of the capability */
  UNKNOWN = 'UNKNOWN',
  /** Device does not support this capability */
  UNSUPPORTED = 'UNSUPPORTED'
}

/** BookQuoteOutput defines the expected response from booking the trade */
export type BookQuoteOutput = {
  __typename: 'BookQuoteOutput';
  /** Response message from booking the trade */
  responseMsg: Scalars['String']['output'];
};

/** BookQuoteParams sets the information to book a trade */
export type BookQuoteParams = {
  /** Base currency for the trade */
  baseCurrency: Scalars['String']['input'];
  /** Amount of base currency */
  baseCurrencyAmount: Scalars['String']['input'];
  /** Counter currency for the trade */
  counterCurrency: Scalars['String']['input'];
  /** Final price for the trade */
  finalPrice: Scalars['String']['input'];
  /** Notional value of the trade */
  notional: Scalars['String']['input'];
  /** Reference price for the trade */
  referencePrice: Scalars['String']['input'];
  /** Side of the trade (buy or sell) */
  side: BookType;
  /** Total edge in basis points */
  totalEdgeBps: Scalars['String']['input'];
  /** Name of the trading entity */
  tradingEntity: Scalars['String']['input'];
};

/** BookType indicates the order type */
export enum BookType {
  /** Buy order type */
  BUY = 'BUY',
  /** Sell order type */
  SELL = 'SELL'
}

/** BooleanButton indicates that the button should be rendered as a boolean switch. */
export type BooleanButton = Button & {
  __typename: 'BooleanButton';
  /** Indicates if the button is disabled to force using the default value */
  disabled: Scalars['Boolean']['output'];
  /** The text displayed on the button */
  label: Scalars['String']['output'];
  /** Indicates if the button should be filled with color */
  primary: Scalars['Boolean']['output'];
  /** The default value of the button the mutation should run with */
  value: Scalars['Boolean']['output'];
};

/**
 * BootMeasurementSetInput contains a snapshot of PCR (Platform Configuration Register) values
 * from a Confidential VM.
 */
export type BootMeasurementSetInput = {
  /** PCR (Platform Configuration Register) SHA256 values mapped by PCR index (0-23). */
  pcrSha256: Array<PCRValueInput>;
  /** Platform-specific boot measurement (Intel TDX or AMD SEV-SNP). */
  platformBootMeasurement: PlatformBootMeasurementInput;
  /**
   * UEFI authenticated attributes SHA256 hash (hex-encoded). The HSM will sign
   * this hash to generate the PKCS#7 signature for UEFI Secure Boot.
   */
  uefiAuthenticatedAttributesHash: Scalars['String']['input'];
};

/** Brokerage support flags for one asset. */
export type BrokerageSupportedAsset = {
  __typename: 'BrokerageSupportedAsset';
  /**
   * Custody-side asset identifier (e.g. "BTC", "SEI_SEI") from the Asset Symbol
   * column of the Anchorage Digital Asset Tracker sheet, or the base/quote of a
   * trading symbol.
   */
  asset: Scalars['String']['output'];
  /**
   * Asset is approved for trading via the chat channel -- i.e. the sheet has an
   * Approved row for this asset under the relevant brokerage entity.
   */
  chat: Scalars['Boolean']['output'];
  /**
   * Human-readable name from the sheet. Empty string when the asset has no sheet
   * row (data gap -- emitted with warning) or the sheet's name column is blank.
   */
  name: Scalars['String']['output'];
  /**
   * Asset is supported via the UI and API channel -- i.e. it appears as the base
   * or quote of an approved + enabled trading_symbol for the relevant entity.
   */
  uiAndApi: Scalars['Boolean']['output'];
};

/** Input to the query brokerageSupportedAssets. */
export type BrokerageSupportedAssetsInput = {
  /** Restrict to rows whose chat flag equals this value. Omit for no filter. */
  filterChat?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Restrict support flags to one or more brokerage entities. Omit (or pass an
   * empty list) to collapse across all brokerage entities.
   */
  filterEntities?: InputMaybe<Array<TradingEntity>>;
  /** Restrict to rows whose uiAndApi flag equals this value. Omit for no filter. */
  filterUiAndApi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a parsed lined from a trusted destinations CSV */
export type BulkTrustedDestinationItem = {
  __typename: 'BulkTrustedDestinationItem';
  /** proposedTrustedDestination is the proposed trusted destination */
  proposedTrustedDestination: ProposedTrustedDestination;
  /** validationErrors is the list of validation errors for the proposed trusted destination */
  validationErrors: Array<BulkTrustedDestinationItemError>;
};

/** BulkTrustedDestinationItemError is a wrapper for message and severity */
export type BulkTrustedDestinationItemError = {
  __typename: 'BulkTrustedDestinationItemError';
  /** level is the error level */
  level: BulkTrustedDestinationItemErrorLevel;
  /** message is the error message */
  message: Scalars['String']['output'];
};

/** BulkTrustedDestinationItemErrorLevel is the severity. Warnings are non-blocking, errors are blocking */
export enum BulkTrustedDestinationItemErrorLevel {
  /** ERROR denotes an error */
  ERROR = 'ERROR',
  /** UNKNOWN denotes an unknown error level */
  UNKNOWN = 'UNKNOWN',
  /** WARNING denotes a warning */
  WARNING = 'WARNING'
}

/** Represents a parsed line from a trusted smart contract CSV file. */
export type BulkTrustedSmartContractItem = {
  __typename: 'BulkTrustedSmartContractItem';
  /** proposedTrustedSmartContract is the proposed trusted smart contract */
  proposedTrustedSmartContract: ProposedTrustedSmartContract;
  /** validationErrors is the list of validation errors for the proposed trusted smart contract */
  validationErrors: Array<BulkTrustedSmartContractItemError>;
};

/** BulkTrustedSmartContractItemError is a wrapper for message and severity */
export type BulkTrustedSmartContractItemError = {
  __typename: 'BulkTrustedSmartContractItemError';
  /** level is the error level */
  level: BulkTrustedSmartContractItemErrorLevel;
  /** message is the error message */
  message: Scalars['String']['output'];
};

/** BulkTrustedSmartContractItemErrorLevel is the severity. Warnings are non-blocking, errors are blocking */
export enum BulkTrustedSmartContractItemErrorLevel {
  /** ERROR denotes an error. */
  ERROR = 'ERROR',
  /** UNKNOWN denotes an unknown error level. */
  UNKNOWN = 'UNKNOWN',
  /** WARNING denotes a warning. */
  WARNING = 'WARNING'
}

/** ButtonType represents a type for buttons shown in StakingSteps, all button types must extend this one. */
export type Button = {
  /** The text displayed on the button */
  label: Scalars['String']['output'];
  /** Indicates if the button should be filled with color */
  primary: Scalars['Boolean']['output'];
};

/** BuyingPower represents a brokerage account's buying power */
export type BuyingPower = {
  __typename: 'BuyingPower';
  /** Available buying power made up of a list of assets */
  available: Array<Amount>;
  /** Available buying power aggregate in USD */
  availableUSD: Amount;
  /** In-use buying power made up of a list of assets */
  inuse: Array<Amount>;
  /** In-use buying power aggregate in USD */
  inuseUSD: Amount;
  /** Total buying power made up of a list of assets */
  total: Array<Amount>;
  /** Total buying power aggregate in USD */
  totalUSD: Amount;
};

/** CRRHistoryConnection contains the edges to CRRScoreDetails */
export type CRRHistoryConnection = {
  __typename: 'CRRHistoryConnection';
  /** List of edges containing CRR score details and cursor information */
  edges: Array<CRRScoreDetailsEdge>;
  /** Page details for the associated list of CrrScoreDetailsEdge */
  pageInfo: PageInfo;
};

/** CRRHistoryFilters contains filter properties to get CRR history for an affiliate */
export type CRRHistoryFilters = {
  /**
   * fromDate filters out records with createDate less than fromDate,
   * results include fromDate(inclusive).
   */
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * getAcceptedCRR flag if true will return accepted CRR in addition
   * to dynamic CRR, if getDynamicCRR is also set to true
   */
  getAcceptedCRR?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * getDynamicCRR flag if true will return dynamic CRR in addition
   * to accepted CRR, if getAcceptedCRR is also set to true
   */
  getDynamicCRR?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * toDate filters out records with createDate greater than toDate,
   * results include toDate(inclusive).
   */
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

/** CRRRiskConfigs contains the risk parameters of a CRR configuration */
export type CRRRiskConfigs = {
  __typename: 'CRRRiskConfigs';
  /** Time at which this CRR configuration version was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Unique ID for this particular risk CRR configuration version */
  crrConfigID: Scalars['String']['output'];
  /** CRR configuration version */
  crrConfigVersion: Scalars['String']['output'];
  /** parameters as JSON */
  riskParametersBody: Scalars['String']['output'];
};

/** CRRScoreDetails contains information related to CRR */
export type CRRScoreDetails = Node & {
  __typename: 'CRRScoreDetails';
  /** createdAt is the date when record was created */
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  /** factorGroups is a list of factors values */
  factorGroups: Array<FactorGroup>;
  /** id is the internal unique identifier */
  id: Scalars['ID']['output'];
  /** numericalScore is the score in decimal as string */
  numericalScore: Maybe<Scalars['String']['output']>;
  /** outcome is the result of the Model output */
  outcome: Maybe<CRRScoreOutcome>;
  /** source gives the source of the CRR */
  source: Maybe<CRRSource>;
};

/** CRRScoreDetailsEdge contains the CRRScoreDetails */
export type CRRScoreDetailsEdge = {
  __typename: 'CRRScoreDetailsEdge';
  /** Cursor for the CrrScoreDetailsEdge */
  cursor: Scalars['ID']['output'];
  /** CRR Score details */
  node: CRRScoreDetails;
};

/** CRRScoreOutcome is the model for CRR categorical outcome */
export enum CRRScoreOutcome {
  /** HIGH is the outcome for HIGH risk */
  HIGH = 'HIGH',
  /** LOW is the outcome for LOW risk */
  LOW = 'LOW',
  /** MEDIUM is the outcome for MEDIUM risk */
  MEDIUM = 'MEDIUM'
}

/** CRRSectionHistoryPoint represents the section scores for a date */
export type CRRSectionHistoryPoint = {
  __typename: 'CRRSectionHistoryPoint';
  /** date is the date of the record */
  date: Maybe<Scalars['Timestamp']['output']>;
  /** sectionValues is the list of values of the sections */
  sectionValues: Array<SectionValue>;
};

/** CRRSource is the model for CRR source */
export enum CRRSource {
  /**
   * ACCEPTED is the approved CRR either copied from dynamic or
   * overridden by a user
   */
  ACCEPTED = 'ACCEPTED',
  /** DYNAMIC is for Dynamic CRR generated by risk models */
  DYNAMIC = 'DYNAMIC'
}

export type CSAFilter = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Input for point-in-time retrieval of CSA margin terms effective at a specific time
 * Given a margin terms ID and a timestamp, returns the single record that was effective at that time.
 * This could be from the main table (if effectiveAt is within its start/end dates) or from history.
 */
export type CSAMarginTermsEffectiveAtInput = {
  effectiveAt: Scalars['Time']['input'];
  marginTermsId: Scalars['ID']['input'];
};

export type CSAMarginTermsFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  csaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencies?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  parties?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CSAMarginTermsHistoryFilter = {
  csaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CallToAction indicates that the requesting user has an outstanding action to take.
 * Presence (non-null) signals there's something to resolve; type says what.
 */
export type CallToAction = {
  __typename: 'CallToAction';
  /**
   * The ID of the pending operation the requesting user needs to endorse (e.g. a
   * quorum/mobile approval). Null when the call to action isn't tied to a specific
   * operation, such as a click-button approval, an endorsement whose operation does
   * not exist yet, or the aggregate CTA on a control agreement.
   */
  operationID: Maybe<Scalars['ID']['output']>;
  /**
   * What the requesting user is being asked to do. On a control agreement, the type
   * of the newest activity's outstanding action.
   */
  type: CallToActionType;
};

/** The kinds of call to action. */
export enum CallToActionType {
  /** Approve or reject with a click-button approval. */
  APPROVAL = 'APPROVAL',
  /** Endorse a quorum (mobile) approval. */
  ENDORSEMENT = 'ENDORSEMENT',
  /** The pledgor must choose the wallets a secured-party proposal applies to. */
  SELECT_WALLET = 'SELECT_WALLET'
}

/** CancelKYCQuestionnaireSubmissionInput is the input for cancelKYCQuestionnaireSubmission. */
export type CancelKYCQuestionnaireSubmissionInput = {
  /** The identifier of the submission to cancel. */
  submissionID: Scalars['ID']['input'];
};

/** CancelOperationResponse contains response for a CancelOperation request. */
export type CancelOperationResponse = {
  __typename: 'CancelOperationResponse';
  /** details contains optional, detailed info, explaining why the statusCode is returned. */
  details: Maybe<Scalars['String']['output']>;
  /** statusCode indicates whether a request has been successfully received, completed, failed, etc. */
  statusCode: ResponseStatusCode;
};

export type CancelServiceFeeTermsInput = {
  /** Agreement id associated to the terms to be canceled */
  agreementId: Scalars['ID']['input'];
};

export type CancelSettlementInput = {
  /** Why the grouping is being undone */
  reason: Scalars['String']['input'];
  settlementId: Scalars['ID']['input'];
};

/** Input for cancelling an account transfer. */
export type CancelTransferInput = {
  transferId: Scalars['String']['input'];
};

/** Carrier information */
export type Carrier = {
  __typename: 'Carrier';
  /** Country ISO code of the carrier */
  countryISO: Scalars['String']['output'];
  /** Name of the carrier */
  name: Scalars['String']['output'];
  /** Technology of the carrier, e.g. LTE */
  technology: Scalars['String']['output'];
};

/** Case represents a Jira case created in the context of a compliance investigation */
export type Case = {
  __typename: 'Case';
  accountID: Scalars['String']['output'];
  affiliateKYCProfileID: Maybe<Scalars['String']['output']>;
  /** List of alerts associated to the case */
  alerts: AlertConnection;
  /** Internal ID of the case */
  caseID: Scalars['String']['output'];
  caseType: Maybe<CaseType>;
  clientType: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  crr: Maybe<CRRScoreOutcome>;
  description: Maybe<Scalars['String']['output']>;
  extAssignee: Maybe<Scalars['String']['output']>;
  extInvestigator: Maybe<Scalars['String']['output']>;
  extTrackingID: Maybe<Scalars['String']['output']>;
  extTrackingLink: Maybe<Scalars['String']['output']>;
  /** id is the unique identifier of the case, equal to caseID */
  id: Scalars['ID']['output'];
  /** Get the kyc process associated in this case if it exists */
  kycProcess: Maybe<KYCProcess>;
  /**
   * KYC Review Completion Date from the case's Jira issue, set by KYC Ops when the
   * review is approved. Null on case types that don't carry the field, and until
   * Jira populates it.
   */
  kycReviewCompletionDate: Maybe<Scalars['Date']['output']>;
  orgKeyID: Scalars['String']['output'];
  status: Maybe<CaseStatus>;
  summary: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};


/** Case represents a Jira case created in the context of a compliance investigation */
export type CasealertsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** CaseConnection implements the connections spec */
export type CaseConnection = {
  __typename: 'CaseConnection';
  /** edges implements the connections spec */
  edges: Array<CaseEdge>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
};

/** CaseEdge implements the connections spec */
export type CaseEdge = {
  __typename: 'CaseEdge';
  /** cursor implements the connections spec */
  cursor: Scalars['String']['output'];
  /** node implements the connections spec */
  node: Case;
};

/** CaseStatus are the possible states for compliance cases */
export enum CaseStatus {
  /** BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_FILED is a case where blocked property or rejected tx is filed */
  BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_FILED = 'BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_FILED',
  /** BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_IN_PROGRESS is a case where blocked property or rejected tx is in progress */
  BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_IN_PROGRESS = 'BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_IN_PROGRESS',
  /** CANCELED the case was canceled */
  CANCELED = 'CANCELED',
  /** CLIENT_APPROVED - Full KYC Review Case */
  CLIENT_APPROVED = 'CLIENT_APPROVED',
  /** CLIENT_OUTREACH - KYC Review Case */
  CLIENT_OUTREACH = 'CLIENT_OUTREACH',
  /** COMPLIANCE_APPROVAL - renamed from Pending BSAO Recommendation */
  COMPLIANCE_APPROVAL = 'COMPLIANCE_APPROVAL',
  /** DORMANT - KYC Review Case */
  DORMANT = 'DORMANT',
  /** ESCALATED_TO_BSAO is a case escalated to BSAO */
  ESCALATED_TO_BSAO = 'ESCALATED_TO_BSAO',
  /** ESCALATED_TO_BSAO_FIRST_CAR is a case escalated to BSAO for the first CAR */
  ESCALATED_TO_BSAO_FIRST_CAR = 'ESCALATED_TO_BSAO_FIRST_CAR',
  /** ESCALATED_TO_BSAO_SACTIONS_OFFICER is a case escalated to BSAO / Sanctions Officer */
  ESCALATED_TO_BSAO_SACTIONS_OFFICER = 'ESCALATED_TO_BSAO_SACTIONS_OFFICER',
  /** ESCALATED_TO_BSAO_SECOND_CAR is a case escalated to BSAO for the second CAR */
  ESCALATED_TO_BSAO_SECOND_CAR = 'ESCALATED_TO_BSAO_SECOND_CAR',
  /** ESCALATED_TO_COMPLIANCE is a case escalated to the compliance team */
  ESCALATED_TO_COMPLIANCE = 'ESCALATED_TO_COMPLIANCE',
  /** FALSE_POSITIVE - NNS, PEP */
  FALSE_POSITIVE = 'FALSE_POSITIVE',
  /** FIRST_CAR_TRIGGERED is a case that triggered it's first CAR */
  FIRST_CAR_TRIGGERED = 'FIRST_CAR_TRIGGERED',
  /** HIGH_RISK_PEP - PEP */
  HIGH_RISK_PEP = 'HIGH_RISK_PEP',
  /** IMMATERIAL_PEP - PEP */
  IMMATERIAL_PEP = 'IMMATERIAL_PEP',
  /** INITIATE_OFFBOARDING_REVIEW - Full KYC Review Case */
  INITIATE_OFFBOARDING_REVIEW = 'INITIATE_OFFBOARDING_REVIEW',
  /** IN_COMPLIANCE_ESCALATION_BSAO_REVIEW is a case in compliance escalation BSAO review */
  IN_COMPLIANCE_ESCALATION_BSAO_REVIEW = 'IN_COMPLIANCE_ESCALATION_BSAO_REVIEW',
  /** IN_COMPLIANCE_ESCALATION_REVIEW is a case in compliance escalation review */
  IN_COMPLIANCE_ESCALATION_REVIEW = 'IN_COMPLIANCE_ESCALATION_REVIEW',
  /** IN_REVIEW the case is under review */
  IN_REVIEW = 'IN_REVIEW',
  /** IN_REVIEW_FIRST_CAR is a case in review for it's first CAR (Continiuos Activity Review) */
  IN_REVIEW_FIRST_CAR = 'IN_REVIEW_FIRST_CAR',
  /** IN_REVIEW_SECOND_CAR is a case where the second CAR is in review */
  IN_REVIEW_SECOND_CAR = 'IN_REVIEW_SECOND_CAR',
  /** MANAGER_REVIEW -the case is under management review */
  MANAGER_REVIEW = 'MANAGER_REVIEW',
  /** MANAGER_REVIEW_FIRST_CAR is a case pending a Manager's review of the first CAR */
  MANAGER_REVIEW_FIRST_CAR = 'MANAGER_REVIEW_FIRST_CAR',
  /** MANAGER_REVIEW_SECOND_CAR is a case where the manager is reviewing the second CAR */
  MANAGER_REVIEW_SECOND_CAR = 'MANAGER_REVIEW_SECOND_CAR',
  /** MATERIAL_HIT - NNS */
  MATERIAL_HIT = 'MATERIAL_HIT',
  /** NEW represents a new case in Jira */
  NEW = 'NEW',
  /** NON_MATERIAL_HIT - NNS */
  NON_MATERIAL_HIT = 'NON_MATERIAL_HIT',
  /** NO_FILING - OFAC Reporting */
  NO_FILING = 'NO_FILING',
  /** OPERATIONS_APPROVAL - renamed from Pending COO Approval */
  OPERATIONS_APPROVAL = 'OPERATIONS_APPROVAL',
  /** PENDING represents a pending case in Jira */
  PENDING = 'PENDING',
  /** PENDING_BSAO_RECOMMENDATION the case is pending a recommendation from BSAO */
  PENDING_BSAO_RECOMMENDATION = 'PENDING_BSAO_RECOMMENDATION',
  /** PENDING_COO_APPROVAL is a case pending COO approval */
  PENDING_COO_APPROVAL = 'PENDING_COO_APPROVAL',
  /** PENDING_EDD - KYC Review Case */
  PENDING_EDD = 'PENDING_EDD',
  /** PENDING_FIRST_CAR is a case pending it's first CAR */
  PENDING_FIRST_CAR = 'PENDING_FIRST_CAR',
  /** PENDING_SECOND_CAR is a case pending a second CAR */
  PENDING_SECOND_CAR = 'PENDING_SECOND_CAR',
  /** PEP_FLAG_REMOVED - PEP */
  PEP_FLAG_REMOVED = 'PEP_FLAG_REMOVED',
  /** QC_REVIEW is a case where QC is reviewing */
  QC_REVIEW = 'QC_REVIEW',
  /** READY_FOR_APPROVAL is a case ready for approval */
  READY_FOR_APPROVAL = 'READY_FOR_APPROVAL',
  /** READY_QC is a case ready for QC */
  READY_QC = 'READY_QC',
  /** RESOLVED represents a resolved case */
  RESOLVED = 'RESOLVED',
  /** SAR_FILED the case was resolved with the filing of a SAR */
  SAR_FILED = 'SAR_FILED',
  /** SAR_FILED_FIRST_CAR is a case where the first CAR was filed */
  SAR_FILED_FIRST_CAR = 'SAR_FILED_FIRST_CAR',
  /** SAR_FILED_SECOND_CAR is a case where the SAR is filed for the second CAR */
  SAR_FILED_SECOND_CAR = 'SAR_FILED_SECOND_CAR',
  /** SAR_FILING_IN_PROGRESS is a case where SAR is being filed */
  SAR_FILING_IN_PROGRESS = 'SAR_FILING_IN_PROGRESS',
  /** SAR_FILING_IN_PROGRESS_FIRST_CAR is a case where the first CAR filing is in progress */
  SAR_FILING_IN_PROGRESS_FIRST_CAR = 'SAR_FILING_IN_PROGRESS_FIRST_CAR',
  /** SAR_FILING_IN_PROGRESS_SECOND_CAR is a case where the second CAR filing is in progress */
  SAR_FILING_IN_PROGRESS_SECOND_CAR = 'SAR_FILING_IN_PROGRESS_SECOND_CAR',
  /** SAR_NOT_FILED the case was resolved with the filing of a SAR */
  SAR_NOT_FILED = 'SAR_NOT_FILED',
  /** SAR_NOT_FILED_FIRST_CAR is a case where the first CAR has not been filed */
  SAR_NOT_FILED_FIRST_CAR = 'SAR_NOT_FILED_FIRST_CAR',
  /** SAR_NOT_FILED_SECOND_CAR is a case where no SAR was filed for the second CAR */
  SAR_NOT_FILED_SECOND_CAR = 'SAR_NOT_FILED_SECOND_CAR',
  /** SECOND_CAR_TRIGGERED is a case where the second CAR was triggered */
  SECOND_CAR_TRIGGERED = 'SECOND_CAR_TRIGGERED',
  /** VSD_FILED - OFAC Reporting */
  VSD_FILED = 'VSD_FILED',
  /** VSD_FILING_IN_PROGRESS is a case where VSD is being filed */
  VSD_FILING_IN_PROGRESS = 'VSD_FILING_IN_PROGRESS'
}

/** CaseStatusEnum are the possible states for compliance cases */
export enum CaseStatusEnum {
  /** BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_FILED is a case where blocked property or rejected tx is filed */
  BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_FILED = 'BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_FILED',
  /** BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_IN_PROGRESS is a case where blocked property or rejected tx is in progress */
  BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_IN_PROGRESS = 'BLOCKED_PROPERTY_OR_REJECTED_TRANSACTIONS_REPORT_IN_PROGRESS',
  /** CANCELED the case was canceled */
  CANCELED = 'CANCELED',
  /** CLIENT_APPROVED - Full KYC Review Case */
  CLIENT_APPROVED = 'CLIENT_APPROVED',
  /** CLIENT_OUTREACH - KYC Review Case */
  CLIENT_OUTREACH = 'CLIENT_OUTREACH',
  /** COMPLIANCE_APPROVAL - renamed from Pending BSAO Recommendation */
  COMPLIANCE_APPROVAL = 'COMPLIANCE_APPROVAL',
  /** DORMANT - KYC Review Case */
  DORMANT = 'DORMANT',
  /** ESCALATED_TO_BSAO is a case escalated to BSAO */
  ESCALATED_TO_BSAO = 'ESCALATED_TO_BSAO',
  /** ESCALATED_TO_BSAO_FIRST_CAR is a case escalated to BSAO for the first CAR */
  ESCALATED_TO_BSAO_FIRST_CAR = 'ESCALATED_TO_BSAO_FIRST_CAR',
  /** ESCALATED_TO_BSAO_SACTIONS_OFFICER is a case escalated to BSAO / Sanctions Officer */
  ESCALATED_TO_BSAO_SACTIONS_OFFICER = 'ESCALATED_TO_BSAO_SACTIONS_OFFICER',
  /** ESCALATED_TO_BSAO_SECOND_CAR is a case escalated to BSAO for the second CAR */
  ESCALATED_TO_BSAO_SECOND_CAR = 'ESCALATED_TO_BSAO_SECOND_CAR',
  /** ESCALATED_TO_COMPLIANCE is a case escalated to the compliance team */
  ESCALATED_TO_COMPLIANCE = 'ESCALATED_TO_COMPLIANCE',
  /** FALSE_POSITIVE - NNS, PEP */
  FALSE_POSITIVE = 'FALSE_POSITIVE',
  /** FIRST_CAR_TRIGGERED is a case that triggered it's first CAR */
  FIRST_CAR_TRIGGERED = 'FIRST_CAR_TRIGGERED',
  /** HIGH_RISK_PEP - PEP */
  HIGH_RISK_PEP = 'HIGH_RISK_PEP',
  /** IMMATERIAL_PEP - PEP */
  IMMATERIAL_PEP = 'IMMATERIAL_PEP',
  /** INITIATE_OFFBOARDING_REVIEW - Full KYC Review Case */
  INITIATE_OFFBOARDING_REVIEW = 'INITIATE_OFFBOARDING_REVIEW',
  /** IN_COMPLIANCE_ESCALATION_BSAO_REVIEW is a case in compliance escalation BSAO review */
  IN_COMPLIANCE_ESCALATION_BSAO_REVIEW = 'IN_COMPLIANCE_ESCALATION_BSAO_REVIEW',
  /** IN_COMPLIANCE_ESCALATION_REVIEW is a case in compliance escalation review */
  IN_COMPLIANCE_ESCALATION_REVIEW = 'IN_COMPLIANCE_ESCALATION_REVIEW',
  /** IN_REVIEW the case is under review */
  IN_REVIEW = 'IN_REVIEW',
  /** IN_REVIEW_FIRST_CAR is a case in review for it's first CAR (Continiuos Activity Review) */
  IN_REVIEW_FIRST_CAR = 'IN_REVIEW_FIRST_CAR',
  /** IN_REVIEW_SECOND_CAR is a case where the second CAR is in review */
  IN_REVIEW_SECOND_CAR = 'IN_REVIEW_SECOND_CAR',
  /** MANAGER_REVIEW -the case is under management review */
  MANAGER_REVIEW = 'MANAGER_REVIEW',
  /** MANAGER_REVIEW_FIRST_CAR is a case pending a Manager's review of the first CAR */
  MANAGER_REVIEW_FIRST_CAR = 'MANAGER_REVIEW_FIRST_CAR',
  /** MANAGER_REVIEW_SECOND_CAR is a case where the manager is reviewing the second CAR */
  MANAGER_REVIEW_SECOND_CAR = 'MANAGER_REVIEW_SECOND_CAR',
  /** MATERIAL_HIT - NNS */
  MATERIAL_HIT = 'MATERIAL_HIT',
  /** NEW represents a new case in Jira */
  NEW = 'NEW',
  /** NON_MATERIAL_HIT - NNS */
  NON_MATERIAL_HIT = 'NON_MATERIAL_HIT',
  /** NO_FILING - OFAC Reporting */
  NO_FILING = 'NO_FILING',
  /** OPERATIONS_APPROVAL - renamed from Pending COO Approval */
  OPERATIONS_APPROVAL = 'OPERATIONS_APPROVAL',
  /** PENDING represents a pending case in Jira */
  PENDING = 'PENDING',
  /** PENDING_BSAO_RECOMMENDATION the case is pending a recommendation from BSAO */
  PENDING_BSAO_RECOMMENDATION = 'PENDING_BSAO_RECOMMENDATION',
  /** PENDING_COO_APPROVAL is a case pending COO approval */
  PENDING_COO_APPROVAL = 'PENDING_COO_APPROVAL',
  /** PENDING_EDD - KYC Review Case */
  PENDING_EDD = 'PENDING_EDD',
  /** PENDING_FIRST_CAR is a case pending it's first CAR */
  PENDING_FIRST_CAR = 'PENDING_FIRST_CAR',
  /** PENDING_SECOND_CAR is a case pending a second CAR */
  PENDING_SECOND_CAR = 'PENDING_SECOND_CAR',
  /** PEP_FLAG_REMOVED - PEP */
  PEP_FLAG_REMOVED = 'PEP_FLAG_REMOVED',
  /** QC_REVIEW is a case where QC is reviewing */
  QC_REVIEW = 'QC_REVIEW',
  /** READY_FOR_APPROVAL is a case ready for approval */
  READY_FOR_APPROVAL = 'READY_FOR_APPROVAL',
  /** READY_QC is a case ready for QC */
  READY_QC = 'READY_QC',
  /** RESOLVED represents a resolved case */
  RESOLVED = 'RESOLVED',
  /** SAR_FILED the case was resolved with the filing of a SAR */
  SAR_FILED = 'SAR_FILED',
  /** SAR_FILED_FIRST_CAR is a case where the first CAR was filed */
  SAR_FILED_FIRST_CAR = 'SAR_FILED_FIRST_CAR',
  /** SAR_FILED_SECOND_CAR is a case where the SAR is filed for the second CAR */
  SAR_FILED_SECOND_CAR = 'SAR_FILED_SECOND_CAR',
  /** SAR_FILING_IN_PROGRESS is a case where SAR is being filed */
  SAR_FILING_IN_PROGRESS = 'SAR_FILING_IN_PROGRESS',
  /** SAR_FILING_IN_PROGRESS_FIRST_CAR is a case where the first CAR filing is in progress */
  SAR_FILING_IN_PROGRESS_FIRST_CAR = 'SAR_FILING_IN_PROGRESS_FIRST_CAR',
  /** SAR_FILING_IN_PROGRESS_SECOND_CAR is a case where the second CAR filing is in progress */
  SAR_FILING_IN_PROGRESS_SECOND_CAR = 'SAR_FILING_IN_PROGRESS_SECOND_CAR',
  /** SAR_NOT_FILED the case was resolved with the filing of a SAR */
  SAR_NOT_FILED = 'SAR_NOT_FILED',
  /** SAR_NOT_FILED_FIRST_CAR is a case where the first CAR has not been filed */
  SAR_NOT_FILED_FIRST_CAR = 'SAR_NOT_FILED_FIRST_CAR',
  /** SAR_NOT_FILED_SECOND_CAR is a case where no SAR was filed for the second CAR */
  SAR_NOT_FILED_SECOND_CAR = 'SAR_NOT_FILED_SECOND_CAR',
  /** SECOND_CAR_TRIGGERED is a case where the second CAR was triggered */
  SECOND_CAR_TRIGGERED = 'SECOND_CAR_TRIGGERED',
  /** VSD_FILED - OFAC Reporting */
  VSD_FILED = 'VSD_FILED',
  /** VSD_FILING_IN_PROGRESS is a case where VSD is being filed */
  VSD_FILING_IN_PROGRESS = 'VSD_FILING_IN_PROGRESS'
}

/** CaseType are the possible types of jira cases */
export enum CaseType {
  /** FULL_KYC_REVIEW is a case that originates from the CCV dashboard */
  FULL_KYC_REVIEW = 'FULL_KYC_REVIEW',
  /**
   * KYC_CRR_UPDATE is a case that enables users to update previously set
   * autorisk flags (eg PEP, FFI / FCA) and revise Accepted CRR ratings
   * without going through the long process of a Full KYC Review Case
   */
  KYC_CRR_UPDATE = 'KYC_CRR_UPDATE',
  /** NEGATIVE_NEWS represents the negative news case type */
  NEGATIVE_NEWS = 'NEGATIVE_NEWS',
  /** OFAC_REPORTING represents the ofac reporting case type */
  OFAC_REPORTING = 'OFAC_REPORTING',
  /** PEP represents the pep case type */
  PEP = 'PEP',
  /** REFERRAL represents the referral case type */
  REFERRAL = 'REFERRAL',
  /** TRANSACTION_ACTIVITY represents the transaction activity case type */
  TRANSACTION_ACTIVITY = 'TRANSACTION_ACTIVITY'
}

export type CasesAtTime = {
  __typename: 'CasesAtTime';
  caseType: Maybe<CaseType>;
  createdAt: Scalars['Date']['output'];
  numberOfCases: Scalars['Int']['output'];
};

/** Extra parameters for celo governance vote */
export type CeloGovernanceVoteExtraParams = {
  __typename: 'CeloGovernanceVoteExtraParams';
  /** actionType is used to construct the canonical operation */
  actionType: Maybe<ExtraParamsActionType>;
  /** destination tag to use in transaction */
  proposalID: Scalars['Int']['output'];
  /** voteOption is the intent of the vote */
  voteOption: VoteOption;
};

/**
 * CeloProposal is retained for historical operation display (via
 * CeloProposalDetails in the VoteDetails union) and for backward compatibility
 * with older iOS clients that query this full shape. Celo governance has been
 * removed; these fields are never populated with real data.
 *
 * Once the minimum supported iOS version is v2.111.0, trim this back to just
 * the `title` field (the historical-display stub); do NOT delete the type, as
 * CeloProposalDetails still references it.
 */
export type CeloProposal = {
  __typename: 'CeloProposal';
  currentVote: Maybe<CurrentVote>;
  deposit: Amount;
  descriptionUrl: Scalars['String']['output'];
  endsIn: Scalars['String']['output'];
  proposalID: Scalars['Int']['output'];
  proposer: Scalars['String']['output'];
  stage: ProposalStage;
  timestamp: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  upvotes: Scalars['Int']['output'];
  votes: VoteTotal;
};

/** Celo proposal-specific details */
export type CeloProposalDetails = {
  __typename: 'CeloProposalDetails';
  /** The Celo proposal associated with the operation */
  celoProposal: CeloProposal;
};

/**
 * CeloValidatorGroupDetail is retained as a ValidatorDetail union member for
 * backward compatibility with older iOS clients. Celo governance has been
 * removed; this type is never instantiated by the server. Safe to delete once
 * the minimum supported iOS version is v2.111.0.
 */
export type CeloValidatorGroupDetail = {
  __typename: 'CeloValidatorGroupDetail';
  /** Total amount of gold locked by this validator group */
  lockedGold: Amount;
  /** Number of total validators in this validator group */
  numMembers: Scalars['Int']['output'];
};

/** ChangeRoleOperation represents an operation to create, update, or delete a role in an organization */
export type ChangeRoleOperation = Operation & {
  __typename: 'ChangeRoleOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** comment is an optional given by the initiator to convey context to other operation reviewers */
  comment: Maybe<Scalars['String']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /**
   * existingRole contains identifier for the role, and its existing/current data, prior to the change made in this operation.
   * nil for CREATE operation, otherwise non-nil.
   * Use `roleChanges` to get the role's updated data, with the change made in this operation.
   */
  existingRole: Maybe<Role>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy required in order to satisfy this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /**
   * role contains identifier for the role, and the new data the role is changed to in this operation.
   * Always non-nil, but Permissions will be empty for DELETE operation.
   * Use `existingRole` to get the role's existing data.
   */
  role: Role;
  /**
   * roleChanges details changes being made by this operation to the permission group. Details are composed for the user interface.
   * @deprecated use rolePermissions, this field is used in an early Demo app release
   */
  roleChanges: RolePermissionChanges;
  /** rolePermissions details changes being made by this operation to the permission group. Details are composed for the user interface. */
  rolePermissions: RolePermissionDetails;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** type indicates how the role is being changed */
  type: RoleChangeType;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
};


/** ChangeRoleOperation represents an operation to create, update, or delete a role in an organization */
export type ChangeRoleOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** ChangeRoleOperation represents an operation to create, update, or delete a role in an organization */
export type ChangeRoleOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/**
 * How an account is billed for a fee: invoiced, charged directly, or not invoiced at all. The
 * same charge method applies to almost all accounts via the fee type's default terms; bespoke
 * terms on an agreement override it for the accounts it covers.
 */
export enum ChargeMethod {
  DIRECT_CHARGE = 'DIRECT_CHARGE',
  DO_NOT_INVOICE = 'DO_NOT_INVOICE',
  INVOICE_CLIENT = 'INVOICE_CLIENT'
}

/** Result of clearing empty policy changelogs. */
export type ClearEmptyPolicyChangelogsResult = {
  __typename: 'ClearEmptyPolicyChangelogsResult';
  /** Number of entries that were successfully deleted. */
  deletedCount: Scalars['Int']['output'];
  /** Total number of entries that matched the criteria. */
  totalMatched: Scalars['Int']['output'];
};

/**
 * Result of starting the clear feature workflow.
 * The mutation returns immediately after starting the workflow.
 * Use the workflowId to track the async execution progress.
 */
export type ClearFeatureResult = {
  __typename: 'ClearFeatureResult';
  /**
   * Number of organizations that were actually modified (had the feature cleared).
   * This will be 0 when the mutation returns (workflow runs asynchronously).
   */
  modifiedCount: Scalars['Int']['output'];
  /**
   * Total number of organizations that were checked.
   * This will be 0 when the mutation returns (workflow runs asynchronously).
   */
  totalChecked: Scalars['Int']['output'];
  /** The Temporal workflow ID that can be used to track progress */
  workflowId: Scalars['String']['output'];
};

export type ClearTaxbitSendFailureInput = {
  /** External ID of the transaction TaxBit rejected */
  externalId: Scalars['String']['input'];
  /** Why the failure is cleared. Logged with the staff email, since the failure row is deleted */
  reason: Scalars['String']['input'];
};

export type ClearTaxbitSendFailurePayload = {
  __typename: 'ClearTaxbitSendFailurePayload';
  /** The failure that was deleted */
  failure: TaxbitSendFailure;
};

/** ClientAffiliateType are the affiliate types a client is allowed to create */
export type ClientAffiliateType = {
  __typename: 'ClientAffiliateType';
  /** The type of affiliate for this clientID when filling this questionnaire ID */
  affiliateType: Scalars['String']['output'];
  /** The client id */
  clientID: Scalars['String']['output'];
};

/** ClientAffiliateTypeInput is the input to create the affiliate types a client is allowed */
export type ClientAffiliateTypeInput = {
  /** The type of affiliate for this clientID when filling this questionnaire ID */
  affiliateType: Scalars['String']['input'];
  /** The client id */
  clientID: Scalars['String']['input'];
};

/**
 * ClientDashboardLoginRequestInfo returns browser data and other information about
 * the session ID and its associated request to login.  If the login request is
 * used or expired, this will not return the information.
 */
export type ClientDashboardLoginRequestInfo = {
  __typename: 'ClientDashboardLoginRequestInfo';
  /** Latitude of the browser on initial request */
  latitude: Scalars['String']['output'];
  /** Longitude of the browser on initial request */
  longitude: Scalars['String']['output'];
};

/** Enum of information that may be provided by institutional clients */
export enum ClientInformationType {
  /** ACCOUNT_NAME ... */
  ACCOUNT_NAME = 'ACCOUNT_NAME',
  /** ACCOUNT_REGISTRATION ... */
  ACCOUNT_REGISTRATION = 'ACCOUNT_REGISTRATION',
  /** ACCOUNT_REGISTRATION_CORPORATION ... */
  ACCOUNT_REGISTRATION_CORPORATION = 'ACCOUNT_REGISTRATION_CORPORATION',
  /** ACCOUNT_REGISTRATION_LLC ... */
  ACCOUNT_REGISTRATION_LLC = 'ACCOUNT_REGISTRATION_LLC',
  /** ACCOUNT_REGISTRATION_OTHER ... */
  ACCOUNT_REGISTRATION_OTHER = 'ACCOUNT_REGISTRATION_OTHER',
  /** ACCOUNT_REGISTRATION_PARTNERSHIP ... */
  ACCOUNT_REGISTRATION_PARTNERSHIP = 'ACCOUNT_REGISTRATION_PARTNERSHIP',
  /** ACCOUNT_REGISTRATION_SOLE_PROPRIETOR ... */
  ACCOUNT_REGISTRATION_SOLE_PROPRIETOR = 'ACCOUNT_REGISTRATION_SOLE_PROPRIETOR',
  /** ACKNOWLEDGE_EMAIL ... */
  ACKNOWLEDGE_EMAIL = 'ACKNOWLEDGE_EMAIL',
  /** ACKNOWLEDGE_NAME ... */
  ACKNOWLEDGE_NAME = 'ACKNOWLEDGE_NAME',
  /** ACKNOWLEDGE_TITLE ... */
  ACKNOWLEDGE_TITLE = 'ACKNOWLEDGE_TITLE',
  /** ADDRESS ... */
  ADDRESS = 'ADDRESS',
  /** ADDRESS2 ... */
  ADDRESS2 = 'ADDRESS2',
  /** ADS_KYC_INSTITUTION_FORM_SUBMISSION_ID ... */
  ADS_KYC_INSTITUTION_FORM_SUBMISSION_ID = 'ADS_KYC_INSTITUTION_FORM_SUBMISSION_ID',
  /** ARE_INVESTMENT_ADVISOR ... */
  ARE_INVESTMENT_ADVISOR = 'ARE_INVESTMENT_ADVISOR',
  /** ARE_REGISTERED_MAS ... */
  ARE_REGISTERED_MAS = 'ARE_REGISTERED_MAS',
  /** ASSET_CLASSES_EXPERIENCE_COMMODITIES */
  ASSET_CLASSES_EXPERIENCE_COMMODITIES = 'ASSET_CLASSES_EXPERIENCE_COMMODITIES',
  /** ASSET_CLASSES_EXPERIENCE_DIGITAL_ASSETS */
  ASSET_CLASSES_EXPERIENCE_DIGITAL_ASSETS = 'ASSET_CLASSES_EXPERIENCE_DIGITAL_ASSETS',
  /** ASSET_CLASSES_EXPERIENCE_EQUITIES */
  ASSET_CLASSES_EXPERIENCE_EQUITIES = 'ASSET_CLASSES_EXPERIENCE_EQUITIES',
  /** ASSET_CLASSES_EXPERIENCE_FIXED_INCOME */
  ASSET_CLASSES_EXPERIENCE_FIXED_INCOME = 'ASSET_CLASSES_EXPERIENCE_FIXED_INCOME',
  /** BUSINESS_REGISTRATION_NUMBER ... */
  BUSINESS_REGISTRATION_NUMBER = 'BUSINESS_REGISTRATION_NUMBER',
  /** CITY */
  CITY = 'CITY',
  /** CLIENT_BASE_ACCREDITED_INVESTORS */
  CLIENT_BASE_ACCREDITED_INVESTORS = 'CLIENT_BASE_ACCREDITED_INVESTORS',
  /** CLIENT_BASE_CRYPTO */
  CLIENT_BASE_CRYPTO = 'CLIENT_BASE_CRYPTO',
  /** CLIENT_BASE_FAMILY */
  CLIENT_BASE_FAMILY = 'CLIENT_BASE_FAMILY',
  /** CLIENT_BASE_HEDGE_FUND */
  CLIENT_BASE_HEDGE_FUND = 'CLIENT_BASE_HEDGE_FUND',
  /** CLIENT_BASE_INSTITUTIONAL_TRUST */
  CLIENT_BASE_INSTITUTIONAL_TRUST = 'CLIENT_BASE_INSTITUTIONAL_TRUST',
  /** CLIENT_BASE_NONE */
  CLIENT_BASE_NONE = 'CLIENT_BASE_NONE',
  /** CLIENT_BASE_PRIVATE_CAPITAL */
  CLIENT_BASE_PRIVATE_CAPITAL = 'CLIENT_BASE_PRIVATE_CAPITAL',
  /** CLIENT_BASE_VENTURE_CAPITAL */
  CLIENT_BASE_VENTURE_CAPITAL = 'CLIENT_BASE_VENTURE_CAPITAL',
  /** COUNTRY */
  COUNTRY = 'COUNTRY',
  /** DATE_OF_INCORPORATION ... */
  DATE_OF_INCORPORATION = 'DATE_OF_INCORPORATION',
  /** DBA_NAME */
  DBA_NAME = 'DBA_NAME',
  /** Optional DBA or Trade names */
  DBA_NAMES = 'DBA_NAMES',
  /** Full legal entity name */
  ENTITY_NAME = 'ENTITY_NAME',
  /** EXPLAIN_YOU_ARE_NOT_REGISTERED ... */
  EXPLAIN_YOU_ARE_NOT_REGISTERED = 'EXPLAIN_YOU_ARE_NOT_REGISTERED',
  /** FEIN ... */
  FEIN = 'FEIN',
  /** INDIVIDUAL_WEBSITE_URL ... */
  INDIVIDUAL_WEBSITE_URL = 'INDIVIDUAL_WEBSITE_URL',
  /** INVESTABLE_ASSETS */
  INVESTABLE_ASSETS = 'INVESTABLE_ASSETS',
  /** INVESTABLE_ASSETS_CRYPTO_PERCENTAGE */
  INVESTABLE_ASSETS_CRYPTO_PERCENTAGE = 'INVESTABLE_ASSETS_CRYPTO_PERCENTAGE',
  /** INVESTMENT_ADVISER_REGISTRATION ... */
  INVESTMENT_ADVISER_REGISTRATION = 'INVESTMENT_ADVISER_REGISTRATION',
  /** INVESTMENT_ADVISER_REGISTRATION_IARD ... */
  INVESTMENT_ADVISER_REGISTRATION_IARD = 'INVESTMENT_ADVISER_REGISTRATION_IARD',
  /** INVESTMENT_ADVISER_REGISTRATION_IARD_OTHER ... */
  INVESTMENT_ADVISER_REGISTRATION_IARD_OTHER = 'INVESTMENT_ADVISER_REGISTRATION_IARD_OTHER',
  /** INVESTMENT_ADVISER_REGISTRATION_PRIMARY_STATE ... */
  INVESTMENT_ADVISER_REGISTRATION_PRIMARY_STATE = 'INVESTMENT_ADVISER_REGISTRATION_PRIMARY_STATE',
  /** INVESTMENT_ADVISOR_COUNTRY ... */
  INVESTMENT_ADVISOR_COUNTRY = 'INVESTMENT_ADVISOR_COUNTRY',
  /** INVESTMENT_ADVISOR_NAME ... */
  INVESTMENT_ADVISOR_NAME = 'INVESTMENT_ADVISOR_NAME',
  /** INVESTMENT_ADVISOR_NUMBER ... */
  INVESTMENT_ADVISOR_NUMBER = 'INVESTMENT_ADVISOR_NUMBER',
  /** KYC_INSTITUTION_FORM_SUBMISSION_ID ... */
  KYC_INSTITUTION_FORM_SUBMISSION_ID = 'KYC_INSTITUTION_FORM_SUBMISSION_ID',
  /** MAILING_ADDRESS ... */
  MAILING_ADDRESS = 'MAILING_ADDRESS',
  /** MAILING_ADDRESS2 ... */
  MAILING_ADDRESS2 = 'MAILING_ADDRESS2',
  /** PHONE ... */
  PHONE = 'PHONE',
  /** PLACE_OF_INCORPORATION ... */
  PLACE_OF_INCORPORATION = 'PLACE_OF_INCORPORATION',
  /** POOLED_VEHICLE */
  POOLED_VEHICLE = 'POOLED_VEHICLE',
  /** PRIMARY_ACCOUNT_OBJECTIVE */
  PRIMARY_ACCOUNT_OBJECTIVE = 'PRIMARY_ACCOUNT_OBJECTIVE',
  /** REGISTERED_BUSINESS_NAME ... */
  REGISTERED_BUSINESS_NAME = 'REGISTERED_BUSINESS_NAME',
  /** State */
  STATE = 'STATE',
  /** STATEMENTS_PREFERENCE ... */
  STATEMENTS_PREFERENCE = 'STATEMENTS_PREFERENCE',
  /** STREET_ADDRESS */
  STREET_ADDRESS = 'STREET_ADDRESS',
  /** Zip code */
  ZIP_CODE = 'ZIP_CODE'
}

/** Properties of a client order */
export type ClientOrder = Node & {
  __typename: 'ClientOrder';
  /** Account for this order */
  account: Maybe<TradingAccount>;
  /** Average price */
  avgPx: Scalars['String']['output'];
  /** Average all-in price */
  avgPxAllIn: Scalars['String']['output'];
  /** Client Order ID */
  clOrdID: Scalars['String']['output'];
  /** Counter quantity All In including fee */
  counterQuantityAllIn: TradingAmount;
  /** Creation Time */
  createdAt: Scalars['Timestamp']['output'];
  /**
   * Cumulative buy quantity
   * @deprecated Use cumBuyTradingQty instead
   */
  cumBuyQty: Amount;
  /** Cumulative buy quantity */
  cumBuyTradingQty: TradingAmount;
  /**
   * Cumulative sell quantity
   * @deprecated Use cumSellTradingQty instead
   */
  cumSellQty: Amount;
  /** Cumulative sell quantity */
  cumSellTradingQty: TradingAmount;
  /** Cumulative trading amount percentage */
  cumTradingQty: TradingAmountPercentage;
  /** Order currency */
  currency: Scalars['String']['output'];
  /** Order id */
  id: Scalars['ID']['output'];
  /** Last Transaction time */
  lastTransactTime: Scalars['Timestamp']['output'];
  /** Remaining trading amount percentage */
  leavesTradingQty: TradingAmountPercentage;
  /** Limit price */
  limitPrice: Maybe<Scalars['String']['output']>;
  /** Market order ID */
  marketOrderID: Maybe<Scalars['String']['output']>;
  /** Order status */
  orderStatus: OrdStatus;
  /** Order type */
  orderType: OrdType;
  /** Organization for this order */
  organization: Organization;
  /** Original client order ID */
  origClOrdID: Scalars['String']['output'];
  /**
   * Order quantity
   * @deprecated Use tradingQuantity instead
   */
  quantity: Amount;
  /** Side of the order */
  side: TradeSide;
  /** Source, e.g. API, Manual, WhiteLabel */
  sourceType: TradeSource;
  /** Subaccount ID */
  subaccountID: Maybe<Scalars['String']['output']>;
  /** Submission time */
  submitTime: Scalars['Timestamp']['output'];
  /** Symbol of the order */
  symbol: Scalars['String']['output'];
  /**
   * Total fee
   * @deprecated Use totalTradingFee instead
   */
  totalFee: Amount;
  /** Total fee */
  totalTradingFee: TradingAmount;
  /** Trading entity stamped on the order */
  tradingEntity: Maybe<Scalars['String']['output']>;
  /** Order quantity */
  tradingQuantity: TradingAmount;
};

/** A connection to a list of items. */
export type ClientOrderConnection = {
  __typename: 'ClientOrderConnection';
  /** A list of edges. */
  edges: Maybe<Array<ClientOrderEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClientOrderEdge = {
  __typename: 'ClientOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ClientOrder>;
};

/** Ordering options for ClientOrder connections */
export type ClientOrderOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ClientOrders. */
  field: ClientOrderOrderField;
};

/** Properties by which ClientOrder connections can be ordered. */
export enum ClientOrderOrderField {
  /** order by avg_px */
  AVG_PX = 'AVG_PX',
  /** order by avg_px_all_in */
  AVG_PX_ALL_IN = 'AVG_PX_ALL_IN',
  /** order by created_at */
  CREATED_AT = 'CREATED_AT',
  /** order by CUM_QTY */
  CUM_QTY = 'CUM_QTY',
  /** order by fee_currency */
  FEE_CURRENCY = 'FEE_CURRENCY',
  /** order by last_transact_time */
  LAST_TRANSACT_TIME = 'LAST_TRANSACT_TIME',
  /** order by leaves_qty */
  LEAVES_QTY = 'LEAVES_QTY',
  /** order by limit_price */
  LIMIT_PRICE = 'LIMIT_PRICE',
  /** order by market order id */
  MARKET_ORDER_ID = 'MARKET_ORDER_ID',
  /** order by ORDER_ID */
  ORDER_ID = 'ORDER_ID',
  /** order by order quantity asset (currency) */
  ORDER_QUANTITY_ASSET = 'ORDER_QUANTITY_ASSET',
  /** order by order_type */
  ORDER_TYPE = 'ORDER_TYPE',
  /** order by QUANTITY */
  QUANTITY = 'QUANTITY',
  /** order by side */
  SIDE = 'SIDE',
  /** order by status */
  STATUS = 'STATUS',
  /** order by submit_time */
  SUBMIT_TIME = 'SUBMIT_TIME',
  /** order by symbol */
  SYMBOL = 'SYMBOL',
  /** order by total_trading_fee */
  TOTAL_FEE = 'TOTAL_FEE',
  /** order by trade_source */
  TRADE_SOURCE = 'TRADE_SOURCE'
}

/** ClientOrderWhereInput is used for filtering ClientOrder objects. */
export type ClientOrderWhereInput = {
  /** account_id field predicates */
  accountID?: InputMaybe<Scalars['String']['input']>;
  /** account_name field predicates for partial or full matching */
  accountNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** avg_px_all_in field predicates */
  avgPxAllInFilter?: InputMaybe<NumericFilterInput>;
  /** avg_px field predicates */
  avgPxFilter?: InputMaybe<NumericFilterInput>;
  /** cum quantity field predicates */
  cumQtyFilter?: InputMaybe<NumericFilterInput>;
  /**
   * entities field predicates
   * @deprecated use tradingEntityIn; removed once the backoffice has moved (BRO-9646)
   */
  entityIn?: InputMaybe<Array<AnchorageEntityType>>;
  /** feeCurrency field predicates */
  feeCurrency?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** List of IDs to filter */
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Last transact time greater than */
  lastTransactTimeGT?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Last transact time less than */
  lastTransactTimeLT?: InputMaybe<Scalars['Timestamp']['input']>;
  /** leavesQtyFilter field with greater or equal than and less than */
  leavesQtyFilter?: InputMaybe<NumericFilterInput>;
  /** limit price field predicates */
  limitPriceFilter?: InputMaybe<NumericFilterInput>;
  /** List of Market Order IDs to filter */
  marketOrderIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** order quantity asset (currency) field predicates */
  orderQuantityAssetIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** order_status field predicates */
  orderStatusIn?: InputMaybe<Array<OrdStatus>>;
  /** order type field predicates */
  orderTypeIn?: InputMaybe<Array<OrdType>>;
  /** org_key_id field predicates */
  orgKeyID?: InputMaybe<Scalars['String']['input']>;
  /** quantity field predicates */
  quantityFilter?: InputMaybe<NumericFilterInput>;
  /** side field predicates */
  sideIn?: InputMaybe<Array<TradeSide>>;
  /** subaccount_id field predicates */
  subaccountID?: InputMaybe<Scalars['String']['input']>;
  /** Matches orders submitted */
  submitTimeFilter?: InputMaybe<TimestampFilterInput>;
  /** symbol field predicates */
  symbolIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** total fee field with greater and less than */
  totalFeeFilter?: InputMaybe<NumericFilterInput>;
  /** tradeSource field predicates */
  tradeSource?: InputMaybe<Array<TradeSource>>;
  /** trading entity predicates. Cannot be combined with entityIn. */
  tradingEntityIn?: InputMaybe<Array<TradingEntity>>;
};

/** ClientPaymentFlow is a payment flow */
export type ClientPaymentFlow = Node & {
  __typename: 'ClientPaymentFlow';
  /** Timestamp of creation of the payment flow */
  createdAt: Scalars['Timestamp']['output'];
  /** Funding readiness of this individual payment */
  fundingStatus: Maybe<ClientPaymentFundingStatus>;
  /** Id of the payment flow */
  id: Scalars['ID']['output'];
  /** Market Order linked to order associated with this payment */
  marketOrderID: Maybe<Scalars['String']['output']>;
  /** Order id of the payment flow */
  orderID: Scalars['String']['output'];
  /** Organization of the payment flow */
  organization: Scalars['String']['output'];
  /** Settlement ID of the payment flow */
  settlementID: Maybe<Scalars['String']['output']>;
  /** Payment status */
  status: ClientPaymentFlowStatus;
  tradingAmount: TradingAmount;
};

/** Client Payment flow connection for pagination */
export type ClientPaymentFlowConnection = {
  __typename: 'ClientPaymentFlowConnection';
  /** List of edges containing payment flow and cursor information */
  edges: Array<ClientPaymentFlowEdge>;
  /** Page details for the associated list of payment flow edges */
  pageInfo: PageInfo;
};

/** Payment flow edge for pagination */
export type ClientPaymentFlowEdge = {
  __typename: 'ClientPaymentFlowEdge';
  /** Cursor for the associated dealer trades */
  cursor: Scalars['String']['output'];
  /** Client Paymentflows */
  node: ClientPaymentFlow;
};

/** Filter for query client payment flow */
export type ClientPaymentFlowFilters = {
  /** Filter by assetType */
  filterAssetTypeID?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  /** Filter time after createdAt */
  filterCreatedAtAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Filter time before createdAt */
  filterCreatedAtBefore?: InputMaybe<Scalars['Timestamp']['input']>;
  /**
   * Filter by Anchorage's entity identifier
   * @deprecated use filterTradingEntities; removed once the backoffice has moved (BRO-9646)
   */
  filterEntities?: InputMaybe<Array<AnchorageEntityType>>;
  /** Filter by payment funding readiness. */
  filterFundingStatus?: InputMaybe<Array<ClientPaymentFundingStatus>>;
  /** Filter by Anchorage's internal identifier of a payment flow */
  filterID?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by Anchorage's order identifier */
  filterOrderID?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization */
  filterOrganizationKeyID?: InputMaybe<Scalars['String']['input']>;
  /** Filter by settlement ID */
  filterSettlementID?: InputMaybe<Scalars['String']['input']>;
  /** Filter by settlment status */
  filterStatus?: InputMaybe<Array<ClientPaymentFlowStatus>>;
  /** Filter by trading entity. Cannot be combined with filterEntities. */
  filterTradingEntities?: InputMaybe<Array<TradingEntity>>;
};

/** ClientPaymentFlowStatus is the statuses of a payment */
export enum ClientPaymentFlowStatus {
  /** Settlement has been created for this payment */
  INITIATED = 'INITIATED',
  /** Settlement is in progress (settling) */
  IN_PROGRESS = 'IN_PROGRESS',
  /** No settlement has been created for this payment */
  PENDING = 'PENDING',
  /** Settlement has been settled */
  SETTLED = 'SETTLED'
}

/** ClientPaymentFundingStatus describes the funding readiness of a single client payment */
export enum ClientPaymentFundingStatus {
  /** Anchorage pays client but not all dealer payments are settled yet */
  PAYABLE_NOT_READY = 'PAYABLE_NOT_READY',
  /** Anchorage pays client and all dealer payments are settled */
  PAYABLE_READY = 'PAYABLE_READY',
  /** Anchorage receives from client (negative quantity) — always ready */
  RECEIVABLE = 'RECEIVABLE'
}

/** Client settlement */
export type ClientSettlement = Node & {
  __typename: 'ClientSettlement';
  /** Assignee of the settlement */
  assignee: Maybe<Scalars['String']['output']>;
  /** Timestamp for settlement creation */
  createdAt: Scalars['Timestamp']['output'];
  /** Aggregate funding readiness of the settlement's underlying payments. */
  fundingStatus: Maybe<BalanceFundingStatus>;
  /** ID of the settlement */
  id: Scalars['ID']['output'];
  /** Organization for this settlement */
  organization: Maybe<Organization>;
  /** payment count */
  paymentCount: Scalars['Int']['output'];
  /** Reason for failure or cancellation */
  reason: Maybe<Scalars['String']['output']>;
  /** Settlement status */
  status: ClientSettlementStatus;
  tradingAmount: TradingAmount;
  /** TransactionID is the manually entered transaction id for fiat or transferID for crypto */
  transactionID: Maybe<Scalars['String']['output']>;
  /** Type of the settlement */
  type: Maybe<ClientSettlementType>;
  /** UpdatedAt is when the settlement is last updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** Client settlement edge */
export type ClientSettlementEdge = {
  __typename: 'ClientSettlementEdge';
  /** Cursor for the associated client settlement */
  cursor: Scalars['String']['output'];
  /** Client settlement */
  node: ClientSettlement;
};

/** Filters for client settlements */
export type ClientSettlementFilters = {
  /** Filter time after createdAt */
  filterCreatedAtAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Filter time before createdAt */
  filterCreatedAtBefore?: InputMaybe<Scalars['Timestamp']['input']>;
  /**
   * Filter by Anchorage entity
   * @deprecated use filterTradingEntities; removed once the backoffice has moved (BRO-9646)
   */
  filterEntities?: InputMaybe<Array<AnchorageEntityType>>;
  /** Filter by aggregate funding readiness. */
  filterFundingStatus?: InputMaybe<Array<BalanceFundingStatus>>;
  /** Filter by settlement ID */
  filterID?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by organization */
  filterOrganizationKeyID?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Organization name */
  filterOrganizationName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by settlment status */
  filterStatus?: InputMaybe<Array<ClientSettlementStatus>>;
  /** Filter by trading entity. Cannot be combined with filterEntities. */
  filterTradingEntities?: InputMaybe<Array<TradingEntity>>;
};

/** ClientSettlementStatus is the statuses of a settlement */
export enum ClientSettlementStatus {
  /** Settlement has been assigned */
  ASSIGNED = 'ASSIGNED',
  /** Settlement has been canceled */
  CANCELED = 'CANCELED',
  /** Settlement has failed */
  FAILED = 'FAILED',
  /** Settlement has been created */
  PENDING = 'PENDING',
  /** Settlement is in progress (settling) */
  PROCESSING = 'PROCESSING',
  /** Settlement has been settled */
  SETTLED = 'SETTLED'
}

/**
 * ClientSettlementTransferCheck reports the source wallet's available balance and
 * the estimated network fee for a settlement's transfer. Informational only: the
 * settlement flow does not depend on it.
 */
export type ClientSettlementTransferCheck = {
  __typename: 'ClientSettlementTransferCheck';
  /** Source wallet available balance for the transfer asset */
  availableBalance: TradingAmount;
  /**
   * Estimated network fee (asset registry fee threshold) in the fee asset; null
   * when the asset has no fee threshold configured
   */
  estimatedFee: Maybe<TradingAmount>;
  /**
   * Source wallet balance of the fee asset; null when the fee asset is the
   * transfer asset itself
   */
  feeAssetBalance: Maybe<TradingAmount>;
  /** True when the balances cover the transfer amount plus the estimated fee */
  sufficient: Scalars['Boolean']['output'];
  /** Absolute quantity the settlement transfer would move */
  transferAmount: TradingAmount;
};

/** ClientSettlementType is the type of a settlement */
export enum ClientSettlementType {
  /** Advisory fee settlement */
  ADVISORY_FEE = 'ADVISORY_FEE',
  /** Custody fee settlement */
  CUSTODY_FEE = 'CUSTODY_FEE',
  /** Management fee settlement */
  MANAGEMENT_FEE = 'MANAGEMENT_FEE',
  /** Model fee settlement */
  MODEL_FEE = 'MODEL_FEE',
  /** Segregated wallets fee settlement */
  SEGREGATED_WALLETS_FEE = 'SEGREGATED_WALLETS_FEE',
  /** Trade settlement */
  TRADE = 'TRADE'
}

/** Client settlements connection */
export type ClientSettlementsConnection = {
  __typename: 'ClientSettlementsConnection';
  /** List of edges containing client settlements */
  edges: Array<ClientSettlementEdge>;
  /** Page details for the associated list of payment flow edges */
  pageInfo: PageInfo;
};

/** Statuses that an institutional client can go through */
export enum ClientStatus {
  /** The client has been onboarded */
  COMPLETE = 'COMPLETE',
  /** The client is in draft mode */
  DRAFT = 'DRAFT',
  /** Information is being populated. Check the individual form statuses */
  IN_PROGRESS = 'IN_PROGRESS',
  /** The client is ready for onboarding */
  READY = 'READY'
}

export type CloseAccountInput = {
  accountId: Scalars['ID']['input'];
  /** Skip the empty-account check. Defaults to false. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CloseSubaccountInput = {
  subaccountId: Scalars['ID']['input'];
};

export type CloseSubaccountResult = {
  __typename: 'CloseSubaccountResult';
  /** False when Ledger held no record, or the subaccount was already closed there. */
  ledgerClosed: Scalars['Boolean']['output'];
  subaccountId: Scalars['ID']['output'];
  /**
   * Non-fatal anomalies, notably a PROGRAM_CUSTOMER subaccount that Ledger knows
   * about but WOS does not.
   */
  warnings: Array<Scalars['String']['output']>;
  /** False when WOS held no record, or the subaccount was already closed there. */
  wosClosed: Scalars['Boolean']['output'];
};

/** ClosureMetadata holds metadata associated with an affiliate closure */
export type ClosureMetadata = {
  __typename: 'ClosureMetadata';
  /** Date the BSA officer recommended closure */
  bsaRecommendedDate: Maybe<Scalars['Date']['output']>;
  /** Date the affiliate was closed */
  closureDate: Scalars['Date']['output'];
  /** Indicates which team closed out the account */
  initiatedBy: Scalars['String']['output'];
  /** Risk Dashboard user who marked the account as closed */
  markedClosedBy: Scalars['String']['output'];
  /** Date of MSA termination */
  msaTerminationDate: Maybe<Scalars['Date']['output']>;
  /** Reason for closure */
  reason: Scalars['String']['output'];
};

export type CmAcceleratedMarginCallConfig = {
  __typename: 'CmAcceleratedMarginCallConfig';
  action: Scalars['String']['output'];
  curePeriod: Scalars['String']['output'];
  ltv: Scalars['String']['output'];
};

/**
 * Which feed served a price: the package/exposure's configured primary, or the service-wide
 * backup. Derived in the GQL layer, not persisted.
 */
export enum CmActiveFeedTier {
  /** Primary feed. */
  PRIMARY = 'PRIMARY',
  /** Backup feed. */
  SECONDARY = 'SECONDARY'
}

/** Alert for a collateral management package */
export type CmAlert = {
  __typename: 'CmAlert';
  /** Type of alert */
  alertType: cmAlertType;
  /** Atlas ID of the participant */
  atlasID: Scalars['ID']['output'];
  /** Name of the counterparty */
  counterpartyName: Scalars['String']['output'];
  /** Unique identifier for the alert */
  id: Scalars['ID']['output'];
  /** Collateral package (loan) ID */
  loanId: Scalars['ID']['output'];
  /** Loan-to-value ratio at time of alert */
  ltv: Scalars['String']['output'];
  /**
   * Settlement ID associated with the alert. Populated for
   * MARGIN_RETURN_REQUESTED alerts and may be null for other alert types.
   */
  settlementID: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the alert was created */
  timestamp: Scalars['Time']['output'];
};

/** An edge in a CM alerts connection */
export type CmAlertEdge = {
  __typename: 'CmAlertEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The alert at the end of the edge */
  node: CmAlert;
};

/** A connection to a list of CM alerts */
export type CmAlertsConnection = {
  __typename: 'CmAlertsConnection';
  edges: Array<CmAlertEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Input for amount with asset type and value. */
export type CmAssetAmountInput = {
  /** The asset type id for this amount */
  assetTypeID: Scalars['AssetTypeID']['input'];
  /**
   * The SP-picked source wallet this leg is sent from. Only meaningful for
   * mutations where the caller supplies the sending wallet (e.g. exposure
   * increase); ignored by mutations that derive wallets from package config
   * (e.g. margin return).
   */
  sourceWalletID?: InputMaybe<Scalars['ID']['input']>;
  /** The value for this amount */
  value: Scalars['String']['input'];
};

export type CmAssetBalanceResponse = {
  __typename: 'CmAssetBalanceResponse';
  balances: Array<CmBalance>;
};

export enum CmAssetBalanceType {
  /** Assets held as collateral */
  COLLATERAL = 'COLLATERAL',
  /** Loaned Assets */
  EXPOSURE = 'EXPOSURE'
}

export type CmAssetConfigResponse = {
  __typename: 'CmAssetConfigResponse';
  assetTypeID: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Input for an asset type identifier. Wrapping enables future extension (e.g. price source, strategy) without a breaking schema change. */
export type CmAssetInput = {
  /** The asset type ID (e.g. "USD", "BTC"). */
  assetTypeID: Scalars['AssetTypeID']['input'];
};

export type CmAssetTrackingConfigResponse = {
  __typename: 'CmAssetTrackingConfigResponse';
  asset: CmAssetConfigResponse;
  /** The backup price feed configured on the asset. Null when it inherits the service default. */
  backupPriceFeed: Maybe<CmPriceFeedResponse>;
  /**
   * The backup price feed the LTV monitor fails over to: the configured one, else the service default.
   * Null when there is none or when it reads the same source and provider as the primary feed.
   */
  effectiveBackupPriceFeed: Maybe<CmPriceFeedResponse>;
  liquidationPriority: Scalars['Int']['output'];
  maxStalenessMinutes: Maybe<Scalars['Int']['output']>;
  notes: Scalars['String']['output'];
  pledgorWalletId: Maybe<Scalars['String']['output']>;
  priceSource: Scalars['String']['output'];
  priceSourceProvider: Scalars['String']['output'];
  /** The pricing strategy of the asset's primary price feed. */
  pricingStrategy: CmPriceStrategies;
  walletId: Maybe<Scalars['String']['output']>;
  weight: Scalars['String']['output'];
};

/** Response for cmAssetsWithPricing and cmAllAssetsWithPricing */
export type CmAssetsWithPricingResponse = {
  __typename: 'CmAssetsWithPricingResponse';
  /**
   * Asset IDs that have USD pricing: for the requested provider/price source
   * when returned from cmAssetsWithPricing, or across every cached
   * provider/price source combination when returned from
   * cmAllAssetsWithPricing. Mainnet IDs in production; regnet/testnet IDs in
   * lower environments.
   */
  assetTypeIDs: Array<Scalars['AssetTypeID']['output']>;
};

export type CmAutoDeleveragingConfig = {
  __typename: 'CmAutoDeleveragingConfig';
  levels: Array<CmDeleveragingLevelResponse>;
};

/** How long a package can run on its backup price feed before operations want to know. */
export type CmBackupFeedToleranceSettings = {
  __typename: 'CmBackupFeedToleranceSettings';
  /** Tolerance, in minutes. Greater than 0. */
  toleranceMinutes: Scalars['Int']['output'];
};

export type CmBalance = {
  __typename: 'CmBalance';
  amount: Amount;
};

/** One row of a liquidation leg's bid depth grid. */
export type CmBidDepthRow = {
  __typename: 'CmBidDepthRow';
  /**
   * Cumulative bid notional within threshold of mid from the cached MarketDataSnapshot, as a decimal
   * string, also when that snapshot is stale. Null when no snapshot is cached or the snapshot has no
   * depth at this threshold.
   */
  depth: Maybe<Scalars['String']['output']>;
  /**
   * The leg's share of the liquidation value divided by depth, as a decimal string. Null when the
   * leg's share is unknown, or depth is null or zero.
   */
  orderVsDepth: Maybe<Scalars['String']['output']>;
  /**
   * Distance below mid the depth is measured to, as a fraction in a decimal string, for example
   * "0.01" for 1%.
   */
  threshold: Scalars['String']['output'];
};

/** The live custody balance of one collateral asset's configured wallet. */
export type CmCollateralWalletBalance = {
  __typename: 'CmCollateralWalletBalance';
  /** Asset type ID (e.g. "BTC"). */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /**
   * Custody's COMPLETE balance of the wallet for this asset, as a decimal string.
   * Null when custody returned no balance for the wallet.
   */
  custodyBalance: Maybe<Scalars['String']['output']>;
  /** Unique ID of the collateral wallet configured for the asset. */
  walletId: Scalars['String']['output'];
};

/**
 * Input for creating one or more exposures. Mirrors the gRPC CreateExposure path,
 * which accepts a batch so the service can validate that all exposures in a
 * package share a single price source.
 */
export type CmCreateExposuresInput = {
  exposures: Array<CmExposureInput>;
};

/**
 * Input for creating a loan / collateral package. Mirrors the fields the gRPC
 * CreatePackage path accepts.
 */
export type CmCreateLoanInput = {
  /** Accelerated margin call config */
  acceleratedMarginCall?: InputMaybe<AcceleratedMarginCall>;
  /** Assets tracked by the package */
  assetTracking: Array<AssetTrackingCreateInput>;
  /** Auto deleveraging config */
  autoDeleveraging?: InputMaybe<AutoDeleveraging>;
  /** Atlas participant ID of the collateral org. Used in 3-party packages. */
  collateralOrgAtlasID?: InputMaybe<Scalars['ID']['input']>;
  /** Critical config */
  critical?: InputMaybe<Critical>;
  /** Which party pays the fees */
  feePayingParty?: InputMaybe<Array<CmParticipantRole>>;
  /**
   * Client-generated key, reused on retries so a repeated submit returns the existing package.
   * Scoped server-side to the secured party, pledgor and collateral org.
   */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Internal name for the loan; generated if omitted */
  internalName?: InputMaybe<Scalars['String']['input']>;
  /** LTV rounding precision */
  ltvRoundingPrecision?: InputMaybe<Scalars['Int']['input']>;
  /** Margin call config */
  marginCall?: InputMaybe<MarginCall>;
  /** Margin return config */
  marginReturn?: InputMaybe<MarginReturn>;
  /** Atlas participant ID of the pledgor (borrower) */
  pledgorId: Scalars['ID']['input'];
  /** Client-facing reference ID */
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Atlas participant ID of the secured party (lender) */
  securedPartyId: Scalars['ID']['input'];
  /** Vault sub ID */
  vaultSubID?: InputMaybe<Scalars['String']['input']>;
  /** Vault unique ID */
  vaultUniqueID?: InputMaybe<Scalars['String']['input']>;
};

/** A single CM operation to create as part of a cmCreateOperation batch. */
export type CmCreateOperationInput = {
  /** The operation action (e.g. INITIAL_FUNDING, PAY_UP) */
  action: CmOperationAction;
  /** Asset descriptor for this operation */
  asset: AssetConfig;
  /** Idempotency key — a unique string generated by the caller to deduplicate retries */
  idempotencyKey: Scalars['String']['input'];
  /** Optional free-text notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Decimal quantity string */
  quantity: Scalars['String']['input'];
  /** Whether this targets an Exposure or a CollateralPackage */
  type: CmOperationType;
  /**
   * The ID of the target entity. For EXPOSURE and LIQUIDATION operations this is
   * an Exposure ID; for COLLATERAL_PACKAGE operations this is a CollateralPackage ID.
   */
  typeID: Scalars['ID']['input'];
};

/**
 * Response from creating one or more CM operations. `operationIds` is ordered to
 * match the `operations` input array, so callers can correlate results by index.
 */
export type CmCreateOperationResponse = {
  __typename: 'CmCreateOperationResponse';
  operationIds: Array<Scalars['ID']['output']>;
};

/**
 * Input for creating a collateral management participant. Mirrors the fields the
 * gRPC CreateParticipant path accepts.
 */
export type CmCreateParticipantInput = {
  /** Atlas (settlement network) participant ID this participant links to */
  atlasParticipantID: Scalars['ID']['input'];
  /** Collateral management participant IDs (not Atlas participant IDs) authorized as collateral counterparties */
  authorizedCounterpartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Email addresses that receive each kind of notification */
  email: CmParticipantEmailInput;
  /** ID of an existing maintenance fee aggregation */
  feeAggregationID?: InputMaybe<Scalars['ID']['input']>;
  /** Internal name of the participant */
  internalName: Scalars['String']['input'];
  /** Free-form notes; empty if omitted */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Utilization ratios of the Talos credit limit at which the credit line check warns, then stops. */
export type CmCreditLineCheckInput = {
  /** Utilization ratio at which the check stops, as a decimal string greater than warnUtilization and at most 1. */
  stopUtilization: Scalars['String']['input'];
  /** Utilization ratio at which the check warns, as a decimal string greater than 0. */
  warnUtilization: Scalars['String']['input'];
};

/** Utilization ratios of the Talos credit limit at which the credit line check warns, then stops. */
export type CmCreditLineCheckSettings = {
  __typename: 'CmCreditLineCheckSettings';
  /** Utilization ratio at which the check stops, as a decimal string greater than warnUtilization and at most 1. */
  stopUtilization: Scalars['String']['output'];
  /** Utilization ratio at which the check warns, as a decimal string greater than 0. */
  warnUtilization: Scalars['String']['output'];
};

export type CmCriticalConfig = {
  __typename: 'CmCriticalConfig';
  action: Scalars['String']['output'];
  defaultNotice: Scalars['String']['output'];
  ltv: Scalars['String']['output'];
  returnToLtv: Scalars['String']['output'];
  warningLtv: Scalars['String']['output'];
};

export type CmDailyTimeWindow = {
  __typename: 'CmDailyTimeWindow';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type CmDeleveragingLevelResponse = {
  __typename: 'CmDeleveragingLevelResponse';
  liquidationPercentage: Scalars['String']['output'];
  price: Scalars['String']['output'];
};

/**
 * An exposure on a collateral package. Returned as part of CmPackagesResponse
 * so the client can render an exposure picker (e.g. for SP-initiated manual
 * exposure increases) and submit cmCreateOperation against the right rows.
 */
export type CmExposure = {
  __typename: 'CmExposure';
  /** Asset type ID for this exposure (e.g. "BTC", "USD"). */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /**
   * Underlying exposure ID. Pass as an entry's typeID to cmCreateOperation when
   * booking an exposure-increase operation against this row.
   */
  id: Scalars['ID']['output'];
};

/** Updatable fields of an exposure's asset tracking config. */
export type CmExposureAssetConfigUpdateInput = {
  /**
   * Required when updating exposureAssetConfig: the asset config is rebuilt
   * wholesale from this asset, and UpdateExposure always validates it.
   */
  asset: AssetConfig;
  /** Replaces the asset's backup price feed. Omit to leave it unchanged. */
  backupPriceFeed?: InputMaybe<CmPriceFeedInput>;
  /** Clears the asset's backup price feed so it inherits the service default. Cannot be combined with backupPriceFeed. */
  clearBackupPriceFeed?: InputMaybe<Scalars['Boolean']['input']>;
  disbursementWalletId?: InputMaybe<Scalars['String']['input']>;
  liquidationPriority?: InputMaybe<Scalars['Int']['input']>;
  maxStalenessMinutes?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  priceSource?: InputMaybe<PriceSource>;
  priceSourceProvider?: InputMaybe<Scalars['String']['input']>;
};

/** The asset config of one exposure on a package, for staff callers. */
export type CmExposureConfig = {
  __typename: 'CmExposureConfig';
  assetTypeID: Scalars['String']['output'];
  /** The backup price feed configured on the exposure. Null when it inherits the service default. */
  backupPriceFeed: Maybe<CmPriceFeedResponse>;
  /**
   * The backup price feed the LTV monitor fails over to: the configured one, else the service default.
   * Null when there is none or when it reads the same source and provider as the primary feed.
   */
  effectiveBackupPriceFeed: Maybe<CmPriceFeedResponse>;
  id: Scalars['ID']['output'];
};

/**
 * Per-asset ceilings for a pay up, each bringing the package's LTV to targetLtv when paid up on
 * its own. Response of cmExposureIncreaseMaxAmounts.
 */
export type CmExposureIncreaseMaxAmountsResponse = {
  __typename: 'CmExposureIncreaseMaxAmountsResponse';
  /**
   * Max quantity per exposure asset priced in the LTV snapshot, truncated to the asset's
   * precision. Only positive amounts are listed, sorted by asset type ID.
   */
  amounts: Array<CmBalance>;
  /**
   * USD exposure that can be added before the package sits at targetLtv (decimal string). Zero or
   * negative means nothing can be paid up. Zero when targetLtv is null.
   */
  headroomUSD: Scalars['String']['output'];
  /**
   * The LTV the amounts bring the package to (decimal string): thresholdLtv minus 0.01. Null
   * whenever thresholdLtv is null.
   */
  targetLtv: Maybe<Scalars['String']['output']>;
  /**
   * The package's danger threshold (decimal string): the Margin Call LTV, else the Critical LTV.
   * Null when the package configures neither, when the threshold is at or below 0.01, or when
   * targetLtv, rounded at the package's LTV precision, is not below the threshold.
   */
  thresholdLtv: Maybe<Scalars['String']['output']>;
};

/** A single exposure to create under an existing collateral package. */
export type CmExposureInput = {
  /** Asset tracked by the exposure */
  assetTracking: AssetTrackingCreateInput;
  /** ID of the existing collateral package this exposure belongs to */
  collateralPackageId: Scalars['ID']['input'];
  /** Internal name for the exposure; generated if omitted */
  internalName?: InputMaybe<Scalars['String']['input']>;
  /** Pricing strategy for the exposure */
  pricingStrategy: CmPriceStrategies;
  /** Client-facing reference ID */
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Exposure type — free-text today (e.g. "Loan") */
  type: Scalars['String']['input'];
};

export type CmLTVTimeSeriesPoint = {
  __typename: 'CmLTVTimeSeriesPoint';
  /** Calculated LTV value */
  ltv: Scalars['Float']['output'];
  /** Time of the calculated ltv */
  timestamp: Scalars['String']['output'];
};

/**
 * The latest calculated LTV snapshot for a collateral package, plus the
 * collateral and exposure valuations it was computed from. Returned by cmLatestLtvs.
 */
export type CmLatestLtv = {
  __typename: 'CmLatestLtv';
  /** The collateral package this snapshot belongs to. */
  collateralPackageID: Scalars['ID']['output'];
  /** Per-asset valuation of the collateral in the package, sorted by asset type ID. */
  collateralValues: Array<CmLtvCollateralAssetValue>;
  /** When this snapshot was calculated by the LTV monitor. */
  createdAt: Scalars['Time']['output'];
  /** Per-asset valuation of the exposures on the package, sorted by asset type ID. */
  exposureValues: Array<CmLtvExposureAssetValue>;
  /** The loan-to-value ratio (decimal string for precision). */
  ltv: Scalars['String']['output'];
};

/** One cached Talos currency-conversion price. */
export type CmLiquidationCacheCurrencyConversion = {
  __typename: 'CmLiquidationCacheCurrencyConversion';
  /** Upper-case mainnet symbol as the cache keys it (e.g. "BTC"). */
  asset: Scalars['String']['output'];
  /** USD price as a decimal string. */
  price: Scalars['String']['output'];
  /** Provider event timestamp on the message. */
  timestamp: Scalars['Time']['output'];
};

/** One cached MarketDataSnapshot price. */
export type CmLiquidationCacheMarketDataSnapshotPrice = {
  __typename: 'CmLiquidationCacheMarketDataSnapshotPrice';
  /** Upper-case mainnet symbol as the cache keys it (e.g. "BTC"). */
  asset: Scalars['String']['output'];
  /**
   * Cumulative bid notional within 0.5% of mid, as a decimal string. A lower bound:
   * the whole visible book when the ladder ends above the cutoff. Null when either
   * side of the book was empty.
   */
  depthHalfPercent: Maybe<Scalars['String']['output']>;
  /**
   * Cumulative bid notional within 1% of mid, as a decimal string. A lower bound:
   * the whole visible book when the ladder ends above the cutoff. Null when either
   * side of the book was empty.
   */
  depthOnePercent: Maybe<Scalars['String']['output']>;
  /**
   * Cumulative bid notional within 0.25% of mid, as a decimal string. A lower bound:
   * the whole visible book when the ladder ends above the cutoff. Null when either
   * side of the book was empty.
   */
  depthQuarterPercent: Maybe<Scalars['String']['output']>;
  /**
   * Cumulative bid notional within 2% of mid, as a decimal string. A lower bound:
   * the whole visible book when the ladder ends above the cutoff. Null when either
   * side of the book was empty.
   */
  depthTwoPercent: Maybe<Scalars['String']['output']>;
  /**
   * Cached price, as a decimal string. Currently always the bid price — the
   * only price type this cache stores today.
   */
  price: Scalars['String']['output'];
  /** Event timestamp on the cached message. */
  timestamp: Scalars['Time']['output'];
};

/** Fee charged on a liquidation. */
export type CmLiquidationFeeSettings = {
  __typename: 'CmLiquidationFeeSettings';
  /** Liquidation fee, as a decimal string between 0 and 1. */
  fee: Scalars['String']['output'];
};

/** One collateral asset's share of a liquidation, priced from its cached Talos MarketDataSnapshot. */
export type CmLiquidationLeg = {
  __typename: 'CmLiquidationLeg';
  /** Collateral asset to sell. */
  asset: Scalars['AssetTypeID']['output'];
  /**
   * Best bid from the cached MarketDataSnapshot, as a decimal string. Null when no snapshot is cached
   * or it is stale.
   */
  bid: Maybe<Scalars['String']['output']>;
  /**
   * Four rows, one per bid depth threshold in ascending order: 0.25%, 0.5%, 1% and 2%. Always four
   * rows; a cell is null when its input is unknown. The depths come from the cached snapshot whatever
   * its age, so a STALE leg can carry them while bid is null. Check freshness before using them.
   */
  bidDepthGrid: Array<CmBidDepthRow>;
  /**
   * Age of the leg's MarketDataSnapshot against the global MARKET_DATA_SNAPSHOT_FRESHNESS
   * thresholds. STALE when no snapshot is cached.
   */
  freshness: CmMarketDataSnapshotFreshness;
  /**
   * Whether the leg's share of the liquidation value is at most the cached bid depth within 1% of
   * mid. Null when the leg's share is unknown or the 1% depth is null. Set on a STALE leg when its
   * cached snapshot has a 1% depth, so check freshness before using it.
   */
  isWithinOnePercentDepth: Maybe<Scalars['Boolean']['output']>;
  /**
   * quantity times the Talos CurrencyConversion USD price of asset times (1 + slippage), as a decimal
   * string. Null when any of the three is unknown.
   */
  notional: Maybe<Scalars['String']['output']>;
  /** Quantity of asset to sell, as a decimal string. Null when the leg's share or bid is unknown. */
  quantity: Maybe<Scalars['String']['output']>;
  /** Asset the leg sells into. Null unless the package has exactly one exposure asset. */
  quoteAsset: Maybe<Scalars['AssetTypeID']['output']>;
  /**
   * Slippage buffer for asset from the SLIPPAGE settings, as a fraction in a decimal string. Null
   * when no slippage row applies.
   */
  slippage: Maybe<Scalars['String']['output']>;
  /** Talos event time of the snapshot bid was read from. Null when bid is null. */
  snapshotAt: Maybe<Scalars['Time']['output']>;
};

/** Liquidation obligation for a collateral package, as stored. */
export type CmLiquidationObligation = {
  __typename: 'CmLiquidationObligation';
  /**
   * Action being taken to remediate the liquidation, derived from the collateral package's
   * configured critical-state action
   */
  action: Action;
  /** Asset type IDs tracked by the collateral package being liquidated */
  assets: Array<Scalars['AssetTypeID']['output']>;
  /** Reference to the collateral package being liquidated */
  collateralPackageID: Scalars['ID']['output'];
  /** Timestamp when the liquidation obligation was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the liquidation obligation */
  id: Scalars['ID']['output'];
  /**
   * Talos orders linked to the obligation, grouped by collateral asset in stored order and in link
   * order within an asset. Empty when none is linked.
   */
  orders: Array<CmLiquidationOrder>;
  /**
   * The target loan-to-value ratio this obligation aims to return the package to, as a
   * decimal string.
   */
  returnToLtv: Scalars['String']['output'];
  /** Current status of the liquidation */
  status: CmLiquidationStatus;
  /** Type of liquidation: partial or full */
  type: CmLiquidationType;
};

/** An edge in a liquidation obligations connection */
export type CmLiquidationObligationEdge = {
  __typename: 'CmLiquidationObligationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The liquidation obligation at the end of the edge */
  node: CmLiquidationObligation;
};

/** A connection to a list of liquidation obligations */
export type CmLiquidationObligationsConnection = {
  __typename: 'CmLiquidationObligationsConnection';
  /** The liquidation obligations on this page */
  edges: Array<CmLiquidationObligationEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** A Talos order linked to one collateral asset of a liquidation obligation. */
export type CmLiquidationOrder = {
  __typename: 'CmLiquidationOrder';
  /** Collateral asset type ID the order sells. */
  asset: Scalars['AssetTypeID']['output'];
  /** Talos order ID, a UUID. */
  talosOrderID: Scalars['String']['output'];
};

/** Pre-execution numbers for one liquidation obligation, priced live on every read. */
export type CmLiquidationPreExecution = {
  __typename: 'CmLiquidationPreExecution';
  /**
   * Grade of the projected credit exposure against the CREDIT_LINE_CHECK warning and stop fractions
   * of the credit limit. UNKNOWN when there is no projected exposure, no positive limit or no
   * thresholds row.
   */
  creditLineCheck: CmPreflightCheckStatus;
  /**
   * USD amount by which the projected credit exposure exceeds the credit limit, as a decimal string.
   * Null unless the projected exposure is above the limit.
   */
  creditLineShortfall: Maybe<Scalars['String']['output']>;
  /**
   * The package's LTV priced live on the LTV feed at read time, as a decimal string. cmPackages.ltv
   * shows the same computation as of the LTV monitor's last run.
   */
  currentLtv: Scalars['String']['output'];
  /** One leg per funded non-fixed-USD collateral asset, sorted by asset. Empty when there is none. */
  legs: Array<CmLiquidationLeg>;
  /**
   * USD value to sell to bring the package back to the obligation's return-to LTV, priced live on the
   * LTV feed, as a decimal string. Zero when the live value is negative.
   */
  liquidationValue: Scalars['String']['output'];
  /** The obligation the numbers are for. */
  obligationID: Scalars['ID']['output'];
  /**
   * Talos program credit exposure plus liquidationValue, divided by the credit limit, as a decimal
   * string. Null when no usable credit row is cached or the limit is not positive.
   */
  projectedCreditUtilization: Maybe<Scalars['String']['output']>;
};

/** Response for cmLiquidationPriceCache query */
export type CmLiquidationPriceCacheResponse = {
  __typename: 'CmLiquidationPriceCacheResponse';
  /** Talos currency-conversion prices, sorted by asset. */
  currencyConversions: Array<CmLiquidationCacheCurrencyConversion>;
  /** MarketDataSnapshot bid prices and bid depths, sorted by asset; unfiltered by staleness. */
  marketDataSnapshotPrices: Array<CmLiquidationCacheMarketDataSnapshotPrice>;
};

/** Current status of a liquidation obligation */
export enum CmLiquidationStatus {
  /** Liquidation has been completed */
  COMPLETED = 'COMPLETED',
  /** Liquidation process has been initiated */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Liquidation obligation has been created but not yet initiated */
  PENDING = 'PENDING'
}

/** Type of liquidation being performed */
export enum CmLiquidationType {
  /** Full liquidation - liquidate all collateral */
  FULL = 'FULL',
  /** Partial liquidation - liquidate a portion of the collateral */
  PARTIAL = 'PARTIAL'
}

/** Which balances a package's LTV counts. */
export enum CmLtvBalanceMode {
  /** Counts custody balances only. */
  CUSTODY = 'CUSTODY',
  /** Also counts committed-but-unsettled margin returns. */
  LEDGER = 'LEDGER'
}

/**
 * The valuation of a single collateral asset within an LTV snapshot.
 * All numeric fields are decimal strings for precision.
 */
export type CmLtvCollateralAssetValue = {
  __typename: 'CmLtvCollateralAssetValue';
  /**
   * Which feed tier served the price, as recorded on the snapshot. Snapshots written before
   * the tier was recorded derive it by comparing priceSource/priceSourceProvider/pricingStrategy
   * against the service default backup feed. Null for fixed-price USD/USD_R or pre-provenance snapshots.
   */
  activeFeedTier: Maybe<CmActiveFeedTier>;
  /** Asset type ID (e.g. "BTC"). */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** USD price used for the valuation. */
  price: Scalars['String']['output'];
  /**
   * The price source (exchange/feed) the valuation price came from, e.g. "GDAX".
   * Raw string rather than the PriceSource enum: the value is read back from a stored
   * snapshot and can name a source that has since been removed from the enum.
   * Null on snapshots written before provenance capture (ATLAS-3202).
   */
  priceSource: Maybe<Scalars['String']['output']>;
  /**
   * The provider the price was ingested through, e.g. "AMBERDATA".
   * Null on snapshots written before provenance capture (ATLAS-3202).
   */
  priceSourceProvider: Maybe<Scalars['String']['output']>;
  /**
   * The pricing strategy used, e.g. "LAST".
   * Null on snapshots written before provenance capture (ATLAS-3202).
   */
  pricingStrategy: Maybe<Scalars['String']['output']>;
  /** Quantity of the asset held as collateral. */
  quantity: Scalars['String']['output'];
  /** Collateral weight applied to the asset (e.g. "0.9"). */
  weight: Scalars['String']['output'];
  /** price * quantity * weight, in USD. */
  weightedValue: Scalars['String']['output'];
};

/**
 * The valuation of a single exposure asset within an LTV snapshot.
 * All numeric fields are decimal strings for precision.
 */
export type CmLtvExposureAssetValue = {
  __typename: 'CmLtvExposureAssetValue';
  /**
   * Which feed tier served the price, as recorded on the snapshot. Snapshots written before
   * the tier was recorded derive it by comparing priceSource/priceSourceProvider/pricingStrategy
   * against the service default backup feed. Null for fixed-price USD/USD_R or pre-provenance snapshots.
   */
  activeFeedTier: Maybe<CmActiveFeedTier>;
  /** Asset type ID (e.g. "USD"). */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** USD price used for the valuation. */
  price: Scalars['String']['output'];
  /**
   * The price source (exchange/feed) the valuation price came from, e.g. "GDAX".
   * Raw string rather than the PriceSource enum: the value is read back from a stored
   * snapshot and can name a source that has since been removed from the enum.
   * Null on snapshots written before provenance capture (ATLAS-3202).
   */
  priceSource: Maybe<Scalars['String']['output']>;
  /**
   * The provider the price was ingested through, e.g. "AMBERDATA".
   * Null on snapshots written before provenance capture (ATLAS-3202).
   */
  priceSourceProvider: Maybe<Scalars['String']['output']>;
  /**
   * The pricing strategy used, e.g. "LAST".
   * Null on snapshots written before provenance capture (ATLAS-3202).
   */
  pricingStrategy: Maybe<Scalars['String']['output']>;
  /** Total exposed quantity of the asset across the package's exposures. */
  quantity: Scalars['String']['output'];
  /** USD value of the exposure (price * quantity). */
  value: Scalars['String']['output'];
};

/** Why an LTV simulation was invalid. */
export enum CmLtvInvalidReason {
  /**
   * The requested return amount would consume the entire collateral value,
   * leaving nothing to project an LTV against. Only possible for
   * cmValidateMarginReturn — cmSimulateLtv's basket never reduces collateral.
   */
  COLLATERAL_FULLY_CONSUMED = 'COLLATERAL_FULLY_CONSUMED',
  /**
   * The simulated LTV would meet or exceed the ceiling the simulation was judged against. For
   * cmValidateMarginReturn that is the collateral return maximum (ReturnToLTV plus 0.02) when
   * the package has one below its danger threshold; otherwise, and always for cmSimulateLtv,
   * it is the danger threshold (Margin Call LTV, or Critical LTV if no Margin Call is
   * configured).
   */
  LTV_ABOVE_DANGER_THRESHOLD = 'LTV_ABOVE_DANGER_THRESHOLD'
}

/**
 * Shared response for the LTV projection queries (cmSimulateLtv, cmValidateMarginReturn),
 * so clients can render the same LTV-preview component from either.
 */
export type CmLtvSimulationResponse = {
  __typename: 'CmLtvSimulationResponse';
  /**
   * Whether the matching mutation would reject this request. Always false when isValid is true.
   * An LTV above the ceiling blocks pledgor callers but not secured-party callers, who should be
   * warned and may still submit. For cmValidateMarginReturn staff act as the pledgor and
   * COLLATERAL_FULLY_CONSUMED blocks everyone; for cmSimulateLtv staff act as the secured party.
   */
  blocksSubmission: Scalars['Boolean']['output'];
  /** The current LTV of the collateral package before the operations are booked (decimal string for precision). */
  currentLtv: Scalars['String']['output'];
  /** Why this simulation is invalid. Null when isValid is true. */
  invalidReason: Maybe<CmLtvInvalidReason>;
  /**
   * Whether the simulated operations would be accepted. False when the simulated LTV breaches
   * the ceiling for the query (see LTV_ABOVE_DANGER_THRESHOLD), or when the collateral is fully
   * consumed — see invalidReason for which. True otherwise, including when no ceiling is
   * configured.
   */
  isValid: Scalars['Boolean']['output'];
  /**
   * The projected LTV after the operations are booked together (decimal string for precision).
   * Null when invalidReason is COLLATERAL_FULLY_CONSUMED — the value is undefined in that case.
   */
  simulatedLtv: Maybe<Scalars['String']['output']>;
  /**
   * The package state the simulated LTV would fall into.
   * Null when invalidReason is COLLATERAL_FULLY_CONSUMED.
   */
  simulatedState: Maybe<CmPackageState>;
  /**
   * The LTV ceiling the simulation was judged against (decimal string for precision). For
   * cmValidateMarginReturn this is the collateral return maximum (ReturnToLTV plus 0.02) when the
   * package has one below its danger threshold, otherwise the danger threshold; for cmSimulateLtv
   * it is always the danger threshold (MC, or Critical if no MC is configured). Null when the
   * package configures no ceiling, in which case only a return that consumes all collateral is
   * invalid.
   */
  thresholdLtv: Maybe<Scalars['String']['output']>;
};

export type CmLtvTimeSeriesResponse = {
  __typename: 'CmLtvTimeSeriesResponse';
  ltvLatestValue: Scalars['Float']['output'];
  /** Change in LTV over the selected time frame from start date to end date */
  ltvPercentChange: Scalars['String']['output'];
  /** List of points containing a timestamp and calculated ltv at that time. */
  ltvSeries: Array<CmLTVTimeSeriesPoint>;
};

export type CmMarginCallConfig = {
  __typename: 'CmMarginCallConfig';
  action: Scalars['String']['output'];
  allowedTransitionWindow: Array<CmDailyTimeWindow>;
  curePeriod: Maybe<Scalars['String']['output']>;
  curePeriodProtection: Maybe<Scalars['Boolean']['output']>;
  ltv: Scalars['String']['output'];
  returnToLtv: Scalars['String']['output'];
  topUpType: Scalars['String']['output'];
  warningLtv: Scalars['String']['output'];
};

export type CmMarginReturnConfig = {
  __typename: 'CmMarginReturnConfig';
  action: Scalars['String']['output'];
  ltv: Scalars['String']['output'];
  returnToLtv: Scalars['String']['output'];
  returnType: Scalars['String']['output'];
};

/**
 * Per-asset ceilings for a manual margin return, each bringing the package's LTV to targetLtv
 * when returned on its own. Response of cmMarginReturnMaxAmounts.
 */
export type CmMarginReturnMaxAmountsResponse = {
  __typename: 'CmMarginReturnMaxAmountsResponse';
  /**
   * Max quantity per collateral asset, truncated to the asset's precision and clamped to the
   * quantity in the LTV snapshot. Only positive amounts are listed, sorted by asset type ID.
   */
  amounts: Array<CmBalance>;
  /**
   * Weighted USD collateral above the collateral required to sit at targetLtv (decimal string).
   * Zero or negative means nothing can be returned. Zero when targetLtv is null.
   */
  headroomUSD: Scalars['String']['output'];
  /**
   * The package's configured ReturnToLTV (decimal string). Null when the package has no
   * MarginReturn target or targetLtv, rounded at the package's LTV precision, is not below
   * the danger threshold.
   */
  returnToLtv: Maybe<Scalars['String']['output']>;
  /**
   * The LTV the amounts bring the package to (decimal string): returnToLtv plus 0.01. Null
   * whenever returnToLtv is null.
   */
  targetLtv: Maybe<Scalars['String']['output']>;
};

/** One asset's cached Talos MarketDataSnapshot. */
export type CmMarketDataSnapshot = {
  __typename: 'CmMarketDataSnapshot';
  /** Asset the snapshot is for. */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /**
   * Cumulative bid notional within 0.5% of mid, as a decimal string. A lower bound: the whole visible
   * book when the ladder ends above the cutoff. Null when either side of the book was empty.
   */
  depthHalfPercent: Maybe<Scalars['String']['output']>;
  /**
   * Cumulative bid notional within 1% of mid, as a decimal string. A lower bound: the whole visible
   * book when the ladder ends above the cutoff. Null when either side of the book was empty.
   */
  depthOnePercent: Maybe<Scalars['String']['output']>;
  /**
   * Cumulative bid notional within 0.25% of mid, as a decimal string. A lower bound: the whole visible
   * book when the ladder ends above the cutoff. Null when either side of the book was empty.
   */
  depthQuarterPercent: Maybe<Scalars['String']['output']>;
  /**
   * Cumulative bid notional within 2% of mid, as a decimal string. A lower bound: the whole visible
   * book when the ladder ends above the cutoff. Null when either side of the book was empty.
   */
  depthTwoPercent: Maybe<Scalars['String']['output']>;
  /** Age of the snapshot against the global MARKET_DATA_SNAPSHOT_FRESHNESS thresholds. */
  freshness: CmMarketDataSnapshotFreshness;
  /** Talos event time of the snapshot. */
  timestamp: Scalars['Time']['output'];
};

/** Age of a cached MarketDataSnapshot against the global MARKET_DATA_SNAPSHOT_FRESHNESS thresholds. */
export enum CmMarketDataSnapshotFreshness {
  /** Younger than warningAfterSeconds. */
  FRESH = 'FRESH',
  /** At least staleAfterSeconds old. */
  STALE = 'STALE',
  /** At least warningAfterSeconds old and younger than staleAfterSeconds. */
  WARNING = 'WARNING'
}

/** How old the last market data snapshot can get before the feed counts as degraded, then stale. */
export type CmMarketDataSnapshotFreshnessInput = {
  /** Seconds after the last snapshot before the feed counts as stale. Greater than warningAfterSeconds. */
  staleAfterSeconds: Scalars['Int']['input'];
  /** Seconds after the last snapshot before the feed counts as degraded. Greater than 0. */
  warningAfterSeconds: Scalars['Int']['input'];
};

/** How old the last market data snapshot can get before the feed counts as degraded, then stale. */
export type CmMarketDataSnapshotFreshnessSettings = {
  __typename: 'CmMarketDataSnapshotFreshnessSettings';
  /** Seconds after the last snapshot before the feed counts as stale. Greater than warningAfterSeconds. */
  staleAfterSeconds: Scalars['Int']['output'];
  /** Seconds after the last snapshot before the feed counts as degraded. Greater than 0. */
  warningAfterSeconds: Scalars['Int']['output'];
};

/** The staleness budget for assets with no override of their own. */
export type CmMaxStalenessSettings = {
  __typename: 'CmMaxStalenessSettings';
  /** Maximum price staleness, in minutes. Greater than 0. */
  maxStalenessMinutes: Scalars['Int']['output'];
};

/** Collateral management operation */
export type CmOperation = {
  __typename: 'CmOperation';
  /** Action type performed */
  action: CmOperationAction;
  /** Amount for this operation */
  assetAmount: Amount;
  /**
   * True when the caller's org owns the linked custody operation. Org-level only: a caller in
   * that org without access to the operation's vault still cannot open it. Staff and service
   * callers get true on every row with an operation ID.
   */
  callerCanViewOperation: Scalars['Boolean']['output'];
  /** Timestamp when the operation was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the operation */
  id: Scalars['ID']['output'];
  /** External operation ID (e.g., wire ID) */
  operationID: Maybe<Scalars['String']['output']>;
  /**
   * Null if a deposit-attribution verdict doesn't apply to this operation. Otherwise true while
   * awaiting a verdict from the external attribution system, false once cleared.
   */
  pendingDepositAttribution: Maybe<Scalars['Boolean']['output']>;
  /** Status of the operation */
  status: CmOperationStatus;
  /** Type of operation (Exposure, CollateralPackage, or Liquidation) */
  type: CmOperationType;
};

/** Action type for collateral management operations */
export enum CmOperationAction {
  /** Return of collateral on loan closure */
  CLOSE_RETURN = 'CLOSE_RETURN',
  /** Deposit identified as dust or spam */
  DUST = 'DUST',
  /** Full liquidation of collateral */
  FULL_LIQUIDATION = 'FULL_LIQUIDATION',
  /** Gas fee */
  GAS_FEE = 'GAS_FEE',
  /** Initial collateral deposit */
  INITIAL_DEPOSIT = 'INITIAL_DEPOSIT',
  /** Initial loan funding */
  INITIAL_FUNDING = 'INITIAL_FUNDING',
  /** Interest accrual */
  INTEREST_ACCRUAL = 'INTEREST_ACCRUAL',
  /** Interest payment */
  INTEREST_PAYDOWN = 'INTEREST_PAYDOWN',
  /** Return of excess collateral */
  MARGIN_RETURN = 'MARGIN_RETURN',
  /** Partial liquidation of collateral */
  PARTIAL_LIQUIDATION = 'PARTIAL_LIQUIDATION',
  /** Loan principal paydown */
  PAY_DOWN = 'PAY_DOWN',
  /** Additional loan disbursement */
  PAY_UP = 'PAY_UP',
  /** Collateral moved back in from rehypothecation */
  REHYPE_IN = 'REHYPE_IN',
  /** Collateral moved out for rehypothecation */
  REHYPE_OUT = 'REHYPE_OUT',
  /** Transfer of collateral ownership */
  SWEEP = 'SWEEP',
  /** Additional collateral deposit */
  TOP_UP = 'TOP_UP'
}

/** An edge in a CM operations connection */
export type CmOperationEdge = {
  __typename: 'CmOperationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The operation at the end of the edge */
  node: CmOperation;
};

/** Status of collateral management operation */
export enum CmOperationStatus {
  /** The operation settled successfully */
  COMPLETE = 'COMPLETE',
  /** The operation did not settle */
  FAILED = 'FAILED',
  /** The operation is stored but has not settled yet */
  PENDING = 'PENDING',
  /** The operation was voided */
  VOID = 'VOID'
}

/** Type of collateral management operation */
export enum CmOperationType {
  COLLATERAL_PACKAGE = 'COLLATERAL_PACKAGE',
  EXPOSURE = 'EXPOSURE',
  LIQUIDATION = 'LIQUIDATION'
}

/** A connection to a list of CM operations */
export type CmOperationsConnection = {
  __typename: 'CmOperationsConnection';
  edges: Array<CmOperationEdge>;
  pageInfo: PageInfo;
};

/**
 * A collateral package's full configuration, mirroring the stored package record
 * (same values the internal gRPC package JSON serves). Decimal values are decimal
 * strings and durations are Go duration strings (e.g. "4h0m0s"). Values are the
 * stored representations — e.g. action strings and defaultNotice — and are NOT
 * guaranteed to round-trip verbatim into CmUpdateLoanInput.
 */
export type CmPackageConfig = {
  __typename: 'CmPackageConfig';
  acceleratedMarginCall: Maybe<CmAcceleratedMarginCallConfig>;
  assetTracking: Array<CmAssetTrackingConfigResponse>;
  autoDeleveraging: Maybe<CmAutoDeleveragingConfig>;
  /** Atlas participant ID of the collateral org. Set on 3-party packages. */
  collateralOrgAtlasID: Maybe<Scalars['ID']['output']>;
  critical: Maybe<CmCriticalConfig>;
  exposures: Array<CmExposureConfig>;
  feePayingParty: Array<CmParticipantRole>;
  /** ID of the collateral package this configuration belongs to */
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  /** Internal free-text notes (markdown) */
  internalNotesMD: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isCollateralDepositDetectionEnabled: Scalars['Boolean']['output'];
  isExposureDepositDetectionEnabled: Scalars['Boolean']['output'];
  ltvBalanceMode: CmLtvBalanceMode;
  ltvRoundingPrecision: Maybe<Scalars['Int']['output']>;
  marginCall: Maybe<CmMarginCallConfig>;
  marginReturn: Maybe<CmMarginReturnConfig>;
  pledgorId: Scalars['ID']['output'];
  referenceId: Scalars['ID']['output'];
  securedPartyId: Scalars['ID']['output'];
  vaultSubID: Maybe<Scalars['String']['output']>;
  vaultUniqueID: Maybe<Scalars['String']['output']>;
};

export type CmPackageCountResponse = {
  __typename: 'CmPackageCountResponse';
  /** Total number of unique participants that are listed as the counterParty */
  counterPartyCount: Scalars['Int']['output'];
  stateCounts: Array<CmStateCount>;
  /** Total number of active packages */
  totalCount: Scalars['Int']['output'];
};

export type CmPackageDetailsParameters = {
  __typename: 'CmPackageDetailsParameters';
  hasSeparator: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  subValue: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  /**
   * How the frontend should render `value`. Only set on "Connected wallets" rows
   * (TEXT or BADGE, depending on the row); null on all other existing rows.
   */
  valueFormat: Maybe<CmParameterValueFormat>;
  /**
   * A wallet's on-chain address, rendered as a copyable code snippet. Only set on
   * "Connected wallets" rows; null otherwise.
   */
  walletAddress: Maybe<Scalars['String']['output']>;
};

export type CmPackageDetailsResponse = {
  __typename: 'CmPackageDetailsResponse';
  parameters: Array<CmPackageDetailsParameters>;
  sectionTitle: Scalars['String']['output'];
};

/** The current state of the collateral package. Independent of status */
export enum CmPackageState {
  /** Accelerated Margin Call - Escalated margin call that shortens the package's margin call cure deadline */
  ACCELERATED_MARGIN_CALL = 'ACCELERATED_MARGIN_CALL',
  /** Closed - collateral package has been fully settled with zero exposure and zero collateral */
  CLOSED = 'CLOSED',
  /** Critical - collateral package levels are dangerous and the collateral should be liquidated */
  CRITICAL = 'CRITICAL',
  /** Healthy */
  HEALTHY = 'HEALTHY',
  /** Margin Call - More collateral is required from the pledgor */
  MARGIN_CALL = 'MARGIN_CALL',
  /** Margin Return - Too much collateral. Some of it needs to be returned to the pledgor */
  MARGIN_RETURN = 'MARGIN_RETURN'
}

/** Overall status of the collateral package. Disabled collateral packages are not monitored */
export enum CmPackageStatus {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Disabled */
  DISABLED = 'DISABLED'
}

/** A connection to a list of items. */
export type CmPackagesConnection = {
  __typename: 'CmPackagesConnection';
  edges: Array<CmPackagesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CmPackagesEdge = {
  __typename: 'CmPackagesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: CmPackagesResponse;
};

/** This query will drive the loan summary card */
export type CmPackagesResponse = {
  __typename: 'CmPackagesResponse';
  /** Atlas ID of current participant */
  atlasID: Scalars['ID']['output'];
  /** The name of the pledgor or the secured party */
  counterparty: Scalars['String']['output'];
  /** The ID of the counterparty */
  counterpartyId: Scalars['ID']['output'];
  /** The deadline when the cure period timer expires */
  curePeriodDeadline: Maybe<Scalars['Time']['output']>;
  /** Current state of the collateral package */
  currentState: CmPackageState;
  /** Action to be performed for the current collateral package state */
  currentStateAction: StateAction;
  /**
   * Exposures booked against this collateral package. Each row gives the
   * client what it needs to render an exposure-increase picker and submit
   * cmCreateOperation against the selected row(s).
   */
  exposures: Array<CmExposure>;
  /** Unique ID of the collateral package */
  id: Scalars['ID']['output'];
  /** Latest LTV value */
  ltv: Scalars['Float']['output'];
  /** Get the package details from the perspective of the participant which could be the pledgor or the secured party */
  participantRole: CmParticipantRole;
  /** The collateral package loan levels and their breach thresholds */
  stateLevels: Array<CmStateLevels>;
  /** Current status of the collateral package */
  status: CmPackageStatus;
  /** Total loaned amount in USD */
  totalExposureAmount: Amount;
};

/** How the frontend should render a CmPackageDetailsParameters row's `value`. */
export enum CmParameterValueFormat {
  /** A badge/pill, e.g. an org-role label. */
  BADGE = 'BADGE',
  /** Plain text (the default appearance for existing rows). */
  TEXT = 'TEXT'
}

/** Email addresses of a collateral management participant, by notification kind. */
export type CmParticipantEmailInput = {
  configuration: Array<Scalars['String']['input']>;
  notice: Array<Scalars['String']['input']>;
  reporting: Array<Scalars['String']['input']>;
};

export type CmParticipantResponse = {
  __typename: 'CmParticipantResponse';
  /** Parties that a user is for active packages only */
  participantRoles: Array<CmParticipantRole>;
};

export enum CmParticipantRole {
  PLEDGOR = 'PLEDGOR',
  SECURED_PARTY = 'SECURED_PARTY'
}

/** Verdict of a release-approval preflight check. */
export enum CmPreflightCheckStatus {
  /** At or above the stop threshold. */
  FAIL = 'FAIL',
  /** Below the warning threshold. */
  PASS = 'PASS',
  /** An input the check needs is missing. */
  UNKNOWN = 'UNKNOWN',
  /** At or above the warning threshold and below the stop threshold. */
  WARNING = 'WARNING'
}

/** Relative LTV change that triggers a price change alert. */
export type CmPriceChangeThresholdSettings = {
  __typename: 'CmPriceChangeThresholdSettings';
  /** Price change threshold, as a decimal string between 0 and 1. */
  priceChangeThreshold: Scalars['String']['output'];
};

/** A price feed: the source, the provider it is ingested through, and the pricing strategy. */
export type CmPriceFeedInput = {
  priceSource: PriceSource;
  priceSourceProvider: Scalars['String']['input'];
  pricingStrategy: CmPriceStrategies;
};

/** A price feed: the source, the provider it is ingested through, and the pricing strategy. */
export type CmPriceFeedResponse = {
  __typename: 'CmPriceFeedResponse';
  priceSource: PriceSource;
  priceSourceProvider: Scalars['String']['output'];
  pricingStrategy: CmPriceStrategies;
};

/** Represents supported assets for a specific price source (exchange) */
export type CmPriceSourceAssets = {
  __typename: 'CmPriceSourceAssets';
  /** List of supported trading pairs (e.g., ["BTC-USD", "ETH-USD"]) */
  assets: Array<Scalars['String']['output']>;
  /** The name of the price source/exchange (e.g., "KRAKEN", "BINANCE") */
  priceSource: Scalars['String']['output'];
  /** List of supported pricing strategies (e.g., ["BID", "ASK", "MID", "LAST"]) */
  strategies: Array<Scalars['String']['output']>;
};

/** Information about a price source provider */
export type CmPriceSourceProviderResponse = {
  __typename: 'CmPriceSourceProviderResponse';
  /** Provider name (e.g., "AMBERDATA") */
  name: Scalars['String']['output'];
};

/** Response containing price sources and their assets for a provider */
export type CmPriceSourcesByProviderResponse = {
  __typename: 'CmPriceSourcesByProviderResponse';
  /** List of price sources/exchanges and their supported assets */
  priceSources: Array<CmPriceSourceAssets>;
  /**
   * The price source provider as published by the marketdata service. Returned as
   * a raw string (not the CmPricingProvider enum) so this endpoint stays
   * forward-compatible if marketdata starts publishing providers we don't track.
   */
  provider: Scalars['String']['output'];
};

/** Response for cmPriceSources query */
export type CmPriceSourcesResponse = {
  __typename: 'CmPriceSourcesResponse';
  /** Price sources (exchanges) currently cached for the requested provider. Sorted. */
  priceSources: Array<PriceSource>;
};

export enum CmPriceStrategies {
  ASK = 'ASK',
  BID = 'BID',
  CHAINLINK_STRATEGY = 'CHAINLINK_STRATEGY',
  KAMINO_STRATEGY = 'KAMINO_STRATEGY',
  LAST = 'LAST',
  MID = 'MID'
}

/** Supported pricing providers */
export enum CmPricingProvider {
  /** Amberdata-sourced pricing ingested via the marketdata service */
  AMBERDATA = 'AMBERDATA',
  /** Chainlink-sourced pricing ingested via the marketdata service */
  CHAINLINK = 'CHAINLINK',
  /** Dev/smoke-testing-only provider; no live production feed emits it, so injected fake prices are collision-free. */
  CM_FAKE = 'CM_FAKE',
  /** Kamino-sourced pricing ingested via the marketdata service */
  KAMINO = 'KAMINO'
}

/** Response for cmPricingStrategies query */
export type CmPricingStrategiesResponse = {
  __typename: 'CmPricingStrategiesResponse';
  /**
   * Pricing strategies (e.g., "BID", "ASK", "MID", "LAST", "KAMINO_STRATEGY") cached
   * for the requested provider and price source. Sorted.
   */
  strategies: Array<CmPriceStrategies>;
};

/** A single operation to include in a cmSimulateLtv basket. Multiple of these may be combined in one query — see cmSimulateLtv. */
export type CmSimulateLtvOperationInput = {
  /** The action being performed (e.g. INITIAL_FUNDING, PAY_UP). */
  action: CmOperationAction;
  /** The asset for the quantity. */
  asset: CmAssetInput;
  /** The quantity of the operation as a decimal string. */
  quantity: Scalars['String']['input'];
  /** The type of operation being simulated (e.g. EXPOSURE). */
  type: CmOperationType;
  /** The ID of the entity being operated on (e.g. exposure ID for an EXPOSURE operation). */
  typeId: Scalars['ID']['input'];
};

/** Slippage tolerance applied when liquidating collateral. */
export type CmSlippageSettings = {
  __typename: 'CmSlippageSettings';
  /** Slippage tolerance, as a decimal string between 0 and 1. */
  slippage: Scalars['String']['output'];
};

/** An open stale-price alert record for one primary price source (see cmStalePriceAlerts). */
export type CmStalePriceAlertResponse = {
  __typename: 'CmStalePriceAlertResponse';
  /**
   * Fingerprint of the asset set last sent to incident.io as firing (sorted asset
   * IDs joined with commas). It may temporarily differ from staleAssets — a newly
   * merged asset joins staleAssets before the next check re-fires — and is empty
   * when the alert has never fired.
   */
  lastFiredFingerprint: Scalars['String']['output'];
  /** The primary price source whose assets are stale. */
  source: Scalars['String']['output'];
  /** Asset IDs currently believed stale on this source. */
  staleAssets: Array<Scalars['String']['output']>;
};

export type CmStateCount = {
  __typename: 'CmStateCount';
  count: Scalars['Int']['output'];
  percentage: Scalars['String']['output'];
  state: CmPackageState;
};

/** These levels are used to show the different LTV percentages required to move the collateral package into different states. */
export type CmStateLevels = {
  __typename: 'CmStateLevels';
  /** Minimum LTV required to transition into this state */
  ltv: Scalars['Float']['output'];
  /** State of the collateral package */
  state: CmPackageState;
};

/**
 * A global or asset-level system setting (slippage, liquidation fee, price
 * change threshold, max staleness, backup price feed, market data snapshot
 * freshness, credit line check, or backup feed tolerance).
 * assetTypeID is null for the global row; when set, the row applies only to
 * that asset.
 */
export type CmSystemSettings = {
  __typename: 'CmSystemSettings';
  /** Asset this row applies to. Null for the global row. */
  assetTypeID: Maybe<Scalars['AssetTypeID']['output']>;
  /** Backup feed tolerance. Set only when type is BACKUP_FEED_TOLERANCE_MINUTES. */
  backupFeedTolerance: Maybe<CmBackupFeedToleranceSettings>;
  /** Backup price feed. Set only when type is BACKUP_PRICE_FEED. */
  backupPriceFeed: Maybe<CmPriceFeedResponse>;
  /** When the settings row was created. */
  createdAt: Scalars['Time']['output'];
  /** Credit line check utilization thresholds. Set only when type is CREDIT_LINE_CHECK. */
  creditLineCheck: Maybe<CmCreditLineCheckSettings>;
  /** Unique identifier for the settings row. */
  id: Scalars['ID']['output'];
  /** Liquidation fee. Set only when type is LIQUIDATION_FEE. */
  liquidationFee: Maybe<CmLiquidationFeeSettings>;
  /** Market data snapshot freshness thresholds. Set only when type is MARKET_DATA_SNAPSHOT_FRESHNESS. */
  marketDataSnapshotFreshness: Maybe<CmMarketDataSnapshotFreshnessSettings>;
  /** Max staleness. Set only when type is MAX_STALENESS_MINUTES. */
  maxStaleness: Maybe<CmMaxStalenessSettings>;
  /** Price change threshold. Set only when type is PRICE_CHANGE_THRESHOLD. */
  priceChangeThreshold: Maybe<CmPriceChangeThresholdSettings>;
  /** Slippage tolerance. Set only when type is SLIPPAGE. */
  slippage: Maybe<CmSlippageSettings>;
  /** Which value this row configures. */
  type: CmSystemSettingsType;
  /** When the settings row was last updated. */
  updatedAt: Scalars['Time']['output'];
};

/** Type of system setting: which value a settings row configures. */
export enum CmSystemSettingsType {
  /** Minutes a package can run on its backup price feed before operations want to know. Global only. */
  BACKUP_FEED_TOLERANCE_MINUTES = 'BACKUP_FEED_TOLERANCE_MINUTES',
  /** Backup price feed that failover uses for assets with no backup feed of their own. Global only. */
  BACKUP_PRICE_FEED = 'BACKUP_PRICE_FEED',
  /** Utilization ratios of the Talos credit limit at which the credit line check warns, then stops. Global only. */
  CREDIT_LINE_CHECK = 'CREDIT_LINE_CHECK',
  /** Fee charged on a liquidation. */
  LIQUIDATION_FEE = 'LIQUIDATION_FEE',
  /** Seconds after the last market data snapshot before the feed counts as degraded, then stale. Global only. */
  MARKET_DATA_SNAPSHOT_FRESHNESS = 'MARKET_DATA_SNAPSHOT_FRESHNESS',
  /** The staleness budget, in minutes, for assets with no override of their own. Global only. */
  MAX_STALENESS_MINUTES = 'MAX_STALENESS_MINUTES',
  /** Relative LTV change that triggers a price change alert. Global only. */
  PRICE_CHANGE_THRESHOLD = 'PRICE_CHANGE_THRESHOLD',
  /** Slippage tolerance applied when liquidating collateral. */
  SLIPPAGE = 'SLIPPAGE'
}

/** The cached Talos program credit exposure row */
export type CmTalosCreditExposure = {
  __typename: 'CmTalosCreditExposure';
  /** The currency of exposure and limit, as Talos reports it */
  currency: Scalars['String']['output'];
  /** The program credit exposure in currency, as a decimal string. Not clamped; it can be negative. */
  exposure: Scalars['String']['output'];
  /** The program credit limit in currency, as a decimal string */
  limit: Scalars['String']['output'];
  /** Talos event time of the row */
  timestamp: Scalars['Time']['output'];
  /** exposure / limit, as a decimal ratio string. Null when limit is zero or negative. */
  utilization: Maybe<Scalars['String']['output']>;
};

/**
 * An order as Talos reports it. Decimals are strings; status is the Talos
 * OrdStatus text unchanged.
 */
export type CmTalosOrder = {
  __typename: 'CmTalosOrder';
  /** Filled quantity. Null when Talos omits it. */
  cumQty: Maybe<Scalars['String']['output']>;
  /** Open quantity. Null when Talos omits it, so it is never mistaken for a closed order. */
  leavesQty: Maybe<Scalars['String']['output']>;
  orderID: Scalars['String']['output'];
  orderQty: Scalars['String']['output'];
  side: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /** Null when Talos omits the submit time. */
  submitTime: Maybe<Scalars['Time']['output']>;
  symbol: Scalars['String']['output'];
};

/**
 * A trade as Talos reports it. Decimals are strings; status is the Talos
 * TradeStatus text unchanged.
 */
export type CmTalosTrade = {
  __typename: 'CmTalosTrade';
  amount: Scalars['String']['output'];
  amountCurrency: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  orderID: Scalars['String']['output'];
  price: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  side: Scalars['String']['output'];
  status: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  tradeID: Scalars['String']['output'];
  transactTime: Scalars['Time']['output'];
};

/**
 * Input for updating a single exposure. Mirrors the gRPC UpdateExposure path;
 * omitted fields are left unchanged. The exposure's collateral package cannot be
 * changed.
 */
export type CmUpdateExposureInput = {
  exposureAssetConfig?: InputMaybe<CmExposureAssetConfigUpdateInput>;
  /** ID of the exposure to update */
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  pricingStrategy?: InputMaybe<CmPriceStrategies>;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Exposure type — free-text today (e.g. "Loan") */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a liquidation obligation. Only status is supported for now. */
export type CmUpdateLiquidationObligationInput = {
  /** New status to set. */
  status?: InputMaybe<CmLiquidationStatus>;
};

/**
 * Input for updating a loan / collateral package. Only `id` is required; any field
 * left null is left unchanged on the package.
 */
export type CmUpdateLoanInput = {
  /** Update the accelerated margin call config */
  acceleratedMarginCall?: InputMaybe<AcceleratedMarginCall>;
  /** Update the asset tracking config */
  assetTracking?: InputMaybe<Array<AssetTrackingInput>>;
  /** Update the auto deleveraging config */
  autoDeleveraging?: InputMaybe<AutoDeleveraging>;
  /**
   * Remove the accelerated margin call config. Mutually exclusive with
   * acceleratedMarginCall; rejected while the package is in MARGIN_CALL_M2.
   */
  clearAcceleratedMarginCall?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Remove the critical config. Mutually exclusive with critical; rejected
   * while the package is in CRITICAL.
   */
  clearCritical?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Remove the margin call config. Mutually exclusive with marginCall;
   * rejected while the package is in MARGIN_CALL_M1 or MARGIN_CALL_M2.
   */
  clearMarginCall?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Remove the margin return config. Mutually exclusive with marginReturn;
   * rejected while the package is in MARGIN_RETURN.
   */
  clearMarginReturn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Atlas participant ID of the collateral org. Used in 3-party packages. */
  collateralOrgAtlasID?: InputMaybe<Scalars['ID']['input']>;
  /** Update the critical config */
  critical?: InputMaybe<Critical>;
  /** Update which party pays the fees */
  feePayingParty?: InputMaybe<Array<CmParticipantRole>>;
  /** The ID of the loan that we want to update */
  id: Scalars['ID']['input'];
  /** Internal name for the loan */
  internalName?: InputMaybe<Scalars['String']['input']>;
  /** Update the internal free-text notes (markdown) on the package */
  internalNotesMD?: InputMaybe<Scalars['String']['input']>;
  /** Update the loan status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable monitoring for incoming collateral deposits on the package. */
  isCollateralDepositDetectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable monitoring for incoming exposure deposits on the package. */
  isExposureDepositDetectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update which balances the package's LTV counts. */
  ltvBalanceMode?: InputMaybe<CmLtvBalanceMode>;
  /** Update the LTV rounding precision */
  ltvRoundingPrecision?: InputMaybe<Scalars['Int']['input']>;
  /** Update the margin call config */
  marginCall?: InputMaybe<MarginCall>;
  /** Update the margin return config */
  marginReturn?: InputMaybe<MarginReturn>;
  /** Update the reference ID */
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Update the vault sub ID */
  vaultSubID?: InputMaybe<Scalars['String']['input']>;
  /** Update the vault unique ID */
  vaultUniqueID?: InputMaybe<Scalars['String']['input']>;
};

/** Connection wrapper for the coinductor automation policies query. */
export type CoinductorAutomationPolicies = {
  __typename: 'CoinductorAutomationPolicies';
  /** List of coinductor automation policy edges. */
  edges: Array<CoinductorAutomationPolicyEdge>;
  /** Whether there are more results after this page. */
  hasNextPage: Scalars['Boolean']['output'];
};

/** A coinductor automation policy that automates mint or burn operations for a given source/destination wallet pair. */
export type CoinductorAutomationPolicy = {
  __typename: 'CoinductorAutomationPolicy';
  /** Asset the policy operates on. */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Creation timestamp. */
  createdAt: Scalars['Time']['output'];
  /**
   * Identifier of the user who created the policy. For org users this is the
   * user key ID; for API users it is their principal identifier (see
   * auth.User.Name()). Null for legacy policies persisted before the field
   * was wired through.
   */
  createdBy: Maybe<Scalars['String']['output']>;
  /** Destination vault ID (derived from the destination wallet). Null when wallet or vault lookup is unavailable. */
  destinationVaultID: Maybe<Scalars['ID']['output']>;
  /** Vault metadata (sub ID, name) for the destination wallet's vault. Null when wallet or vault lookup is unavailable. */
  destinationVaultInfo: Maybe<IssueRedeemVaultInfo>;
  /** Destination wallet ID. */
  destinationWalletID: Scalars['ID']['output'];
  /** Display info (name + address) for the destination wallet. Null when wallet lookup is unavailable. */
  destinationWalletInfo: Maybe<IssueRedeemWalletInfo>;
  /** Set only when the policy was disabled outside the user lifecycle. Null otherwise. */
  forceDisableReason: Maybe<CoinductorPolicyForceDisableReason>;
  /** Unique policy identifier. */
  id: Scalars['ID']['output'];
  /** Human-readable policy name. */
  name: Scalars['String']['output'];
  /** Operation ID of the authorization that created the policy. Null when no create operation has been issued yet. The revokeCoinductorAutomationPolicy response returns the revoke operation here; prefer revokeOperationID for the in-flight revoke. */
  operationID: Maybe<Scalars['OperationID']['output']>;
  /** Whether this policy automates MINT or BURN. */
  policyType: CoinductorPolicyType;
  /** Status the policy had before the revoke was requested. Null unless status is REVOKE_PENDING. */
  preRevokeStatus: Maybe<CoinductorPolicyStatus>;
  /** Org-change operation of the in-flight revoke. Null unless status is REVOKE_PENDING. */
  revokeOperationID: Maybe<Scalars['OperationID']['output']>;
  /** Source vault ID (derived from the source wallet). Null when wallet or vault lookup is unavailable. */
  sourceVaultID: Maybe<Scalars['ID']['output']>;
  /** Vault metadata (sub ID, name) for the source wallet's vault. Null when wallet or vault lookup is unavailable. */
  sourceVaultInfo: Maybe<IssueRedeemVaultInfo>;
  /** Source wallet ID. */
  sourceWalletID: Scalars['ID']['output'];
  /** Display info (name + address) for the source wallet. Null when wallet lookup is unavailable. */
  sourceWalletInfo: Maybe<IssueRedeemWalletInfo>;
  /** Run aggregates of this policy; zero for a policy that never ran. Null when the stats lookup failed; the policy itself is still returned. */
  stats: Maybe<CoinductorAutomationPolicyStats>;
  /** Lifecycle status of the policy. */
  status: CoinductorPolicyStatus;
  /** Last change to the policy record. For a PAUSED policy this is when it was paused, or when a rejected revoke restored it; for a DISABLED one, when it was revoked or force-disabled. */
  updatedAt: Scalars['Time']['output'];
  /**
   * Trusted-destination SubID that post-mint/burn funds are automatically
   * withdrawn to. Null for policies without an automated withdrawal.
   */
  withdrawalDestinationSubID: Maybe<Scalars['String']['output']>;
};

/** Edge wrapper for CoinductorAutomationPolicy. */
export type CoinductorAutomationPolicyEdge = {
  __typename: 'CoinductorAutomationPolicyEdge';
  /** The coinductor automation policy node. */
  node: CoinductorAutomationPolicy;
};

/**
 * Run aggregates of one policy. totalRuns counts every run except SKIPPED;
 * lifetimeVolume sums the COMPLETED runs' conversion amounts.
 */
export type CoinductorAutomationPolicyStats = {
  __typename: 'CoinductorAutomationPolicyStats';
  /** Exact decimal sum of the COMPLETED runs' amounts in lifetimeVolumeAssetTypeID. "0" when no run completed. */
  lifetimeVolume: Scalars['String']['output'];
  /** Asset of lifetimeVolume: the asset the runs' conversions were made in (fiat for MINT policies, the stablecoin for BURN). Null when no run completed. */
  lifetimeVolumeAssetTypeID: Maybe<Scalars['AssetTypeID']['output']>;
  /** Runs in any status except SKIPPED. */
  totalRuns: Scalars['Int']['output'];
};

/** A single execution of a coinductor automation policy */
export type CoinductorAutomationRun = {
  __typename: 'CoinductorAutomationRun';
  /** Decimal amount the run was dispatched for (the conversion's source amount), denominated in amountAssetTypeID. Stamped on the run at dispatch; runs recorded before that are resolved from their conversion, so it is null only for such a run that has no conversion record yet. */
  amount: Maybe<Scalars['String']['output']>;
  /** Asset the amount is denominated in: the deposit's asset, which for a MINT run differs from assetTypeID. Null whenever amount is null. */
  amountAssetTypeID: Maybe<Scalars['AssetTypeID']['output']>;
  /** Asset the run's policy operates on. */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Creation timestamp. */
  createdAt: Scalars['Time']['output'];
  /** Vault metadata (sub ID, name) for the destination wallet's vault. */
  destinationVaultInfo: Maybe<IssueRedeemVaultInfo>;
  /** Destination wallet ID. */
  destinationWalletID: Scalars['ID']['output'];
  /** Display info (name + address) for the destination wallet. */
  destinationWalletInfo: Maybe<IssueRedeemWalletInfo>;
  /** Reason the run failed. Null unless status is FAILED. */
  failureReason: Maybe<Scalars['String']['output']>;
  /** Unique run identifier. */
  id: Scalars['ID']['output'];
  /** Identifier of the issue/redeem conversion this run produced. Null until the conversion record exists. */
  issueRedeemID: Maybe<Scalars['ID']['output']>;
  /** Identifier of the policy that produced this run. */
  policyID: Scalars['ID']['output'];
  /** Human-readable name of the policy that produced this run. Reflects the policy's current name, not the name at the time of the run. */
  policyName: Scalars['String']['output'];
  /** Vault metadata (sub ID, name) for the source wallet's vault. */
  sourceVaultInfo: Maybe<IssueRedeemVaultInfo>;
  /** Source wallet ID. */
  sourceWalletID: Scalars['ID']['output'];
  /** Display info (name + address) for the source wallet. */
  sourceWalletInfo: Maybe<IssueRedeemWalletInfo>;
  /** Lifecycle status of the run. */
  status: CoinductorRunStatus;
  /** Operation ID of the trigger that produced this run. */
  triggerOperationID: Maybe<Scalars['OperationID']['output']>;
  /** Whether this run automates MINT or BURN. */
  triggerType: CoinductorTriggerType;
  /**
   * Trusted-destination SubID that post-mint/burn funds are automatically
   * withdrawn to, mirrored from the policy that produced this run. Null for
   * runs of policies without an automated withdrawal.
   */
  withdrawalDestinationSubID: Maybe<Scalars['String']['output']>;
};

/** Edge wrapper for CoinductorAutomationRun. */
export type CoinductorAutomationRunEdge = {
  __typename: 'CoinductorAutomationRunEdge';
  /** The coinductor automation run node. */
  node: CoinductorAutomationRun;
};

/** Connection wrapper for the coinductor automation runs query. */
export type CoinductorAutomationRuns = {
  __typename: 'CoinductorAutomationRuns';
  /** List of coinductor automation run edges. */
  edges: Array<CoinductorAutomationRunEdge>;
  /** Whether there are more results after this page. */
  hasNextPage: Scalars['Boolean']['output'];
};

/** Counted runs (every status except SKIPPED) of one policy on one UTC calendar day. */
export type CoinductorDailyRunCount = {
  __typename: 'CoinductorDailyRunCount';
  /** Runs that day. */
  count: Scalars['Int']['output'];
  /** YYYY-MM-DD in UTC. Days are bucketed in UTC; render in the user's locale but label the tooltip with this date. */
  date: Scalars['String']['output'];
};

/** Why a policy was disabled by an event outside the user lifecycle. */
export enum CoinductorPolicyForceDisableReason {
  TRUSTED_DESTINATION_REMOVED = 'TRUSTED_DESTINATION_REMOVED'
}

/** Lifecycle status of a coinductor automation policy. */
export enum CoinductorPolicyStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  REVOKE_PENDING = 'REVOKE_PENDING'
}

/** Coinductor policy operation type. MINT generates new tokens; BURN destroys tokens. */
export enum CoinductorPolicyType {
  BURN = 'BURN',
  MINT = 'MINT'
}

/** Lifecycle status of a coinductor automation run. */
export enum CoinductorRunStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  SKIPPED = 'SKIPPED',
  UNKNOWN = 'UNKNOWN'
}

/** Trigger type for a coinductor automation run. */
export enum CoinductorTriggerType {
  BURN = 'BURN',
  MINT = 'MINT',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Input for point-in-time collateral rule lookup
 * Returns exactly one record from main or history table
 */
export type CollateralRuleEffectiveAtInput = {
  collateralRuleId: Scalars['ID']['input'];
  effectiveAt: Scalars['Time']['input'];
};

export type CollateralRuleFilter = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nettingSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purposes?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CollateralRuleHistoryFilter = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nettingSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purposes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CollateralTicket = {
  __typename: 'CollateralTicket';
  actions: Array<CollateralTicketAction>;
  /** The ID of the collateral package */
  collateralPackageID: Scalars['ID']['output'];
  /** The created at timestamp of the collateral ticket */
  createdAt: Scalars['Time']['output'];
  /** The ID of the collateral ticket */
  id: Scalars['ID']['output'];
  /** The idempotency key of the collateral ticket */
  idempotencyKey: Maybe<Scalars['String']['output']>;
  /** The last actioned at timestamp of the collateral ticket */
  lastActionedAt: Scalars['Time']['output'];
  /** The notes of the collateral ticket */
  notes: Scalars['String']['output'];
  /** The status of the collateral ticket */
  status: TicketStatus;
  /** The title of the collateral ticket */
  title: Scalars['String']['output'];
  /** The updated at timestamp of the collateral ticket */
  updatedAt: Scalars['Time']['output'];
};

export type CollateralTicketAction = {
  __typename: 'CollateralTicketAction';
  /** The type of the action */
  actionType: TicketActionType;
  /** Communication logs of the action */
  communicationLogs: Array<CollateralTicketCommunicationLog>;
  /** The created at timestamp of the action */
  createdAt: Scalars['Time']['output'];
  /** The username of the user who created the action */
  createdBy: Scalars['String']['output'];
  /** The ID of the collateral ticket action */
  id: Scalars['ID']['output'];
  /** The idempotency key of the action */
  idempotencyKey: Maybe<Scalars['String']['output']>;
  /** The notes of the action */
  notes: Maybe<Scalars['String']['output']>;
  /** The reference ID of the action */
  referenceID: Scalars['ID']['output'];
  /** The ID of the collateral ticket */
  ticketID: Scalars['ID']['output'];
  /** The updated at timestamp of the action */
  updatedAt: Scalars['Time']['output'];
};

export type CollateralTicketCommunicationLog = {
  __typename: 'CollateralTicketCommunicationLog';
  /** The created at timestamp of the collateral ticket communication log */
  Type: TicketCommunicationType;
  /** The ID of the ticket action */
  actionID: Maybe<Scalars['ID']['output']>;
  /** Body of the message */
  body: Scalars['String']['output'];
  /** Template values for automated e-mail */
  bodyTemplate: Maybe<Scalars['String']['output']>;
  /** The Collateral Package ID */
  collateralPackageID: Scalars['ID']['output'];
  /** The created at timestamp of the collateral ticket communication log */
  createdAt: Scalars['Time']['output'];
  /** Created by field */
  createdBy: Scalars['String']['output'];
  /** The ID of the collateral ticket communication log */
  id: Scalars['ID']['output'];
  /** The idempotency key of the collateral ticket communication log */
  idempotencyKey: Maybe<Scalars['String']['output']>;
  /** Recipients of the message */
  recipients: Array<Scalars['String']['output']>;
  /** Sender of the message */
  sender: Scalars['String']['output'];
  /** When was the message sent */
  sentAt: Scalars['Time']['output'];
  /** Subject of the message */
  subject: Scalars['String']['output'];
  /** The updated at timestamp of the collateral ticket communication log */
  updatedAt: Scalars['Time']['output'];
};

/**
 * CommonOperationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type
 * For resolver implementations, see (eg):
 * - service/graphqlmonolith/models/operation.go (eg EndorsementPayload)
 */
export type CommonOperationInfo = {
  __typename: 'CommonOperationInfo';
  /**
   * appliedPolicy is the policy rule that actually applied to this operation, as
   * selected by the authorization service's CheckOperationPolicy. Null when
   * conditional rules aren't enabled for the operation's org, or when there's no
   * applied selection to report.
   */
  appliedPolicy: Maybe<AppliedPolicy>;
  /** Actions available on this operation */
  availableOperationDecisions: Array<OperationDecision>;
  /** Returns the bio challenge required to pass in order to endorse this operation */
  bioChallenge: Maybe<BioChallenge>;
  /**
   * canonicalOperationPayload is returned to the client to be used as the source of truth for the UI elements describing the operation for "new" operation types such as OffChainOperation that support the visual signing protocol. For old operation types, this field most NOT be used because the security of the system relies on the client constructing it on their own from other graphql fields. It's optional because not all operations are endorsable.
   * For these new operation types, it might be useful to use it in combination with the endorsementPayload field to simplify the (blind) signing of extra metadata.
   */
  canonicalOperationPayload: Maybe<Scalars['String']['output']>;
  /** canonicalOperationPayloadDigest is the digest of the canonicalOperationPayload field. It's useful for debugging purposes. */
  canonicalOperationPayloadDigest: Maybe<Scalars['String']['output']>;
  /**
   * The path to be used to derive the control child private key to allow this operation to be endorsed if one is needed.
   * Example: m/1/2/3
   */
  controlKeyDerivationPath: Maybe<Scalars['String']['output']>;
  /** Data gets the complete operation as a JSON string for debugging. */
  data: Scalars['String']['output'];
  /** displaySubtitle is the subtitle text used in conjunction with the displayTitle */
  displaySubtitle: Scalars['String']['output'];
  /** displayTitle is the standard, human readable name used when displaying the name across all user facing applications */
  displayTitle: Scalars['String']['output'];
  /**
   * endorsementPayload returns a pre-formatted "endorsement" signable. The "Signable" payload type for these structs is always "ENDORSEMENT".
   * This is a json blob formatted and returned as a string.
   * For operations that are not signable, this is null (ex. "DepositEvent")
   */
  endorsementPayload: Maybe<Scalars['String']['output']>;
  /**
   * endorsements is the list of endorsements for the operation
   * The type is nullable so we can return null in cases when the operation is not expected to support endorsements.
   */
  endorsements: Maybe<Array<SimplifiedEndorsement>>;
  /** externalRequestInfo contains information about the external request that initiated the operation, if applicable */
  externalRequestInfo: Maybe<ExternalRequestInfo>;
  /**
   * failureReason is why a failed operation failed, set only when the reason is safe to show the
   * client (for example "Rejected by Anchorage Compliance"). Null otherwise.
   */
  failureReason: Maybe<Scalars['String']['output']>;
  /**
   * generation is the organization generation this operation was created against
   * Organization creation operations won't have an generation before the organization has been created
   */
  generation: Maybe<Scalars['Int']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /**
   * initiator is the user who started the operation. This operation could have been started by an anchorage employee or simply come from the blockchain, so not every operation has an initiator.
   * @deprecated use initiatorV2
   */
  initiator: Maybe<User>;
  /** initiatorKeyID is the key ID of who started the operation. This operation could have been started by an anchorage employee or simply come from the blockchain, so not every operation has an initiator. */
  initiatorKeyID: Maybe<Scalars['String']['output']>;
  /**
   * initiatorV2 is actor in the Anchorage system that started the operation.
   * Operations might be initiated by Anchorage employees, Users, API Keys, etc.
   */
  initiatorV2: Maybe<Actor>;
  /** issueTicket returns the JIRA ticket ID */
  issueTicket: Maybe<Scalars['String']['output']>;
  /** operationFields describe the layout of the operation as per VSP for the iOS to display */
  operationFields: Maybe<Array<OperationField>>;
  /** operationID is the id of the operation */
  operationID: Scalars['OperationID']['output'];
  /** operationImpediment contains info about what impedes an operation from transitioning to the next state. */
  operationImpediment: Maybe<OperationImpediment>;
  /**
   * Organization that this operation belongs to
   * Organization creation operations won't have an organization before the organization has been created
   */
  organization: Maybe<Organization>;
  /** readPolicy is the non-signable representation of the policy that applies to this operation */
  readPolicy: Maybe<ReadPolicy>;
  /** riskReview collects all the risk information for the operation, if any */
  riskReview: Maybe<RiskReview>;
  /**
   * This controls whether or not the iOS app should show a badge saying "external" on the operation list and detail views.
   * This was created when adding walletconnect and is on when walletconnect is used. The meaning might change over time.
   */
  showExternalBadge: Scalars['Boolean']['output'];
  /** signablePayload is the payload that the user is expected to sign - it's a JSON string */
  signablePayload: Maybe<Scalars['String']['output']>;
};


/**
 * CommonOperationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type
 * For resolver implementations, see (eg):
 * - service/graphqlmonolith/models/operation.go (eg EndorsementPayload)
 */
export type CommonOperationInfobioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/**
 * CommonOperationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type
 * For resolver implementations, see (eg):
 * - service/graphqlmonolith/models/operation.go (eg EndorsementPayload)
 */
export type CommonOperationInfoendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

export type ComplianceAlertTotals = {
  __typename: 'ComplianceAlertTotals';
  alertType: AlertType;
  fiveToTen: Scalars['Int']['output'];
  tenPlus: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  zeroToFive: Scalars['Int']['output'];
};

export type ComplianceCaseTotals = {
  __typename: 'ComplianceCaseTotals';
  caseType: CaseType;
  tenToTwenty: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  twentyPlus: Scalars['Int']['output'];
  zeroToTen: Scalars['Int']['output'];
};

/** ComplianceDocumentsConnection contains the edges to ComplianceDocumentsEdge */
export type ComplianceDocumentsConnection = {
  __typename: 'ComplianceDocumentsConnection';
  /** List of edges containing compliance documents and cursor information */
  edges: Array<ComplianceDocumentsEdge>;
  /** Page details for the associated list of ComplianceDocumentsEdge */
  pageInfo: PageInfo;
};

/** ComplianceDocumentsDetail contains information about documents */
export type ComplianceDocumentsDetail = {
  __typename: 'ComplianceDocumentsDetail';
  /** contentType is the type of the document */
  contentType: Maybe<Scalars['String']['output']>;
  /** createdAt is the time when the document is created */
  createdAt: Scalars['Timestamp']['output'];
  /** file is the name of the file */
  file: Scalars['String']['output'];
  /** folderID is the ID of the folder that contains the file */
  folderID: Scalars['String']['output'];
  /** size is the size of the document */
  size: Scalars['Int']['output'];
  /** sizeAsString is the size of the document as string */
  sizeAsString: Scalars['String']['output'];
};

/** ComplianceDocumentsEdge contains the CRRScoreDetails */
export type ComplianceDocumentsEdge = {
  __typename: 'ComplianceDocumentsEdge';
  /** Cursor for the ComplianceDocumentsEdge */
  cursor: Scalars['ID']['output'];
  /** CRR Score details */
  node: ComplianceDocumentsDetail;
};

/** ComplianceIssueInput input data to successfully create a new issue in Jira */
export type ComplianceIssueInput = {
  /** Affiliate ID associated to the issue (deprecated: use affiliateKYCProfileID instead) */
  affiliateID?: InputMaybe<Scalars['String']['input']>;
  /** Affiliate KYC profile ID associated to the issue (preferred over affiliateID) */
  affiliateKYCProfileID?: InputMaybe<Scalars['String']['input']>;
  /** Type of client that represents the affiliate */
  clientType?: InputMaybe<Scalars['String']['input']>;
  /** CRR of the affiliate */
  crr: CRRScoreOutcome;
  /** Description when applicable */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Entity Type associated to the issue */
  entityType: AnchorageEntityType;
  /** ID of the individual associated with the case */
  individualID?: InputMaybe<Scalars['String']['input']>;
  /** Name of the individual associated with the case */
  individualName?: InputMaybe<Scalars['String']['input']>;
  /** Source(s) of the issue being manually created */
  issueSources?: InputMaybe<Array<IssueSource>>;
  /** Type of issue being manually created in jira via CCV */
  issueType: AlertType;
};

/**
 * Confirming a settlement was met: the status change alone, since the money is attached beforehand
 * with dvSaveSettlementMovements. Needs a reason where that money covers less than the net.
 */
export type ConfirmSettlementInput = {
  /**
   * The custody or venue reference, and the hash for an on-chain movement. Both are supplied by the
   * caller, which reads them off the matched ledger row rather than typing them again
   */
  externalRef?: InputMaybe<Scalars['String']['input']>;
  /**
   * The payment made for this settlement, a fiat wire or a crypto transfer, recorded on Free balance and
   * attached in the same step, only where dvSettlementLedgerPreview is enabled; omit it, or send
   * amount "0", to attach money beforehand with dvSaveSettlementMovements instead
   */
  payment?: InputMaybe<SettlementPaymentInput>;
  /** Why this closes for more than the money attached to it. Required only in that case */
  reason?: InputMaybe<Scalars['String']['input']>;
  settlementId: Scalars['ID']['input'];
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** Control Agreement action type */
export enum ControlAgreementAction {
  /** Decrease action */
  decrease = 'decrease',
  /** Increase action */
  increase = 'increase',
  /** Notice of exclusive control */
  noticeOfExclusiveControl = 'noticeOfExclusiveControl',
  /** Notice of returned collateral */
  noticeOfReturnedCollateral = 'noticeOfReturnedCollateral',
  /** Seize action */
  seize = 'seize',
  /** Settle action */
  settle = 'settle',
  /** Terminate action */
  terminate = 'terminate'
}

/** Control agreement actions configuration (output) */
export type ControlAgreementActions = {
  __typename: 'ControlAgreementActions';
  /** Decrease action config */
  decrease: Maybe<GDFAdjustmentConfig>;
  /** Increase action config */
  increase: Maybe<GDFAdjustmentConfig>;
  /** Notice of exclusive control config */
  noticeOfExclusiveControl: Maybe<GDFNoticeConfig>;
  /** Notice of returned collateral config */
  noticeOfReturnedCollateral: Maybe<GDFNoticeConfig>;
  /** Terminate action config */
  terminate: Maybe<GDFTerminateConfig>;
};

/** Control agreement actions configuration (input) */
export type ControlAgreementActionsInput = {
  /** Decrease action config */
  decrease?: InputMaybe<GDFAdjustmentConfigInput>;
  /** Increase action config */
  increase?: InputMaybe<GDFAdjustmentConfigInput>;
  /** Notice of exclusive control config */
  noticeOfExclusiveControl?: InputMaybe<GDFNoticeConfigInput>;
  /** Notice of returned collateral config */
  noticeOfReturnedCollateral?: InputMaybe<GDFNoticeConfigInput>;
  /** Terminate action config */
  terminate?: InputMaybe<GDFTerminateConfigInput>;
};

/** ControlAgreementActivitiesFilter groups filter parameters for the controlAgreementActivities query. */
export type ControlAgreementActivitiesFilter = {
  /** Filter to a specific activity by ID. Returns 0 or 1 results. */
  activityID?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by asset type ID. Returns only activities associated with the given asset type. */
  assetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  /** Filter by control agreement ID. */
  controlAgreementID?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by activity type. */
  filterActivityType?: InputMaybe<ControlAgreementActivityType>;
  /** Filter by activity status. */
  filterStatus?: InputMaybe<ControlAgreementActivityStatus>;
};

/** ControlAgreementActivity represents a workflow activity with its full event timeline. */
export type ControlAgreementActivity = {
  __typename: 'ControlAgreementActivity';
  /** The asset amounts associated with this activity. Only set for increase and decrease activities. */
  amounts: Maybe<Array<Amount>>;
  /**
   * Present if the requesting user has an outstanding action on this activity (a
   * click-button approval or a quorum/mobile endorsement pending for a party they
   * represent); null if there's nothing for the viewer to do.
   *
   * Null once the user has personally endorsed the pending operation, even while that
   * operation is still gathering the rest of its quorum.
   */
  callToAction: Maybe<CallToAction>;
  /** The control agreement this activity is associated with, if any. */
  controlAgreementID: Maybe<Scalars['ID']['output']>;
  /** When the activity was created. */
  createdAt: Scalars['Time']['output'];
  /** The delegation this activity is associated with, if any. */
  delegationID: Maybe<Scalars['ID']['output']>;
  /**
   * When the activity's window closes. An increase, decrease or settlement still awaiting
   * approvals or its funding gate expires then; null for other types, including seizes, and
   * for terminal activities.
   */
  expiresAt: Maybe<Scalars['Time']['output']>;
  /** The unique identifier of the activity. */
  id: Scalars['ID']['output'];
  /**
   * The initiator of this activity, containing both the user and their party role.
   * Null when no initiator is recorded (e.g. system-triggered activities).
   */
  initiator: Maybe<GDFActivityInitiator>;
  /** The state diagram for this activity's timeline. */
  simpleActivityStateDiagram: Array<SimpleStateDiagramItem>;
  /** The current status of the activity. */
  status: ControlAgreementActivityStatus;
  /** The type of activity, as the requesting user's party reads it. */
  type: ControlAgreementActivityType;
  /**
   * The display label for the activity type, as the requesting user's party reads it
   * (e.g. "Create OES agreement", "Pledge").
   */
  typeLabel: Scalars['String']['output'];
  /** When the activity was last updated. */
  updatedAt: Scalars['Time']['output'];
  /**
   * Whether the requesting user should be shown the click-button (Approve/Reject) action for
   * this activity: true iff a party the user represents is a required clickButton approver for
   * this activity and that approval is the one currently pending.
   */
  viewerClickButtonApprovalPending: Scalars['Boolean']['output'];
  /**
   * Wallet and amount pairs for each item in this activity.
   * Always populated when wallet amounts exist on the activity.
   * For secured party users, wallet is null (amounts only, no identifying wallet information).
   * For a settlement, these are the caller's own legs, positive received and negative sent, with
   * each wallet set. Before the settlement names the caller's wallets, wallet is null; staff see
   * the pledgor's legs.
   */
  walletAmounts: Maybe<Array<WalletAmount>>;
};

/** ControlAgreementActivityConnection is a paginated list of activities. */
export type ControlAgreementActivityConnection = {
  __typename: 'ControlAgreementActivityConnection';
  /** A list of edges. */
  edges: Array<ControlAgreementActivityEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** ControlAgreementActivityEdge wraps a ControlAgreementActivity node with its pagination cursor. */
export type ControlAgreementActivityEdge = {
  __typename: 'ControlAgreementActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The activity at the end of the edge. */
  node: ControlAgreementActivity;
};

/**
 * ControlAgreementActivityStatus says whose turn an activity is, or how it ended. The initiating
 * side is the initiator's party, or the pledgor's when Anchorage staff initiated.
 */
export enum ControlAgreementActivityStatus {
  /** The other side's step is current: its approval is being gathered. */
  APPROVED = 'APPROVED',
  /**
   * An increase is waiting for the pledgor's funds to be locked, after the pledgor's approval and
   * before any later approver decides.
   */
  AWAITING_FUNDS = 'AWAITING_FUNDS',
  /** The activity's run was canceled before it finished, as terminating its control agreement does. */
  CANCELED = 'CANCELED',
  /** Activity has completed successfully. */
  COMPLETED = 'COMPLETED',
  /** Activity has failed. */
  FAILED = 'FAILED',
  /** Every approval is in and the change is being applied. */
  PENDING = 'PENDING',
  /**
   * The initiating side's step is current: its approval is being gathered, or nothing past the
   * proposal is done yet.
   */
  PROPOSED = 'PROPOSED',
  /** A party rejected the activity, or its window closed before every approver decided. */
  REJECTED = 'REJECTED',
  /**
   * A secured-party proposal is waiting for the pledgor to select the wallets it applies to,
   * before the pledgor approves it.
   */
  SELECT_WALLETS = 'SELECT_WALLETS'
}

/**
 * ControlAgreementActivityType represents the type of workflow activity, as the requesting
 * user's party reads it: a delegation increase is a PLEDGE to the pledgor and a SECURE to the
 * secured party, a decrease an UNLOCK to the pledgor and a RELEASE to the secured party. Any
 * form is accepted as a filter input.
 */
export enum ControlAgreementActivityType {
  /** Activity to amicably close a control agreement. */
  AMICABLE_CLOSE = 'AMICABLE_CLOSE',
  /**
   * Activity representing a Notice to Contest — the CA's quorum policy was
   * atomically switched to Joint-only and the CA transitioned to In Dispute.
   */
  CONTESTED = 'CONTESTED',
  /** Activity to create a new control agreement. */
  CREATE_CONTROL_AGREEMENT = 'CREATE_CONTROL_AGREEMENT',
  /**
   * Activity to create a new control agreement from an OES (Off-Exchange Settlement)
   * exchange terms profile.
   */
  CREATE_OES_AGREEMENT = 'CREATE_OES_AGREEMENT',
  /**
   * Activity to decrease delegation within a control agreement, as read by a user who
   * represents neither party (staff).
   */
  DECREASE_DELEGATION = 'DECREASE_DELEGATION',
  /**
   * Activity to increase delegation within a control agreement, as read by a user who
   * represents neither party (staff).
   */
  INCREASE_DELEGATION = 'INCREASE_DELEGATION',
  /** Activity to increase delegation within a control agreement, as a pledgor reads it. */
  PLEDGE = 'PLEDGE',
  /** Activity to decrease delegation within a control agreement, as a secured party reads it. */
  RELEASE = 'RELEASE',
  /** Activity to increase delegation within a control agreement, as a secured party reads it. */
  SECURE = 'SECURE',
  /**
   * Activity representing a WPA execute (redemption) — the secured party
   * seizes pledged assets under a withdraw prior authorization.
   */
  SEIZE = 'SEIZE',
  /**
   * Activity representing a delegation settlement — assets are settled directly
   * between the delegation and the secured party by mutual authorization.
   */
  SETTLE = 'SETTLE',
  /** Activity to terminate a control agreement. */
  TERMINATE = 'TERMINATE',
  /** Activity to decrease delegation within a control agreement, as a pledgor reads it. */
  UNLOCK = 'UNLOCK'
}

/**
 * Input for adjusting assets in a control agreement delegation.
 * Uses standard federated Amount types and patterns.
 * The combination of walletID + assetTypeID (from amountDelta) identifies which asset to adjust.
 */
export type ControlAgreementAssetAdjustmentInput = {
  /**
   * The amount delta to apply (uses standard AmountInput).
   * For creation: must be positive (e.g., value: "100.5")
   * For increase: must be positive (e.g., value: "50.0")
   * For decrease: must be negative (e.g., value: "-25.0")
   */
  amountDelta: AmountInput;
  /**
   * The unique wallet ID within the delegator's vault.
   * Combined with assetTypeID to identify which asset to create/adjust.
   * Required unless the secured party initiates. Must be omitted when the secured party
   * initiates: the pledgor selects the wallets afterwards.
   */
  walletID?: InputMaybe<Scalars['String']['input']>;
};

/** Control agreement configuration (output) */
export type ControlAgreementConfig = {
  __typename: 'ControlAgreementConfig';
  /** Actions configuration */
  actions: ControlAgreementActions;
  /**
   * When true, permits the pledgor's source wallet address to be disclosed to the
   * secured party. A negotiated term of the control agreement. Defaults to false.
   */
  pledgorAddressDisclosure: Scalars['Boolean']['output'];
  /** Config version */
  version: Scalars['Int']['output'];
};

/** Control agreement configuration (input) */
export type ControlAgreementConfigInput = {
  /** Actions configuration */
  actions: ControlAgreementActionsInput;
  /**
   * When true, permits the pledgor's source wallet address to be disclosed to the
   * secured party. A negotiated term of the control agreement. Omitted or null
   * means false.
   */
  pledgorAddressDisclosure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Config version */
  version: Scalars['Int']['input'];
};

/** Summary statistics for control agreements showing total pledged amounts */
export type ControlAgreementSummaryStats = {
  __typename: 'ControlAgreementSummaryStats';
  /**
   * Control agreements visible to the requesting user, with the same list and
   * scoping as the gdfControlAgreements query. Exposed here so a dashboard can
   * fetch summary stats, balance history, and the agreement list in one query.
   */
  controlAgreements: GDFControlAgreementConnection;
  /** Per-participant summaries for all enrolled participants visible to the user */
  enrolledParticipantStats: Array<ParticipantSummary>;
  /**
   * Organization-level summary.
   * For STAFF: organizationID="" and organizationName="Anchorage" with grand totals.
   * For ORG users: their organization's ID, name, and totals.
   */
  orgStats: OrganizationSummary;
};


/** Summary statistics for control agreements showing total pledged amounts */
export type ControlAgreementSummaryStatscontrolAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterStatus?: InputMaybe<GDFControlAgreementStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Extra parameters for cosmos */
export type CosmosExtraParams = {
  __typename: 'CosmosExtraParams';
  /** memo to use in transaction */
  memo: Maybe<Scalars['String']['output']>;
};

/** Paginated CSV response for the costBasisDepositsCsv query */
export type CostBasisDepositsCsvConnection = {
  __typename: 'CostBasisDepositsCsvConnection';
  /**
   * UTF-8 CSV string for the current page. Includes a header row plus one row per lot
   * (one row for deposits without lots) for up to `first`/`last` deposits.
   */
  csv: Scalars['String']['output'];
  /**
   * Number of deposits in `csv`. Can be lower than `first` because a page ends early,
   * after a whole deposit, to keep the file under the cost basis upload size limit.
   */
  depositCount: Scalars['Int']['output'];
  /** Pagination information for requesting subsequent pages. */
  pageInfo: PageInfo;
};

/** Cost Basis Job represents a cost basis import job for an organization */
export type CostBasisJob = {
  __typename: 'CostBasisJob';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  errorCsvPath: Maybe<Scalars['String']['output']>;
  metadata: CostBasisJobMetaData;
  status: CostBasisJobStatus;
  updatedAt: Maybe<Scalars['Time']['output']>;
  uploadedCsvPath: Maybe<Scalars['String']['output']>;
};

/** Metadata for a cost basis job containing validation counts */
export type CostBasisJobMetaData = {
  __typename: 'CostBasisJobMetaData';
  invalidDepositCount: Scalars['Int']['output'];
  totalRowCount: Scalars['Int']['output'];
  validDepositCount: Scalars['Int']['output'];
};

/** Status of a cost basis job */
export enum CostBasisJobStatus {
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  WITH_ERRORS = 'WITH_ERRORS'
}

/** Filter criteria for listing counterparties */
export type CounterpartiesV2ListFilter = {
  /** Includes only counterparties with this active state */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * List of kinds of eligible counterparties
   * @deprecated use kindsV2
   */
  kinds?: InputMaybe<Array<CounterpartyKind>>;
  /** List of kinds of eligible counterpartiesV2 */
  kindsV2?: InputMaybe<Array<CounterpartyKindV2>>;
  /** List of names for eligible counterparties */
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Response type for listing counterparties */
export type CounterpartiesV2ListResponse = {
  __typename: 'CounterpartiesV2ListResponse';
  /** Paginated list of counterparties retrieved based on filter and pagination */
  counterparties: Array<CounterpartyV2>;
  /** Pagination information for the response */
  paginationInfo: PageInfo;
};

/** Counterparty information */
export type Counterparty = {
  __typename: 'Counterparty';
  /** createdAt is the timestamp of creation of this record */
  createdAt: Scalars['Timestamp']['output'];
  /** createdBy is the email of the user who created this record */
  createdBy: Scalars['String']['output'];
  /** Display name of the counterparty */
  displayName: Scalars['String']['output'];
  /** Counterparty identifier */
  id: Scalars['ID']['output'];
  /** Whether a counterparty is active or not */
  isActive: Scalars['Boolean']['output'];
  /** Kind of counterparty */
  kind: CounterpartyKind;
  /** Counterparty internal name */
  name: Scalars['String']['output'];
  /** updatedAt is the timestamp of the latest update of this record */
  updatedAt: Scalars['Timestamp']['output'];
  /** updatedBy is the email of the user who last updated this record */
  updatedBy: Scalars['String']['output'];
};

export type CounterpartyAccount = {
  __typename: 'CounterpartyAccount';
  /** @deprecated use CounterpartyKindV2 */
  CounterpartyKind: Maybe<CounterpartyKind>;
  CounterpartyKindV2: Maybe<CounterpartyKindV2>;
  active: Scalars['Boolean']['output'];
  counterpartyId: Scalars['ID']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  displayName: Maybe<Scalars['String']['output']>;
  entity: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationId: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type CounterpartyAccountsFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  counterpartyAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  counterpartyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use kindsV2 */
  kinds?: InputMaybe<Array<CounterpartyKind>>;
  kindsV2?: InputMaybe<Array<CounterpartyKindV2>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CounterpartyAccountsListResponse = {
  __typename: 'CounterpartyAccountsListResponse';
  accounts: Array<CounterpartyAccount>;
  paginationInfo: PageInfo;
};

/** Counterparty Analysis (LexisNexis) */
export type CounterpartyAnalysis = {
  __typename: 'CounterpartyAnalysis';
  /** resultId is an id to search the counterparty */
  resultId: Scalars['String']['output'];
  /** score represents the risk assessment of the address */
  score: TransactionRiskScore;
  /** status is the status of the request (e.g: PENDING,UNSUPPORTED,FAILURE) */
  status: RiskRequestStatus;
  /** analysisType is the type of analysis (e.g: CounterpartyCheck) */
  type: RiskAnalysisType;
  /** vendor is the enum value for the analysis vendor (e.g: LexisNexis) */
  vendor: RiskAnalysisVendor;
};

/** Counterparty connection */
export type CounterpartyConnection = {
  __typename: 'CounterpartyConnection';
  /** List of edges containing counterparty and cursor information */
  edges: Array<CounterpartyEdge>;
  /** Page details for the associated list of counterparties */
  pageInfo: PageInfo;
};

/** Counterparty pagination edge */
export type CounterpartyEdge = {
  __typename: 'CounterpartyEdge';
  /** Cursor for the associated Counterparty. */
  cursor: Scalars['String']['output'];
  /** Counterparty. */
  node: Counterparty;
};

/** Possible counterparty kinds */
export enum CounterpartyKind {
  /** Represents a customer */
  CUSTOMER = 'CUSTOMER',
  /** Represents a dealer */
  DEALER = 'DEALER',
  /** Represents an exchange */
  EXCHANGE = 'EXCHANGE',
  /** Represents a house */
  HOUSE = 'HOUSE',
  /** Represents an invalid kind */
  INVALID = 'INVALID'
}

/** Possible counterparty kinds */
export enum CounterpartyKindV2 {
  /** Represents a customer */
  CUSTOMER = 'CUSTOMER',
  /** Represents a dealer */
  DEALER = 'DEALER',
  /** Represents an exchange */
  EXCHANGE = 'EXCHANGE',
  /** Represents a house */
  HOUSE = 'HOUSE',
  /** Represents an invalid kind */
  INVALID = 'INVALID',
  /** Represents a location */
  LOCATION = 'LOCATION'
}

export type CounterpartyMasterCopyFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  legalNames?: InputMaybe<Array<Scalars['String']['input']>>;
  leis?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CounterpartyScreeningEntry = Node & {
  __typename: 'CounterpartyScreeningEntry';
  /** ID passed from caller, useful for batch requests and linking */
  callerID: Scalars['String']['output'];
  /** Person or entity data being screened */
  counterpartyData: Scalars['JSON']['output'];
  /** Timestamp when the record was created */
  createdAt: Scalars['Time']['output'];
  /** Type of the counterparty entry */
  entryType: CounterpartyScreeningEntryEntryType;
  /** External provider used for screening */
  externalProvider: CounterpartyScreeningEntryExternalProvider;
  /** External provider's result ID for follow-ups (e.g., lexis_nexis_alert_id, trm_id */
  externalProviderResultID: Maybe<Scalars['String']['output']>;
  /** Extra context for the screening entry */
  extraContext: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  /** Screening result score */
  score: CounterpartyScreeningEntryScore;
  /** Service identifier for the screening entry */
  serviceIdentifier: Scalars['String']['output'];
  /** Timestamp when the record was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type CounterpartyScreeningEntryConnection = {
  __typename: 'CounterpartyScreeningEntryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CounterpartyScreeningEntryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CounterpartyScreeningEntryEdge = {
  __typename: 'CounterpartyScreeningEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CounterpartyScreeningEntry>;
};

/** CounterpartyScreeningEntryEntryType is enum for the field entry_type */
export enum CounterpartyScreeningEntryEntryType {
  LEGAL = 'LEGAL',
  NATURAL = 'NATURAL',
  UNKNOWN = 'UNKNOWN'
}

/** CounterpartyScreeningEntryExternalProvider is enum for the field external_provider */
export enum CounterpartyScreeningEntryExternalProvider {
  LEXIS_NEXIS = 'LEXIS_NEXIS',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** Ordering options for CounterpartyScreeningEntry connections */
export type CounterpartyScreeningEntryOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order CounterpartyScreeningEntries. */
  field: CounterpartyScreeningEntryOrderField;
};

/** Properties by which CounterpartyScreeningEntry connections can be ordered. */
export enum CounterpartyScreeningEntryOrderField {
  CREATED_AT = 'CREATED_AT',
  SCORE = 'SCORE',
  UPDATED_AT = 'UPDATED_AT'
}

/** CounterpartyScreeningEntryScore is enum for the field score */
export enum CounterpartyScreeningEntryScore {
  ALERT = 'ALERT',
  DANGER = 'DANGER',
  INITIATED = 'INITIATED',
  SAFE = 'SAFE'
}

/**
 * CounterpartyScreeningEntryWhereInput is used for filtering CounterpartyScreeningEntry objects.
 * Input was generated by ent.
 */
export type CounterpartyScreeningEntryWhereInput = {
  and?: InputMaybe<Array<CounterpartyScreeningEntryWhereInput>>;
  /** caller_id field predicates */
  callerID?: InputMaybe<Scalars['String']['input']>;
  callerIDContains?: InputMaybe<Scalars['String']['input']>;
  callerIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  callerIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  callerIDGT?: InputMaybe<Scalars['String']['input']>;
  callerIDGTE?: InputMaybe<Scalars['String']['input']>;
  callerIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  callerIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  callerIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  callerIDLT?: InputMaybe<Scalars['String']['input']>;
  callerIDLTE?: InputMaybe<Scalars['String']['input']>;
  callerIDNEQ?: InputMaybe<Scalars['String']['input']>;
  callerIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** entry_type field predicates */
  entryType?: InputMaybe<CounterpartyScreeningEntryEntryType>;
  entryTypeIn?: InputMaybe<Array<CounterpartyScreeningEntryEntryType>>;
  entryTypeNEQ?: InputMaybe<CounterpartyScreeningEntryEntryType>;
  entryTypeNotIn?: InputMaybe<Array<CounterpartyScreeningEntryEntryType>>;
  /** external_provider field predicates */
  externalProvider?: InputMaybe<CounterpartyScreeningEntryExternalProvider>;
  externalProviderIn?: InputMaybe<Array<CounterpartyScreeningEntryExternalProvider>>;
  externalProviderNEQ?: InputMaybe<CounterpartyScreeningEntryExternalProvider>;
  externalProviderNotIn?: InputMaybe<Array<CounterpartyScreeningEntryExternalProvider>>;
  /** external_provider_result_id field predicates */
  externalProviderResultID?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDContains?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDGT?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalProviderResultIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalProviderResultIDLT?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalProviderResultIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalProviderResultIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_requests edge predicates */
  hasExternalRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasExternalRequestsWith?: InputMaybe<Array<ExternalScreeningRequestWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CounterpartyScreeningEntryWhereInput>;
  or?: InputMaybe<Array<CounterpartyScreeningEntryWhereInput>>;
  /** score field predicates */
  score?: InputMaybe<CounterpartyScreeningEntryScore>;
  scoreIn?: InputMaybe<Array<CounterpartyScreeningEntryScore>>;
  scoreNEQ?: InputMaybe<CounterpartyScreeningEntryScore>;
  scoreNotIn?: InputMaybe<Array<CounterpartyScreeningEntryScore>>;
  /** service_identifier field predicates */
  serviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierContains?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierGT?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierGTE?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierIn?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceIdentifierLT?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierLTE?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierNEQ?: InputMaybe<Scalars['String']['input']>;
  serviceIdentifierNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A counterparty entity in the trading system */
export type CounterpartyV2 = {
  __typename: 'CounterpartyV2';
  /** Activity status of the counterparty */
  active: Scalars['Boolean']['output'];
  /** Time at which the counterparty was created */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the counterparty */
  createdBy: Scalars['String']['output'];
  /** Display name of the counterparty */
  displayName: Scalars['String']['output'];
  /** UUID keying the counterparty */
  id: Scalars['ID']['output'];
  /**
   * Exact type of the counterparty
   * @deprecated use kindV2
   */
  kind: CounterpartyKind;
  /** Exact type of the counterpartyv2 */
  kindV2: CounterpartyKindV2;
  /** Map of arbitrary JSON values */
  metadata: Maybe<Scalars['String']['output']>;
  /** Name of the counterparty */
  name: Scalars['String']['output'];
  /** UUID that identifies this as a child of another counterparty */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Time at which the counterparty was last updated */
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Last person who updated the counterparty */
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** CounterpartyWithErr represents a counterparty with an error message */
export type CounterpartyWithErr = {
  __typename: 'CounterpartyWithErr';
  /** Counterparty information */
  counterparty: Maybe<Counterparty>;
  /** Error message */
  err: Maybe<Scalars['String']['output']>;
};

/** Country holds country information */
export type Country = {
  __typename: 'Country';
  /** Two letter code of the country */
  code: Scalars['String']['output'];
  /** Name of the country */
  name: Scalars['String']['output'];
};

/**
 * Why one createA1TradeSubscription input was not created. reason is always a
 * client-safe message, never a raw internal error.
 */
export type CreateA1TradeSubscriptionFailure = {
  __typename: 'CreateA1TradeSubscriptionFailure';
  assetTypeId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  subaccountId: Scalars['ID']['output'];
};

export type CreateA1TradeSubscriptionInput = {
  amount: Scalars['Decimal']['input'];
  /**
   * Canonical asset type ID (e.g. "BTC", "XRP"), not a ticker/abbreviation. Also
   * determines the derived roster ID (DWP_<assetTypeId>_ROSTER).
   */
  assetTypeId: Scalars['String']['input'];
  subaccountId: Scalars['ID']['input'];
};

export type CreateA1TradeSubscriptionResult = {
  __typename: 'CreateA1TradeSubscriptionResult';
  failed: Array<CreateA1TradeSubscriptionFailure>;
  succeeded: Array<A1TradeSubscription>;
};

export type CreateAccountCSAInput = {
  accountId: Scalars['ID']['input'];
  csaId: Scalars['ID']['input'];
};

export type CreateAccountNettingSetInput = {
  accountId: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  nettingSetId: Scalars['ID']['input'];
};

export type CreateAndLinkSubaccountWalletInput = {
  /**
   * Canonical asset type ID (e.g. "BTC", "ETH"), not a ticker/abbreviation. Determines
   * the wallet's network; an unknown asset type is rejected.
   */
  assetTypeId: Scalars['String']['input'];
  subaccountId: Scalars['ID']['input'];
};

export type CreateAndLinkSubaccountWalletResult = {
  __typename: 'CreateAndLinkSubaccountWalletResult';
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type CreateAssetInput = {
  /** Optional metadata for the asset */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** The name of the asset */
  name: Scalars['String']['input'];
  /** The symbol of the asset */
  symbol: Scalars['String']['input'];
};

export type CreateCSAInput = {
  accountId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Time']['input']>;
  ironcladUrl?: InputMaybe<Scalars['String']['input']>;
  isdaAgreementId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  pricingSource?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Time']['input'];
  type: DVCSAType;
  valuationAgent: DVPartyType;
  variableImApplies?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCSAMarginTermsInput = {
  csaId: Scalars['ID']['input'];
  currency: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Time']['input']>;
  mta: Scalars['String']['input'];
  party: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  thresholdAmount?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCollateralRuleInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  concentrationLimitPercent?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  nettingSetId: Scalars['ID']['input'];
  purpose: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Time']['input']>;
  valuationPercentage?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a control agreement */
export type CreateControlAgreementInput = {
  /** Control agreement configuration. If not provided, uses the default control agreement configuration. */
  config?: InputMaybe<ControlAgreementConfigInput>;
  /** Input to create a Pledgor delegation within the Control Agreement */
  delegation?: InputMaybe<DelegationInput>;
  /** Optional document ID associated with the control agreement */
  documentID?: InputMaybe<Scalars['ID']['input']>;
  /** Idempotency Key for safe retries */
  idempotencyKey: Scalars['String']['input'];
  /** Name of the control agreement */
  name: Scalars['String']['input'];
  /** The Atlas participant ID of the pledgor */
  pledgorAtlasParticipantID: Scalars['ID']['input'];
  /** The policy vault ID for the pledgor's ratification */
  pledgorRatifyingPolicyVaultID: Scalars['String']['input'];
  /** The Atlas participant ID of the secured party */
  securedPartyAtlasParticipantID: Scalars['ID']['input'];
  /** The policy vault ID for the secured party's ratification */
  securedPartyRatifyingPolicyVaultID: Scalars['String']['input'];
};

/** Response after starting the create control agreement async process */
export type CreateControlAgreementResponse = {
  __typename: 'CreateControlAgreementResponse';
  /** Idempotency Key for safe retries */
  idempotencyKey: Scalars['String']['output'];
};

export type CreateCounterpartyAccountInput = {
  active: Scalars['Boolean']['input'];
  counterpartyId: Scalars['ID']['input'];
  entity: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * metadata is a json map of account metadata
   * For A1_DERIVATIVES accounts, add elwood related fields with keys
   * as defined in tradingdataprovider.CounterpartyAccountMetadataKey
   */
  metadata?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Input for creating a counterparty */
export type CreateCounterpartyInput = {
  /** Activity status of the counterparty */
  active: Scalars['Boolean']['input'];
  /** Display name of the counterparty */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** UUID to be used to identify the counterparty */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind of the counterparty @deprecated(reason: "Use kindV2") */
  kind?: InputMaybe<CounterpartyKind>;
  /** KindV2 of the counterparty. This will override kind when populated */
  kindV2?: InputMaybe<CounterpartyKindV2>;
  /** JSON Metadata for the counterparty */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Name of the counterparty */
  name: Scalars['String']['input'];
  /** UUID of the parent counterparty */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCounterpartyMasterCopyInput = {
  accountControlAgreementExecuted?: InputMaybe<Scalars['String']['input']>;
  accountControlAgreementRequired?: InputMaybe<Scalars['Boolean']['input']>;
  anchorageEntity?: InputMaybe<Scalars['String']['input']>;
  annexAQuestionnaireReceivedDate?: InputMaybe<Scalars['Date']['input']>;
  approverDate?: InputMaybe<Scalars['Date']['input']>;
  approverName?: InputMaybe<Scalars['String']['input']>;
  bilateralAgreementExecutedDate?: InputMaybe<Scalars['Date']['input']>;
  countryOfIncorporation?: InputMaybe<Scalars['String']['input']>;
  creditQuestionnaireReceivedDate?: InputMaybe<Scalars['Date']['input']>;
  crossBorderMarginClassification?: InputMaybe<Scalars['String']['input']>;
  csaRequired?: InputMaybe<Scalars['Boolean']['input']>;
  designatedEvaluationAgent?: InputMaybe<Scalars['String']['input']>;
  dfComplianceRoute?: InputMaybe<Scalars['String']['input']>;
  dfProtocolAdherenceIdP1?: InputMaybe<Scalars['String']['input']>;
  dfProtocolAdherenceIdP2?: InputMaybe<Scalars['String']['input']>;
  dfProtocolReconciliation?: InputMaybe<Scalars['String']['input']>;
  disclosurePackAccessGranted?: InputMaybe<Scalars['Boolean']['input']>;
  ecpCategory?: InputMaybe<Scalars['String']['input']>;
  ecpEvidenceDocReference?: InputMaybe<Scalars['String']['input']>;
  ecpVerificationResult?: InputMaybe<Scalars['String']['input']>;
  endUserExceptionFilingRoute?: InputMaybe<Scalars['String']['input']>;
  endUserExceptionStandingElection?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionSubstitutedCompliance?: InputMaybe<Scalars['String']['input']>;
  exemptionType?: InputMaybe<Scalars['String']['input']>;
  fcsSubsidiaryOfUsParent?: InputMaybe<Scalars['Boolean']['input']>;
  federalEntity?: InputMaybe<Scalars['Boolean']['input']>;
  feuDetermination?: InputMaybe<Scalars['String']['input']>;
  financialCompanyTitleIi?: InputMaybe<Scalars['Boolean']['input']>;
  financialEntityStatus?: InputMaybe<Scalars['Boolean']['input']>;
  goodToTrade?: InputMaybe<Scalars['Boolean']['input']>;
  goodToTradeDate?: InputMaybe<Scalars['Date']['input']>;
  guaranteedByUsPerson?: InputMaybe<Scalars['Boolean']['input']>;
  guarantorAddress?: InputMaybe<Scalars['String']['input']>;
  guarantorExists?: InputMaybe<Scalars['Boolean']['input']>;
  guarantorLei?: InputMaybe<Scalars['String']['input']>;
  guarantorName?: InputMaybe<Scalars['String']['input']>;
  imSegregationAccountReference?: InputMaybe<Scalars['String']['input']>;
  imSegregationCustodian?: InputMaybe<Scalars['String']['input']>;
  imSegregationElection?: InputMaybe<Scalars['Boolean']['input']>;
  initialMarginCsaExecuted?: InputMaybe<Scalars['String']['input']>;
  institutionalSuitabilitySafeHarborBasis?: InputMaybe<Scalars['String']['input']>;
  insuredDepositoryInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  internalCounterpartyId?: InputMaybe<Scalars['String']['input']>;
  isdaMasterAgreementExecuted?: InputMaybe<Scalars['Boolean']['input']>;
  isdaScheduleExecuted?: InputMaybe<Scalars['Boolean']['input']>;
  kycCustomerTypePrimary?: InputMaybe<Scalars['String']['input']>;
  kycCustomerTypeSecondary?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  lei?: InputMaybe<Scalars['String']['input']>;
  marginExemptionElections?: InputMaybe<Scalars['String']['input']>;
  marginRegime?: InputMaybe<Scalars['String']['input']>;
  materialSwapsExposure?: InputMaybe<Scalars['Boolean']['input']>;
  mseRiderAsOfDate?: InputMaybe<Scalars['Date']['input']>;
  mseRiderStatus?: InputMaybe<Scalars['String']['input']>;
  mseStatus?: InputMaybe<Scalars['String']['input']>;
  nonFeuRepresentation?: InputMaybe<Scalars['Boolean']['input']>;
  nonUsMarginRegimeInScope?: InputMaybe<Scalars['Boolean']['input']>;
  noticesEmail?: InputMaybe<Scalars['String']['input']>;
  notificationsDisclosuresEmail?: InputMaybe<Scalars['String']['input']>;
  portfolioDataEmail?: InputMaybe<Scalars['String']['input']>;
  portfolioReconciliationMethod?: InputMaybe<Scalars['String']['input']>;
  ppobLocation?: InputMaybe<Scalars['String']['input']>;
  preparerDate?: InputMaybe<Scalars['Date']['input']>;
  preparerName?: InputMaybe<Scalars['String']['input']>;
  principalAgentCapacity?: InputMaybe<Scalars['String']['input']>;
  reconcileAgainstSdrDataAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  reportingPartyAgreementDate?: InputMaybe<Scalars['Date']['input']>;
  reportingPartyAgreementDocReference?: InputMaybe<Scalars['String']['input']>;
  reportingPartyAgreementMethod?: InputMaybe<Scalars['String']['input']>;
  reportingPartyNegotiationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reportingPartyOutcome?: InputMaybe<Scalars['String']['input']>;
  riskValuationDisputeResolution?: InputMaybe<Scalars['String']['input']>;
  riskValuationEmail?: InputMaybe<Scalars['String']['input']>;
  sdlPartsReturned?: InputMaybe<Scalars['String']['input']>;
  sdlReceivedDate?: InputMaybe<Scalars['Date']['input']>;
  sdlSentDate?: InputMaybe<Scalars['Date']['input']>;
  sdlSignatoryName?: InputMaybe<Scalars['String']['input']>;
  sdlSignatoryTitle?: InputMaybe<Scalars['String']['input']>;
  specialEntityReview?: InputMaybe<Scalars['String']['input']>;
  thirdPartyControlPerson?: InputMaybe<Scalars['String']['input']>;
  tradeReportingEngineUpdatedDate?: InputMaybe<Scalars['Date']['input']>;
  tradingAuthorizationDocReference?: InputMaybe<Scalars['String']['input']>;
  tradingAuthorizationStatus?: InputMaybe<Scalars['String']['input']>;
  tradingSupervisorCountries?: InputMaybe<Scalars['String']['input']>;
  tradingSupervisors?: InputMaybe<Scalars['String']['input']>;
  ultimateUsParentName?: InputMaybe<Scalars['String']['input']>;
  usPersonConduit?: InputMaybe<Scalars['Boolean']['input']>;
  usPersonFinal?: InputMaybe<Scalars['String']['input']>;
  usPersonStatus?: InputMaybe<Scalars['String']['input']>;
  variationMarginCsaExecuted?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new custodian. */
export type CreateCustodianInput = {
  active: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  fax: Scalars['String']['input'];
  isPrimary: Scalars['Boolean']['input'];
  mailingAddress: Scalars['String']['input'];
  microtransaction: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  requireWetSignature: Scalars['Boolean']['input'];
  transferTypes: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CreateDVAccountInput = {
  /** Contact email addresses */
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ignored. The account's own id is stored. */
  counterpartyId?: InputMaybe<Scalars['ID']['input']>;
  /** Counterparty master copy to link this account to */
  counterpartyMasterCopyId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to the account name when null or empty. */
  counterpartyName?: InputMaybe<Scalars['String']['input']>;
  /** The country code (ISO 3166-1 alpha-2) */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Fixing source pre-filled on trades ingested for this account: CME, DERIBIT or ANCHORAGE. Requires a BASE or QUOTE defaultSettlementType. Omit or pass an empty string to leave it unset. */
  defaultFixingSource?: InputMaybe<Scalars['String']['input']>;
  /** Stages trades ingested for this account as post-priced when true. Defaults to false. */
  defaultPostPriced?: InputMaybe<Scalars['Boolean']['input']>;
  /** Premium timing pre-filled on trades ingested for this account: UPFRONT or AT_EXPIRY. Requires defaultPremiumCurrencyType. Omit or pass an empty string to leave it unset. */
  defaultPremiumCurrencyTimingType?: InputMaybe<Scalars['String']['input']>;
  /** Premium currency type pre-filled on trades ingested for this account: BASE or QUOTE. Omit or pass an empty string to leave it unset. */
  defaultPremiumCurrencyType?: InputMaybe<Scalars['String']['input']>;
  /** Settlement type pre-filled on trades ingested for this account: PHYSICAL, BASE or QUOTE. BASE and QUOTE require defaultFixingSource. Omit or pass an empty string to leave it unset. */
  defaultSettlementType?: InputMaybe<Scalars['String']['input']>;
  /** Whether the account is enabled for trading (defaults to true if not provided) */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Entity ID - the trading entity (A1 Derivatives, Swap Dealer, HedgeCo) this account faces */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** Haruko Mask */
  harukoMask?: InputMaybe<Scalars['String']['input']>;
  /** Haruko triparty venue ID, distinct from harukoVenueId */
  harukoTripartyVenueId?: InputMaybe<Scalars['Int']['input']>;
  /** Haruko Venue ID */
  harukoVenueId?: InputMaybe<Scalars['Int']['input']>;
  /** Stops all reporting of this account to ICE (Part 45 EOD and live trade reports) when true. Defaults to false. */
  iceReportingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legal Entity Identifier */
  legalEntityIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Date of master confirmation */
  masterConfirmationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Optional metadata for the account */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** The name of the account */
  name: Scalars['String']['input'];
  /** Org Key ID */
  organizationKeyId: Scalars['String']['input'];
  /** The name to report to the SDR. Only set this when SDR reporting is done on a party other than the papered account name; otherwise leave it null and the account name is reported. */
  sdrReportingName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDVCustodianInput = {
  /** The custodian/exchange name. Surrounding whitespace is trimmed; it must not be empty. */
  custodianName: Scalars['String']['input'];
};

export type CreateDVCustodianWalletInput = {
  /** The ID of the custodian holding the wallet */
  custodianId: Scalars['ID']['input'];
  /** The ID of the trading entity the wallet belongs to */
  entityId: Scalars['ID']['input'];
  /**
   * The wallet/account name, excluding the entity/custodian prefix (e.g. "Derivs Omni"). Surrounding
   * whitespace is trimmed; it must not be empty.
   */
  walletName: Scalars['String']['input'];
};

export type CreateDVEntityInput = {
  /** The name of the entity (e.g., "A1 Derivatives", "Swap Dealer", "HedgeCo") */
  entityName: Scalars['String']['input'];
  /** Haruko venue account this entity's trades are booked under */
  harukoVenueId: Scalars['Int']['input'];
  /** ICE company batch id this entity's SDR reports are submitted under */
  iceCompanyBatchId?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Identifier (LEI) */
  lei?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateDepositAttributionSpamThresholdInput is used for create DepositAttributionSpamThreshold object.
 * Input was generated by ent.
 */
export type CreateDepositAttributionSpamThresholdInput = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  threshold: Scalars['Decimal']['input'];
};

export type CreateDerivsEntityBankAccountInput = {
  /** 4 to 17 digits. */
  accountNumber: Scalars['String']['input'];
  bank: DerivsBank;
  bankadapterAccountId?: InputMaybe<Scalars['String']['input']>;
  entity: DerivsEntity;
  orgId: Scalars['String']['input'];
  partyAddress: DerivsPartyAddressInput;
  partyName: Scalars['String']['input'];
  /** Exactly 9 digits. */
  routingNumber: Scalars['String']['input'];
};

export type CreateDerivsEntityWalletInput = {
  asset: Scalars['String']['input'];
  entity: DerivsEntity;
  /** The custody OrganizationKeyID of the API key that owns the wallet. */
  orgId: Scalars['String']['input'];
  walletId: Scalars['String']['input'];
};

export type CreateDerivsEntityWalletPayload = {
  __typename: 'CreateDerivsEntityWalletPayload';
  entityWallet: DerivsEntityWallet;
};

export type CreateDerivsTransferInput = {
  /** A positive decimal string. */
  amount: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  destination: DerivsEntity;
  /** Required when the purpose is LOAN or REPAYMENT, rejected otherwise. */
  loanReference?: InputMaybe<Scalars['String']['input']>;
  purpose: DerivsTransferPurpose;
  /** Required when the purpose is OTHER, rejected otherwise. */
  purposeOtherText?: InputMaybe<Scalars['String']['input']>;
  /** Also the idempotency key of the transfer. */
  settlementRef: Scalars['String']['input'];
  source: DerivsEntity;
};

export type CreateDerivsTransferPayload = {
  __typename: 'CreateDerivsTransferPayload';
  transfer: DerivsTransfer;
};

export type CreateDerivsTrustedDestinationInput = {
  /** Exactly 4 digits. */
  accountLast4: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  /** The id of a fiat Trusted Destination the LABS custody organization can see. */
  custodyTrustedDestinationId: Scalars['String']['input'];
  destinationEntity: DerivsEntity;
};

/** Input for creating a new DocuSign workflow configuration. */
export type CreateDocuSignWorkflowInput = {
  custodianId?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type CreateDvStatementInput = {
  accountId: Scalars['ID']['input'];
  /**
   * The statement's valuation date, as a date only in the form YYYY-MM-DD, for example
   * "2026-10-29". The statement is valued at 4pm New York time on that date. A datetime,
   * or any other format, is rejected.
   *
   * When omitted or blank, it defaults to today's date once it is 4pm New York time or
   * later, and to yesterday's date before that.
   */
  coverageEnd?: InputMaybe<Scalars['DateTime']['input']>;
  coverageStart?: InputMaybe<Scalars['DateTime']['input']>;
  statementType: DvStatementType;
};

export type CreateDvStatementOutput = {
  __typename: 'CreateDvStatementOutput';
  /**
   * Shared across every statement produced by this call - not itself a
   * statement id. See internal/gql/resolvers/statement.go for how it's used.
   */
  requestId: Scalars['ID']['output'];
  statements: Array<DvStatement>;
};

export type CreateEECredential = {
  apiKey: Scalars['String']['input'];
  exchangeID: Scalars['ID']['input'];
  /** @deprecated Ignored. Removed once the atlas connect flow stops sending it. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** password for the API key may be required for authenticating to the exchange. */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * signingKey is the secret key shared between the user and the exchange in which
   * the exchange uses to validate the authencity of the request that was sent by the user to the exchange's API.
   *
   * Sometimes this is done with asymmetric keys, in which the user gives the exchnage its public key, othertimes its done with a symmetric key and HMAC.
   */
  signingKey: Scalars['String']['input'];
  /** userID for the exchange may be required for authenticating to the exchange. */
  userID?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Ignored. Removed once the atlas connect flow stops sending it. */
  vaultUniqueID?: InputMaybe<Scalars['String']['input']>;
};

/** CreateEECredentialResponse is the response for the createEECredential mutation */
export type CreateEECredentialResponse = {
  __typename: 'CreateEECredentialResponse';
  Credential: EEAPIKey;
  /** @deprecated Always empty. Removed once the atlas connect flow stops selecting it. */
  OperationID: Scalars['String']['output'];
};

export type CreateExposureResult = {
  __typename: 'CreateExposureResult';
  /** IDs of the newly created exposures, in input order */
  ids: Array<Scalars['ID']['output']>;
};

/** CreateFeeConfig represents a fee configuration used in the creation of a fee configuration */
export type CreateFeeConfig = {
  /** Period of the configured fee */
  feePeriod: FeePeriodType;
  /** Rate of the configured fee */
  feeRate: Scalars['Float']['input'];
  /** Target of the fee configuration */
  feeTarget: FeeTargetType;
  /** Target ID of the fee configuration */
  feeTargetID?: InputMaybe<Scalars['String']['input']>;
  /** Type of the configured fee */
  feeType: FeeTypeType;
  /** Is billable defines if we directly bill the target */
  isBillable: Scalars['Boolean']['input'];
  /** Org ID associated to the case */
  orgKeyID: Scalars['String']['input'];
  /** Start date of the configured fee */
  startDate: Scalars['Date']['input'];
};

/** Create fee recalculation input */
export type CreateFeeRecalculation = {
  /** Fee calculation ID associated with the recalculation */
  feeCalculationID: Scalars['String']['input'];
  /** Transaction ID associated with the fee calculation */
  transactionID: Scalars['String']['input'];
};

export type CreateHarukoBackfillRequestsInput = {
  /** End date (exclusive), ISO-8601 UTC date, e.g. "2026-04-30" */
  endDate: Scalars['Date']['input'];
  /** List of endpoints to backfill. */
  endpoints: Array<HarukoEndpoint>;
  /** Start date (inclusive), ISO-8601 UTC date, e.g. "2026-04-29" */
  startDate: Scalars['Date']['input'];
};

/** InstantTransferStandingInstruction represents a standing instruction for instant transfer */
export type CreateInstantTransferStandingInstruction = {
  /** Account ID for instant transfer */
  accountID: Scalars['String']['input'];
};

/**
 * Input for proposing a new otc.internal_movements row. Nothing posts until the maker-checker
 * request this produces reaches quorum.
 */
export type CreateInternalMovementInput = {
  /** This movement's amount — never negative, though zero is possible */
  amount: Scalars['String']['input'];
  /** The asset this movement is denominated in */
  assetId: Scalars['ID']['input'];
  /** The source custodian wallet of this cross-custodian movement — must belong to entityId */
  custodianWalletFromId: Scalars['ID']['input'];
  /**
   * The destination custodian wallet of this cross-custodian movement — must belong to entityId,
   * and differ from custodianWalletFromId
   */
  custodianWalletToId: Scalars['ID']['input'];
  /** Free-form description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The point in time this movement is effective as of */
  effectiveAt: Scalars['Time']['input'];
  /** The trading entity this movement is for */
  entityId: Scalars['ID']['input'];
  /**
   * The counterparty/venue fee charged on the movement, if any — optional (both feeAmount and
   * feeAssetId set, or neither). Never negative. Recordkeeping only.
   */
  feeAmount?: InputMaybe<Scalars['String']['input']>;
  /**
   * The asset feeAmount is denominated in — required iff feeAmount is set, often different from
   * assetId (e.g. a USDC transfer with a fee paid in ETH).
   */
  feeAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** Opt-in dedup key so a retried submit returns the original request instead of creating a duplicate */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Free-form metadata */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Free-form reference to an external record this movement is associated with, if any */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateKYCConfigInput is used for create KYCConfig object.
 * Input was generated by ent.
 */
export type CreateKYCConfigInput = {
  affiliateID: Scalars['String']['input'];
  clientID: Scalars['String']['input'];
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  relianceModel?: InputMaybe<KYCConfigRelianceModel>;
  termsAndConditionsDocusignTemplate?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsModel?: InputMaybe<KYCConfigTermsAndConditionsModel>;
};

/**
 * CreateKYCProcessInput is used for create KYCProcess object.
 * Input was generated by ent.
 */
export type CreateKYCProcessInput = {
  /** AffiliateID is the affiliate ID of the KYCProcess. */
  affiliateID: Scalars['ID']['input'];
  /** Description is the description of the KYCProcess. */
  description: Scalars['String']['input'];
  /** Name is the name of the KYCProcess. */
  name: Scalars['String']['input'];
};

/**
 * CreateKYCProcessTriggerInput is used for create KYCProcessTrigger object.
 * Input was generated by ent.
 */
export type CreateKYCProcessTriggerInput = {
  /** The actions to be executed when the trigger is fired. */
  actions?: InputMaybe<Array<KYCProcessTriggerActionInput>>;
  /** Type of the affiliate */
  affiliateType?: InputMaybe<Scalars['String']['input']>;
  /** Type of anchorage entity */
  anchorageEntityType?: InputMaybe<Scalars['String']['input']>;
  /** The conditions to be validated when the trigger is fired. */
  conditions?: InputMaybe<Array<KYCProcessTriggerConditionInput>>;
  /** The current state of the Jira case. */
  currentJiraState: Scalars['String']['input'];
  /** The type of the Jira case. */
  jiraCaseType: Scalars['String']['input'];
  /** The previous state of the Jira case. */
  previousJiraState?: InputMaybe<Scalars['String']['input']>;
  /** Priority of the process trigger */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateKYCQuestionInput is used for create KYCQuestion object.
 * Input was generated by ent.
 */
export type CreateKYCQuestionInput = {
  /** The categories of the questionnaire */
  categories: Array<Scalars['String']['input']>;
  /**
   * Customer types this question applies to (e.g. FUND, PROTOCOL, GOVERNMENT_ENTITY).
   * Empty means applicable to all customer types.
   */
  customerTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The information type of the questionnaire */
  informationType: Scalars['String']['input'];
  /** Name of the questionnaire */
  name: Scalars['String']['input'];
  /** The question definition of the questionnaire */
  questionDefinition: Scalars['String']['input'];
};

/**
 * CreateKYCQuestionnaireInput is used for create KYCQuestionnaire object.
 * Input was generated by ent.
 */
export type CreateKYCQuestionnaireInput = {
  /** The questionnaire element body, it's a JSON string of KYCQuestionnaireElement type */
  body: Scalars['String']['input'];
  /** The categories of the questionnaire */
  categories: Array<Scalars['String']['input']>;
  /** Number to days after which the questionnaire expires */
  expirationDays?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the questionnaire */
  name: Scalars['String']['input'];
  /** The type of the questionnaire */
  questionnaireType: KYCQuestionnaireType;
  /** The URL associated with the questionnaire */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** CreateKYCQuestionnaireSubmissionInput is the input for CreateKYCQuestionnaireSubmission. */
export type CreateKYCQuestionnaireSubmissionInput = {
  /** The case ID associated with the submission. */
  caseID?: InputMaybe<Scalars['String']['input']>;
  /** The description of the submission. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the KYC profile. */
  kycProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** The KYC profile type. */
  kycProfileType?: InputMaybe<KYCEntityType>;
  /** The name of the submission. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Free-form custom message stored on the submission. For RFI submissions, a non-empty value
   * renders as an "Introduction → Message → Message from Anchorage Digital" intro panel
   * at the top of the body.
   */
  notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * The identifier of the KYCProcess.
   * @deprecated Use kycProfileID + kycProfileType instead
   */
  processID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The identifier of the KYCQuestionnaire. Optional — when omitted, the submission is
   * created in INIT with a NULL questionnaire reference and an empty body, to be set later
   * via updateKYCQuestionnaireSubmission.
   */
  questionnaireID?: InputMaybe<Scalars['ID']['input']>;
  /** The representative to associate with the submission. */
  representative?: InputMaybe<RepresentativeInput>;
};

/**
 * CreateKYCQuestionnaireSubmissionRepresentativeInput is the representative input.
 *
 * Deprecated: use RepresentativeInput instead. Retained for backwards compatibility.
 */
export type CreateKYCQuestionnaireSubmissionRepresentativeInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/**
 * Input for proposing a new otc.ledger_transactions entry. Nothing posts to the ledger until the
 * maker-checker request this produces reaches quorum.
 */
export type CreateLedgerTransactionInput = {
  /** The account this entry belongs to */
  accountId: Scalars['ID']['input'];
  /**
   * The amount of this entry — never negative, though zero is possible — regardless of entry
   * type. Direction (DEBIT for bucketFrom, CREDIT for bucketTo) lives entirely in which of
   * bucketFrom/bucketTo is set, never in this value's sign.
   */
  amount: Scalars['String']['input'];
  /** The asset this entry is denominated in */
  assetId: Scalars['ID']['input'];
  /**
   * The bucket this entry debits. Required for WITHDRAWAL, INTEREST, and TRANSFER (where it's the
   * side the amount moves out of — bucketTo is where it lands); forbidden for DEPOSIT.
   */
  bucketFrom?: InputMaybe<DVLedgerBucket>;
  /**
   * The bucket this entry credits. Required for DEPOSIT and TRANSFER (where it's the side the
   * amount lands, on the same account as bucketFrom); forbidden for WITHDRAWAL and INTEREST.
   */
  bucketTo?: InputMaybe<DVLedgerBucket>;
  /** The custodian wallet this entry is associated with, if any */
  custodianWalletId?: InputMaybe<Scalars['ID']['input']>;
  /** Free-form description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The point in time this entry is effective as of */
  effectiveAt: Scalars['Time']['input'];
  /** The trading entity that faces this entry, if applicable */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The kind of movement this entry records. entryType REVERSAL is rejected on this mutation — use
   * dvReverseLedgerTransaction instead, the only path that creates one.
   */
  entryType: DVLedgerEntryType;
  /** Opt-in dedup key so a retried submit returns the original request instead of creating a duplicate */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Free-form metadata */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Free-form reference to an external record (e.g. margin call, premium invoice) this entry is associated with, if any */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** The trade this entry is associated with, if any */
  tradeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Reserved for a different, not-yet-implemented grouping purpose — does not relate a TRANSFER's
   * two postings, which are always both children of this one new transaction regardless of
   * whether this is set. Ignored by every entry type today; stored as given.
   */
  transferGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateLoanResult = {
  __typename: 'CreateLoanResult';
  /** The ID of the newly created loan / collateral package */
  id: Scalars['ID']['output'];
};

export type CreateMakerCheckerRequestInput = {
  /**
   * Selects the app-side handler that will execute this request. Free text rather than an enum, so a new
   * action needs no migration and this list is open-ended by design
   */
  actionType: Scalars['String']['input'];
  /** Opt-in dedup key so a retried submit returns the original request */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** The command to execute, as a JSON object string */
  payload: Scalars['String']['input'];
  /** The domain object this request targets; blocks a second open request on the same object */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNettingSetInput = {
  baseAssetId?: InputMaybe<Scalars['ID']['input']>;
  collateralizationCategory?: InputMaybe<DVCollateralizationCategory>;
  csaId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Time']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  party?: InputMaybe<Scalars['String']['input']>;
  restrictToAssetId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  terminationAssetId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateNettingSetParamsInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  mta: Scalars['String']['input'];
  nettingSetId: Scalars['ID']['input'];
  party: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['Time']['input'];
  thresholdAmount?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNettingSetRuleInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mta: Scalars['String']['input'];
  nettingSetId: Scalars['ID']['input'];
  party: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['Time']['input'];
  thresholdAmount?: InputMaybe<Scalars['String']['input']>;
  valuationPercentage?: InputMaybe<Scalars['String']['input']>;
};

/**
 * An obligation entered by ops. Client, asset and type come from fixed lists rather than free text, so one
 * entered by hand is indistinguishable downstream from one a generator wrote.
 */
export type CreateObligationInput = {
  accountId: Scalars['ID']['input'];
  /** Signed. Positive means the counterparty owes us */
  amount: Scalars['String']['input'];
  assetId: Scalars['ID']['input'];
  dueDate: Scalars['Time']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** The optional per-netting-set breakdown. The sets come from the client's agreement */
  lines?: InputMaybe<Array<CreateObligationLineInput>>;
  obligationType: DVObligationType;
  /** Required when replaces is set, since it is the only record of why the first call went unmet */
  replaceReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reissuing a call: the obligation this one replaces, which closes as superseded under this same
   * approval. A call is never topped up, so the record that one went unmet has to survive
   */
  replaces?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The trade this obligation traces back to, if any. Obligations generated from a trade's lifecycle
   * carry this automatically; a manually entered obligation (e.g. INTEREST, or re-raising a call) can
   * optionally attach one for traceability
   */
  tradeId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateObligationLineInput = {
  /** Signed, in the obligation's asset */
  amount: Scalars['String']['input'];
  nettingSetId: Scalars['ID']['input'];
};

/** The subaccount a call created, or the subaccount a dry run would create. */
export type CreateOperationalSubaccountResult = {
  __typename: 'CreateOperationalSubaccountResult';
  affiliateID: Scalars['String']['output'];
  /** True when the rows were written. False for a dry run. */
  applied: Scalars['Boolean']['output'];
  externalID: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgID: Scalars['String']['output'];
  subaccountID: Scalars['String']['output'];
  subaccountType: OperationalSubaccountType;
};

export type CreatePackageInput = {
  /**
   * Caller-supplied per-package price stamped onto every leg. Provide this and/or the spread trio,
   * depending on how the venue reports the package. Signed, net of premium legs: may be negative.
   */
  packageTransactionPrice?: InputMaybe<Scalars['String']['input']>;
  /** 3-char ISO currency for the package price. Required when packageTransactionPrice is set. */
  packageTransactionPriceCurrency?: InputMaybe<Scalars['String']['input']>;
  /** 1-char notation code for the package price. Required when packageTransactionPrice is set. */
  packageTransactionPriceNotation?: InputMaybe<Scalars['String']['input']>;
  /** Caller-supplied per-package spread stamped onto every leg (alternative to price). */
  packageTransactionSpread?: InputMaybe<Scalars['String']['input']>;
  /** 3-char ISO currency for the package spread. Required when packageTransactionSpread is set. */
  packageTransactionSpreadCurrency?: InputMaybe<Scalars['String']['input']>;
  /** 1-char notation code for the package spread. Required when packageTransactionSpread is set. */
  packageTransactionSpreadNotation?: InputMaybe<Scalars['String']['input']>;
  /**
   * Book the whole package as a post-priced swap: every leg is stamped and books with its price
   * fields as estimates. A package prices as a single unit, so this is set here, not on legs.
   */
  postPriced?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The trades to book atomically under one package identifier. Must contain at least two —
   * a single-trade booking should use dvCreateTrade instead.
   */
  trades: Array<CreateTradeInput>;
};

export type CreateParticipantResult = {
  __typename: 'CreateParticipantResult';
  /** The collateral management participant ID, usable as securedPartyId or pledgorId in cmCreateLoan */
  id: Scalars['ID']['output'];
};

export type CreatePolicyV2Input = {
  clientID: Scalars['ID']['input'];
  defaultRule: RuleInput;
  keyAccesses: Array<InputKeyAccess>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /**
   * Resources to assign the new policy to. Empty list creates an unassigned
   * policy and the mutation returns PolicyV2 directly. Non-empty list assigns
   * the policy and the mutation returns PendingPolicyChange (requires quorum
   * approval).
   */
  resourceIDs: Array<Scalars['ID']['input']>;
  /**
   * List position is significant: within a scope, earlier rules have higher
   * evaluation priority. Rules are grouped by actionID (scope) on the BE, so
   * position only orders rules that share a scope.
   */
  specificRules: Array<RuleInput>;
};

export type CreateProductInput = {
  /** The base asset ID */
  baseId: Scalars['ID']['input'];
  /** Optional metadata for the product */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** The exercise style of the option - required for option products */
  optionExerciseStyle?: InputMaybe<OptionExerciseStyle>;
  /** The type of option (call/put) - required for option products */
  optionType?: InputMaybe<OptionType>;
  /** The type of financial product */
  productType: ProductType;
  /** The quote asset ID */
  quoteId: Scalars['ID']['input'];
};

/**
 * CreateReportDataFilterInput is used for create ReportDataFilter object.
 * Input was generated by ent.
 */
export type CreateReportDataFilterInput = {
  fieldName: Scalars['String']['input'];
};

/**
 * CreateReportFileInput is used for create ReportFile object.
 * Input was generated by ent.
 */
export type CreateReportFileInput = {
  fileFormat?: InputMaybe<ReportFileFileFormat>;
};

/**
 * CreateReportInput is used for create Report object.
 * Input was generated by ent.
 */
export type CreateReportInput = {
  fileFormats: Array<ReportFileFileFormat>;
  name: Scalars['String']['input'];
  organizationID?: InputMaybe<Scalars['String']['input']>;
  reportFilters: Array<ReportFilterInput>;
  reportSchedulesID?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['String']['input'];
  /** Format: ±[hh]:[mm] where -12:00 <= ±[hh]:[mm] <= +14:00 */
  utcOffset?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportScheduleEmailDestinationInput = {
  /**
   * deliveryFileName is an optional template for the email attachment file name, without extension.
   * Tokens: {report_type}, {date}, {date_compact}, {org_id}. Defaults to {report_type}_24h_{date}.
   * Staff only.
   */
  deliveryFileName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/**
 * CreateReportScheduleInput is used for create ReportSchedule object.
 * Input was generated by ent.
 */
export type CreateReportScheduleInput = {
  dataFilters: Array<ReportFilterInput>;
  /** 1-31. Use 0 to indicate null. Must be set to other than 0 when schedule is not daily. For non-daily reports, represents the day of week or month on which the report will be triggered */
  daysAfterNonDailyScheduleTypeToTrigger?: InputMaybe<Scalars['Int']['input']>;
  /**
   * emailDestinationConfigs lists email destinations with an optional deliveryFileName each. An
   * alternative to emailDestinations; a request may set one of the two, not both. Staff only.
   */
  emailDestinationConfigs?: InputMaybe<Array<CreateReportScheduleEmailDestinationInput>>;
  /**
   * emailDestinations lists plain email addresses, each delivered with the default attachment file
   * name. Use emailDestinationConfigs instead to set a deliveryFileName per destination; a request
   * may set one of the two, not both. Staff only.
   */
  emailDestinations?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fileFormats: Array<ReportFileFileFormat>;
  /** 0-23 */
  hourOfDay: Scalars['Int']['input'];
  mainFilter: CreateReportScheduleMainFilterInput;
  name: Scalars['String']['input'];
  /** organizationID should only be set by staff users. */
  organizationID?: InputMaybe<Scalars['String']['input']>;
  reportType: Scalars['String']['input'];
  scheduleType?: InputMaybe<ReportScheduleScheduleType>;
  /** sftpDestinations should only be set by staff users. */
  sftpDestinations?: InputMaybe<Array<InputMaybe<CreateReportScheduleSftpDestinationInput>>>;
  /** swiftDestinations should only be set by staff users. */
  swiftDestinations?: InputMaybe<Array<ReportScheduleSwiftDestinationSwiftDestination>>;
};

/**
 * CreateReportScheduleMainFilterInput is used for create ReportScheduleMainFilter object.
 * Input was generated by ent.
 */
export type CreateReportScheduleMainFilterInput = {
  fieldName: Scalars['String']['input'];
  scheduleFilterPoint?: InputMaybe<ReportScheduleMainFilterScheduleFilterPoint>;
  scheduleFilterRange?: InputMaybe<ReportScheduleMainFilterScheduleFilterRange>;
};

export type CreateReportScheduleSftpDestinationInput = {
  /**
   * deliveryFileName is an optional template for the SFTP object file name, without extension.
   * Tokens: {prefix}, {report_type}, {date}, {date_compact}, {org_id}; {org_id} and a date token are
   * required. {prefix} renders filePrefix followed by an underscore, or nothing when filePrefix is
   * unset, so write {prefix}name rather than {prefix}_name. Defaults to
   * {prefix}{report_type}_{date}_{org_id}. Staff only.
   */
  deliveryFileName?: InputMaybe<Scalars['String']['input']>;
  destination: ReportScheduleSftpDestinationSftpDestination;
  /** filePrefix is optional and will be used as a prefix for the generated file name. */
  filePrefix?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateReportTypeDefinitionInput is used for create ReportTypeDefinition object.
 * Input was generated by ent.
 */
export type CreateReportTypeDefinitionInput = {
  /** M4 dispatcher routing key: VIEW -> bqViewBacked builder, CUSTOM -> in-process Go provider. M3/M4 reject UNSPECIFIED at runtime. */
  backing?: InputMaybe<ReportTypeDefinitionBacking>;
  /** See bq_project. */
  bqDataset?: InputMaybe<Scalars['String']['input']>;
  /** Required only when backing=VIEW, enforced by M3 validation against the allow-list, NOT a DB constraint. */
  bqProject?: InputMaybe<Scalars['String']['input']>;
  /** bq_project+bq_dataset+bq_view form the BQSource the M2 Store materializes. */
  bqView?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  /** Soft-disable. Report types are never hard-deleted (historical reports and files reference the type id). */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a VIEW-backed CSV report keeps its legacy header row: each emitted header's display name becomes its header cell. Only a type that replaces or shadows a legacy type turns it on. */
  legacyHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  /** For org-visible VIEW reports, names the BQ-view column the M4 bqViewBacked builder binds WHERE <col> = @orgID. NULL for CUSTOM reports (they org-scope in Go). M3 validates it exists in discovered_schema for VIEW reports. */
  orgColumnName?: InputMaybe<Scalars['String']['input']>;
  /** Permission applied to org (non-staff) users. Effective access default is enforced by the M2 FilterReportTypeAccess rule, not the column. */
  orgUserPermission?: InputMaybe<ReportTypeDefinitionOrgUserPermission>;
  /** Rendering format, one per backing: CSV is BigQuery's own export of a VIEW-backed type, MT is the bytes a CUSTOM type's provider writes. */
  outputFormat?: InputMaybe<ReportTypeDefinitionOutputFormat>;
  /** Team accountable for this report type's alerts, emitted as the owning_team metric tag next to report_type_uuid so Datadog monitors route on data instead of hand-synced UUID lists. A typed projection of the datadog-stack team registry — adding a team is registry-first. Sentinel-as-unset with a NOT NULL default keeps the migration additive; UNSPECIFIED is rejected on write. ATTRIBUTION ONLY — never consulted by any permission decision. */
  owningTeam?: InputMaybe<ReportTypeDefinitionOwningTeam>;
  /** Permission applied to staff users. Orthogonal to org_user_permission (request-time user kind selects one). Effective default enforced in M2. */
  staffUserPermission?: InputMaybe<ReportTypeDefinitionStaffUserPermission>;
};

export type CreateServiceFeeTermsInput = {
  /** Top level account id associated to the terms */
  accountIds: Array<Scalars['ID']['input']>;
  /** Url to the agreement document for the service fee term */
  agreementUrl: Scalars['String']['input'];
  /** Defines if the terms renew automatically after the renewal term */
  autoRenewalEnabled: Scalars['Boolean']['input'];
  bespokeStakingTerms?: InputMaybe<StakingFeeTermsInput>;
  /** The actual details of the service fee terms (structure depends on the service type) */
  custodyTerms?: InputMaybe<CustodyFeeTermsDetailInput>;
  /** Date after which the fess are accrued */
  feeAccrualDate: Scalars['Date']['input'];
  /** Number of months after which the terms renew for a similar period */
  renewalTermMonths?: InputMaybe<Scalars['Int']['input']>;
  segregatedWalletsTerms?: InputMaybe<SegregatedWalletsFeeTermsInput>;
  /** Date when the billing terms start taking effect */
  startDate: Scalars['Date']['input'];
};

/**
 * The obligations to net. They must be for one client and one asset. The net is summed from those rows,
 * never sent: ops select, the system adds up.
 */
export type CreateSettlementInput = {
  obligationIds: Array<Scalars['ID']['input']>;
};

/** CreateParticipantResult type represents the result of creating a new participant. */
export type CreateStablecoinRewardsParticipantResult = {
  __typename: 'CreateStablecoinRewardsParticipantResult';
  /** Unique identifier for the newly created participant */
  participantID: Scalars['String']['output'];
};

/** CreateProgramResult type represents the result of creating a new program. */
export type CreateStablecoinRewardsProgramResult = {
  __typename: 'CreateStablecoinRewardsProgramResult';
  /** Unique identifier for the newly created program */
  programID: Scalars['String']['output'];
};

/** CreateStandingInstruction represents a to be created FIAT standing insctruction (trusted address) */
export type CreateStandingInstruction = {
  /** Affiliate ID linked to the Standing Instructions */
  affiliateID: Scalars['String']['input'];
  /** Beneficiary nickname */
  beneficiaryNickname: Scalars['String']['input'];
  /** instantTransfer represents the instant transfer instruction to be created */
  instantTransfer?: InputMaybe<CreateInstantTransferStandingInstruction>;
  /** Memo field */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** Organization to which the standing instruction belongs */
  organizationKeyID: Scalars['String']['input'];
  /** wire represents the wire instruction to be created */
  wire?: InputMaybe<CreateWireStandingInstruction>;
};

export type CreateTaxMappingInput = {
  anchorageSubtype?: InputMaybe<Scalars['String']['input']>;
  anchorageType: Scalars['String']['input'];
  rationale?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether operations of this type are sent to TaxBit. A reportable mapping requires taxbitType; a non-reportable
   * mapping must leave taxbitType and taxbitSubtype empty
   */
  reportable: Scalars['Boolean']['input'];
  /** System the Anchorage operation comes from: OPS_DB or CBS */
  source: Scalars['String']['input'];
  taxbitSubtype?: InputMaybe<Scalars['String']['input']>;
  taxbitType?: InputMaybe<Scalars['String']['input']>;
};

/** CreateTenantInput */
export type CreateTenantInput = {
  /** Taxbit's client identifier */
  clientID: Scalars['String']['input'];
  /** Taxbit's client secret */
  clientSecret: Scalars['String']['input'];
  /** Organization ID associated to the tenant */
  organizationKeyID: Scalars['String']['input'];
  /** Taxbit's tenant identifier */
  tenantID: Scalars['String']['input'];
};

export type CreateTradeInput = {
  /** The account ID that owns this trade */
  accountId: Scalars['ID']['input'];
  /** Additional IM amount */
  additionalImAmount?: InputMaybe<Scalars['String']['input']>;
  /** Additional IM asset ID */
  additionalImAssetId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Telegram @username of the Affiliated Person who agreed the swap with the client, like
   * @name: 5 to 32 letters, digits or underscores after the @.
   */
  affiliatedPerson?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: allocation indicator (4-char code) */
  allocationIndicator?: InputMaybe<Scalars['String']['input']>;
  /** Barrier level -- required for EKO/EKI options, must be absent otherwise */
  barrier?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: cleared flag (e.g. "N" for uncleared swaps) */
  cleared?: InputMaybe<Scalars['String']['input']>;
  /** Trade direction (BUY/SELL) */
  direction: TradeSideEnum;
  /** Effective as at time */
  effectiveAsAt: Scalars['Time']['input'];
  /**
   * Derivatives trading entity (A1, Swap Dealer, HedgeCo) faced by this trade.
   * Nullable until DERSWP-50 wires the write path.
   */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** Execution time */
  execTime: Scalars['Time']['input'];
  /** Expiration time if applicable */
  expiration: Scalars['Time']['input'];
  /**
   * Fee amount is the amount to be
   * paid in fees for the trade
   */
  feeAmount?: InputMaybe<Scalars['String']['input']>;
  /** Fee asset ID */
  feeAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** Fee direction */
  feeDirection?: InputMaybe<DVFeeDirection>;
  /** Fixed quanto rate (for quanto products) */
  fixedQuantoRate?: InputMaybe<Scalars['String']['input']>;
  /** Fixing source */
  fixingSource: Scalars['String']['input'];
  /** Optional group ID for trade grouping */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** Initial margin amount */
  initialMarginAmount?: InputMaybe<Scalars['String']['input']>;
  /** Initial margin asset ID */
  initialMarginAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** Initial margin direction */
  initialMarginDirection?: InputMaybe<Scalars['String']['input']>;
  /** Initial margin method (SIMPLE/RISK_FACTOR/NONE) */
  initialMarginMethod: DVInitialMarginMethod;
  /** CFTC reporting: jurisdiction tag (e.g. "CFTC") */
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  /** Optional memo */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** Netting set ID for margin netting */
  nettingSetId?: InputMaybe<Scalars['ID']['input']>;
  /** CFTC reporting: platform/execution facility identifier (4-char code) */
  platformIdentifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * Book as a post-priced swap (CFTC §43.3(a)(4)): the price fields carry an estimate that flows
   * through everything as a normal price but is never disseminated to the SDR; the finalizing
   * amendment supplies the determined price.
   */
  postPriced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The mid market mark price of at the time of the trade */
  preTradeMidMarketMark?: InputMaybe<Scalars['String']['input']>;
  /**
   * The price of the underlying spot market product
   * at the time of the trade
   */
  preTradeSpotReference?: InputMaybe<Scalars['String']['input']>;
  /** Premium currency type (BASE/QUOTE/QUANTO) */
  premiumCurrencyType?: InputMaybe<Scalars['String']['input']>;
  /** Premium per base unit (for options) */
  premiumPerBaseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Premium timing type (UPFRONT/AT_EXPIRY) */
  premiumTimingType?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: prime brokerage transaction indicator */
  primeBrokerageTransactionIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  /** The product ID this trade is for */
  productId: Scalars['ID']['input'];
  /** Total quantity in base asset */
  quantityBase: Scalars['String']['input'];
  /** Quanto asset ID (for quanto products) */
  quantoAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** Settlement type (PHYSICAL/CASH) */
  settlementType: Scalars['String']['input'];
  /** Strike price for the trade */
  strike: Scalars['String']['input'];
  /** CFTC reporting: strike-price currency (3-char ISO code) */
  strikePriceCurrency?: InputMaybe<Scalars['String']['input']>;
  /** CFTC reporting: strike-price notation (1-char code) */
  strikePriceNotation?: InputMaybe<Scalars['String']['input']>;
  /** Variation margin asset ID */
  variationMarginAssetId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for creating a new Talos account */
export type CreateTradingTalosAccountInput = {
  /** Trading account ID for this Talos account */
  accountID: Scalars['String']['input'];
  /** Alias for this account on the Talos side */
  accountTalosAlias: Scalars['String']['input'];
  /** Organization key ID for this Talos account */
  organizationKeyID: Scalars['String']['input'];
  /** Talos customer name */
  talosCustomer: Scalars['String']['input'];
  /** Talos customer ID */
  talosCustomerID: Scalars['String']['input'];
  /** Talos instance */
  talosInstance: TalosInstance;
};

/** CreateVaultOperation represents an operation where a vault is added to the organization */
export type CreateVaultOperation = Operation & {
  __typename: 'CreateVaultOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** iamChanges represents the JSON encoded IAM changes that will be applied with this operation. */
  iamChanges: Maybe<Scalars['OperationIAMChanges']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policies is the list of policies that will apply to the new vault
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policies: Array<Policy>;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** roleChanges represents the IAM role changes that will be applied with this operation. */
  roleChanges: Maybe<IAMRoleChanges>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** vaultDescription is the description of the vault being created */
  vaultDescription: Scalars['String']['output'];
  /** vaultName is the name of the vault being created */
  vaultName: Scalars['String']['output'];
  /**
   * vaultPolicyContainerUpdate represents the binding changes that will be applied
   * to the vault policy container
   */
  vaultPolicyContainerUpdate: Maybe<VaultPolicyContainerUpdate>;
  /** The sub ID of the vault being created */
  vaultSubID: Scalars['String']['output'];
};


/** CreateVaultOperation represents an operation where a vault is added to the organization */
export type CreateVaultOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** CreateVaultOperation represents an operation where a vault is added to the organization */
export type CreateVaultOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/**
 * V2 policy definition for use in prepareCreateVaultWithNewPolicyV2.
 * Uses RuleInput (quorum/block outcomes; conditions on specific rules) instead of the legacy InputRule.
 */
export type CreateVaultPolicyV2Input = {
  defaultRule: RuleInput;
  keyAccesses: Array<InputKeyAccess>;
  name: Scalars['String']['input'];
  specificRules: Array<RuleInput>;
};

export type CreateWalletScreeningAllowlistEntryInput = {
  address: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** CreateWireStandingInstruction represents a wire standing insctruction (trusted address) */
export type CreateWireStandingInstruction = {
  /** Account Number */
  accountNumber: Scalars['String']['input'];
  /** Beneficiary Address 1 */
  beneficiaryAddress1?: InputMaybe<Scalars['String']['input']>;
  /** Beneficiary Address 2 */
  beneficiaryAddress2?: InputMaybe<Scalars['String']['input']>;
  /** Beneficiary Address 3 */
  beneficiaryAddress3?: InputMaybe<Scalars['String']['input']>;
  /** Beneficiary code */
  beneficiaryCode: Scalars['String']['input'];
  /** Beneficiary Country */
  beneficiaryCountry?: InputMaybe<Scalars['String']['input']>;
  /** Beneficiary Name */
  beneficiaryName: Scalars['String']['input'];
  /** Financial Institution address 1 */
  fiAddress1?: InputMaybe<Scalars['String']['input']>;
  /** Financial Institution address 2 */
  fiAddress2?: InputMaybe<Scalars['String']['input']>;
  /** Financial Institution code */
  fiCode: Scalars['String']['input'];
  /** Financial Institution country */
  fiCountry?: InputMaybe<Scalars['String']['input']>;
  /** Financial Institution ID */
  fiID: Scalars['String']['input'];
  /** Financial Institution name */
  fiName: Scalars['String']['input'];
  /** Intermediate Financial Institution address 1 */
  intermediateAddress1?: InputMaybe<Scalars['String']['input']>;
  /** Intermediate Financial Institution address 2 */
  intermediateAddress2?: InputMaybe<Scalars['String']['input']>;
  /** intermediate Financial Institution code */
  intermediateCode?: InputMaybe<Scalars['String']['input']>;
  /** Intermediate Financial Institution country */
  intermediateCountry?: InputMaybe<Scalars['String']['input']>;
  /** Intermediate Financial Institution ID */
  intermediateID?: InputMaybe<Scalars['String']['input']>;
  /** Intermediate Financial Institution name */
  intermediateName?: InputMaybe<Scalars['String']['input']>;
};

export type Critical = {
  action?: InputMaybe<StateAction>;
  defaultNotice?: InputMaybe<Scalars['Boolean']['input']>;
  ltv?: InputMaybe<Scalars['String']['input']>;
  returnToLtv?: InputMaybe<Scalars['String']['input']>;
  warningLtv?: InputMaybe<Scalars['String']['input']>;
};

/** CurrentVote represents the current vote option for poll */
export type CurrentVote = {
  __typename: 'CurrentVote';
  /** text representation of the vote option */
  option: Maybe<Scalars['String']['output']>;
  /** The integer corresponding to the option, if there's no vote this field is nil */
  optionID: Scalars['Int']['output'];
  /** This could be a number for a fee percent, yes/no, etc. String is generic enough */
  status: ProposalVoteStatus;
};

/** A custodian registered in the system available for account transfers. */
export type Custodian = {
  __typename: 'Custodian';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  mailingAddress: Maybe<Scalars['String']['output']>;
  microtransaction: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  primaryDispatchMethod: Maybe<CustodianDispatchMethod>;
  requireWetSignature: Scalars['Boolean']['output'];
  transferTypes: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** Paginated list of custodians. */
export type CustodianConnection = {
  __typename: 'CustodianConnection';
  /** A list of edges. */
  edges: Maybe<Array<CustodianEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Contact details for dispatching documents to a custodian. */
export type CustodianDispatchMethod = {
  __typename: 'CustodianDispatchMethod';
  address: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  phone: Maybe<Scalars['String']['output']>;
};

/** A custodian edge in a connection. */
export type CustodianEdge = {
  __typename: 'CustodianEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Custodian>;
};

/** CustodyAUC returns the summary of assets under custory held in Anchorage */
export type CustodyAUC = {
  __typename: 'CustodyAUC';
  /** perAssetTotals returns the total value of a each specific asset under custody */
  perAssetTotals: Array<Amount>;
  /** usdTotal returns total value of assets under custody in USD */
  usdTotal: Amount;
};

export type CustodyAssetGroupFeeTermsConfig = {
  __typename: 'CustodyAssetGroupFeeTermsConfig';
  /** If the config is not the default, these will be the asset types which the rates apply to */
  assetTypes: Maybe<Array<Scalars['AssetTypeID']['output']>>;
  /**
   * This is the value that is used to calculate fees
   * when fee approach is MINIMUM_FEE or FIXED_FEE
   * If present, this value will override the value
   * provided at the service fee terms level
   */
  baseFee: Maybe<Scalars['Float']['output']>;
  /** Contains the fee rates which apply to the asset types */
  feeRates: Array<CustodyFeeRateConfig>;
  /** If true, these are the fee rates applied to all asset types without specific rules/rates */
  isDefaultRate: Scalars['Boolean']['output'];
};

export type CustodyAssetGroupFeeTermsConfigInput = {
  /** If the config is not the default, these will be the asset types which the rates apply to */
  assetTypes?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  /**
   * This is the value that is used to calculate fees
   * when fee approach is MINIMUM_FEE or FIXED_FEE
   * If present, this value will override the value
   * provided at the service fee terms level
   */
  baseFee?: InputMaybe<Scalars['Float']['input']>;
  /** Contains the fee rates which apply to the asset types */
  feeRates: Array<CustodyFeeRateConfigInput>;
  /** If true, these are the fee rates applied to all asset types without specific rules/rates */
  isDefaultRate: Scalars['Boolean']['input'];
};

export type CustodyFeeRateConfig = {
  __typename: 'CustodyFeeRateConfig';
  /** Rate to be applied in BPS */
  feeBPSRate: Scalars['Float']['output'];
  /** The minimum custody amount for which the rate applies */
  tierFloor: Scalars['Float']['output'];
};

export type CustodyFeeRateConfigInput = {
  /** Rate to be applied in BPS */
  feeBPSRate: Scalars['Float']['input'];
  /** The minimum custody amount for which the rate applies */
  tierFloor: Scalars['Float']['input'];
};

export type CustodyFeeTermsDetail = {
  __typename: 'CustodyFeeTermsDetail';
  /** This list contains the specific fee rates for each group of assets */
  assetGroups: Array<CustodyAssetGroupFeeTermsConfig>;
  /**
   * This is the value that is used to calculate fees
   * when fee approach is MINIMUM_FEE or FIXED_FEE
   */
  baseFee: Scalars['Float']['output'];
  /** Defines the period when the invoice needs to be paid */
  billingTerms: BillingTerms;
  /** Defines how fees are applied to assets */
  feeApproach: FeeApproach;
  /** If true, it means that the fee rates are applied gradually */
  hasGraduatedFeeRate: Scalars['Boolean']['output'];
  /** Defines how the minimum fee is calculated */
  minimumFeeType: MinimumFeeType;
};

export type CustodyFeeTermsDetailInput = {
  /** This list contains the specific fee rates for each group of assets */
  assetGroups: Array<CustodyAssetGroupFeeTermsConfigInput>;
  /**
   * This is the value that is used to calculate fees
   * when fee approach is MINIMUM_FEE or FIXED_FEE
   */
  baseFee: Scalars['Float']['input'];
  /** Defines the period when the invoice needs to be paid */
  billingTerms: BillingTerms;
  /** Defines how fees are applied to assets */
  feeApproach: FeeApproach;
  /** If true, it means that the fee rates are applied gradually */
  hasGraduatedFeeRate: Scalars['Boolean']['input'];
  /** Defines how the minimum fee is calculated */
  minimumFeeType: MinimumFeeType;
};

export enum CustomerType {
  B2B = 'B2B',
  RIA = 'RIA'
}

/** CvmRootCertificateInfoInput represents information about a single CVM root certificate. */
export type CvmRootCertificateInfoInput = {
  /** Serial number of the certificate (20 bytes, hex-encoded). */
  serialNumber: Scalars['String']['input'];
  /** UEFI TBS (To Be Signed) certificate DER (base64). Required for UEFI and must be empty for addressSigning. */
  tbsDer?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp in unix epoch nanoseconds. */
  timestamp: Scalars['String']['input'];
};

/** CxlRejReason represents */
export enum CxlRejReason {
  /** CxlRejReasonBroker represents */
  BROKER = 'BROKER',
  /** CxlRejReasonDuplicateClOrdID represents */
  DUPLICATE_CL_ORD_ID = 'DUPLICATE_CL_ORD_ID',
  /** Invalid represents */
  INVALID = 'INVALID',
  /** CxlRejReasonInvalidStrategy represents */
  INVALID_STRATEGY = 'INVALID_STRATEGY',
  /** CxlRejReasonOrderAlreadyInPendingCancelOrPendingReplaceStatus represents */
  ORDER_ALREADY_IN_PENDING_CANCEL_OR_PENDING_REPLACE_STATUS = 'ORDER_ALREADY_IN_PENDING_CANCEL_OR_PENDING_REPLACE_STATUS',
  /** CxlRejReasonOther represents */
  OTHER = 'OTHER',
  /** CxlRejReasonRateLimit represents */
  RATE_LIMIT = 'RATE_LIMIT',
  /** CxlRejReasonStaleRequest represents */
  STALE_REQUEST = 'STALE_REQUEST',
  /** CxlRejReasonTooLateToCancel represents */
  TOO_LATE_TO_CANCEL = 'TOO_LATE_TO_CANCEL',
  /** CxlRejReasonUnknownOrder represents */
  UNKNOWN_ORDER = 'UNKNOWN_ORDER'
}

/** DApp represents a decentralized application integrated with the platform. */
export type DApp = {
  __typename: 'DApp';
  /** Categories for the DApp, with human-readable display names. */
  categoryInfos: Array<DAppCategoryInfo>;
  /** Description of the DApp */
  description: Scalars['String']['output'];
  /** ID of the Disclosure document user must accept before connecting to the DApp */
  disclosureID: Scalars['String']['output'];
  /** Is the DApp enabled for Anchorage Digital Bank */
  enabledForADB: Scalars['Boolean']['output'];
  /** Is the DApp enabled for Anchorage Digital Singapore */
  enabledForADS: Scalars['Boolean']['output'];
  /** Is the DApp enabled for Porto */
  enabledForPorto: Scalars['Boolean']['output'];
  /** iconURL */
  iconURL: Scalars['String']['output'];
  /** DApp ID */
  id: Scalars['String']['output'];
  /** name */
  name: Scalars['String']['output'];
  /** WalletConnect v2 App ProjectID */
  projectID: Scalars['String']['output'];
  /** Risk associated with the DApp. */
  risk: Maybe<DAppRisk>;
  /** Supported actions for the DApp. */
  supportedActions: Scalars['String']['output'];
  /** Tier for the DApp. A null tier means the DApp is not featured. */
  tier: Maybe<DAppTier>;
  /** url */
  url: Maybe<Scalars['String']['output']>;
};


/** DApp represents a decentralized application integrated with the platform. */
export type DAppiconURLArgs = {
  iconSize?: Scalars['Int']['input'];
};

/** DAppCategory represents the category of a decentralized application. */
export enum DAppCategory {
  /** Bridge DApps facilitate cross-chain asset transfers */
  BRIDGE = 'BRIDGE',
  /** Claim DApps allow users to claim tokens or rewards */
  CLAIM = 'CLAIM',
  /** DeFi DApps provide decentralized financial services */
  DEFI = 'DEFI',
  /** Exchange DApps enable token swapping and trading */
  EXCHANGE = 'EXCHANGE',
  /** Governance DApps allow participation in protocol governance and voting */
  GOVERNANCE = 'GOVERNANCE',
  /** Lending / Borrowing DApps provide decentralized lending and borrowing services */
  LENDING_BORROWING = 'LENDING_BORROWING',
  /** LP Provisioning DApps allow users to provide liquidity to decentralized pools */
  LP_PROVISIONING = 'LP_PROVISIONING',
  /** Marketplace DApps facilitate buying and selling of digital assets */
  MARKETPLACE = 'MARKETPLACE',
  /** Mint / Redeem DApps allow users to mint or redeem tokenized assets */
  MINT_REDEEM = 'MINT_REDEEM',
  /** NFT DApps support non-fungible token minting, trading, and management */
  NFT = 'NFT',
  /** Off-Chain Signing DApps facilitate message signing without on-chain transactions */
  OFF_CHAIN_SIGNING = 'OFF_CHAIN_SIGNING',
  /** Payment / Payroll DApps enable crypto-based payments and payroll processing */
  PAYMENT_PAYROLL = 'PAYMENT_PAYROLL',
  /** Real-World Assets DApps support tokenization and management of real-world assets */
  REAL_WORLD_ASSETS = 'REAL_WORLD_ASSETS',
  /** Restaking / Liquid Staking DApps provide restaking and liquid staking services */
  RESTAKING_LIQUID_STAKING = 'RESTAKING_LIQUID_STAKING',
  /** Staking DApps allow users to stake assets for network validation rewards */
  STAKING = 'STAKING',
  /** Swap / DEX DApps enable decentralized token swapping and exchange */
  SWAP_DEX = 'SWAP_DEX',
  /** Token Approvals / Revoke DApps allow users to manage and revoke token approvals */
  TOKEN_APPROVALS_REVOKE = 'TOKEN_APPROVALS_REVOKE',
  /** Yield / Aggregators DApps optimize yield farming across multiple protocols */
  YIELD_AGGREGATORS = 'YIELD_AGGREGATORS'
}

/** DAppCategoryInfo provides a category enum value along with its human-readable display name. */
export type DAppCategoryInfo = {
  __typename: 'DAppCategoryInfo';
  /** The category enum value */
  category: DAppCategory;
  /** Human-readable display name for the category */
  displayName: Scalars['String']['output'];
};

/** DAppEntry contains a DApp and its allowed vaults */
export type DAppEntry = {
  __typename: 'DAppEntry';
  /**
   * Vaults that have been allowed for this DApp by the org admin
   * Populated for APPROVED, empty otherwise.
   */
  allowedVaults: Array<Vault>;
  /** The DApp info */
  dapp: DApp;
};

/** DAppEntryConnection is a paginated list of DAppEntry results. */
export type DAppEntryConnection = {
  __typename: 'DAppEntryConnection';
  /** All available categories for the returned DApps, for use as filter options. */
  availableCategories: Array<DAppCategoryInfo>;
  /** The list of DAppEntry edges */
  edges: Array<DAppEntryEdge>;
  /** Pagination metadata */
  pageInfo: PageInfo;
};

/** DAppEntryEdge is an edge in a DAppEntryConnection */
export type DAppEntryEdge = {
  __typename: 'DAppEntryEdge';
  /** Cursor for pagination */
  cursor: Scalars['ID']['output'];
  /** The DAppEntry at this edge */
  node: DAppEntry;
};

/** DAppInput is the input type for creating or updating a DApp */
export type DAppInput = {
  /** Categories for the DApp */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Description of the DApp */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Disclosure document user must accept before connecting to the DApp */
  disclosureID: Scalars['String']['input'];
  /** Is the DApp enabled for Anchorage Digital Bank */
  enabledForADB: Scalars['Boolean']['input'];
  /** Is the DApp enabled for Anchorage Digital Singapore */
  enabledForADS: Scalars['Boolean']['input'];
  /** Is the DApp enabled for Porto */
  enabledForPorto: Scalars['Boolean']['input'];
  /** DApp ID */
  id: Scalars['String']['input'];
  /** name */
  name: Scalars['String']['input'];
  /** WalletConnect v2 App ProjectID */
  projectID?: InputMaybe<Scalars['String']['input']>;
  /** Supported actions for the DApp. */
  supportedActions?: InputMaybe<Scalars['String']['input']>;
  /** Tier for the DApp. A null tier means the DApp is not featured. */
  tier?: InputMaybe<Scalars['String']['input']>;
  /** url */
  url: Scalars['String']['input'];
};

/** DAppKind represents the classification of a DApp for filtering purposes. */
export enum DAppKind {
  /** Only includes org-admin approved dApps for ADx */
  APPROVED = 'APPROVED',
  /**
   * Only includes anchorage-certified dApps for ADx
   * Excludes dApps that are already approved by org-admin
   */
  CERTIFIED = 'CERTIFIED',
  /** Only includes featured dApps (dApps with a non-null tier). */
  FEATURED = 'FEATURED'
}

/** Represents an individual DApp notification. */
export type DAppNotification = {
  __typename: 'DAppNotification';
  /** The timestamp of when this DApp notification was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The ID of this DApp notification. */
  id: Scalars['ID']['output'];
  /** The type of this DApp notification." */
  notificationType: Maybe<DAppNotificationType>;
  /** The ID of the organization this DApp notification belongs to. */
  orgID: Scalars['String']['output'];
  /**
   * The underlying data that was captured when this DApp notification was created.
   * If available, it provides additional info about the notification, though in
   * "raw" format that user may or may not be able to easily understand.
   */
  rawMessage: Maybe<Scalars['String']['output']>;
  /** The ID of the user this DApp notification belongs to. */
  userID: Scalars['String']['output'];
  /** Descriptive info about the notification. Safe to show to user. */
  userVisibleMessage: Scalars['String']['output'];
};

/** The type of DApp notifications that can be retrieved. */
export enum DAppNotificationType {
  /** Represents a DApp notification that should be shown as an error. */
  ERROR = 'ERROR'
}

/** DAppOrderBy specifies the field DApp results can be ordered by. */
export enum DAppOrderBy {
  /**
   * APPROVED_AT — order dApps by the time they were approved.
   * Only relevant when filterByKind is APPROVED.
   */
  APPROVED_AT = 'APPROVED_AT',
  /** NAME — order dApps by their name e.g "uniswap", "aave". */
  NAME = 'NAME',
  /**
   * TIER — order dApps by their featured tier.
   * (higher tier (Tier1) -> lower tier (Tier2) -> non-tiered)
   */
  TIER = 'TIER'
}

/** DAppRisk represents the risk assessment of connecting to a dApp. */
export type DAppRisk = {
  __typename: 'DAppRisk';
  /** Description is a human-readable description of the risk analysis. */
  description: Scalars['String']['output'];
  /** Details are additional details about the risk analysis. */
  details: Array<Scalars['String']['output']>;
  /** RiskLevel is the risk level of connecting to a dApp. */
  riskLevel: DAppRiskLevel;
};

/** DAppRiskLevel represents the risk level of connecting to a dApp. */
export enum DAppRiskLevel {
  /** HIGH means the risk level is high and the dApp is considered malicious. */
  HIGH = 'HIGH',
  /** LOW means the risk level is low and the dApp is considered safe. */
  LOW = 'LOW',
  /** MEDIUM means the risk level is medium and the dApp is considered somewhat risky. */
  MEDIUM = 'MEDIUM',
  /** UNAVAILABLE means the risk level could not be determined at this time due to an error. */
  UNAVAILABLE = 'UNAVAILABLE',
  /** UNDETERMINED means the risk level could not be determined at this time due lack of data. */
  UNDETERMINED = 'UNDETERMINED'
}

/** DAppTier represents the featured-tier of a DApp. A null tier means the DApp is not featured. */
export enum DAppTier {
  /** Tier 1 — top-tier featured DApps. */
  TIER_1 = 'TIER_1',
  /** Tier 2 — second-tier featured DApps. */
  TIER_2 = 'TIER_2'
}

/** DAppTierInfo provides a tier enum value along with its human-readable display name. */
export type DAppTierInfo = {
  __typename: 'DAppTierInfo';
  /** Display name for the tier */
  displayName: Scalars['String']['output'];
  /** The tier enum value */
  tier: DAppTier;
};

/**
 * DEXChainInfo represents a chain that is supported by a Decentralized Exchange (DEX).
 * Only chains supported by both the DEX and Anchorage are returned.
 * Also includes the mapped Anchorage objects with each chain ID.
 */
export type DEXChainInfo = {
  __typename: 'DEXChainInfo';
  chainID: Scalars['Int']['output'];
  chainName: Scalars['String']['output'];
  exchange: DecentralizedExchange;
  networkInfo: NetworkInfo;
};

export type DVAccount = {
  __typename: 'DVAccount';
  /**
   * Marks this account's automation cutoff date. Defaults false; rolled out account by account by
   * flipping one on, with no redeploy. The entity-level flag remains the overall enablement gate for
   * obligation/ledger automation; setting this true does not itself enable automation for the
   * account, it supplies the cutoff date a historical (pre-automation) write is checked against, so a
   * trade whose own due date predates it is blocked rather than silently backdated.
   */
  automateObligationsAndLedgerEntries: Scalars['Boolean']['output'];
  /** Contact email addresses */
  contactEmails: Array<Scalars['String']['output']>;
  /** The counterparty ID */
  counterpartyId: Scalars['ID']['output'];
  /** Counterparty master copy this account is linked to */
  counterpartyMasterCopyId: Maybe<Scalars['ID']['output']>;
  /** The counterparty name */
  counterpartyName: Scalars['String']['output'];
  /** The country code (ISO 3166-1 alpha-2) */
  countryCode: Maybe<Scalars['String']['output']>;
  /** When the account was created */
  createdAt: Scalars['Time']['output'];
  /** Who created the account */
  createdBy: Scalars['String']['output'];
  /** Fixing source pre-filled on trades ingested for this account: CME, DERIBIT or ANCHORAGE. Set only with a BASE or QUOTE defaultSettlementType. */
  defaultFixingSource: Maybe<Scalars['String']['output']>;
  /** Whether trades ingested for this account are staged post-priced */
  defaultPostPriced: Scalars['Boolean']['output'];
  /** Premium timing pre-filled on trades ingested for this account: UPFRONT or AT_EXPIRY. Set only with defaultPremiumCurrencyType. */
  defaultPremiumCurrencyTimingType: Maybe<Scalars['String']['output']>;
  /** Premium currency type pre-filled on trades ingested for this account: BASE or QUOTE. Null when unset. */
  defaultPremiumCurrencyType: Maybe<Scalars['String']['output']>;
  /** Settlement type pre-filled on trades ingested for this account: PHYSICAL, BASE or QUOTE. Null when unset. */
  defaultSettlementType: Maybe<Scalars['String']['output']>;
  /** Whether the account is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Entity ID - the trading entity (A1 Derivatives, Swap Dealer, HedgeCo) this account faces */
  entityId: Maybe<Scalars['ID']['output']>;
  /** Haruko Mask */
  harukoMask: Maybe<Scalars['String']['output']>;
  /** Haruko triparty venue ID, distinct from harukoVenueId */
  harukoTripartyVenueId: Maybe<Scalars['Int']['output']>;
  /** Haruko Venue ID */
  harukoVenueId: Maybe<Scalars['Int']['output']>;
  /** Whether ICE reporting is disabled for this account */
  iceReportingDisabled: Scalars['Boolean']['output'];
  /** The ID of the account */
  id: Scalars['ID']['output'];
  /** Legal Entity Identifier */
  legalEntityIdentifier: Maybe<Scalars['String']['output']>;
  /** Date of master confirmation */
  masterConfirmationDate: Scalars['Date']['output'];
  /** Optional metadata for the account */
  metadata: Maybe<Scalars['String']['output']>;
  /** The name of the account */
  name: Scalars['String']['output'];
  /** The name reported to the SDR, when it differs from the account name. Null means the account name is reported. */
  sdrReportingName: Maybe<Scalars['String']['output']>;
  /** When the account was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** Who last updated the account */
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** Input for generating the account balance report CSV */
export type DVAccountBalanceReportInput = {
  /** Account IDs to include in the report */
  accountIds: Array<Scalars['ID']['input']>;
  /**
   * When true, a negative available USDC balance is netted into the available USD
   * balance and USDC is set to 0. Defaults to true.
   */
  netUSDCWithUSD?: Scalars['Boolean']['input'];
  /**
   * When true, a negative available USDT balance is netted into the available USD
   * balance and USDT is set to 0. Defaults to false.
   */
  netUSDTWithUSD?: Scalars['Boolean']['input'];
};

export type DVAccountFilter = {
  /** Filter by counterparty IDs */
  counterpartyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by counterparty names (partial match) */
  counterpartyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by country codes */
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by specific account IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by account names (partial match) */
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Maps an account to the counterparty (Anchorage trading entity) it is configured
 * to trade with, sourced from otc.accounts.entity_id → otc.entities. An account is
 * configured with at most one counterparty; the counterparty fields are null until
 * one is set.
 */
export type DVAllowableCounterparty = {
  __typename: 'DVAllowableCounterparty';
  /** The account ID */
  accountId: Scalars['ID']['output'];
  /** The account name */
  accountName: Scalars['String']['output'];
  /**
   * ID of the counterparty (Anchorage trading entity, e.g. A1 or Swap Dealer) the
   * account is configured to trade with. Null until a counterparty is configured.
   */
  counterpartyId: Maybe<Scalars['ID']['output']>;
  /** Name of the configured counterparty (Anchorage trading entity) */
  counterpartyName: Maybe<Scalars['String']['output']>;
};

export type DVAsset = {
  __typename: 'DVAsset';
  /** When the asset was created */
  createdAt: Scalars['Time']['output'];
  /** Who created the asset */
  createdBy: Scalars['String']['output'];
  /** The ID of the asset */
  id: Scalars['ID']['output'];
  /** Optional metadata for the asset */
  metadata: Maybe<Scalars['String']['output']>;
  /** The name of the asset */
  name: Scalars['String']['output'];
  /** The symbol of the asset */
  symbol: Scalars['String']['output'];
  /** When the asset was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** Who last updated the asset */
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** Input for generating Bitwise position statement CSV report */
export type DVBitwisePositionStatementInput = {
  /** Account IDs to include in the report (Bitwise, Lucy Piper, Skip & Goose) */
  accountIds: Array<Scalars['ID']['input']>;
  /** Output format for the report. Optional; defaults to BITWISE when omitted. */
  format?: InputMaybe<DVReportFormat>;
  /** Valuation date for position calculations (will use 4:00 PM NY time) */
  valuationDate: Scalars['Date']['input'];
};

/** Input for generating Bitwise trade recap CSV report */
export type DVBitwiseTradeRecapInput = {
  /** Account IDs to include in the report (Bitwise, Lucy Piper, Skip & Goose) */
  accountIds: Array<Scalars['ID']['input']>;
  /** End date for the report period */
  endDate: Scalars['Date']['input'];
  /** Start date for the report period */
  startDate: Scalars['Date']['input'];
};

export type DVBookStagedCloseoutInput = {
  /**
   * The trades to close and how much of each, booked in this order. The quantities must total no
   * more than the staged closeout's quantity minus quantityBooked.
   */
  allocations: Array<DVStagedCloseoutAllocationInput>;
  /** The price at which the closeout is executed */
  closeoutPrice: Scalars['String']['input'];
  /** CurrencyType of the closeout price */
  currencyType: Scalars['String']['input'];
  /** The settlement date for the closeouts */
  settlementDate: Scalars['Time']['input'];
  /** The reference rate of the underlying SPOT instrument */
  spotReferenceRate?: InputMaybe<Scalars['String']['input']>;
};

export type DVCSA = {
  __typename: 'DVCSA';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  endDate: Maybe<Scalars['Time']['output']>;
  /** Whether margin runs raise VM obligations for this CSA. Off until ops opt the CSA in */
  generateVmObligations: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ironcladUrl: Maybe<Scalars['String']['output']>;
  isdaAgreementId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  pricingSource: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Time']['output'];
  status: DVCSAStatus;
  type: Maybe<DVCSAType>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  valuationAgent: DVPartyType;
  variableImApplies: Maybe<Scalars['Boolean']['output']>;
};

export type DVCSAFilter = {
  /** Filter by account IDs */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by specific CSA IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by statuses */
  statuses?: InputMaybe<Array<DVCSAStatus>>;
  /** Filter by CSA types */
  types?: InputMaybe<Array<DVCSAType>>;
};

/** CSA Margin Terms represents the margin calculation parameters for a CSA */
export type DVCSAMarginTerms = {
  __typename: 'DVCSAMarginTerms';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  csaId: Scalars['ID']['output'];
  currency: Scalars['ID']['output'];
  endDate: Maybe<Scalars['Time']['output']>;
  historyId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  mta: Scalars['String']['output'];
  party: Scalars['String']['output'];
  rounding: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['Time']['output'];
  status: Maybe<Scalars['String']['output']>;
  thresholdAmount: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** CSA Status computed from end_date */
export enum DVCSAStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  TERMINATED = 'TERMINATED'
}

/** CSA type classification */
export enum DVCSAType {
  BILATERAL = 'BILATERAL',
  SEGREGATED = 'SEGREGATED',
  TRI_PARTY = 'TRI_PARTY'
}

export type DVClientEmail = {
  __typename: 'DVClientEmail';
  /** The account the trade belongs to */
  accountId: Scalars['ID']['output'];
  /** Attachment metadata (contents via dvClientEmailAttachments) */
  attachments: Array<DVClientEmailAttachment>;
  /** Number of send attempts */
  attemptCount: Scalars['Int']['output'];
  /** Bcc addresses (e.g. the ops distribution list) */
  bccList: Array<Scalars['Email']['output']>;
  /** The rendered email body */
  body: Maybe<Scalars['String']['output']>;
  /** Cc addresses */
  ccList: Array<Scalars['Email']['output']>;
  /** When the row was created */
  createdAt: Scalars['Time']['output'];
  /** The kind of email (e.g. TRADE_CONFIRMATION) */
  emailType: DVClientEmailType;
  /** When the email was handed off to the notification service */
  handedOffAt: Maybe<Scalars['Time']['output']>;
  /** The ID of the email */
  id: Scalars['ID']['output'];
  /** The closeout lifecycle event this email is for, if any */
  lifecycleEventId: Maybe<Scalars['ID']['output']>;
  /** The trade lifecycle event that triggered this email */
  notificationType: LifecycleEventType;
  /** When the email was queued */
  queuedAt: Scalars['Time']['output'];
  /** Who queued the email (an email address, or 'system' for auto-enqueue) */
  queuedBy: Scalars['String']['output'];
  /** To addresses (snapshot of the account's contact emails) */
  recipients: Array<Scalars['Email']['output']>;
  /** When the email was reviewed and actioned */
  reviewedAt: Maybe<Scalars['Time']['output']>;
  /** The staff member who reviewed and actioned (sent or dequeued) the email */
  reviewedBy: Maybe<Scalars['Email']['output']>;
  /** When the email becomes due for automatic sending; null = reviewer send only */
  sendAfter: Maybe<Scalars['Time']['output']>;
  /** The email lifecycle status; SENT means handed off to the notification service */
  status: DVClientEmailStatus;
  /** The email subject */
  subject: Scalars['String']['output'];
  /** The trade this email is for */
  tradeId: Scalars['ID']['output'];
  /** When the row was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

export type DVClientEmailAccountIDsFilter = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  emailTypes?: InputMaybe<Array<DVClientEmailType>>;
  /** Exclude client emails whose account belongs to any of these entities. */
  excludeEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationTypes?: InputMaybe<Array<LifecycleEventType>>;
  queuedAfter?: InputMaybe<Scalars['Time']['input']>;
  queuedBefore?: InputMaybe<Scalars['Time']['input']>;
  sentAfter?: InputMaybe<Scalars['Time']['input']>;
  sentBefore?: InputMaybe<Scalars['Time']['input']>;
  statuses?: InputMaybe<Array<DVClientEmailStatus>>;
};

export type DVClientEmailAttachment = {
  __typename: 'DVClientEmailAttachment';
  /** The durable gs:// location of the archived attachment, set on send */
  attachmentGcsUri: Maybe<Scalars['String']['output']>;
  /** When the attachment was created */
  createdAt: Scalars['Time']['output'];
  /** The attachment filename */
  filename: Scalars['String']['output'];
  /** The ID of the attachment */
  id: Scalars['ID']['output'];
  /** The attachment MIME type */
  mimeType: Scalars['String']['output'];
};

export type DVClientEmailConnection = {
  __typename: 'DVClientEmailConnection';
  /** The edges of the connection */
  edges: Array<DVClientEmailEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

export type DVClientEmailEdge = {
  __typename: 'DVClientEmailEdge';
  /** Cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The client email at the end of the edge */
  node: DVClientEmail;
};

export type DVClientEmailFilter = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emailTypes?: InputMaybe<Array<DVClientEmailType>>;
  /** Exclude client emails for any of these accounts. */
  excludeAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Exclude client emails whose account belongs to any of these entities. */
  excludeEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationTypes?: InputMaybe<Array<LifecycleEventType>>;
  queuedAfter?: InputMaybe<Scalars['Time']['input']>;
  queuedBefore?: InputMaybe<Scalars['Time']['input']>;
  sentAfter?: InputMaybe<Scalars['Time']['input']>;
  sentBefore?: InputMaybe<Scalars['Time']['input']>;
  statuses?: InputMaybe<Array<DVClientEmailStatus>>;
};

export enum DVClientEmailStatus {
  DEQUEUED = 'DEQUEUED',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  /** Replaced by a newer confirmation for the same trade before it was sent */
  SUPERSEDED = 'SUPERSEDED'
}

export enum DVClientEmailType {
  TRADE_CONFIRMATION = 'TRADE_CONFIRMATION'
}

export type DVCloseoutTradeInput = {
  /** The price at which the closeout is executed */
  closeoutPrice: Scalars['String']['input'];
  /** CurrencyType of the closeout price */
  currencyType: Scalars['String']['input'];
  /** The effective date of the closeout */
  effectiveDate: Scalars['Time']['input'];
  /**
   * The time the closeout was executed, used as the offset trade's timestamp on Haruko. When
   * omitted, the server uses the time of the request. Must not be in the future, and must not be
   * before the trade's latest valid activation, amendment, partial closeout or compression (or its
   * execution time when it has no activation). Must fall on or before the UTC day of effectiveDate
   * and of settlementDate, and before the trade's expiration.
   */
  execTime?: InputMaybe<Scalars['Time']['input']>;
  /**
   * The reduced additional initial margin amount. When omitted, the server computes it from the
   * remaining additional IM by the same rule as reducedImAmount. A supplied amount is used as given,
   * and must be between 0 and the remaining additional IM, or exactly the remaining additional IM on a
   * full closeout.
   */
  reducedAdditionalImAmount?: InputMaybe<Scalars['String']['input']>;
  /** The quantity in base asset to close out and offset */
  reducedBaseQuantity: Scalars['String']['input'];
  /**
   * The reduced initial margin amount. When omitted, the server computes it: a partial closeout
   * reduces the remaining IM in proportion to the remaining quantity closed, truncated to 2 decimal
   * places for USD and 8 otherwise, and a full closeout reduces all remaining IM. A supplied amount is
   * used as given, and must be between 0 and the remaining IM, or exactly the remaining IM on a full closeout.
   */
  reducedImAmount?: InputMaybe<Scalars['String']['input']>;
  /** The settlement date for the closeout */
  settlementDate: Scalars['Time']['input'];
  /** The reference rate of the underlying SPOT instrument */
  spotReferenceRate?: InputMaybe<Scalars['String']['input']>;
};

export type DVCollateralRule = {
  __typename: 'DVCollateralRule';
  assetId: Maybe<Scalars['ID']['output']>;
  concentrationLimitPercent: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  endDate: Maybe<Scalars['Time']['output']>;
  historyId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  nettingSetId: Scalars['ID']['output'];
  purpose: Scalars['String']['output'];
  startDate: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  valuationPercentage: Maybe<Scalars['String']['output']>;
};

/** Regulatory collateralization category of a netting set */
export enum DVCollateralizationCategory {
  FLCL = 'FLCL',
  OWC1 = 'OWC1',
  OWC2 = 'OWC2',
  OWP1 = 'OWP1',
  OWP2 = 'OWP2',
  PRC1 = 'PRC1',
  PRC2 = 'PRC2',
  PRCL = 'PRCL',
  UNCL = 'UNCL'
}

/**
 * DVCounterpartyMasterCopy is the derivs-local copy of counterparty reference data
 * sourced from the Transparency/counterparty workstream, used for SDR reporting and
 * CFTC trading-compliance gating.
 */
export type DVCounterpartyMasterCopy = {
  __typename: 'DVCounterpartyMasterCopy';
  accountControlAgreementExecuted: Maybe<Scalars['String']['output']>;
  accountControlAgreementRequired: Maybe<Scalars['Boolean']['output']>;
  anchorageEntity: Maybe<Scalars['String']['output']>;
  annexAQuestionnaireReceivedDate: Maybe<Scalars['Date']['output']>;
  approverDate: Maybe<Scalars['Date']['output']>;
  approverName: Maybe<Scalars['String']['output']>;
  bilateralAgreementExecutedDate: Maybe<Scalars['Date']['output']>;
  countryOfIncorporation: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  creditQuestionnaireReceivedDate: Maybe<Scalars['Date']['output']>;
  crossBorderMarginClassification: Maybe<Scalars['String']['output']>;
  csaRequired: Maybe<Scalars['Boolean']['output']>;
  designatedEvaluationAgent: Maybe<Scalars['String']['output']>;
  dfComplianceRoute: Maybe<Scalars['String']['output']>;
  dfProtocolAdherenceIdP1: Maybe<Scalars['String']['output']>;
  dfProtocolAdherenceIdP2: Maybe<Scalars['String']['output']>;
  dfProtocolReconciliation: Maybe<Scalars['String']['output']>;
  disclosurePackAccessGranted: Maybe<Scalars['Boolean']['output']>;
  ecpCategory: Maybe<Scalars['String']['output']>;
  ecpEvidenceDocReference: Maybe<Scalars['String']['output']>;
  ecpVerificationResult: Maybe<Scalars['String']['output']>;
  endUserExceptionFilingRoute: Maybe<Scalars['String']['output']>;
  endUserExceptionStandingElection: Maybe<Scalars['Boolean']['output']>;
  exemptionClaimed: Maybe<Scalars['Boolean']['output']>;
  exemptionSubstitutedCompliance: Maybe<Scalars['String']['output']>;
  exemptionType: Maybe<Scalars['String']['output']>;
  fcsSubsidiaryOfUsParent: Maybe<Scalars['Boolean']['output']>;
  federalEntity: Maybe<Scalars['Boolean']['output']>;
  feuDetermination: Maybe<Scalars['String']['output']>;
  financialCompanyTitleIi: Maybe<Scalars['Boolean']['output']>;
  financialEntityStatus: Maybe<Scalars['Boolean']['output']>;
  goodToTrade: Maybe<Scalars['Boolean']['output']>;
  goodToTradeDate: Maybe<Scalars['Date']['output']>;
  guaranteedByUsPerson: Maybe<Scalars['Boolean']['output']>;
  guarantorAddress: Maybe<Scalars['String']['output']>;
  guarantorExists: Maybe<Scalars['Boolean']['output']>;
  guarantorLei: Maybe<Scalars['String']['output']>;
  guarantorName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imSegregationAccountReference: Maybe<Scalars['String']['output']>;
  imSegregationCustodian: Maybe<Scalars['String']['output']>;
  imSegregationElection: Maybe<Scalars['Boolean']['output']>;
  initialMarginCsaExecuted: Maybe<Scalars['String']['output']>;
  institutionalSuitabilitySafeHarborBasis: Maybe<Scalars['String']['output']>;
  insuredDepositoryInstitution: Maybe<Scalars['Boolean']['output']>;
  internalCounterpartyId: Maybe<Scalars['String']['output']>;
  isdaMasterAgreementExecuted: Maybe<Scalars['Boolean']['output']>;
  isdaScheduleExecuted: Maybe<Scalars['Boolean']['output']>;
  kycCustomerTypePrimary: Maybe<Scalars['String']['output']>;
  kycCustomerTypeSecondary: Maybe<Scalars['String']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  lei: Maybe<Scalars['String']['output']>;
  marginExemptionElections: Maybe<Scalars['String']['output']>;
  marginRegime: Maybe<Scalars['String']['output']>;
  materialSwapsExposure: Maybe<Scalars['Boolean']['output']>;
  mseRiderAsOfDate: Maybe<Scalars['Date']['output']>;
  mseRiderStatus: Maybe<Scalars['String']['output']>;
  mseStatus: Maybe<Scalars['String']['output']>;
  nonFeuRepresentation: Maybe<Scalars['Boolean']['output']>;
  nonUsMarginRegimeInScope: Maybe<Scalars['Boolean']['output']>;
  noticesEmail: Maybe<Scalars['String']['output']>;
  notificationsDisclosuresEmail: Maybe<Scalars['String']['output']>;
  portfolioDataEmail: Maybe<Scalars['String']['output']>;
  portfolioReconciliationMethod: Maybe<Scalars['String']['output']>;
  ppobLocation: Maybe<Scalars['String']['output']>;
  preparerDate: Maybe<Scalars['Date']['output']>;
  preparerName: Maybe<Scalars['String']['output']>;
  principalAgentCapacity: Maybe<Scalars['String']['output']>;
  reconcileAgainstSdrDataAgreed: Maybe<Scalars['Boolean']['output']>;
  registrationStatus: Maybe<Scalars['String']['output']>;
  reportingPartyAgreementDate: Maybe<Scalars['Date']['output']>;
  reportingPartyAgreementDocReference: Maybe<Scalars['String']['output']>;
  reportingPartyAgreementMethod: Maybe<Scalars['String']['output']>;
  reportingPartyNegotiationRequired: Maybe<Scalars['Boolean']['output']>;
  reportingPartyOutcome: Maybe<Scalars['String']['output']>;
  riskValuationDisputeResolution: Maybe<Scalars['String']['output']>;
  riskValuationEmail: Maybe<Scalars['String']['output']>;
  sdlPartsReturned: Maybe<Scalars['String']['output']>;
  sdlReceivedDate: Maybe<Scalars['Date']['output']>;
  sdlSentDate: Maybe<Scalars['Date']['output']>;
  sdlSignatoryName: Maybe<Scalars['String']['output']>;
  sdlSignatoryTitle: Maybe<Scalars['String']['output']>;
  specialEntityReview: Maybe<Scalars['String']['output']>;
  thirdPartyControlPerson: Maybe<Scalars['String']['output']>;
  tradeReportingEngineUpdatedDate: Maybe<Scalars['Date']['output']>;
  tradingAuthorizationDocReference: Maybe<Scalars['String']['output']>;
  tradingAuthorizationStatus: Maybe<Scalars['String']['output']>;
  tradingSupervisorCountries: Maybe<Scalars['String']['output']>;
  tradingSupervisors: Maybe<Scalars['String']['output']>;
  ultimateUsParentName: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  usPersonConduit: Maybe<Scalars['Boolean']['output']>;
  usPersonFinal: Maybe<Scalars['String']['output']>;
  usPersonStatus: Maybe<Scalars['String']['output']>;
  variationMarginCsaExecuted: Maybe<Scalars['String']['output']>;
};

/** Input for creating a timing rule */
export type DVCreateTimingRuleInput = {
  /** Reference point for timing calculation */
  anchor?: InputMaybe<Scalars['String']['input']>;
  /** CSA ID this timing rule belongs to */
  csaId: Scalars['ID']['input'];
  /** Day convention for calculations */
  dayConvention?: InputMaybe<DVDayConvention>;
  /** Number of days offset from anchor */
  dayOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Event type this rule applies to */
  event: DVTimingEvent;
  /** Timing tier classification */
  tier?: InputMaybe<DVTimingTier>;
  /** Specific time of day (format: HH:MM:SS) */
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  /** Timezone for time calculations (e.g., "America/New_York") */
  timezone: Scalars['String']['input'];
};

/**
 * A custodian/exchange institution (e.g. "ADS", "ADB", "Fireblocks", "Customers Bank"), named once
 * globally and shared by every entity it serves.
 */
export type DVCustodian = {
  __typename: 'DVCustodian';
  /** When the custodian was created */
  createdAt: Scalars['Time']['output'];
  /** The custodian/exchange name, unique ignoring case */
  custodianName: Scalars['String']['output'];
  /** The ID of the custodian */
  id: Scalars['ID']['output'];
  /** When the custodian was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/**
 * A named wallet/account under one trading entity's relationship with a custodian (e.g. "Derivs
 * Omni" under A1's "ADS" relationship) — the selection surfaced in the deposit/withdrawal dropdown.
 * The same custodian can serve more than one entity (e.g. "ADB" serves both A1 and ADSD); each is a
 * separate relationship with its own wallets.
 */
export type DVCustodianWallet = {
  __typename: 'DVCustodianWallet';
  /** When the custodian wallet was created */
  createdAt: Scalars['Time']['output'];
  /** The ID of the parent custodian */
  custodianId: Scalars['ID']['output'];
  /** The custodian/exchange name (e.g. "ADS", "ADB", "Fireblocks", "Customers Bank") */
  custodianName: Scalars['String']['output'];
  /** The ID of the trading entity this wallet belongs to */
  entityId: Scalars['ID']['output'];
  /** The name of the trading entity this wallet belongs to (e.g. "A1, LTD.", "ADSD") */
  entityName: Scalars['String']['output'];
  /** The ID of the custodian wallet */
  id: Scalars['ID']['output'];
  /** When the custodian wallet was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** The wallet/account name, excluding the entity/custodian prefix implied by entityName/custodianName (e.g. "Derivs Omni") */
  walletName: Scalars['String']['output'];
};

export type DVCustodianWalletFilter = {
  /** Only wallets whose custodian serves this entity */
  entityId?: InputMaybe<Scalars['ID']['input']>;
};

/** Day convention for CSA call schedules */
export enum DVDayConvention {
  CALENDAR = 'CALENDAR',
  LOCAL_BUSINESS_DAY = 'LOCAL_BUSINESS_DAY'
}

/** Input for delivering a client report via SFTP */
export type DVDeliverClientReportInput = {
  /** Client identifier that determines the SFTP delivery destination (e.g. "bitwise") */
  client: Scalars['ID']['input'];
  /** The file to deliver */
  file: UploadFile;
};

/** Input for delivering the monthly transfer activity file to Cryptio */
export type DVDeliverCryptioTransferActivityInput = {
  /** A prepared transfer activity CSV to upload as-is. Omit it to generate the month from Haruko. */
  file?: InputMaybe<UploadFile>;
  /** Month the activity covers, as YYYY-MM (e.g. "2026-08") */
  month: Scalars['String']['input'];
};

/** Ops' confirmation of one date's end of day recon */
export type DVEndOfDayReconConfirmation = {
  __typename: 'DVEndOfDayReconConfirmation';
  /** The date whose recon was confirmed */
  asOfDate: Scalars['Date']['output'];
  /** When it was confirmed */
  confirmedAt: Scalars['Timestamp']['output'];
  /** The staff user who confirmed it */
  confirmedBy: Scalars['String']['output'];
};

export type DVEntity = {
  __typename: 'DVEntity';
  /** When the entity was created */
  createdAt: Scalars['Time']['output'];
  /** The name of the entity (e.g., "A1 Derivatives", "Swap Dealer", "HedgeCo") */
  entityName: Scalars['String']['output'];
  /** Whether the entity is a CFTC financial entity, sent as Counterparty 1 financial entity in its SDR reports; null when unset */
  financialEntityStatus: Maybe<Scalars['Boolean']['output']>;
  /** Haruko venue account this entity's trades are booked under */
  harukoVenueId: Scalars['Int']['output'];
  /** ICE company batch id this entity's SDR reports are submitted under; null until the ICE tenant is provisioned */
  iceCompanyBatchId: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id: Scalars['ID']['output'];
  /** Legal Entity Identifier (LEI) */
  lei: Maybe<Scalars['String']['output']>;
  /** Legacy, no longer read: automation depends only on the account's automateObligationsAndLedgerEntries. */
  settlementAutomationsEnabled: Scalars['Boolean']['output'];
  /** When the entity was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

export type DVEntityFilter = {
  /** Filter by entity names (partial match) */
  entityNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by specific entity IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by LEI (partial match) */
  lei?: InputMaybe<Scalars['String']['input']>;
};

export type DVExerciseTradeInput = {
  /** The fix price for non-deliverable options (optional) */
  fixPrice?: InputMaybe<Scalars['String']['input']>;
};

export enum DVFeeDirection {
  A1_PAYS = 'A1_PAYS',
  A1_RECS = 'A1_RECS'
}

export type DVFileDownload = {
  __typename: 'DVFileDownload';
  /** The content of this file, base64 encoded */
  content: Scalars['String']['output'];
  /** The name of this file */
  filename: Scalars['String']['output'];
  /** The MIME type of the file */
  mimeType: Scalars['String']['output'];
};

export type DVHarukoBackfillRequest = {
  __typename: 'DVHarukoBackfillRequest';
  /** When the request was created (UTC) */
  createdAt: Scalars['Time']['output'];
  /** Haruko API endpoint */
  endpoint: HarukoEndpoint;
  /** Error message if the job failed */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** When the job was executed (UTC) */
  executionTime: Maybe<Scalars['Time']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Timestamp of the data being backfilled (UTC) */
  requestedTs: Scalars['Time']['output'];
  /** Job status: scheduled, done, or failed */
  status: Scalars['String']['output'];
};

export type DVHarukoBackfillRequestConnection = {
  __typename: 'DVHarukoBackfillRequestConnection';
  /** The edges of the connection */
  edges: Array<DVHarukoBackfillRequestEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DVHarukoBackfillRequestEdge = {
  __typename: 'DVHarukoBackfillRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The backfill request at the end of the edge. */
  node: DVHarukoBackfillRequest;
};

/** A Haruko group a synthetic venue can be created in, mirrored from Haruko. */
export type DVHarukoGroup = {
  __typename: 'DVHarukoGroup';
  /** Operator choice, on by default for a new group. Only enabled groups that Haruko still returns can receive new venues. */
  enabled: Scalars['Boolean']['output'];
  /** Haruko's own group id. */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Haruko's parent group id. Null for a top-level group, or when Haruko reports a parent it does not return. */
  parentGroupId: Maybe<Scalars['Int']['output']>;
  /** Set when Haruko stopped returning this group. */
  removedAt: Maybe<Scalars['Time']['output']>;
};

/** Which of an account's two Haruko venues an operation is about. */
export enum DVHarukoVenuePurpose {
  /** The account's normal venue, stored as harukoVenueId and named after harukoMask. */
  BILATERAL = 'BILATERAL',
  /** The account's triparty collateral venue, stored as harukoTripartyVenueId and named harukoMask + "_TRIPARTY". */
  TRIPARTY = 'TRIPARTY'
}

/** ECRS GatewayAction applied for an SDR report. */
export enum DVICEGatewayAction {
  REMOVE = 'REMOVE',
  SUBMIT = 'SUBMIT',
  TERMINATE = 'TERMINATE'
}

/**
 * ICE SDR reporting status for one (trade, version). Nullable status fields are
 * null until that stage of the reporting lifecycle has been reached.
 */
export type DVICEReport = {
  __typename: 'DVICEReport';
  /** Whether this report was sent as a correction (an amendment, or a correction report) */
  correction: Scalars['Boolean']['output'];
  /** For a correction report: why it was queued; null otherwise */
  correctionReason: Maybe<Scalars['String']['output']>;
  /** For a correction report: the SUBMITTED version it corrects at ICE; null otherwise */
  correctsVersion: Maybe<Scalars['Int']['output']>;
  /** time the report row was created */
  createdAt: Scalars['Time']['output'];
  /** Origin actor that queued the report (a user id, or the system reporter) */
  createdBy: Scalars['String']['output'];
  /** Reporting entity this report is filed under, resolved from the trade. Map to a name via dvEntities. */
  entityId: Maybe<Scalars['ID']['output']>;
  /** Failure detail (gateway/trade/workflow errors), empty when none */
  errorText: Scalars['String']['output'];
  /** Trade event that queued the report (e.g. ACTIVE, AMENDMENT, MATURE) */
  eventType: Scalars['String']['output'];
  /** GatewayAction applied (SUBMIT on new/amend, TERMINATE/REMOVE on lifecycle end) */
  gatewayAction: DVICEGatewayAction;
  /** ICE gateway submission ID, empty until the file is accepted for ingestion */
  gatewaySubmissionId: Scalars['String']['output'];
  /** time the status was last polled from ICE (null if never polled) */
  lastPolledAt: Maybe<Scalars['Time']['output']>;
  /** Reason given for the latest review action (discard or restore), empty when none */
  reason: Scalars['String']['output'];
  /** Report row id (used to Submit/Discard from the reporting queue) */
  reportId: Scalars['ID']['output'];
  /** Manual-review state (QUEUED awaits a human Submit, SUBMITTED sent to ICE, DISCARDED declined or excluded (restorable), FAILED submission failed (requeueable)) */
  reviewStatus: DVICEReviewStatus;
  /** Gateway submission status; null until a submission has been made */
  submissionStatus: Maybe<DVICESubmissionStatus>;
  /** time the submission was sent to ICE (null if not yet submitted) */
  submittedAt: Maybe<Scalars['Time']['output']>;
  /** Trade this report belongs to */
  tradeId: Scalars['ID']['output'];
  /** TVCFTC_Reporting_Synchronized linkage flag; null until the trade status is polled */
  tvcftcReportingSynchronized: Maybe<DVICEYesNo>;
  /** TVCFTC_Reporting_Valid linkage flag; null until the trade status is polled */
  tvcftcReportingValid: Maybe<DVICEYesNo>;
  /** Unique Trade Identifier reported to the SDR */
  uti: Scalars['String']['output'];
  /**
   * Trade version this report corresponds to; negative for a correction report, which
   * sorts before every live version of the trade
   */
  version: Scalars['Int']['output'];
};

/** One field of a report's submission snapshot, for human-readable review of report contents */
export type DVICEReportField = {
  __typename: 'DVICEReportField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Manual-review state of an SDR report:
 *   QUEUED awaits a human Submit
 *   SUBMITTED has been sent to ICE
 *   DISCARDED was declined
 */
export enum DVICEReviewStatus {
  DISCARDED = 'DISCARDED',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  SUBMITTED = 'SUBMITTED'
}

/** ICE eConfirm/ECRS gateway submission status for a single SDR report. */
export enum DVICESubmissionStatus {
  HOLD = 'HOLD',
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED'
}

/** ICE CFTC reporting linkage flag (Y/N). */
export enum DVICEYesNo {
  N = 'N',
  Y = 'Y'
}

/** Filter for the ICE reporting queue */
export type DVIceReportQueueFilter = {
  /** Amendments only (correction = true) vs originals. */
  correction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Origin actor(s). */
  createdBy?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict to specific reporting entities. */
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** SUBMIT / TERMINATE / REMOVE — e.g. new/amend vs lifecycle-end reports. */
  gatewayActions?: InputMaybe<Array<DVICEGatewayAction>>;
  /** Review state(s). Defaults to [QUEUED] when omitted. */
  reviewStatuses?: InputMaybe<Array<DVICEReviewStatus>>;
  /** Post-submit gateway state — e.g. surface REJECTED reports needing re-action. */
  submissionStatuses?: InputMaybe<Array<DVICESubmissionStatus>>;
  /** Restrict to specific trades. */
  tradeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Lookup by Unique Transaction Identifier. */
  utis?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Maps an ingest chat to the account its ingested trades book into, sourced from
 * otc.ingest_chat_accounts. An unmapped chat parks its messages instead of guessing.
 */
export type DVIngestChatAccount = {
  __typename: 'DVIngestChatAccount';
  /** The account ID ingested trades from this chat book into */
  accountId: Scalars['ID']['output'];
  /** When the chat was first mapped */
  createdAt: Scalars['Time']['output'];
  /** Who first mapped the chat */
  createdBy: Scalars['String']['output'];
  /** Full ingest source, e.g. telegram:-1004392170456 or slack:C0123456789 */
  ingestSource: Scalars['String']['output'];
  /** When the mapping was last moved to another account */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/**
 * One run's booked IM for an account and asset, with a received side and a posted side.
 * Native units, with no spot applied.
 */
export type DVInitialMargin = {
  __typename: 'DVInitialMargin';
  /** The account the requirement is against */
  accountId: Scalars['ID']['output'];
  /** The date that run priced */
  asOfDate: Scalars['Date']['output'];
  /** The asset the requirement is denominated in */
  assetId: Scalars['ID']['output'];
  /** imRequired less imHeld, base only — negative where the account is over */
  imDue: Scalars['String']['output'];
  /** imDue plus imDueTriparty. On a run written before the split it equals the unsuffixed figure */
  imDueTotal: Maybe<Scalars['String']['output']>;
  /** imDue for the triparty part: imRequiredTriparty less imHeldTriparty. Null on a run written before the split */
  imDueTriparty: Maybe<Scalars['String']['output']>;
  /** IM the run saw posted in, base only: INITIAL_MARGIN_HELD, its own snapshot of the ledger */
  imHeld: Scalars['String']['output'];
  /** imHeld plus imHeldTriparty. On a run written before the split it equals the unsuffixed figure */
  imHeldTotal: Maybe<Scalars['String']['output']>;
  /** imHeld for INITIAL_MARGIN_HELD_TRIPARTY. Null on a run written before the split */
  imHeldTriparty: Maybe<Scalars['String']['output']>;
  /** IM the run saw posted out, base only: INITIAL_MARGIN_POSTED */
  imPosted: Scalars['String']['output'];
  /** imPostedRequired less imPosted, base only */
  imPostedDue: Scalars['String']['output'];
  /** imPostedDue plus imPostedDueTriparty. On a run written before the split it equals the unsuffixed figure */
  imPostedDueTotal: Maybe<Scalars['String']['output']>;
  /** imPostedDue for the triparty part. Null on a run written before the split */
  imPostedDueTriparty: Maybe<Scalars['String']['output']>;
  /** IM that must be posted out to the account, base only: the A1_POST legs, without the triparty ones. Zero on a one-way CSA */
  imPostedRequired: Scalars['String']['output'];
  /** imPostedRequired plus imPostedRequiredTriparty. On a run written before the split it equals the unsuffixed figure */
  imPostedRequiredTotal: Maybe<Scalars['String']['output']>;
  /** imPostedRequired for the A1_POST_TRIPARTY legs. Null on a run written before the split, whose imPostedRequired holds the total */
  imPostedRequiredTriparty: Maybe<Scalars['String']['output']>;
  /** imPosted plus imPostedTriparty. On a run written before the split it equals the unsuffixed figure */
  imPostedTotal: Maybe<Scalars['String']['output']>;
  /** imPosted for INITIAL_MARGIN_POSTED_TRIPARTY. Null on a run written before the split */
  imPostedTriparty: Maybe<Scalars['String']['output']>;
  /** IM the account must post in, base only: the A1_REC legs, without the triparty ones */
  imRequired: Scalars['String']['output'];
  /** imRequired plus imRequiredTriparty. On a run written before the split it equals the unsuffixed figure */
  imRequiredTotal: Maybe<Scalars['String']['output']>;
  /** imRequired for the A1_REC_TRIPARTY legs. Null on a run written before the split, whose imRequired holds the total */
  imRequiredTriparty: Maybe<Scalars['String']['output']>;
  /**
   * The netting set a run written before booked IM moved to the account grain calculated this line
   * on. Null for newer runs, which hold one line per account and asset
   * @deprecated Booked IM is per account and asset; new runs leave this null
   */
  nettingSetId: Maybe<Scalars['ID']['output']>;
  /** The run this line belongs to */
  runId: Scalars['ID']['output'];
};

/** Filter for dvInitialMargin. All fields are optional. */
export type DVInitialMarginFilter = {
  /** Filter by account ID */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Read the newest run not dated after this point in time. Defaults to the newest run of any date */
  asOf?: InputMaybe<Scalars['Time']['input']>;
  /** Filter by asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
};

export enum DVInitialMarginMethod {
  NONE = 'NONE',
  RISK_FACTOR = 'RISK_FACTOR',
  SIMPLE = 'SIMPLE'
}

/** IM lines and the run they were read from. */
export type DVInitialMarginResult = {
  __typename: 'DVInitialMarginResult';
  /** The run's IM lines matching the filter. Empty when run is null */
  requirements: Array<DVInitialMargin>;
  /** The run the lines came from. Null when no run has succeeded yet */
  run: Maybe<DVMarginRun>;
};

/**
 * One append-only otc.internal_movements row — a cross-custodian rebalancing transfer for one
 * trading entity (e.g. that entity's "Derivs Omni" wallet at Fireblocks -> its "Derivs Vault" wallet
 * at Binance). Unlike a DVLedgerTransaction, this is not a ledger posting: it never affects any
 * account's reported balance (recordkeeping only), so it has no bucket and no direction, just a
 * source (custodianWalletFromId) and destination (custodianWalletToId) — both otc.custodian_wallets belonging
 * to entityId. Corrections are always reversing entries (reversalOfId set on a new row), never edits
 * — metadata is the sole exception, a free-form note editable in place.
 */
export type DVInternalMovement = {
  __typename: 'DVInternalMovement';
  /** This movement's amount — never negative, though zero is possible */
  amount: Scalars['String']['output'];
  /** The asset this movement is denominated in */
  assetId: Scalars['ID']['output'];
  /** When this movement was created */
  createdAt: Scalars['Time']['output'];
  /** Who created this movement */
  createdBy: Scalars['String']['output'];
  /** The source custodian wallet of this cross-custodian movement */
  custodianWalletFromId: Scalars['ID']['output'];
  /**
   * The destination custodian wallet of this cross-custodian movement — always for the same
   * entityId as custodianWalletFromId
   */
  custodianWalletToId: Scalars['ID']['output'];
  /** Free-form description */
  description: Maybe<Scalars['String']['output']>;
  /** The point in time this movement is effective as of */
  effectiveAt: Scalars['Time']['output'];
  /** The trading entity this movement is for */
  entityId: Scalars['ID']['output'];
  /**
   * The counterparty/venue fee charged on this movement, if any — null when no fee was recorded.
   * Recordkeeping only, like the movement itself: never affects any account's reported balance.
   */
  feeAmount: Maybe<Scalars['String']['output']>;
  /**
   * The asset feeAmount is denominated in, if a fee was recorded — often different from assetId
   * (e.g. a USDC transfer with a fee paid in ETH). Null iff feeAmount is.
   */
  feeAssetId: Maybe<Scalars['ID']['output']>;
  /** The unique ID of this movement */
  id: Scalars['ID']['output'];
  /** Free-form, editable-in-place metadata */
  metadata: Maybe<Scalars['String']['output']>;
  /** Free-form reference to an external record this movement is associated with, if any */
  referenceId: Maybe<Scalars['String']['output']>;
  /** If this movement reverses a prior movement, the ID of that movement */
  reversalOfId: Maybe<Scalars['ID']['output']>;
  /** When this movement was last updated (metadata corrections only) */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** Who last updated this movement */
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type DVInternalMovementConnection = {
  __typename: 'DVInternalMovementConnection';
  /** The edges of the connection, each containing an internal movement and its cursor */
  edges: Array<DVInternalMovementEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DVInternalMovementEdge = {
  __typename: 'DVInternalMovementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The internal movement at the end of the edge. */
  node: DVInternalMovement;
};

/** Filter for listing otc.internal_movements. All fields are optional. */
export type DVInternalMovementFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Filter by asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the source custodian wallet ID */
  custodianWalletFromId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the destination custodian wallet ID */
  custodianWalletToId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by trading entity ID */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DVKillTradeInput = {
  /** Optional reason for killing the trade */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The new state of the trade after killing */
  state: DVTradeStatus;
};

/**
 * A derived balance for one (account, entity, asset) grouping — sums over otc.ledger_transactions
 * entries. Never stored: computed live on every query, so it always reflects entries posted up to
 * now.
 */
export type DVLedgerBalance = {
  __typename: 'DVLedgerBalance';
  /** The account this balance is for */
  accountId: Scalars['ID']['output'];
  /** The account's own name */
  accountName: Scalars['String']['output'];
  /** The asset this balance is denominated in */
  assetId: Scalars['ID']['output'];
  /** The asset's full name (e.g. "Bitcoin") */
  assetName: Scalars['String']['output'];
  /** The asset's ticker symbol (e.g. "BTC") */
  assetSymbol: Scalars['String']['output'];
  /** The account's counterparty name */
  counterpartyName: Scalars['String']['output'];
  /** The trading entity this balance is for, if populated */
  entityId: Maybe<Scalars['ID']['output']>;
  /**
   * The trading entity's name, if entityId is populated. "Unassigned" when entityId is null — a
   * distinct group of its own, not to be confused with a balance actually belonging to an entity
   */
  entityName: Maybe<Scalars['String']['output']>;
  /** Sum of FREE_BALANCE bucket entries only — FREE_BALANCE_TRIPARTY is reported in freeTriparty */
  free: Scalars['String']['output'];
  /** Sum of FREE_BALANCE_TRIPARTY bucket entries, additional to free */
  freeTriparty: Scalars['String']['output'];
  /**
   * What the account is short by once collateral is netted both ways, or negative where it
   * is over. Both legs are live, unless an asOf filter on a past day puts the reading on the run
   */
  imDue: Scalars['String']['output'];
  /**
   * The part of imDue from triparty legs, netted against imHeldTriparty and imPostedTriparty
   * alone. Unsecured triparty collateral does not reduce it. Under an asOf filter on a past day it
   * is the run's figure, null when the run stored no triparty split
   */
  imDueTriparty: Maybe<Scalars['String']['output']>;
  /**
   * Sum of INITIAL_MARGIN_HELD bucket entries only — INITIAL_MARGIN_HELD_TRIPARTY is reported in
   * imHeldTriparty
   */
  imHeld: Scalars['String']['output'];
  /** Sum of INITIAL_MARGIN_HELD_TRIPARTY bucket entries, additional to imHeld */
  imHeldTriparty: Scalars['String']['output'];
  /**
   * IM posted out, read as debits - credits so it is positive: INITIAL_MARGIN_POSTED only,
   * INITIAL_MARGIN_POSTED_TRIPARTY is reported in imPostedTriparty
   */
  imPosted: Scalars['String']['output'];
  /**
   * IM the booked trades require this account to have been posted out for this asset, against
   * imPosted plus imPostedTriparty. Zero on a one-way CSA
   */
  imPostedRequired: Scalars['String']['output'];
  /**
   * The part of imPostedRequired from triparty legs (A1_POST_TRIPARTY). Under an asOf filter on a
   * past day it is the run's figure, null when the run stored no triparty split
   */
  imPostedRequiredTriparty: Maybe<Scalars['String']['output']>;
  /**
   * Triparty IM posted out, additional to imPosted, read as debits - credits so it is positive
   * (INITIAL_MARGIN_POSTED_TRIPARTY)
   */
  imPostedTriparty: Scalars['String']['output'];
  /**
   * IM the booked trades require this account to have posted in for this asset, against imHeld.
   * Native units, moving as trades are booked and closed out rather than at the margin run. Under
   * an asOf filter on a past day it is the run's figure for that day instead, and zero until a run
   * has succeeded
   */
  imRecRequired: Scalars['String']['output'];
  /**
   * The part of imRecRequired from triparty legs (A1_REC_TRIPARTY). Under an asOf filter on a past
   * day it is the run's figure, null when the run stored no triparty split
   */
  imRecRequiredTriparty: Maybe<Scalars['String']['output']>;
  /**
   * imRecRequired less imPostedRequired: the account's net IM for this asset. Positive where it
   * owes IM in, negative where IM is owed back out to it
   */
  imRequired: Scalars['String']['output'];
  /**
   * The part of imRequired from triparty legs: imRecRequiredTriparty less imPostedRequiredTriparty.
   * Under an asOf filter on a past day it is the run's figure, null when the run stored no triparty
   * split
   */
  imRequiredTriparty: Maybe<Scalars['String']['output']>;
  /** The date that run priced, on the same terms as marginRunId */
  marginAsOfDate: Maybe<Scalars['Date']['output']>;
  /**
   * The margin run the IM columns came from. Only ever set under an asOf filter on a past day, and
   * vmRunId then names the same run when set. A current reading is taken from the trades themselves and has no
   * run behind it
   */
  marginRunId: Maybe<Scalars['ID']['output']>;
  /**
   * freeTriparty + imHeldTriparty + vmHeldTriparty — kept for callers still reading this combined
   * figure rather than summing the three themselves
   */
  ofWhichTriparty: Scalars['String']['output'];
  /**
   * The group's Reg IM due, as dvMarginAccounts reports it in regIm.due, on the same terms as
   * regImRequired. Zero on a non-USD row, and zero on a USD row whose run did not state a due
   */
  regImDue: Scalars['String']['output'];
  /** Sum of REG_INITIAL_MARGIN_HELD bucket entries */
  regImHeld: Scalars['String']['output'];
  /**
   * 23.157 reg IM posted out to the counterparty's custodian, read as debits - credits so it is
   * positive (REG_INITIAL_MARGIN_POSTED)
   */
  regImPosted: Scalars['String']['output'];
  /**
   * The Reg IM the margin run requires of the account's affiliate group, as dvMarginAccounts
   * reports it in regIm.required. Populated on USD rows alone and zero on every other asset.
   * Each affiliated account's USD row carries the whole group's figure, so never sum it across
   * accounts
   */
  regImRequired: Scalars['String']['output'];
  /** Sum of SETTLEMENT bucket entries */
  settlement: Scalars['String']['output'];
  /**
   * free + imHeld + regImHeld + vmHeld + settlement, each plus its triparty counterpart
   * (freeTriparty, imHeldTriparty, vmHeldTriparty). Every posted bucket is excluded — imPosted,
   * vmPosted and regImPosted are margin already posted out, not assets of the account.
   */
  total: Scalars['String']['output'];
  /**
   * The instant the ledger columns were read at. For a past day it is the instant the run named by
   * marginRunId read the ledger, so the ledger columns agree with that run's IM; without a run, or
   * for a run that did not record it, it is asOf. A current reading gives the time of the read.
   * Null on a stored snapshot line
   */
  valuesAsOf: Maybe<Scalars['Time']['output']>;
  /** The date that run priced, on the same terms as vmRunId */
  vmAsOfDate: Maybe<Scalars['Date']['output']>;
  /**
   * vmRequired less this row's vmHeld net of vmPosted, at the CSA's valuation percentage. The
   * held leg is the live ledger rather than the run's reading, so a movement booked after the
   * run reaches this figure without waiting for the next one. Under an asOf filter on a past day it
   * is the run's own due instead, valued under the terms that run read. Positive is owed in, on the
   * same terms as imDue
   */
  vmDue: Maybe<Scalars['String']['output']>;
  /**
   * Sum of VARIATION_MARGIN_HELD bucket entries only — VARIATION_MARGIN_HELD_TRIPARTY is reported
   * in vmHeldTriparty
   */
  vmHeld: Scalars['String']['output'];
  /** Sum of VARIATION_MARGIN_HELD_TRIPARTY bucket entries, additional to vmHeld */
  vmHeldTriparty: Scalars['String']['output'];
  /** VM posted out to the client, read as debits - credits so it is positive (VARIATION_MARGIN_POSTED) */
  vmPosted: Scalars['String']['output'];
  /**
   * VM the CSA requires of this account, in the CSA's valuation currency — so it is populated on
   * that currency's row alone and is null on every other asset the account holds. Two CSAs valued
   * in one currency sum. Net of the CSA threshold and gross of collateral, priced against the
   * run's marks, so it moves once a day and not on a collateral movement
   */
  vmRequired: Maybe<Scalars['String']['output']>;
  /**
   * The margin run vmRequired came from. A current vmDue nets that against the live ledger, so
   * only the requirement is pinned to it
   */
  vmRunId: Maybe<Scalars['ID']['output']>;
};

/** Filter for dvLedgerBalances. All fields are optional. */
export type DVLedgerBalanceFilter = {
  /** Filter by account ID */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Read the balances of the New York day this instant falls on. On a past day every column comes
   * from the newest succeeded margin run dated on or before that day, and the ledger columns are read
   * at the instant that run read the ledger, so the hour given does not change the row. Without such
   * a run the ledger is read at asOf, the run ids are null and the requirements zero. A time on the current New York
   * day or later reads the same as omitting it: the live balances
   */
  asOf?: InputMaybe<Scalars['Time']['input']>;
  /** Filter by asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by trading entity ID */
  entityId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * One hourly snapshot of dvLedgerBalances: the live reading as captured at that hour, never an asOf
 * reading, or the record that the capture failed.
 */
export type DVLedgerBalanceSnapshot = {
  __typename: 'DVLedgerBalanceSnapshot';
  /** When the balances were read. Null when the capture failed */
  capturedAt: Maybe<Scalars['Time']['output']>;
  /** Why the capture failed. Null unless status is FAILED */
  error: Maybe<Scalars['String']['output']>;
  /** The snapshot's ID, passed to dvLedgerBalanceSnapshotLines to read its balances */
  id: Scalars['ID']['output'];
  /** Details recorded with the capture, as JSON text */
  metadata: Scalars['String']['output'];
  /** The hour this snapshot stands for */
  scheduledAt: Scalars['Time']['output'];
  /** Whether the capture succeeded */
  status: DVLedgerBalanceSnapshotStatus;
};

export type DVLedgerBalanceSnapshotConnection = {
  __typename: 'DVLedgerBalanceSnapshotConnection';
  /** The edges of the connection, each containing a balance snapshot and its cursor */
  edges: Array<DVLedgerBalanceSnapshotEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DVLedgerBalanceSnapshotEdge = {
  __typename: 'DVLedgerBalanceSnapshotEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The balance snapshot at the end of the edge. */
  node: DVLedgerBalanceSnapshot;
};

/** Filter for dvLedgerBalanceSnapshots. All fields are optional. */
export type DVLedgerBalanceSnapshotFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Only snapshots scheduled at or after this time */
  from?: InputMaybe<Scalars['Time']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by capture status */
  status?: InputMaybe<DVLedgerBalanceSnapshotStatus>;
  /** Only snapshots scheduled at or before this time */
  to?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * One stored balance line of a snapshot. Its balance is the live dvLedgerBalances reading as
 * captured at the snapshot's hour, so the asOf terms in the balance field docs never apply to it.
 */
export type DVLedgerBalanceSnapshotLine = {
  __typename: 'DVLedgerBalanceSnapshotLine';
  /** The balance exactly as it was stored */
  balance: DVLedgerBalance;
  /** The line's ID */
  id: Scalars['ID']['output'];
};

/** Filter for dvLedgerBalanceSnapshotLines. All fields are optional. */
export type DVLedgerBalanceSnapshotLineFilter = {
  /** Filter by account ID */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by trading entity ID */
  entityId?: InputMaybe<Scalars['ID']['input']>;
};

/** Whether the hourly capture of dvLedgerBalances succeeded. */
export enum DVLedgerBalanceSnapshotStatus {
  /** The balances were captured and stored as the snapshot's lines */
  CAPTURED = 'CAPTURED',
  /** The capture failed; the snapshot has no lines and carries the error */
  FAILED = 'FAILED'
}

/** Discriminates which balance a otc.ledger_transactions entry moves. */
export enum DVLedgerBucket {
  FREE_BALANCE = 'FREE_BALANCE',
  /** Same as FREE_BALANCE, but held at a triparty custodian rather than internally. */
  FREE_BALANCE_TRIPARTY = 'FREE_BALANCE_TRIPARTY',
  INITIAL_MARGIN_HELD = 'INITIAL_MARGIN_HELD',
  /** Same as INITIAL_MARGIN_HELD, but held at a triparty custodian rather than internally. */
  INITIAL_MARGIN_HELD_TRIPARTY = 'INITIAL_MARGIN_HELD_TRIPARTY',
  INITIAL_MARGIN_POSTED = 'INITIAL_MARGIN_POSTED',
  /** Same as INITIAL_MARGIN_POSTED, but posted to a triparty custodian. */
  INITIAL_MARGIN_POSTED_TRIPARTY = 'INITIAL_MARGIN_POSTED_TRIPARTY',
  /**
   * reg IM, at an independent third-party custodian, one account per customer —
   * never commingled with the booked INITIAL_MARGIN_* buckets and never netted against them.
   */
  REG_INITIAL_MARGIN_HELD = 'REG_INITIAL_MARGIN_HELD',
  REG_INITIAL_MARGIN_POSTED = 'REG_INITIAL_MARGIN_POSTED',
  SETTLEMENT = 'SETTLEMENT',
  VARIATION_MARGIN_HELD = 'VARIATION_MARGIN_HELD',
  /** Same as VARIATION_MARGIN_HELD, but held at a triparty custodian rather than internally. */
  VARIATION_MARGIN_HELD_TRIPARTY = 'VARIATION_MARGIN_HELD_TRIPARTY',
  VARIATION_MARGIN_POSTED = 'VARIATION_MARGIN_POSTED'
}

/** The kind of movement a otc.ledger_transactions entry records. */
export enum DVLedgerEntryType {
  DEPOSIT = 'DEPOSIT',
  INTEREST = 'INTEREST',
  REVERSAL = 'REVERSAL',
  TRANSFER = 'TRANSFER',
  WITHDRAWAL = 'WITHDRAWAL'
}

/**
 * One entry in the append-only otc.ledger_transactions ledger — a parent row over 1 or 2
 * otc.ledger_entries postings (2 only for TRANSFER or a REVERSAL of one).
 * Balances are always derived sums over entries, never stored.
 */
export type DVLedgerTransaction = {
  __typename: 'DVLedgerTransaction';
  /** The account this entry belongs to */
  accountId: Scalars['ID']['output'];
  /**
   * This entry's amount — never negative, though zero is possible. Direction lives entirely in
   * which of bucketFrom/bucketTo is populated, never in the sign.
   */
  amount: Scalars['String']['output'];
  /** The asset this entry is denominated in */
  assetId: Scalars['ID']['output'];
  /**
   * The bucket this entry debits. Null for a DEPOSIT (which only credits bucketTo), populated for
   * everything else that has a debited side (WITHDRAWAL, INTEREST, TRANSFER, and a REVERSAL of one
   * of those).
   */
  bucketFrom: Maybe<DVLedgerBucket>;
  /**
   * The bucket this entry credits. Null for a WITHDRAWAL/INTEREST (which only debits bucketFrom),
   * populated for everything else that has a credited side (DEPOSIT, TRANSFER, and a REVERSAL of
   * one of those).
   */
  bucketTo: Maybe<DVLedgerBucket>;
  /** When this entry was created */
  createdAt: Scalars['Time']['output'];
  /** Who created this entry */
  createdBy: Scalars['String']['output'];
  /** The custodian wallet this entry is associated with, if any */
  custodianWalletId: Maybe<Scalars['ID']['output']>;
  /** Free-form description */
  description: Maybe<Scalars['String']['output']>;
  /** The point in time this entry is effective as of */
  effectiveAt: Scalars['Time']['output'];
  /** The trading entity that faced this entry, if populated */
  entityId: Maybe<Scalars['ID']['output']>;
  /** The kind of movement this entry records */
  entryType: DVLedgerEntryType;
  /** The unique ID of this ledger entry */
  id: Scalars['ID']['output'];
  /** Free-form, editable-in-place metadata */
  metadata: Maybe<Scalars['String']['output']>;
  /** Free-form reference to an external record (e.g. margin call, premium invoice) this entry is associated with, if any */
  referenceId: Maybe<Scalars['String']['output']>;
  /** If this entry reverses a prior entry, the ID of that entry */
  reversalOfId: Maybe<Scalars['ID']['output']>;
  /** The trade this entry is associated with, if any */
  tradeId: Maybe<Scalars['ID']['output']>;
  /**
   * Reserved for a different, not-yet-implemented grouping purpose — does not relate a TRANSFER's
   * two postings (those are otc.ledger_entries rows under this one transaction already). Unused
   * today.
   */
  transferGroupId: Maybe<Scalars['ID']['output']>;
  /** When this entry was last updated (metadata corrections only) */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** Who last updated this entry */
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type DVLedgerTransactionConnection = {
  __typename: 'DVLedgerTransactionConnection';
  /** The edges of the connection, each containing a ledger transaction and its cursor */
  edges: Array<DVLedgerTransactionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DVLedgerTransactionEdge = {
  __typename: 'DVLedgerTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The ledger transaction at the end of the edge. */
  node: DVLedgerTransaction;
};

/** Filter for listing ledger_transactions. All fields are optional. */
export type DVLedgerTransactionFilter = {
  /** Filter by account ID */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  /** Filter to entries with at least one posting of exactly this amount (decimal string) */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** Filter by asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the bucket this entry debits (see DVLedgerTransaction.bucketFrom) */
  bucketFrom?: InputMaybe<DVLedgerBucket>;
  /** Filter by the bucket this entry credits (see DVLedgerTransaction.bucketTo) */
  bucketTo?: InputMaybe<DVLedgerBucket>;
  /** Filter to entries created at or after this time */
  createdAtFrom?: InputMaybe<Scalars['Time']['input']>;
  /** Filter to entries created before this time */
  createdAtTo?: InputMaybe<Scalars['Time']['input']>;
  /** Filter by creator (exact match) */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the custodian wallet this entry references */
  custodianWalletId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by description (case-insensitive substring; % and _ match literally) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter to entries effective at or after this time */
  effectiveAtFrom?: InputMaybe<Scalars['Time']['input']>;
  /** Filter to entries effective before this time */
  effectiveAtTo?: InputMaybe<Scalars['Time']['input']>;
  /** Filter by trading entity ID */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by entry type */
  entryType?: InputMaybe<DVLedgerEntryType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by ledger transaction ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Filter to entries whose metadata contains this JSON object */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Filter by external reference ID (exact, case-sensitive match) */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the ID of the entry this one reverses */
  reversalOfId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by the trade lifecycle event that posted this entry (a TradeEventType value such as ACTIVE) */
  sourceLifecycleEvent?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the trade this entry references */
  tradeId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by transfer group ID */
  transferGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter to entries last updated at or after this time; never-updated entries never match */
  updatedAtFrom?: InputMaybe<Scalars['Time']['input']>;
  /** Filter to entries last updated before this time; never-updated entries never match */
  updatedAtTo?: InputMaybe<Scalars['Time']['input']>;
  /** Filter by last updater (exact match) */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A deferred command awaiting quorum. The command lives in payload and touches no domain table
 * until the request is EXECUTED.
 */
export type DVMakerCheckerRequest = {
  __typename: 'DVMakerCheckerRequest';
  /** Selects the app-side handler that will execute this request */
  actionType: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  /** Staff identity of the maker */
  createdBy: Scalars['String']['output'];
  /** Whether the creator's own approval counts toward quorum */
  creatorCanApprove: Scalars['Boolean']['output'];
  /** Whether the flow stops at APPROVED, requiring an explicit execute step to run the action */
  deferExecution: Scalars['Boolean']['output'];
  executedAt: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  idempotencyKey: Maybe<Scalars['String']['output']>;
  /** The failure reason when status is FAILED */
  lastError: Maybe<Scalars['String']['output']>;
  /** The command to execute, as a JSON object string */
  payload: Scalars['String']['output'];
  /** The domain object this request targets, if any */
  referenceId: Maybe<Scalars['String']['output']>;
  /** Number of distinct approve votes required */
  requiredApprovals: Scalars['Int']['output'];
  /** Ids produced by the handler on execution, as a JSON string */
  resultRefs: Maybe<Scalars['String']['output']>;
  status: DVMakerCheckerStatus;
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** Staff identity of the last actor to transition the request (e.g. the canceller) */
  updatedBy: Maybe<Scalars['String']['output']>;
  votes: Array<DVMakerCheckerVote>;
};

export type DVMakerCheckerRequestConnection = {
  __typename: 'DVMakerCheckerRequestConnection';
  /** The edges of the connection */
  edges: Array<DVMakerCheckerRequestEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DVMakerCheckerRequestEdge = {
  __typename: 'DVMakerCheckerRequestEdge';
  /** The cursor of the edge */
  cursor: Scalars['String']['output'];
  /** The node of the edge */
  node: DVMakerCheckerRequest;
};

export type DVMakerCheckerRequestFilter = {
  /** Filter by action type (e.g. the pending queue for one feature) */
  actionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter by the request's referenceId — e.g. combined with actionTypes: ["LEDGER_TRANSACTION_REVERSE"]
   * and statuses: [PENDING], this answers "does this specific ledger transaction have a reversal
   * awaiting approval?" (a ledger transaction's own id is stamped as referenceId when its reversal
   * is proposed — at most one open request can exist per (actionType, referenceId) pair).
   */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by status (e.g. [PENDING] for the approvals queue, [APPROVED] for awaiting execution,
   * [REJECTED, CANCELED] for the audit history)
   */
  statuses?: InputMaybe<Array<DVMakerCheckerStatus>>;
};

/** The lifecycle state of a maker-checker request. */
export enum DVMakerCheckerStatus {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  EXECUTED = 'EXECUTED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

/** One immutable vote on a maker-checker request. */
export type DVMakerCheckerVote = {
  __typename: 'DVMakerCheckerVote';
  /** Staff identity of the voter */
  actor: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  decision: DVVoteDecision;
  id: Scalars['ID']['output'];
  /** Required when the decision is REJECT */
  reason: Maybe<Scalars['String']['output']>;
};

/**
 * The account the CSA rows belong to, carrying what is not CSA-grained. Reg IM sums across all of an
 * account's CSAs before its cap applies, so it has no per-CSA meaning and cannot sit on the CSA row.
 */
export type DVMarginAccount = {
  __typename: 'DVMarginAccount';
  accountId: Scalars['ID']['output'];
  accountName: Scalars['String']['output'];
  counterpartyName: Scalars['String']['output'];
  /** The Anchorage entity the account faces, off otc.accounts */
  entityId: Scalars['ID']['output'];
  /**
   * The reg IM group the account belongs to. Null on an account facing an Anchorage entity other than
   * the swap dealer, which carries no reg IM requirement, so a null here is not a half-written run. Two
   * accounts linked as affiliates read the same group row: keyed on groupId, it is one figure, not
   * one each
   */
  regIm: Maybe<DVRegInitialMargin>;
};

/**
 * The counterparty row on the Margin tab: one CSA's rollup and the terms it was gated on, with its
 * netting sets behind it. CSA-grained rather than account-grained — thresholds, MTA and rounding are
 * CSA terms, so an account holding two CSAs is two rows and they must not be summed.
 * vmMtm, vmRequired and vmTotal are rounded for display to the valuation currency's precision: two
 * places for USD, eight for any other currency.
 */
export type DVMarginCSASummary = {
  __typename: 'DVMarginCSASummary';
  /** A-1's threshold. Null is unlimited — a one-way CSA in that direction */
  a1Threshold: Maybe<Scalars['String']['output']>;
  accountId: Scalars['ID']['output'];
  accountName: Scalars['String']['output'];
  /** The counterparty's threshold. Null is unlimited */
  clientThreshold: Maybe<Scalars['String']['output']>;
  counterpartyName: Scalars['String']['output'];
  csaId: Scalars['ID']['output'];
  /** The Anchorage entity the account faces, off otc.accounts */
  entityId: Scalars['ID']['output'];
  /** Whether margin runs raise VM obligations for this CSA, as currently set on the CSA (not as it was when this run ran) */
  generateVmObligations: Scalars['Boolean']['output'];
  /**
   * Null for runs that write booked IM per account and asset. Earlier runs rolled booked IM up
   * here, valued into the valuation currency
   */
  imTotal: Maybe<Scalars['String']['output']>;
  /** Minimum transfer amount. A due below it suppresses the call rather than reducing it */
  mta: Maybe<Scalars['String']['output']>;
  /** The CSA's netting sets. Empty where the run wrote a summary but no per-set rows */
  nettingSets: Array<DVMarginRequirement>;
  /** Rounding increment applied to the transfer */
  rounding: Maybe<Scalars['Int']['output']>;
  runId: Scalars['ID']['output'];
  /** FULLY_COLLATERALIZED, CALL or RETURN */
  state: Maybe<Scalars['String']['output']>;
  /**
   * What the CSA owes. Variation margin only for runs that write booked IM per account and asset,
   * which shows on the ledger. Earlier runs added the booked IM due
   */
  totalDue: Maybe<Scalars['String']['output']>;
  valuationCcy: Scalars['String']['output'];
  /** Valued VM collateral across the sets, signed as A-1, triparty included */
  vmHeldValue: Maybe<Scalars['String']['output']>;
  /** The CSA's net exposure, its netting sets summed. Gross of the threshold */
  vmMtm: Maybe<Scalars['String']['output']>;
  /**
   * What the CSA calls for once its threshold is applied to that exposure. The threshold meets the
   * rollup once, so this is not the sum of the sets' vmRequired
   */
  vmRequired: Maybe<Scalars['String']['output']>;
  /**
   * vmRequired less vmHeldValue, i.e. the figure the MTA is tested against. Null until the run
   * computes VM
   */
  vmTotal: Maybe<Scalars['String']['output']>;
};

/**
 * One run's requirement for a single netting set, in the CSA's valuation currency. A field is null
 * where the run did not compute it — distinct from a computed zero.
 * vmMtm, vmRequired and vmDue are rounded for display to the valuation currency's precision: two
 * places for USD, eight for any other currency.
 */
export type DVMarginRequirement = {
  __typename: 'DVMarginRequirement';
  /** The account the requirement is against */
  accountId: Scalars['ID']['output'];
  /** The CSA whose terms the set is margined under */
  csaId: Scalars['ID']['output'];
  /** 17 CFR 23.154(c) grid IM after the net-down */
  gridIm: Maybe<Scalars['String']['output']>;
  /**
   * Grid IM measured on the side the firm collateralizes — a calculation operand, not an amount
   * posted. These sum across the account's sets to the reg IM group's gridImPost, which is where the
   * cap is applied and where an actual obligation first appears
   */
  gridImPost: Maybe<Scalars['String']['output']>;
  /** Standardized IM before the NGR net-down, kept alongside gridIm so the net-down stays auditable */
  grossIm: Maybe<Scalars['String']['output']>;
  /** Replacement cost summed per trade, the gross operand of the net-down */
  grossRc: Maybe<Scalars['String']['output']>;
  /** grossRc with the mark-to-market sign flipped — the same book seen from the other side */
  grossRcPost: Maybe<Scalars['String']['output']>;
  /** The IM term the set is margined on */
  imTerm: Maybe<Scalars['String']['output']>;
  /** Replacement cost of the set netted, the numerator of ngr */
  netRc: Maybe<Scalars['String']['output']>;
  /** netRc with the mark-to-market sign flipped */
  netRcPost: Maybe<Scalars['String']['output']>;
  nettingSetId: Scalars['ID']['output'];
  nettingSetName: Scalars['String']['output'];
  /** Net-to-gross ratio, netRc over grossRc. One where grossRc is zero, never zero */
  ngr: Maybe<Scalars['String']['output']>;
  /**
   * ngr measured with the mark-to-market sign flipped. The only term that flips with perspective: the
   * grid percentage times notional is unchanged, which is why both sides share one gross figure
   */
  ngrPost: Maybe<Scalars['String']['output']>;
  /** The run this line belongs to */
  runId: Scalars['ID']['output'];
  valuationCcy: Scalars['String']['output'];
  /** Which way the set's VM moves: CP_POSTS, FIRM_POSTS or NONE */
  vmDirection: Maybe<Scalars['String']['output']>;
  /** vmRequired less vmHeldValueTotal. VM due has no triparty split */
  vmDue: Maybe<Scalars['String']['output']>;
  /** Valued VARIATION_MARGIN_HELD after the VM collateral haircut. Base only and unsigned. Null on a run written before the column */
  vmHeldGrossValue: Maybe<Scalars['String']['output']>;
  /** Valued VM collateral, signed as A-1: positive held from the counterparty, negative posted out. Base only, without the triparty bucket. Equals vmHeldGrossValue less vmPostedValue */
  vmHeldValue: Maybe<Scalars['String']['output']>;
  /** vmHeldValue plus vmHeldValueTriparty. On a run written before the split it equals the unsuffixed figure */
  vmHeldValueTotal: Maybe<Scalars['String']['output']>;
  /** Valued VARIATION_MARGIN_HELD_TRIPARTY, gross because there is no VM posted triparty bucket. Null on a run written before the split, whose vmHeldValue holds the total */
  vmHeldValueTriparty: Maybe<Scalars['String']['output']>;
  /** The set's net mark-to-market, signed as A-1: positive means the counterparty owes us */
  vmMtm: Maybe<Scalars['String']['output']>;
  /** Valued VARIATION_MARGIN_POSTED after the VM collateral haircut. Base only and unsigned. Null on a run written before the column */
  vmPostedValue: Maybe<Scalars['String']['output']>;
  /**
   * Exposure the set calls for. The CSA threshold applies to the rollup, not here, so these do not
   * sum to the summary's vmTotal whenever a threshold bites
   */
  vmRequired: Maybe<Scalars['String']['output']>;
};

/** Filter for dvMarginRequirements. All fields are optional. */
export type DVMarginRequirementFilter = {
  /** Filter by account ID — every CSA the account holds */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Read the newest run not dated after this point in time. Defaults to the newest run of any date */
  asOf?: InputMaybe<Scalars['Time']['input']>;
  /** Filter by CSA ID, i.e. one counterparty row */
  csaId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by Anchorage entity — drops every account not facing it */
  entityId?: InputMaybe<Scalars['ID']['input']>;
};

/** Counterparty rows and the run they were read from. */
export type DVMarginRequirementResult = {
  __typename: 'DVMarginRequirementResult';
  /**
   * One row per account the csas belong to, in the same order, for the figures that are not CSA-
   * grained. Join it to a csa row on accountId
   */
  accounts: Array<DVMarginAccount>;
  /** One row per CSA matching the filter. Empty when run is null */
  csas: Array<DVMarginCSASummary>;
  /** The run the rows came from. Null when no run has succeeded yet */
  run: Maybe<DVMarginRun>;
};

/** One margin calculation run. */
export type DVMarginRun = {
  __typename: 'DVMarginRun';
  /** The date the run priced positions at */
  asOfDate: Scalars['Date']['output'];
  /** When the run started */
  createdAt: Scalars['Timestamp']['output'];
  /** The run's unique ID */
  id: Scalars['ID']['output'];
  /** Where the run's marks came from (haruko/internal) */
  markSource: Scalars['String']['output'];
  /** PENDING, SUCCEEDED or FAILED. Only a SUCCEEDED run is ever returned by a read */
  status: Scalars['String']['output'];
  /** Firm-wide Uncleared Swap Margin the run computed, for the capital feed. Null until VM lands */
  usmTotal: Maybe<Scalars['String']['output']>;
};

/** Filter for dvMarginRuns. All fields are optional. */
export type DVMarginRunFilter = {
  /** Runs priced on or after this date */
  asOfFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Runs priced on or before this date */
  asOfTo?: InputMaybe<Scalars['Date']['input']>;
  /** How many runs to return, newest first. Defaults to the newest 90 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Keep only these statuses — PENDING, SUCCEEDED or FAILED. Omit for every status */
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * One run in the run history. Unlike DVMarginRun this is not narrowed to succeeded runs — a run
 * still pending, or one that failed, is what this read exists to show.
 */
export type DVMarginRunStatus = {
  __typename: 'DVMarginRunStatus';
  /** The date the run priced positions at */
  asOfDate: Scalars['Date']['output'];
  /** When the run started */
  createdAt: Scalars['Timestamp']['output'];
  /**
   * Why the run failed. A scoped failure is prefixed with the csa or account it belongs to, a
   * run-level one is a bare message. Empty on a run that did not fail
   */
  errors: Array<Scalars['String']['output']>;
  /** The run's unique ID */
  id: Scalars['ID']['output'];
  /**
   * The run every other margin read resolves to when given no as-of — badge this row, not the first
   * one. True on at most one run firm-wide, and on none at all when the filter excludes it
   */
  latest: Scalars['Boolean']['output'];
  /** The timestamp the marks were snapshotted at */
  markSnapshotAt: Maybe<Scalars['Timestamp']['output']>;
  /** The marks table the run read. Null on a run that failed before reaching marks */
  markSnapshotTable: Maybe<Scalars['String']['output']>;
  /** Where the run's marks came from (haruko/internal) */
  markSource: Scalars['String']['output'];
  /** When the run finished, either way. Null while it is still pending */
  processedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The timestamp the spots were snapshotted at */
  spotSnapshotAt: Maybe<Scalars['Timestamp']['output']>;
  /**
   * The spot table the run read, for the native-units conversion. Null on a run that failed before
   * reaching marks
   */
  spotSnapshotTable: Maybe<Scalars['String']['output']>;
  /** PENDING, SUCCEEDED or FAILED */
  status: Scalars['String']['output'];
  /**
   * A newer succeeded run has taken over as this as-of date's reading. Superseded runs are kept for
   * audit, so a date can hold several runs and only one of them is current
   */
  superseded: Scalars['Boolean']['output'];
  /**
   * Firm-wide Uncleared Swap Margin the run computed — Σ standardized im_std, collect side only, cap
   * and MTA ignored, every counterparty in. Not the Requirement tab's reg IM. Null until VM lands
   */
  usmTotal: Maybe<Scalars['String']['output']>;
};

export type DVMatureTradeInput = {
  /** The fix price for non-deliverable trades (optional) */
  fixPrice?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Netting Set defines how trades are grouped for margin calculation
 * Used for both current records and history records
 */
export type DVNettingSet = {
  __typename: 'DVNettingSet';
  baseAssetId: Maybe<Scalars['ID']['output']>;
  collateralizationCategory: Maybe<DVCollateralizationCategory>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  csaId: Scalars['ID']['output'];
  endDate: Maybe<Scalars['Time']['output']>;
  historyId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  party: Maybe<Scalars['String']['output']>;
  restrictToAssetId: Maybe<Scalars['ID']['output']>;
  startDate: Scalars['Time']['output'];
  status: Maybe<Scalars['String']['output']>;
  terminationAssetId: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type DVNettingSetParams = {
  __typename: 'DVNettingSetParams';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  currency: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  mta: Scalars['String']['output'];
  nettingSetId: Scalars['ID']['output'];
  party: Scalars['String']['output'];
  rounding: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['Time']['output'];
  thresholdAmount: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/**
 * Consolidated netting set rule — combines the former NettingSetParams and CollateralRule
 * into a single entity backed by the otc.netting_set_rules table.
 */
export type DVNettingSetRule = {
  __typename: 'DVNettingSetRule';
  assetId: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  currency: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  mta: Scalars['String']['output'];
  nettingSetId: Scalars['ID']['output'];
  party: Scalars['String']['output'];
  rounding: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['Time']['output'];
  thresholdAmount: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  valuationPercentage: Maybe<Scalars['String']['output']>;
};

export type DVNovateTradeInput = {
  /** The price at which the existing trade's remaining exposure is closed out */
  closeoutPrice: Scalars['String']['input'];
  /** CurrencyType of the closeout price */
  currencyType: Scalars['String']['input'];
  /** Optional memo for the new trade */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** The account ID the new, novated trade will be booked on */
  newAccountId: Scalars['ID']['input'];
  /** The reference rate of the underlying SPOT instrument, applied to both legs */
  spotReferenceRate?: InputMaybe<Scalars['String']['input']>;
};

/**
 * What a client owes us or we owe them, arising from a trade event or entered by ops. Positive means the
 * counterparty owes us, negative means we owe them: direction is the sign, never a separate field.
 */
export type DVObligation = {
  __typename: 'DVObligation';
  /** The client account this is owed by or to */
  accountId: Scalars['ID']['output'];
  /** Signed. Positive means the counterparty owes us */
  amount: Scalars['String']['output'];
  /** The asset it is denominated in */
  assetId: Scalars['ID']['output'];
  /** The symbol of that asset, so a row can be read without resolving the id */
  assetSymbol: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  /**
   * Who the row is attributed to, which depends on its source. For one keyed in by ops this is the maker who
   * proposed it, even though a second person had to approve it before it was written. For a derived one it is
   * whatever raised it
   */
  createdBy: Scalars['String']['output'];
  dueDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /**
   * The per-netting-set breakdown behind the figure, empty for most obligations. Never checked against
   * the amount above, since the called figure is rounded per the agreement while these are the raw
   * per-set requirements
   */
  lines: Array<DVObligationLine>;
  /** What kind of call this is */
  obligationType: DVObligationType;
  /**
   * The obligation this one is a follow-up for: a correction against a settled predecessor, or a
   * reissue of one that was voided and cannot be un-voided in place. That original obligation is left
   * exactly as it was; only this row is new
   */
  originalObligationId: Maybe<Scalars['ID']['output']>;
  /**
   * The lifecycle event that raised this obligation. Absent only for one entered by hand, or a row
   * from before this was tracked
   */
  raisedByEventId: Maybe<Scalars['ID']['output']>;
  /**
   * Why this row exists: a fresh call, a reversal, a correction, or a margin release. A restore
   * normally keeps its prior value here and only becomes RESTORED to avoid claiming the same slot
   * (any status) as another row. Every write path sets it, hand entered included, and it is NOT NULL
   * at the DB level (migration 100, DERSWP-849), so it is never absent for any row created from here on
   */
  role: Maybe<DVObligationRole>;
  /** The settlement covering it, absent while it is still in the queue */
  settlementId: Maybe<Scalars['ID']['output']>;
  /** What produced it: a trade, a margin run, a vendor, or ops by hand */
  source: DVObligationSource;
  /** The event that produced it, absent only for one entered by hand */
  sourceRef: Maybe<Scalars['String']['output']>;
  status: DVObligationStatus;
  /** Why it left the queue, required when superseded or voided */
  statusReason: Maybe<Scalars['String']['output']>;
  /** The call that replaced this one, set when superseded */
  supersededById: Maybe<Scalars['ID']['output']>;
  tradeId: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  /**
   * The lifecycle event that voided this, present only when the void was recorded by code that stamps
   * it. A VOIDED obligation from before that code shipped, or from a replica still running the old code
   * during a rolling deploy, is absent here, so a null value is not proof that none exists. A
   * cancellation being invalidated reissues exactly what it voided by looking this up, since the trade
   * alone cannot tell one cancellation on it apart from another, earlier or later, one.
   */
  voidedByEventId: Maybe<Scalars['ID']['output']>;
};

export type DVObligationConnection = {
  __typename: 'DVObligationConnection';
  edges: Array<DVObligationEdge>;
  pageInfo: PageInfo;
};

export type DVObligationEdge = {
  __typename: 'DVObligationEdge';
  cursor: Scalars['String']['output'];
  node: DVObligation;
};

export type DVObligationFilter = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Either key identifies the asset. Given both, they have to agree */
  assetSymbol?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  /** Bounds due_date, inclusive. Either bound, or both, can be set independently. */
  dueOnOrAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Bounds due_date, inclusive. Either bound, or both, can be set independently. */
  dueOnOrBefore?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Exclude rows whose account name partially matches any of a comma-separated list of keywords, e.g.
   * to hide internal/hedge accounts from an ops-facing list
   */
  excludeAccountName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The obligations one settlement covers */
  settlementId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Column to sort by. Defaults to createdAt (newest first) when omitted, matching every other list
   * in this service.
   */
  sortBy?: InputMaybe<DVObligationSortField>;
  /** Defaults to DESC when omitted, matching createdAt's own default (newest first). */
  sortDirection?: InputMaybe<DVSortDirection>;
  sources?: InputMaybe<Array<DVObligationSource>>;
  /**
   * The blotter's queue is statuses [OPEN] together with ungrouped: true. Asking for ungrouped alone also
   * returns superseded rows, since undoing a grouping releases those too
   */
  statuses?: InputMaybe<Array<DVObligationStatus>>;
  tradeId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<DVObligationType>>;
  /** True for only those not yet on any settlement, false for only those already on one. Omit for both */
  ungrouped?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * One line of an obligation's per-netting-set breakdown, which is how a called figure is explained to the
 * client who received it.
 */
export type DVObligationLine = {
  __typename: 'DVObligationLine';
  /** Signed, in the obligation's asset */
  amount: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nettingSetId: Scalars['ID']['output'];
  obligationId: Scalars['ID']['output'];
};

export enum DVObligationRole {
  CORRECTION = 'CORRECTION',
  MARGIN_RELEASE = 'MARGIN_RELEASE',
  ORIGINAL = 'ORIGINAL',
  RESTORED = 'RESTORED',
  REVERSAL = 'REVERSAL'
}

/** Columns DVObligationFilter.sortBy can name. */
export enum DVObligationSortField {
  CREATED_AT = 'CREATED_AT',
  DUE_DATE = 'DUE_DATE'
}

export enum DVObligationSource {
  MANUAL = 'MANUAL',
  MARGIN_RUN = 'MARGIN_RUN',
  TRADE = 'TRADE',
  VENDOR = 'VENDOR'
}

/**
 * How an obligation left the queue, or that it has not. An unpaid one stays OPEN and ages; a variation
 * margin call that went unmet is SUPERSEDED by the next day's call rather than topped up.
 */
export enum DVObligationStatus {
  OPEN = 'OPEN',
  SETTLED = 'SETTLED',
  SUPERSEDED = 'SUPERSEDED',
  VOIDED = 'VOIDED'
}

export enum DVObligationType {
  ADDITIONAL_INITIAL_MARGIN = 'ADDITIONAL_INITIAL_MARGIN',
  CASH_SETTLEMENT = 'CASH_SETTLEMENT',
  CLOSEOUT = 'CLOSEOUT',
  INITIAL_MARGIN = 'INITIAL_MARGIN',
  INTEREST = 'INTEREST',
  PHYSICAL_DELIVERY = 'PHYSICAL_DELIVERY',
  PREMIUM = 'PREMIUM',
  VARIATION_MARGIN = 'VARIATION_MARGIN'
}

export type DVPackage = {
  __typename: 'DVPackage';
  /** Server-assigned identifier grouping the trades booked in this package. */
  packageIdentifier: Scalars['String']['output'];
  /** TRUE for every booked package; mirrors the flag stamped onto each leg. */
  packageIndicator: Scalars['Boolean']['output'];
  /** Caller-supplied per-package price, if provided. Signed, net of premium legs: may be negative. */
  packageTransactionPrice: Maybe<Scalars['String']['output']>;
  /** 3-char ISO currency for the package price. */
  packageTransactionPriceCurrency: Maybe<Scalars['String']['output']>;
  /** 1-char notation code for the package price. */
  packageTransactionPriceNotation: Maybe<Scalars['String']['output']>;
  /** Caller-supplied per-package spread, if provided. */
  packageTransactionSpread: Maybe<Scalars['String']['output']>;
  /** 3-char ISO currency for the package spread. */
  packageTransactionSpreadCurrency: Maybe<Scalars['String']['output']>;
  /** 1-char notation code for the package spread. */
  packageTransactionSpreadNotation: Maybe<Scalars['String']['output']>;
  /**
   * TRUE when the package was booked post-priced: every leg's price fields are estimates until
   * finalized.
   */
  postPriced: Scalars['Boolean']['output'];
  /** The trades booked under this package. Each carries the packageIdentifier above. */
  trades: Array<DVTrade>;
};

/** Party type for valuation agent */
export enum DVPartyType {
  COUNTERPARTY = 'COUNTERPARTY',
  HOUSE = 'HOUSE'
}

/**
 * One run's position line for a single trade within a netting set, in the CSA's valuation currency.
 * A SKIPPED position carries a reason rather than being left out — it contributed nothing to the
 * netting set's margin, and that absence is what this line exists to explain.
 */
export type DVPosition = {
  __typename: 'DVPosition';
  /** The account the position is booked against */
  accountId: Scalars['ID']['output'];
  /** The date that run priced */
  asOfDate: Scalars['Date']['output'];
  /** The CSA the position's netting set sits under */
  csaId: Scalars['ID']['output'];
  /** The trade's delta, where the run computed one */
  delta: Maybe<Scalars['String']['output']>;
  /** The mark the run priced this trade at */
  mark: Scalars['String']['output'];
  /** Mark-to-market in the valuation currency */
  mtm: Scalars['String']['output'];
  /** The netting set the position rolls into */
  nettingSetId: Scalars['ID']['output'];
  /** Notional in the valuation currency */
  notional: Scalars['String']['output'];
  /**
   * Notional in USD, before the valuation-currency restatement. The pre-restatement figure CEM's
   * add-on operand is computed from
   */
  notionalUsd: Scalars['String']['output'];
  /** Signed quantity from Anchorage's (A1's) view of the trade */
  qty: Scalars['String']['output'];
  /** Why the run skipped this position. Null on an OK line */
  reason: Maybe<Scalars['String']['output']>;
  /** The run this line belongs to */
  runId: Scalars['ID']['output'];
  /** OK or SKIPPED. A SKIPPED line still contributed a row — see reason for why it contributed no VM */
  status: Scalars['String']['output'];
  /** The trade this line prices */
  tradeId: Scalars['ID']['output'];
  /** The currency the figures below are denominated in — the CSA's valuation currency, not USD */
  valuationCcy: Scalars['String']['output'];
};

/** Filter for dvPositions. All fields are optional. */
export type DVPositionFilter = {
  /** Filter by account ID */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Read the newest run not dated after this point in time. Defaults to the newest run of any date */
  asOf?: InputMaybe<Scalars['Time']['input']>;
  /** Filter by CSA ID, i.e. one counterparty row */
  csaId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by netting set ID */
  nettingSetId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by trade ID */
  tradeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Position lines and the run they were read from. */
export type DVPositionResult = {
  __typename: 'DVPositionResult';
  /** The run's position lines matching the filter. Empty when run is null */
  positions: Array<DVPosition>;
  /** The run the lines came from. Null when no run has succeeded yet */
  run: Maybe<DVMarginRun>;
};

export type DVProduct = {
  __typename: 'DVProduct';
  /** Base represent the base asset details */
  base: DVAsset;
  /** The base asset ID */
  baseId: Scalars['ID']['output'];
  /** When the product was created */
  createdAt: Scalars['Time']['output'];
  /** Who created the product */
  createdBy: Scalars['String']['output'];
  /** The ID of the product */
  id: Scalars['ID']['output'];
  /** Optional metadata for the product */
  metadata: Maybe<Scalars['String']['output']>;
  /** The exercise style of the option - only for option products */
  optionExerciseStyle: Maybe<OptionExerciseStyle>;
  /** The type of option (call/put) - only for option products */
  optionType: Maybe<OptionType>;
  /** The type of financial product */
  productType: ProductType;
  /** Quote represent the quote asset details */
  quote: DVAsset;
  /** The quote asset ID */
  quoteId: Scalars['ID']['output'];
  /** The symbol of the product, derived from base, quote, and product type */
  symbol: Scalars['String']['output'];
  /** When the product was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** Who last updated the product */
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type DVProvisionHarukoVenueInput = {
  accountId: Scalars['ID']['input'];
  /** Must be an enabled DVHarukoGroup that Haruko still returns. */
  groupId: Scalars['Int']['input'];
  purpose: DVHarukoVenuePurpose;
};

/**
 * One run's regulatory grid IM for a margin-affiliate group, in the valuation currency. The Post
 * suffix names a DIRECTION, not an amount posted: the bare fields are the side the counterparty
 * collateralizes and the Post fields are the same figures on the side the firm does. Unlike VM these
 * are not two ends of one direction, so both can be live on the same date. Only required and
 * requiredPost are obligations — grid IM is the pre-cap operand they are derived from, and nobody
 * ever posts it. Grid IM sums across the group's netting sets and one cap comes off each direction at
 * the group, so the figures repeat on every CSA the group's accounts hold — read the group once,
 * never sum the rows.
 */
export type DVRegInitialMargin = {
  __typename: 'DVRegInitialMargin';
  /** Group membership as the run saw it */
  accountIds: Array<Scalars['ID']['output']>;
  /**
   * The threshold taken off each direction, usually 50m. Stored rather than derived because
   * required cannot recover it wherever gridIm came in under it
   */
  capApplied: Scalars['String']['output'];
  /**
   * required less held, signed: negative is excess to return. Pinned to what the run saw, so it can
   * lag the live bucket
   */
  due: Maybe<Scalars['String']['output']>;
  /** requiredPost less heldPost, signed as due is */
  duePost: Maybe<Scalars['String']['output']>;
  /** The group's grid IM, raw and pre-cap */
  gridIm: Scalars['String']['output'];
  /**
   * Grid IM measured on the side the firm collateralizes: the same gross notional figure, net down by
   * the NGR with the mark-to-market sign flipped. Raw and pre-cap, so it is an input to requiredPost
   * rather than anything posted. The firm side binds only a financial end user with material swaps
   * exposure
   */
  gridImPost: Scalars['String']['output'];
  /** The group the cap was taken at. The account's own id until affiliate linkage lands */
  groupId: Scalars['ID']['output'];
  /**
   * Collateral in the REG_INITIAL_MARGIN_HELD bucket, segregated at a third-party custodian
   * and never netted against the booked INITIAL_MARGIN_* buckets. Null where the run could
   * not value the group's collateral, which is not the same as nothing held
   */
  held: Maybe<Scalars['String']['output']>;
  /** Collateral in the REG_INITIAL_MARGIN_POSTED bucket */
  heldPost: Maybe<Scalars['String']['output']>;
  /**
   * The group's resolved material swaps exposure. False zeroes required and requiredPost outright,
   * whatever gridIm or gridImPost show. Null means the group reached no definitive determination
   */
  materialSwapsExposure: Maybe<Scalars['Boolean']['output']>;
  /**
   * gridIm less capApplied, floored at zero. A group under the cap carries a requirement of zero
   * against a non-zero gridIm, and so does a group whose materialSwapsExposure reads false,
   * whatever gridIm shows
   */
  required: Scalars['String']['output'];
  /**
   * gridImPost less capApplied, floored at zero — the amount the firm must actually post, and the
   * only figure on this side that is an obligation. Zero when materialSwapsExposure reads false,
   * whatever gridImPost shows
   */
  requiredPost: Scalars['String']['output'];
  /** The run this group's reg IM was computed by */
  runId: Scalars['ID']['output'];
  valuationCcy: Scalars['String']['output'];
};

/** Names the ICE/SDR report to regenerate: reportId, or tradeId with version */
export type DVRegenerateIceReportInput = {
  /** Correction indicator of a new AMENDMENT report; refused for any other report. */
  correction?: InputMaybe<Scalars['Boolean']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  tradeId?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Output format for client-facing report CSVs (trade recap, position statement).
 * BITWISE is the original Bitwise-specific format; GENERIC is the format used for all
 * other clients.
 */
export enum DVReportFormat {
  BITWISE = 'BITWISE',
  GENERIC = 'GENERIC'
}

/** One or more obligations for the same client and asset, netted into a single payment. */
export type DVSettlement = {
  __typename: 'DVSettlement';
  accountId: Scalars['ID']['output'];
  assetId: Scalars['ID']['output'];
  /** The symbol of that asset, so a row can be read without resolving the id */
  assetSymbol: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  /** Signed like netAmount: what is still uncovered. Null for a cross-asset set, which has no defensible figure */
  differenceAmount: Maybe<Scalars['String']['output']>;
  /**
   * The custody or venue reference, and the hash for an on-chain movement. Both recorded when it is
   * marked settled
   */
  externalRef: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The ledger rows that paid it, attached with dvSaveSettlementMovements before it is confirmed.
   * Revised-away rows are not listed
   */
  movements: Array<DVSettlementMovement>;
  /** Signed, the sum of what it covers at the moment it was created. Positive means we receive */
  netAmount: Scalars['String']['output'];
  /** The obligations this settlement covers, each with its own per-netting-set breakdown */
  obligations: Array<DVObligation>;
  settledAt: Maybe<Scalars['Time']['output']>;
  /** The reference ops quote to the counterparty and to the margin vendor */
  settlementRef: Scalars['String']['output'];
  status: DVSettlementStatus;
  /** Why it was cancelled, or why it was closed for more than the money attached to it */
  statusReason: Maybe<Scalars['String']['output']>;
  txHash: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type DVSettlementConnection = {
  __typename: 'DVSettlementConnection';
  edges: Array<DVSettlementEdge>;
  pageInfo: PageInfo;
};

export type DVSettlementEdge = {
  __typename: 'DVSettlementEdge';
  cursor: Scalars['String']['output'];
  node: DVSettlement;
};

export type DVSettlementFilter = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Either key identifies the asset. Given both, they have to agree */
  assetSymbol?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  /**
   * Exclude rows whose account name partially matches any of a comma-separated list of keywords, e.g.
   * to hide internal/hedge accounts from an ops-facing list
   */
  excludeAccountName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<DVSettlementStatus>>;
};

export type DVSettlementLedgerMove = {
  __typename: 'DVSettlementLedgerMove';
  /** Positive: the amount moved from bucketFrom to bucketTo */
  amount: Scalars['String']['output'];
  assetId: Scalars['ID']['output'];
  bucketFrom: DVLedgerBucket;
  bucketTo: DVLedgerBucket;
  description: Scalars['String']['output'];
  obligationId: Scalars['ID']['output'];
};

/**
 * What confirming a settlement would put on the ledger. Everything is empty and enabled is false where
 * confirm records nothing: the release flag or the account's automation is off, or the settlement is only
 * hand-entered obligations other than VM, which settles the old way.
 */
export type DVSettlementLedgerPreview = {
  __typename: 'DVSettlementLedgerPreview';
  enabled: Scalars['Boolean']['output'];
  /** Obligations confirm has no rule for, which Ops record by hand */
  manualObligations: Array<DVSettlementManualObligation>;
  /** The bucket moves confirm records, each a transfer through free balance */
  moves: Array<DVSettlementLedgerMove>;
  /**
   * The payment to prefill on free balance, a fiat wire or a crypto transfer: what the settlement still
   * owes after the money already attached. Null when nothing is left to pay: it nets to zero, it is
   * covered, or a movement in another asset is attached
   */
  payment: Maybe<DVSettlementSuggestedPayment>;
};

export type DVSettlementManualObligation = {
  __typename: 'DVSettlementManualObligation';
  /** Signed: positive means the client pays us */
  amount: Scalars['String']['output'];
  obligationId: Scalars['ID']['output'];
  obligationType: DVObligationType;
  reason: Scalars['String']['output'];
};

/**
 * A ledger row paying a settlement, and how much of that row went to it. One settlement can take several,
 * and one ledger row can be split across several settlements, which is why the amount lives here.
 */
export type DVSettlementMovement = {
  __typename: 'DVSettlementMovement';
  accountId: Scalars['ID']['output'];
  /**
   * Signed, in the LEDGER ROW's asset, which is not always the settlement's. Always 0 for a bucket move,
   * which is shown on the settlement but pays none of its net
   */
  allocatedAmount: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * The ledger entry this draws on, recorded on the ledger screen and only referenced here -- this type
   * never carries the ledger transaction itself. For that, see dvSettlementMovements(settlementId), which
   * pairs each movement with it: unlike a field here, that query is scoped to one settlement's own
   * movements by construction, so it can never be reached from a settlements page and cost one DB round
   * trip per movement across up to 300 rows.
   */
  ledgerTransactionId: Scalars['ID']['output'];
  /** The rate used and where it came from, present only where the two assets differ */
  rate: Maybe<Scalars['String']['output']>;
  rateSource: Maybe<Scalars['String']['output']>;
  settlementId: Scalars['ID']['output'];
};

/**
 * One of a settlement's ledger rows, paired with the ledger transaction it references -- what
 * dvSettlementMovements(settlementId) returns. Kept as its own type, and behind its own settlement-scoped
 * query, rather than a field on DVSettlementMovement: that field would be reachable from a dvSettlements
 * page (up to 300 settlements, each with its own movements) and cost one DB round trip per movement there,
 * so the join is only ever offered where it is naturally cheap -- one settlement's own movements.
 */
export type DVSettlementMovementWithLedgerTransaction = {
  __typename: 'DVSettlementMovementWithLedgerTransaction';
  ledgerTransaction: DVLedgerTransaction;
  movement: DVSettlementMovement;
};

/**
 * UNSETTLED is awaiting payment. CANCELLED is a grouping undone, which returns its obligations to the
 * queue and is only possible before money is attached.
 */
export enum DVSettlementStatus {
  CANCELLED = 'CANCELLED',
  SETTLED = 'SETTLED',
  UNSETTLED = 'UNSETTLED'
}

export type DVSettlementSuggestedPayment = {
  __typename: 'DVSettlementSuggestedPayment';
  /** Positive: the settlement's net, which Ops may change or drop */
  amount: Scalars['String']['output'];
  bucket: DVLedgerBucket;
  /** DEPOSIT when the client pays us, WITHDRAWAL when we pay */
  entryType: DVLedgerEntryType;
};

/** Ascending or descending, for sortBy below. */
export enum DVSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** The closing leg of an ingested chat message, held for a trader to book or dismiss */
export type DVStagedCloseout = {
  __typename: 'DVStagedCloseout';
  accountId: Scalars['ID']['output'];
  /** The account's ACTIVE trades on the same option held on the other side, each with its open quantity */
  candidates: Array<DVStagedCloseoutCandidate>;
  createdAt: Scalars['Time']['output'];
  decidedAt: Maybe<Scalars['Time']['output']>;
  /** Who dismissed or booked it */
  decidedBy: Maybe<Scalars['String']['output']>;
  /** The closing leg's own side, opposite to the open trades it closes */
  direction: TradeSideEnum;
  expiration: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** The Pub/Sub message ID the closeout was ingested from */
  ingestionMessageId: Scalars['String']['output'];
  /** The leg's position in the ingested message, from 0 */
  legIndex: Scalars['Int']['output'];
  /** Premium per base unit, when the chat stated one */
  price: Maybe<Scalars['String']['output']>;
  /** Symbol of the premium currency, when the chat stated a price */
  priceCurrency: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  /** The closing part of the leg, in base units, never more than was open at ingestion */
  quantity: Scalars['String']['output'];
  /** Quantity already booked as closeouts, in base units */
  quantityBooked: Scalars['String']['output'];
  reason: Maybe<Scalars['String']['output']>;
  status: DVStagedCloseoutStatus;
  strike: Scalars['String']['output'];
  /** When the chat says the trade was done */
  tradeTime: Scalars['Time']['output'];
};

/** Part of a staged closeout to book against one open trade */
export type DVStagedCloseoutAllocationInput = {
  /** Quantity to close on the trade, in base units */
  quantity: Scalars['String']['input'];
  /** An open trade from the staged closeout's candidates */
  tradeId: Scalars['ID']['input'];
};

/** An open trade a staged closeout can close */
export type DVStagedCloseoutCandidate = {
  __typename: 'DVStagedCloseoutCandidate';
  /** Quantity still open on the trade, in base units */
  openQuantity: Scalars['String']['output'];
  trade: DVTrade;
};

export enum DVStagedCloseoutStatus {
  /** Booked as closeouts of open trades */
  BOOKED = 'BOOKED',
  /** Being booked as closeouts of open trades */
  BOOKING = 'BOOKING',
  /** Dismissed by a trader without booking */
  DISMISSED = 'DISMISSED',
  /** Waiting for a trader to book or dismiss it */
  STAGED = 'STAGED'
}

/**
 * A margin run that has been queued. It holds no numbers - the run row opens when the run starts,
 * and dvMarginRuns on asOfDate is where it then appears.
 */
export type DVStartedMarginRun = {
  __typename: 'DVStartedMarginRun';
  /** The date the run will price, resolved in New York */
  asOfDate: Scalars['Date']['output'];
  /** The workflow running it, for tracing a run that never appears */
  workflowId: Scalars['ID']['output'];
};

/** Timing event types for CSA operations */
export enum DVTimingEvent {
  /** Call event timing */
  Call = 'Call',
  /** Delivery event timing */
  Delivery = 'Delivery',
  /** Notification event timing */
  Notification = 'Notification',
  /** Valuation event timing */
  Valuation = 'Valuation'
}

/** Timing rule configuration for CSA events */
export type DVTimingRule = {
  __typename: 'DVTimingRule';
  /** Reference point for timing calculation */
  anchor: Maybe<Scalars['String']['output']>;
  /** Created timestamp */
  createdAt: Scalars['Time']['output'];
  /** Created by user */
  createdBy: Scalars['String']['output'];
  /** CSA this timing rule belongs to */
  csaId: Scalars['ID']['output'];
  /** Day convention for calculations */
  dayConvention: Maybe<DVDayConvention>;
  /** Number of days offset from anchor */
  dayOffset: Scalars['Int']['output'];
  endDate: Maybe<Scalars['Time']['output']>;
  /** Event type this rule applies to */
  event: DVTimingEvent;
  historyId: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for the timing rule */
  id: Scalars['ID']['output'];
  startDate: Scalars['Time']['output'];
  status: Maybe<Scalars['String']['output']>;
  /** Timing tier classification */
  tier: Maybe<DVTimingTier>;
  /** Specific time of day (NULL can represent EOD) */
  timeOfDay: Maybe<Scalars['String']['output']>;
  /** Timezone for time calculations */
  timezone: Scalars['String']['output'];
  /** Updated timestamp */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** Updated by user */
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** Filter for timing rules queries */
export type DVTimingRuleFilter = {
  /** Filter by CSA IDs */
  csaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by event types */
  events?: InputMaybe<Array<DVTimingEvent>>;
  /** Filter by timing rule IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by timing tiers */
  tiers?: InputMaybe<Array<DVTimingTier>>;
};

/** Timing tier classifications */
export enum DVTimingTier {
  /** End of day timing tier */
  EndOfDay = 'EndOfDay',
  /** Intraday timing tier */
  Intraday = 'Intraday'
}

export type DVTrade = {
  __typename: 'DVTrade';
  /** account represent the derivative account details */
  account: DVAccount;
  /** The account ID that owns this trade */
  accountId: Scalars['ID']['output'];
  /** Additional IM amount */
  additionalImAmount: Maybe<Scalars['String']['output']>;
  /** Additional IM asset ID */
  additionalImAssetId: Maybe<Scalars['ID']['output']>;
  /** Telegram @username of the Affiliated Person who agreed the swap with the client. Null when unknown. */
  affiliatedPerson: Maybe<Scalars['String']['output']>;
  /** CFTC reporting: allocation indicator (4-char code) */
  allocationIndicator: Maybe<Scalars['String']['output']>;
  /** Barrier level -- required for EKO/EKI options, must be absent otherwise */
  barrier: Maybe<Scalars['String']['output']>;
  /** CFTC reporting: cleared flag (e.g. "N" for uncleared swaps) */
  cleared: Maybe<Scalars['String']['output']>;
  /** When the trade was created */
  createdAt: Scalars['Time']['output'];
  /** Who created the trade */
  createdBy: Scalars['String']['output'];
  /** Trading direction (BUY/SELL) */
  direction: TradeSideEnum;
  /** Effective as at time */
  effectiveAsAt: Scalars['Time']['output'];
  /**
   * Derivatives trading entity (A1, Swap Dealer, HedgeCo) faced by this trade.
   * Nullable until DERSWP-50 wires the write path.
   */
  entityId: Maybe<Scalars['ID']['output']>;
  /** Execution time */
  execTime: Scalars['Time']['output'];
  /** Expiration time if applicable */
  expiration: Scalars['Time']['output'];
  /**
   * Fee amount is the amount to be
   * paid in fees for the trade
   */
  feeAmount: Maybe<Scalars['String']['output']>;
  /** Fee asset ID */
  feeAssetId: Maybe<Scalars['ID']['output']>;
  /** Fee direction */
  feeDirection: Maybe<DVFeeDirection>;
  /** Fixed quanto rate if applicable */
  fixedQuantoRate: Maybe<Scalars['String']['output']>;
  /** Fixing source for settlement */
  fixingSource: Scalars['String']['output'];
  /** Optional group ID for trade grouping */
  groupId: Maybe<Scalars['ID']['output']>;
  /** Haruko trade ID for external system integration */
  harukoId: Maybe<Scalars['ID']['output']>;
  /**
   * For a Client<>SwapDealer trade, the trade ID of the auto-generated SD<>HedgeCo mirror leg
   * that hedges it. NULL on non-SwapDealer trades and on the HedgeCo mirror side. Populated
   * asynchronously by the back-to-back booking workflow after the source trade commits.
   */
  hedgeTradeId: Maybe<Scalars['ID']['output']>;
  /** The unique trade ID */
  id: Scalars['ID']['output'];
  /** The source system the trade was ingested from (e.g. "elwood") */
  ingestSource: Maybe<Scalars['String']['output']>;
  /** Initial margin amount */
  initialMarginAmount: Maybe<Scalars['String']['output']>;
  /** Initial margin asset ID */
  initialMarginAssetId: Maybe<Scalars['ID']['output']>;
  /** Initial margin direction */
  initialMarginDirection: Maybe<Scalars['String']['output']>;
  /** Initial margin method */
  initialMarginMethod: DVInitialMarginMethod;
  /** Initial margin override flag */
  initialMarginOverride: Scalars['Boolean']['output'];
  /** CFTC reporting: jurisdiction tag (e.g. "CFTC") */
  jurisdiction: Maybe<Scalars['String']['output']>;
  /** memo contains arbitrary data (TODO: For now it contains the confirmation report) */
  memo: Maybe<Scalars['String']['output']>;
  /** Netting set ID for margin netting */
  nettingSetId: Maybe<Scalars['ID']['output']>;
  /**
   * CFTC package-transaction reporting: server-assigned identifier grouping trades booked via
   * dvCreatePackage. NULL on single-trade bookings.
   */
  packageIdentifier: Maybe<Scalars['String']['output']>;
  /**
   * CFTC package-transaction reporting: TRUE when this trade was booked as part of a package,
   * FALSE for a Swap Dealer trade booked singly via dvCreateTrade. NULL for other entities.
   */
  packageIndicator: Maybe<Scalars['Boolean']['output']>;
  /**
   * CFTC package-transaction reporting: caller-supplied per-package price. Stored signed, net of
   * premium legs, so it may be negative; reporting emits the absolute value.
   */
  packageTransactionPrice: Maybe<Scalars['String']['output']>;
  /** CFTC package-transaction reporting: 3-char ISO currency for the package price. */
  packageTransactionPriceCurrency: Maybe<Scalars['String']['output']>;
  /** CFTC package-transaction reporting: 1-char price-notation code for the package price. */
  packageTransactionPriceNotation: Maybe<Scalars['String']['output']>;
  /** CFTC package-transaction reporting: caller-supplied per-package spread (alternative to price). */
  packageTransactionSpread: Maybe<Scalars['String']['output']>;
  /** CFTC package-transaction reporting: 3-char ISO currency for the package spread. */
  packageTransactionSpreadCurrency: Maybe<Scalars['String']['output']>;
  /** CFTC package-transaction reporting: 1-char notation code for the package spread. */
  packageTransactionSpreadNotation: Maybe<Scalars['String']['output']>;
  /** CFTC reporting: platform/execution facility identifier (4-char code) */
  platformIdentifier: Maybe<Scalars['String']['output']>;
  /**
   * TRUE for a post-priced swap (CFTC §43.3(a)(4)): booked while its transaction price was still
   * undetermined, with an estimate in the price field. Survives finalization; cleared only by a
   * revertsPostPriced amendment correcting a flag set by mistake.
   */
  postPriced: Scalars['Boolean']['output'];
  /** The mid market mark price of at the time of the trade */
  preTradeMidMarketMark: Maybe<Scalars['String']['output']>;
  /**
   * The price of the underlying spot market product
   * at the time of the trade
   */
  preTradeSpotReference: Maybe<Scalars['String']['output']>;
  /** Premium currency timing type */
  premiumCurrencyTimingType: Maybe<Scalars['String']['output']>;
  /** Premium currency type */
  premiumCurrencyType: Maybe<Scalars['String']['output']>;
  /** Premium delivery time */
  premiumDeliveryTime: Maybe<Scalars['Time']['output']>;
  /** Premium per base unit */
  premiumPerBaseUnit: Maybe<Scalars['String']['output']>;
  /**
   * When the determined price replaced the estimate via the finalizing amendment. Null while the
   * price is still an estimate; only ever set on post-priced trades.
   */
  priceFinalizedAt: Maybe<Scalars['Time']['output']>;
  /** CFTC reporting: prime brokerage transaction indicator */
  primeBrokerageTransactionIndicator: Maybe<Scalars['Boolean']['output']>;
  /** product represent the product details this trade is for */
  product: DVProduct;
  /** The product ID this trade is for */
  productId: Scalars['ID']['output'];
  /** Quantity closed out in base asset */
  quantityClosedOutBase: Maybe<Scalars['String']['output']>;
  /** Total quantity in base asset */
  quantityTotalBase: Scalars['String']['output'];
  /** Total quantity in quote asset */
  quantityTotalQuote: Scalars['String']['output'];
  /** Quanto asset ID */
  quantoAssetId: Maybe<Scalars['ID']['output']>;
  /** Reduced additional initial margin amount due to close out */
  reducedAdditionalImAmount: Maybe<Scalars['String']['output']>;
  /** Reduced initial margin amount due to close out */
  reducedImAmount: Maybe<Scalars['String']['output']>;
  /** Settlement time */
  settlementTime: Scalars['Time']['output'];
  /** Settlement type */
  settlementType: Scalars['String']['output'];
  /** Current processing status of the trade */
  status: DVTradeStatus;
  /** Strike price for the trade */
  strike: Scalars['String']['output'];
  /** CFTC reporting: strike-price currency (3-char ISO code) */
  strikePriceCurrency: Maybe<Scalars['String']['output']>;
  /** CFTC reporting: strike-price notation (1-char code) */
  strikePriceNotation: Maybe<Scalars['String']['output']>;
  /** When the trade was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** Who last updated the trade */
  updatedBy: Maybe<Scalars['String']['output']>;
  /** Universal Trade Identifier */
  uti: Maybe<Scalars['String']['output']>;
  /** Variation margin asset ID */
  variationMarginAssetId: Maybe<Scalars['ID']['output']>;
  /** Trading venue identifier */
  venue: Scalars['String']['output'];
  /** The version number of this trade */
  version: Scalars['Int']['output'];
};

export type DVTradeConnection = {
  __typename: 'DVTradeConnection';
  /** The edges of the connection, each containing a trade and its cursor */
  edges: Array<DVTradeEdge>;
  /** Information to aid in pagination. totalResults counts every trade matching the filter, across all pages. */
  pageInfo: PageInfo;
};

export type DVTradeEdge = {
  __typename: 'DVTradeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The trade at the end of the edge. */
  node: DVTrade;
};

/**
 * Filters for dvTradesConnection. Every field is optional and they combine with AND.
 * createdAfter is inclusive and createdBefore is exclusive; either may be omitted.
 * A createdAfter that is not earlier than createdBefore returns no trades.
 */
export type DVTradeFilter = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['Time']['input']>;
  createdBefore?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  ingestSources?: InputMaybe<Array<DVTradeIngestSource>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<DVTradeStatus>>;
};

/** How a trade booking entered the system. */
export enum DVTradeIngestSource {
  HEDGE = 'HEDGE',
  MANUAL = 'MANUAL',
  SLACK = 'SLACK',
  TELEGRAM = 'TELEGRAM'
}

export type DVTradeLifecycleEvent = {
  __typename: 'DVTradeLifecycleEvent';
  /** time the event was created */
  createdAt: Scalars['Time']['output'];
  /** The details of the event */
  details: Maybe<Scalars['String']['output']>;
  /** The type of lifecycle event */
  eventType: LifecycleEventType;
  /** The unique ID of the lifecycle event */
  id: Scalars['ID']['output'];
  /** time the event was invalidated (null if not invalidated) */
  invalidatedAt: Maybe<Scalars['Time']['output']>;
  /** The trade ID this event belongs to */
  trade: DVTrade;
};

export type DVTradeLifecycleEventConnection = {
  __typename: 'DVTradeLifecycleEventConnection';
  /** The edges of the connection, each containing a lifecycle event and its cursor */
  edges: Array<DVTradeLifecycleEventEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DVTradeLifecycleEventEdge = {
  __typename: 'DVTradeLifecycleEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The lifecycle event at the end of the edge. */
  node: DVTradeLifecycleEvent;
};

export type DVTradeLifecycleEventFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterEventTypes?: InputMaybe<Array<LifecycleEventType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tradeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** One novation: the trade that was closed out and the trade booked to replace it. */
export type DVTradeNovation = {
  __typename: 'DVTradeNovation';
  /** When the new trade was staged */
  novatedAt: Scalars['Time']['output'];
  /** The trade that was novated (closed out) */
  novatedFromTradeId: Scalars['ID']['output'];
  /** The trade booked by the novation */
  tradeId: Scalars['ID']['output'];
};

export type DVTradeNovationConnection = {
  __typename: 'DVTradeNovationConnection';
  /** The edges of the connection, each containing a novation and its cursor */
  edges: Array<DVTradeNovationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DVTradeNovationEdge = {
  __typename: 'DVTradeNovationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The novation at the end of the edge. */
  node: DVTradeNovation;
};

/**
 * A page holds 10000 novations unless first or last sets its size.
 * novatedAfter is inclusive and novatedBefore is exclusive on novatedAt; either may be omitted.
 * A novatedAfter that is not earlier than novatedBefore returns no novations.
 */
export type DVTradeNovationFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  novatedAfter?: InputMaybe<Scalars['Time']['input']>;
  novatedBefore?: InputMaybe<Scalars['Time']['input']>;
};

/** Input for generating trade recap CSV report with datetime range */
export type DVTradeRecapCSVInput = {
  /** Account IDs to include in the report */
  accountIds: Array<Scalars['ID']['input']>;
  /** End datetime for the report period (UTC). If omitted, defaults to server now(). */
  endTime?: InputMaybe<Scalars['Time']['input']>;
  /** Output format for the report. Optional; defaults to BITWISE when omitted. */
  format?: InputMaybe<DVReportFormat>;
  /** Start datetime for the report period (UTC) */
  startTime: Scalars['Time']['input'];
};

export enum DVTradeStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  CLOSED_OUT = 'CLOSED_OUT',
  FORCEFULLY_TERMINATED = 'FORCEFULLY_TERMINATED',
  MATURED = 'MATURED',
  STAGED = 'STAGED',
  VOIDED = 'VOIDED'
}

export type DVTradesRecapReportInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

/** Input for updating a timing rule */
export type DVUpdateTimingRuleInput = {
  /** Reference point for timing calculation */
  anchor?: InputMaybe<Scalars['String']['input']>;
  /** Set anchor to null */
  clearAnchor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set day convention to null */
  clearDayConvention?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set tier to null */
  clearTier?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set time of day to null */
  clearTimeOfDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Day convention for calculations */
  dayConvention?: InputMaybe<DVDayConvention>;
  /** Number of days offset from anchor */
  dayOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Event type this rule applies to */
  event?: InputMaybe<DVTimingEvent>;
  /** Timing tier classification */
  tier?: InputMaybe<DVTimingTier>;
  /** Specific time of day (format: HH:MM:SS) */
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  /** Timezone for time calculations (e.g., "America/New_York") */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** A single approver's decision on a maker-checker request. */
export enum DVVoteDecision {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT'
}

export type DailyTimeWindow = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

/** DataProvider specifies the data source used for a query */
export enum DataProvider {
  /** BigQuery was used for the query */
  BIGQUERY = 'BIGQUERY',
  /** Node/RPC was used for the query */
  NODE = 'NODE'
}

export type DateRange = {
  __typename: 'DateRange';
  endDate: Maybe<Scalars['Date']['output']>;
  startDate: Maybe<Scalars['Date']['output']>;
};

export type DateRangeInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** DealerSettlement is a settlement */
export type DealerSettlement = {
  __typename: 'DealerSettlement';
  /**
   * Signed amount of the settlement
   * @deprecated Use tradingAmount instead
   */
  amount: Maybe<Amount>;
  /**
   * To whom is this dealer settlement assigned to
   * (ie. the user who initiated the transaction)
   */
  assignee: Maybe<Scalars['String']['output']>;
  /** Timestamp of creation of the Dealer settlement */
  createdAt: Scalars['Timestamp']['output'];
  /** The creator of the Dealer settlement */
  createdBy: Scalars['String']['output'];
  /** Dealer settlement details */
  details: Scalars['String']['output'];
  /** Entity of the dealer settlement */
  entity: Scalars['String']['output'];
  /** Id of the dealer settlement */
  id: Scalars['ID']['output'];
  /** Notes justifying the creation of the dealer settlement */
  notes: Maybe<Scalars['String']['output']>;
  /** Number of payments in this settlement */
  numberPayments: Maybe<Scalars['Int']['output']>;
  /** Dealer settlement status */
  status: DealerSettlementStatus;
  /**
   * Trading amount of the settlement
   * Should be used instead of `amount`
   */
  tradingAmount: Maybe<TradingAmount>;
  /** Timestamp of the last update of the Dealer settlement */
  updatedAt: Scalars['Timestamp']['output'];
  /** The updater of the Dealer settlement */
  updatedBy: Scalars['String']['output'];
};

/** Dealer Settlement connection for pagination */
export type DealerSettlementConnection = {
  __typename: 'DealerSettlementConnection';
  /** List of edges containing settlement and cursor information */
  edges: Array<DealerSettlementEdge>;
  /** Page details for the associated list of payment flow edges */
  pageInfo: PageInfo;
};

/** Filters to be applied to the payment flows to generate the settlement */
export type DealerSettlementCreateInput = {
  /** Asset of the settlement */
  filterAssetTypeID: Scalars['AssetTypeID']['input'];
  /** Counterparty of the settlement */
  filterCounterparty: Scalars['String']['input'];
  /** Optional start time of the settlement */
  filterCreatedAtAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Optional end time of the settlement */
  filterCreatedAtBefore?: InputMaybe<Scalars['Timestamp']['input']>;
};

/** Dealer Settlement edge for pagination */
export type DealerSettlementEdge = {
  __typename: 'DealerSettlementEdge';
  /** Cursor for the associated settlements */
  cursor: Scalars['String']['output'];
  /** Settlements */
  node: DealerSettlement;
};

/** SettlementStatus is the different statuses that a settlement can go through */
export enum DealerSettlementStatus {
  /** Dealer Settlement has been canceled */
  CANCELED = 'CANCELED',
  /** Dealer Settlement has been created */
  PENDING = 'PENDING',
  /** Dealer Settlement has been settled */
  SETTLED = 'SETTLED',
  /** The associated transaction has been initiated */
  TRANSACTION_INITIATED = 'TRANSACTION_INITIATED'
}

/**
 * Input-position counterpart of DealerSettlementStatus used in filter arguments.
 * Kept structurally separate from the output enum so the type stays single-owner
 * across subgraphs (federation cannot exact-match-couple input+output uses).
 */
export enum DealerSettlementStatusFilter {
  /** Dealer Settlement has been canceled */
  CANCELED = 'CANCELED',
  /** Dealer Settlement has been created */
  PENDING = 'PENDING',
  /** Dealer Settlement has been settled */
  SETTLED = 'SETTLED',
  /** The associated transaction has been initiated */
  TRANSACTION_INITIATED = 'TRANSACTION_INITIATED'
}

/** Trade execution report */
export type DealerTrade = {
  __typename: 'DealerTrade';
  aggressorSide: Maybe<TradeSide>;
  amountCurrency: Scalars['String']['output'];
  avgPxAllIn: Maybe<Scalars['String']['output']>;
  /** Average price all in amount */
  avgPxAllInAmount: Maybe<Amount>;
  /** Amount that was bought */
  boughtAmount: Maybe<Amount>;
  cancelSessionID: Maybe<Scalars['String']['output']>;
  clOrdID: Maybe<Scalars['String']['output']>;
  /** Linked clientOrderIDs */
  clientOrderIDs: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  cumAmt: Scalars['String']['output'];
  /** cumAmtAllIn denotes counter quantity inclusive of fees */
  cumAmtAllIn: Scalars['String']['output'];
  cumProviderFee: Maybe<Scalars['String']['output']>;
  cumQty: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  cxlRejReason: Maybe<CxlRejReason>;
  /** Entity of the dealer trade */
  entity: Scalars['String']['output'];
  execID: Maybe<Scalars['String']['output']>;
  execType: Maybe<ExecType>;
  feeCurrency: Maybe<Scalars['String']['output']>;
  flowType: Maybe<FlowType>;
  groupID: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initiator: DealerTradeInitiator;
  internalSettlementID: Maybe<Scalars['String']['output']>;
  internalStatus: Maybe<InternalStatus>;
  /** isHistorical informs whether this is a spreadsheet imported dealer trade or not */
  isHistorical: Maybe<Scalars['Boolean']['output']>;
  lastAmt: Maybe<Scalars['String']['output']>;
  lastFee: Maybe<Scalars['String']['output']>;
  lastFeeCurrency: Maybe<Scalars['String']['output']>;
  lastProviderFee: Maybe<Scalars['String']['output']>;
  lastPx: Maybe<Scalars['String']['output']>;
  lastQty: Maybe<Scalars['String']['output']>;
  leavesQty: Maybe<Scalars['String']['output']>;
  /** markets is the list of the counterparties where this trade has been executed at */
  markets: Array<Scalars['String']['output']>;
  ordRejReason: Maybe<OrdRejReason>;
  ordStatus: Maybe<OrdStatus>;
  ordType: OrdType;
  orderID: Maybe<Scalars['String']['output']>;
  orderQty: Scalars['String']['output'];
  orderSessionID: Maybe<Scalars['String']['output']>;
  origClOrdID: Maybe<Scalars['String']['output']>;
  parentOrderID: Maybe<Scalars['String']['output']>;
  parentRFQID: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  /** Price amount */
  priceAmount: Maybe<Amount>;
  providerFeeCurrency: Maybe<Scalars['String']['output']>;
  revision: Maybe<Scalars['Int']['output']>;
  side: TradeSide;
  /** Amount that was sold */
  soldAmount: Maybe<Amount>;
  /** source represents the channel where the trade originated from */
  source: TradeSource;
  sourceID: Maybe<Scalars['String']['output']>;
  /** strategyString represents free-form strategy names */
  strategyString: Scalars['String']['output'];
  subAccount: Maybe<Scalars['String']['output']>;
  symbol: Scalars['String']['output'];
  textMessage: Maybe<Scalars['String']['output']>;
  timeInForce: Maybe<TimeInForce>;
  transactTime: Scalars['Timestamp']['output'];
};

/** DealerTradeInitiator represents the initiator of a dealer trade */
export enum DealerTradeInitiator {
  CUSTOMER = 'CUSTOMER',
  INVALID = 'INVALID',
  TRADING_DESK = 'TRADING_DESK'
}

/** Dealer trades connection for pagination */
export type DealerTradesConnection = {
  __typename: 'DealerTradesConnection';
  /** List of edges containing dealer trades and cursor information */
  edges: Array<DealerTradesEdge>;
  /** Page details for the associated list of dealer trades edges */
  pageInfo: PageInfo;
};

/** Dealer trades edge for pagination */
export type DealerTradesEdge = {
  __typename: 'DealerTradesEdge';
  /** Cursor for the associated dealer trades */
  cursor: Scalars['String']['output'];
  /** Dealer trades */
  node: DealerTrade;
};

/** DealerTradesFilters are the filters for tradingDealerTradesCSV endpoint */
export type DealerTradesFilters = {
  filterCounterparty?: InputMaybe<Array<Scalars['String']['input']>>;
  filterExecID?: InputMaybe<Scalars['ID']['input']>;
  filterFills?: InputMaybe<Scalars['Boolean']['input']>;
  filterFlowType?: InputMaybe<FlowType>;
  filterID?: InputMaybe<Scalars['ID']['input']>;
  filterInitiator?: InputMaybe<Array<DealerTradeInitiator>>;
  filterIsHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  filterOrdType?: InputMaybe<Array<OrdType>>;
  filterParentOrderID?: InputMaybe<Scalars['String']['input']>;
  filterSide?: InputMaybe<TradeSide>;
  filterSource?: InputMaybe<Array<TradeSource>>;
  filterSymbol?: InputMaybe<Array<Scalars['String']['input']>>;
  filterTransactTimeAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  filterTransactTimeBefore?: InputMaybe<Scalars['Timestamp']['input']>;
};

/** DebitInAuthorization is the result of the authorize step for an ACH Debit In */
export type DebitInAuthorization = {
  __typename: 'DebitInAuthorization';
  /**
   * checks holds one entry per authorize check that ran, in run order. Empty, never null, when no check ran.
   * A check with no entry did not run.
   */
  checks: Array<ACHCheckOutcome>;
  /** outcome is the authorize step's verdict. A pull the bank rejected after authorize passed keeps PASSED. */
  outcome: DebitInAuthorizeOutcome;
  /**
   * reason is the typed failure reason, set when outcome is REJECTED or the pull failed at the bank.
   * An unrecognized value is a generic authorize failure.
   */
  reason: Maybe<Scalars['String']['output']>;
};

/** DebitInAuthorizeOutcome is the authorize step's verdict on an ACH Debit In */
export enum DebitInAuthorizeOutcome {
  /** PASSED means authorize let the pull through to the bank */
  PASSED = 'PASSED',
  /** REJECTED means authorize refused the pull and nothing reached the bank */
  REJECTED = 'REJECTED'
}

/** Represents an ACH Debit In: an Anchorage-originated pull from a linked bank account that credits a wallet once the bank settles it */
export type DebitInOperation = Operation & {
  __typename: 'DebitInOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** accountID is the internal bank account this pull is tracked under */
  accountID: Scalars['String']['output'];
  /**
   * accountNumber is the bank account number this pull debits, masked to its last characters. Plaid's
   * mask may be shorter than four characters, and the value is display text, not a reconciliation key.
   * Captured when source resolution succeeds, so it is present on a pull that authorize rejected after
   * resolving its source. Null until source resolution succeeded.
   */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount is the pull amount (positive), credited to the wallet once the pull completes */
  amount: Amount;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** authorization is the result of the authorize step for this pull. Null until authorize ran. */
  authorization: Maybe<DebitInAuthorization>;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation. Can be used to provide more context to the operation. */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /** programCustomerID is the program customer that owns the credited virtual account. Null when the pull credits the wallet's base virtual account. */
  programCustomerID: Maybe<Scalars['String']['output']>;
  /** remittanceInformation is the remittance information the client sent with the pull request, empty when none was sent */
  remittanceInformation: Scalars['String']['output'];
  /**
   * returnOperationID is the id of the ACH Debit In Return that unwinds this pull, once one exists.
   * Null until a return is created. A non-null value on its own does not mean the funds went back:
   * the return must itself be COMPLETE.
   */
  returnOperationID: Maybe<Scalars['String']['output']>;
  /** sameDayACH is true when the client requested same-day settlement for this pull */
  sameDayACH: Scalars['Boolean']['output'];
  /** secCode is the NACHA Standard Entry Class code on the outbound ACH entry, if known */
  secCode: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** statementDescriptor is the statement descriptor the client sent with the pull request, empty when none was sent */
  statementDescriptor: Scalars['String']['output'];
  /** traceNumber is the NACHA trace number of the outbound ACH entry. Null until the bank assigns one. */
  traceNumber: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** virtualAccount resolves the display details of the credited virtual account (owner name, account last-4) from fiat. Null when virtualAccountID is null or the caller may not see the operation's organization. */
  virtualAccount: Maybe<VirtualAccount>;
  /** virtualAccountID is the virtual account this pull credits. Null when the pull credits the wallet's base virtual account. */
  virtualAccountID: Maybe<Scalars['String']['output']>;
  /** The wallet associated with this operation */
  wallet: Wallet;
};


/** Represents an ACH Debit In: an Anchorage-originated pull from a linked bank account that credits a wallet once the bank settles it */
export type DebitInOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** Represents a return for an Anchorage-originated Debit In pull: Anchorage is ODFI and receives it back, unwinding the original credit */
export type DebitInReturnOperation = Operation & {
  __typename: 'DebitInReturnOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** accountID is the internal bank account this return is tracked under */
  accountID: Scalars['String']['output'];
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount is the unwind amount (negative), reversing the original credit */
  amount: Amount;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation. Can be used to provide more context to the operation. */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /** originalOperationID is the id of the Debit In operation this return unwinds */
  originalOperationID: Scalars['String']['output'];
  /** programCustomerID is the program customer that owns that virtual account, copied from the Debit In when the return was created. Null when that pull was not attributed to one. */
  programCustomerID: Maybe<Scalars['String']['output']>;
  /** returnCode is the NACHA return reason code carried on the ACH return entry */
  returnCode: Scalars['String']['output'];
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** virtualAccountID is the virtual account the Debit In this return unwinds credited, copied from it when the return was created. Null when that pull was not attributed to one. */
  virtualAccountID: Maybe<Scalars['String']['output']>;
  /** The wallet associated with this operation */
  wallet: Wallet;
};


/** Represents a return for an Anchorage-originated Debit In pull: Anchorage is ODFI and receives it back, unwinding the original credit */
export type DebitInReturnOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** DebitOutDisputeStatus is where an ACH Debit Out stands in the dispute flow */
export enum DebitOutDisputeStatus {
  /** DISPUTABLE means no return exists yet and the dispute deadline has not passed */
  DISPUTABLE = 'DISPUTABLE',
  /** DISPUTED means a return exists and has not reached a final state yet */
  DISPUTED = 'DISPUTED',
  /** EXPIRED means no return exists and the dispute deadline has passed */
  EXPIRED = 'EXPIRED',
  /** RETURNED means the return completed and the funds are back in the wallet */
  RETURNED = 'RETURNED',
  /**
   * RETURN_FAILED means a return was created but ended without restoring the funds, either ERRORED
   * or EXPIRED. The debit takes no second dispute.
   */
  RETURN_FAILED = 'RETURN_FAILED'
}

/** Represents an ACH Debit Out: a counterparty pulling funds from an Anchorage wallet */
export type DebitOutOperation = Operation & {
  __typename: 'DebitOutOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** accountID is the internal bank account this Debit Out was pulled against */
  accountID: Scalars['String']['output'];
  /**
   * accountNumber is the bank account number of the Anchorage wallet this debit was pulled against,
   * masked to the last 4 characters, for the corporate affidavit the dispute flow collects. Distinct
   * from accountID, which is an internal identifier no bank would recognise. Captured when the debit
   * is recorded, so it stays the account that was actually debited even after the wallet's bank
   * account changes. Null on debits recorded before it was captured, and on a wallet with no
   * provisioned account.
   */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount is the deducted amount */
  amount: Amount;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** companyID is the NACHA Company ID of the originator on the inbound ACH entry, if known */
  companyID: Maybe<Scalars['String']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation. Can be used to provide more context to the operation. */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /**
   * disputableUntil is 10:00 AM ET on the business day after the transaction date, the SLA between
   * Anchorage and its clients for raising a dispute. Null on debits created before the field was
   * populated.
   */
  disputableUntil: Maybe<Scalars['Timestamp']['output']>;
  /**
   * disputeStatus says where this debit stands in the dispute flow. It is derived from the linked
   * return and that return's state, or from disputableUntil when there is no return. Null when the
   * debit carries neither a return nor a dispute deadline, which is the case for debits created
   * before those fields were populated.
   */
  disputeStatus: Maybe<DebitOutDisputeStatus>;
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /** originatorName is the counterparty name supplied by the bank on the inbound ACH entry, if known */
  originatorName: Maybe<Scalars['String']['output']>;
  /** programCustomerID is the program customer that owns the debited virtual account. Null when the debit was not attributed to one. */
  programCustomerID: Maybe<Scalars['String']['output']>;
  /**
   * returnOperationID is the id of the ACH Debit Out Return that unwinds this debit, once one exists.
   * Null until a return is created. A non-null value on its own does not mean the funds came back:
   * the return can still end EXPIRED or ERRORED, which is what disputeStatus accounts for.
   */
  returnOperationID: Maybe<Scalars['String']['output']>;
  /** secCode is the NACHA Standard Entry Class code on the inbound ACH entry, if known */
  secCode: Maybe<Scalars['String']['output']>;
  /**
   * settlementDate is when the bank reported this debit as settled. Null on debits created before
   * the field was populated.
   */
  settlementDate: Maybe<Scalars['Timestamp']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** virtualAccount resolves the display details of the debited virtual account (owner name, account last-4) from fiat. Null when virtualAccountID is null or the caller may not see the operation's organization. */
  virtualAccount: Maybe<VirtualAccount>;
  /** virtualAccountID is the virtual account this debit was pulled against. Null when the debit was not attributed to one. */
  virtualAccountID: Maybe<Scalars['String']['output']>;
  /** The wallet associated with this operation */
  wallet: Wallet;
};


/** Represents an ACH Debit Out: a counterparty pulling funds from an Anchorage wallet */
export type DebitOutOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** Represents a return for a counterparty-originated Debit Out pull: Anchorage is RDFI and files it back to BNY */
export type DebitOutReturnOperation = Operation & {
  __typename: 'DebitOutReturnOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** accountID is the internal bank account this return is tracked under */
  accountID: Scalars['String']['output'];
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount is the restore amount */
  amount: Amount;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /**
   * companyID is the NACHA Company ID of the originator on the Debit Out this return unwinds, copied
   * from it when the return was created. Null when unknown, and on returns created before the copy
   * existed.
   */
  companyID: Maybe<Scalars['String']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation. Can be used to provide more context to the operation. */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /**
   * initiatedBy is the id of the user behind this return, set only when the initiator is a client
   * dispute. The automated and bank-driven initiators have no signed-in user behind them.
   */
  initiatedBy: Maybe<Scalars['String']['output']>;
  /**
   * initiator says what triggered this return: WATERFALL, CLIENT_DISPUTE or BANK today, with further
   * values possible later. A String rather than an enum on purpose, so a value added on the backend
   * does not null out the whole query for clients that predate it. Null on returns created before
   * the field existed.
   */
  initiator: Maybe<Scalars['String']['output']>;
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /** originalOperationID is the id of the Debit Out operation this return unwinds */
  originalOperationID: Scalars['String']['output'];
  /**
   * originatorName is the counterparty name on the Debit Out this return unwinds, copied from it when
   * the return was created. Null when unknown, and on returns created before the copy existed.
   */
  originatorName: Maybe<Scalars['String']['output']>;
  /** programCustomerID is the program customer that owns that virtual account, copied from the Debit Out when the return was created. Null when that debit was not attributed to one. */
  programCustomerID: Maybe<Scalars['String']['output']>;
  /** reason is the free-text note on why this return was filed, when one was given */
  reason: Maybe<Scalars['String']['output']>;
  /** returnCode is the NACHA return reason code carried on the ACH return entry */
  returnCode: Scalars['String']['output'];
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** virtualAccountID is the virtual account of the Debit Out this return unwinds, copied from it when the return was created. Null when that debit was not attributed to one. */
  virtualAccountID: Maybe<Scalars['String']['output']>;
  /** The wallet associated with this operation */
  wallet: Wallet;
};


/** Represents a return for a counterparty-originated Debit Out pull: Anchorage is RDFI and files it back to BNY */
export type DebitOutReturnOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** DebugAvailableConditionsInput selects which condition palette debugAvailableConditions inspects. */
export type DebugAvailableConditionsInput = {
  /** Action scope to filter the palette by. Omit to inspect across all scopes. */
  actionScope?: InputMaybe<Scalars['String']['input']>;
  /** Organization to scope the palette to. Omit to return the fully live catalog with no org filtering. */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
};

/** DebugUserInfo is a type that has a bit of info about users. */
export type DebugUserInfo = {
  __typename: 'DebugUserInfo';
  /** The user's name. */
  name: Scalars['String']['output'];
  /** The organization's OrganizationKeyID. */
  orgID: Scalars['String']['output'];
  /** The organization's name. */
  orgName: Scalars['String']['output'];
};

/** DecentralizedExchange is the name of a Decentralized Exchange that can perform token swaps. */
export enum DecentralizedExchange {
  /** JUPITER perform swaps on the DEX named Jupiter. */
  JUPITER = 'JUPITER',
  /** UNISWAP perform swaps on the DEX named Uniswap. */
  UNISWAP = 'UNISWAP',
  /** UNSPECIFIED signals that no DEX was chosen to retrieve quotes from or to swap with. */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** Information about a set of default settlement instructions */
export type DefaultSettlementInstructions = {
  __typename: 'DefaultSettlementInstructions';
  /** createdAt is the timestamp of creation of this record */
  createdAt: Scalars['Timestamp']['output'];
  /** createdBy is the email of the user who created this record */
  createdBy: Scalars['String']['output'];
  /** id is the identifier */
  id: Scalars['String']['output'];
  /** instructions is a stringified json with the assetType and address for each asset */
  instructions: Scalars['String']['output'];
};

/** Return for Default Staking Fee Terms Query */
export type DefaultStakingFeeTerms = {
  __typename: 'DefaultStakingFeeTerms';
  assetFees: Maybe<AssetStakingFeesConnection>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reviewedAt: Maybe<Scalars['Time']['output']>;
  reviewedBy: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};


/** Return for Default Staking Fee Terms Query */
export type DefaultStakingFeeTermsassetFeesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filter?: InputMaybe<AssetStakingFeesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum DefaultStakingFeeTermsChangeType {
  ADDED = 'ADDED',
  EDITED = 'EDITED'
}

/** DefaultStakingFeeTermsReview represents a review of pending updates to the default staking fees */
export type DefaultStakingFeeTermsReview = {
  __typename: 'DefaultStakingFeeTermsReview';
  changes: DefaultStakingFeeTermsReviewItemsConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};


/** DefaultStakingFeeTermsReview represents a review of pending updates to the default staking fees */
export type DefaultStakingFeeTermsReviewchangesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filter?: InputMaybe<DefaultStakingFeeTermsReviewChangesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DefaultStakingFeeTermsReviewChangesFilter = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DefaultStakingFeeTermsReviewItem = {
  __typename: 'DefaultStakingFeeTermsReviewItem';
  changeType: DefaultStakingFeeTermsChangeType;
  newValue: Maybe<AssetStakingFees>;
  oldValue: Maybe<AssetStakingFees>;
};

export type DefaultStakingFeeTermsReviewItemEdge = {
  __typename: 'DefaultStakingFeeTermsReviewItemEdge';
  cursor: Scalars['CursorType']['output'];
  node: Maybe<DefaultStakingFeeTermsReviewItem>;
};

export type DefaultStakingFeeTermsReviewItemsConnection = {
  __typename: 'DefaultStakingFeeTermsReviewItemsConnection';
  edges: Maybe<Array<DefaultStakingFeeTermsReviewItemEdge>>;
  pageInfo: Maybe<PageInfo>;
};

export enum DefaultStakingFeeTermsReviewType {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT'
}

/** A single pair of wallet and network, used in snParticipantUpdate */
export type DefaultWalletInput = {
  /** The network to update the default wallet for */
  networkID: Scalars['String']['input'];
  /** The wallet unique ID (or null if the caller wants to remove the default) */
  walletUniqueID?: InputMaybe<Scalars['String']['input']>;
};

/** DelegateOperation represents a delegate operation */
export type DelegateOperation = Operation & {
  __typename: 'DelegateOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount returns the associated amount we delegated, only available for v1 delegation */
  amount: Maybe<Amount>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** asset id from with the delegation was made */
  assetID: AssetID;
  /** Further information regarding this asset type associated with this operation */
  assetTypeInfo: AssetTypeInfo;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** canonicalOperationVersion is the version of the canonical delegation that must be used to sign this delegation */
  canonicalOperationVersion: Scalars['Int']['output'];
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** confirmations returns how many confirmations the transaction associated with this delegation has received */
  confirmations: Maybe<Scalars['Int']['output']>;
  /** The Public Key of the target Validator into which the StakingPositionID will consolidate. Used in the context of staking for certain chains, such as Ethereum. */
  consolidationTarget: Maybe<Scalars['String']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** delegateType returns the type of delegation. available for all versions */
  delegateType: Maybe<DelegateType>;
  /** delegationAddress is the address that we are delegating to (ie. for staking, baking, inflation pools, etc.) */
  delegationAddress: Maybe<DelegationAddress>;
  /**
   * If the DelegationAddress is amongst the "Known Staking Validators", it would have a (Known) "name".
   * Note:
   *   - Even if (DelegationAddress, Asset) matches one of "Known Staking Validators", delegationAddressName
   *     would have a value *only if* this DelegateOperation was created with "name" (aka destinationAddressName).
   *   - If the DelegateOperation was created with a "Known Staking Validator"'s DelegationAddress but without
   *     "name", this field would still have no value.
   */
  delegationAddressName: Maybe<Scalars['String']['output']>;
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** destinationManagedAddress resolves the delegation/consolidation destination to a BlockchainAddress when it happens to be an address Anchorage manages, so managedAddressV2 (vault/wallet/account/entity ownership) can be queried. Null for external validator/protocol addresses, which is the common case for delegate/undelegate/redelegate. */
  destinationManagedAddress: Maybe<BlockchainAddress>;
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * extraParams are additional asset type specific parameters that were set for this transaction
   * When constructing the canonical operation for signing, the extra params go in the ExtraParams field
   * as a map from asset type id (usually, parent asset type id) to params object. The convention of extra
   * params is to omit all empty fields, and if no extra params are set for an asset type, to omit the asset
   * type from the map entirely. Note that for legacy reasons this convention
   * is the opposite of the normal CanonicalOperation convention, where no fields are ever omitted.
   */
  extraParams: Maybe<ExtraParams>;
  /** final transaction fee charged for the delegation, detected on the blockchain */
  finalFee: Maybe<Amount>;
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** isFullAmount tells the BE explicitly whether the user wants to delegate/undelegate the full amount */
  isFullAmount: Maybe<Scalars['Boolean']['output']>;
  /** max transaction fee charged for the delegation */
  maxFee: Maybe<Amount>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /**
   * replayProtectionParams are the parameters to be sent to the HSM for creating and signing
   * the transactions required to effect this ExecuteOperation. The user *is not* expected
   * to review the contents of this field. However it may contain information necessary to prevent
   * replays and must be included in the payload signed by the user. Each element is a hex-encoded
   * byte array.
   */
  replayProtectionParams: Maybe<Scalars['String']['output']>;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** sendingBlockchainAddresses is a list of addresses from which a delegate operation is sent */
  sendingBlockchainAddresses: Array<BlockchainAddress>;
  /** signedTransaction is the blockchain transaction to be broadcast to the network */
  signedTransaction: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /**
   * sources are the originating addresses for the delegation
   * @deprecated use sendingBlockchainAddresses
   */
  sources: Array<Source>;
  /** stakingPositionID is the identifier of the staking position */
  stakingPositionID: Maybe<Scalars['String']['output']>;
  /** The provider to use to provision a new Validator. Used in the context of staking for certain chains, such as Ethereum. */
  stakingProvider: Maybe<Scalars['String']['output']>;
  /** transactionID is the blockchain transaction id once available */
  transactionID: Maybe<Scalars['String']['output']>;
  /** transactionSuccess indicates if the blockchain transaction succeeded */
  transactionSuccess: Maybe<Scalars['Boolean']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * usdValueFee is the USD value of the fee (finalFee if known, otherwise maxFee).
   * If both the finalFee and maxFee are not yet known, this field will be null
   */
  usdValueFee: Maybe<Scalars['String']['output']>;
  /** useGasStation if true, the Anchorage gas station was used to pay the gas fees */
  useGasStation: Scalars['Boolean']['output'];
  /** The OrganizationKeyID and Public Key of the target Validator into which the StakingPositionID will consolidate. Used in the context of staking for certain chains, such as Ethereum. */
  validatorConsolidationTarget: Maybe<ValidatorConsolidationTarget>;
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
};


/** DelegateOperation represents a delegate operation */
export type DelegateOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** DelegateOperation represents a delegate operation */
export type DelegateOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** DelegateType is an enum used for delegation, specifically V1 canonical operation */
export enum DelegateType {
  /** COLLECT is when the delegation operation is collecting an inactive stake. */
  COLLECT = 'COLLECT',
  /** CONSOLIDATE is when the operation is consolidating two existing Validators. Used in the context of staking for certain chains, such as Ethereum. */
  CONSOLIDATE = 'CONSOLIDATE',
  /** DELEGATE is when the delegation operation is bonding funds to a validator. */
  DELEGATE = 'DELEGATE',
  /** DELEGATE_DELEGATION_POOL is when the delegation operation is adding funds to a delegation pool */
  DELEGATE_DELEGATION_POOL = 'DELEGATE_DELEGATION_POOL',
  /** DELEGATE_STAKE_POOL is when the delegation operation is adding funds to a stake pool */
  DELEGATE_STAKE_POOL = 'DELEGATE_STAKE_POOL',
  /** DEPOSIT is when the operation is adding funds to an existing Validator. Used in the context of staking for certain chains, such as Ethereum. */
  DEPOSIT = 'DEPOSIT',
  /** EXTERNALLY_MANAGED_DELEGATE is when the delegation operation delegates to something that stakes on our behalf */
  EXTERNALLY_MANAGED_DELEGATE = 'EXTERNALLY_MANAGED_DELEGATE',
  /** INITIALIZE is when the delegation operation is creating a staking contract/validator */
  INITIALIZE = 'INITIALIZE',
  /** INITIALIZE_DELEGATION_POOL is when the delegation operation is creating a delegation pool */
  INITIALIZE_DELEGATION_POOL = 'INITIALIZE_DELEGATION_POOL',
  /** INITIALIZE_STAKE_POOL is when the delegation operation is creating a stake pool validator */
  INITIALIZE_STAKE_POOL = 'INITIALIZE_STAKE_POOL',
  /** INITIALIZE_VESTING is when the delegation operation is creating a vesting contract */
  INITIALIZE_VESTING = 'INITIALIZE_VESTING',
  /** PROVISION is when the operation is provisioning a new Validator. Used in the context of staking for certain chains, such as Ethereum. */
  PROVISION = 'PROVISION',
  /** REDELEGATE is when the delegation operation is moving the delegation to another validator */
  REDELEGATE = 'REDELEGATE',
  /** UNDELEGATE is when the delegation operation is unbonding funds from a validator. Known as 'unbond' in the cosmos docs */
  UNDELEGATE = 'UNDELEGATE',
  /** UNDELEGATE_DELEGATION_POOL is when the delegation operation is unbonding funds from a delegation pool */
  UNDELEGATE_DELEGATION_POOL = 'UNDELEGATE_DELEGATION_POOL',
  /** UNDELEGATE_MARINADE is when the delegation operation is a Marinade undelegate */
  UNDELEGATE_MARINADE = 'UNDELEGATE_MARINADE',
  /** UNDELEGATE_STAKE_POOL is when the delegation operation is unbonding funds from a stake pool */
  UNDELEGATE_STAKE_POOL = 'UNDELEGATE_STAKE_POOL',
  /** WITHDRAW is when the operation is withdrawing funds from an existing Validator. Used in the context of staking for certain chains, such as Ethereum. */
  WITHDRAW = 'WITHDRAW'
}

/**
 * DelegationAddress is aka "Known Staking Validator".
 * Represents a delegation address from the allow-listed "known" ones, to each Anchorage has given a name.
 * When delegating (ie, staking), user could specify (1) either any arbitrary address string they feel
 * comfortable using (which would not be "known" to Anchorage), (2) or choose from the "known" list of
 * Staking Validators (ie, delegation addresses).
 */
export type DelegationAddress = {
  __typename: 'DelegationAddress';
  /** Indicates if this validator belongs to anchorage */
  anchorageValidator: Scalars['Boolean']['output'];
  /** The asset type ID of the delegation address. */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /**
   * The detail for celo validator group.
   * Deprecated: Celo governance is no longer supported. Retained for backward
   * compatibility with older iOS clients; always returns null. Safe to delete
   * once the minimum supported iOS version is v2.111.0.
   * @deprecated Celo governance has been removed. This field always returns null.
   */
  celoValidatorGroupDetail: Maybe<CeloValidatorGroupDetail>;
  /** Status of delegation if assetID is provided */
  delegationStatus: Maybe<DelegationStatus>;
  /** Delegation type of delegation address, for custom pool staking */
  delegationType: Maybe<Scalars['String']['output']>;
  /** Description of the delegation address */
  description: Scalars['String']['output'];
  /** The delegation address */
  destination: Scalars['String']['output'];
  /** Label of the delegation address, liquidstaking */
  label: Maybe<Scalars['String']['output']>;
  /** Name of the delegation address */
  name: Scalars['String']['output'];
  /**
   * The detail for the validator, or null if not available
   * The concrete type depends on the asset type as the details are asset type specific
   */
  validatorDetail: Maybe<ValidatorDetail>;
};

/** Asset input for delegation */
export type DelegationAssetInput = {
  /** The asset amount and type to delegate */
  amount: AmountInput;
  /** The unique wallet ID within the delegator's vault */
  walletID: Scalars['String']['input'];
};

/** Delegation input for control agreement */
export type DelegationInput = {
  /** The list of assets to delegate */
  assets: Array<DelegationAssetInput>;
  /** The pledgor's delegating vault unique ID */
  pledgorDelegatingVaultID: Scalars['String']['input'];
};

/** Status of delegation if assetID is provided */
export type DelegationStatus = {
  __typename: 'DelegationStatus';
  /** The total active amount belonging to the user, this earns the reward */
  active: Maybe<Amount>;
  /** The amount being delegated by the user right now */
  delegating: Maybe<Amount>;
  /** The pending delegated amount to be activated by the user */
  pending: Maybe<Amount>;
};

export type DeleteDerivsEntityWalletPayload = {
  __typename: 'DeleteDerivsEntityWalletPayload';
  id: Scalars['ID']['output'];
};

/** DeleteEECredentialInput is the input for the deleteEECredentialV2 mutation */
export type DeleteEECredentialInput = {
  credentialID: Scalars['ID']['input'];
};

/** DeleteEECredentialResponse is the response for the deleteEECredentialV2 mutation */
export type DeleteEECredentialResponse = {
  __typename: 'DeleteEECredentialResponse';
  credential: EEAPIKey;
  /** @deprecated Always empty. Removed once the atlas connect flow stops selecting it. */
  operationID: Scalars['String']['output'];
};

export type DeleteExpiredLTVHistoryResult = {
  __typename: 'DeleteExpiredLTVHistoryResult';
  /** Number of LTV history rows removed by this pass */
  deletedCount: Scalars['Int']['output'];
};

export type DeleteExposureResult = {
  __typename: 'DeleteExposureResult';
  /** Bool result */
  success: Scalars['Boolean']['output'];
};

/** DeleteKYCConfigInput is used for delete KYCConfig object. */
export type DeleteKYCConfigInput = {
  id: Scalars['ID']['input'];
};

/** DeleteKYCQuestionInput is used for soft delete KYCQuestion object. */
export type DeleteKYCQuestionInput = {
  /** The id of the questionnaire to be deleted */
  id: Scalars['ID']['input'];
};

/** DeleteKYCQuestionnaireInput is used for soft delete KYCQuestionnaire object. */
export type DeleteKYCQuestionnaireInput = {
  /** The id of the questionnaire to be deleted */
  id: Scalars['ID']['input'];
};

export type DeleteOperationResult = {
  __typename: 'DeleteOperationResult';
  /** Bool result */
  success: Scalars['Boolean']['output'];
};

export type DeletePackageResult = {
  __typename: 'DeletePackageResult';
  /** Bool result */
  success: Scalars['Boolean']['output'];
};

export type DeleteTaxMappingInput = {
  /** Id of the active mapping to remove */
  mappingId: Scalars['ID']['input'];
  /** Reason for the removal, stored as the mapping's deactivationRationale */
  rationale?: InputMaybe<Scalars['String']['input']>;
};

export type DeleveragingLevel = {
  liquidationPercentage: Scalars['String']['input'];
  price: Scalars['String']['input'];
};

/** Payload response for the depositAddressCreate mutation */
export type DepositAddressCreatePayload = {
  __typename: 'DepositAddressCreatePayload';
  /** The BlockchainAddress info for the address created by the mutation */
  blockchainAddress: BlockchainAddress;
};

export enum DepositAttributionAssetClass {
  /** CRYPTO represents a crypto deposit attribution */
  CRYPTO = 'CRYPTO',
  /** FIAT represents a fiat deposit attribution */
  FIAT = 'FIAT'
}

/** A connection to a list of items. */
export type DepositAttributionConnectionV2 = {
  __typename: 'DepositAttributionConnectionV2';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<DepositAttributionEdgeV2>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DepositAttributionEdgeV2 = {
  __typename: 'DepositAttributionEdgeV2';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<DepositAttributionV2>;
};

/** Ordering options for DepositAttributionV2 connections */
export type DepositAttributionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DepositAttributions. */
  field: DepositAttributionOrderField;
};

/** Properties by which DepositAttributionV2 connections can be ordered. */
export enum DepositAttributionOrderField {
  ACCOUNT_ID = 'ACCOUNT_ID',
  ATTRIBUTED_AT = 'ATTRIBUTED_AT',
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT'
}

/** DepositAttributionOriginator represents a single originator that can be associated with a deposit attribution */
export type DepositAttributionOriginator = {
  __typename: 'DepositAttributionOriginator';
  /** Originator physical address - unstructured */
  originatorAddresses: Maybe<Array<Scalars['String']['output']>>;
  /** Country of the deposit attribution originator */
  originatorCountry: Scalars['String']['output'];
  /** Name of the deposit attribution originator */
  originatorName: Scalars['String']['output'];
  /** Type of originator of the deposit attribution */
  originatorType: DepositAttributionOriginatorType;
};

export enum DepositAttributionOriginatorType {
  /** ORIGINATOR represents a type for the originator of the deposit. Applicable for crypto and fiat */
  ORIGINATOR = 'ORIGINATOR',
  /** ORIGINATOR_FI represents the originator financial institution of the deposit. Applicable for fiat */
  ORIGINATOR_FI = 'ORIGINATOR_FI',
  /** ORIGINATOR_INTERMEDIARY_FI represents the originator intermediary financial institution of the deposit. Applicable for fiat */
  ORIGINATOR_INTERMEDIARY_FI = 'ORIGINATOR_INTERMEDIARY_FI'
}

/** DepositAttributionPair represents the operationID/sourceAddress pair associated with the attribution */
export type DepositAttributionPair = {
  /** Operation ID of the deposit being attributed */
  operationID: Scalars['String']['input'];
  /** Source Address of the deposit being attributed */
  sourceAddress: Scalars['String']['input'];
};

/**
 * DepositAttributionPrivateWhereInput is used for filtering DepositAttribution objects.
 * This is meant to be used in internal client queries
 */
export type DepositAttributionPrivateWhereInput = {
  /** account_id field predicates */
  accountID?: InputMaybe<Scalars['String']['input']>;
  accountIDContains?: InputMaybe<Scalars['String']['input']>;
  accountIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  accountIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  accountIDGT?: InputMaybe<Scalars['String']['input']>;
  accountIDGTE?: InputMaybe<Scalars['String']['input']>;
  accountIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  accountIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  accountIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  accountIDLT?: InputMaybe<Scalars['String']['input']>;
  accountIDLTE?: InputMaybe<Scalars['String']['input']>;
  accountIDNEQ?: InputMaybe<Scalars['String']['input']>;
  accountIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** anchorage_entity field predicates */
  anchorageEntity?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityContains?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityContainsFold?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityEqualFold?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityGT?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityGTE?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  anchorageEntityLT?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityLTE?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityNEQ?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<DepositAttributionPrivateWhereInput>>;
  /** asset_type_id field predicates */
  assetTypeID?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDContains?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDGT?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDGTE?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetTypeIDLT?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDLTE?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDNEQ?: InputMaybe<Scalars['String']['input']>;
  assetTypeIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** attributed_at field predicates */
  attributedAt?: InputMaybe<Scalars['Time']['input']>;
  attributedAtGT?: InputMaybe<Scalars['Time']['input']>;
  attributedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  attributedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  attributedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  attributedAtLT?: InputMaybe<Scalars['Time']['input']>;
  attributedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  attributedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  attributedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  attributedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** attribution_edited_at field predicates */
  attributionEditedAt?: InputMaybe<Scalars['Time']['input']>;
  attributionEditedAtGT?: InputMaybe<Scalars['Time']['input']>;
  attributionEditedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  attributionEditedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  attributionEditedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  attributionEditedAtLT?: InputMaybe<Scalars['Time']['input']>;
  attributionEditedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  attributionEditedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  attributionEditedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  attributionEditedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** attribution_status field predicates */
  attributionStatus?: InputMaybe<DepositAttributionStatus>;
  attributionStatusIn?: InputMaybe<Array<DepositAttributionStatus>>;
  attributionStatusNEQ?: InputMaybe<DepositAttributionStatus>;
  attributionStatusNotIn?: InputMaybe<Array<DepositAttributionStatus>>;
  /** attribution_type field predicates */
  attributionType?: InputMaybe<DepositAttributionType>;
  attributionTypeIn?: InputMaybe<Array<DepositAttributionType>>;
  attributionTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  attributionTypeNEQ?: InputMaybe<DepositAttributionType>;
  attributionTypeNotIn?: InputMaybe<Array<DepositAttributionType>>;
  attributionTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** interacted_with field predicates */
  interactedWith?: InputMaybe<Scalars['String']['input']>;
  interactedWithContains?: InputMaybe<Scalars['String']['input']>;
  interactedWithContainsFold?: InputMaybe<Scalars['String']['input']>;
  interactedWithEqualFold?: InputMaybe<Scalars['String']['input']>;
  interactedWithGT?: InputMaybe<Scalars['String']['input']>;
  interactedWithGTE?: InputMaybe<Scalars['String']['input']>;
  interactedWithHasPrefix?: InputMaybe<Scalars['String']['input']>;
  interactedWithHasSuffix?: InputMaybe<Scalars['String']['input']>;
  interactedWithIn?: InputMaybe<Array<Scalars['String']['input']>>;
  interactedWithIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  interactedWithLT?: InputMaybe<Scalars['String']['input']>;
  interactedWithLTE?: InputMaybe<Scalars['String']['input']>;
  interactedWithNEQ?: InputMaybe<Scalars['String']['input']>;
  interactedWithNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  interactedWithNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** lexis_nexis_alert_id field predicates */
  lexisNexisAlertID?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisAlertIDGT?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisAlertIDGTE?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisAlertIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  lexisNexisAlertIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lexisNexisAlertIDLT?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisAlertIDLTE?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisAlertIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisAlertIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  lexisNexisAlertIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** lexis_nexis_search_request_id field predicates */
  lexisNexisSearchRequestID?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisSearchRequestIDGT?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisSearchRequestIDGTE?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisSearchRequestIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  lexisNexisSearchRequestIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lexisNexisSearchRequestIDLT?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisSearchRequestIDLTE?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisSearchRequestIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  lexisNexisSearchRequestIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  lexisNexisSearchRequestIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** network_id field predicates */
  networkID?: InputMaybe<Scalars['String']['input']>;
  networkIDContains?: InputMaybe<Scalars['String']['input']>;
  networkIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  networkIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  networkIDGT?: InputMaybe<Scalars['String']['input']>;
  networkIDGTE?: InputMaybe<Scalars['String']['input']>;
  networkIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  networkIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  networkIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  networkIDLT?: InputMaybe<Scalars['String']['input']>;
  networkIDLTE?: InputMaybe<Scalars['String']['input']>;
  networkIDNEQ?: InputMaybe<Scalars['String']['input']>;
  networkIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DepositAttributionPrivateWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** operation_id field predicates */
  operationID?: InputMaybe<Scalars['String']['input']>;
  operationIDContains?: InputMaybe<Scalars['String']['input']>;
  operationIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  operationIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  operationIDGT?: InputMaybe<Scalars['String']['input']>;
  operationIDGTE?: InputMaybe<Scalars['String']['input']>;
  operationIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  operationIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  operationIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  operationIDLT?: InputMaybe<Scalars['String']['input']>;
  operationIDLTE?: InputMaybe<Scalars['String']['input']>;
  operationIDNEQ?: InputMaybe<Scalars['String']['input']>;
  operationIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<DepositAttributionPrivateWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['String']['input']>;
  organizationIDContains?: InputMaybe<Scalars['String']['input']>;
  organizationIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  organizationIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  organizationIDGT?: InputMaybe<Scalars['String']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['String']['input']>;
  organizationIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  organizationIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIDLT?: InputMaybe<Scalars['String']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['String']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['String']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** screening_request_id field predicates */
  screeningRequestID?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDContains?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDGT?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDGTE?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  screeningRequestIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  screeningRequestIDLT?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDLTE?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDNEQ?: InputMaybe<Scalars['String']['input']>;
  screeningRequestIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  screeningRequestIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** screening_status field predicates */
  screeningStatus?: InputMaybe<DepositAttributionScreeningStatus>;
  screeningStatusIn?: InputMaybe<Array<DepositAttributionScreeningStatus>>;
  screeningStatusNEQ?: InputMaybe<DepositAttributionScreeningStatus>;
  screeningStatusNotIn?: InputMaybe<Array<DepositAttributionScreeningStatus>>;
  /** subaccount_id field predicates */
  subaccountID?: InputMaybe<Scalars['String']['input']>;
  subaccountIDContains?: InputMaybe<Scalars['String']['input']>;
  subaccountIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  subaccountIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  subaccountIDGT?: InputMaybe<Scalars['String']['input']>;
  subaccountIDGTE?: InputMaybe<Scalars['String']['input']>;
  subaccountIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subaccountIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subaccountIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subaccountIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  subaccountIDLT?: InputMaybe<Scalars['String']['input']>;
  subaccountIDLTE?: InputMaybe<Scalars['String']['input']>;
  subaccountIDNEQ?: InputMaybe<Scalars['String']['input']>;
  subaccountIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subaccountIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tx_id field predicates */
  txID?: InputMaybe<Scalars['String']['input']>;
  txIDContains?: InputMaybe<Scalars['String']['input']>;
  txIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  txIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  txIDGT?: InputMaybe<Scalars['String']['input']>;
  txIDGTE?: InputMaybe<Scalars['String']['input']>;
  txIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  txIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  txIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  txIDLT?: InputMaybe<Scalars['String']['input']>;
  txIDLTE?: InputMaybe<Scalars['String']['input']>;
  txIDNEQ?: InputMaybe<Scalars['String']['input']>;
  txIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** wallet_type field predicates */
  walletType?: InputMaybe<DepositAttributionWalletType>;
  walletTypeIn?: InputMaybe<Array<DepositAttributionWalletType>>;
  walletTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  walletTypeNEQ?: InputMaybe<DepositAttributionWalletType>;
  walletTypeNotIn?: InputMaybe<Array<DepositAttributionWalletType>>;
  walletTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * DepositAttributionPublicWhereInput is used for filtering DepositAttribution objects
 * This is meant to be used in external client queries
 */
export type DepositAttributionPublicWhereInput = {
  and?: InputMaybe<Array<DepositAttributionPublicWhereInput>>;
  /** attributed_at field predicates */
  attributedAt?: InputMaybe<Scalars['Time']['input']>;
  attributedAtGT?: InputMaybe<Scalars['Time']['input']>;
  attributedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  attributedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  attributedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  attributedAtLT?: InputMaybe<Scalars['Time']['input']>;
  attributedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  attributedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  attributedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  attributedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** attribution_status field predicates */
  attributionStatus?: InputMaybe<DepositAttributionStatus>;
  attributionStatusIn?: InputMaybe<Array<DepositAttributionStatus>>;
  attributionStatusNEQ?: InputMaybe<DepositAttributionStatus>;
  attributionStatusNotIn?: InputMaybe<Array<DepositAttributionStatus>>;
  /** attribution_type field predicates */
  attributionType?: InputMaybe<DepositAttributionType>;
  attributionTypeIn?: InputMaybe<Array<DepositAttributionType>>;
  attributionTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  attributionTypeNEQ?: InputMaybe<DepositAttributionType>;
  attributionTypeNotIn?: InputMaybe<Array<DepositAttributionType>>;
  attributionTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DepositAttributionPublicWhereInput>;
  /** operation_id field predicates */
  operationID?: InputMaybe<Scalars['String']['input']>;
  operationIDContains?: InputMaybe<Scalars['String']['input']>;
  operationIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  operationIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  operationIDGT?: InputMaybe<Scalars['String']['input']>;
  operationIDGTE?: InputMaybe<Scalars['String']['input']>;
  operationIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  operationIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  operationIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  operationIDLT?: InputMaybe<Scalars['String']['input']>;
  operationIDLTE?: InputMaybe<Scalars['String']['input']>;
  operationIDNEQ?: InputMaybe<Scalars['String']['input']>;
  operationIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<DepositAttributionPublicWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** wallet_type field predicates */
  walletType?: InputMaybe<DepositAttributionWalletType>;
  walletTypeIn?: InputMaybe<Array<DepositAttributionWalletType>>;
  walletTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  walletTypeNEQ?: InputMaybe<DepositAttributionWalletType>;
  walletTypeNotIn?: InputMaybe<Array<DepositAttributionWalletType>>;
  walletTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** DepositAttributionScreeningStatus is enum for the field screening_status */
export enum DepositAttributionScreeningStatus {
  ALERT_FALSE_MATCH = 'ALERT_FALSE_MATCH',
  ALERT_TRUE_MATCH = 'ALERT_TRUE_MATCH',
  ALERT_WAITING_RESOLUTION = 'ALERT_WAITING_RESOLUTION',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  NOT_SCREENED = 'NOT_SCREENED',
  NO_ALERT = 'NO_ALERT',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type DepositAttributionSpamThreshold = Node & {
  __typename: 'DepositAttributionSpamThreshold';
  autoAttribute: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEnable: Scalars['Boolean']['output'];
  thresholdAmount: Amount;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type DepositAttributionSpamThresholdConnection = {
  __typename: 'DepositAttributionSpamThresholdConnection';
  /** A list of edges. */
  edges: Maybe<Array<DepositAttributionSpamThresholdEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DepositAttributionSpamThresholdEdge = {
  __typename: 'DepositAttributionSpamThresholdEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<DepositAttributionSpamThreshold>;
};

/** Ordering options for DepositAttributionSpamThreshold connections */
export type DepositAttributionSpamThresholdOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DepositAttributionSpamThresholds. */
  field: DepositAttributionSpamThresholdOrderField;
};

/** Properties by which DepositAttributionSpamThreshold connections can be ordered. */
export enum DepositAttributionSpamThresholdOrderField {
  ASSET_TYPE_ID = 'ASSET_TYPE_ID',
  AUTO_ATTRIBUTE = 'AUTO_ATTRIBUTE',
  CREATED_AT = 'CREATED_AT',
  IS_ENABLE = 'IS_ENABLE',
  THRESHOLD = 'THRESHOLD',
  UPDATED_AT = 'UPDATED_AT'
}

/**
 * DepositAttributionSpamThresholdWhereInput is used for filtering DepositAttributionSpamThreshold objects.
 * Input was generated by ent.
 */
export type DepositAttributionSpamThresholdWhereInput = {
  and?: InputMaybe<Array<DepositAttributionSpamThresholdWhereInput>>;
  /** asset_type_id field predicates */
  assetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDContains?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDContainsFold?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDEqualFold?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDGT?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDGTE?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDHasPrefix?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDHasSuffix?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDIn?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  assetTypeIDLT?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDLTE?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDNEQ?: InputMaybe<Scalars['AssetTypeID']['input']>;
  assetTypeIDNotIn?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  /** auto_attribute field predicates */
  autoAttribute?: InputMaybe<Scalars['Boolean']['input']>;
  autoAttributeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_enable field predicates */
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DepositAttributionSpamThresholdWhereInput>;
  or?: InputMaybe<Array<DepositAttributionSpamThresholdWhereInput>>;
  /** threshold field predicates */
  threshold?: InputMaybe<Scalars['Decimal']['input']>;
  thresholdGT?: InputMaybe<Scalars['Decimal']['input']>;
  thresholdGTE?: InputMaybe<Scalars['Decimal']['input']>;
  thresholdIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  thresholdLT?: InputMaybe<Scalars['Decimal']['input']>;
  thresholdLTE?: InputMaybe<Scalars['Decimal']['input']>;
  thresholdNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  thresholdNotIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** DepositAttributionStatus are the possible status of a deposit attribution fragment */
export enum DepositAttributionStatus {
  /** ATTRIBUTED represents deposit attributions that have an originator name and country attributed */
  ATTRIBUTED = 'ATTRIBUTED',
  /** BLOCKED represents deposit attributions where the screening process resulted in insuccess */
  BLOCKED = 'BLOCKED',
  /** INITIATED represents newly created deposit attributions subject to a first attempt using the automatic attribution process */
  INITIATED = 'INITIATED',
  /** NON_ATTRIBUTABLE represents deposit attributions that cannot be attributed to/by any user */
  NON_ATTRIBUTABLE = 'NON_ATTRIBUTABLE',
  /** PENDING  represents deposits that have pending attributions */
  PENDING = 'PENDING',
  /** UNDER_REVIEW represents deposit attributions that have an ongoing review process */
  UNDER_REVIEW = 'UNDER_REVIEW',
  /** UNKNOWN represents an invalid deposit attribution state */
  UNKNOWN = 'UNKNOWN'
}

/** DepositAttributionType are the options for sorting a list of affiliates */
export enum DepositAttributionType {
  /** AUTOMATIC represents deposits automatically attributed */
  AUTOMATIC = 'AUTOMATIC',
  /** BANK_DATA represents fiat deposits that are attributed through banking data */
  BANK_DATA = 'BANK_DATA',
  /** CLIENT_API represents deposits attributed via client api */
  CLIENT_API = 'CLIENT_API',
  /** GLOBAL_TRUSTED_SMART_CONTRACT represents deposits automatically attributed due to an interaction with a globally trusted smart contract */
  GLOBAL_TRUSTED_SMART_CONTRACT = 'GLOBAL_TRUSTED_SMART_CONTRACT',
  /** INTERNAL represents deposits automatically attributed due to being internal anchorage addresses */
  INTERNAL = 'INTERNAL',
  /** INTRA_GROUP represents deposits automatically attributed due to being internal anchorage addresses but from a different anchorage entity */
  INTRA_GROUP = 'INTRA_GROUP',
  /** MANUAL_CLIENT represents deposits manually attributed externally by client (org users) */
  MANUAL_CLIENT = 'MANUAL_CLIENT',
  /** MANUAL_STAFF represents deposits manually attributed internally by Anchorage (staff users) */
  MANUAL_STAFF = 'MANUAL_STAFF',
  /** SMART_CONTRACT represents deposits automatically due to an interaction with a trusted smart contract */
  SMART_CONTRACT = 'SMART_CONTRACT',
  /** SPAM represents deposits attributed as spam */
  SPAM = 'SPAM',
  /** SPAM_CLIENT represents deposits attributed as spam by clients */
  SPAM_CLIENT = 'SPAM_CLIENT',
  /** SPAM_CLIENT_API represents deposits attributed as spam by clients via API */
  SPAM_CLIENT_API = 'SPAM_CLIENT_API',
  /** SPAM_STAFF represents deposits attributed as spam by staff */
  SPAM_STAFF = 'SPAM_STAFF',
  /** TRAVEL_RULE_CIPHERTRACE represents deposits automatically attributed using travel rule info from ciphertrace */
  TRAVEL_RULE_CIPHERTRACE = 'TRAVEL_RULE_CIPHERTRACE',
  /** TRAVEL_RULE_TRUST represents deposits automatically attributed using travel rule info from trust */
  TRAVEL_RULE_TRUST = 'TRAVEL_RULE_TRUST',
  /** TRUSTED_SOURCES represents deposits automatically attributed using the address trusted sources */
  TRUSTED_SOURCES = 'TRUSTED_SOURCES',
  /** TRUSTED_SOURCES_CLIENT represents deposits automatically attributed using the client defined trusted sources */
  TRUSTED_SOURCES_CLIENT = 'TRUSTED_SOURCES_CLIENT',
  /** TRUSTED_SOURCES_STAFF represents deposits automatically attributed using the staff defined trusted sources */
  TRUSTED_SOURCES_STAFF = 'TRUSTED_SOURCES_STAFF'
}

/** DepositAttributionV2 represents the process of collecting information about the originator of a deposit */
export type DepositAttributionV2 = Node & {
  __typename: 'DepositAttributionV2';
  /** Asset class distinguishes between crypto or fiat */
  asset_class: DepositAttributionAssetClass;
  /** When the deposit was attributed */
  attributedAt: Maybe<Scalars['Time']['output']>;
  /** When the deposit attribution was last edited */
  attributionEditedAt: Maybe<Scalars['Time']['output']>;
  /** Status of the attribution */
  attributionStatus: DepositAttributionStatus;
  /** Type of the attribution done to this deposit */
  attributionType: Maybe<DepositAttributionType>;
  /** When this deposit attribution was created */
  createdAt: Scalars['Time']['output'];
  /** User that created the attribution (usually is automatic) */
  createdBy: Scalars['String']['output'];
  /** ID of the attribution */
  id: Scalars['ID']['output'];
  /** Smart contract address that originated this deposit */
  interactedWith: Maybe<Scalars['String']['output']>;
  /** Notes associated with the attribution */
  notes: Maybe<Scalars['String']['output']>;
  /** Operation/deposit associated with the attribution */
  operation: DepositEventOperation;
  /**
   * Collected information about the originator of the deposit
   * @deprecated Use originators instead
   */
  originator: Maybe<DepositAttributionOriginator>;
  /** Originators of this deposit attribution. One per each type applicable */
  originators: Maybe<Array<DepositAttributionOriginator>>;
  /** ID of the screening request associated with this deposit attribution, if any */
  screeningRequestID: Maybe<Scalars['String']['output']>;
  /** Status of the screening of the deposit attribution */
  screeningStatus: DepositAttributionScreeningStatus;
  /** Source addresses associated with the deposit */
  sourceAddresses: Maybe<Array<Scalars['String']['output']>>;
  /** When this deposit attribution was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** User that updated the attribution (if done manually) */
  updatedBy: Maybe<Scalars['String']['output']>;
  /** Type of wallet associated with the attribution */
  walletType: Maybe<DepositAttributionWalletType>;
};

/** DepositAttributionWalletType are the options for wallet types for deposit attributions */
export enum DepositAttributionWalletType {
  /** CUSTODIAL represents a wallet where the owner does not have complete control over the wallet as they do not have the private key, a third party does. */
  CUSTODIAL = 'CUSTODIAL',
  /** SELF_HOSTED represents a wallet where the owner has complete control over the wallet as they have the private key. */
  SELF_HOSTED = 'SELF_HOSTED',
  /** UNKNOWN represents an invalid wallet type */
  UNKNOWN = 'UNKNOWN'
}

/** Represents a deposit event */
export type DepositEventOperation = Operation & {
  __typename: 'DepositEventOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /**
   * amount is the total balance change that resulted from the deposit
   * @deprecated use amountDeposit and amountFee and don't try to add them together
   */
  amount: Amount;
  /** amountDeposit is the amount that was deposited */
  amountDeposit: Amount;
  /** same as amountDeposit but using historical pricing based on the end time of the operation */
  amountDepositAtEndTime: Amount;
  /** amountFee is the amount that was charged as a fee by the blockchain during the deposit */
  amountFee: Amount;
  /** same as amountFee but using historical pricing based on the end time of the operation */
  amountFeeAtEndTime: Amount;
  /** amountTotal is amountDeposit - amountFee and is set only if feeSharesAssetTypeWithAmount is true */
  amountTotal: Maybe<Amount>;
  /** same as amountTotal but using historical pricing based on the end time of the operation */
  amountTotalAtEndTime: Maybe<Amount>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** attribution is the deposit attribution record associated with a DepositEvent */
  attribution: Maybe<DepositAttributionV2>;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** confirmations returns how many confirmations the transaction associated with this deposit event has received */
  confirmations: Scalars['Int']['output'];
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** delegationAddress describes the address that sent a delegation reward (ie. for staking, baking, inflation pools, etc.) which should match the sending address */
  delegationAddress: Maybe<DelegationAddress>;
  /**
   * The deposit operation linked to this deposit event
   * @deprecated always null - deposits don't exist any more
   */
  deposit: Maybe<DepositOperation>;
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * feeSharesAssetTypeWithAmount is true if the fee and the amount withdrawn share
   * the same asset type. Returns false otherwise, or if the fee is not known.
   */
  feeSharesAssetTypeWithAmount: Scalars['Boolean']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** isChange returns true if the deposit event is a noop transfer to the owner of the same source address */
  isChange: Scalars['Boolean']['output'];
  /** isFromGasStation indicates a deposit came from the gas station and is meant for withdraw/transfer fees */
  isFromGasStation: Scalars['Boolean']['output'];
  /**
   * linkedExecuteOperation is the withdraw/transfer/etc operation that created this
   * DepositEvent, if one exists. The linked operation may or may not belong to the same organization.
   */
  linkedExecuteOperation: Maybe<Operation>;
  /** note is an optional comment providing additional context about the deposit (e.g. origin of funds for fiat interest deposits) */
  note: Maybe<Scalars['String']['output']>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * receivingAddress is the address on which a deposit is to be received
   * @deprecated use receivingBlockchainAddress
   */
  receivingAddress: Scalars['String']['output'];
  /** receivingBlockchainAddress is the address on which a deposit is to be received */
  receivingBlockchainAddress: BlockchainAddress;
  /** receivingProgramCustomerID is the program customer that owns the credited virtual account. Null when receivingVirtualAccountID is null or that virtual account has no program customer. */
  receivingProgramCustomerID: Maybe<Scalars['String']['output']>;
  /** receivingVirtualAccount resolves the display details of the credited virtual account (owner name, account last-4) from fiat. Null when receivingVirtualAccountID is null or the caller may not see the operation's organization. */
  receivingVirtualAccount: Maybe<VirtualAccount>;
  /** receivingVirtualAccountID is the virtual account this deposit credited. Null when the deposit was not attributed to one. */
  receivingVirtualAccountID: Maybe<Scalars['String']['output']>;
  /**
   * receivingWallet is the wallet that received the deposit, or null when the
   * wallet row no longer exists (e.g. a partially failed wallet creation)
   */
  receivingWallet: Maybe<Wallet>;
  /** riskAnalysis is the collected risk information for this deposit if we have any */
  riskAnalysis: Maybe<TransactionRiskAnalysis>;
  /**
   * sendingAddress is the addresses from which a deposit is sent
   * @deprecated use sendingBlockchainAddresses
   */
  sendingAddresses: Array<Scalars['String']['output']>;
  /**
   * sendingBlockchainAddresses is a list of addresses from which a deposit is sent
   * @deprecated use sendingBlockchainAddresses2
   */
  sendingBlockchainAddresses: Array<BlockchainAddress>;
  /** same as sendingBlockchainAddresses but with additional info if the sender is a settlement network participant */
  sendingBlockchainAddresses2: Array<BlockchainAddressWithParticipant>;
  /** sendingProgramCustomerID is the program customer that owns the sending virtual account. Null when sendingVirtualAccountID is null or that virtual account has no program customer. */
  sendingProgramCustomerID: Maybe<Scalars['String']['output']>;
  /** sendingVirtualAccount resolves the sending virtual account's display details from fiat. Null when sendingVirtualAccountID is null or the caller may not see the operation's organization. */
  sendingVirtualAccount: Maybe<VirtualAccount>;
  /** sendingVirtualAccountID is the virtual account that sent this deposit, set when the deposit is the credit side of an internal transfer from a virtual account. Null otherwise, and null when the sending wallet belongs to another organization (another organization's virtual account is that organization's data). */
  sendingVirtualAccountID: Maybe<Scalars['String']['output']>;
  /** sendingWallet is the wallet from which the deposit was sent */
  sendingWallet: Maybe<Wallet>;
  /** sendingWireData contains information about the sending wire transfer */
  sendingWireData: Maybe<WireData>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** tokenID is the non-fungible token id */
  tokenID: Maybe<Scalars['String']['output']>;
  /** transactionID is the blockchain transaction id */
  transactionID: Scalars['String']['output'];
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Scalars['String']['output'];
};


/** Represents a deposit event */
export type DepositEventOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** DepositID is the ID of a specific deposit to a vault and specified asset */
export type DepositID = {
  __typename: 'DepositID';
  /** assetSubID is used to differentiate between multiple assets of the same type within a vault */
  assetSubID: Scalars['String']['output'];
  /** assetTypeID is the type of asset being deposited */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Further information regarding this asset type */
  assetTypeInfo: AssetTypeInfo;
  /** depositSubID represents a unique identifier for this deposit */
  depositSubID: Scalars['String']['output'];
  /** organizationKeyID stores the organization that we're depositing to */
  organizationKeyID: Scalars['String']['output'];
  /** vaultID is the ID of the vault we are depositing to */
  vaultID: VaultID;
};

/** Fiat Deposit Instructions for a wallet */
export type DepositInstructions = {
  __typename: 'DepositInstructions';
  /**
   * Bank Address
   * @deprecated Use 'bankMailingAddress' instead
   */
  bankAddress: Array<Scalars['String']['output']>;
  /** Bank Mailing Address */
  bankMailingAddress: MailingAddress;
  /** Bank Name */
  bankName: Scalars['String']['output'];
  /** Bank Routing Number */
  bankRoutingNumber: Scalars['String']['output'];
  /**
   * Bank Swift Code
   * @deprecated Use 'bankSwiftCode2'
   */
  bankSwiftCode: Scalars['String']['output'];
  /** Bank Swift Code (may not be filled depending on the bank) */
  bankSwiftCode2: Maybe<Scalars['String']['output']>;
  /** Benificiary Account Number */
  beneficiaryAccountNumber: Scalars['String']['output'];
  /**
   * Benificiary Address
   * @deprecated Use 'beneficiaryMailingAddress' instead
   */
  beneficiaryAddress: Array<Scalars['String']['output']>;
  /** Benificiary Mailing Address */
  beneficiaryMailingAddress: MailingAddress;
  /** Benificiary Name */
  beneficiaryName: Scalars['String']['output'];
  /** Intermediary Mailing Address */
  intermediaryMailingAddress: Maybe<MailingAddress>;
  /** Intermediary Name */
  intermediaryName: Maybe<Scalars['String']['output']>;
  /** Intermediary SWIFT Code */
  intermediarySwiftCode: Maybe<Scalars['String']['output']>;
  /**
   * Memo field to idenitfy the wallet
   * @deprecated Use 'memoField2'
   */
  memoField: Scalars['String']['output'];
  /** Memo field to identify the wallet (may not be filled depending on the bank) */
  memoField2: Maybe<Scalars['String']['output']>;
  /**
   * URL to download a PDF of these deposit instructions. Null if the URL could not be built for
   * this caller (e.g. an unrecognized auth context) — this does not fail the rest of the response.
   */
  pdfDownloadURL: Maybe<Scalars['String']['output']>;
};

/** DepositOperation represents a deposit operation */
export type DepositOperation = Operation & {
  __typename: 'DepositOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** Deposit events that are linked to this deposit */
  depositEvents: OperationConnection;
  /** depositID defines the asset ID, vault ID, and sub ID for this deposit */
  depositID: DepositID;
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /**
   * receivingAddress is the address on which a deposit is to be received, populated by the blockchain service
   * @deprecated moving to signedAddress
   */
  receivingAddress: Maybe<Scalars['String']['output']>;
  /** receivingBlockchainAddress is the address on which a deposit is to be received */
  receivingBlockchainAddress: Maybe<BlockchainAddress>;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** signedAddress is the address signed by the organization key on which a deposit is to be received, populated by the blockchain service */
  signedAddress: Maybe<SignedAddress>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
};


/** DepositOperation represents a deposit operation */
export type DepositOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** DepositOperation represents a deposit operation */
export type DepositOperationdepositEventsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<OperationSortFields>;
};


/** DepositOperation represents a deposit operation */
export type DepositOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/**
 * DepositRewardType an Operation represents
 * Subset of DepositType in lib/operation/depositevent/operation.go
 * Only supports types stored on the operation in ExtraData
 * Operations contain reward types, see depositevent.IsRewardType()
 */
export enum DepositRewardType {
  /** ANCHORAGE_DELEGATION_REWARD is a delegation reward from an Anchorage validator */
  ANCHORAGE_DELEGATION_REWARD = 'ANCHORAGE_DELEGATION_REWARD',
  /** DELEGATION_REWARD is a delegation reward */
  DELEGATION_REWARD = 'DELEGATION_REWARD',
  /** FIAT_INTEREST is a fiat interest payment deposited into the account */
  FIAT_INTEREST = 'FIAT_INTEREST',
  /** MEV_REWARD is a staking reward coming from specific validators */
  MEV_REWARD = 'MEV_REWARD',
  /** NONE is a plain or non-reward deposit */
  NONE = 'NONE',
  /** NON_ANCHORAGE_STAKING_REWARD is a staking reward coming from a non-Anchorage validator (ETH staking) */
  NON_ANCHORAGE_STAKING_REWARD = 'NON_ANCHORAGE_STAKING_REWARD',
  /** PRIORITY_FEE_REWARD is a priority fee reward from the Jito tip distribution program */
  PRIORITY_FEE_REWARD = 'PRIORITY_FEE_REWARD',
  /** STAKING_REWARD is a staking reward */
  STAKING_REWARD = 'STAKING_REWARD'
}

/** Possible deposit screening statuses */
export enum DepositScreeningStatus {
  /** Completed screening */
  COMPLETED = 'COMPLETED',
  /** Screening in progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Waiting screening */
  WAITING = 'WAITING'
}

export enum DerivsBank {
  BNY = 'BNY',
  CB = 'CB'
}

export enum DerivsEntity {
  A1 = 'A1',
  ADSD = 'ADSD',
  HEDGECO = 'HEDGECO',
  LABS = 'LABS'
}

export type DerivsEntityBankAccount = {
  __typename: 'DerivsEntityBankAccount';
  /** The account number masked to "****" followed by its last 4 digits. */
  accountNumber: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  bank: DerivsBank;
  bankadapterAccountId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  entity: DerivsEntity;
  id: Scalars['ID']['output'];
  orgId: Scalars['String']['output'];
  partyAddress: DerivsPartyAddress;
  partyName: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Time']['output']>;
};

export type DerivsEntityBankAccountFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bank?: InputMaybe<DerivsBank>;
  entity?: InputMaybe<DerivsEntity>;
};

export type DerivsEntityBankAccountPayload = {
  __typename: 'DerivsEntityBankAccountPayload';
  entityBankAccount: DerivsEntityBankAccount;
};

export type DerivsEntityWallet = {
  __typename: 'DerivsEntityWallet';
  asset: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  entity: DerivsEntity;
  id: Scalars['ID']['output'];
  /** The custody OrganizationKeyID of the API key that owns the wallet. */
  orgId: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Time']['output']>;
  walletId: Scalars['String']['output'];
};

export type DerivsEntityWalletFilter = {
  asset?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<DerivsEntity>;
};

export type DerivsPartyAddress = {
  __typename: 'DerivsPartyAddress';
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2: Maybe<Scalars['String']['output']>;
  locality: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type DerivsPartyAddressInput = {
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  locality: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

export type DerivsTransfer = {
  __typename: 'DerivsTransfer';
  /** A decimal string. */
  amount: Scalars['String']['output'];
  asset: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  destination: DerivsEntity;
  errorMessage: Maybe<Scalars['String']['output']>;
  /** State changes, ordered by time. */
  events: Array<DerivsTransferEvent>;
  failedLeg: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** The trimmed settlement reference. A repeat with the same reference and details returns this transfer. */
  idempotencyKey: Scalars['String']['output'];
  initiatedBy: Scalars['String']['output'];
  /** Both legs, ordered by legNumber. */
  legs: Array<DerivsTransferLeg>;
  loanReference: Maybe<Scalars['String']['output']>;
  purpose: DerivsTransferPurpose;
  purposeOtherText: Maybe<Scalars['String']['output']>;
  settlementRef: Scalars['String']['output'];
  source: DerivsEntity;
  state: DerivsTransferState;
  timedOutStep: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type DerivsTransferConnection = {
  __typename: 'DerivsTransferConnection';
  edges: Array<DerivsTransferEdge>;
  /** totalResults is always null here, and hasPreviousPage is always false: the list pages forward only. */
  pageInfo: PageInfo;
};

export type DerivsTransferEdge = {
  __typename: 'DerivsTransferEdge';
  cursor: Scalars['String']['output'];
  node: DerivsTransfer;
};

export type DerivsTransferEvent = {
  __typename: 'DerivsTransferEvent';
  actor: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  details: Maybe<Scalars['String']['output']>;
  fromState: Maybe<Scalars['String']['output']>;
  legNumber: Maybe<Scalars['Int']['output']>;
  toState: Scalars['String']['output'];
};

export type DerivsTransferFilter = {
  asset?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['Time']['input']>;
  createdFrom?: InputMaybe<Scalars['Time']['input']>;
  destination?: InputMaybe<DerivsEntity>;
  purpose?: InputMaybe<DerivsTransferPurpose>;
  source?: InputMaybe<DerivsEntity>;
  state?: InputMaybe<DerivsTransferState>;
};

export type DerivsTransferLeg = {
  __typename: 'DerivsTransferLeg';
  blockchainTxId: Maybe<Scalars['String']['output']>;
  custodyErrorMessage: Maybe<Scalars['String']['output']>;
  custodyErrorType: Maybe<Scalars['String']['output']>;
  custodyStatus: Maybe<Scalars['String']['output']>;
  custodyTransferId: Maybe<Scalars['String']['output']>;
  endedAt: Maybe<Scalars['Time']['output']>;
  feeAsset: Maybe<Scalars['String']['output']>;
  feeQuantity: Maybe<Scalars['String']['output']>;
  from: DerivsEntity;
  fromWalletId: Scalars['String']['output'];
  legNumber: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['Time']['output']>;
  to: DerivsEntity;
  toWalletId: Scalars['String']['output'];
};

export enum DerivsTransferPurpose {
  IM_POST = 'IM_POST',
  IM_RETURN = 'IM_RETURN',
  LOAN = 'LOAN',
  OTHER = 'OTHER',
  REPAYMENT = 'REPAYMENT',
  SWEEP = 'SWEEP',
  VM = 'VM'
}

export enum DerivsTransferState {
  AWAITING_FUNDS_AVAILABLE = 'AWAITING_FUNDS_AVAILABLE',
  FAILED = 'FAILED',
  FUNDS_AVAILABLE = 'FUNDS_AVAILABLE',
  HOP1_COMPLETED = 'HOP1_COMPLETED',
  HOP1_FAILED = 'HOP1_FAILED',
  HOP1_IN_PROGRESS = 'HOP1_IN_PROGRESS',
  HOP1_QUEUED = 'HOP1_QUEUED',
  HOP2_COMPLETED = 'HOP2_COMPLETED',
  HOP2_FAILED = 'HOP2_FAILED',
  HOP2_IN_PROGRESS = 'HOP2_IN_PROGRESS',
  HOP2_QUEUED = 'HOP2_QUEUED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  TIMED_OUT = 'TIMED_OUT',
  VALIDATING = 'VALIDATING',
  VERIFYING_DESTINATION = 'VERIFYING_DESTINATION'
}

export type DerivsTrustedDestination = {
  __typename: 'DerivsTrustedDestination';
  accountLast4: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  asset: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  custodyTrustedDestinationId: Scalars['String']['output'];
  destinationEntity: DerivsEntity;
  id: Scalars['ID']['output'];
  ownerEntity: DerivsEntity;
  /** The custody OrganizationKeyID of the LABS wallet for the asset. */
  ownerOrgId: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Time']['output']>;
};

export type DerivsTrustedDestinationFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  asset?: InputMaybe<Scalars['String']['input']>;
  destinationEntity?: InputMaybe<DerivsEntity>;
};

export type DerivsTrustedDestinationPayload = {
  __typename: 'DerivsTrustedDestinationPayload';
  trustedDestination: DerivsTrustedDestination;
};

/** Destination identifies valid forms of destinations for a RoleAction */
export type Destination = {
  __typename: 'Destination';
  /** addresses indicates any specific addresses which are valid. An empty list does not indicate all addresses are valid. */
  addresses: Array<AMLBlockchainAddress>;
  /** anyAddress indicates any address is valid, similar to a wildcard. */
  anyAddress: Scalars['Boolean']['output'];
  /** anyDestination is the Any Destination scope granted to this action. Null means no grant. */
  anyDestination: Maybe<AnyDestinationScope>;
  /** anyTrustedDestination indicates transfers to any org trusted destination are allowed. */
  anyTrustedDestination: Scalars['Boolean']['output'];
  /** anyVault indicates any vault is valid, similar to a wildcard. */
  anyVault: Scalars['Boolean']['output'];
  /** anyWallet indicates any wallet is valid, similar to a wildcard. */
  anyWallet: Scalars['Boolean']['output'];
  /** trustedDestinationSubIDs indicates specific org trusted destinations (by sub ID) valid for this action. Fiat trusted destinations are referenced by sub ID rather than expanded into addresses. An empty list does not indicate all trusted destinations are valid. */
  trustedDestinationSubIDs: Maybe<Array<Scalars['String']['output']>>;
  /** vaultUniqueIDs indicates any allowed destination vault id. An empty list does not indicate all vaults are valid. */
  vaultUniqueIDs: Maybe<Array<Scalars['String']['output']>>;
  /**
   * vaults indicates any specific vaults which are valid. An empty list does not indicate all vaults are valid.
   * @deprecated does not work for vaults from other orgs, use vaultUniqueIDs instead
   */
  vaults: Array<Vault>;
  /** walletUniqueIDs indicates any allowed destination wallet id. An empty list does not indicate all wallets are valid. */
  walletUniqueIDs: Maybe<Array<Scalars['String']['output']>>;
  /**
   * wallets indicates any specific wallets which are valid. An empty list does not indicate all wallets are valid.
   * @deprecated does not work for wallets from other orgs, use walletUniqueIDs instead
   */
  wallets: Array<Wallet>;
};

/** DestinationID is the ID of a trusted destination */
export type DestinationID = {
  __typename: 'DestinationID';
  /** destinationSubID is the ID of the trusted destination within the organization */
  destinationSubID: Scalars['String']['output'];
  /** organizationKeyID is the ID of the organization this destination belongs to */
  organizationKeyID: Scalars['String']['output'];
};

/** Represents the status of a device considering the recent activity of the user */
export enum DeviceStatus {
  /** User has been using the app recently and can perform actions */
  ACTIVE = 'ACTIVE',
  /** User did not use the app for a while, and is at-risk of losing access */
  IDLE = 'IDLE',
  /**
   * User lost device or hasn't used app for a long time.
   * At this stage, user cannot perform any actions inside the organization
   */
  LOST = 'LOST'
}

/** Extra parameters for Diem */
export type DiemExtraParams = {
  __typename: 'DiemExtraParams';
  /** tradeID to use in transactions for Designated Dealer withdrawals */
  tradeID: Maybe<Scalars['String']['output']>;
};

/** DisableVaultOperation represents an operation where a vault is disabled */
export type DisableVaultOperation = Operation & {
  __typename: 'DisableVaultOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** iamChanges represents the JSON encoded IAM changes that will be applied with this operation. */
  iamChanges: Maybe<Scalars['OperationIAMChanges']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy required in order to satisfy this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** roleChanges represents the IAM role changes that will be applied with this operation. */
  roleChanges: Maybe<IAMRoleChanges>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * Policies being updated by this operation
   * @deprecated use vaultPolicyContainerUpdate
   */
  updatedPolicies: Array<VaultPolicyUpdate>;
  /** The vault being disabled */
  vault: Vault;
  /**
   * vaultPolicyContainerUpdate represents the binding changes that will be applied
   * to the vault policy container
   */
  vaultPolicyContainerUpdate: Maybe<VaultPolicyContainerUpdate>;
};


/** DisableVaultOperation represents an operation where a vault is disabled */
export type DisableVaultOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** DisableVaultOperation represents an operation where a vault is disabled */
export type DisableVaultOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/**
 * Disclosure represents a disclosure document, recently renamed to legal terms.
 *
 * Results are sorted alphabetically ascending by the human readable title field.
 * The list of disclosures in the UI code can trust that the response is sorted.
 *
 * Furthermore, each disclosure contains info relevant to the user who requested it
 */
export type Disclosure = {
  __typename: 'Disclosure';
  /**
   * disclosureID is the internal key to identify a document (and all its versions)
   * This is not to be user facing.
   *
   * The reason this is a disclosureID and not a documentID is that once a
   * disclosureID has been used, all future versions MUST use the same disclosureID
   * even if the human facing title changes.
   */
  disclosureID: Scalars['String']['output'];
  /**
   * involvesAccount a convenience field which indicates whether the disclosure
   * must be accepted for each account a user is involved with.
   *
   * If true, the disclosure must be accepted per (user, account) disclosure,
   * meaning the user is accepting a disclosure in "relation" to an organization.
   * There will be one or more rows in legalterms_acceptances
   *
   * If false, the disclosure must be accepted per user, and there will only be one
   * row in legalterms_acceptances
   *
   * NOTE: All disclosure acceptances involve a user. An acceptance that involves an
   * account is on "behalf" of an account (as in, other users of that account will not
   * have to independently accept the disclosure).
   */
  involvesAccount: Scalars['Boolean']['output'];
  /** latest indicates whether the disclosure is the latest version */
  latest: Scalars['Boolean']['output'];
  /** markdownContent is the document formatted in markdown */
  markdownContent: Scalars['String']['output'];
  /**
   * A list of reviews (both accepted and not-yet-accepted).
   * See DisclosureReview for more information.
   */
  reviews: Array<DisclosureReview>;
  /**
   * tag represents a type of action that would require this disclosure. For example,
   * a hypothetical action could be "trade", and there may be multiple types of
   * disclosures for trading. This abstraction allows us to have multiple
   * disclosures per action. This also gives us the flexibility to disable a
   * disclosure in the backend by creating a new latest document with a tag value
   * of "deprecated".
   */
  tag: Scalars['String']['output'];
  /** title is the human readable title */
  title: Scalars['String']['output'];
  /**
   * version is the sequential version number of the document, starting from 1.
   * Version numbers are monotonically increasing over time and NEVER skipped.
   * This is an integer because we won't ever run into overflow issues, and
   * expecting an integer as part of the acceptDisclosure() mutation removes the
   * issue of parsing an integer
   */
  version: Scalars['Int']['output'];
};

/**
 * A disclosure contains a list of reviews, both accepted and not-yet-accepted.
 * Unaccepted reviews are useful when prompting the user and showing a list of
 * accounts they are accepting for.
 * Accepted reviews are useful when the user wants to see what documents they
 * have agreed to.
 */
export type DisclosureReview = {
  __typename: 'DisclosureReview';
  /**
   * acceptedAt is the seconds unix timestamp at which the acceptance was received
   * by the backend. It is null if not accepted
   */
  acceptedAt: Maybe<Scalars['String']['output']>;
  /**
   * If disclosure.involvesAccount == false => accountID is null
   * If disclosure.involvesAccount == true => accountID contains a value and
   * there is a DisclosureReview for each account
   */
  accountID: Maybe<Scalars['String']['output']>;
  /**
   * The human readable name of the account. Useful for showing the user which
   * account they are accepting in relation to.
   *
   * This field exists if accountID exists (which only exists if InvolvesAccount is
   * true).
   */
  accountName: Maybe<Scalars['String']['output']>;
};

/**
 * One column of a report type's backing BigQuery view, as of the last time the view
 * was read. Type spellings are standard SQL (INT64, not INTEGER) and the mode is
 * NULLABLE, REQUIRED or REPEATED.
 */
export type DiscoveredSchemaColumn = {
  __typename: 'DiscoveredSchemaColumn';
  mode: Scalars['String']['output'];
  /**
   * Physical column name in the view. This is what a header's or filter's
   * sourceColumn must match.
   */
  name: Scalars['String']['output'];
  /**
   * Standard-SQL column type. An automatic cast resolves against this, so it is
   * what makes a schema refresh change generated SQL.
   */
  type: Scalars['String']['output'];
};

/** Input for dispatching an account transfer. */
export type DispatchTransferInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  step: Scalars['String']['input'];
  transferId: Scalars['String']['input'];
};

/** Result of a dispatchTransfer mutation. Dispatch runs asynchronously; poll transfer status for the outcome. */
export type DispatchTransferResult = {
  __typename: 'DispatchTransferResult';
  /** True if the dispatch was accepted and the workflow started. */
  accepted: Scalars['Boolean']['output'];
  /** Human-readable message describing why the dispatch was rejected, if accepted is false. */
  message: Maybe<Scalars['String']['output']>;
  /** The ID of the transfer. */
  transferId: Scalars['String']['output'];
};

export type DisputeACHDebitOutInput = {
  /**
   * The client's confirmation that they are authorized to submit this dispute on behalf of their
   * Company and that the corporate affidavit's statements are true and accurate. Must be true.
   */
  attestation: Scalars['Boolean']['input'];
  /** The ach.DebitOut operation id being disputed. */
  operationID: Scalars['String']['input'];
  /** Optional free-text note on why the debit is being disputed. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * returnOperationID and submissionTime let the frontend render the dispute receipt without a
 * refetch.
 */
export type DisputeACHDebitOutResult = {
  __typename: 'DisputeACHDebitOutResult';
  returnOperationID: Scalars['String']['output'];
  submissionTime: Scalars['Timestamp']['output'];
};

/** Distress signal information */
export type Distress = {
  __typename: 'Distress';
  /** Raw distress signal value */
  distressSignal: Scalars['Int']['output'];
  /** Indicates whether this meets the distress threshold */
  isDistress: Scalars['Boolean']['output'];
};

/** A DocuSign workflow configuration entry. */
export type DocuSignWorkflow = {
  __typename: 'DocuSignWorkflow';
  createdAt: Scalars['Time']['output'];
  custodianId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  workflowId: Scalars['String']['output'];
};

/** Paginated list of DocuSign workflows. */
export type DocuSignWorkflowConnection = {
  __typename: 'DocuSignWorkflowConnection';
  /** A list of edges. */
  edges: Maybe<Array<DocuSignWorkflowEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A DocuSign workflow edge in a connection. */
export type DocuSignWorkflowEdge = {
  __typename: 'DocuSignWorkflowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<DocuSignWorkflow>;
};

/** Represents an Document Delivery contact setting */
export type DocumentDeliveryContact = {
  /** Refers to the email of the contact */
  email: Scalars['String']['input'];
  /** Refers to the name of the contact */
  name: Scalars['String']['input'];
};

export type DocumentDeliverySetting = {
  __typename: 'DocumentDeliverySetting';
  /** Refers to the email of the contact */
  email: Scalars['String']['output'];
  /** Refers to the name of the contact */
  name: Scalars['String']['output'];
};

export type DocumentDeliverySettingConnection = {
  __typename: 'DocumentDeliverySettingConnection';
  edges: Array<DocumentDeliverySettingEdge>;
  pageInfo: PageInfo;
};

export type DocumentDeliverySettingEdge = {
  __typename: 'DocumentDeliverySettingEdge';
  cursor: Scalars['CursorType']['output'];
  node: DocumentDeliverySetting;
};

export type DocumentDeliverySettingFilter = {
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  settingType: SettingType;
};

/** Ordering options for DocumentDeliverySetting connections */
export type DocumentDeliverySettingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DocumentDeliverySettings. */
  field: DocumentDeliverySettingOrderField;
};

/** Properties by which DocumentDeliverySetting connections can be ordered. */
export enum DocumentDeliverySettingOrderField {
  /** order by email */
  EMAIL = 'EMAIL',
  /** order by name */
  NAME = 'NAME'
}

/** A Signed Docusign which represents a withdrawal authorization from a Program Customer */
export type DocusignSignedDocument = {
  __typename: 'DocusignSignedDocument';
  /** file represents the signed docusign file */
  file: Scalars['String']['output'];
};

/** DurationInputStep allows the user to input a duration value. */
export type DurationInputStep = StakingStep & {
  __typename: 'DurationInputStep';
  /** DefaultValue is the initial value this input will have. */
  defaultValue: Maybe<Scalars['String']['output']>;
  /** Editable should disable the input if false. */
  editable: Scalars['Boolean']['output'];
  /**
   * Used to instruct the UI the name of the field that should be used to store the user's input for this step.
   * This value must be provided on all input steps when using PrepareGenericOperation
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /**
   * The hint shown under the input field. When set, the UI shows it instead of
   * deriving an end date from the value.
   */
  hint: Maybe<Scalars['String']['output']>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Allows the backend to provide info banners to be shown above the step */
  infoItems: Maybe<Array<InfoItem>>;
  /** The label shown on the UI next to the input field. */
  label: Scalars['String']['output'];
  /** MaxValue is the maximum value the user should be allowed to enter. */
  maxValue: Maybe<Scalars['String']['output']>;
  /** MinValue is the minimum value the user should be allowed to enter. */
  minValue: Maybe<Scalars['String']['output']>;
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
  /** The unit of the duration (DAYS or BLOCKS). */
  unit: DurationUnit;
};

/** DurationUnit represents the unit of a duration input. */
export enum DurationUnit {
  BLOCKS = 'BLOCKS',
  DAYS = 'DAYS'
}

/**
 * otcderivativesreporting.client_emails - the review queue that holds
 * statement emails and margin call notices until a reviewer approves or
 * rejects them.
 */
export type DvClientEmail = {
  __typename: 'DvClientEmail';
  accountId: Maybe<Scalars['ID']['output']>;
  /** Set only on a MARGIN_CALL email. */
  asOfDate: Maybe<Scalars['Date']['output']>;
  attachments: Array<DvClientEmailAttachment>;
  bccList: Array<Scalars['String']['output']>;
  body: Maybe<Scalars['String']['output']>;
  ccList: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** Set only on a MARGIN_CALL email. */
  csaId: Maybe<Scalars['ID']['output']>;
  emailType: DvClientEmailType;
  id: Scalars['ID']['output'];
  /** Set only on a MARGIN_CALL email. */
  marginRunId: Maybe<Scalars['ID']['output']>;
  recipients: Array<Scalars['String']['output']>;
  /**
   * Shared with the otcderivativesreporting.statements rows this email's
   * attachments are drawn from.
   */
  requestId: Scalars['ID']['output'];
  status: DvClientEmailStatus;
  subject: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** One attachment on a DvClientEmail - one per generated statement file. */
export type DvClientEmailAttachment = {
  __typename: 'DvClientEmailAttachment';
  fileFormat: DvStatementFileFormat;
  fileType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DvClientEmailConnection = {
  __typename: 'DvClientEmailConnection';
  /** The edges of the connection */
  edges: Array<DvClientEmailEdge>;
  /**
   * Information to aid in pagination. totalResults is always null here - it
   * isn't computed, since doing so would cost a second full-table scan on
   * every page fetch.
   */
  pageInfo: PageInfo;
};

export type DvClientEmailEdge = {
  __typename: 'DvClientEmailEdge';
  /** Cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The client email at the end of the edge */
  node: DvClientEmail;
};

/**
 * Filters for dvClientEmail. Every field is optional and independent - only
 * the ones set narrow the results (an omitted filter, or one with every
 * field unset, returns every row).
 */
export type DvClientEmailFilter = {
  /** Returns edges after this cursor. Use with first for forward pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
  /** Returns edges before this cursor. Use with last for backward pagination. */
  before?: InputMaybe<Scalars['String']['input']>;
  emailType?: InputMaybe<DvClientEmailType>;
  /** How many edges to return after `after`. Defaults to 1000, capped at 1000. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** How many edges to return before `before`. Defaults to 1000, capped at 1000. */
  last?: InputMaybe<Scalars['Int']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
  /** Keeps rows whose status is any of these. Empty or omitted does not filter. */
  statuses?: InputMaybe<Array<DvClientEmailStatus>>;
};

export enum DvClientEmailStatus {
  APPROVED = 'APPROVED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REJECTED = 'REJECTED',
  /** A later margin run replaced this pending margin call. */
  SUPERSEDED = 'SUPERSEDED'
}

export enum DvClientEmailType {
  DAILY_SUMMARY_STATEMENT = 'DAILY_SUMMARY_STATEMENT',
  MARGIN_CALL = 'MARGIN_CALL'
}

/**
 * A small file returned inline as base64-encoded content, for synchronous
 * downloads - as opposed to DvStatement's async gcsUri, only filled in once
 * Temporal generation completes.
 */
export type DvFilePayload = {
  __typename: 'DvFilePayload';
  /** The content of this file, base64 encoded */
  content: Scalars['String']['output'];
  /** The name of this file */
  filename: Scalars['String']['output'];
  /** The MIME type of the file */
  mimeType: Scalars['String']['output'];
};

export type DvGenerateMarginCallNoticesPayload = {
  __typename: 'DvGenerateMarginCallNoticesPayload';
  workflowId: Scalars['String']['output'];
};

/**
 * Filters for dvGetStatements. Every field is optional and independent -
 * only the ones set narrow the results.
 */
export type DvGetStatementsInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Returns edges after this cursor. Use with first for forward pagination. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Returns edges before this cursor. Use with last for backward pagination. */
  before?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<DvStatementFileType>;
  /** How many edges to return after `after`. Defaults to 1000, capped at 1000. */
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** How many edges to return before `before`. Defaults to 1000, capped at 1000. */
  last?: InputMaybe<Scalars['Int']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
  statementType?: InputMaybe<DvStatementType>;
  status?: InputMaybe<DvStatementStatus>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type DvImHaircut = {
  __typename: 'DvImHaircut';
  asset: Scalars['String']['output'];
  /** A fraction in [0,1), a decimal string like percentiles. */
  haircut: Scalars['String']['output'];
};

export type DvImHaircutInput = {
  asset: Scalars['String']['input'];
  /** A fraction in [0,1), a decimal string. */
  haircut: Scalars['String']['input'];
};

/**
 * otcderivativesreporting.part45_submissions - one row per attempt at a daily
 * valuation or collateral report submitted to ICE for Part 45 EOD reporting.
 */
export type DvPart45Submission = {
  __typename: 'DvPart45Submission';
  asOfDate: Scalars['Date']['output'];
  /**
   * Starts at 1 for each submissionType, asOfDate and company, and goes up by
   * one with each dvRegeneratePart45Report call.
   */
  attempt: Scalars['Int']['output'];
  companyBatchId: Scalars['String']['output'];
  companyLei: Scalars['String']['output'];
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /**
   * The GCS folder holding the submission's report files (one per format,
   * or report.xml for submissions created before both formats were stored)
   * and input data. Set once they have been uploaded.
   */
  gcsUri: Maybe<Scalars['String']['output']>;
  /** ICE's own internal reference for the submission. */
  iceGatewaySubmissionId: Maybe<Scalars['String']['output']>;
  /** Set once ICE has accepted the submission. */
  iceSubmissionId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastPolledAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * The raw jsonb metadata this submission carries - trade_count,
   * temporal_workflow_id, and other debug context. Always present, "{}" at
   * minimum.
   */
  metadata: Scalars['String']['output'];
  /** Set when status is REJECTED or HOLD. */
  rejectReason: Maybe<Scalars['String']['output']>;
  /** Format of the active report file (CFTC or TVNA); null for submissions created before both formats were stored. */
  reportFormat: Maybe<Scalars['String']['output']>;
  status: DvPart45SubmissionStatus;
  submissionType: DvPart45SubmissionType;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type DvPart45SubmissionConnection = {
  __typename: 'DvPart45SubmissionConnection';
  /** The edges of the connection */
  edges: Array<DvPart45SubmissionEdge>;
  /**
   * Information to aid in pagination. totalResults is always null here - it
   * isn't computed, since doing so would cost a second full-table scan on
   * every page fetch.
   */
  pageInfo: PageInfo;
};

export type DvPart45SubmissionEdge = {
  __typename: 'DvPart45SubmissionEdge';
  /** Cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The submission at the end of the edge */
  node: DvPart45Submission;
};

/**
 * Filters for dvPart45Submissions. Every field is optional and independent -
 * only the ones set narrow the results (an omitted filter, or one with every
 * field unset, returns every row).
 */
export type DvPart45SubmissionFilter = {
  asOfDateEnd?: InputMaybe<Scalars['Date']['input']>;
  asOfDateStart?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<DvPart45SubmissionStatus>;
  submissionType?: InputMaybe<DvPart45SubmissionType>;
};

export enum DvPart45SubmissionStatus {
  FAILED = 'FAILED',
  HOLD = 'HOLD',
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED',
  SKIPPED = 'SKIPPED'
}

export enum DvPart45SubmissionType {
  COLLATERAL = 'COLLATERAL',
  VALUATION = 'VALUATION'
}

/** The row level a PFE file holds. */
export enum DvPfeGrain {
  /**
   * One row per counterparty and percentile, with the pooled collateral and the
   * CSA terms.
   */
  COUNTERPARTY = 'COUNTERPARTY',
  /** One row per netting set and percentile. */
  NETTING_SET = 'NETTING_SET'
}

/**
 * One potential-future-exposure run, priced off the positions of the day's
 * margin run.
 */
export type DvPfeRun = {
  __typename: 'DvPfeRun';
  asOfDate: Scalars['Date']['output'];
  /** Null while the run is still pending. */
  completedAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * Every netting set that failed, joined. Null on a run that priced
   * everything.
   */
  errorMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  origin: DvVarRunOrigin;
  /** The governed parameter set the run used. */
  parameterVersion: Scalars['String']['output'];
  parameterisation: Scalars['String']['output'];
  /** The spot snapshot the run priced off - the window's end. */
  spotSnapshotAt: Scalars['DateTime']['output'];
  /**
   * A netting set's h-day series fell short of the length its parameters call
   * for, so the run priced off a shorter history.
   */
  stale: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: DvVarRunStatus;
  /**
   * One summary per percentile the run priced. Empty on a run that priced
   * nothing.
   */
  summaries: Array<DvPfeRunSummary>;
  timeStep: Scalars['String']['output'];
  windowEnd: Scalars['DateTime']['output'];
  /** The historical return window, ending at the day's valuation instant. */
  windowStart: Scalars['DateTime']['output'];
};

/** Filters for dvPfeRuns. Every field is optional and independent. */
export type DvPfeRunFilter = {
  /** Runs priced on or after this date. */
  asOfFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Runs priced on or before this date. */
  asOfTo?: InputMaybe<Scalars['Date']['input']>;
  /** How many runs to return, newest first. Defaults to 90, capped at 365. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Read exactly these runs. */
  runIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Keep only these statuses. Omit for every status. */
  statuses?: InputMaybe<Array<DvVarRunStatus>>;
};

/**
 * The figures over the counterparties holding a net row at one percentile.
 * Never floors, never sums a counterparty's own netting sets, never pools or
 * nets collateral - each of those figures is read off the counterparty rows
 * as stored.
 */
export type DvPfeRunSummary = {
  __typename: 'DvPfeRunSummary';
  /**
   * Booked IM held plus reg IM held, USD, never VM. Summed over the
   * counterparties.
   */
  collateral: Scalars['String']['output'];
  counterpartyCount: Scalars['Int']['output'];
  /**
   * The historical cross-check: today's dollar delta on overlapping h-day sums
   * of the daily returns, upper tail at the percentile, floored at 0. Summed
   * over the counterparties' netting sets - null unless every one of them
   * carries a figure.
   */
  deltaNormalGross: Maybe<Scalars['String']['output']>;
  /** The minimum over the counterparties' netting sets. */
  nTailEff: Scalars['Int']['output'];
  /** Summed over the counterparties. */
  nettingSetCount: Scalars['Int']['output'];
  /** Summed over the counterparties. */
  outOfScopeCount: Scalars['Int']['output'];
  /** A fraction in (0,1) - the governed level is 0.99. */
  percentile: Scalars['String']['output'];
  /** Summed over the counterparties' own pfeGross. */
  pfeGross: Scalars['String']['output'];
  /** Summed over the counterparties. */
  pfeNet: Scalars['String']['output'];
};

export type DvRegeneratePart45ReportPayload = {
  __typename: 'DvRegeneratePart45ReportPayload';
  /** The id of the part45_submissions row the workflow creates. */
  submissionId: Scalars['ID']['output'];
  workflowId: Scalars['String']['output'];
};

export enum DvRiskModel {
  PFE = 'PFE',
  VAR = 'VAR'
}

/**
 * A single generated file. A dvCreateStatement call may produce several of
 * these (e.g. DAILY_SUMMARY fans out into a PDF and a CSV row) sharing one
 * requestId.
 */
export type DvStatement = {
  __typename: 'DvStatement';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileFormat: DvStatementFileFormat;
  fileType: DvStatementFileType;
  /**
   * The raw jsonb filter this statement was generated with - whatever
   * distinguishes it within its (account, statement type, version) group,
   * e.g. {"coverageStart":"...","coverageEnd":"..."}. Always present, "{}" at
   * minimum.
   */
  filter: Scalars['String']['output'];
  /** Set only once status is COMPLETE. */
  gcsUri: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Shared by every statement produced by the same dvCreateStatement call. */
  requestId: Scalars['ID']['output'];
  statementType: DvStatementType;
  status: DvStatementStatus;
  version: Scalars['Int']['output'];
};

export type DvStatementConnection = {
  __typename: 'DvStatementConnection';
  /** The edges of the connection */
  edges: Array<DvStatementEdge>;
  /**
   * Information to aid in pagination. totalResults is always null here - it
   * isn't computed, since doing so would cost a second full-table scan on
   * every page fetch.
   */
  pageInfo: PageInfo;
};

export type DvStatementEdge = {
  __typename: 'DvStatementEdge';
  /** Cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The statement at the end of the edge */
  node: DvStatement;
};

export enum DvStatementFileFormat {
  CSV = 'CSV',
  PDF = 'PDF'
}

/** Whether one file of one statement type is generated for one account. */
export type DvStatementFileSetting = {
  __typename: 'DvStatementFileSetting';
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  fileType: DvStatementFileType;
  id: Scalars['ID']['output'];
  statementType: DvStatementType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export enum DvStatementFileType {
  DAILY_SUMMARY_OPEN_POSITIONS_CSV = 'DAILY_SUMMARY_OPEN_POSITIONS_CSV',
  DAILY_SUMMARY_OPEN_TRADES_CSV = 'DAILY_SUMMARY_OPEN_TRADES_CSV',
  DAILY_SUMMARY_PDF = 'DAILY_SUMMARY_PDF'
}

export enum DvStatementStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export enum DvStatementType {
  DAILY_SUMMARY = 'DAILY_SUMMARY'
}

/** One line of a run's report. A structured field is null when the job left its column empty. */
export type DvTradeReconLine = {
  __typename: 'DvTradeReconLine';
  /** Underlying asset. */
  asset: Maybe<Scalars['String']['output']>;
  /** Counterparty of the line's trade or confirm. */
  counterparty: Maybe<Scalars['String']['output']>;
  /** Expiry date. */
  expiry: Maybe<Scalars['Date']['output']>;
  /** What the line is about. */
  kind: Maybe<DvTradeReconLineKind>;
  /** Option type. */
  optionType: Maybe<Scalars['String']['output']>;
  /** Order within the report. */
  position: Scalars['Int']['output'];
  /** Premium, counted in premiumCurrency. */
  premium: Maybe<Scalars['Float']['output']>;
  /** Currency the premium is counted in. */
  premiumCurrency: Maybe<Scalars['String']['output']>;
  /** Booked product. */
  product: Maybe<Scalars['String']['output']>;
  /** Quantity. */
  quantity: Maybe<Scalars['Float']['output']>;
  /** The report section the line sits in. */
  section: Scalars['String']['output'];
  /** Trade side. */
  side: Maybe<Scalars['String']['output']>;
  /** Where the line's confirm came from. */
  source: Maybe<Scalars['String']['output']>;
  /** Spot reference. */
  spotRef: Maybe<Scalars['Float']['output']>;
  /** The line's status. */
  status: DvTradeReconLineStatus;
  /** Strike. */
  strike: Maybe<Scalars['Float']['output']>;
  /** The line as the report prints it. */
  text: Scalars['String']['output'];
  /** Internal id of the booked trade the line is about. */
  tradeId: Maybe<Scalars['ID']['output']>;
};

/** What a report line is about. */
export enum DvTradeReconLineKind {
  /** A booked closeout. */
  CLOSEOUT = 'CLOSEOUT',
  /** A trade confirm. */
  CONFIRM = 'CONFIRM',
  /** A closeout and a new trade that one confirm covers together. */
  CROSS = 'CROSS',
  /** A booked trade. */
  TRADE = 'TRADE'
}

/** A report line's status. */
export enum DvTradeReconLineStatus {
  /** Marked as a break. */
  BREAK = 'BREAK',
  /** Any other line. */
  INFO = 'INFO',
  /** Marked as matching. */
  OK = 'OK',
  /** Marked as a warning. */
  WARN = 'WARN'
}

/** One run of the daily trade recon. */
export type DvTradeReconRun = {
  __typename: 'DvTradeReconRun';
  /** Lines with status BREAK. */
  breakCount: Scalars['Int']['output'];
  /** When the run wrote its report. */
  createdAt: Scalars['DateTime']['output'];
  /** The Dagster run id. */
  id: Scalars['ID']['output'];
  /** How many lines the report holds. */
  lineCount: Scalars['Int']['output'];
  /** Lines with status OK in the trade and closeout reconciliation sections. */
  matchedCount: Scalars['Int']['output'];
  /** The New York date the run reported on. */
  reconDate: Scalars['Date']['output'];
  /** Lines with status WARN. */
  warnCount: Scalars['Int']['output'];
  /** End of the window the run reconciled. */
  windowEnd: Scalars['DateTime']['output'];
  /** Start of the window the run reconciled. */
  windowStart: Scalars['DateTime']['output'];
};

/** Narrows dvTradeReconRuns. */
export type DvTradeReconRunFilter = {
  /** How many runs to return, newest first. Zero, negative or absent means 30; capped at 365. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Runs whose recon date is on or after this date. Defaults to 365 days before reconTo. */
  reconFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Runs whose recon date is on or before this date. Defaults to today in UTC. */
  reconTo?: InputMaybe<Scalars['Date']['input']>;
  /** Only these runs, still within the recon date range. An empty list matches no run. */
  runIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum DvVarOptionSide {
  CALL = 'CALL',
  PUT = 'PUT'
}

export enum DvVarParameterStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

/** One governed parameter set. Changing a value is a new version, never an edit. */
export type DvVarParameters = {
  __typename: 'DvVarParameters';
  /** The set is the model's code default, used when no usable active set can be resolved. */
  codeDefault: Scalars['Boolean']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Taken from the version's first row. Null on the code default. */
  createdBy: Maybe<Scalars['String']['output']>;
  deactivatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Null while the version is ACTIVE, and on the code default. */
  deactivatedBy: Maybe<Scalars['String']['output']>;
  /**
   * The cut taken on IM collateral per asset, ordered by asset. Empty on a VAR
   * set and on a PFE version stored before the haircuts were governed.
   */
  imHaircuts: Array<DvImHaircut>;
  lookbackSteps: Scalars['Int']['output'];
  minObservations: Scalars['Int']['output'];
  model: DvRiskModel;
  /** The asset pairs in scope, as BASE/TERM. */
  pairs: Array<Scalars['String']['output']>;
  parameterisation: Scalars['String']['output'];
  /**
   * Confidence levels as fractions in (0,1), decimal strings like
   * RunDvVarInput.percentiles.
   */
  percentiles: Array<Scalars['String']['output']>;
  pnlAsset: Scalars['String']['output'];
  returnKind: Scalars['String']['output'];
  /** Null on the code default, which no version row backs. */
  status: Maybe<DvVarParameterStatus>;
  timeStep: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/**
 * One confidence level off a target's distribution. Point and cumulative are
 * both "the 99% VaR" of the same simulation. On a Haruko row both are cut from
 * Haruko's p&l rescaled per leg: point is the order statistic, cumulative the
 * sum of the tail through it.
 */
export type DvVarPercentile = {
  __typename: 'DvVarPercentile';
  cumulative: Maybe<Scalars['String']['output']>;
  /**
   * The backup's loss minus the Haruko loss at the same target and percentile.
   * Null on a Haruko percentile, and on a backup percentile the Haruko leg has
   * no figure for.
   */
  divergence: Maybe<Scalars['String']['output']>;
  /** The divergence expressed as a fraction of the Haruko loss. */
  divergenceRatio: Maybe<Scalars['String']['output']>;
  /** A fraction in (0,1) - the governed level is 0.99. */
  percentile: Scalars['String']['output'];
  point: Maybe<Scalars['String']['output']>;
};

/** The moments of the simulated p&l distribution the percentiles are cut from. */
export type DvVarPnLMoments = {
  __typename: 'DvVarPnLMoments';
  dispersion: Scalars['String']['output'];
  max: Scalars['String']['output'];
  mean: Scalars['String']['output'];
  min: Scalars['String']['output'];
  stdDev: Scalars['String']['output'];
};

export enum DvVarPositionType {
  FUTURE = 'FUTURE',
  VANILLA = 'VANILLA'
}

/** What one portfolio target of a run priced. */
export type DvVarResult = {
  __typename: 'DvVarResult';
  /** Set on an ENTITY, HEDGECO or CUSTOM result - the entity the run scoped to. */
  entityId: Maybe<Scalars['ID']['output']>;
  /**
   * Haruko's own handle for the calculation, for tying this row back to their
   * record.
   */
  harukoRequestId: Maybe<Scalars['ID']['output']>;
  harukoVenueId: Maybe<Scalars['ID']['output']>;
  percentiles: Array<DvVarPercentile>;
  /** Null on a target that never priced. */
  pnlMoments: Maybe<DvVarPnLMoments>;
  /** The value of the priced portfolio. Null when Haruko returned no valuation. */
  portfolioValue: Maybe<Scalars['String']['output']>;
  /**
   * On a backup result, the positions that carried a delta, so it can sit below
   * the Haruko leg's count.
   */
  positionCount: Scalars['Int']['output'];
  scope: DvVarScope;
};

/**
 * One historical-simulation run, priced off the positions of the day's margin
 * run. Its figures are cut from Haruko's p&l rescaled per leg to the book's
 * value at the valuation instant.
 */
export type DvVarRun = {
  __typename: 'DvVarRun';
  /**
   * The accounts the Haruko venue filter resolved to. Membership is itself a
   * governed parameter, so this is the evidence of what the run priced.
   */
  accountFilterIds: Array<Scalars['ID']['output']>;
  asOfDate: Scalars['Date']['output'];
  /**
   * The backup figure beside the Haruko results: today's dollar delta on each of
   * the last 500 daily returns, the 6th worst at 99%. It has the same targets,
   * and older runs carry their delta-normal rows here. Empty when the backup was
   * refused or failed, and on a subset run, which the backup skips.
   */
  backup: Array<DvVarResult>;
  /** Null while the run is still pending. */
  completedAt: Maybe<Scalars['DateTime']['output']>;
  /** Every leg that failed, joined. Null on a run that priced everything. */
  errorMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The lookback the percentiles were cut over, in time steps. A backtest widens
   * the window past the lookback, so this reads the backtest rows when the run
   * has them and the window length otherwise. Null when timeStep is not a whole
   * number of days.
   */
  lookbackSteps: Maybe<Scalars['Int']['output']>;
  origin: DvVarRunOrigin;
  /**
   * The governed parameter set the run used. An +override suffix means a leg
   * was swept with parameters outside it.
   */
  parameterVersion: Scalars['String']['output'];
  parameterisation: Scalars['String']['output'];
  /** The asset the p&l is expressed in. */
  pnlAsset: Scalars['String']['output'];
  /**
   * One result per target the run priced - the client-facing leg and the whole
   * book. Empty on a run that priced nothing.
   */
  results: Array<DvVarResult>;
  /**
   * The run priced off stale market data: a calibration was more than 24h old
   * at the valuation instant or could not be read, or the p&l series stops
   * short of the window end.
   */
  stale: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: DvVarRunStatus;
  timeStep: Scalars['String']['output'];
  windowEnd: Scalars['DateTime']['output'];
  /** The historical return window, ending at the day's valuation instant. */
  windowStart: Scalars['DateTime']['output'];
};

/** Filters for dvVarRuns. Every field is optional and independent. */
export type DvVarRunFilter = {
  /** Runs priced on or after this date. */
  asOfFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Runs priced on or before this date. */
  asOfTo?: InputMaybe<Scalars['Date']['input']>;
  /** How many runs to return, newest first. Defaults to 90, capped at 365. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Keep only these statuses. Omit for every status. */
  statuses?: InputMaybe<Array<DvVarRunStatus>>;
};

export enum DvVarRunOrigin {
  MANUAL = 'MANUAL',
  SCHEDULED = 'SCHEDULED'
}

export enum DvVarRunStatus {
  FAILED = 'FAILED',
  /** A leg failed at Haruko and the rest hold usable results. */
  PARTIAL = 'PARTIAL',
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED'
}

export enum DvVarScope {
  /**
   * Exactly the positions a run named, priced as given rather than read off the
   * book. A documentation run over custom positions, never the whole book.
   */
  CUSTOM = 'CUSTOM',
  /**
   * Every account under the dealer entity less the hedge accounts - the
   * client-facing figure Risk waits on.
   */
  ENTITY = 'ENTITY',
  /** HedgeCo's own book: every account under the HedgeCo entity. */
  HEDGECO = 'HEDGECO',
  /**
   * The whole book including the internal hedge legs, which cancel, so a clean
   * hedge lands near zero.
   */
  HEDGED = 'HEDGED',
  /**
   * Every in-scope position the Haruko venue accounts a run named held when it
   * started, priced as one book.
   */
  VENUE = 'VENUE'
}

/** ExternalConnectivityUser is the user profile for the external connectivity feature. */
export type ECUser = {
  __typename: 'ECUser';
  /** connectedExchanges are the exchanges that the user has an active connection with */
  connectedExchanges: Array<EEInfo>;
  /**
   * numAccounts is the total number of accounts the user has at their
   * connected exchanges. This is different than the number of exchange credentials
   * we have for this user.
   */
  numAccounts: Maybe<Scalars['Int']['output']>;
  /** numExchanges is the total number of exchanges the user has connected. */
  numExchanges: Scalars['Int']['output'];
  /** totalAssets are the total asset rollups for this user across all of their exchange acccounts. */
  totalAssets: Array<Amount>;
  /** totalAssetsV2 are the total asset rollups for this user across all of their exchange acccounts. */
  totalAssetsV2: Array<EEAmount>;
  /** totalBalance is the total USD balance that the user has across all exchanges. */
  totalBalance: Amount;
};

/** Information about an existing exchange connection / credential. */
export type EEAPIKey = {
  __typename: 'EEAPIKey';
  /** exchange is the associated exchange for this credential. */
  exchange: EEInfo;
  /** fingerprint is the hash of the api key that can be used to identify the API key. */
  fingerPrint: Scalars['String']['output'];
  /** id is a unique CredentialID */
  id: Scalars['ID']['output'];
  /** status indicates whether the credential is valid or deleted. */
  status: EEAPIKeyStatus;
};

/** A connection to a list of items. */
export type EEAPIKeyConnection = {
  __typename: 'EEAPIKeyConnection';
  /** A list of edges. */
  edges: Array<EEAPIKeyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EEAPIKeyEdge = {
  __typename: 'EEAPIKeyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EEAPIKey;
};

/**
 * External Exchange API KeyStatus denotes the
 * current status of the API key to the external exchange.
 */
export enum EEAPIKeyStatus {
  /** The API key has been deleted and can no longer be used. */
  Deleted = 'Deleted',
  Invalid = 'Invalid',
  /** Valid means the API key can be used. */
  Valid = 'Valid'
}

/**
 * External Exchange Account is an invidual account a part of user's exchange profile.
 * An account will have an API key used to control it, and wallets used to hold funds.
 */
export type EEAccount = {
  __typename: 'EEAccount';
  /** apiKey is the currently configured API key for this account. */
  apiKey: EEAPIKey;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * totalAssets is the is the total amount of each asset the user has across
   * this exchange account.
   * @deprecated Unimplemented, will be removed soon
   */
  totalAssets: Array<Amount>;
  /** totalBalance is the total balance of all the wallets for this account priced in USD. */
  totalBalance: Amount;
  wallets: Array<EEWallet>;
};


/**
 * External Exchange Account is an invidual account a part of user's exchange profile.
 * An account will have an API key used to control it, and wallets used to hold funds.
 */
export type EEAccountwalletsArgs = {
  filterAssetType?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
};

export type EEAmount = Amount | UnsupportedAssetAmount;

export type EEAssetTypeInfo = AssetTypeInfo | UnsupportedAssetAssetTypeInfo;

/**
 * External Exchange Auth Settings contains information about
 * how a specific exchange handles authentication.
 */
export type EEAuthSettings = {
  __typename: 'EEAuthSettings';
  requiresEmailConfirmation: Scalars['Boolean']['output'];
  requiresPassword: Scalars['Boolean']['output'];
  requiresUserID: Scalars['Boolean']['output'];
  requiresWithdrawAddressWhitelist: Scalars['Boolean']['output'];
};

/**
 * External Exchange feature is an enum representing the different
 * features that we support for a specific exchange.
 */
export enum EEFeature {
  Deposit = 'Deposit',
  /**
   * Whether an exchange supports sub accounts
   * and whether making transfers to said subaccounts is possible.
   */
  SubAccounting = 'SubAccounting',
  Transfer = 'Transfer',
  Withdraw = 'Withdraw'
}

export type EEInfo = {
  __typename: 'EEInfo';
  /** addressManagmentURL is the url the user can vist to whitelist cryptocurrency addresses if there is one available. */
  addressManagementURL: Maybe<Scalars['String']['output']>;
  /** apiManagementURL is the url where the user can manage API Keys for the exchange if there is one available. */
  apiManagementURL: Maybe<Scalars['String']['output']>;
  authSettings: EEAuthSettings;
  availableFeatures: Array<EEFeature>;
  displayName: Scalars['String']['output'];
  /**
   * If the request is authenticated then,
   * get the user's exchange accounts if any for this exchange.
   *
   * In the future we may support multiple top level user profiles at
   * an exchange, but for now there will only be one external exchange profile.
   */
  exchangeAccounts: Maybe<Array<EEUser>>;
  id: Scalars['ID']['output'];
  logoURL: Maybe<Scalars['String']['output']>;
  status: EEStatus;
};

export type EENetworkInfo = NetworkInfo | UnsupportedAssetNetworkInfo;

export enum EEStatus {
  Ok = 'Ok',
  Unavailable = 'Unavailable'
}

/**
 * ExternalExchangeUser is the representation of a user's profile
 * at an external exchange.
 */
export type EEUser = {
  __typename: 'EEUser';
  mainAccount: EEAccount;
  subAccounts: Array<EEAccount>;
  /** totalBalance is the total balance for the user across all accounts priced in USD. */
  totalBalance: Amount;
};

/**
 * External Exchange Wallet is a component on an external exchange account
 * that holds funds.
 */
export type EEWallet = {
  __typename: 'EEWallet';
  /** asOf is the time the balance was last retreived from the exchange. */
  asOf: Scalars['Timestamp']['output'];
  balance: Array<Amount>;
  balanceV2: Array<EEAmount>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

/** ERC20ApprovedSpender describes an allowed spender contract for an ERC20 approve operation. */
export type ERC20ApprovedSpender = {
  __typename: 'ERC20ApprovedSpender';
  /** Canonical (EIP-55 checksummed) address of the spender contract. */
  address: Scalars['String']['output'];
  /** Human-readable name of the spender contract. */
  name: Scalars['String']['output'];
};

/** ETHStakingProviderType represents an enum of all the ethereum staking providers */
export enum ETHStakingProviderType {
  /** BITWISE provider type for ethereum staking */
  BITWISE = 'BITWISE',
  /** BLOCKDAEMON provider type for ethereum staking */
  BLOCKDAEMON = 'BLOCKDAEMON',
  /** CONSENSYS provider type for ethereum staking */
  CONSENSYS = 'CONSENSYS',
  /** FIGMENT provider type for ethereum staking */
  FIGMENT = 'FIGMENT',
  /** GALAXY_DIGITAL provider type for ethereum staking */
  GALAXY_DIGITAL = 'GALAXY_DIGITAL',
  /** PARAFI provider type for ethereum staking */
  PARAFI = 'PARAFI',
  /** STAKED provider type for ethereum staking */
  STAKED = 'STAKED',
  /** TWINSTAKE provider type for ethereum staking */
  TWINSTAKE = 'TWINSTAKE'
}

/** Input for re-editing a submitted AML questionnaire. */
export type EditAMLInput = {
  /**
   * The new edited state of the submission. The entire answer set is required,
   * including unchanged values.
   */
  answers: Array<InputQuestionnaireAnswer>;
  /**
   * Re-transmits the Travel Rule message for the operation after the edit lands.
   * Ignored when the operation is not Travel Rule eligible.
   */
  resendTravelRule?: Scalars['Boolean']['input'];
  /** Unique identifier for the AML submission being edited. */
  submissionID: Scalars['String']['input'];
};

/** Result of re-editing a submitted AML questionnaire. */
export type EditAMLResult = {
  __typename: 'EditAMLResult';
  /** Whether the AML edit itself was persisted. */
  success: Scalars['Boolean']['output'];
  /**
   * Non-fatal problems encountered after the edit was persisted — most notably a
   * requested Travel Rule resend that could not be performed. Empty on a clean run.
   */
  warnings: Array<Scalars['String']['output']>;
};

export type EditCostBasisInput = {
  /** The account where the transaction occurred */
  accountId: Scalars['String']['input'];
  /** Cost basis lots to assign (max 100) */
  lots: Array<EditCostBasisLotInput>;
  /** The organization key ID */
  organizationKeyId: Scalars['String']['input'];
  /** The external transaction ID (deposit ID from custody) */
  transactionId: Scalars['String']['input'];
};

export type EditCostBasisLotInput = {
  /** When this lot was acquired (ISO-8601) */
  acquisitionDatetime: Scalars['Time']['input'];
  /** Cost basis per unit */
  costBasis: Scalars['String']['input'];
  /** Number of units in this lot */
  quantity: Scalars['String']['input'];
};

export type EditCostBasisPayload = {
  __typename: 'EditCostBasisPayload';
  /** Error message if the operation failed */
  error: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The transaction ID on success */
  transactionId: Maybe<Scalars['String']['output']>;
};

/** TODO: add description */
export type EditWebhookEndpointInput = {
  /** TODO: add description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** TODO: add description */
  publicKey?: InputMaybe<Scalars['String']['input']>;
  /** TODO: add description */
  subscriptions?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** TODO: add description */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** List of enabled stablecoins for an organization */
export type EnabledStablecoins = {
  __typename: 'EnabledStablecoins';
  /**
   * Map of asset type IDs to their available bridging paths.
   * Keys are AssetTypeIDs, values are lists of AssetTypeIDs.
   */
  bridgingPaths: Scalars['Map']['output'];
  /** List of enabled stablecoins */
  edges: Array<Scalars['AssetTypeID']['output']>;
};

export type EnabledStablecoinsEdge = {
  __typename: 'EnabledStablecoinsEdge';
  node: EnabledStablecoinsNode;
};

export type EnabledStablecoinsNode = {
  __typename: 'EnabledStablecoinsNode';
  assetTypeID: Scalars['AssetTypeID']['output'];
  paths: EnabledStablecoinsPaths;
};

export type EnabledStablecoinsPaths = {
  __typename: 'EnabledStablecoinsPaths';
  bridges: Array<Scalars['AssetTypeID']['output']>;
  swaps: Array<Scalars['AssetTypeID']['output']>;
};

export type EnabledStablecoinsV2 = {
  __typename: 'EnabledStablecoinsV2';
  /** List of enabled stablecoins */
  edges: Array<EnabledStablecoinsEdge>;
};

export type EnabledStablecoinsV3 = {
  __typename: 'EnabledStablecoinsV3';
  /** List of enabled stablecoins with full asset configuration */
  edges: Array<EnabledStablecoinsV3Edge>;
};

export type EnabledStablecoinsV3Edge = {
  __typename: 'EnabledStablecoinsV3Edge';
  node: EnabledStablecoinsV3Node;
};

export type EnabledStablecoinsV3Node = {
  __typename: 'EnabledStablecoinsV3Node';
  /**
   * Actions this organization is allowed to perform on the asset. When the asset
   * has no overrides configured, every action is allowed. Use to gate UI affordances.
   */
  allowedActions: Array<StablecoinAction>;
  assetTypeID: Scalars['AssetTypeID']['output'];
  maxAmount: Maybe<Scalars['String']['output']>;
  maxDisplayDecimals: Maybe<Scalars['String']['output']>;
  paths: EnabledStablecoinsPaths;
  underlyingAssetTypeID: Maybe<Scalars['AssetTypeID']['output']>;
};

export type EnrollOrgForFiatInterestInput = {
  /**
   * Legacy numeric ID of the Account to record the acceptances against; it must
   * list the org. Omitted, the org's Account is resolved server-side, which
   * requires the org to have exactly one.
   */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** The org to enroll. Every other org under the same Account is enrolled too. */
  orgId: Scalars['ID']['input'];
};

export type EnrollOrgForFiatInterestResult = {
  __typename: 'EnrollOrgForFiatInterestResult';
  /** The legacy numeric account ID the MSA acceptances were recorded against. */
  accountId: Scalars['String']['output'];
  /**
   * The orgs whose cascades started, requested org first. Never empty — the
   * mutation errors instead.
   */
  runs: Array<EnrollOrgForFiatInterestRun>;
  skipped: Array<EnrollOrgForFiatInterestSkip>;
};

/** One org whose enrollment cascade started. */
export type EnrollOrgForFiatInterestRun = {
  __typename: 'EnrollOrgForFiatInterestRun';
  orgId: Scalars['ID']['output'];
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

/**
 * One org that couldn't be enrolled; the rest still proceeded. The underlying
 * error is logged server-side.
 */
export type EnrollOrgForFiatInterestSkip = {
  __typename: 'EnrollOrgForFiatInterestSkip';
  orgId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

/** EnrollOrganizationInStablecoinRewardsResult represents the result of enrolling an organization's top level affiliates in stablecoin rewards. */
export type EnrollOrganizationInStablecoinRewardsResult = {
  __typename: 'EnrollOrganizationInStablecoinRewardsResult';
  /** Organization identifier */
  workflowID: Scalars['ID']['output'];
};

/**
 * EnrollParticipantInProgramsResult type represents the result of enrolling a
 * participant in multiple programs.
 */
export type EnrollStablecoinRewardsParticipantsInProgramResult = {
  __typename: 'EnrollStablecoinRewardsParticipantsInProgramResult';
  /** IDs of successfully enrolled participants */
  participantIDs: Array<Scalars['String']['output']>;
  /** ID of program */
  programID: Scalars['String']['output'];
};

/** Possible enrollment types */
export enum EnrollType {
  /** The user is joining an existing organization */
  EXISTING_ORG_ENROLL = 'EXISTING_ORG_ENROLL',
  /** The user is joining a new organization */
  NEW_ORG_ENROLL = 'NEW_ORG_ENROLL',
  /** Special type of enrollment used to recover organizations */
  ORGANIZATION_RECOVERY_ENROLL = 'ORGANIZATION_RECOVERY_ENROLL',
  /** The enrollment will replace the user within its organization */
  REPLACEMENT_ENROLL = 'REPLACEMENT_ENROLL'
}

/** EnrollingUserControlKey represents the state of control keys for a user that's being added to an organization */
export type EnrollingUserControlKey = {
  __typename: 'EnrollingUserControlKey';
  /** Once the control key for the user is provided by the admin adding them or the last admin in an org creation, it'll appear here */
  encryptedControlMasterPrivateKey: Maybe<Scalars['String']['output']>;
  /** Once the user has scanned their QR code and submitted the encryption key, it'll appear here */
  encryptionPublicKey: Maybe<Scalars['String']['output']>;
  /** This is the enroll token (the content of the qr code) for an enrolling user */
  enrollToken: Scalars['String']['output'];
  /** The user's (staged?) name */
  name: Scalars['String']['output'];
  /** The hash of their public key once they've scanned their QR code */
  publicKeyID: Maybe<Scalars['String']['output']>;
};

/** Current enrollment information */
export type Enrollment = {
  __typename: 'Enrollment';
  /** This is true if you must submit control keys for all users (including yourself) before being allowed in the org */
  controlMasterPublicKeyRequired: Scalars['Boolean']['output'];
  /** The enrollment token of this enrollment. */
  enrollToken: Scalars['String']['output'];
  /** Your user will be asked to generate and back up the control master key */
  isControlMasterPublicKeySubmitter: Scalars['Boolean']['output'];
  /** PII information known */
  knownInformation: Array<KnownInformation>;
  /** The name of the user submitted during enrollment. This is not necessarily the name that the ended up with in the organization after enrollment, so it should be used only during enrollment */
  name: Maybe<Scalars['String']['output']>;
  /** The organizationKeyID of the organization once the enrollment process is complete */
  organizationKeyID: Maybe<Scalars['String']['output']>;
  /** The name of the organization you are enrolling into */
  organizationName: Scalars['String']['output'];
  /** PII information required */
  requiredInformation: Array<RequiredInformation>;
  /** The staged organization associated with this enrollment */
  stagedOrganization: StagedOrganization;
  /** The status of the enrollment process */
  status: EnrollmentStatus;
  /** The type of enrollment being performed */
  type: EnrollType;
  /**
   * During organization creation, every admin user will see this list and has to get their control key from here when it's available
   * The last admin will submit the control keys for everyone
   * When adding a user, the initiator, will submit an encrypted control key for them at the time when the initiator endorses the user add operation and it will also show up here. In that case, this list might contain only a single item.
   */
  userControlKeys: Array<EnrollingUserControlKey>;
  /** The status of the enrollment process as it should be shown in the user interface. */
  visualStatus: EnrollmentVisualStatus;
};

/** A connection to a list of enrollments. */
export type EnrollmentConnection = {
  __typename: 'EnrollmentConnection';
  /** A list of edges. */
  edges: Maybe<Array<EnrollmentEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection, representing an Enrollment instance */
export type EnrollmentEdge = {
  __typename: 'EnrollmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge */
  node: Maybe<Enrollment>;
};

/** A connection to a list of enrollment entries */
export type EnrollmentEntriesConnection = {
  __typename: 'EnrollmentEntriesConnection';
  /** A list of edges */
  edges: Array<EnrollmentEntryEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Total count of items */
  totalCount: Scalars['Int']['output'];
};

/** EnrollmentEntry represents an enrollment record */
export type EnrollmentEntry = {
  __typename: 'EnrollmentEntry';
  /** Created at timestamp */
  createdAt: Scalars['String']['output'];
  /** Enrollment token */
  enrollToken: Scalars['String']['output'];
  /** Enrollment type */
  enrollType: EnrollType;
  /** Enrollment public key ID (the public key ID from the enrollment) */
  enrollmentPublicKeyID: Maybe<Scalars['String']['output']>;
  /** Organization key ID */
  organizationKeyID: Scalars['String']['output'];
  /** Original public key ID (the key being replaced in replacement enrollments) */
  originalPublicKeyID: Maybe<Scalars['String']['output']>;
  /** PII ID */
  piiID: Scalars['String']['output'];
  /** Enrollment status */
  status: EnrollmentStatus;
};

/** An edge in the enrollment entries connection */
export type EnrollmentEntryEdge = {
  __typename: 'EnrollmentEntryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The enrollment entry */
  node: EnrollmentEntry;
};

/** Ordering options for Enrollment connections */
export type EnrollmentOrderBy = {
  /** The ordering direction */
  direction?: OrderDirection;
  /** The field by which to order enrollments */
  field?: EnrollmentOrderByField;
};

/** Properties by which Enrollment connections can be ordered */
export enum EnrollmentOrderByField {
  /** Order enrollments by creation date */
  CREATED_AT = 'CREATED_AT'
}

/** Possible enrollment statuses */
export enum EnrollmentStatus {
  /** Enrollment completed but the user has not logged in for the first time yet */
  COMPLETE = 'COMPLETE',
  /** Enrollment completed and no further changes can be made */
  LOCKED = 'LOCKED',
  /** The user has not submitted the minimal required information */
  OPEN = 'OPEN',
  /** Enrollment is still underway */
  PENDING = 'PENDING',
  /** Enrollment was rejected */
  REJECTED = 'REJECTED'
}

/** Defines a vault policy to be associated with an enrollment */
export type EnrollmentVaultPolicy = {
  /**
   * The actions within the vault that the enrollment gives access to
   * Deprecated Legacy PolicyMaps, use 'scopes'.
   * @deprecated Use 'scopes' instead
   */
  actions?: InputMaybe<Array<PolicyActionType>>;
  /** A map of scopes to quorum requirements */
  scopes?: InputMaybe<Array<ScopeToQuorumRequirements>>;
  /** The vault sub ID that the policy refers to */
  vaultSubID: Scalars['String']['input'];
};

/** Enrollment status as it should be shown in the user interface */
export enum EnrollmentVisualStatus {
  /** All steps have been completed, but not approved into the organization. */
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  /** Enrollment token has been used, but not all enrollment steps have been completed. */
  REGISTRATION_IN_PROGRESS = 'REGISTRATION_IN_PROGRESS',
  /** Token has been created, but has not been used. */
  TOKEN_CREATED = 'TOKEN_CREATED',
  /** All steps have been completed, but organization has not been seeded yet. */
  WAITING_FOR_ORG_SEEDING = 'WAITING_FOR_ORG_SEEDING'
}

/** A filter to be used against Enrollment fields. */
export type EnrollmentWhereInput = {
  /** Statuses of enrollment to filter by */
  enrollStatusIn?: InputMaybe<Array<EnrollmentStatus>>;
  /** Types of enrollment to filter by */
  enrollTypeIn?: InputMaybe<Array<EnrollType>>;
};

/** EntityAccount */
export type EntityAccount = {
  __typename: 'EntityAccount';
  /** AccountID */
  accountID: Scalars['String']['output'];
  /** AssetTypeID */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Timestamp of when the EntityAccount was created */
  createdAt: Scalars['Time']['output'];
  /** Identifier of the EntityAccount */
  entityID: EntityID;
  /** Timestamp of when the EntityAccount was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/** Entity account balance */
export type EntityAccountBalances = {
  __typename: 'EntityAccountBalances';
  /** Identifier of the EntityAccount */
  entityID: EntityID;
  /** Quantity associated with the balance */
  quantity: Quantity;
  /** Timestamp of when a balance was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/** TransactionEntryConnection represents a page of EntityAccountsBalance based on the parameters of pagination used, defined by a pageInfo object. */
export type EntityAccountBalancesConnection = {
  __typename: 'EntityAccountBalancesConnection';
  /** Edges contains a list of EntityAccountBalancesEdge objects representing a page of EntityAccountsBalance data. */
  edges: Array<EntityAccountBalancesEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** Represents an entity account balance edge */
export type EntityAccountBalancesEdge = {
  __typename: 'EntityAccountBalancesEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a EntityAccountsBalance */
  node: EntityAccountBalances;
};

/** EntityAccountConnection represents a page of EntityAccounts based on the parameters of pagination used, defined by a pageInfo object. */
export type EntityAccountConnection = {
  __typename: 'EntityAccountConnection';
  /** Edges contains a list of EntityAccountEdge objects representing a page of AddressBalance data. */
  edges: Array<EntityAccountEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** Represents a EntityAccount Edge */
export type EntityAccountEdge = {
  __typename: 'EntityAccountEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a EntityAccount */
  node: Maybe<EntityAccount>;
};

/** Represents an entity ID of an entity account */
export type EntityID = {
  __typename: 'EntityID';
  /** Identifier of the Entity */
  id: Scalars['String']['output'];
  /** Type of the Entity */
  type: Scalars['String']['output'];
};

/** Represents an entity ID of an entity account */
export type EntityIDInput = {
  /** Identifier of the Entity */
  id: Scalars['String']['input'];
  /** Type of the Entity */
  type: Scalars['String']['input'];
};

/**
 * EntityTagsResult wraps an entity's visible tags together with whether the caller
 * may edit them.
 */
export type EntityTagsResult = {
  __typename: 'EntityTagsResult';
  /** Whether the caller may edit this entity's tags right now. (non-initiators may edit only after quorum) */
  canEditOperationTags: Scalars['Boolean']['output'];
  /** Tags visible to the caller — same visibility semantics as the entityTags query. */
  tags: Array<TagResult>;
};

/** Entity type represents the entity type and also information on if that type is credit or not */
export type EntityType = {
  __typename: 'EntityType';
  /** Flag that let us know if the Entity Type is credit */
  isCredit: Scalars['Boolean']['output'];
  /** Name of the Entity Type */
  name: Scalars['String']['output'];
};

/** Simple interface for an error with a message. */
export type ErrorMessage = {
  /** An error message. */
  message: Scalars['String']['output'];
};

/** EstablishWalletConnectSessionResponse */
export type EstablishWalletConnectSessionResponse = {
  __typename: 'EstablishWalletConnectSessionResponse';
  /** connectionID is the ID of the connection */
  connectionID: Maybe<Scalars['ID']['output']>;
  /** Was request successful */
  success: Scalars['Boolean']['output'];
};

/** EthereumEigenLayerInfo is a type that contains information about the EigenPod associated with an asset. */
export type EthereumEigenLayerInfo = {
  __typename: 'EthereumEigenLayerInfo';
  /** HasTrustedSmartContract is true if an EigenPod has been created and the TrustedSmartContract operation associated with this eigenpod is approved. Staking is not possible until this is true. */
  hasTrustedSmartContract: Scalars['Boolean']['output'];
  /** isRelevantForEigenLayer is true when the asset is relevant for EigenLayer and false when it is not. */
  isRelevantForEigenLayer: Scalars['Boolean']['output'];
  /** PodAddress is the address of the EigenPod associated with the asset, if one has been created. Otherwise, it will be null. */
  podAddress: Maybe<Scalars['String']['output']>;
};

/** Extra parameters for ethereum */
export type EthereumExtraParams = {
  __typename: 'EthereumExtraParams';
  /** stakingProvider is the provider that will be used to stake the ethereum */
  stakingProvider: Maybe<ETHStakingProviderType>;
  /** validatorCount is the amount of validators for this staking operation */
  validatorCount: Maybe<Scalars['String']['output']>;
  /** withdrawalAddress is the address to where the funds will be returned to when withdrawal is possible */
  withdrawalAddress: Maybe<Scalars['String']['output']>;
};

/** EthereumFigmentStakingConfiguration holds figment specific staking configuration */
export type EthereumFigmentStakingConfiguration = {
  __typename: 'EthereumFigmentStakingConfiguration';
  /** region is where validators infrastructure is to be deployed */
  region: Scalars['String']['output'];
};

/** EthereumStakingProvidersConfiguration holds staking configurations for known providers */
export type EthereumStakingProvidersConfiguration = {
  __typename: 'EthereumStakingProvidersConfiguration';
  /** figment is the organization staking configuration for the provider Figment */
  figment: Maybe<EthereumFigmentStakingConfiguration>;
  /** twinstake is the organization staking configuration for the provider Twinstake */
  twinstake: Maybe<EthereumTwinstakeStakingConfiguration>;
};

/** EthereumStakingValidator is a representation of a validator, containing what ever information might be necessary */
export type EthereumStakingValidator = {
  __typename: 'EthereumStakingValidator';
  /** addressSubID */
  addressSubID: Scalars['Int']['output'];
  /** assetSubID */
  assetSubID: Scalars['Int']['output'];
  /** assetTypeID */
  assetTypeID: Scalars['String']['output'];
  /** createdAt represents when the validator was created */
  createdAt: Scalars['String']['output'];
  /** depositDataRoot */
  depositDataRoot: Scalars['String']['output'];
  /** depositMessageRoot */
  depositMessageRoot: Scalars['String']['output'];
  /** exitMessage */
  exitMessage: Scalars['String']['output'];
  /** operationID is the identifier of the operation that created said validator */
  operationID: Scalars['String']['output'];
  /** organizationKeyID represents the organization */
  organizationKeyID: Scalars['String']['output'];
  /** provider represents the provider of the validator */
  provider: Scalars['String']['output'];
  /** signature */
  signature: Scalars['String']['output'];
  /** stakedAmount */
  stakedAmount: Scalars['String']['output'];
  /** stakingPositionID is the identifier of the staking position */
  stakingPositionID: Scalars['String']['output'];
  /** status represents the current status of the validator */
  status: Scalars['String']['output'];
  /** unstakeOperationID */
  unstakeOperationID: Scalars['String']['output'];
  /** updatedAt represents when the validator was last changed */
  updatedAt: Scalars['String']['output'];
  /** validatorID is the identifier of the validator */
  validatorID: Scalars['String']['output'];
  /** validatorIndex */
  validatorIndex: Scalars['Uint64']['output'];
  /** validatorPublicKey is the public key of the validator */
  validatorPublicKey: Scalars['String']['output'];
  /** vaultSubID indicates to what vault the validator is from */
  vaultSubID: Scalars['Int']['output'];
  /** withdrawalCredentials */
  withdrawalCredentials: Scalars['String']['output'];
  /** withdrawalPending */
  withdrawalPending: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type EthereumStakingValidatorData = {
  __typename: 'EthereumStakingValidatorData';
  /** A list of edges. */
  edges: Maybe<Array<EthereumStakingValidatorEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EthereumStakingValidatorEdge = {
  __typename: 'EthereumStakingValidatorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<EthereumStakingValidator>;
};

/** EthereumTwinstakeStakingConfiguration holds twinstake specific staking configuration */
export type EthereumTwinstakeStakingConfiguration = {
  __typename: 'EthereumTwinstakeStakingConfiguration';
  /** clientName is a common AD and Twinstake client reference */
  clientName: Scalars['String']['output'];
};

/** ExecType represents */
export enum ExecType {
  /** Canceled represents */
  CANCELED = 'CANCELED',
  /** CancelRejected represents */
  CANCEL_REJECTED = 'CANCEL_REJECTED',
  /** DoneForDay represents */
  DONE_FOR_DAY = 'DONE_FOR_DAY',
  /** Invalid represents */
  INVALID = 'INVALID',
  /** New represents */
  NEW = 'NEW',
  /** Paused represents */
  PAUSED = 'PAUSED',
  /** PendingResume represents */
  PENDINGVRESUME = 'PENDINGVRESUME',
  /** PendingCancel represents */
  PENDING_CANCEL = 'PENDING_CANCEL',
  /** PendingNew represents */
  PENDING_NEW = 'PENDING_NEW',
  /** PendingPause represents */
  PENDING_PAUSE = 'PENDING_PAUSE',
  /** PendingReplace represents */
  PENDING_REPLACE = 'PENDING_REPLACE',
  /** Rejected represents */
  REJECTED = 'REJECTED',
  /** Replaced represents */
  REPLACED = 'REPLACED',
  /** ReplaceRejected represents */
  REPLACE_REJECTED = 'REPLACE_REJECTED',
  /** Restated represents */
  RESTATED = 'RESTATED',
  /** Resumed represents */
  RESUMED = 'RESUMED',
  /** Started represents */
  STARTED = 'STARTED',
  /** Stopped represents */
  STOPPED = 'STOPPED',
  /** Trade represents */
  TRADE = 'TRADE',
  /** Triggered represents */
  TRIGGERED = 'TRIGGERED'
}

/** Inputs to ExecuteFilecoinMinerBalanceWithdrawals mutation */
export type ExecuteFilecoinMinerBalanceWithdrawalsInput = {
  /** CSV containing the operations to process in bulk */
  operationCSV: Scalars['String']['input'];
};

/** Payload from ExecuteFilecoinMinerBalanceWithdrawals mutation */
export type ExecuteFilecoinMinerBalanceWithdrawalsPayload = {
  __typename: 'ExecuteFilecoinMinerBalanceWithdrawalsPayload';
  /** IDs of the generic operations that were successfully executed */
  executedOperations: Array<Scalars['String']['output']>;
};

/** External account. */
export type ExternalAccount = Node & {
  __typename: 'ExternalAccount';
  /** Account location. */
  externalAccountLocation: ExternalAccountLocation;
  /** External account identifier. */
  id: Scalars['ID']['output'];
  /** External account name. */
  name: Scalars['String']['output'];
  /** Human-readable notes. */
  notes: Scalars['String']['output'];
  /** When was this account info last changed. */
  updatedAt: Scalars['Timestamp']['output'];
  /** Who created the account in the database. */
  updatedBy: Scalars['String']['output'];
};

/** Balance of a given external account */
export type ExternalAccountBalance = {
  __typename: 'ExternalAccountBalance';
  /** Balance */
  balance: Amount;
  /** External account */
  externalAccount: ExternalAccount;
};

/** External account balance pagination connection. */
export type ExternalAccountBalanceConnection = {
  __typename: 'ExternalAccountBalanceConnection';
  /** List of edges containing external account balances and cursor information */
  edges: Array<ExternalAccountBalanceEdge>;
  /** Page details for the associated list of external account balances. */
  pageInfo: PageInfo;
};

/** External account balance edge connection. */
export type ExternalAccountBalanceEdge = {
  __typename: 'ExternalAccountBalanceEdge';
  /** CursorType for the associated external account balance. */
  cursor: Scalars['String']['output'];
  /** External account balance. */
  node: ExternalAccountBalance;
};

/** External account pagination connection */
export type ExternalAccountConnection = {
  __typename: 'ExternalAccountConnection';
  /** List of edges containing external accounts and cursor information */
  edges: Array<ExternalAccountEdge>;
  /** Page details for the associated list of external accounts. */
  pageInfo: PageInfo;
};

/** External account pagination edge */
export type ExternalAccountEdge = {
  __typename: 'ExternalAccountEdge';
  /** CursorType for the associated external account. */
  cursor: Scalars['String']['output'];
  /** External account. */
  node: ExternalAccount;
};

/** An external account location (i.e. bank or institution). */
export type ExternalAccountLocation = Node & {
  __typename: 'ExternalAccountLocation';
  /** External account location identifier. */
  id: Scalars['ID']['output'];
  /** Location (i.e., bank/institution name). */
  location: Scalars['String']['output'];
  /** Human-readable notes. */
  notes: Scalars['String']['output'];
  /** When was the account inserted in the database. */
  updatedAt: Scalars['Timestamp']['output'];
  /** Who created the account in the database. */
  updatedBy: Scalars['String']['output'];
};

/** External account location pagination connection */
export type ExternalAccountLocationConnection = {
  __typename: 'ExternalAccountLocationConnection';
  /** List of edges containing external account locations and cursor information */
  edges: Array<ExternalAccountLocationEdge>;
  /** Page details for the associated list of external account locations. */
  pageInfo: PageInfo;
};

/** External account location pagination edge */
export type ExternalAccountLocationEdge = {
  __typename: 'ExternalAccountLocationEdge';
  /** CursorType for the associated external account location. */
  cursor: Scalars['String']['output'];
  /** External account location. */
  node: ExternalAccountLocation;
};

/** Balance of a given organization on an external account */
export type ExternalAccountOrgBalance = {
  __typename: 'ExternalAccountOrgBalance';
  /** Trading account associated with this balance */
  account: Maybe<TradingAccount>;
  /** Organization affiliate associated with this balance */
  affiliate: Maybe<Account>;
  /** Balance */
  balance: Amount;
  /** Time of last executed transaction */
  lastExecutedAt: Scalars['Timestamp']['output'];
  /** Organization associated with this balance */
  organization: Organization;
};

/** External account balance pagination connection. */
export type ExternalAccountOrgBalanceConnection = {
  __typename: 'ExternalAccountOrgBalanceConnection';
  /** List of edges containing external account balances and cursor information */
  edges: Array<ExternalAccountOrgBalanceEdge>;
  /** Page details for the associated list of external account balances. */
  pageInfo: PageInfo;
};

/** External account balance edge connection. */
export type ExternalAccountOrgBalanceEdge = {
  __typename: 'ExternalAccountOrgBalanceEdge';
  /** CursorType for the associated external account balance. */
  cursor: Scalars['String']['output'];
  /** External account balance. */
  node: ExternalAccountOrgBalance;
};

/** Transaction on an external account */
export type ExternalAccountTransaction = Node & {
  __typename: 'ExternalAccountTransaction';
  /** Which brokerage account is associated with this external account */
  account: Maybe<TradingAccount>;
  /** Which Anchorage affiliate entity identifier is associated with this account */
  affiliate: Maybe<Account>;
  /** Amount transacted */
  amount: Amount;
  /** When did this transaction occur */
  executedAt: Scalars['Timestamp']['output'];
  /** External account where transaction occurred */
  externalAccount: ExternalAccount;
  /** Free-form text that might be used to store information regarding transaction identifiers of external entities */
  externalID: Scalars['String']['output'];
  /** Transaction identifier */
  id: Scalars['ID']['output'];
  /** Human-readable notes */
  notes: Scalars['String']['output'];
  /** Organization associated with this transaction */
  organization: Organization;
  /** Type of transaction */
  transactionType: ExternalAccountTransactionType;
  /** When was this transaction updated */
  updatedAt: Scalars['Timestamp']['output'];
  /** Who updated this transaction */
  updatedBy: Scalars['String']['output'];
  /** Which organization vault is associated with this transaction */
  vault: Maybe<Vault>;
};

/** External account transaction pagination connection. */
export type ExternalAccountTransactionConnection = {
  __typename: 'ExternalAccountTransactionConnection';
  /** List of edges containing external account transactions and cursor information */
  edges: Array<ExternalAccountTransactionEdge>;
  /** Page details for the associated list of external account transactions. */
  pageInfo: PageInfo;
};

/** External account transaction edge connection. */
export type ExternalAccountTransactionEdge = {
  __typename: 'ExternalAccountTransactionEdge';
  /** CursorType for the associated external account transaction. */
  cursor: Scalars['String']['output'];
  /** External account transaction. */
  node: ExternalAccountTransaction;
};

export enum ExternalAccountTransactionType {
  /** Charged fees */
  FEE = 'FEE',
  /** Amount was from other operation generating a decrement */
  OTHER_DECREMENT = 'OTHER_DECREMENT',
  /** Amount was from other operation generating an increment */
  OTHER_INCREMENT = 'OTHER_INCREMENT',
  /** Amount was pre-deposited. */
  PREDEPOSIT = 'PREDEPOSIT',
  /** Amount was deposited from proceeds */
  PROCEEDS_DEPOSIT = 'PROCEEDS_DEPOSIT',
  /** Amount is being spent on trades */
  SPENDING_ON_TRADES = 'SPENDING_ON_TRADES',
  /** Amount was withdrawed back to the client */
  WITHDRAWAL_BACK_TO_CLIENT = 'WITHDRAWAL_BACK_TO_CLIENT'
}

/** ExternalRequestInfo contains information about the external request that initiated the operation, if applicable */
export type ExternalRequestInfo = {
  __typename: 'ExternalRequestInfo';
  /** dAppName is the domain name of the dApp (e.g., "uniswap") */
  dAppName: Scalars['String']['output'];
  /** dAppURL is the full URL of the dApp (e.g., "https://app.uniswap.org") */
  dAppURL: Scalars['String']['output'];
};

export type ExternalScreeningRequest = Node & {
  __typename: 'ExternalScreeningRequest';
  /** Timestamp when the record was created */
  createdAt: Scalars['Time']['output'];
  /** The external screening provider */
  externalProvider: ExternalScreeningRequestExternalProvider;
  id: Scalars['ID']['output'];
  /** Raw request payload sent to the external provider */
  requestPayload: Scalars['Map']['output'];
  /** Raw response payload received from the external provider */
  responsePayload: Scalars['Map']['output'];
  /** Raw update payload received from the external provider (e.g., LexisNexis alert decision) */
  updatePayload: Maybe<Scalars['Map']['output']>;
  /** Timestamp when the record was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type ExternalScreeningRequestConnection = {
  __typename: 'ExternalScreeningRequestConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ExternalScreeningRequestEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ExternalScreeningRequestEdge = {
  __typename: 'ExternalScreeningRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ExternalScreeningRequest>;
};

/** ExternalScreeningRequestExternalProvider is enum for the field external_provider */
export enum ExternalScreeningRequestExternalProvider {
  LEXIS_NEXIS = 'LEXIS_NEXIS',
  TRM = 'TRM'
}

/** Ordering options for ExternalScreeningRequest connections */
export type ExternalScreeningRequestOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ExternalScreeningRequests. */
  field: ExternalScreeningRequestOrderField;
};

/** Properties by which ExternalScreeningRequest connections can be ordered. */
export enum ExternalScreeningRequestOrderField {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT'
}

/**
 * ExternalScreeningRequestWhereInput is used for filtering ExternalScreeningRequest objects.
 * Input was generated by ent.
 */
export type ExternalScreeningRequestWhereInput = {
  and?: InputMaybe<Array<ExternalScreeningRequestWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** external_provider field predicates */
  externalProvider?: InputMaybe<ExternalScreeningRequestExternalProvider>;
  externalProviderIn?: InputMaybe<Array<ExternalScreeningRequestExternalProvider>>;
  externalProviderNEQ?: InputMaybe<ExternalScreeningRequestExternalProvider>;
  externalProviderNotIn?: InputMaybe<Array<ExternalScreeningRequestExternalProvider>>;
  /** counterparty_entries edge predicates */
  hasCounterpartyEntries?: InputMaybe<Scalars['Boolean']['input']>;
  hasCounterpartyEntriesWith?: InputMaybe<Array<CounterpartyScreeningEntryWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ExternalScreeningRequestWhereInput>;
  or?: InputMaybe<Array<ExternalScreeningRequestWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * Extra parameters per asset type
 * We assume you don't simultaneously transact in mainnet and testnet
 */
export type ExtraParams = {
  __typename: 'ExtraParams';
  /** params for aptos */
  aptosExtraParams: Maybe<AptosExtraParams>;
  /** params for asset */
  assetExtraParams: Maybe<AssetExtraParams>;
  /** params for Avalanche P-Chain */
  avalanchePChainExtraParams: Maybe<AvalanchePChainExtraParams>;
  /** params for Bitcoin */
  bitcoinExtraParams: Maybe<BitcoinExtraParams>;
  /** params for BSC staking */
  bscExtraParams: Maybe<BSCExtraParams>;
  /** params for celo governance vote */
  celoGovernanceVoteExtraParams: Maybe<CeloGovernanceVoteExtraParams>;
  /** params for cosmos */
  cosmosExtraParams: Maybe<CosmosExtraParams>;
  /**
   * params for diem
   * @deprecated Unused, will be removed in the future
   */
  diemExtraParams: Maybe<DiemExtraParams>;
  /** params for ethereum staking */
  ethereumExtraParams: Maybe<EthereumExtraParams>;
  /** params for fiat */
  fiatExtraParams: Maybe<FiatExtraParams>;
  /** params for fiat trusted destinations */
  fiatTrustedDestinationExtraParams: Maybe<FiatTrustedDestinationExtraParams>;
  /** params for flow delegate/undelegate */
  flowDelegateExtraParams: Maybe<FlowDelegateExtraParams>;
  /** params for maker */
  makerExtraParams: Maybe<MakerExtraParams>;
  /** params for oasis undelegate */
  oasisUndelegateExtraParams: Maybe<OasisUndelegateExtraParams>;
  /** params for ripple */
  rippleExtraParams: Maybe<RippleExtraParams>;
  /** params for starknet */
  starknetExtraParams: Maybe<StarknetExtraParams>;
  /** params for stellar */
  stellarExtraParams: Maybe<StellarExtraParams>;
  /** params for tendermint */
  tendermintExtraParams: Maybe<TendermintExtraParams>;
};

/** Type of the ExtraParams in an operation's canonical representation. */
export enum ExtraParamsActionType {
  /** Avalanche Delegation Operation type */
  AVALANCHE_PCHAIN_DELEGATE = 'AVALANCHE_PCHAIN_DELEGATE',
  /** Avalanche Staking Operation type */
  AVALANCHE_PCHAIN_STAKE = 'AVALANCHE_PCHAIN_STAKE',
  /**
   * Bitcoin - Babylon staking: the backend shall deduce which collection
   * mechanism to use: BITCOIN_BABYLON_STAKING_OUTPUT_SPEND_EXPIRED_TIMELOCK for
   * expired stakes or BITCOIN_BABYLON_UNBONDING_OUTPUT_SPEND_EXPIRED_TIMELOCK for
   * early unbonds.
   */
  BITCOIN_BABYLON_DEDUCE_COLLECT_TYPE = 'BITCOIN_BABYLON_DEDUCE_COLLECT_TYPE',
  /** Bitcoin - Babylon staking: stake Bitcoin. */
  BITCOIN_BABYLON_DELEGATE = 'BITCOIN_BABYLON_DELEGATE',
  /**
   * Bitcoin - Babylon staking: early unbonding path where we have to coordinate
   * with covenant-committee - we need to make the request first to them.
   */
  BITCOIN_BABYLON_STAKING_OUTPUT_SPEND_EARLY_UNBOND = 'BITCOIN_BABYLON_STAKING_OUTPUT_SPEND_EARLY_UNBOND',
  /** Bitcoin - Babylon staking: normal unlock path after the staking time expires. */
  BITCOIN_BABYLON_STAKING_OUTPUT_SPEND_EXPIRED_TIMELOCK = 'BITCOIN_BABYLON_STAKING_OUTPUT_SPEND_EXPIRED_TIMELOCK',
  /**
   * Bitcoin - Babylon staking: for spending the transaction after covenant
   * committee approves unbond, we have to spend the output after the unbond's
   * timelock expires.
   */
  BITCOIN_BABYLON_UNBONDING_OUTPUT_SPEND_EXPIRED_TIMELOCK = 'BITCOIN_BABYLON_UNBONDING_OUTPUT_SPEND_EXPIRED_TIMELOCK',
  /** For celo governance/referendum vote */
  CELO_VOTE_REFERENDUM = 'CELO_VOTE_REFERENDUM',
  /** For flow delegate */
  FLOW_DELEGATE = 'FLOW_DELEGATE',
  /** For flow undelegate */
  FLOW_UNDELEGATE = 'FLOW_UNDELEGATE',
  /** For maker authorize spender */
  MKR_AUTHORIZE_SPENDER = 'MKR_AUTHORIZE_SPENDER',
  /** For maker executive vote */
  MKR_VOTE_EXECUTIVE = 'MKR_VOTE_EXECUTIVE',
  /** For maker poll vote */
  MKR_VOTE_POLL = 'MKR_VOTE_POLL',
  /** For oasis undelegate */
  OASIS_UNDELEGATE = 'OASIS_UNDELEGATE'
}

export type ExtractAgreementPrefillInput = {
  accountIds: Array<Scalars['ID']['input']>;
  agreementObjectId: Scalars['ID']['input'];
  feeTypeIdentifiers: Array<Scalars['String']['input']>;
};

/** FactorGroup represents a group of factors */
export type FactorGroup = {
  __typename: 'FactorGroup';
  /** factorGroups is a list of children groups */
  factorGroups: Maybe<Array<FactorGroup>>;
  /** factors is a list of pair of factor names and values as string */
  factors: Maybe<Array<FactorValues>>;
  /** id is the identifier of the group */
  id: Scalars['String']['output'];
  /** label is the description of the group */
  label: Scalars['String']['output'];
};

/** FactorValues represents a pair of factor name and value in string */
export type FactorValues = {
  __typename: 'FactorValues';
  /** id is the name of a factor */
  id: Scalars['String']['output'];
  /** label is the description of the group */
  label: Scalars['String']['output'];
  /** oldValue is the old value for the factor from previous run */
  oldValue: Scalars['String']['output'];
  /** value is the value for the factor */
  value: Scalars['String']['output'];
};

/** Feature represents a feature that can be made conditionally available to certain clients or users */
export type Feature = {
  __typename: 'Feature';
  /** The name of a feature */
  name: FeatureName;
};

/** FeatureName indicates the types of features that can be enabled */
export enum FeatureName {
  /** Controls whether multiple address generation types are provisioned when provisioning addresses. */
  ADDRESS_PROVISIONING_MULTIPLE_TYPES = 'ADDRESS_PROVISIONING_MULTIPLE_TYPES',
  /**
   * Allows client to use features related to external transfers.
   * This relates to the createTransfer APIv2 endpoint, creating a role with
   * TRANSFER permission and external destinations, and the ability to add API
   * public keys to the organization via operation.
   */
  APIV2_EXTERNAL_TRANSFER = 'APIV2_EXTERNAL_TRANSFER',
  /** Obsolete flag, use only to manually clear the flag from the database. */
  APIV2_TRANSFER_PERMISSION = 'APIV2_TRANSFER_PERMISSION',
  /** Enables an organization to use ECDSA signing with APIv2. EdDSA is the default. */
  APIv2_ECDSA_AUTH = 'APIv2_ECDSA_AUTH',
  /** Controls whether settlements are automatically settled. */
  AUTOMATICALLY_SETTLE_SETTLEMENTS = 'AUTOMATICALLY_SETTLE_SETTLEMENTS',
  /** Controls the access to the bulk vault creation functionality. */
  BULK_VAULT_CREATION = 'BULK_VAULT_CREATION',
  /**
   * Controls whether concurrent UTXO withdrawals for Porto are enabled. This is a
   *  temporary feature flag to allow testing the feature before it is fully enabled.
   */
  CONCURRENT_UTXO_WITHDRAWALS_PORTO = 'CONCURRENT_UTXO_WITHDRAWALS_PORTO',
  /** Controls whether customer override is enabled for the organization. */
  CUSTOMER_OVERRIDE = 'CUSTOMER_OVERRIDE',
  /** Enable Deposit Attribution API for an org */
  DEPOSIT_ATTRIBUTION_API = 'DEPOSIT_ATTRIBUTION_API',
  /** Enable Deposit Attribution Blocking Screening for an org */
  DEPOSIT_ATTRIBUTION_BLOCKING_SCREENING = 'DEPOSIT_ATTRIBUTION_BLOCKING_SCREENING',
  /** Controls whether address pre-provisioning is disabled. */
  DISABLE_ADDRESS_PRE_PROVISIONING = 'DISABLE_ADDRESS_PRE_PROVISIONING',
  /** Enable experimental implementations of concurrent withdrawals. */
  EXPERIMENTAL_CONCURRENT_WITHDRAWALS = 'EXPERIMENTAL_CONCURRENT_WITHDRAWALS',
  /** Enable AML enforcement on external transfers. */
  EXTERNAL_TRANSFERS_AML = 'EXTERNAL_TRANSFERS_AML',
  /** Controls the automation of risk review. */
  EXTERNAL_TRANSFER_AUTO_RISK_REVIEW = 'EXTERNAL_TRANSFER_AUTO_RISK_REVIEW',
  /** Enable anchorage internal alerts on client external withdrawals & transfers */
  EXTERNAL_WITHDRAWAL_ALERT = 'EXTERNAL_WITHDRAWAL_ALERT',
  /** Enable use of fiat assets */
  FIAT_ENABLED = 'FIAT_ENABLED',
  /** Controls the ability to enable AML auto completion with the respective Trusted Destination. */
  FILL_AML_WITH_TRUSTED_DESTINATION = 'FILL_AML_WITH_TRUSTED_DESTINATION',
  /** Controls whether the organization automatically claims its rewards or automatically delegates its rewards */
  FLOW_AUTO_REWARD_DELEGATION_DISABLED = 'FLOW_AUTO_REWARD_DELEGATION_DISABLED',
  /** Enables an organization to use API endpoints for holds. */
  HOLDS = 'HOLDS',
  /**
   *  Controls whether the ledger imports blockchain events
   * for the organization.
   */
  LEDGER_IMPORT_BLOCKCHAIN_EVENTS = 'LEDGER_IMPORT_BLOCKCHAIN_EVENTS',
  /** Controls whether location based authorization is enabled */
  LOCATION_BASED_AUTHORIZATION = 'LOCATION_BASED_AUTHORIZATION',
  /** Enable Onboarding API for an org */
  ONBOARDING_API = 'ONBOARDING_API',
  /** Controls the access to the Onboarding API TCS Exemption per organization. Some RIAs will have a different term and conditions signature flow with their Program Customers that Anchorage does not need to enforce. */
  ONBOARDING_API_TERMS_EXEMPTION = 'ONBOARDING_API_TERMS_EXEMPTION',
  /** Controls Whether the use of PC joins account is enabled for the client. */
  ONBOARDING_PC_JOINT_ACCOUNT = 'ONBOARDING_PC_JOINT_ACCOUNT',
  /** Controls whether optimized batch address generation is enabled. */
  OPTIMIZED_BATCH_ADDRESS_GENERATION = 'OPTIMIZED_BATCH_ADDRESS_GENERATION',
  /** Controls whether the ProgramCustomer Statements include the management fee */
  PC_STATEMENTS_MANAGEMENT_FEE = 'PC_STATEMENTS_MANAGEMENT_FEE',
  /** returns only Assets with sub-id zero vs all assets within a vault */
  RETURN_LEGACY_ASSET_SUB_IDS = 'RETURN_LEGACY_ASSET_SUB_IDS',
  /** Controls whether the RIA are CC'd on PC statement emails. */
  RIA_CC_ON_PC_EMAILS = 'RIA_CC_ON_PC_EMAILS',
  /** Enable RIA flat fee enhancement */
  RIA_FLAT_FEE = 'RIA_FLAT_FEE',
  /** Enable risk assessment for smart contracts */
  RISK_SMART_CONTRACTS = 'RISK_SMART_CONTRACTS',
  /** Controls whether shared policies functionality is enabled for the organization. */
  SHARED_POLICIES = 'SHARED_POLICIES',
  /** Enable skip Deposit Attribution for testing purposes for a specific org */
  SKIP_DEPOSIT_ATTRIBUTION_FOR_TESTING_PURPOSES = 'SKIP_DEPOSIT_ATTRIBUTION_FOR_TESTING_PURPOSES',
  /** Enable skip Risk Review for testing purposes for a specific org */
  SKIP_RISK_REVIEW_FOR_TESTING_PURPOSES = 'SKIP_RISK_REVIEW_FOR_TESTING_PURPOSES',
  /** Show statements generated by the `statements` service. */
  STATEMENTS_V2 = 'STATEMENTS_V2',
  /** Enable Sub Quorums for an org */
  SUB_QUORUMS = 'SUB_QUORUMS',
  /** Controls the ability to request allocation when executing a quote. */
  TRADING_ALLOCATION = 'TRADING_ALLOCATION',
  /** Enable Trading order API for an org */
  TRADING_MARKET_ORDER = 'TRADING_MARKET_ORDER',
  /** Controls the access to the transfer access requests functionality. */
  TRANSFER_ACCESS_REQUEST = 'TRANSFER_ACCESS_REQUEST',
  /** Enables deposit/withdraw functionality in Client Web Dashboard through vault details page. */
  VAULT_DETAILS_OPERATION = 'VAULT_DETAILS_OPERATION',
  /** Controls whether Virtual Accounts owner onboarding is enabled for the organization. */
  VA_OWNER_ONBOARDING = 'VA_OWNER_ONBOARDING',
  /** Indicates whether wallets apiv2 functionality is enabled */
  WALLETS_APIV2 = 'WALLETS_APIV2',
  /** Kill Siwtch the Wallet API Phase3: wallet_creation and address_provision */
  WALLETS_APIV2_PHASE3_KILL_SWITCH = 'WALLETS_APIV2_PHASE3_KILL_SWITCH',
  /**
   * Controls whether the wallet creation action should attempt to provision new
   * addresses when none are available.
   */
  WALLET_CREATE_AUTO_PROVISION = 'WALLET_CREATE_AUTO_PROVISION'
}

export enum FeeApproach {
  FIXED_FEE = 'FIXED_FEE',
  FIXED_FEE_PER_ASSET = 'FIXED_FEE_PER_ASSET',
  MINIMUM_FEE = 'MINIMUM_FEE',
  MINIMUM_FEE_PER_ASSET = 'MINIMUM_FEE_PER_ASSET'
}

/** FeeCalculation represents a fee calculation for a specific period */
export type FeeCalculation = {
  __typename: 'FeeCalculation';
  /** Fee amount calculated */
  amount: Scalars['String']['output'];
  /** End date of the period */
  endDate: Scalars['Date']['output'];
  /** Fee calculation ID */
  feeCalculationID: Scalars['String']['output'];
  /** Type of the fee */
  feeType: FeeTypeType;
  /** Rate applied for the fee calculation */
  rate: Scalars['String']['output'];
  /** Start date of the period */
  startDate: Scalars['Date']['output'];
  /** Current state of the fee calculation */
  state: FeeCalculationStateType;
  /** Total balance used for calculation if applicable */
  totalBalance: Maybe<Scalars['String']['output']>;
  /** Transaction ID associated to the fee calculation */
  transactionID: Maybe<Scalars['String']['output']>;
};

/** FeeCalculationConnection implements the connections spec */
export type FeeCalculationConnection = {
  __typename: 'FeeCalculationConnection';
  /** edges implements the connections spec */
  edges: Array<FeeCalculation>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
};

/** FeeCalculationStateType represents the possible states of a fee calculation */
export enum FeeCalculationStateType {
  /** DONE indicates the fee calculation is completed and settled */
  DONE = 'DONE',
  /** ONGOING indicates the fee is currently being calculated */
  ONGOING = 'ONGOING',
  /** PENDING_SETTLEMENT indicates the fee is calculated and waiting settlement */
  PENDING_SETTLEMENT = 'PENDING_SETTLEMENT',
  /** SETTLING indicates the fee is currently being settled */
  SETTLING = 'SETTLING',
  /** UNKNOWN represents an unknown state */
  UNKNOWN = 'UNKNOWN'
}

/** FeeConfig represents a fee configuration associated to an organization */
export type FeeConfig = {
  __typename: 'FeeConfig';
  /** Internal ID of the fee configuration */
  feeConfigID: Scalars['String']['output'];
  /** Period of the configured fee */
  feePeriod: FeePeriodType;
  /** Rate of the configured fee */
  feeRate: Scalars['Float']['output'];
  /** Target of the fee configuration */
  feeTarget: FeeTargetType;
  /** Target ID of the fee configuration */
  feeTargetID: Maybe<Scalars['String']['output']>;
  /** Type of the configured fee */
  feeType: FeeTypeType;
  /** Is billable defines if we directly bill the target */
  isBillable: Scalars['Boolean']['output'];
  /** Org ID associated to the case */
  orgKeyID: Scalars['String']['output'];
  /** Start date of the configured fee */
  startDate: Scalars['Date']['output'];
};

/** FeeConfigConnection implements the connections spec */
export type FeeConfigConnection = {
  __typename: 'FeeConfigConnection';
  /** edges implements the connections spec */
  edges: Array<FeeConfig>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
};

/**
 * FeeCustomization allows for customization of how transaction fees can be calculated.
 *
 * For detailed explanation, see doc for: type FeeCustomization.
 */
export type FeeCustomization = {
  /**
   * This enum value corresponds to a numeric value that is used as multiplier
   * for ERC20 transactions when calculating gas fee.
   */
  feeReservationLevel?: BaseFeePerGasMultiplierLevel;
};

export type FeeGroup = {
  __typename: 'FeeGroup';
  baseFee: Maybe<Scalars['Float']['output']>;
  feeRates: Array<FeeRate>;
  groupItems: Array<Scalars['String']['output']>;
  isDefaultRate: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type FeeGroupInput = {
  baseFee?: InputMaybe<Scalars['Float']['input']>;
  feeRates: Array<FeeRateInput>;
  groupItems: Array<Scalars['String']['input']>;
  isDefaultRate: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** FeePeriod are the possible periods of fees */
export enum FeePeriodType {
  /** AD_HOC represents the manual fee period */
  AD_HOC = 'AD_HOC',
  /** MONTHLY represents the monthly fee period */
  MONTHLY = 'MONTHLY',
  /** UNKNOWN represents an unknown period */
  UNKNOWN = 'UNKNOWN'
}

export type FeePrefillMetadata = {
  __typename: 'FeePrefillMetadata';
  baseFee: Maybe<Scalars['Float']['output']>;
  chargeMethod: Maybe<ChargeMethod>;
  feeApproach: Maybe<AgreementsFeeApproach>;
  feeTypeIdentifier: Scalars['String']['output'];
  groups: Maybe<Array<Maybe<FeeGroup>>>;
  hasGraduatedFeeRate: Maybe<Scalars['Boolean']['output']>;
  minimumFeeType: Maybe<AgreementsMinimumFeeType>;
  rateUnit: Maybe<FeeRateUnit>;
};

export type FeeRate = {
  __typename: 'FeeRate';
  rate: Scalars['Float']['output'];
  tierFloor: Scalars['Float']['output'];
};

export type FeeRateInput = {
  rate: Scalars['Float']['input'];
  tierFloor: Scalars['Float']['input'];
};

/** BPS and PERCENTAGE are annual rates; the _MONTHLY variants are the same unit quoted per month. */
export enum FeeRateUnit {
  BPS = 'BPS',
  BPS_MONTHLY = 'BPS_MONTHLY',
  PERCENTAGE = 'PERCENTAGE',
  PERCENTAGE_MONTHLY = 'PERCENTAGE_MONTHLY',
  USD = 'USD'
}

/** FeeTargetType are the possible types of fee targets */
export enum FeeTargetType {
  /** SUBACCOUNT represents a ledger subacount */
  SUBACCOUNT = 'SUBACCOUNT',
  /** UNKNOWN represents an unknown target */
  UNKNOWN = 'UNKNOWN'
}

/**
 * A fee configuration entry in the registry (billing.fee_types). The table is append-only:
 * id is one version, feeTypeIdentifier is stable across versions.
 */
export type FeeType = {
  __typename: 'FeeType';
  /**
   * Anchorage legal entities the fee type may be applied to, resolved from
   * allowedAnchorageLegalEntityIds.
   */
  allowedAnchorageLegalEntities: Array<AnchorageLegalEntity>;
  allowedAnchorageLegalEntityIds: Array<Scalars['ID']['output']>;
  category: FeeTypeCategory;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  defaultFeeTerms: Maybe<GenericFeeTerms>;
  defaultsAppliedToAllAccounts: Scalars['Boolean']['output'];
  feeTypeIdentifier: Scalars['String']['output'];
  groupType: Maybe<GroupType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  netsuiteItemType: Maybe<NetsuiteInvoiceItemType>;
  status: FeeTypeStatus;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  usageEntityType: Maybe<UsageEntityType>;
  usageUnit: Maybe<UsageUnit>;
};

export enum FeeTypeCategory {
  FIXED_FEE = 'FIXED_FEE',
  USAGE_FEE = 'USAGE_FEE'
}

export type FeeTypeCreateInput = {
  allowedAnchorageLegalEntityIds: Array<Scalars['ID']['input']>;
  category: FeeTypeCategory;
  defaultFeeTerms?: InputMaybe<GenericFeeTermsInput>;
  defaultsAppliedToAllAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  feeTypeIdentifier: Scalars['String']['input'];
  groupType?: InputMaybe<GroupType>;
  name: Scalars['String']['input'];
  netsuiteItemId?: InputMaybe<Scalars['String']['input']>;
  /** Required for USAGE_FEE. */
  usageEntityType?: InputMaybe<UsageEntityType>;
  usageUnitID?: InputMaybe<Scalars['ID']['input']>;
};

export type FeeTypePayload = {
  __typename: 'FeeTypePayload';
  success: Scalars['Boolean']['output'];
};

export enum FeeTypeStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  IN_REVIEW = 'IN_REVIEW'
}

/** FeeTypeType are the possible types of fees */
export enum FeeTypeType {
  /** ADVISORY represents the Advisory fee type */
  ADVISORY = 'ADVISORY',
  /** CUSTODY represents the Custody fee type */
  CUSTODY = 'CUSTODY',
  /** MANAGEMENT represents the Management fee type */
  MANAGEMENT = 'MANAGEMENT',
  /** MODEL represents the Model fee type */
  MODEL = 'MODEL',
  /** UNKNOWN represents an unknown fee type */
  UNKNOWN = 'UNKNOWN'
}

/**
 * Every field here fully replaces the corresponding value on the new version - a full replace, not a
 * partial update. Fields not present here can't be changed - they always carry over unchanged.
 */
export type FeeTypeUpdateInput = {
  allowedAnchorageLegalEntityIds: Array<Scalars['ID']['input']>;
  defaultFeeTerms?: InputMaybe<GenericFeeTermsInput>;
  defaultsAppliedToAllAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Settable only if the fee type doesn't already have one, and only for USAGE_FEE categories; once set, it can't be changed. */
  groupType?: InputMaybe<GroupType>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  netsuiteItemId?: InputMaybe<Scalars['String']['input']>;
  /** Settable only if the fee type doesn't already have one; once set, it can't be changed. */
  usageUnitID?: InputMaybe<Scalars['ID']['input']>;
};

export type FeeTypesFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<FeeTypeStatus>>;
};

/**
 * A single version row of a fees agreement, covering a set of accounts under one Anchorage
 * legal entity.
 */
export type FeesAgreement = {
  __typename: 'FeesAgreement';
  /** Top level account ids covered by this agreement. */
  accountIds: Array<Scalars['ID']['output']>;
  /** Url of the agreement document, if any. */
  agreementUrl: Maybe<Scalars['String']['output']>;
  /** Reason given for the amendment, if this row is an amendment. */
  amendmentReason: Maybe<Scalars['String']['output']>;
  /** Url of the amendment document, if this row is an amendment. */
  amendmentUrl: Maybe<Scalars['String']['output']>;
  /** Anchorage legal entity this agreement is contracted under. */
  anchorageEntityId: Scalars['ID']['output'];
  /** Whether the agreement renews automatically after the renewal term. */
  autoRenewalEnabled: Scalars['Boolean']['output'];
  /** Billing cadence for this agreement. */
  billingFrequency: BillingFrequency;
  /**
   * Payment terms for invoices under this agreement. Null for an agreement not written since payment
   * terms were added.
   */
  billingTerms: Maybe<BillingTerms>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  /** Date after which fees are accrued. */
  feeAccrualDate: Scalars['Date']['output'];
  /** Per-fee-type generic terms on this agreement. */
  feeTerms: Array<GenericFeeTerms>;
  /** Id of this agreement row. */
  id: Scalars['ID']['output'];
  /**
   * Id of the logical agreement this row is a version of, shared by every version. Use with
   * `parentIds` to fetch all versions once you have any one of them.
   */
  parentId: Scalars['ID']['output'];
  /** Number of months after which the agreement is auto renewed, if set. */
  renewalTermMonths: Maybe<Scalars['Int']['output']>;
  reviewedAt: Maybe<Scalars['Time']['output']>;
  reviewedBy: Maybe<Scalars['String']['output']>;
  /** Date when the agreement starts taking effect. */
  startDate: Scalars['Date']['output'];
  status: AgreementStatus;
  /** Date this agreement terminates, if any. */
  terminationDate: Maybe<Scalars['Date']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  /** Version number of this row within its logical agreement (parentId), starting at 1. */
  version: Scalars['Int']['output'];
};

export type FeesAgreementConnection = {
  __typename: 'FeesAgreementConnection';
  edges: Array<FeesAgreementEdge>;
  pageInfo: PageInfo;
};

export type FeesAgreementCreateInput = {
  /** Top level account ids to cover under this agreement */
  accountIds: Array<Scalars['ID']['input']>;
  /** Url of the agreement document */
  agreementUrl?: InputMaybe<Scalars['String']['input']>;
  /** Anchorage legal entity this agreement is contracted under */
  anchorageLegalEntityId: Scalars['ID']['input'];
  /** Defines if the agreement renews automatically after the renewal term */
  autoRenewalEnabled: Scalars['Boolean']['input'];
  /** Billing cadence for this agreement */
  billingFrequency: BillingFrequency;
  /** Payment terms for invoices under this agreement. Omitted or null stores NET30. */
  billingTerms?: InputMaybe<BillingTerms>;
  /** Date after which fees are accrued */
  feeAccrualDate: Scalars['Date']['input'];
  /** Per-fee-type terms for this agreement */
  feeTerms: Array<GenericFeeTermsInput>;
  /** Number of months after which the agreement is auto renewed */
  renewalTermMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Date when the agreement starts taking effect */
  startDate: Scalars['Date']['input'];
};

export type FeesAgreementEdge = {
  __typename: 'FeesAgreementEdge';
  cursor: Scalars['ID']['output'];
  node: FeesAgreement;
};

export type FeesAgreementPayload = {
  __typename: 'FeesAgreementPayload';
  success: Scalars['Boolean']['output'];
};

export type FeesAgreementTerminateInput = {
  /**
   * Id of the agreement version being terminated, which must be its currently active version. A stale
   * id is rejected, so resolve the active version before terminating. Termination is also rejected
   * while an amendment is pending approval on the same agreement.
   */
  id: Scalars['ID']['input'];
  /** Date the agreement is requested to terminate on. Past dates are accepted. */
  terminationDate: Scalars['Date']['input'];
};

export type FeesAgreementTerminationApproveInput = {
  /** Id of the agreement version under termination review. */
  id: Scalars['ID']['input'];
  /** True to approve the termination request, false to reject it. */
  isApproval: Scalars['Boolean']['input'];
};

export type FeesAgreementUpdateInput = {
  /** Top level account ids to cover under this agreement */
  accountIds: Array<Scalars['ID']['input']>;
  /** Url of the agreement document */
  agreementUrl?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the amendment */
  amendmentReason?: InputMaybe<Scalars['String']['input']>;
  /** Url of the amendment document */
  amendmentUrl?: InputMaybe<Scalars['String']['input']>;
  /** Anchorage legal entity this agreement is contracted under */
  anchorageLegalEntityId: Scalars['ID']['input'];
  /** Defines if the agreement renews automatically after the renewal term */
  autoRenewalEnabled: Scalars['Boolean']['input'];
  /** Billing cadence for this agreement */
  billingFrequency: BillingFrequency;
  /**
   * Payment terms for invoices under this agreement. Omitted or null keeps the current value, or stores
   * NET30 if there is none.
   */
  billingTerms?: InputMaybe<BillingTerms>;
  /** Date after which fees are accrued */
  feeAccrualDate: Scalars['Date']['input'];
  /** Per-fee-type terms replacing the current ones */
  feeTerms: Array<GenericFeeTermsInput>;
  /**
   * Id of the agreement version being amended: the active version (creates a new pending version), or
   * your own still-pending version (overwritten in place instead). A stale id or someone else's pending
   * version is rejected.
   */
  id: Scalars['ID']['input'];
  /** Number of months after which the agreement is auto renewed */
  renewalTermMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Effective date of the agreement. Must not be after feeAccrualDate. */
  startDate: Scalars['Date']['input'];
};

export type FeesAgreementsFilterInput = {
  /** Keep rows covering any of these top level account ids (array overlap). */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Keep rows contracted under any of these Anchorage legal entities. */
  anchorageEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Fetch these exact agreement rows by id. Combines with other filters via AND. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Applies every other filter above first (statuses/accountIds/anchorageEntityIds/ids/parentIds),
   * then narrows the survivors down to the single highest-version row per parentId (e.g. statuses:
   * [ACTIVE], latestVersion: true returns the highest-version ACTIVE row for each agreement, even if a
   * higher-version row exists elsewhere that isn't ACTIVE).
   */
  latestVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fetch every version row under these parent ids - same as `ids` but keyed on parentId.
   * Combines with `ids` and other filters via AND.
   */
  parentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Keep only rows in one of these statuses. */
  statuses?: InputMaybe<Array<AgreementStatus>>;
};

/** A report of a client's fiat balances at the start and end of a month */
export type FiatAccountStatement = {
  __typename: 'FiatAccountStatement';
  /** The displayable account ID, derived from the client's OrganizationKeyID and affiliate AccountID and truncated to 12 characters */
  accountID: Scalars['String']['output'];
  /** The account name, equal to the client's affiliate account name */
  accountName: Scalars['String']['output'];
  /** The ending balance as a decimal number in USD */
  endingBalance: Scalars['String']['output'];
  /** The anchorage entity, equal to the anchorage legal entity associate with this client's affiliate account */
  entityName: Scalars['String']['output'];
  /** fiat transactions for this account in this month */
  fiatTransactions: Array<FiatAccountStatementTransaction>;
  /** The organization key ID */
  organizationKeyID: Scalars['String']['output'];
  /** The organization name, equal to the client's affiliate organization name */
  organizationName: Scalars['String']['output'];
  /** The end date, in the format January 31, 2018 */
  periodEnd: Scalars['String']['output'];
  /** The start date, in the format January 1, 2018 */
  periodStart: Scalars['String']['output'];
  /** The starting balance as a decimal number in USD */
  startingBalance: Scalars['String']['output'];
};

/**
 * The representation of a fiat withdrawal or deposit
 * transaction as presented in an account statement.
 */
export type FiatAccountStatementTransaction = {
  __typename: 'FiatAccountStatementTransaction';
  /** The symbol of the asset transacted */
  currency: Scalars['String']['output'];
  /** The date the transaction was effective */
  date: Scalars['String']['output'];
  /** The quantity of asset transacted */
  quantity: Scalars['String']['output'];
  /** The type of transaction */
  transactionType: Scalars['String']['output'];
};

export enum FiatBankAccountOwner {
  A1 = 'A1',
  B2B = 'B2B',
  HOLD = 'HOLD',
  RIA = 'RIA',
  STABLE = 'STABLE'
}

export enum FiatBankName {
  BNY = 'BNY',
  CB = 'CB',
  CRB = 'CRB'
}

/** Extra parameters for fiat */
export type FiatExtraParams = {
  __typename: 'FiatExtraParams';
  /** accountNumber is the account number of the destination */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Beneficiary Identifier */
  beneficiaryID: Maybe<Scalars['String']['output']>;
  /** Destination virtual account of this fiat withdrawal, part of the endorsed payload */
  destinationVirtualAccountID: Maybe<Scalars['String']['output']>;
  /** Last 4 characters of the destination virtual account's number, part of the endorsed payload */
  destinationVirtualAccountNumberLast4: Maybe<Scalars['String']['output']>;
  /** Financial Institution Identifier */
  financialInstitutionID: Maybe<Scalars['String']['output']>;
  /** Note to the beneficiary of this fiat withdrawal */
  memo: Maybe<Scalars['String']['output']>;
  /** Purpose of this fiat withdrawal */
  purpose: Maybe<Scalars['String']['output']>;
  /** routingNumber is the routing number of the destination */
  routingNumber: Maybe<Scalars['String']['output']>;
  /** standingInstructionId is the id of the standing instruction */
  standingInstructionId: Maybe<Scalars['String']['output']>;
  /** Unique Identifier of a Trusted Destination */
  trustedDestinationID: Maybe<Scalars['String']['output']>;
  /** Source virtual account of this fiat withdrawal, part of the endorsed payload */
  virtualAccountID: Maybe<Scalars['String']['output']>;
  /** Last 4 characters of the source virtual account's number, part of the endorsed payload */
  virtualAccountNumberLast4: Maybe<Scalars['String']['output']>;
};

export type FiatInterestFee = {
  __typename: 'FiatInterestFee';
  currency: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
};

export type FiatInterestFeeTermsDetail = {
  __typename: 'FiatInterestFeeTermsDetail';
  fees: Array<FiatInterestFee>;
};

/** Fiat trusted destination type */
export type FiatTrustedDestination = {
  __typename: 'FiatTrustedDestination';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the fiat trusted destination */
  fiatTrustedDestinationID: Scalars['ID']['output'];
  /** id is the unique identifier of the fiat trusted destination, equal to fiatTrustedDestinationID */
  id: Scalars['ID']['output'];
  instruction: FiatTrustedDestinationIntruction;
  kind: FiatTrustedDestinationKind;
  name: Scalars['String']['output'];
  noteToBeneficiary: Maybe<Scalars['String']['output']>;
  organizationKeyID: Scalars['ID']['output'];
  /**
   * The removal operation for this trusted destination while it is still awaiting a final state.
   * Null when no removal is in progress, or when the removal operation's state could not be read.
   */
  pendingRemovalOperationID: Maybe<Scalars['ID']['output']>;
  state: FiatTrustedDestinationState;
  updatedAt: Scalars['DateTime']['output'];
  /** Null for ACH pull-authorization trusted destinations; usage does not apply to a debit grant. */
  usage: Maybe<FiatTrustedDestinationUsage>;
};

/**
 * Fiat trusted destination ACH pull-authorization type: a grant to an originator to pull funds
 * up to perTransactionLimit. The trusted destination's name doubles as the vendor name; there is
 * no separate vendor-name field.
 */
export type FiatTrustedDestinationACHPullAuthorization = {
  __typename: 'FiatTrustedDestinationACHPullAuthorization';
  /** NACHA Company IDs authorized to pull against this grant, each up to 10 alphanumeric characters */
  companyIds: Array<Scalars['String']['output']>;
  /**
   * Per-transaction limit as a decimal USD string ("dollars.cents"), byte-identical to the
   * HSM-signed canonical form on the operation card
   */
  perTransactionLimit: Scalars['String']['output'];
};

/** Fiat trusted destination ACH push (credit) type */
export type FiatTrustedDestinationACHPush = {
  __typename: 'FiatTrustedDestinationACHPush';
  /** Account number, masked to the last 4 characters */
  accountNumber: Scalars['String']['output'];
  /** ACH routing number */
  routingNumber: Scalars['String']['output'];
};

/** Fiat trusted destination address type */
export type FiatTrustedDestinationAddress = {
  __typename: 'FiatTrustedDestinationAddress';
  /** Address Line 1 */
  addressLine1: Scalars['String']['output'];
  /** Address Line 2 */
  addressLine2: Maybe<Scalars['String']['output']>;
  /** City */
  city: Scalars['String']['output'];
  /** Country */
  country: Scalars['String']['output'];
  /** Province */
  province: Scalars['String']['output'];
  /** Zip Code */
  zipCode: Scalars['String']['output'];
};

/** Fiat trusted destination beneficiary information */
export type FiatTrustedDestinationBeneficiary = {
  __typename: 'FiatTrustedDestinationBeneficiary';
  /** Beneficiary address */
  address: FiatTrustedDestinationAddress;
  /** Beneficiary ID code */
  code: FiatTrustedDestinationIDCode;
  /** The name of the beneficiary - Business */
  entityName: Maybe<Scalars['String']['output']>;
  /** First name of the beneficiary - Individual */
  firstName: Maybe<Scalars['String']['output']>;
  /** Beneficiary ID */
  id: Scalars['String']['output'];
  /** Last name of the beneficiary - Individual */
  lastName: Maybe<Scalars['String']['output']>;
  /** Beneficiary type */
  type: FiatTrustedDestinationBeneficiaryType;
};

/** Fiat trusted destination beneficiary type */
export enum FiatTrustedDestinationBeneficiaryType {
  /** Business */
  BUSINESS = 'BUSINESS',
  /** Individual */
  INDIVIDUAL = 'INDIVIDUAL'
}

/** A connection to a list of items. */
export type FiatTrustedDestinationConnection = {
  __typename: 'FiatTrustedDestinationConnection';
  /** A list of edges. */
  edges: Array<FiatTrustedDestinationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FiatTrustedDestinationEdge = {
  __typename: 'FiatTrustedDestinationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FiatTrustedDestination;
};

/** Extra parameters for fiat trusted destinations */
export type FiatTrustedDestinationExtraParams = {
  __typename: 'FiatTrustedDestinationExtraParams';
  /** Note to the beneficiary of this fiat withdrawal */
  memo: Maybe<Scalars['String']['output']>;
  /** Purpose of this fiat withdrawal */
  purpose: Maybe<Scalars['String']['output']>;
  /** Unique Identifier of a Trusted Destination */
  trustedDestinationID: Maybe<Scalars['String']['output']>;
};

/** Fiat trusted destination destination id code type */
export enum FiatTrustedDestinationIDCode {
  /** Routing number */
  ABA = 'ABA',
  /** Swift code */
  BIC = 'BIC',
  /** Account number */
  DDA = 'DDA'
}

/** Fiat trusted destination instant trasnfer type */
export type FiatTrustedDestinationInstantTransfer = {
  __typename: 'FiatTrustedDestinationInstantTransfer';
  /** Beneficiary address */
  address: FiatTrustedDestinationAddress;
  /** The name of the beneficiary - Business */
  entityName: Maybe<Scalars['String']['output']>;
  /** First name of the beneficiary - Individual */
  firstName: Maybe<Scalars['String']['output']>;
  /** Beneficiary ID */
  id: Scalars['String']['output'];
  /** Last name of the beneficiary - Individual */
  lastName: Maybe<Scalars['String']['output']>;
  /** Beneficiary type */
  type: FiatTrustedDestinationBeneficiaryType;
};

/** Fiat trusted destination institution destination */
export type FiatTrustedDestinationInstitution = {
  __typename: 'FiatTrustedDestinationInstitution';
  /** Financial institution address */
  address: FiatTrustedDestinationAddress;
  /** Financial institution ID code */
  code: FiatTrustedDestinationIDCode;
  /** Financial institution ID */
  id: Scalars['String']['output'];
  /** The name of the financial institution */
  name: Scalars['String']['output'];
};

export type FiatTrustedDestinationIntruction = FiatTrustedDestinationACHPullAuthorization | FiatTrustedDestinationACHPush | FiatTrustedDestinationInstantTransfer | FiatTrustedDestinationWire;

/**
 * Fiat trusted destination kind. Discriminates the union member on
 * FiatTrustedDestination.instruction and, on the mutation side, which sibling input is required.
 */
export enum FiatTrustedDestinationKind {
  /**
   * ACH pull authorization: a grant to an originator, identified by Company IDs, to pull funds
   * up to a per-transaction limit
   */
  ACH_PULL_AUTHORIZATION = 'ACH_PULL_AUTHORIZATION',
  /** ACH push (credit) */
  ACH_PUSH = 'ACH_PUSH',
  /** Instant transfer */
  INSTANT_TRANSFER = 'INSTANT_TRANSFER',
  /** Wire */
  WIRE = 'WIRE'
}

/** Fiat trusted destination destination state type */
export enum FiatTrustedDestinationState {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Disabled */
  DISABLED = 'DISABLED',
  /** Errored: the approval operation failed, expired, or was canceled */
  ERRORED = 'ERRORED',
  /** Pending */
  PENDING = 'PENDING',
  /** Prepared: the destination row exists but its approval operation is not visible yet */
  PREPARED = 'PREPARED',
  /** Rejected */
  REJECTED = 'REJECTED'
}

/** Fiat trusted destination destination id code type */
export enum FiatTrustedDestinationUsage {
  /** My organization */
  MY_ORGANIZATION = 'MY_ORGANIZATION',
  /** Third party */
  THIRD_PARTY = 'THIRD_PARTY'
}

/** Fiat trusted destination Wire type */
export type FiatTrustedDestinationWire = {
  __typename: 'FiatTrustedDestinationWire';
  IntermediaryFinancialInstitution: Maybe<FiatTrustedDestinationInstitution>;
  beneficiary: FiatTrustedDestinationBeneficiary;
  financialInstitution: FiatTrustedDestinationInstitution;
};

/** FiatWithdrawalPurpose type represents the purpose field for a fiat withdrawal */
export type FiatWithdrawalPurpose = {
  __typename: 'FiatWithdrawalPurpose';
  /** Label part of the withdrawal purpose */
  label: Scalars['String']['output'];
  /** Value part of the withdrawal purpose */
  value: Scalars['String']['output'];
};

/** FillKYCQuestionnaireSubmissionDataInput is the input for fillKYCQuestionnaireSubmissionData. */
export type FillKYCQuestionnaireSubmissionDataInput = {
  /** The identifier of the submission to autofill. */
  submissionID: Scalars['ID']['input'];
};

/**
 * One option of a SINGLE_SELECT / MULTI_SELECT report filter. The list order is the
 * display order.
 */
export type FilterStaticOption = {
  __typename: 'FilterStaticOption';
  /** Human label shown for the option (e.g. fieldValue "0" shown as "12:00 AM"). */
  displayName: Scalars['String']['output'];
  /** Value echoed back when a report request selects this option. */
  fieldValue: Scalars['String']['output'];
};

export type FilterStaticOptionInput = {
  displayName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
};

export type FinalizePackageLegPriceInput = {
  /** The determined price: strike for forwards/swaps, premium per base unit for options. */
  price: Scalars['String']['input'];
  /** A leg of the package whose price is still an estimate. */
  tradeId: Scalars['ID']['input'];
};

export type FinalizePackagePriceInput = {
  /**
   * The determined price of every still-estimated leg. Must cover exactly the legs whose price
   * is still an estimate — a package finalizes as a single unit.
   */
  legs: Array<FinalizePackageLegPriceInput>;
  /** Identifier of the post-priced package to finalize. */
  packageIdentifier: Scalars['String']['input'];
  /**
   * Determined per-package price, replacing the estimate booked with the package. Required when
   * the package was booked with a price. Supply the full trio; a package cannot switch between
   * price and spread at finalization. Signed, net of premium legs: may be negative.
   */
  packageTransactionPrice?: InputMaybe<Scalars['String']['input']>;
  /** 3-char ISO currency for the package price. Required when packageTransactionPrice is set. */
  packageTransactionPriceCurrency?: InputMaybe<Scalars['String']['input']>;
  /** 1-char notation code for the package price. Required when packageTransactionPrice is set. */
  packageTransactionPriceNotation?: InputMaybe<Scalars['String']['input']>;
  /**
   * Determined per-package spread (alternative to price). Required when the package was booked
   * with a spread.
   */
  packageTransactionSpread?: InputMaybe<Scalars['String']['input']>;
  /** 3-char ISO currency for the package spread. Required when packageTransactionSpread is set. */
  packageTransactionSpreadCurrency?: InputMaybe<Scalars['String']['input']>;
  /** 1-char notation code for the package spread. Required when packageTransactionSpread is set. */
  packageTransactionSpreadNotation?: InputMaybe<Scalars['String']['input']>;
};

/** Result of fixing key accesses role bindings for multiple organizations. */
export type FixKeyAccessesRoleBindingsResult = {
  __typename: 'FixKeyAccessesRoleBindingsResult';
  /** Organization key IDs that failed to be fixed. */
  failedOrgKeyIDs: Array<Scalars['String']['output']>;
  /** Organization key IDs that were successfully fixed. */
  successfulOrgKeyIDs: Array<Scalars['String']['output']>;
};

export type FixPersonIndividualBindingsResult = {
  __typename: 'FixPersonIndividualBindingsResult';
  bindings: Maybe<Array<PersonIndividualBinding>>;
  errors: Maybe<Array<Scalars['String']['output']>>;
  pageInfo: PaginationInfo;
};

/** Extra parameters for flow Delegate */
export type FlowDelegateExtraParams = {
  __typename: 'FlowDelegateExtraParams';
  /** actionType is used to construct the canonical operation */
  actionType: Maybe<ExtraParamsActionType>;
  /** isStake dictates whether the operation is a delegation or staking */
  isStake: Maybe<Scalars['Boolean']['output']>;
  /** nodeID is a unique identifier for a node that can be delegate to */
  nodeID: Maybe<Scalars['String']['output']>;
};

/** FlowType represents */
export enum FlowType {
  /** invalid represents */
  INVALID = 'INVALID',
  /** talos_institutional represents */
  TALOS_INSTITUTIONAL = 'TALOS_INSTITUTIONAL',
  /** talos_retail represents */
  TALOS_RETAIL = 'TALOS_RETAIL'
}

/** Statuses that an institutional form can go through */
export enum FormStatus {
  /** All required information was collected and validated */
  COMPLETE = 'COMPLETE',
  /** The client has been created but no communications have been sent out to it */
  DRAFT = 'DRAFT',
  /** The information collection is in progress but not accepted */
  IN_PROGRESS = 'IN_PROGRESS',
  /** The form is under review and cannot be edited */
  IN_REVIEW = 'IN_REVIEW'
}

/** Fraction is a representation of fraction */
export type Fraction = {
  __typename: 'Fraction';
  /** denominator is the denominator/bottom of the fraction */
  denominator: Scalars['Int']['output'];
  /** numerator is the numerator/the top of the fraction */
  numerator: Scalars['Int']['output'];
};

/** FragmentBindingSortField are the options for sorting a list of fragment bindings. */
export enum FragmentBindingSortField {
  /**
   * DISPLAY_NAME sorts by the fragment bindings display name.
   * The default policy will always be at the top of the list.
   */
  DISPLAY_NAME = 'DISPLAY_NAME'
}

export type FreezeAccountInput = {
  accountId: Scalars['ID']['input'];
  /**
   * Caller-supplied key for this one freeze. A retry with the same key returns
   * the first result instead of acting again. Must not be empty.
   */
  idempotencyKey: Scalars['String']['input'];
  /** Why compliance is freezing the account. Required, must not be blank. */
  reason: Scalars['String']['input'];
};

export type FreezeAccountResult = {
  __typename: 'FreezeAccountResult';
  accountId: Scalars['ID']['output'];
};

/** GDFActivityInitiator identifies whoever initiated an activity by their party role and participant name. */
export type GDFActivityInitiator = {
  __typename: 'GDFActivityInitiator';
  /** The display name of the participant that initiated this activity. Null when no participant name is available. */
  participantName: Maybe<Scalars['String']['output']>;
  /** The party role of the initiator (e.g. pledgor, securedParty, custodian). */
  party: GDFPartyType;
};

/** Adjustment configuration for increase/decrease (output) */
export type GDFAdjustmentConfig = {
  __typename: 'GDFAdjustmentConfig';
  /** The action name */
  actionName: ControlAgreementAction;
  /** Allowed initiators for this action */
  allowedInitiators: GDFAllowedInitiators;
};

/** Adjustment configuration for increase/decrease (input) */
export type GDFAdjustmentConfigInput = {
  /** The action name */
  actionName: ControlAgreementAction;
  /** Allowed initiators for this action */
  allowedInitiators: GDFAllowedInitiatorsInput;
};

/** Allowed initiator configuration (output) */
export type GDFAllowedInitiator = {
  __typename: 'GDFAllowedInitiator';
  /** The party allowed to initiate */
  party: GDFPartyType;
  /** List of required approvers */
  requiredApprovers: Array<GDFRequiredApprover>;
};

/** Allowed initiator configuration (input) */
export type GDFAllowedInitiatorInput = {
  /** The party allowed to initiate */
  party: GDFPartyType;
  /** List of required approvers */
  requiredApprovers: Array<GDFRequiredApproverInput>;
};

/** Allowed initiators for an action (output) */
export type GDFAllowedInitiators = {
  __typename: 'GDFAllowedInitiators';
  /** Custodian initiator config */
  custodian: Maybe<GDFAllowedInitiator>;
  /** Pledgor initiator config */
  pledgor: Maybe<GDFAllowedInitiator>;
  /** Secured party initiator config */
  securedParty: Maybe<GDFAllowedInitiator>;
};

/** Allowed initiators for an action (input) */
export type GDFAllowedInitiatorsInput = {
  /** Custodian initiator config */
  custodian?: InputMaybe<GDFAllowedInitiatorInput>;
  /** Pledgor initiator config */
  pledgor?: InputMaybe<GDFAllowedInitiatorInput>;
  /** Secured party initiator config */
  securedParty?: InputMaybe<GDFAllowedInitiatorInput>;
};

/** Approval method for control agreement actions */
export enum GDFApprovalMethod {
  /** Click button approval */
  clickButton = 'clickButton',
  /** Quorum approval required */
  quorum = 'quorum'
}

/** Control Agreement type */
export type GDFControlAgreement = {
  __typename: 'GDFControlAgreement';
  /** The parties in the agreement whom the requesting user may represent */
  PartiesCallerRepresents: Array<GDFPartyType>;
  /** When the agreement became active (null if not yet active) */
  activeAt: Maybe<Scalars['Time']['output']>;
  /**
   * Activities for this control agreement. Accepts the same filter as the
   * controlAgreementActivities query, but controlAgreementID is always overridden
   * to this agreement's ID.
   */
  activities: ControlAgreementActivityConnection;
  /**
   * The activity types the requesting user can filter this agreement's activities by, as their
   * party reads them (a pledgor is offered PLEDGE and UNLOCK, a secured party SECURE and
   * RELEASE). CREATE_OES_AGREEMENT is not offered, nor is AMICABLE_CLOSE: no stored activity
   * type maps to it, so filtering by it is rejected as unsupported.
   */
  activityTypeOptions: Array<ControlAgreementActivityType>;
  /**
   * Present if any activity on this control agreement has an outstanding action for
   * the requesting user; null otherwise. Clicking through takes the user to this
   * agreement's detail view, same as clicking the row.
   *
   * Always null for staff users and anyone else representing no party in the agreement.
   */
  callToAction: Maybe<CallToAction>;
  /** Control agreement configuration */
  config: ControlAgreementConfig;
  /** When the control agreement was created */
  createdAt: Scalars['Time']['output'];
  /** Delegations associated with this control agreement */
  delegations: Array<GDFDelegation>;
  /** Optional document ID associated with the control agreement */
  documentID: Maybe<Scalars['ID']['output']>;
  /**
   * The exchange's current Exchange Display Name, the name every screen and every signed payload
   * shows for the exchange. Read live, so a rename reaches existing agreements. Null unless this
   * is an OES agreement whose exchange has a display name; show the participant name then.
   */
  exchangeDisplayName: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the control agreement */
  id: Scalars['ID']['output'];
  /**
   * Name of the control agreement. An OES agreement is named after its exchange's current Exchange
   * Display Name and the trader's exchange account, so a rename reaches existing agreements; it
   * keeps its stored name while the exchange has no display name.
   */
  name: Scalars['String']['output'];
  /** OES-specific fields; null unless this is an OES agreement */
  oes: Maybe<GDFOESAgreementParams>;
  /**
   * The ID of the increase, decrease, settlement or seize activity recorded as in progress
   * on the agreement's first delegation, or null when none is.
   */
  pendingActivityID: Maybe<Scalars['ID']['output']>;
  /** The Atlas participant object of the pledgor */
  pledgorAtlasParticipant: SNParticipant;
  /** Ratification details for the control agreement */
  ratification: GDFControlAgreementRatificationDetails;
  /** The Atlas participant object of the secured party */
  securedPartyAtlasParticipant: SNParticipant;
  /** The status of the control agreement */
  status: GDFControlAgreementStatus;
  /** When the agreement was terminated (null if not yet terminated) */
  terminatedAt: Maybe<Scalars['Time']['output']>;
  /**
   * Total value of all delegated assets across all delegations, converted to USD.
   * $0 if there are no delegations or delegated assets.
   * Null if any delegated asset is missing price data.
   */
  totalDelegatedAssetValueUSD: Maybe<Amount>;
  /** When the control agreement was last updated */
  updatedAt: Scalars['Time']['output'];
  /**
   * Historical USD value of all delegated assets over a time window.
   * Returns up to 300 data points bucketed across the requested window.
   * Returns an empty list if no snapshot data exists.
   */
  valueHistory: Array<GDFControlAgreementValueSnapshot>;
};


/** Control Agreement type */
export type GDFControlAgreementactivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ControlAgreementActivitiesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Control Agreement type */
export type GDFControlAgreementvalueHistoryArgs = {
  timeWindow: GDFValueHistoryTimeWindow;
};

export type GDFControlAgreementConnection = {
  __typename: 'GDFControlAgreementConnection';
  /** A list of edges. */
  edges: Array<GDFControlAgreementEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GDFControlAgreementEdge = {
  __typename: 'GDFControlAgreementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GDFControlAgreement;
};

/** Ratification details for a control agreement */
export type GDFControlAgreementRatificationDetails = {
  __typename: 'GDFControlAgreementRatificationDetails';
  /** When the pledgor ratified (null if not yet ratified) */
  pledgorRatified: Maybe<Scalars['Time']['output']>;
  /** The pledgor's ratifying operation (null if ratification has not yet started) */
  pledgorRatifyingOperation: Maybe<OffChainOperation>;
  /** The operation ID for the pledgor's ratification (null if ratification has not yet started) */
  pledgorRatifyingOperationID: Maybe<Scalars['String']['output']>;
  /** The policy vault ID for the pledgor's ratification */
  pledgorRatifyingPolicyVaultID: Scalars['String']['output'];
  /** When the secured party ratified (null if not yet ratified) */
  securedPartyRatified: Maybe<Scalars['Time']['output']>;
  /** The secured party's ratifying operation (null if ratification has not yet started) */
  securedPartyRatifyingOperation: Maybe<OffChainOperation>;
  /** The operation ID for the secured party's ratification (null if ratification has not yet started) */
  securedPartyRatifyingOperationID: Maybe<Scalars['String']['output']>;
  /** The policy vault ID for the secured party's ratification */
  securedPartyRatifyingPolicyVaultID: Scalars['String']['output'];
};

/** Status of a control agreement */
export enum GDFControlAgreementStatus {
  /** All parties have ratified, agreement is in effect */
  ACTIVE = 'ACTIVE',
  /** Agreement is in dispute (Notice to Contest received). Quorum policy has been switched to Joint-only. The agreement otherwise remains active and in-progress operations continue under the new Joint policy. */
  IN_DISPUTE = 'IN_DISPUTE',
  /** One party or Anchorage backoffice has created the agreement; waiting for all parties to ratify */
  PROPOSED = 'PROPOSED',
  /** One party has rejected the proposed agreement; it never became active */
  REJECTED = 'REJECTED',
  /** LEGACY: previously produced by the SuspendControlAgreement mutation. No longer produced. Retained for back-compat. */
  SUSPENDED = 'SUSPENDED',
  /** Agreement is terminated; holds on pledgor funds have been released, or funds have been transferred to secured party */
  TERMINATED = 'TERMINATED'
}

/**
 * A single data point in a control agreement value history.
 * recordedAt is the bucket midpoint, not a raw snapshot timestamp.
 */
export type GDFControlAgreementValueSnapshot = {
  __typename: 'GDFControlAgreementValueSnapshot';
  /** Whether this data point was derived from carry-forward data (no real snapshot existed) */
  isCarryForward: Scalars['Boolean']['output'];
  /** Timestamp at the midpoint of this bucket */
  recordedAt: Scalars['Time']['output'];
  /** USD value (average of non-carry-forward snapshots in this bucket) */
  usdValue: Amount;
};

export type GDFDelegatedAsset = {
  __typename: 'GDFDelegatedAsset';
  /** The asset amount, containing both an asset type (e.g., BTC, ETH, USDC) and quantity */
  amount: Amount;
  /** When the asset was created */
  createdAt: Scalars['Time']['output'];
  /** The delegatee participant ID */
  delegateeID: Scalars['ID']['output'];
  /** The delegation ID this asset belongs to */
  delegationID: Scalars['ID']['output'];
  /** The delegator participant ID */
  delegatorID: Scalars['ID']['output'];
  /** The hold ID (for root delegated assets) */
  holdID: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the delegated asset */
  id: Scalars['ID']['output'];
  /** The parent delegated asset ID (for sub-delegated assets) */
  parentID: Maybe<Scalars['ID']['output']>;
  /**
   * The current on-chain addresses holding this asset's delegated funds, each with
   * its share of the amount. Staff and the delegator's representatives always see
   * them; the delegatee's representatives see them only when the delegation's
   * pledgorAddressDisclosure usage right is enabled, and get null otherwise. Also
   * null for wallets with more than one current address (e.g. UTXO chains) until
   * per-address balance data is available.
   */
  sourceAddresses: Maybe<Array<GDFSourceAddress>>;
  /** When the asset was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The wallet backing this delegated asset. Resolves addressGenerationType and other wallet fields. */
  wallet: Maybe<Wallet>;
  /** The wallet unique ID (for root delegated assets) */
  walletUniqueID: Scalars['String']['output'];
};

export type GDFDelegation = {
  __typename: 'GDFDelegation';
  /** When the delegation was created */
  createdAt: Scalars['Time']['output'];
  /** The delegated assets associated with this delegation */
  delegatedAssets: Array<GDFDelegatedAsset>;
  /** The delegatee participant ID */
  delegateeID: Scalars['ID']['output'];
  /** The delegator participant ID */
  delegatorID: Scalars['ID']['output'];
  /** The unique identifier of the delegation */
  id: Scalars['ID']['output'];
  /** When the delegation was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The vault unique ID */
  vaultUniqueID: Scalars['String']['output'];
};

/** GDFDelegationCreateInput is the input to gdfDelegationCreate. */
export type GDFDelegationCreateInput = {
  delegatedAssets?: InputMaybe<Array<ControlAgreementAssetAdjustmentInput>>;
  delegateeID: Scalars['ID']['input'];
  delegateeVaultUniqueID: Scalars['String']['input'];
  delegatorID: Scalars['ID']['input'];
  delegatorVaultUniqueID: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  usageRights: GDFDelegationUsageRightsInput;
};

/** GDFDelegationCreateResponse is returned by gdfDelegationCreate. */
export type GDFDelegationCreateResponse = {
  __typename: 'GDFDelegationCreateResponse';
  delegationID: Scalars['ID']['output'];
  workflowID: Scalars['String']['output'];
};

/** GDFDelegationSettleInput is the input to gdfDelegationSettle. */
export type GDFDelegationSettleInput = {
  clientReferenceID?: InputMaybe<Scalars['String']['input']>;
  delegationID: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  legs: Array<GDFDelegationSettleLegInput>;
};

/**
 * GDFDelegationSettleLegInput is one of the caller's wallets in the settlement:
 * a positive amount it receives, or a negative amount it sends.
 */
export type GDFDelegationSettleLegInput = {
  amount: AmountInput;
  walletID: Scalars['String']['input'];
};

/** GDFDelegationSettleResponse is returned by gdfDelegationSettle. */
export type GDFDelegationSettleResponse = {
  __typename: 'GDFDelegationSettleResponse';
  activityID: Scalars['ID']['output'];
};

/**
 * GDFDelegationUsageRightsInput configures what each party may do with the
 * delegation and who must approve each action.
 */
export type GDFDelegationUsageRightsInput = {
  decrease?: InputMaybe<GDFAdjustmentConfigInput>;
  increase?: InputMaybe<GDFAdjustmentConfigInput>;
  /** Discloses the pledgor's source addresses to the secured party. */
  pledgorAddressDisclosure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Grants the secured party the seize action (gdfRedeemPreauthorization). */
  seize?: InputMaybe<Scalars['Boolean']['input']>;
  version: Scalars['Int']['input'];
};

export type GDFEnrollement = {
  __typename: 'GDFEnrollement';
  /** When the enrollment was created */
  createdAt: Scalars['Time']['output'];
  /** The unique enrollment ID */
  id: Scalars['ID']['output'];
  /** The ID of the participant that was enrolled */
  snParticipantID: Scalars['ID']['output'];
  /** The enrollment status */
  status: GDFEnrollementStatus;
  /** When the enrollment was last updated */
  updatedAt: Scalars['Time']['output'];
};

export type GDFEnrollementConnection = {
  __typename: 'GDFEnrollementConnection';
  /** A list of edges. */
  edges: Array<GDFEnrollementEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GDFEnrollementEdge = {
  __typename: 'GDFEnrollementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GDFEnrollement;
};

export enum GDFEnrollementStatus {
  /** The enrollment was successful */
  ACTIVE = 'ACTIVE',
  /** The enrollment failed */
  INACTIVE = 'INACTIVE'
}

/** Notice configuration for NORC/NOEC (output) */
export type GDFNoticeConfig = {
  __typename: 'GDFNoticeConfig';
  /** The action name */
  actionName: ControlAgreementAction;
  /** Number of days for dispute window */
  disputeWindowDays: Scalars['Int']['output'];
};

/** Notice configuration for NORC/NOEC (input) */
export type GDFNoticeConfigInput = {
  /** The action name */
  actionName: ControlAgreementAction;
  /** Number of days for dispute window */
  disputeWindowDays: Scalars['Int']['input'];
};

/** Input for creating an OES agreement */
export type GDFOESAgreementCreateInput = {
  /** The Atlas participant ID of the exchange */
  exchangeParticipantID: Scalars['ID']['input'];
  /** Idempotency Key for safe retries */
  idempotencyKey: Scalars['String']['input'];
  /** The Atlas participant ID of the trader */
  pledgorAtlasParticipantID: Scalars['ID']['input'];
  /** The policy vault ID for the trader's ratification */
  pledgorRatifyingPolicyVaultID: Scalars['String']['input'];
  /** The trader's main account ID at the exchange */
  traderExchangeAccountID: Scalars['String']['input'];
};

/** Response after creating an OES agreement */
export type GDFOESAgreementCreateResponse = {
  __typename: 'GDFOESAgreementCreateResponse';
  /** The created OES agreement, in proposed status */
  controlAgreement: GDFControlAgreement;
};

/** OES-specific fields of a control agreement */
export type GDFOESAgreementParams = {
  __typename: 'GDFOESAgreementParams';
  /** The OES exchange terms profile version the agreement was created from */
  exchangeProfileID: Scalars['ID']['output'];
  /** The version number of that profile */
  exchangeProfileVersion: Scalars['Int']['output'];
  /**
   * The OES terms this agreement was created under. Stays at the pinned version after the
   * exchange publishes newer terms.
   */
  terms: GDFOESExchangeTerms;
  /** The trader's main account ID at the exchange */
  traderExchangeAccountID: Scalars['String']['output'];
};

/** GDFOESExchangeDisplayName is the name traders see for an exchange. */
export type GDFOESExchangeDisplayName = {
  __typename: 'GDFOESExchangeDisplayName';
  exchangeDisplayName: Scalars['String']['output'];
  exchangeParticipantID: Scalars['ID']['output'];
};

/** GDFOESExchangeProfile is one immutable version of an exchange's OES terms. */
export type GDFOESExchangeProfile = {
  __typename: 'GDFOESExchangeProfile';
  config: ControlAgreementConfig;
  contestationWindowSeconds: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  /** Display name of the staff member who saved this version. */
  createdBy: Scalars['String']['output'];
  documentID: Scalars['ID']['output'];
  exchangeDecisionWindowSeconds: Scalars['Int']['output'];
  /** The name traders see for the exchange. Null on versions saved before display names existed. */
  exchangeDisplayName: Maybe<Scalars['String']['output']>;
  exchangeParticipantID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  settlementIntervalCron: Maybe<Scalars['String']['output']>;
  settlementWindowSeconds: Scalars['Int']['output'];
  /** Version number, starting at 1 per exchange. The highest version is the current terms. */
  version: Scalars['Int']['output'];
};

export type GDFOESExchangeProfileConnection = {
  __typename: 'GDFOESExchangeProfileConnection';
  edges: Array<GDFOESExchangeProfileEdge>;
  pageInfo: PageInfo;
};

export type GDFOESExchangeProfileEdge = {
  __typename: 'GDFOESExchangeProfileEdge';
  cursor: Scalars['String']['output'];
  node: GDFOESExchangeProfile;
};

/** GDFOESExchangeProfileUpsertInput is the input to gdfOESExchangeProfileUpsert. */
export type GDFOESExchangeProfileUpsertInput = {
  /**
   * Full control agreement config every OES agreement with this exchange is created from. Must
   * satisfy the OES rule set: increase and decrease both configured, every initiator path
   * requiring pledgor quorum and secured party approval, and the notice of exclusive control present.
   */
  config: ControlAgreementConfigInput;
  /**
   * Seconds the pledgor has to contest a notice of exclusive control before it becomes
   * executable. May be zero; there is no default. This is the authoritative contest window:
   * config.actions.noticeOfExclusiveControl.disputeWindowDays must be 0.
   */
  contestationWindowSeconds: Scalars['Int']['input'];
  /** Reference to the umbrella agreement between Anchorage and the exchange. */
  documentID: Scalars['ID']['input'];
  /**
   * Seconds the exchange has to approve or reject a new OES agreement once the trader has
   * ratified it; an undecided agreement is then rejected. Omitted or 0 means the default of
   * 7 days (604800).
   */
  exchangeDecisionWindowSeconds?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The name traders see for the exchange. Required: a missing or blank value is rejected. Leading
   * and trailing whitespace is trimmed, and no other exchange's current profile may use it,
   * ignoring case.
   */
  exchangeDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Settlement network participant ID of the exchange. */
  exchangeParticipantID: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  /**
   * Standard 5-field cron expression (UTC) for routinely issued settlements. Omit when
   * settlements are only issued ad hoc.
   */
  settlementIntervalCron?: InputMaybe<Scalars['String']['input']>;
  /**
   * Seconds the pledgor has to authorize or reject a settlement proposal before the exchange may
   * issue a notice of exclusive control. Must be positive; there is no default.
   */
  settlementWindowSeconds: Scalars['Int']['input'];
};

/**
 * GDFOESExchangeTerms is the trader-facing view of one version of an exchange's OES terms: the
 * current version when queried by exchange, or the pinned version when read from an agreement.
 */
export type GDFOESExchangeTerms = {
  __typename: 'GDFOESExchangeTerms';
  config: ControlAgreementConfig;
  contestationWindowSeconds: Scalars['Int']['output'];
  documentID: Scalars['ID']['output'];
  exchangeDecisionWindowSeconds: Scalars['Int']['output'];
  /**
   * The exchange's Exchange Display Name. Null when this version has none; show the settlement
   * network participant name then.
   */
  exchangeDisplayName: Maybe<Scalars['String']['output']>;
  exchangeParticipantID: Scalars['ID']['output'];
  settlementIntervalCron: Maybe<Scalars['String']['output']>;
  settlementWindowSeconds: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

/**
 * GDFOESExchangeWithProfile is an exchange that has an OES exchange profile. exchangeDisplayName is
 * null when its current profile has no Exchange Display Name.
 */
export type GDFOESExchangeWithProfile = {
  __typename: 'GDFOESExchangeWithProfile';
  exchangeDisplayName: Maybe<Scalars['String']['output']>;
  exchangeParticipantID: Scalars['ID']['output'];
};

/** Party type in a control agreement */
export enum GDFPartyType {
  /** The custodian party */
  custodian = 'custodian',
  /** The pledgor party */
  pledgor = 'pledgor',
  /** The secured party */
  securedParty = 'securedParty'
}

/** Required approver configuration (output) */
export type GDFRequiredApprover = {
  __typename: 'GDFRequiredApprover';
  /** The approval method */
  method: GDFApprovalMethod;
  /** The party that must approve */
  party: GDFPartyType;
};

/** Required approver configuration (input) */
export type GDFRequiredApproverInput = {
  /** The approval method */
  method: GDFApprovalMethod;
  /** The party that must approve */
  party: GDFPartyType;
};

/** A source address currently holding a share of a delegated asset's funds. */
export type GDFSourceAddress = {
  __typename: 'GDFSourceAddress';
  /** The on-chain address currently holding delegated funds. */
  address: Scalars['String']['output'];
  /** The amount of delegated funds held at this address. */
  amount: Amount;
};

/** Terminate configuration for terminate action (output) */
export type GDFTerminateConfig = {
  __typename: 'GDFTerminateConfig';
  /** Allowed initiators for this action */
  allowedInitiators: Array<GDFPartyType>;
};

/**
 * Terminate action configuration (input).
 * Required approvers are hardcoded to Secured Party (Quorum) and Pledgor (Quorum) regardless of initiator.
 */
export type GDFTerminateConfigInput = {
  /**
   * Parties allowed to initiate the terminate action.
   * Required approvers are hardcoded to Secured Party (Quorum) and Pledgor (Quorum).
   */
  allowedInitiators: Array<GDFPartyType>;
};

/** Supported time windows for control agreement value history. */
export enum GDFValueHistoryTimeWindow {
  ONE_DAY = 'ONE_DAY',
  ONE_MONTH = 'ONE_MONTH',
  ONE_WEEK = 'ONE_WEEK',
  ONE_YEAR = 'ONE_YEAR',
  YEAR_TO_DATE = 'YEAR_TO_DATE'
}

/**
 * Org-level settings for overrides customization.
 * A GasMultipliers contains values that are, or corresponds to, numeric values
 * that can be used as multiplier for ERC20 transactions when calculating gas fee.
 *
 * This type has to match schema.FeeCustomization.
 */
export type GasMultipliers = {
  __typename: 'GasMultipliers';
  /**
   * aka baseFeePerGasMultiplier.
   * This enum value corresponds to a numeric value that is used as multiplier
   * for ERC20 transactions when calculating gas fee.
   *
   * For ETH and ERC20, Go service sends to HSM this gas fee data for signing:
   *   EthereumSignGasPriceParam_DynamicFeeTxn{
   *     MaxPriorityFeePerGas
   *     MaxFeePerGas
   *     GasLimit
   *   }
   *
   * This data is calculated as follows:
   *   MaxPriorityFeePerGas = eth_maxPriorityFeePerGas
   *     baseFeePerGas = eth_gasPrice // last block
   *     baseFeePerGasMultiplier = COALESCE(org-level-baseFeePerGasMultiplier : ETH_BASE_FEE_MULTIPLIER : 7)
   *   MaxFeePerGas = MaxPriorityFeePerGas + (baseFeePerGas * baseFeePerGasMultiplier)
   *     gasLimitMultiplier = COALESCE(ETH_GAS_LIMIT_MULTIPLIER : 1) // 5|10|15 for aurora|zksync|arbitrum
   *     gasUnits = eth_estimateGas * gasLimitMultiplier
   *     if Smart Contract:
   *       tokenGasLimitMultiplier = COALESCE(org-level-gasLimitMultiplierForSmartContract : ETH_TOKEN_GAS_LIMIT_MULTIPLIERS_BY_EXECUTE_ACTION[] : ETH_TOKEN_GAS_LIMIT_MULTIPLIER : 5)
   *       gasUnits = gasUnits * tokenGasLimitMultiplier
   *   GasLimit = gasUnits
   *
   * What each possible value means:
   * - GENEROUS: 7X (default, unless ETH_BASE_FEE_MULTIPLIER is set).
   * - MEDIUM:   5X.
   * - ECONOMY:  2X.
   *
   * This value is used - unless not set,
   * in which case ETH_BASE_FEE_MULTIPLIER is used - unless not set,
   * in which case 7 is used.
   */
  baseFeePerGasMultiplier: Maybe<BaseFeePerGasMultiplierLevel>;
  /**
   * A numeric/float value used as multiplier for ERC20 Smart Contract transactions
   * when calculating gas fee.
   *
   * gasLimitMultiplierForSmartContract is an org-level override for ERC20 Smart Contract "Gas Limit" multiplier.
   * Must be a numeric number, eg, 1.25.
   * Note that due to loss of float precision, given number could be different from .the exact value getting used.
   * In this case there won't be error now or later (when the number gets used for a transaction).
   *
   * This value is used - unless not set,
   * in which case ETH_TOKEN_GAS_LIMIT_MULTIPLIERS_BY_EXECUTE_ACTION is used - unless not set,
   * in which case ETH_TOKEN_GAS_LIMIT_MULTIPLIER is used - unless not set,
   * in which case 5 is used.
   */
  gasLimitMultiplierForSmartContract: Maybe<Scalars['String']['output']>;
};

/** Payload response for submitGeneralFeedback mutation */
export type GeneralFeedbackResponse = {
  __typename: 'GeneralFeedbackResponse';
  /** Was request successful */
  success: Scalars['Boolean']['output'];
};

/** Payload response for generateAPIKeyWithPayload mutation. */
export type GenerateAPIKeyPayload = {
  __typename: 'GenerateAPIKeyPayload';
  /** State of the APIKey after the mutation. */
  apiKey: APIKey;
  /** The secret API key value. This is the only time the value will be shared. */
  secret: Scalars['String']['output'];
  /** Some API public keys must be added to the organization before use. If necessary, a new pending operation is returned. */
  userAddOperation: Maybe<Operation>;
};

export type GenericFeeTerms = {
  __typename: 'GenericFeeTerms';
  baseFee: Maybe<Scalars['Float']['output']>;
  chargeMethod: ChargeMethod;
  /**
   * True bills the fee in advance of its period instead of in arrears. Only allowed for FIXED_FEE
   * fee types. Always false on a fee type's own defaultFeeTerms.
   */
  chargeUpfront: Scalars['Boolean']['output'];
  feeApproach: AgreementsFeeApproach;
  feeTypeIdentifier: Scalars['String']['output'];
  groups: Array<FeeGroup>;
  hasGraduatedFeeRate: Scalars['Boolean']['output'];
  minimumFeeType: Maybe<AgreementsMinimumFeeType>;
  rateUnit: FeeRateUnit;
  usageEntityIds: Array<Scalars['ID']['output']>;
  /**
   * True means the agreement prices only the items it names and the rest inherit the fee type's
   * default group. Always false on a fee type's own defaultFeeTerms.
   */
  useFeeTypeDefaults: Scalars['Boolean']['output'];
};

/** feeTypeIdentifier must match the enclosing FeeTypeCreateInput's. */
export type GenericFeeTermsInput = {
  baseFee?: InputMaybe<Scalars['Float']['input']>;
  chargeMethod: ChargeMethod;
  chargeUpfront?: InputMaybe<Scalars['Boolean']['input']>;
  feeApproach: AgreementsFeeApproach;
  feeTypeIdentifier: Scalars['String']['input'];
  groups: Array<FeeGroupInput>;
  hasGraduatedFeeRate: Scalars['Boolean']['input'];
  minimumFeeType?: InputMaybe<AgreementsMinimumFeeType>;
  rateUnit: FeeRateUnit;
  usageEntityIds: Array<Scalars['ID']['input']>;
  useFeeTypeDefaults?: InputMaybe<Scalars['Boolean']['input']>;
};

/** GenericOperation represents a GenericOperation */
export type GenericOperation = Operation & {
  __typename: 'GenericOperation';
  /**
   * The following are resolved by operationresolvers/operation_offchain.go
   * account that this operation is associated with. Only applicable to vault operations (ex. Withdraw)
   */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** Further information regarding this asset type associated with this operation */
  assetTypeInfo: AssetTypeInfo;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * The following are resolved by type EndorsableOperation:
   * Returns the bio challenge required to pass in order to endorse this operation - TODO: unused field
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** final transaction fee charged, detected on the blockchain */
  finalFee: Maybe<Amount>;
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /**
   * If broadcasting of the operation is taking longer than usual, "impediment" may have descriptive info about why.
   * @deprecated use Operation.OperationInfo.OperationImpediment
   */
  impediment: Maybe<Scalars['String']['output']>;
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** Is the operation in a state that allows cancelation? */
  isCancelable: Scalars['Boolean']['output'];
  /** Is the operation in a state that allows rejection? */
  isRejectable: Scalars['Boolean']['output'];
  /** max transaction fee */
  maxFee: Maybe<Amount>;
  /** OperationCancelation is the data about When and Who requested cancelation of the operation,. */
  operationCancelation: Maybe<OperationCancelation>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to, which is the source organization (not necessarily the org using the initiatorKey)
   * @deprecated use operationInfo
   */
  organization: Maybe<Organization>;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** signedTransaction is the blockchain transaction to be broadcast to the network */
  signedTransaction: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** Mandatory user-facing risk analysis information about the smart contract being executed. */
  smartContractRisk: SmartContractRisk;
  /** Mandatory user-facing simulation information about the smart contract being executed. */
  smartContractSimulation: SmartContractSimulation;
  /** transactionID is the blockchain transaction id once available */
  transactionID: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
};


/** GenericOperation represents a GenericOperation */
export type GenericOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** GenericOperation represents a GenericOperation */
export type GenericOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** GenericOrgChangeOperation is a generic operation that can be used to perform arbitrary operations on an organization */
export type GenericOrgChangeOperation = Operation & {
  __typename: 'GenericOrgChangeOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /** Contains any extra details for the backoffice, concerning this operation. */
  backOfficeDetails: GenericOrgChangeOperationBackOfficeDetails;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /**
   * encryptionKeyForControlKeyPropagation returns the key used to encrypt the control key before propagating it.
   * The presence of this field informs the iOS app that it needs to trigger the Control Key propagation process when endorsing this operation.
   */
  encryptionKeyForControlKeyPropagation: Maybe<Scalars['String']['output']>;
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
};


/** GenericOrgChangeOperation is a generic operation that can be used to perform arbitrary operations on an organization */
export type GenericOrgChangeOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** GenericOrgChangeOperation is a generic operation that can be used to perform arbitrary operations on an organization */
export type GenericOrgChangeOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

export type GenericOrgChangeOperationBackOfficeDetails = {
  __typename: 'GenericOrgChangeOperationBackOfficeDetails';
  /**
   * The user being added to the organization.
   * Only available on generic organization change operations that add or replace
   * users.
   */
  newUser: Maybe<StagedUser>;
  /**
   * True when the underlying generic organization change contains at least
   * one user-add change (UserAddChange, UserAddAndPoliciesChange, or
   * UserReplaceChange). False otherwise.
   *
   * This is a structural discriminator only. It does NOT factor in operator
   * type, institutional individual presence, or KYC form status — those
   * gates remain on the consumer side. Consumers MUST NOT treat a `true`
   * value as proof that a review is currently pending.
   */
  requiresKYCReview: Scalars['Boolean']['output'];
  /**
   * The user being removed from the organization.
   * Only available on generic organization change operations that remove or
   * replace users.
   */
  user: Maybe<UserV2>;
};

/** GetAllDAppEntriesResponse contains the list of DApps and all available filter options. */
export type GetAllDAppEntriesResponse = {
  __typename: 'GetAllDAppEntriesResponse';
  /** All available DApp categories with display names */
  availableCategories: Array<DAppCategoryInfo>;
  /** All available DApp tiers with display names */
  availableTiers: Array<DAppTierInfo>;
  /** List of DApp entries matching the provided filters. */
  dAppEntries: Array<DAppEntry>;
};

export type GetCounterpartyAccountInput = {
  id: Scalars['ID']['input'];
};

/** The result of getIssuerTokenizationAssets. */
export type GetIssuerTokenizationAssetsPayload = {
  __typename: 'GetIssuerTokenizationAssetsPayload';
  /** The tokenized assets the calling org is the issuer of. */
  assets: Array<IssuerTokenizationAsset>;
};

/** GetKYCQuestionnaireSubmissionURLInput is the input for getKYCQuestionnaireSubmissionURL. */
export type GetKYCQuestionnaireSubmissionURLInput = {
  /**
   * Optional representative to provision the session for. When omitted, falls
   * back to the authenticated staff user's email.
   */
  representative?: InputMaybe<RepresentativeInput>;
  /** The identifier of the submission. */
  submissionID: Scalars['ID']['input'];
  /**
   * When true, provisions a view-only session: the returned URL opens the app
   * read-only and is only valid for submitted (COMPLETED) submissions.
   */
  viewOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GlobalTrustedSource = Node & {
  __typename: 'GlobalTrustedSource';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  disregardSourceAddress: Scalars['Boolean']['output'];
  dueDiligence: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  network: Scalars['String']['output'];
  originatorCountry: Scalars['String']['output'];
  originatorName: Scalars['String']['output'];
  sourceAddress: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  walletType: GlobalTrustedSourceWalletType;
};

/** A connection to a list of items. */
export type GlobalTrustedSourceConnection = {
  __typename: 'GlobalTrustedSourceConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<GlobalTrustedSourceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GlobalTrustedSourceEdge = {
  __typename: 'GlobalTrustedSourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<GlobalTrustedSource>;
};

/** Ordering options for GlobalTrustedSource connections */
export type GlobalTrustedSourceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GlobalTrustedSources. */
  field: GlobalTrustedSourceOrderField;
};

/** Properties by which GlobalTrustedSource connections can be ordered. */
export enum GlobalTrustedSourceOrderField {
  CREATED_AT = 'CREATED_AT',
  NETWORK = 'NETWORK',
  UPDATED_AT = 'UPDATED_AT'
}

/** GlobalTrustedSourceWalletType is enum for the field wallet_type */
export enum GlobalTrustedSourceWalletType {
  CUSTODIAL = 'CUSTODIAL',
  SELF_HOSTED = 'SELF_HOSTED'
}

/**
 * GlobalTrustedSourceWhereInput is used for filtering GlobalTrustedSource objects.
 * Input was generated by ent.
 */
export type GlobalTrustedSourceWhereInput = {
  and?: InputMaybe<Array<GlobalTrustedSourceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** due_diligence field predicates */
  dueDiligence?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceContains?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceContainsFold?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceEqualFold?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceGT?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceGTE?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceIn?: InputMaybe<Array<Scalars['String']['input']>>;
  dueDiligenceLT?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceLTE?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceNEQ?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** network field predicates */
  network?: InputMaybe<Scalars['String']['input']>;
  networkContains?: InputMaybe<Scalars['String']['input']>;
  networkContainsFold?: InputMaybe<Scalars['String']['input']>;
  networkEqualFold?: InputMaybe<Scalars['String']['input']>;
  networkGT?: InputMaybe<Scalars['String']['input']>;
  networkGTE?: InputMaybe<Scalars['String']['input']>;
  networkHasPrefix?: InputMaybe<Scalars['String']['input']>;
  networkHasSuffix?: InputMaybe<Scalars['String']['input']>;
  networkIn?: InputMaybe<Array<Scalars['String']['input']>>;
  networkLT?: InputMaybe<Scalars['String']['input']>;
  networkLTE?: InputMaybe<Scalars['String']['input']>;
  networkNEQ?: InputMaybe<Scalars['String']['input']>;
  networkNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<GlobalTrustedSourceWhereInput>;
  or?: InputMaybe<Array<GlobalTrustedSourceWhereInput>>;
  /** originator_country field predicates */
  originatorCountry?: InputMaybe<Scalars['String']['input']>;
  originatorCountryContains?: InputMaybe<Scalars['String']['input']>;
  originatorCountryContainsFold?: InputMaybe<Scalars['String']['input']>;
  originatorCountryEqualFold?: InputMaybe<Scalars['String']['input']>;
  originatorCountryGT?: InputMaybe<Scalars['String']['input']>;
  originatorCountryGTE?: InputMaybe<Scalars['String']['input']>;
  originatorCountryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  originatorCountryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  originatorCountryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  originatorCountryLT?: InputMaybe<Scalars['String']['input']>;
  originatorCountryLTE?: InputMaybe<Scalars['String']['input']>;
  originatorCountryNEQ?: InputMaybe<Scalars['String']['input']>;
  originatorCountryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** originator_name field predicates */
  originatorName?: InputMaybe<Scalars['String']['input']>;
  originatorNameContains?: InputMaybe<Scalars['String']['input']>;
  originatorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  originatorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  originatorNameGT?: InputMaybe<Scalars['String']['input']>;
  originatorNameGTE?: InputMaybe<Scalars['String']['input']>;
  originatorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  originatorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  originatorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  originatorNameLT?: InputMaybe<Scalars['String']['input']>;
  originatorNameLTE?: InputMaybe<Scalars['String']['input']>;
  originatorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  originatorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** source_address field predicates */
  sourceAddress?: InputMaybe<Scalars['String']['input']>;
  sourceAddressContains?: InputMaybe<Scalars['String']['input']>;
  sourceAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  sourceAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  sourceAddressGT?: InputMaybe<Scalars['String']['input']>;
  sourceAddressGTE?: InputMaybe<Scalars['String']['input']>;
  sourceAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sourceAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sourceAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceAddressLT?: InputMaybe<Scalars['String']['input']>;
  sourceAddressLTE?: InputMaybe<Scalars['String']['input']>;
  sourceAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  sourceAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** wallet_type field predicates */
  walletType?: InputMaybe<GlobalTrustedSourceWalletType>;
  walletTypeIn?: InputMaybe<Array<GlobalTrustedSourceWalletType>>;
  walletTypeNEQ?: InputMaybe<GlobalTrustedSourceWalletType>;
  walletTypeNotIn?: InputMaybe<Array<GlobalTrustedSourceWalletType>>;
};

/**
 * GovernanceSetupStatus represents the state of setting up governance for an asset
 * DEPRECATED: Governance is no longer supported. Retained for backward compatibility with iOS.
 */
export enum GovernanceSetupStatus {
  /** COMPLETE represents the state when voting setup has been completed */
  COMPLETE = 'COMPLETE',
  /** INCOMPLETE represents the state when voting setup has not been started or completed */
  INCOMPLETE = 'INCOMPLETE',
  /** NOT_SUPPORTED is for assets that do not support voting (eg BTC) */
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  /** UNAVAILABLE represents the state when voting setup on the blockchain is impossible */
  UNAVAILABLE = 'UNAVAILABLE'
}

/**
 * GovernanceSetupStep represents an individual step and its state for setting up governance
 * DEPRECATED: Governance is no longer supported. Retained for backward compatibility with iOS.
 */
export type GovernanceSetupStep = {
  __typename: 'GovernanceSetupStep';
  /** description is a user-friendly description of this setup step */
  description: Scalars['String']['output'];
  /** state represents the state of this individual step */
  state: GovernanceStepState;
  /** type represents the type of this setup step */
  type: GovernanceSetupType;
};

/**
 * GovernanceSetupType represents the type of the setup step
 * DEPRECATED: Governance is no longer supported. Retained for backward compatibility with iOS.
 */
export enum GovernanceSetupType {
  /** CELO_CREATE_ACCOUNT encodes a CELO_CREATE_ACCOUNT, enabling this asset to lock/unlock, participate in validator voting, and vote on governance proposals */
  CELO_CREATE_ACCOUNT = 'CELO_CREATE_ACCOUNT',
  /** IOU_CHIEF_APPROVAL encodes an approve ERC20 operation for a ETH address to the MKR Chief contract, sent to the IOU contract */
  IOU_CHIEF_APPROVAL = 'IOU_CHIEF_APPROVAL',
  /** LOCK encodes a LOCK operation, binding an amount of this asset for use in voting */
  LOCK = 'LOCK',
  /** MKR_CHIEF_APPROVAL encodes an approve ERC20 operation for a ETH address to the MKR Chief contract, sent to the base MKR contract */
  MKR_CHIEF_APPROVAL = 'MKR_CHIEF_APPROVAL'
}

/**
 * GovernanceStepProgress represents the progress of an individual step for setting up governance
 * DEPRECATED: Governance is no longer supported. Retained for backward compatibility with iOS.
 */
export enum GovernanceStepProgress {
  /** COMPLETE is when the step is complete */
  COMPLETE = 'COMPLETE',
  /** FAILED is when the step failed for any reason */
  FAILED = 'FAILED',
  /** IN_PROGRESS is when the step is in progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** NOT_READY is when the step hasn't been initiated but isn't ready yet */
  NOT_READY = 'NOT_READY',
  /** READY_TO_START is when the step hasn't been initiated but is ready */
  READY_TO_START = 'READY_TO_START'
}

/**
 * GovernanceStepState represents the state of an individual step for setting up governance
 * DEPRECATED: Governance is no longer supported. Retained for backward compatibility with iOS.
 */
export type GovernanceStepState = {
  __typename: 'GovernanceStepState';
  /** operationID is optional if this step has created an operation to link to */
  operationID: Maybe<Scalars['String']['output']>;
  /** progress describes the state of this individual setup step */
  progress: GovernanceStepProgress;
};

export type GroupHoldingBreakdown = {
  __typename: 'GroupHoldingBreakdown';
  /**
   * Returns the percentage breakdown by asset in portfolio.
   * Set debug to true to enable more logging.
   * NOTE: this could significantly increase query lantency and amount of data returned.
   *   Access it only when must.
   */
  holdings: Array<HoldingBreakdown>;
  /** TotalBalanceAmount returns an amount type object representing the value in USD of all holdings for the organization or vault based on the currency type */
  totalBalanceAmount: Amount;
};

/**
 * What groups[].groupItems represents for this fee type, set once at creation and shared by
 * every GenericFeeTerms entry for it. Currently only ASSET_TYPE.
 */
export enum GroupType {
  ASSET_TYPE = 'ASSET_TYPE'
}

/** High Risk Jurisdictions countries Analsysis */
export type HRJAnalysis = {
  __typename: 'HRJAnalysis';
  /** geolocationRiskScore epresents the risk assessment of the device location */
  geolocationRiskScore: TransactionRiskScore;
  /** ipAddressRiskScore epresents the risk assessment of the IP Address */
  ipAddressRiskScore: TransactionRiskScore;
  /** isGeolocationHighRisk represents whether the device location of the user is HRJ country */
  isGeolocationHighRisk: Scalars['Boolean']['output'];
  /** isIPAdressHighRisk represents whether the IP Address of the user is HRJ country */
  isIPAdressHighRisk: Scalars['Boolean']['output'];
  /** Unique identifier of the key endorsing the operation */
  publicKeyID: Scalars['PublicKeyID']['output'];
  /** status is the status of the request (e.g: PENDING,UNSUPPORTED,FAILURE,COMPLETE) */
  status: RiskRequestStatus;
  /** analysisType is the type of analysis (e.g: HRJCheck) */
  type: RiskAnalysisType;
  /**
   * user represents the info of the user endorsing the operation
   * @deprecated Use userKey instead
   */
  user: User;
  /** userKey represents the info of the user key endorsing the operation */
  userKey: UserKey;
};

/** Types of HSM migrations. */
export enum HSMMigrationType {
  /** Migration to backfill encrypted wallet xpubs for vaults. */
  BACKFILL_VAULT_XPUBS = 'BACKFILL_VAULT_XPUBS',
  /** Migration to convert each flat condition in a condition group into a single-condition bundle. */
  CONDITIONS_TO_BUNDLES = 'CONDITIONS_TO_BUNDLES',
  /** Revert migration for ENABLE_REGO_AS_PRIMARY_EVALUATOR - goes back to having the Rego evaluator as a shadow of the legacy evaluator. */
  DISABLE_REGO_AS_PRIMARY_EVALUATOR = 'DISABLE_REGO_AS_PRIMARY_EVALUATOR',
  /** Migration to enforce the Rego evaluator as the decision maker. */
  ENABLE_REGO_AS_PRIMARY_EVALUATOR = 'ENABLE_REGO_AS_PRIMARY_EVALUATOR',
  /** Migration to delete policy maps and change policy SOT to container exclusive. */
  ENFORCE_CONTAINER_EXCLUSIVE = 'ENFORCE_CONTAINER_EXCLUSIVE',
  /** No migration. */
  NONE = 'NONE',
  /** Migration to backfill structured fragment IDs and outcomes on policy containers and enable conditional rules. */
  POLICIES_WITH_CONDITIONAL_RULES = 'POLICIES_WITH_CONDITIONAL_RULES',
  /** Migration to group equivalent policy containers together and create policy container groups if needed. */
  POLICY_CONTAINER_GROUPS_V2 = 'POLICY_CONTAINER_GROUPS_V2',
  /** Revert migration for POLICIES_WITH_CONDITIONAL_RULES - disables conditional rules flag without removing IDs. */
  REVERT_POLICIES_WITH_CONDITIONAL_RULES = 'REVERT_POLICIES_WITH_CONDITIONAL_RULES'
}

export type HarukoBackfillRequestFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filter by endpoint */
  endpoint?: InputMaybe<HarukoEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by status: scheduled, done, or failed */
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum HarukoEndpoint {
  /** @deprecated No longer scheduled. Use SUMMARY_OF_ACCOUNTS. */
  ACCOUNT_OVERVIEW = 'ACCOUNT_OVERVIEW',
  NOOP = 'NOOP',
  PNL_OPEN_REALISED = 'PNL_OPEN_REALISED',
  RECONCILIATION_SUMMARY = 'RECONCILIATION_SUMMARY',
  RISK_PNL_W_RISK_CRITERIA = 'RISK_PNL_W_RISK_CRITERIA',
  SCENARIO_ANALYSIS = 'SCENARIO_ANALYSIS',
  SUMMARY_OF_ACCOUNTS = 'SUMMARY_OF_ACCOUNTS',
  TRADES = 'TRADES'
}

/** Hold is a quantity of an asset. It used to represent holds but now it represents any amount relevant to the asset. */
export type Hold = {
  __typename: 'Hold';
  /** apiKeyName represents the API Key name. Its value will be set if the hold is of HoldTypePlacedByAPIKey, otherwise it may be empty. */
  apiKeyName: Maybe<Scalars['String']['output']>;
  /** description is the user-friendly description of this balance */
  description: Scalars['String']['output'];
  /** endTime is the time the balance is no longer effective */
  endTime: Maybe<Scalars['String']['output']>;
  /** The amount of balance */
  holdAmount: Amount;
  /** holdID represents the hold ID. Its value will be set if the hold is of HoldTypePlacedByAPIKey, otherwise it may be empty. */
  holdID: Maybe<Scalars['String']['output']>;
  /** The category that describes why the hold is in place */
  holdType: HoldType;
  /** startTime is the time the balance goes into effect */
  startTime: Maybe<Scalars['String']['output']>;
};

/** HoldOwnerType should match entities.HoldOwnerType */
export enum HoldOwnerType {
  /** API_KEY */
  API_KEY = 'API_KEY',
  /** MINT_BURN */
  MINT_BURN = 'MINT_BURN',
  /** OPERATION */
  OPERATION = 'OPERATION',
  /** SETTLEMENT_NETWORK */
  SETTLEMENT_NETWORK = 'SETTLEMENT_NETWORK'
}

/** HoldStatus should match entities.HoldStatus */
export enum HoldStatus {
  /** ACTIVE */
  ACTIVE = 'ACTIVE',
  /** EXECUTING */
  EXECUTING = 'EXECUTING',
  /** EXPIRED */
  EXPIRED = 'EXPIRED',
  /** RELEASED */
  RELEASED = 'RELEASED'
}

/** HoldType represents the types/reasons a hold can occur */
export enum HoldType {
  /** ALLUVIAL_PENDING represents the balance sitting in the Alluvial SMS Orchestrator, waiting to be staked */
  ALLUVIAL_PENDING = 'ALLUVIAL_PENDING',
  /** ALLUVIAL_STAKED represents the staked balance */
  ALLUVIAL_STAKED = 'ALLUVIAL_STAKED',
  /** ALLUVIAL_UNSTAKED represents the unstaked balance sitting in the TVS, waiting to be swept to the Beneficiary */
  ALLUVIAL_UNSTAKED = 'ALLUVIAL_UNSTAKED',
  /** ALLUVIAL_UNSTAKING represents the balance since we've ordered to unstake it till it's sitting in the TVS waiting to be swept to the Beneficiary */
  ALLUVIAL_UNSTAKING = 'ALLUVIAL_UNSTAKING',
  /** ALLUVIAL_UNSWEPT represents Execution Layer rewards sitting in the TVS, waiting to be swept to the Beneficiary */
  ALLUVIAL_UNSWEPT = 'ALLUVIAL_UNSWEPT',
  /** ALL_TIME_REWARDS is the total of all rewards that have been received by this address during participation actions */
  ALL_TIME_REWARDS = 'ALL_TIME_REWARDS',
  /** AML is for when AML checks occur on deposits */
  AML = 'AML',
  /** ASSOCIATED_RENT_RESERVE represents rent reserve balance type for associated addresses */
  ASSOCIATED_RENT_RESERVE = 'ASSOCIATED_RENT_RESERVE',
  /** ATLAS_DELEGATION is the amount locked to be used in Atlas delegation. */
  ATLAS_DELEGATION = 'ATLAS_DELEGATION',
  /** ATTRIBUTION_BLOCKED is for holds created by deposits that are blocked due to the screening process flag them as being potentially suspicious. */
  ATTRIBUTION_BLOCKED = 'ATTRIBUTION_BLOCKED',
  /** ATTRIBUTION_UNDER_REVIEW  is for holds created by deposits that are under review, that is, waiting for the screening process of the attribution to complete. */
  ATTRIBUTION_UNDER_REVIEW = 'ATTRIBUTION_UNDER_REVIEW',
  /** AVAILABLE is the amount that can be withdrawn from the regular address */
  AVAILABLE = 'AVAILABLE',
  /** BEACON_RESTAKED is the amount currently restaking in the beacon chain */
  BEACON_RESTAKED = 'BEACON_RESTAKED',
  /** BRIDGING is the amount being bridged */
  BRIDGING = 'BRIDGING',
  /** BTC_DELEGATION_REWARDS is the amount of rewards accrued from staking BTC */
  BTC_DELEGATION_REWARDS = 'BTC_DELEGATION_REWARDS',
  /**
   * CMS_DEFAULT is the amount earmarked because the account defaulted on a
   * coordinated multiparty settlement.
   */
  CMS_DEFAULT = 'CMS_DEFAULT',
  /** COMPLETE is the total balance owned */
  COMPLETE = 'COMPLETE',
  /** DELEGATED_USABLE represents the delegated tokens that are not unvested */
  DELEGATED_USABLE = 'DELEGATED_USABLE',
  /** DELEGATE_AVAILABLE is the amount that can be delegated by this address */
  DELEGATE_AVAILABLE = 'DELEGATE_AVAILABLE',
  /** DELEGATE_VOTE_LOCK is a user-initiated lock of token to a delegate */
  DELEGATE_VOTE_LOCK = 'DELEGATE_VOTE_LOCK',
  /** DELEGATION_REWARDS is the amount of rewards accrued from staking */
  DELEGATION_REWARDS = 'DELEGATION_REWARDS',
  /** ELECTING_VALIDATOR is the amount used in validator election (only used by Celo) */
  ELECTING_VALIDATOR = 'ELECTING_VALIDATOR',
  /**
   * EXECUTE_OPERATION indicates a hold applied as the result of a pending operation for this asset. Examples include
   * withdrawals, transfers, and network transaction fees.
   */
  EXECUTE_OPERATION = 'EXECUTE_OPERATION',
  /** GOVERNANCE_UNBOND is a withdrawal from a governance voting lock that is waiting out its exit delay */
  GOVERNANCE_UNBOND = 'GOVERNANCE_UNBOND',
  /** IMPORTABLE is the amount available to import from other chain/blockchain */
  IMPORTABLE = 'IMPORTABLE',
  /** LOCK is a user-initiated hold (for example, locking MKR) */
  LOCK = 'LOCK',
  /** MINT_BURN is the amount locked to be used in a mint or burn conversion */
  MINT_BURN = 'MINT_BURN',
  /** NON_ATTRIBUTABLE is for holds created by deposits that cannot be attributed by any user. */
  NON_ATTRIBUTABLE = 'NON_ATTRIBUTABLE',
  /** OFFCHAIN_VESTING is for holds created by offchain vesting to hold funds prior to their vesting time. */
  OFFCHAIN_VESTING = 'OFFCHAIN_VESTING',
  /** OFFCHAIN_VESTING_UNSTAKEABLE is for holds created by offchain vesting that cannot be staked. */
  OFFCHAIN_VESTING_UNSTAKEABLE = 'OFFCHAIN_VESTING_UNSTAKEABLE',
  /** OPERATIONAL_STAKING_RESERVE represents an operational reserve held for future unstake/collect operations */
  OPERATIONAL_STAKING_RESERVE = 'OPERATIONAL_STAKING_RESERVE',
  /** OPERATIONAL_VESTING_RESERVE represents an operational reserve held for future vesting operations */
  OPERATIONAL_VESTING_RESERVE = 'OPERATIONAL_VESTING_RESERVE',
  /** PENDING is a balance state right before LOCK, where it exists but it is not accessible */
  PENDING = 'PENDING',
  /** PENDING_ATTRIBUTION is the amount holded due to pending deposit attributions */
  PENDING_ATTRIBUTION = 'PENDING_ATTRIBUTION',
  /** PLACED_BY_API_KEY indicates a hold that was placed by a user via an API client */
  PLACED_BY_API_KEY = 'PLACED_BY_API_KEY',
  /** REDELEGATING */
  REDELEGATING = 'REDELEGATING',
  /** RENT_RESERVE represents rent reserve balance type */
  RENT_RESERVE = 'RENT_RESERVE',
  /** RESERVE represents reserve balance type */
  RESERVE = 'RESERVE',
  /** RESTAKED is the amount currently restaking */
  RESTAKED = 'RESTAKED',
  /** RESTAKING_REWARDS is the amount of rewards accrued from restaking */
  RESTAKING_REWARDS = 'RESTAKING_REWARDS',
  /** SETTLEMENT_NETWORK is the amount locked to be used in a settlement. It's locked right before executing a settlement and unlocked after the settlement is completed. */
  SETTLEMENT_NETWORK = 'SETTLEMENT_NETWORK',
  /** SPAM is the amount holded due to deposits flagged as spam */
  SPAM = 'SPAM',
  /** UNBOND is a user-initiated waiting hold applied for a successful unbonding operation (for example, unbonding cosmos) */
  UNBOND = 'UNBOND',
  /** UNBONDED */
  UNBONDED = 'UNBONDED',
  /** UNVESTED is the opposite of BalanceTypeVested. These funds can't be claimed yet. */
  UNVESTED = 'UNVESTED',
  /** UNVESTED_DELEGATABLE is the unvested balance that is delegatable. */
  UNVESTED_DELEGATABLE = 'UNVESTED_DELEGATABLE',
  /** UTXO_EXCLUSION is a cleared UTXO a client has fenced off from automatic coin selection */
  UTXO_EXCLUSION = 'UTXO_EXCLUSION',
  /** VALIDATOR_COMMISSION is the amount of commission earned by an Anchorage validator */
  VALIDATOR_COMMISSION = 'VALIDATOR_COMMISSION',
  /** VESTED applies to vesting contracts and represents the funds that are held in it and have already vested, so they can be claimed (provided they are also unlocked) */
  VESTED = 'VESTED',
  /** VESTING_AVAILABLE is the amount that's in your vesting contract and is available for being claimed */
  VESTING_AVAILABLE = 'VESTING_AVAILABLE',
  /** VESTING_TOTAL is the total balance of the vesting contract if there is one */
  VESTING_TOTAL = 'VESTING_TOTAL',
  /** VESTING_UNLOCKED is the portion of the balance that's in the vesting contract and is not locked */
  VESTING_UNLOCKED = 'VESTING_UNLOCKED',
  /** VOTE_PROXY_LOCK is the amount locked by the vote proxy contract */
  VOTE_PROXY_LOCK = 'VOTE_PROXY_LOCK'
}

export type HoldingBreakdown = {
  __typename: 'HoldingBreakdown';
  /** Asset Type Info of the holding asset */
  assetTypeInfo: AssetTypeInfo;
  /** FIAT asset can have multiple allocations, this field will return the allocations for the FIAT asset */
  balanceAllocation: Array<BalanceAllocation>;
  /** HoldingBalance is the sum of all amounts of assets of this asset type within the organization/vault */
  holdingBalance: Amount;
  /**
   * Percentage of the parent org/vault's portfolio that this holding makes up (proportion out of 1 format. Eg: 100% -> 1, 20% -> 0.2).
   * This is probably misplaced, and should have been a map of asset types to percentages on the org/vault resolvers.
   */
  holdingPercentage: Scalars['String']['output'];
  /** Number of wallets that hold this asset */
  numberOfWallets: Scalars['Int']['output'];
  /**
   * subBalances represent a portion of the balance that is
   * being used for a specific purpose, eg "available" or "locked".
   */
  subBalances: Array<NamedBalance>;
};


export type HoldingBreakdownsubBalancesArgs = {
  visibleForPurpose?: InputMaybe<VisibleForPurpose>;
};

/** Sorting options for holdings in portfolios and vaults */
export enum HoldingSortFields {
  /** Sorts by the USD value of each holding with the holding of assettype = USD first */
  USD_FIRST = 'USD_FIRST',
  /** Sort by the USD value of each holding */
  USD_VALUE = 'USD_VALUE'
}

export type IAM = {
  __typename: 'IAM';
  checkPermission: Scalars['Boolean']['output'];
  permissions: IAMPermissionConnection;
  resourceID: Scalars['String']['output'];
  roles: IAMRoleConnection;
};


export type IAMcheckPermissionArgs = {
  action: IAMPermissionAction;
  principal?: InputMaybe<Scalars['String']['input']>;
  resourceID?: InputMaybe<Scalars['String']['input']>;
};


export type IAMpermissionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IAMPermissionOrder>;
  where?: InputMaybe<IAMPermissionWhereInput>;
};


export type IAMrolesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IAMRoleOrder>;
  where?: InputMaybe<IAMRoleWhereInput>;
};

/** IAMAccessLevel is enum for the field accessLevel */
export enum IAMAccessLevel {
  /** User is Approver. Allowed to approve Operations on the Resource. */
  APPROVER = 'APPROVER',
  /** User is Initiator. Allowed to initiate Operations on the Resource. */
  INITIATOR = 'INITIATOR',
  /** User is both Initiator and Approver. Allowed to initiator and approve Operations on the Resource. */
  INITIATOR_AND_APPROVER = 'INITIATOR_AND_APPROVER'
}

export type IAMCategory = Node & {
  __typename: 'IAMCategory';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions: Maybe<Array<IAMPermission>>;
  type: IAMCategoryType;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** IAMCategoryType is enum for the field type */
export enum IAMCategoryType {
  ADMINISTRATOR_POLICIES_MANAGEMENT = 'ADMINISTRATOR_POLICIES_MANAGEMENT',
  API_KEY_MANAGEMENT = 'API_KEY_MANAGEMENT',
  API_PERMISSION_GROUP_MANAGEMENT = 'API_PERMISSION_GROUP_MANAGEMENT',
  APPROVED_APPS_MANAGEMENT = 'APPROVED_APPS_MANAGEMENT',
  CONNECTED_APPS_MANAGEMENT = 'CONNECTED_APPS_MANAGEMENT',
  EXTERNAL_ACCOUNTS_MANAGEMENT = 'EXTERNAL_ACCOUNTS_MANAGEMENT',
  IP_ALLOWLIST_MANAGEMENT = 'IP_ALLOWLIST_MANAGEMENT',
  SETTINGS_VISIBILITY_MANAGEMENT = 'SETTINGS_VISIBILITY_MANAGEMENT',
  SETTLEMENT_NETWORK_MANAGEMENT = 'SETTLEMENT_NETWORK_MANAGEMENT',
  STABLECOIN_REWARDS_MANAGEMENT = 'STABLECOIN_REWARDS_MANAGEMENT',
  STAFF_MEMBERS_PERMISSIONS = 'STAFF_MEMBERS_PERMISSIONS',
  TRANSFER_ACCESS_MANAGEMENT = 'TRANSFER_ACCESS_MANAGEMENT',
  TRUSTED_DESTINATIONS_MANAGEMENT = 'TRUSTED_DESTINATIONS_MANAGEMENT',
  TRUSTED_SMART_CONTRACTS_MANAGEMENT = 'TRUSTED_SMART_CONTRACTS_MANAGEMENT',
  TRUSTED_SOURCES_MANAGEMENT = 'TRUSTED_SOURCES_MANAGEMENT',
  UNSPECIFIED = 'UNSPECIFIED',
  USER_ACCESS_MANAGEMENT = 'USER_ACCESS_MANAGEMENT',
  VAULTS_MANAGEMENT = 'VAULTS_MANAGEMENT',
  VAULT_TRANSACTIONS = 'VAULT_TRANSACTIONS',
  WALLET_KEYS_MANAGEMENT = 'WALLET_KEYS_MANAGEMENT',
  WEBHOOK_MANAGEMENT = 'WEBHOOK_MANAGEMENT'
}

/**
 * IAMCategoryWhereInput is used for filtering Category objects.
 * Input was generated by ent.
 */
export type IAMCategoryWhereInput = {
  and?: InputMaybe<Array<IAMCategoryWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayNameGT?: InputMaybe<Scalars['String']['input']>;
  displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameLT?: InputMaybe<Scalars['String']['input']>;
  displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  displayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** permissions edge predicates */
  hasPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionsWith?: InputMaybe<Array<IAMPermissionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<IAMCategoryWhereInput>;
  or?: InputMaybe<Array<IAMCategoryWhereInput>>;
  /** type field predicates */
  type?: InputMaybe<IAMCategoryType>;
  typeIn?: InputMaybe<Array<IAMCategoryType>>;
  typeNEQ?: InputMaybe<IAMCategoryType>;
  typeNotIn?: InputMaybe<Array<IAMCategoryType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** IAMMember is a member for a role */
export type IAMMember = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  vaults: VaultConnection;
};


/** IAMMember is a member for a role */
export type IAMMembervaultsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VaultWhereInput>;
};

/** A connection to a list of items. */
export type IAMMemberConnection = {
  __typename: 'IAMMemberConnection';
  /** A list of edges. */
  edges: Maybe<Array<IAMMemberEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IAMMemberEdge = {
  __typename: 'IAMMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<IAMMember>;
};

/** Ordering options for Member connections */
export type IAMMemberOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Users. */
  field: IAMMemberOrderField;
};

/** Properties by which IAM Member connections can be ordered. */
export enum IAMMemberOrderField {
  NAME = 'NAME'
}

/** Represents a user as a member of a role */
export type IAMMemberUser = IAMMember & Node & {
  __typename: 'IAMMemberUser';
  /** Stable unique ID of the user */
  id: Scalars['ID']['output'];
  /** Name of this member */
  name: Scalars['String']['output'];
  /**
   * User object of this member
   * @deprecated Use userV2 instead
   */
  user: User;
  userV2: UserV2;
  /** Vaults that this member has a role in */
  vaults: VaultConnection;
};


/** Represents a user as a member of a role */
export type IAMMemberUservaultsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VaultWhereInput>;
};

/** A filter to be used against User fields. */
export type IAMMemberWhereInput = {
  /** id field predicates */
  id?: InputMaybe<Scalars['String']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IAMPermission = Node & {
  __typename: 'IAMPermission';
  action: IAMPermissionAction;
  availability: IAMPermissionAvailability;
  category: Maybe<IAMCategory>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /** This is just here for generation and is calculated on every getter, the DB value holds no meaning */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  resourceType: IAMPermissionResourceType;
  roles: Maybe<Array<IAMRole>>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** IAMPermissionAction is enum for the field action */
export enum IAMPermissionAction {
  AML_POST_REVIEW_EDIT = 'AML_POST_REVIEW_EDIT',
  API_KEY_CREATE_INITIATE = 'API_KEY_CREATE_INITIATE',
  API_KEY_REVOKE_INITIATE = 'API_KEY_REVOKE_INITIATE',
  API_KEY_UPDATE_INITIATE = 'API_KEY_UPDATE_INITIATE',
  API_KEY_WITHDRAW_INITIATE = 'API_KEY_WITHDRAW_INITIATE',
  APPROVED_APPS_EDIT = 'APPROVED_APPS_EDIT',
  ASSET_PRICES_UPDATE_ACCESS = 'ASSET_PRICES_UPDATE_ACCESS',
  ASSET_TAGS_UPDATE_ACCESS = 'ASSET_TAGS_UPDATE_ACCESS',
  BACKOFFICE_SENSITIVE_DATA_ACCESS = 'BACKOFFICE_SENSITIVE_DATA_ACCESS',
  BANKING_SOLUTIONS_ACCESS = 'BANKING_SOLUTIONS_ACCESS',
  CAN_APPROVE_SELFHOSTED_ADS_WITHDRAWALS_ACCESS = 'CAN_APPROVE_SELFHOSTED_ADS_WITHDRAWALS_ACCESS',
  CLIENT_OPS_ACCESS = 'CLIENT_OPS_ACCESS',
  CLIENT_OPS_DIRECT_EDIT_ACCESS = 'CLIENT_OPS_DIRECT_EDIT_ACCESS',
  CLOSE_CLIENT_ACCOUNT_ACCESS = 'CLOSE_CLIENT_ACCOUNT_ACCESS',
  COMPLIANCE_ALERTS_OPS_ACCESS = 'COMPLIANCE_ALERTS_OPS_ACCESS',
  COMPLIANCE_DOCS_KYC_OPS_ACCESS = 'COMPLIANCE_DOCS_KYC_OPS_ACCESS',
  COMPLIANCE_DOCS_TRANSACTION_ACTIVITY_OPS_ACCESS = 'COMPLIANCE_DOCS_TRANSACTION_ACTIVITY_OPS_ACCESS',
  COMPLIANCE_HOLD_ACCESS = 'COMPLIANCE_HOLD_ACCESS',
  COMPLIANCE_TRUST_ACCESS = 'COMPLIANCE_TRUST_ACCESS',
  CONNECTED_APPS_VIEWERS_ACCESS = 'CONNECTED_APPS_VIEWERS_ACCESS',
  CREATE_VAULT_INITIATE = 'CREATE_VAULT_INITIATE',
  CRR_MODEL_RISK_CONFIG_ACCESS = 'CRR_MODEL_RISK_CONFIG_ACCESS',
  DEPOSIT_INITIATE = 'DEPOSIT_INITIATE',
  DEVELOPER_SECTION_VIEW = 'DEVELOPER_SECTION_VIEW',
  DISABLE_VAULT_INITIATE = 'DISABLE_VAULT_INITIATE',
  ENABLE_VAULT_INITIATE = 'ENABLE_VAULT_INITIATE',
  EXTERNAL_ACCOUNTS_CONFIGURATION_EDIT = 'EXTERNAL_ACCOUNTS_CONFIGURATION_EDIT',
  FIAT_DIRECT_ATTRIBUTION_ACCESS = 'FIAT_DIRECT_ATTRIBUTION_ACCESS',
  FIAT_UNASSIGNED_DEPOSIT_ATTRIBUTION_ACCESS = 'FIAT_UNASSIGNED_DEPOSIT_ATTRIBUTION_ACCESS',
  FINANCE_ACCESS = 'FINANCE_ACCESS',
  FREEZE_WITHDRAWAL_ACCESS = 'FREEZE_WITHDRAWAL_ACCESS',
  IP_ALLOWLIST_ACCESS = 'IP_ALLOWLIST_ACCESS',
  KYC_ALERTS_OPS_ACCESS = 'KYC_ALERTS_OPS_ACCESS',
  LENDING_OPS_ACCESS = 'LENDING_OPS_ACCESS',
  LENDING_OPS_TRANSFERS_ACCESS = 'LENDING_OPS_TRANSFERS_ACCESS',
  MANUAL_DEPOSIT_ATTRIBUTION_ACCESS = 'MANUAL_DEPOSIT_ATTRIBUTION_ACCESS',
  ON_CALL_ACCESS = 'ON_CALL_ACCESS',
  OPERATOR_SELF_ACCESS = 'OPERATOR_SELF_ACCESS',
  ORGANIZATIONS_IAM_VIEW = 'ORGANIZATIONS_IAM_VIEW',
  ORGANIZATIONS_USERS_DOWNLOAD = 'ORGANIZATIONS_USERS_DOWNLOAD',
  ORGANIZATION_POLICIES_VIEW = 'ORGANIZATION_POLICIES_VIEW',
  OTC_DERIVATIVES_ACCOUNT_WRITE_ACCESS = 'OTC_DERIVATIVES_ACCOUNT_WRITE_ACCESS',
  OTC_DERIVATIVES_CLIENT_COMMS_WRITE_ACCESS = 'OTC_DERIVATIVES_CLIENT_COMMS_WRITE_ACCESS',
  OTC_DERIVATIVES_CREDIT_TERMS_WRITE_ACCESS = 'OTC_DERIVATIVES_CREDIT_TERMS_WRITE_ACCESS',
  OTC_DERIVATIVES_PRODUCT_AND_REPORTING_WRITE_ACCESS = 'OTC_DERIVATIVES_PRODUCT_AND_REPORTING_WRITE_ACCESS',
  OTC_DERIVATIVES_RISK_WRITE_ACCESS = 'OTC_DERIVATIVES_RISK_WRITE_ACCESS',
  OTC_DERIVATIVES_SETTLEMENT_WRITE_ACCESS = 'OTC_DERIVATIVES_SETTLEMENT_WRITE_ACCESS',
  OTC_DERIVATIVES_TRADE_WRITE_ACCESS = 'OTC_DERIVATIVES_TRADE_WRITE_ACCESS',
  PERMISSION_GROUP_CREATE_INITIATE = 'PERMISSION_GROUP_CREATE_INITIATE',
  PERMISSION_GROUP_DELETE_INITIATE = 'PERMISSION_GROUP_DELETE_INITIATE',
  PERMISSION_GROUP_UPDATE_INITIATE = 'PERMISSION_GROUP_UPDATE_INITIATE',
  PERSON_KYC_VIEWERS_ACCESS = 'PERSON_KYC_VIEWERS_ACCESS',
  REPORTING_SCHEDULE_ACTIVATE_ACCESS = 'REPORTING_SCHEDULE_ACTIVATE_ACCESS',
  REPORTING_VIEW = 'REPORTING_VIEW',
  REVIEWER_HOLD_ACCESS = 'REVIEWER_HOLD_ACCESS',
  REVIEWER_TRUST_ACCESS = 'REVIEWER_TRUST_ACCESS',
  RISK_TRADING_LIMITS_ACCESS = 'RISK_TRADING_LIMITS_ACCESS',
  ROLE_CHANGE_INITIATE = 'ROLE_CHANGE_INITIATE',
  SCIM_CONNECTION_MANAGE = 'SCIM_CONNECTION_MANAGE',
  SCIM_CONNECTION_WRITE_ACCESS = 'SCIM_CONNECTION_WRITE_ACCESS',
  SCIM_RECONCILIATION_WRITE_ACCESS = 'SCIM_RECONCILIATION_WRITE_ACCESS',
  SETTLEMENT_NETWORK_PARTICIPANTS_EDIT = 'SETTLEMENT_NETWORK_PARTICIPANTS_EDIT',
  SETTLEMENT_OPS_ACCESS = 'SETTLEMENT_OPS_ACCESS',
  STABLECOIN_REWARDS_CONFIGURATION_EDIT = 'STABLECOIN_REWARDS_CONFIGURATION_EDIT',
  STAKING_INITIATE = 'STAKING_INITIATE',
  STATEMENTS_VIEW = 'STATEMENTS_VIEW',
  SYMBOLOGY_RELINK_ACCESS = 'SYMBOLOGY_RELINK_ACCESS',
  SYMBOLOGY_WRITE_ACCESS = 'SYMBOLOGY_WRITE_ACCESS',
  TAX_CENTER_VIEW = 'TAX_CENTER_VIEW',
  TEAM_MEMBER_DETAIL_VIEW = 'TEAM_MEMBER_DETAIL_VIEW',
  TMS_MODEL_RISK_CONFIG_ACCESS = 'TMS_MODEL_RISK_CONFIG_ACCESS',
  TRADING_ACCESS = 'TRADING_ACCESS',
  TRADING_COMPLIANCE_ACCESS = 'TRADING_COMPLIANCE_ACCESS',
  TRADING_OPS_ACCESS = 'TRADING_OPS_ACCESS',
  TRANSFER_ACCESS_REQUEST_INITIATE = 'TRANSFER_ACCESS_REQUEST_INITIATE',
  TRUSTED_DESTINATIONS_ADD_INITIATE = 'TRUSTED_DESTINATIONS_ADD_INITIATE',
  TRUSTED_DESTINATIONS_REMOVE_INITIATE = 'TRUSTED_DESTINATIONS_REMOVE_INITIATE',
  TRUSTED_DESTINATIONS_VIEW = 'TRUSTED_DESTINATIONS_VIEW',
  TRUSTED_SMART_CONTRACTS_ADD_INITIATE = 'TRUSTED_SMART_CONTRACTS_ADD_INITIATE',
  TRUSTED_SMART_CONTRACTS_REMOVE_INITIATE = 'TRUSTED_SMART_CONTRACTS_REMOVE_INITIATE',
  TRUSTED_SMART_CONTRACTS_VIEW = 'TRUSTED_SMART_CONTRACTS_VIEW',
  TRUSTED_SOURCES_ADD_INITIATE = 'TRUSTED_SOURCES_ADD_INITIATE',
  TRUSTED_SOURCES_EDIT_INITIATE = 'TRUSTED_SOURCES_EDIT_INITIATE',
  TRUSTED_SOURCES_REMOVE_INITIATE = 'TRUSTED_SOURCES_REMOVE_INITIATE',
  UNSPECIFIED = 'UNSPECIFIED',
  UPDATE_ORG_POLICIES_INITIATE = 'UPDATE_ORG_POLICIES_INITIATE',
  UPDATE_VAULT_POLICIES_INITIATE = 'UPDATE_VAULT_POLICIES_INITIATE',
  USER_ADD_INITIATE = 'USER_ADD_INITIATE',
  USER_REMOVE_INITIATE = 'USER_REMOVE_INITIATE',
  USER_REPLACE_INITIATE = 'USER_REPLACE_INITIATE',
  VAULTS_DETAILS_EDIT = 'VAULTS_DETAILS_EDIT',
  VAULTS_DETAILS_VIEW = 'VAULTS_DETAILS_VIEW',
  VAULTS_MEMBERS_VIEW = 'VAULTS_MEMBERS_VIEW',
  VAULTS_POLICIES_VIEW = 'VAULTS_POLICIES_VIEW',
  VAULTS_READ = 'VAULTS_READ',
  VAULTS_WALLET_CREATE = 'VAULTS_WALLET_CREATE',
  VIEW_CRR_HISTORY_ACCESS = 'VIEW_CRR_HISTORY_ACCESS',
  VIRTUAL_ACCOUNT_ENABLEMENT_ACCESS = 'VIRTUAL_ACCOUNT_ENABLEMENT_ACCESS',
  VOTE_INITIATE = 'VOTE_INITIATE',
  WALLET_KEY_EXPORT_PREFERENCE_EDIT = 'WALLET_KEY_EXPORT_PREFERENCE_EDIT',
  WEBHOOK_ADD_INITIATE = 'WEBHOOK_ADD_INITIATE',
  WEBHOOK_EDIT_INITIATE = 'WEBHOOK_EDIT_INITIATE',
  WEBHOOK_REMOVE_INITIATE = 'WEBHOOK_REMOVE_INITIATE',
  WITHDRAW_INITIATE = 'WITHDRAW_INITIATE',
  WITHDRAW_VIEW = 'WITHDRAW_VIEW'
}

/** IAMPermissionAvailability is enum for the field availability */
export enum IAMPermissionAvailability {
  BASE = 'BASE',
  SPECIFIC = 'SPECIFIC',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** A connection to a list of items. */
export type IAMPermissionConnection = {
  __typename: 'IAMPermissionConnection';
  /** A list of edges. */
  edges: Maybe<Array<IAMPermissionEdge>>;
  /** True if at least one of the permissions is related to dynamic resources, e.g. vaults. */
  hasDynamicPermissions: Scalars['Boolean']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IAMPermissionEdge = {
  __typename: 'IAMPermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<IAMPermission>;
};

/** Ordering options for IAMPermission connections */
export type IAMPermissionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IAMPermissions. */
  field: IAMPermissionOrderField;
};

/** Properties by which IAMPermission connections can be ordered. */
export enum IAMPermissionOrderField {
  DISPLAY_NAME = 'DISPLAY_NAME',
  NAME = 'NAME'
}

/** IAMPermissionResourceType is enum for the field resource_type */
export enum IAMPermissionResourceType {
  ORGANIZATION = 'ORGANIZATION',
  UNDEFINED = 'UNDEFINED',
  VAULT = 'VAULT'
}

/**
 * IAMPermissionWhereInput is used for filtering Permission objects.
 * Input was generated by ent.
 */
export type IAMPermissionWhereInput = {
  /** action field predicates */
  action?: InputMaybe<IAMPermissionAction>;
  actionIn?: InputMaybe<Array<IAMPermissionAction>>;
  actionNEQ?: InputMaybe<IAMPermissionAction>;
  actionNotIn?: InputMaybe<Array<IAMPermissionAction>>;
  and?: InputMaybe<Array<IAMPermissionWhereInput>>;
  /** availability field predicates */
  availability?: InputMaybe<IAMPermissionAvailability>;
  availabilityIn?: InputMaybe<Array<IAMPermissionAvailability>>;
  availabilityNEQ?: InputMaybe<IAMPermissionAvailability>;
  availabilityNotIn?: InputMaybe<Array<IAMPermissionAvailability>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayNameGT?: InputMaybe<Scalars['String']['input']>;
  displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameLT?: InputMaybe<Scalars['String']['input']>;
  displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  displayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** category edge predicates */
  hasCategory?: InputMaybe<Scalars['Boolean']['input']>;
  hasCategoryWith?: InputMaybe<Array<IAMCategoryWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<IAMPermissionWhereInput>;
  or?: InputMaybe<Array<IAMPermissionWhereInput>>;
  /** resource_type field predicates */
  resourceType?: InputMaybe<IAMPermissionResourceType>;
  resourceTypeIn?: InputMaybe<Array<IAMPermissionResourceType>>;
  resourceTypeNEQ?: InputMaybe<IAMPermissionResourceType>;
  resourceTypeNotIn?: InputMaybe<Array<IAMPermissionResourceType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** IAMResource is a resource where we have IAM controls */
export type IAMResource = {
  name: Scalars['String']['output'];
};

export type IAMRole = Node & {
  __typename: 'IAMRole';
  availability: IAMRoleAvailability;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /** Position of the role in lists, lowest first. Custom roles use the default, so they sort after system roles. */
  displayOrder: Scalars['Int']['output'];
  /** This is just here for generation and is calculated on every getter, the DB value holds no meaning */
  enabled: Scalars['Boolean']['output'];
  hasRoles: Maybe<Array<IAMRole>>;
  id: Scalars['ID']['output'];
  isInRoles: Maybe<Array<IAMRole>>;
  members: IAMMemberConnection;
  name: Scalars['String']['output'];
  permissions: IAMPermissionConnection;
  roleType: IAMRoleRoleType;
  subtitle: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};


export type IAMRolemembersArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IAMMemberOrder>;
  where?: InputMaybe<IAMMemberWhereInput>;
};


export type IAMRolepermissionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IAMPermissionOrder>;
  where?: InputMaybe<IAMPermissionWhereInput>;
};

/** IAMRoleAvailability is enum for the field availability */
export enum IAMRoleAvailability {
  BASE = 'BASE',
  SPECIFIC = 'SPECIFIC',
  UNSPECIFIED = 'UNSPECIFIED'
}

/**
 * IAMRoleBindingWhereInput is used for filtering RoleBinding objects.
 * Input was generated by ent.
 */
export type IAMRoleBindingWhereInput = {
  and?: InputMaybe<Array<IAMRoleBindingWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** role edge predicates */
  hasRole?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoleWith?: InputMaybe<Array<IAMRoleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** member_id field predicates */
  memberID?: InputMaybe<Scalars['String']['input']>;
  memberIDContains?: InputMaybe<Scalars['String']['input']>;
  memberIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  memberIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  memberIDGT?: InputMaybe<Scalars['String']['input']>;
  memberIDGTE?: InputMaybe<Scalars['String']['input']>;
  memberIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  memberIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  memberIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  memberIDLT?: InputMaybe<Scalars['String']['input']>;
  memberIDLTE?: InputMaybe<Scalars['String']['input']>;
  memberIDNEQ?: InputMaybe<Scalars['String']['input']>;
  memberIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<IAMRoleBindingWhereInput>;
  or?: InputMaybe<Array<IAMRoleBindingWhereInput>>;
  /** organization_key_id field predicates */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDContains?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDGT?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDGTE?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationKeyIDLT?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDLTE?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** resource_id field predicates */
  resourceID?: InputMaybe<Scalars['String']['input']>;
  resourceIDContains?: InputMaybe<Scalars['String']['input']>;
  resourceIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  resourceIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  resourceIDGT?: InputMaybe<Scalars['String']['input']>;
  resourceIDGTE?: InputMaybe<Scalars['String']['input']>;
  resourceIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  resourceIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  resourceIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceIDLT?: InputMaybe<Scalars['String']['input']>;
  resourceIDLTE?: InputMaybe<Scalars['String']['input']>;
  resourceIDNEQ?: InputMaybe<Scalars['String']['input']>;
  resourceIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** IAMRoleChange is a single role change that will be the outcome of a given operation. */
export type IAMRoleChange = {
  __typename: 'IAMRoleChange';
  /** Added field represents the users that will be added role. */
  added: Array<Actor>;
  /** addedKeyIDs field represents the keys that will be added to the role. */
  addedKeyIDs: Array<Scalars['String']['output']>;
  /** Removed field represents the users that will be removed role. */
  removed: Array<Actor>;
  /** removedKeyIDs field represents the keys that will be removed from the role. */
  removedKeyIDs: Array<Scalars['String']['output']>;
  /** resources field is the list of resources bounded to the role change. */
  resources: Array<Resource>;
  /** roleSnapshot is the state of the role before the change. */
  roleSnapshot: IAMRoleSnapshot;
};

/** IAMRoleChanges is the list of role changes that will be the outcome of a given operation. */
export type IAMRoleChanges = {
  __typename: 'IAMRoleChanges';
  /** changes is the list of role changes that will be the outcome of a given operation. */
  changes: Array<IAMRoleChange>;
  /** summary is the summary of the role changes. */
  summary: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type IAMRoleConnection = {
  __typename: 'IAMRoleConnection';
  /** A list of edges. */
  edges: Maybe<Array<IAMRoleEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IAMRoleEdge = {
  __typename: 'IAMRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<IAMRole>;
};

/** Ordering options for IAMRole connections */
export type IAMRoleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IAMRoles. */
  field: IAMRoleOrderField;
};

/** Properties by which IAMRole connections can be ordered. */
export enum IAMRoleOrderField {
  CREATED_AT = 'CREATED_AT',
  DISPLAY_NAME = 'DISPLAY_NAME',
  DISPLAY_ORDER = 'DISPLAY_ORDER',
  NAME = 'NAME'
}

/** IAMRoleRoleType is enum for the field role_type */
export enum IAMRoleRoleType {
  CUSTOM = 'CUSTOM',
  SYSTEM = 'SYSTEM',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** IAMRoleSnapshot is the state of a role at the time of the operation creation. */
export type IAMRoleSnapshot = {
  __typename: 'IAMRoleSnapshot';
  /** description is the description of the role. */
  description: Scalars['String']['output'];
  /** id is the id of the role. */
  id: Scalars['ID']['output'];
  /** name is the name of the role. */
  name: Scalars['String']['output'];
};

/**
 * IAMRoleWhereInput is used for filtering Role objects.
 * Input was generated by ent.
 */
export type IAMRoleWhereInput = {
  and?: InputMaybe<Array<IAMRoleWhereInput>>;
  /** availability field predicates */
  availability?: InputMaybe<IAMRoleAvailability>;
  availabilityIn?: InputMaybe<Array<IAMRoleAvailability>>;
  availabilityNEQ?: InputMaybe<IAMRoleAvailability>;
  availabilityNotIn?: InputMaybe<Array<IAMRoleAvailability>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayNameGT?: InputMaybe<Scalars['String']['input']>;
  displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameLT?: InputMaybe<Scalars['String']['input']>;
  displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  displayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** display_order field predicates */
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  displayOrderGT?: InputMaybe<Scalars['Int']['input']>;
  displayOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  displayOrderIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  displayOrderLT?: InputMaybe<Scalars['Int']['input']>;
  displayOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  displayOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  displayOrderNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** has_roles edge predicates */
  hasHasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasHasRolesWith?: InputMaybe<Array<IAMRoleWhereInput>>;
  /** is_in_roles edge predicates */
  hasIsInRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasIsInRolesWith?: InputMaybe<Array<IAMRoleWhereInput>>;
  /** permissions edge predicates */
  hasPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionsWith?: InputMaybe<Array<IAMPermissionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<IAMRoleWhereInput>;
  or?: InputMaybe<Array<IAMRoleWhereInput>>;
  /** organization_key_id field predicates */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDContains?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDGT?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDGTE?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationKeyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organizationKeyIDLT?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDLTE?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationKeyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** role_type field predicates */
  roleType?: InputMaybe<IAMRoleRoleType>;
  roleTypeIn?: InputMaybe<Array<IAMRoleRoleType>>;
  roleTypeNEQ?: InputMaybe<IAMRoleRoleType>;
  roleTypeNotIn?: InputMaybe<Array<IAMRoleRoleType>>;
  /** subtitle field predicates */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitleContains?: InputMaybe<Scalars['String']['input']>;
  subtitleContainsFold?: InputMaybe<Scalars['String']['input']>;
  subtitleEqualFold?: InputMaybe<Scalars['String']['input']>;
  subtitleGT?: InputMaybe<Scalars['String']['input']>;
  subtitleGTE?: InputMaybe<Scalars['String']['input']>;
  subtitleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subtitleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subtitleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subtitleLT?: InputMaybe<Scalars['String']['input']>;
  subtitleLTE?: InputMaybe<Scalars['String']['input']>;
  subtitleNEQ?: InputMaybe<Scalars['String']['input']>;
  subtitleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** IAMUserAccess represents a user-access relation. */
export type IAMUserAccess = Node & {
  __typename: 'IAMUserAccess';
  /** The access level of the user. */
  accessLevel: IAMAccessLevel;
  /** Unique identifier of this IAMUserAccess. Defaults to user.ID. */
  id: Scalars['ID']['output'];
  /** The user associated with this IAMUserAccess. */
  user: UserV2;
};

/** A connection to a list of items. */
export type IAMUserAccessConnection = {
  __typename: 'IAMUserAccessConnection';
  /** A list of edges. */
  edges: Maybe<Array<IAMUserAccessEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IAMUserAccessEdge = {
  __typename: 'IAMUserAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<IAMUserAccess>;
};

/** A filter to be used against IAMUserAccess fields. */
export type IAMUserAccessWhereInput = {
  /** accessLevel field predicates */
  accessLevel?: InputMaybe<Scalars['String']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IAMUserRole = Node & {
  __typename: 'IAMUserRole';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  hasRoles: Maybe<Array<IAMRole>>;
  icon: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInRoles: Maybe<Array<IAMRole>>;
  name: Scalars['String']['output'];
  organizationKeyID: Maybe<Scalars['String']['output']>;
  permissions: IAMPermissionConnection;
  roleType: IAMRoleRoleType;
  subtitle: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  vaults: VaultConnection;
};


export type IAMUserRolepermissionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IAMPermissionOrder>;
  where?: InputMaybe<IAMPermissionWhereInput>;
};


export type IAMUserRolevaultsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VaultWhereInput>;
};

export type IAMUserRoleConnection = {
  __typename: 'IAMUserRoleConnection';
  edges: Maybe<Array<IAMUserRoleEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IAMUserRoleEdge = {
  __typename: 'IAMUserRoleEdge';
  cursor: Scalars['CursorType']['output'];
  node: Maybe<IAMUserRole>;
};

export type IPAllowlistConfig = {
  __typename: 'IPAllowlistConfig';
  /** Whether the allowlist is active. No endpoint type restricts access while this is false. */
  enabled: Scalars['Boolean']['output'];
  /**
   * Every endpoint type the organization has switched on or holds entries for,
   * each with its own setting. Enforcement is that setting AND `enabled`.
   */
  endpointTypes: Array<IPAllowlistEndpointConfig>;
  entitlement: IPAllowlistEntitlement;
};

export type IPAllowlistConfigUpsertInput = {
  enabled: Scalars['Boolean']['input'];
  enabledEndpointTypes: Array<IPAllowlistEndpointType>;
  organizationKeyID: Scalars['ID']['input'];
};

export type IPAllowlistEndpointConfig = {
  __typename: 'IPAllowlistEndpointConfig';
  /**
   * Whether this endpoint type is switched on, independent of the allowlist's own
   * state. It restricts access only while IPAllowlistConfig.enabled is also true.
   */
  enabled: Scalars['Boolean']['output'];
  endpointType: IPAllowlistEndpointType;
};

export enum IPAllowlistEndpointType {
  APP = 'APP',
  BROWSER_EXTENSION = 'BROWSER_EXTENSION',
  CLIENT_DASHBOARD = 'CLIENT_DASHBOARD',
  REST_API = 'REST_API'
}

/** An organization's level of access to IP allowlisting. Written only by staff. */
export enum IPAllowlistEntitlement {
  /** IP-restricted, but only Anchorage staff may change the allowlist. */
  ANCHORAGE_MANAGED = 'ANCHORAGE_MANAGED',
  /** No access to the feature. */
  NO_ACCESS = 'NO_ACCESS',
  /** IP-restricted, and the organization may manage its own allowlist. */
  SELF_SERVE = 'SELF_SERVE'
}

export type IPAllowlistEntriesFilter = {
  endpointTypes?: InputMaybe<Array<IPAllowlistEndpointType>>;
};

export type IPAllowlistEntry = {
  __typename: 'IPAllowlistEntry';
  cidr: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Actor;
  endpointTypes: Array<IPAllowlistEndpointType>;
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  lastModifiedAt: Maybe<Scalars['Time']['output']>;
  lastModifiedBy: Maybe<Actor>;
};

export type IPAllowlistEntryUpsertInput = {
  cidr: Scalars['String']['input'];
  endpointTypes: Array<IPAllowlistEndpointType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID: Scalars['ID']['input'];
};

export type IPAllowlistMigrateFromEnvVarInput = {
  /** When true, reports what the migration would do without writing anything. */
  dryRun: Scalars['Boolean']['input'];
};

export type IPAllowlistMigrateFromEnvVarResult = {
  __typename: 'IPAllowlistMigrateFromEnvVarResult';
  dryRun: Scalars['Boolean']['output'];
  organizations: Array<IPAllowlistMigrationOrgResult>;
};

export type IPAllowlistMigrationOrgResult = {
  __typename: 'IPAllowlistMigrationOrgResult';
  /** The entitlement the org's config row ends up holding. */
  entitlement: IPAllowlistEntitlement;
  entriesCreated: Scalars['Int']['output'];
  /** Entries removed from the DB because the legacy config does not list their CIDR. */
  entriesDeleted: Scalars['Int']['output'];
  /** Entries already present in the DB that already match the legacy config. */
  entriesSkipped: Scalars['Int']['output'];
  /** Entries already present in the DB whose endpoint types the legacy config corrects. */
  entriesUpdated: Scalars['Int']['output'];
  organizationKeyID: Scalars['ID']['output'];
  /** CIDRs configured only for the legacy WEBHOOK endpoint, which this migration does not carry over. */
  webhookCIDRsIgnored: Scalars['Int']['output'];
};

/** IconName enum is used to determine the icon to display in the InfoItem. */
export enum IconName {
  /** Icon for a clock */
  CLOCK = 'CLOCK',
  /** Icon of a hand holding coins */
  COINS_HAND = 'COINS_HAND',
  /** Icon of a gift */
  GIFT = 'GIFT',
  /** Icon for an info blurb */
  INFO_OUTLINE = 'INFO_OUTLINE',
  /** Icon for a new release */
  NEW_RELEASE = 'NEW_RELEASE',
  /** Icon for a wallet */
  WALLET = 'WALLET'
}

/** IconType is the type of the icon requested */
export enum IconType {
  /** PNG */
  PNG = 'PNG',
  /** SVG */
  SVG = 'SVG'
}

/** ImpedimentType indicates the type of an impediment. */
export enum ImpedimentType {
  /**
   * The source wallet lacks enough balance to cover the transaction (amount and/or
   * network fee). The operation keeps retrying; depositing funds lets it proceed.
   */
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  /** This is an impediment by network conditions. */
  NETWORK_CONDITIONS = 'NETWORK_CONDITIONS',
  /** This is an impediment of unspecified type. */
  OTHER = 'OTHER'
}

/** An inbound TRUST Travel Rule record. */
export type InboundTravelRule = {
  __typename: 'InboundTravelRule';
  /** Asset type ID. */
  assetTypeID: Scalars['String']['output'];
  /** Operation ID the record is linked to, if matched. */
  operationID: Maybe<Scalars['String']['output']>;
  /** Decrypted PII payload as a JSON string. */
  payload: Scalars['String']['output'];
  /** Received timestamp (UnixNano). */
  receivedDate: Scalars['Timestamp']['output'];
  /** Transaction ID. */
  transactionID: Scalars['String']['output'];
};

/**
 * IndividualAffiliateRelationship describes the relationship between an individual
 * and a affiliate.
 */
export enum IndividualAffiliateRelationship {
  /** AML_SERVICE_PROVIDER represents an AML Service Provider relation between individual and affiliate */
  AML_SERVICE_PROVIDER = 'AML_SERVICE_PROVIDER',
  /** AUTHORIZED_SIGNATORY represents an authorized signatory relation between individual and affiliate */
  AUTHORIZED_SIGNATORY = 'AUTHORIZED_SIGNATORY',
  /** BENEFICIAL_OWNER represents a Beneficial Owner relation between individual and affiliate */
  BENEFICIAL_OWNER = 'BENEFICIAL_OWNER',
  /** BENEFICIARY represents a Beneficiary relation between individual and affiliate */
  BENEFICIARY = 'BENEFICIARY',
  /** BOARD_DIRECTOR represents a Board Director relation between individual and affiliate */
  BOARD_DIRECTOR = 'BOARD_DIRECTOR',
  /** CONTROL_PERSON represents a Control Person relation between individual and affiliate */
  CONTROL_PERSON = 'CONTROL_PERSON',
  /** DONOR represents a Donor relation between individual and affiliate */
  DONOR = 'DONOR',
  /** FEEDER_FUND represents a Feeder fund relation between individual and affiliate */
  FEEDER_FUND = 'FEEDER_FUND',
  /** FUND_ADMINISTRATOR represents a Fund Administrator relation between individual and affiliate */
  FUND_ADMINISTRATOR = 'FUND_ADMINISTRATOR',
  /** GENERAL_PARTNER represents a General Partner relation between individual and affiliate */
  GENERAL_PARTNER = 'GENERAL_PARTNER',
  /** GRANTOR represents a Grantor/Settlor relation between individual and affiliate */
  GRANTOR = 'GRANTOR',
  /** GRANTOR_DONOR represents a Grantor/Donor/Settlor relation between individual and affiliate */
  GRANTOR_DONOR = 'GRANTOR_DONOR',
  /** GUARANTOR represents a Guarantor relation between individual and affiliate */
  GUARANTOR = 'GUARANTOR',
  /** INVESTMENT_MANAGER represents a Investment Manager between individual and affiliate */
  INVESTMENT_MANAGER = 'INVESTMENT_MANAGER',
  /** MANAGING_MEMBER represents a Managing Member relation between individual and affiliate */
  MANAGING_MEMBER = 'MANAGING_MEMBER',
  /** OTHER represents another relation between individual and affiliate */
  OTHER = 'OTHER',
  /** PARENT_ENTITY represents a Parent entity relation between individual and affiliate */
  PARENT_ENTITY = 'PARENT_ENTITY',
  /** PARTICIPATING_MEMBER represents an Authorized User relation between individual and affiliate */
  PARTICIPATING_MEMBER = 'PARTICIPATING_MEMBER',
  /** SENIOR_OFFICER represents a Senior Officer relation between individual and affiliate */
  SENIOR_OFFICER = 'SENIOR_OFFICER',
  /** TRUSTEE_SUCCESSOR_TRUSTEE represents a Trustee/Success Trustee relation between individual and affiliate */
  TRUSTEE_SUCCESSOR_TRUSTEE = 'TRUSTEE_SUCCESSOR_TRUSTEE',
  /** TRUST_PROTECTOR represents a Trust protector relation between individual and affiliate */
  TRUST_PROTECTOR = 'TRUST_PROTECTOR'
}

/** IndividualAffiliateRelationshipAudit contains information related to an individual affiliate relationship audit */
export type IndividualAffiliateRelationshipAudit = Node & {
  __typename: 'IndividualAffiliateRelationshipAudit';
  /** The relation with affiliate */
  affiliate: InstitutionalAffiliate;
  /** The audit action */
  auditAction: Scalars['String']['output'];
  /** The audit notes */
  auditNotes: Maybe<Scalars['String']['output']>;
  /** The audit timestamp */
  auditTimestamp: Scalars['Timestamp']['output'];
  /** The audit user */
  auditUser: Scalars['String']['output'];
  /** The individual control title within the affiliate */
  controlTitle: Maybe<Scalars['String']['output']>;
  /** The individual affiliate relationship id */
  id: Scalars['ID']['output'];
  /** The relation with individual */
  individual: InstitutionalIndividual;
  /** The kyc screening audit related information */
  kycScreening: Maybe<KYCScreening>;
  /** Specified if the relation is with individual or related party */
  memberType: Scalars['String']['output'];
  /** The individual ownership percentage related with the affiliate */
  ownershipPercentage: Maybe<Scalars['String']['output']>;
  /** The relation with related party */
  relatedParty: Maybe<KYCRelatedParty>;
  /** The individual roles within the affiliate */
  relationshipTypes: Maybe<Array<IndividualAffiliateRelationship>>;
};

/** Type of information and reason rejected */
export type IndividualInformationRejection = {
  __typename: 'IndividualInformationRejection';
  /** Type of information */
  informationType: IndividualInformationType;
  /** Reason the information was rejected */
  rejectionReason: Scalars['String']['output'];
};

/** Individual PII Types */
export enum IndividualInformationType {
  /** App access desired. E.g. Admin, regular, none. */
  ACCESS_TYPE = 'ACCESS_TYPE',
  /** ACKNOWLEDGE_EMAIL... */
  ACKNOWLEDGE_EMAIL = 'ACKNOWLEDGE_EMAIL',
  /** ACKNOWLEDGE_NAME ... */
  ACKNOWLEDGE_NAME = 'ACKNOWLEDGE_NAME',
  /** ACKNOWLEDGE_TITLE... */
  ACKNOWLEDGE_TITLE = 'ACKNOWLEDGE_TITLE',
  /** First part of the address, usually door number and street */
  ADDRESS = 'ADDRESS',
  /** Second part of the address, usually city, state and zip code */
  ADDRESS2 = 'ADDRESS2',
  /** ADDRESS_PROOF ... */
  ADDRESS_PROOF = 'ADDRESS_PROOF',
  /** ADDRESS_PROOF_DOCUMENT ... */
  ADDRESS_PROOF_DOCUMENT = 'ADDRESS_PROOF_DOCUMENT',
  /** ADS_KYC_IND_FORM_SUBMISSION_ID ... */
  ADS_KYC_INDIVIDUAL_FORM_SUBMISSION_ID = 'ADS_KYC_INDIVIDUAL_FORM_SUBMISSION_ID',
  /** ALIAS */
  ALIAS = 'ALIAS',
  /** CALCUATED_INFO_HASH ... */
  CALCULATED_INFO_HASH = 'CALCULATED_INFO_HASH',
  /** CITIZENSHIP_STATUS ... */
  CITIZENSHIP_STATUS = 'CITIZENSHIP_STATUS',
  /** CITY */
  CITY = 'CITY',
  /** COMPANY_NAME ... */
  COMPANY_NAME = 'COMPANY_NAME',
  /** COUNTRY */
  COUNTRY = 'COUNTRY',
  /** COUNTRY_OF_CITIZENSHIP */
  COUNTRY_OF_CITIZENSHIP = 'COUNTRY_OF_CITIZENSHIP',
  /** Date of birth */
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  /** Email */
  EMAIL = 'EMAIL',
  /** First name */
  FIRST_NAME = 'FIRST_NAME',
  /** GOVERNMENT_ID */
  GOVERNMENT_ID = 'GOVERNMENT_ID',
  /** HAS_SSN */
  HAS_SSN = 'HAS_SSN',
  /** ID Card back side picture */
  ID_CARD_BACK = 'ID_CARD_BACK',
  /** ID_CARD_BACK_SECOND... */
  ID_CARD_BACK_SECOND = 'ID_CARD_BACK_SECOND',
  /** ID Card front side picture */
  ID_CARD_FRONT = 'ID_CARD_FRONT',
  /** ID_CARD_FRONT_SECOND ... */
  ID_CARD_FRONT_SECOND = 'ID_CARD_FRONT_SECOND',
  /** ID_ISSUING_COUNTRY ... */
  ID_ISSUING_COUNTRY = 'ID_ISSUING_COUNTRY',
  /** ID_ISSUING_COUNTRY_SECOND ... */
  ID_ISSUING_COUNTRY_SECOND = 'ID_ISSUING_COUNTRY_SECOND',
  /** The type of the ID (ex. Passport) */
  ID_TYPE = 'ID_TYPE',
  /** ID_TYPE_SECOND ... */
  ID_TYPE_SECOND = 'ID_TYPE_SECOND',
  /** The type of individual. E.g. beneficial owner, authorized person, participating member */
  INDIVIDUAL_TYPE = 'INDIVIDUAL_TYPE',
  /** IS_MAILING_ADDRESS_DIFFERENT ... */
  IS_MAILING_ADDRESS_DIFFERENT = 'IS_MAILING_ADDRESS_DIFFERENT',
  /** KYC_IND_FORM_SUBMISSION_ID ... */
  KYC_INDIVIDUAL_FORM_SUBMISSION_ID = 'KYC_INDIVIDUAL_FORM_SUBMISSION_ID',
  /** Last name */
  LAST_NAME = 'LAST_NAME',
  /** MAILING_CITY ... */
  MAILING_CITY = 'MAILING_CITY',
  /** MAILING_COUNTRY ... */
  MAILING_COUNTRY = 'MAILING_COUNTRY',
  /** MAILING_STATE ... */
  MAILING_STATE = 'MAILING_STATE',
  /** MAILING_STREET_ADDRESS ... */
  MAILING_STREET_ADDRESS = 'MAILING_STREET_ADDRESS',
  /** MAILING_ZIP_CODE ... */
  MAILING_ZIP_CODE = 'MAILING_ZIP_CODE',
  /** MATERIAL_NEWS */
  MATERIAL_NEWS = 'MATERIAL_NEWS',
  /** Middle name */
  MIDDLE_NAME = 'MIDDLE_NAME',
  /** Name */
  NAME = 'NAME',
  /** NON_MATERIAL_NEWS */
  NON_MATERIAL_NEWS = 'NON_MATERIAL_NEWS',
  /** ONBOARDING_API_SUBMISSION_ID ... */
  ONBOARDING_API_SUBMISSION_ID = 'ONBOARDING_API_SUBMISSION_ID',
  /** PASSPORT_DOCUMENT */
  PASSPORT_DOCUMENT = 'PASSPORT_DOCUMENT',
  /** PEP ... */
  PEP = 'PEP',
  /** PEP_COUNTRY_SERVED ... */
  PEP_COUNTRY_SERVED = 'PEP_COUNTRY_SERVED',
  /** PEP_END_DATE_SERVED ... */
  PEP_END_DATE_SERVED = 'PEP_END_DATE_SERVED',
  /** PEP_ROLE ... */
  PEP_ROLE = 'PEP_ROLE',
  /** PEP_START_DATE_SERVED ... */
  PEP_START_DATE_SERVED = 'PEP_START_DATE_SERVED',
  /** Phone number */
  PHONE = 'PHONE',
  /** PRIMARY_COUNTRY ... */
  PRIMARY_COUNTRY = 'PRIMARY_COUNTRY',
  /** RP_INCORPORATION_DATE ... */
  RP_INCORPORATION_DATE = 'RP_INCORPORATION_DATE',
  /** RP_INCORPORATION_PLACE ... */
  RP_INCORPORATION_PLACE = 'RP_INCORPORATION_PLACE',
  /** RP_INVESTMENT_ADVISOR_NUMBER ... */
  RP_INVESTMENT_ADVISOR_NUMBER = 'RP_INVESTMENT_ADVISOR_NUMBER',
  /** SECOND_COUNTRY ... */
  SECOND_COUNTRY = 'SECOND_COUNTRY',
  /** SETTLOR */
  SETTLOR = 'SETTLOR',
  /** SHARES_HELD_PERCENT ... */
  SHARES_HELD_PERCENT = 'SHARES_HELD_PERCENT',
  /** Social security number */
  SSN = 'SSN',
  /** State */
  STATE = 'STATE',
  /** STREET_ADDRESS */
  STREET_ADDRESS = 'STREET_ADDRESS',
  /** SUPERVISOR_INSTITUTIONAL_NAME ... */
  SUPERVISOR_INSTITUTIONAL_NAME = 'SUPERVISOR_INSTITUTIONAL_NAME',
  /** SUPERVISOR_TYPE ... */
  SUPERVISOR_TYPE = 'SUPERVISOR_TYPE',
  /** TITLE ... */
  TITLE = 'TITLE',
  /** US_RESIDENCY_STATUS ... */
  US_RESIDENCY_STATUS = 'US_RESIDENCY_STATUS',
  /** Ownership percentage */
  VERIFY_OWNERSHIP_PERCENTAGE = 'VERIFY_OWNERSHIP_PERCENTAGE',
  /** Role */
  VERIFY_ROLE = 'VERIFY_ROLE',
  /** Voice and video recording */
  VOICE_PHRASE = 'VOICE_PHRASE',
  /** Zip code */
  ZIP_CODE = 'ZIP_CODE'
}

/**
 * Individual PII types accepted on input.
 *
 * Mirrors IndividualInformationType so staff flows can echo read values back as input;
 * omit a value here only when it is provably not submittable.
 */
export enum IndividualInformationTypeInput {
  /** App access desired. E.g. Admin, regular, none. */
  ACCESS_TYPE = 'ACCESS_TYPE',
  /** ACKNOWLEDGE_EMAIL... */
  ACKNOWLEDGE_EMAIL = 'ACKNOWLEDGE_EMAIL',
  /** ACKNOWLEDGE_NAME ... */
  ACKNOWLEDGE_NAME = 'ACKNOWLEDGE_NAME',
  /** ACKNOWLEDGE_TITLE... */
  ACKNOWLEDGE_TITLE = 'ACKNOWLEDGE_TITLE',
  /** First part of the address, usually door number and street */
  ADDRESS = 'ADDRESS',
  /** Second part of the address, usually city, state and zip code */
  ADDRESS2 = 'ADDRESS2',
  /** ADDRESS_PROOF ... */
  ADDRESS_PROOF = 'ADDRESS_PROOF',
  /** ADDRESS_PROOF_DOCUMENT ... */
  ADDRESS_PROOF_DOCUMENT = 'ADDRESS_PROOF_DOCUMENT',
  /** ADS_KYC_IND_FORM_SUBMISSION_ID ... */
  ADS_KYC_INDIVIDUAL_FORM_SUBMISSION_ID = 'ADS_KYC_INDIVIDUAL_FORM_SUBMISSION_ID',
  /** ALIAS */
  ALIAS = 'ALIAS',
  /** CALCUATED_INFO_HASH ... */
  CALCULATED_INFO_HASH = 'CALCULATED_INFO_HASH',
  /** CITIZENSHIP_STATUS ... */
  CITIZENSHIP_STATUS = 'CITIZENSHIP_STATUS',
  /** CITY */
  CITY = 'CITY',
  /** COMPANY_NAME ... */
  COMPANY_NAME = 'COMPANY_NAME',
  /** COUNTRY */
  COUNTRY = 'COUNTRY',
  /** COUNTRY_OF_CITIZENSHIP */
  COUNTRY_OF_CITIZENSHIP = 'COUNTRY_OF_CITIZENSHIP',
  /** Date of birth */
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  /** Email */
  EMAIL = 'EMAIL',
  /** First name */
  FIRST_NAME = 'FIRST_NAME',
  /** GOVERNMENT_ID */
  GOVERNMENT_ID = 'GOVERNMENT_ID',
  /** HAS_SSN */
  HAS_SSN = 'HAS_SSN',
  /** ID Card back side picture */
  ID_CARD_BACK = 'ID_CARD_BACK',
  /** ID_CARD_BACK_SECOND... */
  ID_CARD_BACK_SECOND = 'ID_CARD_BACK_SECOND',
  /** ID Card front side picture */
  ID_CARD_FRONT = 'ID_CARD_FRONT',
  /** ID_CARD_FRONT_SECOND ... */
  ID_CARD_FRONT_SECOND = 'ID_CARD_FRONT_SECOND',
  /** ID_ISSUING_COUNTRY ... */
  ID_ISSUING_COUNTRY = 'ID_ISSUING_COUNTRY',
  /** ID_ISSUING_COUNTRY_SECOND ... */
  ID_ISSUING_COUNTRY_SECOND = 'ID_ISSUING_COUNTRY_SECOND',
  /** The type of the ID (ex. Passport) */
  ID_TYPE = 'ID_TYPE',
  /** ID_TYPE_SECOND ... */
  ID_TYPE_SECOND = 'ID_TYPE_SECOND',
  /** The type of individual. E.g. beneficial owner, authorized person, participating member */
  INDIVIDUAL_TYPE = 'INDIVIDUAL_TYPE',
  /** IS_MAILING_ADDRESS_DIFFERENT ... */
  IS_MAILING_ADDRESS_DIFFERENT = 'IS_MAILING_ADDRESS_DIFFERENT',
  /** KYC_IND_FORM_SUBMISSION_ID ... */
  KYC_INDIVIDUAL_FORM_SUBMISSION_ID = 'KYC_INDIVIDUAL_FORM_SUBMISSION_ID',
  /** Last name */
  LAST_NAME = 'LAST_NAME',
  /** MAILING_CITY ... */
  MAILING_CITY = 'MAILING_CITY',
  /** MAILING_COUNTRY ... */
  MAILING_COUNTRY = 'MAILING_COUNTRY',
  /** MAILING_STATE ... */
  MAILING_STATE = 'MAILING_STATE',
  /** MAILING_STREET_ADDRESS ... */
  MAILING_STREET_ADDRESS = 'MAILING_STREET_ADDRESS',
  /** MAILING_ZIP_CODE ... */
  MAILING_ZIP_CODE = 'MAILING_ZIP_CODE',
  /** MATERIAL_NEWS */
  MATERIAL_NEWS = 'MATERIAL_NEWS',
  /** Middle name */
  MIDDLE_NAME = 'MIDDLE_NAME',
  /** Name */
  NAME = 'NAME',
  /** NON_MATERIAL_NEWS */
  NON_MATERIAL_NEWS = 'NON_MATERIAL_NEWS',
  /** ONBOARDING_API_SUBMISSION_ID ... */
  ONBOARDING_API_SUBMISSION_ID = 'ONBOARDING_API_SUBMISSION_ID',
  /** PASSPORT_DOCUMENT */
  PASSPORT_DOCUMENT = 'PASSPORT_DOCUMENT',
  /** PEP ... */
  PEP = 'PEP',
  /** PEP_COUNTRY_SERVED ... */
  PEP_COUNTRY_SERVED = 'PEP_COUNTRY_SERVED',
  /** PEP_END_DATE_SERVED ... */
  PEP_END_DATE_SERVED = 'PEP_END_DATE_SERVED',
  /** PEP_ROLE ... */
  PEP_ROLE = 'PEP_ROLE',
  /** PEP_START_DATE_SERVED ... */
  PEP_START_DATE_SERVED = 'PEP_START_DATE_SERVED',
  /** Phone number */
  PHONE = 'PHONE',
  /** PRIMARY_COUNTRY ... */
  PRIMARY_COUNTRY = 'PRIMARY_COUNTRY',
  /** RP_INCORPORATION_DATE ... */
  RP_INCORPORATION_DATE = 'RP_INCORPORATION_DATE',
  /** RP_INCORPORATION_PLACE ... */
  RP_INCORPORATION_PLACE = 'RP_INCORPORATION_PLACE',
  /** RP_INVESTMENT_ADVISOR_NUMBER ... */
  RP_INVESTMENT_ADVISOR_NUMBER = 'RP_INVESTMENT_ADVISOR_NUMBER',
  /** SECOND_COUNTRY ... */
  SECOND_COUNTRY = 'SECOND_COUNTRY',
  /** SETTLOR */
  SETTLOR = 'SETTLOR',
  /** SHARES_HELD_PERCENT ... */
  SHARES_HELD_PERCENT = 'SHARES_HELD_PERCENT',
  /** Social security number */
  SSN = 'SSN',
  /** State */
  STATE = 'STATE',
  /** STREET_ADDRESS */
  STREET_ADDRESS = 'STREET_ADDRESS',
  /** SUPERVISOR_INSTITUTIONAL_NAME ... */
  SUPERVISOR_INSTITUTIONAL_NAME = 'SUPERVISOR_INSTITUTIONAL_NAME',
  /** SUPERVISOR_TYPE ... */
  SUPERVISOR_TYPE = 'SUPERVISOR_TYPE',
  /** TITLE ... */
  TITLE = 'TITLE',
  /** US_RESIDENCY_STATUS ... */
  US_RESIDENCY_STATUS = 'US_RESIDENCY_STATUS',
  /** Ownership percentage */
  VERIFY_OWNERSHIP_PERCENTAGE = 'VERIFY_OWNERSHIP_PERCENTAGE',
  /** Role */
  VERIFY_ROLE = 'VERIFY_ROLE',
  /** Voice and video recording */
  VOICE_PHRASE = 'VOICE_PHRASE',
  /** Zip code */
  ZIP_CODE = 'ZIP_CODE'
}

/** InfoItem is an icon/text pair to display information */
export type InfoItem = {
  __typename: 'InfoItem';
  /** Icon to be shown with the info text */
  iconName: IconName;
  /** Information to be shown */
  text: Scalars['String']['output'];
};

/** InfoStep is a step that allows the backend to display information to the user. */
export type InfoStep = StakingStep & {
  __typename: 'InfoStep';
  /** Can be ignored since this step has no data to send */
  fieldName: Maybe<Scalars['String']['output']>;
  /**
   * Ignore this field
   *
   * TODO: do not use - will panic.
   */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** InfoItems is an ordered list of icons/text to show in the info screen */
  infoItems: Array<InfoItem>;
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
  /** SubtitleMessage shows as a subtitle to the TitleMessage */
  subtitleMessage: Scalars['String']['output'];
  /** TitleIcon shows at the top of the info screen */
  titleIcon: IconName;
  /** TitleMessage shows at the top of the info screen */
  titleMessage: Scalars['String']['output'];
};

/**
 * InfoTypeRejection represents a rejection of an information field with a generic type identifier.
 * Uses String instead of enum for flexibility.
 */
export type InfoTypeRejection = {
  __typename: 'InfoTypeRejection';
  /** The information type key (e.g., "FIRST_NAME", "EMAIL", "COUNTRY") */
  informationType: Scalars['String']['output'];
  /** The reason for rejection */
  rejectionReason: Scalars['String']['output'];
};

/** Operation initiator */
export type Initiator = APIKey | User;

/** InlineFiatBeneficiary is the beneficiary of an inline fiat destination */
export type InlineFiatBeneficiary = {
  __typename: 'InlineFiatBeneficiary';
  /** The beneficiary's account number, masked to its last 4 characters */
  accountNumber: Scalars['String']['output'];
  /** The beneficiary's address */
  address: MailingAddress;
  /** First name of an individual beneficiary */
  firstName: Maybe<Scalars['String']['output']>;
  /** Last name of an individual beneficiary */
  lastName: Maybe<Scalars['String']['output']>;
  /** The bank-facing name: the entity name of a business, or the joined first and last name of an individual */
  name: Scalars['String']['output'];
  /** Whether the beneficiary is a business or an individual */
  type: InlineFiatBeneficiaryType;
};

/** InlineFiatBeneficiaryType is the kind of beneficiary on an inline fiat destination */
export enum InlineFiatBeneficiaryType {
  /** Business */
  BUSINESS = 'BUSINESS',
  /** Individual */
  INDIVIDUAL = 'INDIVIDUAL'
}

/** InlineFiatDestination is the beneficiary, banks, purpose and memo a fiat transfer carries inline instead of a trusted destination */
export type InlineFiatDestination = {
  __typename: 'InlineFiatDestination';
  /** The beneficiary of the wire */
  beneficiary: InlineFiatBeneficiary;
  /** The beneficiary's financial institution */
  financialInstitution: InlineFiatFinancialInstitution;
  /** The intermediary financial institution, when the wire routes through one */
  intermediaryFinancialInstitution: Maybe<InlineFiatFinancialInstitution>;
  /** Note to the beneficiary */
  memo: Maybe<Scalars['String']['output']>;
  /** Purpose of the wire */
  purpose: Maybe<Scalars['String']['output']>;
};

/** InlineFiatFinancialInstitution is a bank on an inline fiat destination */
export type InlineFiatFinancialInstitution = {
  __typename: 'InlineFiatFinancialInstitution';
  /** The financial institution's address */
  address: MailingAddress;
  /** The scheme of the financial institution identifier */
  code: InlineFiatFinancialInstitutionCode;
  /** The name of the financial institution */
  name: Maybe<Scalars['String']['output']>;
  /** The financial institution identifier, a routing number or a BIC as code names it */
  routingID: Scalars['String']['output'];
};

/** InlineFiatFinancialInstitutionCode is the scheme of a financial institution identifier on an inline fiat destination */
export enum InlineFiatFinancialInstitutionCode {
  /** Routing number */
  ABA = 'ABA',
  /** SWIFT code */
  BIC = 'BIC'
}

/** Fiat trusted destination ACH pull-authorization input type */
export type InputACHPullAuthorizationFiatTrustedDestination = {
  /** NACHA Company IDs authorized to pull against this grant, each up to 10 alphanumeric characters */
  companyIds: Array<Scalars['String']['input']>;
  /**
   * Per-transaction limit as a decimal USD string: digits, optional ".", at most 2 fractional
   * digits, greater than zero. No sign, commas, or currency symbol.
   */
  perTransactionLimit: Scalars['String']['input'];
};

/** Fiat trusted destination ACH push input type */
export type InputACHPushFiatTrustedDestination = {
  /** Account number */
  accountNumber: Scalars['String']['input'];
  /** ACH routing number */
  routingNumber: Scalars['String']['input'];
};

/** Extra parameters for aptos */
export type InputAptosExtraParams = {
  /** buyInsAddresses are the addresses of the buy ins the new vesting contract */
  buyInsAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** buyInsCoins are the tokens that match the buyInsAddresses for the new vesting contract */
  buyInsCoins?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  /** commission is the operator commission percentage */
  commission?: InputMaybe<Scalars['Int']['input']>;
  /** shareholders are the addresses of the vesting contract shareholders */
  shareholders?: InputMaybe<Array<Scalars['String']['input']>>;
  /** vestingPeriodDuration is the duration of the new vesting contract */
  vestingPeriodDuration?: InputMaybe<Scalars['Int']['input']>;
  /** vestingScheduleDenominators are the schedule fraction denominators for the new vesting contract */
  vestingScheduleDenominators?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** vestingScheduleDenominators are the schedule fraction numerators for the new vesting contract */
  vestingScheduleNumerators?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** vestingStartTimestampSecs is the start date of the new vesting contract */
  vestingStartTimestampSecs?: InputMaybe<Scalars['String']['input']>;
  /** voterAddress is the account's voter address */
  voterAddress?: InputMaybe<Scalars['String']['input']>;
  /** withdrawalAddress is the address to which the vested tokens will be withdrawn to */
  withdrawalAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Optional extra params for assets that require it */
export type InputAssetExtraParams = {
  /** value for the extra parameter */
  value: Scalars['String']['input'];
};

/** Extra parameters for Avalanche Staking operations */
export type InputAvalanchePChainExtraParams = {
  /** Action type is used to decide which fields should be used. */
  actionType: ExtraParamsActionType;
  /** Address where the rewards from delegation will be sent to */
  delegatorRewardsAddress?: InputMaybe<Scalars['String']['input']>;
  /**
   * Duration of the delegation in days, as a string (e.g. "14" for 14 days).
   * Used only by delegate operations. If omitted, the delegation runs from the current time through the validator's end time.
   */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** Staking position end time in RFC3339 format. Required for stake; ignored for delegate. */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Node's Proof of Possession Public Key */
  nodePublicKey?: InputMaybe<Scalars['String']['input']>;
  /** Node's Proof of Possession Signature */
  nodeSignature?: InputMaybe<Scalars['String']['input']>;
  /** Staking position start time in RFC3339 format. Required for stake; ignored for delegate. */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** Address where the staking rewards will be sent to */
  validatorRewardsAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Extra parameters for BSC staking */
export type InputBSCExtraParams = {
  /**
   * delegateVotePower indicates whether to also delegate the associated governance voting
   * power. Applies to DELEGATE and REDELEGATE operations; not applicable for UNDELEGATE.
   * Defaults to true when omitted.
   */
  delegateVotePower?: InputMaybe<Scalars['Boolean']['input']>;
  /** redelegateSrc is the source validator address, required for redelegate operations. */
  redelegateSrc?: InputMaybe<Scalars['String']['input']>;
};

/** Extra parameters for Bitcoin Babylon Claim operations. */
export type InputBitcoinBabylonClaimExtraParams = {
  /**
   * The version of the babylon staking global params.
   * Optional because it should be deduced, not provided.
   */
  babylonStakingVersion?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the delegate operation that the claim operation is associated with. */
  delegateOperationID?: InputMaybe<Scalars['String']['input']>;
  /**
   * The public key of the finality provider encoded in hex.
   * Optional because it should be deduced, not provided.
   */
  finalityProviderPublicKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * The relative lock-time in blocks.
   * Optional because it should be deduced, not provided.
   */
  timelockBlocks?: InputMaybe<Scalars['Int']['input']>;
};

/** Extra parameters for Bitcoin Babylon Deduce Collect operations. */
export type InputBitcoinBabylonDeduceCollectTypeExtraParams = {
  /** delegateOperationID is the ID of the delegate operation to be collected. */
  delegateOperationID?: InputMaybe<Scalars['String']['input']>;
};

/** Extra parameters for Bitcoin Babylon Delegate operations. */
export type InputBitcoinBabylonDelegateExtraParams = {
  /** Babylon address for rewards. */
  babylonAddressForRewards?: InputMaybe<Scalars['String']['input']>;
  /** The babylon staking version. Used only for testing. */
  babylonStakingVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The public key of the finality provider encoded in hex. */
  finalityProviderPublicKey?: InputMaybe<Scalars['String']['input']>;
  /** The relative lock-time in blocks. Used only for testing. */
  timelockBlocks?: InputMaybe<Scalars['Int']['input']>;
};

/** Extra parameters for Bitcoin Babylon Early Unbond operations. */
export type InputBitcoinBabylonEarlyUnbondExtraParams = {
  /**
   * The version of the babylon staking global params.
   * Optional because it should be deduced, not provided.
   */
  babylonStakingVersion?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the delegate operation that the early unbond operation is associated with. */
  delegateOperationID?: InputMaybe<Scalars['String']['input']>;
  /**
   * The public key of the finality provider encoded in hex.
   * Optional because it should be deduced, not provided.
   */
  finalityProviderPublicKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * The relative lock-time in blocks.
   * Optional because it should be deduced, not provided.
   */
  timelockBlocks?: InputMaybe<Scalars['Int']['input']>;
};

/** Extra parameters for Bitcoin Babylon Spend Unbond Expired Timelock operations. */
export type InputBitcoinBabylonSpendUnbondExpiredTimelockExtraParams = {
  /**
   * The version of the babylon staking global params.
   * Optional because it should be deduced, not provided.
   */
  babylonStakingVersion?: InputMaybe<Scalars['Int']['input']>;
  /** delegateOperationID is the ID of the delegate operation that the spend unbond expired timelock operation is associated with. */
  delegateOperationID?: InputMaybe<Scalars['String']['input']>;
  /**
   * The public key of the finality provider encoded in hex.
   * Optional because it should be deduced, not provided.
   */
  finalityProviderPublicKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unbonding relative lock-time in blocks.
   * Optional because it should be deduced, not provided.
   */
  unbondTimelockBlocks?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Unbond TxID broadcast by the covenant committee
   * Optional because it should be deduced, not provided.
   */
  unbondTxID?: InputMaybe<Scalars['String']['input']>;
  /**
   * unbond Vout index to spend
   * Optional because it should be deduced, not provided.
   */
  unbondVout?: InputMaybe<Scalars['Int']['input']>;
};

/** Extra parameters for Bitcoin operations. */
export type InputBitcoinExtraParams = {
  /** Action type is used to decide which fields should be used. */
  actionType?: InputMaybe<ExtraParamsActionType>;
  /** Bitcoin Babylon Claim extra parameters. */
  babylonClaimExtraParams?: InputMaybe<InputBitcoinBabylonClaimExtraParams>;
  /**
   * Bitcoin - Babylon staking: the backend shall deduce which collection
   * mechanism to use: BITCOIN_BABYLON_STAKING_OUTPUT_SPEND_EXPIRED_TIMELOCK for
   * expired stakes or BITCOIN_BABYLON_UNBONDING_OUTPUT_SPEND_EXPIRED_TIMELOCK for
   * early unbonds.
   */
  babylonDeduceCollectTypeExtraParams?: InputMaybe<InputBitcoinBabylonDeduceCollectTypeExtraParams>;
  /** Bitcoin Babylon Delegate extra parameters. */
  babylonDelegateExtraParams?: InputMaybe<InputBitcoinBabylonDelegateExtraParams>;
  /** Bitcoin Babylon Early Unbond extra parameters. */
  babylonEarlyUnbondExtraParams?: InputMaybe<InputBitcoinBabylonEarlyUnbondExtraParams>;
  /** Bitcoin Babylon Spend Unbond Expired Timelock extra parameters. */
  babylonSpendUnbondExpiredTimelockExtraParams?: InputMaybe<InputBitcoinBabylonSpendUnbondExpiredTimelockExtraParams>;
};

/** InputBlockchainAddress describes a combination of blockchain network and text address */
export type InputBlockchainAddress = {
  /** address is the text representation of a blockchain address. */
  address: Scalars['String']['input'];
  /** DO NOT USE: AML is not used for this type, will be removed in the future */
  amlQuestionnaire: InputQuestionnaireSubmission;
  /** networkID is the network or blockchain for which the address. */
  networkID: Scalars['ID']['input'];
};

/**
 * Extra parameters for celo governance vote.
 * Deprecated: Celo governance has been removed. This input is accepted but ignored.
 */
export type InputCeloGovernanceVoteExtraParams = {
  /** actionType is used to construct canonical payload */
  actionType?: InputMaybe<ExtraParamsActionType>;
  /** destination tag to use in transaction */
  proposalID: Scalars['Int']['input'];
  /** voteOption is the intent of the vote */
  voteOption: VoteOption;
};

/** Extra parameters for cosmos */
export type InputCosmosExtraParams = {
  /** memo to use in transaction */
  memo?: InputMaybe<Scalars['String']['input']>;
};

/** InputCreateGlobalTrustedSource represents the data necessary to create a global trusted source */
export type InputCreateGlobalTrustedSource = {
  /**
   * Whether the attribution waterfall should disregard the source address for this record.
   * Defaults to false when omitted.
   */
  disregardSourceAddress?: Scalars['Boolean']['input'];
  /** Due diligence notes for this global trusted source */
  dueDiligence: Scalars['String']['input'];
  /** Network from the respective source address */
  network: Scalars['String']['input'];
  /** Country of the trusted source originator */
  originatorCountry: Scalars['String']['input'];
  /** Name of the trusted source originator */
  originatorName: Scalars['String']['input'];
  /** Source address to consider as trusted */
  sourceAddress: Scalars['String']['input'];
  /** Type of wallet associated with the trusted source */
  walletType: TrustedSourceWalletType;
};

export type InputCreateLegalterms = {
  /** Should use either ShortName or Name of an entities.AnchorageEntity. */
  anchorageEntity?: InputMaybe<Scalars['String']['input']>;
  /** Protocol-specific info, eg "BTC" (asset ID), "EVM" (a group of blockchains), "Celo" (blockchain ID). */
  assetTypeID?: InputMaybe<Scalars['String']['input']>;
  /** Disclosure type, eg "tos" for Terms of Service, "Price", "Privacy". */
  category: Scalars['String']['input'];
  /** Field for an optional custom reference */
  custom?: InputMaybe<Scalars['String']['input']>;
  /** Name of a product/feature, eg "walletconnect". */
  feature?: InputMaybe<Scalars['String']['input']>;
  involvesAccount: Scalars['Boolean']['input'];
  staticContent: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** InputCreateTrustedSource represents the data necessary to create a trusted source */
export type InputCreateTrustedSource = {
  /** Network from the respective source address */
  network: Scalars['String']['input'];
  /** Organization where we want to add the trusted source */
  organizationID: Scalars['String']['input'];
  /** Country of the trusted source originator */
  originatorCountry: Scalars['String']['input'];
  /** Name of the trusted source originator */
  originatorName: Scalars['String']['input'];
  /** Source address to consider as trusted */
  sourceAddress: Scalars['String']['input'];
  /** Country of the trusted source vasp in case the originator does not control the wallet. */
  vaspCountry?: InputMaybe<Scalars['String']['input']>;
  /** Name of the trusted source vasp in case the originator does not control the wallet */
  vaspName?: InputMaybe<Scalars['String']['input']>;
  /** Type of wallet associated with the trusted source */
  walletType: TrustedSourceWalletType;
};

export type InputCreateVaultPolicy = {
  /** Default rule for the policy */
  defaultRule: InputRule;
  /** List of keys that are part of this policy along with its access level */
  keys: Array<InputKeyAccess>;
  /** Policy name */
  name: Scalars['String']['input'];
  /** Ordered list of rules (ordering determines the priority of the rules) */
  specificRules?: InputMaybe<Array<InputRule>>;
};

/** InputDepositAttributionOriginator represents a single originator that can be associated with a deposit attribution */
export type InputDepositAttributionOriginator = {
  /** Country of the deposit attribution originator */
  originatorCountry: Scalars['String']['input'];
  /** Name of the deposit attribution originator */
  originatorName: Scalars['String']['input'];
};

/** InputDestination is an input for valid forms of destinations for a role */
export type InputDestination = {
  /** addresses indicates any specific addresses which are valid. An empty list does not indicate all addresses are valid. */
  addresses?: InputMaybe<Array<InputBlockchainAddress>>;
  /**
   * Allows fiat payouts to any destination without a trusted destination or quorum approval. Cannot be combined with addresses or
   * trusted destinations. Requires the Any Destination Module.
   */
  anyDestination?: InputMaybe<Scalars['AnyDestinationScopeInput']['input']>;
  /**
   * anyTrustedDestination dynamically allows transfers to any address in the org's trusted destinations.
   * Unlike trustedDestinationSubIDs which copies specific addresses at creation time,
   * this flag checks trusted destinations at transfer time.
   */
  anyTrustedDestination?: InputMaybe<Scalars['Boolean']['input']>;
  /** internalDestinationsAllowed indicates which internal destinations that will be allowed. If not supplied, defaults to NONE. */
  internalDestinationsAllowed: InternalDestinationsAllowed;
  /**
   * trustedDestinations indicates existing trusted destinations which will be copied into allowed destination addresses.
   *
   * The trusted destination data is not linked the resulting RolePermission. Any change to the trusted destination will not change the RolePermission.
   * Metadata is retained to display the input trusted destination for operation reviewers.
   */
  trustedDestinationSubIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** vaultIDs indicates which internal destination vaults will be allowed. */
  vaultIDs?: InputMaybe<Array<inputVaultID>>;
};

/** Extra parameters for diem */
export type InputDiemExtraParams = {
  /** tradeId to use in transaction if it's from or to a Designated Dealer */
  tradeId?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a setting */
export type InputDocDeliverySetting = {
  /** Id of the affiliate (if applicable) */
  affiliateID?: InputMaybe<Scalars['ID']['input']>;
  /** Refers to the value(s) of the setting */
  value?: InputMaybe<Array<DocumentDeliveryContact>>;
};

/** Inputs to importETHValidatorSet mutation */
export type InputETHValidatorParameters = {
  /** amount is the amount to deposit to the validator, expressed in Gwei */
  amount: Scalars['Uint64']['input'];
  /** publicKey is the public key of the validator */
  publicKey: Scalars['String']['input'];
  /** signature is the signature of the validator deposit data */
  signature: Scalars['String']['input'];
  /** withdrawalCredentials is the withdrawal credentials of the validator */
  withdrawalCredentials: Scalars['String']['input'];
};

/** InputEditDepositAttributions is a tuple of operationID/sourceAddress that shall be changed */
export type InputEditDepositAttributions = {
  /** Array of pairs being attributed */
  attributionPairs: Array<DepositAttributionPair>;
  /** Notes added to the attribution submission */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Originator associated with the attribution */
  originator?: InputMaybe<InputDepositAttributionOriginator>;
  /** Type of wallet associated with the attribution */
  walletType?: InputMaybe<DepositAttributionWalletType>;
};

/** InputEditGlobalTrustedSource represents the data necessary to edit a global trusted source */
export type InputEditGlobalTrustedSource = {
  /** Whether the attribution waterfall should disregard the source address for this record. */
  disregardSourceAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Due diligence notes for this global trusted source */
  dueDiligence?: InputMaybe<Scalars['String']['input']>;
  /** ID of the global trusted source to edit */
  id: Scalars['String']['input'];
  /** Country of the trusted source originator */
  originatorCountry?: InputMaybe<Scalars['String']['input']>;
  /** Name of the trusted source originator */
  originatorName?: InputMaybe<Scalars['String']['input']>;
  /** Type of wallet associated with the trusted source */
  walletType?: InputMaybe<TrustedSourceWalletType>;
};

/** InputEditTrustedSource represents the data necessary to edit a trusted source */
export type InputEditTrustedSource = {
  /** Trusted source identifier */
  id: Scalars['String']['input'];
  /** Country of the trusted source originator */
  originatorCountry?: InputMaybe<Scalars['String']['input']>;
  /** Name of the trusted source originator */
  originatorName?: InputMaybe<Scalars['String']['input']>;
  /** Type of wallet associated with the trusted source */
  walletType?: InputMaybe<TrustedSourceWalletType>;
};

/** InputEncryptedControlMasterPrivateKey is is used in submitStagedControlKeys */
export type InputEncryptedControlMasterPrivateKey = {
  /** The private key encrypted to the encryption key of this device */
  encryptedControlMasterPrivateKey: Scalars['String']['input'];
  /** The user's publicKeyID from EnrollingUserControlKey.publicKeyID */
  publicKeyID: Scalars['String']['input'];
};

/** InputEncryptedWalletRecoveryKeyShares is used in submitStagedWalletRecoveryKeyShares mutation */
export type InputEncryptedWalletRecoveryKeyShares = {
  /** The share of the wallet recovery key encrypted to the encryption key of this device */
  encryptedShare: Scalars['String']['input'];
  /** The user's publicKeyID */
  publicKeyID: Scalars['String']['input'];
};

/** InputEndorseOperation represents the input needed to endorse an operation. */
export type InputEndorseOperation = {
  /**
   * This field is required when submitting execute operations for the HSM to process.
   * The child control key is derived from the master control key for the relevant wallet
   * according to the Porto spec:
   * https://www.notion.so/anchorage/Porto-Control-key-key-export-features-d9b433d754234d60a75884007b859477
   */
  childControlKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * This field is required when adding or replacing users in self-operated organizations (where the Operator for the Organization is SELF)
   * It requires a copy of the control key, encrypted by the encryptionPublicKey for the new user.
   * It should be formatter in whatever way the secure enclave libraries like it in so it's easy to decrypt on the new user's device.
   */
  encryptedControlMasterPrivateKey?: InputMaybe<Scalars['String']['input']>;
  /** ID of the operation to endorse. */
  operationID: Scalars['String']['input'];
  /** Signed endorsement with metadata payload. */
  payload: Scalars['String']['input'];
};

/** Extra parameters for ethereum staking */
export type InputEthereumExtraParams = {
  /** stakingProvider is the provider that will be used to stake the ethereum */
  stakingProvider?: InputMaybe<ETHStakingProviderType>;
  /** validatorCount is the amount of validators for this staking operation */
  validatorCount?: InputMaybe<Scalars['String']['input']>;
  /** withdrawalAddress is the address to where the funds will be returned to when withdrawal is possible */
  withdrawalAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Inputs to setEthereumStakingProvidersConfigurationForOrg mutation */
export type InputEthereumFigmentStakingConfiguration = {
  /** region is where validators infrastructure is to be deployed */
  region: Scalars['String']['input'];
};

/** Inputs to setEthereumStakingProvidersConfigurationForOrg mutation */
export type InputEthereumStakingProvidersConfiguration = {
  /** figment is the organization staking configuration for the provider Figment */
  figment?: InputMaybe<InputEthereumFigmentStakingConfiguration>;
  /** twinstake is the organization staking configuration for the provider Twinstake */
  twinstake?: InputMaybe<InputEthereumTwinstakeStakingConfiguration>;
};

/** Inputs to setEthereumStakingProvidersConfigurationForOrg mutation */
export type InputEthereumTwinstakeStakingConfiguration = {
  /** clientName is a common AD and Twinstake client reference */
  clientName: Scalars['String']['input'];
};

/**
 * Extra parameters per asset type
 * We assume you don't simultaneously transact in mainnet and testnet
 */
export type InputExtraParams = {
  /** params for aptos */
  aptosExtraParams?: InputMaybe<InputAptosExtraParams>;
  /** extra supported params for assets */
  assetExtraParams?: InputMaybe<InputAssetExtraParams>;
  /** params for Avalanche P-Chain */
  avalanchePChainExtraParams?: InputMaybe<InputAvalanchePChainExtraParams>;
  /** params for Bitcoin */
  bitcoinExtraParams?: InputMaybe<InputBitcoinExtraParams>;
  /** params for BSC staking */
  bscExtraParams?: InputMaybe<InputBSCExtraParams>;
  /**
   * params for celo governance vote
   * @deprecated Celo governance has been removed. This field is ignored.
   */
  celoGovernanceVoteExtraParams?: InputMaybe<InputCeloGovernanceVoteExtraParams>;
  /** params for cosmos */
  cosmosExtraParams?: InputMaybe<InputCosmosExtraParams>;
  /**
   * params for diem
   * @deprecated Unused, will be removed in future versions
   */
  diemExtraParams?: InputMaybe<InputDiemExtraParams>;
  /** params for ethereum staking */
  ethereumExtraParams?: InputMaybe<InputEthereumExtraParams>;
  /**
   * params for FIAT
   * @deprecated Use fiatTrustedDestinationExtraParams instead
   */
  fiatExtraParams?: InputMaybe<InputFiatExtraParams>;
  /** params for FIAT trusted destinations */
  fiatTrustedDestinationExtraParams?: InputMaybe<InputFiatTrustedDestinationExtraParams>;
  /** input params for flow delegation */
  flowDelegateExtraParams?: InputMaybe<InputFlowDelegateExtraParams>;
  /** params for maker */
  makerExtraParams?: InputMaybe<InputMakerExtraParams>;
  /** input params for oasis undelegate */
  oasisUndelegateExtraParams?: InputMaybe<InputOasisUndelegateExtraParams>;
  /** params for ripple */
  rippleExtraParams?: InputMaybe<InputRippleExtraParams>;
  /** params for starknet */
  starknetExtraParams?: InputMaybe<InputStarknetExtraParams>;
  /** params for stellar */
  stellarExtraParams?: InputMaybe<InputStellarExtraParams>;
  /** params for tendermint */
  tendermintExtraParams?: InputMaybe<InputTendermintExtraParams>;
};

/** Extra parameters for Fiat */
export type InputFiatExtraParams = {
  /** Unique Identifier of a Standing Instruction */
  standingInstructionID: Scalars['String']['input'];
};

/** Fiat trusted destination address input type */
export type InputFiatTrustedDestinationAddress = {
  /** Address Line 1 */
  addressLine1: Scalars['String']['input'];
  /** Address Line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city: Scalars['String']['input'];
  /** Country */
  country: Scalars['String']['input'];
  /** Province */
  province: Scalars['String']['input'];
  /** Zip Code */
  zipCode: Scalars['String']['input'];
};

/** Fiat trusted destination beneficiary information */
export type InputFiatTrustedDestinationBenificiary = {
  /** Beneficiary address */
  address: InputFiatTrustedDestinationAddress;
  /** Beneficiary ID code */
  code: FiatTrustedDestinationIDCode;
  /** The name of the beneficiary - Business */
  entityName?: InputMaybe<Scalars['String']['input']>;
  /** First name of the beneficiary - Individual */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Beneficiary ID */
  id: Scalars['String']['input'];
  /** Last name of the beneficiary - Individual */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Beneficiary type */
  type: FiatTrustedDestinationBeneficiaryType;
};

/** Extra parameters for Fiat trusted destinations */
export type InputFiatTrustedDestinationExtraParams = {
  /** Note to the beneficiary of this fiat withdrawal */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** Purpose of this fiat withdrawal */
  purpose: Scalars['String']['input'];
  /** Unique Identifier of a Trusted Destination */
  trustedDestinationID: Scalars['String']['input'];
};

/** Fiat trusted destination institution */
export type InputFiatTrustedDestinationInstitution = {
  /** Financial institution address */
  address: InputFiatTrustedDestinationAddress;
  /** Financial institution ID code */
  code: FiatTrustedDestinationIDCode;
  /** Financial institution ID */
  id: Scalars['String']['input'];
  /** The name of the financial institution */
  name: Scalars['String']['input'];
};

/** Extra parameters for flow Delegate */
export type InputFlowDelegateExtraParams = {
  /** actionType is used to construct canonical payload */
  actionType?: InputMaybe<ExtraParamsActionType>;
  /** isStake dictates whether the operation is a delegation or staking */
  isStake?: InputMaybe<Scalars['Boolean']['input']>;
  /** nodeID is a unique identifier for a node that can be delegate to */
  nodeID?: InputMaybe<Scalars['String']['input']>;
};

/**
 * InputFragmentBindingChange represents a fragment binding with the scope and the set of
 * fragments that compose the policy
 */
export type InputFragmentBindingChange = {
  /** The ID of the binding that is being updated. */
  bindingID: Scalars['String']['input'];
  /** The human readable display name of the binding. */
  displayName: Scalars['String']['input'];
  /** The fragments that will be updated. */
  fragments: Array<InputStructuredFragment>;
  /** The action that the binding applies to. */
  scope: Scalars['String']['input'];
};

/** InputFragmentPolicyQuorum is the representation of policy quorum update */
export type InputFragmentPolicyQuorum = {
  /** The updated human readable description of the quorum. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The updated human readable display name of the quorum. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The updated set of principals that will be granted the role. */
  members: Array<Scalars['String']['input']>;
  /** The strictness requirement of fulfilling the quorum in order to fulfill the containing policy fragment. */
  quorumRequirement: QuorumRequirement;
  /** The updated number of endorsements from the expanded members which must be provided. */
  threshold: Scalars['Int']['input'];
};

/** Type used for submitting PII */
export type InputIndividualInformation = {
  /** The type of information */
  informationType: IndividualInformationTypeInput;
  /** The value of the information */
  value: Scalars['String']['input'];
};

/**
 * InputInfoType represents a key-value pair for profile information.
 * Uses String for informationType instead of enum for flexibility.
 */
export type InputInfoType = {
  /** The information type key (e.g., "FIRST_NAME", "DATE_OF_BIRTH") */
  informationType: Scalars['String']['input'];
  /** The value for this information type */
  value: Scalars['String']['input'];
};

export type InputKYCProfileInfo = {
  /** The key/identifier for this piece of information */
  key: Scalars['String']['input'];
  /** The value of the information */
  value: Scalars['String']['input'];
};

/** InputKYCQuestionAnswer is the input type for the actual user answer for a question */
export type InputKYCQuestionAnswer = {
  /** The free form text written in response to the question */
  freeformText?: InputMaybe<Scalars['String']['input']>;
  /** A group of answers, used to answer for a question of type group */
  group: Array<Array<InputKYCQuestionAnswer>>;
  /** The option IDs selected in response to the question */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The id of the question this answer is related to */
  questionID: Scalars['String']['input'];
};

export type InputKeyAccess = {
  accessLevel: IAMAccessLevel;
  keyID: Scalars['ID']['input'];
};

/** InputKeyRename represents the input needed to rename a single key. */
export type InputKeyRename = {
  name: Scalars['String']['input'];
  publicKeyID: Scalars['PublicKeyID']['input'];
};

/** Type used for submitting known information */
export type InputKnownInformation = {
  /** The grouped information value if applicable */
  groupValue?: InputMaybe<Array<InputMaybe<Array<InputKnownInformation>>>>;
  /** The type of information */
  informationType: Scalars['String']['input'];
  /** The value of the information */
  value: Scalars['String']['input'];
};

/** Extra parameters for maker */
export type InputMakerExtraParams = {
  /** toggle for IOU or MKR authorize spender transaction */
  isAuthorizingIOUToken?: InputMaybe<Scalars['Boolean']['input']>;
  /** for polling: the ID of the option being voted on */
  optionID?: InputMaybe<Scalars['Int']['input']>;
  /** for polling: the ID of the poll being voted on */
  pollID?: InputMaybe<Scalars['Int']['input']>;
  /** what type of vote: VOTE for executive, POLLVOTE for polling */
  voteType?: InputMaybe<Scalars['String']['input']>;
};

/** Extra parameters for oasis undelegate */
export type InputOasisUndelegateExtraParams = {
  /** actionType is used to construct canonical payload */
  actionType?: InputMaybe<ExtraParamsActionType>;
  /** estimated value of shares at time of undelegate request */
  estimatedSharesAmount?: InputMaybe<Scalars['String']['input']>;
  /** numShares to undelegate */
  numShares?: InputMaybe<Scalars['String']['input']>;
  /** percentShares to undelegate */
  percentShares?: InputMaybe<Scalars['String']['input']>;
};

/**
 * InputOneOffParam is to generically input parameters for one-off operations
 * such as Ethereum contract parameters
 */
export type InputOneOffParam = {
  /** The label (or key) for a one-off operation parameter */
  label: Scalars['String']['input'];
  /** The value for a one-off operation parameter */
  value: Scalars['String']['input'];
};

/**
 * InputOperationActionPair represents a set composed of an OperationAction and a specificed sub action,
 * e.g. a pair ORGANIZATION_CHANGE action with CREATE_VAULT subAction
 */
export type InputOperationActionPair = {
  /** The OperationAction of the pair. */
  action: OperationAction;
  /** The string representation of the sub action of the pair, if any. */
  subAction?: InputMaybe<Scalars['String']['input']>;
};

/** Type used for submitting PII */
export type InputPII = {
  /** The type of information */
  informationType: PIIInformationType;
  /** The value of the information */
  value: Scalars['String']['input'];
};

/** InputPerformManualDepositAttributions is a tuple of operationID/sourceAddress that shall be attributed */
export type InputPerformManualDepositAttributions = {
  /** Array of pairs being attributed */
  attributionPairs: Array<DepositAttributionPair>;
  /** Notes added to the attribution submission */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Originator associated with the attribution */
  originator: InputDepositAttributionOriginator;
  /** Flag to indicate if the source addresses associated with this attribution should be added to the trusted sources */
  trustedSource: Scalars['Boolean']['input'];
  /** Type of wallet associated with the attribution */
  walletType: DepositAttributionWalletType;
};

/** InputPolicy is constructed of lists of quorums and other data */
export type InputPolicy = {
  /** The action associated with this policy */
  action: PolicyActionType;
  /** initiateOnlyUsers is a list of initators that can create but can't approve the operations with this action */
  initiateOnlyUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Minimum number of endorsments needed from the requiredUsers List.
   * When not present or empty defaults to the number of required users.
   */
  numRequiredUsers?: InputMaybe<Scalars['Int']['input']>;
  /** Quorums are the list of quorums for this policy */
  quorums: Array<InputQuorum>;
  /**
   * List of soft required users. This requirement is not cryptographically enforced,
   * meaning that this will serve as a guideline to the risk reviewer only.
   */
  requiredUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputPolicyAccessLevel = {
  /** Access level of the user */
  accessLevel: IAMAccessLevel;
  /** Unique identifier of the policy container group */
  policyID: Scalars['ID']['input'];
  /**
   * Quorums the user will be added to
   * Only for initiate and approve
   */
  quorumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** InputPolicyContainerUpdate represents a set of changes to be applied to a policy container. */
export type InputPolicyContainerUpdate = {
  /** fragmentBindingChanges represents the list of fragment binding changes to be applied. */
  fragmentBindingChanges?: InputMaybe<Array<InputFragmentBindingChange>>;
  /** roleBindingChanges represents the list of role binding changes to be applied. */
  roleBindingChanges?: InputMaybe<Array<InputRoleBindingChange>>;
};

/** InputPolicyContainerUpdateChanges represents the changes to be made to a policy container. */
export type InputPolicyContainerUpdateChanges = {
  /** The ID of the resource to be updated. */
  resourceID: Scalars['String']['input'];
  /** The details of the update to be applied to the policy container. */
  update: InputPolicyContainerUpdate;
};

/** Answer provided for a particular question with metadata */
export type InputQuestionnaireAnswer = {
  /** List of options or freeform text for the answer */
  answerData: InputQuestionnaireAnswerData;
  /** Unique identifier for the question */
  questionID: Scalars['String']['input'];
};

/** Actual answer data provided by the user */
export type InputQuestionnaireAnswerData = {
  /** Freeform text given by the user */
  freeformText?: InputMaybe<Scalars['String']['input']>;
  /** Options selected by the user */
  options: Array<Scalars['String']['input']>;
};

/** Questionnaire submission that a user sends */
export type InputQuestionnaireSubmission = {
  /** List of answers to submit on a questionnaire */
  answers: Array<InputQuestionnaireAnswer>;
  /** Unique identifier for the questionnaire */
  questionnaireID: Scalars['String']['input'];
};

/**
 * InputQuorum represents a list of authorized keys combined with the required number of
 * keys in order for the quorum to be met.
 */
export type InputQuorum = {
  /** Number of signatures required to satisfy this quorum */
  signaturesRequired: Scalars['Int']['input'];
  /** List of keys authorized to participate in this quorum */
  userKeyIDs: Array<Scalars['String']['input']>;
};

/** Extra parameters for ripple */
export type InputRippleExtraParams = {
  /** destination tag to use in transaction */
  destinationTag?: InputMaybe<Scalars['String']['input']>;
};

/**
 * InputRoleBindingChange represents a role binding with the role and the set of
 * authorized keys that belong to that role binding
 */
export type InputRoleBindingChange = {
  /** The ID of the binding that is being updated. */
  bindingID: Scalars['String']['input'];
  /**
   * The updated set of principals that will be granted the role.
   * If this list is empty the binding won't be deleted.
   */
  members: Array<Scalars['String']['input']>;
  /** The role that the binding update is granting. */
  roleID: Scalars['String']['input'];
};

/** InputRolePermission is an input into the app mutation for changeRole */
export type InputRolePermission = {
  /** action describes the action that is being enabled for this role */
  action: Scalars['RoleActionInput']['input'];
  /** anySourceVault indicates the action is valid for any source vault. */
  anySourceVault?: InputMaybe<Scalars['Boolean']['input']>;
  /** dailyUSDTransferLimit is an optional USD limit of funds transferrable in a 24-hour window. */
  dailyUSDTransferLimit?: InputMaybe<Scalars['Decimal']['input']>;
  /** destination indicates valid destinations for this action. */
  destination?: InputMaybe<InputDestination>;
  /**
   * sourceVaultSubIDs is the list of vault sub ids that this action wants to be valid for.
   *
   * For backwards compatibility, an empty list is equivalent to the wildcard, meaning all current and future vaults are allowed. `anySourceVault` is preferred to indicate a wildcard.
   */
  sourceVaultSubIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * InputRule is the representation of a new policy rule.
 * This is used to create a new rule in a policy.
 */
export type InputRule = {
  /** The action that this rule applies to. The actionID is essentially the scope */
  actionID: Scalars['String']['input'];
  /** Quorums that are part of this rule */
  quorums: Array<InputRuleQuorum>;
};

/** InputRuleQuorum is the representation of policy quorum update */
export type InputRuleQuorum = {
  /** The updated human readable description of the quorum. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The updated human readable display name of the quorum. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The updated set of principals that will be granted the role. */
  members: Array<Scalars['String']['input']>;
  /** The strictness requirement of fulfilling the quorum in order to fulfill the containing policy fragment. */
  quorumRequirement: QuorumRequirement;
  /** The updated number of endorsements from the expanded members which must be provided. */
  threshold: Scalars['Int']['input'];
};

/** InputRuleQuorumUpdate is the representation of policy quorum update */
export type InputRuleQuorumUpdate = {
  /** The updated human readable description of the quorum. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The updated human readable display name of the quorum. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the quorum to update. If not provided, a new quorum will be created. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The updated set of principals that will be granted the role. */
  members: Array<Scalars['String']['input']>;
  /** The strictness requirement of fulfilling the quorum in order to fulfill the containing policy fragment. */
  quorumRequirement: QuorumRequirement;
  /** The updated number of endorsements from the expanded members which must be provided. */
  threshold: Scalars['Int']['input'];
};

/**
 * InputRuleUpdate is the representation of a policy rule update.
 * This is used to update an existing rule in a policy.
 */
export type InputRuleUpdate = {
  /** The action that this rule applies to. The actionID is essentially the scope */
  actionID: Scalars['String']['input'];
  /** Quorums that are part of this rule */
  quorums: Array<InputRuleQuorumUpdate>;
};

/** Extra parameters for starknet */
export type InputStarknetExtraParams = {
  /** redelegateSrc is used when redelegating with the value of the source delegation pool */
  redelegateSrc?: InputMaybe<Scalars['String']['input']>;
  /** rewardAddress is the address that will receive the rewards from the delegation */
  rewardAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Extra parameters for stellar */
export type InputStellarExtraParams = {
  /** memo to use in transaction */
  memo?: InputMaybe<Scalars['String']['input']>;
};

/** InputStructuredFragment is the representation of a fragment update */
export type InputStructuredFragment = {
  /** The updated quorums that must be met in order to fulfill the fragment. */
  quorums: Array<InputFragmentPolicyQuorum>;
  /** The type of back office risk review that must be performed. */
  riskReviewRequirement: RiskReviewRequirement;
};

/** InputSubmission is the parsed AML answers */
export type InputSubmission = {
  __typename: 'InputSubmission';
  /** answers is the list of answers for the questionnaire */
  answers: Maybe<Array<Answer>>;
  /** questionnaireID is the ID of the questionnaire */
  questionnaireID: Scalars['String']['output'];
};

/** Extra Parameters for tendermint */
export type InputTendermintExtraParams = {
  /** memo is the message to be included in the transaction */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** redelegateSrc is used when redelegating with the value of the source validator */
  redelegateSrc?: InputMaybe<Scalars['String']['input']>;
};

/** InputTrustedDestinationExtraParams contains optional extra params for a trusted destination. */
export type InputTrustedDestinationExtraParams = {
  /** memo is the destination tag/memo required by the asset for transactions */
  memo?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateLegalterms = {
  anchorageEntity?: InputMaybe<Scalars['String']['input']>;
  assetTypeID?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  custom?: InputMaybe<Scalars['String']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  involvesAccount: Scalars['Boolean']['input'];
  isMaterialChange: Scalars['Boolean']['input'];
  lastInternalVersion: Scalars['Int']['input'];
  lastLegaltermsVersion: Scalars['Int']['input'];
  legaltermsID: Scalars['String']['input'];
  staticContent: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** InputUserAccessChange represents an access level change of a user on a specific resource. */
export type InputUserAccessChange = {
  /** accessLevel is the new IAM access level for the user on the resource. */
  accessLevel?: InputMaybe<IAMAccessLevel>;
  /** Unique UserV2 identifier. */
  userID: Scalars['ID']['input'];
};

/** InputUserAccessUpdate represents an access level change of a user on a specific resource. */
export type InputUserAccessUpdate = {
  /** changes is the set of user access level changes to be applied. */
  changes: Array<InputUserAccessChange>;
  /** resourceID is the unique id of the resource (vault or organization) being updated for user accesses */
  resourceID: Scalars['String']['input'];
};

/**
 * InputVaultFragmentBindingChange represents a fragment binding with the scope and the set of
 * fragments that compose the vault policy
 */
export type InputVaultFragmentBindingChange = {
  /** inputFragmentBindingChange represents the changes that will be updated in the fragment binding. */
  inputFragmentBindingChange?: InputMaybe<InputFragmentBindingChange>;
  /** Vault sub ID */
  vaultSubID: Scalars['Int']['input'];
};

/** Vault policies by vault sub ID */
export type InputVaultPolicy = {
  /** Policies */
  policies: Array<InputPolicy>;
  /** Vault sub ID */
  vaultSubID: Scalars['String']['input'];
};

/** InputVaultPolicyContainerUpdate represents a set of changes to be applied to a vault policy container. */
export type InputVaultPolicyContainerUpdate = {
  /** fragmentBindingChanges represents the list of fragment binding changes to be applied. */
  fragmentBindingChanges?: InputMaybe<Array<InputVaultFragmentBindingChange>>;
  /** roleBindingChanges represents the list of role binding changes to be applied. */
  roleBindingChanges?: InputMaybe<Array<InputVaultRoleBindingChange>>;
};

/**
 * InputVaultRoleBindingChange represents a role binding with the role and the set of
 * authorized keys that belong to that vault role binding
 */
export type InputVaultRoleBindingChange = {
  /** inputRoleBindingChange represents the changes that will be updated in the role binding. */
  inputRoleBindingChange?: InputMaybe<InputRoleBindingChange>;
  /** Vault sub ID */
  vaultSubID: Scalars['Int']['input'];
};

/**
 * Full replacement address for a wallet's virtual account at an MT-backed bank. Modern Treasury
 * requires line1, locality, region, and postalCode; line2 is optional.
 */
export type InputVirtualAccountAddress = {
  /** Country code */
  country: Scalars['String']['input'];
  /** Street address line 1 */
  line1: Scalars['String']['input'];
  /** Street address line 2 (optional) */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** City or locality */
  locality: Scalars['String']['input'];
  /** Postal code or ZIP code */
  postalCode: Scalars['String']['input'];
  /** State or region */
  region: Scalars['String']['input'];
};

/** Fiat trusted destination input type */
export type InputWireFiatTrustedDestination = {
  /** Intermediate financial institution information */
  IntermediaryFinancialInstitution?: InputMaybe<InputFiatTrustedDestinationInstitution>;
  /** Beneficiary information */
  beneficiary: InputFiatTrustedDestinationBenificiary;
  /** Financial institution information */
  financialInstitution: InputFiatTrustedDestinationInstitution;
};

/** InstantTransferStandingInstruction represents a standing instruction for instant transfer */
export type InstantTransferStandingInstruction = {
  __typename: 'InstantTransferStandingInstruction';
  /** Account ID for instant transfer */
  accountID: Scalars['String']['output'];
};

/** Represents a affiliate */
export type InstitutionalAffiliate = {
  __typename: 'InstitutionalAffiliate';
  /** The accounts associated with this affiliate. Staff only. */
  accounts: Array<Account>;
  /** ActivitiesCSV represents the activities in a csv format */
  activitiesCSV: Scalars['String']['output'];
  /**
   * List of the deposit attributions associated with the affiliate
   *
   * DEPRECATED: Migrated to AffiliateKYCProfile.affiliateDepositAttributions for Denali KYC 2.0.
   * This field will be removed once all clients migrate to AffiliateKYCProfile.
   * See ONMON-3585.
   */
  affiliateDepositAttributions: DepositAttributionConnectionV2;
  /** Unique identifier for the affiliate */
  affiliateID: Scalars['String']['output'];
  /** Affiliate type */
  affiliateType: Maybe<Scalars['String']['output']>;
  /** List of alert totals by type and age */
  alertTotals: Array<ComplianceAlertTotals>;
  /** List of the alerts associated with the affiliate */
  alerts: AlertConnection;
  /** List of the alerts associated with the affiliate in CSV format */
  alertsCSV: Scalars['String']['output'];
  /** Number of alerts created over time */
  alertsOverTime: Array<AlertsAtTime>;
  /** List of case totals by type and age */
  caseTotals: Array<ComplianceCaseTotals>;
  /** List of the cases associated with the affiliate */
  cases: CaseConnection;
  /** List of the cases associated with the affiliate in CSV format */
  casesCSV: Scalars['String']['output'];
  /** Number of cases created over time */
  casesOverTime: Array<CasesAtTime>;
  /** Unique identifier for the institution */
  clientID: Scalars['String']['output'];
  /** All members from other affiliates under the same institution */
  clientMembers: Array<InstitutionalIndividual>;
  /** returns of the clients/orgs that this affiliate is part of */
  clients: Array<InstitutionalClient>;
  /**
   * Metadata associated with affiliate closure. Returns null for OPEN
   * affiliates; returns the most-recent closure metadata for CLOSED
   * affiliates that have recorded closure data; returns an empty object
   * for CLOSED affiliates with no recorded closure data (legacy parity).
   */
  closureMetadata: Maybe<ClosureMetadata>;
  /** CRR outcome is the accepted CRR value for the affiliate */
  crrScoreOutcome: Maybe<CRRScoreOutcome>;
  /** Anchorage entities associated with this affiliate */
  entities: Array<AnchorageEntity>;
  /** FCA flag stored for the affiliate */
  fca: Scalars['Boolean']['output'];
  /** FFI flag stored for the affiliate */
  ffi: Scalars['Boolean']['output'];
  /** The status of the client */
  formStatus: FormStatus;
  /** id is the unique identifier of the affiliate, equal to affiliateID */
  id: Scalars['ID']['output'];
  /** All known information about this institutional client */
  knownInformation: Array<KnownAffiliateInformation>;
  /** Search for Institutional Affiliate KYC kycProcesses */
  kycProcesses: KYCProcessConnection;
  /** KYC applicable questionnaire */
  kycQuestionnaire: Maybe<Questionnaire>;
  /**
   * KYC Related Parties is a temporary solution for the KYC Related Parties entity.
   * This will be implemented with a generic KYC Entities solution
   */
  kycRelatedParties: KYCRelatedPartyConnection;
  /** Last KYC refresh date is the date when the affiliate had  Full KYC Review */
  lastKYCRefreshDate: Maybe<Scalars['Date']['output']>;
  /** Material News flag stored for the affiliate */
  materialNews: Scalars['Boolean']['output'];
  /** All members of the institution */
  members: Array<InstitutionalIndividual>;
  /** All member audit changes in a given affiliate */
  membersAudit: Maybe<Array<IndividualAffiliateRelationshipAudit>>;
  /** Name of the institution */
  name: Scalars['String']['output'];
  /** Next KYC refresh date is the date when a KYC refresh is due */
  nextKYCRefreshDate: Maybe<Scalars['Date']['output']>;
  /** Non-Material News flag stored for the affiliate */
  nonMaterialNews: Scalars['Boolean']['output'];
  /**
   * DEPRECATED: Migrated to AffiliateKYCProfile.numberOfSubaccounts for Denali KYC 2.0.
   * This field will be removed once all clients migrate to AffiliateKYCProfile.
   * See ONMON-3585.
   */
  numberOfSubaccounts: Maybe<Scalars['Int']['output']>;
  /** Onboarding Date is the date when the affiliate was fully onboarded at Anchorage */
  onboardingDate: Maybe<Scalars['Date']['output']>;
  /** The parent affiliate if any */
  parentAffiliate: Maybe<InstitutionalAffiliate>;
  /** Unique identifier for the parent affiliate */
  parentAffiliateID: Maybe<Scalars['String']['output']>;
  /** PEP flag stored for the affiliate */
  pep: Scalars['Boolean']['output'];
  /** Portfolio is an affiliate level summary of holdings */
  portfolio: Portfolio;
  /** PortfolioCSV represents the affiliate portfolio in a csv format */
  portfolioCSV: Scalars['String']['output'];
  /**
   * DEPRECATED: Migrated to AffiliateKYCProfile.postedBalance for Denali KYC 2.0.
   * This field will be removed once all clients migrate to AffiliateKYCProfile.
   * See ONMON-3585.
   */
  postedBalance: Maybe<Scalars['String']['output']>;
  /** Primary customer type is the value of the PrimaryCustomerType */
  primaryCustomerType: Maybe<Scalars['String']['output']>;
  /** All program customers for the affiliate */
  programCustomers: Array<InstitutionalAffiliate>;
  /** Associated institution representatives */
  representatives: Array<InstitutionalRepresentative>;
  /** Secondary customer type is the value of the SecondaryCustomerType */
  secondaryCustomerType: Maybe<Scalars['String']['output']>;
  /**
   * Settings returns this affiliate specific settings
   * DEPRECATED: Migrated to AffiliateKYCProfile.settings for Denali KYC 2.0.
   * This field will be removed once all clients migrate to AffiliateKYCProfile.
   * See ONMON-3585.
   */
  settings: Maybe<Array<Setting>>;
  /** Status of the affiliate (OPEN or CLOSED) derived from constraint state. */
  status: AffiliateStatus;
  /** Suspicious Activity flag stored for the affiliate */
  suspiciousActivity: Scalars['Boolean']['output'];
  /**
   * WithdrawalFrozen indicates whether the affiliate has withdrawals frozen
   * (true iff every linked account has FREEZE_WITHDRAWAL enabled).
   */
  withdrawalFrozen: Scalars['Boolean']['output'];
};


/** Represents a affiliate */
export type InstitutionalAffiliateactivitiesCSVArgs = {
  filterAccountIDs: Array<Scalars['String']['input']>;
  filterActions?: InputMaybe<Array<OperationAction>>;
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterStates?: InputMaybe<Array<OperationState>>;
  fromDate: Scalars['Timestamp']['input'];
  organizationKeyID: Scalars['String']['input'];
  toDate: Scalars['Timestamp']['input'];
};


/** Represents a affiliate */
export type InstitutionalAffiliateaffiliateDepositAttributionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DepositAttributionOrder>;
  sourceAddressesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<DepositAttributionPrivateWhereInput>;
};


/** Represents a affiliate */
export type InstitutionalAffiliatealertsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  alertID?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<AlertStatus>;
};


/** Represents a affiliate */
export type InstitutionalAffiliatealertsCSVArgs = {
  alertID?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<AlertStatus>;
};


/** Represents a affiliate */
export type InstitutionalAffiliatealertsOverTimeArgs = {
  aggregatedBy: AggregationFilterType;
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


/** Represents a affiliate */
export type InstitutionalAffiliatecasesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  caseID?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CaseStatus>;
};


/** Represents a affiliate */
export type InstitutionalAffiliatecasesCSVArgs = {
  caseID?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CaseStatus>;
};


/** Represents a affiliate */
export type InstitutionalAffiliatecasesOverTimeArgs = {
  aggregatedBy: AggregationFilterType;
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


/** Represents a affiliate */
export type InstitutionalAffiliateknownInformationArgs = {
  filterInfoTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  latestOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a affiliate */
export type InstitutionalAffiliatekycProcessesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filter?: InputMaybe<KYCProcessWhereInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<KYCProcessOrder>>;
};


/** Represents a affiliate */
export type InstitutionalAffiliatekycQuestionnaireArgs = {
  questionnaireType?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a affiliate */
export type InstitutionalAffiliatekycRelatedPartiesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<KYCRelatedPartyWhereInput>;
};

/** InstitutionalAffiliateConnection implements the connections spec */
export type InstitutionalAffiliateConnection = {
  __typename: 'InstitutionalAffiliateConnection';
  /** edges implements the connections spec */
  edges: Array<InstitutionalAffiliateEdge>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
};

/** InstitutionalAffiliateEdge implements the connections spec */
export type InstitutionalAffiliateEdge = {
  __typename: 'InstitutionalAffiliateEdge';
  /** cursor implements the connections spec */
  cursor: Scalars['String']['output'];
  /** node implements the connections spec */
  node: InstitutionalAffiliate;
};

/** InstitutionalAffiliateMemberFilters specifies filters for the institutional affiliate member gql queries */
export type InstitutionalAffiliateMemberFilters = {
  /** List of affiliate IDs to filter the results */
  affiliateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of individual IDs to filter the results */
  individualIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** InstitutionalAffiliateRelationshipPair encodes an affiliate with a list of relationships */
export type InstitutionalAffiliateRelationshipPair = {
  __typename: 'InstitutionalAffiliateRelationshipPair';
  /** affiliate implements the connections spec */
  affiliate: InstitutionalAffiliate;
  /** relationship implements the connections spec */
  relationship: Array<IndividualAffiliateRelationship>;
};

/** InstitutionalAffiliateRelationshipPairConnection implements the connections spec */
export type InstitutionalAffiliateRelationshipPairConnection = {
  __typename: 'InstitutionalAffiliateRelationshipPairConnection';
  /** edges implements the connections spec */
  edges: Array<InstitutionalAffiliateRelationshipPairEdge>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

/** InstitutionalAffiliateRelationshipPairEdge implements the connections spec */
export type InstitutionalAffiliateRelationshipPairEdge = {
  __typename: 'InstitutionalAffiliateRelationshipPairEdge';
  /** cursor implements the connections spec */
  cursor: Scalars['String']['output'];
  /** node implements the connections spec */
  node: InstitutionalAffiliateRelationshipPair;
};

/** InstitutionalAffiliateSortFields are the options for sorting a list of affiliates */
export enum InstitutionalAffiliateSortFields {
  /** AFFILIATE_TYPE is to sort for affiliates' type */
  AFFILIATE_TYPE = 'AFFILIATE_TYPE',
  /** FORM_STATUS is the status associted to the affiliate's form */
  FORM_STATUS = 'FORM_STATUS',
  /** NAME is the name of the affiliate */
  NAME = 'NAME',
  /** ORG_NAME is the name of the organization associated to the affiliate */
  ORG_NAME = 'ORG_NAME',
  /** PENDING_ATTRIBUTIONS is to sort for affiliates' pending attributions number */
  PENDING_ATTRIBUTIONS = 'PENDING_ATTRIBUTIONS'
}

/** Base resolver for all institutional audit csv exports */
export type InstitutionalAuditCSVExports = {
  __typename: 'InstitutionalAuditCSVExports';
  /** Returns the audit information for the affiliate members */
  affiliateMembersCSV: Scalars['String']['output'];
  /** Returns the audit information for the affiliates info */
  affiliatesInfoCSV: Scalars['String']['output'];
  /** Returns the audit information for the individuals info */
  individualsInfoCSV: Scalars['String']['output'];
};


/** Base resolver for all institutional audit csv exports */
export type InstitutionalAuditCSVExportsaffiliateMembersCSVArgs = {
  filters?: InputMaybe<InstitutionalAffiliateMemberFilters>;
};


/** Base resolver for all institutional audit csv exports */
export type InstitutionalAuditCSVExportsaffiliatesInfoCSVArgs = {
  filters?: InputMaybe<InstitutionalInfoFilters>;
};


/** Base resolver for all institutional audit csv exports */
export type InstitutionalAuditCSVExportsindividualsInfoCSVArgs = {
  filters?: InputMaybe<InstitutionalInfoFilters>;
};

/** Represents an institution */
export type InstitutionalClient = {
  __typename: 'InstitutionalClient';
  /** List of affiliates associated with this client */
  affiliates: Array<InstitutionalAffiliate>;
  /** Unique identifier for the institution */
  clientID: Scalars['String']['output'];
  /** Shows information of when the client was deleted, or null if active */
  deletedAt: Maybe<Scalars['String']['output']>;
  /** Anchorage entities associated with this client */
  entities: Array<AnchorageEntity>;
  /** The status of the client form */
  formStatus: FormStatus;
  /** id is the unique identifier of the client, equal to clientID */
  id: Scalars['ID']['output'];
  /** KYC applicable questionnaire */
  kycQuestionnaire: Maybe<Questionnaire>;
  /** All members of the institution */
  members: Array<InstitutionalIndividual>;
  /** Name of the institution */
  name: Scalars['String']['output'];
  /** Associated institution representatives */
  representatives: Array<InstitutionalRepresentative>;
  /**
   * Resolves the staged organization created based on this client.
   * It will be null if the client has not reached that state yet.
   */
  stagedOrganization: Maybe<StagedOrganization>;
  /** The status of the client */
  status: ClientStatus;
};


/** Represents an institution */
export type InstitutionalClientkycQuestionnaireArgs = {
  questionnaireType?: InputMaybe<Scalars['String']['input']>;
};

/** InstitutionalClientConnection implements the connections spec */
export type InstitutionalClientConnection = {
  __typename: 'InstitutionalClientConnection';
  /** edges implements the connections spec */
  edges: Array<InstitutionalClientEdge>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
};

/** InstitutionalClientEdge implements the connections spec */
export type InstitutionalClientEdge = {
  __typename: 'InstitutionalClientEdge';
  /** cursor implements the connections spec */
  cursor: Scalars['String']['output'];
  /** node implements the connections spec */
  node: InstitutionalClient;
};

/** InstitutionalClientSortFields are the options for sorting a list of clients */
export enum InstitutionalClientSortFields {
  /** NAME is the name of the client */
  NAME = 'NAME',
  /** STATUS is the client status (not the form status) */
  STATUS = 'STATUS'
}

/** Filter states for cosmetically archived institutional clients */
export enum InstitutionalCosmeticStatus {
  /** Shows active */
  ACTIVE = 'ACTIVE',
  /** Shows all */
  ALL = 'ALL',
  /** Shows only deleted */
  DELETED = 'DELETED'
}

/** Represents an individual belonging to an institution */
export type InstitutionalIndividual = {
  __typename: 'InstitutionalIndividual';
  /**
   * Relationships of this individual with the provided affiliate.
   * If no affiliate ID is provided, and this call is within an affiliate resolver,
   * that affiliate ID will be used instead.
   */
  affiliateRelationships: Maybe<Array<IndividualAffiliateRelationship>>;
  /** The client identifier, if any. */
  clientID: Maybe<Scalars['String']['output']>;
  /** Creation date of the institutional individual */
  createdAt: Scalars['DateTime']['output'];
  /** The status of the client */
  formStatus: FormStatus;
  /** id is the unique identifier of the individual, equal to individualID */
  id: Scalars['ID']['output'];
  /** Unique ID of the individual */
  individualID: Scalars['String']['output'];
  /** Institutional affiliates that this institutional individual is associated with. */
  institutionalAffiliateRelationships: InstitutionalAffiliateRelationshipPairConnection;
  /** A job title is the role of an individual in all of the affiliates of the client one belongs to */
  jobTitle: Maybe<Scalars['String']['output']>;
  /** Specific known information, queried by type */
  knownInformation: Array<KnownInformation>;
  /** Search for Institutional Individual KYC kycProcesses */
  kycProcesses: KYCProcessConnection;
  /** KYC applicable questionnaire */
  kycQuestionnaire: Maybe<Questionnaire>;
  /**
   * The percentage of the affiliate that the individual owns. Only relevant for
   * beneficial owners.
   */
  ownershipPercentage: Maybe<Scalars['String']['output']>;
  /** Person associated with this individual, if any */
  person: Maybe<Person>;
  /** Associated institution representatives */
  representatives: Array<InstitutionalRepresentative>;
  /** Role of an individual in the affiliate (such as CEO, COO, etc). */
  role: Maybe<Scalars['String']['output']>;
};


/** Represents an individual belonging to an institution */
export type InstitutionalIndividualaffiliateRelationshipsArgs = {
  affiliateID?: InputMaybe<Scalars['String']['input']>;
};


/** Represents an individual belonging to an institution */
export type InstitutionalIndividualinstitutionalAffiliateRelationshipsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an individual belonging to an institution */
export type InstitutionalIndividualjobTitleArgs = {
  clientID?: InputMaybe<Scalars['String']['input']>;
};


/** Represents an individual belonging to an institution */
export type InstitutionalIndividualknownInformationArgs = {
  filterInfoTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  latestOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents an individual belonging to an institution */
export type InstitutionalIndividualkycProcessesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filter?: InputMaybe<KYCProcessWhereInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<KYCProcessOrder>>;
};


/** Represents an individual belonging to an institution */
export type InstitutionalIndividualkycQuestionnaireArgs = {
  questionnaireType?: InputMaybe<Scalars['String']['input']>;
};


/** Represents an individual belonging to an institution */
export type InstitutionalIndividualownershipPercentageArgs = {
  affiliateID?: InputMaybe<Scalars['String']['input']>;
};


/** Represents an individual belonging to an institution */
export type InstitutionalIndividualroleArgs = {
  affiliateID?: InputMaybe<Scalars['String']['input']>;
};

/** Connection for InstitutionalIndividual type */
export type InstitutionalIndividualConnection = {
  __typename: 'InstitutionalIndividualConnection';
  /** List of edges */
  edges: Maybe<Array<InstitutionalIndividualEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

/** Edge for InstitutionalIndividual type */
export type InstitutionalIndividualEdge = {
  __typename: 'InstitutionalIndividualEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: InstitutionalIndividual;
};

/** InstitutionalInfoFilters specifies filters for the institutional info gql queries */
export type InstitutionalInfoFilters = {
  /** List of IDs to filter the results */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of affiliate IDs to filter the results */
  informationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents a person that is allowed to fill out institutional forms */
export type InstitutionalRepresentative = {
  __typename: 'InstitutionalRepresentative';
  /** Email of the the representative. */
  email: Scalars['String']['output'];
  /** Optional label/role of the representative for this entity (e.g. CEO, Authorized Signer). */
  label: Maybe<Scalars['String']['output']>;
  /** Name of the representative. */
  name: Scalars['String']['output'];
};

/** Enum of lifecyle stages, for institutional clients/affiliates/individuals */
export enum InstitutionalValueLifecycle {
  /** DRAFT means the value is not yet final, and can be changed */
  DRAFT = 'DRAFT',
  /** HISTORICAL means the value is a version that can no longer be changed in the database, but is not the most-recent version */
  HISTORICAL = 'HISTORICAL',
  /** LATEST means the value is a version that can no longer be changed in the database, and is the most-recent version */
  LATEST = 'LATEST'
}

/** Instruction represents the instructions for a standing instruction */
export type Instruction = InstantTransferStandingInstruction | WireStandingInstruction;

/** IntelTdxMeasurementsInput represents Intel TDX boot measurements. */
export type IntelTdxMeasurementsInput = {
  /** Intel TDX MRTD measurement (48 bytes, 96 hex characters). */
  mrtd: Scalars['String']['input'];
  /** Intel TDX RTMR0 measurement (48 bytes, 96 hex characters). */
  rtmr0: Scalars['String']['input'];
  /** Intel TDX RTMR1 measurement (48 bytes, 96 hex characters). */
  rtmr1: Scalars['String']['input'];
  /** Intel TDX RTMR2 measurement (48 bytes, 96 hex characters). */
  rtmr2: Scalars['String']['input'];
  /** Intel TDX RTMR3 measurement (48 bytes, 96 hex characters). */
  rtmr3: Scalars['String']['input'];
};

export type InterestWalletConfigurationInfo = {
  __typename: 'InterestWalletConfigurationInfo';
  isConfiguredForInterest: Scalars['Boolean']['output'];
};

/**
 * InternalDestinationsAllowed is an enum of choices for allowing internal destinations.
 * It may be expanded in the future to allow more specificity.
 */
export enum InternalDestinationsAllowed {
  /** ALLOW_ALL indicates all internal destinations will be allowed. This includes any vault, any wallet, or other future internal destination. */
  ALLOW_ALL = 'ALLOW_ALL',
  /**
   * ALLOW_ORG_SCOPED indicates only internal destinations within the role's own organization will be allowed. It does not restrict external transfers.
   * Not enforced yet: until a follow-up change it allows no internal destinations beyond any vaultIDs supplied, the same as NONE.
   */
  ALLOW_ORG_SCOPED = 'ALLOW_ORG_SCOPED',
  /** NONE indicates no internal destinations will be allowed */
  NONE = 'NONE'
}

/** InternalStatus represents */
export enum InternalStatus {
  /** canceled represents */
  CANCELED = 'CANCELED',
  /** executed represents */
  EXECUTED = 'EXECUTED',
  /** invalid represents */
  INVALID = 'INVALID',
  /** pending represents */
  PENDING = 'PENDING',
  /** rejected represents */
  REJECTED = 'REJECTED',
  /** settled represents */
  SETTLED = 'SETTLED',
  /** settling represents */
  SETTLING = 'SETTLING'
}

/** Invoice represents the billed amounts for a specific billing period for a Billing Entity */
export type Invoice = {
  __typename: 'Invoice';
  billingEntity: BillingEntity;
  billingPeriod: DateRange;
  createdAt: Scalars['Date']['output'];
  documentLink: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  issuedDate: Scalars['Date']['output'];
};

export type InvoiceConnection = {
  __typename: 'InvoiceConnection';
  edges: Maybe<Array<Maybe<InvoiceEdge>>>;
  pageInfo: PageInfo;
};

export type InvoiceEdge = {
  __typename: 'InvoiceEdge';
  cursor: Scalars['CursorType']['output'];
  node: Maybe<Invoice>;
};

/** Invoice email destination */
export type InvoiceEmailDestination = {
  /** Email address of the recipient */
  email: Scalars['String']['input'];
  /** Name of the recipient */
  name: Scalars['String']['input'];
};

export type InvoiceNumberFilter = {
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Invoices. */
  field: InvoiceOrderField;
};

export enum InvoiceOrderField {
  BILLING_PERIOD_END_DATE = 'BILLING_PERIOD_END_DATE',
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  ISSUE_DATE = 'ISSUE_DATE'
}

export type InvoiceQueryFilter = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  billingPeriodSearch?: InputMaybe<DateRangeInput>;
  invoiceNumber?: InputMaybe<InvoiceNumberFilter>;
  issueDateSearch?: InputMaybe<DateRangeInput>;
  /**
   * Filter invoices by organization key ID. Only honored for STAFF callers;
   * ignored for ORG_USER callers (their org is enforced from the auth context).
   */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
};

/** Customer-facing conversion status. Projects the internal mintburn state machine into a smaller set of customer-actionable outcomes. */
export enum IssueRedeemConversionStatus {
  /** Conversion was fulfilled successfully. */
  COMPLETED = 'COMPLETED',
  /** Endorsements approved; conversion is pending. */
  EXECUTING = 'EXECUTING',
  /** Conversion failed. */
  FAILED = 'FAILED',
  /** Conversion has started and is awaiting endorsements. */
  INITIATED = 'INITIATED',
  /** Unrecognised internal state (forward-compatibility fallback). */
  UNKNOWN = 'UNKNOWN'
}

/** Statuses accepted by the getIssueRedeemHistory status filter. Mirrors IssueRedeemConversionStatus without UNKNOWN, which is a response-only forward-compatibility fallback and not a filterable state. */
export enum IssueRedeemConversionStatusFilter {
  /** Conversion was fulfilled successfully. */
  COMPLETED = 'COMPLETED',
  /** Endorsements approved; conversion is pending. */
  EXECUTING = 'EXECUTING',
  /** Conversion failed. */
  FAILED = 'FAILED',
  /** Conversion has started and is awaiting endorsements. */
  INITIATED = 'INITIATED'
}

/** Optional sub-status that further qualifies a FAILED conversion. Only surfaced for customer-observable outcomes; deliberately null for internal/system failures. */
export enum IssueRedeemConversionSubStatus {
  /** Conversion was rejected by the customer. */
  REJECTED_BY_CUSTOMER = 'REJECTED_BY_CUSTOMER'
}

/** Issue/Redeem operation edge */
export type IssueRedeemEdge = {
  __typename: 'IssueRedeemEdge';
  /** The issue/redeem node */
  node: IssueRedeemNode;
};

/** Issue/Redeem history response */
export type IssueRedeemHistory = {
  __typename: 'IssueRedeemHistory';
  /** List of issue/redeem operations */
  edges: Array<IssueRedeemEdge>;
  /** Whether there are more results */
  hasNextPage: Scalars['Boolean']['output'];
};

/** Issue/Redeem operation node */
export type IssueRedeemNode = {
  __typename: 'IssueRedeemNode';
  /** Amount of the operation */
  amount: Scalars['String']['output'];
  /** Authorization operation ID */
  authorizationOperationID: Maybe<Scalars['OperationID']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['Time']['output'];
  /** Destination asset type ID */
  destinationAssetTypeID: Scalars['AssetTypeID']['output'];
  /** Customer-facing destination operation ID for the conversion */
  destinationOperationID: Maybe<Scalars['OperationID']['output']>;
  /** Destination wallet ID */
  destinationWalletID: Scalars['ID']['output'];
  /** Unique issue/redeem identifier */
  issueRedeemID: Scalars['ID']['output'];
  /** Customer-facing operation type. One of MINT, BURN, BRIDGE, SWAP. */
  operationType: Scalars['String']['output'];
  /** Source asset type ID */
  sourceAssetTypeID: Scalars['AssetTypeID']['output'];
  /** Customer-facing source operation ID for the conversion */
  sourceOperationID: Maybe<Scalars['OperationID']['output']>;
  /** Source wallet ID */
  sourceWalletID: Scalars['ID']['output'];
  /** Customer-facing status of the conversion. */
  status: IssueRedeemConversionStatus;
  /** Optional sub-status qualifying the conversion. */
  subStatus: Maybe<IssueRedeemConversionSubStatus>;
  /** Vault information for this operation */
  vaultInfo: Maybe<IssueRedeemVaultInfo>;
};

export type IssueRedeemVaultInfo = {
  __typename: 'IssueRedeemVaultInfo';
  /** Vault name */
  vaultName: Scalars['String']['output'];
  /** Vault sub ID */
  vaultSubID: Scalars['String']['output'];
};

/** Wallet display info (name + on-chain address) for an issue/redeem operation. */
export type IssueRedeemWalletInfo = {
  __typename: 'IssueRedeemWalletInfo';
  /** Wallet on-chain address. */
  walletAddress: Scalars['String']['output'];
  /** Resolved wallet name. */
  walletName: Scalars['String']['output'];
};

/** IssueSource are the possible sources of issues for Referral, PEP, NEGATIVE NEwS and OFAC cases */
export enum IssueSource {
  /** BANKING_PARTNER_RFI is a compliance issue case source */
  BANKING_PARTNER_RFI = 'BANKING_PARTNER_RFI',
  /** SOURCE_314_B is a compliance issue case source */
  BLOCKCHAIN_ANALYTICS = 'BLOCKCHAIN_ANALYTICS',
  /** CORRECTED_AMENDED_SAR is a compliance issue case source */
  CORRECTED_AMENDED_SAR = 'CORRECTED_AMENDED_SAR',
  /** CRR_RISK_FACTOR_CHANGE is a KYC ad hoc issue alert source */
  CRR_RISK_FACTOR_CHANGE = 'CRR_RISK_FACTOR_CHANGE',
  /** DA_BEHAVIORAL is a compliance issue case source */
  DA_BEHAVIORAL = 'DA_BEHAVIORAL',
  /** EMPLOYEE_REFERRAL is a compliance issue case source */
  EMPLOYEE_REFERRAL = 'EMPLOYEE_REFERRAL',
  /** FIAT_BEHAVIORAL is a compliance issue case source */
  FIAT_BEHAVIORAL = 'FIAT_BEHAVIORAL',
  /** MONTHLY_TRANSACTION_REVIEW is a compliance issue case source */
  MONTHLY_TRANSACTION_REVIEW = 'MONTHLY_TRANSACTION_REVIEW',
  /** NNS_ALERT is a compliance issue case source */
  NNS_ALERT = 'NNS_ALERT',
  /** NON_MATERIAL_CLIENT_CHANGE is a KYC ad hoc issue alert source */
  NON_MATERIAL_CLIENT_CHANGE = 'NON_MATERIAL_CLIENT_CHANGE',
  /** OTHER is a KYC ad hoc issue alert source */
  OTHER = 'OTHER',
  /** PEP_ALERT is a compliance issue case source */
  PEP_ALERT = 'PEP_ALERT',
  /** QA_CTMG_IA_FINDING is a KYC ad hoc issue alert source */
  QA_CTMG_IA_FINDING = 'QA_CTMG_IA_FINDING',
  /** SANCTIONS_ALERT is a compliance issue case source */
  SANCTIONS_ALERT = 'SANCTIONS_ALERT',
  /** SOURCE_90_DAY_REVIEW is a compliance issue case source */
  SOURCE_90_DAY_REVIEW = 'SOURCE_90_DAY_REVIEW',
  /** SOURCE_314_A_TRUE_MATCH is a compliance issue case source */
  SOURCE_314_A_TRUE_MATCH = 'SOURCE_314_A_TRUE_MATCH',
  /** SOURCE_314_B is a compliance issue case source */
  SOURCE_314_B = 'SOURCE_314_B'
}

/**
 * A tokenized asset the calling org is the issuer of, together with the fixed wallet it
 * mints to and burns from.
 */
export type IssuerTokenizationAsset = {
  __typename: 'IssuerTokenizationAsset';
  /** The tokenized asset type. */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /**
   * The wallet the org mints to / burns from for this asset. Always present: assets missing
   * one are excluded from the list rather than returned with an empty wallet.
   */
  issuerHoldingWalletID: Scalars['ID']['output'];
  /** Maximum amount that can be minted in a single operation, if configured. Null means no limit. */
  maxAmount: Maybe<Scalars['String']['output']>;
};

/** JiraComplianceIssue represents the output of the CreateComplianceIssue mutation */
export type JiraComplianceIssue = {
  __typename: 'JiraComplianceIssue';
  /** jiraID is the id of the issue in Jira */
  jiraID: Scalars['String']['output'];
  /** jiraLink is the link to the issue in Jira */
  jiraLink: Scalars['String']['output'];
};

/**
 * JsonForm represents an RJSF-compatible form definition that the frontend renders dynamically.
 * It contains the JSON Schema for data validation and a UI Schema for presentation control.
 */
export type JsonForm = {
  __typename: 'JsonForm';
  /**
   * actionID uniquely identifies this action in the format "{protocol}_{action}" (e.g. "solana_stake").
   * Must be passed back when submitting the form.
   */
  actionID: Scalars['String']['output'];
  /** buttonLabel is the text for the form's submit button (e.g. "Submit Stake"). */
  buttonLabel: Scalars['String']['output'];
  /**
   * disabledHint provides a reason why this action is currently disabled.
   * Null when the action is available.
   */
  disabledHint: Maybe<Scalars['String']['output']>;
  /** jsonSchema is the JSON Schema (draft-07) describing the form's data model and validation rules. */
  jsonSchema: Scalars['JSON']['output'];
  /** requiresEndorsement indicates whether this action needs endorsement before execution. */
  requiresEndorsement: Scalars['Boolean']['output'];
  /** title is the display title for the form/operation (e.g. "Stake SOL"). */
  title: Scalars['String']['output'];
  /** uiSchema is the RJSF UI Schema controlling how the form is rendered (widget types, ordering, etc.). */
  uiSchema: Scalars['JSON']['output'];
  /**
   * version is the schema version. Must be passed back on submission to ensure
   * the form data is validated against the same schema version.
   */
  version: Scalars['Int']['output'];
};

/**
 * JupiterDEXInput contains the required fields for performing a token swap using Jupiter
 * Decentralized Exchange (DEX).
 */
export type JupiterDEXInput = {
  /**
   * QuoteData is the escaped JSON object of the selected quote that will be used to perform the
   * swap.
   */
  quoteData: Scalars['String']['input'];
};

/** JupiterQuote represents an individual quote from Uniswap's Classic protocol pool. */
export type JupiterQuote = {
  __typename: 'JupiterQuote';
  /** BuyTokenAmount token and amount to be bought in the token swap. */
  buyTokenAmount: TokenAmount;
  /** BuyWalletAddress is the address of the wallet which will receive the bought token. */
  buyWalletAddress: Scalars['String']['output'];
  /** ExchangeRate is the amount of the sell token that can be purchased relative 1 buy token. */
  exchangeRate: TokenAmount;
  /** GasFeeUSDC is the fee total estimated cost of the transaction denominated in USDC. */
  gasFeeUSDC: Scalars['String']['output'];
  /**
   * MaximumSlippage is the maximum amount the price can change between the time the Blockchain
   * transaction is submitted and the time it is executed.
   */
  maximumSlippage: Scalars['String']['output'];
  /** Indicates whether routing was restricted to go through 1 market. */
  onlyDirectRoutes: Scalars['Boolean']['output'];
  /**
   * PriceImpactPercent is the impact the swap has on the market price of the Jupiter pool of tokens.
   * The value is between 0-100 percent.
   */
  priceImpactPercent: Scalars['String']['output'];
  /** QuoteAmountsDisplay is the string to be displayed with buy/sell amount and assettype. */
  quoteAmountsDisplay: Scalars['String']['output'];
  /** QuoteData is the escaped JSON object of the quote response that must be sent in the swap request. */
  quoteData: Scalars['String']['output'];
  /** RequestID is a unique identifier of the quote request that resulted in this response. */
  requestID: Scalars['String']['output'];
  /** Routing is the selected routing the token swap will go through if executed (e.g. Jupiter). */
  routing: Scalars['String']['output'];
  /** SellTokenAmount token and amount to be sold in the token swap. */
  sellTokenAmount: TokenAmount;
  /** SellWalletAddress is the address of the wallet which will sell the token. */
  sellWalletAddress: Scalars['String']['output'];
};

/** JupiterQuoteInput contains fields specifically for retrieving quote data from the Jupiter DEX. */
export type JupiterQuoteInput = {
  amount: AmountInput;
  buyTokenAssetTypeID: Scalars['String']['input'];
  maximumSlippage: Scalars['Float']['input'];
  onlyDirectRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  quoteType: TokenQuoteType;
  sellTokenAssetTypeID: Scalars['String']['input'];
  sellTokenWalletAddress: Scalars['String']['input'];
};

export type KYC = {
  __typename: 'KYC';
  /** Returns a single affiliate KYC profile by ID */
  affiliateKYCProfile: Maybe<AffiliateKYCProfile>;
  /**
   * Returns historical audit data for related party changes on an affiliate KYC profile.
   * The affiliateKYCProfileID is the affiliate (source) profile ID.
   */
  affiliateKYCProfileRelatedPartiesAudit: AffiliateKYCProfileRelatedPartyAuditConnection;
  /** Returns affiliate KYC profiles with pagination and filtering */
  affiliateKYCProfiles: AffiliateKYCProfileConnection;
  kycConfigs: KYCConfigConnection;
  /** Returns the list of valid customer types that can be used to tag KYC questions. */
  kycCustomerTypes: Array<KYCCustomerType>;
  kycProcessTriggers: KYCProcessTriggerConnection;
  /** Returns historical audit data for KYC profile information changes */
  kycProfileInfoHistory: KYCProfileInfoHistoryConnection;
  /**
   * kycQuestionPool returns all KYC questions grouped into a hierarchical tree by
   * their layout_definition: one element per questionnaire page (nav_level2)
   * holding the page's sections, each holding its questions. Use the optional
   * `where` filter (e.g. categoriesIn) to narrow the pool by entity type.
   */
  kycQuestionPool: Array<KYCQuestionnaireElement>;
  kycQuestionnaireSubmissionById: Maybe<KYCQuestionnaireSubmission>;
  kycQuestionnaireSubmissions: KYCQuestionnaireSubmissionConnection;
  kycQuestionnaires: KYCQuestionnaireConnection;
  kycQuestions: KYCQuestionConnection;
  /**
   * KYC Related Parties is a temporary solution for the KYC Related Parties entity.
   * This will be implemented with a generic KYC Entities solution
   */
  kycRelatedParties: KYCRelatedPartyConnection;
  /** Returns KYC screening requests with pagination, filtering, and ordering */
  kycScreeningRequests: KYCScreeningRequestConnection;
  /** Returns a single organization KYC profile by ID */
  organizationKYCProfile: Maybe<OrganizationKYCProfile>;
  /** Returns organization KYC profiles with pagination and filtering */
  organizationKYCProfiles: OrganizationKYCProfileConnection;
  /** Returns a single related party KYC profile by ID */
  relatedPartyKYCProfile: Maybe<RelatedPartyKYCProfile>;
  /** Returns related party KYC profiles with pagination and filtering */
  relatedPartyKYCProfiles: RelatedPartyKYCProfileConnection;
  /** Returns representatives with pagination and filtering */
  representatives: RepresentativeConnection;
};


export type KYCaffiliateKYCProfileArgs = {
  id: Scalars['ID']['input'];
};


export type KYCaffiliateKYCProfileRelatedPartiesAuditArgs = {
  affiliateKYCProfileID: Scalars['String']['input'];
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type KYCaffiliateKYCProfilesArgs = {
  affiliateTypeIn?: InputMaybe<Array<AffiliateType>>;
  after?: InputMaybe<Scalars['CursorType']['input']>;
  anchorageEntityIn?: InputMaybe<Array<AnchorageEntityType>>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<KYCProfileOrder>;
  organizationKYCProfileID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<KYCStatus>>;
};


export type KYCkycConfigsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KYCConfigOrder>>;
  where?: InputMaybe<KYCConfigWhereInput>;
};


export type KYCkycProcessTriggersArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KYCProcessTriggerOrder>>;
  where?: InputMaybe<KYCProcessTriggerWhereInput>;
};


export type KYCkycProfileInfoHistoryArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filterKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kycProfileID: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type KYCkycQuestionPoolArgs = {
  where?: InputMaybe<KYCQuestionWhereInput>;
};


export type KYCkycQuestionnaireSubmissionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type KYCkycQuestionnaireSubmissionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KYCQuestionnaireSubmissionOrder>>;
  where?: InputMaybe<KYCQuestionnaireSubmissionWhereInput>;
};


export type KYCkycQuestionnairesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KYCQuestionnaireOrder>>;
  where?: InputMaybe<KYCQuestionnaireWhereInput>;
};


export type KYCkycQuestionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KYCQuestionOrder>>;
  where?: InputMaybe<KYCQuestionWhereInput>;
};


export type KYCkycRelatedPartiesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<KYCRelatedPartyWhereInput>;
};


export type KYCkycScreeningRequestsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KYCScreeningRequestOrder>>;
  where?: InputMaybe<KYCScreeningRequestWhereInput>;
};


export type KYCorganizationKYCProfileArgs = {
  id: Scalars['ID']['input'];
};


export type KYCorganizationKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  anchorageEntityIn?: InputMaybe<Array<AnchorageEntityType>>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<KYCProfileOrder>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<KYCStatus>>;
};


export type KYCrelatedPartyKYCProfileArgs = {
  id: Scalars['ID']['input'];
};


export type KYCrelatedPartyKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  anchorageEntityIn?: InputMaybe<Array<AnchorageEntityType>>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationKYCProfileID?: InputMaybe<Scalars['ID']['input']>;
  relatedPartyType?: InputMaybe<RelatedPartyType>;
  rolesIn?: InputMaybe<Array<KYCRoleType>>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<KYCStatus>>;
};


export type KYCrepresentativesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kycProfileType?: InputMaybe<KYCEntityType>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationKYCProfileID?: InputMaybe<Scalars['ID']['input']>;
};

/** KYCActionStatus is for the KYCActionStatus entity */
export type KYCActionStatus = {
  __typename: 'KYCActionStatus';
  /** action is the KYCSubmissionAction */
  action: KYCSubmissionAction;
  /** status is the action status depending on the questions answered for specific validation level */
  status: KYCActionStatusType;
};

/** KYCActionStatusType is enum for KYCActionStatusType */
export enum KYCActionStatusType {
  /** DISABLED means action is disabled */
  DISABLED = 'DISABLED',
  /** ENABLED means action is enabled */
  ENABLED = 'ENABLED'
}

export type KYCApplicationFilter = {
  includePorto?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KYCConfig = Node & {
  __typename: 'KYCConfig';
  affiliate: InstitutionalAffiliate;
  client: InstitutionalClient;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  deletedAt: Maybe<Scalars['Time']['output']>;
  deletedBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization: Maybe<Organization>;
  relianceModel: KYCConfigRelianceModel;
  termsAndConditionsDocusignTemplate: Maybe<Scalars['String']['output']>;
  termsAndConditionsModel: KYCConfigTermsAndConditionsModel;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type KYCConfigConnection = {
  __typename: 'KYCConfigConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<KYCConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KYCConfigEdge = {
  __typename: 'KYCConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<KYCConfig>;
};

/** Ordering options for KYCConfig connections */
export type KYCConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KYCConfigs. */
  field: KYCConfigOrderField;
};

/** Properties by which KYCConfig connections can be ordered. */
export enum KYCConfigOrderField {
  AFFILIATE_ID = 'AFFILIATE_ID',
  CLIENT_ID = 'CLIENT_ID',
  CREATED_AT = 'CREATED_AT',
  CREATED_BY = 'CREATED_BY',
  DELETED_AT = 'DELETED_AT',
  DELETED_BY = 'DELETED_BY',
  ID = 'ID',
  ORGANIZATION_KEY_ID = 'ORGANIZATION_KEY_ID',
  RELIANCE_MODEL = 'RELIANCE_MODEL',
  TERMS_AND_CONDITIONS_DOCUSIGN_TEMPLATE = 'TERMS_AND_CONDITIONS_DOCUSIGN_TEMPLATE',
  TERMS_AND_CONDITIONS_MODEL = 'TERMS_AND_CONDITIONS_MODEL',
  UPDATED_AT = 'UPDATED_AT',
  UPDATED_BY = 'UPDATED_BY'
}

/** KYCConfigRelianceModel is enum for the field reliance_model */
export enum KYCConfigRelianceModel {
  FULL_RELIANCE = 'FULL_RELIANCE',
  NO_RELIANCE = 'NO_RELIANCE',
  PARTIAL_RELIANCE = 'PARTIAL_RELIANCE',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** KYCConfigTermsAndConditionsModel is enum for the field terms_and_conditions_model */
export enum KYCConfigTermsAndConditionsModel {
  DOCUSIGN = 'DOCUSIGN',
  EXEMPTION = 'EXEMPTION',
  UNSPECIFIED = 'UNSPECIFIED'
}

/**
 * KYCConfigWhereInput is used for filtering KYCConfig objects.
 * Input was generated by ent.
 */
export type KYCConfigWhereInput = {
  /** affiliate_id field predicates */
  affiliateID?: InputMaybe<Scalars['String']['input']>;
  affiliateIDContains?: InputMaybe<Scalars['String']['input']>;
  affiliateIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  affiliateIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  affiliateIDGT?: InputMaybe<Scalars['String']['input']>;
  affiliateIDGTE?: InputMaybe<Scalars['String']['input']>;
  affiliateIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  affiliateIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  affiliateIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  affiliateIDLT?: InputMaybe<Scalars['String']['input']>;
  affiliateIDLTE?: InputMaybe<Scalars['String']['input']>;
  affiliateIDNEQ?: InputMaybe<Scalars['String']['input']>;
  affiliateIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<KYCConfigWhereInput>>;
  /** client_id field predicates */
  clientID?: InputMaybe<Scalars['String']['input']>;
  clientIDContains?: InputMaybe<Scalars['String']['input']>;
  clientIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  clientIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  clientIDGT?: InputMaybe<Scalars['String']['input']>;
  clientIDGTE?: InputMaybe<Scalars['String']['input']>;
  clientIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  clientIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  clientIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIDLT?: InputMaybe<Scalars['String']['input']>;
  clientIDLTE?: InputMaybe<Scalars['String']['input']>;
  clientIDNEQ?: InputMaybe<Scalars['String']['input']>;
  clientIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** deleted_by field predicates */
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  deletedByContains?: InputMaybe<Scalars['String']['input']>;
  deletedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  deletedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  deletedByGT?: InputMaybe<Scalars['String']['input']>;
  deletedByGTE?: InputMaybe<Scalars['String']['input']>;
  deletedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deletedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deletedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLT?: InputMaybe<Scalars['String']['input']>;
  deletedByLTE?: InputMaybe<Scalars['String']['input']>;
  deletedByNEQ?: InputMaybe<Scalars['String']['input']>;
  deletedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<KYCConfigWhereInput>;
  or?: InputMaybe<Array<KYCConfigWhereInput>>;
  /** organization_key_id field predicates */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDContains?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDGT?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDGTE?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationKeyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organizationKeyIDLT?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDLTE?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  organizationKeyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationKeyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** reliance_model field predicates */
  relianceModel?: InputMaybe<KYCConfigRelianceModel>;
  relianceModelIn?: InputMaybe<Array<KYCConfigRelianceModel>>;
  relianceModelNEQ?: InputMaybe<KYCConfigRelianceModel>;
  relianceModelNotIn?: InputMaybe<Array<KYCConfigRelianceModel>>;
  /** terms_and_conditions_docusign_template field predicates */
  termsAndConditionsDocusignTemplate?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateContains?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateGT?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  termsAndConditionsDocusignTemplateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditionsDocusignTemplateLT?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsDocusignTemplateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  termsAndConditionsDocusignTemplateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** terms_and_conditions_model field predicates */
  termsAndConditionsModel?: InputMaybe<KYCConfigTermsAndConditionsModel>;
  termsAndConditionsModelIn?: InputMaybe<Array<KYCConfigTermsAndConditionsModel>>;
  termsAndConditionsModelNEQ?: InputMaybe<KYCConfigTermsAndConditionsModel>;
  termsAndConditionsModelNotIn?: InputMaybe<Array<KYCConfigTermsAndConditionsModel>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A customer type with its code and human-readable label. */
export type KYCCustomerType = {
  __typename: 'KYCCustomerType';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** KYCDataConflict is the kyc data conflict information */
export type KYCDataConflict = {
  __typename: 'KYCDataConflict';
  /** field is field text label */
  field: Maybe<Scalars['String']['output']>;
  /** newValue is the new value of the field at SOT */
  newValue: Maybe<Scalars['String']['output']>;
  /** section is the section label */
  section: Maybe<Scalars['String']['output']>;
  /** tag is the information type of the field */
  tag: Maybe<Scalars['String']['output']>;
  /** type is the type of the field */
  type: Maybe<KYCQuestionType>;
  /** updatedAt is the time the field was changed at SOT */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** updatedBy is the user who changed the field at SOT */
  updatedBy: Maybe<Scalars['String']['output']>;
};

/**
 * KYCDataLookupResponse carries answers resolved from an external source
 * against the submission's questionnaire, ready to apply to the form.
 */
export type KYCDataLookupResponse = {
  __typename: 'KYCDataLookupResponse';
  /** Resolved answers keyed by the submission's question and option IDs. */
  answers: Array<KYCQuestionAnswer>;
  /**
   * Whether the source key matched a record. False also covers the cases where
   * the lookup is unavailable (disabled, invalid key, upstream failure, no match).
   */
  found: Scalars['Boolean']['output'];
};

/**
 * KYCDataLookupSource identifies an external data source a question's
 * onAnswer.dataLookup trigger can call.
 */
export enum KYCDataLookupSource {
  /** The SEC IAPD (Investment Adviser Public Disclosure) firm registry, keyed by CRD number. */
  SEC_IAPD = 'SEC_IAPD'
}

/** KYCDataLookupTrigger declares a kycDataLookup call to make on answer. */
export type KYCDataLookupTrigger = {
  __typename: 'KYCDataLookupTrigger';
  /**
   * Question IDs whose current answer values become the kycDataLookup query's
   * args, in order.
   */
  args: Array<Scalars['String']['output']>;
  /** The external data source to query. */
  source: KYCDataLookupSource;
};

/** KYCEntityRelationship describes the relationship between two kyc entities. */
export enum KYCEntityRelationship {
  /** AML_SERVICE_PROVIDER represents an AML Service Provider relation */
  AML_SERVICE_PROVIDER = 'AML_SERVICE_PROVIDER',
  /** AUTHORIZED_SIGNATORY represents an authorized signatory relation */
  AUTHORIZED_SIGNATORY = 'AUTHORIZED_SIGNATORY',
  /** BENEFICIAL_OWNER represents a Beneficial Owner relation */
  BENEFICIAL_OWNER = 'BENEFICIAL_OWNER',
  /** BENEFICIARY represents a Beneficiary relation */
  BENEFICIARY = 'BENEFICIARY',
  /** BOARD_DIRECTOR represents a Board Director relation */
  BOARD_DIRECTOR = 'BOARD_DIRECTOR',
  /** CONTROL_PERSON represents a Control Person relation */
  CONTROL_PERSON = 'CONTROL_PERSON',
  /** DONOR represents a Donor relation between individual and affiliate */
  DONOR = 'DONOR',
  /** FEEDER_FUND represents a Feeder fund relation */
  FEEDER_FUND = 'FEEDER_FUND',
  /** FUND_ADMINISTRATOR represents a Fund Administrator relation */
  FUND_ADMINISTRATOR = 'FUND_ADMINISTRATOR',
  /** GENERAL_PARTNER represents a General Partner relation */
  GENERAL_PARTNER = 'GENERAL_PARTNER',
  /** GRANTOR represents a Grantor/Settlor relation between individual and affiliate */
  GRANTOR = 'GRANTOR',
  /** GRANTOR_DONOR represents a Grantor/Donor/Settlor relation */
  GRANTOR_DONOR = 'GRANTOR_DONOR',
  /** GUARANTOR represents a Guarantor relation between individual and affiliate */
  GUARANTOR = 'GUARANTOR',
  /** INVESTMENT_MANAGER represents a Investment Manager */
  INVESTMENT_MANAGER = 'INVESTMENT_MANAGER',
  /** MANAGING_MEMBER represents a Managing Member relation */
  MANAGING_MEMBER = 'MANAGING_MEMBER',
  /** OTHER represents another relation */
  OTHER = 'OTHER',
  /** PARENT_ENTITY represents a Parent entity relation */
  PARENT_ENTITY = 'PARENT_ENTITY',
  /** PARTICIPATING_MEMBER represents an Authorized User relation */
  PARTICIPATING_MEMBER = 'PARTICIPATING_MEMBER',
  /** SENIOR_OFFICER represents a Senior Officer relation */
  SENIOR_OFFICER = 'SENIOR_OFFICER',
  /** TRUSTEE_SUCCESSOR_TRUSTEE represents a Trustee/Success Trustee relation */
  TRUSTEE_SUCCESSOR_TRUSTEE = 'TRUSTEE_SUCCESSOR_TRUSTEE',
  /** TRUST_PROTECTOR represents a Trust protector relation */
  TRUST_PROTECTOR = 'TRUST_PROTECTOR'
}

/** KYCEntityType is enum for the kyc entity type */
export enum KYCEntityType {
  /** AFFILIATE represents an affiliate entity */
  AFFILIATE = 'AFFILIATE',
  /** INDIVIDUAL represents an individual entity */
  INDIVIDUAL = 'INDIVIDUAL',
  /** RELATED_PARTY represents a related party entity */
  RELATED_PARTY = 'RELATED_PARTY',
  /** UNSPECIFIED is the default value for the kyc entity type */
  UNSPECIFIED = 'UNSPECIFIED'
}

/**
 * KYCEntityWhereInput is used for filtering KYCEntity objects.
 * Input was generated by ent.
 */
export type KYCEntityWhereInput = {
  and?: InputMaybe<Array<KYCEntityWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<KYCEntityWhereInput>;
  or?: InputMaybe<Array<KYCEntityWhereInput>>;
};

/** KYCNavStatusType is enum for the kyc Nav element status type */
export enum KYCNavStatusType {
  /** COMPLETED means all required questions are answered */
  COMPLETED = 'COMPLETED',
  /** ERROR means at least one question has an error */
  ERROR = 'ERROR',
  /** INCOMPLETE means no questions are answered */
  INCOMPLETE = 'INCOMPLETE'
}

/** KYCOptionsList is a reference to list of options to display in the question */
export enum KYCOptionsList {
  /** COUNTRIES is a list of countries */
  COUNTRIES = 'COUNTRIES',
  /** UNSPECIFIED is a default value for the options list */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** KYCProcess is the ent schema for the KYCProcess entity. */
export type KYCProcess = Node & {
  __typename: 'KYCProcess';
  alloyToken: Maybe<Scalars['String']['output']>;
  caseID: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endedAt: Maybe<Scalars['Time']['output']>;
  /** KYCProcessID is the ID of the KYCProcess. */
  id: Scalars['ID']['output'];
  kycAnalyst: Maybe<Scalars['String']['output']>;
  kycEntityID: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  qcAnalyst: Maybe<Scalars['String']['output']>;
  questionnaireSubmissions: Maybe<Array<KYCQuestionnaireSubmission>>;
  state: KYCProcessState;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type KYCProcessConnection = {
  __typename: 'KYCProcessConnection';
  /** A list of edges. */
  edges: Maybe<Array<KYCProcessEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KYCProcessEdge = {
  __typename: 'KYCProcessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<KYCProcess>;
};

/** Ordering options for KYC Process connections */
export type KYCProcessOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Users. */
  field: KYCProcessOrderField;
};

/** Properties by which KYC Process connections can be ordered. */
export enum KYCProcessOrderField {
  ID = 'ID',
  JIRA_CASE_ID = 'JIRA_CASE_ID',
  JIRA_CASE_TYPE = 'JIRA_CASE_TYPE',
  NAME = 'NAME',
  STATE = 'STATE'
}

/** KYCProcessState is enum for the field state */
export enum KYCProcessState {
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  REVIEW = 'REVIEW',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** KYCProcessTrigger is used for configuring the KYC Process Triggers. */
export type KYCProcessTrigger = Node & {
  __typename: 'KYCProcessTrigger';
  /** The actions to be taken when the trigger is fired. */
  actions: Maybe<Array<KYCProcessTriggerAction>>;
  /** Type of the affiliate */
  affiliateType: Maybe<Scalars['String']['output']>;
  /** Anchorage entity type */
  anchorageEntityType: Maybe<Scalars['String']['output']>;
  /** The conditions to be validated when the trigger is fired. */
  conditions: Maybe<Array<KYCProcessTriggerCondition>>;
  /** The current JIRA state. */
  currentJiraState: Scalars['String']['output'];
  /** The unique identifier for the KYCProcessTrigger. */
  id: Scalars['ID']['output'];
  /** The JIRA case type. */
  jiraCaseType: Scalars['String']['output'];
  /** The previous JIRA state. */
  previousJiraState: Maybe<Scalars['String']['output']>;
  /** Priority of the trigger */
  priority: Scalars['Int']['output'];
};

/** A KYCProcess trigger action configuration */
export type KYCProcessTriggerAction = {
  __typename: 'KYCProcessTriggerAction';
  /** The type of the KYCProcessTriggerAction. */
  actionType: KYCProcessTriggerActionType;
  /** The configuration of the KYCProcessTriggerAction. */
  config: Scalars['String']['output'];
};

/** KYCProcessTriggerActionInput is used to create/update KYCProcessTrigger actions. */
export type KYCProcessTriggerActionInput = {
  /** The type of the KYCProcessTriggerAction. */
  actionType: KYCProcessTriggerActionType;
  /** The configuration of the KYCProcessTriggerAction. */
  config: Scalars['String']['input'];
};

/** KYCProcessTriggerActionType is enum for the field type */
export enum KYCProcessTriggerActionType {
  /** KYC Process action type. */
  KYC_PROCESS = 'KYC_PROCESS',
  /** Notification action type. */
  NOTIFICATION = 'NOTIFICATION',
  /** Questionnaire submission action type. */
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  /** Screening action type. */
  SCREENING = 'SCREENING'
}

/** A connection to a list of items. */
export type KYCProcessTriggerCondition = {
  __typename: 'KYCProcessTriggerCondition';
  /** The type of the KYCProcessTriggerCondition. */
  conditionType: KYCProcessTriggerConditionType;
  /** The configuration of the KYCProcessTriggerCondition. */
  config: Scalars['String']['output'];
};

/** A KYCProcessTriggerConditionInput is used to create/update KYCProcessTrigger conditions. */
export type KYCProcessTriggerConditionInput = {
  /** The type of the KYCProcessTriggerCondition. */
  conditionType: KYCProcessTriggerConditionType;
  /** The configuration of the KYCProcessTriggerCondition. */
  config: Scalars['String']['input'];
};

/** KYCProcessTriggerConditionType is enum for the field KYCProcessCondition type */
export enum KYCProcessTriggerConditionType {
  /** KYC Process action type. */
  KYC_PROCESS = 'KYC_PROCESS',
  /** Questionnaire submission action type. */
  QUESTIONNAIRE = 'QUESTIONNAIRE'
}

/** A connection to a list of items. */
export type KYCProcessTriggerConnection = {
  __typename: 'KYCProcessTriggerConnection';
  /** A list of edges. */
  edges: Maybe<Array<KYCProcessTriggerEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KYCProcessTriggerEdge = {
  __typename: 'KYCProcessTriggerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<KYCProcessTrigger>;
};

/** Ordering options for KYCProcessTrigger connections */
export type KYCProcessTriggerOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KYCProcessTriggers. */
  field: KYCProcessTriggerOrderField;
};

/** Properties by which KYCProcessTrigger connections can be ordered. */
export enum KYCProcessTriggerOrderField {
  /** Order by Affiliate type field */
  AFFILIATE_TYPE = 'AFFILIATE_TYPE',
  /** Order by Anchorage entity type field */
  ANCHORAGE_ENTITY_TYPE = 'ANCHORAGE_ENTITY_TYPE',
  /** Order by Current JIRA State field */
  CURRENT_JIRA_STATE = 'CURRENT_JIRA_STATE',
  /** Order by ID field */
  ID = 'ID',
  /** Order by JIRA Case Type field */
  JIRA_CASE_TYPE = 'JIRA_CASE_TYPE',
  /** Order by Previous JIRA State field */
  PREVIOUS_JIRA_STATE = 'PREVIOUS_JIRA_STATE',
  /** Order by Priority */
  PRIORITY = 'PRIORITY'
}

/**
 * KYCProcessTriggerWhereInput is used for filtering KYCProcessTrigger objects.
 * Input was generated by ent.
 */
export type KYCProcessTriggerWhereInput = {
  /** affiliate_type field predicates */
  affiliateType?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeContains?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeGT?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeGTE?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  affiliateTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  affiliateTypeLT?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeLTE?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  affiliateTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  affiliateTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** anchorage_entity_type field predicates */
  anchorageEntityType?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeContains?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeGT?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeGTE?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  anchorageEntityTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  anchorageEntityTypeLT?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeLTE?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  anchorageEntityTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<KYCProcessTriggerWhereInput>>;
  /** current_jira_state field predicates */
  currentJiraState?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateContains?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateContainsFold?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateEqualFold?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateGT?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateGTE?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  currentJiraStateLT?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateLTE?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateNEQ?: InputMaybe<Scalars['String']['input']>;
  currentJiraStateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** jira_case_type field predicates */
  jiraCaseType?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeContains?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeGT?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeGTE?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  jiraCaseTypeLT?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeLTE?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  jiraCaseTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<KYCProcessTriggerWhereInput>;
  or?: InputMaybe<Array<KYCProcessTriggerWhereInput>>;
  /** previous_jira_state field predicates */
  previousJiraState?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateContains?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateContainsFold?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateEqualFold?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateGT?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateGTE?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  previousJiraStateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  previousJiraStateLT?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateLTE?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateNEQ?: InputMaybe<Scalars['String']['input']>;
  previousJiraStateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  previousJiraStateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** priority field predicates */
  priority?: InputMaybe<Scalars['Int']['input']>;
  priorityGT?: InputMaybe<Scalars['Int']['input']>;
  priorityGTE?: InputMaybe<Scalars['Int']['input']>;
  priorityIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  priorityLT?: InputMaybe<Scalars['Int']['input']>;
  priorityLTE?: InputMaybe<Scalars['Int']['input']>;
  priorityNEQ?: InputMaybe<Scalars['Int']['input']>;
  priorityNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * KYCProcessWhereInput is used for filtering KYCProcess objects.
 * Input was generated by ent.
 */
export type KYCProcessWhereInput = {
  /** alloy_token field predicates */
  alloyToken?: InputMaybe<Scalars['String']['input']>;
  alloyTokenContains?: InputMaybe<Scalars['String']['input']>;
  alloyTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  alloyTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  alloyTokenGT?: InputMaybe<Scalars['String']['input']>;
  alloyTokenGTE?: InputMaybe<Scalars['String']['input']>;
  alloyTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  alloyTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  alloyTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  alloyTokenIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  alloyTokenLT?: InputMaybe<Scalars['String']['input']>;
  alloyTokenLTE?: InputMaybe<Scalars['String']['input']>;
  alloyTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  alloyTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  alloyTokenNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<KYCProcessWhereInput>>;
  /** case_id field predicates */
  caseID?: InputMaybe<Scalars['String']['input']>;
  caseIDContains?: InputMaybe<Scalars['String']['input']>;
  caseIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  caseIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  caseIDGT?: InputMaybe<Scalars['String']['input']>;
  caseIDGTE?: InputMaybe<Scalars['String']['input']>;
  caseIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  caseIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  caseIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  caseIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  caseIDLT?: InputMaybe<Scalars['String']['input']>;
  caseIDLTE?: InputMaybe<Scalars['String']['input']>;
  caseIDNEQ?: InputMaybe<Scalars['String']['input']>;
  caseIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  caseIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ended_at field predicates */
  endedAt?: InputMaybe<Scalars['Time']['input']>;
  endedAtGT?: InputMaybe<Scalars['Time']['input']>;
  endedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  endedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endedAtLT?: InputMaybe<Scalars['Time']['input']>;
  endedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  endedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  endedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** kyc_entity edge predicates */
  hasKycEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasKycEntityWith?: InputMaybe<Array<KYCEntityWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kyc_analyst field predicates */
  kycAnalyst?: InputMaybe<Scalars['String']['input']>;
  kycAnalystContains?: InputMaybe<Scalars['String']['input']>;
  kycAnalystContainsFold?: InputMaybe<Scalars['String']['input']>;
  kycAnalystEqualFold?: InputMaybe<Scalars['String']['input']>;
  kycAnalystGT?: InputMaybe<Scalars['String']['input']>;
  kycAnalystGTE?: InputMaybe<Scalars['String']['input']>;
  kycAnalystHasPrefix?: InputMaybe<Scalars['String']['input']>;
  kycAnalystHasSuffix?: InputMaybe<Scalars['String']['input']>;
  kycAnalystIn?: InputMaybe<Array<Scalars['String']['input']>>;
  kycAnalystIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kycAnalystLT?: InputMaybe<Scalars['String']['input']>;
  kycAnalystLTE?: InputMaybe<Scalars['String']['input']>;
  kycAnalystNEQ?: InputMaybe<Scalars['String']['input']>;
  kycAnalystNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  kycAnalystNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** kyc_entity_id field predicates */
  kycEntityID?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDContains?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDGT?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDGTE?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  kycEntityIDLT?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDLTE?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  kycEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<KYCProcessWhereInput>;
  or?: InputMaybe<Array<KYCProcessWhereInput>>;
  /** qc_analyst field predicates */
  qcAnalyst?: InputMaybe<Scalars['String']['input']>;
  qcAnalystContains?: InputMaybe<Scalars['String']['input']>;
  qcAnalystContainsFold?: InputMaybe<Scalars['String']['input']>;
  qcAnalystEqualFold?: InputMaybe<Scalars['String']['input']>;
  qcAnalystGT?: InputMaybe<Scalars['String']['input']>;
  qcAnalystGTE?: InputMaybe<Scalars['String']['input']>;
  qcAnalystHasPrefix?: InputMaybe<Scalars['String']['input']>;
  qcAnalystHasSuffix?: InputMaybe<Scalars['String']['input']>;
  qcAnalystIn?: InputMaybe<Array<Scalars['String']['input']>>;
  qcAnalystIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  qcAnalystLT?: InputMaybe<Scalars['String']['input']>;
  qcAnalystLTE?: InputMaybe<Scalars['String']['input']>;
  qcAnalystNEQ?: InputMaybe<Scalars['String']['input']>;
  qcAnalystNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  qcAnalystNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state field predicates */
  state?: InputMaybe<KYCProcessState>;
  stateIn?: InputMaybe<Array<KYCProcessState>>;
  stateNEQ?: InputMaybe<KYCProcessState>;
  stateNotIn?: InputMaybe<Array<KYCProcessState>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * KYCProfile interface defines common fields for all KYC profile types.
 * Implemented by OrganizationKYCProfile, AffiliateKYCProfile, AccountKYCProfile, and RelatedPartyKYCProfile.
 */
export type KYCProfile = {
  /** Anchorage entity associated with this profile */
  anchorageEntity: Maybe<AnchorageEntity>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Exemptions for this KYC profile - information types that are exempt from collection */
  exemptions: Array<Scalars['String']['output']>;
  /** Unique identifier for the KYC profile */
  id: Scalars['ID']['output'];
  /** Name associated with the profile */
  name: Scalars['String']['output'];
  /** Current status of the KYC profile */
  status: KYCStatus;
};

/** Customer type classification for a KYC profile */
export type KYCProfileCustomerType = {
  __typename: 'KYCProfileCustomerType';
  /** Primary customer type */
  primary: Maybe<Scalars['String']['output']>;
  /** Secondary customer type */
  secondary: Maybe<Scalars['String']['output']>;
};

/** KYC compliance and risk flags */
export type KYCProfileFlags = {
  __typename: 'KYCProfileFlags';
  /** FCA (Financial Crimes Assessment) flag */
  fca: Scalars['Boolean']['output'];
  /** FFI (Foreign Financial Institution) flag */
  ffi: Scalars['Boolean']['output'];
  /** Material News flag */
  materialNews: Scalars['Boolean']['output'];
  /** Non-Material News flag */
  nonMaterialNews: Scalars['Boolean']['output'];
  /** PEP (Politically Exposed Person) flag */
  pep: Scalars['Boolean']['output'];
  /** Suspicious Activity flag */
  suspiciousActivity: Scalars['Boolean']['output'];
};

/** Key-value information associated with a KYC profile */
export type KYCProfileInfo = {
  __typename: 'KYCProfileInfo';
  /** URL to blob content if the value is stored as a blob */
  contentURL: Maybe<Scalars['String']['output']>;
  /** The key/identifier for this piece of information */
  key: Scalars['String']['output'];
  /** Human-readable label for this information */
  label: Scalars['String']['output'];
  /** The value of the information */
  value: Scalars['String']['output'];
};

/** Historical audit entry for KYC profile information changes */
export type KYCProfileInfoHistory = {
  __typename: 'KYCProfileInfoHistory';
  /** URL to blob content if the value is stored as a blob */
  contentURL: Maybe<Scalars['String']['output']>;
  /** Related group information (stub placeholder for future use) */
  groupInformation: Array<KYCProfileInfoHistory>;
  /** Unique identifier for this history entry */
  id: Scalars['ID']['output'];
  /** The key/identifier for this piece of information */
  key: Scalars['String']['output'];
  /** The KYC profile this history belongs to */
  kycProfileID: Scalars['String']['output'];
  /** Optional notes about why this change was made */
  notes: Maybe<Scalars['String']['output']>;
  /** When this change was recorded */
  updatedAt: Scalars['DateTime']['output'];
  /** Who made this change */
  updatedBy: Scalars['String']['output'];
  /** The value of the information at this point in time */
  value: Scalars['String']['output'];
};

/** Connection for KYCProfileInfoHistory pagination */
export type KYCProfileInfoHistoryConnection = {
  __typename: 'KYCProfileInfoHistoryConnection';
  /** A list of edges */
  edges: Array<KYCProfileInfoHistoryEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Total count of history entries matching the filter */
  totalCount: Scalars['Int']['output'];
};

/** Edge for KYCProfileInfoHistory */
export type KYCProfileInfoHistoryEdge = {
  __typename: 'KYCProfileInfoHistoryEdge';
  /** Cursor for pagination */
  cursor: Scalars['CursorType']['output'];
  /** The history entry */
  node: KYCProfileInfoHistory;
};

/** Ordering options for KYC Profile connections */
export type KYCProfileOrder = {
  /** The ordering direction */
  direction?: OrderDirection;
  /** The field by which to order KYC Profiles */
  field: KYCProfileOrderField;
};

/** Properties by which KYC Profile connections can be ordered */
export enum KYCProfileOrderField {
  /** Order by anchorage entity */
  ANCHORAGE_ENTITY = 'ANCHORAGE_ENTITY',
  /** Order by profile name */
  NAME = 'NAME',
  /** Order by KYC status */
  STATUS = 'STATUS'
}

/** KYC refresh date information */
export type KYCProfileRefresh = {
  __typename: 'KYCProfileRefresh';
  /** Last KYC refresh date is the date when the affiliate had Full KYC Review */
  lastRefreshDate: Maybe<Scalars['Date']['output']>;
  /** Next KYC refresh date is the date when a KYC refresh is due */
  nextRefreshDate: Maybe<Scalars['Date']['output']>;
};

/** KYCProfileRelation interface defines relationship data common to all KYC profile relations */
export type KYCProfileRelation = {
  /** Ownership percentage in this relationship (for beneficial owners) */
  ownershipPercentage: Maybe<Scalars['String']['output']>;
  /** Role description (e.g., CEO, CFO, Board Member) */
  roleDescription: Maybe<Scalars['String']['output']>;
  /** Types of relationship (e.g., BENEFICIAL_OWNER, CONTROL_PERSON, AUTHORIZED_REPRESENTATIVE) */
  roles: Maybe<Array<KYCRoleType>>;
};

/**
 * KYCProfileRelationAuditRole contains the role details for a relationship audit entry.
 * Implements the existing KYCProfileRelation interface to reuse standard role fields.
 */
export type KYCProfileRelationAuditRole = KYCProfileRelation & {
  __typename: 'KYCProfileRelationAuditRole';
  /** Ownership percentage in this relationship (for beneficial owners) */
  ownershipPercentage: Maybe<Scalars['String']['output']>;
  /** Role description (e.g., CEO, CFO, Board Member) */
  roleDescription: Maybe<Scalars['String']['output']>;
  /** Types of relationship (e.g., BENEFICIAL_OWNER, CONTROL_PERSON, AUTHORIZED_REPRESENTATIVE) */
  roles: Maybe<Array<KYCRoleType>>;
};

export type KYCQuestion = Node & {
  __typename: 'KYCQuestion';
  categories: Array<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  customerTypes: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  informationType: Scalars['String']['output'];
  layoutDefinition: Maybe<KYCQuestionLayoutDefinition>;
  name: Scalars['String']['output'];
  questionDefinition: KYCQuestionDefinition;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** KYCQuestionAnswer is the actual user answer for a question */
export type KYCQuestionAnswer = {
  __typename: 'KYCQuestionAnswer';
  /** The free form text written in response to the question */
  freeformText: Maybe<Scalars['String']['output']>;
  /** A group of answers, used to answer for a question of type group */
  group: Array<Array<KYCQuestionAnswer>>;
  /** The option IDs selected in response to the question */
  options: Maybe<Array<Scalars['String']['output']>>;
  /** The id of the question this answer is related to */
  questionID: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type KYCQuestionConnection = {
  __typename: 'KYCQuestionConnection';
  /** A list of edges. */
  edges: Maybe<Array<KYCQuestionEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** KYCQuestionDefinition contains the details for a particular question */
export type KYCQuestionDefinition = {
  __typename: 'KYCQuestionDefinition';
  /**
   * alternativeTexts is a list of alternative question texts in the question defenition.
   * This can be used to override text value for a specific question inside a questionnaire.
   */
  alternativeTexts: Maybe<Array<Scalars['String']['output']>>;
  /** The text to display below the options or field */
  footer: Scalars['String']['output'];
  /** Used to allow custom text answer by using this "id" (only for dropdown) */
  freeformOptionID: Scalars['String']['output'];
  /** The group of questions that can be answered more than once (only for GROUP) */
  group: Array<KYCQuestionDefinition>;
  /** groupMetadata is the metadata that affect the child entities created by the group questions */
  groupMetadata: Maybe<KYCQuestionGroupMetadata>;
  /** The text to display below "text" but above the options or field */
  header: Scalars['String']['output'];
  /** hidden is used for one question value should not be displayed. Could be used prefilled with an answer in a previous form and serve only for triggering questions within a questionnaire. */
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier for the question */
  id: Scalars['String']['output'];
  /** The optional user-friendly shorthand name for the question */
  name: Scalars['String']['output'];
  /** note is a free-form annotation attached to the question definition. */
  note: Maybe<Scalars['String']['output']>;
  /** onAnswer declares side effects to run when this question receives an answer. */
  onAnswer: Maybe<Array<KYCQuestionOnAnswer>>;
  /** Identifies whether this question is optional */
  optional: Scalars['Boolean']['output'];
  /** List of possible options (only for CHIP, RADIO, CHECKBOX, DROPDOWN, DROPDOWN_MULTI_SELECT, RADIO_GROUP) */
  options: Array<KYCQuestionOption>;
  /**
   * OptionsList is a reference to a list of options to display in the question (only for CHIP, RADIO, CHECKBOX, DROPDOWN, DROPDOWN_MULTI_SELECT, RADIO_GROUP)
   * Can be used as an alternative of the actual array of options
   */
  optionsList: KYCOptionsList;
  /** The text to display inside the field (only for textfield or dropdown) */
  placeholderText: Scalars['String']['output'];
  /** preFill should be used to specify if a given question should have its value prefilled or not */
  preFill: Scalars['Boolean']['output'];
  /** Used for one question value should not be editable. Could be used prefilled with an answer in a previous form and serve only information purposes. */
  readOnly: Scalars['Boolean']['output'];
  /** relatedQuestionIDs is a list of question IDs that are related to the current question */
  relatedQuestionIDs: Maybe<Array<Scalars['String']['output']>>;
  /** The rules for validating the user's answer */
  rules: Array<KYCQuestionRule>;
  /** SampleText is the text to display as a sample answer */
  sampleText: Scalars['String']['output'];
  /** The text to display below SectionTitle but above the field, in case the question is a section */
  sectionSubTitle: Scalars['String']['output'];
  /** The text to display above the field, in case the question is a section */
  sectionTitle: Scalars['String']['output'];
  /** Used to show the next question before answering this one this can cascade, if the next question has ShowNext, also show it (only for OneByOne) */
  showNext: Scalars['Boolean']['output'];
  /** The optional internal identifier tag */
  tag: Scalars['String']['output'];
  /** The text to display above the options or field */
  text: Scalars['String']['output'];
  /** A tooltip to explain the question */
  tooltip: Scalars['String']['output'];
  /** Used to only ask this question if the user selected a specific option e.g. {{"o1", "o2"}, {"o3"}} means [[o1 AND o2] OR [o3]] */
  triggerOptionID: Array<Array<Scalars['String']['output']>>;
  /** The type of question */
  type: KYCQuestionType;
  /** validationLevel set the level of validation for the question, meaning that depending on save action the question can be validated or not (default 0) */
  validationLevel: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type KYCQuestionEdge = {
  __typename: 'KYCQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<KYCQuestion>;
};

/** KYCQuestionGroupMetadata is the metadata that affect the child entities created by the group questions */
export type KYCQuestionGroupMetadata = {
  __typename: 'KYCQuestionGroupMetadata';
  /** question tag of the child question that holds the relation types */
  childRelationTag: Maybe<Scalars['String']['output']>;
  /** default relation type for the relation group question */
  defaultRelationType: Maybe<KYCEntityRelationship>;
  /** entity type for the relation group question */
  entityType: KYCEntityType;
};

/** KYCQuestionLayoutDefinition holds nav placement hints for a pooled question. */
export type KYCQuestionLayoutDefinition = {
  __typename: 'KYCQuestionLayoutDefinition';
  /** Top-level navigation label. */
  navLevel1: Maybe<Scalars['String']['output']>;
  /** Second-level navigation label. */
  navLevel2: Maybe<Scalars['String']['output']>;
};

/** KYCQuestionOnAnswer is a side effect to run when a question is answered. */
export type KYCQuestionOnAnswer = {
  __typename: 'KYCQuestionOnAnswer';
  /** Resolve answers from an external data-lookup source. */
  dataLookup: Maybe<KYCDataLookupTrigger>;
};

/** KYCQuestionOption is a selectable element for chip, radio, dropdown, checkbox, dropdown_multi_select, and RADIO_GROUP questions */
export type KYCQuestionOption = {
  __typename: 'KYCQuestionOption';
  /** When an exclusive option is selected, it should be the only selected option */
  exclusive: Scalars['Boolean']['output'];
  /** The unique identifier for the option */
  id: Scalars['String']['output'];
  /** In a RADIO_GROUP question, this represents the questions that will be active when this option is selected */
  questionGroup: Maybe<Array<KYCQuestionDefinition>>;
  /** The subtext for the option */
  subtext: Scalars['String']['output'];
  /** Display a subtitle based on a previous question (only for radio questions) */
  subtitleQuestionID: Scalars['String']['output'];
  /** The optional internal identifier tag */
  tag: Scalars['String']['output'];
  /** The text to display for this option */
  text: Scalars['String']['output'];
  /** The tooltip for the option */
  tooltip: Scalars['String']['output'];
};

/** Ordering options for KYCQuestion connections */
export type KYCQuestionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KYCQuestions. */
  field: KYCQuestionOrderField;
};

/** Properties by which KYCQuestion connections can be ordered. */
export enum KYCQuestionOrderField {
  /** Order by Created At field */
  CREATED_AT = 'CREATED_AT',
  /** Order by ID field */
  ID = 'ID',
  /** Order by Information Type field */
  INFORMATION_TYPE = 'INFORMATION_TYPE'
}

/** KYCQuestionRule describes a rule that validates a question's answers */
export type KYCQuestionRule = {
  __typename: 'KYCQuestionRule';
  /** A custom error message to be displayed if the validation fails */
  errorMessage: Scalars['String']['output'];
  /** The ID of a question whose answer will be the value for the rule */
  questionId: Maybe<Scalars['String']['output']>;
  /** The type of validation rule */
  type: KYCQuestionRuleType;
  /** The value of the rule (e.g. a regular expression or a number indicating the max value) */
  value: Scalars['String']['output'];
};

/** KYCQuestionRuleType describes the validation preformed by the rule */
export enum KYCQuestionRuleType {
  /** ADD_DAYS is a rule that checks if the date answer is within a given number of days from the current date */
  ADD_DAYS = 'ADD_DAYS',
  /** CHECK_SUM is a rule that checks if the sum of the answers for a given question inside a group equals a given value */
  CHECK_SUM = 'CHECK_SUM',
  /** DISTINCT is a rule that checks if a given question inside a group has unique answers */
  DISTINCT = 'DISTINCT',
  /** MAX_DATE is the maximum accepted date in the answer for date type questions */
  MAX_DATE = 'MAX_DATE',
  /** MAX_LENGTH is a maximum amount of characters or items in the answer */
  MAX_LENGTH = 'MAX_LENGTH',
  /** MAX_SUM is a rule that checks if the sum of the answers for a given question inside a group is below a given value */
  MAX_SUM = 'MAX_SUM',
  /** MIN_DATE is the minimum accepted date in the answer for date type questions */
  MIN_DATE = 'MIN_DATE',
  /** MIN_LENGTH is a minimum amount of characters or items in the answer */
  MIN_LENGTH = 'MIN_LENGTH',
  /** MIN_SUM is a rule that checks if the sum of the answers for a given question inside a group is above a given value */
  MIN_SUM = 'MIN_SUM',
  /** REGEX is a rule that contains a regex expression that is validated against the the answer text */
  REGEX = 'REGEX'
}

/** KYCQuestionType is the type of the questionnaire question */
export enum KYCQuestionType {
  /** CARD_SELECT allows the selection of one option in a list displayed as cards */
  CARD_SELECT = 'CARD_SELECT',
  /** CHECKBOX allows for the selection of multiple options in a list, adequate for short lists, may be optional */
  CHECKBOX = 'CHECKBOX',
  /** CHIP allows the selection of one option in a list, adequate for selecting words in short lists */
  CHIP = 'CHIP',
  /** CONFIRMATION is a question type to confirm a section of information */
  CONFIRMATION = 'CONFIRMATION',
  /** DATE is a question picker input type, should be answered with freeform text in the form of MM/DD/YYYY, may be optional */
  DATE = 'DATE',
  /** DROPDOWN allows the selection of one option in a list, adequate for long lists */
  DROPDOWN = 'DROPDOWN',
  /** DROPDOWN_MULTI_SELECT allows for the selection of multiple options in a list, adequate for long lists, may be optional */
  DROPDOWN_MULTI_SELECT = 'DROPDOWN_MULTI_SELECT',
  /** GROUP enables a group of questions to be answered multiple times, may be optional, use MAX_LENGTH/MIN_LENGTH to specify the required number of times to answer the questions, answers must be given ion the answer group */
  GROUP = 'GROUP',
  /** RADIO allows the selection of one option in a list, adequate for short lists */
  RADIO = 'RADIO',
  /** RADIO_GROUP enables a group of questions when the corresponding option is selected, the sub questions are answered as regular questions, may be optional */
  RADIO_GROUP = 'RADIO_GROUP',
  /** SECTION indicates the question is to be handled as a section describing the next questions, cannot receive answers */
  SECTION = 'SECTION',
  /** SUMMARY is also free text input, may be optional */
  SUMMARY = 'SUMMARY',
  /** TAX_CERTIFICATION is free text holding the tax form type the TaxBit SDK reports, e.g. W-9, cannot be optional */
  TAX_CERTIFICATION = 'TAX_CERTIFICATION',
  /** TEXTFIELD is a free text input, may be optional */
  TEXTFIELD = 'TEXTFIELD',
  /** TEXT_AREA is also free text input, may be optional */
  TEXT_AREA = 'TEXT_AREA',
  /** UPLOAD allows file uploads, may be optional */
  UPLOAD = 'UPLOAD',
  /** VOID is a no-op input type, cannot receive answers */
  VOID = 'VOID'
}

/**
 * KYCQuestionWhereInput is used for filtering KYCQuestion objects.
 * Input was generated by ent.
 */
export type KYCQuestionWhereInput = {
  and?: InputMaybe<Array<KYCQuestionWhereInput>>;
  categoriesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  customerTypesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** information_type field predicates */
  informationType?: InputMaybe<Scalars['String']['input']>;
  informationTypeContains?: InputMaybe<Scalars['String']['input']>;
  informationTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  informationTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  informationTypeGT?: InputMaybe<Scalars['String']['input']>;
  informationTypeGTE?: InputMaybe<Scalars['String']['input']>;
  informationTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  informationTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  informationTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  informationTypeLT?: InputMaybe<Scalars['String']['input']>;
  informationTypeLTE?: InputMaybe<Scalars['String']['input']>;
  informationTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  informationTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<KYCQuestionWhereInput>;
  or?: InputMaybe<Array<KYCQuestionWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** KYCQuestionnaire is for the KYCQuestionnaire entity. */
export type KYCQuestionnaire = Node & {
  __typename: 'KYCQuestionnaire';
  /** The Anchorage entities derived from the questionnaire categories */
  anchorageEntities: Array<AnchorageEntity>;
  /** The body of the questionnaire */
  body: KYCQuestionnaireElement;
  /** The body of the questionnaire as a json string */
  bodyJson: Scalars['String']['output'];
  /** The categories associated with the questionnaire */
  categories: Array<Scalars['String']['output']>;
  /** The timestamp when the questionnaire was created */
  createdAt: Scalars['Time']['output'];
  /** The identifier of the user who created the questionnaire */
  createdBy: Scalars['String']['output'];
  /** The timestamp when the questionnaire was deleted */
  deletedAt: Maybe<Scalars['Time']['output']>;
  /** The description of the questionnaire. */
  description: Maybe<Scalars['String']['output']>;
  /** The expiration days of the questionnaire */
  expirationDays: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the questionnaire */
  id: Scalars['ID']['output'];
  /** The name of the questionnaire */
  name: Scalars['String']['output'];
  /** The type of the questionnaire */
  questionnaireType: KYCQuestionnaireType;
  /** The timestamp when the questionnaire was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
  /** The identifier of the user who last updated the questionnaire */
  updatedBy: Maybe<Scalars['String']['output']>;
  /** The URL associated with the questionnaire */
  url: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type KYCQuestionnaireConnection = {
  __typename: 'KYCQuestionnaireConnection';
  /** A list of edges. */
  edges: Maybe<Array<KYCQuestionnaireEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KYCQuestionnaireEdge = {
  __typename: 'KYCQuestionnaireEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<KYCQuestionnaire>;
};

/** KYCQuestionnaireElement is for the KYCQuestionnaireElement entity. */
export type KYCQuestionnaireElement = {
  __typename: 'KYCQuestionnaireElement';
  /** The nested elements within this questionnaire element */
  elements: Array<KYCQuestionnaireElement>;
  /** The unique identifier for the questionnaire element */
  id: Scalars['ID']['output'];
  /** The layout configuration for this element */
  layout: Maybe<KYCQuestionnaireElementLayout>;
  /** Indicates if the element should be pre-filled */
  preFill: Scalars['Boolean']['output'];
  /** The question definition associated with this element */
  question: Maybe<KYCQuestionDefinition>;
  /** The subtitle of the questionnaire element */
  subtitle: Scalars['String']['output'];
  /** The title of the questionnaire element */
  title: Scalars['String']['output'];
  /** The conditions that trigger this element */
  triggeredBy: Array<Array<Scalars['String']['output']>>;
  /** IDs of the nearest questions that directly trigger this element; populated only in the question pool. */
  triggeredByQuestionIDs: Array<Scalars['ID']['output']>;
  /** The type of the questionnaire element */
  type: KYCQuestionnaireElementType;
};

/** KYCQuestionnaireElementLayout is for the KYCQuestionnaireElementLayout entity. */
export type KYCQuestionnaireElementLayout = {
  __typename: 'KYCQuestionnaireElementLayout';
  /** group template details for a group question element group */
  groupTemplate: Maybe<KYCQuestionnaireElementLayoutGroupTemplate>;
  /** icon used for a questionnaire element. Will mostly be used for NAV elements */
  icon: Scalars['String']['output'];
  /** layout orientation of a questionnaire element */
  orientation: Maybe<KYCQuestionnaireElementLayoutOrientation>;
  /** reloadLabel is the label used for reload button */
  reloadLabel: Scalars['String']['output'];
  /** supportsReload indicates if the element should enable a reload button */
  supportsReload: Scalars['Boolean']['output'];
  /** size of a questionnaire element if the question is of type text area */
  textAreaSize: Maybe<KYCQuestionnaireElementLayoutTextAreaSize>;
  /** layout type of questionnaire element */
  type: Maybe<KYCQuestionnaireElementLayoutType>;
};

/**
 * KYCQuestionnaireElementLayoutGroupTemplate is a layout property for kyc questionnaire element that specifies
 * detailed fields for configuring a group question template in the user interface
 */
export type KYCQuestionnaireElementLayoutGroupTemplate = {
  __typename: 'KYCQuestionnaireElementLayoutGroupTemplate';
  /** button title to add details for the group item modal */
  addDetailsButtonTitle: Scalars['String']['output'];
  /** icon used for each questionnaire group element */
  icon: Scalars['String']['output'];
  /** icon template used for each questionnaire group element */
  iconTemplate: Scalars['String']['output'];
  /** description template used for a group item */
  itemDescriptionTemplate: Scalars['String']['output'];
  /** subtitle used for a group item modals */
  itemSubtitle: Scalars['String']['output'];
  /** template string used for an existing group item */
  itemTemplate: Scalars['String']['output'];
  /** title used for a group item modals */
  itemTitle: Scalars['String']['output'];
  /** description shown on the new group item, in both the empty and filled states */
  newItemDescription: Maybe<Scalars['String']['output']>;
  /** bool indicating if the user can add new group answer items */
  newItemDisabled: Scalars['Boolean']['output'];
  /** template string used for new group item */
  newItemTemplate: Scalars['String']['output'];
  /** optionId used to trigger the group item modal */
  triggerOptionIdForModal: Scalars['String']['output'];
};

/** KYCQuestionnaireElementOrientation is enum for the KYCQuestionnaireElement orientation */
export enum KYCQuestionnaireElementLayoutOrientation {
  /** HORIZONTAL is a horizontal orientation */
  HORIZONTAL = 'HORIZONTAL',
  /** UNSPECIFIED is a default value for the orientation */
  UNSPECIFIED = 'UNSPECIFIED',
  /** VERTICAL is a vertical orientation */
  VERTICAL = 'VERTICAL'
}

/** KYCQuestionnaireElementLayoutTextAreaSize is enum for the size of a KYCQuestionnaireElement if the question type is text area. */
export enum KYCQuestionnaireElementLayoutTextAreaSize {
  /** LARGE is a large size for the text area */
  LARGE = 'LARGE',
  /** REGULAR is a regular size for the text area */
  REGULAR = 'REGULAR',
  /** SMALL is a small size for the text area */
  SMALL = 'SMALL',
  /** UNSPECIFIED is a default value for the text area size */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** KYCQuestionnaireElementLayoutType is enum for the KYCQuestionnaireElementLayout type */
export enum KYCQuestionnaireElementLayoutType {
  /** MESSAGE is a element layout type that renders a reviewer custom message */
  MESSAGE = 'MESSAGE',
  /** MODAL is a element layout type that is a modal */
  MODAL = 'MODAL',
  /** SUB_BLOCK is a element layout type that is a sub block */
  SUB_BLOCK = 'SUB_BLOCK',
  /** UNSPECIFIED is a element layout type that is not specified */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** KYCQuestionnaireElementType is enum for the KYCQuestionnaireElement type */
export enum KYCQuestionnaireElementType {
  /** BLOCK is a block element type */
  BLOCK = 'BLOCK',
  /** NAV is a nav element type */
  NAV = 'NAV',
  /** QUESTION is a question element type */
  QUESTION = 'QUESTION',
  /** QUESTIONNAIRE is a questionnaire element type */
  QUESTIONNAIRE = 'QUESTIONNAIRE'
}

/** KYCQuestionnaireNavStatus is for the KYCQuestionnaireNavStatus entity */
export type KYCQuestionnaireNavStatus = {
  __typename: 'KYCQuestionnaireNavStatus';
  /** elementID is the nav element id */
  elementID: Scalars['String']['output'];
  /** status is the Nav element status indicating all questions are answered */
  status: KYCNavStatusType;
};

/** Ordering options for KYCQuestionnaire connections */
export type KYCQuestionnaireOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KYCQuestionnaires. */
  field: KYCQuestionnaireOrderField;
};

/** Properties by which KYCQuestionnaire connections can be ordered. */
export enum KYCQuestionnaireOrderField {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  NAME = 'NAME',
  QUESTIONNAIRE_TYPE = 'QUESTIONNAIRE_TYPE'
}

/** KYCQuestionnaireSubmission is for the KYCQuestionnaireSubmission entity. */
export type KYCQuestionnaireSubmission = Node & {
  __typename: 'KYCQuestionnaireSubmission';
  answers: Maybe<Array<KYCQuestionAnswer>>;
  body: Maybe<KYCQuestionnaireElement>;
  case: Maybe<Case>;
  committedAt: Maybe<Scalars['Time']['output']>;
  conflicts: Maybe<Array<KYCDataConflict>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  draftBody: Maybe<KYCQuestionnaireElement>;
  draftQuestions: Array<KYCQuestionDefinition>;
  expirationDays: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kycProcess: KYCProcess;
  kycQuestionnaire: KYCQuestionnaire;
  /** @deprecated The live body is now always the last-sent snapshot — use questions instead. */
  lastSentQuestionIDs: Maybe<Array<Scalars['String']['output']>>;
  name: Maybe<Scalars['String']['output']>;
  notes: Scalars['String']['output'];
  progress: Maybe<KYCQuestionnaireSubmissionProgress>;
  /** @deprecated Use questions instead. */
  questionIDs: Array<Scalars['String']['output']>;
  questions: Array<KYCQuestionDefinition>;
  representative: Maybe<Representative>;
  sentBy: Maybe<Scalars['String']['output']>;
  state: KYCQuestionnaireSubmissionState;
  submittedAt: Maybe<Scalars['Time']['output']>;
  submittedBy: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type KYCQuestionnaireSubmissionConnection = {
  __typename: 'KYCQuestionnaireSubmissionConnection';
  /** A list of edges. */
  edges: Maybe<Array<KYCQuestionnaireSubmissionEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KYCQuestionnaireSubmissionEdge = {
  __typename: 'KYCQuestionnaireSubmissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<KYCQuestionnaireSubmission>;
};

/** Ordering options for KYCQuestionnaireSubmission connections */
export type KYCQuestionnaireSubmissionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KYCQuestionnaireSubmissions. */
  field: KYCQuestionnaireSubmissionOrderField;
};

/** Properties by which KYCQuestionnaireSubmission connections can be ordered. */
export enum KYCQuestionnaireSubmissionOrderField {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  STATE = 'STATE'
}

/** KYCQuestionnaireSubmissionProgress is for the KYCQuestionnaireSubmissionProgress entity. */
export type KYCQuestionnaireSubmissionProgress = {
  __typename: 'KYCQuestionnaireSubmissionProgress';
  /** actionStatus is the status of the submission action */
  actionStatus: Maybe<Array<KYCActionStatus>>;
  /** currentNavElementID is the current nav element id that is being filled in the questionnaire */
  currentNavElementID: Maybe<Scalars['String']['output']>;
  /** navStatus is the status (if all questions are answered) of the nav elements in the questionnaire */
  navStatus: Maybe<Array<KYCQuestionnaireNavStatus>>;
  /** percentage is the percentage of required questions answered in the questionnaire */
  percentage: Maybe<Scalars['String']['output']>;
  /** validationErrors are the current validation errors on the questionnaire */
  validationErrors: Maybe<Array<KYCQuestionnaireValidationError>>;
};

/** KYCQuestionnaireSubmissionQuestionNoteInput pairs a question ID with a note. */
export type KYCQuestionnaireSubmissionQuestionNoteInput = {
  note: Scalars['String']['input'];
  questionID: Scalars['ID']['input'];
};

/** KYCQuestionnaireSubmissionSelectedQuestionInput pairs a question ID with an optional note. */
export type KYCQuestionnaireSubmissionSelectedQuestionInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  questionID: Scalars['ID']['input'];
};

/** KYCQuestionnaireSubmissionState is enum for the field state */
export enum KYCQuestionnaireSubmissionState {
  /** CANCELED is the state when the submission is canceled */
  CANCELED = 'CANCELED',
  /** COMPLETED is the state when the submission is completed */
  COMPLETED = 'COMPLETED',
  /** EXPIRED is the state when the submission is expired */
  EXPIRED = 'EXPIRED',
  /** INIT is the initial state of the submission */
  INIT = 'INIT',
  /** IN_PROGRESS is the state when the submission is in progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** IN_REVIEW is the state when the submission is in review */
  IN_REVIEW = 'IN_REVIEW',
  /** SENT is the state when the email link has been dispatched but the recipient has not yet started answering */
  SENT = 'SENT'
}

/**
 * KYCQuestionnaireSubmissionWhereInput is used for filtering KYCQuestionnaireSubmission objects.
 * Input was generated by ent.
 */
export type KYCQuestionnaireSubmissionWhereInput = {
  and?: InputMaybe<Array<KYCQuestionnaireSubmissionWhereInput>>;
  /** case_id field predicates */
  caseID?: InputMaybe<Scalars['String']['input']>;
  caseIDContains?: InputMaybe<Scalars['String']['input']>;
  caseIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  caseIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  caseIDGT?: InputMaybe<Scalars['String']['input']>;
  caseIDGTE?: InputMaybe<Scalars['String']['input']>;
  caseIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  caseIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  caseIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  caseIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  caseIDLT?: InputMaybe<Scalars['String']['input']>;
  caseIDLTE?: InputMaybe<Scalars['String']['input']>;
  caseIDNEQ?: InputMaybe<Scalars['String']['input']>;
  caseIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  caseIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** kyc_process edge predicates */
  hasKycProcess?: InputMaybe<Scalars['Boolean']['input']>;
  hasKycProcessWith?: InputMaybe<Array<KYCProcessWhereInput>>;
  /** kyc_questionnaire edge predicates */
  hasKycQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  hasKycQuestionnaireWith?: InputMaybe<Array<KYCQuestionnaireWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kyc_process_id field predicates */
  kycProcessID?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDContains?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDGT?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDGTE?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  kycProcessIDLT?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDLTE?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  kycProcessIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kyc_questionnaire_id field predicates */
  kycQuestionnaireID?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDContains?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDContainsFold?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDEqualFold?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDGT?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDGTE?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDHasPrefix?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDHasSuffix?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  kycQuestionnaireIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kycQuestionnaireIDLT?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDLTE?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  kycQuestionnaireIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  kycQuestionnaireIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<KYCQuestionnaireSubmissionWhereInput>;
  or?: InputMaybe<Array<KYCQuestionnaireSubmissionWhereInput>>;
  /** sent_by field predicates */
  sentBy?: InputMaybe<Scalars['String']['input']>;
  sentByContains?: InputMaybe<Scalars['String']['input']>;
  sentByContainsFold?: InputMaybe<Scalars['String']['input']>;
  sentByEqualFold?: InputMaybe<Scalars['String']['input']>;
  sentByGT?: InputMaybe<Scalars['String']['input']>;
  sentByGTE?: InputMaybe<Scalars['String']['input']>;
  sentByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sentByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sentByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sentByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sentByLT?: InputMaybe<Scalars['String']['input']>;
  sentByLTE?: InputMaybe<Scalars['String']['input']>;
  sentByNEQ?: InputMaybe<Scalars['String']['input']>;
  sentByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sentByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state field predicates */
  state?: InputMaybe<KYCQuestionnaireSubmissionState>;
  stateIn?: InputMaybe<Array<KYCQuestionnaireSubmissionState>>;
  stateNEQ?: InputMaybe<KYCQuestionnaireSubmissionState>;
  stateNotIn?: InputMaybe<Array<KYCQuestionnaireSubmissionState>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** KYCQuestionnaireType is enum for the field questionnaire_type */
export enum KYCQuestionnaireType {
  /** KYC questionnaire type where the customer is being onboarded. */
  KYC_ONBOARDING = 'KYC_ONBOARDING',
  /** KYC questionnaire type for Quality control for the KYC process. */
  KYC_QC = 'KYC_QC',
  /** KYC questionnaire type where the customer's information is under review. */
  KYC_REVIEW = 'KYC_REVIEW',
  /** KYC questionnaire type for Request For Information (RFI) flows. */
  KYC_RFI = 'KYC_RFI',
  /** KYC questionnaire type related to the terms for Registered Investment Advisor (RIA). */
  RIA_TERMS = 'RIA_TERMS',
  /** Default value when the KYC questionnaire type is not specified. */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** KYCQuestionnaireValidationError is for the KYCQuestionnaireValidationError entity */
export type KYCQuestionnaireValidationError = {
  __typename: 'KYCQuestionnaireValidationError';
  /** The index of the rule that failed in the question's rules list */
  failingRuleIndex: Maybe<Scalars['Int']['output']>;
  /** groupAnswerIndex is the index of group answer for which the specific error occurred in */
  groupAnswerIndex: Maybe<Scalars['Int']['output']>;
  /** message is the error message */
  message: Scalars['String']['output'];
  /** navElementID is the nav element id associated to the question that has the error */
  navElementID: Scalars['String']['output'];
  /** parentGroupQuestionID is the ID of the parent question (if exists) error occurred in */
  parentGroupQuestionID: Maybe<Scalars['String']['output']>;
  /** questionID is the ID of the question that has the error */
  questionID: Scalars['String']['output'];
  /** questionType is the type of the question the error occurred in */
  questionType: KYCQuestionType;
  /** questionValidationLevel is the level of validation for the question, meaning that depending on save action we might want to consider this error or not */
  questionValidationLevel: Scalars['Int']['output'];
};

/**
 * KYCQuestionnaireWhereInput is used for filtering KYCQuestionnaire objects.
 * Input was generated by ent.
 */
export type KYCQuestionnaireWhereInput = {
  and?: InputMaybe<Array<KYCQuestionnaireWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<KYCQuestionnaireWhereInput>;
  or?: InputMaybe<Array<KYCQuestionnaireWhereInput>>;
  /** questionnaire_type field predicates */
  questionnaireType?: InputMaybe<KYCQuestionnaireType>;
  questionnaireTypeIn?: InputMaybe<Array<KYCQuestionnaireType>>;
  questionnaireTypeNEQ?: InputMaybe<KYCQuestionnaireType>;
  questionnaireTypeNotIn?: InputMaybe<Array<KYCQuestionnaireType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** KYCRelatedParty represents a related party */
export type KYCRelatedParty = {
  __typename: 'KYCRelatedParty';
  /** The related party country code */
  countryCode: Maybe<Scalars['String']['output']>;
  /** The related party id */
  id: Scalars['ID']['output'];
  /** The related party name */
  name: Scalars['String']['output'];
  /** Relationships of this related party with the provided affiliate. */
  relationships: Maybe<Array<KYCRelatedPartyRelationship>>;
};

/** KYCRelatedPartyConnection represents a list of KYCRelatedParty edges. */
export type KYCRelatedPartyConnection = {
  __typename: 'KYCRelatedPartyConnection';
  /** A list of edges. */
  edges: Maybe<Array<KYCRelatedPartyEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KYCRelatedPartyEdge = {
  __typename: 'KYCRelatedPartyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<KYCRelatedParty>;
};

/** KYCRelatedPartyRelationship specifies the relationship between a related party and an affiliate */
export type KYCRelatedPartyRelationship = {
  __typename: 'KYCRelatedPartyRelationship';
  /** The related party relationship affiliate id */
  affiliateID: Scalars['ID']['output'];
  /** Kyc roles of this related party with the provided affiliate. */
  kycRoles: Maybe<Array<IndividualAffiliateRelationship>>;
  /**
   * The percentage of the affiliate that the individual owns. Only relevant for
   * beneficial owners.
   */
  ownershipPercentage: Maybe<Scalars['String']['output']>;
  /** Role of an individual in the affiliate (such as CEO, COO, etc). */
  role: Maybe<Scalars['String']['output']>;
};

/** KYCRelatedPartyWhereInput specifies filtering options for KYCRelatedPartyConnection. */
export type KYCRelatedPartyWhereInput = {
  /** affiliateIDs field predicates */
  affiliateIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** clientID field predicates */
  clientID?: InputMaybe<Scalars['String']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * KYCRoleType describes the role type relationship between individuals and affiliates/organizations.
 * Aligns with the denali package kycprofiles.KYCRoleType.
 */
export enum KYCRoleType {
  /** AML_SERVICE_PROVIDER represents an AML Service Provider relation between individual and affiliate */
  AML_SERVICE_PROVIDER = 'AML_SERVICE_PROVIDER',
  /** AUTHORIZED_SIGNATORY represents an authorized signatory relation between individual and affiliate */
  AUTHORIZED_SIGNATORY = 'AUTHORIZED_SIGNATORY',
  /** BENEFICIAL_OWNER represents a Beneficial Owner relation between individual and affiliate */
  BENEFICIAL_OWNER = 'BENEFICIAL_OWNER',
  /** BENEFICIARY represents a Beneficiary relation between individual and affiliate */
  BENEFICIARY = 'BENEFICIARY',
  /** BOARD_DIRECTOR represents a Board Director relation between individual and affiliate */
  BOARD_DIRECTOR = 'BOARD_DIRECTOR',
  /** CONTROL_PERSON represents a Control Person relation between individual and affiliate */
  CONTROL_PERSON = 'CONTROL_PERSON',
  /** DONOR represents a Donor relation between individual and affiliate */
  DONOR = 'DONOR',
  /** FEEDER_FUND represents a Feeder fund relation between individual and affiliate */
  FEEDER_FUND = 'FEEDER_FUND',
  /** FUND_ADMINISTRATOR represents a Fund Administrator relation between individual and affiliate */
  FUND_ADMINISTRATOR = 'FUND_ADMINISTRATOR',
  /** GENERAL_PARTNER represents a General Partner relation between individual and affiliate */
  GENERAL_PARTNER = 'GENERAL_PARTNER',
  /** GRANTOR represents a Grantor/Settlor relation between individual and affiliate */
  GRANTOR = 'GRANTOR',
  /** GRANTOR_DONOR represents a Grantor/Donor/Settlor relation between individual and affiliate */
  GRANTOR_DONOR = 'GRANTOR_DONOR',
  /** GUARANTOR represents a Guarantor relation between individual and affiliate */
  GUARANTOR = 'GUARANTOR',
  /** INVESTMENT_MANAGER represents a Investment Manager between individual and affiliate */
  INVESTMENT_MANAGER = 'INVESTMENT_MANAGER',
  /** MANAGING_MEMBER represents a Managing Member relation between individual and affiliate */
  MANAGING_MEMBER = 'MANAGING_MEMBER',
  /** OTHER represents another relation between individual and affiliate */
  OTHER = 'OTHER',
  /** PARENT_ENTITY represents a Parent entity relation between individual and affiliate */
  PARENT_ENTITY = 'PARENT_ENTITY',
  /** PARTICIPATING_MEMBER represents an Authorized User relation between individual and affiliate */
  PARTICIPATING_MEMBER = 'PARTICIPATING_MEMBER',
  /** SENIOR_OFFICER represents a Senior Officer relation between individual and affiliate */
  SENIOR_OFFICER = 'SENIOR_OFFICER',
  /** TRUSTEE_SUCCESSOR_TRUSTEE represents a Trustee/Success Trustee relation between individual and affiliate */
  TRUSTEE_SUCCESSOR_TRUSTEE = 'TRUSTEE_SUCCESSOR_TRUSTEE',
  /** TRUST_PROTECTOR represents a Trust protector relation between individual and affiliate */
  TRUST_PROTECTOR = 'TRUST_PROTECTOR'
}

/** KYCScreening specifies properties related with KYC Information Screening */
export type KYCScreening = {
  __typename: 'KYCScreening';
  /** specify if should force to push changes to the screening process */
  forceScreening: Scalars['Boolean']['output'];
  /** specify what is the reason for pusing changes to the screening process */
  screeningReason: Scalars['String']['output'];
};

/** KYCScreeningInput specifies properties related with KYC Information Screening */
export type KYCScreeningInput = {
  /** specify if should force to push changes to the screening process */
  forceScreening: Scalars['Boolean']['input'];
  /** specify what is the reason for pusing changes to the screening process */
  screeningReason: Scalars['String']['input'];
};

/** KYCScreeningRequest represents a KYC screening request entity */
export type KYCScreeningRequest = Node & {
  __typename: 'KYCScreeningRequest';
  awaitEntities: Maybe<Scalars['Boolean']['output']>;
  bypassDuplicateCheck: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  hash: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  journeyAppToken: Maybe<Scalars['String']['output']>;
  journeyToken: Maybe<Scalars['String']['output']>;
  kycEntityID: Scalars['String']['output'];
  kycEntityType: KYCScreeningRequestKycEntityType;
  message: Maybe<Scalars['String']['output']>;
  relatedRequestID: Maybe<Scalars['String']['output']>;
  screeningProvider: KYCScreeningRequestScreeningProvider;
  state: KYCScreeningRequestState;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of KYCScreeningRequest items. */
export type KYCScreeningRequestConnection = {
  __typename: 'KYCScreeningRequestConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<KYCScreeningRequestEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a KYCScreeningRequest connection. */
export type KYCScreeningRequestEdge = {
  __typename: 'KYCScreeningRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<KYCScreeningRequest>;
};

/** KYCScreeningRequestKycEntityType enum represents the entity type being screened */
export enum KYCScreeningRequestKycEntityType {
  AFFILIATE = 'AFFILIATE',
  INDIVIDUAL = 'INDIVIDUAL',
  RELATED_PARTY_INDIVIDUAL = 'RELATED_PARTY_INDIVIDUAL',
  RELATED_PARTY_INSTITUTION = 'RELATED_PARTY_INSTITUTION',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** Ordering options for KYCScreeningRequest connections */
export type KYCScreeningRequestOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KYCScreeningRequests. */
  field: KYCScreeningRequestOrderField;
};

/** Properties by which KYCScreeningRequest connections can be ordered. */
export enum KYCScreeningRequestOrderField {
  CREATED_AT = 'CREATED_AT',
  CREATED_BY = 'CREATED_BY',
  HASH = 'HASH',
  ID = 'ID',
  JOURNEY_APP_TOKEN = 'JOURNEY_APP_TOKEN',
  JOURNEY_TOKEN = 'JOURNEY_TOKEN',
  KYC_ENTITY_ID = 'KYC_ENTITY_ID',
  KYC_ENTITY_TYPE = 'KYC_ENTITY_TYPE',
  RELATED_REQUEST_ID = 'RELATED_REQUEST_ID',
  SCREENING_PROVIDER = 'SCREENING_PROVIDER',
  STATE = 'STATE',
  UPDATED_AT = 'UPDATED_AT',
  UPDATED_BY = 'UPDATED_BY'
}

/** KYCScreeningRequestScreeningProvider enum represents the screening provider */
export enum KYCScreeningRequestScreeningProvider {
  ALLOY = 'ALLOY',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** KYCScreeningRequestState enum represents the state of a screening request */
export enum KYCScreeningRequestState {
  COMPLETED = 'COMPLETED',
  DISCARDED = 'DISCARDED',
  IN_ERROR = 'IN_ERROR',
  PROCESSING = 'PROCESSING',
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  TERMINAL = 'TERMINAL',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** KYCScreeningRequestWhereInput is used for filtering KYCScreeningRequest objects. */
export type KYCScreeningRequestWhereInput = {
  and?: InputMaybe<Array<KYCScreeningRequestWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** hash field predicates */
  hash?: InputMaybe<Scalars['String']['input']>;
  hashContains?: InputMaybe<Scalars['String']['input']>;
  hashContainsFold?: InputMaybe<Scalars['String']['input']>;
  hashEqualFold?: InputMaybe<Scalars['String']['input']>;
  hashGT?: InputMaybe<Scalars['String']['input']>;
  hashGTE?: InputMaybe<Scalars['String']['input']>;
  hashHasPrefix?: InputMaybe<Scalars['String']['input']>;
  hashHasSuffix?: InputMaybe<Scalars['String']['input']>;
  hashIn?: InputMaybe<Array<Scalars['String']['input']>>;
  hashIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  hashLT?: InputMaybe<Scalars['String']['input']>;
  hashLTE?: InputMaybe<Scalars['String']['input']>;
  hashNEQ?: InputMaybe<Scalars['String']['input']>;
  hashNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  hashNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** journey_app_token field predicates */
  journeyAppToken?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenContains?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenGT?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenGTE?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  journeyAppTokenIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  journeyAppTokenLT?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenLTE?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  journeyAppTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  journeyAppTokenNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** journey_token field predicates */
  journeyToken?: InputMaybe<Scalars['String']['input']>;
  journeyTokenContains?: InputMaybe<Scalars['String']['input']>;
  journeyTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  journeyTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  journeyTokenGT?: InputMaybe<Scalars['String']['input']>;
  journeyTokenGTE?: InputMaybe<Scalars['String']['input']>;
  journeyTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  journeyTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  journeyTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  journeyTokenIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  journeyTokenLT?: InputMaybe<Scalars['String']['input']>;
  journeyTokenLTE?: InputMaybe<Scalars['String']['input']>;
  journeyTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  journeyTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  journeyTokenNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** kyc_entity_id field predicates */
  kycEntityID?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDContains?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDGT?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDGTE?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  kycEntityIDLT?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDLTE?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDNEQ?: InputMaybe<Scalars['String']['input']>;
  kycEntityIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** kyc_entity_type field predicates */
  kycEntityType?: InputMaybe<KYCScreeningRequestKycEntityType>;
  kycEntityTypeIn?: InputMaybe<Array<KYCScreeningRequestKycEntityType>>;
  kycEntityTypeNEQ?: InputMaybe<KYCScreeningRequestKycEntityType>;
  kycEntityTypeNotIn?: InputMaybe<Array<KYCScreeningRequestKycEntityType>>;
  not?: InputMaybe<KYCScreeningRequestWhereInput>;
  or?: InputMaybe<Array<KYCScreeningRequestWhereInput>>;
  /** related_request_id field predicates */
  relatedRequestID?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDContains?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDGT?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDGTE?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedRequestIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  relatedRequestIDLT?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDLTE?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDNEQ?: InputMaybe<Scalars['String']['input']>;
  relatedRequestIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedRequestIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** screening_provider field predicates */
  screeningProvider?: InputMaybe<KYCScreeningRequestScreeningProvider>;
  screeningProviderIn?: InputMaybe<Array<KYCScreeningRequestScreeningProvider>>;
  screeningProviderNEQ?: InputMaybe<KYCScreeningRequestScreeningProvider>;
  screeningProviderNotIn?: InputMaybe<Array<KYCScreeningRequestScreeningProvider>>;
  /** state field predicates */
  state?: InputMaybe<KYCScreeningRequestState>;
  stateIn?: InputMaybe<Array<KYCScreeningRequestState>>;
  stateNEQ?: InputMaybe<KYCScreeningRequestState>;
  stateNotIn?: InputMaybe<Array<KYCScreeningRequestState>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** KYC profile status values */
export enum KYCStatus {
  /** Profile review is complete */
  COMPLETE = 'COMPLETE',
  /** Profile is in draft state */
  DRAFT = 'DRAFT',
  /** Information collection is in progress but not submitted */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Profile is currently under review */
  IN_REVIEW = 'IN_REVIEW',
  /** Profile has been submitted and is pending review */
  PENDING = 'PENDING',
  /** Profile is ready to onboard */
  READY = 'READY'
}

/** KYCSubmissionAction is enum for the field questionnaire submission action */
export enum KYCSubmissionAction {
  /** Commit validate kyc submission data and propagate to source of truth */
  COMMIT = 'COMMIT',
  /** Draft saves the submission data ignoring validations */
  DRAFT = 'DRAFT',
  /** Submit validates and saves all submission data into source of truth */
  SUBMIT = 'SUBMIT'
}

/** KYCType specifies different entity types of KYC Information */
export enum KYCType {
  /** AFFILIATE */
  AFFILIATE = 'AFFILIATE',
  /** CLIENT */
  CLIENT = 'CLIENT',
  /** INDIVIDUAL */
  INDIVIDUAL = 'INDIVIDUAL'
}

/**
 * Key is a interface that shall be implemented by all types that derive/augment
 * keys.
 */
export type Key = {
  /** Unique identifier of this key pair, usually it's the public key ID. */
  id: Scalars['ID']['output'];
  /** Key information. */
  keyInfo: KeyInfo;
};

/** Represents the access details for a specific key within a policy. */
export type KeyAccess = {
  __typename: 'KeyAccess';
  /** The access level granted to the key within the policy. */
  accessLevel: IAMAccessLevel;
  /** The key associated with this access entry. */
  key: Key;
};

/** A connection to a list of KeyAccess edges, with pagination information. */
export type KeyAccessConnection = {
  __typename: 'KeyAccessConnection';
  /** A list of edges containing KeyAccess nodes. */
  edges: Array<KeyAccessEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of KeyAccess nodes in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type KeyAccessDeltaInput = {
  add: Array<InputKeyAccess>;
  remove: Array<Scalars['ID']['input']>;
  update: Array<InputKeyAccess>;
};

/** An edge in a connection that contains a KeyAccess node and a cursor for pagination. */
export type KeyAccessEdge = {
  __typename: 'KeyAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The KeyAccess node at the end of the edge. */
  node: KeyAccess;
};

/** A filter to be used against the key accesses returned by `PolicyV2.keyAccesses`. */
export type KeyAccessWhereInput = {
  /**
   * Restrict results to the given user key IDs. Omit or pass an empty list to
   * return all key accesses.
   */
  userKeyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Information about an asymmetric key algorithm. */
export type KeyAlgorithm = {
  __typename: 'KeyAlgorithm';
  /**
   * DON'T USE THIS FIELD. This field is deprecated and will be removed in the
   * future. Use digestibleName instead.
   * @deprecated Use digestibleName instead.
   */
  digestableName: Scalars['String']['output'];
  /**
   * An opaque representation of the algorithm's name. Clients shall
   * not make any assumptions about the value of this field. This field
   * shall be used whenever a digest needs to be computed and the algorithm
   * of a key needs to be included (e.g., Keys that are added to
   * organization structures). If this field is null, the key's algorithm should
   * not be taken into account when computing digests.
   */
  digestibleName: Maybe<Scalars['String']['output']>;
  /** A description of the algorithm in a form suitable for displaying in UIs. */
  displayDescription: Scalars['String']['output'];
  /** The name of the algorithm in a form suitable for displaying in UIs. */
  displayName: Scalars['String']['output'];
};

/** A connection to a list of keys. */
export type KeyConnection = {
  __typename: 'KeyConnection';
  /** A list of edges. */
  edges: Array<KeyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** KeyData contains all publically available information of an asymmetric key pair. */
export type KeyData = {
  __typename: 'KeyData';
  /** Details about the cryptographic algorithm used to create this key. */
  algorithm: KeyAlgorithm;
  /**
   * String representation of the public key of this key pair. The specific format
   * used depends on the algorithm. Most of the time this field should be treated by
   * clients as an opaque string.
   */
  publicKey: Scalars['String']['output'];
};

/** An edge in a connection. */
export type KeyEdge = {
  __typename: 'KeyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Key;
};

/** Key represents information about a cryptographic key/key pair. */
export type KeyInfo = Node & {
  __typename: 'KeyInfo';
  /** Timestamp of when this key was added to our system. */
  addedAt: Scalars['Timestamp']['output'];
  /** Optional user-provided description of this key pair. */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Optional master control key encrypted to the encryptionKey.
   * See spec: Porto: Control key + key export features.
   */
  encryptedControlMasterPrivateKey: Maybe<Scalars['String']['output']>;
  /**
   * Optional key for receiving encrypted data such as wallet key backups.
   * See spec: Porto: Control key + key export features.
   */
  encryptionKey: Maybe<KeyData>;
  /** Unique identifier of this key pair, usually it's the public key ID. */
  id: Scalars['ID']['output'];
  /**
   * If this field is null the key can be deleted/removed/revoked.
   * Otherwise, it contains the human readable reason for why it can't be.
   */
  irremovabilityReason: Maybe<Scalars['String']['output']>;
  /**
   * Indicates if the key has been used recently or not. Note that this value
   * might be computed and not reflect exact real-time status.
   */
  isActive: Scalars['Boolean']['output'];
  /**
   * True if the key was marked as lost by Anchorage. Marking a key as lost is
   * not an irreversible operation and it can be unmarked by Anchorage.
   */
  isMarkedLost: Scalars['Boolean']['output'];
  /** Public key details. */
  key: KeyData;
  /**
   * Timestamp of when this key was last used. Might be null if this key was not used
   * yet.
   */
  lastUsedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Name of this key pair. This name might be cryptographically protected. */
  name: Scalars['String']['output'];
  /** User that owns this key. */
  owner: UserV2;
  /** Purpose of this key. */
  purpose: KeyPurpose;
  /** Indicates the last known status of this key. */
  status: KeyStatus;
};

/** KeyPurpose represents the purpose of a key. */
export enum KeyPurpose {
  /** The key is meant to be used programmatically. */
  API = 'API',
  /** The key is meant to be used by a person. */
  USER = 'USER'
}

/** KeyStatus represents the status of a key. */
export enum KeyStatus {
  /** The key will become active after some required action and cannot yet be used. */
  PENDING = 'PENDING',
  /** The key was revoked/removed and cannot be used anymore. */
  REVOKED = 'REVOKED',
  /** The key is ready to be used but hasn't been used yet. */
  UNUSED = 'UNUSED',
  /** The key has been used already. */
  USED = 'USED'
}

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Filtering options for Keys returned from the connection. */
export type KeyWhereInput = {
  /** Filter by key IDs. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Currently known affiliate information */
export type KnownAffiliateInformation = {
  __typename: 'KnownAffiliateInformation';
  /**
   * Address from where the content may be loaded.
   * Only present on blob types
   */
  contentURL: Maybe<Scalars['String']['output']>;
  /** Group information */
  groupInformation: Maybe<Array<Array<KnownAffiliateInformation>>>;
  /** The type of information */
  informationType: Scalars['String']['output'];
  /** The kyc screening audit related information */
  kycScreening: Maybe<KYCScreening>;
  /** The notes associated to a given audit trail entry */
  notes: Maybe<Scalars['String']['output']>;
  /** The timestamp when the change was made */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The user that made the change associated to the audit trail info */
  updatedBy: Maybe<Scalars['String']['output']>;
  /** The value of the information */
  value: Scalars['String']['output'];
  /** The lifecyle stage of the value */
  valueLifecycle: InstitutionalValueLifecycle;
};

/** Currently known individual information */
export type KnownInformation = {
  __typename: 'KnownInformation';
  /**
   * Address from where the content may be loaded.
   * Only present on blob types
   */
  contentURL: Maybe<Scalars['String']['output']>;
  /** The type of information */
  informationType: IndividualInformationType;
  /** The kyc screening audit related information */
  kycScreening: Maybe<KYCScreening>;
  /** The notes associated to a given audit trail entry */
  notes: Maybe<Scalars['String']['output']>;
  /** The timestamp when the change was made */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The user that made the change associated to the audit trail info */
  updatedBy: Maybe<Scalars['String']['output']>;
  /**
   * The value of the information
   * WARNING: This is all redacted when querying from the app or client dashboard.
   */
  value: Scalars['String']['output'];
  /** The lifecyle stage of the value */
  valueLifecycle: InstitutionalValueLifecycle;
};

/** A legal term contains a list of acceptances. */
export type LegalTermAcceptance = {
  __typename: 'LegalTermAcceptance';
  /**
   * acceptedAt is the seconds unix timestamp at which the acceptance was received
   * by the backend. It is null if not accepted
   */
  acceptedAt: Maybe<Scalars['Time']['output']>;
  /**
   * If legalterm.involvesAccount == false => accountID is null
   * If legalterm.involvesAccount == true => accountID contains a value and
   * there is a LegalTermAcceptance for each account
   */
  accountID: Maybe<Scalars['String']['output']>;
  /**
   * The human readable name of the account. Useful for showing the user which
   * account they are accepting in relation to.
   *
   * This field exists if accountID exists (which only exists if InvolvesAccount is
   * true).
   */
  accountName: Maybe<Scalars['String']['output']>;
};

/** Connection type for paginated legal term acceptances */
export type LegalTermAcceptanceConnection = {
  __typename: 'LegalTermAcceptanceConnection';
  /** A list of edges. */
  edges: Array<LegalTermAcceptanceEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a legal term acceptance connection. */
export type LegalTermAcceptanceEdge = {
  __typename: 'LegalTermAcceptanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: LegalTermAcceptance;
};

/** Connection type for paginated legal terms */
export type LegalTermConnection = {
  __typename: 'LegalTermConnection';
  /** A list of edges. */
  edges: Array<LegalTermEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a legal term connection. */
export type LegalTermEdge = {
  __typename: 'LegalTermEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Legalterm;
};

/**
 * Represents a legalterm document with the newly added fields such as
 * internalVersion, category, entity and assetType.
 * Used in new endpoints (like getAllLatestLegalterm) while older ones use
 * Disclosure for backward compatibility
 */
export type Legalterm = {
  __typename: 'Legalterm';
  acceptances: Array<Maybe<LegalTermAcceptance>>;
  acceptancesV2: Array<Maybe<LegalTermAcceptance>>;
  anchorageEntity: Maybe<Scalars['String']['output']>;
  assetTypeID: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  custom: Maybe<Scalars['String']['output']>;
  feature: Maybe<Scalars['String']['output']>;
  internalVersion: Scalars['Int']['output'];
  involvesAccount: Scalars['Boolean']['output'];
  legaltermsID: Scalars['String']['output'];
  legaltermsVersion: Scalars['Int']['output'];
  staticContent: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/**
 * The mandatory fields of a LexisNexis alert-update payload, mirroring the JSON
 * body LexisNexis posts to the production update webhook.
 */
export type LexisNexisUpdateInput = {
  eventType: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
  state: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export enum LifecycleEventType {
  ACTIVE = 'ACTIVE',
  AMENDMENT = 'AMENDMENT',
  CANCELLATION = 'CANCELLATION',
  COMPRESSION = 'COMPRESSION',
  CONFIRMED = 'CONFIRMED',
  CONFIRM_SENT = 'CONFIRM_SENT',
  EXERCISE = 'EXERCISE',
  EXPIRE = 'EXPIRE',
  FORCEFULLY_TERMINATED = 'FORCEFULLY_TERMINATED',
  FULL_CLOSEOUT = 'FULL_CLOSEOUT',
  MATURE = 'MATURE',
  NOVATION = 'NOVATION',
  PARTIAL_CLOSEOUT = 'PARTIAL_CLOSEOUT',
  REPORTED = 'REPORTED',
  REVERT_AMENDMENT = 'REVERT_AMENDMENT',
  REVERT_CANCELLATION = 'REVERT_CANCELLATION',
  REVERT_EXERCISE = 'REVERT_EXERCISE',
  REVERT_EXPIRE = 'REVERT_EXPIRE',
  REVERT_FORCED_TERMINATION = 'REVERT_FORCED_TERMINATION',
  REVERT_FULL_CLOSEOUT = 'REVERT_FULL_CLOSEOUT',
  REVERT_MATURE = 'REVERT_MATURE',
  REVERT_PARTIAL_CLOSEOUT = 'REVERT_PARTIAL_CLOSEOUT',
  REVERT_SEVERE_AMENDMENT = 'REVERT_SEVERE_AMENDMENT',
  SETTLED = 'SETTLED',
  SEVERE_AMENDMENT = 'SEVERE_AMENDMENT',
  STAGED = 'STAGED',
  VOIDED = 'VOIDED'
}

export type LiftRestrictionsInput = {
  reason: RestrictionLiftReason;
  /** 1 to 500 targets, none twice. */
  targets: Array<RestrictionTargetInput>;
};

/** LiquidityVenue represents a venue where liquidity can be obtained for trading */
export type LiquidityVenue = {
  __typename: 'LiquidityVenue';
  /** displayName is the user facing identifier for a liquidity venue(e.g. Coinbase Exchange) */
  displayName: Scalars['String']['output'];
  /** name is the model/backend facing identifier for a liquidity venue(e.g. coinbaseexchange) */
  name: Scalars['String']['output'];
};

/** LockOperation represents a Lock operation */
export type LockOperation = Operation & {
  __typename: 'LockOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount is the Amount that is being locked up */
  amount: Amount;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** asset id from with the authorization was made */
  assetID: AssetID;
  /** Further information regarding this asset type associated with this operation */
  assetTypeInfo: AssetTypeInfo;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** canonicalOperationVersion is the version of the canonical authorization that must be used to sign this authorization */
  canonicalOperationVersion: Scalars['Int']['output'];
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** confirmations returns how many confirmations the transaction associated with this authorization has received */
  confirmations: Maybe<Scalars['Int']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * extraParams are additional asset type specific parameters that were set for this transaction
   * When constructing the canonical operation for signing, the extra params go in the ExtraParams field
   * as a map from asset type id (usually, parent asset type id) to params object. The convention of extra
   * params is to omit all empty fields, and if no extra params are set for an asset type, to omit the asset
   * type from the map entirely. Note that for legacy reasons this convention
   * is the opposite of the normal CanonicalOperation convention, where no fields are ever omitted.
   */
  extraParams: Maybe<ExtraParams>;
  /** final transaction fee charged for the authorization, detected on the blockchain */
  finalFee: Maybe<Amount>;
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** max transaction fee charged for the authorization */
  maxFee: Maybe<Amount>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /**
   * replayProtectionParams are the parameters to be sent to the HSM for creating and signing
   * the transactions required to effect this ExecuteOperation. The user *is not* expected
   * to review the contents of this field. However it may contain information necessary to prevent
   * replays and must be included in the payload signed by the user. Format is a hex-encoded
   * byte array.
   */
  replayProtectionParams: Maybe<Scalars['String']['output']>;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** sendingBlockchainAddresses is a list of addresses from which a lock operation is sent */
  sendingBlockchainAddresses: Array<BlockchainAddress>;
  /** signedTransaction is the blockchain transaction to be broadcast to the network */
  signedTransaction: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /**
   * sources are the originating addresses for the authorization
   * @deprecated use sendingBlockchainAddresses
   */
  sources: Array<Source>;
  /** transactionID is the blockchain transaction id once available */
  transactionID: Maybe<Scalars['String']['output']>;
  /** transactionSuccess indicates if the blockchain transaction succeeded */
  transactionSuccess: Maybe<Scalars['Boolean']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * usdValueFee is the USD value of the fee (finalFee if known, otherwise maxFee).
   * If both the finalFee and maxFee are not yet known, this field will be null
   */
  usdValueFee: Maybe<Scalars['String']['output']>;
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
};


/** LockOperation represents a Lock operation */
export type LockOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** LockOperation represents a Lock operation */
export type LockOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** Login information */
export type Login = {
  __typename: 'Login';
  /** loginMetadata contains data about this login */
  loginMetadata: Maybe<LoginMetadata>;
};

/** LoginMetadata contains all of the metadata gathered about this login */
export type LoginMetadata = {
  __typename: 'LoginMetadata';
  /** altitude is the altitude measured by the device */
  altitude: Scalars['String']['output'];
  /** App version running on the device */
  appVersion: Scalars['String']['output'];
  /** level of the battery in percentage */
  batteryLevel: Scalars['String']['output'];
  /** biometricFingerprint is a hash of the the biometrics data on the device */
  biometricFingerprint: Scalars['String']['output'];
  /** biometricType is the type of biometics used to authenticate to the secure enclave on the device */
  biometricType: Scalars['String']['output'];
  /** bluetooth information */
  bluetooth: Bluetooth;
  /** Carrier information */
  carrier: Carrier;
  /** createdAt is the time at which the data was gathered */
  createdAt: Scalars['Timestamp']['output'];
  /** deviceInfo is the name of the device */
  deviceInfo: Scalars['String']['output'];
  /** Device type */
  deviceType: Scalars['String']['output'];
  /** IP address from which the login was made (can be empty string for old logins) */
  ipAddress: Scalars['String']['output'];
  /** latitude is the latitude from GPS */
  latitude: Scalars['String']['output'];
  /** longitude is the longitude from GPS */
  longitude: Scalars['String']['output'];
  /** Model of the device */
  model: Scalars['String']['output'];
  /** list of network interfaces active */
  networkInterfaces: Array<RiskMetadataNetworkInterface>;
  /** information regarding pedometer */
  pedometer: Pedometer;
  /** rawMetadata is the unprocessed data sent from the phone */
  rawMetadata: Scalars['String']['output'];
  /**
   * number of steps. -1 if unknown.
   * @deprecated use pedometer field instead
   */
  steps: Scalars['Int']['output'];
  /** System name in use in the device */
  systemName: Scalars['String']['output'];
  /** System version in use in the device */
  systemVersion: Scalars['String']['output'];
  /** list of wifi names active */
  wifi: Array<Scalars['String']['output']>;
};

/** Lost device report */
export type LostDevice = {
  __typename: 'LostDevice';
  /** When was the loss reported. This is a timestamp with nanosecond precision */
  lostAt: Scalars['String']['output'];
  /** Organization that the device belongs to */
  organization: Organization;
  /** Reporter of the loss */
  reporter: Scalars['String']['output'];
  /** User associated with the lost device */
  user: User;
};

/** Mailing Address */
export type MailingAddress = {
  __typename: 'MailingAddress';
  /** Address line 1 */
  address1: Scalars['String']['output'];
  /** Address line 2 */
  address2: Maybe<Scalars['String']['output']>;
  /** City */
  city: Scalars['String']['output'];
  /** Country */
  country: Scalars['String']['output'];
  /** Province */
  province: Scalars['String']['output'];
  /** Zip Code */
  zipCode: Scalars['String']['output'];
};

/** Extra parameters for maker */
export type MakerExtraParams = {
  __typename: 'MakerExtraParams';
  /** toggle for IOU or MKR authorize spender transaction */
  isAuthorizingIOUToken: Maybe<Scalars['Boolean']['output']>;
  /** for polling: the ID of the option being voted on */
  optionID: Maybe<Scalars['Int']['output']>;
  /** for polling: the ID of the poll being voted on */
  pollID: Maybe<Scalars['Int']['output']>;
  /** what type of vote: EXECUTIVE for votes which affect the blockchain, POLL for votes that don't */
  voteType: Maybe<Scalars['String']['output']>;
};

/**
 * The top-level struct returned by the Maker governance dashboard.
 * DEPRECATED: Maker governance is no longer supported. This type is kept for backward compatibility with old operations and iOS apps.
 */
export type MakerGovernanceBallot = {
  __typename: 'MakerGovernanceBallot';
  /** Whether this ballot is still active */
  active: Scalars['Boolean']['output'];
  /** Timestamp when the ballot finished. Only significant when 'active' is false */
  endedAt: Scalars['String']['output'];
  /** The proposals to vote on in this ballot */
  proposals: Array<MakerGovernanceProposal>;
  /**
   * Timestamp when the ballot was created.
   * @deprecated The date the Ballot was created is not useful information. Use MakerGovernanceProposal.startedAt instead.
   */
  startedAt: Scalars['String']['output'];
  /**
   * Should always be 'Governance: Executive Vote' for the current active ballot. May have
   * different values for past ballots.
   */
  topic: Scalars['String']['output'];
  /** ex: 'Here you can vote to approve a raise to the Dai Credit System's governance fee.' */
  topicBlurb: Scalars['String']['output'];
};

/**
 * MakerGovernanceProposal is a single proposal within a ballot
 * DEPRECATED: Maker governance is no longer supported. This type is kept for backward compatibility with old operations and iOS apps.
 */
export type MakerGovernanceProposal = {
  __typename: 'MakerGovernanceProposal';
  /**
   * This is a big, multi-paragraph markdown string describing both this specific proposal and
   * including information about Maker govenrance voting in general. Might as well just render
   * the whole thing for the client, as does Maker's governance dashboard.
   */
  about: Scalars['String']['output'];
  /** The timestamp at which this was executed. It will be empty if it hasn't been executed. */
  executedAt: Maybe<Scalars['String']['output']>;
  /** ex: 'Vote for this proposal to lower the Stability fee by 2% to a total of 14.5% per year' */
  proposalBlurb: Scalars['String']['output'];
  /**
   * This is the Ethereum address of the proposal (a ds-spell contract), and is what should be
   * submitted in the `voteYeas` array of a Maker vote operation
   */
  source: Scalars['String']['output'];
  /** Timestamp when the proposal was proposed. */
  startedAt: Scalars['String']['output'];
  /** ex: 'Keep the Stability Fee set to a total of 14.5% per year' */
  title: Scalars['String']['output'];
  /** voteStatus is the voting status of the proposal */
  voteStatus: ProposalVoteStatus;
};

/**
 * MakerPoll represents one poll with multiple voting options
 * DEPRECATED: Maker governance is no longer supported. This type is kept for backward compatibility with old operations and iOS apps.
 */
export type MakerPoll = {
  __typename: 'MakerPoll';
  /**
   * This is a big, multi-paragraph markdown string describing both this specific proposal and
   * including information about Maker polling in general. Similar to executive votes, we will
   * render the whole thing for the client.
   */
  about: Scalars['String']['output'];
  /** currentVote represent the current voted option, if user has voted */
  currentVote: Maybe<CurrentVote>;
  /** The timestamp at which voting will end for this poll in UnixNano */
  endTime: Scalars['String']['output'];
  /** Each option has an OptionID and the value it represents */
  options: Array<MakerPollOption>;
  /** The PollID of this poll */
  pollID: Scalars['Int']['output'];
  /** ex: 'Signal your support to adjust the Stability Fee within a range of 1% to 9%' */
  summary: Scalars['String']['output'];
  /** ex: 'Stability Fee Adjustment - November 11, 2019' */
  title: Scalars['String']['output'];
  /**
   * The timestamp at which we most recently pulled information about this poll, since we will
   * have a caching layer for some info.
   */
  updatedAt: Scalars['String']['output'];
};

/**
 * Maker polling-specific details
 * DEPRECATED: Maker governance is no longer supported. This type is kept for backward compatibility with historical operations.
 */
export type MakerPollDetails = {
  __typename: 'MakerPollDetails';
  /** The Maker poll associated with the operation */
  makerPoll: MakerPoll;
};

/** MakerPollOption represents one voting option in a poll */
export type MakerPollOption = {
  __typename: 'MakerPollOption';
  /** This could be a number for a fee percent, yes/no, etc. String is generic enough */
  description: Scalars['String']['output'];
  /** The integer corresponding to the option */
  optionID: Scalars['Int']['output'];
  /** A decimal of the amount of MKR supporting this option */
  supportAmount: Scalars['String']['output'];
};

/**
 * Maker executive voting-specific details
 * DEPRECATED: Maker governance is no longer supported. This type is kept for backward compatibility with historical operations.
 */
export type MakerVoteDetails = {
  __typename: 'MakerVoteDetails';
  /** Returns the Maker governance executive vote ballot active when this operation was created, if one exists. */
  makerBallot: MakerGovernanceBallot;
};

/** Input for managing (creating, increasing, or decreasing) a delegation for a control agreement */
export type ManageDelegationForControlAgreementInput = {
  /** The list of asset adjustments to perform */
  assetAdjustments: Array<ControlAgreementAssetAdjustmentInput>;
  /** The control agreement ID */
  controlAgreementID: Scalars['ID']['input'];
  /**
   * The delegation ID to manage.
   * Identifies which delegation to update.
   */
  delegationID: Scalars['ID']['input'];
  /** Idempotency Key for safe retries */
  idempotencyKey: Scalars['String']['input'];
};

/** Response after managing a delegation for a control agreement */
export type ManageDelegationForControlAgreementResponse = {
  __typename: 'ManageDelegationForControlAgreementResponse';
  /** The idempotency key that was provided in the request */
  idempotencyKey: Scalars['String']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** ManagedAddress, aka BlockchainKeyDerivationParams, contains info that is relevant to addresses managed by Anchorage. */
export type ManagedAddress = {
  __typename: 'ManagedAddress';
  /**
   * AddressID is the combination of org/vault/wallet/address-SubID.
   * It *is* the BlockchainKeyDerivationParams, which is managed by Anchorage.
   */
  addressID: AddressID;
  /** addressSignature is the signature to be verified of the address by the organization key */
  addressSignature: Signature;
  /** The time of creation of this address. This is marked as the time that the address is made visible to the client - this will be null if the address is not marked as used */
  createdAt: Maybe<Scalars['String']['output']>;
  /** The WalletKey associated with this managed address. */
  walletKey: Maybe<WalletKey>;
  /**
   * A list of wallets associated with this managed address.
   * Usually a single wallet, but some addresses, such as vesting contracts may be associated with multiple wallets.
   *
   * TODO:
   *   - was added 3-yr ago: https://github.com/anchorlabsinc/anchorage/pull/14321/files#diff-e19686e2cebf174b6319524481451e5b220d7cfbcbed9aa0ded396a02f95c327
   *   - the implementation always returns only one wallet.
   *   - should we deprecate this, and return "Wallet!" instead?
   */
  wallets: Array<Wallet>;
};

/**
 * ManagedAddressV2 contains information for addresses managed by Anchorage.
 * Supports both signature version 1 (EDDSA-based) and signature version 2 (certificate-based).
 */
export type ManagedAddressV2 = {
  __typename: 'ManagedAddressV2';
  /**
   * addressID is the combination of org/vault/wallet/address-SubID that identifies this address.
   * Available for all signature versions.
   */
  addressID: ManagedAddressV2AddressID;
  /**
   * certChain is the X.509 certificate chain used for signature verification.
   * Each certificate is a DER-encoded byte string (base64-encoded).
   * For signature version 1: Returns empty array (not applicable).
   * For signature version 2: Returns the certificate chain for verifying the signature.
   * @deprecated Use signatureV2.certChain instead
   */
  certChain: Array<Scalars['String']['output']>;
  /**
   * The time of creation of this address. This is marked as the time that the address is made visible to the client.
   * Returns null if the address is not marked as allocated/used.
   * Format: Unix timestamp in nanoseconds as a string.
   * Available for all signature versions.
   */
  createdAt: Maybe<Scalars['String']['output']>;
  /**
   * signature is the organization signature of the address, verifiable by the organization's public key.
   * For signature version 1: Returns the base64-encoded EDDSA signature.
   * For signature version 2: Returns the base64-encoded certificate signature bytes.
   * @deprecated Use signatureV1.signature or signatureV2.signature instead
   */
  signature: Scalars['String']['output'];
  /**
   * signatureV1 contains EDDSA-based signature information.
   * Returns populated object for signature version 1, null for signature version 2.
   */
  signatureV1: Maybe<SignatureV1>;
  /**
   * signatureV2 contains certificate-based signature information.
   * Returns populated object for signature version 2, null for signature version 1.
   */
  signatureV2: Maybe<SignatureV2>;
  /**
   * signedAddressPayload is the raw payload bytes that were signed, encoded as base64.
   * This is the payload from the external signature that the HSM created.
   * For signature version 1: Returns empty string (not applicable).
   * For signature version 2: Returns the base64-encoded signed payload.
   * @deprecated Use signatureV2.signedAddressPayload instead
   */
  signedAddressPayload: Scalars['String']['output'];
  /**
   * The wallet key used for this address. Contains key metadata including path, format, and allocation status.
   * Available for all signature versions.
   */
  walletKey: Maybe<WalletKey>;
  /**
   * List of wallets associated with this address.
   * Usually contains one wallet, but may contain multiple for vesting contracts.
   * Available for all signature versions.
   */
  wallets: Array<Wallet>;
};

/** ManagedAddressV2AddressID uniquely identifies an address Anchorage controls for ManagedAddressV2 */
export type ManagedAddressV2AddressID = {
  __typename: 'ManagedAddressV2AddressID';
  /** addressSubID is the id of the address within the context of this asset */
  addressSubID: Scalars['String']['output'];
  /** assetID is the AssetID this address belongs to */
  assetID: ManagedAddressV2AssetID;
  /**
   * ID uniquely identifies an address managed by Anchorage.
   * ID is a hash derived solely from: org/vault/wallet/address-SubID.
   */
  id: Scalars['ID']['output'];
};

/** ManagedAddressV2AssetID is the ID of an asset within a vault for ManagedAddressV2 */
export type ManagedAddressV2AssetID = {
  __typename: 'ManagedAddressV2AssetID';
  /** assetSubID is used to differentiate between multiple assets of the same type within a vault */
  assetSubID: Scalars['String']['output'];
  /** assetTypeID is the type of asset being held */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** vaultID is the ID of the vault this asset is in */
  vaultID: VaultID;
};

/** ManualTradeRequestParams contains all trade values in format provided during registering manual trade */
export type ManualTradeRequestParams = {
  __typename: 'ManualTradeRequestParams';
  AmountBought: Scalars['String']['output'];
  AmountSold: Scalars['String']['output'];
  AssetBought: Scalars['String']['output'];
  AssetSold: Scalars['String']['output'];
  CreatedAt: Scalars['Timestamp']['output'];
  Fee: Scalars['String']['output'];
  FeeCurrency: Scalars['String']['output'];
  OrganizationKeyID: Scalars['String']['output'];
  Price: Scalars['String']['output'];
  TradeID: Scalars['String']['output'];
  capacity: TradeCapacity;
};

export type MarginCall = {
  action?: InputMaybe<StateAction>;
  curePeriod?: InputMaybe<Scalars['String']['input']>;
  curePeriodProtection?: InputMaybe<Scalars['Boolean']['input']>;
  dailyTimeWindow?: InputMaybe<Array<DailyTimeWindow>>;
  ltv?: InputMaybe<Scalars['String']['input']>;
  returnToLtv?: InputMaybe<Scalars['String']['input']>;
  topUpType?: InputMaybe<Scalars['String']['input']>;
  warningLtv?: InputMaybe<Scalars['String']['input']>;
};

export type MarginReturn = {
  action?: InputMaybe<StateAction>;
  ltv?: InputMaybe<Scalars['String']['input']>;
  returnToLtv?: InputMaybe<Scalars['String']['input']>;
  returnType?: InputMaybe<Scalars['String']['input']>;
};

export type MarkReportFileVerificationAsCanceledInput = {
  /**
   * Full path to file in verification bucket (e.g., _report_type=etf/_cutoff_date=2025-11-19/.../report.csv)
   * This serves as a unique identifier for the verification record.
   */
  fileURL: Scalars['String']['input'];
};

export type MarkReportFileVerificationAsVerifiedInput = {
  /**
   * Full path to file in verification bucket (e.g., _report_type=etf/_cutoff_date=2025-11-19/.../report.csv)
   * This serves as a unique identifier for the verification record.
   */
  fileURL: Scalars['String']['input'];
  /** Reason for overriding the verification checks made by external system, if applicable. */
  overrideReason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Confirms a settlement by attaching the money and closing it in one step. Temporary, alongside
 * dvConfirmSettlement, for a caller not yet using dvSaveSettlementMovements.
 */
export type MarkSettlementSettledInput = {
  /**
   * The custody or venue reference, and the hash for an on-chain movement. Both are supplied by the
   * caller, which reads them off the matched ledger row rather than typing them again
   */
  externalRef?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  movements?: InputMaybe<Array<SettlementMovementInput>>;
  /** Why this closes for more than the money attached to it. Required only in that case */
  reason?: InputMaybe<Scalars['String']['input']>;
  settlementId: Scalars['ID']['input'];
  txHash?: InputMaybe<Scalars['String']['input']>;
};

/** Marketing Widget */
export type MarketingWidget = {
  __typename: 'MarketingWidget';
  /** Body of the widget as text */
  body: Scalars['String']['output'];
  /**
   * ctaText is a customizable call-to-action text for the action
   * @deprecated This field was split into two. Use either 'webCtaText' or 'iOSCtaText' instead
   */
  ctaText: Scalars['String']['output'];
  /**
   * displayPage is an indentifier for which page this widget should appear on:
   *   - dashboard
   *   - vault
   *   - wallet_list
   *   - wallet_detail
   *   - web3_portal
   */
  displayPage: Maybe<Scalars['DisplayPage']['output']>;
  /** iOSCtaText is a customizable call-to-action text for the action in the iOS app */
  iOSCtaText: Scalars['String']['output'];
  /** iOSUrl is the link when users click in the iOS app. */
  iOSURL: Scalars['String']['output'];
  /** Identifier of the marketing widget */
  id: Scalars['ID']['output'];
  /** imageURL is points to an existing image */
  imageURL: Scalars['String']['output'];
  /** isSuppressible, when true, indicates the user can dismiss this widget */
  isSupressible: Scalars['Boolean']['output'];
  /** Title of the widget */
  title: Scalars['String']['output'];
  /** webCtaText is a customizable call-to-action text for the web action */
  webCtaText: Scalars['String']['output'];
  /** webURL is for link when users click through the web */
  webURL: Scalars['String']['output'];
  /** widgetType indicates the type of a widget to the front end (e.g. modal, banner) */
  widgetType: WidgetType;
};

/** Represents a Metadata key value pair */
export type MetadataKeyValuePair = {
  /** Represents the metadata key */
  key: TransactionMetadataKey;
  /** Represents the metadata value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Method indicates the fx rate used in RFQ */
export enum Method {
  /** Direct method for FX rate calculation */
  DIRECT = 'DIRECT',
  /** Synthetic method for FX rate calculation */
  SYNTHETIC = 'SYNTHETIC'
}

/** A sub-threshold deposit recorded for staff review. */
export type MicroDeposit = {
  __typename: 'MicroDeposit';
  /** Decimal string of the deposit amount, signed as observed. */
  amount: Scalars['String']['output'];
  assetTypeId: Scalars['String']['output'];
  /** Populated for crypto micro deposits when blockchain lookup succeeded. */
  blockchainTxHash: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  entryId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Populated for crypto micro deposits; null for fiat. */
  operationId: Maybe<Scalars['String']['output']>;
  /** Current review status: "Pending" or "Reviewed". */
  status: Scalars['String']['output'];
  subaccountId: Scalars['String']['output'];
  transactTime: Scalars['Time']['output'];
  transactionId: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  /** Decimal string of the absolute USD value at recording time. */
  usdValue: Scalars['String']['output'];
};

/** Paginated list of micro deposits. */
export type MicroDepositConnection = {
  __typename: 'MicroDepositConnection';
  /** A list of edges. */
  edges: Maybe<Array<MicroDepositEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A micro deposit edge in a connection. */
export type MicroDepositEdge = {
  __typename: 'MicroDepositEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<MicroDeposit>;
};

export enum MinimumFeeType {
  AUC_BASED = 'AUC_BASED',
  GREATER_VALUE = 'GREATER_VALUE',
  SURCHARGE = 'SURCHARGE'
}

/** A mint or burn conversion. */
export type MintBurnConversion = Node & {
  __typename: 'MintBurnConversion';
  /** Authorization Operation ID */
  authorizationOperationID: Maybe<Scalars['OperationID']['output']>;
  /** Unique mintburn conversion identifier */
  id: Scalars['ID']['output'];
};

export type MovementOfFunds = {
  __typename: 'MovementOfFunds';
  amount: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  fromBankName: Scalars['String']['output'];
  imad: Maybe<Scalars['String']['output']>;
  ledgerTransactionID: Maybe<Scalars['String']['output']>;
  movementOfFundsID: Scalars['String']['output'];
  reviewedAt: Maybe<Scalars['DateTime']['output']>;
  reviewedBy: Maybe<Scalars['String']['output']>;
  status: MovementOfFundsStatus;
  toBankName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum MovementOfFundsStatus {
  /** Approved status */
  APPROVED = 'APPROVED',
  /** Completed status */
  COMPLETED = 'COMPLETED',
  /** Failed status */
  FAILED = 'FAILED',
  /** Pending status */
  PENDING = 'PENDING',
  /** Processing status */
  PROCESSING = 'PROCESSING',
  /** Rejected status */
  REJECTED = 'REJECTED',
  /** Sent status */
  SENT = 'SENT'
}

/** Mutation exposes all methods that allow information to be updated on the backend */
export type Mutation = {
  __typename: 'Mutation';
  /**
   * Accept one disclosure. There should be one call per DisclosureReview from the
   * disclosures query.
   *
   * Returns true if acceptance was saved or if acceptance already exists.
   * Returns false if an error occurred. If there is an error, it will also be sent to Sentry
   */
  acceptDisclosure: Scalars['Boolean']['output'];
  /**
   * Accept one legal term.
   * Returns true if acceptance was saved or if acceptance already exists.
   * Returns false if an error occurred. If there is an error, it will also be sent to Sentry
   */
  acceptLegalTerm: Scalars['Boolean']['output'];
  /**
   * ackWalletKeyDownload should be called whenver a WalletKey, identified by the given walletKeyID from the WalletKeyBackup type, was successfully downloaded.
   * ackWalletKeyDownload will unlock the wallet for use (NOOP if already unlocked.)
   * ackWalletKeyDownload returns nothing on success (or error.)
   */
  ackWalletKeyDownload: Scalars['Boolean']['output'];
  /** acknowledge a scanning issue */
  acknowledgeScanningIssue: Scalars['Boolean']['output'];
  /**
   * Turn on a schedule that is waiting for activation and record the staff user who did it.
   * A schedule waits when it is created on the metastore route, or when an update there adds
   * an email, SFTP or SWIFT destination to an activated one.
   */
  activateReportSchedule: ReportSchedule;
  /**
   * Associate an affiliate KYC profile to a organization KYC profile
   * This mutation will perform the following actions:
   * - Creates a new affilite in Client Entities service if needed
   * - Creates a new affiliate KYC profile if needed
   * - Associates the new (or existent) affiliate KYC profille to an organization kyc profile
   */
  addAffiliateKYCProfile: AffiliateKYCProfile;
  /**
   * Adds a representative to the affiliate
   *
   * If the representative exists, the name is ignored, otherwise it is required.
   */
  addAffiliateRepresentative: Scalars['Boolean']['output'];
  /** Adds assets to an existing program. */
  addAssetsToStablecoinRewardsProgram: AddAssetsToStablecoinRewardsProgramResult;
  /** addClientAffiliateType adds an affiliate type for the client when an affiliate fills a specific questionnaire id */
  addClientAffiliateType: Scalars['Boolean']['output'];
  /**
   * Allows adding individuals to an institution with one or more relationships.
   * Ordering of relationships doesn't matter.
   *
   * first, middle, and last must all be filled out. If middle name
   * is not filled out, an empty string must be submitted for middleName
   * so that we have an explicit record that the middle name was not filled out.
   */
  addIndividualAndRelationships: Array<IndividualInformationRejection>;
  /**
   * Adds a representative to an individual in a client
   *
   * If the representative exists, the name is ignored, otherwise it is required.
   */
  addIndividualRepresentativeInClient: Scalars['Boolean']['output'];
  /**
   * addOrUpdateDocumentDeliverySetting appends to the existing settings of a given setting for a specific Organization.
   * If an email is already present in settings, this mutation will overwrite the name of the recipient
   */
  addOrUpdateDocumentDeliverySetting: Scalars['Boolean']['output'];
  /**
   * Adds a person to the affiliate as an authorized user (PARTICIPATING_MEMBER).
   * A person who hasn't been sent the individual KYC form gets it. Any staff
   * member can add people, but only to affiliates enabled for participating member add.
   */
  addParticipatingMember: ParticipatingMemberAddResult;
  /**
   * DEPRECATED: Use addRelatedPartyKycProfile instead.
   *
   * Adds a new related party to an affiliate with relationship information.
   * Similar to addIndividualAndRelationships but for related party individuals.
   *
   * This mutation only supports individual related parties and will be removed in a future version.
   *
   * first, middle, and last must all be filled out. If middle name
   * is not filled out, an empty string must be submitted for middleName
   * so that we have an explicit record that the middle name was not filled out.
   * @deprecated Use addRelatedPartyKycProfile instead. This mutation only supports individual related parties.
   */
  addRelatedPartyAndRelationships: Array<IndividualInformationRejection>;
  /**
   * Adds a new related party (individual or institutional) to an affiliate KYC profile.
   *
   * This mutation supports both individual and institutional related parties.
   * For individuals: Provide EITHER fullName OR (firstName + lastName).
   * For institutions: fullName is required.
   *
   * Returns rejections for any validation failures.
   */
  addRelatedPartyKycProfile: Array<InfoTypeRejection>;
  /** Allows adding related parties to an affiliate. */
  addRelatedPartyRelationships: Scalars['Boolean']['output'];
  /**
   * Adds a representative to a KYC profile (affiliate or related party).
   * If the representative doesn't exist, representativeName is required to create it.
   * Returns true on success.
   */
  addRepresentative: Scalars['Boolean']['output'];
  /**
   * Add a (subaccount, asset) pair to the true-up skip list: the engine will treat
   * that asset on that subaccount as a no-op in both stages. Staff-only. Idempotent —
   * re-adding the same pair returns the existing skip.
   */
  addTrueUpSkip: TrueUpSkip;
  adjustTradingStrategyCollateralHold: TradingStrategyCollateralHold;
  /** allowlistValidator allowlists a validator clients may stake to and returns it. */
  allowlistValidator: AllowlistedValidator;
  /**
   * Freezes every target in one transaction and returns the rows as stored, in input order.
   * Requires the FREEZE_WITHDRAWAL_ACCESS permission.
   */
  applyRestrictions: Array<RestrictionRecord>;
  /**
   * Sets the exact tag state for an entity scoped to the caller's tag type and org.
   * Upserts desired tag associations and removes any active associations of the same
   * scope that are not in the desired list — all in one transaction.
   * Tag type and org are derived server-side from the authenticated actor:
   * staff users apply backoffice tags; org users apply client tags scoped to their org.
   * Passing an empty tags list removes all active associations of the caller's scope.
   */
  applyTags: ApplyTagsPayload;
  /** Allows a risk reviewer to approve the information of a affiliate */
  approveAffiliate: Scalars['Boolean']['output'];
  /**
   * Approves the KYC profile information for an affiliate.
   * Returns true if the approval was successful, false otherwise.
   */
  approveAffiliateKYCProfileInfo: Scalars['Boolean']['output'];
  /** Allows a risk reviewer to approve the information of an individual */
  approveIndividualInClient: Scalars['Boolean']['output'];
  /** Approves the given standing instruction if in PENDING state */
  approvesStandingInstruction: Scalars['Boolean']['output'];
  /**
   * archiveWallets archives wallets identified by the given IDs.
   * Returns error if walletIDs is empty.
   * Returns no error if nothing is updated (eg, no wallet matches, or all matching wallets
   * already are in "archived" state.)
   */
  archiveWallets: ArchiveWalletsResponse;
  /** Assign Funds to a Program Customer from the Unassigned Subaccount */
  assignUnassignedFunds: Scalars['Boolean']['output'];
  /** Queues address attestation requests. */
  attestAddresses: Scalars['Boolean']['output'];
  /** Attribute a set of deposit operations as spam */
  attributeDepositsAsSpam: Scalars['Boolean']['output'];
  /**
   * Trigger an asynchronous audit of all organization definitions for known legacy field issues.
   * Checks each organization's HSM-signed JSON for:
   * - TrustedDestinations set to null (should be an empty map)
   * - Legacy Users field still in use (should be migrated to Keys)
   * - PolicyMap set to null (should be an empty map)
   *
   * Returns immediately with a workflow ID. Use the workflow ID to track progress.
   */
  auditOrganizationLegacyFields: AuditOrganizationLegacyFieldsResult;
  /** Backfills wallet_has_been_used for wallets that have deposit events. */
  backfillWalletHasBeenUsed: Scalars['Boolean']['output'];
  /**
   * Disables the given event types for the given orgs, or for every org that exists at call time
   * if allOrgs is true (mutually exclusive with orgIDs: set exactly one). Purely subtractive — it
   * never touches other event types an org may have enabled.
   */
  batchDisableWebhookEventTypes: Scalars['Boolean']['output'];
  /**
   * Enables (upserts) the given event types for the given orgs, or for every org that exists at
   * call time if allOrgs is true (mutually exclusive with orgIDs: set exactly one). Purely
   * additive — it never disables event types not named in the request.
   */
  batchEnableWebhookEventTypes: Scalars['Boolean']['output'];
  /** Endorse multiple operations. */
  batchEndorse: Scalars['Boolean']['output'];
  /** Book a quote for a trade */
  blockPricerBookQuote: BookQuoteOutput;
  /** Execute a Request for Quote (RFQ) operation */
  blockPricerRfq: RFQOutput;
  /** Echoes the message back to the client. */
  blockchainEcho: Scalars['String']['output'];
  /** Broadcasts a raw transaction */
  broadcastRawTransaction: Scalars['String']['output'];
  /**
   * Broadcasts (or re-attempts a broadcast of) a previously submitted
   * transaction with an operationID
   */
  broadcastTransaction: Scalars['String']['output'];
  btApproveWithdrawal: Scalars['ID']['output'];
  btRejectWithdrawal: Scalars['ID']['output'];
  /** BulletinBoardServiceCreateAddressOwnership creates address ownership in TRUST Bulletin Board */
  bulletinBoardServiceCreateAddressOwnership: Scalars['Boolean']['output'];
  /** BulletinBoardServiceDeleteAddressOwnership deletes address ownership from TRUST Bulletin Board */
  bulletinBoardServiceDeleteAddressOwnership: Maybe<Scalars['Map']['output']>;
  /**
   * Cancel an ongoing full quorum recovery for the given organization.
   * No-op if no recovery workflow is running.
   */
  cancelFullQuorumRecovery: Scalars['Boolean']['output'];
  /** Cancel a KYCQuestionnaireSubmission. Valid from INIT, SENT, and IN_PROGRESS states. */
  cancelKYCQuestionnaireSubmission: Maybe<KYCQuestionnaireSubmission>;
  /** cancelManualTrade allows to cancel a manual trade. */
  cancelManualTrade: Scalars['Boolean']['output'];
  /** Cancel an offchain vesting schedule and release its holds */
  cancelOffchainVestingSchedule: Scalars['Boolean']['output'];
  /**
   * Sends a request to cancel given operation.
   * Returns a code indicating the status of the cancelation request:
   * - OK:          means the operation has been canceled successfully.
   * - ACCEPTED:    means the cancelation request has been received successfully but not yet processed.
   * - BAD_REQUEST: means the operation is in non-cancelable state, or is a non-cancelable operation.
   * - FORBIDDEN:   means the user is not authorized to cancel the operation.
   *
   * Sample BAD_REQUEST:
   * - operation is in non-cancelable state (eg, COMPLETE).
   * - operation is of non-cancelable type (eg, GAS_STATION; non-execute).
   *
   * This API is async, and safe to call repeatedly.
   */
  cancelOperationAsync: CancelOperationResponse;
  /**
   * Cancel scheduled shared policies migration for organizations.
   * Only cancels organizations with status SCHEDULED (soft-deletes the entry).
   */
  cancelSharedPoliciesMigration: Scalars['Boolean']['output'];
  cancelTransaction: Scalars['Boolean']['output'];
  /** Cancels an account transfer. */
  cancelTransfer: Transfer;
  /**
   * Canonicalizes the organization definitions in the database.
   * Returns a message for each organization, detailing whether it succeeded or failed.
   */
  canonicalizeOrganizationsInDatabase: Array<Scalars['String']['output']>;
  /**
   * changes an operation state, only works if the operation is in a final state
   * can move ERRORED back to BROADCASTING, COMPLETE to ERRORED
   */
  changeOperationState: Scalars['Boolean']['output'];
  /**
   * overwrites an operation with the given raw JSON payload
   * use only when there is no safer mutation that can be used
   * intended as a better alternative to database surgery
   * it performs only basic validations but does update balances
   */
  changeRawOperation: Scalars['Boolean']['output'];
  /**
   * Request the creation of a role change operation
   * It returns a generic operation for developer friendliness but it will
   * always be of type "ChangeRoleOperation"
   */
  changeRole: Operation;
  /**
   * Clears all disclosure acceptances, regardless of org/account/disclosure/version, for the User in the context.
   *
   * Returns true unless error was encountered.
   */
  clearDisclosureAcceptances: Scalars['Boolean']['output'];
  /**
   * Clear empty policy changelog entries that contain only /policy/Data/ID changes.
   * These are legacy entries that were recorded before filtering was implemented.
   *
   * Returns the number of entries that matched the criteria.
   * If dryRun is false, entries will be deleted. If true, only counts will be returned.
   */
  clearEmptyPolicyChangelogs: ClearEmptyPolicyChangelogsResult;
  /**
   * Clear a client-facing feature from ALL organizations asynchronously.
   * This triggers a Temporal workflow that removes the feature from all orgs that have it enabled.
   * The workflow processes organizations in batches until all organizations have been checked.
   * Returns immediately after starting the workflow - use the workflow ID to track progress.
   */
  clearFeatureFromAllOrganizations: ClearFeatureResult;
  /**
   * Clears all legal term acceptances, regardless of org/account/disclosure/version, for the User in the context.
   * Returns true unless error was encountered.
   */
  clearLegalTermAcceptances: Scalars['Boolean']['output'];
  /**
   * Delete the B2B send failure of a transaction. The next TaxBit sync sends it again only if its updated_at falls inside
   * the sync's read window; otherwise it needs a backfill. Sends nothing itself. Returns the deleted failure. Returns a 404
   * error when the transaction has no send failure. Requires the FINANCE_ACCESS staff permission
   */
  clearTaxbitSendFailure: ClearTaxbitSendFailurePayload;
  /**
   * Deletes voice phrase PII entries for the given individuals, so they are
   * re-prompted to record a new one.
   */
  clearVoicePhrases: Scalars['Boolean']['output'];
  /** Approve a client dashboard login */
  clientDashboardLogin: Scalars['Boolean']['output'];
  /** Log out of all client dashboard sessions for this user */
  clientDashboardLogout: Scalars['Boolean']['output'];
  /**
   * Close a v4 account: move it to CLOSING and let its close workflow finish the
   * job. Staff-only. Returns nothing but an error when there is one (null on
   * success); the account's status shows the progress.
   *
   * The close cascades: an aggregate closes its children first, and cancels the
   * opening of one that has not finished opening. Whatever balance an account still
   * holds, including funds that arrive after this request, is moved to the
   * organization's closing funds account, and pending transactions are waited for
   * however long they take, so an account whose pending transactions never
   * complete stays CLOSING (on-call is paged after 72 hours).
   *
   * Without force the account (and every child) must be empty when this is called,
   * like a client's close. With force that check is skipped, and the organization
   * must have a closing funds account to move the funds to.
   *
   * Does nothing for an account that is already CLOSING or CLOSED. Rejected for one
   * that is still OPENING.
   */
  closeAccount: Maybe<Scalars['Boolean']['output']>;
  /** Close account(s) */
  closeAccounts: Scalars['Boolean']['output'];
  /** Closes an affiliate */
  closeAffiliate: Scalars['Boolean']['output'];
  /**
   * Close a subaccount in both Ledger and WOS. Staff-only. Ledger is closed first,
   * so if the second write fails the subaccount stays locked down for money
   * movement rather than open. Rejected when Ledger reports pending transactions.
   *
   * A subaccount present in only one store is closed there and reported via a
   * warning: org-level house subaccounts exist only in Ledger by design, and some
   * PROGRAM_CUSTOMER subaccounts were never synced to WOS.
   *
   * Safe to re-run — that is how a partially applied closure is converged.
   */
  closeSubaccount: CloseSubaccountResult;
  /** Create one or more exposures under existing collateral packages. */
  cmCreateExposure: CreateExposureResult;
  /** Create a loan / collateral package */
  cmCreateLoan: CreateLoanResult;
  /**
   * Create one or more CM operations from the client dashboard. Every entry is
   * validated (secured-party access + manual-operation eligibility) up front
   * before any operation is created — so a validation failure on any entry
   * short-circuits the whole batch with nothing written. Creates then run
   * sequentially in input order; if a create fails mid-batch, earlier entries
   * are already committed. Callers should supply a distinct idempotencyKey per
   * entry so that retrying the whole batch after a mid-batch create failure
   * short-circuits the already-committed entries and re-attempts the rest.
   * For ORG_USER callers, the caller must be the secured party for every target
   * package in the batch.
   * Exposes the core input fields for manual operations; system-only input fields
   * (OperationID, TransactionID, LiquidationProceed*) are intentionally omitted.
   */
  cmCreateOperation: CmCreateOperationResponse;
  /**
   * Create a collateral management participant linked to an existing Atlas participant.
   * Repeating the call with identical input returns the existing participant's ID; a
   * repeat with different data for the same Atlas participant is rejected.
   */
  cmCreateParticipant: CreateParticipantResult;
  /** Create ticket */
  cmCreateTicket: CollateralTicket;
  /** Create ticket action */
  cmCreateTicketAction: CollateralTicketAction;
  /** Create ticket communication log */
  cmCreateTicketCommunicationLog: CollateralTicketCommunicationLog;
  /**
   * Delete LTV history rows older than the configured maximum age. The periodic
   * runnable does the same on a schedule; this runs one pass on demand.
   */
  cmDeleteExpiredLTVHistory: DeleteExpiredLTVHistoryResult;
  /**
   * Delete Exposure
   * This deletes an Exposure if it has no operations.
   */
  cmDeleteExposure: DeleteExposureResult;
  /**
   * Delete CM Operation
   * This deletes one or more Collateral Management operations which are different from normal operations.
   */
  cmDeleteOperation: DeleteOperationResult;
  /**
   * Delete Collateral Package
   * This deletes a Collateral Package.
   */
  cmDeletePackage: DeletePackageResult;
  /** Delete a system settings row (global or asset level) by ID. */
  cmDeleteSystemSettings: Scalars['Boolean']['output'];
  /**
   * Link a Talos order ID to one collateral asset of a liquidation obligation, in any status. An asset
   * can hold several orders. The first failed check writes nothing: talosOrderID is a UUID; the
   * obligation exists; the obligation's package tracks asset as collateral that is not fixed USD; no
   * other asset of the obligation holds the ID. Resending an ID the asset already holds changes
   * nothing. Returns true once the asset holds the ID; the obligation lists it under orders.
   */
  cmLinkTalosOrder: Scalars['Boolean']['output'];
  /**
   * Execute a trading order via the Trading service.
   * Creates a new order for liquidation or collateral rebalancing
   */
  cmNewOrderSingle: TradingOrderResponse;
  /**
   * Send loan funds from an SP-owned wallet to the pledgor's disbursement wallet.
   * Either side may propose. `sourceWalletID` is required for
   * SP callers and must be empty for pledgor callers.
   * Rejected for pledgor callers when the projected LTV reaches or exceeds the danger threshold
   * (MC, or Critical if no MC is configured); secured-party callers (and staff, who act as the
   * secured party) are never blocked by it. Preview with cmSimulateLtv.
   */
  cmRequestExposureIncrease: RequestMarginReturnResponse;
  /**
   * Request a margin return by creating a settlement network transfer.
   * This wraps the settlement network's CreateTwoWaySettlement API.
   * Rejected when the return would consume the entire collateral value, or when the caller acts as
   * the pledgor (a pledgor org user, or staff) and the projected LTV would reach or exceed the
   * ceiling that cmValidateMarginReturn checks against. Secured-party callers are not blocked by
   * the ceiling.
   * Creates a MARGIN_RETURN_REQUESTED alert and initiates the settlement process.
   */
  cmRequestMarginReturn: RequestMarginReturnResponse;
  /** Run RunLTVMonitor for collateral packages. */
  cmRunLTVMonitor: RunLTVMonitorResult;
  /** Run RunSettlementMonitor for collateral packages. */
  cmRunSettlementMonitor: RunSettlementMonitorResult;
  /** Run RunWalletMonitor for collateral packages. */
  cmRunWalletMonitor: RunWalletMonitorResult;
  /**
   * Set the asset-level value of a system setting. Only slippage can be set
   * at the asset level right now, so type must be SLIPPAGE. Creates the asset-level
   * row if it doesn't exist yet, otherwise updates it.
   */
  cmSetAssetLevelSystemSettings: CmSystemSettings;
  /**
   * Set the global system setting (slippage, liquidation fee, price change
   * threshold, max staleness, backup price feed, market data snapshot freshness,
   * credit line check, or backup feed tolerance) for a type. Creates the global
   * row if it doesn't exist yet, otherwise updates it.
   * Exactly one of slippage/liquidationFee/priceChangeThreshold/maxStalenessMinutes/
   * backupPriceFeed/marketDataSnapshotFreshness/creditLineCheck/backupFeedToleranceMinutes
   * must be set, matching type.
   */
  cmSetGlobalSystemSettings: CmSystemSettings;
  /** Update a single exposure's mutable fields. Omitted fields are left unchanged. */
  cmUpdateExposure: UpdateExposureResult;
  /**
   * Update a liquidation obligation from the Retool queue. Setting status to its
   * current value is a no-op.
   */
  cmUpdateLiquidationObligation: CmLiquidationObligation;
  /** Update loan / collateral package */
  cmUpdateLoan: UpdateLoanResult;
  /**
   * Update a CM operation. The only status this accepts is VOID, on a PENDING row whose
   * settlement is terminal.
   */
  cmUpdateOperation: CmOperation;
  /** Update ticket */
  cmUpdateTicket: CollateralTicket;
  completeTransaction: Scalars['Boolean']['output'];
  /** Update Transaction Monitoring configurations for a given rule */
  complianceUpdateTMSConfigs: Scalars['Boolean']['output'];
  /**
   * Configure wallets for a stablecoinreward participant.
   * this is a wrapper around the snParticipantUpdate mutation
   */
  configureStablecoinRewardsParticipantWallets: StablecoinRewardsParticipant;
  /**
   * Create one or more trade subscriptions: allocate `amount` of `assetTypeId`
   * from an UNASSIGNED_STRATEGY_FUNDS subaccount into the DWP asset roster for
   * that asset type. Staff-only. orgId and programCustomerId are resolved from
   * each subaccount, not caller-supplied; each subaccount must have exactly one
   * program customer and must be an UNASSIGNED_STRATEGY_FUNDS operational
   * subaccount in Ledger. Each input is processed independently — one input
   * failing validation, or hitting an already-active subscription for its
   * org/subaccount/asset type, does not affect any other input. The result
   * reports every input as either succeeded or failed.
   */
  createA1TradeSubscription: CreateA1TradeSubscriptionResult;
  /** Create specific API Key for transfers for a given domain (lending / brokerage / other) */
  createAPIKeyForTransfers: Operation;
  /** CreateAccount manually dispatches a workflow to create an account. It is used by blockchains that need on-chain objects to be fully functional. */
  createAccount: Scalars['Boolean']['output'];
  /** Creates a top level affiliateV2 with a generated ID, no account and no KYC profile, for a counterparty that is not a client */
  createAffiliateV2: AffiliateV2;
  /**
   * Get-or-create the subaccount's deposit wallet for the given asset and link it
   * to the subaccount (WOS-local primary link + Ledger). Staff-only. Async — starts
   * a workflow and returns its handle; the wallet/link may not exist yet on return.
   * (WM-474)
   */
  createAndLinkSubaccountWallet: CreateAndLinkSubaccountWalletResult;
  /** Creates a balance adjustment operation. */
  createBalanceAdjustment: Scalars['String']['output'];
  /** Creates a comment on the client dashboard */
  createClientOperationComment: OperationComment;
  /** Create a coinductor automation policy for a source/destination wallet pair on the given asset. */
  createCoinductorAutomationPolicy: CoinductorAutomationPolicy;
  /** createContractCallOperation encodes a call to a verified EVM contract function and creates a generic execute operation. Returns the operationID. */
  createContractCallOperation: Scalars['String']['output'];
  /** Create a counterparty */
  createCounterparty: CounterpartyV2;
  createCounterpartyAccount: CounterpartyAccount;
  /** Creates a new custodian and returns its ID. */
  createCustodian: Scalars['String']['output'];
  /** Creates a deposit attribution spam threshold */
  createDepositAttributionSpamThreshold: Scalars['Boolean']['output'];
  createDerivsEntityBankAccount: DerivsEntityBankAccountPayload;
  createDerivsEntityWallet: CreateDerivsEntityWalletPayload;
  createDerivsTransfer: CreateDerivsTransferPayload;
  createDerivsTrustedDestination: DerivsTrustedDestinationPayload;
  /** Provisions a new enroll token to be used by developers */
  createDevEnrollToken: Scalars['String']['output'];
  /** Creates a new DocuSign workflow configuration. */
  createDocuSignWorkflow: DocuSignWorkflow;
  /** Create an external exchange credential by registering an exchange API key. */
  createEECredential: CreateEECredentialResponse;
  /** Creates a new enrollment token and sends an invitation email to the provided email address */
  createEnrollTokenAndSendEmail: Scalars['String']['output'];
  /** Create a new fee recalculation */
  createFeeRecalculation: Scalars['String']['output'];
  /** Request the creation of a generic operation */
  createGenericOperation: Scalars['String']['output'];
  /** Creates an GenericOperation */
  createGenericOperationForOrg: Scalars['String']['output'];
  /** Creates global trusted sources in batch */
  createGlobalTrustedSources: Scalars['Boolean']['output'];
  /** Create a new compliance issue in Jira */
  createJiraComplianceIssue: JiraComplianceIssue;
  /** Create KYCConfig object. */
  createKYCConfig: Maybe<KYCConfig>;
  /** Create KYCProcess object. */
  createKYCProcess: Maybe<KYCProcess>;
  /** Create KYCProcessTrigger mutation. */
  createKYCProcessTrigger: Maybe<KYCProcessTrigger>;
  /**
   * Create an exemption for a KYC profile information field.
   * Allows staff to mark certain information as not required for this profile.
   */
  createKYCProfileExemption: Scalars['Boolean']['output'];
  /** Create KYCQuestion object. */
  createKYCQuestion: Maybe<KYCQuestion>;
  /** Create KYCQuestionnaire object. */
  createKYCQuestionnaire: Maybe<KYCQuestionnaire>;
  /** Create KYCQuestionnaireSubmission mutation. */
  createKYCQuestionnaireSubmission: Maybe<KYCQuestionnaireSubmission>;
  /**
   * Inserts a new legalterms document and inserts into the legaltermsDB with external and internal versions of 1.
   * Returns true unless error was encountered.
   */
  createLegalterms: Scalars['Boolean']['output'];
  /** Create a mint or burn conversion operation. */
  createMintBurnConversion: MintBurnConversion;
  /** Creates a movement of funds between Fiat FBO accounts */
  createMovementOfFunds: MovementOfFunds;
  /** Request the creation of an offchain operation */
  createOffChainOperation: Scalars['String']['output'];
  /** Creates an OffChainOperation */
  createOffChainOperationForOrg: Scalars['String']['output'];
  /** Create an offchain vesting schedule */
  createOffchainVestingSchedule: OffchainVestingSchedule;
  /** Creates a one-off operation, currently used for Celo and Keep tasks */
  createOneOff: Scalars['String']['output'];
  /**
   * Create one org-level operational subaccount and its PRIMARY affiliate row (staff only).
   * The write goes through the log_history trigger, so public.history records the acting
   * staff user. Not idempotent: a second call for an existing externalID is rejected.
   */
  createOperationalSubaccount: CreateOperationalSubaccountResult;
  /**
   * Creates a new organization profile with the specified name and anchorage entity types.
   * Note: This is currently a stub implementation returning dummy data for development purposes.
   */
  createOrganizationProfile: OrganizationKYCProfile;
  /** Create specific permission group for transfers for a given domain (lending / brokerage / other) */
  createPermissionGroupForTransfers: Operation;
  /** Creates a person with an associated institutional individual, or returns the existing person ID. */
  createPerson: Scalars['String']['output'];
  createReport: Report;
  createReportSchedule: ReportSchedule;
  /**
   * Register a report type in the metastore, complete with its headers and filter
   * definitions. Staff only.
   *
   * ONE call carries the report type's full desired state -- the definition row plus
   * both complete child sets -- written in a single transaction and validated as a
   * whole. A definition with no children is not a legal report type, so both child
   * arguments are required:
   *
   * - every report type needs a filter set containing exactly one main filter, the
   *   date range each generated report is scoped by;
   * - a CSV type needs at least one emitted header, or it renders a file with no
   *   columns;
   * - an MT type takes no headers at all -- its provider renders the message
   *   itself -- and so passes headers: [].
   *
   * Registering a VIEW-backed type reads the backing view's schema from BigQuery
   * first: the children's source columns and orgColumnName are checked against the
   * view's current columns, and that snapshot is stored with the type, so a
   * registration cannot claim columns the view does not have. A view that cannot be
   * read -- unknown, unreadable, or not a warehouse-managed relation -- is a
   * rejected create rather than a type registered blind, as is one whose columns a
   * header or a filter names but no report can project. A column of such a type that
   * nothing references is recorded like any other. Reconfiguring an existing
   * type goes through setReportTypeHeaders / setReportTypeFilterDefinitions, which
   * each replace their whole set, and refreshReportTypeSchema re-reads the view when
   * it changes.
   */
  createReportTypeDefinition: ReportTypeDefinition;
  /** Create a new scheduled report */
  createScheduledReport: ScheduledReport;
  /** Add scheduled report subscriber */
  createScheduledReportSubscriber: ScheduledReportSubscriber;
  /** Creates a settlement for the given organization including the provided trade IDs */
  createSettlement: Scalars['Boolean']['output'];
  /** Creates a new settlement instructions record for the given organization. */
  createSettlementInstructions: Scalars['Boolean']['output'];
  /** Creates a new participant. */
  createStablecoinRewardsParticipant: CreateStablecoinRewardsParticipantResult;
  /** Creates a new program. */
  createStablecoinRewardsProgram: CreateStablecoinRewardsProgramResult;
  /** Creates a new standing instruction */
  createStandingInstruction: Scalars['String']['output'];
  /**
   * Create an active tax mapping. Leading and trailing spaces are removed, and empty strings are stored as null. Returns a
   * 409 error when an active mapping already exists for the same source, type and subtype. Requires the FINANCE_ACCESS
   * staff permission
   */
  createTaxMapping: TaxMappingPayload;
  /**
   * Request the preparation of a Tendermint claim staking rewards one-off operation.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "OneOffOperation".
   */
  createTendermintClaimRewardsOneoff: Operation;
  /** Creates a test module */
  createTestModule: Scalars['String']['output'];
  createTransaction: Transaction;
  createTransactions: Array<Scalars['String']['output']>;
  /** Creates trusted sources in batch */
  createTrustedSources: Scalars['Boolean']['output'];
  /** Create a settlement network settlement between two participants */
  createTwoWaySettlement: SNTwoWaySettlement;
  /** Create Unassigned policy */
  createUnassignedPolicy: PolicyV2;
  /** Create a vestingContract */
  createVestingContract: Scalars['String']['output'];
  createWalletScreeningAllowlistEntry: WalletScreeningAllowlistEntry;
  /** Creates a withdrawal operation without initiator (should only be used for NFTs) */
  createWithdrawalNoInitiator: Scalars['String']['output'];
  deactivateDerivsEntityBankAccount: DerivsEntityBankAccountPayload;
  deactivateDerivsTrustedDestination: DerivsTrustedDestinationPayload;
  /**
   * Creates a settlement; preserved for legacy devdebug / Retool flows in the trading subgraph.
   * When tradeIDs is empty and includeAllUnsettledTrades is false, it auto-selects
   * executed unsettled trades for the given organization/account.
   */
  debugCreateSettlement: Scalars['Boolean']['output'];
  /** Review pending default staking fee terms (approve/reject) */
  defaultStakingFeeTermsReview: ReviewPendingDefaultStakingFeeTermsPayload;
  /** Update default staking fee terms - send for review */
  defaultStakingFeeTermsUpdate: UpdateDefaultStakingFeeTermsPayload;
  /** deleteAssociatedAddress deletes the associated address for a given addressID */
  deleteAssociatedAddress: Scalars['Boolean']['output'];
  /**
   * Soft deletes a client. This sets the field isActive to false, and deletedAt the current time.
   * Returns true on success. There is no way to undelete a client without going into the database.
   */
  deleteClient: Scalars['Boolean']['output'];
  /** Delete a comment on the client dashbaord */
  deleteClientOperationComment: Scalars['Boolean']['output'];
  deleteDerivsEntityWallet: DeleteDerivsEntityWalletPayload;
  /**
   * Delete an existing exchange credential.
   * @deprecated Use deleteEECredentialV2. This will be deleted soon.
   */
  deleteEECredential: Scalars['Boolean']['output'];
  /** Delete an existing exchange credential. */
  deleteEECredentialV2: DeleteEECredentialResponse;
  /**
   * Deletes the fixed prices for the from/to asset pair.
   * If ToAsset is "" or USD, all fixed price conversions defined in
   * priceSymbolsToPopulateFixedPriceFor for the FromAsset are deleted.
   */
  deleteFixedPrice: Scalars['Boolean']['output'];
  /** Delete KYCConfig object. */
  deleteKYCConfig: Scalars['Boolean']['output'];
  /** Delete KYCProcessTrigger mutation. */
  deleteKYCProcessTrigger: Scalars['Boolean']['output'];
  /** Remove an exemption for a KYC profile information field. */
  deleteKYCProfileExemption: Scalars['Boolean']['output'];
  /** Delete KYCQuestion object. */
  deleteKYCQuestion: Scalars['Boolean']['output'];
  /** Delete KYCQuestionnaire object. */
  deleteKYCQuestionnaire: Scalars['Boolean']['output'];
  /** Delete an unassigned policy */
  deletePolicy: Scalars['Boolean']['output'];
  /** Deletes an existing settlementID */
  deleteSettlement: Scalars['Boolean']['output'];
  /**
   * Remove an active tax mapping. The mapping becomes inactive with no replacement, so its source, type and subtype are
   * left unmapped. Nothing is deleted. Returns the removed mapping. Returns a 412 error when the mapping is not active.
   * Requires the FINANCE_ACCESS staff permission
   */
  deleteTaxMapping: TaxMappingPayload;
  /** Deletes a test module */
  deleteTestModule: Scalars['Boolean']['output'];
  /**
   * Deletes transfers by IDs in bulk. Returns the number of transfers deleted.
   * Associated asset rows are removed automatically via cascade.
   */
  deleteTransfers: Scalars['Int']['output'];
  /** Deletes personal identifiable information for a user */
  deleteUserPII: Scalars['Boolean']['output'];
  deleteWalletScreeningAllowlistEntry: Scalars['Boolean']['output'];
  /** TODO: add description */
  deleteWebhookEndpoint: Scalars['Boolean']['output'];
  /**
   * DepositAddressCreate tries to create a new deposit address for the given wallet ID.
   * It supports UTXO-based assets only - errors on Account-based assets.
   *
   * For Porto (aka MustAckWalletKeyBackups=true), these APIs work together to "Generate New Address" :
   *   - AckWalletKeyDownload
   *   - DepositAddressCreate
   *   - GetWalletKeyBackupOrCreateNewAddress (aka WalletKeyBackupBeforeAddressCreation)
   *
   * FE/iOS should implement UX flow that does the following:
   *   - call GetWalletKeyBackupOrCreateNewAddress first, which
   *     -- if "not-taken" address *is*  found, and     BackupReceived: returns nil.
   *     -- if "not-taken" address *is*  found, but not BackupReceived: returns Backup data.
   *     -- if "not-taken" address *not* found: sends a request to provision address, and returns UserVisible error.
   *   - repeat the call until getting either nil or Backup data.
   *   - if got Backup data:
   *     -- call AckWalletKeyDownload to ACK "Backup received".
   *   - if got nil:
   *     -- call DepositAddressCreate to generate new address.
   *
   * Note:
   * - DepositAddressCreate returns UserVisible error if not BackupReceived.
   * - DepositAddressCreate returns UserVisible error if a "not-taken" address *not* found.
   */
  depositAddressCreate: DepositAddressCreatePayload;
  /** Deposit Source Screening new log */
  depositScreening: Scalars['Boolean']['output'];
  /** This is similar to robologin but it works in any environment for any user */
  developerBrowserExtensionLogin: Scalars['Boolean']['output'];
  /** This is similar to robologin but it works in any environment for any user */
  developerClientDashboardLogin: Scalars['Boolean']['output'];
  /** Disable a module for all organizations on a given operator */
  disableModuleForOperator: Scalars['Boolean']['output'];
  /** Disable a module for a list of organizations */
  disableModuleForOrganizations: Scalars['Boolean']['output'];
  /** Disables the given standing instruction */
  disableStandingInstruction: Scalars['Boolean']['output'];
  /**
   * Accepts a dispatch request for an account transfer. The actual dispatch runs asynchronously;
   * poll the transfer status to observe the outcome (AwaitDispatch → Dispatched or DispatchFailed).
   * Allowed when transfer status is Signed or DispatchFailed.
   */
  dispatchTransfer: Transfer;
  /**
   * Files a client-initiated ACH Debit Out return dispute (FIAT-3d). Always files R29 (corporate
   * customer advises not authorized) — v1 has no other reason. Gated on the caller holding
   * WITHDRAW_INITIATE on the debit's wallet, and on the Debit Out being COMPLETE, not already
   * linked to a Return, and still before its DisputeDeadline. Idempotent: a second call for the
   * same debit returns the existing Return (including one a racing waterfall decision created
   * first), rather than filing twice.
   */
  disputeACHDebitOut: DisputeACHDebitOutResult;
  /**
   * Atomically activate every staged leg of a package. All activation preconditions
   * are validated before anything is touched, the legs book to Haruko as one batch
   * (unwound if any leg is rejected), and the status flips commit in one database
   * transaction. Any single leg failing leaves every leg staged.
   */
  dvActivatePackage: DVPackage;
  /** Activate a trade */
  dvActivateTrade: DVTrade;
  /**
   * Adds a setting for one file of one statement type for an account. Errors
   * when the account is unknown or disabled in otcderivatives, when the
   * statement type has no such file, or when the account already has a setting
   * for that file (use dvSetStatementFileSettingEnabled to change it).
   */
  dvAddStatementFileSetting: DvStatementFileSetting;
  /** Amend a trade */
  dvAmendTrade: DVTrade;
  /**
   * Approves a client email, moving it from PENDING_APPROVAL to APPROVED.
   * Errors if it isn't currently PENDING_APPROVAL.
   */
  dvApproveClientEmail: DvClientEmail;
  /**
   * Book a package directly, skipping the staging step: stages every leg atomically,
   * then activates the whole package as one action. If activation fails, the package
   * remains fully staged and the error names its identifier so activation can be retried.
   */
  dvBookPackage: DVPackage;
  /**
   * Book a staged closeout: close each allocation's trade, in order, as dvCloseoutTrade does, with the
   * effective date and exec time set to the chat's trade time and the IM reductions computed by the
   * server. Only a STAGED closeout, or one whose booking started over 5 minutes ago, can be booked. If
   * an allocation fails, the ones before it stay booked and the closeout returns to STAGED with what
   * is left, unless another booking took it over first. It becomes BOOKED once its whole quantity is
   * booked.
   */
  dvBookStagedCloseout: DVStagedCloseout;
  /** Cancel a maker-checker request that has not yet executed (pending, or approved awaiting execution). */
  dvCancelMakerCheckerRequest: DVMakerCheckerRequest;
  /**
   * Undo a grouping made in error, returning its obligations to the queue. Takes effect immediately, since
   * grouping took one signature and so ungrouping cannot take two. Refused once money is attached.
   */
  dvCancelSettlement: DVSettlement;
  /** closeout a trade, either partially or fully */
  dvCloseoutTrade: DVTrade;
  /**
   * Confirm the end of day recon for asOfDate as the caller. WorkflowEndOfDay starts capital and
   * Part 45 for that date within a minute of the first confirmation. A date with no succeeded margin
   * run dated asOfDate is refused. A date already confirmed returns its first confirmation unchanged.
   */
  dvConfirmEndOfDayRecon: DVEndOfDayReconConfirmation;
  /**
   * Confirm a settlement was met. The money is attached beforehand with dvSaveSettlementMovements, or sent
   * here as payment where the account's settlement automation is on and the settlement isn't only
   * hand-entered obligations other than VM. In that case confirming also records and attaches each obligation's
   * bucket moves, the ones dvSettlementLedgerPreview shows. Immediate, no approval — needs a reason to
   * close short.
   */
  dvConfirmSettlement: DVSettlement;
  /** Create account */
  dvCreateAccount: DVAccount;
  dvCreateAccountCSA: Scalars['Boolean']['output'];
  dvCreateAccountNettingSet: Scalars['Boolean']['output'];
  /** Create asset */
  dvCreateAsset: DVAsset;
  dvCreateCSA: DVCSA;
  /** Create CSA margin terms for calculating margin requirements */
  dvCreateCSAMarginTerms: DVCSAMarginTerms;
  /** Create a new collateral rule for a netting set */
  dvCreateCollateralRule: DVCollateralRule;
  /** Create a counterparty master copy record */
  dvCreateCounterpartyMasterCopy: DVCounterpartyMasterCopy;
  /** Create a custodian. The name must not match an existing custodian, ignoring case. */
  dvCreateCustodian: DVCustodian;
  /**
   * Create a custodian wallet for an entity and custodian, creating their relationship when it does
   * not exist yet. The name must not match another wallet of that entity and custodian, ignoring case.
   */
  dvCreateCustodianWallet: DVCustodianWallet;
  /** Create entity */
  dvCreateEntity: DVEntity;
  /** Schedule Haruko data backfill requests for a date range and set of endpoints. */
  dvCreateHarukoBackfillRequests: Scalars['Int']['output'];
  /**
   * Propose a new internal_movements row — a cross-custodian rebalancing transfer for one trading
   * entity (via custodianWalletFromId/custodianWalletToId). Recordkeeping only: never posts to the ledger, never
   * affects any account's reported balance. Opens an INTERNAL_MOVEMENT_CREATE maker-checker request;
   * nothing is written until it reaches quorum.
   */
  dvCreateInternalMovement: DVMakerCheckerRequest;
  /**
   * Propose a new ledger_transactions entry — DEPOSIT, WITHDRAWAL, TRANSFER, or INTEREST. Opens a
   * LEDGER_TRANSACTION_CREATE maker-checker request; nothing posts to the ledger until it reaches
   * quorum.
   */
  dvCreateLedgerTransaction: DVMakerCheckerRequest;
  /** Open a maker-checker request. The command is stored and executes only after quorum. */
  dvCreateMakerCheckerRequest: DVMakerCheckerRequest;
  /** Create a new netting set for grouping trades under a CSA */
  dvCreateNettingSet: DVNettingSet;
  dvCreateNettingSetParams: DVNettingSetParams;
  /** Create a consolidated netting set rule (replaces separate dvCreateNettingSetParams + dvCreateCollateralRule) */
  dvCreateNettingSetRule: DVNettingSetRule;
  /**
   * Enter an obligation by hand, or reissue one, replacing the call it supersedes. Opens a
   * SETTLEMENT_OBLIGATION_CREATE maker-checker request: NOTHING is written until a second person approves,
   * so this returns the request, not the obligation. Its id appears on the request's resultRefs once
   * executed.
   */
  dvCreateObligation: DVMakerCheckerRequest;
  /**
   * Book N trades atomically as a CFTC-reportable package. Generates one package
   * identifier and stamps the three package-price fields onto every leg. Any single
   * trade failing validation or insert rolls back all N.
   */
  dvCreatePackage: DVPackage;
  /** Create product */
  dvCreateProduct: DVProduct;
  /**
   * Net the obligations selected into one settlement. Takes effect immediately, with no approval: the net
   * follows from the rows picked rather than being entered, and nothing has left the firm yet. Where the
   * account's settlement automation is on, hand-entered obligations other than VM go on a settlement of
   * their own, apart from the automatic ones.
   */
  dvCreateSettlement: DVSettlement;
  /**
   * Kicks off asynchronous generation of a statement and returns immediately.
   * It produces one row per file the account has enabled for the statementType
   * in its statement file settings, all sharing one requestId. An account with
   * no enabled file gets no rows and an empty requestId.
   * Each returned statement starts PENDING; poll its status separately once a
   * statement query exists.
   */
  dvCreateStatement: CreateDvStatementOutput;
  /** Create a new timing rule for a CSA */
  dvCreateTimingRule: DVTimingRule;
  /** Create a new trade */
  dvCreateTrade: DVTrade;
  /**
   * Deactivates an ACTIVE version of the model by appending an INACTIVE row, so
   * the previous active version, or the code default, resolves again. Refused
   * when the model stores no such version or it is already INACTIVE.
   */
  dvDeactivateVarParameters: DvVarParameters;
  dvDeleteAccountCSA: Scalars['Boolean']['output'];
  dvDeleteAccountNettingSet: Scalars['Boolean']['output'];
  /** Delete asset */
  dvDeleteAsset: Scalars['Boolean']['output'];
  dvDeleteCSA: Scalars['Boolean']['output'];
  /**
   * Soft delete CSA margin terms by setting status to 'Terminated'
   * This preserves the record for historical reference while preventing its use
   */
  dvDeleteCSAMarginTerms: Scalars['Boolean']['output'];
  /**
   * Soft delete collateral rule by setting status to 'Terminated'
   * This preserves the record for historical reference while preventing its use
   */
  dvDeleteCollateralRule: Scalars['Boolean']['output'];
  /** Delete entity */
  dvDeleteEntity: Scalars['Boolean']['output'];
  /** Delete one or more scheduled or failed Haruko backfill jobs by ID. */
  dvDeleteHarukoBackfillRequests: Scalars['Boolean']['output'];
  /**
   * Soft delete netting set by setting status to 'Terminated'
   * This preserves the record for historical reference while preventing its use
   */
  dvDeleteNettingSet: Scalars['Boolean']['output'];
  dvDeleteNettingSetParams: Scalars['Boolean']['output'];
  /** Delete a consolidated netting set rule (soft-delete by setting end_date) */
  dvDeleteNettingSetRule: Scalars['Boolean']['output'];
  /** Delete product */
  dvDeleteProduct: Scalars['Boolean']['output'];
  /** Delete a timing rule */
  dvDeleteTimingRule: Scalars['Boolean']['output'];
  /**
   * Deliver a client report via SFTP
   * Uploads a file to the SFTP pending bucket for delivery to the specified client.
   */
  dvDeliverClientReport: Scalars['Boolean']['output'];
  /**
   * Deliver the monthly transfer activity file to Cryptio
   * Generates the month from Haruko, or uploads the CSV given instead, and returns the object path written.
   */
  dvDeliverCryptioTransferActivity: Scalars['String']['output'];
  /** Dequeue a QUEUED or FAILED client email so it is never sent */
  dvDequeueClientEmail: DVClientEmail;
  /** Discard a QUEUED ICE/SDR report with an optional reason */
  dvDiscardIceReport: DVICEReport;
  /**
   * Dismiss a STAGED closeout without booking it, recording the caller, the time and the reason.
   * A closeout in any other status is rejected.
   */
  dvDismissStagedCloseout: DVStagedCloseout;
  /**
   * Run the action of an approved maker-checker request whose action defers execution. executionInput
   * optionally carries execute-step data for the handler, as a JSON object string.
   */
  dvExecuteMakerCheckerRequest: DVMakerCheckerRequest;
  /** Exercise a trade */
  dvExerciseTrade: DVTrade;
  /** Expire a trade */
  dvExpireTrade: DVTrade;
  /**
   * Finalize a post-priced package as a single unit: every still-estimated leg gets its
   * determined price and the package price/spread trio gets its determined value, atomically.
   * Each leg reports to the SDR as a non-correction modification (CFTC §43.3(a)(4)).
   */
  dvFinalizePackagePrice: DVPackage;
  /**
   * Starts the workflow that queues a PENDING_APPROVAL margin call notice for
   * every CSA with a non-zero VM transfer in the newest succeeded margin run
   * dated asOfDate, and returns its workflow id. Each run supersedes the CSA's
   * earlier pending notices for that date. Errors if asOfDate is in the future.
   */
  dvGenerateMarginCallNotices: DvGenerateMarginCallNoticesPayload;
  /** Invalidate a lifecycle event (e.g., closeout) */
  dvInvalidateLifecycleEvent: DVTradeLifecycleEvent;
  /** Cancel, void, or forcefully terminate a trade */
  dvKillTrade: DVTrade;
  /**
   * Confirm a settlement was met, attaching the money in the same step. Temporary, alongside
   * dvConfirmSettlement, for a caller not yet using dvSaveSettlementMovements.
   */
  dvMarkSettlementSettled: DVMakerCheckerRequest;
  /** Mature a trade */
  dvMatureTrade: DVTrade;
  /**
   * Novate a trade: fully close out its remaining exposure and book a new trade with the same
   * economics on a different account. Returns the new trade.
   */
  dvNovateTrade: DVTrade;
  /** Create the account's Haruko venue for the given purpose in the given group. */
  dvProvisionHarukoVenue: DVAccount;
  /**
   * Queue a CFTC correction (Correction=Y) of a trade ICE already accepted, built from the
   * trade's current state, as a new QUEUED report at the next negative version. It is never
   * submitted automatically: submit it with dvSubmitIceReport or discard it with
   * dvDiscardIceReport. Errors when reason is blank, when no report of the trade was accepted
   * by ICE, while the newest SUBMITTED report has not reached ICE, while a report of the trade
   * is QUEUED or FAILED, when the trade was removed from ICE, and for a trade the live flow
   * does not report
   */
  dvQueueIceCorrection: DVICEReport;
  /**
   * Render the trade confirmation PDF and queue it as a client email awaiting review. If the caller
   * may send client emails and auto-send is enabled, it is also sent automatically once due.
   */
  dvQueueTradeConfirmationEmail: DVClientEmail;
  /**
   * Rebuild a live trade ICE/SDR report's submission XML from its version's lifecycle event
   * and set it QUEUED, creating the report when the version has none. At the version that
   * invalidated the event just before it, rebuild or create the INVALIDATE report from that
   * event, once ICE has accepted the event's report. Give reportId, or tradeId with version.
   * correction is required for a new AMENDMENT report and refused otherwise. Errors for
   * every version the live flow would not report, for a SUBMITTED or DISCARDED report, for
   * an invalidation the lifecycle cannot settle, and when a newer version of the trade is
   * already SUBMITTED
   */
  dvRegenerateIceReport: DVICEReport;
  /**
   * Starts the submissionType report workflow for asOfDate with a new
   * submission, stored as that date's next attempt with its own report files in
   * GCS. Earlier attempts and their files stay as they are. The report uses the
   * newest succeeded margin run dated asOfDate, but reads account LEIs,
   * ice_reporting_disabled and trade details as they are now. The report goes
   * to ICE when dvt-part45-reporting-enabled is on, and ends SKIPPED otherwise.
   * Returns the new submission's id and the workflow id without waiting.
   * Errors if asOfDate is after today in New York.
   */
  dvRegeneratePart45Report: DvRegeneratePart45ReportPayload;
  /**
   * Rejects a client email, moving it from PENDING_APPROVAL to REJECTED.
   * Errors if it isn't currently PENDING_APPROVAL.
   */
  dvRejectClientEmail: DvClientEmail;
  /** Requeue a FAILED client email for another send attempt */
  dvRequeueClientEmail: DVClientEmail;
  /**
   * Requeue a FAILED ICE/SDR report back to QUEUED for another submission attempt.
   * Errors if the report is not FAILED
   */
  dvRequeueIceReport: DVICEReport;
  /** Reschedule one or more failed Haruko backfill jobs. */
  dvRescheduleHarukoBackfillRequests: Scalars['Boolean']['output'];
  /**
   * Restore a DISCARDED ICE/SDR report back to QUEUED so it can be reviewed and submitted,
   * with an optional reason. Errors if the report is not DISCARDED, if it is a correction
   * report (queue a new correction instead), or if the reason is whitespace-only
   */
  dvRestoreIceReport: DVICEReport;
  /**
   * Propose the reversal of an existing internal_movements row, named by its own id. Opens an
   * INTERNAL_MOVEMENT_REVERSE maker-checker request; nothing is written until it reaches quorum.
   */
  dvReverseInternalMovement: DVMakerCheckerRequest;
  /**
   * Propose the reversal of an existing ledger_transactions entry, named by its own id — for a
   * TRANSFER this always reverses both of its postings together as one unit, never a single leg.
   * Opens a LEDGER_TRANSACTION_REVERSE maker-checker request; nothing posts to the ledger until it
   * reaches quorum.
   */
  dvReverseLedgerTransaction: DVMakerCheckerRequest;
  /**
   * Correct a package flagged post-priced by mistake: every leg drops the flag and any
   * finalization atomically, and each previously reported leg re-reports to the SDR as a
   * correction (STAGED legs were never reported and do not).
   */
  dvRevertPackagePostPriced: DVPackage;
  /**
   * Starts a VaR run against Haruko and returns as soon as the run has an id,
   * leaving the pricing to finish behind it. Poll dvVarRun(id:) for the
   * outcome. Every input field is optional - the ones set sweep that parameter
   * off the governed set, which marks the run as ungoverned.
   */
  dvRunVar: RunDvVarOutput;
  /**
   * Attach the ledger rows backing a settlement, replacing whatever was attached before. Immediate, no
   * approval: run it as many times as it takes before confirming. Refused once settled or cancelled. Only
   * deposits and withdrawals count toward the net; any other row is attached at 0. A TRANSFER is refused
   * where confirm records the settlement's bucket moves itself.
   */
  dvSaveSettlementMovements: DVSettlement;
  /** Review and send a QUEUED client email via the notification service */
  dvSendClientEmail: DVClientEmail;
  /**
   * Submits submissionId's already-generated report to ICE - the
   * human-in-the-loop path for a submission the scheduled, flag-gated
   * workflow left at SKIPPED (or FAILED). Errors if the submission doesn't
   * exist, has no report generated yet (no gcsUri), is not the latest attempt
   * for its date, or was already submitted (a second call, or a race with the
   * scheduled path, both surface as a plain error rather than a duplicate ICE
   * submission). Returns immediately
   * with the submission at status PROCESSING; it reaches a terminal status
   * (PROCESSED/REJECTED/HOLD) on its own, visible via dvPart45Submission(id).
   */
  dvSendToICE: DvPart45Submission;
  /** Turn VM obligation generation from margin runs on or off for one CSA. Changes nothing else on the CSA */
  dvSetCSAGenerateVMObligations: DVCSA;
  /** Enable or disable a Haruko group for new venues. */
  dvSetHarukoGroupEnabled: DVHarukoGroup;
  /**
   * Map an ingest chat (e.g. telegram:-1004392170456) to the enabled account its
   * ingested trades book into. Re-mapping an already mapped chat moves it.
   */
  dvSetIngestChatAccount: DVIngestChatAccount;
  /** Turns an existing setting on or off. Errors when the setting does not exist. */
  dvSetStatementFileSettingEnabled: DvStatementFileSetting;
  /**
   * Run margin now, outside the daily end-of-day run. Returns once the run is queued rather than
   * once it has finished, so poll dvMarginRuns for the outcome. asOfTs is the instant positions and
   * the ledger are read at, defaulting to now; the run is recorded under its New York date.
   * valuationTs is the instant marks price at, defaulting to the 16:00 New York on or before asOfTs.
   * A date already running is refused, and every run is a new row, so a re-run supersedes the
   * earlier one rather than replacing it.
   *
   * Positions are the trades open at asOfTs plus any in tradeIds, rebuilt as of asOfTs. accountId
   * values every trade on those accounts in its current state instead, meaning the trade row as it
   * stands: quantity closed out, reduced IM and status. tradeIds values only the listed trades in
   * their current state, and takes precedence over accountIds for which trades that covers. A listed
   * trade booked after asOfTs is in the run, and a current-state trade no longer ACTIVE drops out.
   * Every CSA is still calculated and the run is firm-wide. Ledger balances are still read at
   * asOfTs. A listed trade outside accountIds, or an unknown trade, is refused.
   */
  dvStartMarginRun: DVStartedMarginRun;
  /**
   * Submit a QUEUED ICE/SDR report to ICE.
   * Errors if the report is no longer QUEUED
   */
  dvSubmitIceReport: DVICEReport;
  /** Refresh the Haruko group list from Haruko and return every stored group. */
  dvSyncHarukoGroups: Array<DVHarukoGroup>;
  /** Update account */
  dvUpdateAccount: DVAccount;
  /** Update asset */
  dvUpdateAsset: DVAsset;
  dvUpdateCSA: DVCSA;
  /**
   * Update existing CSA margin terms
   * Creates a new version starting from NOW() and archives the previous version
   */
  dvUpdateCSAMarginTerms: DVCSAMarginTerms;
  /**
   * Update existing collateral rule
   * Creates a new version starting from NOW() and archives the previous version
   */
  dvUpdateCollateralRule: DVCollateralRule;
  /**
   * Update an existing counterparty master copy record.
   * PUT semantics - full replacement; an omitted field is cleared (set to NULL)
   */
  dvUpdateCounterpartyMasterCopy: DVCounterpartyMasterCopy;
  /** Update entity */
  dvUpdateEntity: DVEntity;
  /**
   * Update existing netting set
   * Creates a new version starting from NOW() and archives the previous version
   */
  dvUpdateNettingSet: DVNettingSet;
  dvUpdateNettingSetParams: DVNettingSetParams;
  /** Update a consolidated netting set rule */
  dvUpdateNettingSetRule: DVNettingSetRule;
  /** Update product */
  dvUpdateProduct: DVProduct;
  /** Update an existing timing rule */
  dvUpdateTimingRule: DVTimingRule;
  /**
   * Void an obligation entered by mistake, keeping its row with the reason. Opens a
   * SETTLEMENT_OBLIGATION_VOID maker-checker request: nothing changes until a second person approves. Only
   * an open, ungrouped, hand-entered obligation can be voided; a grouped one needs dvCancelSettlement first.
   */
  dvVoidObligation: DVMakerCheckerRequest;
  /**
   * Record an approve or reject vote on a pending request. A reject terminates it; an approve
   * that reaches quorum executes it.
   */
  dvVoteMakerCheckerRequest: DVMakerCheckerRequest;
  /**
   * Writes a new ACTIVE version of the model's governed parameter set. The input
   * carries the whole set; nothing is inherited from the active version. The set
   * is checked the way a run checks it, at today's 16:00 New York valuation
   * instant. Refused when the model already stores the version, when the label is
   * empty, contains +, or is a code default's label (1.0.0, pfe-1.0.0,
   * pfe-1.1.0), or when the set fails the check. Runs whose valuation instant
   * falls after the write resolve it.
   */
  dvWriteVarParameters: DvVarParameters;
  /**
   * Edits a AML questionnaires.
   *
   * The submission must exist; answers are always validated for
   * completeness.
   */
  editAML: EditAMLResult;
  /** Edit an existing comment on the client dashboard */
  editClientOperationComment: Scalars['Boolean']['output'];
  /**
   * Edit the cost basis for a B2B deposit transaction.
   * Wraps the UpdateCostBasis flow; DEPOSIT-only, max 100 lots.
   */
  editCostBasis: EditCostBasisPayload;
  /** Edit a manual attribution to a given list of operations */
  editDepositAttributions: Scalars['Boolean']['output'];
  /** Edits global trusted sources in batch */
  editGlobalTrustedSources: Scalars['Boolean']['output'];
  /** Edit a operations' description */
  editOperationDescription: Scalars['Boolean']['output'];
  /** Edit the spam attribution data of a set of deposit operations */
  editSpamAttributionData: Scalars['Boolean']['output'];
  /** Edit single trusted source status */
  editTrustedSourceStatus: Scalars['Boolean']['output'];
  /** Edit trusted sources in batch */
  editTrustedSources: Scalars['Boolean']['output'];
  /** Enable a module for all organizations on a given operator */
  enableModuleForOperator: Scalars['Boolean']['output'];
  /** Enable a module for a list of organizations */
  enableModuleForOrganizations: Scalars['Boolean']['output'];
  /** Enables subaccounts for an Organization */
  enableSubaccountsForOrganization: Scalars['Boolean']['output'];
  /** Endorse an operation */
  endorse: Scalars['Boolean']['output'];
  /**
   * Endorses an operation during risk review.
   *
   * Note: only transfer operations are supported for now.
   */
  endorseRiskReview: Scalars['Boolean']['output'];
  /**
   * Start the cash-interest enrollment cascade (WM-919/WM-1097) for an org and
   * every sibling org under the same Anchorage Account: grants each the
   * fiat-interest MSA amendment, enrolls their subaccounts' fiat wallets with
   * the Interest service, and sets the org and subaccount flags. Staff-only.
   * Async — enrollment may not be complete on return.
   */
  enrollOrgForFiatInterest: EnrollOrgForFiatInterestResult;
  /** Enrolls all of an organization's top level affiliates in stablecoin rewards */
  enrollOrganizationInStablecoinRewards: Maybe<EnrollOrganizationInStablecoinRewardsResult>;
  /** Enrolls participants in a specified program using their participant IDs */
  enrollStablecoinRewardsParticipantsInProgram: EnrollStablecoinRewardsParticipantsInProgramResult;
  /** Retrieves a new enrollment token, if orgPolicyScopes or Scopes(in vaultPolicyActions) are present, they are used, otherwise, their respective orgPolicyActions and actions (within vaultPolicyAction) are used instead */
  enrollToken: Scalars['String']['output'];
  /** Add a new user */
  enrollUser: Scalars['String']['output'];
  /** Enrolls a user key and returns the user ID. */
  enrollUserKey: Scalars['String']['output'];
  /**
   * Establish a WalletConnect connection (aka session) for the wallet.
   * NOTE: naming GraphQL `...Connection` causes `make lint-graphql` to fail with
   *   A field that returns a Connection Type must include forward pagination arguments (`first` and `after`)...
   *   - see https://relay.dev/graphql/connections.htm#sec-Reserved-Types
   */
  establishWalletConnectSession: EstablishWalletConnectSessionResponse;
  /**
   * Executes a batch of Filecoin miner balance withdrawals one after another.
   * This creates one filecoin::miner::withdraw_balance generic operation for each
   * inputted entry.
   */
  executeFilecoinMinerBalanceWithdrawals: ExecuteFilecoinMinerBalanceWithdrawalsPayload;
  /** Save/update an external account location */
  externalAccountLocationSave: Scalars['Boolean']['output'];
  /** Delete external account locations */
  externalAccountLocationsDelete: Scalars['Boolean']['output'];
  /** Save/update an external account */
  externalAccountSave: Scalars['Boolean']['output'];
  /** Save/update an external account transaction */
  externalAccountTransactionSave: Scalars['Boolean']['output'];
  /** Set account id to given value for all external account transactions for given org */
  externalAccountTransactionSetAccountIDForAllTransactionsInOrg: Scalars['Int']['output'];
  /** Set account id to given value for specific external account transaction */
  externalAccountTransactionSetAccountIDForTransaction: Scalars['Boolean']['output'];
  /** Delete external account transactions */
  externalAccountTransactionsDelete: Scalars['Boolean']['output'];
  /** Delete external accounts */
  externalAccountsDelete: Scalars['Boolean']['output'];
  /** fails an operation: DON'T DO THIS UNLESS YOU ARE 100% SURE IT'S NOT IN THE BLOCKCHAIN AND IT CAN'T END UP IN THE BLOCKCHAIN */
  failOperation: Scalars['Boolean']['output'];
  /** Create a new fee type in the registry */
  feeTypeCreate: FeeTypePayload;
  /**
   * Edit an existing fee type, producing a new ACTIVE version and marking the previous version
   * INACTIVE
   */
  feeTypeUpdate: FeeTypePayload;
  /** Submits general customer feedback */
  feedbackSubmitGeneral: GeneralFeedbackResponse;
  /**
   * This is deprecated, please use SubmitNewAssetFeedback.
   * Submits new asset feedback.
   * @deprecated Use submitNewAssetFeedback instead
   */
  feedbackSubmitNewAsset: NewAssetFeedbackResponse;
  /**
   * Approve a pending agreement or amendment: applies the given terms to it, activates it, and, if it
   * supersedes an earlier active version, marks that version AMENDED.
   *
   * Reuses FeesAgreementUpdateInput, but note input.id here must be the PENDING version being
   * approved, not the currently active version that field's own doc describes - approving is not an
   * amendment, so there is no active version to require instead.
   */
  feesAgreementApprove: FeesAgreementPayload;
  /** Create a new fees agreement */
  feesAgreementCreate: FeesAgreementPayload;
  /**
   * Reject/cancel a pending agreement or amendment before it is approved: PENDING -> CANCELED.
   * Any existing active terms are left untouched.
   */
  feesAgreementReject: FeesAgreementPayload;
  /**
   * Request termination of an active fees agreement: moves its active version to
   * TERMINATION_IN_REVIEW and records the requested termination date. Approving or rejecting that
   * request is a separate mutation.
   */
  feesAgreementTerminate: FeesAgreementPayload;
  /**
   * Approve or reject a pending termination request (TERMINATION_IN_REVIEW). Approving moves it to
   * TERMINATED or TERMINATION_UPCOMING depending on the requested termination date; rejecting returns
   * it to ACTIVE. Only approving requires the reviewer to differ from whoever requested the
   * termination - a requester can reject (cancel) their own termination request.
   */
  feesAgreementTerminationApprove: FeesAgreementPayload;
  /**
   * Cancel a TERMINATION_UPCOMING agreement, reverting it to ACTIVE: no approval step, no
   * maker/reviewer restriction. The canceller replaces the original approver on the record.
   */
  feesAgreementTerminationCancel: FeesAgreementPayload;
  /**
   * Amend an existing fees agreement. Naming the active version creates a new pending version; naming
   * your own still-pending version instead overwrites it in place. A stale id or someone else's pending
   * version is rejected.
   */
  feesAgreementUpdate: FeesAgreementPayload;
  /** fillAffiliateFormData fills the form data for an affiliate and creates it's corresponding individuals, then submits the form for the affiliate and its individuals */
  fillAffiliateFormData: Scalars['Boolean']['output'];
  /**
   * Auto-fills KYC form data for testing purposes (non-production environments only).
   * Generates test data for all required fields and creates/submits forms for
   * the KYC profile and any associated individuals specified by name.
   *
   * This is a development/testing utility and will only work when auto-fill is enabled.
   */
  fillKYCProfileFormData: Scalars['Boolean']['output'];
  /**
   * Autofills and submits an existing KYCQuestionnaireSubmission (e.g. an RFI)
   * in place, by ID, forcing it to Complete regardless of starting state.
   * Disabled outside non-prod environments. Valid from INIT, SENT, and
   * IN_PROGRESS; rejected for COMPLETED, CANCELED, and EXPIRED.
   */
  fillKYCQuestionnaireSubmissionData: Scalars['Boolean']['output'];
  /**
   * Creates a test organization with configurable KYC handling.
   * Returns existing org if one with the same name exists.
   * This is a oneshot operation for e2e tests - no polling/retry loops for external services.
   */
  findOrCreateTestOrganization: TestOrganizationResult;
  /** Fixes invalid policy container ids and missing organization key names. */
  fixInvalidOrganization: Scalars['Boolean']['output'];
  /**
   * STAFF-ONLY: Fix missing role bindings for key accesses (users) based on quorum membership
   *
   * For each organization:
   * - Org-level quorum users → roles/root/organization.admin + roles/root/legacy.viewOnly
   * - Vault-level quorum users → roles/root/vault.operator
   *
   * Only adds missing role bindings. Idempotent.
   * Returns the result containing both successful and failed organization key IDs.
   */
  fixKeyAccessesRoleBindings: FixKeyAccessesRoleBindingsResult;
  /** Fixes missing bindings between Persons and Institutional Individuals. */
  fixPersonIndividualBindings: FixPersonIndividualBindingsResult;
  /**
   * forceRefreshOrganization will send a request to the HSM to immediately refresh the signature
   * an organization, regardless of time remaining to expiry. This is useful for situations where
   * we rely on the refresh path of the HSM to make upgrades to the schema of organizations.
   */
  forceRefreshOrganization: Scalars['Boolean']['output'];
  /**
   * Freeze a v4 account for compliance. Staff-only. Sets the compliance (staff)
   * freeze only; a freeze the customer set through the API is separate and is not
   * touched. The reason is required and is stored with the account's
   * ACCOUNT_FROZEN event for audit; it is never sent to the customer.
   *
   * Freezing an account that compliance already froze does nothing and records no
   * new event. Rejected for an account that is not OPEN.
   */
  freezeAccount: FreezeAccountResult;
  /** Funds an address for the given asset type with the given amount. */
  fund: Scalars['Boolean']['output'];
  /** Funds a subaccount for the given asset type with the given amount. */
  fundSubaccount: Scalars['Boolean']['output'];
  /**
   * Approve or reject a delegation activity via click-button method.
   * The caller must represent a party configured for click-button approval
   * on the delegation's usage rights for the activity's action type.
   * When reject is true, the running workflow is cancelled (triggering hold
   * compensation) and the activity status transitions to REJECTED.
   * While the activity is SELECT_WALLETS, the pledgor may reject it whatever its
   * approval method, and nobody may approve it. While it is AWAITING_FUNDS, nobody
   * may approve or reject it.
   */
  gdfApproveDelegationActivity: ApproveDelegationActivityResponse;
  /** create a control agreement */
  gdfControlAgreementCreate: CreateControlAgreementResponse;
  /** update a control agreement's documentID */
  gdfControlAgreementUpdateDocumentID: UpdateControlAgreementDocumentIDResponse;
  /**
   * Create a standalone (WPA-backed) delegation between two enrolled
   * participants. Staff only. When delegatedAssets are provided, the increase
   * workflow starts and the pledgor approves the WPA change that places the
   * delegation's holds.
   */
  gdfDelegationCreate: GDFDelegationCreateResponse;
  /**
   * Settle assets out of or into a delegation by mutual authorization. The caller
   * must represent a party the delegation's settle rights allow to propose, and
   * each leg names one of its own wallets; the pledgor's quorum approves. Returns
   * the settle activity's ID; the settlement runs asynchronously on the
   * delegation's adjustment workflow.
   */
  gdfDelegationSettle: GDFDelegationSettleResponse;
  /**
   * Manage delegations for a control agreement (increase, or decrease).
   * The provided delegation must already exist.
   */
  gdfManageDelegationForControlAgreement: ManageDelegationForControlAgreementResponse;
  /**
   * Create an OES (Off-Exchange Settlement) agreement between a trader (the pledgor) and an exchange
   * (the secured party) on the exchange's current OES terms. Only staff and the trader's organization
   * may create one.
   */
  gdfOESAgreementCreate: GDFOESAgreementCreateResponse;
  /**
   * Append a new immutable version of an exchange's OES (Off-Exchange Settlement) terms profile.
   * Staff only. Control agreements already created from earlier versions are never modified;
   * the new version applies to relationships created after it.
   */
  gdfOESExchangeProfileUpsert: GDFOESExchangeProfile;
  /** enroll a gdf participant */
  gdfParticipantEnroll: GDFEnrollement;
  /**
   * gdfRedeemPreauthorization starts the WPA execute (redemption) workflow for a
   * delegation: it records a seize activity and transfers the delegated assets to
   * the secured party's destination per leg. Returns the started Temporal
   * workflow ID.
   */
  gdfRedeemPreauthorization: RedeemPreauthorizationResponse;
  /**
   * Staff recovery tool for holds a workflow left behind: releases only holds custody
   * records as the delegation's, with no workflow and no party approval.
   */
  gdfReleaseDelegationHolds: ReleaseDelegationHoldsResponse;
  /**
   * Rescind a Notice to Contest, restoring the CA to Active status and
   * reverting the delegation's quorum policy to its pre-contest values.
   * Staff only.
   */
  gdfRescindContestNotice: RescindContestNoticeResponse;
  /**
   * Select the pledgor's wallets for a pledge or unlock the secured party proposed. The activity
   * must be SELECT_WALLETS and the caller must represent the pledgor. The selection restates the
   * proposal with a wallet on every entry: the same assets, each adding up to the proposed amount.
   * An asset may be split across wallets. A pledge's wallets must be in the agreement's vault on
   * the asset's network, and need not hold the funds yet. An unlock's wallets must each pledge at
   * least what they unlock. The pledgor's quorum is asked to endorse once the selection is accepted.
   */
  gdfSelectDelegationActivityWallets: SelectDelegationActivityWalletsResponse;
  /**
   * Contest a control agreement (Notice to Contest). Atomically flips the
   * delegation's quorum policy to Joint-only and transitions CA status to
   * "In Dispute". The CA otherwise remains active and in-progress operations
   * continue under the Joint policy. Both staff and org users may initiate.
   */
  gdfSuspendControlAgreement: SuspendControlAgreementResponse;
  /** Terminate an active control agreement. */
  gdfTerminateControlAgreement: TerminateControlAgreementResponse;
  /**
   * Generates a new REST API key. This key will be associated with
   * the provided email. If no email is provided, the email of the
   * logged in user will be used instead.
   *
   * This mutation returns the API key. It is the only time such key
   * will be shared.
   */
  generateAPIKeyWithPayload: GenerateAPIKeyPayload;
  /** Generates and returns a monthly trading PDF statement for the specified organization and month. */
  generateMonthlyTradingStatement: TradingStatement;
  /**
   * Generates a signed URLs to upload documents related
   * to compliance alerts
   */
  generateMultiSignedURLs: Array<UploadSignedUrl>;
  /** Generates and returns an order-based monthly trading PDF statement for the specified organization and month. */
  generateOrderBasedMonthlyTradingStatement: TradingStatement;
  /** Creates new unused addresses for the give wallet ID - for UTXO wallets only (ie, BITCOIN_MAINNET) */
  generatePoolAddressesForWalletID: Scalars['String']['output'];
  /**
   * Generates a signed URL to upload documents related
   * to compliance alerts
   */
  generateSignedURLToUploadDocsForComplianceAlerts: Scalars['String']['output'];
  /** Creates an API key with a caller-supplied secret. Test-only. Returns an error outside EnvironmentLocal / EnvironmentDevelopment. */
  generateTestAPIKey: GenerateAPIKeyPayload;
  /**
   * Returns a URL that can be used to access the form
   * The "formType" can be one of client, affiliate or individual.
   */
  getFormSessionURL: Scalars['String']['output'];
  /**
   * Returns a URL that can be used to access the form
   * for a given kyc profile
   */
  getFormUrl: Scalars['String']['output'];
  /**
   * Provision a session for a submission and return the form URL without sending
   * any email. When the input omits a representative, the authenticated staff
   * user's email is used.
   */
  getKYCQuestionnaireSubmissionURL: Scalars['String']['output'];
  /** Requests a quote given the provided request. If no quote can be provided this mutation returns */
  getQuote: Maybe<Quote>;
  /** Get the verified ABI for a contract/chain and store the ABI in blockchaindb. */
  getVerifiedABI: VerifiedAbiResponse;
  iamRoleAddUsers: Scalars['Boolean']['output'];
  iamRoleUpdateUsers: Scalars['Boolean']['output'];
  /** importETHValidatorSet can be used to import a validator list into our database */
  importETHValidatorSet: Scalars['Boolean']['output'];
  /**
   * Oncall-only: replays a LexisNexis alert-update to unblock a stuck alert
   * when the webhook/subscriber path has failed.
   */
  injectLexisNexisUpdate: Scalars['Boolean']['output'];
  /** Invalidates an enrollment token. */
  invalidateEnrollment: Scalars['Boolean']['output'];
  ipAllowlistConfigUpsert: IPAllowlistConfig;
  ipAllowlistEntriesDelete: Scalars['Int']['output'];
  ipAllowlistEntriesUpsert: Array<IPAllowlistEntry>;
  /** One-time backfill of every organization's legacy env-var IP allowlist into the DB-backed store. Idempotent; safe to re-run. */
  ipAllowlistMigrateFromEnvVar: IPAllowlistMigrateFromEnvVarResult;
  ipAllowlistSetEntitlement: IPAllowlistConfig;
  /**
   * Unfreezes every target in one transaction and returns the rows as stored, in input order.
   * Requires the FREEZE_WITHDRAWAL_ACCESS permission.
   */
  liftRestrictions: Array<RestrictionRecord>;
  /** Marks a list of affiliateV2, its relationships and accountsV2 as deleted */
  markAffiliatesV2AndAccountsV2AsDeleted: Scalars['Boolean']['output'];
  /** Marks deposit attributions as non-attributable for all given operation IDs */
  markDepositAttributionsAsNonAttributable: Scalars['Boolean']['output'];
  /**
   * Cancel a report file verification so the generated report is not delivered.
   * Only valid for verifications still pending review; an already-verified (delivered)
   * file cannot be canceled. To produce a corrected report after canceling, regenerate the schedule.
   */
  markReportFileVerificationAsCanceled: ReportFileVerification;
  /**
   * Mark a report file verification as verified and initiate delivery to SFTP destination.
   * This mutation is called by the external verification system after a file has been verified.
   */
  markReportFileVerificationAsVerified: ReportFileVerification;
  /** Marks the shares associated with the user as exported */
  markWalletRecoveryKeySharesExported: Scalars['Boolean']['output'];
  /** Merge individual data from multiple individuals into a single individual */
  mergeIndividuals: Scalars['Boolean']['output'];
  /** Merges a list of persons into one, the first in the list. */
  mergePersons: Scalars['Boolean']['output'];
  /**
   * Merges multiple related party KYC profiles into a single target profile.
   * The source profiles will be merged into the target profile.
   * Returns true if the merge was successful.
   */
  mergeRelatedPartyKycProfiles: Scalars['Boolean']['output'];
  /** Merges a list of top level affiliates and their accounts into a single top level affiliate */
  mergeTopLevelAffiliatesAndAccounts: Scalars['Boolean']['output'];
  migrateOrgsToSharedPolicies: Scalars['Boolean']['output'];
  /**
   * Triggers a migration of role bindings in the organizations.
   * dryRun parameter is used to test the migration without actually applying it.
   * One of the following migration options must be chosen:
   * - migrateAll: migrate all organizations
   * - organizations: migrate only the specified organizations
   * - chunkSize: migrate only the specified number of organizations
   */
  migrateRoles: Scalars['Boolean']['output'];
  /** Notify the execution of an order. Generates and sends the notification. */
  notifyOrderExecution: Scalars['Boolean']['output'];
  /** Marks an OPEN cycle CLOSED so the next one can open. Later, settlement closes cycles instead. Development and staging only. */
  nxtTfcCloseCycle: NxtTfcCloseCyclePayload;
  /** Seeds and opens cycle cycleNo for the owner from the snapshot. Idempotent for the same snapshot. Development and staging only. */
  nxtTfcOpenCycle: NxtTfcOpenCyclePayload;
  /** open a scanning issue */
  openScanningIssue: Scalars['Boolean']['output'];
  /** This takes a "prepared" operation (not a staged one) and makes it visible in the app and triggers a push notification to make sure the user can get to the operation easily on the app and endorse it. */
  operationMakeVisibleInOperationsList: Scalars['Boolean']['output'];
  /**
   * An easier to use and signatureless API for rejecting operations
   * The same can be achieved with the endorse API, but it requires a signature, which can make UX unnecessarily annoying and isn't usable from the client dashboard
   * This is usable only by org users for now (not staff users) because we need to record which user rejected it
   */
  operationReject: Scalars['Boolean']['output'];
  /** Pause an active coinductor automation policy. Returns the updated policy. */
  pauseCoinductorAutomationPolicy: CoinductorAutomationPolicy;
  /** Initiates the monthly payout workflow. */
  payMonthlyStablecoinRewards: PayMonthlyStablecoinRewardsRewardsResult;
  /** Add a new manual attribution to a given list of operations */
  performManualDepositAttributions: Scalars['Boolean']['output'];
  placeHoldsForActiveSubscriptions: PlaceHoldsForActiveSubscriptionsResult;
  placeTradingStrategyCollateralHolds: Array<TradingStrategyCollateralHold>;
  /**
   * prepareActionFromJSONForm validates and prepares a completed JSON form for execution.
   * The form data is validated against the enriched JSON Schema before processing.
   */
  prepareActionFromJSONForm: PrepareActionFromJSONFormPayload;
  /**
   * Request the preparation of an add fiat trusted destination operation
   * It returns a generic operation for developer friendliness but it will
   * always be of type "GenericOrgChange"
   */
  prepareAddFiatTrustedDestination: Operation;
  /**
   * Request the preparation of an add trusted destination operation
   * It returns a generic operation for developer friendliness but it will
   * always be of type "AddTrustedDestinationOperation".
   */
  prepareAddTrustedDestination: Operation;
  /**
   * Request the preparation of an AuthorizeSpender operation.
   * As opposed to create, prepare requires a clientID.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "AuthorizeSpender".
   *
   * For simplicity, the address of the "spender" will be filled in by the
   * server. If this becomes parametrizable in the future, a field will be
   * added here.
   */
  prepareAuthorizeSpender: Operation;
  /** Prepare a BinaryAttestation OffChainOperation and return the endorsement bundle. */
  prepareBinaryAttestation: PrepareBinaryAttestationPayload;
  /** Request the preparation of a organization change operation. This will be a single operation with multiple changes. */
  prepareCreateGenericOrganizationChange: Operation;
  /** Prepare an operation to rename one or more keys' display names. */
  prepareCreateKeyRename: Operation;
  /** Create a new policy */
  prepareCreateNewPolicy: Operation;
  /**
   * Create a new policy for organizations with conditions enabled. Returns
   * PendingPolicyChange when the policy is assigned to resources, or PolicyV2
   * when unassigned.
   */
  prepareCreatePolicyV2: PolicyV2WriteResult;
  /**
   * Request the preparation of a create vault operation
   * As opposed to create, prepare requires a clientID.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "CreateVaultOperation".
   * @deprecated Use 'prepareCreateVaultWithNewPolicyV2' or 'prepareCreateVaultWithExistingPolicy'
   */
  prepareCreateVault: Operation;
  /** Create vault with existing group ID */
  prepareCreateVaultWithExistingPolicy: Operation;
  /** Create vault and associate a new policy with it */
  prepareCreateVaultWithNewPolicy: Operation;
  /**
   * Create vault and associate a new policy with it. Accepts the V2 rule format
   * (quorum/block outcomes; conditions on specific rules). Gated on the
   * shared-policies-conditional-rules-enabled feature flag.
   */
  prepareCreateVaultWithNewPolicyV2: Operation;
  /**
   * Request the preparation of a delegation operation.
   * As opposed to create, prepare requires a clientID.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "DelegateOperation".
   */
  prepareDelegation: Operation;
  /**
   * Request the preparation of a disable vault operation
   * As opposed to create, prepare requires a clientID.
   * Disable the vault with the given vault sub ID
   */
  prepareDisableVault: Operation;
  /** Prepare the creation of a generic operation */
  prepareGenericOperation: Operation;
  /**
   * Request the preparation of a Lock operation.
   * As opposed to create, prepare requires a clientID.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "Lock".
   */
  prepareLock: Operation;
  /**
   * Request the preparation of a one-off operation.
   * As opposed to create, prepare requires a clientID.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "OneOffOperation".
   *
   * This is deprecated to reduce our attack surface, use one-off type specific mutations
   * @deprecated Use one-off type specific mutations
   */
  prepareOneOff: Operation;
  /** Create a raw transaction approval org change. */
  prepareRawTransactionApproval: Scalars['String']['output'];
  /**
   * Request the preparation of a remove fiat trusted destination operation.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "GenericOrgChange". Removal goes through quorum approval;
   * the trusted destination is removed from the organization blob and the fiat
   * record is disabled once the operation completes.
   */
  prepareRemoveFiatTrustedDestination: Operation;
  /**
   * Request the preparation of a remove trusted destination operation
   * As opposed to create, prepare requires a clientID.
   * Returns either a "RemoveTrustedDestinationOperation" or "GenericOrgChangeOperation".
   */
  prepareRemoveTrustedDestination: Operation;
  /**
   * Request the preparation of a remove user operation
   * As opposed to create, prepare requires a clientID.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "UserRemoveOperation".
   */
  prepareRemoveUser: Operation;
  /** Replace policy assigned to resource */
  prepareReplacePolicyAssignment: Operation;
  /**
   * Request the preparation of an organization change operation that adds and/or
   * removes approved Turnkey binary configs. Both lists may be combined in a single
   * operation to support atomic rotation (remove old config + add new config in one
   * quorum-approved change).
   */
  prepareTurnkeyBinaryConfigChange: Operation;
  /**
   * Request the preparation of an Unlock operation.
   * As opposed to create, prepare requires a clientID.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "Unlock".
   */
  prepareUnlock: Operation;
  /**
   * Request the preparation of a org policy update operation
   * As opposed to create, prepare requires a clientID.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "OrgPolicyChangeOperation.
   * @deprecated Use 'prepareUpdatePolicyV2'
   */
  prepareUpdateOrgPolicy: Operation;
  /** Update policy by group ID */
  prepareUpdatePolicy: Operation;
  /** Update an existing policy. Same return semantics as prepareCreatePolicyV2. */
  prepareUpdatePolicyV2: PolicyV2WriteResult;
  /**
   * Request the preparation of a vault policy update operation
   * As opposed to create, prepare requires a clientID.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "VaultPolicyChangeOperation".
   * @deprecated Use 'prepareUpdatePolicyV2'
   */
  prepareUpdateVaultPolicy: Operation;
  /**
   * Request the preparation of a Vote operation.
   * Deprecated: Governance is no longer supported. Retained for backward
   * compatibility with older iOS clients; always returns an error. Safe to
   * delete once the minimum supported iOS version is v2.111.0.
   * @deprecated Governance has been removed. This mutation always returns an error.
   */
  prepareVote: Operation;
  /**
   * Request the preparation of a withdrawal operation.
   * It returns a generic operation for developer friendliness but it will
   * always be of type "WithdrawOperation".
   * Call the PrepareWithdrawal query with one of the following parameter groups populated.
   * Group 1 - walletID
   * Group 2 - vaultSubID and assetSubID
   * ALL parameters in ONE AND ONLY ONE group of the two above groups MUST be populated.
   * -- the "ONLY ONE" rule applies to both Source and Destination (with slight variation).
   * -- though, Source and Destination can provide different groups.
   * Slight variation:
   * -- for Source, if vaultSubID is provide, assetSubID must also be provided.
   * -- for Destination, if vaultSubID is provide, assetSubID is still optional
   *    (if not provided, would default to first asset in the given vault).
   */
  prepareWithdrawal: Operation;
  /**
   * MAKER step (one-shot): file a manual deposit when a bank received funds but
   * the normal webhook/polling/MT path didn't deliver. The exception is created
   * directly at PENDING_APPROVAL (data + proposal set together). Checker uses
   * reviewOpsException as for any other type. Approval drives the bank's natural
   * deposit workflow via the layer-6 routing logic (adapter inline / CRB synth
   * Resource / CB pre-store Cubix row). Per-bank required fields are enforced
   * server-side by the option-A required-field set; missing required field for
   * the chosen bank → VALIDATION_ERROR naming the field(s).
   */
  proposeManualDeposit: OpsExceptionMutationResult;
  /**
   * MAKER step: propose an override (empty overrides = retry without change).
   * Proposer identity comes from ctx, never the request body.
   */
  proposeOpsExceptionOverride: OpsExceptionMutationResult;
  /**
   * MAKER step for unassigned_deposit_attribution: attribute a parked deposit to
   * the corrected receiving account, or reject the attribution outright. ATTRIBUTE
   * resolves correctedReceivingAccountID via the organic bank_info matcher and
   * freezes the result (wallet/org/client name) into the proposal so the checker
   * approves a named client, not an opaque account ID; an unresolvable ID refuses
   * with VALIDATION_ERROR before the exception ever reaches the approval queue.
   * Checker uses the existing reviewOpsException mutation, as for any other type.
   */
  proposeUnassignedDepositAttribution: OpsExceptionMutationResult;
  /** Creates a new address for the given vault, asset and asset type */
  provisionAddress: Scalars['String']['output'];
  /** Enqueues affiliate KYC screening requests. */
  queueAffiliateKYCScreening: Scalars['Boolean']['output'];
  /** Enqueues individual KYC screening requests. */
  queueIndividualKYCScreening: Scalars['Boolean']['output'];
  /**
   * Rebuild all policy container groups for the given organization.
   * This deletes all existing policy container groups and recreates new ones based on the
   * current state of the organization. Custom group names and unassigned policies are NOT
   * preserved by this operation. Prefer refreshPolicyContainerGroups unless a full reset is needed.
   */
  rebuildPolicyContainerGroups: Scalars['Boolean']['output'];
  /** Rebuilds the index that tracks which organization a user belongs to. */
  rebuildUserToOrganizationIndex: Scalars['Boolean']['output'];
  /** Completes an operation. Don't do this unless you understand the consequences. */
  recklesslyCompleteOperationIKnowWhatImDoing: Scalars['Boolean']['output'];
  /** Fetches historical prices from configured sources and inserts/overwrites rows. */
  refillPriceHistory: Scalars['Boolean']['output'];
  /**
   * Refresh all policy container groups for the given organization based on the current state
   * of the organization, without deleting existing groups first. Groups are upserted by group ID,
   * so custom group names are preserved and unassigned policies are left untouched.
   */
  refreshPolicyContainerGroups: Scalars['Boolean']['output'];
  /**
   * Re-read a VIEW-backed report type's columns from BigQuery and report how they
   * differ from its stored snapshot. Staff only.
   *
   * Diff-then-apply: the default call reads BigQuery and writes nothing, so the
   * difference can be reviewed first. Applying is a behavior-mutating write — a
   * column's type is what resolves a header's automatic cast, so a new snapshot
   * changes the SQL the next generated report runs — and it goes through the same
   * validation as any other write.
   *
   * Rejected, leaving the stored snapshot untouched: a source that is not
   * allow-listed or cannot be read; a source that is not a warehouse-managed
   * relation (a view, a materialized view or a table are all accepted — an external
   * table or a snapshot is not); a refreshed schema missing the type's
   * orgColumnName, or no longer spelling it STRING; a refreshed schema that turns a
   * column the type emits or predicates on into a repeated one, or into one of a
   * type no report can project. A column of an unprojectable type that no header or
   * filter names is recorded like any other — the view is wider than the report.
   * Columns merely disappearing is NOT rejected — they are reported in
   * staleHeaderSourceColumns / staleFilterSourceColumns, since the view has already
   * changed and refusing to record that only hides it.
   */
  refreshReportTypeSchema: ReportTypeSchemaDiff;
  /**
   * Regenerate a schedule's report for a given reference time after the source data has been fixed.
   * The regenerated report replaces the earlier one: any prior verification still pending review is
   * canceled, and a fresh report is generated and enters verification.
   */
  regenerateReportSchedule: Report;
  /** Registers a token for push notifications */
  registerDeviceToken: Scalars['Boolean']['output'];
  /** TODO: add description */
  registerWebhookEndpoint: WebhookEndpoint;
  releaseTradingStrategyCollateralHold: Scalars['Boolean']['output'];
  /**
   * Removes an affiliate from a client org (reused affiliates only).
   * Blocked when the affiliate has open accounts under this client.
   * Staff only. Legacy path - tracked debt: ONMON-5007.
   */
  removeAffiliateFromClient: Scalars['Boolean']['output'];
  /**
   * Removes an affiliate KYC profile from one or more organization KYC profiles.
   * This severs the relationship between the affiliate and the specified organizations.
   * Staff only.
   */
  removeAffiliateKycProfile: Scalars['Boolean']['output'];
  /** Removes a representative of the affiliate */
  removeAffiliateRepresentative: Scalars['Boolean']['output'];
  /** Removes an enablement status override for a given asset, organization and entity */
  removeAssetEnablementStatusOverride: Scalars['Boolean']['output'];
  /** Removes an asset from an existing program by deleting it, so rewards stop accruing for it. */
  removeAssetFromStablecoinRewardsProgram: RemoveAssetFromStablecoinRewardsProgramResult;
  /** Removes global trusted sources by their IDs */
  removeGlobalTrustedSources: Scalars['Boolean']['output'];
  /** Removes an individual from an affiliate */
  removeIndividualFromAffiliate: Scalars['Boolean']['output'];
  /** Removes a representative of the individual */
  removeIndividualRepresentative: Scalars['Boolean']['output'];
  /**
   * Removes a related party KYC profile from one or more affiliate KYC profiles.
   * This severs the relationship between the related party and the specified affiliates.
   * Staff only.
   */
  removeRelatedPartyKycProfile: Scalars['Boolean']['output'];
  /** Removes related party relations from multiple affiliates */
  removeRelatedPartyRelationships: Scalars['Boolean']['output'];
  /**
   * Removes a representative from a KYC profile (affiliate or related party).
   * This soft-deletes the association but keeps the representative profile.
   * Returns true on success.
   */
  removeRepresentative: Scalars['Boolean']['output'];
  /** Remove a scheduled report */
  removeScheduledReport: Scalars['Boolean']['output'];
  /** Remove a scheduled report subscriber */
  removeScheduledReportSubscriber: Scalars['Boolean']['output'];
  /**
   * Removes participants from the specified program using their participant IDs
   * and program IDs.
   */
  removeStablecoinRewardsParticipantsFromProgram: RemoveStablecoinRewardsParticipantsFromProgramResult;
  /**
   * Remove a (subaccount, asset) pair from the true-up skip list so the asset trues
   * up normally again. Staff-only. Removing a pair that is not skipped is a no-op.
   */
  removeTrueUpSkip: TrueUpSkipResult;
  /** Removes a set of trusted sources defined for deposit attributions */
  removeTrustedSources: Scalars['Boolean']['output'];
  /** removeValidatorFromAllowlist removes a validator from the staking allowlist. */
  removeValidatorFromAllowlist: Scalars['Boolean']['output'];
  /**
   * Retrieves a replacement token that can be used to replace the device associated
   * with
   * the provided user key ID.
   *
   * If no user key ID is provided, the replacement token refers to the caller.
   */
  replaceToken: Scalars['String']['output'];
  /**
   * Regenerates a single address for the given AssetID.
   * This is used re-encrypt the Wallet Key backups for the addreses using the
   * current organization quorum.
   */
  reprovisionAddress: Scalars['Boolean']['output'];
  /** Re-queue blockchain screening rows (TTRM Toolbox). Returns the count re-queued. */
  rescreenBlockchainScreening: Scalars['Int']['output'];
  /** Resends an affiliate form to a specific representative. */
  resendAffiliateForm: Scalars['Boolean']['output'];
  /** Resends an individual form to a representative of that individual. */
  resendIndividualForm: Scalars['Boolean']['output'];
  /** Resend an existing order execution notification. Does not generate a new notification. */
  resendOrderExecutionNotification: Scalars['Boolean']['output'];
  /** Make the given list of vaults the only ones allowed for the DApp. */
  resetAllowedVaultsForDApp: ResetAllowedVaultsForDAppResponse;
  /** Resets the screening state of in-flight deposit attributions so they can be screened again */
  resetDepositAttributionScreening: Scalars['Boolean']['output'];
  /** resetNetwork resets a network */
  resetNetwork: Scalars['Boolean']['output'];
  /** resignTransaction moves a broadcasting transaction to resign */
  resignTransaction: Scalars['Boolean']['output'];
  /** resolve a scanning issue */
  resolveScanningIssue: Scalars['Boolean']['output'];
  /** Restore a comment on the client dashbaord */
  restoreClientOperationComment: OperationComment;
  /** Resume a paused coinductor automation policy. Returns the updated policy. */
  resumeCoinductorAutomationPolicy: CoinductorAutomationPolicy;
  /**
   * Voids the current DocuSign envelope and resends a new one.
   * Only valid when the transfer is in AwaitSignature status.
   */
  retriggerDocuSign: Transfer;
  /**
   * Re-run the opening for a v4 account stuck in OPENING after its automatic
   * opening failed for good (IAS-254). Staff-only. Starts under the same
   * workflow id the automatic opening used: a re-run on an account whose
   * opening is still running attaches to that run instead of starting a
   * second one; a re-run after a failed run starts fresh. Rejected, with no
   * workflow started, when the account is not in orgId, is a legacy account
   * (not created through the v4 accounts API), or is not in the OPENING state.
   */
  retryAccountOpening: RetryAccountOpeningResult;
  /**
   * Records a staff review of a withdrawal request at PENDING_REVIEW, then wakes its workflow.
   * An approval releases the withdrawal to the bank and takes no rejectionReason; a rejection needs one and fails the withdrawal with it.
   */
  reviewFiatWithdrawalRequest: Scalars['Boolean']['output'];
  reviewMovementOfFundsStatus: MovementOfFunds;
  /**
   * CHECKER step: approve/reject a pending proposal. Self-review is rejected by
   * the logic layer (maker-checker).
   */
  reviewOpsException: OpsExceptionMutationResult;
  /** Revokes an API key */
  revokeAPIKeyWithErrors: RevokeAPIKeyPayload;
  /** Permanently revoke a coinductor automation policy. Returns the updated policy. */
  revokeCoinductorAutomationPolicy: CoinductorAutomationPolicy;
  /** Revokes all user keys that are not part of any organization. */
  revokeRemovedKeys: Scalars['Boolean']['output'];
  /** Create RIA fee configurations */
  riaCreatFeeConfiguration: Scalars['String']['output'];
  /** Endorses an operation */
  riskEndorse: Scalars['Boolean']['output'];
  /**
   * Copy the SessionID from generate_session_id in your client dashboard (check your network tab)
   * Use a known robot name in the org you want to authenticate into. If you don't provide one, we'll use a random one.
   */
  roboLogin: Scalars['Boolean']['output'];
  /**
   * Triggers a rollback of role bindings in the organization.
   * rollbackAll applies the rollback to all organizations.
   */
  rollbackMigrateRoles: Scalars['Boolean']['output'];
  /**
   * Starts a balance audit in the background and returns `true` without waiting for it.
   * Read the results with `getAuditReport` or `getMultiBalanceSourceAuditReport`.
   *
   * - **Joins a matching manual run.** If a manual run with the same scope is already
   *   in progress, this call joins it instead of starting a new one.
   * - **Same scope** means the same `networkID`, or both calls omit it.
   */
  runAuditReport: Scalars['Boolean']['output'];
  /** sanitizeAddress checks the validity of an address and provides the canonical form of the address. */
  sanitizeAddress: SanitizeAddressPayload;
  /** saveSettings creates or updates a given setting */
  saveDocumentDeliverySetting: Scalars['Boolean']['output'];
  /** Save KYCQuestionnaireSubmission mutation. */
  saveKYCQuestionnaireSubmission: Maybe<SaveKYCQuestionnaireSubmissionResponse>;
  /** Save a scanning issue */
  saveScanningIssue: Scalars['Boolean']['output'];
  /**
   * scanBlock scans from a starting block, 0 is unlimited.
   * By default, the mutation is disabled for networks where rescans are known to be unsafe (currently all Solana networks, due to how stake accounts are tracked). Set overrideDisabledNetwork to true to bypass this check.
   */
  scanBlock: Scalars['Boolean']['output'];
  /**
   * scanBlockInterval starts a workflow to scan the given interval of blocks.
   * By default, the mutation is disabled for networks where rescans are known to be unsafe (currently all Solana networks, due to how stake accounts are tracked). Set overrideDisabledNetwork to true to bypass this check.
   */
  scanBlockInterval: WorkflowID;
  /**
   * scanDateInterval starts a workflow to scan transactions within a date range
   * using the historical provider (BigQuery) if the blockchain supports it.
   * Similar to scanBlockInterval but uses dates instead of block numbers.
   * By default, the mutation is disabled for networks where rescans are known to be unsafe (currently all Solana networks, due to how stake accounts are tracked). Set overrideDisabledNetwork to true to bypass this check.
   */
  scanDateInterval: ScanDateIntervalResult;
  /**
   * Schedule organizations for shared policies migration on a given date.
   * Organizations go through: SCHEDULED → READY → COMPLETE.
   */
  scheduleSharedPoliciesMigration: ScheduleOrganizationMigrationResult;
  seAssignDeposit: Scalars['ID']['output'];
  seAssignWithdrawal: Scalars['ID']['output'];
  seCreateLocation: Scalars['ID']['output'];
  seCreateTransfer: Scalars['ID']['output'];
  seReverseTransfer: SETransfer;
  seUpdateLocation: Scalars['ID']['output'];
  seUpdateTransfer: Scalars['ID']['output'];
  /**
   * Sends a KYC form to a representative for the specified KYC profile.
   * Creates a session and sends an email with a link to fill out the form.
   * Works for affiliates, related parties, and organizations.
   *
   * If the representative doesn't exist, a new representative will be created
   * (representativeName is required in this case).
   */
  sendForm: Scalars['Boolean']['output'];
  /**
   * Sends an invitation email to the address associated with the enroll token
   * or the one specified one instead, if provided.
   */
  sendInvitationEmailForEnrollment: Scalars['Boolean']['output'];
  /**
   * Sends KYCEvent mutation.
   * This triggers the same actions defined in the kyc process triggers as if
   * it was a jira case transition.
   */
  sendKYCEvent: Scalars['Boolean']['output'];
  /**
   * Send a submission to its representative(s). Registers a session and emails
   * the form link. When the input omits a representative, the form is resent to
   * the representative(s) already linked to the submission. Returns true on
   * success.
   */
  sendKYCQuestionnaireSubmission: Maybe<Scalars['Boolean']['output']>;
  /** Submits Referral form */
  sendReferralWorkflowSubmission: Scalars['Boolean']['output'];
  /**
   * Delivers a test webhook to an endpoint right away. eventTypeID must be one of the event types
   * the endpoint is subscribed to. The payload is a fixed placeholder shaped like the event's real
   * payload, and the delivery is encrypted exactly as a real one is when the endpoint has a public key.
   */
  sendTestWebhook: Scalars['Boolean']['output'];
  /** Send emails for statements that can but haven't been sent yet */
  sendUnsentStatementEmails: Scalars['Boolean']['output'];
  /** Approve service fee terms termination */
  serviceFeeTermsApproveTermination: ServiceFeeTermsPayload;
  /** Cancel pending service fee terms */
  serviceFeeTermsCancel: ServiceFeeTermsPayload;
  /** Configure new service fee terms */
  serviceFeeTermsCreate: ServiceFeeTermsPayload;
  /** Terminate service fee terms */
  serviceFeeTermsTerminate: ServiceFeeTermsPayload;
  /** Update existing service fee terms */
  serviceFeeTermsUpdate: ServiceFeeTermsPayload;
  /** Sets the asset enablement status of an asset for a given entity. */
  setAssetEnablementStatus: Scalars['Boolean']['output'];
  /** Sets an enablement status override for a given asset, organization and entity */
  setAssetEnablementStatusOverride: Scalars['Boolean']['output'];
  /**
   * Set tags for an asset type. This operation replaces all existing tags
   * with the provided list of tags and returns the current tags.
   */
  setAssetTags: SetAssetTagsPayload;
  /** setAssociatedAddress sets the associated address for a given addressID */
  setAssociatedAddress: Scalars['Boolean']['output'];
  /** Sets whether a specific organization can trade only in crypto. Returns true if the operation was successful */
  setCryptoOnly: Scalars['Boolean']['output'];
  /** setETHStakingProviderForVault sets the preferred ETH validator provider for a specific vault */
  setETHStakingProviderForVault: Scalars['Boolean']['output'];
  /** TODO: add description */
  setEnabledWebhookEventTypes: Scalars['Boolean']['output'];
  /** setEthereumStakingProvidersConfigurationForOrg sets the organization staking configurations of all staking providers */
  setEthereumStakingProvidersConfigurationForOrg: Scalars['Boolean']['output'];
  /** SetExemptPII allows us to skip a piece of PII if not available (example: videos) */
  setExemptPII: Scalars['Boolean']['output'];
  /**
   * Enables or disables a feature for the supplied organization. Returns true if the operation was successful
   * TODO: migrate existing apps to this one and drop devdebug's
   * @deprecated Client-facing features are deprecated. Use a LaunchDarkly feature flag to roll a feature out to every organization, or an organization module for a feature that organizations opt into.
   */
  setFeatureEnabled: Scalars['Boolean']['output'];
  /** Sets a fixed price for conversion between two assets. */
  setFixedPrice: Scalars['Boolean']['output'];
  /**
   * Sets the flow address for the given AssetID
   * This is used to bootstrap the root account that creates other flow accounts
   * Refused on Flow mainnet
   * Only accepts Flow asset types
   */
  setFlowAddress: Scalars['Boolean']['output'];
  /**
   * Sets a specific form to a specific status.
   * The "formType" can be one of client, affiliate or individual.
   */
  setFormStatus: Scalars['Boolean']['output'];
  /** Sets the gas station wallet, only for use in tests. */
  setGasStationForTestOnly: Scalars['Boolean']['output'];
  /**
   * Sets the hedera address for the given AssetID
   * This is used to bootstrap the root account that creates other hedera accounts
   * Only accepts Hedera asset types
   */
  setHederaAddress: Scalars['Boolean']['output'];
  /** setLastLoginDate forces last login date for testing purposes, namely quorum liveness */
  setLastLoginDate: Scalars['Boolean']['output'];
  /** Marks a device as having been lost */
  setLostDevice: Scalars['Boolean']['output'];
  /** Sets the notification count for the current user's device */
  setNotificationCount: Scalars['Boolean']['output'];
  /** Updates the current access policy values for a given organization. Currently, only web session expiry is implemented, but this should include source IP requirements in the future. */
  setOrganizationAccessPolicy: SetOrganizationAccessPolicyPayload;
  /**
   * Disable or re-enable an organization
   * Set disabled True to disable, False to re-enable
   */
  setOrganizationDisabled: Scalars['Boolean']['output'];
  /**
   * Sets the status of an organization KYC profile.
   * Returns the updated organization KYC profile ID and status.
   * Note: This is currently a stub implementation returning dummy data for development purposes.
   */
  setOrganizationKycProfileStatus: SetOrganizationKycProfileStatusResult;
  /**
   * Sets the notes for a given organization. Edits existing notes or creates
   * them if they don't exist.
   */
  setOrganizationNotes: Scalars['Boolean']['output'];
  /** Set a new organization wire fee config */
  setOrganizationWireFeeConfig: Scalars['Boolean']['output'];
  /**
   * Sets the price symbol conversion for the from/to asset pair for a specified
   * source.
   */
  setPriceSymbolConversion: Scalars['Boolean']['output'];
  /**
   * Replace a report type's entire filter-definition set in one transaction. Staff
   * only.
   *
   * The input is the full desired state: filters not listed are removed. Exactly one
   * filter must be the main filter.
   */
  setReportTypeFilterDefinitions: ReportTypeDefinition;
  /**
   * Replace a report type's entire header set in one transaction. Staff only.
   *
   * The input is the full desired state: headers not listed are removed. An MT-format
   * report type takes no headers at all.
   */
  setReportTypeHeaders: ReportTypeDefinition;
  /**
   * Replace a report type's entire validation set in one transaction. Staff only.
   *
   * The input is the full desired state: validations not listed are removed, and an
   * empty list clears them. Each routine's BigQuery signature is checked against the
   * contract for its kind before anything is written.
   */
  setReportTypeValidations: ReportTypeDefinition;
  /**
   * setSLAForOrg sets the current sla for the organization
   * Note that this doesn't affect existing operations.
   * the sla parameter is a duration string (e.g. "24h", or "12h30m")
   * from the first time the operation entered risk review
   */
  setSLAForOrg: Scalars['Boolean']['output'];
  /**
   * Sets an address to be of type SpecialAddressType, true means it got to the watcher
   * This is attached to an address that is already created, but does not have a SpecialAddressType yet
   */
  setSpecialAddress: Scalars['Boolean']['output'];
  /**
   * Set a subaccount's segregation flag (`is_segregated`). Staff-only. This is the
   * flag half of making a subaccount segregated; the primary wallet link is
   * established separately via createAndLinkSubaccountWallet. (WM-474)
   */
  setSubaccountSegregation: SetSubaccountSegregationResult;
  /**
   * Sets the customer override value for the supplied organization.
   * Customer override takes place when the client facing feature flag CUSTOMER_OVERRIDE is enabled for the organization.
   * The customer value is used within Talos to represent our side as one of the counterparties in a trade.
   */
  setTalosCustomer: Scalars['Boolean']['output'];
  /** Sets whether a list of users can trade. Returns the list of traders updated */
  setTraders: Array<Scalars['String']['output']>;
  /**
   * Sets the value of a personal identifiable information for a user. Creates a new
   * personal identifiable information attribute, if it doesn't exist
   */
  setUserPII: Scalars['Boolean']['output'];
  /**
   * Update vesting info for an asset. NOTE: rescan blockchain after the vesting info is set, so the vest contract address balance is correctly accounted for.
   * The runbook for celo is here https://docs.google.com/document/d/1WM8Wo9OHHuzibQcPbQ16o4FBENL1WfHtWgJUEtOyNaM/edit#heading=h.2eormx3sovz0
   */
  setVestingInfo: Maybe<VestingInfo>;
  /** Set Wallet key PDF export preference */
  setWalletKeyExportPreference: SetWalletKeyExportPreferenceResponse;
  /**
   * Toggles exclusion for UTXOs or whole pooled addresses in one of the caller's own wallets.
   * Exactly one of utxos / addressSubIDs must be non-empty. Address targets expand to the
   * address's eligible UTXOs as read just before the write; a deposit that lands between that read
   * and the write keeps its state and shows up on the next call. The write is one transaction:
   * either every eligible target changes or nothing does. Targets that cannot change (spent, held
   * for another reason, unknown, already in the requested state) are reported SKIPPED with a
   * reason, including a target spent between the read and the write.
   */
  setWalletUtxoExclusion: UtxoExclusionResult;
  /** Share invoices by email with PDF attachments */
  shareInvoicesByEmail: ShareInvoicesByEmailPayload;
  /** Share tax documents by email with PDF attachments */
  shareTaxDocumentsByEmail: ShareTaxDocumentsByEmailPayload;
  /** Add a trusted counterparty to a list of partipants. Description is copied to each participant. */
  snAddTrustedCounterparties: Array<SNTrustedCounterparty>;
  /**
   * Create a settlement network participant from a given account ID. The caller must have access to the account.
   * The name is set based on the name of the affiliate that the account is associated with.
   */
  snParticipantCreate: SNParticipant;
  /**
   * Update a settlement network participant. Some fields are staff-only and some fields can be set by the user.
   * If there's no comment on a field, it's a staff-only field.
   */
  snParticipantUpdate: SNParticipant;
  /**
   * Release holds with the given IDs for the given settlement.
   * Only used from retool.
   */
  snReleaseHolds: SNReleaseHoldsResponse;
  /**
   * Accepts an incoming settlement and sets the wallets, returns the settlement if successful.
   *
   * New wallets will be created for any missing wallet amounts, provided a vaultID is given.
   */
  snSettlementAccept: SNTwoWaySettlement;
  /**
   * Overrides the settlement acceptance for a participant.
   * Approval requires prior wallet selection for the participant's side.
   * Rejection is only possible
   * Only applicable to development environment.
   */
  snSettlementApprovalOverride: SNTwoWaySettlement;
  /** Cancel a created settlement, returns the settlement if successful */
  snSettlementCancel: SNTwoWaySettlement;
  /** Rejects an incoming settlement, returns the settlement if successful */
  snSettlementReject: SNTwoWaySettlement;
  /** Update a trusted counterparty for a participant */
  snUpdateTrustedCounterparty: SNTrustedCounterparty;
  /**
   * stagedOrganizationComplete completes the staged organization and creates an add organization operation
   * returns the operation id
   */
  stagedOrganizationComplete: Maybe<Scalars['String']['output']>;
  /** Creates a new StagedOrganization */
  stagedOrganizationCreate: StagedOrganization;
  /**
   * TESTING ONLY. Finds the staged organization with this name and operator, or creates it with
   * server-generated, deterministic keys for the given users. Refused outside local and development.
   */
  stagedOrganizationCreateForTesting: StagedOrganization;
  /** stagedOrganizationDelete sets the deleted flag on the staged org and removes all existing enrollments */
  stagedOrganizationDelete: Scalars['Boolean']['output'];
  /** stagedOrganizationUpdate updates a staged organization. It takes the old and new versions (as JSON) and safely updates it. */
  stagedOrganizationUpdate: StagedOrganization;
  /** stagedOrganizationUpdateV2 updates a staged organization. Instead of relying on the clients manipulating the definition, it has inputs */
  stagedOrganizationUpdateV2: StagedOrganization;
  /** Starts an add user operation for the given enroll token. */
  startAddUserOperation: Scalars['String']['output'];
  /** Starts dynamic CRR calculation */
  startDynamicCRRCalculation: Scalars['Boolean']['output'];
  /**
   * Start a full quorum recovery for the given organization.
   * The number of lost keys must meet the user replace quorum threshold.
   */
  startFullQuorumRecovery: Scalars['Boolean']['output'];
  /** Starts the background operations for a token swap. */
  startTokenSwap: StartTokenSwapResult;
  /**
   * Start an asynchronous batch activation of wallets on new networks.
   *
   * This creates a cross-product: for N source wallets and M target networks,
   * up to N×M new wallet records are created, each reusing the wallet_sub_id
   * from its source wallet.
   *
   * All source wallets must be in the same vault and same provisioning group.
   * All target networks must be in the same provisioning group as the sources.
   *
   * Idempotent: If a wallet already exists for (vault, network, wallet_sub_id),
   * it is returned without error.
   *
   * Returns a workflow ID that can be used to query activation status via
   * walletActivationBatch(workflowID).
   */
  startWalletActivationBatch: WalletActivationBatchResponse;
  startWalletBulkCreate: WalletBulkCreateResponse;
  /**
   * Creates signed URLs for the given statement type and IDs.
   * Creates a timed signed URL from GCP for each statement.
   */
  statementsV2CreateSignedStatementURLs: StatementsV2CreateSignedStatementURLsResult;
  /**
   * Publishes statements so they are visible to clients.
   * Statements are filtered for all the provided IDs in the given months.
   * Months must be formatted as an integer matching YYYYMM.
   * If a month/ID combination is not found, there will be no error.
   * Returns an error if both statementIDs and coverageStartMonthsAsYYYYMM are empty.
   * Response is the number of statements that have been published.
   */
  statementsV2PublishStatements: StatementsV2PublishStatementsResult;
  /** Adds a new schedule for generating statements. */
  statementsV2ScheduleCreate: StatementsV2ScheduleCreateResult;
  /**
   * Triggers the generation of statements for a given statement type and filter
   * configuration. The result of this mutation is a trigger ID that can be used to
   * check the status of the generation process.
   */
  statementsV2StatementGenerateAsync: StatementsV2StatementGenerateAsync;
  /** storeABIManual stores an ABI manually for a contract address without verification */
  storeABIManual: Scalars['Boolean']['output'];
  /** Transfers funds from the commingled wallet to a program customer wallet for gas fees */
  subaccountGasFillWallet: Scalars['Boolean']['output'];
  /** Sweep deposited funds on a subaccount linked wallet to the commingled wallet */
  subaccountSweepBetweenWallets: Scalars['Boolean']['output'];
  /** Sweep deposited regular commingled and withdrawal commingled */
  subaccountSweepCommingledWallets: Scalars['Boolean']['output'];
  /** Sweep deposited funds on a subaccount linked wallet to the commingled wallet */
  subaccountSweepLinkedWallet: Scalars['Boolean']['output'];
  /**
   * SubmitNewAssetFeedback persists new asset request feedback to Google Sheets and creates a Slack notification. It should be used over the deprecaed FeedbackSubmitNewAsset endpoint.
   * At least one of requestedAssetTypeID and contractAddress must be provided.
   */
  submitNewAssetFeedback: NewAssetFeedbackResponse;
  /** Allows the submission of ad-hoc PII */
  submitPII: Scalars['Boolean']['output'];
  /** This sets the control master public key for the current user's staged organization and the private key equivalents for other users. This is called only once pre-onboarding by the last admin and shouldn't need to be called more than once. */
  submitStagedControlKeys: Scalars['Boolean']['output'];
  /**
   * This sets the wallet recovery public key for the organization before it associates the encrypted shares with the users.
   * The wallet recovery public key is signed with the lead admin's encryption key.
   * This mutation is preferred over submitStagedWalletRecoveryKeyShares as we are migrating away from submitting key shares for staged orgs.
   */
  submitStagedWalletRecoveryKey: Scalars['Boolean']['output'];
  /**
   * This sets the wallet recovery public key for the organization and it associates the encrypted shares with the users.
   * The wallet recovery public key is signed with the lead admin's encryption key.
   * This is deprecating as we are moving KeyShares out of organization creations
   * Please use submitStagedWalletRecoveryKey and submitWalletRecoveryKeyShares instead
   * @deprecated use submitStagedWalletRecoveryKey and submitWalletRecoveryKeyShares instead
   */
  submitStagedWalletRecoveryKeyShares: Scalars['Boolean']['output'];
  /**
   * submitWalletRecoveryKeyShares stores and associates encrypted wallet recovery private key shares with users of the organization.
   * This is called after the org is created, once per organization's life span.
   * Will error unless called by org's lead admin.
   */
  submitWalletRecoveryKeyShares: Scalars['Boolean']['output'];
  /**
   * Reconcile each subaccount's program-customer list to exactly what rows
   * specifies — adds new customers, removes any not in the list. Staff-only.
   * idempotencyKey should be caller-supplied and scoped to the specific delivery
   * (e.g. DWP's delivery reference), so re-processing the same data is a no-op
   * rather than a duplicate reconcile. The caller (Retool, a script) is
   * responsible for turning DWP's file into this structured list — this API
   * does not accept or parse a file format itself.
   */
  syncProgramCustomerRoster: SyncProgramCustomerRosterResult;
  /** Sync TaxBit SDK tax-certification-form fields to KYC for the given account. */
  syncTaxCertificationDataToKYC: SyncTaxCertificationDataToKYCPayload;
  /**
   * Tag a transaction for tax purposes (e.g., contribution, rollover, distribution).
   * This operation syncs the tag to TaxBit and records an audit trail entry.
   */
  tagTaxTransaction: TagTaxTransactionPayload;
  /** Mint a TaxBit account-owner token for the affiliate that owns the submission. */
  taxCertificationToken: TaxCertificationToken;
  /** Create a Tax Tenant */
  taxCreateTenant: TaxTenant;
  /** Delete a Tax Tenant */
  taxDeleteTenant: Scalars['Boolean']['output'];
  /** Reconcile tax transactions for trades by fetching trades and syncing missing ones to TaxBit */
  taxReconcileTrades: TaxReconcileTradesResult;
  /** Update a Tax Tenant */
  taxUpdateTenant: Scalars['Boolean']['output'];
  /**
   * Fetch a TaxBit account-owner-scoped bearer token, used by the client
   * dashboard to initialize the TaxBit SDK for a specific account.
   */
  taxbitAccountOwnerToken: TaxbitAccountOwnerTokenPayload;
  /**
   * Terminate a WalletConnect connection to the DApp, eg, Snapshot, for the wallet.
   * NOTE: naming GraphQL `...Connection` causes `make lint-graphql` to fail with
   *   A field that returns a Connection Type must include forward pagination arguments (`first` and `after`)...
   *   - see https://relay.dev/graphql/connections.htm#sec-Reserved-Types
   */
  terminateWalletConnectSession: TerminateWalletConnectSessionResponse;
  /**
   * Terminate a WalletConnect connection to the DApp, eg, Snapshot, for the wallet.
   * NOTE: naming GraphQL `...Connection` causes `make lint-graphql` to fail with
   *   A field that returns a Connection Type must include forward pagination arguments (`first` and `after`)...
   *   - see https://relay.dev/graphql/connections.htm#sec-Reserved-Types
   */
  terminateWalletConnectSessions: TerminateWalletConnectSessionResponse;
  /**
   * Mint or burn a tokenized asset (e.g. tokenized gold). The product and workflow are
   * derived from the asset's config in mintburn, not from this call.
   */
  tokenize: TokenizePayload;
  /** Trade on a quote by quote ID */
  tradeQuote: TradeQuoteResponse;
  /** Save a new settlement address for an asset */
  tradingAddSettlementAddress: Scalars['Boolean']['output'];
  /** Adds a trading symbol */
  tradingAddSymbol: Scalars['Boolean']['output'];
  /** Approve a trading asset update (maker-checker pattern) */
  tradingApproveAsset: Scalars['Boolean']['output'];
  /** Approves an already added trading symbol */
  tradingApproveSymbolByID: Scalars['Boolean']['output'];
  /** Assign/Unassign a client settlement to an op */
  tradingAssignClientSettlement: Scalars['Boolean']['output'];
  /** Cancel a client settlement */
  tradingCancelClientSettlements: Array<Scalars['String']['output']>;
  /** Create a new counterparty */
  tradingCounterpartyCreate: Scalars['ID']['output'];
  /** Activate or deactivate a specific counterparty */
  tradingCounterpartyUpdate: Scalars['ID']['output'];
  /** Creates a new brokerage trading account */
  tradingCreateAccount: TradingAccount;
  /** Create a trading asset */
  tradingCreateAsset: TradingAsset;
  /** Create a client settlement */
  tradingCreateClientSettlement: ClientSettlement;
  /** Created an external asset */
  tradingCreateExternalAsset: TradingExternalAsset;
  /** Creates a client settlement out of a fee */
  tradingCreateFeeClientSettlement: ClientSettlement;
  /** tradingCreateManualOrders creates one or more manual orders. */
  tradingCreateManualOrders: Array<Scalars['ID']['output']>;
  /**
   * Creates a settlement for the given organization and account.
   * The trades are selected based on the filters provided.
   */
  tradingCreateSettlementFromFilters: Settlement;
  /**
   * Create a new Talos account
   * Replaces tradingCreateWhitelabelAccount (deprecated)
   */
  tradingCreateTalosAccount: TradingTalosAccount;
  /** Create a new permission set */
  tradingCreateTradingPermission: Array<TradingPermission>;
  /**
   * Create wallet settlement instructions for Anchorage Client Settlement FBO Org
   * This wallet will be used as the source or destination of the automated
   * RIA/B2B2X settlements
   */
  tradingCreateWalletSettlementInstructions: WalletSettlementInstruction;
  /** Create whitelabel user */
  tradingCreateWhitelabelUser: Maybe<TradingWhitelabelUser>;
  /** Cancels a manual dealer trade */
  tradingDealerManualTradeCancel: Scalars['Boolean']['output'];
  /** Creates a dealer manual trade */
  tradingDealerManualTradeCreate: Scalars['ID']['output'];
  /** Update fields in dealer manual trades */
  tradingDealerManualTradeUpdate: Scalars['Boolean']['output'];
  /** Cancels a dealer settlement */
  tradingDealerSettlementCancel: Scalars['Boolean']['output'];
  /** Creates a dealer settlement */
  tradingDealerSettlementCreate: Scalars['ID']['output'];
  /** Create a dealer settlement with all payment flows with a counterparty and asset */
  tradingDealerSettlementCreateCounterpartyAsset: Scalars['ID']['output'];
  /** Create or preview a dealer settlement creation */
  tradingDealerSettlementCreateFromFilters: DealerSettlement;
  /** Initiates a dealer settlement */
  tradingDealerSettlementInitiate: Scalars['Boolean']['output'];
  /** Settles a dealer settlement */
  tradingDealerSettlementSettle: Scalars['Boolean']['output'];
  /** Updates the transaction IDs of a dealer settlement */
  tradingDealerSettlementUpdateTransactionIDs: Scalars['Boolean']['output'];
  /**
   * Delete a trading asset
   * Currently this is a hard delete, we may want to change this for a soft delete
   */
  tradingDeleteAsset: Scalars['Boolean']['output'];
  /** Delete an external asset */
  tradingDeleteExternalAsset: Scalars['Boolean']['output'];
  /** Delete a trade settlement transaction */
  tradingDeleteTradeSettlementTransaction: Scalars['Boolean']['output'];
  /** Deletes a wallet settlement instruction entry */
  tradingDeleteWalletSettlementInstruction: Scalars['Boolean']['output'];
  /** Delete whitelabel user */
  tradingDeleteWhitelabelUser: Scalars['Boolean']['output'];
  /** Enable/Disables an already added trading symbol */
  tradingEnableSymbolByID: Scalars['Boolean']['output'];
  /** Fixes a specific trading credit discrepancy. */
  tradingFixCreditDiscrepancy: Scalars['Boolean']['output'];
  /** Cancel ledger transaction from input */
  tradingLedgerCancelTransactions: Array<TradingLedgerCancelTransactionResult>;
  /** Create ledger transaction from input */
  tradingLedgerCreateTransactions: Array<Scalars['ID']['output']>;
  tradingLedgerReconcileTransactions: TradingLedgerReconcileTransactionResult;
  /** Link a dealer side order to a client side order */
  tradingLinkClientAndDealerOrders: Scalars['Boolean']['output'];
  /** Process a client settlement */
  tradingProcessClientSettlement: Scalars['Boolean']['output'];
  /**
   * Force-reload the in-memory trading asset caches (internal + external) on the
   * replica that serves this request (not the whole fleet).
   */
  tradingRefreshAssets: Scalars['Boolean']['output'];
  /** Reinitiate a client settlement */
  tradingReinitiateClientSettlement: Scalars['Boolean']['output'];
  /** Add a new trade settlement transaction */
  tradingSaveTradeSettlementTransaction: Scalars['String']['output'];
  /** Updates multiple trading accounts */
  tradingUpdateAccounts: Array<UpdateAccountResult>;
  /** Update a trading asset (name, description, codeAbbreviation, and custodyCode) */
  tradingUpdateAsset: TradingAsset;
  /** Updates trading precision for a symbol */
  tradingUpdateAssetPrecision: Scalars['Boolean']['output'];
  /** Update a backfilled manual order, returns the OrderID of the updated order - TO BE DEPRECATED */
  tradingUpdateBackfilledManualOrder: Scalars['ID']['output'];
  /** Update fiat settlemnt transaction */
  tradingUpdateFiatSettlementTransaction: Scalars['Boolean']['output'];
  /** Update a manual order, returns the OrderID of the newly created order */
  tradingUpdateManualOrder: Scalars['ID']['output'];
  /** Edit already set crypto settlement instruction for both default and org-specific instructions */
  tradingUpdateSettlementAddress: Scalars['Boolean']['output'];
  /** Updates a trading symbol */
  tradingUpdateSymbolByID: Scalars['Boolean']['output'];
  /**
   * Update an existing Talos account
   * Replaces tradingUpdateWhitelabelAccount (deprecated)
   */
  tradingUpdateTalosAccount: TradingTalosAccount;
  /** Update an existing trade settlement transaction */
  tradingUpdateTradeSettlementTransaction: Scalars['Boolean']['output'];
  /** Update whitelabel user */
  tradingUpdateWhitelabelUser: Scalars['Boolean']['output'];
  /** Enable or disable TravelRule autosend */
  travelRuleSetAutomation: Scalars['Boolean']['output'];
  /**
   * Triggers a refresh of static development enrollment tokens (in devtokens.go).
   * As an alternative to re-populating the dev environment, this mutation will add any missing enrollments.
   * This assumes the development organizations already exists, each with at least one devtoken.
   */
  triggerDevTokenRefresh: Scalars['String']['output'];
  /**
   * Trigger the fiat (USD) wallet backfill workflow, creating missing BNY USD
   * wallets for eligible RIA PROGRAM_CUSTOMER subaccounts (staff/dev only). Returns
   * the started workflow ID. The backfill is idempotent (already-linked subaccounts
   * are skipped), so it is safe to re-run; a run whose prior attempt FAILED may be
   * retried under the same label, and a fresh label starts a new run. Note: if the
   * backfill kill-switch (ledger-fiat-wallet-backfill-enabled) is off, the run is a
   * no-op that SUCCEEDS, consuming the label — enable the flag and use a new label.
   */
  triggerFiatWalletBackfill: Scalars['String']['output'];
  /**
   * Manually triggers fill-based tax reporting for B2B trades in a time range, covering both
   * USD and crypto-crypto pairs. Runs hourly on its own, so use this only to backfill or re-process.
   * Crypto-crypto trades over 7 days old are skipped: the Price Service has no prices that far back.
   */
  triggerFillBasedTaxReport: TriggerFillBasedTaxReportResult;
  /**
   * Starts the HandleStakedPositionTransfer workflow for a staked position, equivalent to the
   * custody gRPC TriggerHandleStakedTransferWorkflow. A staff caller triggers the transfer as a
   * system user.
   */
  triggerHandleStakedTransferWorkflow: TriggerHandleStakedTransferWorkflowPayload;
  /**
   * Triggers the data quality checks for Persons. These checks run async and the
   * results can be retrieved with the returned ID through
   * `getPersonDataQualityChecksResult`
   */
  triggerPersonDataQualityChecks: Scalars['ID']['output'];
  /**
   * Trigger the RIA -> BNY FBO fund-migration workflow for a wave of orgs (staff/dev only).
   * Returns the started workflow ID. Re-triggering a wave that already SUCCEEDED is
   * rejected; a wave whose prior run FAILED may be retried under the same label.
   */
  triggerRIAFBOMigration: Scalars['String']['output'];
  /** Trigger a scheduled report by id */
  triggerScheduledReport: Scalars['Boolean']['output'];
  /**
   * Start the USDC strategy fund sweep for an org: settle `amount` between the
   * org's strategy sub-account and its client sub-accounts as a ledger posting.
   * Staff-only. Async — starts a workflow and returns its handle; nothing has
   * moved on return. One sweep per org and direction runs at a time; triggering a
   * second while one is open is rejected.
   */
  triggerStrategyFundSweep: TriggerStrategyFundSweepResult;
  /**
   * Manually trigger the per-subaccount true-up workflow (ops/CX failsafe, WM-319).
   * Staff-only. The run is identical to the scheduled invocation; only the
   * invocation source (manual) differs, captured for audit.
   */
  triggerSubaccountTrueUp: TriggerSubaccountTrueUpResult;
  /** Triggers the periodic task to update the NFT metadata and upload to GCS */
  triggerUpdateNFTMetadataPeriodicTask: Scalars['Boolean']['output'];
  /**
   * Staff only. Delivers a webhook event immediately to one endpoint, bypassing the
   * delivery queue. Used by on-call to re-deliver events.
   */
  triggerWebhook: Scalars['Boolean']['output'];
  /**
   * unarchiveWallets unarchives wallets identified by the given IDs.
   * Returns error if walletIDs is empty.
   * Returns no error if nothing is updated (eg, no wallet matches, or all matching wallets
   * already are in "unarchived" state.)
   */
  unarchiveWallets: ArchiveWalletsResponse;
  /**
   * Remove the compliance (staff) freeze from a v4 account. Staff-only. A freeze
   * the customer set through the API stays, so the account can still read as
   * FROZEN afterwards. The reason is required and is stored with the account's
   * ACCOUNT_UNFROZEN event for audit; it is never sent to the customer.
   *
   * Rejected when the account has no compliance freeze, and for an account that is
   * not OPEN.
   */
  unfreezeAccount: UnfreezeAccountResult;
  /** Unsets the customer override for the supplied organization. */
  unsetTalosCustomer: Scalars['Boolean']['output'];
  /**
   * Remove a tax tag from a transaction.
   * This operation syncs the removal to TaxBit and records an audit trail entry.
   */
  untagTaxTransaction: UntagTaxTransactionPayload;
  /**
   * Change the name and/or the external reference of one v4 account, in any
   * organization. Staff-only. The reason, the staff member's name, and the old
   * and new value of each field sent are stored with the account's
   * ACCOUNT_UPDATED event for audit; no webhook is sent to the customer.
   *
   * Rejected for an account that is not FBO, OMNIBUS or SEGREGATED, for one that
   * is CLOSING or CLOSED, and when another account of the same organization
   * already has the external reference.
   */
  updateAccount: StaffUpdateAccountResult;
  /** Updates accounts withdrawal freeze restrictions */
  updateAccountsFreezeWithdrawal: Scalars['Boolean']['output'];
  /** Updates the queue state of address attestations. */
  updateAddressesAttestationsState: Scalars['Boolean']['output'];
  /** Creates or updates a affiliate. If affiliate ID is provided it updates */
  updateAffiliate: InstitutionalAffiliate;
  /** updateAffiliateDocusignTemplate sets a specific docusign template to be used in terms and conditions */
  updateAffiliateDocusignTemplate: Scalars['String']['output'];
  /** Allows the submission of ad-hoc institutional information */
  updateAffiliateInformation: Array<AffiliateInformationRejection>;
  /**
   * Updates an existing affiliate KYC profile's name, status and type.
   * At least one of name, status or affiliateType must be provided.
   */
  updateAffiliateKYCProfile: AffiliateKYCProfile;
  /** Changes an affiliateV2 name */
  updateAffiliateV2Name: Scalars['Boolean']['output'];
  /** Updates affiliates withdrawal freeze restrictions */
  updateAffiliatesFreezeWithdrawal: Scalars['Boolean']['output'];
  /** Updates atlas participant associated with a participant. */
  updateAtlasParticipantForStablecoinRewards: UpdateAtlasParticipantForStablecoinRewardsResult;
  /** Update the auto compound state */
  updateAutoCompound: Scalars['Boolean']['output'];
  /** Update CRR risk parameters configuration */
  updateCRRRiskParameters: Scalars['Boolean']['output'];
  /** Creates or updates a client. If client ID is provided it updates */
  updateClient: InstitutionalClient;
  /** Allows the update of an institutional client name */
  updateClientName: Scalars['Boolean']['output'];
  /** Update a counterparty */
  updateCounterparty: CounterpartyV2;
  updateCounterpartyAccount: CounterpartyAccount;
  /** Updates an existing custodian. */
  updateCustodian: Custodian;
  /** Updates the default bank for an organization */
  updateDefaultBankForOrg: UpdateDefaultBankForOrgResponse;
  updateDepositAttributionSpamThreshold: Scalars['Boolean']['output'];
  updateDerivsEntityBankAccount: DerivsEntityBankAccountPayload;
  updateDerivsEntityWallet: UpdateDerivsEntityWalletPayload;
  updateDerivsTrustedDestination: DerivsTrustedDestinationPayload;
  /** Updates an existing DocuSign workflow configuration. */
  updateDocuSignWorkflow: DocuSignWorkflow;
  /**
   * Allows updating an individual belonging to an institution.
   * If the individual has start its form, this mutation will fail.
   * Ordering of relationships doesn't matter.
   */
  updateIndividualAndRelationships: Array<IndividualInformationRejection>;
  /** Allows the submission of ad-hoc PII */
  updateIndividualInformation: Array<IndividualInformationRejection>;
  /** Update KYCConfig object. */
  updateKYCConfig: Maybe<KYCConfig>;
  /** Update KYCProcessTrigger mutation. */
  updateKYCProcessTrigger: Maybe<KYCProcessTrigger>;
  /** Update KYCQuestion object. */
  updateKYCQuestion: Maybe<KYCQuestion>;
  /** Update KYCQuestionnaire object. */
  updateKYCQuestionnaire: Maybe<KYCQuestionnaire>;
  /** Update KYCQuestionnaireSubmission mutation. */
  updateKYCQuestionnaireSubmission: Maybe<KYCQuestionnaireSubmission>;
  /** Inserts a legalterms document updating */
  updateLegalterms: Scalars['Boolean']['output'];
  /** updateMarketingWidget tells the backend a widget had an interaction */
  updateMarketingWidget: Scalars['Boolean']['output'];
  /**
   * Updates an existing or creates a new network status
   * Returns true  in case of successful   update/creation
   * Returns false in case of unsuccessful update/creation
   */
  updateNetworkStatus: Scalars['Boolean']['output'];
  /** updateOrgACHDebitInSettings stores the org's ACH Debit In settings, recording the staff user as the actor. */
  updateOrgACHDebitInSettings: Scalars['Boolean']['output'];
  /**
   * updateOrgGasConfig will...
   * - if replace=true:  reset  fee multiplers for the orgID to given data. Multiplier not given, if existing, would be removed.
   * - if replace=false: update fee multiplers for the orgID: only multiplers provided are affected.
   *
   * "replace" cannot delete the whole config: orgGasConfig is mandatory, with at least one field set.
   * To achieve the effect of "delete config", set BaseFeePerGasMultiplier to UNSPECIFIED.
   *
   * Multipliers that can be updated:
   * - ETH base-fee multiplier (aka BaseFeePerGasMultiplier; FeeReservationLevel)
   * - ERC20 GasLimitMultiplierForSmartContract
   */
  updateOrgGasConfig: Scalars['Boolean']['output'];
  /**
   * Updates the name of an organization KYC profile.
   * Returns the updated organization KYC profile ID and name.
   */
  updateOrganizationKycProfileName: UpdateOrganizationKycProfileNameResult;
  /**
   * Updates an organization profile name.
   * Note: This is currently a stub implementation returning dummy data for development purposes.
   */
  updateOrganizationProfile: OrganizationKYCProfile;
  /** Update policy name */
  updatePolicyName: Scalars['Boolean']['output'];
  /** Updates the primary bank for a wallet */
  updatePrimaryBankForWallet: UpdatePrimaryBankForWalletResponse;
  /** Updates the primary dispatch method for a custodian. */
  updatePrimaryDispatchMethod: CustodianDispatchMethod;
  updateRIAOrganizationConfiguration: Scalars['Boolean']['output'];
  /**
   * updateRIATermsQuestionnaire sets a specific questionnaire to be used in terms and conditions
   * @deprecated not used anymore only docusign terms now
   */
  updateRIATermsQuestionnaire: Scalars['Boolean']['output'];
  /**
   * DEPRECATED: Use updateRelatedPartyKycProfile instead.
   *
   * Updates a related party's information and their relationship with an affiliate.
   * Similar to UpdateIndividualAndRelationships but for related party individuals.
   *
   * This mutation only supports individual related parties and will be removed in a future version.
   * @deprecated Use updateRelatedPartyKycProfile instead. This mutation only supports individual related parties.
   */
  updateRelatedPartyAndRelationships: Array<IndividualInformationRejection>;
  /**
   * Updates an existing related party's information and relationship with an affiliate.
   *
   * Supports both individual and institutional related parties.
   * Note: The related party type (INDIVIDUAL vs INSTITUTIONAL) cannot be changed after creation.
   *
   * Returns rejections for any validation failures.
   */
  updateRelatedPartyKycProfile: Array<InfoTypeRejection>;
  /** Allows updating related party relationship with an affiliate. */
  updateRelatedPartyRelationships: Scalars['Boolean']['output'];
  updateReportSchedule: ReportSchedule;
  /**
   * Patch a report type definition's own columns, validating the row the patch
   * would leave behind rather than the fields it names. Staff only.
   *
   * Partial by design, and immutable by input shape: backing, the discovered schema
   * and the audit columns are absent from the input, so a VIEW type can never
   * become a CUSTOM one -- disable it and register a new type instead. There is no
   * delete mutation either; `enabled: false` is the soft delete.
   *
   * Rejected, leaving the row untouched: a merged row breaking any rule a
   * registration would break; a repoint whose new view cannot be read, or which
   * turns a referenced column into a repeated or unprojectable one; `enabled:
   * false` or an org-column clear while enabled schedules reference the type --
   * runs already in flight never block a patch. A repoint whose new view merely lacks
   * a column a child names SUCCEEDS -- staged reconfiguration is the contract, and
   * the shortfall comes back in staleHeaderSourceColumns / staleFilterSourceColumns.
   */
  updateReportTypeDefinition: ReportTypeDefinition;
  /**
   * Updates a representative's name.
   * Note: Email updates are not supported. Representatives are uniquely identified by email.
   * If an email change is needed, remove the representative and add them again with the new email.
   * Returns true on success.
   */
  updateRepresentative: Scalars['Boolean']['output'];
  /** Update role metadata (name) */
  updateRoleMetadata: Role;
  /** Sets the blockchain scan height for a specific asset */
  updateScanProgress: Scalars['Boolean']['output'];
  /** Updates the settlement status, atomically updating the underlying trades' statuses */
  updateSettlementStatus: Scalars['Boolean']['output'];
  /** Updates notes associated with a participant. */
  updateStablecoinRewardsParticipantNotes: UpdateStablecoinRewardsParticipantNotesResult;
  /** Updates start date associated with a participant. */
  updateStablecoinRewardsParticipantStartDate: UpdateStablecoinRewardsParticipantStartDateResult;
  /** Updates notes associated with a program. */
  updateStablecoinRewardsProgramNotes: UpdateStablecoinRewardsProgramNotesResult;
  /**
   * Update an active tax mapping. The mapping becomes inactive and a new active version with the same source, type and
   * subtype replaces it. The input is the whole new version: an omitted taxbitType, taxbitSubtype or rationale is cleared.
   * Returns the new version. Returns a 412 error when the mapping is not active. Requires the FINANCE_ACCESS staff
   * permission
   */
  updateTaxMapping: TaxMappingPayload;
  /** Updates the tier for a given participant and program */
  updateTierForStablecoinRewardsEnrollment: UpdateTierForStablecoinRewardsEnrollmentResult;
  /** Updates whether the given organization is approved by the Compliance Team to access trading */
  updateTradeApprovalByComplianceTeam: Scalars['Boolean']['output'];
  /** Updates whether the given organization is approved by the Trading Team to access trading */
  updateTradeApprovalByTradingTeam: Scalars['Boolean']['output'];
  /** Updates an organization's trade commission rate */
  updateTradeCommissionRate: Scalars['Boolean']['output'];
  /** Updates an organization's trade settings */
  updateTradeSettings: Scalars['Boolean']['output'];
  /** Update trades status */
  updateTradesStatus: Scalars['Boolean']['output'];
  /** Updates an organization's list of email recipients to be notified for trading-related communications. */
  updateTradingEmailRecipients: Scalars['Boolean']['output'];
  updateTransaction: Scalars['Boolean']['output'];
  /** Updates an existing account transfer. */
  updateTransfer: Transfer;
  /** Updates a transfer asset by ID. */
  updateTransferAsset: TransferAsset;
  /** Update unassigned policy */
  updateUnassignedPolicy: PolicyV2;
  /** updateUnsettledManualTrade allows to update an unsettled manual trade. */
  updateUnsettledManualTrade: Scalars['Boolean']['output'];
  /** Updates the settings for a user. */
  updateUserSettings: Scalars['Boolean']['output'];
  /**
   * updateValidatorAssignments updates the various validator assignments for the addresses by day and blockHeight on that day
   * This is used to update the validator assignments for Celo assets that we may have missed
   * so it can be filled back from the blockchain data
   * The response is the number of entries inserted or updated
   */
  updateValidatorAssignments: Scalars['String']['output'];
  /** Updates the account a vault belongs to */
  updateVaultAccount: Scalars['Boolean']['output'];
  /** Update vault metadata (name, description) */
  updateVaultMetadata: Vault;
  /**
   * Updates the address on file for a virtual account at an MT-backed bank (BNY, SCB). virtualAccountID
   * is the fiat.bank_info row's own id (see bankInfosForOrg), not a wallet/bank pair - a wallet can have
   * more than one virtual account at the same bank. approvedBy is a required free-text audit trail
   * field naming who approved the change; it is not verified against anything.
   */
  updateVirtualAccountAddress: UpdateVirtualAccountAddressResponse;
  /** Removes user key IDs from `backup_json.WalletKeyBackup.Shares` by wallet coordinates. */
  updateWalletKeyBackup: Scalars['Boolean']['output'];
  /** Removes user key IDs from `backup_json.WalletKeyBackup.Shares` by walletKey unique ID. */
  updateWalletKeyBackupByID: Scalars['Boolean']['output'];
  updateWalletScreeningAllowlistEntry: Scalars['Boolean']['output'];
  /** TODO: add description */
  updateWebhookEndpoint: WebhookEndpoint;
  /** Upload an account statement to GCS to make available for download in the client dashboard */
  uploadAccountStatement: Scalars['Boolean']['output'];
  /**
   * Allows the submission of affiliate information files
   * @deprecated use the upload rest endpoint instead
   */
  uploadAffiliateInformation: Maybe<Scalars['String']['output']>;
  /**
   * Upload a cost-basis CSV for processing.
   * Validates headers, checks for duplicate active jobs, stores the file in GCS,
   * and enqueues a Temporal workflow. Returns the job ID.
   */
  uploadCostBasisCSV: UploadCostBasisCSVPayload;
  /**
   * Allows the submission of PII files
   * @deprecated use the upload rest endpoint instead
   */
  uploadIndividualInformation: Maybe<Scalars['String']['output']>;
  /** Upload an trusted destinations list to validate and process into a bulk trusted destination creation */
  uploadTrustedDestinationsCSV: Array<BulkTrustedDestinationItem>;
  /**
   * Upload a trusted smart contracts list to validate and process into a bulk
   * trusted smart contract creation.
   */
  uploadTrustedSmartContractsCSV: Array<BulkTrustedSmartContractItem>;
  /** upsertDApp adds or updates a DApp */
  upsertDApp: Scalars['Boolean']['output'];
  /** Approve a previously initialized WalletConnect session. */
  walletConnectApproveSession: WalletConnectApproveSessionResponse;
  /**
   * Initializes a WalletConnect session with the provided wallet and URI. This is
   * an alternative to the `establishWalletConnectSession` mutation and allows for
   * more control over the session.
   */
  walletConnectInitializeSession: WalletConnectInitializeSessionResponse;
  /** Reject a previously initialized WalletConnect session. */
  walletConnectRejectSession: WalletConnectRejectSessionResponse;
  /** Creates a brand new wallet for the given vault and networkID and returns details of the newly created wallet */
  walletCreate: WalletResponsePayload;
  /** Updates the name of the wallet for walletID to the specified name string */
  walletRename: WalletResponsePayload;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationacceptDisclosureArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  clientAcceptedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  disclosureID: Scalars['String']['input'];
  documentVersion: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationacceptLegalTermArgs = {
  accountV2ID?: InputMaybe<Scalars['String']['input']>;
  clientAcceptedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  legalTermID: Scalars['String']['input'];
  legalTermVersion: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationackWalletKeyDownloadArgs = {
  walletKeyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationacknowledgeScanningIssueArgs = {
  id: Scalars['String']['input'];
  networkID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationactivateReportScheduleArgs = {
  input: ActivateReportScheduleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddAffiliateKYCProfileArgs = {
  affiliateID?: InputMaybe<Scalars['String']['input']>;
  affiliateType: AffiliateType;
  anchorageEntityTypes: AnchorageEntityType;
  name: Scalars['String']['input'];
  orgKYCProfileID: Scalars['String']['input'];
  parentAffiliateID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddAffiliateRepresentativeArgs = {
  affiliateID: Scalars['String']['input'];
  representative?: InputMaybe<RepresentativeInput>;
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddAssetsToStablecoinRewardsProgramArgs = {
  assetTypeIDs: Array<Scalars['AssetTypeID']['input']>;
  programID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddClientAffiliateTypeArgs = {
  input: ClientAffiliateTypeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddIndividualAndRelationshipsArgs = {
  affiliateID: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  entries?: InputMaybe<Array<InputIndividualInformation>>;
  firstName: Scalars['String']['input'];
  kycRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  kycScreening?: InputMaybe<KYCScreeningInput>;
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  ownershipPercentage?: InputMaybe<Scalars['String']['input']>;
  representative?: InputMaybe<RepresentativeInput>;
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddIndividualRepresentativeInClientArgs = {
  clientID: Scalars['String']['input'];
  individualID: Scalars['String']['input'];
  representative?: InputMaybe<RepresentativeInput>;
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddOrUpdateDocumentDeliverySettingArgs = {
  organizationID: Scalars['ID']['input'];
  settingType: SettingType;
  settingsValues?: InputMaybe<Array<DocumentDeliveryContact>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddParticipatingMemberArgs = {
  affiliateID: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddRelatedPartyAndRelationshipsArgs = {
  input: AddRelatedPartyAndRelationshipsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddRelatedPartyKycProfileArgs = {
  input: AddRelatedPartyKycProfileInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddRelatedPartyRelationshipsArgs = {
  affiliateID: Scalars['ID']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  kycRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  kycScreening?: InputMaybe<KYCScreeningInput>;
  name: Scalars['String']['input'];
  ownershipPercentage?: InputMaybe<Scalars['String']['input']>;
  relatedPartyID?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddRepresentativeArgs = {
  kycProfileID: Scalars['String']['input'];
  representative?: InputMaybe<RepresentativeInput>;
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationaddTrueUpSkipArgs = {
  input: TrueUpSkipInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationadjustTradingStrategyCollateralHoldArgs = {
  assetTypeID: Scalars['String']['input'];
  holdID: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  newQuantity: Scalars['String']['input'];
  subaccountID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationallowlistValidatorArgs = {
  input: AllowlistedValidatorInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationapplyRestrictionsArgs = {
  input: ApplyRestrictionsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationapplyTagsArgs = {
  input: ApplyTagsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationapproveAffiliateArgs = {
  affiliateID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationapproveAffiliateKYCProfileInfoArgs = {
  affiliateKycProfileID: Scalars['ID']['input'];
  organizationKYCProfileID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationapproveIndividualInClientArgs = {
  clientID: Scalars['String']['input'];
  individualID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationapprovesStandingInstructionArgs = {
  standingInstructionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationarchiveWalletsArgs = {
  walletIDs: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationassignUnassignedFundsArgs = {
  orgID: Scalars['String']['input'];
  purpose: TransactionType;
  reportToTaxbit?: InputMaybe<Scalars['Boolean']['input']>;
  subaccountID: Scalars['String']['input'];
  transactionIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationattestAddressesArgs = {
  requests: Array<AttestAddressRequest>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationattributeDepositsAsSpamArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  operationIDs: Array<Scalars['OperationID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationauditOrganizationLegacyFieldsArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationbatchDisableWebhookEventTypesArgs = {
  allOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  orgIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationbatchEnableWebhookEventTypesArgs = {
  allOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  orgIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationbatchEndorseArgs = {
  distressSignal?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  operations: Array<InputEndorseOperation>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationblockPricerBookQuoteArgs = {
  bookQuoteInput: BookQuoteParams;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationblockPricerRfqArgs = {
  rfqInput: RFQParams;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationblockchainEchoArgs = {
  message: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationbroadcastRawTransactionArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  rawTransaction: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationbroadcastTransactionArgs = {
  networkID: Scalars['String']['input'];
  operationID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationbtApproveWithdrawalArgs = {
  transferID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationbtRejectWithdrawalArgs = {
  transferID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationbulletinBoardServiceCreateAddressOwnershipArgs = {
  address: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  vasp: TrustVASP;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationbulletinBoardServiceDeleteAddressOwnershipArgs = {
  address: Scalars['String']['input'];
  blockchainID: Scalars['String']['input'];
  vasp: TrustVASP;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcancelFullQuorumRecoveryArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcancelKYCQuestionnaireSubmissionArgs = {
  input: CancelKYCQuestionnaireSubmissionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcancelManualTradeArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID: Scalars['String']['input'];
  tradeID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcancelOffchainVestingScheduleArgs = {
  vestingScheduleID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcancelOperationAsyncArgs = {
  operationID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcancelSharedPoliciesMigrationArgs = {
  orgKeyIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcancelTransactionArgs = {
  transactionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcancelTransferArgs = {
  input: CancelTransferInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcanonicalizeOrganizationsInDatabaseArgs = {
  organizationKeyIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationchangeOperationStateArgs = {
  expirationTime?: InputMaybe<Scalars['Timestamp']['input']>;
  operationID: Scalars['String']['input'];
  operationState: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationchangeRawOperationArgs = {
  newData: Scalars['String']['input'];
  oldData: Scalars['String']['input'];
  operationType: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationchangeRoleArgs = {
  changeType: RoleChangeType;
  clientID?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputRolePermission>>;
  roleSubID?: InputMaybe<Scalars['String']['input']>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationclearEmptyPolicyChangelogsArgs = {
  dryRun: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationclearFeatureFromAllOrganizationsArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  featureName: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationclearTaxbitSendFailureArgs = {
  input: ClearTaxbitSendFailureInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationclearVoicePhrasesArgs = {
  individualIDs: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationclientDashboardLoginArgs = {
  payload: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcloseAccountArgs = {
  input: CloseAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcloseAccountsArgs = {
  updates: Array<AccountClosure>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcloseAffiliateArgs = {
  affiliateID: Scalars['String']['input'];
  bsaRecommendedDate?: InputMaybe<Scalars['Date']['input']>;
  closureDate: Scalars['Date']['input'];
  initiatedBy: Scalars['String']['input'];
  msaSigned?: InputMaybe<Scalars['Boolean']['input']>;
  msaTerminationDate?: InputMaybe<Scalars['Date']['input']>;
  reason: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcloseSubaccountArgs = {
  input: CloseSubaccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmCreateExposureArgs = {
  input: CmCreateExposuresInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmCreateLoanArgs = {
  input: CmCreateLoanInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmCreateOperationArgs = {
  operations: Array<CmCreateOperationInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmCreateParticipantArgs = {
  input: CmCreateParticipantInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmCreateTicketArgs = {
  collateralPackageID: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmCreateTicketActionArgs = {
  actionType: TicketActionType;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceID: Scalars['ID']['input'];
  ticketID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmCreateTicketCommunicationLogArgs = {
  actionID?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  collateralPackageID: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<Scalars['String']['input']>;
  sender: Scalars['String']['input'];
  sentAt: Scalars['Time']['input'];
  subject: Scalars['String']['input'];
  type: TicketCommunicationType;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmDeleteExposureArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmDeleteOperationArgs = {
  ids: Array<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmDeletePackageArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmDeleteSystemSettingsArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmLinkTalosOrderArgs = {
  asset: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  talosOrderID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmNewOrderSingleArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  allocation?: InputMaybe<Array<OrderAllocationInput>>;
  clOrderID?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  limitPrice?: InputMaybe<Scalars['String']['input']>;
  orderType: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  side: Scalars['String']['input'];
  subaccountID?: InputMaybe<Scalars['String']['input']>;
  symbol: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmRequestExposureIncreaseArgs = {
  assetAmounts: Array<CmAssetAmountInput>;
  collateralPackageID: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  useGasStation?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmRequestMarginReturnArgs = {
  assetAmounts: Array<CmAssetAmountInput>;
  collateralPackageID: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  useGasStation?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmRunLTVMonitorArgs = {
  packageID?: InputMaybe<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmRunSettlementMonitorArgs = {
  packageID?: InputMaybe<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmRunWalletMonitorArgs = {
  packageID?: InputMaybe<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmSetAssetLevelSystemSettingsArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  slippage?: InputMaybe<Scalars['String']['input']>;
  type: CmSystemSettingsType;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmSetGlobalSystemSettingsArgs = {
  backupFeedToleranceMinutes?: InputMaybe<Scalars['Int']['input']>;
  backupPriceFeed?: InputMaybe<CmPriceFeedInput>;
  creditLineCheck?: InputMaybe<CmCreditLineCheckInput>;
  liquidationFee?: InputMaybe<Scalars['String']['input']>;
  marketDataSnapshotFreshness?: InputMaybe<CmMarketDataSnapshotFreshnessInput>;
  maxStalenessMinutes?: InputMaybe<Scalars['Int']['input']>;
  priceChangeThreshold?: InputMaybe<Scalars['String']['input']>;
  slippage?: InputMaybe<Scalars['String']['input']>;
  type: CmSystemSettingsType;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmUpdateExposureArgs = {
  input: CmUpdateExposureInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmUpdateLiquidationObligationArgs = {
  id: Scalars['ID']['input'];
  input: CmUpdateLiquidationObligationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmUpdateLoanArgs = {
  input: CmUpdateLoanInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmUpdateOperationArgs = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<CmOperationStatus>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcmUpdateTicketArgs = {
  collateralPackageID?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TicketStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcompleteTransactionArgs = {
  metadata?: InputMaybe<Scalars['String']['input']>;
  transactionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcomplianceUpdateTMSConfigsArgs = {
  entityType: TMSRuleEntityType;
  ruleGroup: TMSRuleGroup;
  ruleName: TMSRuleName;
  tmsConfigs: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationconfigureStablecoinRewardsParticipantWalletsArgs = {
  configurations?: InputMaybe<Array<StablecoinRewardWalletConfigurationInput>>;
  participantID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateA1TradeSubscriptionArgs = {
  input: Array<CreateA1TradeSubscriptionInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateAPIKeyForTransfersArgs = {
  description: Scalars['String']['input'];
  domain: TransferAccessRequestDomain;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateAccountArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateAffiliateV2Args = {
  name: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateAndLinkSubaccountWalletArgs = {
  input: CreateAndLinkSubaccountWalletInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateBalanceAdjustmentArgs = {
  addressSubID: Scalars['String']['input'];
  adjustmentType: BalanceAdjustmentType;
  amount: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  balanceType: Scalars['String']['input'];
  clientFacingDescription: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  externalAddress: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  originalOperationID?: InputMaybe<Scalars['String']['input']>;
  tokenID?: InputMaybe<Scalars['String']['input']>;
  txReceiptID?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['String']['input'];
  virtualAccountID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateClientOperationCommentArgs = {
  message: Scalars['String']['input'];
  operationID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateCoinductorAutomationPolicyArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  destinationWalletID: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sourceWalletID: Scalars['ID']['input'];
  withdrawalDestinationSubID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateContractCallOperationArgs = {
  request: UnencodedInput;
  walletUniqueID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateCounterpartyArgs = {
  input?: InputMaybe<CreateCounterpartyInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateCounterpartyAccountArgs = {
  input: CreateCounterpartyAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateCustodianArgs = {
  input: CreateCustodianInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateDepositAttributionSpamThresholdArgs = {
  input: CreateDepositAttributionSpamThresholdInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateDerivsEntityBankAccountArgs = {
  input: CreateDerivsEntityBankAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateDerivsEntityWalletArgs = {
  input: CreateDerivsEntityWalletInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateDerivsTransferArgs = {
  input: CreateDerivsTransferInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateDerivsTrustedDestinationArgs = {
  input: CreateDerivsTrustedDestinationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateDevEnrollTokenArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  includePII?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateDocuSignWorkflowArgs = {
  input: CreateDocuSignWorkflowInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateEECredentialArgs = {
  credential: CreateEECredential;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateEnrollTokenAndSendEmailArgs = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orgPolicyScopes?: InputMaybe<Array<ScopeToQuorumRequirements>>;
  vaultPolicyActions?: InputMaybe<Array<EnrollmentVaultPolicy>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateFeeRecalculationArgs = {
  input: CreateFeeRecalculation;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateGenericOperationArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  genericOperationType?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
  userIntentType?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateGenericOperationForOrgArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  userIntentType: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateGlobalTrustedSourcesArgs = {
  input: Array<InputCreateGlobalTrustedSource>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateJiraComplianceIssueArgs = {
  input: ComplianceIssueInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateKYCConfigArgs = {
  input: CreateKYCConfigInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateKYCProcessArgs = {
  input: CreateKYCProcessInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateKYCProcessTriggerArgs = {
  input: CreateKYCProcessTriggerInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateKYCProfileExemptionArgs = {
  informationType: Scalars['String']['input'];
  kycProfileID: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateKYCQuestionArgs = {
  input: CreateKYCQuestionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateKYCQuestionnaireArgs = {
  input: CreateKYCQuestionnaireInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateKYCQuestionnaireSubmissionArgs = {
  input: CreateKYCQuestionnaireSubmissionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateLegaltermsArgs = {
  legalterm: InputCreateLegalterms;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateMintBurnConversionArgs = {
  amount: AmountInput;
  destinationAssetTypeID: Scalars['AssetTypeID']['input'];
  destinationWalletID: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  sourceWalletID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateMovementOfFundsArgs = {
  amount: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fromBankName: Scalars['String']['input'];
  toBankName: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateOffChainOperationArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  offChainOperationType: Scalars['String']['input'];
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateOffChainOperationForOrgArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  operationType?: InputMaybe<OffChainOperationType>;
  organizationKeyID: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateOffchainVestingScheduleArgs = {
  accountID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  dryRun: Scalars['Boolean']['input'];
  unstakeable?: Scalars['Boolean']['input'];
  vestingScheduleCSVBase64: Scalars['String']['input'];
  walletAddresses: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateOneOffArgs = {
  addressSubID: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  oneOffParams: Array<InputOneOffParam>;
  oneoffType: OneOffType;
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateOperationalSubaccountArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  externalID: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orgID: Scalars['String']['input'];
  subaccountType: OperationalSubaccountType;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateOrganizationProfileArgs = {
  anchorageEntityTypes: Array<AnchorageEntityType>;
  name: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreatePermissionGroupForTransfersArgs = {
  domain: TransferAccessRequestDomain;
  name: Scalars['String']['input'];
  vaultSubIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreatePersonArgs = {
  individualID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateReportArgs = {
  input: CreateReportInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateReportScheduleArgs = {
  input: CreateReportScheduleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateReportTypeDefinitionArgs = {
  filterDefinitions: Array<ReportTypeFilterDefinitionInput>;
  headers: Array<ReportTypeHeaderInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: CreateReportTypeDefinitionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateScheduledReportArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  reportName: Scalars['String']['input'];
  scheduleDayOfMonth: Scalars['Int']['input'];
  scheduleDayOfWeek: Scalars['Int']['input'];
  scheduleHour: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateScheduledReportSubscriberArgs = {
  emailAddress: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scheduledReportID: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateSettlementArgs = {
  accountID?: InputMaybe<Scalars['ID']['input']>;
  includeAllUnsettledTrades?: InputMaybe<Scalars['Boolean']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  tradeIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateSettlementInstructionsArgs = {
  instructionsJSON: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateStablecoinRewardsParticipantArgs = {
  atlasParticipantID: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  topLevelAffiliateID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateStablecoinRewardsProgramArgs = {
  assetTypeIDs: Array<Scalars['AssetTypeID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateStandingInstructionArgs = {
  standingInstruction: CreateStandingInstruction;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateTaxMappingArgs = {
  input: CreateTaxMappingInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateTendermintClaimRewardsOneoffArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  validatorAddress: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateTestModuleArgs = {
  name: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateTransactionArgs = {
  allowOverdraftBalance?: InputMaybe<Scalars['Boolean']['input']>;
  allowPending?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityEntries?: InputMaybe<Array<TransactionEntryInput>>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  organizationKeyId: Scalars['String']['input'];
  status: TransactionStatus;
  transactionType: TransactionType;
  walletEntries?: InputMaybe<Array<WalletEntryInput>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateTransactionsArgs = {
  in: Array<TransactionInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateTrustedSourcesArgs = {
  input: Array<InputCreateTrustedSource>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateTwoWaySettlementArgs = {
  acceptorID: Scalars['ID']['input'];
  applyPostLock?: InputMaybe<Scalars['Boolean']['input']>;
  clientReferenceID?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  proposerID: Scalars['ID']['input'];
  useGasStation?: InputMaybe<Scalars['Boolean']['input']>;
  vaultUniqueID?: InputMaybe<Scalars['ID']['input']>;
  walletAmounts: Array<WalletAmountInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateUnassignedPolicyArgs = {
  defaultRule: InputRule;
  keyAccesses: Array<InputKeyAccess>;
  name: Scalars['String']['input'];
  specificRules: Array<InputRule>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateVestingContractArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  numReleasePeriods?: InputMaybe<Scalars['Int']['input']>;
  organizationKeyID: Scalars['String']['input'];
  revocable?: InputMaybe<Scalars['Boolean']['input']>;
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateWalletScreeningAllowlistEntryArgs = {
  input: CreateWalletScreeningAllowlistEntryInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationcreateWithdrawalNoInitiatorArgs = {
  amlQuestionnaire: InputQuestionnaireSubmission;
  amount: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  destinationAssetSubID?: InputMaybe<Scalars['String']['input']>;
  destinationVaultSubID?: InputMaybe<Scalars['String']['input']>;
  destinationWalletID?: InputMaybe<Scalars['ID']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID: Scalars['String']['input'];
  tokenID?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeactivateDerivsEntityBankAccountArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeactivateDerivsTrustedDestinationArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdebugCreateSettlementArgs = {
  accountID?: InputMaybe<Scalars['ID']['input']>;
  includeAllUnsettledTrades?: InputMaybe<Scalars['Boolean']['input']>;
  organizationKeyID: Scalars['String']['input'];
  tradeIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdefaultStakingFeeTermsReviewArgs = {
  input: ReviewPendingDefaultStakingFeeTermsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdefaultStakingFeeTermsUpdateArgs = {
  input: UpdateDefaultStakingFeeTermsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteAssociatedAddressArgs = {
  addressSubID: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  associatedAddressType: Scalars['String']['input'];
  blockNumber: Scalars['String']['input'];
  externalAddress: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteClientArgs = {
  clientID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteClientOperationCommentArgs = {
  commentID: Scalars['String']['input'];
  commentSubID: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteDerivsEntityWalletArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteEECredentialArgs = {
  credentialID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteEECredentialV2Args = {
  input: DeleteEECredentialInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteFixedPriceArgs = {
  fromAsset: Scalars['String']['input'];
  fromTokenID?: Scalars['String']['input'];
  toAsset: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteKYCConfigArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteKYCProcessTriggerArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteKYCProfileExemptionArgs = {
  informationType: Scalars['String']['input'];
  kycProfileID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteKYCQuestionArgs = {
  input: DeleteKYCQuestionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteKYCQuestionnaireArgs = {
  input: DeleteKYCQuestionnaireInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeletePolicyArgs = {
  policyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteSettlementArgs = {
  settlementID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteTaxMappingArgs = {
  input: DeleteTaxMappingInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteTestModuleArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteTransfersArgs = {
  ids: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteUserPIIArgs = {
  piiType: Array<PIIInformationType>;
  userId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteWalletScreeningAllowlistEntryArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeleteWebhookEndpointArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdepositAddressCreateArgs = {
  walletID: Scalars['ID']['input'];
  walletTypeOverride?: InputMaybe<WalletTypeOverride>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdepositScreeningArgs = {
  email: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  operationID: Scalars['String']['input'];
  reviewStatus: DepositScreeningStatus;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeveloperBrowserExtensionLoginArgs = {
  publicKeyID: Scalars['String']['input'];
  sessionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdeveloperClientDashboardLoginArgs = {
  publicKeyID: Scalars['String']['input'];
  sessionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdisableModuleForOperatorArgs = {
  moduleID: Scalars['ID']['input'];
  operator: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdisableModuleForOrganizationsArgs = {
  moduleID: Scalars['ID']['input'];
  organizationKeyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdisableStandingInstructionArgs = {
  standingInstructionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdispatchTransferArgs = {
  input: DispatchTransferInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdisputeACHDebitOutArgs = {
  input: DisputeACHDebitOutInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvActivatePackageArgs = {
  packageIdentifier: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvActivateTradeArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvAddStatementFileSettingArgs = {
  input: AddDvStatementFileSettingInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvAmendTradeArgs = {
  id: Scalars['ID']['input'];
  input: AmendDvTradeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvApproveClientEmailArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvBookPackageArgs = {
  input: CreatePackageInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvBookStagedCloseoutArgs = {
  id: Scalars['ID']['input'];
  input: DVBookStagedCloseoutInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCancelMakerCheckerRequestArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCancelSettlementArgs = {
  input: CancelSettlementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCloseoutTradeArgs = {
  id: Scalars['ID']['input'];
  input: DVCloseoutTradeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvConfirmEndOfDayReconArgs = {
  asOfDate: Scalars['Date']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvConfirmSettlementArgs = {
  input: ConfirmSettlementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateAccountArgs = {
  input: CreateDVAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateAccountCSAArgs = {
  input: CreateAccountCSAInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateAccountNettingSetArgs = {
  input: CreateAccountNettingSetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateAssetArgs = {
  input: CreateAssetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateCSAArgs = {
  input: CreateCSAInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateCSAMarginTermsArgs = {
  input: CreateCSAMarginTermsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateCollateralRuleArgs = {
  input: CreateCollateralRuleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateCounterpartyMasterCopyArgs = {
  input: CreateCounterpartyMasterCopyInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateCustodianArgs = {
  input: CreateDVCustodianInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateCustodianWalletArgs = {
  input: CreateDVCustodianWalletInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateEntityArgs = {
  input: CreateDVEntityInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateHarukoBackfillRequestsArgs = {
  input: CreateHarukoBackfillRequestsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateInternalMovementArgs = {
  input: CreateInternalMovementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateLedgerTransactionArgs = {
  input: CreateLedgerTransactionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateMakerCheckerRequestArgs = {
  input: CreateMakerCheckerRequestInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateNettingSetArgs = {
  input: CreateNettingSetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateNettingSetParamsArgs = {
  input: CreateNettingSetParamsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateNettingSetRuleArgs = {
  input: CreateNettingSetRuleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateObligationArgs = {
  input: CreateObligationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreatePackageArgs = {
  input: CreatePackageInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateProductArgs = {
  input: CreateProductInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateSettlementArgs = {
  input: CreateSettlementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateStatementArgs = {
  input: CreateDvStatementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateTimingRuleArgs = {
  input: DVCreateTimingRuleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvCreateTradeArgs = {
  input: CreateTradeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeactivateVarParametersArgs = {
  model: DvRiskModel;
  version: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteAccountCSAArgs = {
  accountId: Scalars['ID']['input'];
  csaId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteAccountNettingSetArgs = {
  accountId: Scalars['ID']['input'];
  nettingSetId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteAssetArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteCSAArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteCSAMarginTermsArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteCollateralRuleArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteEntityArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteHarukoBackfillRequestsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteNettingSetArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteNettingSetParamsArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteNettingSetRuleArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeleteTimingRuleArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeliverClientReportArgs = {
  input: DVDeliverClientReportInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDeliverCryptioTransferActivityArgs = {
  input: DVDeliverCryptioTransferActivityInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDequeueClientEmailArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDiscardIceReportArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvDismissStagedCloseoutArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvExecuteMakerCheckerRequestArgs = {
  executionInput?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvExerciseTradeArgs = {
  id: Scalars['ID']['input'];
  input: DVExerciseTradeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvExpireTradeArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvFinalizePackagePriceArgs = {
  input: FinalizePackagePriceInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvGenerateMarginCallNoticesArgs = {
  asOfDate: Scalars['Date']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvInvalidateLifecycleEventArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvKillTradeArgs = {
  id: Scalars['ID']['input'];
  input: DVKillTradeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvMarkSettlementSettledArgs = {
  input: MarkSettlementSettledInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvMatureTradeArgs = {
  id: Scalars['ID']['input'];
  input: DVMatureTradeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvNovateTradeArgs = {
  id: Scalars['ID']['input'];
  input: DVNovateTradeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvProvisionHarukoVenueArgs = {
  input: DVProvisionHarukoVenueInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvQueueIceCorrectionArgs = {
  reason: Scalars['String']['input'];
  tradeId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvQueueTradeConfirmationEmailArgs = {
  lifecycleEventId?: InputMaybe<Scalars['ID']['input']>;
  tradeId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvRegenerateIceReportArgs = {
  input: DVRegenerateIceReportInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvRegeneratePart45ReportArgs = {
  asOfDate: Scalars['Date']['input'];
  submissionType: DvPart45SubmissionType;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvRejectClientEmailArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvRequeueClientEmailArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvRequeueIceReportArgs = {
  reportId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvRescheduleHarukoBackfillRequestsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvRestoreIceReportArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvReverseInternalMovementArgs = {
  input: ReverseInternalMovementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvReverseLedgerTransactionArgs = {
  input: ReverseLedgerTransactionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvRevertPackagePostPricedArgs = {
  packageIdentifier: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvRunVarArgs = {
  input: RunDvVarInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvSaveSettlementMovementsArgs = {
  input: SaveSettlementMovementsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvSendClientEmailArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvSendToICEArgs = {
  submissionId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvSetCSAGenerateVMObligationsArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvSetHarukoGroupEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvSetIngestChatAccountArgs = {
  input: SetDVIngestChatAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvSetStatementFileSettingEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvStartMarginRunArgs = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  asOfTs?: InputMaybe<Scalars['Timestamp']['input']>;
  tradeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  valuationTs?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvSubmitIceReportArgs = {
  reportId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDVAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateAssetArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAssetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateCSAArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCSAInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateCSAMarginTermsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCSAMarginTermsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateCollateralRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCollateralRuleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateCounterpartyMasterCopyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCounterpartyMasterCopyInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateEntityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDVEntityInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateNettingSetArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNettingSetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateNettingSetParamsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNettingSetParamsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateNettingSetRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNettingSetRuleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateProductArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProductInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvUpdateTimingRuleArgs = {
  id: Scalars['ID']['input'];
  input: DVUpdateTimingRuleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvVoidObligationArgs = {
  input: VoidObligationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvVoteMakerCheckerRequestArgs = {
  id: Scalars['ID']['input'];
  input: VoteMakerCheckerRequestInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationdvWriteVarParametersArgs = {
  input: WriteDvVarParametersInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationeditAMLArgs = {
  input: EditAMLInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationeditClientOperationCommentArgs = {
  commentID: Scalars['String']['input'];
  commentSubID: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationeditCostBasisArgs = {
  input: EditCostBasisInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationeditDepositAttributionsArgs = {
  attributions: InputEditDepositAttributions;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationeditGlobalTrustedSourcesArgs = {
  input: Array<InputEditGlobalTrustedSource>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationeditOperationDescriptionArgs = {
  message: Scalars['String']['input'];
  operationID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationeditSpamAttributionDataArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  operationIDs: Array<Scalars['OperationID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationeditTrustedSourceStatusArgs = {
  disabledReason?: InputMaybe<TrustedSourceDisableReason>;
  id: Scalars['String']['input'];
  status: TrustedSourceStatus;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationeditTrustedSourcesArgs = {
  input: Array<InputEditTrustedSource>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationenableModuleForOperatorArgs = {
  moduleID: Scalars['ID']['input'];
  operator: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationenableModuleForOrganizationsArgs = {
  moduleID: Scalars['ID']['input'];
  organizationKeyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationenableSubaccountsForOrganizationArgs = {
  affiliateID: Scalars['String']['input'];
  isStaking?: Scalars['Boolean']['input'];
  ledgerOnboard: Scalars['Boolean']['input'];
  orgID: Scalars['String']['input'];
  organizationType?: SubaccountOrganizationType;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationendorseArgs = {
  childControlKey?: InputMaybe<Scalars['String']['input']>;
  distressSignal?: InputMaybe<Scalars['Int']['input']>;
  encryptedControlMasterPrivateKey?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  operationID: Scalars['String']['input'];
  operationPayload?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationendorseRiskReviewArgs = {
  decision: RiskDecision;
  operationID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationenrollOrgForFiatInterestArgs = {
  input: EnrollOrgForFiatInterestInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationenrollOrganizationInStablecoinRewardsArgs = {
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationenrollStablecoinRewardsParticipantsInProgramArgs = {
  participantIDs: Array<Scalars['String']['input']>;
  programID: Scalars['String']['input'];
  tier?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationenrollTokenArgs = {
  orgPolicyActions?: InputMaybe<Array<PolicyActionType>>;
  orgPolicyScopes?: InputMaybe<Array<ScopeToQuorumRequirements>>;
  vaultPolicyActions?: InputMaybe<Array<EnrollmentVaultPolicy>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationenrollUserArgs = {
  accessLevels: Array<InputPolicyAccessLevel>;
  email?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationenrollUserKeyArgs = {
  userKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationestablishWalletConnectSessionArgs = {
  qrCode: Scalars['String']['input'];
  walletUniqueID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationexecuteFilecoinMinerBalanceWithdrawalsArgs = {
  input: ExecuteFilecoinMinerBalanceWithdrawalsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationexternalAccountLocationSaveArgs = {
  id: Scalars['ID']['input'];
  location: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationexternalAccountLocationsDeleteArgs = {
  id: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationexternalAccountSaveArgs = {
  id: Scalars['ID']['input'];
  locationID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationexternalAccountTransactionSaveArgs = {
  accountID?: InputMaybe<Scalars['ID']['input']>;
  affiliateID?: InputMaybe<Scalars['ID']['input']>;
  assetTypeID: Scalars['AssetTypeID']['input'];
  executedAt: Scalars['Timestamp']['input'];
  externalAccountID: Scalars['ID']['input'];
  externalID: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
  organizationKeyID: Scalars['ID']['input'];
  quantity: Scalars['String']['input'];
  transactionType: ExternalAccountTransactionType;
  vaultSubID?: InputMaybe<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationexternalAccountTransactionSetAccountIDForAllTransactionsInOrgArgs = {
  accountID: Scalars['ID']['input'];
  organizationKeyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationexternalAccountTransactionSetAccountIDForTransactionArgs = {
  accountID: Scalars['ID']['input'];
  externalAccountTransactionID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationexternalAccountTransactionsDeleteArgs = {
  id: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationexternalAccountsDeleteArgs = {
  id: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfailOperationArgs = {
  operationID: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  skipWorkflow?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeeTypeCreateArgs = {
  input: FeeTypeCreateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeeTypeUpdateArgs = {
  input: FeeTypeUpdateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeedbackSubmitGeneralArgs = {
  message: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeedbackSubmitNewAssetArgs = {
  requestedAsset: Scalars['String']['input'];
  volume: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeesAgreementApproveArgs = {
  input: FeesAgreementUpdateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeesAgreementCreateArgs = {
  input: FeesAgreementCreateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeesAgreementRejectArgs = {
  agreementId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeesAgreementTerminateArgs = {
  input: FeesAgreementTerminateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeesAgreementTerminationApproveArgs = {
  input: FeesAgreementTerminationApproveInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeesAgreementTerminationCancelArgs = {
  agreementId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfeesAgreementUpdateArgs = {
  input: FeesAgreementUpdateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfillAffiliateFormDataArgs = {
  affiliateID: Scalars['String']['input'];
  createAnchorageIndividuals: Scalars['Boolean']['input'];
  createExtraIndividuals: Scalars['Boolean']['input'];
  individualNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfillKYCProfileFormDataArgs = {
  individualNames?: InputMaybe<Array<Scalars['String']['input']>>;
  kycProfileID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfillKYCQuestionnaireSubmissionDataArgs = {
  input: FillKYCQuestionnaireSubmissionDataInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfindOrCreateTestOrganizationArgs = {
  hsmZoneID?: InputMaybe<Scalars['String']['input']>;
  kycMode?: InputMaybe<TestOrgKYCMode>;
  name: Scalars['String']['input'];
  operator?: InputMaybe<Scalars['String']['input']>;
  userCount?: InputMaybe<Scalars['Int']['input']>;
  vaultNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfixInvalidOrganizationArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfixKeyAccessesRoleBindingsArgs = {
  organizationKeyIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfixPersonIndividualBindingsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  dryRun: Scalars['Boolean']['input'];
  first: Scalars['Uint64']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationforceRefreshOrganizationArgs = {
  ignoreOngoingOrgChanges?: InputMaybe<Scalars['Boolean']['input']>;
  migrationType?: InputMaybe<HSMMigrationType>;
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfreezeAccountArgs = {
  input: FreezeAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfundArgs = {
  address: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  special?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationfundSubaccountArgs = {
  amount: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  subaccountId: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfApproveDelegationActivityArgs = {
  activityID: Scalars['ID']['input'];
  reject?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfControlAgreementCreateArgs = {
  input: CreateControlAgreementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfControlAgreementUpdateDocumentIDArgs = {
  input: UpdateControlAgreementDocumentIDInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfDelegationCreateArgs = {
  input: GDFDelegationCreateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfDelegationSettleArgs = {
  input: GDFDelegationSettleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfManageDelegationForControlAgreementArgs = {
  input: ManageDelegationForControlAgreementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfOESAgreementCreateArgs = {
  input: GDFOESAgreementCreateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfOESExchangeProfileUpsertArgs = {
  input: GDFOESExchangeProfileUpsertInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfParticipantEnrollArgs = {
  snParticipantID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfRedeemPreauthorizationArgs = {
  input: RedeemPreauthorizationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfReleaseDelegationHoldsArgs = {
  input: ReleaseDelegationHoldsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfRescindContestNoticeArgs = {
  input: RescindContestNoticeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfSelectDelegationActivityWalletsArgs = {
  activityID: Scalars['ID']['input'];
  assetAdjustments: Array<ControlAgreementAssetAdjustmentInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfSuspendControlAgreementArgs = {
  input: SuspendControlAgreementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgdfTerminateControlAgreementArgs = {
  input: TerminateControlAgreementInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgenerateAPIKeyWithPayloadArgs = {
  description: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roleSubID?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgenerateMonthlyTradingStatementArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  month: Scalars['Int']['input'];
  organizationKeyID: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgenerateMultiSignedURLsArgs = {
  uploadCaseFiles: Array<UploadAlertCaseFiles>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgenerateOrderBasedMonthlyTradingStatementArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  month: Scalars['Int']['input'];
  organizationKeyID: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgeneratePoolAddressesForWalletIDArgs = {
  networkID: Scalars['String']['input'];
  numAddresses: Scalars['Int']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
  walletSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgenerateSignedURLToUploadDocsForComplianceAlertsArgs = {
  documentName: Scalars['String']['input'];
  folderID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgenerateTestAPIKeyArgs = {
  description: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  roleSubID?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgetFormSessionURLArgs = {
  formID: Scalars['String']['input'];
  formType: Scalars['String']['input'];
  useKycFormURLFormat?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgetFormUrlArgs = {
  kycProfileID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgetKYCQuestionnaireSubmissionURLArgs = {
  input: GetKYCQuestionnaireSubmissionURLInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgetQuoteArgs = {
  request: QuoteRequestParams;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationgetVerifiedABIArgs = {
  contractAddress: Scalars['String']['input'];
  networkID: Scalars['ID']['input'];
  provider?: InputMaybe<AbiVerificationProvider>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationiamRoleAddUsersArgs = {
  id: Scalars['ID']['input'];
  organizationKeyID: Scalars['String']['input'];
  resources: Array<Scalars['String']['input']>;
  users: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationiamRoleUpdateUsersArgs = {
  input: Array<UpdateIAMRoleUsersInput>;
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationimportETHValidatorSetArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  provider: ETHStakingProviderType;
  validators: Array<InputETHValidatorParameters>;
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationinjectLexisNexisUpdateArgs = {
  input: LexisNexisUpdateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationinvalidateEnrollmentArgs = {
  enrollToken: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationipAllowlistConfigUpsertArgs = {
  input: IPAllowlistConfigUpsertInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationipAllowlistEntriesDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
  organizationKeyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationipAllowlistEntriesUpsertArgs = {
  input: Array<IPAllowlistEntryUpsertInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationipAllowlistMigrateFromEnvVarArgs = {
  input: IPAllowlistMigrateFromEnvVarInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationipAllowlistSetEntitlementArgs = {
  entitlement: IPAllowlistEntitlement;
  organizationKeyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationliftRestrictionsArgs = {
  input: LiftRestrictionsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmarkAffiliatesV2AndAccountsV2AsDeletedArgs = {
  affiliateIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmarkDepositAttributionsAsNonAttributableArgs = {
  operationIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmarkReportFileVerificationAsCanceledArgs = {
  input: MarkReportFileVerificationAsCanceledInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmarkReportFileVerificationAsVerifiedArgs = {
  input: MarkReportFileVerificationAsVerifiedInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmergeIndividualsArgs = {
  notes: Scalars['String']['input'];
  overridePIIs?: InputMaybe<Array<InputIndividualInformation>>;
  sourceIndividualIDs: Array<Scalars['ID']['input']>;
  targetIndividualID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmergePersonsArgs = {
  personIDs: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmergeRelatedPartyKycProfilesArgs = {
  notes: Scalars['String']['input'];
  overridePIIs?: InputMaybe<Array<InputKYCProfileInfo>>;
  sourceRelatedPartyKycProfileIDs: Array<Scalars['ID']['input']>;
  targetRelatedPartyKycProfileID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmergeTopLevelAffiliatesAndAccountsArgs = {
  affiliatesToMerge: Array<Scalars['String']['input']>;
  topLevelAffiliate: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmigrateOrgsToSharedPoliciesArgs = {
  organizationKeyIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationmigrateRolesArgs = {
  chunkSize?: InputMaybe<Scalars['Int']['input']>;
  dryRun: Scalars['Boolean']['input'];
  migrateAll?: InputMaybe<Scalars['Boolean']['input']>;
  organizations?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationnotifyOrderExecutionArgs = {
  orderID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationnxtTfcCloseCycleArgs = {
  input: NxtTfcCloseCycleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationnxtTfcOpenCycleArgs = {
  input: NxtTfcOpenCycleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationopenScanningIssueArgs = {
  id: Scalars['String']['input'];
  networkID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationoperationMakeVisibleInOperationsListArgs = {
  operationID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationoperationRejectArgs = {
  operationID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationpauseCoinductorAutomationPolicyArgs = {
  policyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationpayMonthlyStablecoinRewardsArgs = {
  payoutDate: Scalars['Date']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationperformManualDepositAttributionsArgs = {
  attributions: InputPerformManualDepositAttributions;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationplaceTradingStrategyCollateralHoldsArgs = {
  holds: Array<TradingStrategyCollateralHoldInput>;
  idempotencyKey: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareActionFromJSONFormArgs = {
  input: PrepareActionFromJSONFormInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareAddFiatTrustedDestinationArgs = {
  achPullAuthorization?: InputMaybe<InputACHPullAuthorizationFiatTrustedDestination>;
  achPush?: InputMaybe<InputACHPushFiatTrustedDestination>;
  clientID: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  kind?: FiatTrustedDestinationKind;
  name: Scalars['String']['input'];
  noteToBeneficiary?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  trustedDestinationUsage?: InputMaybe<FiatTrustedDestinationUsage>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
  wire?: InputMaybe<InputWireFiatTrustedDestination>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareAddTrustedDestinationArgs = {
  amlQuestionnaire?: InputMaybe<InputQuestionnaireSubmission>;
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  description: Scalars['String']['input'];
  destinationAddress: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  isNetworkLevel?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  trustedDestinationExtraParams?: InputMaybe<InputTrustedDestinationExtraParams>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareAuthorizeSpenderArgs = {
  amountAuthorized?: InputMaybe<Scalars['String']['input']>;
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  extraParams?: InputMaybe<InputExtraParams>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareBinaryAttestationArgs = {
  input: PrepareBinaryAttestationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareCreateGenericOrganizationChangeArgs = {
  addAssetSupport?: InputMaybe<Array<AddAssetSupportInput>>;
  addBootMeasurementSets?: InputMaybe<Array<AddBootMeasurementSetInput>>;
  addQuorumRecoveries?: InputMaybe<Array<AddQuorumRecoveryInput>>;
  addTrustedDestinations?: InputMaybe<Array<AddTrustedDestinationsInput>>;
  addTrustedSmartContracts?: InputMaybe<Array<AddTrustedSmartContractInput>>;
  clientID?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  organizationRename?: InputMaybe<OrganizationRenameInput>;
  policyContainerUpdates?: InputMaybe<Array<InputPolicyContainerUpdateChanges>>;
  removeAssetSupport?: InputMaybe<Array<RemoveAssetSupportInput>>;
  removeBootMeasurementSets?: InputMaybe<Array<RemoveBootMeasurementSetInput>>;
  removeQuorumRecoveries?: InputMaybe<Array<RemoveQuorumRecoveryInput>>;
  removeTrustedDestinations?: InputMaybe<Array<RemoveTrustedDestinationsInput>>;
  removeTrustedSmartContracts?: InputMaybe<Array<RemoveTrustedSmartContractInput>>;
  removeUserKeys?: InputMaybe<Array<RemoveUserKeyInput>>;
  setCvmIntelTdxRootCa?: InputMaybe<SetCvmIntelTdxRootCaInput>;
  setCvmRootCertificatesInfo?: InputMaybe<SetCvmRootCertificatesInfoInput>;
  setIntelTdxCollateral?: InputMaybe<SetIntelTdxCollateralInput>;
  updateAssetSupport?: InputMaybe<Array<UpdateAssetSupportInput>>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareCreateKeyRenameArgs = {
  clientID: Scalars['ID']['input'];
  keyRenames: Array<InputKeyRename>;
  message?: InputMaybe<Scalars['String']['input']>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareCreateNewPolicyArgs = {
  clientID: Scalars['ID']['input'];
  defaultRule: InputRule;
  keyAccesses: Array<InputKeyAccess>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resourcesIDs: Array<Scalars['ID']['input']>;
  specificRules?: InputMaybe<Array<InputRule>>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareCreatePolicyV2Args = {
  input: CreatePolicyV2Input;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareCreateVaultArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  clientID: Scalars['String']['input'];
  description: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  policies?: InputMaybe<Array<InputPolicy>>;
  policyContainerUpdates?: InputMaybe<InputPolicyContainerUpdate>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareCreateVaultWithExistingPolicyArgs = {
  accountID: Scalars['ID']['input'];
  clientID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  policyID: Scalars['ID']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareCreateVaultWithNewPolicyArgs = {
  accountID: Scalars['ID']['input'];
  clientID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  policy: InputCreateVaultPolicy;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareCreateVaultWithNewPolicyV2Args = {
  accountID: Scalars['ID']['input'];
  clientID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  policy: CreateVaultPolicyV2Input;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareDelegationArgs = {
  amount?: InputMaybe<Scalars['String']['input']>;
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  consolidationTarget?: InputMaybe<Scalars['String']['input']>;
  delegateType?: InputMaybe<DelegateType>;
  destination: Scalars['String']['input'];
  destinationName?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  extraParams?: InputMaybe<InputExtraParams>;
  isFullAmount?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  stakingPositionID?: InputMaybe<Scalars['String']['input']>;
  stakingProvider?: InputMaybe<Scalars['String']['input']>;
  useGasStation?: InputMaybe<Scalars['Boolean']['input']>;
  vaultSubID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareDisableVaultArgs = {
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareGenericOperationArgs = {
  assetSubID?: InputMaybe<Scalars['String']['input']>;
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  genericOperationType?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
  userIntentType?: InputMaybe<Scalars['String']['input']>;
  vaultSubID?: InputMaybe<Scalars['String']['input']>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
  walletUniqueID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareLockArgs = {
  amount: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  extraParams?: InputMaybe<InputExtraParams>;
  message?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareOneOffArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  extraParams?: InputMaybe<InputExtraParams>;
  message?: InputMaybe<Scalars['String']['input']>;
  oneOffParams: Array<InputOneOffParam>;
  oneOffType: OneOffType;
  vaultSubID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareRawTransactionApprovalArgs = {
  marshalledChange: Scalars['String']['input'];
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareRemoveFiatTrustedDestinationArgs = {
  clientID: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  trustedDestinationID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareRemoveTrustedDestinationArgs = {
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  trustedDestinationSubID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareRemoveUserArgs = {
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  publicKeyID: Scalars['PublicKeyID']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareReplacePolicyAssignmentArgs = {
  clientID: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  newPolicyID: Scalars['ID']['input'];
  resourceID: Scalars['ID']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareTurnkeyBinaryConfigChangeArgs = {
  addTurnkeyBinaryConfigs?: InputMaybe<Array<AddTurnkeyBinaryConfigInput>>;
  clientID?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  removeTurnkeyBinaryConfigs?: InputMaybe<Array<RemoveTurnkeyBinaryConfigInput>>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareUnlockArgs = {
  amount: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  extraParams?: InputMaybe<InputExtraParams>;
  message?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareUpdateOrgPolicyArgs = {
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<InputPolicy>>;
  policyContainerUpdates?: InputMaybe<InputPolicyContainerUpdate>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareUpdatePolicyArgs = {
  clientID: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  policyID: Scalars['ID']['input'];
  updatedDefaultRule?: InputMaybe<InputRuleUpdate>;
  updatedKeyAccesses?: InputMaybe<Array<InputKeyAccess>>;
  updatedName?: InputMaybe<Scalars['String']['input']>;
  updatedResourcesIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedSpecificRules?: InputMaybe<Array<InputRuleUpdate>>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareUpdatePolicyV2Args = {
  input: UpdatePolicyV2Input;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareUpdateVaultPolicyArgs = {
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  policyContainerUpdates?: InputMaybe<InputVaultPolicyContainerUpdate>;
  userAccessUpdates?: InputMaybe<Array<InputUserAccessUpdate>>;
  vaultPolicies?: InputMaybe<Array<InputVaultPolicy>>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareVoteArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  extraParams?: InputMaybe<InputExtraParams>;
  message?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['String']['input'];
  visibleInOperationsList?: Scalars['Boolean']['input'];
  voteYeas: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprepareWithdrawalArgs = {
  amlQuestionnaire?: InputMaybe<InputQuestionnaireSubmission>;
  amount: Scalars['String']['input'];
  assetSubID?: InputMaybe<Scalars['String']['input']>;
  assetTypeID: Scalars['AssetTypeID']['input'];
  clientID: Scalars['String']['input'];
  deductFeeFromAmountIfSameType?: InputMaybe<Scalars['Boolean']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  destinationAssetSubID?: InputMaybe<Scalars['String']['input']>;
  destinationSNParticipantID?: InputMaybe<Scalars['String']['input']>;
  destinationTrustedDestinationID?: InputMaybe<Scalars['String']['input']>;
  destinationVaultSubID?: InputMaybe<Scalars['String']['input']>;
  destinationWalletID?: InputMaybe<Scalars['ID']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  extraParams?: InputMaybe<InputExtraParams>;
  feeCustomization?: InputMaybe<FeeCustomization>;
  message?: InputMaybe<Scalars['String']['input']>;
  orgGasConfig?: InputMaybe<OrgGasConfigInput>;
  tokenID?: InputMaybe<Scalars['String']['input']>;
  useGasStation?: InputMaybe<Scalars['Boolean']['input']>;
  vaultSubID?: InputMaybe<Scalars['String']['input']>;
  visibleInOperationsList?: Scalars['Boolean']['input'];
  walletID?: InputMaybe<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationproposeManualDepositArgs = {
  input: ProposeManualDepositInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationproposeOpsExceptionOverrideArgs = {
  exceptionID: Scalars['String']['input'];
  expectedVersion: Scalars['Int']['input'];
  overrides: Array<KeyValueInput>;
  reason: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationproposeUnassignedDepositAttributionArgs = {
  input: ProposeUnassignedDepositAttributionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationprovisionAddressArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationqueueAffiliateKYCScreeningArgs = {
  affiliateID: Scalars['ID']['input'];
  bypassDuplicateCheck?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationqueueIndividualKYCScreeningArgs = {
  bypassDuplicateCheck?: InputMaybe<Scalars['Boolean']['input']>;
  clientID: Scalars['ID']['input'];
  individualID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrebuildPolicyContainerGroupsArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrecklesslyCompleteOperationIKnowWhatImDoingArgs = {
  blockHash: Scalars['String']['input'];
  blockHeight: Scalars['String']['input'];
  extraData: Scalars['String']['input'];
  finalFee: Scalars['String']['input'];
  operationID: Scalars['String']['input'];
  receiptID: Scalars['String']['input'];
  transactionSuccess: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrefillPriceHistoryArgs = {
  assetTypeIDs: Array<Scalars['AssetTypeID']['input']>;
  days: Scalars['Int']['input'];
  overwrite?: Scalars['Boolean']['input'];
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrefreshPolicyContainerGroupsArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrefreshReportTypeSchemaArgs = {
  applyChanges?: InputMaybe<Scalars['Boolean']['input']>;
  expectedSchemaFingerprint?: InputMaybe<Scalars['String']['input']>;
  reportTypeDefinitionID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationregenerateReportScheduleArgs = {
  input: RegenerateReportScheduleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationregisterDeviceTokenArgs = {
  deviceToken: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationregisterWebhookEndpointArgs = {
  in: NewWebhookEndpointInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationreleaseTradingStrategyCollateralHoldArgs = {
  holdID: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveAffiliateFromClientArgs = {
  affiliateID: Scalars['String']['input'];
  clientID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveAffiliateKycProfileArgs = {
  affiliateKYCProfileID: Scalars['ID']['input'];
  organizationKYCProfileIDs: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveAffiliateRepresentativeArgs = {
  affiliateID: Scalars['String']['input'];
  representativeEmail: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveAssetEnablementStatusOverrideArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  entity: AnchorageEntityType;
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveAssetFromStablecoinRewardsProgramArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  programID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveGlobalTrustedSourcesArgs = {
  globalTrustedSourceIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveIndividualFromAffiliateArgs = {
  affiliateID: Array<Scalars['ID']['input']>;
  individualID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveIndividualRepresentativeArgs = {
  individualID: Scalars['String']['input'];
  representativeEmail: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveRelatedPartyKycProfileArgs = {
  affiliateKYCProfileIDs: Array<Scalars['ID']['input']>;
  relatedPartyKYCProfileID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveRelatedPartyRelationshipsArgs = {
  affiliateID: Array<Scalars['ID']['input']>;
  relatedPartyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveRepresentativeArgs = {
  kycProfileID: Scalars['String']['input'];
  representativeProfileID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveScheduledReportArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveScheduledReportSubscriberArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveStablecoinRewardsParticipantsFromProgramArgs = {
  participantIDs: Array<Scalars['String']['input']>;
  programID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveTrueUpSkipArgs = {
  input: TrueUpSkipInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveTrustedSourcesArgs = {
  trustedSouceIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationremoveValidatorFromAllowlistArgs = {
  address: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationreplaceTokenArgs = {
  userKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationreprovisionAddressArgs = {
  addressSubID: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrescreenBlockchainScreeningArgs = {
  analysisType: Scalars['String']['input'];
  identifier?: InputMaybe<Scalars['String']['input']>;
  operationID: Scalars['String']['input'];
  source: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationresendAffiliateFormArgs = {
  affiliateID: Scalars['String']['input'];
  representative?: InputMaybe<RepresentativeInput>;
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
  useKycFormURLFormat?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationresendIndividualFormArgs = {
  individualID: Scalars['String']['input'];
  representative?: InputMaybe<RepresentativeInput>;
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
  useKycFormURLFormat?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationresendOrderExecutionNotificationArgs = {
  notificationID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationresetAllowedVaultsForDAppArgs = {
  allowedVaultSubIDs: Array<Scalars['String']['input']>;
  dappID: Scalars['String']['input'];
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationresetDepositAttributionScreeningArgs = {
  operationIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationresetNetworkArgs = {
  networkID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationresignTransactionArgs = {
  operationID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationresolveScanningIssueArgs = {
  id: Scalars['String']['input'];
  networkID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrestoreClientOperationCommentArgs = {
  commentID: Scalars['String']['input'];
  commentSubID: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationresumeCoinductorAutomationPolicyArgs = {
  policyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationretriggerDocuSignArgs = {
  input: RetriggerDocuSignInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationretryAccountOpeningArgs = {
  input: RetryAccountOpeningInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationreviewFiatWithdrawalRequestArgs = {
  approved: Scalars['Boolean']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  transactionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationreviewMovementOfFundsStatusArgs = {
  id: Scalars['String']['input'];
  status: MovementOfFundsStatus;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationreviewOpsExceptionArgs = {
  approved: Scalars['Boolean']['input'];
  exceptionID: Scalars['String']['input'];
  expectedVersion: Scalars['Int']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrevokeAPIKeyWithErrorsArgs = {
  keyID: Scalars['String']['input'];
  reportCompromised?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrevokeCoinductorAutomationPolicyArgs = {
  policyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrevokeRemovedKeysArgs = {
  dryRun: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationriaCreatFeeConfigurationArgs = {
  input: CreateFeeConfig;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationriskEndorseArgs = {
  decision: OperationDecision;
  operationID: Scalars['String']['input'];
  overrideRequiredApprovals?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationroboLoginArgs = {
  robotName?: InputMaybe<Scalars['String']['input']>;
  sessionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrollbackMigrateRolesArgs = {
  organization?: InputMaybe<Scalars['String']['input']>;
  rollbackAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationrunAuditReportArgs = {
  networkID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsanitizeAddressArgs = {
  address: Scalars['String']['input'];
  networkID: Scalars['NetworkID']['input'];
  validationPurpose?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsaveDocumentDeliverySettingArgs = {
  isOrgLevel: Scalars['Boolean']['input'];
  organizationID: Scalars['ID']['input'];
  settingType: SettingType;
  settings?: InputMaybe<Array<InputDocDeliverySetting>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsaveKYCQuestionnaireSubmissionArgs = {
  input: SaveKYCQuestionnaireSubmissionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsaveScanningIssueArgs = {
  scanningIssue: ScanningIssueInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationscanBlockArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  block: Scalars['String']['input'];
  maxScanLimit: Scalars['String']['input'];
  overrideDisabledNetwork?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationscanBlockIntervalArgs = {
  end: Scalars['String']['input'];
  networkID: Scalars['String']['input'];
  overrideDisabledNetwork?: Scalars['Boolean']['input'];
  start: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationscanDateIntervalArgs = {
  endDate: Scalars['String']['input'];
  networkID: Scalars['String']['input'];
  overrideDisabledNetwork?: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationscheduleSharedPoliciesMigrationArgs = {
  orgKeyIDs: Array<Scalars['String']['input']>;
  scheduledFor: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationseAssignDepositArgs = {
  destinationCounterpartyAccountID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationseAssignWithdrawalArgs = {
  id: Scalars['ID']['input'];
  sourceCounterpartyAccountID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationseCreateLocationArgs = {
  seCreateLocationInput: SECreateLocationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationseCreateTransferArgs = {
  seCreateTransferInput: SECreateTransferInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationseReverseTransferArgs = {
  transferID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationseUpdateLocationArgs = {
  seUpdateLocationInput: SEUpdateLocationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationseUpdateTransferArgs = {
  seUpdateTransferInput: SEUpdateTransferInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsendFormArgs = {
  kycProfileID: Scalars['ID']['input'];
  representative?: InputMaybe<RepresentativeInput>;
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsendInvitationEmailForEnrollmentArgs = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  enrollToken: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsendKYCEventArgs = {
  input: SendKYCEventInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsendKYCQuestionnaireSubmissionArgs = {
  input: SendKYCQuestionnaireSubmissionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsendReferralWorkflowSubmissionArgs = {
  formName: ReferralFormName;
  submission: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsendTestWebhookArgs = {
  endpointID: Scalars['ID']['input'];
  eventTypeID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsendUnsentStatementEmailsArgs = {
  accountIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationID: Scalars['String']['input'];
  statementIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  statementTypes?: InputMaybe<Array<StatementType>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationserviceFeeTermsApproveTerminationArgs = {
  input: ApproveServiceFeeTermsTerminationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationserviceFeeTermsCancelArgs = {
  input: CancelServiceFeeTermsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationserviceFeeTermsCreateArgs = {
  input: CreateServiceFeeTermsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationserviceFeeTermsTerminateArgs = {
  input: TerminateServiceFeeTermsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationserviceFeeTermsUpdateArgs = {
  input: UpdateServiceFeeTermsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetAssetEnablementStatusArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  enabled: Scalars['Boolean']['input'];
  entity: AnchorageEntityType;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetAssetEnablementStatusOverrideArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  enabled: Scalars['Boolean']['input'];
  entity: AnchorageEntityType;
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetAssetTagsArgs = {
  input: SetAssetTagsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetAssociatedAddressArgs = {
  addressSubID: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  associatedAddressType: Scalars['String']['input'];
  blockNumber: Scalars['String']['input'];
  externalAddress: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  scannable: Scalars['Boolean']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetCryptoOnlyArgs = {
  isCryptoOnly: Scalars['Boolean']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetETHStakingProviderForVaultArgs = {
  organizationKeyID: Scalars['String']['input'];
  vaultETHStakingProvider: ETHStakingProviderType;
  vaultSubID: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetEnabledWebhookEventTypesArgs = {
  in: Array<Scalars['String']['input']>;
  orgID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetEthereumStakingProvidersConfigurationForOrgArgs = {
  configuration: InputEthereumStakingProvidersConfiguration;
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetExemptPIIArgs = {
  enrollToken: Scalars['String']['input'];
  informationType: IndividualInformationTypeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetFeatureEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  featureName: FeatureName;
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetFixedPriceArgs = {
  fromAsset: Scalars['String']['input'];
  fromTokenID?: Scalars['String']['input'];
  price: Scalars['String']['input'];
  toAsset: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetFlowAddressArgs = {
  address: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetFormStatusArgs = {
  formID: Scalars['String']['input'];
  formStatus: FormStatus;
  formType: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetGasStationForTestOnlyArgs = {
  walletID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetHederaAddressArgs = {
  address: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetLastLoginDateArgs = {
  date: Scalars['Timestamp']['input'];
  userKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetLostDeviceArgs = {
  recovered?: InputMaybe<Scalars['Boolean']['input']>;
  userKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetNotificationCountArgs = {
  count: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetOrganizationAccessPolicyArgs = {
  organizationKeyID: Scalars['String']['input'];
  webSessionExpiry: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetOrganizationDisabledArgs = {
  disabled: Scalars['Boolean']['input'];
  organizationKeyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetOrganizationKycProfileStatusArgs = {
  organizationKycProfileID: Scalars['ID']['input'];
  status: KYCStatus;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetOrganizationNotesArgs = {
  notes: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetOrganizationWireFeeConfigArgs = {
  chargeWireFee: Scalars['Boolean']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetPriceSymbolConversionArgs = {
  fromAsset: Scalars['String']['input'];
  source: Scalars['String']['input'];
  toAsset: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetReportTypeFilterDefinitionsArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  filterDefinitions: Array<ReportTypeFilterDefinitionInput>;
  reportTypeDefinitionID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetReportTypeHeadersArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  headers: Array<ReportTypeHeaderInput>;
  reportTypeDefinitionID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetReportTypeValidationsArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  reportTypeDefinitionID: Scalars['ID']['input'];
  validations: Array<ReportTypeValidationInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetSLAForOrgArgs = {
  organizationKeyID: Scalars['String']['input'];
  sla: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetSpecialAddressArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  specialAddressType: SpecialAddressType;
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetSubaccountSegregationArgs = {
  input: SetSubaccountSegregationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetTalosCustomerArgs = {
  customerName: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetTradersArgs = {
  input: Array<SetTraderInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetUserPIIArgs = {
  piis: Array<InputMaybe<InputPII>>;
  userId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetVestingInfoArgs = {
  addressSubID: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  autoClaimVestedSchedule?: InputMaybe<VestingSchedule>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  iWillRescanTheBlockchainAfter: Scalars['Boolean']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetWalletKeyExportPreferenceArgs = {
  deliveryChannel: WalletKeyExportChannel;
  email?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsetWalletUtxoExclusionArgs = {
  excluded: Scalars['Boolean']['input'];
  input: WalletUtxoExclusionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationshareInvoicesByEmailArgs = {
  input: ShareInvoicesByEmailInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationshareTaxDocumentsByEmailArgs = {
  input: ShareTaxDocumentsByEmailInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsnAddTrustedCounterpartiesArgs = {
  counterpartyID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ownerIDs: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsnParticipantCreateArgs = {
  accountID: Scalars['String']['input'];
  automations?: InputMaybe<Array<SNAutomationInput>>;
  customDefaultWallets?: InputMaybe<Array<ReplaceDefaultWalletInput>>;
  defaultVaultUniqueID?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['String']['input'];
  tier?: InputMaybe<SNParticipantTier>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsnParticipantUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  automations?: InputMaybe<Array<SNAutomationInput>>;
  customDefaultWallets?: InputMaybe<Array<DefaultWalletInput>>;
  defaultVaultUniqueID?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  replaceCustomDefaultWallets?: InputMaybe<Array<ReplaceDefaultWalletInput>>;
  tier?: InputMaybe<SNParticipantTier>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsnReleaseHoldsArgs = {
  holdIDs: Array<Scalars['ID']['input']>;
  settlementID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsnSettlementAcceptArgs = {
  settlementID: Scalars['ID']['input'];
  useGasStation?: InputMaybe<Scalars['Boolean']['input']>;
  vaultUniqueID?: InputMaybe<Scalars['ID']['input']>;
  walletAmounts: Array<WalletAmountInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsnSettlementApprovalOverrideArgs = {
  approve: Scalars['Boolean']['input'];
  participantID: Scalars['ID']['input'];
  settlementID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsnSettlementCancelArgs = {
  settlementID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsnSettlementRejectArgs = {
  settlementID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsnUpdateTrustedCounterpartyArgs = {
  counterpartyID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  ownerID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstagedOrganizationCompleteArgs = {
  orgToken: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstagedOrganizationCreateArgs = {
  backupStrategy?: InputMaybe<WalletKeyBackupStrategy>;
  clientID: Scalars['String']['input'];
  hsmZoneID: Scalars['String']['input'];
  name: Scalars['String']['input'];
  operator: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstagedOrganizationCreateForTestingArgs = {
  input: StagedOrganizationCreateForTestingInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstagedOrganizationDeleteArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  orgToken: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstagedOrganizationUpdateArgs = {
  newDefinition: Scalars['String']['input'];
  oldDefinition: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstagedOrganizationUpdateV2Args = {
  enrollTokensToEdit?: InputMaybe<Array<StagedTokenInput>>;
  enrollTokensToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  individualsToAdd?: InputMaybe<Array<StagedTokenInput>>;
  orgToken: Scalars['String']['input'];
  signaturesRequired?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstartAddUserOperationArgs = {
  enrollToken: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstartDynamicCRRCalculationArgs = {
  affiliateIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstartFullQuorumRecoveryArgs = {
  lostKeyIDs: Array<Scalars['String']['input']>;
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstartTokenSwapArgs = {
  input: StartTokenSwapInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstartWalletActivationBatchArgs = {
  sourceWalletIDs: Array<Scalars['ID']['input']>;
  targetNetworkIDs: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstartWalletBulkCreateArgs = {
  request: StartWalletBulkCreateInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstatementsV2CreateSignedStatementURLsArgs = {
  statementIDs: Array<Scalars['String']['input']>;
  statementTypeID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstatementsV2PublishStatementsArgs = {
  coverageStartMonthsAsYYYYMM: Array<Scalars['Int']['input']>;
  shouldPublish?: Scalars['Boolean']['input'];
  statementIDs: Array<Scalars['String']['input']>;
  statementTypeID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstatementsV2ScheduleCreateArgs = {
  scheduleInput: StatementsV2ScheduleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstatementsV2StatementGenerateAsyncArgs = {
  filters: Array<StatementsV2StatementFilter>;
  forceCreation?: Scalars['Boolean']['input'];
  format?: StatementsV2StatementFormat;
  isCorrection?: Scalars['Boolean']['input'];
  isDebug?: Scalars['Boolean']['input'];
  overrideMonthlyBalances?: Scalars['Boolean']['input'];
  publishImmediately?: Scalars['Boolean']['input'];
  statementTypeID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationstoreABIManualArgs = {
  abi: Scalars['String']['input'];
  contractAddress: Scalars['String']['input'];
  implementationAddress?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  networkID: Scalars['String']['input'];
  standard?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubaccountGasFillWalletArgs = {
  amount: AmountInput;
  walletID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubaccountSweepBetweenWalletsArgs = {
  amount?: InputMaybe<AmountInput>;
  destinationwalletID: Scalars['String']['input'];
  sourcewalletID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubaccountSweepCommingledWalletsArgs = {
  amount?: InputMaybe<AmountInput>;
  createIfMissing: Scalars['Boolean']['input'];
  orgID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubaccountSweepLinkedWalletArgs = {
  walletID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubmitNewAssetFeedbackArgs = {
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  requestedAssetDecimals?: InputMaybe<Scalars['Int']['input']>;
  requestedAssetName?: InputMaybe<Scalars['String']['input']>;
  requestedAssetRiskLevel?: InputMaybe<SmartContractRiskLevel>;
  requestedAssetTypeID?: InputMaybe<Scalars['String']['input']>;
  requestedNetworkID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubmitPIIArgs = {
  entries: Array<InputPII>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubmitStagedControlKeysArgs = {
  controlMasterPublicKey: Scalars['String']['input'];
  userKeys: Array<InputEncryptedControlMasterPrivateKey>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubmitStagedWalletRecoveryKeyArgs = {
  walletRecoveryKeyAlgorithm: Scalars['String']['input'];
  walletRecoveryPublicKey: Scalars['String']['input'];
  walletRecoveryPublicKeySignature: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubmitStagedWalletRecoveryKeySharesArgs = {
  encryptedShares: Array<InputEncryptedWalletRecoveryKeyShares>;
  walletRecoveryKeyAlgorithm: Scalars['String']['input'];
  walletRecoveryPublicKey: Scalars['String']['input'];
  walletRecoveryPublicKeySignature: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsubmitWalletRecoveryKeySharesArgs = {
  encryptedShares: Array<InputEncryptedWalletRecoveryKeyShares>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsyncProgramCustomerRosterArgs = {
  idempotencyKey: Scalars['String']['input'];
  rows: Array<ProgramCustomerRosterRowInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationsyncTaxCertificationDataToKYCArgs = {
  input: SyncTaxCertificationDataToKYCInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtagTaxTransactionArgs = {
  input: TagTaxTransactionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtaxCertificationTokenArgs = {
  submissionID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtaxCreateTenantArgs = {
  input: CreateTenantInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtaxDeleteTenantArgs = {
  tenantID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtaxReconcileTradesArgs = {
  input: TaxReconcileTradesInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtaxUpdateTenantArgs = {
  input: UpdateTenantInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtaxbitAccountOwnerTokenArgs = {
  input: TaxbitAccountOwnerTokenInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationterminateWalletConnectSessionArgs = {
  connectionID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationterminateWalletConnectSessionsArgs = {
  dappID: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  userKeyIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtokenizeArgs = {
  input: TokenizeInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradeQuoteArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  allocationRequest?: InputMaybe<Scalars['Boolean']['input']>;
  quoteID: Scalars['String']['input'];
  side: TradeSide;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingAddSettlementAddressArgs = {
  address: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingAddSymbolArgs = {
  entity?: InputMaybe<AnchorageEntityType>;
  symbol: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingApproveAssetArgs = {
  input: TradingApproveAssetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingApproveSymbolByIDArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingAssignClientSettlementArgs = {
  isUnassign?: InputMaybe<Scalars['Boolean']['input']>;
  orgKeyID: Scalars['String']['input'];
  settlementID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCancelClientSettlementsArgs = {
  orgKeyID: Scalars['String']['input'];
  settlementIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCounterpartyCreateArgs = {
  displayName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  kind: CounterpartyKind;
  name: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCounterpartyUpdateArgs = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateAccountArgs = {
  accountID?: InputMaybe<Scalars['ID']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  limits?: InputMaybe<Array<AmountInput>>;
  name: Scalars['String']['input'];
  organizationKeyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateAssetArgs = {
  input: TradingCreateAssetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateClientSettlementArgs = {
  assetTypeID: Scalars['String']['input'];
  entity?: InputMaybe<AnchorageEntityType>;
  orgKeyID: Scalars['String']['input'];
  paymentFlowIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  tradingEntity?: InputMaybe<TradingEntity>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateExternalAssetArgs = {
  input: TradingCreateExternalAssetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateFeeClientSettlementArgs = {
  entity?: InputMaybe<AnchorageEntityType>;
  feeTransactionID: Scalars['String']['input'];
  orgKeyID: Scalars['String']['input'];
  tradingEntity?: InputMaybe<TradingEntity>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateManualOrdersArgs = {
  input: Array<TradingCreateManualOrderInput>;
  linkedDealerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateSettlementFromFiltersArgs = {
  filters: TradingCreateSettlementFromFiltersInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateTalosAccountArgs = {
  input: CreateTradingTalosAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateTradingPermissionArgs = {
  input: TradingPermissionsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateWalletSettlementInstructionsArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  walletUniqueID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingCreateWhitelabelUserArgs = {
  auth0ID: Scalars['String']['input'];
  email: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  otpSeed?: InputMaybe<Scalars['String']['input']>;
  otpSeedEncryptionAlgo?: InputMaybe<Scalars['Int']['input']>;
  userKeyID?: InputMaybe<Scalars['String']['input']>;
  userKeyIDType?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerManualTradeCancelArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerManualTradeCreateArgs = {
  amount: Scalars['String']['input'];
  amountCurrency: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  entity?: InputMaybe<Scalars['String']['input']>;
  execID?: InputMaybe<Scalars['ID']['input']>;
  internalSettlementID?: InputMaybe<Scalars['ID']['input']>;
  isHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  lastEventType?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  ordType: OrdType;
  parentOrderID: Scalars['ID']['input'];
  price: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  side: TradeSide;
  symbol: Scalars['String']['input'];
  tradeID?: InputMaybe<Scalars['String']['input']>;
  transactTime: Scalars['Timestamp']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerManualTradeUpdateArgs = {
  ID: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['String']['input']>;
  amountCurrency?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  execID?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  ordType?: InputMaybe<OrdType>;
  parentOrderID?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<TradeSide>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  transactTime?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerSettlementCancelArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerSettlementCreateArgs = {
  paymentFlowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerSettlementCreateCounterpartyAssetArgs = {
  assetType: Scalars['AssetTypeID']['input'];
  counterparty: Scalars['String']['input'];
  entity?: InputMaybe<AnchorageEntityType>;
  tradingEntity?: InputMaybe<TradingEntity>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerSettlementCreateFromFiltersArgs = {
  input: DealerSettlementCreateInput;
  isPreview: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerSettlementInitiateArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerSettlementSettleArgs = {
  id: Scalars['ID']['input'];
  transactionIDs: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDealerSettlementUpdateTransactionIDsArgs = {
  id: Scalars['ID']['input'];
  transactionIDs: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDeleteAssetArgs = {
  input: TradingDeleteAssetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDeleteExternalAssetArgs = {
  input: TradingDeleteExternalAssetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDeleteTradeSettlementTransactionArgs = {
  tradeSettlementTransactionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDeleteWalletSettlementInstructionArgs = {
  instructionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingDeleteWhitelabelUserArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingEnableSymbolByIDArgs = {
  id: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingFixCreditDiscrepancyArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingLedgerCancelTransactionsArgs = {
  input: TradingLedgerCancelTransactionsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingLedgerCreateTransactionsArgs = {
  input: TradingLedgerCreateTransactionsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingLedgerReconcileTransactionsArgs = {
  input: TradingLedgerReconcileTransactionsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingLinkClientAndDealerOrdersArgs = {
  clientOrderIDs: Array<Scalars['String']['input']>;
  dealerOrderIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingProcessClientSettlementArgs = {
  orgKeyID: Scalars['String']['input'];
  settlementID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingReinitiateClientSettlementArgs = {
  orgKeyID: Scalars['String']['input'];
  settlementID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingSaveTradeSettlementTransactionArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  settlementID: Scalars['String']['input'];
  transactionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateAccountsArgs = {
  organizationKeyID: Scalars['ID']['input'];
  updateAccounts: Array<UpdateAccountInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateAssetArgs = {
  input: TradingUpdateAssetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateAssetPrecisionArgs = {
  active: Scalars['Boolean']['input'];
  baseSizeScale: Scalars['Int']['input'];
  minimumOrderSize?: InputMaybe<Scalars['Decimal']['input']>;
  minimumOrderSizeString?: InputMaybe<Scalars['String']['input']>;
  priceScale: Scalars['Int']['input'];
  quoteSizeScale: Scalars['Int']['input'];
  symbol: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateBackfilledManualOrderArgs = {
  tradingUpdateManualOrderInput: TradingUpdateManualOrderInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateFiatSettlementTransactionArgs = {
  orgKeyID: Scalars['String']['input'];
  settlementID: Scalars['String']['input'];
  transactionID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateManualOrderArgs = {
  tradingUpdateManualOrderInput: TradingUpdateManualOrderInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateSettlementAddressArgs = {
  address: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateSymbolByIDArgs = {
  id: Scalars['ID']['input'];
  newEntity?: InputMaybe<AnchorageEntityType>;
  newSymbol?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateTalosAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTradingTalosAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateTradeSettlementTransactionArgs = {
  assetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  tradeSettlementTransactionID: Scalars['String']['input'];
  transactionID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtradingUpdateWhitelabelUserArgs = {
  auth0ID?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  userKeyID?: InputMaybe<Scalars['String']['input']>;
  userKeyIDType?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtravelRuleSetAutomationArgs = {
  automationEnabled: Scalars['Boolean']['input'];
  operationID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtriggerFiatWalletBackfillArgs = {
  label: Scalars['String']['input'];
  networkID?: InputMaybe<Scalars['String']['input']>;
  orgIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtriggerFillBasedTaxReportArgs = {
  input: TriggerFillBasedTaxReportInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtriggerHandleStakedTransferWorkflowArgs = {
  input: TriggerHandleStakedTransferWorkflowInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtriggerRIAFBOMigrationArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  mode: Scalars['String']['input'];
  networkID?: InputMaybe<Scalars['String']['input']>;
  orgIDs: Array<Scalars['String']['input']>;
  wave: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtriggerScheduledReportArgs = {
  retryAt?: InputMaybe<Scalars['Time']['input']>;
  scheduledReportID: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtriggerStrategyFundSweepArgs = {
  input: TriggerStrategyFundSweepInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtriggerSubaccountTrueUpArgs = {
  input: TriggerSubaccountTrueUpInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationtriggerWebhookArgs = {
  endpointID: Scalars['ID']['input'];
  in: TriggerWebhookInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationunarchiveWalletsArgs = {
  walletIDs: Array<Scalars['ID']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationunfreezeAccountArgs = {
  input: UnfreezeAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationunsetTalosCustomerArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationuntagTaxTransactionArgs = {
  input: UntagTaxTransactionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAccountArgs = {
  input: StaffUpdateAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAccountsFreezeWithdrawalArgs = {
  updates: Array<AccountFreezeWithdrawalInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAddressesAttestationsStateArgs = {
  requests: Array<AttestAddressRequest>;
  state: AddressAttestationState;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAffiliateArgs = {
  affiliateID?: InputMaybe<Scalars['String']['input']>;
  affiliateType?: InputMaybe<Scalars['String']['input']>;
  anchorageEntityTypes: Array<AnchorageEntityType>;
  clientID: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentAffiliateID?: InputMaybe<Scalars['String']['input']>;
  relatedPartyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  representative?: InputMaybe<RepresentativeInput>;
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
  sourceKYCProfileID?: InputMaybe<Scalars['String']['input']>;
  topLevelAffiliateID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAffiliateDocusignTemplateArgs = {
  affiliateID: Scalars['ID']['input'];
  templateID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAffiliateInformationArgs = {
  affiliateID: Scalars['ID']['input'];
  entries: Array<InputKnownInformation>;
  kycScreening?: InputMaybe<KYCScreeningInput>;
  notes: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAffiliateKYCProfileArgs = {
  affiliateKYCProfileID: Scalars['String']['input'];
  affiliateType?: InputMaybe<AffiliateType>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<KYCStatus>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAffiliateV2NameArgs = {
  affiliateID: Scalars['String']['input'];
  name: Scalars['String']['input'];
  propagate?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAffiliatesFreezeWithdrawalArgs = {
  updates: Array<AffiliateFreezeWithdrawalInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAtlasParticipantForStablecoinRewardsArgs = {
  atlasParticipantID: Scalars['String']['input'];
  participantID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateAutoCompoundArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  enabled: Scalars['Boolean']['input'];
  organizationID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateCRRRiskParametersArgs = {
  crrConfigs: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateClientArgs = {
  anchorageEntityTypes: Array<AnchorageEntityType>;
  clientID?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateClientNameArgs = {
  clientID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateCounterpartyArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateCounterpartyInput>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateCounterpartyAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCounterpartyAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateCustodianArgs = {
  input: UpdateCustodianInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateDefaultBankForOrgArgs = {
  bankName: BankName;
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateDepositAttributionSpamThresholdArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  input: UpdateDepositAttributionSpamThresholdInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateDerivsEntityBankAccountArgs = {
  input: UpdateDerivsEntityBankAccountInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateDerivsEntityWalletArgs = {
  input: UpdateDerivsEntityWalletInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateDerivsTrustedDestinationArgs = {
  input: UpdateDerivsTrustedDestinationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateDocuSignWorkflowArgs = {
  input: UpdateDocuSignWorkflowInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateIndividualAndRelationshipsArgs = {
  affiliateID: Scalars['ID']['input'];
  entries?: InputMaybe<Array<InputIndividualInformation>>;
  individualID: Scalars['ID']['input'];
  kycRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  kycScreening?: InputMaybe<KYCScreeningInput>;
  ownershipPercentage?: InputMaybe<Scalars['String']['input']>;
  representative?: InputMaybe<RepresentativeInput>;
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateIndividualInformationArgs = {
  entries: Array<InputKnownInformation>;
  individualID: Scalars['ID']['input'];
  kycScreening?: InputMaybe<KYCScreeningInput>;
  notes: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateKYCConfigArgs = {
  input: UpdateKYCConfigInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateKYCProcessTriggerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKYCProcessTriggerInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateKYCQuestionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKYCQuestionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateKYCQuestionnaireArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKYCQuestionnaireInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateKYCQuestionnaireSubmissionArgs = {
  input: UpdateKYCQuestionnaireSubmissionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateLegaltermsArgs = {
  legalterm: InputUpdateLegalterms;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateMarketingWidgetArgs = {
  id: Scalars['ID']['input'];
  interaction: WidgetInteraction;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateNetworkStatusArgs = {
  additionalInfoUrl?: InputMaybe<Scalars['String']['input']>;
  isDegraded: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  networkID: Scalars['NetworkID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateOrgACHDebitInSettingsArgs = {
  orgID: Scalars['String']['input'];
  settings: OrgACHDebitInSettingsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateOrgGasConfigArgs = {
  orgGasConfig: OrgGasConfigInput;
  orgID: Scalars['String']['input'];
  replace?: Scalars['Boolean']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateOrganizationKycProfileNameArgs = {
  name: Scalars['String']['input'];
  organizationKycProfileID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateOrganizationProfileArgs = {
  name: Scalars['String']['input'];
  organizationKYCProfileID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdatePolicyNameArgs = {
  name: Scalars['String']['input'];
  policyID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdatePrimaryBankForWalletArgs = {
  bankName: BankName;
  walletID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdatePrimaryDispatchMethodArgs = {
  input: UpdatePrimaryDispatchMethodInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateRIAOrganizationConfigurationArgs = {
  in: OrganizationConfigurationInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateRIATermsQuestionnaireArgs = {
  affiliateID: Scalars['ID']['input'];
  questionnaireName: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateRelatedPartyAndRelationshipsArgs = {
  input: UpdateRelatedPartyAndRelationshipsInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateRelatedPartyKycProfileArgs = {
  input: UpdateRelatedPartyKycProfileInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateRelatedPartyRelationshipsArgs = {
  affiliateID: Scalars['ID']['input'];
  kycRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  kycScreening?: InputMaybe<KYCScreeningInput>;
  ownershipPercentage?: InputMaybe<Scalars['String']['input']>;
  relatedPartyID: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateReportScheduleArgs = {
  input: UpdateReportScheduleInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateReportTypeDefinitionArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  input: UpdateReportTypeDefinitionInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateRepresentativeArgs = {
  newName: Scalars['String']['input'];
  representativeProfileID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateRoleMetadataArgs = {
  name: Scalars['String']['input'];
  roleSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateScanProgressArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  blockHash: Scalars['String']['input'];
  blockHeight: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateSettlementStatusArgs = {
  note: Scalars['String']['input'];
  settlementID: Scalars['String']['input'];
  status: TradeStatus;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateStablecoinRewardsParticipantNotesArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  participantID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateStablecoinRewardsParticipantStartDateArgs = {
  participantID: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateStablecoinRewardsProgramNotesArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTaxMappingArgs = {
  input: UpdateTaxMappingInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTierForStablecoinRewardsEnrollmentArgs = {
  participantID: Scalars['String']['input'];
  programID: Scalars['String']['input'];
  tier: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTradeApprovalByComplianceTeamArgs = {
  enabled: Scalars['Boolean']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTradeApprovalByTradingTeamArgs = {
  enabled: Scalars['Boolean']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTradeCommissionRateArgs = {
  organizationKeyID: Scalars['String']['input'];
  tradeCommissionBPS: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTradeSettingsArgs = {
  RFQTTL?: InputMaybe<Scalars['String']['input']>;
  acceptPriceLeniency?: InputMaybe<Scalars['String']['input']>;
  acceptTimeLeniency?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID: Scalars['String']['input'];
  priceImprovementRatio?: InputMaybe<Scalars['String']['input']>;
  pricesTimeout?: InputMaybe<Scalars['String']['input']>;
  quoteTTL?: InputMaybe<Scalars['String']['input']>;
  tradingEntity?: InputMaybe<TradingEntity>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTradesStatusArgs = {
  note: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  status: TradeStatus;
  tradeIDs: Array<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTradingEmailRecipientsArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  emails: Array<Scalars['String']['input']>;
  organizationKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTransactionArgs = {
  entityEntries?: InputMaybe<Array<TransactionEntryInput>>;
  organizationKeyId?: InputMaybe<Scalars['String']['input']>;
  status: TransactionStatus;
  transactionID: Scalars['String']['input'];
  walletEntries?: InputMaybe<Array<WalletEntryInput>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTransferArgs = {
  input: UpdateTransferInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateTransferAssetArgs = {
  input: UpdateTransferAssetInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateUnassignedPolicyArgs = {
  policyID: Scalars['ID']['input'];
  updatedDefaultRule?: InputMaybe<InputRuleUpdate>;
  updatedKeyAccesses?: InputMaybe<Array<InputKeyAccess>>;
  updatedName?: InputMaybe<Scalars['String']['input']>;
  updatedSpecificRules?: InputMaybe<Array<InputRuleUpdate>>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateUnsettledManualTradeArgs = {
  accountID?: InputMaybe<Scalars['ID']['input']>;
  amountBought: Scalars['String']['input'];
  amountSold: Scalars['String']['input'];
  assetBought: Scalars['String']['input'];
  assetSold: Scalars['String']['input'];
  capacity: TradeCapacity;
  createdAt: Scalars['Timestamp']['input'];
  fee: Scalars['String']['input'];
  feeCurrency: Scalars['String']['input'];
  orderType?: InputMaybe<OrdType>;
  organizationKeyID: Scalars['String']['input'];
  parentTradeID?: InputMaybe<Scalars['ID']['input']>;
  price: Scalars['String']['input'];
  side: TradeSide;
  tradeID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateUserSettingsArgs = {
  tradeDailyDigestEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tradeNotificationPerTransactionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  userKeyID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateValidatorAssignmentsArgs = {
  assetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  date: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateVaultAccountArgs = {
  accountID: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateVaultMetadataArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateVirtualAccountAddressArgs = {
  address: InputVirtualAccountAddress;
  approvedBy: Scalars['String']['input'];
  virtualAccountID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateWalletKeyBackupArgs = {
  addressSubID: Scalars['Int']['input'];
  networkID: Scalars['String']['input'];
  orgKeyID: Scalars['String']['input'];
  userKeyIDsToRemove: Array<Scalars['String']['input']>;
  vaultSubID: Scalars['Int']['input'];
  walletSubID: Scalars['Int']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateWalletKeyBackupByIDArgs = {
  userKeyIDsToRemove: Array<Scalars['String']['input']>;
  walletKeyUniqueID: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateWalletScreeningAllowlistEntryArgs = {
  input: UpdateWalletScreeningAllowlistEntryInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupdateWebhookEndpointArgs = {
  id: Scalars['ID']['input'];
  in: EditWebhookEndpointInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationuploadAccountStatementArgs = {
  accountID: Scalars['String']['input'];
  displayDateDay: Scalars['Int']['input'];
  displayDateMonth: Scalars['Int']['input'];
  displayDateYear: Scalars['Int']['input'];
  fileBase64: Scalars['String']['input'];
  orgKeyID?: InputMaybe<Scalars['String']['input']>;
  statementType: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationuploadAffiliateInformationArgs = {
  affiliateID: Scalars['ID']['input'];
  digestOnly?: InputMaybe<Scalars['Boolean']['input']>;
  fileBase64: Scalars['String']['input'];
  informationType: Scalars['String']['input'];
  kycScreening?: InputMaybe<KYCScreeningInput>;
  notes: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationuploadCostBasisCSVArgs = {
  input: UploadCostBasisCSVInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationuploadIndividualInformationArgs = {
  fileBase64: Scalars['String']['input'];
  individualID: Scalars['ID']['input'];
  informationType: Scalars['String']['input'];
  kycScreening?: InputMaybe<KYCScreeningInput>;
  notes: Scalars['String']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationuploadTrustedDestinationsCSVArgs = {
  fileBase64: Scalars['String']['input'];
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationuploadTrustedSmartContractsCSVArgs = {
  csvFileToUploadBase64: Scalars['String']['input'];
  orgID?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationupsertDAppArgs = {
  dApp: DAppInput;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationwalletConnectApproveSessionArgs = {
  sessionID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationwalletConnectInitializeSessionArgs = {
  uri: Scalars['String']['input'];
  walletUniqueID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationwalletConnectRejectSessionArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  sessionID: Scalars['ID']['input'];
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationwalletCreateArgs = {
  addressGenerationType?: InputMaybe<AddressGenerationType>;
  name: Scalars['String']['input'];
  networkID: Scalars['ID']['input'];
  vaultSubID: Scalars['String']['input'];
  walletTypeOverride?: InputMaybe<WalletTypeOverride>;
};


/** Mutation exposes all methods that allow information to be updated on the backend */
export type MutationwalletRenameArgs = {
  name: Scalars['String']['input'];
  walletID: Scalars['ID']['input'];
};

/** NFTCollection defines a NFT collection metadata */
export type NFTCollection = {
  __typename: 'NFTCollection';
  /** Further information regarding this asset type */
  assetTypeInfo: AssetTypeInfo;
  /** Token type for the collection (e.g. ERC721) */
  collectionType: Scalars['String']['output'];
  /** Image URL of the most recently added NFT, max 9 */
  images: Array<Scalars['String']['output']>;
  /** The last NFT Token added to the collection */
  latestToken: NftTokenInfo;
  /** Collection Name */
  name: Scalars['String']['output'];
  /** Number of tokens from this collection we currently have */
  tokenCount: Scalars['Int']['output'];
  /** Total price of all NFT tokens from this collection */
  totalPrice: Amount;
};

/**
 * NamedBalance represents a balance with metadata about why it's held.
 * Except for holds placed by API Key, the data is grouped by hold type, with the balance being the sum of the amount over all holds of that type.
 * For holds placed by API Key,
 */
export type NamedBalance = {
  __typename: 'NamedBalance';
  /**
   * amount represents the total amount of all holds of a specific hold type (that is not HoldTypePlacedByAPIKey),
   * and represents the amount of a specific hold if it is of HoldTypePlacedByAPIKey.
   */
  amount: Amount;
  /** apiKeyName represents the API Key name. Its value will be set if the hold is of HoldTypePlacedByAPIKey, otherwise it may be empty. */
  apiKeyName: Maybe<Scalars['String']['output']>;
  /**
   * description represents the HoldType, the types/reasons a hold can occur for holds not placed by API key,
   * and represents the
   */
  description: Scalars['String']['output'];
  /** holdID represents the hold ID. Its value will be set if the hold is of HoldTypePlacedByAPIKey, otherwise it may be empty. */
  holdID: Maybe<Scalars['String']['output']>;
};

export type NamingScheme = {
  nameTemplate?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A NetSuite invoice line item type (e.g. Custody Fee, Staking Rewards Fee) */
export type NetsuiteInvoiceItemType = {
  __typename: 'NetsuiteInvoiceItemType';
  description: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  itemName: Scalars['String']['output'];
  itemType: Scalars['String']['output'];
  netsuiteItemId: Scalars['String']['output'];
  subtype: Scalars['String']['output'];
};

/**
 * Input for point-in-time retrieval of netting set effective at a specific time
 * Returns exactly ONE record for the specific netting set ID at the given time
 */
export type NettingSetEffectiveAtInput = {
  effectiveAt: Scalars['Time']['input'];
  nettingSetId: Scalars['ID']['input'];
};

export type NettingSetFilter = {
  csaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  parties?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filter for netting set history records */
export type NettingSetHistoryFilter = {
  csaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type NettingSetParamsFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nettingSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type NettingSetRuleFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nettingSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** NetworkInfo contains information about the blockchain network on which assets are traded */
export type NetworkInfo = _commonNetworkInfo & {
  __typename: 'NetworkInfo';
  /** Returns the Address Provisioning Group ID of a group of networks that share address provisioning. */
  addressProvisioningGroupID: Scalars['String']['output'];
  /** Returns the network IDs that share the same ADC */
  compatibleNetworkIDs: Array<Scalars['ID']['output']>;
  /** Returns the NetworkInfos of the networks that share the same ADC */
  compatibleNetworks: Array<NetworkInfo>;
  /**
   * iconURL returns the url for fetching the icon for this network.
   * If the type is SVG, the size is ignored.
   * Icons are square.
   * The size is in pixels.
   */
  iconURL: Scalars['String']['output'];
  /** id is the unique identifier of the network, equal to networkID */
  id: Scalars['ID']['output'];
  /**
   * Labels that apply to the network (e.g. "Limited")
   * The limit argument will limit the max number of labels returned (unlimited by default)
   */
  labels: Array<NetworkLabel>;
  /** Returns the name of the Network in the form of a string */
  name: Scalars['String']['output'];
  /** Returns the ID of the native asset type for this network */
  nativeAssetTypeID: Scalars['AssetTypeID']['output'];
  /** Returns the Network Explorer URL. Could be nil. */
  networkExplorerURL: Maybe<Scalars['String']['output']>;
  /** Returns the ID of the Network */
  networkID: Scalars['ID']['output'];
  /** Information about the network when it is in degraded status (null if it's not degraded) */
  networkStatus: Maybe<NetworkStatus>;
  /** Returns the address provisioning family of the network */
  provisioningFamily: Scalars['String']['output'];
  /**
   * The token types supported by this network in our platform
   * This list is not exhaustive and may not include all token types supported by the network
   */
  supportedTokenTypes: Maybe<Array<TokenType>>;
  /** True if the network supports multiple addresses per wallet (ex. bitcoin) */
  supportsMultipleAddressesPerWallet: Scalars['Boolean']['output'];
  /** True if the network supports network level trusted destination (TD can be used on any asset on this network) */
  supportsNetworkLevelTrustedDestination: Scalars['Boolean']['output'];
};


/** NetworkInfo contains information about the blockchain network on which assets are traded */
export type NetworkInfoiconURLArgs = {
  iconType?: IconType;
  size?: Scalars['Int']['input'];
};


/** NetworkInfo contains information about the blockchain network on which assets are traded */
export type NetworkInfolabelsArgs = {
  limit?: Scalars['Int']['input'];
};

/** NetworkLabel provides information about a network label */
export type NetworkLabel = {
  __typename: 'NetworkLabel';
  /** Longer description of the label (can be shown in a tooltip or detailed screen) */
  description: Scalars['String']['output'];
  /** The name of the label - a short text shown in the label */
  title: Scalars['String']['output'];
};

/** NetworkStatus contains information when a network is in degraded status */
export type NetworkStatus = {
  __typename: 'NetworkStatus';
  /** optional link for more information (null if no additional information available) */
  additionalInfoUrl: Maybe<Scalars['String']['output']>;
  /** longer description of the network status */
  message: Scalars['String']['output'];
  /** Returns the ID of the Network */
  networkID: Scalars['NetworkID']['output'];
  /** short title describing the network status */
  title: Scalars['String']['output'];
};

/** Payload response for submitNewAssetFeedback mutation */
export type NewAssetFeedbackResponse = {
  __typename: 'NewAssetFeedbackResponse';
  /** Was request successful */
  success: Scalars['Boolean']['output'];
};

/** TODO: add description */
export type NewWebhookEndpointInput = {
  /** TODO: add description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** TODO: add description */
  orgID?: InputMaybe<Scalars['String']['input']>;
  /** TODO: add description */
  publicKey: Scalars['String']['input'];
  /** TODO: add description */
  subscriptions?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** TODO: add description */
  url: Scalars['String']['input'];
};

/** Token info for an NFT like token */
export type NftTokenInfo = TokenInfo & {
  __typename: 'NftTokenInfo';
  /** When this NFT was first deposited */
  addedAt: Maybe<Scalars['String']['output']>;
  /** The asset type id for this token */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Value of the token type (formatted for display) */
  displayValue: Maybe<Scalars['String']['output']>;
  /** The image url of this NFT */
  imageURL: Maybe<Scalars['String']['output']>;
  /** The name of the NFT */
  name: Scalars['String']['output'];
  /** The unique id for this token */
  tokenID: Scalars['String']['output'];
  /** The Explorer URL for this NFT */
  url: Scalars['String']['output'];
  /** Value of the token type (as a raw decimal value) */
  value: Maybe<Scalars['String']['output']>;
};

/** Node interface defined for objects with a Globally Unique ID. Implemented as defined in the Shopify GraphQL Tutorial, among other places. Reference link: https://github.com/Shopify/graphql-design-tutorial/blob/master/TUTORIAL.md */
export type Node = {
  /** The globally unique ID of the object */
  id: Scalars['ID']['output'];
};

/** Details for a validator that doesn't use a network address as its identifier */
export type NonAddressValidatorDetail = {
  __typename: 'NonAddressValidatorDetail';
  /** The validator identifier can be any string */
  identifier: Scalars['String']['output'];
  /** The user visible label of the identifier to show in UI (e.g. "Node ID") */
  identifierLabel: Scalars['String']['output'];
};

/** Notice is a notification with paragraphs and color. */
export type Notice = {
  __typename: 'Notice';
  /** Paragraph representing the notice content */
  content: Paragraph;
  /** Type of the notice that has a matching style */
  type: NoticeType;
};

/** NoticeType is an Enum representing the severity of a Notice. */
export enum NoticeType {
  /** Error notice */
  ERROR = 'ERROR',
  /** Information notice */
  INFO = 'INFO',
  /** Warning notice */
  WARNING = 'WARNING'
}

/** NumericFilterInput contains information about a numeric value filter */
export type NumericFilterInput = {
  /** Matches the equal value */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Matches value greater than or equal */
  gte?: InputMaybe<Scalars['String']['input']>;
  /** Matches value less than */
  lt?: InputMaybe<Scalars['String']['input']>;
};

export type NxtCounterpartyAccount = {
  __typename: 'NxtCounterpartyAccount';
  accountIdUuid: Maybe<Scalars['String']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  commissionBps: Maybe<Scalars['String']['output']>;
  counterparty: Maybe<NxtTradingCounterparty>;
  counterpartyId: Maybe<Scalars['ID']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  creditLimits: Maybe<Scalars['String']['output']>;
  custodySource: Maybe<Scalars['String']['output']>;
  entity: Maybe<NxtTradingEntity>;
  entityId: Maybe<Scalars['ID']['output']>;
  houseAccountType: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSubaccount: Scalars['Boolean']['output'];
  isTradingAccount: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  whitelabelEnabled: Scalars['Boolean']['output'];
};

export type NxtCounterpartyAccountPage = {
  __typename: 'NxtCounterpartyAccountPage';
  items: Array<NxtCounterpartyAccount>;
  pageInfo: NxtPageInfo;
};

export type NxtPageInfo = {
  __typename: 'NxtPageInfo';
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalSize: Scalars['Int']['output'];
};

export type NxtTfcAccount = Node & {
  __typename: 'NxtTfcAccount';
  accountId: Scalars['ID']['output'];
  custodyAccountId: Maybe<Scalars['ID']['output']>;
  custodyOrgId: Maybe<Scalars['ID']['output']>;
  iaasAccountId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  kind: NxtTfcAccountKind;
  name: Scalars['String']['output'];
  product: Maybe<NxtTfcPoolProduct>;
};

export enum NxtTfcAccountKind {
  END_CLIENT = 'END_CLIENT',
  FBO = 'FBO',
  INFRA = 'INFRA',
  OMNIBUS = 'OMNIBUS',
  PARTNER = 'PARTNER',
  PROGRAM = 'PROGRAM',
  RESERVE = 'RESERVE',
  SUB_ACCOUNT = 'SUB_ACCOUNT'
}

export type NxtTfcAmount = {
  __typename: 'NxtTfcAmount';
  asset: Scalars['String']['output'];
  decimals: Scalars['Int']['output'];
  units: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export type NxtTfcAssetCheck = {
  __typename: 'NxtTfcAssetCheck';
  asset: Scalars['String']['output'];
  custodyAggregate: NxtTfcAmount;
  difference: NxtTfcAmount;
  matches: Scalars['Boolean']['output'];
  sumOfSettled: NxtTfcAmount;
};

export type NxtTfcBlockedReason = {
  __typename: 'NxtTfcBlockedReason';
  detectedAt: Maybe<Scalars['DateTime']['output']>;
  mismatches: Array<NxtTfcAssetCheck>;
};

export type NxtTfcCloseCycleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cycleNo: Scalars['Int']['input'];
  ownerId: Scalars['ID']['input'];
};

export type NxtTfcCloseCyclePayload = {
  __typename: 'NxtTfcCloseCyclePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  cycle: Maybe<NxtTfcCycle>;
  errors: Array<NxtTfcOpenCycleError>;
};

export type NxtTfcCycle = Node & {
  __typename: 'NxtTfcCycle';
  attemptedAt: Scalars['DateTime']['output'];
  blockedReason: Maybe<NxtTfcBlockedReason>;
  closedAt: Maybe<Scalars['DateTime']['output']>;
  cycleKeys: Array<Scalars['String']['output']>;
  cycleNo: Scalars['Int']['output'];
  delegations: Array<NxtTfcDelegation>;
  id: Scalars['ID']['output'];
  maxAgeAt: Maybe<Scalars['DateTime']['output']>;
  openedAt: Maybe<Scalars['DateTime']['output']>;
  owner: NxtTfcAccount;
  partner: NxtTfcAccount;
  positions: NxtTfcPositionConnection;
  seedRun: Maybe<NxtTfcSeedRun>;
  snapshot: NxtTfcSnapshot;
  status: NxtTfcCycleStatus;
};


export type NxtTfcCyclepositionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NxtTfcPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NxtTfcCycleConnection = {
  __typename: 'NxtTfcCycleConnection';
  edges: Array<NxtTfcCycleEdge>;
  pageInfo: PageInfo;
};

export type NxtTfcCycleEdge = {
  __typename: 'NxtTfcCycleEdge';
  cursor: Scalars['String']['output'];
  node: NxtTfcCycle;
};

export type NxtTfcCycleFilter = {
  latestOnly?: InputMaybe<Scalars['Boolean']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  partnerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<NxtTfcCycleStatus>>;
};

export type NxtTfcCycleOrder = {
  direction: OrderDirection;
  field: NxtTfcCycleOrderField;
};

export enum NxtTfcCycleOrderField {
  OPENED_AT = 'OPENED_AT',
  PARTNER_NAME = 'PARTNER_NAME'
}

export enum NxtTfcCycleStatus {
  BLOCKED = 'BLOCKED',
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
  OPENING = 'OPENING',
  SETTLING = 'SETTLING'
}

export type NxtTfcCycleSummary = {
  __typename: 'NxtTfcCycleSummary';
  blocked: Scalars['Int']['output'];
  closedAwaitingNext: Scalars['Int']['output'];
  oldestOpenAt: Maybe<Scalars['DateTime']['output']>;
  open: Scalars['Int']['output'];
  opening: Scalars['Int']['output'];
};

export type NxtTfcDelegation = {
  __typename: 'NxtTfcDelegation';
  asset: Scalars['String']['output'];
  congruent: Scalars['Boolean']['output'];
  consumed: NxtTfcAmount;
  custodyAggregate: NxtTfcAmount;
  cycleKey: Scalars['String']['output'];
  delegated: NxtTfcAmount;
  remaining: NxtTfcAmount;
};

export type NxtTfcOpenCycleError = {
  __typename: 'NxtTfcOpenCycleError';
  code: NxtTfcOpenCycleErrorCode;
  message: Scalars['String']['output'];
};

/** Why a cycle could not be opened or closed. Mirrors the codes nxt-buying-power's harness endpoints return. */
export enum NxtTfcOpenCycleErrorCode {
  /** The snapshot's per-client balances don't add up to the custody aggregate. The cycle is now BLOCKED. */
  CONGRUENCE_MISMATCH = 'CONGRUENCE_MISMATCH',
  /** The owner is not an ACTIVE account that may hold custody (a Segregated pool, an FBO, or a direct partner's own account) with custody on in its effective policy. Nothing was written. */
  CUSTODY_NOT_ALLOWED = 'CUSTODY_NOT_ALLOWED',
  /** Cycle k is already OPEN with a different snapshot. There is no reseeding mid-cycle. */
  CYCLE_ALREADY_SEEDED = 'CYCLE_ALREADY_SEEDED',
  /** Close only: the cycle is not OPEN. */
  CYCLE_NOT_OPEN = 'CYCLE_NOT_OPEN',
  /** Cycle k − 1 is not CLOSED yet. */
  PREVIOUS_CYCLE_NOT_CLOSED = 'PREVIOUS_CYCLE_NOT_CLOSED',
  /** The snapshot id is unknown to the balance adapter. */
  SNAPSHOT_NOT_FOUND = 'SNAPSHOT_NOT_FOUND',
  /** The harness mutations run only in development and staging. */
  STAGING_ONLY = 'STAGING_ONLY',
  /** The owner account is not in nxt-buying-power's tree. */
  UNKNOWN_OWNER = 'UNKNOWN_OWNER'
}

export type NxtTfcOpenCycleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cycleNo: Scalars['Int']['input'];
  /** The owner: the account that holds custody. A Segregated pool or FBO (for example POOL-01), not its partner; or a direct partner's own account. */
  ownerId: Scalars['ID']['input'];
  snapshotId: Scalars['ID']['input'];
};

export type NxtTfcOpenCyclePayload = {
  __typename: 'NxtTfcOpenCyclePayload';
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The cycle after the call: OPEN on success, BLOCKED on CONGRUENCE_MISMATCH, the existing cycle on CYCLE_ALREADY_SEEDED, null otherwise. */
  cycle: Maybe<NxtTfcCycle>;
  /** Empty on success, including the idempotent case (same cycle, same snapshot). */
  errors: Array<NxtTfcOpenCycleError>;
};

export enum NxtTfcPoolProduct {
  OMNIBUS = 'OMNIBUS',
  SEGREGATED = 'SEGREGATED',
  VIRTUAL = 'VIRTUAL'
}

export type NxtTfcPosition = Node & {
  __typename: 'NxtTfcPosition';
  account: NxtTfcAccount;
  asset: Scalars['String']['output'];
  buyingPower: NxtTfcAmount;
  cycleKey: Scalars['String']['output'];
  encumbrance: NxtTfcAmount;
  id: Scalars['ID']['output'];
  openOut: NxtTfcAmount;
  pendingIn: NxtTfcAmount;
  pendingOut: NxtTfcAmount;
  settled: NxtTfcAmount;
  version: Maybe<Scalars['Int']['output']>;
};

export type NxtTfcPositionConnection = {
  __typename: 'NxtTfcPositionConnection';
  edges: Array<NxtTfcPositionEdge>;
  pageInfo: PageInfo;
};

export type NxtTfcPositionEdge = {
  __typename: 'NxtTfcPositionEdge';
  cursor: Scalars['String']['output'];
  node: NxtTfcPosition;
};

export type NxtTfcPositionFilter = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NxtTfcSeedRun = {
  __typename: 'NxtTfcSeedRun';
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  startedAt: Scalars['DateTime']['output'];
  steps: Array<NxtTfcSeedStep>;
};

export type NxtTfcSeedStep = {
  __typename: 'NxtTfcSeedStep';
  at: Maybe<Scalars['DateTime']['output']>;
  detail: Maybe<Scalars['String']['output']>;
  name: NxtTfcSeedStepName;
  state: NxtTfcSeedStepState;
};

export enum NxtTfcSeedStepName {
  CONGRUENCE_CHECKED = 'CONGRUENCE_CHECKED',
  CYCLE_OPENED = 'CYCLE_OPENED',
  POSITIONS_WRITTEN = 'POSITIONS_WRITTEN',
  ROLLED_BACK = 'ROLLED_BACK',
  SNAPSHOT_READ = 'SNAPSHOT_READ'
}

export enum NxtTfcSeedStepState {
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  SKIPPED = 'SKIPPED'
}

export type NxtTfcSnapshot = {
  __typename: 'NxtTfcSnapshot';
  asOf: Maybe<Scalars['DateTime']['output']>;
  snapshotId: Scalars['ID']['output'];
};

export type NxtTrade = {
  __typename: 'NxtTrade';
  amount: Maybe<Scalars['String']['output']>;
  baseCurrency: Maybe<Scalars['String']['output']>;
  ccy1Qty: Maybe<Scalars['String']['output']>;
  ccy2Qty: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayAmount: Maybe<Scalars['String']['output']>;
  displayCcy1Qty: Maybe<Scalars['String']['output']>;
  displayCcy2Qty: Maybe<Scalars['String']['output']>;
  displayFee: Maybe<Scalars['String']['output']>;
  displayOrderQty: Maybe<Scalars['String']['output']>;
  displayPrice: Maybe<Scalars['String']['output']>;
  execId: Scalars['String']['output'];
  execType: Maybe<Scalars['String']['output']>;
  fee: Maybe<Scalars['String']['output']>;
  feeCurrency: Maybe<Scalars['String']['output']>;
  feeRate: Maybe<Scalars['String']['output']>;
  fundingType: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastTrader: Maybe<Scalars['String']['output']>;
  market: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderQty: Scalars['String']['output'];
  price: Scalars['String']['output'];
  priceAllIn: Maybe<Scalars['String']['output']>;
  quoteCurrency: Maybe<Scalars['String']['output']>;
  settlementDate: Maybe<Scalars['String']['output']>;
  side: Scalars['String']['output'];
  subAccount: Maybe<Scalars['String']['output']>;
  symbol: Scalars['String']['output'];
  tradeType: Maybe<Scalars['String']['output']>;
  transactTime: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
};

export type NxtTradeFilter = {
  execId?: InputMaybe<Scalars['String']['input']>;
  markets?: InputMaybe<Array<Scalars['String']['input']>>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  symbols?: InputMaybe<Array<Scalars['String']['input']>>;
  transactTimeFrom?: InputMaybe<Scalars['String']['input']>;
  transactTimeTo?: InputMaybe<Scalars['String']['input']>;
};

export type NxtTradePage = {
  __typename: 'NxtTradePage';
  items: Array<NxtTrade>;
  pageInfo: NxtPageInfo;
};

export type NxtTradingCounterparty = {
  __typename: 'NxtTradingCounterparty';
  fundingType: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type NxtTradingEntity = {
  __typename: 'NxtTradingEntity';
  id: Scalars['ID']['output'];
};

/** Extra parameters for oasis undelegate */
export type OasisUndelegateExtraParams = {
  __typename: 'OasisUndelegateExtraParams';
  /** actionType is used to construct the canonical operation */
  actionType: Maybe<ExtraParamsActionType>;
  /** estimatedSharesAmount is the estimate value in ROSE that the numShares corresponds to based on the conversion rate at the time the operation was created */
  estimatedSharesAmount: Maybe<Scalars['String']['output']>;
  /** numShares actually being undelegated */
  numShares: Maybe<Scalars['String']['output']>;
  /** percentShares that were requested to undelegate */
  percentShares: Maybe<Scalars['String']['output']>;
};

/** OasisValidatorDetail is an implementation of ValidatorDetail for Oasis */
export type OasisValidatorDetail = {
  __typename: 'OasisValidatorDetail';
  /** Commission rate of the validator, e.g.: "5.5%" or null if not available */
  commissionRate: Maybe<Scalars['String']['output']>;
  /** Total amount delegated to the validator or null if not available */
  totalDelegated: Maybe<Amount>;
  /** Uptime of the validator, e.g.: "99.8%" or null if not available */
  uptime: Maybe<Scalars['String']['output']>;
};

/** OffChainOperation represents an OffChainOperation */
export type OffChainOperation = Operation & {
  __typename: 'OffChainOperation';
  /**
   * The following are resolved by operationresolvers/operation_offchain.go
   * account that this operation is associated with. Only applicable to vault operations (ex. Withdraw)
   */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /**
   * appStatus is the app-facing state of the operation, a simplified version of operationState
   * TODO: unused field
   */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /** binaryAttestationResult is the HSM result for completed BinaryAttestation operations. */
  binaryAttestationResult: Maybe<BinaryAttestationResult>;
  /**
   * The following are resolved by type EndorsableOperation:
   *
   * Returns the bio challenge required to pass in order to endorse this operation - TODO: unused field
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /**
   * endorsements is the list of endorsements for the operation
   * TODO: unused field
   */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to, which is the source organization (not necessarily the org using the initiatorKey)
   * @deprecated use operationInfo
   */
  organization: Maybe<Organization>;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** signedPayload is the signed blockchain payload to be used by the dApp */
  signedPayload: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** Mandatory user-facing risk analysis information about the smart contract being executed. */
  smartContractRisk: SmartContractRisk;
  /** Mandatory user-facing simulation information about the smart contract being executed. */
  smartContractSimulation: SmartContractSimulation;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
};


/** OffChainOperation represents an OffChainOperation */
export type OffChainOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** OffChainOperation represents an OffChainOperation */
export type OffChainOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** Types of offchain operation */
export enum OffChainOperationType {
  /** Ethereum signing for personal_sign and eth_sign */
  ETH_PERSONAL_SIGN = 'ETH_PERSONAL_SIGN',
  /** Ethereum signing for eth_signTypedData */
  ETH_SIGN_TYPED_DATA = 'ETH_SIGN_TYPED_DATA'
}

/**
 * OffCurveRisk describes whether a Solana address is off-curve.
 * An off-curve destination can be unrecoverable (no private key can exist for it), so the
 * client surfaces a warning and requires acknowledgment before proceeding.
 */
export type OffCurveRisk = {
  __typename: 'OffCurveRisk';
  /**
   * True when the address is off-curve. When the risk is present it is always off-curve
   * (on-curve addresses resolve the parent offCurveRisk field to null), so this is effectively
   * always true, but is modeled explicitly for a clear, forward-compatible client contract.
   */
  isOffCurve: Scalars['Boolean']['output'];
};

export type OffchainVestingSchedule = {
  __typename: 'OffchainVestingSchedule';
  /** Account for the vesting schedule */
  account: Account;
  /** Breakdown of vesting schedule by wallet */
  allocations: Array<VestingWallet>;
  /** Time when the last vesting occurs in this schedule */
  endTime: Scalars['Timestamp']['output'];
  /** Creation time of the vesting schedule */
  startTime: Scalars['Timestamp']['output'];
  /** Current status of the vesting schedule */
  status: OffchainVestingScheduleStatus;
  /** Total amount to be vested */
  totalAmount: Amount;
  /** Disallow staking on the unvested tokens */
  unstakeable: Scalars['Boolean']['output'];
  /** Amount vested so far */
  vestedAmount: Amount;
  /** Offchain vesting schedule identifier */
  vestingScheduleID: Scalars['String']['output'];
};

/** OffchainVestingScheduleStatus is the offchain vesting schedule status */
export enum OffchainVestingScheduleStatus {
  /** Currently vesting */
  ACTIVE = 'ACTIVE',
  /** Vesting canceled */
  CANCELED = 'CANCELED',
  /** Fully vested */
  COMPLETE = 'COMPLETE',
  /** Vesting schedule not yet created */
  DRAFT = 'DRAFT'
}

/** OnboardingStatus signals the step for onboarding of the StagedUser */
export enum OnboardingStatus {
  /** COMPLETE is the last onboarding step */
  COMPLETE = 'COMPLETE',
  /** COMPLETE_WITH_EXEMPTED_PIIS is the last step if PIIs were exempted by the team */
  COMPLETE_WITH_EXEMPTED_PIIS = 'COMPLETE_WITH_EXEMPTED_PIIS',
  /** PIIS is the second step of onboarding: waiting for PIIs */
  PIIS = 'PIIS',
  /** QRSCAN is the first step of onboarding: waiting for QR code scan */
  QRSCAN = 'QRSCAN'
}

/** OneOffOperation represents a one-off operation (for example: Edgeware Signaling) */
export type OneOffOperation = Operation & {
  __typename: 'OneOffOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount returns the non-fee balance this operation affected if any */
  amount: Maybe<Amount>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** asset id from with the operation was made */
  assetID: AssetID;
  /** Further information regarding this asset type associated with this operation */
  assetTypeInfo: AssetTypeInfo;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** canonicalOperationVersion is the version of the canonical operation that must be used to sign this operation */
  canonicalOperationVersion: Scalars['Int']['output'];
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** confirmations returns how many confirmations the transaction associated with this operation has received */
  confirmations: Maybe<Scalars['Int']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced for this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * extraParams are additional asset type specific parameters that were set for this transaction
   * When constructing the canonical operation for signing, the extra params go in the ExtraParams field
   * as a map from asset type id (usually, parent asset type id) to params object. The convention of extra
   * params is to omit all empty fields, and if no extra params are set for an asset type, to omit the asset
   * type from the map entirely. Note that for legacy reasons this convention
   * is the opposite of the normal CanonicalOperation convention, where no fields are ever omitted.
   */
  extraParams: Maybe<ExtraParams>;
  /** final transaction fee charged for the operation, detected on the blockchain */
  finalFee: Maybe<Amount>;
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** max transaction fee charged for the operation */
  maxFee: Maybe<Amount>;
  /** oneOffParams is a generic list of parameters used for this one-off operation */
  oneOffParams: Array<OneOffParam>;
  /** oneOffType is the type of one-off operation (eg. EDG_SIG for Edgeware Signaling) */
  oneOffType: OneOffType;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /** rawTransaction is the unsigned transaction effecting the intent of this operation */
  rawTransaction: Maybe<Scalars['String']['output']>;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** sendingBlockchainAddresses is a list of addresses from which a one off operation is sent */
  sendingBlockchainAddresses: Array<BlockchainAddress>;
  /** signedTransaction is the blockchain transaction to be broadcast to the network */
  signedTransaction: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /**
   * sources are the originating addresses for the operation
   * @deprecated use sendingBlockchainAddresses
   */
  sources: Array<Source>;
  /** transactionID is the blockchain transaction id once available */
  transactionID: Maybe<Scalars['String']['output']>;
  /** transactionSuccess indicates if the blockchain transaction succeeded */
  transactionSuccess: Maybe<Scalars['Boolean']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * usdValueFee is the USD value of the fee (finalFee if known, otherwise maxFee).
   * If both the finalFee and maxFee are not yet known, this field will be null
   */
  usdValueFee: Maybe<Scalars['String']['output']>;
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
};


/** OneOffOperation represents a one-off operation (for example: Edgeware Signaling) */
export type OneOffOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** OneOffOperation represents a one-off operation (for example: Edgeware Signaling) */
export type OneOffOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/**
 * OneOffParam is a way to generically display parameters for one-off operations
 * such as Ethereum contract parameters
 */
export type OneOffParam = {
  __typename: 'OneOffParam';
  /** The human-readable description to display for a one-off operation parameter */
  description: Scalars['String']['output'];
  /** The label (or key) for a one-off operation parameter */
  label: Scalars['String']['output'];
  /** The type of a one-off operation parameter */
  type: OneOffParamType;
  /** The value to display for a one-off operation parameter */
  value: Scalars['String']['output'];
};

/** OneOffParamType determines the type of the value for a one-off operation parameter */
export enum OneOffParamType {
  /** A string representation of an Amount in JSON */
  AMOUNT = 'AMOUNT',
  /** A string representation of an Amount as a decimal string */
  AMOUNT_DECIMAL = 'AMOUNT_DECIMAL',
  /** schema.AssetTypeAddress, marshaled to JSON */
  ASSET_TYPE_ADDRESS = 'ASSET_TYPE_ADDRESS',
  /** A normal string address */
  ASSET_TYPE_ADDRESS_STRING = 'ASSET_TYPE_ADDRESS_STRING',
  /** human readable boolean value */
  BOOLEAN = 'BOOLEAN',
  /** hex encoded binary */
  BYTES = 'BYTES',
  /** An Edgeware address used for signaling where airdropped edgeware assets should be sent */
  EDGEWARE_PUBLIC_KEY = 'EDGEWARE_PUBLIC_KEY',
  /** A string representation of a SignedAddress in JSON */
  SIGNED_ADDRESS = 'SIGNED_ADDRESS',
  /** uint256, represented as an ascii number */
  UINT256 = 'UINT256'
}

/** OneOffType is the type of one-off operation */
export enum OneOffType {
  /** Setup Governance for AAVE */
  AAVE_GOVERNANCE_SETUP = 'AAVE_GOVERNANCE_SETUP',
  /** Setup Governance for AAVE by type */
  AAVE_GOVERNANCE_SETUP_BY_TYPE = 'AAVE_GOVERNANCE_SETUP_BY_TYPE',
  /** Increases lockup period of staked assets to enable voting */
  APTOS_INCREASE_LOCKUP_PERIOD = 'APTOS_INCREASE_LOCKUP_PERIOD',
  /** Rotate consensus key for aptos account */
  APTOS_ROTATE_CONSENSUS_KEY = 'APTOS_ROTATE_CONSENSUS_KEY',
  /** Change beneficiary address of vesting contract for Aptos account */
  APTOS_SET_BENEFICIARY = 'APTOS_SET_BENEFICIARY',
  /**
   * Change operator address for Aptos account
   * @deprecated Aptos set operator construction has been removed. Retained for historical operations.
   */
  APTOS_SET_OPERATOR = 'APTOS_SET_OPERATOR',
  /**
   * Change voter address for Aptos account
   * @deprecated Aptos set voter construction has been removed. Retained for historical operations.
   */
  APTOS_SET_VOTER = 'APTOS_SET_VOTER',
  /** Update Operator Commission */
  APTOS_UPDATE_OPERATOR_COMMISSION = 'APTOS_UPDATE_OPERATOR_COMMISSION',
  /** Withdraw unlocked tokens from vesting contract */
  APTOS_VESTING_ADMIN_WITHDRAW = 'APTOS_VESTING_ADMIN_WITHDRAW',
  /** Set a management role on a vesting contract */
  APTOS_VESTING_SET_MANAGEMENT_ROLE = 'APTOS_VESTING_SET_MANAGEMENT_ROLE',
  /** Terminate a vesting contract */
  APTOS_VESTING_TERMINATE_CONTRACT = 'APTOS_VESTING_TERMINATE_CONTRACT',
  /** Withdraw already unlocked funds */
  APTOS_WITHDRAW_UNLOCKED_STAKE = 'APTOS_WITHDRAW_UNLOCKED_STAKE',
  /** Migrate an aragon v1 address to aragon v2 */
  ARAGON_MIGRATE_V1_TO_V2 = 'ARAGON_MIGRATE_V1_TO_V2',
  /** Request the legacy augur contract to approve the conversion */
  AUGUR_APPROVE_MIGRATION = 'AUGUR_APPROVE_MIGRATION',
  /** Migrate an already approved augur address to Augur v2 */
  AUGUR_MIGRATE_V1_TO_V2 = 'AUGUR_MIGRATE_V1_TO_V2',
  /**
   * Authorizes a key to be used for participation in Celo's lightweight identity protocol
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  AUTHORIZE_ATTESTATION_SIGNER = 'AUTHORIZE_ATTESTATION_SIGNER',
  /**
   * Authorizes a key to participate in BFT consensus, and register and manage a Validator or Validator Group
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  AUTHORIZE_VALIDATOR_SIGNER = 'AUTHORIZE_VALIDATOR_SIGNER',
  /**
   * Authorizes a key for validator key rotation
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  AUTHORIZE_VALIDATOR_SIGNER_WITH_KEYS = 'AUTHORIZE_VALIDATOR_SIGNER_WITH_KEYS',
  /**
   * Authorizes another key to sign on our behalf for the purposes of voting on the blockchain
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  AUTHORIZE_VOTE_SIGNER = 'AUTHORIZE_VOTE_SIGNER',
  /**
   * AUTO_COMPOUND is a one-off operation that automatically compounds the rewards of a staking asset
   * @deprecated Auto-compound construction has been removed. Retained for historical operations.
   */
  AUTO_COMPOUND = 'AUTO_COMPOUND',
  /**
   * Votes for Celo Validator groups may be activated once a new epoch begins
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CELO_ACTIVATE = 'CELO_ACTIVATE',
  /**
   * Moves celo token funds from the vesting contract to our address
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CELO_CLAIM_TOKEN = 'CELO_CLAIM_TOKEN',
  /**
   * Creates an account on the blockchain that's used for participation
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CELO_CREATE_ACCOUNT = 'CELO_CREATE_ACCOUNT',
  /**
   * Cancels an in-progress unlocking and re-locks some of the gold from it
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CELO_RELOCK = 'CELO_RELOCK',
  /**
   * Revokes pending votes that are not active
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CELO_REVOKE_PENDING = 'CELO_REVOKE_PENDING',
  /**
   * Change the expiration setting on a ReleaseGold contract
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CELO_SET_CAN_EXPIRE = 'CELO_SET_CAN_EXPIRE',
  /**
   * Set the Metadata URL of an Account or ReleaseGold contract
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CELO_SET_METADATA_URL = 'CELO_SET_METADATA_URL',
  /**
   * Set the name of an Account or ReleaseGold contract
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CELO_SET_NAME = 'CELO_SET_NAME',
  /**
   * Withdraws recently unlocked funds from the LockGold contract into our vesting contract
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CELO_WITHDRAW_LOCKED = 'CELO_WITHDRAW_LOCKED',
  /**
   * Moves funds from the vesting contract into our address
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  CLAIM_VESTED = 'CLAIM_VESTED',
  /** Setup Governance for COMP */
  COMP_GOVERNANCE_SETUP = 'COMP_GOVERNANCE_SETUP',
  /**
   * DEPRECATED: dYdX Bridge v3 to v4 tokens
   * @deprecated The dYdX bridge has been removed. Retained for historical operations.
   */
  DYDX_BRIDGE_CHAINS = 'DYDX_BRIDGE_CHAINS',
  /** Setup Governance for dYdX */
  DYDX_GOVERNANCE_SETUP = 'DYDX_GOVERNANCE_SETUP',
  /** Setup Governance for dYdX by type */
  DYDX_GOVERNANCE_SETUP_BY_TYPE = 'DYDX_GOVERNANCE_SETUP_BY_TYPE',
  /**
   * Edgeware signaling for the one time airdrop signaling on Ethereum, expired September 1st, 2019
   * @deprecated Edgeware signaling construction has been removed. Retained for historical operations.
   */
  EDGEWARE_SIGNALING = 'EDGEWARE_SIGNALING',
  /**
   * Filecoin add signer to multisig actor
   * @deprecated Filecoin add signer construction has been removed. Retained for historical operations.
   */
  FILECOIN_ADD_SIGNER = 'FILECOIN_ADD_SIGNER',
  /**
   * Filecoin miner change of ownership address
   * @deprecated Filecoin miner change owner address construction has been removed. Retained for historical operations.
   */
  FILECOIN_MINER_CHANGE_OWNER_ADDRESS = 'FILECOIN_MINER_CHANGE_OWNER_ADDRESS',
  /**
   * Confirm change to worker address for FIL miners
   * @deprecated No longer creatable; retained for historical operations.
   */
  FILECOIN_MINER_CONFIRM_WORKER_ADDRESS_CHANGE = 'FILECOIN_MINER_CONFIRM_WORKER_ADDRESS_CHANGE',
  /**
   * Change worker and control addresses for FIL miners
   * @deprecated No longer creatable; never had a working construction path.
   */
  FILECOIN_MINER_ROTATE_WORKER_AND_CONTROL_ADDRESSES = 'FILECOIN_MINER_ROTATE_WORKER_AND_CONTROL_ADDRESSES',
  /**
   * Terminates sectors for FIL miners
   * @deprecated Filecoin miner terminate sectors construction has been removed. Retained for historical operations.
   */
  FILECOIN_MINER_TERMINATE_SECTORS = 'FILECOIN_MINER_TERMINATE_SECTORS',
  /**
   * Filecoin withdrawal miner balance
   * @deprecated Filecoin miner withdraw balance construction has been removed. Retained for historical operations.
   */
  FILECOIN_MINER_WITHDRAW_BALANCE = 'FILECOIN_MINER_WITHDRAW_BALANCE',
  /**
   * Moves funds from the signing contract to our address
   * @deprecated Filecoin propose construction has been removed. Retained for historical operations.
   */
  FILECOIN_PROPOSE = 'FILECOIN_PROPOSE',
  /**
   * Filecoin remove signer from multisig actor
   * @deprecated Filecoin remove signer construction has been removed. Retained for historical operations.
   */
  FILECOIN_REMOVE_SIGNER = 'FILECOIN_REMOVE_SIGNER',
  /**
   * Filecoin swap signer within multisig actor
   * @deprecated Filecoin swap signer construction has been removed. Retained for historical operations.
   */
  FILECOIN_SWAP_SIGNER = 'FILECOIN_SWAP_SIGNER',
  /**
   * Flow claim unstaked
   * @deprecated Flow one-off construction has been removed. Retained for historical operations.
   */
  FLOW_CLAIM_UNSTAKED = 'FLOW_CLAIM_UNSTAKED',
  /** Flow claim vested */
  FLOW_CLAIM_VESTED = 'FLOW_CLAIM_VESTED',
  /** Create new Flow Account */
  FLOW_CREATE_ACCOUNT = 'FLOW_CREATE_ACCOUNT',
  /**
   * Flow delegate rewards
   * @deprecated Flow one-off construction has been removed. Retained for historical operations.
   */
  FLOW_DELEGATE_REWARDS = 'FLOW_DELEGATE_REWARDS',
  /**
   * Set up Flow Staking Collection
   * @deprecated Flow one-off construction has been removed. Retained for historical operations.
   */
  FLOW_SETUP_STAKING_COLLECTION = 'FLOW_SETUP_STAKING_COLLECTION',
  /**
   * Flow stake unstaked
   * @deprecated Flow one-off construction has been removed. Retained for historical operations.
   */
  FLOW_STAKE_UNSTAKED = 'FLOW_STAKE_UNSTAKED',
  /**
   * Flow claim rewards
   * @deprecated Flow one-off construction has been removed. Retained for historical operations.
   */
  FLOW_WITHDRAW_REWARDS = 'FLOW_WITHDRAW_REWARDS',
  /** Create new Hedera Account */
  HEDERA_CREATE_ACCOUNT = 'HEDERA_CREATE_ACCOUNT',
  /**
   * Moves KEEP Token funds from the vesting contract into our address
   * @deprecated KEEP token vesting-claim construction has been removed. Retained for historical operations.
   */
  KEEP_CLAIM_VESTED = 'KEEP_CLAIM_VESTED',
  /**
   * Locks funds for participation
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  LOCK = 'LOCK',
  /**
   * Unlock maker on behalf of the client
   * @deprecated Maker governance construction has been removed. Retained for historical operations.
   */
  MAKER_V1_1_UNLOCK = 'MAKER_V1_1_UNLOCK',
  /**
   * Approve the vote delegate contract to move MKR tokens
   * @deprecated Maker governance construction has been removed. Retained for historical operations.
   */
  MAKER_VOTE_DELEGATE_APPROVE = 'MAKER_VOTE_DELEGATE_APPROVE',
  /**
   * Approve the vote delegate contract to move IOU tokens
   * @deprecated Maker governance construction has been removed. Retained for historical operations.
   */
  MAKER_VOTE_DELEGATE_APPROVE_IOU = 'MAKER_VOTE_DELEGATE_APPROVE_IOU',
  /**
   * Free assets from Maker Vote Delegate
   * @deprecated Maker governance construction has been removed. Retained for historical operations.
   */
  MAKER_VOTE_DELEGATE_FREE = 'MAKER_VOTE_DELEGATE_FREE',
  /**
   * Lock assets to Maker Vote Delegate
   * @deprecated Maker governance construction has been removed. Retained for historical operations.
   */
  MAKER_VOTE_DELEGATE_LOCK = 'MAKER_VOTE_DELEGATE_LOCK',
  /**
   * Approve the vote proxy contract to transfer to lock
   * @deprecated Maker governance construction has been removed. Retained for historical operations.
   */
  MAKER_VOTE_PROXY_APPROVE = 'MAKER_VOTE_PROXY_APPROVE',
  /**
   * Initiate Link with an External Address through the Maker Vote Proxy
   * @deprecated Maker governance construction has been removed. Retained for historical operations.
   */
  MAKER_VOTE_PROXY_FACTORY_INITIATE_LINK = 'MAKER_VOTE_PROXY_FACTORY_INITIATE_LINK',
  /** Setup Governance for NOTE */
  NOTE_GOVERNANCE_SETUP = 'NOTE_GOVERNANCE_SETUP',
  /** Amend the commission schedule on the Oasis blockchain */
  OASIS_AMEND_COMMISSION_SCHEDULE = 'OASIS_AMEND_COMMISSION_SCHEDULE',
  /** Register an entity on the Oasis blockchain */
  OASIS_REGISTER_ENTITY = 'OASIS_REGISTER_ENTITY',
  /**
   * Create Solana nonce accounts
   * @deprecated Solana nonce account creation has been removed. Retained for historical operations.
   */
  SOLANA_CREATE_NONCE_ACCOUNT = 'SOLANA_CREATE_NONCE_ACCOUNT',
  /**
   * Withdraw from Solana stake account
   * @deprecated Superseded by the Solana COLLECT delegate operation. Retained for historical operations.
   */
  SOLANA_WITHDRAW_STAKE = 'SOLANA_WITHDRAW_STAKE',
  /** Deploy a new starknet account using UDC */
  STARKNET_UDC_DEPLOY_ACCOUNT = 'STARKNET_UDC_DEPLOY_ACCOUNT',
  /** Setup Governance for staked AAVE */
  STKAAVE_GOVERNANCE_SETUP = 'STKAAVE_GOVERNANCE_SETUP',
  /** Setup Governance for staked AAVE by type */
  STKAAVE_GOVERNANCE_SETUP_BY_TYPE = 'STKAAVE_GOVERNANCE_SETUP_BY_TYPE',
  /** Claim rewards of tendermint assets */
  TENDERMINT_CLAIM_REWARDS = 'TENDERMINT_CLAIM_REWARDS',
  /**
   * Tezos sweep moves funds from a KT1 address to a tz1 address for the same asset. This is part of the babylon migration of Oct 2019.
   * @deprecated Tezos sweep construction has been removed. Retained for historical operations.
   */
  TEZOS_SWEEP = 'TEZOS_SWEEP',
  /** Setup Governance for UNI */
  UNI_GOVERNANCE_SETUP = 'UNI_GOVERNANCE_SETUP',
  /**
   * Unlocks locked funds
   * @deprecated Celo governance has been removed. Retained for historical operations.
   */
  UNLOCK = 'UNLOCK',
  /**
   * DEPRECATED: WETH dYdX Bridge v3 to v4 tokens
   * @deprecated The dYdX bridge has been removed. Retained for historical operations.
   */
  WETHDYDX_BRIDGE_CHAINS = 'WETHDYDX_BRIDGE_CHAINS',
  /** Setup Governance for Wrapped Ethereum dYdX */
  WETHDYDX_GOVERNANCE_SETUP = 'WETHDYDX_GOVERNANCE_SETUP',
  /** Setup Governance for Wrapped Ethereum dYdX by type */
  WETHDYDX_GOVERNANCE_SETUP_BY_TYPE = 'WETHDYDX_GOVERNANCE_SETUP_BY_TYPE'
}

/**
 * Operation is the interface for operations. The full interface is owned by the
 * graphqlmonolith/custody; this subgraph declares the minimal key field so its
 * mutations can return operations that the router resolves elsewhere.
 */
export type Operation = {
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Maybe<Organization>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * slaLeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
};


/**
 * Operation is the interface for operations. The full interface is owned by the
 * graphqlmonolith/custody; this subgraph declares the minimal key field so its
 * mutations can return operations that the router resolves elsewhere.
 */
export type OperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** The Action an Operation represents */
export enum OperationAction {
  /** AUTHORIZE_SPENDER is a request to authorize an address to transfer an amount on this asset's behalf */
  AUTHORIZE_SPENDER = 'AUTHORIZE_SPENDER',
  /** BALANCE_ADJUSTMENT is a balance adjustment */
  BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT',
  /** CREATE_VAULT is a request to create a new vault */
  CREATE_VAULT = 'CREATE_VAULT',
  /** DELEGATE is a request to delegate vault assets to be staked, baked, inflation pool, etc. */
  DELEGATE = 'DELEGATE',
  /** DEPOSIT is a request for an address at which assets may be deposited */
  DEPOSIT = 'DEPOSIT',
  /** DEPOSIT_EVENT is an observed deposit */
  DEPOSIT_EVENT = 'DEPOSIT_EVENT',
  /** GENERIC is an action to arbitrary operations */
  GENERIC = 'GENERIC',
  /** GENERIC_ORGANIZATION_CHANGE is an action to arbitrary operations */
  GENERIC_ORGANIZATION_CHANGE = 'GENERIC_ORGANIZATION_CHANGE',
  /** LOCK is a request to lock funds to be used as part of governance, defi, etc. */
  LOCK = 'LOCK',
  /** OFFCHAIN_OPERATION is an action to perform offchain operation such as Snapshot Voting */
  OFFCHAIN_OPERATION = 'OFFCHAIN_OPERATION',
  /** ONE_OFF is a one-off operation action */
  ONE_OFF = 'ONE_OFF',
  /** ORGANIZATION_ADD is a request to create a new customer */
  ORGANIZATION_ADD = 'ORGANIZATION_ADD',
  /** ORGANIZATION_CHANGE represents a group of changes to the organization */
  ORGANIZATION_CHANGE = 'ORGANIZATION_CHANGE',
  /** ORGANIZATION_POLICY_CHANGE is a request to change an organization's policy */
  ORGANIZATION_POLICY_CHANGE = 'ORGANIZATION_POLICY_CHANGE',
  /** ORGANIZATION_POLICY_CHANGES is a request to change multiple organization's policies */
  ORGANIZATION_POLICY_CHANGES = 'ORGANIZATION_POLICY_CHANGES',
  /** ORGANIZATION_RECOVERY is a request to recover an org */
  ORGANIZATION_RECOVERY = 'ORGANIZATION_RECOVERY',
  /** ROLE_CHANGE is a request to change a role belonging to an organization */
  ROLE_CHANGE = 'ROLE_CHANGE',
  /** SIGN_TERMS_AND_CONDITIONS is an action to sign terms and conditions for offchain interactions - like for Dapps */
  SIGN_TERMS_AND_CONDITIONS = 'SIGN_TERMS_AND_CONDITIONS',
  /** TRANSFER is a request to transfer funds via API */
  TRANSFER = 'TRANSFER',
  /** TRUSTED_DESTINATION_ADD is a request to add a new trusted destination */
  TRUSTED_DESTINATION_ADD = 'TRUSTED_DESTINATION_ADD',
  /** TRUSTED_DESTINATION_REMOVE is a request to remove an existing trusted destination */
  TRUSTED_DESTINATION_REMOVE = 'TRUSTED_DESTINATION_REMOVE',
  /** TRUSTED_SMART_CONTRACT_ADD is a request to add a new trusted smart contract */
  TRUSTED_SMART_CONTRACT_ADD = 'TRUSTED_SMART_CONTRACT_ADD',
  /** TRUSTED_SMART_CONTRACT_REMOVE is a request to remove an existing trusted smart contract */
  TRUSTED_SMART_CONTRACT_REMOVE = 'TRUSTED_SMART_CONTRACT_REMOVE',
  /** UNLOCK is a request to unlock funds */
  UNLOCK = 'UNLOCK',
  /** USER_ADD is a request to add a user */
  USER_ADD = 'USER_ADD',
  /** USER_ADD_AND_POLICIES is a request to add an user and add it to policies */
  USER_ADD_AND_POLICIES = 'USER_ADD_AND_POLICIES',
  /** USER_REMOVE is a request to remove a user */
  USER_REMOVE = 'USER_REMOVE',
  /** USER_REMOVE_AND_POLICIES is a request to remove an user from the organization and its policies */
  USER_REMOVE_AND_POLICIES = 'USER_REMOVE_AND_POLICIES',
  /** USER_REPLACE is a request to replace a user within an org */
  USER_REPLACE = 'USER_REPLACE',
  /** VAULT_DISABLE is a request to disable a vault */
  VAULT_DISABLE = 'VAULT_DISABLE',
  /** VAULT_POLICY_CHANGE is a request to change a vault's policy */
  VAULT_POLICY_CHANGE = 'VAULT_POLICY_CHANGE',
  /** VAULT_POLICY_CHANGES is a request to change multiple vault's policies */
  VAULT_POLICY_CHANGES = 'VAULT_POLICY_CHANGES',
  /** VOTE is a request to vote */
  VOTE = 'VOTE',
  /** WITHDRAW is a request to withdraw assets */
  WITHDRAW = 'WITHDRAW'
}

/**
 * OperationCancelation is the data about When and Who requested cancelation of the operation
 * (that contains the OperationCancelation).
 */
export type OperationCancelation = {
  __typename: 'OperationCancelation';
  /** When was cancelation request received. */
  requestedAt: Scalars['String']['output'];
  /**
   * Which user requested cancelation of the operation.
   * @deprecated use requestingUserKey instead
   */
  requestedBy: User;
  /** Which user requested cancelation of the operation. */
  requestingUserKey: UserKey;
};

/** OperationComment is one comment for an operation */
export type OperationComment = {
  __typename: 'OperationComment';
  /** commentID is the ID of the comment, not exposed to the user but used for edit/delete/restore calls */
  commentID: Scalars['String']['output'];
  /** commentSubID is the revision of the comment, not exposed to the user but used for edit/delete/restore calls */
  commentSubID: Scalars['Int']['output'];
  /** createdAt is the timestamp at which the comment was initially created */
  createdAt: Scalars['String']['output'];
  /** createdBy is the user who created the comment (User defined in ./organization.graphqls) */
  createdBy: User;
  /** editedAt is the timestamp at which the comment was most recently modified */
  editedAt: Maybe<Scalars['String']['output']>;
  /** editedBy is the user who most recently edited the comment (User defined in ./organization.graphqls) */
  editedBy: Maybe<User>;
  /** message is the main body of the comment */
  message: Scalars['String']['output'];
};

/** OperationConnection implements the connections spec */
export type OperationConnection = {
  __typename: 'OperationConnection';
  /** edges implements the connections spec */
  edges: Array<OperationEdge>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
};

/** Possible decisions available in response to an operation */
export enum OperationDecision {
  /** Approve the operation */
  APPROVE = 'APPROVE',
  /** Initiate the operation, but do not approve it */
  INITIATE = 'INITIATE',
  /** Reject the operation */
  REJECT = 'REJECT'
}

/** OperationEdge implements the connections spec */
export type OperationEdge = {
  __typename: 'OperationEdge';
  /** cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** node implements the connections spec */
  node: Operation;
};

/**
 * OperationField is the union of all the fields shown to the user in the iOS app
 * This is expressed as a union because some fields are signed and some are not
 * if the field is a signed field, the app is expected to lookup the content from SignablePayload whereas UnsignedOperationField contains the content directly
 */
export type OperationField = SignedOperationField | UnsignedOperationField;

/** OperationImpediment contains info about what impedes an operation from transitioning to the next state. */
export type OperationImpediment = {
  __typename: 'OperationImpediment';
  /**
   * details contains more detailed info (than userMessage) about the impediment.
   * It could contain stack, hence not appropriate for clients to see.
   *
   * eg:
   *   --- at anchorage/source/go/service/blockchain/blockchainmodule/commonmodule/commonmodule.go:1 (CommonModule.Broadcast) ---
   *   --- at anchorage/source/go/service/blockchain/blockchainmodule/commonmodule/commonmodule.go:2 (CommonModule.Broadcast) ---
   *   Caused by: [ETHEREUM_MAINNET] Transaction broadcast rejected due to network conditions. Will retry but broadcast will take longer than usual and may require manual intervention.
   *
   * eg:
   *   --- at anchorage/source/go/service/blockchain/blockchainmodule/commonmodule/commonmodule.go:1 (CommonModule.Broadcast) ---
   *   Caused by: grpc error calling /commonwatcherproto.CommonWatcher/BroadcastV2
   *   --- at anchorage/source/go/lib/std/grpcutil/grpcutil.go:306 (ErrorConvertingClientInterceptor) ---
   *   Caused by: rpc error: code = Unknown desc =
   *   --- at anchorage/source/go/service/gethwatcher/service/service.go:2 (Service.BroadcastV2) ---
   *   Caused by: eth_sendRawTransaction [0x02f8]
   *   --- at anchorage/source/go/service/gethwatcher/service/rpcclient.go:3 (tracedRPCClient.CallContext) ---
   *   Caused by: insufficient funds for gas * price + value: have 50000000 want 50767172
   */
  details: Maybe<Scalars['String']['output']>;
  /**
   * impedimentType is the classification of impediments, such as NETWORK_CONDITIONS.
   * @deprecated use impedimentTypeEnum
   */
  impedimentType: Scalars['String']['output'];
  /** impedimentTypeEnum is the classification of impediments, such as NETWORK_CONDITIONS. */
  impedimentTypeEnum: ImpedimentType;
  /**
   * To show OperationImpediment data, UI should display a combination of
   * - title as header/title,
   * - userMessage as body.
   *
   * eg: "Broadcasting is taking longer than expected".
   */
  title: Scalars['String']['output'];
  /**
   * userMessage contains user-friendly message about the impediment.
   *
   * eg: "Refusing to broadcast transaction 0xa156 with gas fee cap 1522671266, below 3554414047 (current base fee 2808481390)"
   * eg: "Insufficient funds for gas * price + value: have 50000000 want 50767172"
   */
  userMessage: Scalars['String']['output'];
};

/** OperationSortFields are the options for sorting a list of operations */
export enum OperationSortFields {
  /** CREATED_AT is the time at which the operation was initiated */
  CREATED_AT = 'CREATED_AT',
  /** END_TIME is the time at which the operation was ended */
  END_TIME = 'END_TIME',
  /** STATE is the current state of the operation */
  STATE = 'STATE',
  /** UPDATED_AT is the time the operation row was last modified */
  UPDATED_AT = 'UPDATED_AT'
}

/**
 * OperationState is the state of the operation as it is processed by our system
 * These are not code-gen'd right now but they really should be
 */
export enum OperationState {
  /** ADDRESS_AVAILABLE is the state when an address has been generated by the HSM and we are waiting for a deposit */
  ADDRESS_AVAILABLE = 'ADDRESS_AVAILABLE',
  /** ADDRESS_REQUEST is the state when an address has been requested from the HSM, but it's not available yet */
  ADDRESS_REQUEST = 'ADDRESS_REQUEST',
  /**
   * BROADCASTABLE is the state when the transaction is ready for blockchain service to broadcast.
   * When a transaction is in this state and before it's moved to BROADCASTING state, if cancelation request
   * is received, the transaction can be successfully canceled.
   */
  BROADCASTABLE = 'BROADCASTABLE',
  /**
   * OperationStateBroadcasted is the state when the blockchain service *has* broadcasted the transaction,
   * but scanner hasn't detected the transaction on-chain yet.
   */
  BROADCASTED = 'BROADCASTED',
  /**
   * BROADCASTING is the state when the blockchain service is broadcasting the transaction.
   * When a transaction is in this state, user can still attempt to send a cancelation request - but
   * the request would be ignored unless the broadcasting encounters network congestion, in which case
   * the transaction would be moved to BROADCASTABLE state, allow cancelation to succeed.
   */
  BROADCASTING = 'BROADCASTING',
  /** CANCELED is the state when the operation has been canceled. */
  CANCELED = 'CANCELED',
  /** COMPLETE is the state when the action is complete */
  COMPLETE = 'COMPLETE',
  /**
   * DEPOSIT_EVENT_ATTRIBUTION_REQUIRED is the state a deposit event has if it is already confirmed on the blockchain
   * but requires more information about the sources of the deposit (only appliable to regular deposits for ADB)
   */
  DEPOSIT_EVENT_ATTRIBUTION_REQUIRED = 'DEPOSIT_EVENT_ATTRIBUTION_REQUIRED',
  /** DEPOSIT_EVENT_DETECTED is the state a deposit event is created in when we detect it on the blockchain */
  DEPOSIT_EVENT_DETECTED = 'DEPOSIT_EVENT_DETECTED',
  /** ERRORED is the state when the action has experienced a fatal error */
  ERRORED = 'ERRORED',
  /** EXPIRED is the state when the action has timed out */
  EXPIRED = 'EXPIRED',
  /** FAILURE_COMMITTED means that the transaction was a failure on the blockchain and maybe only the fee was consumed */
  FAILURE_COMMITTED = 'FAILURE_COMMITTED',
  /** GAS_PENDING is the state when the operation is waiting for a deposit from the gas station */
  GAS_PENDING = 'GAS_PENDING',
  /** INITIATOR_EXPIRED is the state when initiator has not timely approved the operation, causing it auto-expired. */
  INITIATOR_EXPIRED = 'INITIATOR_EXPIRED',
  /** INITIATOR_PREPARED is the state when we ask the initiator of the operation to accept it before others process it, but, unlike in INITIATOR_REQUIRED, this state allows any number of operations to be created at the same time and the first one to be endorsed wins. */
  INITIATOR_PREPARED = 'INITIATOR_PREPARED',
  /** INITIATOR_REJECTED is the state operations go into if the initiator rejected them. The app is not expected to show these because they might be operations that were never endorsed in the first place and don't matter. */
  INITIATOR_REJECTED = 'INITIATOR_REJECTED',
  /** INITIATOR_REQUIRED is the state when we ask the initiator of the operation to accept it before others process it */
  INITIATOR_REQUIRED = 'INITIATOR_REQUIRED',
  /** OFFCHAIN_OPERATION_SIGNING is the state when the HSM is in the process of signing the OffChainOperation */
  OFFCHAIN_OPERATION_SIGNING = 'OFFCHAIN_OPERATION_SIGNING',
  /** ORGANIZATION_CHANGE_REQUEST is the state a organization change operation is in as soon as a user requests it, before it's processed by us */
  ORGANIZATION_CHANGE_REQUEST = 'ORGANIZATION_CHANGE_REQUEST',
  /** ORGANIZATION_SIGNING is the state when the HSM is in the process of signing the organization */
  ORGANIZATION_SIGNING = 'ORGANIZATION_SIGNING',
  /** ORG_CREATION_SIGNING is the state when the HSM is in  the process of signing a new organization */
  ORG_CREATION_SIGNING = 'ORG_CREATION_SIGNING',
  /** ORG_RISK_RECON is the state when we are performing risk recon but are not done gathering info yet for new orgs */
  ORG_RISK_RECON = 'ORG_RISK_RECON',
  /** QR_CODE_SCANNING is the state when we are waiting for users to scan the organization recovery QR Codes. */
  QR_CODE_SCANNING = 'QR_CODE_SCANNING',
  /** QUEUED represents an operation that has been requested but is not active in any way yet because other operations are blocking it */
  QUEUED = 'QUEUED',
  /** RISK_PENDING is the state when all risk data is ready and the risk team has to review the operation */
  RISK_PENDING = 'RISK_PENDING',
  /** RISK_RECON is the state when we are performing risk recon but are not done gathering info yet */
  RISK_RECON = 'RISK_RECON',
  /** RISK_REJECTED is the state when the risk team has rejected the operation */
  RISK_REJECTED = 'RISK_REJECTED',
  /** SIGS_FAILED is the state when a user has denied or canceled an operation */
  SIGS_FAILED = 'SIGS_FAILED',
  /** SIGS_REQUIRED is the state when we ask users to confirm an operation */
  SIGS_REQUIRED = 'SIGS_REQUIRED',
  /** TRANSACTION_REQUEST is the state a transaction operation is in as soon as a user requests it, before it's processed by us */
  TRANSACTION_REQUEST = 'TRANSACTION_REQUEST',
  /** TRANSACTION_SIGNING is the state when the HSM is in  the process of signing the transaction */
  TRANSACTION_SIGNING = 'TRANSACTION_SIGNING'
}

/**
 * Subaccount types that createOperationalSubaccount may create. Deliberately narrower than
 * SubaccountType: a type is added here only once its extra setup, if any, is understood.
 */
export enum OperationalSubaccountType {
  COLLATERAL = 'COLLATERAL',
  UNASSIGNED_STRATEGY_FUNDS = 'UNASSIGNED_STRATEGY_FUNDS'
}

export type OpsException = {
  __typename: 'OpsException';
  createdAt: Scalars['Timestamp']['output'];
  dataJSON: Scalars['String']['output'];
  id: Scalars['String']['output'];
  proposalJSON: Maybe<Scalars['String']['output']>;
  status: OpsExceptionStatus;
  type: OpsExceptionType;
  updatedAt: Scalars['Timestamp']['output'];
  version: Scalars['Int']['output'];
};

export type OpsExceptionConnection = {
  __typename: 'OpsExceptionConnection';
  edges: Array<OpsExceptionEdge>;
  pageInfo: PageInfo;
};

export type OpsExceptionEdge = {
  __typename: 'OpsExceptionEdge';
  cursor: Scalars['String']['output'];
  node: OpsException;
};

export type OpsExceptionEvent = {
  __typename: 'OpsExceptionEvent';
  actor: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  dataJSON: Maybe<Scalars['String']['output']>;
  event: OpsExceptionEventType;
  exceptionID: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum OpsExceptionEventType {
  APPROVED = 'APPROVED',
  AUTO_RESOLVED = 'AUTO_RESOLVED',
  CREATED = 'CREATED',
  EXECUTION_FAILED = 'EXECUTION_FAILED',
  EXECUTION_STARTED = 'EXECUTION_STARTED',
  EXECUTION_SUCCEEDED = 'EXECUTION_SUCCEEDED',
  PROPOSED = 'PROPOSED',
  REJECTED = 'REJECTED',
  RETRY_FAILED = 'RETRY_FAILED',
  SIGNAL_SENT = 'SIGNAL_SENT',
  SUPERSEDED = 'SUPERSEDED'
}

export type OpsExceptionMutationResult = {
  __typename: 'OpsExceptionMutationResult';
  errorMessage: Maybe<Scalars['String']['output']>;
  exception: Maybe<OpsException>;
  status: OpsExceptionMutationStatus;
};

export enum OpsExceptionMutationStatus {
  STATUS_ERROR = 'STATUS_ERROR',
  SUCCESS = 'SUCCESS',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  VERSION_CONFLICT = 'VERSION_CONFLICT'
}

export enum OpsExceptionStatus {
  EXECUTING = 'EXECUTING',
  OPEN = 'OPEN',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  RESOLVED = 'RESOLVED',
  SUPERSEDED = 'SUPERSEDED'
}

export enum OpsExceptionType {
  MANUAL_DEPOSIT = 'MANUAL_DEPOSIT',
  STUCK_WORKFLOW = 'STUCK_WORKFLOW',
  UNASSIGNED_DEPOSIT_ATTRIBUTION = 'UNASSIGNED_DEPOSIT_ATTRIBUTION'
}

export enum OptionExerciseStyle {
  AMERICAN = 'AMERICAN',
  EUROPEAN = 'EUROPEAN'
}

export enum OptionType {
  CALL = 'CALL',
  EKI_CALL = 'EKI_CALL',
  EKI_PUT = 'EKI_PUT',
  EKO_CALL = 'EKO_CALL',
  EKO_PUT = 'EKO_PUT',
  PUT = 'PUT'
}

/** OrdRejReason represents */
export enum OrdRejReason {
  /** RejReasonBrokerOption represents */
  BROKER_OPTION = 'BROKER_OPTION',
  /** RejReasonDuplicateOrder represents */
  DUPLICATE_ORDER = 'DUPLICATE_ORDER',
  /** RejReasonExchangeClosed represents */
  EXCHANGE_CLOSED = 'EXCHANGE_CLOSED',
  /** RejReasonForceCancel represents */
  FORCE_CANCEL = 'FORCE_CANCEL',
  /** RejReasonImmediateOrderDidNotCross represents */
  IMMEDIATE_ORDER_DID_NOT_CROSS = 'IMMEDIATE_ORDER_DID_NOT_CROSS',
  /** RejReasonInternalError represents */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** Invalid represents */
  INVALID = 'INVALID',
  /** RejReasonInvalidStrategy represents */
  INVALID_STRATEGY = 'INVALID_STRATEGY',
  /** RejReasonOrderExceedsLimit represents */
  ORDER_EXCEEDS_LIMIT = 'ORDER_EXCEEDS_LIMIT',
  /** RejReasonPostOnlyOrderWouldCross represents */
  POST_ONLY_ORDER_WOULD_CROSS = 'POST_ONLY_ORDER_WOULD_CROSS',
  /** RejReasonQuoteExpired represents */
  QUOTE_EXPIRED = 'QUOTE_EXPIRED',
  /** RejReasonQuoteRequestTimeout represents */
  QUOTE_REQUEST_TIMEOUT = 'QUOTE_REQUEST_TIMEOUT',
  /** RejReasonRateLimit represents */
  RATE_LIMIT = 'RATE_LIMIT',
  /** RejReasonStaleRequest represents */
  STALE_REQUEST = 'STALE_REQUEST',
  /** RejReasonTooLateToEnter represents */
  TOO_LATE_TO_ENTER = 'TOO_LATE_TO_ENTER',
  /** RejReasonUnknownMarket represents */
  UNKNOWN_MARKET = 'UNKNOWN_MARKET',
  /** RejReasonUnknownOrder represents */
  UNKNOWN_ORDER = 'UNKNOWN_ORDER',
  /** RejReasonUnknownSymbol represents */
  UNKNOWN_SYMBOL = 'UNKNOWN_SYMBOL'
}

/** OrdStatus represents the status of an order */
export enum OrdStatus {
  CANCELED = 'CANCELED',
  DONE_FOR_DAY = 'DONE_FOR_DAY',
  FILLED = 'FILLED',
  INVALID = 'INVALID',
  NEW = 'NEW',
  PARTIALLY_FILLED = 'PARTIALLY_FILLED',
  PENDING_CANCEL = 'PENDING_CANCEL',
  PENDING_NEW = 'PENDING_NEW',
  PENDING_REPLACE = 'PENDING_REPLACE',
  REJECTED = 'REJECTED'
}

/** OrdType represents the type of an order */
export enum OrdType {
  /** Invalid represents */
  INVALID = 'INVALID',
  /** OrdTypeLimit represents */
  LIMIT = 'LIMIT',
  /** OrdTypeLimitAllIn represents */
  LIMIT_ALL_IN = 'LIMIT_ALL_IN',
  /** OrdTypeMarket represents */
  MARKET = 'MARKET',
  /** OrdTypeOTHER represents */
  OTHER = 'OTHER',
  /** OrdTypePEGGED represents */
  PEGGED = 'PEGGED',
  /** OrdTypePOV represents */
  POV = 'POV',
  /** OrdTypeRFQ represents */
  RFQ = 'RFQ',
  /** OrdTypeStopLimit represents */
  STOP_LIMIT = 'STOP_LIMIT',
  /** OrdTypeStopLoss represents */
  STOP_LOSS = 'STOP_LOSS',
  /** OrdTypeTakeProfitLimit represents */
  TAKE_PROFIT_LIMIT = 'TAKE_PROFIT_LIMIT',
  /** OrdTypeTWAP represents */
  TWAP = 'TWAP',
  /** OrdTypeVWAP represents */
  VWAP = 'VWAP'
}

/** Input type for order allocation across subaccounts */
export type OrderAllocationInput = {
  /** Quantity allocated to this subaccount */
  quantity: Scalars['String']['input'];
  /** Subaccount ID for allocation */
  subaccountID: Scalars['String']['input'];
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  ASC = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  DESC = 'DESC'
}

/** Order execution report */
export type OrderExecutionReport = {
  __typename: 'OrderExecutionReport';
  /** aggressorSide represents */
  aggressorSide: Maybe<TradeSide>;
  /** amountCurrency represents */
  amountCurrency: Scalars['String']['output'];
  /** avgPx represents */
  avgPx: Scalars['String']['output'];
  /** avgPxAllIn represents */
  avgPxAllIn: Maybe<Scalars['String']['output']>;
  /** cancelSessionID represents */
  cancelSessionID: Maybe<Scalars['String']['output']>;
  /** clOrdID represents */
  clOrdID: Scalars['String']['output'];
  /** createdAt represents */
  createdAt: Scalars['Timestamp']['output'];
  /** cumAmt represents */
  cumAmt: Scalars['String']['output'];
  /** cumProviderFee represents */
  cumProviderFee: Maybe<Scalars['String']['output']>;
  /** cumQty represents */
  cumQty: Scalars['String']['output'];
  /** currency represents */
  currency: Scalars['String']['output'];
  /** cxlRejReason represents */
  cxlRejReason: Maybe<CxlRejReason>;
  /** execID represents */
  execID: Scalars['String']['output'];
  /** execType represents */
  execType: ExecType;
  /** feeCurrency represents */
  feeCurrency: Maybe<Scalars['String']['output']>;
  /** flowType represents */
  flowType: FlowType;
  /** groupID represents */
  groupID: Maybe<Scalars['String']['output']>;
  /** id represents */
  id: Scalars['String']['output'];
  /** lastAmt represents */
  lastAmt: Maybe<Scalars['String']['output']>;
  /** lastFee represents */
  lastFee: Maybe<Scalars['String']['output']>;
  /** lastFeeCurrency represents */
  lastFeeCurrency: Maybe<Scalars['String']['output']>;
  /** lastMarket represents */
  lastMarket: Maybe<Scalars['String']['output']>;
  /** lastProviderFee represents */
  lastProviderFee: Maybe<Scalars['String']['output']>;
  /** lastPx represents */
  lastPx: Maybe<Scalars['String']['output']>;
  /** lastQty represents */
  lastQty: Maybe<Scalars['String']['output']>;
  /** leavesQty represents */
  leavesQty: Scalars['String']['output'];
  /** OrdRejReason represents */
  ordRejReason: Maybe<OrdRejReason>;
  /** ordStatus represents */
  ordStatus: OrdStatus;
  /** ordType represents */
  ordType: OrdType;
  /** orderID represents */
  orderID: Scalars['String']['output'];
  /** orderQty represents */
  orderQty: Scalars['String']['output'];
  /** orderSessionID represents */
  orderSessionID: Maybe<Scalars['String']['output']>;
  /** origClOrdID represents */
  origClOrdID: Maybe<Scalars['String']['output']>;
  /** parentOrderID represents */
  parentOrderID: Scalars['String']['output'];
  /** parentRFQID represents */
  parentRFQID: Scalars['String']['output'];
  /** price represents */
  price: Maybe<Scalars['String']['output']>;
  /** providerFeeCurrency represents */
  providerFeeCurrency: Maybe<Scalars['String']['output']>;
  /** requestUser represents */
  requestUser: Scalars['String']['output'];
  /** revision represents */
  revision: Scalars['Int']['output'];
  /** side represents */
  side: TradeSide;
  /** subAccount represents */
  subAccount: Maybe<Scalars['String']['output']>;
  /** symbol represents */
  symbol: Scalars['String']['output'];
  /** textMessage represents */
  textMessage: Maybe<Scalars['String']['output']>;
  /** timeInForce represents */
  timeInForce: TimeInForce;
  /** transactTime represents */
  transactTime: Scalars['Timestamp']['output'];
};

/** Order execution report connection for pagination */
export type OrderExecutionReportConnection = {
  __typename: 'OrderExecutionReportConnection';
  /** List of edges containing order execution report and cursor information */
  edges: Array<OrderExecutionReportEdge>;
  /** Page details for the associated list of  order execution report edges */
  pageInfo: PageInfo;
};

/** Order execution report edge for pagination */
export type OrderExecutionReportEdge = {
  __typename: 'OrderExecutionReportEdge';
  /** Cursor for the associated order execution report */
  cursor: Scalars['String']['output'];
  /** Order execution report */
  node: OrderExecutionReport;
};

/** Represents an order execution notification. */
export type OrderNotification = {
  __typename: 'OrderNotification';
  /** The name of the file. */
  filename: Scalars['String']['output'];
  /** The ID of order notification */
  id: Scalars['String']['output'];
  /** The order data (Base64-encoded). */
  orderData: Scalars['String']['output'];
  /** The order type */
  orderType: Scalars['String']['output'];
};

/** OrderState represents the state of an order at a specific point in time */
export type OrderState = {
  __typename: 'OrderState';
  /** Order status */
  orderStatus: OrdStatus;
  /** Transaction time */
  transactTime: Scalars['Timestamp']['output'];
};

/** An organization's ACH Debit In settings, set by Anchorage staff. */
export type OrgACHDebitInSettings = {
  __typename: 'OrgACHDebitInSettings';
  /** The NACHA batch header Company Name the end user sees on their bank statement. */
  companyName: Maybe<Scalars['String']['output']>;
};

export type OrgACHDebitInSettingsInput = {
  /** 1 to 16 printable ASCII characters, with no leading or trailing space. */
  companyName: Scalars['String']['input'];
};

/** A single organization's holding of an asset, with its share of total AUC across all holders. */
export type OrgAssetHolding = {
  __typename: 'OrgAssetHolding';
  /** The organization's balance of the asset. */
  balance: Amount;
  /** shareOfAUC as a two-decimal percentage string (e.g. "12.34%"), so frontends show it directly. */
  formattedShareOfAUC: Scalars['String']['output'];
  /** The organization holding the asset, resolved as a federated reference by organizationKeyID. */
  organization: Organization;
  /**
   * 1-based absolute rank in the balance-descending order across ALL holders (rank 1 =
   * largest), stable across pages.
   */
  rank: Scalars['Int']['output'];
  /** This org's balance as a fraction of the total across ALL holders. 0 if the total is zero. */
  shareOfAUC: Scalars['Float']['output'];
  /** USD value of the balance. Null if a price is unavailable for the asset. */
  usdValue: Maybe<Amount>;
};

/** A page of OrgAssetHolding nodes ordered by balance descending (connections spec). */
export type OrgAssetHoldingConnection = {
  __typename: 'OrgAssetHoldingConnection';
  /** The OrgAssetHoldingEdge objects on this page. */
  edges: Array<OrgAssetHoldingEdge>;
  /** Cursors and has-next/has-previous flags for this page. */
  pageInfo: PageInfo;
  /** Grand-total native balance summed across ALL holders. */
  totalBalance: Amount;
  /** Total number of distinct organizations holding the asset across all pages. */
  totalCount: Scalars['Int']['output'];
  /** Grand-total USD value of totalBalance across ALL holders. Null if a price is unavailable. */
  totalUsdValue: Maybe<Amount>;
};

/** An OrgAssetHolding node paired with its opaque pagination cursor (connections spec). */
export type OrgAssetHoldingEdge = {
  __typename: 'OrgAssetHoldingEdge';
  /** Opaque base64 cursor for this node's absolute position in the balance-descending set. */
  cursor: Scalars['String']['output'];
  /** The organization's holding. */
  node: OrgAssetHolding;
};

/**
 * A OrgGasConfig is a container of GasMultipliers data.
 *
 * This type has to match schema.OrgConfig.
 * (Billing already defines "type FeeConfig".)
 */
export type OrgGasConfig = {
  __typename: 'OrgGasConfig';
  /** The contained GasMultipliers. */
  gasMultipliers: Maybe<GasMultipliers>;
};

/**
 * OrgGasConfigInput allows for customization of how transaction fees can be calculated.
 *
 * For detailed explanation, see doc for: type GasMultipliers.
 */
export type OrgGasConfigInput = {
  /**
   * This enum value corresponds to a numeric value that is used as multiplier
   * for ERC20 transactions when calculating gas fee.
   */
  baseFeePerGasMultiplier?: InputMaybe<BaseFeePerGasMultiplierLevel>;
  /**
   * A numeric/float value used as multiplier for ERC20 Smart Contract transactions
   * when calculating gas fee.
   */
  gasLimitMultiplierForSmartContract?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Holds information about the action of an organization that cannot be safistied due
 * to the respective list of users.
 *
 * This is tightly coupled with users' device health.
 */
export type OrgPolicyQuorumSummary = {
  __typename: 'OrgPolicyQuorumSummary';
  /** Action under analysis. */
  action: PolicyActionType;
  /** The human readable display name of the policy. */
  displayName: Scalars['String']['output'];
  /** Status of this quorum given current user devices' health */
  status: Maybe<PolicyStatus>;
  /** Users that are used to compute the quorum. */
  users: Array<User>;
};


/**
 * Holds information about the action of an organization that cannot be safistied due
 * to the respective list of users.
 *
 * This is tightly coupled with users' device health.
 */
export type OrgPolicyQuorumSummaryusersArgs = {
  sortField?: InputMaybe<UserSortField>;
};

export type Organization = IAMResource & {
  __typename: 'Organization';
  /** The accounts associated with this organization. */
  accounts: Array<Account>;
  /** accountsV2 returns the accountsV2(top level accounts) for the organization */
  accountsV2: AccountV2Connection;
  /**
   * The admin policy for the organization. Does not include draft policies.
   * Only valid if the organization is migrated to grouped containers.
   */
  adminPolicyV2: PolicyV2;
  /** Returns a list of subaccounts for an AffiliateID under an Organization */
  affiliateSubaccounts: Array<Subaccount>;
  /** affiliatesV2 returns the affiliatesV2(top level affiliates) for the organization */
  affiliatesV2: AffiliateV2Connection;
  /** Returns sha256(organization key id + user salt) to hide Anchorage identifiers from blockchain risk analysis providers */
  analysisUserHandle: Scalars['String']['output'];
  /** Send the user to this URL to log in. This is primarily useful to the iOS app. */
  clientDashboardURL: Scalars['String']['output'];
  /** An ongoing org change that is blocking new org changes */
  conflictingOrgChange: Maybe<Operation>;
  /** Timestamp of when the organization was created with nanosecond precision */
  createdAt: Scalars['String']['output'];
  /** SLA is the sla for the organization expressed in nanoseconds */
  currentSLA: Scalars['String']['output'];
  /** Timestamp of when the organization was disabled with nanosecond precision */
  disabledAt: Maybe<Scalars['String']['output']>;
  documentDeliverySettings: DocumentDeliverySettingConnection;
  /**
   * enabledFeatures returns an array of enabled features for this organization
   * @deprecated Client-facing features are deprecated. Use a LaunchDarkly feature flag to roll a feature out to every organization, or an organization module for a feature that organizations opt into.
   */
  enabledFeatures: Array<Feature>;
  /** Enabled Modules for this organization */
  enabledModules: OrganizationModuleConnection;
  /** Returns enrollments in the organization, with optional filtering. */
  enrollments: EnrollmentConnection;
  /** The Anchorage entity types this organization belongs to. */
  entityTypes: Array<AnchorageEntityTypeOutput>;
  exportIAMRoleAssignments: Scalars['String']['output'];
  /** Export organization policies. */
  exportOrganizationPolicies: OrganizationPoliciesBlob;
  /**
   * List of active fiat trusted destinations for this organization, used as the
   * selection pool when creating or editing roles.
   */
  fiatTrustedDestinations: Array<FiatTrustedDestination>;
  /**
   * Gas station behavior for this organization. Combine with AssetTypeInfo.supportsGasStation
   * to decide per asset.
   */
  gasStationSettings: OrganizationGasStationSettings;
  /** Gets the generation of this version of the organization */
  generation: Scalars['String']['output'];
  /** List of trusted destinations associated with this organization, with pagination. */
  getTrustedDestinations: TrustedDestinationConnection;
  /** Get the list of users in all generations of the organization */
  historicalUsers: Array<User>;
  iam: IAM;
  iamRoles: IAMRoleConnection;
  /** id is the unique identifier of the organization, equal to organizationKeyID */
  id: Scalars['ID']['output'];
  ipAllowlistConfig: IPAllowlistConfig;
  ipAllowlistEntries: Array<IPAllowlistEntry>;
  /** Indicates whether the organization can trade only in crypto */
  isCryptoOnly: Scalars['Boolean']['output'];
  /** Whether the organization is enabled for third party wires */
  isEnabledForThirdPartyWires: Scalars['Boolean']['output'];
  /** Whether the organization is enrolled in the stablecoin rewards program */
  isEnrolledInStablecoinRewards: Scalars['Boolean']['output'];
  /** Whether this organization is an ETF Issuer */
  isUsingETF: Scalars['Boolean']['output'];
  /** Whether this organization is using the SMA system */
  isUsingSMA: Scalars['Boolean']['output'];
  /**
   * Indicates whether the organization is using shared policies.
   * When true, vaultPoliciesV2 and adminPolicyV2 fields are available.
   * When false, policiesV2DryRun can be used to preview what policies would look like after migration.
   */
  isUsingSharedPolicies: Scalars['Boolean']['output'];
  /** The org's lead admin user's key info. */
  leadAdminUserKey: UserKey;
  /** Get the list of lost devices reported for this organization */
  lostDevices: Array<LostDevice>;
  /** Name of the organization */
  name: Scalars['String']['output'];
  /** Number of users at risk of losing or lost access */
  nonHealthyUserCount: Scalars['Int']['output'];
  /** Returns an offchain vesting schedule */
  offchainVestingSchedule: OffchainVestingSchedule;
  /** List of offchain vesting schedules associated with this organization */
  offchainVestingSchedules: Array<OffchainVestingSchedule>;
  /**
   * Get the list of operations in this organization
   * first and after implement the connections spec
   */
  operations: OperationConnection;
  /** Operator generally depends on who's reviewing operations for this organization. Usually this is ANCHORAGE or SELF */
  operator: Scalars['String']['output'];
  /**
   * Whether an organization change can be made or not due to conflicting operations in progress
   * @deprecated Concurrent changes are dealt with gracefully now
   */
  orgChangePossible: Maybe<Scalars['Boolean']['output']>;
  /**
   * The full canonical organization object, as a json string, that is signed over to validate the organization.
   * Technically this field is not needed, you should be able to reconstruct this object with other data provided
   * in the graphql Organization. This field is provided for convenience. Validating that the signature field
   * is correct for this object is not sufficient, you must also deserialize the json and validate the fields
   * in this object match the graphql-returned fields.
   * DO NOT validate this object against the provided graphql publicKey field. The organization's public key
   * must be stored at time of enrollment, and only the stored value can be used to validate signatures.
   */
  orgObject: Scalars['String']['output'];
  /**
   * Provides a summary of an organization's quorum policy
   * @deprecated This looks abandoned a long time ago
   */
  orgPolicyDescription: Scalars['String']['output'];
  /** The id of the organization */
  organizationKeyID: Scalars['String']['output'];
  /** Return the OwnFunds related to the Organization that uses the Subaccount system */
  ownSubaccountFunds: Array<SubaccountAffiliateCustomerFields>;
  /**
   * Defines the Policy that must be satisfied in order to perform any given Action
   * @deprecated Legacy PolicyMaps. Use 'readPolicies'
   */
  policies: Array<Policy>;
  /**
   * Dry-run preview of all policies after shared policies migration.
   * Returns what policies (both vault and org) WOULD look like if migration were performed.
   * Only available for organizations that have NOT yet been migrated.
   */
  policiesV2DryRun: Array<PolicyV2>;
  /** Information about policy containers on the resource. */
  policyInfo: Maybe<PolicyInfo>;
  /** Policies that cannot be satisfied. May be empty if there are no issues. */
  policyQuorumSummary: Maybe<PolicyQuorumSummary>;
  /**
   * Portfolio returns an organization-level summary of current holdings
   * Set the optional filterAssetTypeIDs to restrict the holdings list (amounts) to just these AssetTypeIDs.
   * Set debug to true to enable more logging.
   */
  portfolio: Portfolio;
  /**
   * Default-rule action for V2 conditional-rule policies, filtered by resource
   * type. Returns the RuleAction implementation (identity + possibleConditions);
   * quorum sizing lives on possibleOutcomes. Gated on
   * shared-policies-conditional-rules-enabled.
   */
  possibleDefaultActionV2: PolicyAction;
  /**
   * Specific-rule actions for V2 conditional-rule policies, filtered by resource
   * type. Nodes are the RuleAction implementation. Gated on
   * shared-policies-conditional-rules-enabled.
   */
  possibleSpecificActionsV2: PolicyActionConnection;
  /**
   * The hash of the canonical json serialization of the previous version of the Organization.
   * If this is the first version, the previousHash will be the empty string.
   * Returned as hex-encoded byte-string
   */
  previousHash: Scalars['String']['output'];
  /** The public key of the organization. Returned as hex-encoded byte-string */
  publicKey: Scalars['String']['output'];
  /** Non-signable representation of the policies applicable to this organization */
  readPolicies: ReadPolicyConnection;
  /**
   * List of items each representing the permission details of a role.
   *
   * The roles are those associated with the organization, as used by the user interface.
   *
   * For each RolePermissionDetails, the changeType will be UNCHANGED.
   */
  rolePermissions: Array<RolePermissionDetails>;
  /** List of roles associated with this organization. This reflects the internal representation of the Role. */
  roles: Array<Role>;
  /** Settings returns this organization specific settings */
  settings: Maybe<Array<Setting>>;
  /**
   * The signature from the HSM over this organization's data
   * Returned as hex-encoded byte-string
   */
  signature: Signature;
  snParticipants: Array<SNParticipant>;
  /** Returns a subaccount with SubaccountID and OrganizationID */
  subaccount: Subaccount;
  subaccountOrg: Maybe<SubaccountOrg>;
  /** Return the Affiliates information related to the Organization that uses the Subaccount system */
  subaccountProgramCustomers: Array<SubaccountAffiliateCustomerFields>;
  /** Whether the Anchorage gas station is supported on this organization to pay gas fees */
  supportsGasStation: Scalars['Boolean']['output'];
  /** Whether organization has access to self enroll in stablecoin rewards */
  supportsStablecoinRewardsSelfServe: Scalars['Boolean']['output'];
  /** The Trade Commission Rate in BPS */
  tradeCommissionRate: Maybe<Scalars['Int']['output']>;
  /** The number of trades of the organization */
  tradeCount: Scalars['Int']['output'];
  /** The trade settings of the organization */
  tradeSettings: TradeSettings;
  /** Get the list of trader users in this organization */
  traders: Array<User>;
  /** Whether the compliance team has approved this organization for trading */
  tradingApprovedByComplianceTeam: Scalars['Boolean']['output'];
  /** Whether the trading team has approved this organization for trading */
  tradingApprovedByTradingTeam: Scalars['Boolean']['output'];
  /** Whether trading is enabled for this organization */
  tradingEnabled: Scalars['Boolean']['output'];
  /** The trading volume of the organization (USD) */
  tradingVolume: Maybe<Amount>;
  /** Specific trusted destination by SubID */
  trustedDestination: Maybe<TrustedDestination>;
  /**
   * List of trusted destinations associated with this organization (without pagination)
   * When destinationAssetTypeID is set, the returned trusted destinations should be applicable to this assetTypeID.
   * The result would include network level trusted destinations where the networkID matches with this assetTypeID
   * and asset level trusted destinations where the assetTypeID matches with this assetTypeID.
   */
  trustedDestinations: Array<TrustedDestination>;
  /** Get a trusted smart contract by SubID. */
  trustedSmartContract: Maybe<TrustedSmartContract>;
  /**
   * List of trusted smart contracts associated with this organization, with zero or more optional filters, with pagination.
   * If multiple filters are provided, they are AND'ed: only entities matching *all* filters will be returned.
   */
  trustedSmartContracts: TrustedSmartContractConnection;
  /** Returns sha256(organization key id) to help clean up previous bug when analysisUserHandle had been generated with an empty salt */
  unsaltedAnalysisUserHandle: Scalars['String']['output'];
  /** Number of users in the organization */
  userCount: Scalars['Int']['output'];
  /** Get the list of user key IDs in this organization */
  userKeyIDs: Array<Scalars['PublicKeyID']['output']>;
  /** Get the list of user keys in this organization */
  userKeys: KeyConnection;
  /**
   * Get the list of users in this organization
   * @deprecated Use usersV2 instead
   */
  users: Array<User>;
  /** Get the list of users in this organization */
  usersV2: UserV2Connection;
  /** vault with particular vaultSubID associated with this organization */
  vault: Vault;
  /**
   * Policies associated with vaults. Does not include draft policies.
   * Only valid if the organization is migrated to grouped containers.
   */
  vaultPoliciesV2: PolicyV2Connection;
  /** List of vaults associated with this organization */
  vaults: Array<Vault>;
  /** List of vaults associated with this organization, with pagination. */
  vaultsWithPagination: VaultConnection;
  /** walletKeyBackupStrategy can be only ADMIN_KEYS_QUOURM for now and this strategy has no other configs so far */
  walletKeyBackupStrategy: Maybe<WalletKeyBackupStrategy>;
  /** A list of all wallet recovery key share info in the org. */
  walletRecoveryKeySharesInfo: Array<WalletRecoveryKeyShareInfo>;
};


export type OrganizationaccountsV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountV2WhereInput>;
};


export type OrganizationaffiliateSubaccountsArgs = {
  filterAffiliateID: Scalars['String']['input'];
};


export type OrganizationaffiliatesV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AffiliateV2WhereInput>;
};


export type OrganizationdocumentDeliverySettingsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filter: DocumentDeliverySettingFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentDeliverySettingOrder>;
};


export type OrganizationenabledModulesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationModuleWhereInput>;
};


export type OrganizationenrollmentsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnrollmentOrderBy>;
  where?: InputMaybe<EnrollmentWhereInput>;
};


export type OrganizationgetTrustedDestinationsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterByAssetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  filterByDestinationAddress?: InputMaybe<Scalars['String']['input']>;
  filterByName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationiamRolesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IAMRoleOrder>;
  where?: InputMaybe<IAMRoleWhereInput>;
};


export type OrganizationipAllowlistEntriesArgs = {
  filter?: InputMaybe<IPAllowlistEntriesFilter>;
};


export type OrganizationoffchainVestingScheduleArgs = {
  scheduleID: Scalars['String']['input'];
};


export type OrganizationoperationsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterActions?: InputMaybe<Array<OperationAction>>;
  filterAssetSubID?: InputMaybe<Scalars['String']['input']>;
  filterAssetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterByTags?: InputMaybe<Array<TagFilter>>;
  filterCreatedSince?: InputMaybe<Scalars['String']['input']>;
  filterCreatedUntil?: InputMaybe<Scalars['String']['input']>;
  filterDelegateTypes?: InputMaybe<Array<DelegateType>>;
  filterDepositRewardTypes?: InputMaybe<Array<DepositRewardType>>;
  filterExcludeSpamDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  filterFromGasStation?: InputMaybe<Scalars['Boolean']['input']>;
  filterOperationIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterProgramCustomerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterPublicKeyID?: InputMaybe<Scalars['String']['input']>;
  filterRequiresDecision?: InputMaybe<Scalars['Boolean']['input']>;
  filterStates?: InputMaybe<Array<OperationState>>;
  filterVaultSubID?: InputMaybe<Scalars['String']['input']>;
  filterVaultSubIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterVirtualAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterWalletIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeChange?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<OperationSortFields>;
};


export type OrganizationportfolioArgs = {
  debug?: Scalars['Boolean']['input'];
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  forceRunBlockedQuery?: Scalars['Boolean']['input'];
};


export type OrganizationpossibleDefaultActionV2Args = {
  where: PolicyActionWhereInput;
};


export type OrganizationpossibleSpecificActionsV2Args = {
  where: PolicyActionWhereInput;
};


export type OrganizationreadPoliciesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationsubaccountArgs = {
  filterSubaccountID: Scalars['String']['input'];
};


export type OrganizationtradeCountArgs = {
  since?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationtradingVolumeArgs = {
  since?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationtrustedDestinationArgs = {
  destinationSubID: Scalars['String']['input'];
};


export type OrganizationtrustedDestinationsArgs = {
  destinationAssetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
};


export type OrganizationtrustedSmartContractArgs = {
  smartContractSubID: Scalars['String']['input'];
};


export type OrganizationtrustedSmartContractsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filterAddresses?: Array<Scalars['String']['input']>;
  filterNameSubstr?: InputMaybe<Scalars['String']['input']>;
  filterNetworkIDs?: Array<Scalars['ID']['input']>;
  filterPurposes?: Array<TrustedSmartContractPurpose>;
  filterTrustedSmartContractSubIDs?: Array<Scalars['String']['input']>;
  filterVaultSubIDs?: Array<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDESC?: Scalars['Boolean']['input'];
  sortField?: TrustedSmartContractSortingField;
};


export type OrganizationuserKeysArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<KeyWhereInput>;
};


export type OrganizationusersArgs = {
  userKeyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type OrganizationusersV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserV2WhereInput>;
};


export type OrganizationvaultArgs = {
  overrideAllowedAssetSubIDsForOrgKeyIDsWithSlowBackOfficeQuery?: Array<Scalars['Int']['input']>;
  preloadAvailableBalanceForPurposes?: Array<AvailableForPurpose>;
  vaultSubID?: InputMaybe<Scalars['String']['input']>;
  vaultUniqueID?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationvaultPoliciesV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filter?: InputMaybe<PolicyV2FilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationvaultsArgs = {
  filterCurrentUserIsVaultMember?: InputMaybe<Scalars['Boolean']['input']>;
  filterStates?: InputMaybe<Array<VaultState>>;
  forceRunBlockedQuery?: Scalars['Boolean']['input'];
};


export type OrganizationvaultsWithPaginationArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterCurrentUserIsVaultMember?: InputMaybe<Scalars['Boolean']['input']>;
  filterStates?: InputMaybe<Array<VaultState>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<VaultSortField>;
};

/** Access policy values for a given organization. Currently, only web session expiry is implemented, but this should include source IP requirements in the future. */
export type OrganizationAccessPolicy = {
  __typename: 'OrganizationAccessPolicy';
  /** The amount of time a web session will be valid. Accepts a golang time.Duration string. Decimal numbers with a unit suffix, such as "3h" or "2h45m20s". */
  webSessionExpiry: Scalars['String']['output'];
};

/** Represents the balance of an organization */
export type OrganizationBalance = {
  __typename: 'OrganizationBalance';
  /** Amount */
  amount: Scalars['String']['output'];
  /** AssetTypeID */
  assetTypeID: Scalars['String']['output'];
  /** Balance Type */
  balanceType: Scalars['String']['output'];
  /** Organization key ID */
  orgID: Scalars['String']['output'];
};

/** OrganizationBalanceConnection represents a page of OrganizationBalances based on the parameters of pagination used, defined by a pageInfo object. */
export type OrganizationBalanceConnection = {
  __typename: 'OrganizationBalanceConnection';
  /** Edges contains a list of OrganizationBalanceEdge objects representing a page of OrganizationBalance data. */
  edges: Array<OrganizationBalanceEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** Represents the delta balance of an organization between two dates */
export type OrganizationBalanceDelta = {
  __typename: 'OrganizationBalanceDelta';
  /** AssetTypeID */
  assetTypeID: Scalars['String']['output'];
  /** Balance Type */
  balanceType: Scalars['String']['output'];
  /** Change in amount between start and end date */
  deltaAmount: Scalars['String']['output'];
  /** Organization key ID */
  orgID: Scalars['String']['output'];
};

/** OrganizationBalanceDeltaConnection represents a page of Organization balances over a period of time based on the parameters of pagination used, defined by a pageInfo object. */
export type OrganizationBalanceDeltaConnection = {
  __typename: 'OrganizationBalanceDeltaConnection';
  /** Edges contains a list of OrganizationBalanceDeltaEdge objects representing a page of OrganizationBalanceDelta data. */
  edges: Array<OrganizationBalanceDeltaEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** Represents an organization balance delta edge */
export type OrganizationBalanceDeltaEdge = {
  __typename: 'OrganizationBalanceDeltaEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a OrganizationBalanceDelta */
  node: OrganizationBalanceDelta;
};

/** Represents an organization balance edge */
export type OrganizationBalanceEdge = {
  __typename: 'OrganizationBalanceEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents an OrganizationBalance */
  node: OrganizationBalance;
};

/** Represents the configuration of an organization */
export type OrganizationConfigurationEntry = {
  __typename: 'OrganizationConfigurationEntry';
  /**
   * The type of the configuration
   *
   * Accepted types are:
   * - funding_threshold: Sets the funding threshold for the organization
   * - overdraft_limit: Sets the limit for funding balance overdrafting
   */
  type: Scalars['String']['output'];
  /** The value of the configuration */
  value: Scalars['String']['output'];
};

/** Represents the input configuration of an organization */
export type OrganizationConfigurationEntryInput = {
  /**
   * The type of the configuration
   *
   * Accepted types are:
   * - funding_threshold: Sets the funding threshold for the organization
   * - overdraft_limit: Sets the limit for funding balance overdrafting
   */
  type: Scalars['String']['input'];
  /** The value of the configuration */
  value: Scalars['String']['input'];
};

/** Represents the input for creating or updating an organization configuration */
export type OrganizationConfigurationInput = {
  /** The new configuration */
  configuration?: InputMaybe<Array<OrganizationConfigurationEntryInput>>;
  /** Organization key ID */
  organizationKeyID: Scalars['String']['input'];
};

/** OrganizationConnection represents a page of Organizations based on the parameters of pagination used, defined by a pageInfo object. */
export type OrganizationConnection = {
  __typename: 'OrganizationConnection';
  /** Edges contains a list of OrganizationEdge objects representing a page of Organization data. */
  edges: Array<OrganizationEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** Represents an organization edge */
export type OrganizationEdge = {
  __typename: 'OrganizationEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents an Organization */
  node: RIAOrganization;
};

/** Typed filter for organization queries. */
export type OrganizationFilterInput = {
  affiliateID?: InputMaybe<StringOps>;
  and?: InputMaybe<Array<OrganizationFilterInput>>;
  createdAt?: InputMaybe<TimeOps>;
  id?: InputMaybe<StringOps>;
  /** Filter by firm-level cash-interest enrollment. */
  isFiatInterestEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<OrganizationFilterInput>;
  or?: InputMaybe<Array<OrganizationFilterInput>>;
  type?: InputMaybe<OrganizationTypeOps>;
  updatedAt?: InputMaybe<TimeOps>;
};

/** Gas station behavior for an organization */
export type OrganizationGasStationSettings = {
  __typename: 'OrganizationGasStationSettings';
  /** Initial value of useGasStation in forms. False whenever supported is false */
  defaultEnabled: Scalars['Boolean']['output'];
  /** Whether the organization may use the gas station. Always equal to Organization.supportsGasStation */
  supported: Scalars['Boolean']['output'];
  /**
   * Whether the UI renders the gas station toggle. When false, the UI sends defaultEnabled.
   * False whenever supported is false
   */
  userSelectable: Scalars['Boolean']['output'];
};

/** OrganizationKYCProfile represents KYC profile data for an organization entity */
export type OrganizationKYCProfile = KYCProfile & {
  __typename: 'OrganizationKYCProfile';
  /** Affiliate KYC profiles associated with this organization */
  affiliateKYCProfiles: AffiliateKYCProfileConnection;
  /** Possible affiliate types for this organization KYC profile */
  affiliateTypes: Array<Scalars['String']['output']>;
  /** Anchorage entity associated with this profile */
  anchorageEntity: Maybe<AnchorageEntity>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Exemptions for this KYC profile - information types that are exempt from collection */
  exemptions: Array<Scalars['String']['output']>;
  /** Unique identifier for the KYC profile */
  id: Scalars['ID']['output'];
  /** Name of the organization */
  name: Scalars['String']['output'];
  /** Related party KYC profiles associated with this organization */
  relatedPartyKYCProfiles: RelatedPartyKYCProfileConnection;
  /** Current status of the KYC profile */
  status: KYCStatus;
};


/** OrganizationKYCProfile represents KYC profile data for an organization entity */
export type OrganizationKYCProfileaffiliateKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** OrganizationKYCProfile represents KYC profile data for an organization entity */
export type OrganizationKYCProfilerelatedPartyKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  relatedPartyType?: InputMaybe<RelatedPartyType>;
};

/** Connection for OrganizationKYCProfile type */
export type OrganizationKYCProfileConnection = {
  __typename: 'OrganizationKYCProfileConnection';
  /** List of edges */
  edges: Array<OrganizationKYCProfileEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge for OrganizationKYCProfile type */
export type OrganizationKYCProfileEdge = {
  __typename: 'OrganizationKYCProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge */
  node: OrganizationKYCProfile;
};

export enum OrganizationMigrationStatus {
  COMPLETE = 'COMPLETE',
  READY = 'READY',
  SCHEDULED = 'SCHEDULED'
}

export type OrganizationModule = Node & {
  __typename: 'OrganizationModule';
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  moduleType: OrganizationModuleModuleType;
  name: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type OrganizationModuleConnection = {
  __typename: 'OrganizationModuleConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<OrganizationModuleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationModuleEdge = {
  __typename: 'OrganizationModuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<OrganizationModule>;
};

/** OrganizationModuleModuleType is enum for the field module_type */
export enum OrganizationModuleModuleType {
  BASE = 'BASE',
  SPECIFIC = 'SPECIFIC',
  UNSPECIFIED = 'UNSPECIFIED'
}

/**
 * OrganizationModuleWhereInput is used for filtering OrganizationModule objects.
 * Input was generated by ent.
 */
export type OrganizationModuleWhereInput = {
  and?: InputMaybe<Array<OrganizationModuleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** module_type field predicates */
  moduleType?: InputMaybe<OrganizationModuleModuleType>;
  moduleTypeIn?: InputMaybe<Array<OrganizationModuleModuleType>>;
  moduleTypeNEQ?: InputMaybe<OrganizationModuleModuleType>;
  moduleTypeNotIn?: InputMaybe<Array<OrganizationModuleModuleType>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrganizationModuleWhereInput>;
  or?: InputMaybe<Array<OrganizationModuleWhereInput>>;
};

/** Notes for a single organization */
export type OrganizationNotes = {
  __typename: 'OrganizationNotes';
  /** Timestamp in nanos of when these notes were last edited */
  lastEditedAt: Scalars['String']['output'];
  /** Email of the risk user that last edited this comment */
  lastEditedBy: Scalars['String']['output'];
  /** Content of the notes */
  notesContent: Scalars['String']['output'];
};

/** Fields available for ordering organizations. */
export enum OrganizationOrderField {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  PROGRAM_CUSTOMER_ID = 'PROGRAM_CUSTOMER_ID',
  TYPE = 'TYPE',
  UPDATED_AT = 'UPDATED_AT'
}

/** Typed ordering for organization queries. */
export type OrganizationOrderInput = {
  direction: OrderDirection;
  field: OrganizationOrderField;
};

/** Represents the different types of program customer subaccount */
export enum OrganizationPcSubaccountType {
  /** Custodial subaccount for individuals */
  CUSTODIAL = 'CUSTODIAL',
  /** Taxable subaccount for individuals */
  INDIVIDUAL_TAXABLE = 'INDIVIDUAL_TAXABLE',
  /** Taxable subaccount for institutions */
  INSTITUTIONAL_TAXABLE = 'INSTITUTIONAL_TAXABLE',
  /** IRA subaccount for individuals */
  IRA = 'IRA',
  /** Joint subaccount for individuals */
  JOINT = 'JOINT',
  /** Roth subaccount for individuals */
  ROTH = 'ROTH'
}

/** A blob containing exported organization policies. */
export type OrganizationPoliciesBlob = {
  __typename: 'OrganizationPoliciesBlob';
  /** The URL where the exported policies blob can be accessed. */
  blobURL: Scalars['String']['output'];
  /** The name of the exported file. */
  fileName: Scalars['String']['output'];
  /** The file type of the exported blob (e.g., "csv"). */
  fileType: Scalars['String']['output'];
  /** The MIME type of the exported blob (e.g., "text/csv"). */
  mimeType: Scalars['String']['output'];
};

/** OrganizationPurposeType is enum for the field purpose */
export enum OrganizationPurpose {
  /** An organization containing asset information */
  ASSET_SUPPORT = 'ASSET_SUPPORT',
  /** An organization containing quorum recovery information */
  QUORUM_RECOVERY = 'QUORUM_RECOVERY'
}

/** OrganizationRenameInput represents the input needed to rename an organization */
export type OrganizationRenameInput = {
  /** The new name of the organization. */
  name: Scalars['String']['input'];
};

/** Represents a Subaccount of an organization */
export type OrganizationSubaccount = {
  __typename: 'OrganizationSubaccount';
  /**
   * Affiliates associated with the subaccount
   * @deprecated Dead field — not queried by any client. Will be removed in a future release.
   */
  affiliates: Array<Affiliate>;
  /** Timestamp of when the subaccount was created */
  createdAt: Scalars['Time']['output'];
  /** Organization key ID of the organization the subaccounts belongs to */
  orgID: Scalars['String']['output'];
  /** Type of the program customer subaccount */
  pcSubaccountType: OrganizationPcSubaccountType;
  /** Subaccount assets grouped by asset type and list of names of all assets the subaccount holds. Paginated by asset type group. */
  subaccountAssets: SubaccountAssetsConnection;
  /** Subaccount ID */
  subaccountID: Scalars['String']['output'];
  /** Name of the subaccount */
  subaccountName: Scalars['String']['output'];
  /** Status of the subaccount */
  subaccountStatus: SubaccountStatus;
  /** Type of the subaccount */
  subaccountType: Scalars['String']['output'];
};


/** Represents a Subaccount of an organization */
export type OrganizationSubaccountsubaccountAssetsArgs = {
  paginationInput?: InputMaybe<PaginationInput>;
};

/** Represents a paginated connection of Organization Subaccount */
export type OrganizationSubaccountConnection = {
  __typename: 'OrganizationSubaccountConnection';
  /** Edges contains a list of OrganizationSubaccountEdge objects representing a page of OrganizationSubaccount data. */
  edges: Array<OrganizationSubaccountEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** Represents a Organization Subaccount Edge */
export type OrganizationSubaccountEdge = {
  __typename: 'OrganizationSubaccountEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a Subaccount */
  node: OrganizationSubaccount;
};

/** Organization-level pledge summary */
export type OrganizationSummary = {
  __typename: 'OrganizationSummary';
  organizationID: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  pledgeAmounts: PledgeAmounts;
};

/** Trading availability for an organization */
export enum OrganizationTradingStatus {
  /** Trading disabled */
  DISABLED = 'DISABLED',
  /** Trading enabled */
  ENABLED = 'ENABLED'
}

/** SubaccountOrgType comparison operations. */
export type OrganizationTypeOps = {
  eq?: InputMaybe<SubaccountOrgType>;
  in?: InputMaybe<Array<SubaccountOrgType>>;
  neq?: InputMaybe<SubaccountOrgType>;
  nin?: InputMaybe<Array<SubaccountOrgType>>;
};

/** OrganizationsDB contains a pageable list of organizations */
export type OrganizationsDB = {
  __typename: 'OrganizationsDB';
  /** edges implements the connections spec */
  edges: Array<OrganizationsDBEdge>;
  /** pageInfo implements the connections spec */
  pageInfo: PageInfo;
};

/** OrganizationsDBEdge implements the connections spec */
export type OrganizationsDBEdge = {
  __typename: 'OrganizationsDBEdge';
  /** cursor implements the connections spec */
  cursor: Scalars['String']['output'];
  /** node implements the connections spec */
  node: Organization;
};

/** An outbound Travel Rule record. */
export type OutboundTravelRule = {
  __typename: 'OutboundTravelRule';
  /** Transfer amount. */
  amount: Scalars['String']['output'];
  /** Asset type ID. */
  assetTypeID: Scalars['String']['output'];
  /** Created timestamp (UnixNano). */
  createdAt: Scalars['Timestamp']['output'];
  /** Raw extra data as a JSON string, if present. */
  extraData: Maybe<Scalars['String']['output']>;
  /** Transmission network, if set. */
  network: Maybe<Scalars['String']['output']>;
  /** Operation ID. */
  operationID: Scalars['String']['output'];
  /** Organization key ID. */
  orgID: Scalars['String']['output'];
  /** Received identity payload as JSON, if present. */
  receivedPayload: Maybe<Scalars['String']['output']>;
  /** Sent timestamp (UnixNano), if sent. */
  sentAt: Maybe<Scalars['Timestamp']['output']>;
  /** TRUST transmission timestamp (UnixNano), if sent via TRUST. */
  sentTimeViaTrust: Maybe<Scalars['Timestamp']['output']>;
  /** Travel Rule status. */
  status: Scalars['String']['output'];
  /** Transaction ID, if set. */
  transactionID: Maybe<Scalars['String']['output']>;
  /** Transmitted identity payload as JSON, if present. */
  transmittedPayload: Maybe<Scalars['String']['output']>;
  /** TRUST identity payload as JSON, if present. */
  trustPayload: Maybe<Scalars['String']['output']>;
  /** TRUST network status, if set. */
  trustStatus: Maybe<Scalars['String']['output']>;
  /** VASP identifiers from every source, unfiltered. */
  vaspIdentifiers: Array<VaspIdentifier>;
};

/** Error occurred when API key has outstanding holds. */
export type OutstandingHoldsError = ErrorMessage & {
  __typename: 'OutstandingHoldsError';
  /** An error message. */
  message: Scalars['String']['output'];
};

/** PCRValueInput represents a PCR index and its SHA256 hash value. */
export type PCRValueInput = {
  /** The PCR index (0-23 for TPM 2.0). */
  index: Scalars['Int']['input'];
  /** The SHA256 hash value for this PCR (64 hex characters). */
  value: Scalars['String']['input'];
};

/** PII Information Types */
export enum PIIInformationType {
  /** App access desired. E.g. Admin, regular, none. */
  ACCESS_TYPE = 'ACCESS_TYPE',
  /** First part of the address, usually door number and street */
  ADDRESS = 'ADDRESS',
  /** Second part of the address, usually city, state and zip code */
  ADDRESS2 = 'ADDRESS2',
  /** ALIAS */
  ALIAS = 'ALIAS',
  /** CITY */
  CITY = 'CITY',
  /** Country */
  COUNTRY = 'COUNTRY',
  /** COUNTRY_OF_CITIZENSHIP */
  COUNTRY_OF_CITIZENSHIP = 'COUNTRY_OF_CITIZENSHIP',
  /** Date of birth */
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  /** Email */
  EMAIL = 'EMAIL',
  /** First Name */
  FIRST_NAME = 'FIRST_NAME',
  /** ID Card back side picture */
  ID_CARD_BACK = 'ID_CARD_BACK',
  /** ID Card front side picture */
  ID_CARD_FRONT = 'ID_CARD_FRONT',
  /** The type of individual. E.g. beneficial owner, authorized person, participating member */
  INDIVIDUAL_TYPE = 'INDIVIDUAL_TYPE',
  /** Last Name */
  LAST_NAME = 'LAST_NAME',
  /** Name */
  NAME = 'NAME',
  /** Phone number */
  PHONE = 'PHONE',
  /** Social security number */
  SSN = 'SSN',
  /** State */
  STATE = 'STATE',
  /** Voice and video recording */
  VOICE_PHRASE = 'VOICE_PHRASE',
  /** Zip code */
  ZIP_CODE = 'ZIP_CODE'
}

/** Rejection reasons for PII entries */
export enum PIIRequirementReason {
  /** The image is too blurry */
  BLURRY = 'BLURRY',
  /** The submitted value was inconclusive */
  INCONCLUSIVE = 'INCONCLUSIVE',
  /** The submitted value is invalid */
  INVALID = 'INVALID',
  /** The information type is missing */
  MISSING = 'MISSING',
  /** Other */
  OTHER = 'OTHER'
}

/** Type used to return personal identifiable information */
export type PIIValue = {
  __typename: 'PIIValue';
  /** The type of information */
  piiType: PIIInformationType;
  /** The value of the information */
  value: Maybe<Scalars['String']['output']>;
};

/** PageInfo implements the connections spec */
export type PageInfo = {
  __typename: 'PageInfo';
  /** endCursor returns the cursor of the last value in the page returned */
  endCursor: Scalars['String']['output'];
  /** hasNextPage implements the connections spec */
  hasNextPage: Scalars['Boolean']['output'];
  /** hasPreviousPage implements the connections spec */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** startCursor returns the cursor of the first value in the page returned */
  startCursor: Scalars['String']['output'];
  /** totalResults returns the number of all results without pagination */
  totalResults: Maybe<Scalars['Int']['output']>;
};

/** PageParams holds the information for paginating the query */
export type PageParams = {
  /** Cursor after which edges should be picked - for forward pagination */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Cursor before which edges should be picked - for backward pagination */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Maximum number of edges returned after the 'after' cursor - for forward pagination */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of edges returned before the 'before' cursor - for backward pagination */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** PaginationInfo implements the connections spec */
export type PaginationInfo = {
  __typename: 'PaginationInfo';
  /** endCursor returns the cursor of the last value in the page returned */
  endCursor: Scalars['String']['output'];
  /** hasNextPage implements the connections spec */
  hasNextPage: Scalars['Boolean']['output'];
  /** hasPreviousPage implements the connections spec */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** startCursor returns the cursor of the first value in the page returned */
  startCursor: Scalars['String']['output'];
  /** totalResults returns the number of all results without pagination */
  totalResults: Scalars['Int']['output'];
};

/** Common input type for relay-style cursor pagination. */
export type PaginationInput = {
  /** Get elements after this cursor */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Get elements before this cursor */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Get first n elements (after the after cursor) */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Get past n elements (before the before cursor) */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** PaginationParams is a helper input type for pagination arguments */
export type PaginationParams = {
  /** after is the cursor to start returning items from */
  after?: InputMaybe<Scalars['String']['input']>;
  /** before is the cursor to end returning items at */
  before?: InputMaybe<Scalars['String']['input']>;
  /** first is the number of items to return starting from the cursor in after */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** last is the number of items to return starting from the cursor in before */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Paragraph represents a paragraph of text with an icon. */
export type Paragraph = {
  __typename: 'Paragraph';
  /**
   * iconURL returns the url for fetching the icon for this network.
   * If the type is SVG, the size is ignored.
   * Icons are square.
   * The size is in pixels.
   */
  iconURL: Scalars['String']['output'];
  /** The text to be shown */
  text: Scalars['String']['output'];
};


/** Paragraph represents a paragraph of text with an icon. */
export type ParagraphiconURLArgs = {
  iconType?: IconType;
  size?: Scalars['Int']['input'];
};

/** Per-participant pledge summary */
export type ParticipantSummary = {
  __typename: 'ParticipantSummary';
  participantID: Scalars['ID']['output'];
  participantName: Scalars['String']['output'];
  pledgeAmounts: PledgeAmounts;
};

export type ParticipatingMemberAddCandidate = {
  __typename: 'ParticipatingMemberAddCandidate';
  canAdd: Scalars['Boolean']['output'];
  match: ParticipatingMemberAddMatch;
  /** Whether an existing person's name on file differs from the name given, ignoring case, accents, spaces and punctuation. */
  nameDiffers: Scalars['Boolean']['output'];
  /** The first and last name on file, when nameDiffers and the caller may see sensitive data. */
  nameOnFile: Maybe<Scalars['String']['output']>;
};

/** What adding an email to the affiliate would do. */
export enum ParticipatingMemberAddMatch {
  /** This person is already on the affiliate. */
  ALREADY_ADDED = 'ALREADY_ADDED',
  /** KYC approved this person before. They are added without a form. */
  APPROVED = 'APPROVED',
  /** A profile exists that was never sent a form, or an earlier add's form email failed. It is sent now. */
  DRAFT = 'DRAFT',
  /** This person was sent a form and hasn't submitted it. Add them once they submit and KYC approves it. */
  FORM_IN_PROGRESS = 'FORM_IN_PROGRESS',
  /** This person submitted a form KYC hasn't approved yet. Add them once KYC approves it. */
  IN_REVIEW = 'IN_REVIEW',
  /** No KYC profile uses this email. A new one is created and sent the form. */
  NEW_PERSON = 'NEW_PERSON'
}

export type ParticipatingMemberAddResult = {
  __typename: 'ParticipatingMemberAddResult';
  /** Whether the individual KYC form was sent. */
  formSent: Scalars['Boolean']['output'];
};

/** PayMonthlyRewardsResult type represents the result of initiating the pay monthly rewards workflow. */
export type PayMonthlyStablecoinRewardsRewardsResult = {
  __typename: 'PayMonthlyStablecoinRewardsRewardsResult';
  /** Unique identifier for the workflow */
  workflowID: Scalars['ID']['output'];
};

/** PaymentAmount contains client settlement payments amount and count */
export type PaymentAmount = {
  __typename: 'PaymentAmount';
  /** Count of payments */
  count: Scalars['Int']['output'];
  tradingAmount: TradingAmount;
};

/** PaymentFlow is a payment flow */
export type PaymentFlow = Node & {
  __typename: 'PaymentFlow';
  /**
   * Display Amount of the payment flow, this value is rounded
   * and shouldn't be used for any calculations, use value instead
   * @deprecated Use tradingAmount instead
   */
  amount: Amount;
  /** Counterparty of the payment flow */
  counterparty: Scalars['String']['output'];
  /** Timestamp of creation of the payment flow */
  createdAt: Scalars['Timestamp']['output'];
  /** Entity of the payment flow ('HOLD', 'SINGAPORE', 'A1', etc.) */
  entity: Scalars['String']['output'];
  /** Id of the payment flow */
  id: Scalars['ID']['output'];
  /** Order id of the payment flow */
  orderID: Scalars['String']['output'];
  /** Settlement ID of the payment flow */
  settlementID: Maybe<Scalars['String']['output']>;
  /** Settlement status */
  settlementStatus: Maybe<DealerSettlementStatus>;
  /** Side of the payment flow */
  side: TradeSide;
  /** Trading amount of the payment flow */
  tradingAmount: TradingAmount;
  /**
   * CounterpartyWithErr object related to this payment flow.
   * This field is automatically resolved based on the counterparty
   */
  tradingCounterparty: Maybe<CounterpartyWithErr>;
  /**
   * Amount of the payment flow, this is the value with maximum precision
   * This is the value that should be used for calculations
   */
  value: Scalars['Decimal']['output'];
};

/** Payment flow connection for pagination */
export type PaymentFlowConnection = {
  __typename: 'PaymentFlowConnection';
  /** List of edges containing payment flow and cursor information */
  edges: Array<PaymentFlowEdge>;
  /** Page details for the associated list of payment flow edges */
  pageInfo: PageInfo;
};

/** Payment flow edge for pagination */
export type PaymentFlowEdge = {
  __typename: 'PaymentFlowEdge';
  /** Cursor for the associated dealer trades */
  cursor: Scalars['String']['output'];
  /** Dealer trades */
  node: PaymentFlow;
};

/** PaymentReference is a single (type, value) payment identifier */
export type PaymentReference = {
  __typename: 'PaymentReference';
  /** type of this payment reference */
  type: PaymentReferenceType;
  /** value of this payment reference */
  value: Scalars['String']['output'];
};

/** PaymentReferenceType identifies the kind of a payment reference */
export enum PaymentReferenceType {
  /** BNY Customer Reference Number */
  CRN = 'CRN',
  /** Fedwire Input Message Accountability Data, stamped when the sending bank inputs the wire */
  IMAD = 'IMAD',
  /** SWIFT Message Input Reference (display only, not a dedup key) */
  MIR = 'MIR',
  /** BNY Message Reference (also called Sender's Reference) */
  MREF = 'MREF',
  /** Fedwire Output Message Accountability Data, stamped when the Fed delivers the wire */
  OMAD = 'OMAD',
  /** BNY Retrieval Reference Number */
  RRN = 'RRN',
  /** BNY Sequence Number */
  SSN = 'SSN',
  /** BNY Transaction Reference (also called Related Reference) */
  TREF = 'TREF',
  /** SWIFT Unique End-to-end Transaction Reference */
  UETR = 'UETR',
  /** BNY Virtual Account Management reference */
  VAM = 'VAM'
}

/** Represents the different types of program customer subaccount */
export enum PcSubaccountType {
  /** Custodial subaccount for individuals */
  CUSTODIAL = 'CUSTODIAL',
  /** Taxable subaccount for individuals */
  INDIVIDUAL_TAXABLE = 'INDIVIDUAL_TAXABLE',
  /** Taxable subaccount for institutions */
  INSTITUTIONAL_TAXABLE = 'INSTITUTIONAL_TAXABLE',
  /** IRA subaccount for individuals */
  IRA = 'IRA',
  /** Joint subaccount for individuals */
  JOINT = 'JOINT',
  /** Roth subaccount for individuals */
  ROTH = 'ROTH'
}

/** Collection of pedometer data */
export type Pedometer = {
  __typename: 'Pedometer';
  /** List of pedometer data entries */
  data: Array<PedometerData>;
  /** State of the pedometer data collection */
  state: Scalars['String']['output'];
};

/** Holds information collected via pedometer */
export type PedometerData = {
  __typename: 'PedometerData';
  /** End collection date with nano precision */
  endDate: Scalars['String']['output'];
  /** Start collection date with nano precision */
  startDate: Scalars['String']['output'];
  /** Number of steps taken. -1 means error */
  steps: Scalars['Int']['output'];
};

/** Wraps the Operation produced by a policy write requiring quorum approval. */
export type PendingPolicyChange = {
  __typename: 'PendingPolicyChange';
  operation: Operation;
};

/** PercentageInputStep allows the user to input a percentage value. */
export type PercentageInputStep = StakingStep & {
  __typename: 'PercentageInputStep';
  /**
   * DefaultValue is the initial value this input will have, expressed as a string
   * representation of a decimal (e.g. "10" for 10%).
   */
  defaultValue: Maybe<Scalars['String']['output']>;
  /** Editable should disable the input if false. */
  editable: Scalars['Boolean']['output'];
  /**
   * Used to instruct the UI the name of the field that should be used to store the user's input for this step.
   * This value must be provided on all input steps when using PrepareGenericOperation
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /** The hint shown under the input field. */
  hint: Maybe<Scalars['String']['output']>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Allows the backend to provide info banners to be shown above the step */
  infoItems: Maybe<Array<InfoItem>>;
  /** The label shown on the UI next to the input field. */
  label: Scalars['String']['output'];
  /** MaxValue is the maximum value the user should be allowed to enter. */
  maxValue: Maybe<Scalars['String']['output']>;
  /** MinValue is the minimum value the user should be allowed to enter. */
  minValue: Maybe<Scalars['String']['output']>;
  /**
   * Precision is the number of decimal places allowed for the percentage
   * (e.g. 2 for two decimal places like 12.34%).
   */
  precision: Scalars['Int']['output'];
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
};

/** PermitAmount specifies how the amount used in permit operations is interpreted. */
export enum PermitAmount {
  /** EXACT tells the quote endpoint to use the input amount for the permit operation. */
  EXACT = 'EXACT',
  /** FULL tells the quote endpoint to use an unlimited token quantity for the permit operation. */
  FULL = 'FULL',
  /** UNSPECIFIED is used where no other valid permit amount is available. */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** Natural person with a unique government identifier */
export type Person = Node & {
  __typename: 'Person';
  /** Affiliate KYC profiles that this person is associated with, including relationship metadata */
  affiliateKYCProfilesRelation: AffiliateKYCProfileRelationConnection;
  /**
   * Email of the Person
   * Fetched from latest KYC submission, except for Porto only persons
   */
  email: Scalars['String']['output'];
  /** ID of the Person */
  id: Scalars['ID']['output'];
  /**
   * IndividualIDs is a list of institutional individuals that this person is
   *  associated with.
   */
  individualIDs: Maybe<Array<Scalars['IndividualID']['output']>>;
  /** Institutional affiliates that this person is associated with. */
  institutionalAffiliateRelationships: InstitutionalAffiliateRelationshipPairConnection;
  /** The latest KYC InstitutionalIndividual that represents this natural person */
  institutionalIndividual: Maybe<InstitutionalIndividual>;
  /** All institutional individuals associated with this natural person */
  institutionalIndividuals: InstitutionalIndividualConnection;
  /** Most recent institutional individual. */
  latestIndividualID: Maybe<Scalars['IndividualID']['output']>;
  /**
   * Name of the Person
   * Fetched from latest KYC submission, except for Porto only persons
   */
  name: Scalars['String']['output'];
  /**
   * Phone number of the Person
   * Fetched from latest KYC submission
   */
  phoneNumber: Scalars['String']['output'];
  /** Related party KYC profiles associated with this person */
  relatedPartyKYCProfiles: RelatedPartyKYCProfileConnection;
  /** List of unique devices used by this person */
  uniqueDevices: UniqueDeviceConnection;
  /** List of user key IDs associated with this person. */
  userKeyIDs: Maybe<Array<Scalars['PublicKeyID']['output']>>;
  /**
   * A list of users that represent the enrollments this natural person
   * has done across several organizations
   */
  users: UserConnection;
  /**
   * A list of users that represent the enrollments this natural person
   * has done across several organizations
   */
  usersV2: UserV2Connection;
};


/** Natural person with a unique government identifier */
export type PersonaffiliateKYCProfilesRelationArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<AffiliateKYCProfileRelationOrder>;
  rolesIn?: InputMaybe<Array<KYCRoleType>>;
};


/** Natural person with a unique government identifier */
export type PersoninstitutionalAffiliateRelationshipsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Natural person with a unique government identifier */
export type PersoninstitutionalIndividualsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Natural person with a unique government identifier */
export type PersonrelatedPartyKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Natural person with a unique government identifier */
export type PersonuniqueDevicesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UniqueDeviceWhereInput>;
};


/** Natural person with a unique government identifier */
export type PersonusersArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Natural person with a unique government identifier */
export type PersonusersV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of persons. */
export type PersonConnection = {
  __typename: 'PersonConnection';
  /** A list of edges. */
  edges: Maybe<Array<PersonEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

/** Contains the result of the checks ran */
export type PersonDataQualityChecksResult = {
  __typename: 'PersonDataQualityChecksResult';
  /** Description of the error occurred */
  error: Maybe<Scalars['String']['output']>;
  /** List of the exceptions found with persons' data */
  result: Maybe<Array<PersonDataQualityException>>;
  /** Current state of the person quality checks */
  state: PersonDataQualityChecksState;
};

/** Indicates the state of the person data quality checks */
export enum PersonDataQualityChecksState {
  /** Person data quality checks have been completed successfully */
  COMPLETE = 'COMPLETE',
  /** There was an error while running the person data quality */
  ERROR = 'ERROR',
  /** Person data quality checks have not started */
  NOT_STARTED = 'NOT_STARTED',
  /** Person data quality checks are still running */
  RUNNING = 'RUNNING'
}

/** Person data quality exception. */
export type PersonDataQualityException = {
  __typename: 'PersonDataQualityException';
  /** Human-readable reason for this exception. */
  exceptionReason: Scalars['String']['output'];
  /** Person IDs associated with this exception */
  personIDs: Array<Scalars['ID']['output']>;
  /** Person names associated with this exception. They are in the same order as the IDs */
  personNames: Array<Scalars['String']['output']>;
};

/** An edge in a connection, representing a Person instance */
export type PersonEdge = {
  __typename: 'PersonEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge */
  node: Maybe<Person>;
};

export type PersonIndividualBinding = {
  __typename: 'PersonIndividualBinding';
  individualID: Scalars['String']['output'];
  personID: Scalars['String']['output'];
};

/** Ordering options for Person connections */
export type PersonOrderBy = {
  /** The ordering direction */
  direction?: OrderDirection;
  /** The field by which to order Persons */
  field: PersonOrderByField;
};

/** Properties by which Person connections can be ordered */
export enum PersonOrderByField {
  /** Order Persons by email */
  EMAIL = 'EMAIL',
  /** Order Persons by name */
  NAME = 'NAME'
}

/** A filter to be used against Person fields. Filters are mutually exclusive. */
export type PersonWhereInput = {
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Person IDs to filter by */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** String to search for in PII values */
  piiContains?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceHoldsForActiveSubscriptionsFailure = {
  __typename: 'PlaceHoldsForActiveSubscriptionsFailure';
  assetTypeId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  subaccountId: Scalars['ID']['output'];
  subscriptionId: Scalars['ID']['output'];
};

export type PlaceHoldsForActiveSubscriptionsResult = {
  __typename: 'PlaceHoldsForActiveSubscriptionsResult';
  failed: Array<PlaceHoldsForActiveSubscriptionsFailure>;
  succeeded: Array<A1TradeSubscription>;
};

/**
 * PlatformBootMeasurementInput represents platform-specific boot measurements.
 * Exactly one of intelTdx or amdSevSnp must be provided.
 */
export type PlatformBootMeasurementInput = {
  /** AMD SEV-SNP boot measurements. */
  amdSevSnp?: InputMaybe<AmdSevSnpMeasurementsInput>;
  /** Intel TDX boot measurements. */
  intelTdx?: InputMaybe<IntelTdxMeasurementsInput>;
};

/** Pledge amount summaries in USD and per-asset breakdown */
export type PledgeAmounts = {
  __typename: 'PledgeAmounts';
  /** Per-asset-type breakdown of assets pledged FROM this entity (as pledgor). */
  assetBreakdownPledgedFrom: Array<AssetBreakdownElement>;
  /** Per-asset-type breakdown of assets pledged TO this entity (as secured party). */
  assetBreakdownPledgedTo: Array<AssetBreakdownElement>;
  /**
   * Total USD value pledged FROM this entity (as pledgor).
   * Null if price data is incomplete.
   */
  totalPledgedFrom: Maybe<Amount>;
  /**
   * Historical USD value of assets pledged FROM this entity (as pledgor),
   * aggregated across all contributing control agreements.
   * Returns up to 300 data points bucketed across the requested window with
   * carry-forward fill (same semantics as GDFControlAgreement.valueHistory).
   * Returns an empty list only when no control agreements contribute to this total.
   * When contributing CAs exist but have no snapshots in the window, returns
   * 300 carry-forward zero-value data points.
   */
  totalPledgedFromValueHistory: Array<GDFControlAgreementValueSnapshot>;
  /**
   * Total USD value pledged TO this entity (as secured party).
   * Null if price data is incomplete.
   */
  totalPledgedTo: Maybe<Amount>;
  /**
   * Historical USD value of assets pledged TO this entity (as secured party),
   * aggregated across all contributing control agreements.
   * Returns up to 300 data points bucketed across the requested window with
   * carry-forward fill (same semantics as GDFControlAgreement.valueHistory).
   * Returns an empty list only when no control agreements contribute to this total.
   * When contributing CAs exist but have no snapshots in the window, returns
   * 300 carry-forward zero-value data points.
   */
  totalPledgedToValueHistory: Array<GDFControlAgreementValueSnapshot>;
};


/** Pledge amount summaries in USD and per-asset breakdown */
export type PledgeAmountstotalPledgedFromValueHistoryArgs = {
  timeWindow: GDFValueHistoryTimeWindow;
};


/** Pledge amount summaries in USD and per-asset breakdown */
export type PledgeAmountstotalPledgedToValueHistoryArgs = {
  timeWindow: GDFValueHistoryTimeWindow;
};

/** Policy is constructed of lists of quorums and other data */
export type Policy = {
  __typename: 'Policy';
  /** The action associated with this policy */
  action: PolicyActionType;
  /** List of keys authorized to initiate these types of operations */
  initiateOnlyUsers: Array<User>;
  /** quorums are the list of quorums for this policy */
  quorums: Array<Quorum>;
  /**
   * List of users that are required in order to perform this operation.
   * This list is not cryptographically protected.
   * @deprecated use requiredUsersQuorums instead
   */
  requiredUsers: Array<User>;
  /**
   * requiredUsersQuorums are the softly required user quorums for this policy.
   * If there are no requiredUsersQuorums an empty list will be returned.
   */
  requiredUsersQuorums: Array<RequiredUsersQuorum>;
};


/** Policy is constructed of lists of quorums and other data */
export type PolicyinitiateOnlyUsersArgs = {
  sortField?: InputMaybe<UserSortField>;
};


/** Policy is constructed of lists of quorums and other data */
export type PolicyrequiredUsersArgs = {
  sortField?: InputMaybe<UserSortField>;
};

/** PolicyAction defines an action that can be taken as part of a policy. */
export type PolicyAction = {
  /** Identifier of the action */
  id: Scalars['String']['output'];
  /** Name of the action */
  name: Scalars['String']['output'];
};

export type PolicyActionConnection = {
  __typename: 'PolicyActionConnection';
  /** A list of edges containing PolicyAction nodes. */
  edges: Array<PolicyActionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of PolicyAction nodes in the connection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PolicyActionEdge = {
  __typename: 'PolicyActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The PolicyAction node at the end of the edge. */
  node: PolicyAction;
};

/**
 * Enumerates the different possible policy actions
 * This enum is not exaustive compared to schema.Action since there are actions that cannot
 * actually be protected by a policy, e.g. a deposit
 */
export enum PolicyActionType {
  /** request to create a new vault */
  CREATE_VAULT = 'CREATE_VAULT',
  /** request for an address at which assets may be deposited */
  DEPOSIT = 'DEPOSIT',
  /** request to create a new generic organization change */
  GENERIC_ORGANIZATION_CHANGE = 'GENERIC_ORGANIZATION_CHANGE',
  /** Used for actions that have no governing policy. */
  NONE = 'NONE',
  /** request to create a new offchain operation */
  OFFCHAIN_OPERATION_ADD = 'OFFCHAIN_OPERATION_ADD',
  /** request to change an organization */
  ORGANIZATION_CHANGE = 'ORGANIZATION_CHANGE',
  /** request to change an organization's policy */
  ORGANIZATION_POLICY_CHANGE = 'ORGANIZATION_POLICY_CHANGE',
  /** request to change an organization fragment binding */
  ORGANIZATION_POLICY_FRAGMENT_BINDING_CHANGE = 'ORGANIZATION_POLICY_FRAGMENT_BINDING_CHANGE',
  /** request to change an organization role binding */
  ORGANIZATION_POLICY_ROLE_BINDING_CHANGE = 'ORGANIZATION_POLICY_ROLE_BINDING_CHANGE',
  /** request to rename an organization */
  ORGANIZATION_RENAME = 'ORGANIZATION_RENAME',
  /** request to add a quorum recovery entry */
  QUORUM_RECOVERY_ADD = 'QUORUM_RECOVERY_ADD',
  /** request to remove a quorum recovery entry */
  QUORUM_RECOVERY_REMOVE = 'QUORUM_RECOVERY_REMOVE',
  /** request to create, update or delete a role */
  ROLE_CHANGE = 'ROLE_CHANGE',
  /** request to add a new trusted destination */
  TRUSTED_DESTINATION_ADD = 'TRUSTED_DESTINATION_ADD',
  /** request to remove an existing trusted destination */
  TRUSTED_DESTINATION_REMOVE = 'TRUSTED_DESTINATION_REMOVE',
  /** request to add a new trusted smart contract */
  TRUSTED_SMART_CONTRACT_ADD = 'TRUSTED_SMART_CONTRACT_ADD',
  /** request to remove an existing trusted smart contract */
  TRUSTED_SMART_CONTRACT_REMOVE = 'TRUSTED_SMART_CONTRACT_REMOVE',
  /** request to add a user */
  USER_ADD = 'USER_ADD',
  /** request to remove a user */
  USER_REMOVE = 'USER_REMOVE',
  /** request to change a vault's policy */
  VAULT_POLICY_CHANGE = 'VAULT_POLICY_CHANGE',
  /** request to change a vault fragment binding */
  VAULT_POLICY_FRAGMENT_BINDING_CHANGE = 'VAULT_POLICY_FRAGMENT_BINDING_CHANGE',
  /** request to change a vault role binding */
  VAULT_POLICY_ROLE_BINDING_CHANGE = 'VAULT_POLICY_ROLE_BINDING_CHANGE',
  /** request to move funds out of a vault */
  WITHDRAW = 'WITHDRAW'
}

export type PolicyActionWhereInput = {
  /**
   * Filter by policy action type. Required at runtime: a request that omits it
   * or sends null gets a 400 error.
   */
  type?: InputMaybe<PolicyResourceType>;
};

/** PolicyChange represents a single policy change entry */
export type PolicyChange = {
  __typename: 'PolicyChange';
  /**
   * Timestamp when the change was completed
   * This is only set when the operation is in a final state or when it does not have an operation
   */
  completedDate: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this changelog entry. */
  id: Scalars['ID']['output'];
  /** User that initiated the change. */
  initiator: UserV2;
  /**
   * Operation ID if this change is part of an operation.
   * Null for changes that are not tied to an operation.
   */
  operationID: Maybe<Scalars['String']['output']>;
  /**
   * Status of the change or associated operation.
   * Can be: COMPLETE, GATHERING_APPROVALS, CANCELED, ERRORED, etc.
   */
  status: Scalars['String']['output'];
  /**
   * Subtitle describing what was changed, as a comma-separated list.
   * Examples: "Name, Rules, Users, Vaults"
   */
  subtitle: Scalars['String']['output'];
  /**
   * Title describing the type of change.
   * Examples: "Create vault policy", "Update vault policy"
   */
  title: Scalars['String']['output'];
};

/** Connection type for PolicyChange pagination. */
export type PolicyChangeConnection = {
  __typename: 'PolicyChangeConnection';
  /** List of edges containing PolicyChange nodes. */
  edges: Array<PolicyChangeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of PolicyChange nodes in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Edge type for PolicyChange connection. */
export type PolicyChangeEdge = {
  __typename: 'PolicyChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The PolicyChange node at the end of the edge. */
  node: PolicyChange;
};

/** A blob containing exported policy changelog. */
export type PolicyChangelogBlob = {
  __typename: 'PolicyChangelogBlob';
  /** The suggested filename for the downloaded CSV. */
  fileName: Scalars['String']['output'];
  /** The URL where the exported changelog CSV can be accessed. */
  url: Scalars['String']['output'];
};

/**
 * PolicyContainer represents a single identifiable subject in a policy graph.
 * The policy graph is a single parented hierarchy structure such that all policy containers inherit policy data and fragments from their ancestry up
 * through the highest known parent in an evaluation context.
 */
export type PolicyContainer = {
  __typename: 'PolicyContainer';
  /** The globally unique identifier for the policy container. */
  containerID: Scalars['String']['output'];
  /** The policy data that is attached to the container. */
  dataContainer: PolicyDataContainer;
  /** The fragment data that is attached to the container. */
  fragmentContainer: PolicyFragmentContainer;
  /**
   * The Policy Container of the parent type in the hierarchy.
   * Organizations do not have a parent.
   */
  parent: Maybe<PolicyContainer>;
};

/** PolicyContainerUpdate is the collection of updates being applied to the policy container */
export type PolicyContainerUpdate = {
  __typename: 'PolicyContainerUpdate';
  /** fragmentBindingUpdates is the fragment changes that will be applied to the policy */
  fragmentBindingUpdates: Maybe<Array<PolicyFragmentBindingUpdate>>;
  /** roleBindingUpdates is the role binding changes that will be applied to the policy */
  roleBindingUpdates: Maybe<Array<PolicyRoleBindingUpdate>>;
};

/** Secure information required to evaluate policies. */
export type PolicyDataContainer = {
  __typename: 'PolicyDataContainer';
  /** The bindings of principals to roles on the container. */
  roleBindings: Array<PolicyRoleBinding>;
  /** The roles that are defined on the policy container. */
  roles: Array<PolicyRole>;
};

/** PolicyDecision is the evaluator's verdict for a policy rule. */
export enum PolicyDecision {
  /** All requirements were met. */
  AUTHORIZED = 'AUTHORIZED',
  /** Requirements are missing but can still be met (e.g. more endorsements). */
  INSUFFICIENT = 'INSUFFICIENT',
  /** One of the conditions failed to be met. */
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  /** Explicitly rejected by a block-outcome rule; cannot be authorized. */
  REJECTED = 'REJECTED',
  /** Authorized except for unmet weak (soft) quorums. */
  SOFT_AUTHORIZED = 'SOFT_AUTHORIZED'
}

/** The fragment that may be met in order to perform the scoped action. */
export type PolicyFragment = PolicyStructuredFragment;

/** A scoped policy fragment that may be met in order to perform the scoped action. */
export type PolicyFragmentBinding = Node & {
  __typename: 'PolicyFragmentBinding';
  /** The human readable description of the binding. */
  description: Scalars['String']['output'];
  /** The human readable display name of the binding. */
  displayName: Scalars['String']['output'];
  /** A globally unique identifier of the binding. */
  fragmentBindingID: Scalars['String']['output'];
  /** The fragments that may be met in order to perform the scoped action. */
  fragments: Array<PolicyFragment>;
  /** The ID of the PolicyFragmentBinding. Mirrors fragmentBindingID */
  id: Scalars['ID']['output'];
  /** The fragment is for internal use and should not be displayed to users. */
  internal: Scalars['Boolean']['output'];
  /** The action that the binding applies to. */
  scope: Scalars['String']['output'];
};

/** PolicyFragmentBindingUpdate is an update that will be applied to a single fragment */
export type PolicyFragmentBindingUpdate = {
  __typename: 'PolicyFragmentBindingUpdate';
  /** originalBinding is the fragment binding prior to update. This will not be present for newly added fragment bindings. */
  originalBinding: Maybe<PolicyFragmentBinding>;
  /** updatedBinding is the fragment binding prior to update. This will not be present for fragment bindings being deleted. */
  updatedBinding: Maybe<PolicyFragmentBinding>;
};

/** Policy fragment binding pagination connection. */
export type PolicyFragmentConnection = {
  __typename: 'PolicyFragmentConnection';
  /** List of edges containing policy fragment bindings. */
  edges: Array<PolicyFragmentEdge>;
  /** Page details for the policy fragment connection. */
  pageInfo: PageInfo;
};

/** Policy fragments that define governance of the container. */
export type PolicyFragmentContainer = {
  __typename: 'PolicyFragmentContainer';
  /** Scoped policies that are bound to the container. */
  fragmentBindings: Array<PolicyFragmentBinding>;
};

/** Policy fragment binding edge connection. */
export type PolicyFragmentEdge = {
  __typename: 'PolicyFragmentEdge';
  /** Cursor implements the connections spec for pagination */
  cursor: Scalars['String']['output'];
  /** Node implements the connections spec for pagination */
  node: PolicyFragmentBinding;
};

/**
 * PolicyInfo is the information about the policy containers on the resource.
 * This should be called 'Policy' but due to legacy migration needs a unique name.
 */
export type PolicyInfo = {
  __typename: 'PolicyInfo';
  /**
   * The directly applied policy of the organization.
   * All child resources (such as vaults) will inherit the applied policy following inheritance semantics.
   */
  appliedPolicy: Maybe<PolicyContainer>;
  /** The effective policy of the organization when inheritance is applied. */
  effectivePolicy: Maybe<PolicyContainer>;
  /** The source of truth for the policy. */
  sourceOfTruth: Maybe<PolicySourceOfTruth>;
};


/**
 * PolicyInfo is the information about the policy containers on the resource.
 * This should be called 'Policy' but due to legacy migration needs a unique name.
 */
export type PolicyInfoappliedPolicyArgs = {
  sortField?: InputMaybe<FragmentBindingSortField>;
};


/**
 * PolicyInfo is the information about the policy containers on the resource.
 * This should be called 'Policy' but due to legacy migration needs a unique name.
 */
export type PolicyInfoeffectivePolicyArgs = {
  sortField?: InputMaybe<FragmentBindingSortField>;
};

export type PolicyQuorum = Node & {
  __typename: 'PolicyQuorum';
  /** The human readable description of the quorum. */
  description: Maybe<Scalars['String']['output']>;
  /** The effective set of members in the quorum when members is expanded. */
  displayMembers: Array<Actor>;
  /** The human readable display name of the quorum. */
  displayName: Maybe<Scalars['String']['output']>;
  /**
   * The effective set of members in the quorum when members is expanded.
   * @deprecated Legacy UserV1. Use 'displayMembers' instead.
   */
  expandedMembers: Array<User>;
  /** The ID of the PolicyQuorum. This ID will be based on the quorum position within the array. */
  id: Scalars['ID']['output'];
  /** The set of principals that will be granted the role. */
  members: Array<Scalars['String']['output']>;
  /** The strictness requirement of fulfilling the quorum in order to fulfill the containing policy fragment. */
  quorumRequirement: QuorumRequirement;
  /** The number of endorsements from the expanded members which must be provided. */
  threshold: Scalars['Int']['output'];
};

/** Policy quorum pagination connection. */
export type PolicyQuorumConnection = {
  __typename: 'PolicyQuorumConnection';
  /** A list of edges. */
  edges: Array<PolicyQuorumEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PolicyQuorumEdge = {
  __typename: 'PolicyQuorumEdge';
  /** A CursorType for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: PolicyQuorum;
};

/** Holds unsatisfiable policies at the org and vaults level. */
export type PolicyQuorumSummary = {
  __typename: 'PolicyQuorumSummary';
  /** Analysis of organization actions */
  inOrg: Array<OrgPolicyQuorumSummary>;
  /** Analysis of vaults actions */
  inVaults: Array<VaultPolicyQuorumSummary>;
  /** Returns status for the most at-risk policy. */
  status: PolicyStatus;
};

/** PolicyResource represents the resource that the policy is applied to. */
export type PolicyResource = Organization | Vault;

/** Type of the resource to which policies can be applied. */
export enum PolicyResourceType {
  ORGANIZATION = 'ORGANIZATION',
  VAULT = 'VAULT'
}

/** A role that may be granted to principals of the Organization. */
export type PolicyRole = {
  __typename: 'PolicyRole';
  /** The permissions and roles that comprise the role. */
  members: Array<Scalars['String']['output']>;
  /** A globally unique identifier of the role. */
  roleID: Scalars['String']['output'];
};

/** A relationship between a role and a set of principals that will be granted that role. */
export type PolicyRoleBinding = {
  __typename: 'PolicyRoleBinding';
  /** The set of principals that will be granted the role. */
  members: Array<Scalars['String']['output']>;
  /** The role that the binding is granting. */
  role: PolicyRole;
  /** A globally unique identifier of the binding. */
  roleBindingID: Scalars['String']['output'];
};

/** PolicyRoleBindingUpdate is an update that will be applied to a single role binding fragment. */
export type PolicyRoleBindingUpdate = {
  __typename: 'PolicyRoleBindingUpdate';
  /** originalBinding is the role binding prior to update. This will not be present for newly added role bindings. */
  originalBinding: Maybe<PolicyRoleBinding>;
  /** updatedBinding is the binding after update. This will not be present for bindings being deleted. */
  updatedBinding: Maybe<PolicyRoleBinding>;
};

/** A policy rule with conditions and a polymorphic outcome. */
export type PolicyRuleV2 = Rule & {
  __typename: 'PolicyRuleV2';
  action: RuleAction;
  conditions: RuleConditions;
  id: Scalars['ID']['output'];
  outcome: RuleOutcome;
  /** Outcome constraints valid for this rule given its stored conditions. */
  possibleOutcomes: PossibleOutcomes;
};

export type PolicyRuleV2Connection = {
  __typename: 'PolicyRuleV2Connection';
  edges: Array<PolicyRuleV2Edge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PolicyRuleV2Edge = {
  __typename: 'PolicyRuleV2Edge';
  cursor: Scalars['CursorType']['output'];
  node: PolicyRuleV2;
};

/**
 * PolicySourceOfTruth is the current source of truth for policies.
 * As organizations move from governance policies to policy containers they move from POLICY_SOT_LEGACY_EXCLUSIVE -> POLICY_SOT_CONTAINER.
 */
export enum PolicySourceOfTruth {
  /** Policy is defined and enforced by policy containers for this resource. */
  POLICY_SOT_CONTAINER = 'POLICY_SOT_CONTAINER',
  /**
   * Policy is defined and enforce by the legacy governance policies for this resource.
   * Policy Containers are derived from the legacy governance policies.
   */
  POLICY_SOT_LEGACY = 'POLICY_SOT_LEGACY',
  /** Policy is defined and enforced by legacy governance policies for this resource. */
  POLICY_SOT_LEGACY_EXCLUSIVE = 'POLICY_SOT_LEGACY_EXCLUSIVE'
}

/** Possible policy status */
export enum PolicyStatus {
  /** At least one quorum has as many users as the minimum required */
  AT_RISK = 'AT_RISK',
  /** All quorums are healthy */
  GOOD = 'GOOD',
  /** At least one quorum cannot be achieved */
  LOST = 'LOST',
  /** At least one quorum is reaching the minimum required users for quorum */
  NEEDS_ATTENTION = 'NEEDS_ATTENTION'
}

/** A strongly typed policy fragment that may be fulfilled in order to perform a scoped action. */
export type PolicyStructuredFragment = {
  __typename: 'PolicyStructuredFragment';
  /** The minimum number of members required in the fragment base quorum. */
  defaultMinimumMembers: Scalars['Int']['output'];
  /** The minimum number of endorsements required in the fragment base quorum. */
  defaultMinimumThreshold: Scalars['Int']['output'];
  /** All the quorums that must be met in order to fulfill the fragment. */
  quorums: Maybe<Array<PolicyQuorum>>;
  /** The destinations for applicable actions that must be used in order to fulfill the fragment. */
  restrictedDestinations: Maybe<Array<Scalars['String']['output']>>;
  /** The type of back office risk review that must be performed. */
  riskReviewRequirement: RiskReviewRequirement;
  /** The initial value of the threshold for the fragment base quorum. */
  thresholdInitialValue: Scalars['Int']['output'];
};

/** Represents an org policy update */
export type PolicyUpdate = {
  __typename: 'PolicyUpdate';
  /** Original policy */
  originalPolicy: Policy;
  /** new initiators list for the policy */
  updatedInitiateOnlyUsers: Array<User>;
  /** quorums are the list of quorums for this policy */
  updatedQuorums: Array<Quorum>;
  /**
   * new list of required users.
   * this list is not cryptographically protected
   * @deprecated use updatedRequiredUsersQuorums instead
   */
  updatedRequiredUsers: Array<User>;
  /**
   * updatedRequiredUsersQuorums are the softly required user quorums for this policy update.
   * If there are no updatedRequiredUsersQuorums an empty list will be returned.
   */
  updatedRequiredUsersQuorums: Array<RequiredUsersQuorum>;
};


/** Represents an org policy update */
export type PolicyUpdateupdatedInitiateOnlyUsersArgs = {
  sortField?: InputMaybe<UserSortField>;
};


/** Represents an org policy update */
export type PolicyUpdateupdatedRequiredUsersArgs = {
  sortField?: InputMaybe<UserSortField>;
};

export type PolicyV2 = {
  __typename: 'PolicyV2';
  /** List of keys that are not part of this policy but can be added */
  availableKeys: KeyConnection;
  /**
   * Changelog of changes to this policy
   *
   * Entries are sorted by creation date (newest last).
   */
  changelog: PolicyChangeConnection;
  /** Default rule for the policy */
  defaultRule: QuorumRule;
  /** Default rule of the policy. */
  defaultRuleV2: PolicyRuleV2;
  /**
   * Export changelog for this policy as a CSV file.
   * Returns a URL where the CSV can be downloaded.
   */
  exportChangelog: PolicyChangelogBlob;
  /** Identifier of a policy (if a policy is shared between multiple resources, the ID will be the same) */
  id: Scalars['ID']['output'];
  /** List of keys that are part of this policy along with its AccessLevel */
  keyAccesses: KeyAccessConnection;
  /** Name of the policy */
  name: Scalars['String']['output'];
  /** Pending operations that are associated with this policy */
  pendingOperations: Array<Operation>;
  /** List of resources that this policy applies to (both Organization and Vault implement Resource) */
  resources: ResourceConnection;
  /** Ordered list of rules */
  specificRules: RuleConnection;
  /** Ordered list of specific rules. Earlier rules take priority. */
  specificRulesV2: PolicyRuleV2Connection;
};


export type PolicyV2availableKeysArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PolicyV2changelogArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PolicyV2keyAccessesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<KeyAccessWhereInput>;
};


export type PolicyV2resourcesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PolicyV2specificRulesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PolicyV2Connection = {
  __typename: 'PolicyV2Connection';
  /** A list of edges containing PolicyV2 nodes. */
  edges: Array<PolicyV2Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of PolicyV2 nodes in the connection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PolicyV2Edge = {
  __typename: 'PolicyV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The PolicyV2 node at the end of the edge. */
  node: PolicyV2;
};

/** Filter input for policiesV2 in the organization. */
export type PolicyV2FilterInput = {
  policyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Result of a policy write. Branches on whether resources are assigned:
 * - PolicyV2: returned when the policy is unassigned (resourceIDs empty)
 *   and the write applied directly.
 * - PendingPolicyChange: returned when the policy is assigned to one or
 *   more resources (resourceIDs non-empty) and the change requires quorum
 *   approval — wraps the produced Operation.
 */
export type PolicyV2WriteResult = PendingPolicyChange | PolicyV2;

/** PooledAddressExclusionState is a pooled address's exclusion summary across its UTXOs. */
export enum PooledAddressExclusionState {
  /** Every UTXO at the address carries an exclusion hold. */
  EXCLUDED = 'EXCLUDED',
  /** No UTXO at the address carries an exclusion hold. */
  INCLUDED = 'INCLUDED',
  /** Some UTXOs at the address carry an exclusion hold and some do not. */
  PARTIAL = 'PARTIAL'
}

export type Portfolio = {
  __typename: 'Portfolio';
  /**
   * allNFTCollections returns all NFT collections without pagination based on which NFTs we have per vault
   * Set debug to true to enable more logging.
   */
  allNFTCollections: Array<NFTCollection>;
  /** 24h price change across the portfolio's holdings, as a percent-scale string: "2.31" means +2.31%. */
  dayChange: Scalars['String']['output'];
  /**
   * GroupHoldingsBreakdown returns holdingsBreakdowns and can optionally be used to query for a specific type of holdings (fiat/crypto)
   * HoldingsBreakdown contains two concepts:
   * - A holding is the total balance for a given asset type
   * - The breakdown adds additional info to this balance, including sub-balances and the percentage of the portfolio it makes up
   * Set debug to true to enable more logging.
   * Note: holdingsBreakdown can cause significant query latency, especially when aggregating large numbers of wallets. Use HoldingsBreakdownLite instead when you can.
   * isFiat:
   * - if nil: both FIAT and Crypto assets are returned.
   * - if true: only FIAT assets are returned.
   * - if false: only Crypto assets are returned.
   * includeInactive:
   * - if nil or false: returns only assets that had previous transactions in the current vault.
   * - if true: returns assets covered by all non-archived wallets in the current vault.
   */
  groupHoldingsBreakdown: GroupHoldingBreakdown;
  /**
   * HoldingBreakdown is a misnomer - should have been called HoldingWithBreakdowns:
   * - A holding is the total balance (amount with asset type) for a given asset type.
   * - The breakdown adds additional info to this balance, including sub-balances and the percentage of the portfolio allocated to each asset type.
   * Set debug to true to enable more logging.
   * Note: holdingsBreakdown can cause significant query latency, especially when aggregating large numbers of wallets. Use HoldingsBreakdownLite instead when you can.
   * @deprecated Doesn't handle fiat/cyrpto distinction, use groupHoldingsBreakdown instead
   */
  holdingsBreakdown: Array<HoldingBreakdown>;
  /**
   * HoldingsBreakdownLite is the faster version of GroupHoldingsBreakdown and HoldingsBreakdown with only key data for FE to display.
   * HoldingsBreakdownLite returns a list of holding amounts that each satisfies all given filters.
   * isFiat:
   * - if nil: both FIAT and Crypto assets are returned.
   * - if true: only FIAT assets are returned.
   * - if false: only Crypto assets are returned.
   * includeInactive:
   * - if nil or false: returns only assets that had previous transactions in the current scope vault.
   * - if true: returns assets covered by all wallets in the current vault.
   * filterByAssetTypeIDs:
   * - iff not empty, only holdings for these asset types are returned.
   */
  holdingsBreakdownLite: Array<Amount>;
  /**
   * NonZeroHoldings is deprecated, use HoldingsBreakdownLite instead.
   * It returns a list of holdings with the following properties:
   *   - A holding is the total balance (amount with asset type) for a given asset type.
   *   - The zero balances have been filtered out.
   * Should be used in preference to holdingsBreakdown.
   */
  nonZeroHoldings: Array<Amount>;
  /**
   * The value in USD of all holdings for the organization or vault
   * @deprecated Use totalBalanceAmount instead
   */
  totalBalance: Scalars['String']['output'];
  /** TotalBalanceAmount returns an amount type object representing the value in USD of all holdings for the organization or vault */
  totalBalanceAmount: Amount;
};


export type PortfolioallNFTCollectionsArgs = {
  debug?: Scalars['Boolean']['input'];
};


export type PortfoliogroupHoldingsBreakdownArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  isFiat?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<HoldingSortFields>;
};


export type PortfolioholdingsBreakdownArgs = {
  sortField?: InputMaybe<HoldingSortFields>;
};


export type PortfolioholdingsBreakdownLiteArgs = {
  filterByAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  isFiat?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PortfoliononZeroHoldingsArgs = {
  filterByAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  includeOnlyFiatTrading?: InputMaybe<Scalars['Boolean']['input']>;
  isFiat?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Outcomes valid for a given (action, draft conditions) tuple. A non-null
 * field signals that outcome kind is allowed; null means it isn't.
 */
export type PossibleOutcomes = {
  __typename: 'PossibleOutcomes';
  block: Maybe<BlockOutcomeAvailability>;
  quorum: Maybe<QuorumOutcomeConstraints>;
};

/** Draft action and its conditions to evaluate for possibleOutcomes. */
export type PossibleOutcomesInput = {
  actionID: Scalars['String']['input'];
  conditions: Array<RuleConditionInput>;
  resourceType: PolicyResourceType;
};

/** PreTransactionRequestInput is one way of describing the transaction. Exactly one field is set. */
export type PreTransactionRequestInput =
  /** encoded is the JSON-RPC payload the post-creation scan receives, passed through as is. */
  { encoded: Scalars['JSON']['input']; unencoded?: never; }
  |  /** unencoded is a structured call the server encodes into that payload. EVM only today. */
  { encoded?: never; unencoded: UnencodedInput; };

/** PreTransactionScan pairs the risk verdict with the simulation. */
export type PreTransactionScan = {
  __typename: 'PreTransactionScan';
  /** smartContractRisk is the risk verdict for the transaction. */
  smartContractRisk: SmartContractRisk;
  /** smartContractSimulation is the simulation outcome for the transaction. */
  smartContractSimulation: SmartContractSimulation;
};

/** PrepareActionFromJSONFormInput contains the form data and context needed to execute an action. */
export type PrepareActionFromJSONFormInput = {
  /**
   * actionID identifies which action is being submitted (e.g. "solana_stake").
   * Must match the actionID from the JsonForm that was rendered.
   */
  actionID: Scalars['String']['input'];
  /** formData is the raw JSON form data submitted by the user, validated against the JSON Schema. */
  formData: Scalars['JSON']['input'];
  /** target identifies the entity this action applies to and its scope. */
  target: ActionTarget;
  /** version must match the version from the JsonForm to ensure schema compatibility. */
  version: Scalars['Int']['input'];
};

/** PrepareActionFromJSONFormPayload is the response after successfully preparing an action. */
export type PrepareActionFromJSONFormPayload = {
  __typename: 'PrepareActionFromJSONFormPayload';
  /** operationID is the ID of the created operation, which can be tracked for status. */
  operationID: Scalars['String']['output'];
};

/** Input for preparing a BinaryAttestation operation. */
export type PrepareBinaryAttestationInput = {
  /**
   * binaryHash is deprecated. Signers submit the sha256 measurement through
   * signreveal so each signer computes the binary hash independently.
   * @deprecated Signers submit the sha256 measurement through signreveal.
   */
  binaryHash?: InputMaybe<Scalars['String']['input']>;
  /** expiration is unix seconds. When 0 or unset, the server picks a default. */
  expiration?: InputMaybe<Scalars['String']['input']>;
  /** gitCommit is the verbatim git commit identifier the ceremony attests. */
  gitCommit: Scalars['String']['input'];
  /**
   * organizationKeyID is the org under whose seed the HSM derives the reveal
   * keypair.
   */
  organizationKeyID: Scalars['String']['input'];
  /** vaultSubID is the selected vault whose BINARY_ATTESTATION policy applies. */
  vaultSubID: Scalars['String']['input'];
};

/** Prepare-time bundle for a BinaryAttestation operation. */
export type PrepareBinaryAttestationPayload = {
  __typename: 'PrepareBinaryAttestationPayload';
  /** Org reveal public key, uncompressed P-256 SEC1 hex. */
  attestationRevealPublicKey: Scalars['String']['output'];
  /** Prepare-time endorsed params JSON. */
  canonicalEndorsedParams: Scalars['String']['output'];
  /** Prepare-time signable payload JSON. */
  canonicalSignablePayload: Scalars['String']['output'];
  /**
   * Prepare-time reference digest sha256(canonicalSignablePayload), hex-encoded.
   * The FIDO2 browser assertion signs sha256(signable), not this field.
   */
  expectedChallenge: Scalars['String']['output'];
  /** The verbatim git commit identifier the ceremony attests. */
  gitCommit: Scalars['String']['output'];
  /** The operation created for this ceremony. */
  operationID: Scalars['String']['output'];
};

/** PresentationRule represents the most basic rule that other rules must extend. */
export type PresentationRule = {
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
};

/** PresentationRuleDontShowAgain indicates that the step should be skipped by the UI if the UI's local state indicates that the current user has previously checked the box when previously displayed a staking form containing this rule with the same flagIdentifier. */
export type PresentationRuleDontShowAgain = PresentationRule & {
  __typename: 'PresentationRuleDontShowAgain';
  /** CheckedByDefault is if the "Don't show again" checkbox should be checked by default */
  checkedByDefault: Maybe<Scalars['Boolean']['output']>;
  /** FlagIdentifier is the identifier used by the consumer to remember if this step has been seen before in a completed form. */
  flagIdentifier: Maybe<Scalars['String']['output']>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
};

/** PresentationRuleJustOnceAny indicates that the step should be skipped by the UI if the UI local state indicates that the current user has previously completed any staking form containing this rule with the same flagIdentifier. */
export type PresentationRuleJustOnce = PresentationRule & {
  __typename: 'PresentationRuleJustOnce';
  /** FlagIdentifier is the identifier used by the consumer to remember if this step has been seen before in a completed form. */
  flagIdentifier: Maybe<Scalars['String']['output']>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
};

/** Price information in USD for the given asset and time from the price service. */
export type PriceAttestationData = {
  __typename: 'PriceAttestationData';
  source: Scalars['String']['output'];
  timeAssessed: Scalars['String']['output'];
  usdExchangeRate: Scalars['String']['output'];
};

export enum PriceSource {
  BINANCE = 'BINANCE',
  BYBIT = 'BYBIT',
  CHAINLINK = 'CHAINLINK',
  /** Dev/smoke-testing-only source; no live production feed emits it, so injected fake prices are collision-free. */
  CM_FAKE = 'CM_FAKE',
  /** GDAX (Coinbase) price feed via Amberdata. */
  GDAX = 'GDAX',
  KAMINO = 'KAMINO',
  KRAKEN = 'KRAKEN',
  OKEX = 'OKEX'
}

/** Whether a pricing source prices a vendor ticker right now. */
export enum PriceSourceAvailability {
  /** The source returned a non-zero price. */
  AVAILABLE = 'AVAILABLE',
  /** The source does not list the ticker. */
  UNAVAILABLE = 'UNAVAILABLE',
  /** The source failed, timed out, or custody could not reach the price service. */
  UNKNOWN = 'UNKNOWN'
}

/** Conversion for an asset to another asset for a specified source. */
export type PriceSymbolConversion = {
  __typename: 'PriceSymbolConversion';
  /** Source asset identifier. */
  fromAsset: Scalars['String']['output'];
  /** The source this conversions is applicable (i.e., CRYPTO_COMPARE). */
  source: Scalars['String']['output'];
  /** When an actor last set source and userType. Null when the row predates the audit columns. */
  sourceSetAt: Maybe<Scalars['Timestamp']['output']>;
  /** Destination asset identifier. */
  toAsset: Scalars['String']['output'];
  /** When the price service last wrote the row. Null when the price service reports no time. */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Who last set the source. Null when the row predates the audit columns. */
  userType: Maybe<PriceSymbolConversionUserType>;
};

export enum PriceSymbolConversionUserType {
  /** The price service's automatic source switch. */
  SERVICE = 'SERVICE',
  /** A staff member, through setPriceSymbolConversion. */
  STAFF = 'STAFF'
}

export type ProductFilter = {
  /** Filter by base asset IDs */
  baseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by specific product IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by option exercise styles */
  optionExerciseStyles?: InputMaybe<Array<OptionExerciseStyle>>;
  /** Filter by option types */
  optionTypes?: InputMaybe<Array<OptionType>>;
  /** Filter by product types */
  productTypes?: InputMaybe<Array<ProductType>>;
  /** Filter by quote asset IDs */
  quoteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ProductType {
  FORWARD = 'FORWARD',
  OPTION = 'OPTION',
  SWAP = 'SWAP'
}

/** ProductUpdates contain information regarding new features and important changes to the product. */
export type ProductUpdates = {
  __typename: 'ProductUpdates';
  /** feedURL is the URL address for the feed. */
  feedURL: Scalars['String']['output'];
  /** items is a list of posts in the feed */
  items: Array<ProductUpdatesItem>;
  /** unreadCount is the number of posts in the feed marked as unread for the current user */
  unreadCount: Maybe<Scalars['Int']['output']>;
};

/** ProductUpdatesCategory represents the level of importance a product update can be identified with for notifying the user */
export enum ProductUpdatesCategory {
  /** IMPORTANT marks items with a high level of importance */
  IMPORTANT = 'IMPORTANT'
}

/** ProductUpdatesItem contains information regarding a change to the product. */
export type ProductUpdatesItem = {
  __typename: 'ProductUpdatesItem';
  /** content of the product update in plain text format */
  content: Scalars['String']['output'];
  /** content of the product update in HTML format */
  contentHTML: Scalars['String']['output'];
  /** id is used to differentiate between multiple items */
  id: Scalars['String']['output'];
  /** list of image URLs embedded in the post */
  images: Array<Scalars['String']['output']>;
  /** optional URL to redirect users for additional information */
  link: Maybe<Scalars['String']['output']>;
  /** optional text for rendering the redirect URL */
  linkText: Maybe<Scalars['String']['output']>;
  /** URL to the standalone post */
  postURL: Maybe<Scalars['String']['output']>;
  /** human readable title for the product update */
  title: Scalars['String']['output'];
};

/** Program Customer type for querying */
export type ProgramCustomer = {
  __typename: 'ProgramCustomer';
  /** Anchorage entity type */
  anchorageEntity: AnchorageEntityTypeOutput;
  /** Unique identifier for the program customer */
  id: Scalars['String']['output'];
  /** Name of the program customer */
  name: Scalars['String']['output'];
  numberOfSubaccounts: Maybe<Scalars['Int']['output']>;
  /** Parent RIA affiliate */
  parentAffiliate: Maybe<InstitutionalAffiliate>;
  /** Parent RIA affiliate */
  parentAffiliateID: Maybe<Scalars['String']['output']>;
  postedBalance: Maybe<Scalars['String']['output']>;
  /** Type of program customer (individual/institution) */
  programCustomerType: Scalars['String']['output'];
  /** Current state/status of the program customer */
  state: Scalars['String']['output'];
};

/** Connection type for program customers following GraphQL Relay specification */
export type ProgramCustomerConnection = {
  __typename: 'ProgramCustomerConnection';
  /** List of program customer edges */
  edges: Array<ProgramCustomerEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Edge type for program customers containing cursor and node data */
export type ProgramCustomerEdge = {
  __typename: 'ProgramCustomerEdge';
  /** Cursor for this specific program customer */
  cursor: Scalars['String']['output'];
  /** The actual program customer data */
  node: ProgramCustomer;
};

/**
 * ProgramCustomerKYCProfile represents a program customer as a first-class Denali KYC profile.
 * Program customers are child entities of an RIA affiliate.
 */
export type ProgramCustomerKYCProfile = {
  __typename: 'ProgramCustomerKYCProfile';
  /** Anchorage entity associated with this profile */
  anchorageEntity: Maybe<AnchorageEntity>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the KYC profile */
  id: Scalars['ID']['output'];
  /** Name of the program customer */
  name: Scalars['String']['output'];
  /** The parent affiliate (RIA) that this program customer belongs to */
  parentAffiliate: Maybe<AffiliateKYCProfile>;
  /** The program customer subtype */
  programCustomerType: Maybe<ProgramCustomerKYCProfileType>;
  /** Current status of the KYC profile */
  status: KYCStatus;
};

/** Connection type for ProgramCustomerKYCProfile */
export type ProgramCustomerKYCProfileConnection = {
  __typename: 'ProgramCustomerKYCProfileConnection';
  edges: Array<ProgramCustomerKYCProfileEdge>;
  pageInfo: PageInfo;
};

/** Edge type for ProgramCustomerKYCProfile */
export type ProgramCustomerKYCProfileEdge = {
  __typename: 'ProgramCustomerKYCProfileEdge';
  cursor: Scalars['CursorType']['output'];
  node: ProgramCustomerKYCProfile;
};

/** Sort fields for program customer KYC profiles */
export enum ProgramCustomerKYCProfileSortField {
  NAME = 'NAME'
}

/** Subtype of a program customer KYC profile */
export enum ProgramCustomerKYCProfileType {
  INDIVIDUAL = 'INDIVIDUAL',
  INSTITUTION = 'INSTITUTION'
}

/** Filter input for program customer KYC profiles */
export type ProgramCustomerKYCProfileWhereInput = {
  /** Filter by name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by specific program customer KYC profile ID */
  programCustomerKYCProfileID?: InputMaybe<Scalars['String']['input']>;
  /** Filter by program customer subtype */
  programCustomerTypes?: InputMaybe<Array<ProgramCustomerKYCProfileType>>;
  /** Sort descending */
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort field (default NAME) */
  sortField?: InputMaybe<ProgramCustomerKYCProfileSortField>;
};

/** SubaccountProgramCustomerRole comparison operations. */
export type ProgramCustomerRoleOps = {
  eq?: InputMaybe<SubaccountProgramCustomerRole>;
  in?: InputMaybe<Array<SubaccountProgramCustomerRole>>;
  neq?: InputMaybe<SubaccountProgramCustomerRole>;
  nin?: InputMaybe<Array<SubaccountProgramCustomerRole>>;
};

export type ProgramCustomerRosterRowInput = {
  programCustomerID: Scalars['String']['input'];
  role: Scalars['String']['input'];
  subaccountID: Scalars['String']['input'];
};

/** Input type for filtering program customers */
export type ProgramCustomerWhereInput = {
  /** Filter by AffiliateType */
  affiliateTypes?: InputMaybe<Array<AffiliateType>>;
  /** Filter by program customer name (partial text matching) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization ID (exact matching) */
  organizationID?: InputMaybe<Scalars['String']['input']>;
  /** Filter by RIA affiliate ID (exact matching) */
  riaAffiliateID?: InputMaybe<Scalars['String']['input']>;
  /** Sorting direction desc */
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  /** Field to be used for sorting (default NAME) */
  sortField?: InputMaybe<InstitutionalAffiliateSortFields>;
};

/** PromoterType is the different types of actors that can cause a trade state change */
export enum PromoterType {
  API_USER = 'API_USER',
  RISK_REVIEWER = 'RISK_REVIEWER',
  TRADING_SYSTEM = 'TRADING_SYSTEM',
  UNKNOWN = 'UNKNOWN',
  USER = 'USER'
}

/**
 * ProposalStage is retained for backward compatibility with older iOS clients.
 * Celo governance has been removed. Safe to delete once the minimum supported
 * iOS version is v2.111.0.
 */
export enum ProposalStage {
  APPROVAL = 'APPROVAL',
  EXECUTION = 'EXECUTION',
  EXPIRATION = 'EXPIRATION',
  NONE = 'NONE',
  QUEUED = 'QUEUED',
  REFERENDUM = 'REFERENDUM'
}

/** ProposalVoteStatus represents the state of a proposal, and whether it's voted on, in progress, or not */
export enum ProposalVoteStatus {
  /** COMPLETE is the state when the proposal has been voted on */
  COMPLETE = 'COMPLETE',
  /** NONE is the state when the proposal has not been voted on */
  NONE = 'NONE',
  /** PENDING is the state when the proposal is in progress but has not complete (because of an operation in progress) */
  PENDING = 'PENDING'
}

export type ProposeManualDepositInput = {
  amountCents: Scalars['Int']['input'];
  amountCentsConfirmation: Scalars['Int']['input'];
  bank: FiatBankName;
  bankAccountOwner?: InputMaybe<FiatBankAccountOwner>;
  bankPortalReference?: InputMaybe<Scalars['String']['input']>;
  beneficiaryName?: InputMaybe<Scalars['String']['input']>;
  imad?: InputMaybe<Scalars['String']['input']>;
  incidentID?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  omad?: InputMaybe<Scalars['String']['input']>;
  orgID: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  receivingAccountID?: InputMaybe<Scalars['String']['input']>;
  receivingParentAccountID?: InputMaybe<Scalars['String']['input']>;
  senderAccountNumber?: InputMaybe<Scalars['String']['input']>;
  senderBank?: InputMaybe<Scalars['String']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
  senderRoutingNumber?: InputMaybe<Scalars['String']['input']>;
  transactionID: Scalars['String']['input'];
};

export type ProposeUnassignedDepositAttributionInput = {
  action: UnassignedDepositAttributionAction;
  correctedReceivingAccountID?: InputMaybe<Scalars['String']['input']>;
  exceptionID: Scalars['String']['input'];
  expectedVersion: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

/** ProposedTrustedDestination is the type that represents a proposed trusted destination */
export type ProposedTrustedDestination = {
  __typename: 'ProposedTrustedDestination';
  /** amlSubmission returns the recorded answers for the AML questionnaire */
  amlSubmission: Maybe<InputSubmission>;
  /** Further information regarding this asset type */
  assetTypeInfo: AssetTypeInfo;
  /** Description of the trusted address */
  description: Scalars['String']['output'];
  /** The address */
  destination: Scalars['String']['output'];
  /**
   * isAtNetworkLevel denotes whether the trusted destination is used as network level or asset level
   * true: network level, false: asset level
   */
  isAtNetworkLevel: Scalars['Boolean']['output'];
  /** Name of the trusted address */
  name: Scalars['String']['output'];
  /** ExtraParams for for trusted destinations, depending on the asset being used */
  trustedDestinationExtraParams: Maybe<TrustedDestinationExtraParams>;
};

/** ProposedTrustedSmartContract is the type that represents a proposed trusted smart contract */
export type ProposedTrustedSmartContract = {
  __typename: 'ProposedTrustedSmartContract';
  /** Description of the trusted smart contract. */
  description: Scalars['String']['output'];
  /** Name of the trusted smart contract. */
  name: Scalars['String']['output'];
  /** The network ID the smart contract is for. */
  networkID: Scalars['ID']['output'];
  /** The network info corresponding to the network ID. Available only if the ID is valid. */
  networkInfo: Maybe<NetworkInfo>;
  /** The canonical address. */
  smartContractAddress: Scalars['String']['output'];
  /** Unique IDs of the vaults in which the smart contract is considered "trusted". */
  vaultIDs: Array<Scalars['String']['output']>;
  /**
   * The vaults in which the smart contract is considered "trusted".
   * The length may be smaller than vaultIDs: for all Unique IDs, only those with a valid vault are included in this list.
   */
  vaults: Array<Vault>;
};

/** ProtocolPool is the actual pool of quotes used to perform a token swap. */
export enum ProtocolPool {
  /** JUPITER is the Jupiter pool used for swaps. */
  JUPITER = 'JUPITER',
  /** UNISWAP represents v2, v3, and v4 versions of the Uniswap protocol pools at the same time. */
  UNISWAP = 'UNISWAP',
  /** UNISWAP_V2 is the v2 version of the Uniswap protocol pool. */
  UNISWAP_V2 = 'UNISWAP_V2',
  /** UNISWAP_V3 is the v3 version of the Uniswap protocol pool. */
  UNISWAP_V3 = 'UNISWAP_V3',
  /** UNISWAP_V4 is the v4 version of the Uniswap protocol pool. */
  UNISWAP_V4 = 'UNISWAP_V4',
  /** UNSPECIFIED is used where no other valid protocol pool is available. */
  UNSPECIFIED = 'UNSPECIFIED'
}

/**
 * QosEnclave holds the hardware-attested QuorumOS enclave measurements (Nitro PCRs)
 * for an approved Turnkey deployment.
 */
export type QosEnclave = {
  __typename: 'QosEnclave';
  /**
   * SHA-384, expected value for PCR[0] and PCR[1]. Pins the kernel side of
   * the QoS image (hex-encoded, 48 bytes).
   */
  kernelHash: Scalars['String']['output'];
  /**
   * SHA-384, expected value for PCR[2]. Pins the userspace side of the QoS
   * image (hex-encoded, 48 bytes).
   */
  userspaceHash: Scalars['String']['output'];
};

/**
 * QosEnclaveInput holds the hardware-attested QuorumOS enclave measurements
 * (Nitro PCRs) for an approved Turnkey deployment.
 */
export type QosEnclaveInput = {
  /**
   * SHA-384, expected value for PCR[0] and PCR[1]. Pins the kernel side of
   * the QoS image (hex-encoded, 48 bytes).
   */
  kernelHash: Scalars['String']['input'];
  /**
   * SHA-384, expected value for PCR[2]. Pins the userspace side of the QoS
   * image (hex-encoded, 48 bytes).
   */
  userspaceHash: Scalars['String']['input'];
};

/** Represents a quantity in the ledger */
export type Quantity = {
  __typename: 'Quantity';
  /** Amount */
  amount: Scalars['String']['output'];
  /** AssetTypeID */
  assetTypeID: Scalars['String']['output'];
  /** Balance Type */
  balanceType: Maybe<Scalars['String']['output']>;
  /** TokenID */
  tokenID: Maybe<Scalars['String']['output']>;
};

/** The query type, represents all of the entry points into our object graph */
export type Query = {
  __typename: 'Query';
  /** Returns a list of available BalanceTypes */
  BalanceTypes: Array<Scalars['String']['output']>;
  /** Fetch a paginated list of counterparty balance entries based on filters */
  a1Balances: A1BalancesConnection;
  /** abiFetchableNetworks returns the caller's org-enabled EVM networks an ABI can be fetched for. */
  abiFetchableNetworks: Array<NetworkInfo>;
  accountConstraintGroups: AccountConstraintGroupConnection;
  accountConstraintStates: AccountConstraintStateConnection;
  accountConstraints: AccountConstraintConnection;
  /**
   * List accounts of any type and organization, as they are stored, oldest
   * created first. Staff-only. Without page.first or page.last, a page has 50
   * accounts; more than 100 is refused.
   */
  accounts: AccountV4Connection;
  accountsV2: AccountV2Connection;
  /** Lists address attestation requests with the respective filter */
  addressAttestations: Array<AddressAttestation>;
  /**
   * addressPublicKey returns the hex-encoded public key backing the given address ID.
   * Used to recover the key generated by provisionAddress/setHederaAddress etc. for
   * chains (e.g. Hedera) where the on-chain address isn't derived from the key.
   */
  addressPublicKey: Scalars['String']['output'];
  /**
   * One pooled address's unspent UTXOs with their inclusion state, for the address drill-in. Every
   * listed UTXO is INCLUDED or EXCLUDED; coins held for another reason are left out because the
   * client cannot toggle them. Org users reach wallets of their own organization; tenancy is
   * enforced in the resolver.
   */
  addressUtxos: AddressUtxoResult;
  affiliateAnchorageRelationships: AffiliateAnchorageRelationshipConnection;
  /** Returns a list of subaccounts for an affiliate */
  affiliateSubaccounts: OrganizationSubaccountConnection;
  affiliatesV2: AffiliateV2Connection;
  /** allNetworkIDs returns all registered network IDs on the platform, sorted alphabetically. */
  allNetworkIDs: Array<Scalars['String']['output']>;
  /** returns all statements for an org */
  allStatements: Array<Statement>;
  /** Returns the list of networks that we support for asset support form in the current environment. */
  allSupportedNetworks: Maybe<Array<NetworkInfo>>;
  /**
   * amlQuestionnaireAnswers returns a list of answers from a previous AML record to prefill a questionnaire
   * One of address OR participantID+trustedCounterpartyParticipantID must be provided
   */
  amlQuestionnaireAnswers: AMLPrefillAnswers;
  anchorageLegalEntities: AnchorageLegalEntityConnection;
  /** Returns a REST API key */
  apiKey: APIKey;
  /** Returns the list of all REST API keys, with optional filters */
  apiKeys: Array<APIKey>;
  /** Checks if a email sending workflow is already running for the given organization */
  areStatementsBeingSent: Scalars['Boolean']['output'];
  /** Returns paginated list of asset support requests with optional filtering */
  assetSupportRequests: AssetSupportRequestConnection;
  /** Information regarding this asset type */
  assetTypeInfo: AssetTypeInfo;
  /** List of information for all supported asset types */
  assetTypeInfos: Array<AssetTypeInfo>;
  /** Produces a csv showing the number of required confirmations for each asset type. If assetTypes is not specified, it will return all asset types. */
  assetTypeRequiredConfirmationsReport: Scalars['String']['output'];
  /**
   * assetTypeTeamMappings returns asset types grouped by their owning Protocols team.
   * Each group contains a team label (A-F or "Other"), team name, and the list of asset type IDs.
   */
  assetTypeTeamMappings: Array<AssetTypeTeamGroup>;
  /** Returns available tax document years. */
  availableTaxDocumentYears: Array<TaxDocumentYearInfo>;
  /**
   * Get each wallet's base fiat.bank_info row for an organization (excluding virtual accounts and
   * subaccounts), optionally filtered by bank name
   */
  bankInfosForOrg: Array<BankInfoForOrg>;
  /** Returns billing entities after applying filters */
  billingEntities: Maybe<BillingEntitiesConnection>;
  billingNextInvoiceDate: Maybe<Scalars['Date']['output']>;
  /** Get list of trading assets to supply base, quote, counter currencies */
  blockPricerTradingAssets: Array<BlockPricerTradingAsset>;
  /** Get list of whitelisted trading entity names */
  blockPricerTradingEntities: Array<Scalars['String']['output']>;
  /** Get a list of liquidity venues */
  blockPricerTradingLiquidityVenues: Array<LiquidityVenue>;
  /**
   * blockchainAddress returns a BlockchainAddress by address string and assetTypeID.
   * The networkID is derived from the assetTypeID server-side.
   * Used to fetch address risk metadata via federation with the addressrisk subgraph.
   * Returns null if address is not provided.
   */
  blockchainAddress: Maybe<BlockchainAddress>;
  /** Returns the banner message for the blockchain service. */
  blockchainBanner: Scalars['String']['output'];
  /** List blockchain screening rows (TTRM Toolbox). */
  blockchainScreening: Array<BlockchainScreeningRecord>;
  /**
   * The BigQuery (project, dataset) pairs this environment admits as report
   * sources, so a registration form offers real sources instead of asking an
   * operator to remember a spelling from an earlier registration.
   *
   * It reads the code-resident allow-list, never BigQuery: the answer is what
   * somebody DECIDED is registrable, not what the service account happens to be
   * able to see, so a dataset that is readable but un-allow-listed is deliberately
   * absent and nothing becomes registrable by becoming visible. Having no I/O it
   * cannot fail — an environment with no pairs returns an empty list, which is the
   * honest answer that nothing is registrable there.
   */
  bqAllowedSources: Array<BQSource>;
  /**
   * The relations inside ONE allow-listed (project, dataset) pair whose names match
   * the filter, each with its type and whether it could back a report type — so a
   * form can offer real relation names instead of learning from a failed
   * createReportTypeDefinition whether one exists.
   *
   * A pair outside the allow-list is refused BEFORE BigQuery is called at all, on
   * the same verdict a create is refused on and naming the pairs this environment
   * does admit: browsing must not reach a dataset a registration could not name.
   *
   * It reads metadata only — tables.list and tables.get, never a query job — so it
   * scans nothing, bills nothing, and discloses relation names and types, never
   * rows. It writes nothing and caches nothing, and no answer it gives is a token
   * a later create trusts.
   *
   * Pass-through, not paging: at most 20 matches come back, with truncated set when
   * a further match exists. The move on a truncated listing is a narrower filter,
   * not a next page — there is none to ask for.
   */
  bqSourceRelations: BQRelationListing;
  /**
   * Read an allow-listed BigQuery view's live column schema BEFORE any report type
   * definition names it, so a registration form can check orgColumnName and the
   * header and filter source columns against the real view instead of learning
   * them from a failed createReportTypeDefinition.
   *
   * It is the same read the create performs on the way in — the same allow-list
   * gate before BigQuery is called, the same whole-source rejections (a dataset
   * that is not allow-listed, a source that does not exist or cannot be read, one
   * that is not a warehouse-managed relation, one with no columns at all) — so a
   * preview that succeeds is what the create will see. It writes nothing, caches
   * nothing, and judges no column: a column of a type no report can project is
   * reported like any other, because the view is wider than any one report.
   */
  bqViewSchema: BQViewSchemaPreview;
  /**
   * Brokerage support matrix per asset: one row per custody-side asset code with
   * flags for which brokerage channels currently support it. Sourced from a union
   * of two backing systems: the Anchorage Digital Asset Tracker sheet (chat) and
   * the approved+enabled trading_symbol set (uiAndApi). Assets are included when
   * at least one channel supports them.
   */
  brokerageSupportedAssets: Array<BrokerageSupportedAsset>;
  /** BulletinBoardServiceGetAddressOwnership gets address ownership from TRUST Bulletin Board */
  bulletinBoardServiceGetAddressOwnership: Maybe<Scalars['Map']['output']>;
  /**
   * Returns true iff current user has the permission to cancel the operation,
   * and the operation is in cancelable state.
   */
  canCancelOperation: Scalars['Boolean']['output'];
  /** Checks if user can edit CRR Risk parameters */
  canChangeCRRRiskConfigs: Scalars['Boolean']['output'];
  /** Checks if user can access CRR history data and view */
  canViewCRRHistory: Scalars['Boolean']['output'];
  /** Checks if user can access Close Account button */
  canViewCloseAccount: Scalars['Boolean']['output'];
  /** Checks if user can access Compliance Alerts information */
  canViewComplianceAlerts: Scalars['Boolean']['output'];
  /** Checks if user can access the Freeze withdrawal button */
  canViewFreezeWithdrawal: Scalars['Boolean']['output'];
  /** Checks if user can access KYC Alerts information */
  canViewKYCAlerts: Scalars['Boolean']['output'];
  /** Checks if a staff member has a given permission. */
  checkStaffPermission: Scalars['Boolean']['output'];
  /** Returns the affiliate types available for institutional client */
  clientAffiliateTypes: Maybe<Array<ClientAffiliateType>>;
  /** Retrieve details about a client dashboard login request before it is claimed */
  clientDashboardLoginRequestInfo: ClientDashboardLoginRequestInfo;
  /** Client Orders */
  clientOrders: ClientOrderConnection;
  /** Return the Client Orders in the CSV format */
  clientOrdersCSV: Scalars['String']['output'];
  /** Returns list of trades for the client dashboard */
  clientTradesView: TradesView;
  /** Get collateral management alerts with filters and pagination */
  cmAlerts: CmAlertsConnection;
  /**
   * Get the asset IDs that have USD pricing available from any cached
   * provider/price source combination, i.e. the union of what
   * cmAssetsWithPricing would return across every combination. IDs are
   * returned in environment-native form, same as cmAssetsWithPricing.
   */
  cmAllAssetsWithPricing: CmAssetsWithPricingResponse;
  /** Get collateral and/or exposure balances for active packages */
  cmAssetBalance: Maybe<CmAssetBalanceResponse>;
  /**
   * Get the asset IDs that have USD pricing available from the given provider
   * on the given price source (exchange). IDs are returned in environment-native
   * form: mainnet IDs (e.g. "BTC") in production, and the corresponding
   * regnet/testnet IDs (e.g. "BTC_S") in lower environments.
   */
  cmAssetsWithPricing: CmAssetsWithPricingResponse;
  /**
   * Live custody balance of the wallet configured for each collateral asset of a
   * package, so staff can spot drift between the collateral CM has booked and what
   * custody actually holds. Reads custody at request time; not a stored snapshot.
   */
  cmCollateralWalletBalances: Array<CmCollateralWalletBalance>;
  /** Get collateral management Participant for active packages */
  cmCurrentParticipant: CmParticipantResponse;
  /**
   * The largest pay up of each exposure asset that on its own brings the package's LTV to one
   * point below its danger threshold (the Margin Call LTV, else the Critical LTV). Computed from
   * the same LTV snapshot cmSimulateLtv uses. Single-asset pay up only; the amounts are not
   * additive across assets.
   */
  cmExposureIncreaseMaxAmounts: CmExposureIncreaseMaxAmountsResponse;
  /**
   * Get the latest calculated LTV snapshot per collateral package, including the
   * collateral and exposure valuations it was computed from. Reads the snapshots
   * persisted by the LTV monitor.
   */
  cmLatestLtvs: Array<CmLatestLtv>;
  /**
   * List liquidation obligations with filters and pagination. Filters combine with AND; an empty
   * ids list applies no id filter. Read one obligation with ids: [id], first: 1. The page leaves out,
   * without an error, an obligation that does not exist, whose package the caller cannot see as
   * secured party, or whose stored data cannot be converted, so a read by ids returns no edge for it.
   */
  cmLiquidationObligations: CmLiquidationObligationsConnection;
  /**
   * Live pre-execution numbers for one liquidation obligation, recomputed on every call: the
   * liquidation value, the package's live LTV, the projected credit utilization and its check, and
   * one leg per funded non-fixed-USD collateral asset. Errors when the obligation is unknown, its
   * package is not visible to the caller, or the package cannot be priced.
   */
  cmLiquidationPreExecution: CmLiquidationPreExecution;
  /** Liquidation price cache contents on the replica that served this request. Staff diagnostic; no staleness check. */
  cmLiquidationPriceCache: CmLiquidationPriceCacheResponse;
  /** Get loan-to-value ratio time series for collateral packages */
  cmLtvTimeSeries: Maybe<CmLtvTimeSeriesResponse>;
  /**
   * The largest amount of each collateral asset that can be returned on its own to bring the
   * package's LTV to one point above its configured ReturnToLTV (targetLtv). Computed from the
   * same LTV snapshot cmValidateMarginReturn uses. Single-asset return only; the amounts are
   * not additive across assets.
   */
  cmMarginReturnMaxAmounts: CmMarginReturnMaxAmountsResponse;
  /**
   * Cached Talos MarketDataSnapshot bid depths and freshness, one row per distinct requested asset, in
   * request order. An asset with no cached snapshot is omitted.
   */
  cmMarketDataSnapshots: Array<CmMarketDataSnapshot>;
  /** Get collateral management operations with filters and pagination */
  cmOperations: CmOperationsConnection;
  /**
   * Get collateral packages' full configuration — the fields the admin portal
   * edits via cmUpdateLoan, including the internal notes. Staff-only; non-staff
   * callers get an authorization error. Returns all packages when cmPackageIds
   * is omitted.
   */
  cmPackageConfigs: Array<CmPackageConfig>;
  /** Get package counts by state for active packages */
  cmPackageCount: CmPackageCountResponse;
  /** Get collateral package terms and asset configuration */
  cmPackageDetails: Array<CmPackageDetailsResponse>;
  /** Get loan (collateral package) details */
  cmPackages: CmPackagesConnection;
  /** Get list of all available price source providers with live data */
  cmPriceSourceProviders: Array<CmPriceSourceProviderResponse>;
  /** Get the price sources (exchanges) currently cached for a single provider. */
  cmPriceSources: CmPriceSourcesResponse;
  /**
   * Get all pricing data for CM system.
   * Returns supported price sources, assets and strategies by provider.
   */
  cmPriceSourcesByProvider: Array<CmPriceSourcesByProviderResponse>;
  /** Get the pricing strategies cached for the given provider and price source. */
  cmPricingStrategies: CmPricingStrategiesResponse;
  /**
   * Simulate the LTV a collateral package would have if the given operations were booked together.
   * Read-only: computes against the most recent stored LTV snapshot (collateral and prices); writes nothing.
   * Every operation's typeId must resolve to an exposure on the same collateral package — mixed-package inputs are rejected.
   * Per-operation deltas are summed before the single LTV division so the result reflects the combined effect, not N independent previews.
   * Returns the projected LTV, whether it stays strictly below the danger threshold (isValid; MC, or
   * Critical if no MC is configured), and whether cmRequestExposureIncrease would reject it
   * (blocksSubmission): an LTV at or above the threshold blocks pledgor callers but only warns
   * secured-party callers (and staff, who act as the secured party).
   * Use this before submitting cmRequestExposureIncrease to show the user the impact.
   */
  cmSimulateLtv: CmLtvSimulationResponse;
  /**
   * Get the open stale-price alert records, keyed by primary price source. A record
   * appears when an asset's primary feed is stale and failover has not served a
   * price (no backup feed configured, failover disabled, or the backup stale too).
   * lastFiredFingerprint is the asset set last sent to incident.io as firing, which
   * may temporarily differ from staleAssets; empty when the alert has never fired.
   */
  cmStalePriceAlerts: Array<CmStalePriceAlertResponse>;
  /**
   * Get system settings for a given type: the global row plus any asset-level
   * rows.
   */
  cmSystemSettings: Array<CmSystemSettings>;
  /**
   * Get the cached Talos program credit exposure for the service. Null when no row is cached,
   * when more than one row is cached, or when the cached row is offline.
   */
  cmTalosCreditExposure: Maybe<CmTalosCreditExposure>;
  /**
   * One Talos order's detail, read from the Talos /v1/orders endpoint. Takes the
   * Talos order ID linked to a liquidation obligation, not an obligation ID.
   */
  cmTalosOrder: CmTalosOrder;
  /**
   * Every trade of one Talos order, newest first, read from the Talos /v1/trades
   * endpoint. An order with no trades returns an empty list.
   */
  cmTalosTrades: Array<CmTalosTrade>;
  /**
   * Validates whether a proposed margin return keeps the projected LTV strictly below the
   * collateral return maximum: the package's ReturnToLTV plus 0.02 (the cmMarginReturnMaxAmounts
   * target plus 0.01 of tolerance). When the package has no ReturnToLTV, or that maximum is not
   * below the danger threshold (MC, or Critical if no MC is configured), the projected LTV must
   * instead stay strictly below the danger threshold.
   * Returns the projected LTV, whether it stays below that ceiling (isValid), and whether
   * cmRequestMarginReturn would reject it (blocksSubmission): an LTV above the ceiling blocks
   * pledgor callers (and staff, who act as the pledgor) but only warns secured-party callers,
   * while a return that consumes all collateral blocks everyone.
   * Use this before submitting cmRequestMarginReturn to show the user the impact.
   * Shares its response shape with cmSimulateLtv so clients can render both from one component.
   */
  cmValidateMarginReturn: CmLtvSimulationResponse;
  /** Get collateral communications sent to clients */
  collateralCommunications: Array<CollateralTicketCommunicationLog>;
  /** Get collateral ticket */
  collateralTickets: Array<CollateralTicket>;
  /** Healthcheck endpoint to verify GraphQL federation is working */
  complianceAlertsHealthcheck: Scalars['String']['output'];
  /** Checks if user can edit transaction monitoring system configs */
  complianceCanUpdateTMSConfigs: Scalars['Boolean']['output'];
  /** Gets compliance documents */
  complianceDocuments: ComplianceDocumentsConnection;
  /** Returns the transaction monitoring system configs */
  complianceTMSConfigs: TMSConfigsConnection;
  /** Returns the transaction monitoring system configs metadata */
  complianceTMSConfigsMetadata: Array<TMSRuleGroupMetadata>;
  /**
   * List activities for a control agreement.
   * When activityID is provided, returns at most one result.
   */
  controlAgreementActivities: ControlAgreementActivityConnection;
  /**
   * Get summary statistics showing total dollar value of assets pledged to/from
   * the requesting user's organization across all enrolled participants.
   *
   * For STAFF users: shows all enrolled participants across all organizations.
   * For ORG users: shows only participants in their organization.
   */
  controlAgreementSummaryStats: ControlAgreementSummaryStats;
  /**
   * Returns a paginated CSV of deposits requiring cost basis entry.
   * Deposits with existing cost basis get one row per lot (deposit columns repeated);
   * others get one row with empty lot columns, to be filled in and re-uploaded.
   */
  costBasisDepositsCsv: CostBasisDepositsCsvConnection;
  /** Returns a Cost Basis Job by ID. */
  costBasisJob: Maybe<CostBasisJob>;
  /** Fetch a paginated list of counterparties based on filters */
  counterparties: CounterpartiesV2ListResponse;
  /** Fetch a single counterparty by ID */
  counterparty: CounterpartyV2;
  counterpartyAccount: CounterpartyAccount;
  counterpartyAccounts: CounterpartyAccountsListResponse;
  counterpartyScreeningEntries: CounterpartyScreeningEntryConnection;
  /** currentActor returns information about the current actor (e.g. user key) */
  currentActor: Actor;
  /**
   * currentRiskUser returns information about the currently logged in user
   *
   * Deprecated: Use currentStaffUser from the authorization service instead, which includes permissions.
   * @deprecated Use currentStaffUser from the authorization service instead, which includes permissions
   */
  currentRiskUser: RiskDashboardUser;
  /**
   * Returns the current staff user with their permissions.
   * This replaces the deprecated currentRiskUser query.
   */
  currentStaffUser: StaffUser;
  /**
   * currentUser returns information about the currently logged in user
   * @deprecated Use currentUserV2 instead
   */
  currentUser: User;
  /** currentUserV2 returns information about the currently logged in user */
  currentUserV2: UserV2;
  /** custodyAUC returns the summary of assets under custory held in Anchorage */
  custodyAUC: CustodyAUC;
  /**
   * Returns true when the custodyoperations subgraph is healthy.
   * TODO: Remove this once real queries are added. This is boilerplate for the initial subgraph bootstrap.
   */
  custodyOperationsHealth: Scalars['Boolean']['output'];
  /** Retrieves all matching DApp notifications within a given time range. */
  dAppNotifications: Array<DAppNotification>;
  /**
   * debugAvailableConditions inspects the conditions editor palette. With no
   * organizationKeyID it returns the fully live catalog (no org filtering); pass one
   * to see what that org would be offered. Staff-only, since staff have no org in
   * their own request context.
   */
  debugAvailableConditions: Array<RuleConditionType>;
  /** debugRawTransaction returns the argument */
  debugRawTransaction: Scalars['String']['output'];
  /** debugUTXOs returns info about utxos we own */
  debugUTXOs: Scalars['String']['output'];
  /** Returns active default staking fee terms */
  defaultStakingFeeTerms: Maybe<DefaultStakingFeeTerms>;
  /** Return the default staking fee terms review if it is pending */
  defaultStakingFeeTermsPendingReview: Maybe<DefaultStakingFeeTermsReview>;
  /** Returns the deposit attribution spam thresholds */
  depositAttributionSpamThresholds: DepositAttributionSpamThresholdConnection;
  /** List of the deposit attributions */
  depositAttributionsV2: DepositAttributionConnectionV2;
  derivsEntityBankAccounts: Array<DerivsEntityBankAccount>;
  derivsEntityWallets: Array<DerivsEntityWallet>;
  derivsHealth: Scalars['Boolean']['output'];
  derivsTransfer: Maybe<DerivsTransfer>;
  /** Newest first. Paginates forward with first and after; the page size defaults to 50 and is capped at 200. */
  derivsTransfers: DerivsTransferConnection;
  derivsTrustedDestinations: Array<DerivsTrustedDestination>;
  /**
   * Gets latest disclosures.
   * This will only fetch the latest version of each document. So if Terms Of Use
   * has 3 versions, versions 1 and 2 won't be in the list of responses
   */
  disclosures: Array<Disclosure>;
  /**
   * Gets latest-version disclosure documents applicable to the given UI screen.
   * This will only fetch the latest version of each document.
   */
  disclosuresByScreen: Array<Disclosure>;
  /** Retrieves the base64 encoded file content of a specified report file. */
  downloadReport: Scalars['String']['output'];
  /**
   * Retrieves the base64 encoded file content of the file sent that is linked to the given report id and sftp destination id.
   * This can be called by staff users. Meant for testing purposes.
   */
  downloadSftpReport: Scalars['String']['output'];
  /** Get a single account by ID */
  dvAccount: Maybe<DVAccount>;
  /**
   * Get account balance report CSV.
   * Generates a per-asset balance report for the specified accounts showing current
   * balance and available balance (after deducting IM locked in active trades).
   * Triparty assets are shown on separate rows suffixed "Tri-Party".
   * Output is in the Metaplanet preferred CSV format.
   */
  dvAccountBalanceReport: DVFileDownload;
  /** List accounts with optional filtering */
  dvAccounts: Array<DVAccount>;
  /**
   * Maps each account to the counterparty (Anchorage trading entity) it is
   * configured to trade with. An account has at most one; the counterparty fields
   * are null until it is configured.
   */
  dvAllowableCounterparties: Array<DVAllowableCounterparty>;
  /** Get a single asset by ID */
  dvAsset: Maybe<DVAsset>;
  /** List assets with optional filtering */
  dvAssets: Array<DVAsset>;
  /**
   * Get Bitwise Position Statement CSV Report
   * Generates the position statement CSV in Bitwise's required format for the specified accounts.
   * This does NOT upload to SFTP - it returns the CSV content for download/comparison.
   */
  dvBitwisePositionStatement: DVFileDownload;
  /**
   * Get Bitwise Trade Recap CSV Report
   * Generates the trade recap CSV in Bitwise's required format for the specified accounts and time period.
   * This does NOT upload to SFTP - it returns the CSV content for download/comparison.
   */
  dvBitwiseTradeRecap: DVFileDownload;
  /** Get a single CSA by Account ID */
  dvCSA: Maybe<DVCSA>;
  /** List CSAs with optional filtering */
  dvCSAs: Array<DVCSA>;
  /** Whether the calling user may send, dequeue, or requeue client emails */
  dvCanSendClientEmails: Scalars['Boolean']['output'];
  /**
   * Lists otcderivativesreporting.client_emails rows matching the given
   * filter, newest first, paginated. Every field on the filter is optional
   * and independent - only the ones set narrow the results (an omitted
   * filter, or one with every field unset, returns every row).
   */
  dvClientEmail: DvClientEmailConnection;
  /** Distinct account IDs across client emails matching the filter (unpaginated) */
  dvClientEmailAccountIDs: Array<Scalars['ID']['output']>;
  /** Download a client email's attachments (e.g. the confirmation PDF) for preview */
  dvClientEmailAttachments: Array<DVFileDownload>;
  /** List client emails (trade confirmations) with filtering and cursor pagination */
  dvClientEmails: DVClientEmailConnection;
  dvCollateralRules: Array<DVCollateralRule>;
  /** List counterparty master copies with optional filtering by ids, LEIs, or legal names */
  dvCounterpartyMasterCopies: Array<DVCounterpartyMasterCopy>;
  /** Get a specific counterparty master copy by ID */
  dvCounterpartyMasterCopy: Maybe<DVCounterpartyMasterCopy>;
  /** List custodian wallets for the deposit/withdrawal dropdown, optionally scoped to one entity. */
  dvCustodianWallets: Array<DVCustodianWallet>;
  /** List every custodian, ordered by name, for the custodian dropdown. */
  dvCustodians: Array<DVCustodian>;
  /** The end of day recon confirmations dated fromDate through toDate, both inclusive, newest first. */
  dvEndOfDayRecons: Array<DVEndOfDayReconConfirmation>;
  /** List entities with optional filtering */
  dvEntities: Array<DVEntity>;
  /** Get a single entity by ID */
  dvEntity: Maybe<DVEntity>;
  dvFilterAccountCSAs: Array<DVCSA>;
  dvFilterAccountNettingSets: Array<DVNettingSet>;
  dvFilterCSAs: Array<DVCSA>;
  dvFilterNettingSetParams: Array<DVNettingSetParams>;
  /** Filter consolidated netting set rules by criteria */
  dvFilterNettingSetRules: Array<DVNettingSetRule>;
  /** Get a specific CSA margin terms by ID */
  dvGetCSAMarginTerms: Maybe<DVCSAMarginTerms>;
  /**
   * Get CSA margin terms effective at a specific point in time
   * This is critical for margin calculations to determine what terms applied at trade execution time.
   * Searches both current and historical records to find the terms that were in effect at the given timestamp.
   */
  dvGetCSAMarginTermsEffectiveAt: Maybe<DVCSAMarginTerms>;
  /**
   * Returns a client email attachment's generated file content, base64
   * encoded. Errors if the attachment doesn't exist or has a file format with
   * no mapped MIME type.
   */
  dvGetClientEmailAttachmentFile: DvFilePayload;
  /** Get a single collateral rule by ID */
  dvGetCollateralRule: Maybe<DVCollateralRule>;
  /**
   * Get collateral rule effective at a specific point in time
   * Returns exactly ONE record (not a list)
   * Checks main table first, then history table if not found
   */
  dvGetCollateralRuleEffectiveAt: Maybe<DVCollateralRule>;
  /** Get a specific netting set by ID */
  dvGetNettingSet: Maybe<DVNettingSet>;
  /**
   * Get netting set effective at a specific point in time
   * This is critical for determining which netting set was active at trade execution time.
   * Searches both current and historical records to find the netting set that was in effect at the given timestamp.
   * Returns exactly ONE record (not a list)
   */
  dvGetNettingSetEffectiveAt: Maybe<DVNettingSet>;
  /**
   * Returns a part45 submission's active report file, the one reportFormat
   * names, base64 encoded. A submission created before both formats were
   * stored returns its report.xml, before and after it is sent as TVNA.
   * The filename carries the report type, the format (TVNA for a
   * report.xml), the as-of date and, after the first attempt, the attempt
   * number, e.g. valu-cftc-2026-10-21.xml or valu-cftc-2026-10-21-attempt3.xml.
   * Errors if the submission doesn't exist or has no report generated yet
   * (no GCS object to read).
   */
  dvGetPart45SubmissionReportFile: DvFilePayload;
  /**
   * One CSV over a span of as-of dates: for each date, all rows of its newest
   * SUCCEEDED run on a governed parameter version. A date without one is
   * absent. Refused when the span is over 365 days or asOfFrom is after
   * asOfTo.
   */
  dvGetPfeRangeFile: DvFilePayload;
  /**
   * One run's rows at one grain as a CSV: a header, then a row per stored row
   * at every percentile the run priced. A run with no rows returns the header
   * only. Errors on an unknown run id.
   */
  dvGetPfeRunFile: DvFilePayload;
  /**
   * Returns a COMPLETE statement's generated file content, base64 encoded.
   * Errors if the statement doesn't exist or isn't COMPLETE yet (no file to
   * return).
   */
  dvGetStatementFile: DvFilePayload;
  /**
   * Lists otc.statements rows, optionally filtered, paginated. Every filter
   * field on the input is optional and independent - only the ones set
   * narrow the results (an omitted input, or one with every filter field
   * unset, returns every row).
   */
  dvGetStatements: DvStatementConnection;
  /** One VaR run as an xlsx workbook, one sheet per block. Errors on an unknown run id. */
  dvGetVarRunFile: DvFilePayload;
  /** List Haruko backfill requests with optional filtering by status or endpoint */
  dvHarukoBackfillRequests: DVHarukoBackfillRequestConnection;
  /**
   * List Haruko groups mirrored from Haruko. enabledOnly true returns enabled groups with no
   * removedAt; false or omitted returns every row.
   */
  dvHarukoGroups: Array<DVHarukoGroup>;
  /** List ICE SDR reporting status for a trade, one entry per reported version */
  dvICEReports: Array<DVICEReport>;
  /**
   * The report's submission snapshot parsed into ordered name/value fields, for a readable
   * review of report contents before Submit/Discard. Reflects the point-in-time snapshot.
   */
  dvIceReportDetails: Array<DVICEReportField>;
  /**
   * List ICE/SDR reports across trades for the reporting queue. Defaults to the QUEUED
   * reports awaiting manual submit when the filter / reviewStatuses is omitted.
   */
  dvIceReportQueue: Array<DVICEReport>;
  /** List ingest chat to account mappings, optionally restricted to one account */
  dvIngestChatAccounts: Array<DVIngestChatAccount>;
  /**
   * IM per account and asset from a margin run, with the run it was read from. This is the
   * run's dated reading; dvLedgerBalances carries the requirement as the trades stand now.
   */
  dvInitialMargin: DVInitialMarginResult;
  /**
   * List internal_movements entries (cross-custodian rebalancing transfers) with optional filtering
   * and cursor pagination. Recordkeeping only — these never appear in dvLedgerTransactions or affect
   * dvLedgerBalances.
   */
  dvInternalMovements: DVInternalMovementConnection;
  /**
   * The balance lines of one stored snapshot, ordered by account name, asset symbol, entity name,
   * then id. A failed snapshot has no lines. An unknown snapshotId is a "snapshot not found" error.
   */
  dvLedgerBalanceSnapshotLines: Array<DVLedgerBalanceSnapshotLine>;
  /**
   * List the stored hourly snapshots of dvLedgerBalances, newest scheduledAt first, with cursor
   * pagination. A failed hour is listed with its error rather than left out.
   */
  dvLedgerBalanceSnapshots: DVLedgerBalanceSnapshotConnection;
  /**
   * List derived balances — sums over otc.ledger_transactions, grouped by account/entity/asset,
   * each carrying the IM requirement booked on its (account, asset) trades. Under an asOf filter on
   * a past day every column is the margin run's for that day instead, see DVLedgerBalanceFilter.asOf. An (account, asset) with a
   * requirement and no entries behind it comes back with zero balances against the account's own
   * entity, so a requirement is never hidden for want of a ledger movement.
   */
  dvLedgerBalances: Array<DVLedgerBalance>;
  /** List ledger_transactions entries with optional filtering and cursor pagination */
  dvLedgerTransactions: DVLedgerTransactionConnection;
  /**
   * List CSA margin terms with optional filtering
   * Use filter.csaIds to list terms for specific CSAs
   */
  dvListCSAMarginTerms: Array<DVCSAMarginTerms>;
  /**
   * List CSA margin terms history with optional filtering
   * Use filter.marginTermsId to get history for a specific margin terms record
   * Use filter for advanced filtering by multiple IDs or CSA IDs
   */
  dvListCSAMarginTermsHistory: Array<DVCSAMarginTerms>;
  /**
   * List collateral rule audit history
   * Single API for all history listing/filtering needs:
   * - Use filter.ids to get history for specific collateral rule(s)
   * - Use filter.nettingSetIds to filter by netting set IDs
   */
  dvListCollateralRuleHistory: Array<DVCollateralRule>;
  /**
   * List collateral rules with optional filtering
   * Single API for all listing/filtering needs:
   * - No filter or empty filter: returns all collateral rules
   * - With filter: applies filtering criteria
   * - Lists collateral rules with optional filtering. When filter is null/empty, returns all rules.
   */
  dvListCollateralRules: Array<DVCollateralRule>;
  /**
   * List netting set audit history
   * Single API for all history listing/filtering needs:
   * - Use filter.ids to get history for specific netting set(s)
   * - Use filter.csaIds to filter by CSA IDs
   */
  dvListNettingSetHistory: Array<DVNettingSet>;
  /**
   * List netting sets with optional filtering
   * Single API for all listing/filtering needs
   * - No filter or empty filter: returns all netting sets
   * - With filter: applies filtering criteria
   */
  dvListNettingSets: Array<DVNettingSet>;
  /**
   * List timing rule audit history
   * Single API for all history listing/filtering needs:
   * - Use filter.ids to get history for specific timing rule(s)
   * - Use filter.csaIds to filter by CSA IDs
   */
  dvListTimingRuleHistory: Array<DVTimingRule>;
  /** List timing rules with optional filtering */
  dvListTimingRules: Array<DVTimingRule>;
  /** Get a single maker-checker request with its full vote trail. */
  dvMakerCheckerRequest: Maybe<DVMakerCheckerRequest>;
  /**
   * List maker-checker requests newest first with optional filtering and cursor pagination. Serves
   * every operational view: the pending-approvals queue (statuses: [PENDING]), approved awaiting
   * execution (statuses: [APPROVED]), and the cross-action audit history (e.g. statuses: [REJECTED]).
   */
  dvMakerCheckerRequests: DVMakerCheckerRequestConnection;
  /**
   * The margin requirement from a run, one row per CSA with its netting sets behind it. The
   * per-set rows carry each set's own numbers, so they do not sum to the rollup wherever the
   * CSA threshold bites.
   */
  dvMarginRequirements: DVMarginRequirementResult;
  /**
   * Margin run history, newest first — whether and when each daily run processed, the marks it read
   * and why it failed. The only margin read that returns a run other than a succeeded one, so it is
   * what tells ops that today's run is late rather than showing them yesterday's numbers. A run that
   * dies before it opens leaves no row, so a missing date reads as late.
   */
  dvMarginRuns: Array<DVMarginRunStatus>;
  dvNettingSetParams: Array<DVNettingSetParams>;
  /** List consolidated netting set rules for a netting set */
  dvNettingSetRules: Array<DVNettingSetRule>;
  dvNettingSets: Array<DVNettingSet>;
  /** One obligation with its breakdown. */
  dvObligation: Maybe<DVObligation>;
  /**
   * List settlement obligations with their per-netting-set breakdown. The blotter's queue is
   * statuses [OPEN] with ungrouped true; drop those to see history, since a call that went unpaid is what
   * an examiner asks about.
   */
  dvObligations: DVObligationConnection;
  /** Get a package by its identifier: the package-level info plus every trade booked under it */
  dvPackage: Maybe<DVPackage>;
  /**
   * A single otcderivativesreporting.part45_submissions row by id. Errors if
   * no submission with that id exists.
   */
  dvPart45Submission: DvPart45Submission;
  /**
   * Lists otcderivativesreporting.part45_submissions rows matching filter,
   * newest as_of_date first, paginated. Every field on filter is optional and
   * independent - only the ones set narrow the results (an omitted filter, or
   * one with every field unset, returns every row).
   */
  dvPart45Submissions: DvPart45SubmissionConnection;
  /**
   * PFE runs, newest as-of first and newest run first within a date. Defaults
   * to the newest 90 runs, 365 is the ceiling.
   */
  dvPfeRuns: Array<DvPfeRun>;
  /**
   * The trades behind a netting set's margin call, one row per (run, netting set, trade). A SKIPPED
   * position comes back with its reason rather than being filtered out, since a position that
   * contributed nothing is what this screen gets opened to find.
   */
  dvPositions: DVPositionResult;
  /** Get a single product by ID */
  dvProduct: Maybe<DVProduct>;
  /** List products with optional filtering */
  dvProducts: Array<DVProduct>;
  /** Get SDR report for a trade */
  dvSDRReport: DVFileDownload;
  /** One settlement with its attached ledger rows. */
  dvSettlement: Maybe<DVSettlement>;
  /**
   * What confirming an unsettled settlement would put on the ledger, for the settle modal to show before
   * confirm: the bucket moves, the wire to prefill, and the obligations to record by hand. Confirm works
   * the moves out again, so a balance that changes in between changes what it records.
   */
  dvSettlementLedgerPreview: DVSettlementLedgerPreview;
  /**
   * settlementId's ledger rows, each paired with the ledger transaction it references. Scoped to one
   * settlement by construction, unlike a field on DVSettlementMovement would be, so resolving every
   * pairing here is always cheap regardless of how many other settlements exist.
   */
  dvSettlementMovements: Array<DVSettlementMovementWithLedgerTransaction>;
  /** List settlements with the ledger rows attached to each. */
  dvSettlements: DVSettlementConnection;
  /**
   * Staged closeouts in any of the given statuses (all statuses when omitted), newest first, at most
   * 500. Each one lists the account's ACTIVE trades it can close.
   */
  dvStagedCloseouts: Array<DVStagedCloseout>;
  /**
   * Lists the per-account statement file settings, optionally for some accounts
   * only. A file with no setting is enabled, so only files someone has set are
   * returned.
   */
  dvStatementFileSettings: Array<DvStatementFileSetting>;
  /** Get a timing rule by ID */
  dvTimingRule: Maybe<DVTimingRule>;
  /** List timing rules for a specific CSA */
  dvTimingRules: Array<DVTimingRule>;
  /** Get a single trade by ID */
  dvTrade: Maybe<DVTrade>;
  /**
   * Get trade confirmation
   * It returns a base64 encoded string containing the trade confirmation PDF
   * the returned format is "application/pdf|$filename|$base64PDFData"
   */
  dvTradeConfirmation: Scalars['String']['output'];
  /** List all the life cycle event for a given trade */
  dvTradeLifeCycleEvents: DVTradeLifecycleEventConnection;
  /** List novations newest first, with optional filtering and cursor pagination */
  dvTradeNovations: DVTradeNovationConnection;
  /**
   * Get client-facing Trade Recap CSV.
   * This is the client-facing trade recap; for the A1 internal trade recap
   * see dvTradesRecapReport.
   * Generates a trade recap CSV for the specified accounts and datetime range.
   * Returns a single combined CSV sorted by trade timestamp then account ID.
   * endTime defaults to server now() when omitted.
   */
  dvTradeRecapCSV: DVFileDownload;
  /**
   * One run's report, line by line in report order, at most 20000 lines. Errors with
   * not found on a run id that is unknown or whose recon date is over 365 days ago.
   */
  dvTradeReconLines: Array<DvTradeReconLine>;
  /**
   * Runs of the daily trade recon, the job that reconciles the desk's chat confirms
   * against the booked trades. Newest run first. Defaults to the newest 30 runs whose
   * recon date is in the last 365 days; 365 runs is the ceiling.
   */
  dvTradeReconRuns: Array<DvTradeReconRun>;
  /**
   * List trades with optional filtering
   * @deprecated Use dvTradesConnection
   */
  dvTrades: Array<DVTrade>;
  /**
   * List trades newest first (createdAt, then id), with optional filtering and cursor pagination.
   * A page holds 500 trades unless first or last sets its size; at most 1000.
   */
  dvTradesConnection: DVTradeConnection;
  /**
   * Get A1 internal Trades Recap Report.
   * This is the internal (A1) trade recap used by staff; for the client-facing
   * trade recap see dvTradeRecapCSV.
   */
  dvTradesRecapReport: DVFileDownload;
  /** Every stored version of the model, newest first, active or not. */
  dvVarParameterVersions: Array<DvVarParameters>;
  /**
   * A governed parameter set of one model. With no argument, the set a run
   * would use now: the ACTIVE version, or the model's code default when no usable
   * active set can be resolved. asOfDate gives the set a run of that date resolved, at the
   * date's 16:00 New York valuation instant. version gives that stored version
   * with its current status, null when it is not stored. version and asOfDate
   * are alternatives, giving both is refused.
   */
  dvVarParameters: Maybe<DvVarParameters>;
  /**
   * One VaR run. Give id to read a named run - the one dvRunVar just started,
   * say. Otherwise the newest run of asOfDate, or of any date when that is
   * omitted too. Null when nothing matches.
   */
  dvVarRun: Maybe<DvVarRun>;
  /**
   * VaR runs, newest as-of first and newest run first within a date. Defaults
   * to the newest 90 runs, 365 is the ceiling.
   */
  dvVarRuns: Array<DvVarRun>;
  /**
   * enabledFeatures returns an array of enabled features for this user
   * @deprecated Client-facing features are deprecated. Use a LaunchDarkly feature flag to roll a feature out to every organization, or an organization module for a feature that organizations opt into.
   */
  enabledFeatures: Array<Feature>;
  /** Enrollment specific information */
  enrollment: Maybe<Enrollment>;
  /** Get enrollment entries with filtering by organization, status, and type */
  enrollmentEntries: EnrollmentEntriesConnection;
  /**
   * Returns a list of transactions under an entity account.
   * Returns a summary of the entries of each transaction grouped by account_id and balance_type
   */
  entityAccountTransactions: TransactionConnection;
  /** Returns a list of entity accounts */
  entityAccounts: EntityAccountConnection;
  /** Retuns an entity accounts' balances */
  entityAccountsBalances: EntityAccountBalancesConnection;
  /**
   * Returns all tags visible to the caller for the given entity.
   * Staff see all tag types; org users see only their own CLIENT tags.
   * Returns an empty list if the entity has no tags or does not exist.
   */
  entityTags: Array<TagResult>;
  /**
   * Returns all tags visible to the caller for the given entity, together with whether the
   * caller may edit them (see EntityTagsResult.canEditOperationTags).
   * Staff see all tag types; org users see only their own CLIENT tags.
   * Returns an empty list of tags if the entity has no tags or does not exist.
   */
  entityTagsResult: EntityTagsResult;
  /** Returns the list of all entity types */
  entityTypes: Maybe<Array<EntityType>>;
  exchangeAPIKeys: EEAPIKeyConnection;
  /** Get information about exchanges supported for external connectivity. */
  exchangeInfos: Array<EEInfo>;
  /** Export Wallet key PDF according to preference. */
  exportWalletKey: WalletKeyExportResult;
  /** Filter external account balances */
  externalAccountBalances: ExternalAccountBalanceConnection;
  /** Filter external account locations */
  externalAccountLocations: ExternalAccountLocationConnection;
  /** Filter organization balances on external accounts */
  externalAccountOrgBalances: ExternalAccountOrgBalanceConnection;
  /** Get list of valid external account transaction types */
  externalAccountTransactionTypes: Array<ExternalAccountTransactionType>;
  /** Filter external account transactions */
  externalAccountTransactions: ExternalAccountTransactionConnection;
  /** Filter external accounts */
  externalAccounts: ExternalAccountConnection;
  /**
   * Get the user's external connectivity profile.
   * This includes connected exchange accounts and balances.
   *
   * Optionally provide an assettype ID to filter exchange balances based off the asset type.
   */
  externalConnectivityUserInfo: ECUser;
  externalScreeningRequests: ExternalScreeningRequestConnection;
  /**
   * Extracts prefill values for the Define Fees wizard from an uploaded agreement PDF, for review
   * before submitting through feeAgreementCreate. Returns an error if agreementObjectId can't be
   * read from storage, feeTypeIdentifiers is empty, or a feeTypeIdentifier isn't registered.
   * agreementPrefill is null when AI extraction is unavailable in this environment; warnings then
   * explains why. Otherwise, warnings flags anything - an unrecognised asset, an ambiguous or
   * missing default fee group, an implausible rate or date, a client-name mismatch - worth a
   * second look before submitting, without blocking the prefill itself.
   */
  extractAgreementPrefill: AgreementPrefillPayload;
  /** Returns the fee-type registry, optionally filtered */
  feeTypes: Array<FeeType>;
  /**
   * Paginated list of fee agreement versions matching the given filters.
   * STAFF-only Backoffice view; use AccountV2.feesAgreements for the per-TLA view.
   * serviceFeeTerms is the legacy per-service-type equivalent.
   */
  feesAgreements: FeesAgreementConnection;
  /** Fetches a Signed Withdrawal Authorization for a Program Customer within an RIA */
  fetchSignedDocusignForWithdrawal: DocusignSignedDocument;
  /** Get FIAT Trusted Destination */
  fiatTrustedDestination: FiatTrustedDestination;
  /**
   * Get FIAT Trusted Destinations
   * @deprecated Use paginatedFiatTrustedDestinations
   */
  fiatTrustedDestinations: Array<FiatTrustedDestination>;
  /** Fetches a Signed URL for a Signed Withdrawal Authorization for a Program Customer within an RIA */
  fiatWithdrawalSignedDocusignURLs: Array<Scalars['String']['output']>;
  /** filteredOrganizations is a paginated, filterable list of all organizations that exist */
  filteredOrganizations: OrganizationsDB;
  /**
   * Retrieves a single control agreement by its unique identifier.
   * Returns an error if the control agreement does not exist.
   */
  gdfControlAgreementByID: GDFControlAgreement;
  /** List control agreements */
  gdfControlAgreements: GDFControlAgreementConnection;
  /** List gdf enrollements */
  gdfEnrollements: GDFEnrollementConnection;
  /** List OES agreements */
  gdfOESAgreements: GDFControlAgreementConnection;
  /**
   * The Exchange Display Names of up to 100 exchanges, for traders choosing one. Leaves out
   * exchanges without a display name, which traders see under their participant name. Available
   * to any authenticated user.
   */
  gdfOESExchangeDisplayNames: Array<GDFOESExchangeDisplayName>;
  /**
   * List OES exchange profile versions, newest first, optionally for one exchange. With
   * filterCurrentOnly, only the current (highest) version of each exchange is returned, so a page
   * grows with the number of exchanges rather than the number of saves. Staff only.
   */
  gdfOESExchangeProfileList: GDFOESExchangeProfileConnection;
  /**
   * The current OES terms for an exchange, shown to traders when requesting a relationship and
   * when reviewing a pledge. Available to any authenticated user. Not found when the exchange
   * has no terms profile.
   */
  gdfOESExchangeTerms: GDFOESExchangeTerms;
  /**
   * The exchanges among up to 100 given ones that have an OES exchange profile, for traders
   * choosing an exchange to connect. Exchanges without a profile and unknown IDs are left out.
   * exchangeDisplayName is null when the current profile has none. Available to any authenticated
   * user.
   */
  gdfOESExchangesWithProfile: Array<GDFOESExchangeWithProfile>;
  /** Generates an account statement PDF */
  generateAccountStatementPdf: AccountStatementPdf;
  /** Generates white label OTP code */
  generateWhiteLabelOTP: Scalars['String']['output'];
  /** getAddressStatus is used for querying status of address */
  getAddressDebugStatus: Scalars['String']['output'];
  /** Gets the public key of the given AddressID. */
  getAddressPublicKey: Scalars['String']['output'];
  /** Get the addresses that have been generated for given org. */
  getAddressesReportCSV: Scalars['String']['output'];
  /** Returns a list of DApps and all available filter options (categories). */
  getAllDAppEntries: GetAllDAppEntriesResponse;
  /**
   * Gets all the latest-version disclosure documents.
   * Will only fetch the last version of each document
   */
  getAllLatestLegalterms: Array<Legalterm>;
  /**
   * Returns the allowed ERC20 spender contracts for a given asset type.
   * Returns an empty list if the asset type has no allowed spenders.
   */
  getAllowedERC20Spenders: Array<ERC20ApprovedSpender>;
  /**
   * Returns a single allowlisted validator by asset type and address, or null if it isn't allowlisted.
   * Exposes the internal allowlisting policy that AllowlistedValidatorPublicInfo redacts; STAFF-only
   * for that reason.
   */
  getAllowlistedValidator: Maybe<AllowlistedValidator>;
  /**
   * Returns every validator allowlisted for the given asset type, regardless of org scoping.
   * Empty if none are allowlisted. Exposes the internal allowlisting policy that
   * AllowlistedValidatorPublicInfo redacts; STAFF-only for that reason.
   */
  getAllowlistedValidatorsByAssetTypeID: Array<AllowlistedValidator>;
  /**
   * Returns the validators the given organization is permitted to stake to for an asset type
   * (those applying to all organizations plus those scoped to it). Empty if none.
   */
  getAllowlistedValidatorsByAssetTypeIDAndOrg: Array<AllowlistedValidatorPublicInfo>;
  /** Returns the list of all REST API keys, with optional filters */
  getApiKeys: Array<APIKey>;
  /** Get list of approved countries for fiat transactions */
  getApprovedCountries: Array<ApprovedCountry>;
  /**
   * Returns audit log entries for a specific asset type showing historical changes.
   * Entries cover both the asset type itself and its asset-enablement records —
   * when and by whom the asset was enabled or disabled (globally, per entity type,
   * or per organization) — distinguished by the auditType field on each entry.
   * This allows backoffice staff to track when and how assets were modified.
   */
  getAssetAuditLog: Array<AssetAuditLogEntry>;
  /** getAssetTypesEnabledForOrg get the enabled asset types for an org */
  getAssetTypesEnabledForOrg: Array<Scalars['AssetTypeID']['output']>;
  /** List of enablement information for all supported asset types */
  getAssetsEnablementInfo: Array<AssetEnablementInfo>;
  /**
   * Returns the stored balance discrepancies as CSV. It does not run an audit.
   *
   * - **Freshness varies by asset.** Each asset's rows come from the last audit that
   *   covered it. Check the `UpdatedAt` column.
   * - **`assetTypeID`** limits the rows to that asset.
   * - **To refresh**, call `runAuditReport`. It runs in the background, so new rows
   *   appear only after it finishes.
   */
  getAuditReport: Scalars['String']['output'];
  /** Get the bank information associated with a Financial Institution ID */
  getBankDirectoryEntry: BankDirectoryEntry;
  /** Gets CRR history for a given affiliate */
  getCRRHistory: CRRHistoryConnection;
  /** Gets CRR history CSV for a given affiliate */
  getCRRHistoryCSV: Scalars['String']['output'];
  /** Get current CRR parameters in the CRR configuration */
  getCRRRiskConfigs: CRRRiskConfigs;
  /** Gets CRR section values history for a given affiliate */
  getCRRSectionHistory: Array<CRRSectionHistoryPoint>;
  /** Returns coinductor automation policies for the calling org, optionally filtered by status. */
  getCoinductorAutomationPolicies: CoinductorAutomationPolicies;
  /** Counted runs per UTC day for one policy over [since, until), ascending; days without a run are omitted. Uses the same counted-status rule as stats.totalRuns, so the two agree for a policy whose whole history lies inside the window. */
  getCoinductorAutomationPolicyActivity: Array<CoinductorDailyRunCount>;
  /** Returns coinductor automation runs for the calling org, ordered by createdAt descending. */
  getCoinductorAutomationRuns: CoinductorAutomationRuns;
  /** Returns a paginated list of DApp entries with filtering and sorting. */
  getDAppEntries: DAppEntryConnection;
  /** Returns a single DApp entry by ID. */
  getDAppEntry: DAppEntry;
  /** Gets the total number of deposit attributions */
  getDepositAttributionsCount: Scalars['Int']['output'];
  /** getETHStakingProviderForVault gets the preferred eth staking provider for an org */
  getETHStakingProviderForVault: ETHStakingProviderType;
  /** getEnabledAssets gets the current enabled assets system wide */
  getEnabledAssets: Array<Scalars['AssetTypeID']['output']>;
  /** Returns a list of allowed stablecoins for an organization. */
  getEnabledStablecoins: EnabledStablecoins;
  /** Returns a list of allowed stablecoins for an organization. */
  getEnabledStablecoinsV2: EnabledStablecoinsV2;
  /** Returns a list of allowed stablecoins for an organization, including underlying asset and max amount. */
  getEnabledStablecoinsV3: EnabledStablecoinsV3;
  /** Get organization staking configurations of all staking providers */
  getEthereumStakingProvidersConfigurationForOrg: EthereumStakingProvidersConfiguration;
  /** getEthereumStakingValidatorsForOrg gets all the staking validators (used and unused) for an organization */
  getEthereumStakingValidatorsForOrg: EthereumStakingValidatorData;
  /** Get the list of withdrawal purposes */
  getFiatWithdrawalPurposes: Array<FiatWithdrawalPurpose>;
  /**
   * Return a CSV of the asset prices at a particular hour for given asset types, or if no asset types provided then for all asset types
   * Used for one specific client:
   * https://www.notion.so/anchorage/Asset-Prices-For-Bain-Capital-1f310566f0904097a3f99843014ed94c
   */
  getHourlyAssetTypePrices: Scalars['String']['output'];
  /** Returns the history of issue/redeem operations. */
  getIssueRedeemHistory: IssueRedeemHistory;
  /**
   * The tokenized assets the calling org is the issuer of, for the ClientDashboard
   * Tokenization page.
   */
  getIssuerTokenizationAssets: GetIssuerTokenizationAssetsPayload;
  /** Gets all legal term acceptances that can be filtered by accountID (optional) */
  getLegalTermAcceptances: Array<LegalTermAcceptance>;
  /** Gets all legal term acceptances that can be filtered by top level accountID (optional) */
  getLegalTermAcceptancesV2: Array<LegalTermAcceptance>;
  /** Get the list of movement of funds */
  getMovementOfFunds: Array<MovementOfFunds>;
  /**
   * Returns the stored balance discrepancies, with every balance source (OperationsDB,
   * Blockchain, UBB) for each one. It does not run an audit.
   *
   * - **Freshness varies by asset.** Each asset's rows come from the last audit that
   *   covered it. Check each discrepancy's `updatedAt`.
   * - **`assetTypeID`** limits the results to that asset.
   * - **To refresh**, call `runAuditReport`. It runs in the background, so new results
   *   appear only after it finishes.
   */
  getMultiBalanceSourceAuditReport: BalanceDiscrepancyReport;
  /** Retrieve an attachment content by ID */
  getOrderNotificationAttachment: Maybe<AttachmentContent>;
  /** Retrieve a list of Order notification by order ID */
  getOrderNotifications: Array<OrderNotification>;
  /** getOrgACHDebitInSettings returns the org's ACH Debit In settings, or null when none are set. */
  getOrgACHDebitInSettings: Maybe<OrgACHDebitInSettings>;
  /**
   * getOrgGasConfig returns given org's config which contains such info as:
   * - ETH base-fee multiplier (aka BaseFeePerGasMultiplier; FeeReservationLevel)
   * - ERC20 GasLimitMultiplierForSmartContract
   */
  getOrgGasConfig: Maybe<OrgGasConfig>;
  /** Get the current access policy values for a given organization. Currently, only web session expiry is implemented, but this should include source IP requirements in the future. */
  getOrganizationAccessPolicy: OrganizationAccessPolicy;
  /** Gets the result of the Persons data quality checks of a given run. */
  getPersonDataQualityChecksResult: PersonDataQualityChecksResult;
  /**
   * Gets the price symbol conversions for specified assets and/or sources.
   * If no asset or source is specified, all conversions are returned.
   */
  getPriceSymbolConversions: Array<PriceSymbolConversion>;
  /** Returns the raw JSON payload for the given operationID */
  getRawOperation: Scalars['String']['output'];
  /** getScanProgress gets the scan progress data for a specified asset */
  getScanProgress: ScanProgress;
  /** Gets a list of subscribers for a scheduled report */
  getScheduledReportSubscribersByScheduledReportID: Array<ScheduledReportSubscriber>;
  /** Gets the scheduled reports of organizations the user can access */
  getScheduledReports: Array<ScheduledReport>;
  /** Returns the groups a given staff member belongs to. */
  getStaffGroups: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the members of a given staff permission group. */
  getStaffPermissionMembers: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Returns the commingled-funds Wallet for an Organization's Subaccounts on the
   * given network. Returns null when there is no commingled wallet for the network
   * (e.g. Flow networks, which are short-circuited and never have one).
   */
  getSubaccountOrganizationCommingledWallet: Maybe<Wallet>;
  /** Gets the value set with setTalosCustomer. */
  getTalosCustomer: Scalars['String']['output'];
  /** Get price data for the given asset and timestamp. */
  getTimestampedPriceInfo: PriceAttestationData;
  /**
   * The total-supply history of a tokenized asset the calling org is the issuer of, for the
   * ClientDashboard Tokenization asset page chart.
   */
  getTokenizationAssetSupplyHistory: TokenizationAssetSupplyHistoryPayload;
  /**
   * The total supply (net minted) of a tokenized asset the calling org is the issuer of, for the
   * ClientDashboard Tokenization asset page.
   */
  getTokenizationAssetTotalSupply: TokenizationAssetTotalSupplyPayload;
  /**
   * Returns the custody operation ID for a single tokenization operation, once it exists. The
   * custody operation is created asynchronously by the tokenization workflow, so callers should
   * poll this while tokenizationStatus is PENDING and stop once custodyOperationID is non-null
   * (open the endorsement flow) or tokenizationStatus is ERROR (the workflow can fail before ever
   * creating a custody operation, in which case custodyOperationID never becomes non-null).
   */
  getTokenizationCustodyOperationID: TokenizationCustodyOperationIDPayload;
  /** Returns the calling organization's tokenization mint/burn history, newest first. */
  getTokenizationHistory: TokenizationHistory;
  /** Returns an organization's list of email recipients to be notified for trading-related communications. */
  getTradingEmailRecipients: Array<Scalars['String']['output']>;
  /** Gets Transaction count by destination country for a given organization */
  getTransactionByDestCountry: Array<AggregatedByCountryTransaction>;
  /** Gets Transaction Volume history for a given organization */
  getTransactionVolumeHistory: Array<AggregatedTransactionVolume>;
  /** Returns a single account transfer by ID. */
  getTransfer: Transfer;
  /**
   * Return a csv report of all trusted destinations, for either given org or all orgs.
   * In either case, only the kind of orgs user has access to would be included:
   *   - ADx
   *   - Porto (aka SELF)
   *   - etc.
   */
  getTrustedDestinationsReportCSV: Scalars['String']['output'];
  /**
   * Return a csv report of all trusted smart contracts, for either given org or all orgs.
   * In either case, only the kind of orgs user has access to would be included:
   *   - ADx
   *   - Porto (aka SELF)
   *   - etc.
   */
  getTrustedSmartContractsReportCSV: Scalars['String']['output'];
  /**
   * Gets the trusted sources
   * @deprecated Use trustedSources instead
   */
  getTrustedSources: TrustedSourceConnection;
  /**
   * Returns a JSON string with all public keys and their user IDs for the specified organization.
   * If orgKeyID is omitted, returns data for all organizations.
   */
  getUserIDsForHSM: Scalars['String']['output'];
  /** Gets personal identifiable information for a given user */
  getUserPII: Maybe<Array<PIIValue>>;
  /** getValidatorAssignmentsReport returns a csv report of all the validator assignments for the asset between the two days */
  getValidatorAssignmentsReport: Scalars['String']['output'];
  /** Get vesting info for an asset */
  getVestingInfo: Maybe<VestingInfo>;
  /**
   * Get all active connections for the User.
   * @deprecated Use getWalletConnectSessionsWithPagination instead
   */
  getWalletConnectSessions: Array<WalletConnectSession>;
  /**
   * Get all active connections for the Org.
   * @deprecated Use getWalletConnectSessionsForOrgWithPagination instead
   */
  getWalletConnectSessionsForOrg: Array<WalletConnectSession>;
  /** Get all active connections for the Org. */
  getWalletConnectSessionsForOrgWithPagination: WalletConnectSessionConnection;
  /** Get WalletConnect sessions (aka connections). */
  getWalletConnectSessionsWithPagination: WalletConnectSessionConnection;
  /** List of the global trusted sources */
  globalTrustedSources: GlobalTrustedSourceConnection;
  /** Returns wether there is a pending review for the default staking fee terms */
  hasDefaultStakingFeeTermsPendingReview: Scalars['Boolean']['output'];
  /** Checks if a certain user has access to deposit attribution actions */
  hasManualDepositAttributionAccess: Scalars['Boolean']['output'];
  /** Placeholder */
  helloWorld: Scalars['String']['output'];
  /** Hello world, settlementengine */
  helloWorldSettlementEngine: Scalars['String']['output'];
  iamPermissions: IAMPermissionConnection;
  /** List inbound TRUST Travel Rule records (TTRM Toolbox). */
  inboundTravelRule: Array<InboundTravelRule>;
  /** Returns a specific institutional affiliate */
  institutionalAffiliate: InstitutionalAffiliate;
  /** Returns all institutional affiliates */
  institutionalAffiliates: InstitutionalAffiliateConnection;
  /** Base resolver for all institutional audit csv exports */
  institutionalAuditCSVExports: InstitutionalAuditCSVExports;
  /** Returns a specific institutional client */
  institutionalClient: InstitutionalClient;
  /**
   * Returns all institutional clients
   * @deprecated Use institutionalClientsFiltered instead.
   */
  institutionalClients: Array<InstitutionalClient>;
  /** Returns filtered institutional clients */
  institutionalClientsFiltered: InstitutionalClientConnection;
  /** Returns all institutional individuals */
  institutionalIndividuals: InstitutionalIndividualConnection;
  /** Returns an invoice by its ID */
  invoice: Maybe<Invoice>;
  /** Returns invoices based on the filters */
  invoices: Maybe<InvoiceConnection>;
  /**
   * Returns if a given feature is enabled for the given organization
   * @deprecated Client-facing features are deprecated. Use a LaunchDarkly feature flag to roll a feature out to every organization, or an organization module for a feature that organizations opt into.
   */
  isFeatureEnabled: Scalars['Boolean']['output'];
  kyc: Maybe<KYC>;
  /**
   * Resolve answers for a submission from an external data-lookup source.
   * Read-only: answers are persisted through the regular save flow.
   */
  kycDataLookup: KYCDataLookupResponse;
  /** Get KYCQuestionnaireSubmission by ID query. */
  kycQuestionnaireSubmissionById: Maybe<KYCQuestionnaireSubmission>;
  /** Returns the most recently created Cost Basis Job for an organization. */
  latestCostBasisJob: Maybe<CostBasisJob>;
  /** Returns a list of all transactions */
  ledgerTransactions: TransactionConnection;
  /**
   * Gets paginated legal term acceptances for a specific legal term.
   * Can optionally filter by accountID.
   */
  legalTermAcceptances: LegalTermAcceptanceConnection;
  /**
   * Gets paginated latest-version legal terms with optional filters.
   * Returns all latest legal terms (or filtered by IDs/screen) with pagination support.
   */
  legalTerms: LegalTermConnection;
  /**
   * Returns all supported asset tag definitions.
   * Tags represent immutable characteristics of assets (e.g., STABLE, REBASING).
   */
  listAssetTags: Array<AssetTagDefinition>;
  /** Returns all dispatch methods registered for a given custodian. */
  listCustodianDispatchMethods: Array<CustodianDispatchMethod>;
  /** Returns a paginated list of custodians registered in the system for account transfers. */
  listCustodians: CustodianConnection;
  /** Returns a paginated list of DocuSign workflow configurations. */
  listDocuSignWorkflows: DocuSignWorkflowConnection;
  /** Returns a paginated list of micro deposits, optionally filtered by subaccount IDs or statuses. */
  listMicroDeposits: MicroDepositConnection;
  /** Returns a paginated list of request documents for a given transfer. */
  listRequestDocuments: RequestDocumentConnection;
  /**
   * Returns all tags with their associated asset type IDs.
   * This shows which assets are tagged with which characteristics.
   */
  listTagsWithAssetTypeIDs: Array<TagWithAssetTypes>;
  /** Returns a paginated list of transfer events, optionally filtered by transfer ID. */
  listTransferEvents: TransferEventConnection;
  /** Returns a paginated list of account transfers, optionally filtered by subaccount IDs or transfer statuses. */
  listTransfers: TransferConnection;
  /** marketingWidgets query returns all the marketing widgets for a given display page */
  marketingWidgets: Array<MarketingWidget>;
  /** List of information for all native supported asset types */
  nativeAssetTypeInfos: Array<AssetTypeInfo>;
  /** Returns the invoice line item types configured in NetSuite */
  netsuiteInvoiceItemTypes: Array<NetsuiteInvoiceItemType>;
  /** Returns all degraded or non-degraded network statuses */
  networkStatuses: Array<NetworkStatus>;
  /**
   * Returns the list of networks that support walletconnect in the current environment.
   * Deprecated as it is misnomer, use networksSupportingWalletConnect instead.
   * @deprecated use networksSupportingWalletConnect instead
   */
  networksSupportingSmartContract: Maybe<Array<NetworkInfo>>;
  /** Returns the list of networks that support walletconnect in the current environment. */
  networksSupportingWalletConnect: Maybe<Array<NetworkInfo>>;
  notificationGraphQLStatus: Scalars['String']['output'];
  nxtCounterpartyAccounts: NxtCounterpartyAccountPage;
  nxtHealth: Scalars['Boolean']['output'];
  nxtTfcCycle: Maybe<NxtTfcCycle>;
  nxtTfcCycleSummary: NxtTfcCycleSummary;
  nxtTfcCycles: NxtTfcCycleConnection;
  nxtTrades: NxtTradePage;
  /** operation gets an operation by its id */
  operation: Maybe<Operation>;
  /**
   * Get the list of operations in this organization
   * first and after implement the connections spec
   */
  operations: OperationConnection;
  /** Fetch a single ops exception (detail pane). Null when not found. */
  opsException: Maybe<OpsException>;
  /** Event/audit timeline for one ops exception, chronological. */
  opsExceptionHistory: Array<OpsExceptionEvent>;
  /** List ops exceptions for the dashboard table, filtered + cursor-paginated. */
  opsExceptions: OpsExceptionConnection;
  /** Returns order state transitions for a specified order */
  orderHistory: Array<OrderState>;
  /**
   * organization by id and optional generation.
   * Id is the organization public key ID, and generation is organization generation
   */
  organization: Organization;
  /** Returns the total balances (of all subaccounts or for subaccounts of a given type) of various organizations */
  organizationBalances: OrganizationBalanceConnection;
  /** Returns the delta in balances for various organizations between two points in time */
  organizationBalancesDelta: OrganizationBalanceConnection;
  /** Returns a list of blockchain assets for an organization */
  organizationBlockchainAssets: Maybe<Array<BlockchainAsset>>;
  organizationForPurposeKeyID: Scalars['ID']['output'];
  organizationModules: OrganizationModuleConnection;
  /**
   * Notes for the given organization, if any exist. Organization notes are a
   * single freetext field per organization.
   */
  organizationNotes: Maybe<OrganizationNotes>;
  /** organizationStatements returns all statements for an organization */
  organizationStatements: Array<Statement>;
  /** Returns a list of subaccounts for a list of organizations */
  organizationSubaccounts: OrganizationSubaccountConnection;
  /** organizations is the list of organizations that exist */
  organizations: Array<Organization>;
  /**
   * Lists the organizations currently holding the given asset with each org's balance, USD
   * value, and share of total AUC, ordered by balance descending. Paginated via the standard
   * Relay connection arguments (first/after, last/before); cursors are opaque.
   */
  organizationsHoldingAsset: OrgAssetHoldingConnection;
  /** Return a csv report of all organizations along with metadata */
  organizationsReport: Scalars['String']['output'];
  /**
   * Returns true when the otcderivativesreporting subgraph is healthy.
   * TODO: Remove this once real queries are added. This is boilerplate for the initial subgraph bootstrap.
   */
  otcDerivativesReportingHealth: Scalars['Boolean']['output'];
  /** List outbound Travel Rule records (TTRM Toolbox). */
  outboundTravelRule: Array<OutboundTravelRule>;
  /** Returns the outstanding trading positions for the requesting organization */
  outstandingTradingPositions: Array<TradingPosition>;
  /** Returns the list of outstanding trading positions for the specified organization */
  outstandingTradingPositionsRisk: Array<TradingPosition>;
  /** Get FIAT Trusted Destination(s) Paginated */
  paginatedFiatTrustedDestinations: FiatTrustedDestinationConnection;
  /**
   * What adding this person to the affiliate would do. The only stored PII it
   * returns is nameOnFile, and only when the name given doesn't match it and the
   * caller may see sensitive data.
   */
  participatingMemberAddCandidate: ParticipatingMemberAddCandidate;
  /** Whether any staff member can add participating members to this affiliate. */
  participatingMemberAddEnabled: Scalars['Boolean']['output'];
  /** persons is the list of all persons Anchorage knows about */
  persons: PersonConnection;
  /**
   * Returns a paginated list of all policies (FragmentBindings) configurable
   * by an OperationAction pair, for a resource.
   * Only a subset of actions allows manipulating affected policies (e.g. VAULT_POLICY_CHANGE)
   * If the action creates a new resource, a template of the affected policies is returned.
   * First element represents the default policy of the resource.
   *
   * In the first iteration pagination is not implemented.
   */
  policyFragmentsAffected: PolicyFragmentConnection;
  /**
   * Returns a paginated list of all the enforced policies (FragmentBindings), for a resource.
   * Policies may be filtered by a Operation action pair (actions and subactions).
   * SubActions are used to distinguish between OneOffs with the same action.
   * @deprecated Use iam.permissions
   */
  policyFragmentsEnforced: PolicyFragmentConnection;
  /**
   * Portfolio returns an organization-level summary of current holdings
   * Set the optional filterAssetTypeIDs to restrict the holdings list (amounts) to just these AssetTypeIDs.
   * Set debug to true to enable more logging.
   * @deprecated Use Organization.portfolio
   */
  portfolio: Portfolio;
  possibleDefaultAction: PolicyAction;
  /**
   * Outcomes valid for the given action and draft conditions. Called as the
   * draft changes in the rule editor.
   */
  possibleOutcomes: PossibleOutcomes;
  possibleSpecificActions: PolicyActionConnection;
  /**
   * Asks a pricing source whether it prices vendorSymbol against USD right now.
   * The answer depends only on vendorSymbol and source. fromAsset is logged, not sent.
   */
  priceSourceAvailability: PriceSourceAvailability;
  /** Get info on product updates */
  productUpdates: ProductUpdates;
  /** Returns program customers with cursor-based pagination and filtering */
  programCustomers: ProgramCustomerConnection;
  /** questionnaireByName returns the active questionnaire for the name provided */
  questionnaireByName: Questionnaire;
  quorumLivenessGraphQLStatus: Scalars['String']['output'];
  reportFileValidations: ReportFileValidationConnection;
  reportFileVerifications: ReportFileVerificationConnection;
  /** Get the available values for a specific filter field in a report type. */
  reportFilterAvailableValues: Array<Maybe<ReportFilterConfigValue>>;
  reportSchedules: ReportScheduleConnection;
  /**
   * Get the configuration (available filters) for a specific report type.
   * This can be called by staff users who must provide an organization ID.
   */
  reportTypeConfig: ReportTypeConfig;
  reportTypeDefinitions: ReportTypeDefinitionConnection;
  /**
   * Get a list of available report types.
   * This can be called by staff users who must provide an organization ID.
   */
  reportTypes: Array<Maybe<ReportType>>;
  reports: ReportConnection;
  /**
   * Returns reserves snapshots for a stablecoin, ordered by createdAt descending (cursor on
   * lastCreatedAt). Pagination params are consistent with GetReservesHistoryRequest in
   * mintburn.proto for the gRPC endpoint.
   */
  reservesHistory: ReservesHistory;
  /** The freeze and unfreeze events of the vault, or of one wallet plus its vault, newest first. */
  restrictionHistory: RestrictionEventConnection;
  /** The restrictions of the vault and of its wallets, newest first. */
  restrictions: RestrictionRecordConnection;
  /** The restrictions of at most 100 wallets, newest first. */
  restrictionsByWallets: Array<RestrictionRecord>;
  restrictionsGraphqlHealth: Scalars['Boolean']['output'];
  /**
   * Reveal the full account number of a wire FIAT Trusted Destination, which every other field
   * returns masked. Org users with permission to view or to add trusted
   * destinations only.
   */
  revealFiatTrustedDestinationAccountNumber: Scalars['String']['output'];
  /** Returns RIA accrued fees for the given filters */
  riaAccruedFees: FeeCalculationConnection;
  /** Returns RIA fee configurations for the given filters */
  riaFeeConfigurations: FeeConfigConnection;
  /** Returns a list of RIA organizations */
  riaOrganizations: OrganizationConnection;
  /** Shows detailed information on risk requirements for this operation */
  riskReviewRequirements: Maybe<RiskReviewRequirements>;
  /** Returns list of trades for the risk dashboard */
  riskTradesView: TradesView;
  /** Returns the list of approval groups the current risk user is in */
  riskUserApprovalGroups: Array<RiskApprovalGroupType>;
  /** Returns the list of groups the current risk user is in */
  riskUserGroups: Array<Scalars['String']['output']>;
  riskreviewGraphqlHealth: Scalars['Boolean']['output'];
  /** scanEdgeNode performs a manual scan of the edge node fromthe beginning of time for a given address */
  scanEdgeNode: Scalars['Boolean']['output'];
  /** scanNodeHealth returns a sequence number representing the forward progess of the edge node for a given asset. */
  scanNodeHealth: Scalars['String']['output'];
  /**
   * scanPreTransaction simulates and risk-scans a transaction from one of the caller's wallets before any operation exists.
   * Advisory: it creates and persists nothing. Internal failures come back as UNAVAILABLE, not as errors.
   */
  scanPreTransaction: PreTransactionScan;
  /**
   * get scanning issues
   *
   * Once a network's scanning issues are served by its own cohort scanner, they are only
   * reachable by filtering on that network: routing is header-based, so a query with no
   * networkID cannot fan out and returns the monolith's issues alone. Pass networkID to see
   * a cohort's issues.
   */
  scanningIssues: Array<ScanningIssue>;
  /** List organizations pending shared policies migration (SCHEDULED or READY). */
  scheduledSharedPoliciesMigrations: Array<ScheduledOrganizationMigration>;
  seLocationConnection: SELocationConnection;
  /**
   * Reconcile transfers against the ledger to verify balance consistency.
   * Compares the final state in the ledger with expected state from transfer data.
   */
  seReconcileTransfers: SEReconciliationResult;
  seTransferConnection: SETransferConnection;
  /**
   * Returns entities of the given type that carry ANY of the specified tag names (OR semantics).
   * Tag scope (type and org) is derived from the authenticated actor: staff see BACKOFFICE tags;
   * org users see CLIENT tags scoped to their own org.
   * Supports forward cursor pagination via first and after arguments.
   */
  searchOperationsByTagName: TaggedEntityConnection;
  /**
   * Returns paginated tags matching the given type(s) and optional org scope.
   * Provide either `tagType` or `tagTypes`; if both are omitted,
   * staff callers receive a validation error, while org users are always
   * scoped to CLIENT tags regardless of what is passed.
   * Default order is alphabetical by name ascending (ties broken by most recently created).
   * Pass sortField/sortOrder to choose a different ordering; cursors are sort-aware and
   * remain stable only while sortField and sortOrder are unchanged.
   * Staff can search any tag type; org users may only search CLIENT tags scoped to their own org.
   * Use first/after for cursor-based pagination (default page size 20, max 100).
   * Pass searchTerm to filter to tags whose name contains the term (case-insensitive);
   * changing searchTerm mid-pagination invalidates an existing cursor, so restart from
   * the first page (omit after) whenever searchTerm changes.
   */
  searchTags: TagResultConnection;
  /** Returns service fee terms after applying filters */
  serviceFeeTerms: Maybe<ServiceFeeTermsConnection>;
  /** Returns the most recent settlement instructions record for the given organization. */
  settlementInstructions: Scalars['String']['output'];
  /** Returns the list of settlements */
  settlementViewClient: SettlementView;
  /** Returns the list of settlements */
  settlementViewRisk: SettlementView;
  /**
   * Gets a signed URL to download documents related
   * to compliance alerts
   */
  signedURLToDownloadDocsForComplianceAlerts: Scalars['String']['output'];
  /** smartContractABI resolves a contract's ABI on a network into its write functions. */
  smartContractABI: SmartContractABI;
  /**
   * Returns the list of assets that can be used in settlements between two given participants.
   * For an asset to be usable, the custodians for the two participants must support the asset and the transfer API must support the asset. More restrictions can be added in the future.
   */
  snAssets: Array<AssetTypeInfo>;
  /** Get a settlement network participant by ID. Anyone with knowledge of the ID can learn at least the participant's name and custodian. */
  snParticipantByID: SNParticipant;
  /**
   * Sorted and paginated list of participants.
   * Sorted from most recent to least recent by creation time by default.
   */
  snParticipants: SNParticipantConnection;
  /** Get a settlement network settlement by ID. */
  snSettlementByID: SNTwoWaySettlement;
  /**
   * Filtered, sorted and paginated list of settlements.
   * Sorted from most recent to least recent by creation time by default.
   */
  snSettlements: SNTwoWaySettlementConnection;
  /**
   * Filtered, sorted and paginated list of counterparties.
   * Sorted from most recent to least recent by creation time by default.
   */
  snTrustedCounterparties: SNCounterpartyConnection;
  /** Returns all completed transactions between two nanosecond timestamps in csv format */
  socReportCSV: Scalars['String']['output'];
  /** Returns the latest stored reward rate per stablecoin asset. */
  stablecoinAssetRates: Array<StablecoinAssetRate>;
  /**
   * Returns available asset type IDs for Stablecoin Rewards.
   * For org users: filtered to assets enabled for their organization.
   * For staff users: all approved assets.
   */
  stablecoinRewardsAvailableAssets: Array<Scalars['AssetTypeID']['output']>;
  /** Get a stablecoin rewards participant by ID. Anyone with knowledge of the ID can learn at least the top level affiliate name. */
  stablecoinRewardsParticipantByID: StablecoinRewardsParticipant;
  /**
   * Sorted and paginated list of participants.
   * Sorted from most recent to least recent by creation time by default.
   */
  stablecoinRewardsParticipants: StablecoinRewardsParticipantConnection;
  /** Returns the staged organization identified by the ID if it exists */
  stagedOrganization: Maybe<StagedOrganization>;
  /** Get staged organizations using filters */
  stagedOrganizations: StagedOrganizationConnection;
  /** Returns consolidated information standards like countries, states or others */
  standards: Standards;
  /** Get FIAT Standing Instructions */
  standingInstructions: Array<StandingInstruction>;
  /**
   * Given a statement type ID and filter field name, returns the available values
   * that can be applied to the filter.
   */
  statementsV2FilterAvailableValues: Array<StatementsV2StatementFilterAvailableValues>;
  /**
   * Given a statement type ID and filter field name, returns the available values
   * that can be applied to the filter.
   */
  statementsV2FilterAvailableValuesV2: StatementsV2StatementFilterAvailableValuesConnection;
  /**
   * Given a statement type ID, returns the list of filter configurations that can
   * be applied to the statement type.
   */
  statementsV2FilterConfig: Array<StatementsV2StatementFilterConfig>;
  /**
   * Lists statements with comprehensive filtering options.
   * Returns all statements matching the provided filters.
   */
  statementsV2List: Array<StatementsV2Statement>;
  /** Returns the most recently corrected published statement for the given statement type. */
  statementsV2MostRecentCorrectedStatement: Maybe<StatementsV2MostRecentCorrectedStatement>;
  /** Returns the list of schedules that have been created. */
  statementsV2Schedules: Array<StatementsV2Schedule>;
  /** Given a statement ID, returns the statement. */
  statementsV2StatementGet: StatementsV2Statement;
  /** Returns the list of statement types that the service can generate. */
  statementsV2Types: Array<StatementsV2StatementType>;
  subaccount: Maybe<SubaccountV2>;
  /** Returns balances for a specific subaccount */
  subaccountBalances: SubaccountBalanceConnection;
  /**
   * Returns a subaccount by ID alone - the organization is derived from the subaccount itself,
   * not required as input. Intended for internal/ops lookups (e.g. resolving a subaccount to its
   * affiliate and organization); not for customer-facing use, since it takes no tenant scoping as
   * input.
   */
  subaccountByID: Subaccount;
  subaccountOrg: Maybe<SubaccountOrg>;
  subaccountOrgs: SubaccountOrgConnection;
  /** Returns a list of transactions for a specific subaccount */
  subaccountTransactions: TransactionConnection;
  subaccounts: SubaccountConnection;
  /**
   * Returns all basic infos of chains that each DEX supports.
   * Also includes the corresponding Anchorage Blockchain ID mapped by
   * ChainID (if present).
   */
  supportedDEXChainInfos: Array<DEXChainInfo>;
  /**
   * Returns the organization's B2B tax accounts (top-level affiliates) with each
   * account's TaxBit W-form tax documentation status.
   *
   * Staff users must pass organizationKeyId; org users are scoped to their
   * session organization and must not pass it.
   */
  taxAccounts: TaxAccountConnection;
  /** W-form status of the affiliate that owns the submission; null before a W-form is submitted. */
  taxCertificationStatus: Maybe<TaxCertificationWForm>;
  taxDocumentTypeInfos: Maybe<Array<TaxDocumentTypeInfo>>;
  /**
   * Returns Tax Documents with filtering, ordering, and pagination support.
   * Uses Ent-generated types for zero-conversion data access.
   */
  taxDocuments: TaxDocumentConnection;
  /**
   * Returns the active tax mappings. Inactive mappings, the history of edits, are
   * never returned.
   *
   * Pages stay consistent only while no mapping is edited. An edit replaces the
   * mapping with a new one that has a new id and createdAt, and possibly a new
   * reportable value. A mapping edited during a walk over the pages can be
   * skipped, or returned twice.
   */
  taxMappings: TaxMappingConnection;
  /** Returns Tax Provider Transactions for a given organization or subaccount */
  taxProviderTransactions: TaxProviderTransactionConnection;
  taxTenants: Array<TaxTenant>;
  /** TaxBit transaction types, with the subtypes TaxBit allows for each */
  taxbitTransactionTypes: Array<TaxbitTransactionTypeInfo>;
  /** Risk associated with a Token. */
  tokenRisk: TokenRisk;
  tokenSellApproval: TokenApprovalResult;
  /** Retrieves an individual quote data for a token swap. */
  tokenSwapQuoteData: QuoteResult;
  /**
   * Returns a paginated list of token swaps filtered by any combination of its
   * arguments. Results are returned in reverse chronological order by when they
   * were created(i.e. results are listed from most recently created, at the
   * beginning of the list, to the least recently created, at the end of the list.
   */
  tokenSwaps: TokenSwapConnection;
  /** Returns the csv list of trades for the client dashboard */
  tradesClientViewCsv: Scalars['String']['output'];
  /** Returns the list of organization trading aliases in CSV format */
  tradesRiskOrgAliasesCsv: Scalars['String']['output'];
  /** Returns list of trades for the risk dashboard in CSV format */
  tradesRiskViewCsv: Scalars['String']['output'];
  /** Lists an org trading accounts */
  tradingAccounts: Array<TradingAccount>;
  /** Get the configuration for advanced trading */
  tradingAdvancedTradingConfig: AdvancedTradingConfig;
  /** Get all trading asset */
  tradingAssets: Array<TradingAsset>;
  /** Returns a list of payment flows */
  tradingClientPaymentFlows: ClientPaymentFlowConnection;
  /**
   * Check the source wallet's available balance and estimated network fee for a
   * settlement's transfer. Informational only; it does not affect the settlement.
   */
  tradingClientSettlementTransferCheck: ClientSettlementTransferCheck;
  /** Returns list of client trades */
  tradingClientTrades: TradesView;
  /** Returns list of client trades in a comma-separated values format */
  tradingClientTradesCSV: Scalars['String']['output'];
  /** Get list of counterparties */
  tradingCounterparties: CounterpartyConnection;
  /** Returns credit discrepancies for all orgs. */
  tradingCreditDiscrepancies: Array<TradingCreditDiscrepancy>;
  /** Returns a list of dealer settlements */
  tradingDealerSettlements: DealerSettlementConnection;
  /** Return all dealer trades, both automatic dealer trades from execution reports and also dealer manual trades */
  tradingDealerTrades: DealerTradesConnection;
  /** Return all dealer trades CSV, both automatic dealer trades from execution reports and also dealer manual trades */
  tradingDealerTradesCSV: Scalars['String']['output'];
  /** Get all trading external assets */
  tradingExternalAssets: Array<TradingExternalAsset>;
  /** Get client settlements */
  tradingGetClientSettlements: ClientSettlementsConnection;
  /** Returns trade execution reports. */
  tradingGetExecutionReports: TradeExecutionReportConnection;
  /** Get order execution reports */
  tradingGetOrderExecutionReports: OrderExecutionReportConnection;
  /**
   * TODO: add filters
   * Fetch the unsettled client balances
   */
  tradingGetUnsettledClientBalances: UnsettledClientBalancesConnection;
  /**
   * Get wallet settlement instructions
   * These instructions are used to decide where the RIA automatic settlements
   * should be send from and to in the perspective of the Anchorage Client
   * Settlement FBO Org.
   * The settlement instructions for the RIA organizations are stored in the ledger
   */
  tradingGetWalletSettlementInstructions: Array<WalletSettlementInstruction>;
  /** Get the default settlement addresses for all the assets */
  tradingLatestDefaultSettlementInstructions: DefaultSettlementInstructions;
  /** Lists trading organizations */
  tradingOrganizations: Array<TradingOrganization>;
  /** Returns a list of payment flows */
  tradingPaymentFlows: PaymentFlowConnection;
  /** Get trading permissions */
  tradingPermissions: Array<TradingPermission>;
  /** Returns the outstanding positions for the specified list of trades while ensuring they all belong to the specified organization */
  tradingSettlementPreview: TradingSettlementPreview;
  /**
   * Returns all currently-active (placed but not yet released) trading strategy
   * collateral holds for a subaccount, optionally narrowed to a single asset
   * type. There is no other way to audit what's actually locked for a
   * subaccount without this: adjust/release require already knowing a holdID,
   * and holdIDs are only ever handed back from place/adjust's own responses.
   */
  tradingStrategyCollateralHolds: Array<TradingStrategyCollateralHold>;
  /** Get trading symbols. Setting isEnabled to true and isApproved to false is an invalid combination of filters for this endpoint. */
  tradingSymbols: Array<TradingSymbol>;
  /** Get talos accounts */
  tradingTalosAccounts: Array<TradingTalosAccount>;
  /** Fetch a list of trade settlement transactions */
  tradingTradeSettlementTransactions: TradeSettlementTransactionConnection;
  /** Get unsettled client balances summary */
  tradingUnsettledClientBalanceSummary: TradingUnsettledClientBalanceSummary;
  /** Returns a list of unsettled dealer balances */
  tradingUnsettledDealerBalances: UnsettledDealerBalancesConnection;
  /**
   * Get whitelabel users
   * Replaces tradingWhitelabelUsers in graphqlmonolith (deprecated there)
   */
  tradingWhitelabelUsers: Array<TradingWhitelabelUser>;
  /** Returns a list of transction entries for a given transaction. */
  transactionEntries: TransactionEntryConnection;
  /** Lists the client transfer access requests */
  transferAccessRequests: Maybe<Array<TransferAccessRequest>>;
  /** Get travel rule information */
  travelRuleInformation: TravelRuleInformation;
  /** Trigger an address risk workflow and return status message */
  triggerAddressRiskWorkflow: Response;
  /**
   * List the operator-managed true-up skips for a subaccount — the (asset) pairs the
   * true-up engine will not move for it. Staff-only.
   */
  trueUpSkips: Array<TrueUpSkip>;
  /**
   * List trusted sources with ent-based filtering and pagination.
   * Replaces getTrustedSources with a cleaner ent e2e pattern.
   */
  trustedSources: TrustedSourceConnectionV2;
  /**
   * Returns the Turnkey binary configs currently approved in the
   * TURNKEY_BINARY_CONFIG special organization, grouped by service name.
   * Returns an empty list when no config is approved.
   */
  turnkeyBinaryConfigs: Array<TurnkeyBinaryConfigsForService>;
  /** Return manual trade if not settled */
  unSettledManualTrade: Maybe<ManualTradeRequestParams>;
  /** Returns the usage units available for fee-type configuration */
  usageUnits: Array<UsageUnit>;
  /** userInfo gets info about a user from their ID. Usually this is a PublicKeyID. */
  userInfo: DebugUserInfo;
  /** Returns the settings for a user. */
  userSettings: UserSettings;
  /** usersV2 is the list of all users Anchorage knows about */
  usersV2: UserV2Connection;
  /** Validates the role bindings of the specified organization. */
  validateMigrateRoles: Array<Scalars['String']['output']>;
  /**
   * Returns a single vault by subID or vaultUniqueID.
   * At least one parameter must be provided.
   * vault by sub Id or Unique Id for this organization
   */
  vault: Vault;
  /** Returns a list of vaults for the current organization with optional filtering. */
  vaults: Array<Vault>;
  /** Returns a paginated list of vaults with filtering and sorting support. */
  vaultsWithPagination: VaultConnection;
  /**
   * Get the current address on file for a virtual account at an MT-backed bank (BNY, SCB, JPM).
   * virtualAccountID is the fiat.bank_info row's own id (see bankInfosForOrg), not a wallet/bank pair -
   * a wallet can have more than one virtual account at the same bank.
   */
  virtualAccountAddress: VirtualAccountAddress;
  /**
   * Query the status of a wallet activation batch by workflow ID.
   *
   * Returns the current status of the activation workflow, including per-wallet
   * results with individual success/failure tracking when the workflow completes.
   */
  walletActivationBatch: WalletActivationBatchJobResponse;
  walletBulkCreateJob: WalletBulkCreateJobResponse;
  /** Gets info that could be used to filter on wallet lists. */
  walletFilterData: Maybe<WalletFilterData>;
  /** Get Wallet key PDF export preference */
  walletKeyExportPreference: WalletKeyExportPreference;
  walletScreeningAllowlistEntries: WalletScreeningAllowlistEntryConnection;
  /**
   * Get all wallets within all vaults of this organization.
   * This API will soon replace "wallets".
   *
   * NOTE: these quantity filters will be silently ignored iff the org is Porto:
   * - filterMinQuantity, filterMaxQuantity, quantityRangeIsInclusive.
   * - filterByNonZeroBalance.
   *
   * NOTE: filterByBackupReceived is silently ignored iff the org does NOT require wallet key backup acknowledgement.
   */
  wallets: WalletConnection;
  /** TODO: add description */
  webhookAllEventTypes: Maybe<Array<WebhookEventType>>;
  /** TODO: add description */
  webhookEndpoint: WebhookEndpoint;
  webhookEndpoints: WebhookEndpointConnection;
  webhookEventTypes: WebhookEventTypeConnection;
  /** TODO: add description */
  webhookValidationKey: WebhookValidationKey;
};


/** The query type, represents all of the entry points into our object graph */
export type Querya1BalancesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<A1BalancesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryabiFetchableNetworksArgs = {
  filterByTrustedSmartContracts?: Scalars['Boolean']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaccountConstraintGroupsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountConstraintGroupWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaccountConstraintStatesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountConstraintStateWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaccountConstraintsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountConstraintWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaccountsArgs = {
  filter?: InputMaybe<AccountV4Filter>;
  page: PaginationParams;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaccountsV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountV2WhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaddressAttestationsArgs = {
  addresses?: InputMaybe<Array<Scalars['String']['input']>>;
  assetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  createdAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<AddressAttestationState>>;
  updatedAfter?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaddressPublicKeyArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  keyType: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaddressUtxosArgs = {
  addressSubID: Scalars['String']['input'];
  afterId?: InputMaybe<Scalars['ID']['input']>;
  filter?: UtxoExclusionStateFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchByTxid?: InputMaybe<Scalars['String']['input']>;
  walletID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaffiliateAnchorageRelationshipsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AffiliateAnchorageRelationshipWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaffiliateSubaccountsArgs = {
  affiliateID: Scalars['String']['input'];
  orgID: Scalars['String']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
  subaccountID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryaffiliatesV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AffiliateV2Order>;
  where?: InputMaybe<AffiliateV2WhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryallStatementsArgs = {
  accountIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  displayDateSince?: InputMaybe<Scalars['Date']['input']>;
  displayDateUntil?: InputMaybe<Scalars['Date']['input']>;
  excludeTypes?: InputMaybe<Array<StatementType>>;
  includeAllOrTheseTypes?: InputMaybe<Array<StatementType>>;
  orderBy?: InputMaybe<Array<StatementOrder>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryamlQuestionnaireAnswersArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  assetTypeID: Scalars['AssetTypeID']['input'];
  participantID?: InputMaybe<Scalars['String']['input']>;
  trustedCounterpartyParticipantID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryanchorageLegalEntitiesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorageLegalEntityWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryapiKeyArgs = {
  keyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryapiKeysArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  roleSubID?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryareStatementsBeingSentArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryassetSupportRequestsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  assetTypeId?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryassetTypeInfoArgs = {
  assetType: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryassetTypeInfosArgs = {
  filterByContractAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  filterByNetworkIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  isFiat?: InputMaybe<Scalars['Boolean']['input']>;
  sortByPopularity?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryassetTypeRequiredConfirmationsReportArgs = {
  assetTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerybankInfosForOrgArgs = {
  bankName?: InputMaybe<BankName>;
  orgID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerybillingEntitiesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter: BillingEntitiesFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryblockchainAddressArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryblockchainScreeningArgs = {
  analysisTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operationIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  orgIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  requestStatus?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerybqSourceRelationsArgs = {
  dataset: Scalars['String']['input'];
  filter?: InputMaybe<BQRelationFilterInput>;
  project: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerybqViewSchemaArgs = {
  dataset: Scalars['String']['input'];
  project: Scalars['String']['input'];
  view: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerybrokerageSupportedAssetsArgs = {
  input: BrokerageSupportedAssetsInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerybulletinBoardServiceGetAddressOwnershipArgs = {
  address: Scalars['String']['input'];
  blockchainID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycanCancelOperationArgs = {
  operationID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycheckStaffPermissionArgs = {
  permission: Scalars['String']['input'];
  principal?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryclientAffiliateTypesArgs = {
  clientID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryclientDashboardLoginRequestInfoArgs = {
  sessionID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryclientOrdersArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClientOrderOrder>;
  where?: InputMaybe<ClientOrderWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryclientOrdersCSVArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClientOrderOrder>;
  where?: InputMaybe<ClientOrderWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryclientTradesViewArgs = {
  afterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  beforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filterAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterSettlementIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterSide?: InputMaybe<TradeSide>;
  filterStatuses?: InputMaybe<Array<TradeStatus>>;
  filterSymbol?: InputMaybe<Scalars['String']['input']>;
  filterTradeID?: InputMaybe<Scalars['String']['input']>;
  filterUserKeyID?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmAlertsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  alertTypes?: InputMaybe<Array<cmAlertType>>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  loanIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmAssetBalanceArgs = {
  assetBalanceType: CmAssetBalanceType;
  cmPackageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  role: CmParticipantRole;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmAssetsWithPricingArgs = {
  priceSource: PriceSource;
  provider: CmPricingProvider;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmCollateralWalletBalancesArgs = {
  cmPackageID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmExposureIncreaseMaxAmountsArgs = {
  collateralPackageID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmLatestLtvsArgs = {
  cmPackageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmLiquidationObligationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  collateralPackageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<CmLiquidationStatus>>;
  types?: InputMaybe<Array<CmLiquidationType>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmLiquidationPreExecutionArgs = {
  obligationID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmLtvTimeSeriesArgs = {
  cmPackageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['Timestamp']['input'];
  role?: InputMaybe<CmParticipantRole>;
  startDate: Scalars['Timestamp']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmMarginReturnMaxAmountsArgs = {
  collateralPackageID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmMarketDataSnapshotsArgs = {
  assetTypeIDs: Array<Scalars['AssetTypeID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmOperationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  cmPackageId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  operationType?: InputMaybe<CmOperationType>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmPackageConfigsArgs = {
  cmPackageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmPackageCountArgs = {
  role?: InputMaybe<CmParticipantRole>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmPackageDetailsArgs = {
  packageID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmPackagesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  cmPackageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  packageStates?: InputMaybe<Array<CmPackageState>>;
  packageStatuses?: InputMaybe<Array<CmPackageStatus>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmPriceSourcesArgs = {
  provider: CmPricingProvider;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmPriceSourcesByProviderArgs = {
  exchange?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<CmPricingProvider>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmPricingStrategiesArgs = {
  priceSource: PriceSource;
  provider: CmPricingProvider;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmSimulateLtvArgs = {
  operations: Array<CmSimulateLtvOperationInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmSystemSettingsArgs = {
  type: CmSystemSettingsType;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmTalosOrderArgs = {
  orderID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmTalosTradesArgs = {
  orderID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycmValidateMarginReturnArgs = {
  assetAmounts: Array<CmAssetAmountInput>;
  collateralPackageID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycollateralCommunicationsArgs = {
  collateralPackageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycollateralTicketsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<TicketStatus>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycomplianceDocumentsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderID: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycomplianceTMSConfigsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  filterBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  filterEntityType?: InputMaybe<TMSRuleEntityType>;
  filterLatestVersionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filterTMSConfigVersion?: InputMaybe<Scalars['Int']['input']>;
  filterTMSRuleGroup?: InputMaybe<TMSRuleGroup>;
  filterTMSRuleName?: InputMaybe<Array<TMSRuleName>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycomplianceTMSConfigsMetadataArgs = {
  filterEntityType?: InputMaybe<TMSRuleEntityType>;
  filterTMSRuleGroup?: InputMaybe<Array<TMSRuleGroup>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycontrolAgreementActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ControlAgreementActivitiesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycostBasisDepositsCsvArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filter: TaxProviderTransactionsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycostBasisJobArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycounterpartiesArgs = {
  filter?: InputMaybe<CounterpartiesV2ListFilter>;
  pagination?: InputMaybe<PageParams>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycounterpartyArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycounterpartyAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycounterpartyAccountsArgs = {
  filter?: InputMaybe<CounterpartyAccountsFilter>;
  pagination?: InputMaybe<PageParams>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerycounterpartyScreeningEntriesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CounterpartyScreeningEntryOrder>;
  where?: InputMaybe<CounterpartyScreeningEntryWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydAppNotificationsArgs = {
  filterMaxCreatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  filterMinCreatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  filterTypes: Array<DAppNotificationType>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydebugAvailableConditionsArgs = {
  input: DebugAvailableConditionsInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydebugRawTransactionArgs = {
  networkID: Scalars['String']['input'];
  rawSignedTx: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydebugUTXOsArgs = {
  addressSubID?: InputMaybe<Scalars['String']['input']>;
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  option?: InputMaybe<Scalars['String']['input']>;
  organization: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydepositAttributionSpamThresholdsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DepositAttributionSpamThresholdOrder>;
  where?: InputMaybe<DepositAttributionSpamThresholdWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydepositAttributionsV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DepositAttributionOrder>;
  sourceAddressesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<DepositAttributionPublicWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryderivsEntityBankAccountsArgs = {
  filter?: InputMaybe<DerivsEntityBankAccountFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryderivsEntityWalletsArgs = {
  filter?: InputMaybe<DerivsEntityWalletFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryderivsTransferArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryderivsTransfersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DerivsTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryderivsTrustedDestinationsArgs = {
  filter?: InputMaybe<DerivsTrustedDestinationFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydisclosuresArgs = {
  filterDisclosureIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  forPorto?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydisclosuresByScreenArgs = {
  screen: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydownloadReportArgs = {
  fileID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydownloadSftpReportArgs = {
  reportID: Scalars['ID']['input'];
  sftpDestinationID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvAccountBalanceReportArgs = {
  input: DVAccountBalanceReportInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvAccountsArgs = {
  filter?: InputMaybe<DVAccountFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvAssetArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvAssetsArgs = {
  filter?: InputMaybe<AssetFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvBitwisePositionStatementArgs = {
  input: DVBitwisePositionStatementInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvBitwiseTradeRecapArgs = {
  input: DVBitwiseTradeRecapInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvCSAArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvCSAsArgs = {
  filter?: InputMaybe<DVCSAFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvClientEmailArgs = {
  filter?: InputMaybe<DvClientEmailFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvClientEmailAccountIDsArgs = {
  filter?: InputMaybe<DVClientEmailAccountIDsFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvClientEmailAttachmentsArgs = {
  emailId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvClientEmailsArgs = {
  filter: DVClientEmailFilter;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvCollateralRulesArgs = {
  nettingSetId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvCounterpartyMasterCopiesArgs = {
  filter?: InputMaybe<CounterpartyMasterCopyFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvCounterpartyMasterCopyArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvCustodianWalletsArgs = {
  filter?: InputMaybe<DVCustodianWalletFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvEndOfDayReconsArgs = {
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvEntitiesArgs = {
  filter?: InputMaybe<DVEntityFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvEntityArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvFilterAccountCSAsArgs = {
  filter?: InputMaybe<AccountCSAFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvFilterAccountNettingSetsArgs = {
  filter?: InputMaybe<AccountNettingSetFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvFilterCSAsArgs = {
  filter?: InputMaybe<CSAFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvFilterNettingSetParamsArgs = {
  filter?: InputMaybe<NettingSetParamsFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvFilterNettingSetRulesArgs = {
  filter?: InputMaybe<NettingSetRuleFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetCSAMarginTermsArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetCSAMarginTermsEffectiveAtArgs = {
  input: CSAMarginTermsEffectiveAtInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetClientEmailAttachmentFileArgs = {
  attachmentId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetCollateralRuleArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetCollateralRuleEffectiveAtArgs = {
  input: CollateralRuleEffectiveAtInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetNettingSetArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetNettingSetEffectiveAtArgs = {
  input: NettingSetEffectiveAtInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetPart45SubmissionReportFileArgs = {
  submissionId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetPfeRangeFileArgs = {
  asOfFrom: Scalars['Date']['input'];
  asOfTo: Scalars['Date']['input'];
  grain: DvPfeGrain;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetPfeRunFileArgs = {
  grain: DvPfeGrain;
  runId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetStatementFileArgs = {
  statementId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetStatementsArgs = {
  input?: InputMaybe<DvGetStatementsInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvGetVarRunFileArgs = {
  runId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvHarukoBackfillRequestsArgs = {
  filter?: InputMaybe<HarukoBackfillRequestFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvHarukoGroupsArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvICEReportsArgs = {
  tradeId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvIceReportDetailsArgs = {
  reportId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvIceReportQueueArgs = {
  filter?: InputMaybe<DVIceReportQueueFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvIngestChatAccountsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvInitialMarginArgs = {
  filter?: InputMaybe<DVInitialMarginFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvInternalMovementsArgs = {
  filter?: InputMaybe<DVInternalMovementFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvLedgerBalanceSnapshotLinesArgs = {
  filter?: InputMaybe<DVLedgerBalanceSnapshotLineFilter>;
  snapshotId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvLedgerBalanceSnapshotsArgs = {
  filter?: InputMaybe<DVLedgerBalanceSnapshotFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvLedgerBalancesArgs = {
  filter?: InputMaybe<DVLedgerBalanceFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvLedgerTransactionsArgs = {
  filter?: InputMaybe<DVLedgerTransactionFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvListCSAMarginTermsArgs = {
  filter?: InputMaybe<CSAMarginTermsFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvListCSAMarginTermsHistoryArgs = {
  filter?: InputMaybe<CSAMarginTermsHistoryFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvListCollateralRuleHistoryArgs = {
  filter?: InputMaybe<CollateralRuleHistoryFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvListCollateralRulesArgs = {
  filter?: InputMaybe<CollateralRuleFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvListNettingSetHistoryArgs = {
  filter?: InputMaybe<NettingSetHistoryFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvListNettingSetsArgs = {
  filter?: InputMaybe<NettingSetFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvListTimingRuleHistoryArgs = {
  filter?: InputMaybe<TimingRuleHistoryFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvListTimingRulesArgs = {
  filter: DVTimingRuleFilter;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvMakerCheckerRequestArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvMakerCheckerRequestsArgs = {
  filter?: InputMaybe<DVMakerCheckerRequestFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvMarginRequirementsArgs = {
  filter?: InputMaybe<DVMarginRequirementFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvMarginRunsArgs = {
  filter?: InputMaybe<DVMarginRunFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvNettingSetParamsArgs = {
  nettingSetId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvNettingSetRulesArgs = {
  nettingSetId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvNettingSetsArgs = {
  csaId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvObligationArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvObligationsArgs = {
  filter?: InputMaybe<DVObligationFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvPackageArgs = {
  packageIdentifier: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvPart45SubmissionArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvPart45SubmissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DvPart45SubmissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvPfeRunsArgs = {
  filter?: InputMaybe<DvPfeRunFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvPositionsArgs = {
  filter?: InputMaybe<DVPositionFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvProductArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvSDRReportArgs = {
  tradeId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvSettlementArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvSettlementLedgerPreviewArgs = {
  settlementId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvSettlementMovementsArgs = {
  settlementId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvSettlementsArgs = {
  filter?: InputMaybe<DVSettlementFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvStagedCloseoutsArgs = {
  status?: InputMaybe<Array<DVStagedCloseoutStatus>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvStatementFileSettingsArgs = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTimingRuleArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTimingRulesArgs = {
  csaId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradeArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradeConfirmationArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradeLifeCycleEventsArgs = {
  filter: DVTradeLifecycleEventFilter;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradeNovationsArgs = {
  filter?: InputMaybe<DVTradeNovationFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradeRecapCSVArgs = {
  input: DVTradeRecapCSVInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradeReconLinesArgs = {
  runId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradeReconRunsArgs = {
  filter?: InputMaybe<DvTradeReconRunFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradesArgs = {
  filter?: InputMaybe<TradeFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradesConnectionArgs = {
  filter?: InputMaybe<DVTradeFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvTradesRecapReportArgs = {
  input: DVTradesRecapReportInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvVarParameterVersionsArgs = {
  model?: InputMaybe<DvRiskModel>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvVarParametersArgs = {
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
  model?: InputMaybe<DvRiskModel>;
  version?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvVarRunArgs = {
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerydvVarRunsArgs = {
  filter?: InputMaybe<DvVarRunFilter>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryenrollmentEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enrollmentStatuses?: InputMaybe<Array<EnrollmentStatus>>;
  enrollmentTypes?: InputMaybe<Array<EnrollType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryentityAccountTransactionsArgs = {
  assetTypeID?: InputMaybe<Scalars['String']['input']>;
  entityID?: InputMaybe<EntityIDInput>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  entryTransactTimeAfter?: InputMaybe<Scalars['Time']['input']>;
  entryTransactTimeBefore?: InputMaybe<Scalars['Time']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  metadataFilter?: InputMaybe<MetadataKeyValuePair>;
  paginationInput?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Array<TransactionStatus>>;
  transactTimeAfter?: InputMaybe<Scalars['Time']['input']>;
  transactTimeBefore?: InputMaybe<Scalars['Time']['input']>;
  transactionType?: InputMaybe<Array<TransactionType>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryentityAccountsArgs = {
  accountIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assetTypeIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityID_IDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityIDs?: InputMaybe<Array<InputMaybe<EntityIDInput>>>;
  entityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paginationInput?: InputMaybe<PaginationInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryentityAccountsBalancesArgs = {
  assetTypeID?: InputMaybe<Scalars['String']['input']>;
  balanceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  entityID?: InputMaybe<EntityIDInput>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  paginationInput?: InputMaybe<PaginationInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryentityTagsArgs = {
  entityID: Scalars['String']['input'];
  entityType?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryentityTagsResultArgs = {
  entityID: Scalars['String']['input'];
  entityType?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryexchangeAPIKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterAPIKeyInIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterStatus?: InputMaybe<Array<EEAPIKeyStatus>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryexchangeInfosArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryexportWalletKeyArgs = {
  walletKeyID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryexternalAccountBalancesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterEndTimestampExclusive?: InputMaybe<Scalars['Timestamp']['input']>;
  filterExternalAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterStartTimestampInclusive?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryexternalAccountLocationsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  updatedAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  updatedBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryexternalAccountOrgBalancesArgs = {
  accountAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterEndTimestampExclusive?: InputMaybe<Scalars['Timestamp']['input']>;
  filterOrganizationKeyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterStartTimestampInclusive?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryexternalAccountTransactionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterID?: InputMaybe<Scalars['ID']['input']>;
  filterOrganizationKeyID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  updatedAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  updatedBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryexternalAccountsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterID?: InputMaybe<Scalars['ID']['input']>;
  filterLocationID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  updatedAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  updatedBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryexternalScreeningRequestsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExternalScreeningRequestOrder>;
  where?: InputMaybe<ExternalScreeningRequestWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryextractAgreementPrefillArgs = {
  input: ExtractAgreementPrefillInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryfeeTypesArgs = {
  filter?: InputMaybe<FeeTypesFilterInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryfeesAgreementsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<FeesAgreementsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryfetchSignedDocusignForWithdrawalArgs = {
  transactionID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryfiatTrustedDestinationArgs = {
  fiatTrustedDestinationID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryfiatTrustedDestinationsArgs = {
  affiliateID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<FiatTrustedDestinationState>;
  walletUniqueID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryfiatWithdrawalSignedDocusignURLsArgs = {
  transactionID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryfilteredOrganizationsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filterOrganizationName?: InputMaybe<Scalars['String']['input']>;
  filterTradingStatus?: InputMaybe<OrganizationTradingStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygdfControlAgreementByIDArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygdfControlAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterPledgorID?: InputMaybe<Scalars['ID']['input']>;
  filterSecuredPartyID?: InputMaybe<Scalars['ID']['input']>;
  filterStatus?: InputMaybe<GDFControlAgreementStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygdfEnrollementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterStatus?: InputMaybe<GDFEnrollementStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygdfOESAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterExchangeID?: InputMaybe<Scalars['ID']['input']>;
  filterStatus?: InputMaybe<GDFControlAgreementStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygdfOESExchangeDisplayNamesArgs = {
  exchangeParticipantIDs: Array<Scalars['ID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygdfOESExchangeProfileListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterCurrentOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filterExchangeParticipantID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygdfOESExchangeTermsArgs = {
  exchangeParticipantID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygdfOESExchangesWithProfileArgs = {
  exchangeParticipantIDs: Array<Scalars['ID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygenerateAccountStatementPdfArgs = {
  accountID: Scalars['String']['input'];
  debug?: Scalars['Boolean']['input'];
  endDateDay: Scalars['Int']['input'];
  endDateMonth: Scalars['Int']['input'];
  endDateYear: Scalars['Int']['input'];
  orgKeyID?: InputMaybe<Scalars['String']['input']>;
  startDateDay: Scalars['Int']['input'];
  startDateMonth: Scalars['Int']['input'];
  startDateYear: Scalars['Int']['input'];
  statementType?: InputMaybe<StatementType>;
  store?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAddressDebugStatusArgs = {
  address: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAddressPublicKeyArgs = {
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  keyType: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAddressesReportCSVArgs = {
  filterAssetIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterNetworkIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterStatus?: InputMaybe<AddressStatus>;
  filterVaultSubIDs?: Array<Scalars['String']['input']>;
  orgID: Scalars['String']['input'];
  searchName?: InputMaybe<Scalars['String']['input']>;
  searchNameOrAddressOrAsset?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAllDAppEntriesArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  enabledForADB?: InputMaybe<Scalars['Boolean']['input']>;
  enabledForADS?: InputMaybe<Scalars['Boolean']['input']>;
  enabledForPorto?: InputMaybe<Scalars['Boolean']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAllowedERC20SpendersArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAllowlistedValidatorArgs = {
  address: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAllowlistedValidatorsByAssetTypeIDArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAllowlistedValidatorsByAssetTypeIDAndOrgArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetApiKeysArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  orgKeyID?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAssetAuditLogArgs = {
  action?: InputMaybe<AssetAuditAction>;
  assetTypeID: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<AssetAuditSortOrder>;
  timestampAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  timestampBefore?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAssetTypesEnabledForOrgArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAssetsEnablementInfoArgs = {
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetAuditReportArgs = {
  assetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetBankDirectoryEntryArgs = {
  financialInstitutionID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetCRRHistoryArgs = {
  affiliateID: Scalars['String']['input'];
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<CRRHistoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetCRRHistoryCSVArgs = {
  affiliateID: Scalars['String']['input'];
  filters?: InputMaybe<CRRHistoryFilters>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetCRRSectionHistoryArgs = {
  affiliateID: Scalars['String']['input'];
  fromDate: Scalars['Timestamp']['input'];
  toDate: Scalars['Timestamp']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetCoinductorAutomationPoliciesArgs = {
  filterByStatus?: InputMaybe<Array<CoinductorPolicyStatus>>;
  lastCreatedAt?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetCoinductorAutomationPolicyActivityArgs = {
  policyID: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetCoinductorAutomationRunsArgs = {
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  filterByStatus?: InputMaybe<Array<CoinductorRunStatus>>;
  lastCreatedAt?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  policyID?: InputMaybe<Scalars['ID']['input']>;
  triggerType?: InputMaybe<CoinductorTriggerType>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetDAppEntriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterByKind?: InputMaybe<DAppKind>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DAppOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetDAppEntryArgs = {
  dappID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetDepositAttributionsCountArgs = {
  statusIn?: InputMaybe<Array<DepositAttributionStatus>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetETHStakingProviderForVaultArgs = {
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['Int']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetEnabledAssetsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetEthereumStakingProvidersConfigurationForOrgArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetEthereumStakingValidatorsForOrgArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetTypeID: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationKeyID: Scalars['String']['input'];
  vaultSubID?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetHourlyAssetTypePricesArgs = {
  assetTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  day: Scalars['String']['input'];
  hour: Scalars['Int']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetIssueRedeemHistoryArgs = {
  filterCreatedSince?: InputMaybe<Scalars['String']['input']>;
  filterCreatedUntil?: InputMaybe<Scalars['String']['input']>;
  filterOperationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  filterStatuses?: InputMaybe<Array<IssueRedeemConversionStatusFilter>>;
  filterVaultSubIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  lastCreatedAt?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetLegalTermAcceptancesArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  legaltermsID: Scalars['String']['input'];
  legaltermsVersion: Scalars['Int']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetLegalTermAcceptancesV2Args = {
  accountV2ID?: InputMaybe<Scalars['String']['input']>;
  legaltermsID: Scalars['String']['input'];
  legaltermsVersion: Scalars['Int']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetMultiBalanceSourceAuditReportArgs = {
  assetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetOrderNotificationAttachmentArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetOrderNotificationsArgs = {
  orderID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetOrgACHDebitInSettingsArgs = {
  orgID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetOrgGasConfigArgs = {
  orgID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetOrganizationAccessPolicyArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetPersonDataQualityChecksResultArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetPriceSymbolConversionsArgs = {
  fromAssets?: InputMaybe<Array<Scalars['String']['input']>>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetRawOperationArgs = {
  operationID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetScanProgressArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetScheduledReportSubscribersByScheduledReportIDArgs = {
  scheduledReportID: Scalars['Int']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetStaffGroupsArgs = {
  principal?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetStaffPermissionMembersArgs = {
  permission: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetSubaccountOrganizationCommingledWalletArgs = {
  network: Scalars['NetworkID']['input'];
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTalosCustomerArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTimestampedPriceInfoArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  timestamp: Scalars['Int']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTokenizationAssetSupplyHistoryArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTokenizationAssetTotalSupplyArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTokenizationCustodyOperationIDArgs = {
  tokenizationID: Scalars['OperationID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTokenizationHistoryArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  lastCreatedAt?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTradingEmailRecipientsArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTransactionByDestCountryArgs = {
  filterAccountIDs: Array<Scalars['String']['input']>;
  fromDate: Scalars['Timestamp']['input'];
  organizationKeyID: Scalars['String']['input'];
  toDate: Scalars['Timestamp']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTransactionVolumeHistoryArgs = {
  aggregatedBy: AggregationFilterType;
  filterAccountIDs: Array<Scalars['String']['input']>;
  fromDate: Scalars['Timestamp']['input'];
  organizationKeyID: Scalars['String']['input'];
  toDate: Scalars['Timestamp']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTransferArgs = {
  id: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTrustedDestinationsReportCSVArgs = {
  filterOrgID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTrustedSmartContractsReportCSVArgs = {
  filterOrgID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetTrustedSourcesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['String']['input']>;
  originatorCountry?: InputMaybe<Scalars['String']['input']>;
  originatorName?: InputMaybe<Scalars['String']['input']>;
  sourceAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  trustedSourceStatus?: InputMaybe<TrustedSourceStatus>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetUserIDsForHSMArgs = {
  orgKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetUserPIIArgs = {
  piiType: Array<PIIInformationType>;
  userId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetValidatorAssignmentsReportArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetVestingInfoArgs = {
  addressSubID: Scalars['String']['input'];
  assetSubID: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetWalletConnectSessionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterByCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  filterStatuses?: InputMaybe<Array<WalletConnectSessionStatus>>;
  first?: Scalars['Int']['input'];
  last?: Scalars['Int']['input'];
  sortDESC?: Scalars['Boolean']['input'];
  sortField?: WalletConnectSessionSortField;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetWalletConnectSessionsForOrgArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterStatuses?: InputMaybe<Array<WalletConnectSessionStatus>>;
  first?: Scalars['Int']['input'];
  last?: Scalars['Int']['input'];
  organizationKeyID: Scalars['String']['input'];
  sortDESC?: Scalars['Boolean']['input'];
  sortField?: WalletConnectSessionSortField;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetWalletConnectSessionsForOrgWithPaginationArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterStatuses?: InputMaybe<Array<WalletConnectSessionStatus>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByDApp?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationKeyID: Scalars['String']['input'];
  sortDESC?: Scalars['Boolean']['input'];
  sortField?: WalletConnectSessionSortField;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerygetWalletConnectSessionsWithPaginationArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterByCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  filterStatuses?: InputMaybe<Array<WalletConnectSessionStatus>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByDApp?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  sortDESC?: Scalars['Boolean']['input'];
  sortField?: WalletConnectSessionSortField;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryglobalTrustedSourcesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GlobalTrustedSourceOrder>;
  where?: InputMaybe<GlobalTrustedSourceWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryiamPermissionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IAMPermissionOrder>;
  where?: InputMaybe<IAMPermissionWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryinboundTravelRuleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  operationIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionHashes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryinstitutionalAffiliateArgs = {
  affiliateID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryinstitutionalAffiliatesArgs = {
  accountIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  affiliateName?: InputMaybe<Scalars['String']['input']>;
  affiliateTypes?: InputMaybe<Array<AffiliateType>>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  clientIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeAffiliateTypes?: InputMaybe<Array<AffiliateType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  pendingDepositAttributions?: Scalars['Boolean']['input'];
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<InstitutionalAffiliateSortFields>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryinstitutionalClientArgs = {
  clientID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryinstitutionalClientsArgs = {
  filterArchivedClients?: InputMaybe<InstitutionalCosmeticStatus>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryinstitutionalClientsFilteredArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  clientIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationKeyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<InstitutionalClientSortFields>;
  status?: InputMaybe<Array<ClientStatus>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryinstitutionalIndividualsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filterAnchorageEntityType?: InputMaybe<AnchorageEntityType>;
  filterAnchorageEntityTypes?: InputMaybe<Array<AnchorageEntityType>>;
  filterSearchTypes?: InputMaybe<Array<IndividualInformationTypeInput>>;
  filterSearchValue: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryinvoiceArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryinvoicesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<InvoiceQueryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InvoiceOrder>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryisFeatureEnabledArgs = {
  featureName: FeatureName;
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerykycDataLookupArgs = {
  args: Array<Scalars['String']['input']>;
  source: KYCDataLookupSource;
  submissionID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerykycQuestionnaireSubmissionByIdArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylatestCostBasisJobArgs = {
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryledgerTransactionsArgs = {
  assetTypeID?: InputMaybe<Scalars['String']['input']>;
  entryTransactTimeAfter?: InputMaybe<Scalars['Time']['input']>;
  entryTransactTimeBefore?: InputMaybe<Scalars['Time']['input']>;
  metadataFilter?: InputMaybe<MetadataKeyValuePair>;
  orgIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Array<TransactionStatus>>;
  transactTimeAfter?: InputMaybe<Scalars['Time']['input']>;
  transactTimeBefore?: InputMaybe<Scalars['Time']['input']>;
  transactionType?: InputMaybe<Array<TransactionType>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylegalTermAcceptancesArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  legaltermsID: Scalars['String']['input'];
  legaltermsVersion: Scalars['Int']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylegalTermsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  byScreen?: InputMaybe<UIScreen>;
  filterLegalTermIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forPorto?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByTitle?: InputMaybe<Scalars['Boolean']['input']>;
  titleSearch?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylistCustodianDispatchMethodsArgs = {
  custodianId: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylistCustodiansArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylistDocuSignWorkflowsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylistMicroDepositsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  subaccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylistRequestDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  transferId: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylistTransferEventsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  transferId?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerylistTransfersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  subaccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  transferStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerymarketingWidgetsArgs = {
  page: Scalars['DisplayPage']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerynativeAssetTypeInfosArgs = {
  sortByPopularity?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerynetworkStatusesArgs = {
  showDegradedNetworks: Scalars['Boolean']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerynxtCounterpartyAccountsArgs = {
  entityId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerynxtTfcCycleArgs = {
  cycleNo: Scalars['Int']['input'];
  ownerId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerynxtTfcCyclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NxtTfcCycleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NxtTfcCycleOrder>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerynxtTradesArgs = {
  entityId: Scalars['ID']['input'];
  filter?: InputMaybe<NxtTradeFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryoperationArgs = {
  operationID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryoperationsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAccountID?: InputMaybe<Scalars['String']['input']>;
  filterAccountIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterActions?: InputMaybe<Array<OperationAction>>;
  filterAppStatuses?: InputMaybe<Array<AppStatus>>;
  filterAssetSubID?: InputMaybe<Scalars['String']['input']>;
  filterAssetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterByTags?: InputMaybe<Array<TagFilter>>;
  filterCreatedSince?: InputMaybe<Scalars['String']['input']>;
  filterCreatedUntil?: InputMaybe<Scalars['String']['input']>;
  filterDelegateTypes?: InputMaybe<Array<DelegateType>>;
  filterDepositRewardTypes?: InputMaybe<Array<DepositRewardType>>;
  filterEndedSince?: InputMaybe<Scalars['String']['input']>;
  filterEndedUntil?: InputMaybe<Scalars['String']['input']>;
  filterExcludeSpamDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  filterFromGasStation?: InputMaybe<Scalars['Boolean']['input']>;
  filterIncludeOneOff?: InputMaybe<Scalars['Boolean']['input']>;
  filterOperationIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterOrganizationKeyID?: InputMaybe<Scalars['String']['input']>;
  filterProgramCustomerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterPublicKeyID?: InputMaybe<Scalars['String']['input']>;
  filterRequiresDecision?: InputMaybe<Scalars['Boolean']['input']>;
  filterStates?: InputMaybe<Array<OperationState>>;
  filterUpdatedSince?: InputMaybe<Scalars['String']['input']>;
  filterUpdatedUntil?: InputMaybe<Scalars['String']['input']>;
  filterVaultSubID?: InputMaybe<Scalars['String']['input']>;
  filterVaultSubIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterVirtualAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterWalletIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeChange?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<OperationSortFields>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryopsExceptionArgs = {
  id: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryopsExceptionHistoryArgs = {
  id: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryopsExceptionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Array<OpsExceptionStatus>>;
  typeFilter?: InputMaybe<OpsExceptionType>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorderHistoryArgs = {
  filterMarketOrderID: Scalars['ID']['input'];
  filterOrderID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationArgs = {
  generation?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationBalancesArgs = {
  orgID?: InputMaybe<Scalars['String']['input']>;
  orgIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<PaginationInput>;
  subaccountType?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationBalancesDeltaArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  orgIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<PaginationInput>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  subaccountTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  txStatuses?: InputMaybe<Array<TransactionStatus>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationBlockchainAssetsArgs = {
  orgID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationForPurposeKeyIDArgs = {
  purpose: OrganizationPurpose;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationModulesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationModuleWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationNotesArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationStatementsArgs = {
  accountIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  displayDateSince?: InputMaybe<Scalars['Date']['input']>;
  displayDateUntil?: InputMaybe<Scalars['Date']['input']>;
  excludeTypes?: InputMaybe<Array<StatementType>>;
  includeAllOrTheseTypes?: InputMaybe<Array<StatementType>>;
  orderBy?: InputMaybe<Array<StatementOrder>>;
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationSubaccountsArgs = {
  entityIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  orgID?: InputMaybe<Scalars['String']['input']>;
  orgIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<PaginationInput>;
  subaccountTypes: Array<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryorganizationsHoldingAssetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetTypeID: Scalars['AssetTypeID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryoutboundTravelRuleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  operationIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  orgIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionHashes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryoutstandingTradingPositionsRiskArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerypaginatedFiatTrustedDestinationsArgs = {
  affiliateID?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kinds?: InputMaybe<Array<FiatTrustedDestinationKind>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<FiatTrustedDestinationState>;
  walletUniqueID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryparticipatingMemberAddCandidateArgs = {
  affiliateID: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryparticipatingMemberAddEnabledArgs = {
  affiliateID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerypersonsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PersonOrderBy>;
  where?: InputMaybe<PersonWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerypolicyFragmentsAffectedArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAction: InputOperationActionPair;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resourceID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerypolicyFragmentsEnforcedArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAction: InputOperationActionPair;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resourceID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryportfolioArgs = {
  debug?: Scalars['Boolean']['input'];
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerypossibleDefaultActionArgs = {
  where: PolicyActionWhereInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerypossibleOutcomesArgs = {
  input: PossibleOutcomesInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerypossibleSpecificActionsArgs = {
  where: PolicyActionWhereInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerypriceSourceAvailabilityArgs = {
  fromAsset: Scalars['String']['input'];
  source: Scalars['String']['input'];
  vendorSymbol: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryproductUpdatesArgs = {
  category?: InputMaybe<ProductUpdatesCategory>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryprogramCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProgramCustomerWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryquestionnaireByNameArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  assetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  participantID?: InputMaybe<Scalars['String']['input']>;
  questionnaireName: Scalars['String']['input'];
  trustedCounterpartyParticipantID?: InputMaybe<Scalars['String']['input']>;
  vaultSubID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryreportFileValidationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportFileValidationWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryreportFileVerificationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportFileVerificationOrder>;
  where?: InputMaybe<ReportFileVerificationWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryreportFilterAvailableValuesArgs = {
  fieldName: Scalars['String']['input'];
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  reportType: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryreportSchedulesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportScheduleOrder>;
  where?: InputMaybe<ReportScheduleWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryreportTypeConfigArgs = {
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  reportType: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryreportTypeDefinitionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportTypeDefinitionWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryreportTypesArgs = {
  excludeReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryreportsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportOrder>;
  where?: InputMaybe<ReportWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryreservesHistoryArgs = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  lastCreatedAt?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  stablecoin?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryrestrictionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  vaultId: Scalars['String']['input'];
  walletId?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryrestrictionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<RestrictionsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  vaultId: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryrestrictionsByWalletsArgs = {
  status?: InputMaybe<RestrictionStatus>;
  walletIds: Array<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryrevealFiatTrustedDestinationAccountNumberArgs = {
  fiatTrustedDestinationID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryriaAccruedFeesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['Date']['input'];
  feeTypes?: InputMaybe<Array<FeeTypeType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationKeyID: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  subaccountId: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryriaFeeConfigurationsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  feeTypes?: InputMaybe<Array<FeeTypeType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationKeyID: Scalars['String']['input'];
  subaccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryriaOrganizationsArgs = {
  etfOrgsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  orgIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<PaginationInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryriskReviewRequirementsArgs = {
  operationID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryriskTradesViewArgs = {
  afterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  beforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filterAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterMarket?: InputMaybe<Scalars['String']['input']>;
  filterOrderID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterOrganizationKeyID?: InputMaybe<Scalars['String']['input']>;
  filterSettlementIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterSide?: InputMaybe<TradeSide>;
  filterStatuses?: InputMaybe<Array<TradeStatus>>;
  filterSymbol?: InputMaybe<Scalars['String']['input']>;
  filterTradeID?: InputMaybe<Scalars['String']['input']>;
  filterUserKeyID?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryscanEdgeNodeArgs = {
  addresses: Array<Scalars['String']['input']>;
  assetTypeID: Scalars['AssetTypeID']['input'];
  errorIfMissing?: Scalars['Boolean']['input'];
  fromBlock?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryscanNodeHealthArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryscanPreTransactionArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  request: PreTransactionRequestInput;
  walletUniqueID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryscanningIssuesArgs = {
  networkID?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ScanningIssueState>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryseLocationConnectionArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  seLocationInput?: InputMaybe<SELocationInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryseReconcileTransfersArgs = {
  input?: InputMaybe<SEReconcileTransfersInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryseTransferConnectionArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  seTransferInput?: InputMaybe<SETransferInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysearchOperationsByTagNameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  tagNames: Array<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysearchTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orgID?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<TagSortField>;
  sortOrder?: InputMaybe<OrderDirection>;
  tagType?: InputMaybe<TagType>;
  tagTypes?: InputMaybe<Array<InputMaybe<TagType>>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryserviceFeeTermsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter: ServiceFeeTermsFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysettlementInstructionsArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysettlementViewClientArgs = {
  afterTime?: InputMaybe<Scalars['Timestamp']['input']>;
  beforeTime?: InputMaybe<Scalars['Timestamp']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filterSettlementIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterStatuses?: InputMaybe<Array<TradeStatus>>;
  filterUserKeyID?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysettlementViewRiskArgs = {
  afterTime?: InputMaybe<Scalars['Timestamp']['input']>;
  beforeTime?: InputMaybe<Scalars['Timestamp']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filterAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  filterOrganizationKeyID?: InputMaybe<Scalars['String']['input']>;
  filterSettlementIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterStatuses?: InputMaybe<Array<TradeStatus>>;
  filterUserKeyID?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysignedURLToDownloadDocsForComplianceAlertsArgs = {
  documentName: Scalars['String']['input'];
  folderID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysmartContractABIArgs = {
  contractAddress: Scalars['String']['input'];
  networkID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysnAssetsArgs = {
  acceptorID: Scalars['ID']['input'];
  proposerID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysnParticipantByIDArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysnParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterActive?: InputMaybe<Scalars['Boolean']['input']>;
  filterName?: InputMaybe<Scalars['String']['input']>;
  filterParticipantInIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysnSettlementByIDArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysnSettlementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterActionNeededFromMe?: InputMaybe<Scalars['Boolean']['input']>;
  filterActionNotNeededFromMe?: InputMaybe<Scalars['Boolean']['input']>;
  filterParticipantInIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterState?: InputMaybe<SNSettlementStateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysnTrustedCounterpartiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterActive?: InputMaybe<Scalars['Boolean']['input']>;
  filterCanSettle?: Scalars['Boolean']['input'];
  filterOwnerInIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchByNameOrID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysocReportCSVArgs = {
  filterCreatedSince: Scalars['String']['input'];
  filterCreatedUntil: Scalars['String']['input'];
  filterOrganizationKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystablecoinRewardsParticipantByIDArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystablecoinRewardsParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterParticipantInIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystagedOrganizationArgs = {
  stagedOrganizationID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystagedOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasOrganizationKeyID?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  operators?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationKeyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  stagedOrganizationIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystandingInstructionsArgs = {
  affiliateID?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StandingInstructionStateType>;
  walletUniqueID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystatementsV2FilterAvailableValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterFieldName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statementTypeID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystatementsV2FilterAvailableValuesV2Args = {
  filterFieldName: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
  statementTypeID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystatementsV2FilterConfigArgs = {
  statementTypeID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystatementsV2ListArgs = {
  accountIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  affiliateIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  coverageTimeEnd?: InputMaybe<TimeRangeInput>;
  createdAt?: InputMaybe<TimeRangeInput>;
  excludeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  orgID: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
  statementIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  statementTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<StatementsV2StatementGenerationStatus>>;
  subaccountIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  vaultGroupIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystatementsV2MostRecentCorrectedStatementArgs = {
  statementTypeID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerystatementsV2StatementGetArgs = {
  statementID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysubaccountArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysubaccountBalancesArgs = {
  assetTypeID?: InputMaybe<Scalars['String']['input']>;
  balanceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<PaginationInput>;
  subaccountID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysubaccountByIDArgs = {
  subaccountID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysubaccountOrgArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysubaccountOrgsArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
  orderBy?: InputMaybe<Array<OrganizationOrderInput>>;
  page: PaginationParams;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysubaccountTransactionsArgs = {
  assetTypeID?: InputMaybe<Scalars['String']['input']>;
  entryTransactTimeAfter?: InputMaybe<Scalars['Time']['input']>;
  entryTransactTimeBefore?: InputMaybe<Scalars['Time']['input']>;
  paginationInput?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Array<TransactionStatus>>;
  subaccountID: Scalars['String']['input'];
  transactTimeAfter?: InputMaybe<Scalars['Time']['input']>;
  transactTimeBefore?: InputMaybe<Scalars['Time']['input']>;
  transactionType?: InputMaybe<Array<TransactionType>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerysubaccountsArgs = {
  filter?: InputMaybe<SubaccountFilterInput>;
  orderBy?: InputMaybe<Array<SubaccountOrderInput>>;
  page: PaginationParams;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytaxAccountsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationKeyId?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytaxCertificationStatusArgs = {
  submissionID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytaxDocumentsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaxDocumentOrder>;
  where?: InputMaybe<TaxDocumentWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytaxMappingsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  filter?: InputMaybe<TaxMappingsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaxMappingOrder>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytaxProviderTransactionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  filter: TaxProviderTransactionsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaxProviderTransactionOrder>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytokenRiskArgs = {
  input: TokenRiskInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytokenSellApprovalArgs = {
  sellAmount: Scalars['String']['input'];
  sellApprovalValue?: TokenSellApprovalValue;
  sellTokenAddress: Scalars['String']['input'];
  sellTokenChainID: Scalars['Int']['input'];
  sellWalletAddress: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytokenSwapQuoteDataArgs = {
  input: TokenSwapQuoteDataInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytokenSwapsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterByAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterByCreatedAtAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  filterByCreatedAtBefore?: InputMaybe<Scalars['Timestamp']['input']>;
  filterByIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByNetworkIDs?: InputMaybe<Array<Scalars['NetworkID']['input']>>;
  filterByStatuses?: InputMaybe<Array<TokenSwapStatus>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradesClientViewCsvArgs = {
  afterTime?: InputMaybe<Scalars['Timestamp']['input']>;
  beforeTime?: InputMaybe<Scalars['Timestamp']['input']>;
  filterAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterSide?: InputMaybe<TradeSide>;
  filterStatuses?: InputMaybe<Array<TradeStatus>>;
  filterSymbol?: InputMaybe<Scalars['String']['input']>;
  filterTradeID?: InputMaybe<Scalars['String']['input']>;
  filterUserKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradesRiskViewCsvArgs = {
  afterTime: Scalars['Timestamp']['input'];
  beforeTime: Scalars['Timestamp']['input'];
  filterAccountIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterMarket?: InputMaybe<Scalars['String']['input']>;
  filterOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterOrganizationKeyID?: InputMaybe<Scalars['String']['input']>;
  filterSettlementIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterStatuses?: InputMaybe<Array<TradeStatus>>;
  filterTradeID?: InputMaybe<Scalars['String']['input']>;
  filterTradingPair?: InputMaybe<Scalars['String']['input']>;
  filterUserKeyID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingAccountsArgs = {
  affiliateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  filterEntity?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationKeyID?: InputMaybe<Scalars['ID']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingAssetsArgs = {
  input: TradingAssetsInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingClientPaymentFlowsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ClientPaymentFlowFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingClientSettlementTransferCheckArgs = {
  orgKeyID: Scalars['String']['input'];
  settlementID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingClientTradesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  filterBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  filterHasSubaccountID?: InputMaybe<Scalars['Boolean']['input']>;
  filterManualTrades?: InputMaybe<Scalars['Boolean']['input']>;
  filterMarket?: InputMaybe<Scalars['String']['input']>;
  filterMarketOrderID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterNullSettlementID?: InputMaybe<Scalars['Boolean']['input']>;
  filterOrderID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterOrderTypes?: InputMaybe<Array<OrdType>>;
  filterOrganizationKeyID?: InputMaybe<Scalars['String']['input']>;
  filterSettlementIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterSide?: InputMaybe<TradeSide>;
  filterStatuses?: InputMaybe<Array<TradeStatus>>;
  filterSymbol?: InputMaybe<Scalars['String']['input']>;
  filterTradeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterTradeSources?: InputMaybe<Array<TradeSource>>;
  filterTransactTimeAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  filterTransactTimeBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  filterUserKeyID?: InputMaybe<Scalars['String']['input']>;
  filterVaultIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingClientTradesCSVArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  filterBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  filterHasSubaccountID?: InputMaybe<Scalars['Boolean']['input']>;
  filterManualTrades?: InputMaybe<Scalars['Boolean']['input']>;
  filterMarket?: InputMaybe<Scalars['String']['input']>;
  filterMarketOrderID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterNullSettlementID?: InputMaybe<Scalars['Boolean']['input']>;
  filterOrderID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterOrderTypes?: InputMaybe<Array<OrdType>>;
  filterOrganizationKeyID?: InputMaybe<Scalars['String']['input']>;
  filterSettlementIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterSide?: InputMaybe<TradeSide>;
  filterStatuses?: InputMaybe<Array<TradeStatus>>;
  filterSymbol?: InputMaybe<Scalars['String']['input']>;
  filterTradeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterTradeSources?: InputMaybe<Array<TradeSource>>;
  filterUserKeyID?: InputMaybe<Scalars['String']['input']>;
  filterVaultIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingCounterpartiesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterActive?: InputMaybe<Scalars['Boolean']['input']>;
  filterKind?: InputMaybe<Array<CounterpartyKind>>;
  filterName?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingDealerSettlementsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterAssignee?: InputMaybe<Array<Scalars['String']['input']>>;
  filterCounterparty?: InputMaybe<Array<Scalars['String']['input']>>;
  filterCreatedAtAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  filterCreatedAtBefore?: InputMaybe<Scalars['Timestamp']['input']>;
  filterEntity?: InputMaybe<Array<Scalars['String']['input']>>;
  filterID?: InputMaybe<Scalars['ID']['input']>;
  filterStatuses?: InputMaybe<Array<DealerSettlementStatusFilter>>;
  filterTransactionID?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingDealerTradesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterCounterparty?: InputMaybe<Array<Scalars['String']['input']>>;
  filterEntity?: InputMaybe<Array<Scalars['String']['input']>>;
  filterExcludeSubAccountPrefix?: InputMaybe<Array<Scalars['String']['input']>>;
  filterExecID?: InputMaybe<Scalars['ID']['input']>;
  filterFills?: InputMaybe<Scalars['Boolean']['input']>;
  filterFlowType?: InputMaybe<FlowType>;
  filterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterInitiator?: InputMaybe<Array<DealerTradeInitiator>>;
  filterIsHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  filterOrdType?: InputMaybe<Array<OrdType>>;
  filterParentOrderID?: InputMaybe<Scalars['String']['input']>;
  filterSide?: InputMaybe<TradeSide>;
  filterSource?: InputMaybe<Array<TradeSource>>;
  filterSymbol?: InputMaybe<Array<Scalars['String']['input']>>;
  filterTransactTimeAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  filterTransactTimeBefore?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingDealerTradesCSVArgs = {
  filters?: InputMaybe<DealerTradesFilters>;
  pageParams?: InputMaybe<PageParams>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingExternalAssetsArgs = {
  input: TradingExternalAssetsInput;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingGetClientSettlementsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ClientSettlementFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingGetExecutionReportsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  afterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  beforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  execID?: InputMaybe<Array<Scalars['String']['input']>>;
  filterOrderID?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  internalStatus?: InputMaybe<Array<InternalStatus>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketID?: InputMaybe<Array<Scalars['String']['input']>>;
  ordStatus?: InputMaybe<Array<OrdStatus>>;
  symbol?: InputMaybe<Array<Scalars['String']['input']>>;
  transactTimeAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  transactTimeBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingGetOrderExecutionReportsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  afterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  beforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  filterMissingParentOrderID?: InputMaybe<Scalars['Boolean']['input']>;
  filterSymbol?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<tradingGetOrderExecutionReportsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ordStatus?: InputMaybe<Array<OrdStatus>>;
  transactTimeAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  transactTimeBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingGetUnsettledClientBalancesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<UnsettledClientBalancesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingOrganizationsArgs = {
  entities?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingPaymentFlowsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAssetType?: InputMaybe<Scalars['AssetTypeID']['input']>;
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterCounterparty?: InputMaybe<Scalars['String']['input']>;
  filterCreatedAtAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  filterCreatedAtBefore?: InputMaybe<Scalars['Timestamp']['input']>;
  filterEntity?: InputMaybe<Array<Scalars['String']['input']>>;
  filterExcludeSettled?: InputMaybe<Scalars['Boolean']['input']>;
  filterID?: InputMaybe<Scalars['ID']['input']>;
  filterMissingSettlementID?: InputMaybe<Scalars['Boolean']['input']>;
  filterOrderID?: InputMaybe<Scalars['ID']['input']>;
  filterSettlementID?: InputMaybe<Scalars['String']['input']>;
  filterSide?: InputMaybe<TradeSide>;
  filterStatuses?: InputMaybe<Array<DealerSettlementStatusFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingPermissionsArgs = {
  filterOrganizationKeyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterPermissionTypes?: InputMaybe<Array<TradingPermissionTypeFilter>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingSettlementPreviewArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
  organizationKeyID: Scalars['String']['input'];
  tradeIDs: Array<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingStrategyCollateralHoldsArgs = {
  assetTypeID?: InputMaybe<Scalars['String']['input']>;
  subaccountID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingSymbolsArgs = {
  filterEntities?: InputMaybe<Array<AnchorageEntityType>>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingTalosAccountsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TradingTalosAccountFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingTradeSettlementTransactionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterID?: InputMaybe<Array<Scalars['String']['input']>>;
  filterSettlementID?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingUnsettledDealerBalancesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterAssetTypeID?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterCounterparty?: InputMaybe<Array<Scalars['String']['input']>>;
  filterEntity?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytradingWhitelabelUsersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytransactionEntriesArgs = {
  assetTypeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  balanceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<PaginationInput>;
  transactionID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytransferAccessRequestsArgs = {
  filterDomains?: InputMaybe<Array<TransferAccessRequestDomain>>;
  forAllOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytravelRuleInformationArgs = {
  operationID: Scalars['String']['input'];
  orgID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytriggerAddressRiskWorkflowArgs = {
  operationID: Scalars['String']['input'];
  workflowId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytrueUpSkipsArgs = {
  subaccountId: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerytrustedSourcesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TrustedSourceOrder>;
  where?: InputMaybe<TrustedSourceWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryunSettledManualTradeArgs = {
  tradeID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryuserInfoArgs = {
  ID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryuserSettingsArgs = {
  userKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryusersV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserV2WhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryvalidateMigrateRolesArgs = {
  organizationKeyID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QueryvaultArgs = {
  subID?: InputMaybe<Scalars['String']['input']>;
  vaultUniqueID?: InputMaybe<Scalars['String']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryvaultsArgs = {
  filterCurrentUserIsVaultMember?: InputMaybe<Scalars['Boolean']['input']>;
  filterStates?: InputMaybe<Array<VaultState>>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryvaultsWithPaginationArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterCurrentUserIsVaultMember?: InputMaybe<Scalars['Boolean']['input']>;
  filterStates?: InputMaybe<Array<VaultState>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<VaultSortField>;
};


/** The query type, represents all of the entry points into our object graph */
export type QueryvirtualAccountAddressArgs = {
  virtualAccountID: Scalars['String']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerywalletActivationBatchArgs = {
  workflowID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerywalletBulkCreateJobArgs = {
  workflowID: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerywalletScreeningAllowlistEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerywalletsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  excludeFIAT?: InputMaybe<Scalars['Boolean']['input']>;
  filterByAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterByAssetTypeNetworkIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterByBackupReceived?: InputMaybe<Scalars['Boolean']['input']>;
  filterByIsArchived?: InputMaybe<Scalars['Boolean']['input']>;
  filterByNetworkIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterByVaultSubIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterByWalletIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByWalletsWithOneOfAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterCurrentUserIsVaultMember?: InputMaybe<Scalars['Boolean']['input']>;
  filterMaxQuantity?: InputMaybe<Scalars['String']['input']>;
  filterMinQuantity?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  quantityRangeIsInclusive?: Scalars['Boolean']['input'];
  searchByAddress?: InputMaybe<Scalars['String']['input']>;
  searchByName?: InputMaybe<Scalars['String']['input']>;
  sortDESC?: Scalars['Boolean']['input'];
  sortField?: WalletSortField;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerywebhookEndpointArgs = {
  id: Scalars['ID']['input'];
};


/** The query type, represents all of the entry points into our object graph */
export type QuerywebhookEndpointsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WebhookEndpointWhereInput>;
};


/** The query type, represents all of the entry points into our object graph */
export type QuerywebhookEventTypesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WebhookEventTypeWhereInput>;
};

/** QuestionAnswer is the actual user answer for a question */
export type QuestionAnswer = {
  __typename: 'QuestionAnswer';
  /** The free form text written in response to the question */
  freeformText: Maybe<Scalars['String']['output']>;
  /** A group of answers, used to answer for a question of type group */
  group: Array<Array<QuestionAnswer>>;
  /** The option IDs selected in response to the question */
  options: Maybe<Array<Scalars['String']['output']>>;
  /** The id of the question this answer is related to */
  questionID: Scalars['String']['output'];
};

/** Questionnaire contains the entire questionnaire body */
export type Questionnaire = {
  __typename: 'Questionnaire';
  /** Time at which this questionnaire version was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Resolves the questionnaire pages */
  pages: Array<QuestionnairePage>;
  /** List of pages in this questionnaire as JSON */
  questionnaireBody: Scalars['String']['output'];
  /** Unique ID for this particular questionnaire version */
  questionnaireID: Scalars['String']['output'];
  /** Name of questionnaire, e.g. aml_address */
  questionnaireName: Scalars['String']['output'];
  /** Type of the questionnaire */
  questionnaireType: Scalars['String']['output'];
  /** Version of the questionnaire */
  questionnaireVersion: Scalars['String']['output'];
};

/** Answer provided for a particular question with metadata */
export type QuestionnaireAnswer = {
  __typename: 'QuestionnaireAnswer';
  /** List of options or freeform text for the answer */
  answerData: Maybe<QuestionnaireAnswerData>;
  /** Timestamp at which the answer was recorded */
  createdAt: Scalars['Timestamp']['output'];
  /** Flags if the answer was provided after the operation was risk reviewed(when applicable) */
  postReviewAnswer: Scalars['Boolean']['output'];
  /** Unique identifier for the question */
  questionID: Scalars['String']['output'];
  /** The user that submitted the answer */
  userID: Scalars['String']['output'];
};

/** Actual answer data provided by the user */
export type QuestionnaireAnswerData = {
  __typename: 'QuestionnaireAnswerData';
  /** Freeform text given by the user */
  freeformText: Scalars['String']['output'];
  /** Options selected by the user */
  options: Array<Scalars['String']['output']>;
};

/** QuestionnairePage contains all questions for a single page, simple questionnaires may use only a single page */
export type QuestionnairePage = {
  __typename: 'QuestionnairePage';
  /** The unique identifier for this page */
  id: Scalars['String']['output'];
  /** Specifies whether to show questions one at a time or the entire page at once */
  oneByOne: Scalars['Boolean']['output'];
  /** The list of ordered questions to ask */
  questions: Array<QuestionnaireQuestion>;
  /** The subtitle is for a block of text following the header */
  subtitle: Scalars['String']['output'];
  /** The header to display on the page */
  title: Scalars['String']['output'];
};

/** QuestionnaireQuestion contains the details for a particular question */
export type QuestionnaireQuestion = {
  __typename: 'QuestionnaireQuestion';
  /** The response for the question, which is a list of options or freeform text for the answer. */
  answer: Maybe<QuestionAnswer>;
  /** The text to display below the options or field */
  footer: Scalars['String']['output'];
  /** Used to allow custom text answer by using this "id" (only for dropdown) */
  freeformOptionID: Scalars['String']['output'];
  /** The group of questions that can be answered more than once (only for GROUP) */
  group: Array<QuestionnaireQuestion>;
  /** The text to display below "text" but above the options or field */
  header: Scalars['String']['output'];
  /** The unique identifier for the question */
  id: Scalars['String']['output'];
  /** The optional user-friendly shorthand name for the question */
  name: Scalars['String']['output'];
  /** Identifies whether this question is optional */
  optional: Scalars['Boolean']['output'];
  /** List of possible options (only for CHIP, RADIO, CHECKBOX, DROPDOWN, DROPDOWN_MULTI_SELECT, RADIO_GROUP) */
  options: Array<QuestionnaireQuestionOption>;
  /** The text to display inside the field (only for textfield or dropdown) */
  placeholderText: Scalars['String']['output'];
  /** Used for one question value should not be editable. Could be used prefilled with an answer in a previous form and serve only information purposes. */
  readOnly: Scalars['Boolean']['output'];
  /** The rules for validating the user's answer */
  rules: Array<QuestionnaireQuestionRule>;
  /** The text to display below SectionTitle but above the field, in case the question is a section */
  sectionSubTitle: Scalars['String']['output'];
  /** The text to display above the field, in case the question is a section */
  sectionTitle: Scalars['String']['output'];
  /** Used to show the next question before answering this one this can cascade, if the next question has ShowNext, also show it (only for OneByOne) */
  showNext: Scalars['Boolean']['output'];
  /** The optional internal identifier tag */
  tag: Scalars['String']['output'];
  /** The text to display above the options or field */
  text: Scalars['String']['output'];
  /** A tooltip to explain the question */
  tooltip: Scalars['String']['output'];
  /** Used to only ask this question if the user selected a specific option e.g. {{"o1", "o2"}, {"o3"}} means [[o1 AND o2] OR [o3]] */
  triggerOptionID: Array<Array<Scalars['String']['output']>>;
  /** The type of question */
  type: QuestionnaireQuestionType;
};

/** QuestionnaireQuestionOption is a selectable element for chip, radio, dropdown, checkbox, dropdown_multi_select, and RADIO_GROUP questions */
export type QuestionnaireQuestionOption = {
  __typename: 'QuestionnaireQuestionOption';
  /** When an exclusive option is selected, it should be the only selected option */
  exclusive: Scalars['Boolean']['output'];
  /** The unique identifier for the option */
  id: Scalars['String']['output'];
  /** In a RADIO_GROUP question, this represents the questions that will be active when this option is selected */
  questionGroup: Maybe<Array<QuestionnaireQuestion>>;
  /** The subtext for the option */
  subtext: Scalars['String']['output'];
  /** Display a subtitle based on a previous question (only for radio questions) */
  subtitleQuestionID: Scalars['String']['output'];
  /** The optional internal identifier tag */
  tag: Scalars['String']['output'];
  /** The text to display for this option */
  text: Scalars['String']['output'];
  /** The tooltip for the option */
  tooltip: Scalars['String']['output'];
};

/** QuestionnaireQuestionRule describes a rule that validates a question's answers */
export type QuestionnaireQuestionRule = {
  __typename: 'QuestionnaireQuestionRule';
  /** A custom error message to be displayed if the validation fails */
  errorMessage: Scalars['String']['output'];
  /** The ID of a question whose answer will be the value for the rule */
  questionId: Maybe<Scalars['String']['output']>;
  /** The type of validation rule */
  type: QuestionnaireQuestionRuleType;
  /** The value of the rule (e.g. a regular expression or a number indicating the max value) */
  value: Scalars['String']['output'];
};

/** QuestionnaireQuestionRuleType describes the validation preformed by the rule */
export enum QuestionnaireQuestionRuleType {
  /** ADD_DAYS is a rule that checks if the date answer is within a given number of days from the current date */
  ADD_DAYS = 'ADD_DAYS',
  /** CHECK_SUM is a rule that checks if the sum of the answers for a given question inside a group equals a given value */
  CHECK_SUM = 'CHECK_SUM',
  /** DISTINCT is a rule that checks if a given question inside a group has unique answers */
  DISTINCT = 'DISTINCT',
  /** MAX_DATE is the maximum accepted date in the answer for date type questions */
  MAX_DATE = 'MAX_DATE',
  /** MAX_LENGTH is a maximum amount of characters or items in the answer */
  MAX_LENGTH = 'MAX_LENGTH',
  /** MAX_SUM is a rule that checks if the sum of the answers for a given question inside a group is below a given value */
  MAX_SUM = 'MAX_SUM',
  /** MIN_DATE is the minimum accepted date in the answer for date type questions */
  MIN_DATE = 'MIN_DATE',
  /** MIN_LENGTH is a minimum amount of characters or items in the answer */
  MIN_LENGTH = 'MIN_LENGTH',
  /** MIN_SUM is a rule that checks if the sum of the answers for a given question inside a group is above a given value */
  MIN_SUM = 'MIN_SUM',
  /** REGEX is a rule that contains a regex expression that is validated against the the answer text */
  REGEX = 'REGEX'
}

/** QuestionnaireQuestionType is the type of the questionnaire question */
export enum QuestionnaireQuestionType {
  /** CHECKBOX allows for the selection of multiple options in a list, adequate for short lists, may be optional */
  CHECKBOX = 'CHECKBOX',
  /** CHIP allows the selection of one option in a list, adequate for selecting words in short lists */
  CHIP = 'CHIP',
  /** DATE is a question picker input type, should be answered with freeform text in the form of MM/DD/YYYY, may be optional */
  DATE = 'DATE',
  /** DROPDOWN allows the selection of one option in a list, adequate for long lists */
  DROPDOWN = 'DROPDOWN',
  /** DROPDOWN_MULTI_SELECT allows for the selection of multiple options in a list, adequate for long lists, may be optional */
  DROPDOWN_MULTI_SELECT = 'DROPDOWN_MULTI_SELECT',
  /** GROUP enables a group of questions to be answered multiple times, may be optional, use MAX_LENGTH/MIN_LENGTH to specify the required number of times to answer the questions, answers must be given ion the answer group */
  GROUP = 'GROUP',
  /** RADIO allows the selection of one option in a list, adequate for short lists */
  RADIO = 'RADIO',
  /** RADIO_GROUP enables a group of questions when the corresponding option is selected, the sub questions are answered as regular questions, may be optional */
  RADIO_GROUP = 'RADIO_GROUP',
  /** SECTION indicates the question is to be handled as a section describing the next questions, cannot receive answers */
  SECTION = 'SECTION',
  /** TEXTFIELD is a free text input, may be optional */
  TEXTFIELD = 'TEXTFIELD',
  /** TEXT_AREA is also free text input, may be optional */
  TEXT_AREA = 'TEXT_AREA',
  /** UPLOAD allows file uploads, may be optional */
  UPLOAD = 'UPLOAD',
  /** VOID is a no-op input type, cannot receive answers */
  VOID = 'VOID'
}

/** Questionnaire and submitted answers */
export type QuestionnaireSubmission = {
  __typename: 'QuestionnaireSubmission';
  /** List of answers */
  answers: Array<QuestionnaireAnswer>;
  /** Time at which this submission was created */
  createdAt: Scalars['Timestamp']['output'];
  /** If the submitted answers can be edited */
  editable: Scalars['Boolean']['output'];
  /** id is the unique identifier of the questionnaire submission, equal to submissionID */
  id: Scalars['ID']['output'];
  /** Questionnaire used on this submission */
  questionnaire: Questionnaire;
  /** Unique identifier for the submission */
  submissionID: Scalars['String']['output'];
  /** If the questionnaire has been validated for all required answers */
  submitted: Scalars['Boolean']['output'];
  /** The user that created the submission */
  userID: Scalars['String']['output'];
};

/**
 * Quorum represents a list of authorized keys combined with the required number of
 * keys in order for the quorum to be met.
 */
export type Quorum = {
  __typename: 'Quorum';
  /** Number of signatures required to satisfy this quorum */
  signaturesRequired: Scalars['Int']['output'];
  /** Number of users authorized by this quorum */
  userCount: Scalars['Int']['output'];
  /** List of keys authorized to participate in this quorum */
  users: Array<User>;
};


/**
 * Quorum represents a list of authorized keys combined with the required number of
 * keys in order for the quorum to be met.
 */
export type QuorumusersArgs = {
  sortField?: InputMaybe<UserSortField>;
};

/** QuorumAction defines an action that requires a quorum to be met. */
export type QuorumAction = PolicyAction & {
  __typename: 'QuorumAction';
  /** Minimum number of members required for this action */
  defaultMinimumMembers: Scalars['Int']['output'];
  /** Minimum number of endorsements required for this action */
  defaultMinimumThreshold: Scalars['Int']['output'];
  /** Identifier of the action */
  id: Scalars['String']['output'];
  /** Name of the action */
  name: Scalars['String']['output'];
  /** Initial value of a threshold before being set by the user. */
  thresholdInitialValue: Scalars['Int']['output'];
};

export type QuorumOutcome = {
  __typename: 'QuorumOutcome';
  quorum: QuorumV2;
  subquorums: QuorumV2Connection;
};

export type QuorumOutcomeConstraints = {
  __typename: 'QuorumOutcomeConstraints';
  minimumMembers: Scalars['Int']['output'];
  minimumThreshold: Scalars['Int']['output'];
  thresholdInitialValue: Scalars['Int']['output'];
};

/**
 * Quorum branch of a rule outcome. The quorums list carries all subquorums
 * (strict + weak) — matches V1 InputRuleUpdate.quorums semantics.
 *
 * Each quorum's identity is stable across edits. Round-trip QuorumV2.id on
 * InputRuleQuorumUpdate.id so the BE can tell an in-place quorum edit from a
 * delete+add. Omit the id only for a genuinely new quorum; the BE mints one.
 */
export type QuorumOutcomeInput = {
  quorums: Array<InputRuleQuorumUpdate>;
};

/** The strictness of a quorum to be met in order to fulfill a policy fragment. */
export enum QuorumRequirement {
  /**
   * The quorum must be met in order to fulfill the policy fragment.
   * There exists no mechanism that can override or bypass the quorum.
   */
  QUORUM_REQUIREMENT_STRICT = 'QUORUM_REQUIREMENT_STRICT',
  /**
   * The quorum in optional in order to fulfill the policy framgment.
   * There exists mechanisms that can override the quorum requirement.
   */
  QUORUM_REQUIREMENT_WEAK = 'QUORUM_REQUIREMENT_WEAK'
}

/** Represents a quorum-based rule. */
export type QuorumRule = Rule & {
  __typename: 'QuorumRule';
  /** Action that the rule will be applied to */
  action: QuorumAction;
  /** Identifier of a rule */
  id: Scalars['ID']['output'];
  /** Base quorum for the rule */
  quorum: QuorumV2;
  /** Subquorums for this rule */
  subquorums: QuorumV2Connection;
};

/** Represents a quorum, with the list of keys and a threshold that must be met. */
export type QuorumV2 = {
  __typename: 'QuorumV2';
  /** List of keys that are not part of this policy but can be added */
  availableKeys: KeyConnection;
  /** The human readable description of the quorum. */
  description: Maybe<Scalars['String']['output']>;
  /** Identifier of a quorum */
  id: Scalars['ID']['output'];
  /** List of keys that are part of this quorum */
  keys: KeyConnection;
  /** Name that identifies the quorum. This cannot be used as a unique identifier. */
  name: Scalars['String']['output'];
  /** Threshold that needs to be met for the quorum to be met */
  threshold: Scalars['Int']['output'];
};


/** Represents a quorum, with the list of keys and a threshold that must be met. */
export type QuorumV2availableKeysArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a quorum, with the list of keys and a threshold that must be met. */
export type QuorumV2keysArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a paginated connection of QuorumV2. */
export type QuorumV2Connection = {
  __typename: 'QuorumV2Connection';
  /** A list of edges containing QuorumV2 nodes. */
  edges: Array<QuorumV2Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of QuorumV2 nodes in the connection. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** Represents an edge in a paginated connection of QuorumV2. */
export type QuorumV2Edge = {
  __typename: 'QuorumV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The QuorumV2 node at the end of the edge. */
  node: QuorumV2;
};

/** Quote for a given request */
export type Quote = {
  __typename: 'Quote';
  /** Bid quote amount */
  bid: Maybe<Amount>;
  /** Bid quote amount per unit */
  bidUnit: Maybe<Amount>;
  /** Offer quote amount */
  offer: Maybe<Amount>;
  /** Offer quote amount per unit */
  offerUnit: Maybe<Amount>;
  /** Quantity to quote for in units of Currency */
  quantity: Amount;
  /** quoteID of this quote */
  quoteID: Scalars['String']['output'];
  /** Rejection reason if applicable */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** Side of the quote request. */
  side: QuoteSide;
  /** Spread in BPS */
  spreadBPS: Maybe<Scalars['String']['output']>;
  /** Difference between bid and offer */
  spreadUnit: Maybe<Amount>;
  /** The current quote status */
  status: QuoteStatus;
  /** The time this quote was procured. */
  timestamp: Maybe<Scalars['Timestamp']['output']>;
  /** Trading pair being quoted */
  tradingPair: Scalars['String']['output'];
  /** The expire time of the quote. */
  validUntilTime: Maybe<Scalars['Timestamp']['output']>;
};

/** Represents the request for a quote */
export type QuoteRequestParams = {
  /** Account ID */
  accountID?: InputMaybe<Scalars['String']['input']>;
  /** Asset type of Quantity */
  assetTypeID: Scalars['AssetTypeID']['input'];
  /** Quantity to quote for in units of Currency */
  quantity: Scalars['String']['input'];
  /** Side of the quote request. */
  sideFilter: QuoteSideFilter;
  /** Trading pair being quoted */
  tradingPair: Scalars['String']['input'];
};

/**
 * The result of a quote request that captures the individual formats that
 * individual quotes can take.
 */
export type QuoteResult = JupiterQuote | UniswapClassicQuote | UniswapXQuoteV2;

/** Possible quote sides */
export enum QuoteSide {
  /** Buying base asset type */
  BUY = 'BUY',
  /** Selling base asset type */
  SELL = 'SELL',
  /** Both buying and selling base asset type */
  TWOWAY = 'TWOWAY'
}

/**
 * Possible quote sides accepted as an input filter on the GetQuote request.
 * Mirrors QuoteSide; kept as a separate type so the input enum can evolve
 * independently of the output enum and to avoid cross-subgraph exact-match
 * coupling.
 */
export enum QuoteSideFilter {
  /** Buying base asset type */
  BUY = 'BUY',
  /** Selling base asset type */
  SELL = 'SELL',
  /** Both buying and selling base asset type */
  TWOWAY = 'TWOWAY'
}

/** The different statuses that a quote can go through */
export enum QuoteStatus {
  /** The code was executed, meaning that it is complete and executed */
  EXECUTED = 'EXECUTED',
  /** The quote is open and awaiting trading or cancellation */
  OPEN = 'OPEN',
  /** The quote was rejected */
  REJECTED = 'REJECTED'
}

/** RFQOutput defines the expected fields the block-pricer model responds with */
export type RFQOutput = {
  __typename: 'RFQOutput';
  /** Ask information for the RFQ */
  ask: Maybe<BidAskOutput>;
  /** Bid information for the RFQ */
  bid: Maybe<BidAskOutput>;
  /** Reference price information */
  referencePrice: Maybe<ReferencePrice>;
};

/** RFQParams sets the params the block-pricer model requires */
export type RFQParams = {
  /** Base currency for the trade */
  baseCurrency: Scalars['String']['input'];
  /** Counter currency for the trade */
  counterCurrency: Scalars['String']['input'];
  /** Whether to enable FX rate */
  enableFxRate: Scalars['Boolean']['input'];
  /** Name of the trading entity */
  entityName: Scalars['String']['input'];
  /** Estimated delivery time for the trade */
  estimatedDeliveryTime: Scalars['String']['input'];
  /** List of liquidity venues to consider */
  liquidityVenues: Array<Scalars['String']['input']>;
  /** Method for FX rate calculation */
  method: Method;
  /** Participating rate for the trade */
  participatingRate: Scalars['Percent']['input'];
  /** Quote currency for the trade */
  quoteCurrency: Scalars['String']['input'];
  /** Size of the trade */
  size: Scalars['String']['input'];
  /** Whether to use USDC parity */
  usdcParity: Scalars['Boolean']['input'];
};

/** Represents an RIA organization */
export type RIAOrganization = {
  __typename: 'RIAOrganization';
  /** Identifier of the affiliate */
  affiliateID: Scalars['String']['output'];
  /** Organization configuration */
  configuration: Maybe<Array<OrganizationConfigurationEntry>>;
  /** Timestamp of when the Organization was created */
  createdAt: Scalars['Time']['output'];
  /** Organization information */
  organization: Organization;
  /** Timestamp of when the Organization was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/**
 * ReadPolicy type represents a policy designed exclusively for read operations.
 * It simplifies the view of policy representations, focusing on read-specific attributes.
 * It cannot be used for signing purposes.
 */
export type ReadPolicy = Node & {
  __typename: 'ReadPolicy';
  /** DisplayName is the human readable name of the policy. */
  displayName: Scalars['String']['output'];
  /** The ID of the ReadPolicy. */
  id: Scalars['ID']['output'];
  /** Quorums are the list of quorums that must be met in order to fulfill the policy. */
  quorums: ReadQuorumConnection;
  /** Resource represents the resource that the policy is applied to. */
  resource: PolicyResource;
};


/**
 * ReadPolicy type represents a policy designed exclusively for read operations.
 * It simplifies the view of policy representations, focusing on read-specific attributes.
 * It cannot be used for signing purposes.
 */
export type ReadPolicyquorumsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Read policy pagination connection. */
export type ReadPolicyConnection = {
  __typename: 'ReadPolicyConnection';
  /** A list of edges. */
  edges: Array<ReadPolicyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReadPolicyEdge = {
  __typename: 'ReadPolicyEdge';
  /** A CursorType for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: ReadPolicy;
};

/**
 * ReadQuorum type represents a quorum optimized for read queries.
 * It cannot be used for signing purposes.
 */
export type ReadQuorum = Node & {
  __typename: 'ReadQuorum';
  /** The base quorum represents the strictly enforced Quorum. */
  baseQuorum: PolicyQuorum;
  /** The ID of the ReadQuorum. This ID will be based on the quorum position within the array. */
  id: Scalars['ID']['output'];
  /** The SubQuorums represent the weakly enforced quorums. */
  subQuorums: PolicyQuorumConnection;
};


/**
 * ReadQuorum type represents a quorum optimized for read queries.
 * It cannot be used for signing purposes.
 */
export type ReadQuorumsubQuorumsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Read quorum pagination connection. */
export type ReadQuorumConnection = {
  __typename: 'ReadQuorumConnection';
  /** A list of edges. */
  edges: Array<ReadQuorumEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReadQuorumEdge = {
  __typename: 'ReadQuorumEdge';
  /** A CursorType for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: ReadQuorum;
};

/** ReceivingAddressInfo embeds information about the receiving address for a withdraw operation */
export type ReceivingAddressInfo = {
  __typename: 'ReceivingAddressInfo';
  /** isTrustedDestination demarcates whether the organization has added this as a trusted destination */
  isTrustedDestination: Scalars['Boolean']['output'];
  /** name is for a trusted destination's name */
  name: Maybe<Scalars['String']['output']>;
  /** riskAnalysis is the collected risk information for this address if we have any */
  riskAnalysis: Maybe<TransactionRiskAnalysis>;
  /**
   * signedAddress is the signed ID for this address if it is allocated to an organization the user
   * is authorized to view
   */
  signedAddress: Maybe<SignedAddress>;
};

/** ReceivingFiatTrustedDestination contains the fiat trusted destination and the fedID to identify the wire transaction */
export type ReceivingFiatTrustedDestination = {
  __typename: 'ReceivingFiatTrustedDestination';
  /** Withdrawal Wire transfer ID */
  fedID: Maybe<Scalars['String']['output']>;
  /** Trusted Destination for the withdrawal */
  trustedDestination: FiatTrustedDestination;
};

/** ReceivingStandingInstruction contains to standing instructiong and the fedID to identify the wire transaction */
export type ReceivingStandingInstruction = {
  __typename: 'ReceivingStandingInstruction';
  /** Withdrawal Wire transfer ID */
  fedID: Maybe<Scalars['String']['output']>;
  /** Standing instruction for the withdrawal */
  standingInstruction: StandingInstruction;
};

/** RedeemPreauthorizationInput is the input to gdfRedeemPreauthorization. */
export type RedeemPreauthorizationInput = {
  delegationID: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  legs: Array<RedemptionLegInput>;
};

/** RedeemPreauthorizationResponse is returned by gdfRedeemPreauthorization. */
export type RedeemPreauthorizationResponse = {
  __typename: 'RedeemPreauthorizationResponse';
  workflowID: Scalars['String']['output'];
};

/**
 * RedemptionLegInput describes one asset transfer in a redemption: a source
 * wallet on the pledgor side and a fully-specified destination wallet on the
 * secured-party side.
 */
export type RedemptionLegInput = {
  amount: Scalars['String']['input'];
  assetTypeID: Scalars['String']['input'];
  destinationAddress: Scalars['String']['input'];
  destinationAddressSubID: Scalars['Int']['input'];
  destinationNetworkID: Scalars['String']['input'];
  destinationOrganizationKeyID: Scalars['String']['input'];
  destinationVaultSubID: Scalars['Int']['input'];
  destinationWalletSubID: Scalars['Int']['input'];
  sourceWalletUniqueID: Scalars['ID']['input'];
};

/** ReferencePrice is the price of BlockPricerTradingAsset that block-pricer model used in calculations */
export type ReferencePrice = {
  __typename: 'ReferencePrice';
  /** Volume-weighted average price for the market */
  vwapMarket: Scalars['String']['output'];
};

/** ReferralFormName defines the name for each of the referral forms */
export enum ReferralFormName {
  /** A1 Referral Form Name */
  A1_REFERRAL_FORM = 'A1_REFERRAL_FORM',
  /** ATLAS Referral Form Name */
  ATLAS_REFERRAL_FORM = 'ATLAS_REFERRAL_FORM',
  /** PORTO Referral Form Name */
  PORTO_REFERRAL_FORM = 'PORTO_REFERRAL_FORM',
  /** Stablecoin Referral Form Name */
  STABLECOIN_REFERRAL_FORM = 'STABLECOIN_REFERRAL_FORM'
}

export type RegenerateReportScheduleInput = {
  /**
   * The scheduled/cutoff time of the original report to regenerate. The regenerated report replaces the
   * earlier report produced for this schedule at this time. Matching is hour-granular (YYYY-MM-DDTHH): the
   * minutes and seconds are ignored, so two calls for the same schedule and hour resolve to the same
   * regeneration.
   */
  referenceTime: Scalars['Time']['input'];
  /** ID of the report schedule to regenerate. */
  reportScheduleID: Scalars['ID']['input'];
};

/** RelatedPartyKYCProfile represents KYC profile data for a related party (person or business) */
export type RelatedPartyKYCProfile = KYCProfile & {
  __typename: 'RelatedPartyKYCProfile';
  /** Affiliate KYC profiles associated with this related party */
  affiliateKYCProfiles: AffiliateKYCProfileRelationConnection;
  /** Anchorage entity associated with this profile */
  anchorageEntity: Maybe<AnchorageEntity>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Exemptions for this KYC profile - information types that are exempt from collection */
  exemptions: Array<Scalars['String']['output']>;
  /** Unique identifier for the KYC profile */
  id: Scalars['ID']['output'];
  /** Key-value information associated with this KYC profile */
  kycProfileInfos: Array<KYCProfileInfo>;
  /** KYC legacy questionnaire for Person direct edit */
  legacyQuestionnaire: Maybe<Questionnaire>;
  /** Name of the related party */
  name: Scalars['String']['output'];
  /** Organization KYC profiles associated with this related party (can belong to multiple organizations) */
  organizationKYCProfiles: OrganizationKYCProfileConnection;
  /** Person ID associated with this related party profile */
  personID: Maybe<Scalars['ID']['output']>;
  /** Type of related party (person or business) */
  relatedPartyType: RelatedPartyType;
  /** Representatives associated with this related party */
  representatives: RepresentativeConnection;
  /** Current status of the KYC profile */
  status: KYCStatus;
};


/** RelatedPartyKYCProfile represents KYC profile data for a related party (person or business) */
export type RelatedPartyKYCProfileaffiliateKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** RelatedPartyKYCProfile represents KYC profile data for a related party (person or business) */
export type RelatedPartyKYCProfilelegacyQuestionnaireArgs = {
  questionnaireType?: InputMaybe<Scalars['String']['input']>;
};


/** RelatedPartyKYCProfile represents KYC profile data for a related party (person or business) */
export type RelatedPartyKYCProfileorganizationKYCProfilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** RelatedPartyKYCProfile represents KYC profile data for a related party (person or business) */
export type RelatedPartyKYCProfilerepresentativesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Connection for RelatedPartyKYCProfile type */
export type RelatedPartyKYCProfileConnection = {
  __typename: 'RelatedPartyKYCProfileConnection';
  /** List of edges */
  edges: Array<RelatedPartyKYCProfileEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge for RelatedPartyKYCProfile type */
export type RelatedPartyKYCProfileEdge = {
  __typename: 'RelatedPartyKYCProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge */
  node: RelatedPartyKYCProfile;
};

/**
 * RelatedPartyKYCProfileRelation represents the relationship between a client/affiliate and a related party
 * This type contains both the related party KYC profile and the metadata about their relationship
 */
export type RelatedPartyKYCProfileRelation = KYCProfileRelation & {
  __typename: 'RelatedPartyKYCProfileRelation';
  /** Ownership percentage in this relationship (for beneficial owners) */
  ownershipPercentage: Maybe<Scalars['String']['output']>;
  /** The related party KYC profile */
  relatedParty: RelatedPartyKYCProfile;
  /** Role description (e.g., CEO, CFO, Board Member) */
  roleDescription: Maybe<Scalars['String']['output']>;
  /** Types of relationship (e.g., BENEFICIAL_OWNER, CONTROL_PERSON, AUTHORIZED_REPRESENTATIVE) */
  roles: Maybe<Array<KYCRoleType>>;
};

/** Connection for RelatedPartyKYCProfileRelation type */
export type RelatedPartyKYCProfileRelationConnection = {
  __typename: 'RelatedPartyKYCProfileRelationConnection';
  /** List of edges */
  edges: Array<RelatedPartyKYCProfileRelationEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge for RelatedPartyKYCProfileRelation type */
export type RelatedPartyKYCProfileRelationEdge = {
  __typename: 'RelatedPartyKYCProfileRelationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge */
  node: RelatedPartyKYCProfileRelation;
};

/** Type of related party */
export enum RelatedPartyType {
  /** Individual person */
  INDIVIDUAL = 'INDIVIDUAL',
  /** Business or institutional entity */
  INSTITUTION = 'INSTITUTION'
}

export type ReleaseDelegationHoldsInput = {
  delegationID: Scalars['ID']['input'];
  /** Custody hold IDs to release. Each must be owned by the delegation. */
  holdIDs: Array<Scalars['ID']['input']>;
};

export type ReleaseDelegationHoldsResponse = {
  __typename: 'ReleaseDelegationHoldsResponse';
  releasedCount: Scalars['Int']['output'];
};

/** RemoveAssetFromProgramResult type represents the result of removing an asset from a program. */
export type RemoveAssetFromStablecoinRewardsProgramResult = {
  __typename: 'RemoveAssetFromStablecoinRewardsProgramResult';
  /** Asset type that was removed from the program */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Unique identifier for the updated program */
  programID: Scalars['String']['output'];
};

/**
 * RemoveAssetSupportInput represents the input needed to remove the support for a given asset
 * like an ERC-20 or Solana SPL token.
 */
export type RemoveAssetSupportInput = {
  /**
   * The asset type ID of the asset to remove support for.
   * Example: "MKR" the Maker assetTypeID
   */
  assetTypeID: Scalars['String']['input'];
};

/** RemoveBootMeasurementSetInput represents the input needed to remove a boot measurement set for a service. */
export type RemoveBootMeasurementSetInput = {
  /** The service name identifier (e.g., "hsm-native"). */
  serviceName: Scalars['String']['input'];
};

/**
 * RemoveQuorumRecoveryInput represents the input needed to remove the quorum
 * recovery entry for a given organization.
 */
export type RemoveQuorumRecoveryInput = {
  /** The ID of the organization for which the quorum recovery is being removed. */
  organizationKeyID: Scalars['String']['input'];
};

/**
 * RemoveParticipantsFromProgramResult type represents the result of removing
 * participants from a program.
 */
export type RemoveStablecoinRewardsParticipantsFromProgramResult = {
  __typename: 'RemoveStablecoinRewardsParticipantsFromProgramResult';
  /** List of IDs of successfully removed participants */
  participantIDs: Array<Scalars['String']['output']>;
  /** Unique identifier for the program */
  programID: Scalars['String']['output'];
};

/** RemoveTrustedDestinationOperation represents an operation where a user is added to the organization */
export type RemoveTrustedDestinationOperation = Operation & {
  __typename: 'RemoveTrustedDestinationOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** Trusted destination being removed from the organization */
  destination: TrustedDestination;
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
};


/** RemoveTrustedDestinationOperation represents an operation where a user is added to the organization */
export type RemoveTrustedDestinationOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** RemoveTrustedDestinationOperation represents an operation where a user is added to the organization */
export type RemoveTrustedDestinationOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** RemoveTrustedDestinationsInput represents the input needed to remove a trusted destination. */
export type RemoveTrustedDestinationsInput = {
  /** The Sub ID of the trusted destination to remove. */
  subID: Scalars['String']['input'];
};

/**
 * RemoveTrustedSmartContractInput represents the input needed to remove a trusted
 * smart contract.
 */
export type RemoveTrustedSmartContractInput = {
  /** The Sub ID of the trusted smart contract to remove. */
  subID: Scalars['String']['input'];
};

/** RemoveTurnkeyBinaryConfigInput represents the input needed to remove an approved Turnkey binary config. */
export type RemoveTurnkeyBinaryConfigInput = {
  /** The deployment/service name identifier (e.g., "turnkey-signer"). */
  serviceName: Scalars['String']['input'];
  /**
   * The full Turnkey binary config identifying exactly which entry to
   * remove. The appId inside turnkeyBinaryConfig alone is not sufficient:
   * multiple configs can share an appId for the same service (e.g. during
   * a rolling app deployment), so the full config disambiguates the
   * entry to remove.
   */
  turnkeyBinaryConfig: TurnkeyBinaryConfigInput;
};

/**
 * RemoveUserAndPoliciesOperation represents an operation where a user is removed from the organization
 * and all its policies
 */
export type RemoveUserAndPoliciesOperation = Operation & {
  __typename: 'RemoveUserAndPoliciesOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** iamChanges represents the JSON encoded IAM changes that will be applied with this operation. */
  iamChanges: Maybe<Scalars['OperationIAMChanges']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** The key that will be removed from the organization */
  key: Key;
  /** The public key ID of the user key that will be removed from the organization */
  keyID: Scalars['PublicKeyID']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * policyContainerUpdate represents the bindings that will be applied
   * to the org policy container
   */
  policyContainerUpdate: Maybe<PolicyContainerUpdate>;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** roleChanges represents the IAM role changes that will be applied with this operation. */
  roleChanges: Maybe<IAMRoleChanges>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * Policies the user is being removed from
   * @deprecated use policyContainerUpdate
   */
  updatedOrgPolicies: Array<PolicyUpdate>;
  /**
   * Vault policies the user is being removed from
   * @deprecated use vaultPolicyContainerUpdate
   */
  updatedVaultPolicies: Array<VaultPolicyUpdate>;
  /** The user being removed from the organization */
  user: User;
  /**
   * vaultPolicyContainerUpdate represents the bindings that will be applied
   * to the vault policy container
   */
  vaultPolicyContainerUpdate: Maybe<VaultPolicyContainerUpdate>;
};


/**
 * RemoveUserAndPoliciesOperation represents an operation where a user is removed from the organization
 * and all its policies
 */
export type RemoveUserAndPoliciesOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/**
 * RemoveUserAndPoliciesOperation represents an operation where a user is removed from the organization
 * and all its policies
 */
export type RemoveUserAndPoliciesOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** RemoveUserKeyInput represents the input needed to remove a user key */
export type RemoveUserKeyInput = {
  /** The public key ID of the user key to remove. */
  publicKeyID: Scalars['PublicKeyID']['input'];
};

/** A single pair of wallet and network, used in snParticipantUpdate */
export type ReplaceDefaultWalletInput = {
  /** The network to update the default wallet for */
  networkID: Scalars['String']['input'];
  /** The wallet unique ID */
  walletUniqueID: Scalars['String']['input'];
};

/** ReplaceUserOperation represents an operation where a user is replaced by another one */
export type ReplaceUserOperation = Operation & {
  __typename: 'ReplaceUserOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** The key that will be added to the organization */
  newKey: Key;
  /** The public key ID of the user key that will be added to the organization */
  newKeyID: Scalars['PublicKeyID']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** The user being added to the organization */
  newUser: StagedUser;
  /** The key that will be removed from the organization */
  oldKey: Key;
  /** The public key ID of the user key that will be removed from the organization */
  oldKeyID: Scalars['PublicKeyID']['output'];
  /** The user being removed from the organization */
  oldUser: User;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * policyContainerUpdate represents the bindings that will be applied
   * to the org policy container
   */
  policyContainerUpdate: Maybe<PolicyContainerUpdate>;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * Policies the user is being added to
   * @deprecated use policyContainerUpdate
   */
  updatedOrgPolicies: Array<PolicyUpdate>;
  /**
   * Vault policies the user is being added to
   * @deprecated use vaultPolicyContainerUpdate
   */
  updatedVaultPolicies: Array<VaultPolicyUpdate>;
  /**
   * vaultPolicyContainerUpdate represents the bindings that will be applied
   * to the vault policy container
   */
  vaultPolicyContainerUpdate: Maybe<VaultPolicyContainerUpdate>;
};


/** ReplaceUserOperation represents an operation where a user is replaced by another one */
export type ReplaceUserOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** ReplaceUserOperation represents an operation where a user is replaced by another one */
export type ReplaceUserOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

export type Report = Node & {
  __typename: 'Report';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  createdByPubKeyID: Scalars['String']['output'];
  createdByUser: Actor;
  dateRangeEnd: Maybe<Scalars['Time']['output']>;
  dateRangeStart: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates if the report was created by a staff user */
  isCreatedByStaff: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationID: Scalars['String']['output'];
  /** Organization name associated with the report */
  organizationName: Scalars['String']['output'];
  reportFiles: ReportFileConnection;
  reportFilters: ReportDataFilterConnection;
  reportSchedules: Maybe<ReportSchedule>;
  reportStatus: ReportReportStatus;
  type: Scalars['String']['output'];
  typeDisplayName: Scalars['String']['output'];
  /** Format: ±[hh]:[mm] where -12:00 <= ±[hh]:[mm] <= +14:00 */
  utcOffset: Scalars['String']['output'];
};


export type ReportreportFilesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportFileWhereInput>;
};


export type ReportreportFiltersArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportDataFilterWhereInput>;
};

/** A connection to a list of items. */
export type ReportConnection = {
  __typename: 'ReportConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ReportDataFilter = Node & {
  __typename: 'ReportDataFilter';
  fieldDisplayName: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  filterType: ReportDataFilterFilterType;
  id: Scalars['ID']['output'];
  reportFilterValues: ReportDataFilterValueConnection;
  reports: Report;
};


export type ReportDataFilterreportFilterValuesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportDataFilterValueWhereInput>;
};

/** A connection to a list of items. */
export type ReportDataFilterConnection = {
  __typename: 'ReportDataFilterConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportDataFilterEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportDataFilterEdge = {
  __typename: 'ReportDataFilterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportDataFilter>;
};

/** ReportDataFilterFilterType is enum for the field filter_type */
export enum ReportDataFilterFilterType {
  FILTER_TYPE_DATE_POINT = 'FILTER_TYPE_DATE_POINT',
  FILTER_TYPE_DATE_RANGE = 'FILTER_TYPE_DATE_RANGE',
  FILTER_TYPE_MULTI_SELECT = 'FILTER_TYPE_MULTI_SELECT',
  FILTER_TYPE_SINGLE_SELECT = 'FILTER_TYPE_SINGLE_SELECT',
  FILTER_TYPE_UNSPECIFIED = 'FILTER_TYPE_UNSPECIFIED'
}

export type ReportDataFilterValue = Node & {
  __typename: 'ReportDataFilterValue';
  displayValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reportFilters: ReportDataFilter;
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ReportDataFilterValueConnection = {
  __typename: 'ReportDataFilterValueConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportDataFilterValueEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportDataFilterValueEdge = {
  __typename: 'ReportDataFilterValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportDataFilterValue>;
};

/**
 * ReportDataFilterValueWhereInput is used for filtering ReportDataFilterValue objects.
 * Input was generated by ent.
 */
export type ReportDataFilterValueWhereInput = {
  and?: InputMaybe<Array<ReportDataFilterValueWhereInput>>;
  /** display_value field predicates */
  displayValue?: InputMaybe<Scalars['String']['input']>;
  displayValueContains?: InputMaybe<Scalars['String']['input']>;
  displayValueContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayValueEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayValueGT?: InputMaybe<Scalars['String']['input']>;
  displayValueGTE?: InputMaybe<Scalars['String']['input']>;
  displayValueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayValueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayValueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayValueLT?: InputMaybe<Scalars['String']['input']>;
  displayValueLTE?: InputMaybe<Scalars['String']['input']>;
  displayValueNEQ?: InputMaybe<Scalars['String']['input']>;
  displayValueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** report_filters edge predicates */
  hasReportFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportFiltersWith?: InputMaybe<Array<ReportDataFilterWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportDataFilterValueWhereInput>;
  or?: InputMaybe<Array<ReportDataFilterValueWhereInput>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * ReportDataFilterWhereInput is used for filtering ReportDataFilter objects.
 * Input was generated by ent.
 */
export type ReportDataFilterWhereInput = {
  and?: InputMaybe<Array<ReportDataFilterWhereInput>>;
  /** field_display_name field predicates */
  fieldDisplayName?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameContains?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameGT?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameGTE?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldDisplayNameLT?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameLTE?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** field_name field predicates */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldNameContains?: InputMaybe<Scalars['String']['input']>;
  fieldNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameGT?: InputMaybe<Scalars['String']['input']>;
  fieldNameGTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fieldNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldNameLT?: InputMaybe<Scalars['String']['input']>;
  fieldNameLTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fieldNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter_type field predicates */
  filterType?: InputMaybe<ReportDataFilterFilterType>;
  filterTypeIn?: InputMaybe<Array<ReportDataFilterFilterType>>;
  filterTypeNEQ?: InputMaybe<ReportDataFilterFilterType>;
  filterTypeNotIn?: InputMaybe<Array<ReportDataFilterFilterType>>;
  /** report_filter_values edge predicates */
  hasReportFilterValues?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportFilterValuesWith?: InputMaybe<Array<ReportDataFilterValueWhereInput>>;
  /** reports edge predicates */
  hasReports?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportsWith?: InputMaybe<Array<ReportWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportDataFilterWhereInput>;
  or?: InputMaybe<Array<ReportDataFilterWhereInput>>;
};

/** An edge in a connection. */
export type ReportEdge = {
  __typename: 'ReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Report>;
};

export type ReportFile = Node & {
  __typename: 'ReportFile';
  allValidationsPass: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  emailDeliveries: ReportFileEmailDeliveryConnection;
  fileFormat: ReportFileFileFormat;
  /** The name of the reports object within the reports GCS bucket */
  fileURL: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reports: Report;
  sftpDeliveries: ReportFileSftpDeliveryConnection;
  swiftDeliveries: ReportFileSwiftDeliveryConnection;
  validations: ReportFileValidationConnection;
  verifications: ReportFileVerificationConnection;
};


export type ReportFileemailDeliveriesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportFileEmailDeliveryWhereInput>;
};


export type ReportFilesftpDeliveriesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportFileSftpDeliveryWhereInput>;
};


export type ReportFileswiftDeliveriesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportFileSwiftDeliveryWhereInput>;
};


export type ReportFilevalidationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportFileValidationWhereInput>;
};


export type ReportFileverificationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportFileVerificationOrder>;
  where?: InputMaybe<ReportFileVerificationWhereInput>;
};

/** A connection to a list of items. */
export type ReportFileConnection = {
  __typename: 'ReportFileConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportFileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportFileEdge = {
  __typename: 'ReportFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportFile>;
};

export type ReportFileEmailDelivery = Node & {
  __typename: 'ReportFileEmailDelivery';
  /** Filename of the report attachment */
  attachmentFilename: Scalars['String']['output'];
  /** Timestamp when the delivery was claimed for processing. Used for concurrency control */
  claimedForDeliveryAt: Scalars['Time']['output'];
  /** Timestamp when the delivery record was created */
  createdAt: Scalars['Time']['output'];
  /** User or system that initiated the delivery */
  createdBy: Scalars['String']['output'];
  /** Timestamp when the email was successfully sent */
  deliveredAt: Maybe<Scalars['Time']['output']>;
  /** Email address where the report was delivered */
  emailAddress: Scalars['String']['output'];
  /** Current status of this email delivery */
  emailDeliveryStatus: ReportFileEmailDeliveryEmailDeliveryStatus;
  /** Subject line of the sent email */
  emailSubject: Scalars['String']['output'];
  /** Error message if delivery failed */
  errorMsg: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Foreign key to report_files table */
  reportFileID: Scalars['ID']['output'];
  reportFiles: ReportFile;
};

/** A connection to a list of items. */
export type ReportFileEmailDeliveryConnection = {
  __typename: 'ReportFileEmailDeliveryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportFileEmailDeliveryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportFileEmailDeliveryEdge = {
  __typename: 'ReportFileEmailDeliveryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportFileEmailDelivery>;
};

/** ReportFileEmailDeliveryEmailDeliveryStatus is enum for the field email_delivery_status */
export enum ReportFileEmailDeliveryEmailDeliveryStatus {
  EMAIL_DELIVERY_STATUS_FAILED = 'EMAIL_DELIVERY_STATUS_FAILED',
  EMAIL_DELIVERY_STATUS_SENT = 'EMAIL_DELIVERY_STATUS_SENT',
  EMAIL_DELIVERY_STATUS_UNSPECIFIED = 'EMAIL_DELIVERY_STATUS_UNSPECIFIED'
}

/**
 * ReportFileEmailDeliveryWhereInput is used for filtering ReportFileEmailDelivery objects.
 * Input was generated by ent.
 */
export type ReportFileEmailDeliveryWhereInput = {
  and?: InputMaybe<Array<ReportFileEmailDeliveryWhereInput>>;
  /** attachment_filename field predicates */
  attachmentFilename?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameContains?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameContainsFold?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameEqualFold?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameGT?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameGTE?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentFilenameLT?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameLTE?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameNEQ?: InputMaybe<Scalars['String']['input']>;
  attachmentFilenameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** claimed_for_delivery_at field predicates */
  claimedForDeliveryAt?: InputMaybe<Scalars['Time']['input']>;
  claimedForDeliveryAtGT?: InputMaybe<Scalars['Time']['input']>;
  claimedForDeliveryAtGTE?: InputMaybe<Scalars['Time']['input']>;
  claimedForDeliveryAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  claimedForDeliveryAtLT?: InputMaybe<Scalars['Time']['input']>;
  claimedForDeliveryAtLTE?: InputMaybe<Scalars['Time']['input']>;
  claimedForDeliveryAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  claimedForDeliveryAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** delivered_at field predicates */
  deliveredAt?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtGT?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deliveredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deliveredAtLT?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deliveredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_address field predicates */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailAddressContains?: InputMaybe<Scalars['String']['input']>;
  emailAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailAddressGT?: InputMaybe<Scalars['String']['input']>;
  emailAddressGTE?: InputMaybe<Scalars['String']['input']>;
  emailAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailAddressLT?: InputMaybe<Scalars['String']['input']>;
  emailAddressLTE?: InputMaybe<Scalars['String']['input']>;
  emailAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  emailAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** email_delivery_status field predicates */
  emailDeliveryStatus?: InputMaybe<ReportFileEmailDeliveryEmailDeliveryStatus>;
  emailDeliveryStatusIn?: InputMaybe<Array<ReportFileEmailDeliveryEmailDeliveryStatus>>;
  emailDeliveryStatusNEQ?: InputMaybe<ReportFileEmailDeliveryEmailDeliveryStatus>;
  emailDeliveryStatusNotIn?: InputMaybe<Array<ReportFileEmailDeliveryEmailDeliveryStatus>>;
  /** email_subject field predicates */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailSubjectContains?: InputMaybe<Scalars['String']['input']>;
  emailSubjectContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailSubjectEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailSubjectGT?: InputMaybe<Scalars['String']['input']>;
  emailSubjectGTE?: InputMaybe<Scalars['String']['input']>;
  emailSubjectHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailSubjectHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailSubjectIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailSubjectLT?: InputMaybe<Scalars['String']['input']>;
  emailSubjectLTE?: InputMaybe<Scalars['String']['input']>;
  emailSubjectNEQ?: InputMaybe<Scalars['String']['input']>;
  emailSubjectNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** error_msg field predicates */
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  errorMsgContains?: InputMaybe<Scalars['String']['input']>;
  errorMsgContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorMsgEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorMsgGT?: InputMaybe<Scalars['String']['input']>;
  errorMsgGTE?: InputMaybe<Scalars['String']['input']>;
  errorMsgHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorMsgHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorMsgIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMsgIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorMsgLT?: InputMaybe<Scalars['String']['input']>;
  errorMsgLTE?: InputMaybe<Scalars['String']['input']>;
  errorMsgNEQ?: InputMaybe<Scalars['String']['input']>;
  errorMsgNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMsgNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_files edge predicates */
  hasReportFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportFilesWith?: InputMaybe<Array<ReportFileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportFileEmailDeliveryWhereInput>;
  or?: InputMaybe<Array<ReportFileEmailDeliveryWhereInput>>;
  /** report_file_id field predicates */
  reportFileID?: InputMaybe<Scalars['ID']['input']>;
  reportFileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reportFileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  reportFileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** ReportFileFileFormat is enum for the field file_format */
export enum ReportFileFileFormat {
  FILE_FORMAT_CSV = 'FILE_FORMAT_CSV',
  FILE_FORMAT_MT = 'FILE_FORMAT_MT',
  FILE_FORMAT_UNSPECIFIED = 'FILE_FORMAT_UNSPECIFIED'
}

export type ReportFileSftpDelivery = Node & {
  __typename: 'ReportFileSftpDelivery';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  deliveredAt: Maybe<Scalars['Time']['output']>;
  errorMsg: Maybe<Scalars['String']['output']>;
  filePath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reportFileID: Scalars['ID']['output'];
  reportFiles: ReportFile;
  sftpDeliveryStatus: ReportFileSftpDeliverySftpDeliveryStatus;
  sftpDestination: ReportFileSftpDeliverySftpDestination;
  verifiedAt: Maybe<Scalars['Time']['output']>;
  verifiedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type ReportFileSftpDeliveryConnection = {
  __typename: 'ReportFileSftpDeliveryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportFileSftpDeliveryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportFileSftpDeliveryEdge = {
  __typename: 'ReportFileSftpDeliveryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportFileSftpDelivery>;
};

/** ReportFileSftpDeliverySftpDeliveryStatus is enum for the field sftp_delivery_status */
export enum ReportFileSftpDeliverySftpDeliveryStatus {
  SFTP_DELIVERY_STATUS_AWAITING_VERIFICATION = 'SFTP_DELIVERY_STATUS_AWAITING_VERIFICATION',
  SFTP_DELIVERY_STATUS_DELIVERED_TO_PENDING = 'SFTP_DELIVERY_STATUS_DELIVERED_TO_PENDING',
  SFTP_DELIVERY_STATUS_FAILED = 'SFTP_DELIVERY_STATUS_FAILED',
  SFTP_DELIVERY_STATUS_UNSPECIFIED = 'SFTP_DELIVERY_STATUS_UNSPECIFIED'
}

/** ReportFileSftpDeliverySftpDestination is enum for the field sftp_destination */
export enum ReportFileSftpDeliverySftpDestination {
  SFTP_DESTINATION_BITWISE = 'SFTP_DESTINATION_BITWISE',
  SFTP_DESTINATION_BLACKROCK = 'SFTP_DESTINATION_BLACKROCK',
  SFTP_DESTINATION_BNY = 'SFTP_DESTINATION_BNY',
  SFTP_DESTINATION_BYORE = 'SFTP_DESTINATION_BYORE',
  SFTP_DESTINATION_METAPLANET = 'SFTP_DESTINATION_METAPLANET',
  SFTP_DESTINATION_STATE_STREET = 'SFTP_DESTINATION_STATE_STREET',
  SFTP_DESTINATION_UNSPECIFIED = 'SFTP_DESTINATION_UNSPECIFIED',
  SFTP_DESTINATION_US_BANK = 'SFTP_DESTINATION_US_BANK'
}

/**
 * ReportFileSftpDeliveryWhereInput is used for filtering ReportFileSftpDelivery objects.
 * Input was generated by ent.
 */
export type ReportFileSftpDeliveryWhereInput = {
  and?: InputMaybe<Array<ReportFileSftpDeliveryWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** delivered_at field predicates */
  deliveredAt?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtGT?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deliveredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deliveredAtLT?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deliveredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** error_msg field predicates */
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  errorMsgContains?: InputMaybe<Scalars['String']['input']>;
  errorMsgContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorMsgEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorMsgGT?: InputMaybe<Scalars['String']['input']>;
  errorMsgGTE?: InputMaybe<Scalars['String']['input']>;
  errorMsgHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorMsgHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorMsgIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMsgIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorMsgLT?: InputMaybe<Scalars['String']['input']>;
  errorMsgLTE?: InputMaybe<Scalars['String']['input']>;
  errorMsgNEQ?: InputMaybe<Scalars['String']['input']>;
  errorMsgNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMsgNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** file_path field predicates */
  filePath?: InputMaybe<Scalars['String']['input']>;
  filePathContains?: InputMaybe<Scalars['String']['input']>;
  filePathContainsFold?: InputMaybe<Scalars['String']['input']>;
  filePathEqualFold?: InputMaybe<Scalars['String']['input']>;
  filePathGT?: InputMaybe<Scalars['String']['input']>;
  filePathGTE?: InputMaybe<Scalars['String']['input']>;
  filePathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  filePathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  filePathIn?: InputMaybe<Array<Scalars['String']['input']>>;
  filePathLT?: InputMaybe<Scalars['String']['input']>;
  filePathLTE?: InputMaybe<Scalars['String']['input']>;
  filePathNEQ?: InputMaybe<Scalars['String']['input']>;
  filePathNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** report_files edge predicates */
  hasReportFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportFilesWith?: InputMaybe<Array<ReportFileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportFileSftpDeliveryWhereInput>;
  or?: InputMaybe<Array<ReportFileSftpDeliveryWhereInput>>;
  /** report_file_id field predicates */
  reportFileID?: InputMaybe<Scalars['ID']['input']>;
  reportFileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reportFileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  reportFileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sftp_delivery_status field predicates */
  sftpDeliveryStatus?: InputMaybe<ReportFileSftpDeliverySftpDeliveryStatus>;
  sftpDeliveryStatusIn?: InputMaybe<Array<ReportFileSftpDeliverySftpDeliveryStatus>>;
  sftpDeliveryStatusNEQ?: InputMaybe<ReportFileSftpDeliverySftpDeliveryStatus>;
  sftpDeliveryStatusNotIn?: InputMaybe<Array<ReportFileSftpDeliverySftpDeliveryStatus>>;
  /** sftp_destination field predicates */
  sftpDestination?: InputMaybe<ReportFileSftpDeliverySftpDestination>;
  sftpDestinationIn?: InputMaybe<Array<ReportFileSftpDeliverySftpDestination>>;
  sftpDestinationNEQ?: InputMaybe<ReportFileSftpDeliverySftpDestination>;
  sftpDestinationNotIn?: InputMaybe<Array<ReportFileSftpDeliverySftpDestination>>;
  /** verified_at field predicates */
  verifiedAt?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtGT?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  verifiedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedAtLT?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  verifiedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** verified_by field predicates */
  verifiedBy?: InputMaybe<Scalars['String']['input']>;
  verifiedByContains?: InputMaybe<Scalars['String']['input']>;
  verifiedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  verifiedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  verifiedByGT?: InputMaybe<Scalars['String']['input']>;
  verifiedByGTE?: InputMaybe<Scalars['String']['input']>;
  verifiedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  verifiedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  verifiedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  verifiedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedByLT?: InputMaybe<Scalars['String']['input']>;
  verifiedByLTE?: InputMaybe<Scalars['String']['input']>;
  verifiedByNEQ?: InputMaybe<Scalars['String']['input']>;
  verifiedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  verifiedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportFileSwiftDelivery = Node & {
  __typename: 'ReportFileSwiftDelivery';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  deliveredAt: Maybe<Scalars['Time']['output']>;
  errorMsg: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  queueName: Scalars['String']['output'];
  reportFileID: Scalars['ID']['output'];
  reportFiles: ReportFile;
  swiftDeliveryStatus: ReportFileSwiftDeliverySwiftDeliveryStatus;
  swiftDestination: ReportFileSwiftDeliverySwiftDestination;
  temporalWorkflowID: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ReportFileSwiftDeliveryConnection = {
  __typename: 'ReportFileSwiftDeliveryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportFileSwiftDeliveryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportFileSwiftDeliveryEdge = {
  __typename: 'ReportFileSwiftDeliveryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportFileSwiftDelivery>;
};

/** ReportFileSwiftDeliverySwiftDeliveryStatus is enum for the field swift_delivery_status */
export enum ReportFileSwiftDeliverySwiftDeliveryStatus {
  SWIFT_DELIVERY_STATUS_DELIVERED = 'SWIFT_DELIVERY_STATUS_DELIVERED',
  SWIFT_DELIVERY_STATUS_FAILED = 'SWIFT_DELIVERY_STATUS_FAILED',
  SWIFT_DELIVERY_STATUS_FAILED_UNRETRIABLE = 'SWIFT_DELIVERY_STATUS_FAILED_UNRETRIABLE',
  SWIFT_DELIVERY_STATUS_UNSPECIFIED = 'SWIFT_DELIVERY_STATUS_UNSPECIFIED'
}

/** ReportFileSwiftDeliverySwiftDestination is enum for the field swift_destination */
export enum ReportFileSwiftDeliverySwiftDestination {
  SWIFT_DESTINATION_ANCHORAGE = 'SWIFT_DESTINATION_ANCHORAGE',
  SWIFT_DESTINATION_BLACKROCK = 'SWIFT_DESTINATION_BLACKROCK',
  SWIFT_DESTINATION_UNSPECIFIED = 'SWIFT_DESTINATION_UNSPECIFIED'
}

/**
 * ReportFileSwiftDeliveryWhereInput is used for filtering ReportFileSwiftDelivery objects.
 * Input was generated by ent.
 */
export type ReportFileSwiftDeliveryWhereInput = {
  and?: InputMaybe<Array<ReportFileSwiftDeliveryWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** delivered_at field predicates */
  deliveredAt?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtGT?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deliveredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deliveredAtLT?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deliveredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deliveredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** error_msg field predicates */
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  errorMsgContains?: InputMaybe<Scalars['String']['input']>;
  errorMsgContainsFold?: InputMaybe<Scalars['String']['input']>;
  errorMsgEqualFold?: InputMaybe<Scalars['String']['input']>;
  errorMsgGT?: InputMaybe<Scalars['String']['input']>;
  errorMsgGTE?: InputMaybe<Scalars['String']['input']>;
  errorMsgHasPrefix?: InputMaybe<Scalars['String']['input']>;
  errorMsgHasSuffix?: InputMaybe<Scalars['String']['input']>;
  errorMsgIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMsgIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  errorMsgLT?: InputMaybe<Scalars['String']['input']>;
  errorMsgLTE?: InputMaybe<Scalars['String']['input']>;
  errorMsgNEQ?: InputMaybe<Scalars['String']['input']>;
  errorMsgNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMsgNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_files edge predicates */
  hasReportFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportFilesWith?: InputMaybe<Array<ReportFileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportFileSwiftDeliveryWhereInput>;
  or?: InputMaybe<Array<ReportFileSwiftDeliveryWhereInput>>;
  /** queue_name field predicates */
  queueName?: InputMaybe<Scalars['String']['input']>;
  queueNameContains?: InputMaybe<Scalars['String']['input']>;
  queueNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  queueNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  queueNameGT?: InputMaybe<Scalars['String']['input']>;
  queueNameGTE?: InputMaybe<Scalars['String']['input']>;
  queueNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  queueNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  queueNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  queueNameLT?: InputMaybe<Scalars['String']['input']>;
  queueNameLTE?: InputMaybe<Scalars['String']['input']>;
  queueNameNEQ?: InputMaybe<Scalars['String']['input']>;
  queueNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** report_file_id field predicates */
  reportFileID?: InputMaybe<Scalars['ID']['input']>;
  reportFileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reportFileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  reportFileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** swift_delivery_status field predicates */
  swiftDeliveryStatus?: InputMaybe<ReportFileSwiftDeliverySwiftDeliveryStatus>;
  swiftDeliveryStatusIn?: InputMaybe<Array<ReportFileSwiftDeliverySwiftDeliveryStatus>>;
  swiftDeliveryStatusNEQ?: InputMaybe<ReportFileSwiftDeliverySwiftDeliveryStatus>;
  swiftDeliveryStatusNotIn?: InputMaybe<Array<ReportFileSwiftDeliverySwiftDeliveryStatus>>;
  /** swift_destination field predicates */
  swiftDestination?: InputMaybe<ReportFileSwiftDeliverySwiftDestination>;
  swiftDestinationIn?: InputMaybe<Array<ReportFileSwiftDeliverySwiftDestination>>;
  swiftDestinationNEQ?: InputMaybe<ReportFileSwiftDeliverySwiftDestination>;
  swiftDestinationNotIn?: InputMaybe<Array<ReportFileSwiftDeliverySwiftDestination>>;
  /** temporal_workflow_id field predicates */
  temporalWorkflowID?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDContains?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDGT?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDGTE?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  temporalWorkflowIDLT?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDLTE?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDNEQ?: InputMaybe<Scalars['String']['input']>;
  temporalWorkflowIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReportFileValidation = Node & {
  __typename: 'ReportFileValidation';
  /** When the validation record was created */
  createdAt: Scalars['Time']['output'];
  /** Human-readable description of what the validation checks */
  description: Maybe<Scalars['String']['output']>;
  /** Human-readable messages describing the details of validation checks that failed */
  failureCauses: Maybe<Array<Scalars['String']['output']>>;
  /** Unique identifier for the validation record */
  id: Scalars['ID']['output'];
  /** Machine-readable validation name (e.g. 'balance_reconciliation') */
  name: Scalars['String']['output'];
  /** True when the validation check passed */
  pass: Scalars['Boolean']['output'];
  /** Relationship to parent report file */
  reportFile: ReportFile;
  /** FK to parent report file */
  reportFileID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type ReportFileValidationConnection = {
  __typename: 'ReportFileValidationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportFileValidationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportFileValidationEdge = {
  __typename: 'ReportFileValidationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportFileValidation>;
};

/**
 * ReportFileValidationWhereInput is used for filtering ReportFileValidation objects.
 * Input was generated by ent.
 */
export type ReportFileValidationWhereInput = {
  and?: InputMaybe<Array<ReportFileValidationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_file edge predicates */
  hasReportFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportFilesWith?: InputMaybe<Array<ReportFileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ReportFileValidationWhereInput>;
  or?: InputMaybe<Array<ReportFileValidationWhereInput>>;
  /** pass field predicates */
  pass?: InputMaybe<Scalars['Boolean']['input']>;
  passNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_file_id field predicates */
  reportFileID?: InputMaybe<Scalars['ID']['input']>;
  reportFileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reportFileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  reportFileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ReportFileVerification = Node & {
  __typename: 'ReportFileVerification';
  /** True when the system auto-verified this file (auto_send=true and all validations passed); false when verified by a human */
  autoVerified: Scalars['Boolean']['output'];
  /** When the verification was canceled */
  canceledAt: Maybe<Scalars['Time']['output']>;
  /** User that canceled the verification; the report file will not be delivered */
  canceledBy: Maybe<Scalars['String']['output']>;
  /** When file was uploaded to verification bucket */
  createdAt: Scalars['Time']['output'];
  /** User that created the verification record / initiated the verification flow */
  createdBy: Scalars['String']['output'];
  /** Full path to file in verification bucket (e.g., _report_type=etf/_cutoff_date=2025-11-19/.../report.csv) */
  fileURL: Scalars['String']['output'];
  /** Unique identifier for verification record */
  id: Scalars['ID']['output'];
  /** Reason provided when overriding verification to approve file for delivery */
  overrideReason: Maybe<Scalars['String']['output']>;
  /** Relationship to parent report file */
  reportFile: ReportFile;
  /** Current verification status (PENDING, VERIFIED, or CANCELED) */
  verificationStatus: ReportFileVerificationVerificationStatus;
  /** When verification was completed and file approved for delivery */
  verifiedAt: Maybe<Scalars['Time']['output']>;
  /** User that verified the file */
  verifiedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type ReportFileVerificationConnection = {
  __typename: 'ReportFileVerificationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportFileVerificationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportFileVerificationEdge = {
  __typename: 'ReportFileVerificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportFileVerification>;
};

/** Ordering options for ReportFileVerification connections */
export type ReportFileVerificationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ReportFileVerifications. */
  field: ReportFileVerificationOrderField;
};

/** Properties by which ReportFileVerification connections can be ordered. */
export enum ReportFileVerificationOrderField {
  CREATED_AT = 'CREATED_AT'
}

/** ReportFileVerificationVerificationStatus is enum for the field verification_status */
export enum ReportFileVerificationVerificationStatus {
  VERIFICATION_STATUS_CANCELED = 'VERIFICATION_STATUS_CANCELED',
  VERIFICATION_STATUS_PENDING = 'VERIFICATION_STATUS_PENDING',
  VERIFICATION_STATUS_UNSPECIFIED = 'VERIFICATION_STATUS_UNSPECIFIED',
  VERIFICATION_STATUS_VERIFIED = 'VERIFICATION_STATUS_VERIFIED'
}

/**
 * ReportFileVerificationWhereInput is used for filtering ReportFileVerification objects.
 * Input was generated by ent.
 */
export type ReportFileVerificationWhereInput = {
  and?: InputMaybe<Array<ReportFileVerificationWhereInput>>;
  /** auto_verified field predicates */
  autoVerified?: InputMaybe<Scalars['Boolean']['input']>;
  autoVerifiedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** canceled_at field predicates */
  canceledAt?: InputMaybe<Scalars['Time']['input']>;
  canceledAtGT?: InputMaybe<Scalars['Time']['input']>;
  canceledAtGTE?: InputMaybe<Scalars['Time']['input']>;
  canceledAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  canceledAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  canceledAtLT?: InputMaybe<Scalars['Time']['input']>;
  canceledAtLTE?: InputMaybe<Scalars['Time']['input']>;
  canceledAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  canceledAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  canceledAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** canceled_by field predicates */
  canceledBy?: InputMaybe<Scalars['String']['input']>;
  canceledByContains?: InputMaybe<Scalars['String']['input']>;
  canceledByContainsFold?: InputMaybe<Scalars['String']['input']>;
  canceledByEqualFold?: InputMaybe<Scalars['String']['input']>;
  canceledByGT?: InputMaybe<Scalars['String']['input']>;
  canceledByGTE?: InputMaybe<Scalars['String']['input']>;
  canceledByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  canceledByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  canceledByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  canceledByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  canceledByLT?: InputMaybe<Scalars['String']['input']>;
  canceledByLTE?: InputMaybe<Scalars['String']['input']>;
  canceledByNEQ?: InputMaybe<Scalars['String']['input']>;
  canceledByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  canceledByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** file_url field predicates */
  fileURL?: InputMaybe<Scalars['String']['input']>;
  fileURLContains?: InputMaybe<Scalars['String']['input']>;
  fileURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  fileURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  fileURLGT?: InputMaybe<Scalars['String']['input']>;
  fileURLGTE?: InputMaybe<Scalars['String']['input']>;
  fileURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fileURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fileURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fileURLLT?: InputMaybe<Scalars['String']['input']>;
  fileURLLTE?: InputMaybe<Scalars['String']['input']>;
  fileURLNEQ?: InputMaybe<Scalars['String']['input']>;
  fileURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** report_file edge predicates */
  hasReportFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportFilesWith?: InputMaybe<Array<ReportFileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportFileVerificationWhereInput>;
  or?: InputMaybe<Array<ReportFileVerificationWhereInput>>;
  /** override_reason field predicates */
  overrideReason?: InputMaybe<Scalars['String']['input']>;
  overrideReasonContains?: InputMaybe<Scalars['String']['input']>;
  overrideReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  overrideReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  overrideReasonGT?: InputMaybe<Scalars['String']['input']>;
  overrideReasonGTE?: InputMaybe<Scalars['String']['input']>;
  overrideReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  overrideReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  overrideReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  overrideReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  overrideReasonLT?: InputMaybe<Scalars['String']['input']>;
  overrideReasonLTE?: InputMaybe<Scalars['String']['input']>;
  overrideReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  overrideReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  overrideReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** verification_status field predicates */
  verificationStatus?: InputMaybe<ReportFileVerificationVerificationStatus>;
  verificationStatusIn?: InputMaybe<Array<ReportFileVerificationVerificationStatus>>;
  verificationStatusNEQ?: InputMaybe<ReportFileVerificationVerificationStatus>;
  verificationStatusNotIn?: InputMaybe<Array<ReportFileVerificationVerificationStatus>>;
  /** verified_at field predicates */
  verifiedAt?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtGT?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  verifiedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedAtLT?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  verifiedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  verifiedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** verified_by field predicates */
  verifiedBy?: InputMaybe<Scalars['String']['input']>;
  verifiedByContains?: InputMaybe<Scalars['String']['input']>;
  verifiedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  verifiedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  verifiedByGT?: InputMaybe<Scalars['String']['input']>;
  verifiedByGTE?: InputMaybe<Scalars['String']['input']>;
  verifiedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  verifiedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  verifiedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  verifiedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedByLT?: InputMaybe<Scalars['String']['input']>;
  verifiedByLTE?: InputMaybe<Scalars['String']['input']>;
  verifiedByNEQ?: InputMaybe<Scalars['String']['input']>;
  verifiedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  verifiedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * ReportFileWhereInput is used for filtering ReportFile objects.
 * Input was generated by ent.
 */
export type ReportFileWhereInput = {
  and?: InputMaybe<Array<ReportFileWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_format field predicates */
  fileFormat?: InputMaybe<ReportFileFileFormat>;
  fileFormatIn?: InputMaybe<Array<ReportFileFileFormat>>;
  fileFormatNEQ?: InputMaybe<ReportFileFileFormat>;
  fileFormatNotIn?: InputMaybe<Array<ReportFileFileFormat>>;
  /** file_url field predicates */
  fileURL?: InputMaybe<Scalars['String']['input']>;
  fileURLContains?: InputMaybe<Scalars['String']['input']>;
  fileURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  fileURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  fileURLGT?: InputMaybe<Scalars['String']['input']>;
  fileURLGTE?: InputMaybe<Scalars['String']['input']>;
  fileURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fileURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fileURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fileURLLT?: InputMaybe<Scalars['String']['input']>;
  fileURLLTE?: InputMaybe<Scalars['String']['input']>;
  fileURLNEQ?: InputMaybe<Scalars['String']['input']>;
  fileURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** email_deliveries edge predicates */
  hasEmailDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmailDeliveriesWith?: InputMaybe<Array<ReportFileEmailDeliveryWhereInput>>;
  /** reports edge predicates */
  hasReports?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportsWith?: InputMaybe<Array<ReportWhereInput>>;
  /** sftp_deliveries edge predicates */
  hasSftpDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  hasSftpDeliveriesWith?: InputMaybe<Array<ReportFileSftpDeliveryWhereInput>>;
  /** swift_deliveries edge predicates */
  hasSwiftDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  hasSwiftDeliveriesWith?: InputMaybe<Array<ReportFileSwiftDeliveryWhereInput>>;
  /** validations edge predicates */
  hasValidations?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidationsWith?: InputMaybe<Array<ReportFileValidationWhereInput>>;
  /** verifications edge predicates */
  hasVerifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasVerificationsWith?: InputMaybe<Array<ReportFileVerificationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportFileWhereInput>;
  or?: InputMaybe<Array<ReportFileWhereInput>>;
};

export type ReportFilterConfig = {
  __typename: 'ReportFilterConfig';
  displayName: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  filterType: ReportDataFilterFilterType;
};

export type ReportFilterConfigValue = {
  __typename: 'ReportFilterConfigValue';
  displayValue: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReportFilterInput = {
  fieldName: Scalars['String']['input'];
  filterValues: Array<ReportFilterValueInput>;
};

export type ReportFilterValueInput = {
  displayValue: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Ordering options for Report connections */
export type ReportOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Reports. */
  field: ReportOrderField;
};

/** Properties by which Report connections can be ordered. */
export enum ReportOrderField {
  CREATED_AT = 'CREATED_AT'
}

/** ReportReportStatus is enum for the field report_status */
export enum ReportReportStatus {
  REPORT_STATUS_FAILED = 'REPORT_STATUS_FAILED',
  REPORT_STATUS_GENERATED = 'REPORT_STATUS_GENERATED',
  REPORT_STATUS_GENERATING_FILE = 'REPORT_STATUS_GENERATING_FILE',
  REPORT_STATUS_PENDING = 'REPORT_STATUS_PENDING',
  REPORT_STATUS_STARTED = 'REPORT_STATUS_STARTED',
  REPORT_STATUS_UNSPECIFIED = 'REPORT_STATUS_UNSPECIFIED'
}

export type ReportSchedule = Node & {
  __typename: 'ReportSchedule';
  activatedAt: Maybe<Scalars['Time']['output']>;
  activatedBy: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  createdByPubKeyID: Scalars['String']['output'];
  createdByUser: Actor;
  /** 1-31. Use 0 to indicate null. Must be set to other than 0 when schedule is not daily. For non-daily reports, represents the day of week or month on which the report will be triggered */
  daysAfterNonDailyScheduleTypeToTrigger: Scalars['Int']['output'];
  enabled: Maybe<Scalars['Boolean']['output']>;
  fileFormats: ReportScheduleFileFormatsConnection;
  /** 0-23 */
  hourOfDay: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if the schedule was created by a staff user */
  isCreatedByStaff: Scalars['Boolean']['output'];
  /** Indicates if the schedule was updated by a staff user */
  isUpdatedByStaff: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationID: Scalars['String']['output'];
  /**
   * Name of the organization the schedule belongs to. Falls back to
   * `organizationID` when the organization service does not know the id, so one
   * orphaned schedule cannot blank a paginated list.
   */
  organizationName: Scalars['String']['output'];
  pendingActivation: Scalars['Boolean']['output'];
  reportScheduleDataFilters: ReportScheduleDataFilterConnection;
  reportScheduleEmailDestinations: ReportScheduleEmailDestinationConnection;
  reportScheduleMainFilter: Maybe<ReportScheduleMainFilter>;
  reportScheduleSftpDestinations: ReportScheduleSftpDestinationConnection;
  reportScheduleSwiftDestinations: ReportScheduleSwiftDestinationConnection;
  reportType: Scalars['String']['output'];
  reportTypeDisplayName: Scalars['String']['output'];
  scheduleReports: ReportConnection;
  scheduleType: ReportScheduleScheduleType;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  updatedByUser: Actor;
};


export type ReportSchedulefileFormatsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportScheduleFileFormatsWhereInput>;
};


export type ReportSchedulereportScheduleDataFiltersArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportScheduleDataFilterWhereInput>;
};


export type ReportSchedulereportScheduleEmailDestinationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportScheduleEmailDestinationOrder>;
  where?: InputMaybe<ReportScheduleEmailDestinationWhereInput>;
};


export type ReportSchedulereportScheduleSftpDestinationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportScheduleSftpDestinationOrder>;
  where?: InputMaybe<ReportScheduleSftpDestinationWhereInput>;
};


export type ReportSchedulereportScheduleSwiftDestinationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportScheduleSwiftDestinationOrder>;
  where?: InputMaybe<ReportScheduleSwiftDestinationWhereInput>;
};


export type ReportSchedulescheduleReportsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportOrder>;
  where?: InputMaybe<ReportWhereInput>;
};

/** A connection to a list of items. */
export type ReportScheduleConnection = {
  __typename: 'ReportScheduleConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportScheduleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ReportScheduleDataFilter = Node & {
  __typename: 'ReportScheduleDataFilter';
  fieldDisplayName: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  filterType: ReportScheduleDataFilterFilterType;
  id: Scalars['ID']['output'];
  reportSchedule: ReportSchedule;
  reportScheduleDataFilterValues: ReportScheduleDataFilterValueConnection;
};


export type ReportScheduleDataFilterreportScheduleDataFilterValuesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportScheduleDataFilterValueWhereInput>;
};

/** A connection to a list of items. */
export type ReportScheduleDataFilterConnection = {
  __typename: 'ReportScheduleDataFilterConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportScheduleDataFilterEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportScheduleDataFilterEdge = {
  __typename: 'ReportScheduleDataFilterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportScheduleDataFilter>;
};

/** ReportScheduleDataFilterFilterType is enum for the field filter_type */
export enum ReportScheduleDataFilterFilterType {
  FILTER_TYPE_DATE_POINT = 'FILTER_TYPE_DATE_POINT',
  FILTER_TYPE_DATE_RANGE = 'FILTER_TYPE_DATE_RANGE',
  FILTER_TYPE_MULTI_SELECT = 'FILTER_TYPE_MULTI_SELECT',
  FILTER_TYPE_SINGLE_SELECT = 'FILTER_TYPE_SINGLE_SELECT',
  FILTER_TYPE_UNSPECIFIED = 'FILTER_TYPE_UNSPECIFIED'
}

export type ReportScheduleDataFilterValue = Node & {
  __typename: 'ReportScheduleDataFilterValue';
  displayValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reportScheduleDataFilter: ReportScheduleDataFilter;
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ReportScheduleDataFilterValueConnection = {
  __typename: 'ReportScheduleDataFilterValueConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportScheduleDataFilterValueEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportScheduleDataFilterValueEdge = {
  __typename: 'ReportScheduleDataFilterValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportScheduleDataFilterValue>;
};

/**
 * ReportScheduleDataFilterValueWhereInput is used for filtering ReportScheduleDataFilterValue objects.
 * Input was generated by ent.
 */
export type ReportScheduleDataFilterValueWhereInput = {
  and?: InputMaybe<Array<ReportScheduleDataFilterValueWhereInput>>;
  /** display_value field predicates */
  displayValue?: InputMaybe<Scalars['String']['input']>;
  displayValueContains?: InputMaybe<Scalars['String']['input']>;
  displayValueContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayValueEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayValueGT?: InputMaybe<Scalars['String']['input']>;
  displayValueGTE?: InputMaybe<Scalars['String']['input']>;
  displayValueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayValueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayValueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayValueLT?: InputMaybe<Scalars['String']['input']>;
  displayValueLTE?: InputMaybe<Scalars['String']['input']>;
  displayValueNEQ?: InputMaybe<Scalars['String']['input']>;
  displayValueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** report_schedule_data_filter edge predicates */
  hasReportScheduleDataFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportScheduleDataFiltersWith?: InputMaybe<Array<ReportScheduleDataFilterWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportScheduleDataFilterValueWhereInput>;
  or?: InputMaybe<Array<ReportScheduleDataFilterValueWhereInput>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * ReportScheduleDataFilterWhereInput is used for filtering ReportScheduleDataFilter objects.
 * Input was generated by ent.
 */
export type ReportScheduleDataFilterWhereInput = {
  and?: InputMaybe<Array<ReportScheduleDataFilterWhereInput>>;
  /** field_display_name field predicates */
  fieldDisplayName?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameContains?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameGT?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameGTE?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldDisplayNameLT?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameLTE?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** field_name field predicates */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldNameContains?: InputMaybe<Scalars['String']['input']>;
  fieldNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameGT?: InputMaybe<Scalars['String']['input']>;
  fieldNameGTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fieldNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldNameLT?: InputMaybe<Scalars['String']['input']>;
  fieldNameLTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fieldNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter_type field predicates */
  filterType?: InputMaybe<ReportScheduleDataFilterFilterType>;
  filterTypeIn?: InputMaybe<Array<ReportScheduleDataFilterFilterType>>;
  filterTypeNEQ?: InputMaybe<ReportScheduleDataFilterFilterType>;
  filterTypeNotIn?: InputMaybe<Array<ReportScheduleDataFilterFilterType>>;
  /** report_schedule_data_filter_values edge predicates */
  hasReportScheduleDataFilterValues?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportScheduleDataFilterValuesWith?: InputMaybe<Array<ReportScheduleDataFilterValueWhereInput>>;
  /** report_schedule edge predicates */
  hasReportSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportSchedulesWith?: InputMaybe<Array<ReportScheduleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportScheduleDataFilterWhereInput>;
  or?: InputMaybe<Array<ReportScheduleDataFilterWhereInput>>;
};

/** An edge in a connection. */
export type ReportScheduleEdge = {
  __typename: 'ReportScheduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportSchedule>;
};

export type ReportScheduleEmailDestination = Node & {
  __typename: 'ReportScheduleEmailDestination';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  /** Template for the email attachment file name, without extension. Tokens: {report_type}, {date}, {date_compact}, {org_id}; other characters must be letters, digits, underscore or hyphen. Example: bq_etf_balance_report_24h_{date}. Defaults to {report_type}_24h_{date} when unset. Staff only. */
  deliveryFileName: Maybe<Scalars['String']['output']>;
  emailDestination: Scalars['String']['output'];
  enabled: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  reportSchedule: ReportSchedule;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type ReportScheduleEmailDestinationConnection = {
  __typename: 'ReportScheduleEmailDestinationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportScheduleEmailDestinationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportScheduleEmailDestinationEdge = {
  __typename: 'ReportScheduleEmailDestinationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportScheduleEmailDestination>;
};

/** Ordering options for ReportScheduleEmailDestination connections */
export type ReportScheduleEmailDestinationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ReportScheduleEmailDestinations. */
  field: ReportScheduleEmailDestinationOrderField;
};

/** Properties by which ReportScheduleEmailDestination connections can be ordered. */
export enum ReportScheduleEmailDestinationOrderField {
  CREATED_AT = 'CREATED_AT'
}

/**
 * ReportScheduleEmailDestinationWhereInput is used for filtering ReportScheduleEmailDestination objects.
 * Input was generated by ent.
 */
export type ReportScheduleEmailDestinationWhereInput = {
  and?: InputMaybe<Array<ReportScheduleEmailDestinationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** delivery_file_name field predicates */
  deliveryFileName?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameContains?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameGT?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameGTE?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryFileNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryFileNameLT?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameLTE?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameNEQ?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryFileNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_destination field predicates */
  emailDestination?: InputMaybe<Scalars['String']['input']>;
  emailDestinationContains?: InputMaybe<Scalars['String']['input']>;
  emailDestinationContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailDestinationEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailDestinationGT?: InputMaybe<Scalars['String']['input']>;
  emailDestinationGTE?: InputMaybe<Scalars['String']['input']>;
  emailDestinationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailDestinationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailDestinationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailDestinationLT?: InputMaybe<Scalars['String']['input']>;
  emailDestinationLTE?: InputMaybe<Scalars['String']['input']>;
  emailDestinationNEQ?: InputMaybe<Scalars['String']['input']>;
  emailDestinationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_schedule edge predicates */
  hasReportSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportSchedulesWith?: InputMaybe<Array<ReportScheduleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportScheduleEmailDestinationWhereInput>;
  or?: InputMaybe<Array<ReportScheduleEmailDestinationWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportScheduleFileFormats = Node & {
  __typename: 'ReportScheduleFileFormats';
  fileFormat: ReportScheduleFileFormatsFileFormat;
  id: Scalars['ID']['output'];
  reportSchedule: ReportSchedule;
};

/** A connection to a list of items. */
export type ReportScheduleFileFormatsConnection = {
  __typename: 'ReportScheduleFileFormatsConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportScheduleFileFormatsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportScheduleFileFormatsEdge = {
  __typename: 'ReportScheduleFileFormatsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportScheduleFileFormats>;
};

/** ReportScheduleFileFormatsFileFormat is enum for the field file_format */
export enum ReportScheduleFileFormatsFileFormat {
  FILE_FORMAT_CSV = 'FILE_FORMAT_CSV',
  FILE_FORMAT_MT = 'FILE_FORMAT_MT',
  FILE_FORMAT_UNSPECIFIED = 'FILE_FORMAT_UNSPECIFIED'
}

/**
 * ReportScheduleFileFormatsWhereInput is used for filtering ReportScheduleFileFormats objects.
 * Input was generated by ent.
 */
export type ReportScheduleFileFormatsWhereInput = {
  and?: InputMaybe<Array<ReportScheduleFileFormatsWhereInput>>;
  /** file_format field predicates */
  fileFormat?: InputMaybe<ReportScheduleFileFormatsFileFormat>;
  fileFormatIn?: InputMaybe<Array<ReportScheduleFileFormatsFileFormat>>;
  fileFormatNEQ?: InputMaybe<ReportScheduleFileFormatsFileFormat>;
  fileFormatNotIn?: InputMaybe<Array<ReportScheduleFileFormatsFileFormat>>;
  /** report_schedule edge predicates */
  hasReportSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportSchedulesWith?: InputMaybe<Array<ReportScheduleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportScheduleFileFormatsWhereInput>;
  or?: InputMaybe<Array<ReportScheduleFileFormatsWhereInput>>;
};

export type ReportScheduleMainFilter = Node & {
  __typename: 'ReportScheduleMainFilter';
  fieldDisplayName: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  filterType: ReportScheduleMainFilterFilterType;
  id: Scalars['ID']['output'];
  reportSchedule: ReportSchedule;
  scheduleFilterPoint: ReportScheduleMainFilterScheduleFilterPoint;
  scheduleFilterRange: ReportScheduleMainFilterScheduleFilterRange;
};

/** A connection to a list of items. */
export type ReportScheduleMainFilterConnection = {
  __typename: 'ReportScheduleMainFilterConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportScheduleMainFilterEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportScheduleMainFilterEdge = {
  __typename: 'ReportScheduleMainFilterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportScheduleMainFilter>;
};

/** ReportScheduleMainFilterFilterType is enum for the field filter_type */
export enum ReportScheduleMainFilterFilterType {
  FILTER_TYPE_DATE_POINT = 'FILTER_TYPE_DATE_POINT',
  FILTER_TYPE_DATE_RANGE = 'FILTER_TYPE_DATE_RANGE',
  FILTER_TYPE_MULTI_SELECT = 'FILTER_TYPE_MULTI_SELECT',
  FILTER_TYPE_SINGLE_SELECT = 'FILTER_TYPE_SINGLE_SELECT',
  FILTER_TYPE_UNSPECIFIED = 'FILTER_TYPE_UNSPECIFIED'
}

/** ReportScheduleMainFilterScheduleFilterPoint is enum for the field schedule_filter_point */
export enum ReportScheduleMainFilterScheduleFilterPoint {
  POINT_END_OF_LAST_MONTH = 'POINT_END_OF_LAST_MONTH',
  POINT_END_OF_LAST_QUARTER = 'POINT_END_OF_LAST_QUARTER',
  POINT_END_OF_LAST_WEEK = 'POINT_END_OF_LAST_WEEK',
  POINT_END_OF_LAST_YEAR = 'POINT_END_OF_LAST_YEAR',
  POINT_PREVIOUS_WEEK_DAY = 'POINT_PREVIOUS_WEEK_DAY',
  POINT_UNSPECIFIED = 'POINT_UNSPECIFIED',
  POINT_YESTERDAY = 'POINT_YESTERDAY'
}

/** ReportScheduleMainFilterScheduleFilterRange is enum for the field schedule_filter_range */
export enum ReportScheduleMainFilterScheduleFilterRange {
  RANGE_LAST_MONTH = 'RANGE_LAST_MONTH',
  RANGE_LAST_QUARTER = 'RANGE_LAST_QUARTER',
  RANGE_LAST_WEEK = 'RANGE_LAST_WEEK',
  RANGE_LAST_YEAR = 'RANGE_LAST_YEAR',
  RANGE_MONTH_TO_DATE = 'RANGE_MONTH_TO_DATE',
  RANGE_PREVIOUS_WEEK_DAY = 'RANGE_PREVIOUS_WEEK_DAY',
  RANGE_QUARTER_TO_DATE = 'RANGE_QUARTER_TO_DATE',
  RANGE_UNSPECIFIED = 'RANGE_UNSPECIFIED',
  RANGE_WEEK_TO_DATE = 'RANGE_WEEK_TO_DATE',
  RANGE_YEAR_TO_DATE = 'RANGE_YEAR_TO_DATE',
  RANGE_YESTERDAY = 'RANGE_YESTERDAY'
}

/**
 * ReportScheduleMainFilterWhereInput is used for filtering ReportScheduleMainFilter objects.
 * Input was generated by ent.
 */
export type ReportScheduleMainFilterWhereInput = {
  and?: InputMaybe<Array<ReportScheduleMainFilterWhereInput>>;
  /** field_display_name field predicates */
  fieldDisplayName?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameContains?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameGT?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameGTE?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldDisplayNameLT?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameLTE?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fieldDisplayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** field_name field predicates */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldNameContains?: InputMaybe<Scalars['String']['input']>;
  fieldNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameGT?: InputMaybe<Scalars['String']['input']>;
  fieldNameGTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fieldNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldNameLT?: InputMaybe<Scalars['String']['input']>;
  fieldNameLTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fieldNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter_type field predicates */
  filterType?: InputMaybe<ReportScheduleMainFilterFilterType>;
  filterTypeIn?: InputMaybe<Array<ReportScheduleMainFilterFilterType>>;
  filterTypeNEQ?: InputMaybe<ReportScheduleMainFilterFilterType>;
  filterTypeNotIn?: InputMaybe<Array<ReportScheduleMainFilterFilterType>>;
  /** report_schedule edge predicates */
  hasReportSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportSchedulesWith?: InputMaybe<Array<ReportScheduleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportScheduleMainFilterWhereInput>;
  or?: InputMaybe<Array<ReportScheduleMainFilterWhereInput>>;
  /** schedule_filter_point field predicates */
  scheduleFilterPoint?: InputMaybe<ReportScheduleMainFilterScheduleFilterPoint>;
  scheduleFilterPointIn?: InputMaybe<Array<ReportScheduleMainFilterScheduleFilterPoint>>;
  scheduleFilterPointNEQ?: InputMaybe<ReportScheduleMainFilterScheduleFilterPoint>;
  scheduleFilterPointNotIn?: InputMaybe<Array<ReportScheduleMainFilterScheduleFilterPoint>>;
  /** schedule_filter_range field predicates */
  scheduleFilterRange?: InputMaybe<ReportScheduleMainFilterScheduleFilterRange>;
  scheduleFilterRangeIn?: InputMaybe<Array<ReportScheduleMainFilterScheduleFilterRange>>;
  scheduleFilterRangeNEQ?: InputMaybe<ReportScheduleMainFilterScheduleFilterRange>;
  scheduleFilterRangeNotIn?: InputMaybe<Array<ReportScheduleMainFilterScheduleFilterRange>>;
};

/** Ordering options for ReportSchedule connections */
export type ReportScheduleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ReportSchedules. */
  field: ReportScheduleOrderField;
};

/** Properties by which ReportSchedule connections can be ordered. */
export enum ReportScheduleOrderField {
  CREATED_AT = 'CREATED_AT'
}

/** ReportScheduleScheduleType is enum for the field schedule_type */
export enum ReportScheduleScheduleType {
  SCHEDULE_ANNUALLY = 'SCHEDULE_ANNUALLY',
  SCHEDULE_DAILY = 'SCHEDULE_DAILY',
  SCHEDULE_DAILY_WORKDAYS = 'SCHEDULE_DAILY_WORKDAYS',
  SCHEDULE_MONTHLY = 'SCHEDULE_MONTHLY',
  SCHEDULE_QUARTERLY = 'SCHEDULE_QUARTERLY',
  SCHEDULE_UNSPECIFIED = 'SCHEDULE_UNSPECIFIED',
  SCHEDULE_WEEKLY = 'SCHEDULE_WEEKLY'
}

export type ReportScheduleSftpDestination = Node & {
  __typename: 'ReportScheduleSftpDestination';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  /** Template for the SFTP object file name, without extension. Tokens: {prefix}, {report_type}, {date}, {date_compact}, {org_id}; {org_id} and a date token are required so names stay unique per organization and file date in the delivery bucket; other characters must be letters, digits, underscore or hyphen. {prefix} renders the destination file prefix followed by an underscore, or nothing when the destination has no prefix, so write {prefix}name rather than {prefix}_name. Example: {prefix}bq_etf_balance_report_{date}_{org_id}. Defaults to {prefix}{report_type}_{date}_{org_id} when unset. Staff only. Not applied to the legacy ETF report types delivered to BNY or US Bank, which use bespoke fixed names. */
  deliveryFileName: Maybe<Scalars['String']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  filePrefix: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reportSchedule: ReportSchedule;
  sftpDestination: ReportScheduleSftpDestinationSftpDestination;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type ReportScheduleSftpDestinationConnection = {
  __typename: 'ReportScheduleSftpDestinationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportScheduleSftpDestinationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportScheduleSftpDestinationEdge = {
  __typename: 'ReportScheduleSftpDestinationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportScheduleSftpDestination>;
};

/** Ordering options for ReportScheduleSftpDestination connections */
export type ReportScheduleSftpDestinationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ReportScheduleSftpDestinations. */
  field: ReportScheduleSftpDestinationOrderField;
};

/** Properties by which ReportScheduleSftpDestination connections can be ordered. */
export enum ReportScheduleSftpDestinationOrderField {
  CREATED_AT = 'CREATED_AT'
}

/** ReportScheduleSftpDestinationSftpDestination is enum for the field sftp_destination */
export enum ReportScheduleSftpDestinationSftpDestination {
  SFTP_DESTINATION_BITWISE = 'SFTP_DESTINATION_BITWISE',
  SFTP_DESTINATION_BLACKROCK = 'SFTP_DESTINATION_BLACKROCK',
  SFTP_DESTINATION_BNY = 'SFTP_DESTINATION_BNY',
  SFTP_DESTINATION_BYORE = 'SFTP_DESTINATION_BYORE',
  SFTP_DESTINATION_METAPLANET = 'SFTP_DESTINATION_METAPLANET',
  SFTP_DESTINATION_STATE_STREET = 'SFTP_DESTINATION_STATE_STREET',
  SFTP_DESTINATION_UNSPECIFIED = 'SFTP_DESTINATION_UNSPECIFIED',
  SFTP_DESTINATION_US_BANK = 'SFTP_DESTINATION_US_BANK'
}

/**
 * ReportScheduleSftpDestinationWhereInput is used for filtering ReportScheduleSftpDestination objects.
 * Input was generated by ent.
 */
export type ReportScheduleSftpDestinationWhereInput = {
  and?: InputMaybe<Array<ReportScheduleSftpDestinationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** delivery_file_name field predicates */
  deliveryFileName?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameContains?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameGT?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameGTE?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryFileNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryFileNameLT?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameLTE?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameNEQ?: InputMaybe<Scalars['String']['input']>;
  deliveryFileNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryFileNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** file_prefix field predicates */
  filePrefix?: InputMaybe<Scalars['String']['input']>;
  filePrefixContains?: InputMaybe<Scalars['String']['input']>;
  filePrefixContainsFold?: InputMaybe<Scalars['String']['input']>;
  filePrefixEqualFold?: InputMaybe<Scalars['String']['input']>;
  filePrefixGT?: InputMaybe<Scalars['String']['input']>;
  filePrefixGTE?: InputMaybe<Scalars['String']['input']>;
  filePrefixHasPrefix?: InputMaybe<Scalars['String']['input']>;
  filePrefixHasSuffix?: InputMaybe<Scalars['String']['input']>;
  filePrefixIn?: InputMaybe<Array<Scalars['String']['input']>>;
  filePrefixIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  filePrefixLT?: InputMaybe<Scalars['String']['input']>;
  filePrefixLTE?: InputMaybe<Scalars['String']['input']>;
  filePrefixNEQ?: InputMaybe<Scalars['String']['input']>;
  filePrefixNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  filePrefixNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_schedule edge predicates */
  hasReportSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportSchedulesWith?: InputMaybe<Array<ReportScheduleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportScheduleSftpDestinationWhereInput>;
  or?: InputMaybe<Array<ReportScheduleSftpDestinationWhereInput>>;
  /** sftp_destination field predicates */
  sftpDestination?: InputMaybe<ReportScheduleSftpDestinationSftpDestination>;
  sftpDestinationIn?: InputMaybe<Array<ReportScheduleSftpDestinationSftpDestination>>;
  sftpDestinationNEQ?: InputMaybe<ReportScheduleSftpDestinationSftpDestination>;
  sftpDestinationNotIn?: InputMaybe<Array<ReportScheduleSftpDestinationSftpDestination>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportScheduleSwiftDestination = Node & {
  __typename: 'ReportScheduleSwiftDestination';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  enabled: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  reportSchedule: ReportSchedule;
  swiftDestination: ReportScheduleSwiftDestinationSwiftDestination;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type ReportScheduleSwiftDestinationConnection = {
  __typename: 'ReportScheduleSwiftDestinationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportScheduleSwiftDestinationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportScheduleSwiftDestinationEdge = {
  __typename: 'ReportScheduleSwiftDestinationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportScheduleSwiftDestination>;
};

/** Ordering options for ReportScheduleSwiftDestination connections */
export type ReportScheduleSwiftDestinationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ReportScheduleSwiftDestinations. */
  field: ReportScheduleSwiftDestinationOrderField;
};

/** Properties by which ReportScheduleSwiftDestination connections can be ordered. */
export enum ReportScheduleSwiftDestinationOrderField {
  CREATED_AT = 'CREATED_AT'
}

/** ReportScheduleSwiftDestinationSwiftDestination is enum for the field swift_destination */
export enum ReportScheduleSwiftDestinationSwiftDestination {
  SWIFT_DESTINATION_ANCHORAGE = 'SWIFT_DESTINATION_ANCHORAGE',
  SWIFT_DESTINATION_BLACKROCK = 'SWIFT_DESTINATION_BLACKROCK',
  SWIFT_DESTINATION_UNSPECIFIED = 'SWIFT_DESTINATION_UNSPECIFIED'
}

/**
 * ReportScheduleSwiftDestinationWhereInput is used for filtering ReportScheduleSwiftDestination objects.
 * Input was generated by ent.
 */
export type ReportScheduleSwiftDestinationWhereInput = {
  and?: InputMaybe<Array<ReportScheduleSwiftDestinationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_schedule edge predicates */
  hasReportSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportSchedulesWith?: InputMaybe<Array<ReportScheduleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReportScheduleSwiftDestinationWhereInput>;
  or?: InputMaybe<Array<ReportScheduleSwiftDestinationWhereInput>>;
  /** swift_destination field predicates */
  swiftDestination?: InputMaybe<ReportScheduleSwiftDestinationSwiftDestination>;
  swiftDestinationIn?: InputMaybe<Array<ReportScheduleSwiftDestinationSwiftDestination>>;
  swiftDestinationNEQ?: InputMaybe<ReportScheduleSwiftDestinationSwiftDestination>;
  swiftDestinationNotIn?: InputMaybe<Array<ReportScheduleSwiftDestinationSwiftDestination>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * ReportScheduleWhereInput is used for filtering ReportSchedule objects.
 * Input was generated by ent.
 */
export type ReportScheduleWhereInput = {
  /** activated_at field predicates */
  activatedAt?: InputMaybe<Scalars['Time']['input']>;
  activatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  activatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  activatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  activatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  activatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  activatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** activated_by field predicates */
  activatedBy?: InputMaybe<Scalars['String']['input']>;
  activatedByContains?: InputMaybe<Scalars['String']['input']>;
  activatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  activatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  activatedByGT?: InputMaybe<Scalars['String']['input']>;
  activatedByGTE?: InputMaybe<Scalars['String']['input']>;
  activatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  activatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  activatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  activatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activatedByLT?: InputMaybe<Scalars['String']['input']>;
  activatedByLTE?: InputMaybe<Scalars['String']['input']>;
  activatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  activatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  activatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<ReportScheduleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_by_pub_key_id field predicates */
  createdByPubKeyID?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDContains?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDGT?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDGTE?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByPubKeyIDLT?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDLTE?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** days_after_non_daily_schedule_type_to_trigger field predicates */
  daysAfterNonDailyScheduleTypeToTrigger?: InputMaybe<Scalars['Int']['input']>;
  daysAfterNonDailyScheduleTypeToTriggerGT?: InputMaybe<Scalars['Int']['input']>;
  daysAfterNonDailyScheduleTypeToTriggerGTE?: InputMaybe<Scalars['Int']['input']>;
  daysAfterNonDailyScheduleTypeToTriggerIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysAfterNonDailyScheduleTypeToTriggerLT?: InputMaybe<Scalars['Int']['input']>;
  daysAfterNonDailyScheduleTypeToTriggerLTE?: InputMaybe<Scalars['Int']['input']>;
  daysAfterNonDailyScheduleTypeToTriggerNEQ?: InputMaybe<Scalars['Int']['input']>;
  daysAfterNonDailyScheduleTypeToTriggerNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** file_formats edge predicates */
  hasFileFormats?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileFormatsWith?: InputMaybe<Array<ReportScheduleFileFormatsWhereInput>>;
  /** report_schedule_data_filters edge predicates */
  hasReportScheduleDataFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportScheduleDataFiltersWith?: InputMaybe<Array<ReportScheduleDataFilterWhereInput>>;
  /** report_schedule_email_destinations edge predicates */
  hasReportScheduleEmailDestinations?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportScheduleEmailDestinationsWith?: InputMaybe<Array<ReportScheduleEmailDestinationWhereInput>>;
  /** report_schedule_main_filter edge predicates */
  hasReportScheduleMainFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportScheduleMainFiltersWith?: InputMaybe<Array<ReportScheduleMainFilterWhereInput>>;
  /** report_schedule_sftp_destinations edge predicates */
  hasReportScheduleSftpDestinations?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportScheduleSftpDestinationsWith?: InputMaybe<Array<ReportScheduleSftpDestinationWhereInput>>;
  /** report_schedule_swift_destinations edge predicates */
  hasReportScheduleSwiftDestinations?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportScheduleSwiftDestinationsWith?: InputMaybe<Array<ReportScheduleSwiftDestinationWhereInput>>;
  /** schedule_reports edge predicates */
  hasScheduleReports?: InputMaybe<Scalars['Boolean']['input']>;
  hasScheduleReportsWith?: InputMaybe<Array<ReportWhereInput>>;
  /** hour_of_day field predicates */
  hourOfDay?: InputMaybe<Scalars['Int']['input']>;
  hourOfDayGT?: InputMaybe<Scalars['Int']['input']>;
  hourOfDayGTE?: InputMaybe<Scalars['Int']['input']>;
  hourOfDayIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  hourOfDayLT?: InputMaybe<Scalars['Int']['input']>;
  hourOfDayLTE?: InputMaybe<Scalars['Int']['input']>;
  hourOfDayNEQ?: InputMaybe<Scalars['Int']['input']>;
  hourOfDayNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_created_by_staff field predicates */
  isCreatedByStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isCreatedByStaffNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_updated_by_staff field predicates */
  isUpdatedByStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedByStaffNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ReportScheduleWhereInput>;
  or?: InputMaybe<Array<ReportScheduleWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['String']['input']>;
  organizationIDContains?: InputMaybe<Scalars['String']['input']>;
  organizationIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  organizationIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  organizationIDGT?: InputMaybe<Scalars['String']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['String']['input']>;
  organizationIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  organizationIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIDLT?: InputMaybe<Scalars['String']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['String']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['String']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** pending_activation field predicates */
  pendingActivation?: InputMaybe<Scalars['Boolean']['input']>;
  pendingActivationNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_type field predicates */
  reportType?: InputMaybe<Scalars['String']['input']>;
  reportTypeContains?: InputMaybe<Scalars['String']['input']>;
  reportTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  reportTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  reportTypeGT?: InputMaybe<Scalars['String']['input']>;
  reportTypeGTE?: InputMaybe<Scalars['String']['input']>;
  reportTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  reportTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  reportTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reportTypeLT?: InputMaybe<Scalars['String']['input']>;
  reportTypeLTE?: InputMaybe<Scalars['String']['input']>;
  reportTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  reportTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** schedule_type field predicates */
  scheduleType?: InputMaybe<ReportScheduleScheduleType>;
  scheduleTypeIn?: InputMaybe<Array<ReportScheduleScheduleType>>;
  scheduleTypeNEQ?: InputMaybe<ReportScheduleScheduleType>;
  scheduleTypeNotIn?: InputMaybe<Array<ReportScheduleScheduleType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportType = {
  __typename: 'ReportType';
  description: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outputFormat: ReportFileFileFormat;
};

export type ReportTypeConfig = {
  __typename: 'ReportTypeConfig';
  availableFilters: Array<Maybe<ReportFilterConfig>>;
  reportType: Scalars['String']['output'];
};

export type ReportTypeDefinition = Node & {
  __typename: 'ReportTypeDefinition';
  /** M4 dispatcher routing key: VIEW -> bqViewBacked builder, CUSTOM -> in-process Go provider. M3/M4 reject UNSPECIFIED at runtime. */
  backing: ReportTypeDefinitionBacking;
  /** See bq_project. */
  bqDataset: Maybe<Scalars['String']['output']>;
  /** Required only when backing=VIEW, enforced by M3 validation against the allow-list, NOT a DB constraint. */
  bqProject: Maybe<Scalars['String']['output']>;
  /** bq_project+bq_dataset+bq_view form the BQSource the M2 Store materializes. */
  bqView: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  discoveredAt: Maybe<Scalars['Time']['output']>;
  /**
   * Snapshot of the backing view's columns, taken when the type was registered and
   * replaced by each applied refreshReportTypeSchema. Always empty for a
   * CUSTOM-backed type, which has no BigQuery source. Stored as a JSON column
   * rather than an edge, so it is resolved separately from the generated fields.
   */
  discoveredSchema: Array<DiscoveredSchemaColumn>;
  displayName: Scalars['String']['output'];
  /** Soft-disable. Report types are never hard-deleted (historical reports and files reference the type id). */
  enabled: Scalars['Boolean']['output'];
  /**
   * Enabled schedules of every organization that reference this type: while it is
   * above zero, updateReportTypeDefinition refuses to disable the type.
   */
  enabledScheduleCount: Scalars['Int']['output'];
  filterDefinitions: ReportTypeFilterDefinitionConnection;
  headers: ReportTypeHeaderConnection;
  /** THE report-type identifier -- the same value legacy rows carry in report.type / report_schedule.report_type, not a surrogate alongside a second key. M4.5/M5 seeds set it explicitly to the legacy type UUID (create takes an explicit id; the default only serves brand-new types). Unique by primary key, so no secondary index. */
  id: Scalars['ID']['output'];
  isCreatedByStaff: Scalars['Boolean']['output'];
  isUpdatedByStaff: Scalars['Boolean']['output'];
  /** Whether a VIEW-backed CSV report keeps its legacy header row: each emitted header's display name becomes its header cell. Only a type that replaces or shadows a legacy type turns it on. */
  legacyHeaders: Scalars['Boolean']['output'];
  /** For org-visible VIEW reports, names the BQ-view column the M4 bqViewBacked builder binds WHERE <col> = @orgID. NULL for CUSTOM reports (they org-scope in Go). M3 validates it exists in discovered_schema for VIEW reports. */
  orgColumnName: Maybe<Scalars['String']['output']>;
  /** Permission applied to org (non-staff) users. Effective access default is enforced by the M2 FilterReportTypeAccess rule, not the column. */
  orgUserPermission: ReportTypeDefinitionOrgUserPermission;
  /** Rendering format, one per backing: CSV is BigQuery's own export of a VIEW-backed type, MT is the bytes a CUSTOM type's provider writes. */
  outputFormat: ReportTypeDefinitionOutputFormat;
  /** Team accountable for this report type's alerts, emitted as the owning_team metric tag next to report_type_uuid so Datadog monitors route on data instead of hand-synced UUID lists. A typed projection of the datadog-stack team registry — adding a team is registry-first. Sentinel-as-unset with a NOT NULL default keeps the migration additive; UNSPECIFIED is rejected on write. ATTRIBUTION ONLY — never consulted by any permission decision. */
  owningTeam: ReportTypeDefinitionOwningTeam;
  /** Permission applied to staff users. Orthogonal to org_user_permission (request-time user kind selects one). Effective default enforced in M2. */
  staffUserPermission: ReportTypeDefinitionStaffUserPermission;
  /**
   * The same for its configured filter definitions, whose predicate columns stop
   * the generated query being built rather than a column being emitted.
   */
  staleFilterSourceColumns: Array<Scalars['String']['output']>;
  /**
   * Source columns of this type's configured headers that its own snapshot no
   * longer has, computed in memory and empty for a type never introspected.
   */
  staleHeaderSourceColumns: Array<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  validations: ReportTypeValidationConnection;
  /** Optimistic-concurrency version of the whole definition aggregate. Starts at 1; every write against an existing definition compares and increments it. */
  version: Scalars['Int']['output'];
};


export type ReportTypeDefinitionfilterDefinitionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportTypeFilterDefinitionWhereInput>;
};


export type ReportTypeDefinitionheadersArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReportTypeHeaderWhereInput>;
};


export type ReportTypeDefinitionvalidationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportTypeValidationOrder>;
  where?: InputMaybe<ReportTypeValidationWhereInput>;
};

/** ReportTypeDefinitionBacking is enum for the field backing */
export enum ReportTypeDefinitionBacking {
  BACKING_CUSTOM = 'BACKING_CUSTOM',
  BACKING_UNSPECIFIED = 'BACKING_UNSPECIFIED',
  BACKING_VIEW = 'BACKING_VIEW'
}

/** A connection to a list of items. */
export type ReportTypeDefinitionConnection = {
  __typename: 'ReportTypeDefinitionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportTypeDefinitionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportTypeDefinitionEdge = {
  __typename: 'ReportTypeDefinitionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportTypeDefinition>;
};

/** ReportTypeDefinitionOrgUserPermission is enum for the field org_user_permission */
export enum ReportTypeDefinitionOrgUserPermission {
  REPORT_TYPE_PERMISSION_NO_ACCESS = 'REPORT_TYPE_PERMISSION_NO_ACCESS',
  REPORT_TYPE_PERMISSION_READ_ONLY = 'REPORT_TYPE_PERMISSION_READ_ONLY',
  REPORT_TYPE_PERMISSION_READ_WRITE = 'REPORT_TYPE_PERMISSION_READ_WRITE',
  REPORT_TYPE_PERMISSION_UNSPECIFIED = 'REPORT_TYPE_PERMISSION_UNSPECIFIED'
}

/** ReportTypeDefinitionOutputFormat is enum for the field output_format */
export enum ReportTypeDefinitionOutputFormat {
  REPORT_OUTPUT_FORMAT_CSV = 'REPORT_OUTPUT_FORMAT_CSV',
  REPORT_OUTPUT_FORMAT_MT = 'REPORT_OUTPUT_FORMAT_MT',
  REPORT_OUTPUT_FORMAT_UNSPECIFIED = 'REPORT_OUTPUT_FORMAT_UNSPECIFIED'
}

/** ReportTypeDefinitionOwningTeam is enum for the field owning_team */
export enum ReportTypeDefinitionOwningTeam {
  OWNING_TEAM_CUSTODY = 'OWNING_TEAM_CUSTODY',
  OWNING_TEAM_DATA_PLATFORM = 'OWNING_TEAM_DATA_PLATFORM',
  OWNING_TEAM_STAKING_AND_ASSET_MANAGEMENT = 'OWNING_TEAM_STAKING_AND_ASSET_MANAGEMENT',
  OWNING_TEAM_TRADING = 'OWNING_TEAM_TRADING',
  OWNING_TEAM_UNSPECIFIED = 'OWNING_TEAM_UNSPECIFIED'
}

/** ReportTypeDefinitionStaffUserPermission is enum for the field staff_user_permission */
export enum ReportTypeDefinitionStaffUserPermission {
  REPORT_TYPE_PERMISSION_NO_ACCESS = 'REPORT_TYPE_PERMISSION_NO_ACCESS',
  REPORT_TYPE_PERMISSION_READ_ONLY = 'REPORT_TYPE_PERMISSION_READ_ONLY',
  REPORT_TYPE_PERMISSION_READ_WRITE = 'REPORT_TYPE_PERMISSION_READ_WRITE',
  REPORT_TYPE_PERMISSION_UNSPECIFIED = 'REPORT_TYPE_PERMISSION_UNSPECIFIED'
}

/**
 * ReportTypeDefinitionWhereInput is used for filtering ReportTypeDefinition objects.
 * Input was generated by ent.
 */
export type ReportTypeDefinitionWhereInput = {
  and?: InputMaybe<Array<ReportTypeDefinitionWhereInput>>;
  /** backing field predicates */
  backing?: InputMaybe<ReportTypeDefinitionBacking>;
  backingIn?: InputMaybe<Array<ReportTypeDefinitionBacking>>;
  backingNEQ?: InputMaybe<ReportTypeDefinitionBacking>;
  backingNotIn?: InputMaybe<Array<ReportTypeDefinitionBacking>>;
  /** bq_dataset field predicates */
  bqDataset?: InputMaybe<Scalars['String']['input']>;
  bqDatasetContains?: InputMaybe<Scalars['String']['input']>;
  bqDatasetContainsFold?: InputMaybe<Scalars['String']['input']>;
  bqDatasetEqualFold?: InputMaybe<Scalars['String']['input']>;
  bqDatasetGT?: InputMaybe<Scalars['String']['input']>;
  bqDatasetGTE?: InputMaybe<Scalars['String']['input']>;
  bqDatasetHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bqDatasetHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bqDatasetIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bqDatasetIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bqDatasetLT?: InputMaybe<Scalars['String']['input']>;
  bqDatasetLTE?: InputMaybe<Scalars['String']['input']>;
  bqDatasetNEQ?: InputMaybe<Scalars['String']['input']>;
  bqDatasetNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bqDatasetNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bq_project field predicates */
  bqProject?: InputMaybe<Scalars['String']['input']>;
  bqProjectContains?: InputMaybe<Scalars['String']['input']>;
  bqProjectContainsFold?: InputMaybe<Scalars['String']['input']>;
  bqProjectEqualFold?: InputMaybe<Scalars['String']['input']>;
  bqProjectGT?: InputMaybe<Scalars['String']['input']>;
  bqProjectGTE?: InputMaybe<Scalars['String']['input']>;
  bqProjectHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bqProjectHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bqProjectIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bqProjectIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bqProjectLT?: InputMaybe<Scalars['String']['input']>;
  bqProjectLTE?: InputMaybe<Scalars['String']['input']>;
  bqProjectNEQ?: InputMaybe<Scalars['String']['input']>;
  bqProjectNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bqProjectNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bq_view field predicates */
  bqView?: InputMaybe<Scalars['String']['input']>;
  bqViewContains?: InputMaybe<Scalars['String']['input']>;
  bqViewContainsFold?: InputMaybe<Scalars['String']['input']>;
  bqViewEqualFold?: InputMaybe<Scalars['String']['input']>;
  bqViewGT?: InputMaybe<Scalars['String']['input']>;
  bqViewGTE?: InputMaybe<Scalars['String']['input']>;
  bqViewHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bqViewHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bqViewIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bqViewIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bqViewLT?: InputMaybe<Scalars['String']['input']>;
  bqViewLTE?: InputMaybe<Scalars['String']['input']>;
  bqViewNEQ?: InputMaybe<Scalars['String']['input']>;
  bqViewNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bqViewNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** discovered_at field predicates */
  discoveredAt?: InputMaybe<Scalars['Time']['input']>;
  discoveredAtGT?: InputMaybe<Scalars['Time']['input']>;
  discoveredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  discoveredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  discoveredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  discoveredAtLT?: InputMaybe<Scalars['Time']['input']>;
  discoveredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  discoveredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  discoveredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  discoveredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayNameGT?: InputMaybe<Scalars['String']['input']>;
  displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameLT?: InputMaybe<Scalars['String']['input']>;
  displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  displayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter_definitions edge predicates */
  hasFilterDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasFilterDefinitionsWith?: InputMaybe<Array<ReportTypeFilterDefinitionWhereInput>>;
  /** headers edge predicates */
  hasHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  hasHeadersWith?: InputMaybe<Array<ReportTypeHeaderWhereInput>>;
  /** validations edge predicates */
  hasValidations?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidationsWith?: InputMaybe<Array<ReportTypeValidationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_created_by_staff field predicates */
  isCreatedByStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isCreatedByStaffNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_updated_by_staff field predicates */
  isUpdatedByStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedByStaffNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** legacy_headers field predicates */
  legacyHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  legacyHeadersNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ReportTypeDefinitionWhereInput>;
  or?: InputMaybe<Array<ReportTypeDefinitionWhereInput>>;
  /** org_column_name field predicates */
  orgColumnName?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameContains?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameGT?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameGTE?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  orgColumnNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  orgColumnNameLT?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameLTE?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameNEQ?: InputMaybe<Scalars['String']['input']>;
  orgColumnNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  orgColumnNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** org_user_permission field predicates */
  orgUserPermission?: InputMaybe<ReportTypeDefinitionOrgUserPermission>;
  orgUserPermissionIn?: InputMaybe<Array<ReportTypeDefinitionOrgUserPermission>>;
  orgUserPermissionNEQ?: InputMaybe<ReportTypeDefinitionOrgUserPermission>;
  orgUserPermissionNotIn?: InputMaybe<Array<ReportTypeDefinitionOrgUserPermission>>;
  /** output_format field predicates */
  outputFormat?: InputMaybe<ReportTypeDefinitionOutputFormat>;
  outputFormatIn?: InputMaybe<Array<ReportTypeDefinitionOutputFormat>>;
  outputFormatNEQ?: InputMaybe<ReportTypeDefinitionOutputFormat>;
  outputFormatNotIn?: InputMaybe<Array<ReportTypeDefinitionOutputFormat>>;
  /** owning_team field predicates */
  owningTeam?: InputMaybe<ReportTypeDefinitionOwningTeam>;
  owningTeamIn?: InputMaybe<Array<ReportTypeDefinitionOwningTeam>>;
  owningTeamNEQ?: InputMaybe<ReportTypeDefinitionOwningTeam>;
  owningTeamNotIn?: InputMaybe<Array<ReportTypeDefinitionOwningTeam>>;
  /** staff_user_permission field predicates */
  staffUserPermission?: InputMaybe<ReportTypeDefinitionStaffUserPermission>;
  staffUserPermissionIn?: InputMaybe<Array<ReportTypeDefinitionStaffUserPermission>>;
  staffUserPermissionNEQ?: InputMaybe<ReportTypeDefinitionStaffUserPermission>;
  staffUserPermissionNotIn?: InputMaybe<Array<ReportTypeDefinitionStaffUserPermission>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** version field predicates */
  version?: InputMaybe<Scalars['Int']['input']>;
  versionGT?: InputMaybe<Scalars['Int']['input']>;
  versionGTE?: InputMaybe<Scalars['Int']['input']>;
  versionIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  versionLT?: InputMaybe<Scalars['Int']['input']>;
  versionLTE?: InputMaybe<Scalars['Int']['input']>;
  versionNEQ?: InputMaybe<Scalars['Int']['input']>;
  versionNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ReportTypeFilterDefinition = Node & {
  __typename: 'ReportTypeFilterDefinition';
  createdAt: Scalars['Time']['output'];
  /** Value pre-populated when the report is generated. NULL = no default. */
  defaultValue: Maybe<Scalars['String']['output']>;
  /** UI label for the filter. Maps to ReportFilterConfig.display_name for listing parity. */
  displayName: Scalars['String']['output'];
  /** Filter identifier passed in report requests. Defaults to the lowercased source_column at the M3 API layer, stored materialized. Unique per report type. */
  fieldName: Scalars['String']['output'];
  /** Widget semantics (DATE_RANGE/DATE_POINT/SINGLE_SELECT/MULTI_SELECT). Reuses the legacy models.FilterType, which maps 1:1 to reportdatageneratorproto.ReportFilterType (pinned by test); the M4.5/M5 listing path maps it verbatim. Default UNSPECIFIED; an explicit type is required at the M3 API layer. */
  filterType: ReportTypeFilterDefinitionFilterType;
  /** Surrogate primary key. */
  id: Scalars['ID']['output'];
  /** Hidden from the UI but still validated server-side. Maps to ReportFilterConfig.is_hidden. */
  isHidden: Scalars['Boolean']['output'];
  /** Marks the primary date filter. Exactly one main filter per parent is enforced by M3 validation, NOT a DB constraint (too race-prone on concurrent update). For VIEW reports M3 requires its source_column be a DATE or a TIMESTAMP, and a point-in-time main filter (operator DATE_EQ) requires a DATE: equality against an instant matches one moment rather than a whole day. */
  isMainFilter: Scalars['Boolean']['output'];
  /** SQL shape of the predicate the M4 bqViewBacked builder emits (DATE_BETWEEN -> BETWEEN @lo AND @hi, IN -> IN UNNEST(@p), ...). Orthogonal to filter_type. Default UNSPECIFIED; M3 derives it from filter_type when not set explicitly, then stores it explicitly. */
  operator: ReportTypeFilterDefinitionOperator;
  reportTypeDefinition: ReportTypeDefinition;
  /** Identity-presence gate (RS-386-derived). true => the filter is evaluable only when the request carries a bound org-user identity (UserV2-resolved person, not a device key). M1 ships this column DORMANT: no write/serve/generate path reads it. Enforcement lands with M3 validation + the availability work; congruent with the legacy ReportFilterConfig.requires_user_identity added by RS-386 Workstream A. */
  requiresUserIdentity: Scalars['Boolean']['output'];
  /** Listing/UI order for this filter. Unique per report type. */
  sortOrder: Scalars['Int']['output'];
  /** BQ column this filter predicates on (for CUSTOM reports, the provider's known column). For VIEW reports M3 validation requires it exist in discovered_schema; not a DB constraint. */
  sourceColumn: Scalars['String']['output'];
  /**
   * Options for SINGLE_SELECT / MULTI_SELECT filters, in display order. Empty for
   * every other filter type. Stored as a JSON column rather than an edge, so it is
   * resolved separately from the generated fields.
   */
  staticOptions: Array<FilterStaticOption>;
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/** A connection to a list of items. */
export type ReportTypeFilterDefinitionConnection = {
  __typename: 'ReportTypeFilterDefinitionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportTypeFilterDefinitionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportTypeFilterDefinitionEdge = {
  __typename: 'ReportTypeFilterDefinitionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportTypeFilterDefinition>;
};

/** ReportTypeFilterDefinitionFilterType is enum for the field filter_type */
export enum ReportTypeFilterDefinitionFilterType {
  FILTER_TYPE_DATE_POINT = 'FILTER_TYPE_DATE_POINT',
  FILTER_TYPE_DATE_RANGE = 'FILTER_TYPE_DATE_RANGE',
  FILTER_TYPE_MULTI_SELECT = 'FILTER_TYPE_MULTI_SELECT',
  FILTER_TYPE_SINGLE_SELECT = 'FILTER_TYPE_SINGLE_SELECT',
  FILTER_TYPE_UNSPECIFIED = 'FILTER_TYPE_UNSPECIFIED'
}

/**
 * One filter a report type exposes. Whole-set input: createReportTypeDefinition and
 * setReportTypeFilterDefinitions both take the complete desired set, which must
 * contain exactly one main filter.
 */
export type ReportTypeFilterDefinitionInput = {
  /** Value pre-populated when the report is generated. */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** UI label for the filter. Defaults to the title-cased source column. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter identifier used in report requests. Defaults to sourceColumn. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  filterType: ReportTypeFilterDefinitionFilterType;
  /** Hidden from the UI but still validated server-side. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Marks the primary date filter. Exactly one filter in the set must set it. For
   * VIEW types its column must be a DATE or a TIMESTAMP, and a point-in-time main
   * filter (operator DATE_EQ) needs a DATE: equality against an instant matches one
   * moment rather than a whole day.
   */
  isMainFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * SQL shape of the predicate. Defaults to the filter type's natural operator
   * (DATE_RANGE -> DATE_BETWEEN, DATE_POINT -> DATE_EQ, SINGLE_SELECT -> EQ,
   * MULTI_SELECT -> IN) and is then stored explicitly.
   */
  operator?: InputMaybe<ReportTypeFilterDefinitionOperator>;
  /**
   * When true the filter is only evaluable for a request carrying a bound org-user
   * identity.
   */
  requiresUserIdentity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Listing order for this filter. Unique within the report type. */
  sortOrder: Scalars['Int']['input'];
  /**
   * BigQuery column this filter predicates on. Must exist in the type's discovered
   * schema for VIEW types.
   */
  sourceColumn: Scalars['String']['input'];
  /** Required for SINGLE_SELECT / MULTI_SELECT filters, rejected for the others. */
  staticOptions?: InputMaybe<Array<FilterStaticOptionInput>>;
};

/** ReportTypeFilterDefinitionOperator is enum for the field operator */
export enum ReportTypeFilterDefinitionOperator {
  FILTER_OPERATOR_BETWEEN = 'FILTER_OPERATOR_BETWEEN',
  FILTER_OPERATOR_DATE_BETWEEN = 'FILTER_OPERATOR_DATE_BETWEEN',
  FILTER_OPERATOR_DATE_EQ = 'FILTER_OPERATOR_DATE_EQ',
  FILTER_OPERATOR_EQ = 'FILTER_OPERATOR_EQ',
  FILTER_OPERATOR_IN = 'FILTER_OPERATOR_IN',
  FILTER_OPERATOR_UNSPECIFIED = 'FILTER_OPERATOR_UNSPECIFIED'
}

/**
 * ReportTypeFilterDefinitionWhereInput is used for filtering ReportTypeFilterDefinition objects.
 * Input was generated by ent.
 */
export type ReportTypeFilterDefinitionWhereInput = {
  and?: InputMaybe<Array<ReportTypeFilterDefinitionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** default_value field predicates */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  defaultValueContains?: InputMaybe<Scalars['String']['input']>;
  defaultValueContainsFold?: InputMaybe<Scalars['String']['input']>;
  defaultValueEqualFold?: InputMaybe<Scalars['String']['input']>;
  defaultValueGT?: InputMaybe<Scalars['String']['input']>;
  defaultValueGTE?: InputMaybe<Scalars['String']['input']>;
  defaultValueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  defaultValueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  defaultValueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValueLT?: InputMaybe<Scalars['String']['input']>;
  defaultValueLTE?: InputMaybe<Scalars['String']['input']>;
  defaultValueNEQ?: InputMaybe<Scalars['String']['input']>;
  defaultValueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayNameGT?: InputMaybe<Scalars['String']['input']>;
  displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameLT?: InputMaybe<Scalars['String']['input']>;
  displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  displayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** field_name field predicates */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldNameContains?: InputMaybe<Scalars['String']['input']>;
  fieldNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameGT?: InputMaybe<Scalars['String']['input']>;
  fieldNameGTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fieldNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldNameLT?: InputMaybe<Scalars['String']['input']>;
  fieldNameLTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fieldNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter_type field predicates */
  filterType?: InputMaybe<ReportTypeFilterDefinitionFilterType>;
  filterTypeIn?: InputMaybe<Array<ReportTypeFilterDefinitionFilterType>>;
  filterTypeNEQ?: InputMaybe<ReportTypeFilterDefinitionFilterType>;
  filterTypeNotIn?: InputMaybe<Array<ReportTypeFilterDefinitionFilterType>>;
  /** report_type_definition edge predicates */
  hasReportTypeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportTypeDefinitionsWith?: InputMaybe<Array<ReportTypeDefinitionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_hidden field predicates */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_main_filter field predicates */
  isMainFilter?: InputMaybe<Scalars['Boolean']['input']>;
  isMainFilterNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ReportTypeFilterDefinitionWhereInput>;
  /** operator field predicates */
  operator?: InputMaybe<ReportTypeFilterDefinitionOperator>;
  operatorIn?: InputMaybe<Array<ReportTypeFilterDefinitionOperator>>;
  operatorNEQ?: InputMaybe<ReportTypeFilterDefinitionOperator>;
  operatorNotIn?: InputMaybe<Array<ReportTypeFilterDefinitionOperator>>;
  or?: InputMaybe<Array<ReportTypeFilterDefinitionWhereInput>>;
  /** requires_user_identity field predicates */
  requiresUserIdentity?: InputMaybe<Scalars['Boolean']['input']>;
  requiresUserIdentityNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** source_column field predicates */
  sourceColumn?: InputMaybe<Scalars['String']['input']>;
  sourceColumnContains?: InputMaybe<Scalars['String']['input']>;
  sourceColumnContainsFold?: InputMaybe<Scalars['String']['input']>;
  sourceColumnEqualFold?: InputMaybe<Scalars['String']['input']>;
  sourceColumnGT?: InputMaybe<Scalars['String']['input']>;
  sourceColumnGTE?: InputMaybe<Scalars['String']['input']>;
  sourceColumnHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sourceColumnHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sourceColumnIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumnLT?: InputMaybe<Scalars['String']['input']>;
  sourceColumnLTE?: InputMaybe<Scalars['String']['input']>;
  sourceColumnNEQ?: InputMaybe<Scalars['String']['input']>;
  sourceColumnNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTypeHeader = Node & {
  __typename: 'ReportTypeHeader';
  /** Type coercion applied by the M4 bqViewBacked builder. CAST_UNSPECIFIED (proto-0 default) behaves as CAST_AUTO, which resolves against the discovered BQ type at build time (DATE/TIMESTAMP/TIME/NUMERIC -> STRING for deterministic CSV). */
  castAs: ReportTypeHeaderCastAs;
  createdAt: Scalars['Time']['output'];
  /** Human label for this column (the POC called this label). M3 defaults it to TitleCase(source_column). Maps to ReportDataHeaderEntry.display_name for listing parity. It never reaches the CSV file: a VIEW type emits the field_name aliases as the header row (BigQuery header=true) and uses display_name for UI/listing only, and a CUSTOM type is MT-only and carries no headers at all -- ratified 2026-08-06 because BigQuery rejects the parens 4 of the 7 Tier-2 legacy headers carry, so respelling aliases could not reproduce them. */
  displayName: Scalars['String']['output'];
  /** Stable report-side identifier used by filter requests and the API surface. Defaults to the lowercased source_column at the M3 API layer; stored materialized. Diverges from source_column beyond case only as Option-B dbt-rename insulation. */
  fieldName: Scalars['String']['output'];
  /** Surrogate primary key. */
  id: Scalars['ID']['output'];
  /** When true the column is fetched but not emitted (e.g. internal join keys). */
  isExcluded: Scalars['Boolean']['output'];
  reportTypeDefinition: ReportTypeDefinition;
  /** Position of this column in the rendered output. Unique per report type. int32 (not int) so the entproto-generated field is int32, not int64. */
  sortOrder: Scalars['Int']['output'];
  /** Physical column name in the backing BQ view (for CUSTOM: the SQL alias the provider emits). The only header identifier the M4 builder interpolates into SQL (backtick-quoted). Must exist in discovered_schema for VIEW reports -- enforced by M3 validation, NOT a DB constraint. Deliberately not unique per definition (see Indexes). */
  sourceColumn: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/** ReportTypeHeaderCastAs is enum for the field cast_as */
export enum ReportTypeHeaderCastAs {
  CAST_AUTO = 'CAST_AUTO',
  CAST_BOOL = 'CAST_BOOL',
  CAST_DATE = 'CAST_DATE',
  CAST_FLOAT64 = 'CAST_FLOAT64',
  CAST_INT64 = 'CAST_INT64',
  CAST_NONE = 'CAST_NONE',
  CAST_NUMERIC = 'CAST_NUMERIC',
  CAST_STRING = 'CAST_STRING',
  CAST_TIMESTAMP = 'CAST_TIMESTAMP',
  CAST_UNSPECIFIED = 'CAST_UNSPECIFIED'
}

/** A connection to a list of items. */
export type ReportTypeHeaderConnection = {
  __typename: 'ReportTypeHeaderConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportTypeHeaderEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportTypeHeaderEdge = {
  __typename: 'ReportTypeHeaderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportTypeHeader>;
};

/**
 * One output column of a report type. Whole-set input: createReportTypeDefinition
 * and setReportTypeHeaders both take the complete desired set.
 */
export type ReportTypeHeaderInput = {
  /** Type coercion applied when the column is projected. Defaults to CAST_AUTO. */
  castAs?: InputMaybe<ReportTypeHeaderCastAs>;
  /**
   * UI / listing label. Defaults to the title-cased source column ("report_date" ->
   * "Report Date"). For CUSTOM types it is also the rendered CSV header; for VIEW
   * types it is UI-only, since BigQuery writes the fieldName aliases as the header
   * row.
   */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Stable report-side identifier. Defaults to sourceColumn. Lowercase snake_case.
   * For VIEW types this is also what BigQuery writes as the CSV header.
   */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** When true the column is fetched but not emitted (e.g. an internal join key). */
  isExcluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Position of the column in the rendered output. Unique within the report type. */
  sortOrder: Scalars['Int']['input'];
  /**
   * Physical column in the backing BigQuery view (for CUSTOM types: the SQL alias
   * the provider emits). Must exist in the type's discovered schema for VIEW types.
   */
  sourceColumn: Scalars['String']['input'];
};

/**
 * ReportTypeHeaderWhereInput is used for filtering ReportTypeHeader objects.
 * Input was generated by ent.
 */
export type ReportTypeHeaderWhereInput = {
  and?: InputMaybe<Array<ReportTypeHeaderWhereInput>>;
  /** cast_as field predicates */
  castAs?: InputMaybe<ReportTypeHeaderCastAs>;
  castAsIn?: InputMaybe<Array<ReportTypeHeaderCastAs>>;
  castAsNEQ?: InputMaybe<ReportTypeHeaderCastAs>;
  castAsNotIn?: InputMaybe<Array<ReportTypeHeaderCastAs>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  displayNameGT?: InputMaybe<Scalars['String']['input']>;
  displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  displayNameLT?: InputMaybe<Scalars['String']['input']>;
  displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  displayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** field_name field predicates */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldNameContains?: InputMaybe<Scalars['String']['input']>;
  fieldNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fieldNameGT?: InputMaybe<Scalars['String']['input']>;
  fieldNameGTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fieldNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fieldNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldNameLT?: InputMaybe<Scalars['String']['input']>;
  fieldNameLTE?: InputMaybe<Scalars['String']['input']>;
  fieldNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fieldNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** report_type_definition edge predicates */
  hasReportTypeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportTypeDefinitionsWith?: InputMaybe<Array<ReportTypeDefinitionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_excluded field predicates */
  isExcluded?: InputMaybe<Scalars['Boolean']['input']>;
  isExcludedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ReportTypeHeaderWhereInput>;
  or?: InputMaybe<Array<ReportTypeHeaderWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** source_column field predicates */
  sourceColumn?: InputMaybe<Scalars['String']['input']>;
  sourceColumnContains?: InputMaybe<Scalars['String']['input']>;
  sourceColumnContainsFold?: InputMaybe<Scalars['String']['input']>;
  sourceColumnEqualFold?: InputMaybe<Scalars['String']['input']>;
  sourceColumnGT?: InputMaybe<Scalars['String']['input']>;
  sourceColumnGTE?: InputMaybe<Scalars['String']['input']>;
  sourceColumnHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sourceColumnHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sourceColumnIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumnLT?: InputMaybe<Scalars['String']['input']>;
  sourceColumnLTE?: InputMaybe<Scalars['String']['input']>;
  sourceColumnNEQ?: InputMaybe<Scalars['String']['input']>;
  sourceColumnNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * One column whose type or mode differs between the stored snapshot and the live
 * view.
 */
export type ReportTypeSchemaColumnChange = {
  __typename: 'ReportTypeSchemaColumnChange';
  liveMode: Scalars['String']['output'];
  liveType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  storedMode: Scalars['String']['output'];
  storedType: Scalars['String']['output'];
};

/**
 * The result of a refreshReportTypeSchema call: how the live BigQuery view differs
 * from the report type's stored snapshot, and whether that difference was written.
 */
export type ReportTypeSchemaDiff = {
  __typename: 'ReportTypeSchemaDiff';
  /**
   * Columns the view has and the snapshot does not. Harmless until a header names
   * one.
   */
  addedColumns: Array<DiscoveredSchemaColumn>;
  /** True when the live schema was written to the definition. False for a dry run. */
  applied: Scalars['Boolean']['output'];
  /**
   * Set on a dry run that could not be applied — the reason an applyChanges call
   * would be rejected, so it can be shown next to the diff that explains it. Null
   * when applying would succeed.
   */
  applyBlockedReason: Maybe<Scalars['String']['output']>;
  /**
   * Columns both sides have under a different type or mode. These change generated
   * SQL without any configuration changing.
   */
  changedColumns: Array<ReportTypeSchemaColumnChange>;
  /** When the snapshot was stamped. Null on a dry run. */
  discoveredAt: Maybe<Scalars['Time']['output']>;
  /**
   * True when the live view has gained a column, lost one, or spells one with a
   * different type or mode. Column order is deliberately not a change: nothing
   * resolves positionally, and both full schemas are returned, so a reorder stays
   * visible.
   */
  hasChanges: Scalars['Boolean']['output'];
  /** What the view reports now, in the view's own column order. */
  liveSchema: Array<DiscoveredSchemaColumn>;
  /**
   * Set while the main filter's source column is still in the view but of a type
   * the report's date range can no longer bind to. This drift does not block an
   * apply by itself — generation is where such a report stops — but it says nothing
   * about whether the refresh as a whole applies: read applyBlockedReason for that,
   * since the same column can also break a rule that does block. Null when the main
   * filter binds, and when its column is gone entirely, which
   * staleFilterSourceColumns reports instead.
   */
  mainFilterBindWarning: Maybe<Scalars['String']['output']>;
  /** Columns the snapshot has and the view no longer does, as they were recorded. */
  removedColumns: Array<DiscoveredSchemaColumn>;
  reportTypeDefinitionID: Scalars['ID']['output'];
  /**
   * Identifies the live schema this call read by content, so two readings of an
   * unchanged view match and any real change does not.
   */
  schemaFingerprint: Scalars['String']['output'];
  /**
   * Source columns of configured filter definitions that the live view no longer
   * has.
   */
  staleFilterSourceColumns: Array<Scalars['String']['output']>;
  /**
   * Source columns of configured headers that the live view no longer has, excluded
   * headers included. An emitted header stops the type generating until it is
   * reconfigured; an excluded one does not, but either one blocks the next write of
   * the header set.
   */
  staleHeaderSourceColumns: Array<Scalars['String']['output']>;
  /**
   * The stored snapshot as it was before this call; empty when the type had never
   * been introspected.
   */
  storedSchema: Array<DiscoveredSchemaColumn>;
};

export type ReportTypeValidation = Node & {
  __typename: 'ReportTypeValidation';
  /** BigQuery dataset of the routine; the (project, dataset) pair is allow-listed. */
  bqDataset: Scalars['String']['output'];
  /** BigQuery project of the routine. */
  bqProject: Scalars['String']['output'];
  /** BigQuery routine id: a table-valued function for a CHECK, a procedure for a PRE_STEP. */
  bqRoutine: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  /** A disabled step is kept but skipped at run time. */
  enabled: Scalars['Boolean']['output'];
  /** Surrogate primary key. */
  id: Scalars['ID']['output'];
  /** CHECK returns a result row; PRE_STEP writes state before the checks run. */
  kind: ReportTypeValidationKind;
  /** Stored validation name, unique within the report type. */
  name: Scalars['String']['output'];
  reportTypeDefinition: ReportTypeDefinition;
  /** Run order, unique per report type; every PRE_STEP sorts before every CHECK. */
  sortOrder: Scalars['Int']['output'];
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/** A connection to a list of items. */
export type ReportTypeValidationConnection = {
  __typename: 'ReportTypeValidationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportTypeValidationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportTypeValidationEdge = {
  __typename: 'ReportTypeValidationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReportTypeValidation>;
};

/**
 * One BigQuery routine registered against a report type's export. Whole-set input:
 * setReportTypeValidations takes the complete desired set.
 */
export type ReportTypeValidationInput = {
  /** BigQuery dataset of the routine. */
  bqDataset: Scalars['String']['input'];
  /** BigQuery project of the routine. The (project, dataset) pair must be allow-listed. */
  bqProject: Scalars['String']['input'];
  /**
   * BigQuery routine id: a table-valued function for a CHECK, a procedure for a
   * PRE_STEP. Its signature must match the contract for its kind.
   */
  bqRoutine: Scalars['String']['input'];
  /** A disabled step is kept but skipped at run time. Defaults to true. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** CHECK returns a result row; PRE_STEP writes state before the checks run. */
  kind: ReportTypeValidationKind;
  /** Validation name, unique within the report type. */
  name: Scalars['String']['input'];
  /** Run order, unique within the report type. Every PRE_STEP sorts before every CHECK. */
  sortOrder: Scalars['Int']['input'];
};

/** ReportTypeValidationKind is enum for the field kind */
export enum ReportTypeValidationKind {
  CHECK = 'CHECK',
  PRE_STEP = 'PRE_STEP'
}

/** Ordering options for ReportTypeValidation connections */
export type ReportTypeValidationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ReportTypeValidations. */
  field: ReportTypeValidationOrderField;
};

/** Properties by which ReportTypeValidation connections can be ordered. */
export enum ReportTypeValidationOrderField {
  SORT_ORDER = 'SORT_ORDER'
}

/**
 * ReportTypeValidationWhereInput is used for filtering ReportTypeValidation objects.
 * Input was generated by ent.
 */
export type ReportTypeValidationWhereInput = {
  and?: InputMaybe<Array<ReportTypeValidationWhereInput>>;
  /** bq_dataset field predicates */
  bqDataset?: InputMaybe<Scalars['String']['input']>;
  bqDatasetContains?: InputMaybe<Scalars['String']['input']>;
  bqDatasetContainsFold?: InputMaybe<Scalars['String']['input']>;
  bqDatasetHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bqDatasetHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bqDatasetIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bqDatasetNEQ?: InputMaybe<Scalars['String']['input']>;
  bqDatasetNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** bq_project field predicates */
  bqProject?: InputMaybe<Scalars['String']['input']>;
  bqProjectContains?: InputMaybe<Scalars['String']['input']>;
  bqProjectContainsFold?: InputMaybe<Scalars['String']['input']>;
  bqProjectHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bqProjectHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bqProjectIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bqProjectNEQ?: InputMaybe<Scalars['String']['input']>;
  bqProjectNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** bq_routine field predicates */
  bqRoutine?: InputMaybe<Scalars['String']['input']>;
  bqRoutineContains?: InputMaybe<Scalars['String']['input']>;
  bqRoutineContainsFold?: InputMaybe<Scalars['String']['input']>;
  bqRoutineHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bqRoutineHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bqRoutineIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bqRoutineNEQ?: InputMaybe<Scalars['String']['input']>;
  bqRoutineNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_type_definition edge predicates */
  hasReportTypeDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportTypeDefinitionsWith?: InputMaybe<Array<ReportTypeDefinitionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<ReportTypeValidationKind>;
  kindIn?: InputMaybe<Array<ReportTypeValidationKind>>;
  kindNEQ?: InputMaybe<ReportTypeValidationKind>;
  kindNotIn?: InputMaybe<Array<ReportTypeValidationKind>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ReportTypeValidationWhereInput>;
  or?: InputMaybe<Array<ReportTypeValidationWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * ReportWhereInput is used for filtering Report objects.
 * Input was generated by ent.
 */
export type ReportWhereInput = {
  and?: InputMaybe<Array<ReportWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_by_pub_key_id field predicates */
  createdByPubKeyID?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDContains?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDGT?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDGTE?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByPubKeyIDLT?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDLTE?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByPubKeyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** date_range_end field predicates */
  dateRangeEnd?: InputMaybe<Scalars['Time']['input']>;
  dateRangeEndGT?: InputMaybe<Scalars['Time']['input']>;
  dateRangeEndGTE?: InputMaybe<Scalars['Time']['input']>;
  dateRangeEndIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateRangeEndIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dateRangeEndLT?: InputMaybe<Scalars['Time']['input']>;
  dateRangeEndLTE?: InputMaybe<Scalars['Time']['input']>;
  dateRangeEndNEQ?: InputMaybe<Scalars['Time']['input']>;
  dateRangeEndNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateRangeEndNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** date_range_start field predicates */
  dateRangeStart?: InputMaybe<Scalars['Time']['input']>;
  dateRangeStartGT?: InputMaybe<Scalars['Time']['input']>;
  dateRangeStartGTE?: InputMaybe<Scalars['Time']['input']>;
  dateRangeStartIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateRangeStartIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dateRangeStartLT?: InputMaybe<Scalars['Time']['input']>;
  dateRangeStartLTE?: InputMaybe<Scalars['Time']['input']>;
  dateRangeStartNEQ?: InputMaybe<Scalars['Time']['input']>;
  dateRangeStartNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateRangeStartNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** report_files edge predicates */
  hasReportFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportFilesWith?: InputMaybe<Array<ReportFileWhereInput>>;
  /** report_filters edge predicates */
  hasReportFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportFiltersWith?: InputMaybe<Array<ReportDataFilterWhereInput>>;
  /** report_schedules edge predicates */
  hasReportSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportSchedulesWith?: InputMaybe<Array<ReportScheduleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_created_by_staff field predicates */
  isCreatedByStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isCreatedByStaffNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ReportWhereInput>;
  or?: InputMaybe<Array<ReportWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['String']['input']>;
  organizationIDContains?: InputMaybe<Scalars['String']['input']>;
  organizationIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  organizationIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  organizationIDGT?: InputMaybe<Scalars['String']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['String']['input']>;
  organizationIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  organizationIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIDLT?: InputMaybe<Scalars['String']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['String']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['String']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** report_status field predicates */
  reportStatus?: InputMaybe<ReportReportStatus>;
  reportStatusIn?: InputMaybe<Array<ReportReportStatus>>;
  reportStatusNEQ?: InputMaybe<ReportReportStatus>;
  reportStatusNotIn?: InputMaybe<Array<ReportReportStatus>>;
  /** type field predicates */
  type?: InputMaybe<Scalars['String']['input']>;
  typeContains?: InputMaybe<Scalars['String']['input']>;
  typeContainsFold?: InputMaybe<Scalars['String']['input']>;
  /** type_display_name field predicates */
  typeDisplayName?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameContains?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameGT?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameGTE?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  typeDisplayNameLT?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameLTE?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  typeDisplayNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  typeEqualFold?: InputMaybe<Scalars['String']['input']>;
  typeGT?: InputMaybe<Scalars['String']['input']>;
  typeGTE?: InputMaybe<Scalars['String']['input']>;
  typeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  typeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  typeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  typeLT?: InputMaybe<Scalars['String']['input']>;
  typeLTE?: InputMaybe<Scalars['String']['input']>;
  typeNEQ?: InputMaybe<Scalars['String']['input']>;
  typeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** utc_offset field predicates */
  utcOffset?: InputMaybe<Scalars['String']['input']>;
  utcOffsetContains?: InputMaybe<Scalars['String']['input']>;
  utcOffsetContainsFold?: InputMaybe<Scalars['String']['input']>;
  utcOffsetEqualFold?: InputMaybe<Scalars['String']['input']>;
  utcOffsetGT?: InputMaybe<Scalars['String']['input']>;
  utcOffsetGTE?: InputMaybe<Scalars['String']['input']>;
  utcOffsetHasPrefix?: InputMaybe<Scalars['String']['input']>;
  utcOffsetHasSuffix?: InputMaybe<Scalars['String']['input']>;
  utcOffsetIn?: InputMaybe<Array<Scalars['String']['input']>>;
  utcOffsetLT?: InputMaybe<Scalars['String']['input']>;
  utcOffsetLTE?: InputMaybe<Scalars['String']['input']>;
  utcOffsetNEQ?: InputMaybe<Scalars['String']['input']>;
  utcOffsetNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Representative associated with a KYC profile */
export type Representative = {
  __typename: 'Representative';
  /** Email of the representative */
  email: Scalars['String']['output'];
  /** Optional label/role of the representative for this entity (e.g. CEO, Authorized Signer). */
  label: Maybe<Scalars['String']['output']>;
  /** Name of the representative */
  name: Scalars['String']['output'];
};

/** Connection for Representative type */
export type RepresentativeConnection = {
  __typename: 'RepresentativeConnection';
  /** List of edges */
  edges: Array<RepresentativeEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
};

/** Edge for Representative type */
export type RepresentativeEdge = {
  __typename: 'RepresentativeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Representative;
};

/**
 * RepresentativeInput is the unified input for specifying a representative on a
 * mutation. All fields are optional; resolvers prefer this input and fall back to
 * the deprecated flat representativeEmail/representativeName arguments for old
 * clients. The label is only persisted on the legacy institutional affiliate and
 * individual representative paths.
 */
export type RepresentativeInput = {
  /** Email of the representative. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Optional label/role of the representative for this entity (e.g. CEO, Authorized Signer). */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Name of the representative (required when creating a new representative). */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A signed document reference associated with an account transfer. */
export type RequestDocument = {
  __typename: 'RequestDocument';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  documentType: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  storageUrl: Scalars['String']['output'];
  transferId: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** Paginated list of request documents. */
export type RequestDocumentConnection = {
  __typename: 'RequestDocumentConnection';
  /** A list of edges. */
  edges: Maybe<Array<RequestDocumentEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A request document edge in a connection. */
export type RequestDocumentEdge = {
  __typename: 'RequestDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<RequestDocument>;
};

/**
 * Response from a mutation that proposes a settlement.
 * Shared across proposal-style mutations (e.g. cmRequestMarginReturn, cmRequestExposureIncrease).
 */
export type RequestMarginReturnResponse = {
  __typename: 'RequestMarginReturnResponse';
  /**
   * The proposed settlement, resolved by the settlement network subgraph.
   * Nullable so a transient resolution failure doesn't null-cascade over settlementID.
   */
  settlement: Maybe<SNTwoWaySettlement>;
  /**
   * Settlement ID from settlement network
   * Used to track the settlement through its lifecycle
   */
  settlementID: Scalars['ID']['output'];
};

/** Identifies PII entries that must be provided */
export type RequiredInformation = {
  __typename: 'RequiredInformation';
  /** Description of the rejection */
  description: Scalars['String']['output'];
  /** The type of information required */
  informationType: IndividualInformationType;
  /** Human readable message regarding the previous rejection of this type */
  rejectionMessage: Maybe<Scalars['String']['output']>;
  /** The reason why this information is required */
  requirementReason: PIIRequirementReason;
};

/**
 * RequiredUsersQuorum is a soft constraint on required endorsements for a policy.
 *
 * These are different than quorums as they are not cryptographically protected.
 * During Risk Review, Anchorage Reviewers may execute an operation before
 * the minimum number of users within a required users quorum have endorsed it.
 *
 * RequiredUsersQuorum will likely be replaced with Quorum in the future.
 */
export type RequiredUsersQuorum = {
  __typename: 'RequiredUsersQuorum';
  /**
   * The number of users from 'users' that are required.
   * 'signaturesRequired' will always be <= len('users')
   */
  signaturesRequired: Scalars['Int']['output'];
  /** List of users whose endorsements are required to meet the virtual quorum. */
  users: Array<User>;
};


/**
 * RequiredUsersQuorum is a soft constraint on required endorsements for a policy.
 *
 * These are different than quorums as they are not cryptographically protected.
 * During Risk Review, Anchorage Reviewers may execute an operation before
 * the minimum number of users within a required users quorum have endorsed it.
 *
 * RequiredUsersQuorum will likely be replaced with Quorum in the future.
 */
export type RequiredUsersQuorumusersArgs = {
  sortField?: InputMaybe<UserSortField>;
};

export type RescindContestNoticeInput = {
  controlAgreementID: Scalars['ID']['input'];
};

export type RescindContestNoticeResponse = {
  __typename: 'RescindContestNoticeResponse';
  success: Scalars['Boolean']['output'];
};

/**
 * Per-source reserve balances as decimal strings. Sparse union across all supported
 * stablecoins; each field is one reserve source and is nil when the source is not
 * applicable to the snapshot's stablecoin or the value isn't reported.
 */
export type ReserveComponents = {
  __typename: 'ReserveComponents';
  adbBrUsdptReserves: Maybe<Scalars['String']['output']>;
  adbBrUsdptReservesAnalog: Maybe<Scalars['String']['output']>;
  adbBrUsdptReservesOnchain: Maybe<Scalars['String']['output']>;
  adbBuidlUsdgo: Maybe<Scalars['String']['output']>;
  adbGsUsdgoReserves: Maybe<Scalars['String']['output']>;
  adbJpmUsdgoReserves: Maybe<Scalars['String']['output']>;
  adbJpmUsdptReserves: Maybe<Scalars['String']['output']>;
  adbJpmZlUsdReserves: Maybe<Scalars['String']['output']>;
  adbVaultFusd: Maybe<Scalars['String']['output']>;
  adbVaultUsdtb: Maybe<Scalars['String']['output']>;
  usdCashReserveBalance7788: Maybe<Scalars['String']['output']>;
  usdCashReserveBalance8369: Maybe<Scalars['String']['output']>;
  usdFboBalance: Maybe<Scalars['String']['output']>;
  usdUsBankBalance: Maybe<Scalars['String']['output']>;
};

/**
 * Connection wrapper for the reservesHistory query. Edges are ordered by createdAt descending,
 * matching the cursor on lastCreatedAt. The cron loads snapshots in chronological order, so
 * createdAt order aligns with reportDate order in practice.
 */
export type ReservesHistory = {
  __typename: 'ReservesHistory';
  /**
   * Stablecoins the caller is authorized to view, derived from backend access control. Empty when
   * the caller has no reserves access. The frontend uses this to populate the token selector.
   */
  availableStablecoins: Array<Scalars['String']['output']>;
  /** List of reserves snapshot edges. */
  edges: Array<ReservesSnapshotEdge>;
  /**
   * Whether there are more results after this page. Frontend derives the next cursor from the
   * last edge's node.createdAt.
   */
  hasNextPage: Scalars['Boolean']['output'];
  /**
   * The stablecoin this response's snapshot data is for: the requested token, or the default that was
   * loaded when none was requested. Empty when the caller has no access and no data was loaded.
   */
  stablecoin: Scalars['String']['output'];
};

/**
 * A point-in-time reserves composition snapshot for a stablecoin, sourced from the daily
 * reconciliation process. All monetary amounts are decimal strings to preserve precision;
 * frontend rounds for display via formatMoney / formatPercentage.
 */
export type ReservesSnapshot = {
  __typename: 'ReservesSnapshot';
  /** Recon adjustments value (decimal as string). */
  adjustments: Scalars['String']['output'];
  /** When mintburn ingested this snapshot. */
  createdAt: Scalars['Time']['output'];
  /** Unique snapshot identifier. */
  id: Scalars['ID']['output'];
  /** The date this snapshot represents (midnight UTC). */
  reportDate: Scalars['Time']['output'];
  /** Per-source reserve component balances. */
  reserveComponents: ReserveComponents;
  /**
   * Reserve ratio as a fraction-as-string (e.g., "1.00305" represents 100.305%). Frontend
   * multiplies by 100 to render as a percentage.
   */
  reserveRatio: Scalars['String']['output'];
  /** The stablecoin this snapshot is for (e.g., "USDGO"). */
  stablecoin: Scalars['String']['output'];
  /** Total reserves backing the stablecoin (decimal as string). */
  totalReserves: Scalars['String']['output'];
  /**
   * Total stablecoin supply aggregated across all chains the stablecoin is deployed on.
   * Displayed as "Total Supply" in the frontend.
   */
  totalStablecoinOnNetwork: Scalars['String']['output'];
};

/** Edge wrapper for ReservesSnapshot. */
export type ReservesSnapshotEdge = {
  __typename: 'ReservesSnapshotEdge';
  /** The reserves snapshot node. */
  node: ReservesSnapshot;
};

/** ResetAllowedVaultsForDAppResponse */
export type ResetAllowedVaultsForDAppResponse = {
  __typename: 'ResetAllowedVaultsForDAppResponse';
  /** Was request successful */
  success: Scalars['Boolean']['output'];
};

/** Resource represents a resource (e.g. Organization, Vault) */
export type Resource = Organization | Vault;

export type ResourceConnection = {
  __typename: 'ResourceConnection';
  /** A list of edges */
  edges: Array<ResourceEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** The total number of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type ResourceEdge = {
  __typename: 'ResourceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The resource node at the end of the edge */
  node: Resource;
};

export type Response = {
  __typename: 'Response';
  Status: Maybe<Scalars['String']['output']>;
};

/**
 * ResponseStatusCode is similar to HTTP response status code.
 * It indicates whether a request has been successfully received, completed, failed, etc.
 */
export enum ResponseStatusCode {
  /**
   * ACCEPTED means the request has been successfully received but not yet processed.
   * Note that the processing of the request could still fail.
   */
  ACCEPTED = 'ACCEPTED',
  /** OK means a request has been processed, to completion, successfully. */
  OK = 'OK'
}

/** Restriction represents a limitation on an entity */
export type Restriction = {
  __typename: 'Restriction';
  /** Additional fields for an account closure */
  closureDetail: Maybe<ClosureMetadata>;
  /** Indicates if the restriction is active */
  enabled: Scalars['Boolean']['output'];
  /** Indicates who last changed the restriction */
  lastModifiedBy: Scalars['String']['output'];
  /** Indicates why restriction was updated */
  reason: Scalars['String']['output'];
  /** Indicates the type of restriction */
  restrictionType: RestrictionType;
};

export enum RestrictionAction {
  FREEZE = 'FREEZE',
  UNFREEZE = 'UNFREEZE'
}

/** RestrictionEntityType represents the entity type for a restriction */
export enum RestrictionEntityType {
  /** Indicates entity is an account */
  ACCOUNT = 'ACCOUNT',
  /** Indicates entity is an affiliate */
  AFFILIATE = 'AFFILIATE'
}

/** One freeze or unfreeze of a restriction, read from its history. */
export type RestrictionEvent = {
  __typename: 'RestrictionEvent';
  action: RestrictionAction;
  at: Scalars['Time']['output'];
  by: Scalars['String']['output'];
  /** VAULT when walletId is null, WALLET otherwise. */
  level: RestrictionLevel;
  /** The freeze reason code of a FREEZE, the unfreeze reason code of an UNFREEZE. */
  reason: Scalars['String']['output'];
  restrictionId: Scalars['ID']['output'];
  vaultId: Scalars['String']['output'];
  wallet: Maybe<Wallet>;
  walletId: Maybe<Scalars['String']['output']>;
};

export type RestrictionEventConnection = {
  __typename: 'RestrictionEventConnection';
  edges: Array<RestrictionEventEdge>;
  pageInfo: PageInfo;
};

export type RestrictionEventEdge = {
  __typename: 'RestrictionEventEdge';
  cursor: Scalars['String']['output'];
  node: RestrictionEvent;
};

/** Initial values, copied from the account freeze dialog; compliance confirms the list. */
export enum RestrictionFreezeReason {
  COMPLIANCE_REVIEW = 'COMPLIANCE_REVIEW',
  FIU_INVESTIGATION = 'FIU_INVESTIGATION',
  SANCTIONS_TEAM_DETERMINATION = 'SANCTIONS_TEAM_DETERMINATION'
}

export enum RestrictionLevel {
  VAULT = 'VAULT',
  WALLET = 'WALLET'
}

export enum RestrictionLiftReason {
  COMPLIANCE_REVIEW_COMPLETED = 'COMPLIANCE_REVIEW_COMPLETED',
  INCORRECTLY_FROZEN = 'INCORRECTLY_FROZEN'
}

/** A vault or wallet freeze. Named RestrictionRecord because the supergraph already has Restriction for the account level. */
export type RestrictionRecord = {
  __typename: 'RestrictionRecord';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** VAULT when walletId is null, WALLET otherwise. */
  level: RestrictionLevel;
  /** The freeze reason code; the unfreeze reason code once LIFTED. */
  reason: Scalars['String']['output'];
  status: RestrictionStatus;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  vaultId: Scalars['String']['output'];
  walletId: Maybe<Scalars['String']['output']>;
};

export type RestrictionRecordConnection = {
  __typename: 'RestrictionRecordConnection';
  edges: Array<RestrictionRecordEdge>;
  pageInfo: PageInfo;
};

export type RestrictionRecordEdge = {
  __typename: 'RestrictionRecordEdge';
  cursor: Scalars['String']['output'];
  node: RestrictionRecord;
};

export enum RestrictionStatus {
  ACTIVE = 'ACTIVE',
  LIFTED = 'LIFTED'
}

export type RestrictionTargetInput = {
  vaultId: Scalars['String']['input'];
  /** Omitted: the target is the vault itself. */
  walletId?: InputMaybe<Scalars['String']['input']>;
};

/** Indicates the type of restriction */
export enum RestrictionType {
  /** Restriction controls account closure */
  CLOSE = 'CLOSE',
  /** Indicates the restriction controls withdrawal */
  FREEZE_WITHDRAWAL = 'FREEZE_WITHDRAWAL'
}

export type RestrictionsFilters = {
  /** WALLET matches the rows with a walletId, VAULT the vault row. */
  level?: InputMaybe<RestrictionLevel>;
  status?: InputMaybe<RestrictionStatus>;
};

/** Input for retriggering a DocuSign envelope on an account transfer. */
export type RetriggerDocuSignInput = {
  transferId: Scalars['String']['input'];
};

export type RetryAccountOpeningInput = {
  accountId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};

export type RetryAccountOpeningResult = {
  __typename: 'RetryAccountOpeningResult';
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

/** Input for proposing the reversal of an existing otc.internal_movements row. */
export type ReverseInternalMovementInput = {
  /** Opt-in dedup key so a retried submit returns the original request instead of creating a duplicate */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** The internal_movements row to reverse. */
  internalMovementId: Scalars['ID']['input'];
};

/** Input for proposing the reversal of an existing otc.ledger_transactions entry. */
export type ReverseLedgerTransactionInput = {
  /** Opt-in dedup key so a retried submit returns the original request instead of creating a duplicate */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** The ledger_transactions entry to reverse. */
  ledgerTransactionId: Scalars['ID']['input'];
};

export type ReviewPendingDefaultStakingFeeTermsInput = {
  reviewType: DefaultStakingFeeTermsReviewType;
  versionId: Scalars['ID']['input'];
};

export type ReviewPendingDefaultStakingFeeTermsPayload = {
  __typename: 'ReviewPendingDefaultStakingFeeTermsPayload';
  success: Scalars['Boolean']['output'];
};

/** Payload response for revokeAPIKeyWithErrors mutation. */
export type RevokeAPIKeyPayload = {
  __typename: 'RevokeAPIKeyPayload';
  /** State of the APIKey after the mutation. */
  apiKey: Maybe<APIKey>;
  /** Errors encountered while revoking API key. */
  revokeErrors: Array<ErrorMessage>;
};

/** Extra parameters for ripple */
export type RippleExtraParams = {
  __typename: 'RippleExtraParams';
  /** destination tag to use in transaction */
  destinationTag: Maybe<Scalars['String']['output']>;
};

/** Type of RiskAnalysis */
export enum RiskAnalysisType {
  /** ACH Debit Out Originating Financial Institution Counterparty Information */
  ACH_ORIGINATOR_FI_SCREENING = 'ACH_ORIGINATOR_FI_SCREENING',
  /** ACH Debit Out Originator Counterparty Information */
  ACH_ORIGINATOR_SCREENING = 'ACH_ORIGINATOR_SCREENING',
  /** Check Alerts */
  ALERT_CHECK = 'ALERT_CHECK',
  /** Beneficiary Country Check Information */
  AML_BENEFICIARY_COUNTRY_CHECK = 'AML_BENEFICIARY_COUNTRY_CHECK',
  /** Beneficiary Counterparty Information */
  AML_BENEFICIARY_SCREENING = 'AML_BENEFICIARY_SCREENING',
  /** Destination Country Check Information */
  AML_DESTINATION_COUNTRY_CHECK = 'AML_DESTINATION_COUNTRY_CHECK',
  /** Financial Institution Counterparty Information */
  AML_INSTITUTION_SCREENING = 'AML_INSTITUTION_SCREENING',
  /** Originator Country Check Information */
  AML_ORIGINATOR_COUNTRY_CHECK = 'AML_ORIGINATOR_COUNTRY_CHECK',
  /** Originator Counterparty Information */
  AML_ORIGINATOR_SCREENING = 'AML_ORIGINATOR_SCREENING',
  /** Check Counterparty Information */
  COUNTERPARTY_CHECK = 'COUNTERPARTY_CHECK',
  /** Fiat Beneficiary Country Check Information */
  FIAT_BENEFICIARY_COUNTRY_CHECK = 'FIAT_BENEFICIARY_COUNTRY_CHECK',
  /** Fiat Beneficiary Financial Institution Country Check Information */
  FIAT_BENEFICIARY_FI_COUNTRY_CHECK = 'FIAT_BENEFICIARY_FI_COUNTRY_CHECK',
  /** Fiat Beneficiary Financial Institution Counterparty Information */
  FIAT_BENEFICIARY_FI_SCREENING = 'FIAT_BENEFICIARY_FI_SCREENING',
  /** Fiat Beneficiary Counterparty Information */
  FIAT_BENEFICIARY_SCREENING = 'FIAT_BENEFICIARY_SCREENING',
  /** Fiat Intermediate Financial Institution Country Check Information */
  FIAT_INTERMEDIATE_FI_COUNTRY_CHECK = 'FIAT_INTERMEDIATE_FI_COUNTRY_CHECK',
  /** Fiat Intermediate Financial Institution Counterparty Information */
  FIAT_INTERMEDIATE_FI_SCREENING = 'FIAT_INTERMEDIATE_FI_SCREENING',
  /** High Risk Jurisdictions countries check */
  HRJ_CHECK = 'HRJ_CHECK',
  /** Screen Wallet */
  WALLET_SCREENING = 'WALLET_SCREENING'
}

/** Vendor for RiskAnalysis */
export enum RiskAnalysisVendor {
  /** Analysis from LexisNexis */
  LEXIS_NEXIS = 'LEXIS_NEXIS',
  /** Analysis from LexisNexis */
  SANCTIONED_COUNTRIES = 'SANCTIONED_COUNTRIES',
  /** Analysis from TRM */
  TRM = 'TRM'
}

/** Details on an individual approval group's approval status */
export type RiskApprovalGroup = {
  __typename: 'RiskApprovalGroup';
  /** A list of individual group members */
  members: Array<RiskApprovalGroupMember>;
  /** The name of the approver group */
  name: Scalars['String']['output'];
  /** The group's overall approval status, nil if no decisions were made */
  status: Maybe<OperationDecision>;
};

/** Details on an individual risk reviewer's approval status */
export type RiskApprovalGroupMember = {
  __typename: 'RiskApprovalGroupMember';
  /** Email address of the approver */
  email: Scalars['String']['output'];
  /** Timestamp in nanos of when the most recent decision was made, null for pending endorsements */
  lastDecisionTime: Maybe<Scalars['String']['output']>;
  /** Their current approval status, nil if no decisions were made */
  status: Maybe<OperationDecision>;
};

/** Risk user approval groups */
export enum RiskApprovalGroupType {
  /** Used when the user belongs to the Client Operations team */
  CLIENT_OPS = 'CLIENT_OPS',
  /** Used when the user belongs to the Client Operations that allows to direct edit kyc information */
  CLIENT_OPS_DIRECT_EDIT = 'CLIENT_OPS_DIRECT_EDIT',
  /** Used when the user belongs to the Compliance Hold approval group */
  COMPLIANCE_HOLD = 'COMPLIANCE_HOLD',
  /** Used when the user belongs to the Compliance Trust approval group */
  COMPLIANCE_TRUST = 'COMPLIANCE_TRUST',
  /** Used when the user belongs to the Hold approval group */
  HOLD = 'HOLD',
  /** Used when the user belongs to the Trading team */
  TRADING = 'TRADING',
  /** Used when the user belongs to the Trading Compliance team */
  TRADING_COMPLIANCE = 'TRADING_COMPLIANCE',
  /** Used when the user belongs to the Trading Limits approval group */
  TRADING_LIMITS = 'TRADING_LIMITS',
  /** Used when the user belongs to the Trust approval group */
  TRUST = 'TRUST'
}

/** RiskDashboardUser represents a user of the Risk Dashboard, separate from users of the Anchorage application */
export type RiskDashboardUser = {
  __typename: 'RiskDashboardUser';
  /** email is the email of a RiskDashboardUser, and uniquely identifies that user. */
  email: Scalars['String']['output'];
};

/** Decision recorded when a staff member endorses an operation during risk review. */
export enum RiskDecision {
  /** Approve the operation */
  APPROVE = 'APPROVE',
  /** Reject the operation */
  REJECT = 'REJECT'
}

/** An endorsement performed by a risk reviewer */
export type RiskEndorsement = {
  __typename: 'RiskEndorsement';
  /** The timestamp in nanos of when the comment was added */
  createdAt: Scalars['String']['output'];
  /** Decision made by the reviewer */
  decision: OperationDecision;
  /** Email of the risk reviewer */
  email: Scalars['String']['output'];
  /** ID of the endorsement */
  endorsementID: Scalars['String']['output'];
  /** ID of the Operation associated with this endorsement */
  operationID: Scalars['OperationID']['output'];
};

/** TokenRiskLevelDetail provides a single reason why a scanned token was scored in a particular way. */
export type RiskLevelDetail = {
  __typename: 'RiskLevelDetail';
  /** Description is the text that explains the risk level. */
  description: Scalars['String']['output'];
  /** ID uniquely identifies the type of detail being represented. */
  id: Scalars['String']['output'];
  /** Type is the type of detail being represented. */
  type: TokenRiskLevelDetailType;
};

/** EndorsementRiskData contains all of the risk data gathered about this endorsement */
export type RiskMetadata = {
  __typename: 'RiskMetadata';
  /** altitude is the altitude measured by the device */
  altitude: Scalars['String']['output'];
  /** level of the battery in percentage */
  batteryLevel: Scalars['String']['output'];
  /** biometricFingerprint is a hash of the the biometrics data on the device */
  biometricFingerprint: Scalars['String']['output'];
  /** biometricType is the type of biometics used to authenticate to the secure enclave on the device */
  biometricType: Scalars['String']['output'];
  /** bluetooth information */
  bluetooth: Bluetooth;
  /** Carrier information */
  carrier: Carrier;
  /** createdTime is the time at which the data was gathered */
  createdTime: Scalars['String']['output'];
  /** deviceInfo is the name of the device */
  deviceInfo: Scalars['String']['output'];
  /** Device type */
  deviceType: Scalars['String']['output'];
  /** Distress signal from the client */
  distressSignal: Maybe<Distress>;
  /** IP address from which the endorsement was made (can be empty string for old endorsements) */
  ipAddress: Scalars['String']['output'];
  /** If we can find out from the IP address who their internet provider is, we fill that out here. We can't always know that. */
  ipProvider: Maybe<Scalars['String']['output']>;
  /** latitude is the latitude from GPS */
  latitude: Scalars['String']['output'];
  /** locationCollectionState is the state the location collection ended up in. */
  locationCollectionState: Scalars['String']['output'];
  /** locationCollectionType is the type of the location collection */
  locationCollectionType: Scalars['String']['output'];
  /** locationError provides an error message if the user had an error collecting the location */
  locationError: Maybe<Scalars['String']['output']>;
  /** locationTimestamp discriminates how old the location is. */
  locationTimestamp: Scalars['Float']['output'];
  /** longitude is the longitude from GPS */
  longitude: Scalars['String']['output'];
  /** Model of the device */
  model: Scalars['String']['output'];
  /** list of network interfaces active */
  networkInterfaces: Array<RiskMetadataNetworkInterface>;
  /** information regarding pedometer */
  pedometer: Pedometer;
  /** Optional: If the user used a VPN, TOR or another type of proxy, this returns info about the type of proxy used */
  proxyType: Maybe<Scalars['String']['output']>;
  /** rawMetadata is the unprocessed data sent from the phone */
  rawMetadata: Scalars['String']['output'];
  /**
   * number of steps. -1 if unknown.
   * @deprecated use pedometer field instead
   */
  steps: Scalars['Int']['output'];
  /** System name in use in the device */
  systemName: Scalars['String']['output'];
  /** System version in use in the device */
  systemVersion: Scalars['String']['output'];
  /** voiceBiometricsDetectedText is the text from the speech recognition */
  voiceBiometricsDetectedText: Scalars['String']['output'];
  /** voiceBiometricsDetectedTextConfidence is the confidence of the speech recognition result */
  voiceBiometricsDetectedTextConfidence: Scalars['Float']['output'];
  /** voiceBiometricsError is returned if we are unable to proccess the voice data */
  voiceBiometricsError: Scalars['String']['output'];
  /** voiceBiometricsFaceConfidence indicates the confidence of the face match */
  voiceBiometricsFaceConfidence: Scalars['Float']['output'];
  /** voiceBiometricsStatus indicates the result of the voice biometrics gathering */
  voiceBiometricsStatus: Maybe<VoiceBiometricsStatus>;
  /** voiceBiometricsVoiceConfidence indicates the confidence of the voice match */
  voiceBiometricsVoiceConfidence: Scalars['Float']['output'];
  /** list of wifi names active */
  wifi: Array<Scalars['String']['output']>;
};

/** Risk metadata-specific network interface */
export type RiskMetadataNetworkInterface = {
  __typename: 'RiskMetadataNetworkInterface';
  /** IP Address associated with this interface */
  address: Maybe<Scalars['String']['output']>;
  /** Family of the address */
  family: AddressFamily;
  /** Name of the network interface */
  name: Scalars['String']['output'];
};

/** Vendor for RiskAnalysis */
export enum RiskRequestStatus {
  /** RiskAnalysis has been completed */
  COMPLETE = 'COMPLETE',
  /** RiskAnalysis has failed */
  FAILED = 'FAILED',
  /** RiskAnalysis is being requested */
  PENDING = 'PENDING',
  /** RiskAnalysis has being queued */
  QUEUED = 'QUEUED',
  /** AssetType or Operation for AssetType not Supported */
  UNSUPPORTED = 'UNSUPPORTED'
}

/** RiskReview aggregates all the risk information for the operation, if any */
export type RiskReview = {
  __typename: 'RiskReview';
  /** amlRecord is the associated AML record, if present */
  amlRecord: Maybe<AMLRecord>;
  /** id is the unique identifier of the operation under review, equal to operationID */
  id: Scalars['ID']['output'];
  /** Operation ID for federation resolution */
  operationID: Scalars['String']['output'];
  /** riskAnalysis is the collected risk information for this transaction, if any */
  riskAnalysis: Maybe<TransactionRiskAnalysis>;
  /** travelRule is the travel rule information of the transaction, if applicable */
  travelRule: Maybe<TravelRuleInformation>;
};

/** The type of back office review that must be performed by Anchorage in prior to execution of a scoped action. */
export enum RiskReviewRequirement {
  /** Manual risk review is not required by Anchorage prior to execution of an action. */
  RISK_REVIEW_BYPASSED = 'RISK_REVIEW_BYPASSED',
  /** Manual risk review must be performed by Anchorage prior to execution of an action. */
  RISK_REVIEW_REQUIRED = 'RISK_REVIEW_REQUIRED'
}

/** Details on an operation's risk requirements */
export type RiskReviewRequirements = {
  __typename: 'RiskReviewRequirements';
  /** A list of endorsements that have currently been made for this operation */
  endorsements: Array<RiskEndorsement>;
  /** The groups which are needed for this operation's approval */
  groups: Array<RiskApprovalGroup>;
  /** The number of approvals required for an operation to qualify as passing risk review */
  numRequiredApprovals: Scalars['Int']['output'];
  /** The number of unique reviewers who have reviewed this operation */
  numReviews: Scalars['Int']['output'];
};

/** Role represents a permission group that can be associated with a user or API key */
export type Role = {
  __typename: 'Role';
  /** name is the client-supplied name of the role */
  name: Scalars['String']['output'];
  /** permissions is the list of permissions that are granted by this role */
  permissions: Array<RolePermission>;
  /** publicKeyIDs is the list of api public keys' ids that belong to the role */
  publicKeyIDs: Maybe<Array<Scalars['String']['output']>>;
  /** roleID is the id of the role */
  roleID: RoleID;
};

/** RoleAction represents the name of an action that can be performed with this level of permission */
export enum RoleAction {
  /** ACH_DEBIT_IN is the ability to initiate ACH debits into wallets within a vault */
  ACH_DEBIT_IN = 'ACH_DEBIT_IN',
  /** APPROVE_IAAS_POLICY_ACTIONS is the role of a policy engine approval key: it approves and rejects actions awaiting approval. Its keys are registered by the policy engine, not added to the organization. */
  APPROVE_IAAS_POLICY_ACTIONS = 'APPROVE_IAAS_POLICY_ACTIONS',
  /** AUTHORIZE_SETTLEMENTS gives the ability to authorize settlements involving vaults that have this permission. This has the same effect as iOS endorsements on the operation for authorizing the settlement. */
  AUTHORIZE_SETTLEMENTS = 'AUTHORIZE_SETTLEMENTS',
  /** CONFIGURE_WEBHOOKS gives the ability to configure webhook endpoints and their respective subscriptions */
  CONFIGURE_WEBHOOKS = 'CONFIGURE_WEBHOOKS',
  /** CONSTRUCT_TRANSACTION gives the ability to construct transactions. */
  CONSTRUCT_TRANSACTION = 'CONSTRUCT_TRANSACTION',
  /** CONSTRUCT_TRANSFER gives the ability to construct transfers. */
  CONSTRUCT_TRANSFER = 'CONSTRUCT_TRANSFER',
  /** CONVERT_STABLECOINS gives the ability to create and approve stablecoin conversion. */
  CONVERT_STABLECOINS = 'CONVERT_STABLECOINS',
  /** CREATE_DEPOSIT_ADDRESS is the ability to generate and retrieve deposit addresses within a vault */
  CREATE_DEPOSIT_ADDRESS = 'CREATE_DEPOSIT_ADDRESS',
  /** CREATE_TRANSACTION gives the ability to create transactions. */
  CREATE_TRANSACTION = 'CREATE_TRANSACTION',
  /** DEPOSIT_ATTRIBUTION is the ability to use deposit attribution via API */
  DEPOSIT_ATTRIBUTION = 'DEPOSIT_ATTRIBUTION',
  /**
   * No longer used but kept for backwards compatibility as some orgs may still
   * have this permission.
   */
  DIEM_PREBURN = 'DIEM_PREBURN',
  /** EXTERNAL_LOAN_WRITE is the ability to originate loans through API */
  EXTERNAL_LOAN_WRITE = 'EXTERNAL_LOAN_WRITE',
  /** FACILITY_ONLY is the ability to read lending facility data */
  FACILITY_ONLY = 'FACILITY_ONLY',
  /** FIAT_BANKING gives the ability to directly manage fiat bank external parties and payments. */
  FIAT_BANKING = 'FIAT_BANKING',
  /** HOLD is the ability to create holds on assets in a vault */
  HOLD = 'HOLD',
  /** INITIATE_WITHDRAWAL is the ability to initiate a withdraw from a vault */
  INITIATE_WITHDRAWAL = 'INITIATE_WITHDRAWAL',
  /**
   * INTERNAL_TRANSFER is the ability to transfer assets from one Anchorage vault to another vault
   * @deprecated No longer used. Kept because older organizations may still have this permission.
   */
  INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
  /** LENDER_READ is the ability to read lender account data */
  LENDER_READ = 'LENDER_READ',
  /** MANAGE_COLLATERAL_PACKAGES gives the ability to manage collateral packages */
  MANAGE_COLLATERAL_PACKAGES = 'MANAGE_COLLATERAL_PACKAGES',
  /** MANAGE_IAAS_POLICY_ENGINE gives the ability to manage the organization's policy engine: create and archive policies, register and revoke approval keys, and manage approval groups and their members, plus everything READ_IAAS_POLICY_ENGINE allows. */
  MANAGE_IAAS_POLICY_ENGINE = 'MANAGE_IAAS_POLICY_ENGINE',
  /** MANAGE_TAGS gives the ability to create, update, and delete tags for the organization */
  MANAGE_TAGS = 'MANAGE_TAGS',
  /** MANAGE_TRUSTED_DESTINATIONS gives the ability to add and remove trusted destinations from the organization */
  MANAGE_TRUSTED_DESTINATIONS = 'MANAGE_TRUSTED_DESTINATIONS',
  /** ONBOARDING is the ability to manage onboarding data */
  ONBOARDING = 'ONBOARDING',
  /** PROPOSE_ACCEPT_SETTLEMENTS gives the ability to propose or accept settlements involving vaults that have this permission. They still have to be authorized separately through the API or app. */
  PROPOSE_ACCEPT_SETTLEMENTS = 'PROPOSE_ACCEPT_SETTLEMENTS',
  /** PROPOSE_CONSTRUCT_TRANSACTION gives the ability to propose construct transactions. */
  PROPOSE_CONSTRUCT_TRANSACTION = 'PROPOSE_CONSTRUCT_TRANSACTION',
  /** PROPOSE_CONSTRUCT_TRANSFER gives the ability to propose construct transfers. */
  PROPOSE_CONSTRUCT_TRANSFER = 'PROPOSE_CONSTRUCT_TRANSFER',
  /** PROPOSE_CREATE_TRANSACTION gives the ability to propose create transactions. */
  PROPOSE_CREATE_TRANSACTION = 'PROPOSE_CREATE_TRANSACTION',
  /** READ is read access to vault and account metadata */
  READ = 'READ',
  /** READ_AUDIT_EVENTS gives the ability to read the organization's audit trail events */
  READ_AUDIT_EVENTS = 'READ_AUDIT_EVENTS',
  /** READ_DEPOSIT_ATTRIBUTION is the ability to read deposit attribution data via API */
  READ_DEPOSIT_ATTRIBUTION = 'READ_DEPOSIT_ATTRIBUTION',
  /** READ_IAAS_POLICY_ENGINE gives read-only access to the organization's policy engine: its policies, approval keys, approval groups and the actions awaiting endorsement. */
  READ_IAAS_POLICY_ENGINE = 'READ_IAAS_POLICY_ENGINE',
  /** READ_STATEMENTS gives the ability to read and download statements for the organization */
  READ_STATEMENTS = 'READ_STATEMENTS',
  /** READ_SUBACCOUNT is the ability to read data from the subaccount system */
  READ_SUBACCOUNT = 'READ_SUBACCOUNT',
  /** READ_TRADE is the ability to read all trade data */
  READ_TRADE = 'READ_TRADE',
  /** REJECT_OPERATION gives the ability to reject in-progress operations via API. */
  REJECT_OPERATION = 'REJECT_OPERATION',
  /** STABLECOIN_ISSUANCE gives the ability to mint and burn stablecoins via API. */
  STABLECOIN_ISSUANCE = 'STABLECOIN_ISSUANCE',
  /** STAKE gives the ability to stake and unstake assets */
  STAKE = 'STAKE',
  /** STAKE2 gives the ability to create staking/unstaking related transactions. */
  STAKE2 = 'STAKE2',
  /** SUBACCOUNT is the ability to use subaccount system to manage positions */
  SUBACCOUNT = 'SUBACCOUNT',
  /** TOKEN_ISSUANCE gives the ability to mint and burn tokenized assets via API. */
  TOKEN_ISSUANCE = 'TOKEN_ISSUANCE',
  /** TRADE is the ability to execute trades and read trade data created by the API key */
  TRADE = 'TRADE',
  /** TRANSFER is the ability to transfer assets */
  TRANSFER = 'TRANSFER',
  /** VIRTUAL_ACCOUNTS is the ability to create and delete virtual accounts within a vault */
  VIRTUAL_ACCOUNTS = 'VIRTUAL_ACCOUNTS',
  /** WRITE_TAX is the ability to access tax endpoints (accounts/transfers) */
  WRITE_TAX = 'WRITE_TAX'
}

/** RoleChangeType describes the type of role change that the operation is performing */
export enum RoleChangeType {
  /** CREATE indicates a new role is being created */
  CREATE = 'CREATE',
  /** DELETE indicates an existing role is being deleted */
  DELETE = 'DELETE',
  /** UPDATE indicates an existing role is being updated */
  UPDATE = 'UPDATE'
}

/** RoleID identifies a role within an organization */
export type RoleID = {
  __typename: 'RoleID';
  /** organizationKeyID is the ID of the organization this role belongs to */
  organizationKeyID: Scalars['String']['output'];
  /** roleSubID is the id of the role within the context of this organization */
  roleSubID: Scalars['String']['output'];
};

/**
 * RolePermission permits an action, with action-specific parameters such as whitelisted vaults.
 * This reflects the internal, but non-sensitive, representation of the permission.
 */
export type RolePermission = {
  __typename: 'RolePermission';
  /** action describes the action that is being enabled for this role */
  action: RoleAction;
  /** anySourceVault indicates the action is valid for any source vault. */
  anySourceVault: Scalars['Boolean']['output'];
  /** destination indicates valid destinations for this action. */
  destination: Maybe<Destination>;
  /**
   * destinationOrgKeyIDs was never used and will be removed soon.
   * @deprecated never populated, will be removed when app no longer queries field
   */
  destinationOrgKeyIDs: Maybe<Array<Scalars['String']['output']>>;
  /**
   * sourceVaults is the list of vaults that this action is valid in.
   *
   * For backwards compatibility, an empty list means all current and future vaults are allowed. However, please instead use `anySourceVault`.
   */
  sourceVaults: Array<Vault>;
  /** transferLimit is a user-chosen limit of funds transferrable in a time window. */
  transferLimit: Maybe<AmountDuration>;
};

/**
 * RolePermissionChange is a deprecated model meant to detail a permission or a change to a permission as used by the user interface.
 *
 * This type is basically an alias for RolePermissionDetail. An early Demo app release includes a query fragment for this type.
 */
export type RolePermissionChange = {
  __typename: 'RolePermissionChange';
  /** changeType indicates what type of change (if any) is occurring for a permission. */
  changeType: RolePermissionChangeType;
  /** destinations contains detail on allowed destinations for this permission. */
  destinations: Maybe<Array<RolePermissionDestinationDetail>>;
  /** previousSubtitle is an optional prior user interface subtitle when a permission is being updated or deleted. */
  previousSubtitle: Maybe<Scalars['String']['output']>;
  /** previousTitle is the prior user interface title for this permission. Only present when the title has changed. */
  previousTitle: Maybe<Scalars['String']['output']>;
  /** reviewTitle is an optional user interface prompt to review further details for a permission, such as destinations. */
  reviewTitle: Maybe<Scalars['String']['output']>;
  /** subtitle is an optional user interface subtitle for this permission. */
  subtitle: Maybe<Scalars['String']['output']>;
  /** title is a user interface title for this permission. */
  title: Maybe<Scalars['String']['output']>;
};

/** RolePermissionChangeType indicates the type of change occurring for a permission */
export enum RolePermissionChangeType {
  /** CREATE is used when a new permission is being added that didn't exist before. */
  CREATE = 'CREATE',
  /** DELETE is used when an existing permission will no longer exist. */
  DELETE = 'DELETE',
  /** UNCHANGED is used when viewing an existing permission that is not being changed. */
  UNCHANGED = 'UNCHANGED',
  /** UPDATE is used when an existing permission has one or more parameters being changed. */
  UPDATE = 'UPDATE'
}

/**
 * RolePermissionChanges is a deprecated model meant to details a role permissions as used by the user interface.
 *
 * This type is basically an alias for RolePermissionDetails. An early Demo app release includes a query fragment for this type.
 */
export type RolePermissionChanges = {
  __typename: 'RolePermissionChanges';
  /** amountLimit includes changes to an amount limit, which is relevant for the transfer permission. */
  amountLimit: Maybe<Array<RolePermissionChange>>;
  /** destinations includes changes to allowed transfer destinations. */
  destinations: Maybe<Array<RolePermissionChange>>;
  /** globalPermissions includes permissions which do not pertain to vaults. */
  globalPermissions: Maybe<Array<RolePermissionChange>>;
  /** transferTypes includes categorical changes to the transfer permission (internal/external). */
  transferTypes: Maybe<Array<RolePermissionChange>>;
  /** vaultPermissions includes permissions which apply to vaults, but excludes the transfer permission. */
  vaultPermissions: Maybe<Array<RolePermissionChange>>;
};

/** RolePermissionDestinationDetail details an allowed destination for a permission as used by the user interface. */
export type RolePermissionDestinationDetail = AMLBlockchainAddress | TrustedDestination;

/** RolePermissionDetail details a permission or a change to a permission as used by the user interface. */
export type RolePermissionDetail = {
  __typename: 'RolePermissionDetail';
  /** active is a user interface value for this permission. */
  active: Maybe<Scalars['Boolean']['output']>;
  /** changeType indicates what type of change (if any) is occurring for a permission. */
  changeType: RolePermissionChangeType;
  /** destinations contains detail on allowed destinations for this permission. */
  destinations: Maybe<Array<RolePermissionDestinationDetail>>;
  /** fiatTrustedDestinations are the fiat trusted destinations allowlisted for this permission, hydrated by the fiat subgraph. */
  fiatTrustedDestinations: Maybe<Array<FiatTrustedDestination>>;
  /** previousSubtitle is an optional prior user interface subtitle when a permission is being updated or deleted. */
  previousSubtitle: Maybe<Scalars['String']['output']>;
  /** previousTitle is the prior user interface title for this permission. Only present when the title has changed. */
  previousTitle: Maybe<Scalars['String']['output']>;
  /** previouslyActive is the prior user interface value for this permission. Only present when the value has changed. */
  previouslyActive: Maybe<Scalars['Boolean']['output']>;
  /** reviewTitle is an optional user interface prompt to review further details for a permission, such as destinations. */
  reviewTitle: Maybe<Scalars['String']['output']>;
  /** subtitle is an optional user interface subtitle for this permission. */
  subtitle: Maybe<Scalars['String']['output']>;
  /** title is a user interface title for this permission. */
  title: Maybe<Scalars['String']['output']>;
  /** transferType indicates if the transfer is an INTERNAL or EXTERNAL transfer. */
  transferType: Maybe<RolePermissionTransferType>;
};

/** RolePermissionDetails details a role permissions as used by the user interface. */
export type RolePermissionDetails = {
  __typename: 'RolePermissionDetails';
  /** amountLimit includes changes to an amount limit, which is relevant for the transfer permission. */
  amountLimit: Maybe<Array<RolePermissionDetail>>;
  /** destinations includes changes to allowed transfer destinations. */
  destinations: Maybe<Array<RolePermissionDetail>>;
  /** globalPermissions includes permissions which do not pertain to vaults. */
  globalPermissions: Maybe<Array<RolePermissionDetail>>;
  /** roleID is the id of the role these details are associated with */
  roleID: RoleID;
  /** transferTypes includes categorical changes to the transfer permission (internal/external). */
  transferTypes: Maybe<Array<RolePermissionDetail>>;
  /** vaultPermissions includes permissions which apply to vaults, but excludes the transfer permission. */
  vaultPermissions: Maybe<Array<RolePermissionDetail>>;
};

/** RolePermissionTransferType represents the type of transfer permission the change refers */
export enum RolePermissionTransferType {
  /** EXTERNAL_TRANSFER is the type of transfer permission associated with external transfers */
  EXTERNAL_TRANSFER = 'EXTERNAL_TRANSFER',
  /** INTERNAL_TRANSFERs is the type of transfer permission associated with internal transfers */
  INTERNAL_TRANSFER = 'INTERNAL_TRANSFER'
}

/** Represents a rule that can be applied to a policy action. */
export type Rule = {
  /** Action that the rule will be applied to */
  action: PolicyAction;
  /** Identifier of a rule */
  id: Scalars['ID']['output'];
};

export type RuleAction = PolicyAction & {
  __typename: 'RuleAction';
  /** Identifier of the action */
  id: Scalars['String']['output'];
  /** Name of the action */
  name: Scalars['String']['output'];
  /** Condition types the editor can offer under this action. */
  possibleConditions: Array<RuleConditionType>;
  /**
   * Condition type keys (matching RuleConditionType.key) this action's catalog
   * entry requires. A key absent from possibleConditions (because it is gated off)
   * means no rule satisfying this action can be built yet. Empty when the action
   * requires no conditions.
   */
  requiredConditionTypeKeys: Array<Scalars['String']['output']>;
};

/** A single condition on a rule. The conditions list on a rule is AND-composed. */
export type RuleCondition = {
  __typename: 'RuleCondition';
  /**
   * Per-instance condition identity, stable across edits — round-trip on
   * `RuleConditionInput.id` so the BE can tell an update from a delete+add.
   */
  id: Scalars['ID']['output'];
  operator: RuleConditionOperator;
  parameters: Array<RuleConditionParameter>;
  type: RuleConditionType;
};

export enum RuleConditionAvailability {
  ENABLED = 'ENABLED',
  HIDDEN = 'HIDDEN',
  UNAVAILABLE = 'UNAVAILABLE'
}

/**
 * Rendering signal only: the args member's __typename tells the client which
 * component to render, and its fields name the parameter keys that component fills.
 */
export type RuleConditionComponent = {
  __typename: 'RuleConditionComponent';
  args: RuleConditionComponentArgs;
};

export type RuleConditionComponentArgs = TrustedSmartContractMethodArgs;

export type RuleConditionInput = {
  /**
   * Per-instance condition identity. Omit on create; the BE generates one.
   * Round-tripped on edit so identity is preserved across changes.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  operatorKey: Scalars['String']['input'];
  parameters: Array<RuleConditionParameterInput>;
  typeKey: Scalars['String']['input'];
};

/** Severity of a form message. Clients treat an unknown value as INFO. */
export enum RuleConditionMessageSeverity {
  INFO = 'INFO',
  WARNING = 'WARNING'
}

export type RuleConditionMultiSelectParameter = RuleConditionParameter & {
  __typename: 'RuleConditionMultiSelectParameter';
  defaultValues: Maybe<Array<RuleConditionParameterOption>>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  possibleValues: Array<RuleConditionParameterOption>;
  readOnly: Scalars['Boolean']['output'];
  required: Maybe<RuleConditionRequiredValidation>;
  /**
   * The selected options, in the order they were saved. The order has no meaning:
   * the condition holds when the request value matches any of them. Compare
   * selections as sets, and send an unchanged selection back as it was read.
   */
  values: Array<RuleConditionParameterOption>;
};

export type RuleConditionNumberParameter = RuleConditionParameter & {
  __typename: 'RuleConditionNumberParameter';
  defaultValue: Maybe<Scalars['String']['output']>;
  helperMessage: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Most decimal places the value may have. Null when the field declares no limit. */
  precision: Maybe<Scalars['Int']['output']>;
  readOnly: Scalars['Boolean']['output'];
  required: Maybe<RuleConditionRequiredValidation>;
  value: Maybe<Scalars['String']['output']>;
};

export type RuleConditionOperator = {
  __typename: 'RuleConditionOperator';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type RuleConditionParameter = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /**
   * Whether the client must render the field without letting the user change it.
   * The value is still sent back on save. The server does not enforce it: a save
   * that changes a read-only value is accepted.
   */
  readOnly: Scalars['Boolean']['output'];
  /**
   * Null when the field is optional. When set, the field must hold a value (for a
   * multi-select, at least one selection) and errorMessage is the copy shown while
   * it does not.
   */
  required: Maybe<RuleConditionRequiredValidation>;
};

export type RuleConditionParameterInput = {
  key: Scalars['String']['input'];
  value: RuleConditionParameterValueInput;
};

export type RuleConditionParameterMultiSelectValueInput = {
  /**
   * The selected option keys. They are stored in the order sent and read back in
   * that order. The order has no meaning for the condition.
   */
  optionKeys: Array<Scalars['String']['input']>;
};

export type RuleConditionParameterOption = {
  __typename: 'RuleConditionParameterOption';
  children: Array<RuleConditionParameterOption>;
  description: Maybe<Scalars['String']['output']>;
  /** Icon shown next to the option. Null when the option has none. */
  icon: Maybe<RuleConditionParameterOptionIcon>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** One icon source per option. A client that recognizes no member shows no icon. */
export type RuleConditionParameterOptionIcon = RuleConditionProductIcon | RuleConditionRemoteIcon;

export type RuleConditionParameterSelectValueInput = {
  optionKey: Scalars['String']['input'];
};

/** Exactly one of the four fields per parameter. */
export type RuleConditionParameterValueInput =
  { multiSelect: RuleConditionParameterMultiSelectValueInput; number?: never; select?: never; text?: never; }
  |  { multiSelect?: never; number: Scalars['String']['input']; select?: never; text?: never; }
  |  { multiSelect?: never; number?: never; select: RuleConditionParameterSelectValueInput; text?: never; }
  |  { multiSelect?: never; number?: never; select?: never; text: Scalars['String']['input']; };

/** A design-system icon, same convention as RuleConditionType.icon. */
export type RuleConditionProductIcon = {
  __typename: 'RuleConditionProductIcon';
  name: Scalars['String']['output'];
};

/** A remote asset icon on the static host, with the URL rule of AssetTypeInfo.iconURL. */
export type RuleConditionRemoteIcon = {
  __typename: 'RuleConditionRemoteIcon';
  /**
   * URL of the icon in the requested rendition. If the type is SVG, the size is
   * ignored. PNG sizes are 24, 48 and 72. Icons are square.
   */
  url: Scalars['String']['output'];
};


/** A remote asset icon on the static host, with the URL rule of AssetTypeInfo.iconURL. */
export type RuleConditionRemoteIconurlArgs = {
  iconType?: IconType;
  size?: Scalars['Int']['input'];
};

/** Present on a parameter only when the field must hold a value. */
export type RuleConditionRequiredValidation = {
  __typename: 'RuleConditionRequiredValidation';
  errorMessage: Scalars['String']['output'];
};

export type RuleConditionSelectParameter = RuleConditionParameter & {
  __typename: 'RuleConditionSelectParameter';
  defaultValue: Maybe<RuleConditionParameterOption>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  possibleValues: Array<RuleConditionParameterOption>;
  readOnly: Scalars['Boolean']['output'];
  required: Maybe<RuleConditionRequiredValidation>;
  value: Maybe<RuleConditionParameterOption>;
};

export type RuleConditionSentence = {
  __typename: 'RuleConditionSentence';
  elements: Array<RuleConditionSentenceElement>;
};

export type RuleConditionSentenceElement = {
  __typename: 'RuleConditionSentenceElement';
  appearance: RuleConditionSentenceElementAppearance;
  content: RuleConditionSentenceElementContent;
};

export enum RuleConditionSentenceElementAppearance {
  DEFAULT = 'DEFAULT',
  EMPHASIS = 'EMPHASIS',
  MUTED = 'MUTED'
}

export type RuleConditionSentenceElementContent = RuleConditionSentenceLiteralElementContent | RuleConditionSentenceOperatorElementContent | RuleConditionSentenceParameterElementContent | RuleConditionSentenceTypeElementContent;

export type RuleConditionSentenceLiteralElementContent = {
  __typename: 'RuleConditionSentenceLiteralElementContent';
  text: Scalars['String']['output'];
};

export type RuleConditionSentenceOperatorElementContent = {
  __typename: 'RuleConditionSentenceOperatorElementContent';
  isOperatorElement: Scalars['Boolean']['output'];
};

export type RuleConditionSentenceParameterElementContent = {
  __typename: 'RuleConditionSentenceParameterElementContent';
  keyRef: Scalars['String']['output'];
  maxElements: Maybe<Scalars['Int']['output']>;
  pluralObjectType: Maybe<Scalars['String']['output']>;
};

export type RuleConditionSentenceTypeElementContent = {
  __typename: 'RuleConditionSentenceTypeElementContent';
  isTypeElement: Scalars['Boolean']['output'];
};

export type RuleConditionTextParameter = RuleConditionParameter & {
  __typename: 'RuleConditionTextParameter';
  defaultValue: Maybe<Scalars['String']['output']>;
  helperMessage: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  required: Maybe<RuleConditionRequiredValidation>;
  value: Maybe<Scalars['String']['output']>;
};

/** Catalog entry describing one condition type the FE can offer. */
export type RuleConditionType = {
  __typename: 'RuleConditionType';
  availability: RuleConditionAvailability;
  /**
   * Bespoke client component that fills this type's parameters, when one exists.
   * Null means the generic per-parameter editors apply.
   */
  component: Maybe<RuleConditionComponent>;
  defaultOperator: Maybe<RuleConditionOperator>;
  description: Maybe<Scalars['String']['output']>;
  /**
   * One static message shown below the parameters while this type is selected.
   * Null shows nothing.
   */
  formMessage: Maybe<RuleConditionTypeFormMessage>;
  icon: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  parameters: Array<RuleConditionParameter>;
  possibleOperators: Array<RuleConditionOperator>;
  sentence: RuleConditionSentence;
};

/** Static copy a condition type shows in its form, with the tone to render it in. */
export type RuleConditionTypeFormMessage = {
  __typename: 'RuleConditionTypeFormMessage';
  message: Scalars['String']['output'];
  severity: RuleConditionMessageSeverity;
};

export type RuleConditions = {
  __typename: 'RuleConditions';
  items: Array<RuleCondition>;
};

/** Represents a paginated connection of rules. */
export type RuleConnection = {
  __typename: 'RuleConnection';
  /** A list of edges */
  edges: Array<RuleEdge>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type RuleDeltaInput = {
  add: Array<RuleInput>;
  /**
   * Full ordered list of rule IDs after the edit applies — must contain every
   * rule that should exist post-edit (newly added, updated, and unchanged).
   * The BE infers order from this list; partial lists are rejected.
   */
  order: Array<Scalars['ID']['input']>;
  remove: Array<Scalars['ID']['input']>;
  update: Array<RuleInput>;
};

/** Represents an edge in a paginated connection of rules. */
export type RuleEdge = {
  __typename: 'RuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Rule;
};

export type RuleInput = {
  actionID: Scalars['String']['input'];
  conditions: Array<RuleConditionInput>;
  /**
   * Per-instance rule identity. FE-generated and arbitrary; used by
   * RuleDeltaInput to reference rules in update/reorder operations.
   */
  id: Scalars['ID']['input'];
  outcome: RuleOutcomeInput;
};

export type RuleOutcome = BlockOutcome | QuorumOutcome;

/** Exactly one of quorum or block. */
export type RuleOutcomeInput =
  { block: BlockOutcomeInput; quorum?: never; }
  |  { block?: never; quorum: QuorumOutcomeInput; };

/** The parameters to sweep. An omitted field keeps its governed value. */
export type RunDvVarInput = {
  /**
   * How many backtest results to make, each carrying the var cut a step before
   * it and the step it forecast. Widens the window to the lookback plus this
   * count, so the run reports as ungoverned.
   */
  backtestSteps?: InputMaybe<Scalars['Int']['input']>;
  /** Run even though the date already holds a governed result. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  /** Length of the historical return series, in time steps. */
  lookbackSteps?: InputMaybe<Scalars['Int']['input']>;
  parameterisation?: InputMaybe<Scalars['String']['input']>;
  /** Confidence levels as fractions in (0,1) - the governed level is 0.99. */
  percentiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Price exactly these positions instead of the whole book, whether or not the
   * book holds them. Replaces both standard legs with one CUSTOM target and
   * reports the run as ungoverned.
   */
  positions?: InputMaybe<Array<RunDvVarPosition>>;
  /**
   * Price the book these Haruko venue accounts hold when the run starts, instead
   * of the whole book. Replaces the standard legs with one VENUE target and
   * reports the run as ungoverned. A venue an otc account carries is read as the
   * house side, with each notional negated. Refused beside positions, empty, or
   * naming an id twice.
   */
  venueAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * End of the return window. Moves the window without moving the as-of date,
   * which is what a stress run over a past window needs. Cannot be later than
   * the day's valuation instant.
   */
  windowEnd?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RunDvVarOutput = {
  __typename: 'RunDvVarOutput';
  asOfDate: Maybe<Scalars['Date']['output']>;
  /** Null on a run that was skipped rather than started. */
  runId: Maybe<Scalars['ID']['output']>;
  /** Why no run started. Null on a run that did. */
  skippedReason: Maybe<Scalars['String']['output']>;
  /** PENDING on a run that started - the pricing is still going. */
  status: Maybe<DvVarRunStatus>;
};

/**
 * One position to price exactly as given. Mirrors the Haruko position: the
 * server fills notionalCurrency, premiumCurrency, venue and id.
 */
export type RunDvVarPosition = {
  /** BTC or ETH - the only pairs the model prices. */
  baseAsset: Scalars['String']['input'];
  /** Must be after the run's valuation instant. */
  expiry: Scalars['DateTime']['input'];
  /**
   * Signed in the base asset - negative is short. A decimal string, like
   * percentiles.
   */
  notional: Scalars['String']['input'];
  /** Required for a vanilla, refused otherwise. */
  optionSide?: InputMaybe<DvVarOptionSide>;
  positionType: DvVarPositionType;
  /** A decimal string. Required and positive for a vanilla, refused otherwise. */
  strike?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  termAsset: Scalars['String']['input'];
  venueAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type RunLTVMonitorResult = {
  __typename: 'RunLTVMonitorResult';
  /** Bool result */
  success: Scalars['Boolean']['output'];
};

export type RunSettlementMonitorResult = {
  __typename: 'RunSettlementMonitorResult';
  /** Bool result */
  success: Scalars['Boolean']['output'];
};

export type RunWalletMonitorResult = {
  __typename: 'RunWalletMonitorResult';
  /** Bool result */
  success: Scalars['Boolean']['output'];
};

export type SEAmount = {
  __typename: 'SEAmount';
  asset: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
};

export type SEAmountInput = {
  asset: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
};

export type SECreateLocationInput = {
  /** Create Counterparty Account for balance tracking, default to false */
  createCtpyAcc?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional UUID identifier
   * If the client provides an invalid UUID, then it errors
   * If the client doesn't provide any UUID then the system will generate a UUIDv4
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notesMD: Scalars['String']['input'];
};

/**
 * SECreateTransferInput is used to create a transfer
 * For a deposit:
 * - SourceAccount is the cty depositing the funds
 * - DestinationAccount is where the funds are being deposited into
 * For a withdrawal:
 * - SourceAccount is where the funds are being withdrawn from
 * - DestinationAccount is the cty withdrawing the funds
 * For a credit transfer:
 * - SourceAccount is who is sending the funds
 * - DestinationAccount is who is receiving the funds
 * For a transfer between two debit accounts:
 * - SourceAccount is where the funds are being sent from
 * - DestinationAccount is where the funds are being sent to
 */
export type SECreateTransferInput = {
  asset: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  destinationAccountID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalTxID?: InputMaybe<Scalars['String']['input']>;
  fees?: InputMaybe<Array<SEAmountInput>>;
  instructionID?: InputMaybe<Scalars['ID']['input']>;
  integrationID?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  notesMD: Scalars['String']['input'];
  notionalQuantityUSD?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['String']['input'];
  settlementID?: InputMaybe<Scalars['ID']['input']>;
  sourceAccountID?: InputMaybe<Scalars['ID']['input']>;
  transferType: SETransferType;
};

export type SELocation = {
  __typename: 'SELocation';
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  /** ID of the location */
  id: Scalars['ID']['output'];
  /** Name of the location */
  name: Scalars['String']['output'];
  /** NotesMD of the location */
  notesMD: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type SELocationConnection = {
  __typename: 'SELocationConnection';
  edges: Array<SELocationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SELocationEdge = {
  __typename: 'SELocationEdge';
  cursor: Scalars['CursorType']['output'];
  node: SELocation;
};

export type SELocationInput = {
  filterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input for reconciling transfers against ledger */
export type SEReconcileTransfersInput = {
  /** Optional list of transfer IDs to reconcile. If empty, reconciles all transfers. */
  filterID?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Maximum number of transfers to check in this reconciliation run */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of transfers to skip before starting reconciliation */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A specific reconciliation mismatch between transfer and ledger */
export type SEReconciliationMismatch = {
  __typename: 'SEReconciliationMismatch';
  /** Actual amount found in ledger */
  actualAmount: Scalars['String']['output'];
  /** Asset involved in the mismatch */
  asset: Scalars['String']['output'];
  /** Balance type (e.g., POSTED, HOLD, PENDING) */
  balanceType: Scalars['String']['output'];
  /** Difference between expected and actual (expected - actual) */
  difference: Scalars['String']['output'];
  /** Entity ID involved in the mismatch */
  entityID: Scalars['String']['output'];
  /** Entity type (e.g., COUNTERPARTY, COUNTERPARTY_DEBIT) */
  entityType: Scalars['String']['output'];
  /** Expected amount from transfer data */
  expectedAmount: Scalars['String']['output'];
  /** ID of the transfer with the mismatch */
  transferID: Scalars['ID']['output'];
};

/** Result of transfer reconciliation */
export type SEReconciliationResult = {
  __typename: 'SEReconciliationResult';
  /** Number of transfers that failed validation (invalid accounts or transfer type) */
  invalidTransfers: Scalars['Int']['output'];
  /** List of transfer IDs that have ledger balance mismatches */
  mismatchedTransfers: Array<Scalars['ID']['output']>;
  /** Detailed list of all ledger balance mismatches found */
  mismatches: Array<SEReconciliationMismatch>;
  /** Total number of transfers checked */
  totalTransfersChecked: Scalars['Int']['output'];
  /** Number of transfers that passed validation (valid accounts and transfer type) */
  validTransfers: Scalars['Int']['output'];
  /** Validation errors (account not found, inactive, or incorrect transfer type) */
  validationErrors: Array<SEValidationError>;
};

/**
 * Settlement represents the intent of transferring funds from A to B
 * Settlements are then payed off using Transfers, the transfer itself is just the
 * representation of the 'I owe you' (IOU)
 * TODO(BRO-7149): settlement information is still incomplete, to be wrapped up
 */
export type SESettlement = {
  __typename: 'SESettlement';
  /** ID of the settlement */
  id: Scalars['ID']['output'];
};

/**
 * SETransfer represents a set of movement of funds in the 'real world'
 * Depending on the type of the transfer it might be 1 or more transactions
 * E.g. An Atlas settlement might imply multiple blockchain transaction but would
 * be represented as a single settlement engine transfer
 */
export type SETransfer = {
  __typename: 'SETransfer';
  /**
   * Asset that was transferred
   * TODO(BRO-7148): This should reference a trading asset
   */
  asset: Scalars['String']['output'];
  destinationAccountID: Maybe<Scalars['ID']['output']>;
  /** Internal details information */
  details: Maybe<SETransferDetails>;
  externalID: Scalars['String']['output'];
  /** transaction ID in the ledger */
  externalTxID: Maybe<Scalars['String']['output']>;
  fees: Maybe<Array<SEAmount>>;
  /** ID of the transfer */
  id: Scalars['ID']['output'];
  integrationID: Scalars['String']['output'];
  metadata: Maybe<Scalars['String']['output']>;
  /** Notional Quantity in USD that was transferred */
  notionalQuantityUSD: Maybe<Scalars['String']['output']>;
  /** Quantity that was transferred */
  quantity: Scalars['String']['output'];
  /** Settlement associated with this transfer */
  settlement: Maybe<SESettlement>;
  sourceAccountID: Maybe<Scalars['ID']['output']>;
  /** State of the transfer */
  state: SETransferState;
  /** TransferType of the transfer */
  transferType: SETransferType;
};

export type SETransferConnection = {
  __typename: 'SETransferConnection';
  edges: Array<SETransferEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Details about the transfer, only available to authorized parties */
export type SETransferDetails = {
  __typename: 'SETransferDetails';
  /** When was this transfer created */
  createdAt: Scalars['DateTime']['output'];
  /** Who created this transfer */
  createdBy: Scalars['String']['output'];
  /** NotesMD is a markdown string that can be used to store additional information */
  notesMD: Scalars['String']['output'];
  /** When was this transfer updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Who updated this transfer */
  updatedBy: Scalars['String']['output'];
};

export type SETransferEdge = {
  __typename: 'SETransferEdge';
  cursor: Scalars['CursorType']['output'];
  node: SETransfer;
};

export type SETransferInput = {
  filterAsset?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * This value is provided in
   * nanoseconds (e.g. 1748553168374659132) and inclusive for both After and Before
   */
  filterCreatedAtAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  filterCreatedAtBefore?: InputMaybe<Scalars['Timestamp']['input']>;
  filterDestinationAccountID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterExternalID?: InputMaybe<Array<Scalars['String']['input']>>;
  filterExternalTxID?: InputMaybe<Array<Scalars['String']['input']>>;
  filterID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterIntegrationID?: InputMaybe<Array<Scalars['String']['input']>>;
  filterNotionalThreshold?: InputMaybe<Scalars['String']['input']>;
  filterSettlementID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterSourceAccountID?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterState?: InputMaybe<Array<SETransferState>>;
  filterTransferType?: InputMaybe<Array<SETransferType>>;
};

export enum SETransferState {
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  LOCK_MUTEX = 'LOCK_MUTEX',
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED',
  REQUIRES_APPROVAL = 'REQUIRES_APPROVAL',
  REQUIRES_ASSIGNMENT = 'REQUIRES_ASSIGNMENT',
  REVERSED = 'REVERSED',
  SUCCESS = 'SUCCESS'
}

export enum SETransferType {
  /** Transfer between two credit accounts */
  CREDIT_TRANSFER = 'CREDIT_TRANSFER',
  /** Transfer between two debit accounts */
  DEBIT_TRANSFER = 'DEBIT_TRANSFER',
  /** Deposit of funds, impacts a credit and a debit account */
  DEPOSIT = 'DEPOSIT',
  /** Withdrawal of funds, impacts a credit and a debit account */
  WITHDRAWAL = 'WITHDRAWAL'
}

export type SEUpdateLocationInput = {
  /** ID of the location to update */
  id: Scalars['ID']['input'];
  /** Name of the location */
  name?: InputMaybe<Scalars['String']['input']>;
  /** NotesMD of the location */
  notesMD?: InputMaybe<Scalars['String']['input']>;
};

export type SEUpdateTransferInput = {
  destinationAccountID?: InputMaybe<Scalars['ID']['input']>;
  externalTxID?: InputMaybe<Scalars['String']['input']>;
  fees?: InputMaybe<Array<SEAmountInput>>;
  id: Scalars['ID']['input'];
  notesMD?: InputMaybe<Scalars['String']['input']>;
  notionalQuantityUSD?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<SEAmountInput>;
  settlementID?: InputMaybe<Scalars['String']['input']>;
  sourceAccountID?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SETransferType>;
};

/** A validation error for a transfer (account or transfer type issue) */
export type SEValidationError = {
  __typename: 'SEValidationError';
  /** Field that has the error (e.g., source_account, destination_account, type) */
  field: Scalars['String']['output'];
  /** Description of the validation error */
  message: Scalars['String']['output'];
  /** ID of the transfer with the validation error */
  transferID: Scalars['ID']['output'];
};

/** Action is the action to be taken when the matcher is matched. */
export type SNAction = SNWalletSelectAction;

/** Action is the action to be taken when the matcher is matched. */
export type SNActionInput = {
  /** The wallet that needs to be selected for the automation. */
  walletUniqueID?: InputMaybe<Scalars['String']['input']>;
};

/**
 * An automation is a rule that can be set by the user to automatically select a wallet for a settlement.
 * It is a combination of a matcher and an action. The matcher is used to determine if the rule should be applied, and the action is used to select the wallet.
 */
export type SNAutomation = {
  __typename: 'SNAutomation';
  /** The action to be taken when the condition is met. */
  action: SNAction;
  /** The condition that must be met for the automation to be triggered. */
  matcher: SNMatcher;
  /** The priority of the automation rule */
  priority: Scalars['Int']['output'];
};

/** Automations define the rules where a articipant can skip the acceptor review step when creating a settlement. */
export type SNAutomationInput = {
  /** The action to be taken when the condition is met. */
  action: SNActionInput;
  /** The condition that must be met for the automation to be triggered. */
  matcher: SNMatcherInput;
  /** priority of the automation rule, lower numbers are higher priority. */
  priority: Scalars['Int']['input'];
};

/** A matcher that uses the counterparty ID and the assetType to match a settlement. */
export type SNCounterPartyAssetMatcher = {
  __typename: 'SNCounterPartyAssetMatcher';
  /**
   * The asset type IDs to match against.
   * Matches a settlement if it contains a wallet amount with an asset in this list.
   */
  assetTypeIDs: Array<Scalars['AssetTypeID']['output']>;
  /** The participant ID to match against. */
  counterpartyID: Maybe<Scalars['ID']['output']>;
};

/** A connection to a list of items. */
export type SNCounterpartyConnection = {
  __typename: 'SNCounterpartyConnection';
  /** A list of edges. */
  edges: Array<SNCounterpartyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SNCounterpartyEdge = {
  __typename: 'SNCounterpartyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SNTrustedCounterparty;
};

/** One reason a wallet's available balance sits below its total balance. */
export type SNFundingHold = {
  __typename: 'SNFundingHold';
  amount: Amount;
  description: Scalars['String']['output'];
  holdType: Scalars['String']['output'];
};

/**
 * Why a sending wallet amount could not be covered at the last funding check.
 * For a fee shortfall (isFee), required and shortfall are based on the network fee threshold estimate,
 * not the fee the transaction will pay.
 */
export type SNFundingShortfall = {
  __typename: 'SNFundingShortfall';
  available: Amount;
  holds: Array<SNFundingHold>;
  /** True when the shortfall is in the network fee asset rather than the settled asset. */
  isFee: Scalars['Boolean']['output'];
  required: Amount;
  shortfall: Amount;
  wallet: Maybe<Wallet>;
};

/** A leg of a settlement */
export type SNLeg = {
  __typename: 'SNLeg';
  /** The amount being transferred in this leg */
  amount: Amount;
  /** The destination wallet for this leg */
  destinationWallet: Maybe<Wallet>;
  /** ID of Fee Hold corresponding to the transfer request */
  feeHoldID: Maybe<Scalars['ID']['output']>;
  /** Status of Fee Hold */
  feeHoldStatus: Maybe<Scalars['String']['output']>;
  /** Indicates if the fees for this leg are funded */
  feesFunded: Scalars['Boolean']['output'];
  /** Indicates if the primary asset for this leg is funded */
  funded: Scalars['Boolean']['output'];
  /**
   * Why this leg's sending wallet could not be covered at the last funding check.
   * Empty when funded, and also empty when the leg's sending participant is redacted for the caller;
   * unlike SNSettlementSide.fundingShortfalls this field is non-null, so redaction is not distinguishable here.
   */
  fundingShortfalls: Array<SNFundingShortfall>;
  /** Indicates this leg will use the gas station feature to cover fees. */
  gasStationEnabled: Scalars['Boolean']['output'];
  /** ID of Hold corresponding to the transfer request */
  holdID: Maybe<Scalars['ID']['output']>;
  /** Status of Hold */
  holdStatus: Maybe<Scalars['String']['output']>;
  /** List of Operation IDs created as part of the Transfer Request */
  operationIDs: Array<Scalars['String']['output']>;
  /** The participant ID that is sending in this leg */
  sendingParticipantID: Scalars['String']['output'];
  /** The source wallet for this leg */
  sourceWallet: Maybe<Wallet>;
  /**
   * Transfer request ID.
   *
   * If null, the transfer has not yet been enqueued.
   */
  transferID: Maybe<Scalars['ID']['output']>;
  /**
   * Transfer request status
   *
   * If null, the transfer has not yet been enqueued.
   */
  transferStatus: Maybe<Scalars['String']['output']>;
};

/** Matcher is the conditions used to determine if the automation should be applied. */
export type SNMatcher = SNCounterPartyAssetMatcher;

/** Matcher is the conditions used to determine if the automation should be applied. */
export type SNMatcherInput = {
  /**
   * The asset type ID to match against.
   * Matches a settlement if it contains a wallet amount with an asset in this list.
   */
  assetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  /** The participant ID to match against. */
  counterpartyID?: InputMaybe<Scalars['ID']['input']>;
};

/** A participant in the settlement network */
export type SNParticipant = Node & {
  __typename: 'SNParticipant';
  /**
   * Custody account
   * Null if callerHasViewAccess is false.
   */
  account: Maybe<Account>;
  /**
   * list of automations for the participant.
   * empty if callerHasViewAccess is false.
   */
  automations: Maybe<Array<SNAutomation>>;
  /** True if the participant is in the same organization as the user. */
  callerHasViewAccess: Scalars['Boolean']['output'];
  /** This is extracted from the account for now */
  custodianName: Scalars['String']['output'];
  /**
   * Null if Anchorage hasn't selected one.
   * Null if callerHasViewAccess is false.
   */
  defaultVault: Maybe<Vault>;
  /**
   * Null if Anchorage hasn't selected one.
   * Null if callerHasViewAccess is false.
   */
  defaultWallets: Maybe<Array<Wallet>>;
  /** Unique participant identifier */
  id: Scalars['ID']['output'];
  /** This is true if this participant can receive payments. */
  isActive: Scalars['Boolean']['output'];
  /**
   * Last time this participant became activate. If they were never inactivate, this is the same as the time they were created.
   * Null if callerHasViewAccess is false.
   */
  lastActivatedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Participant name. This is genrally a legal name of an "affiliate" */
  name: Scalars['String']['output'];
  /**
   * The assets that the participant can exchange on the settlement network
   * Null if callerHasViewAccess is false.
   */
  supportedAssets: Maybe<Array<AssetTypeInfo>>;
  /** Can this participant sned and receive (two way) settlements? */
  supportsAdvancedSettlements: Scalars['Boolean']['output'];
  /** Check this field before trying to send the participant a withdrawal to ensure it doesn't fail. */
  supportsReceivingWithdrawals: Scalars['Boolean']['output'];
  /** Can this participant do settlements or only send/receive withdrawals? */
  supportsSettlements: Scalars['Boolean']['output'];
  /**
   * Basic or Advanced. This is not public information, but the capabilities of the participant are. This makes sure that this flag is used only in participant settings screens and not when making decisions about what features are supported.
   * Null if callerHasViewAccess is false.
   */
  tier: Maybe<SNParticipantTier>;
};


/** A participant in the settlement network */
export type SNParticipantsupportsReceivingWithdrawalsArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
};

/** A connection to a list of items. */
export type SNParticipantConnection = {
  __typename: 'SNParticipantConnection';
  /** A list of edges. */
  edges: Array<SNParticipantEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SNParticipantEdge = {
  __typename: 'SNParticipantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SNParticipant;
};

/** SNParticipantTier is a way to specify what set of features a participant has access to */
export enum SNParticipantTier {
  /** Advanced participants have access to two-way settlements as long as both parties are advanced. */
  ADVANCED = 'ADVANCED',
  /** Basic participants have access only to one-way settlements. */
  BASIC = 'BASIC'
}

/** Response object for releasing holds */
export type SNReleaseHoldsResponse = {
  __typename: 'SNReleaseHoldsResponse';
  /** Indicates if releasing holds was successful. */
  success: Scalars['Boolean']['output'];
};

export type SNSettlementSide = {
  __typename: 'SNSettlementSide';
  /**
   * This means there is nothing preventing the settlement from executing that this side of the settlement can unblock.
   * It's true if the wallets are funded and the settlement is accepted.
   */
  actionNeeded: Scalars['Boolean']['output'];
  /**
   * This settlement has gone through quorum approval and is waiting for funding.
   * Null if callerHasViewAccess is false.
   */
  authorized: Maybe<Scalars['Boolean']['output']>;
  /**
   * This settlement can't be completed because this operation is blocking it from executing.
   * Null if callerHasViewAccess is false.
   */
  blockedByOperation: Maybe<Operation>;
  /** True if the participant is in the same organization as the user. */
  callerHasViewAccess: Scalars['Boolean']['output'];
  /**
   * This settlement's fees has been funded. They are funded if each leg's fees are funded.
   * Null if callerHasViewAccess is false.
   */
  feesFunded: Maybe<Scalars['Boolean']['output']>;
  /**
   * This settlement has been funded.
   * Null if callerHasViewAccess is false.
   */
  funded: Maybe<Scalars['Boolean']['output']>;
  /**
   * Why each sending wallet could not be covered at the last funding check.
   * Empty when funded. Null if callerHasViewAccess is false.
   */
  fundingShortfalls: Maybe<Array<SNFundingShortfall>>;
  /**
   * Indicates the participant has selected to use the gas station feature to cover fees.
   *
   * Not all assets are supported by Gas Station, so check the SNLeg if that leg is using Gas Station.
   * Null if callerHasViewAccess is false.
   */
  gasStationEnabled: Maybe<Scalars['Boolean']['output']>;
  /**
   * The operation for endorsing the settlement.
   * Null if callerHasViewAccess is false.
   */
  operation: Maybe<Operation>;
  /** Settlement side participant */
  participant: SNParticipant;
  /**
   * The vault that the participant has selected for the settlement. All wallets are from this vault.
   * If no wallet amounts have been selected yet (ex. sometimes the acceptor has yet to selec them), then this is null.
   * Null if callerHasViewAccess is false.
   */
  vault: Maybe<Vault>;
  /**
   * Potentially empty list
   * Null if callerHasViewAccess is false.
   */
  walletAmounts: Maybe<Array<SNWalletAmount>>;
};

/** A state for settlements. It's a high level description of what's happening or has happened to the settlement. */
export enum SNSettlementState {
  /**
   * The settlement is awaiting an action by the proposer and/or acceptor.
   * The needed action may be settlement acceptance, funding of wallets, fee funding, etc.
   */
  ACTION_NEEDED = 'ACTION_NEEDED',
  /** The settlement has been marked for cancellation. */
  CANCELING = 'CANCELING',
  /**
   * The settlement is awaiting an action from the other participant. The current participant does not need to take any action.
   * This only applies when queried by a participant of the settlement.
   */
  COUNTERPARTY_ACTION_NEEDED = 'COUNTERPARTY_ACTION_NEEDED',
  /** The settlement was executed successfully. */
  EXECUTED = 'EXECUTED',
  /** The settlement is being executed. */
  EXECUTING = 'EXECUTING',
  /** The settlement failed to execute. */
  FAILED = 'FAILED',
  /** The settlement was rejected by one of the participants. */
  REJECTED = 'REJECTED',
  /** The participants took too long to accept the settlement. */
  TIMED_OUT = 'TIMED_OUT'
}

/** A state filter for settlements. Each value here can correspond to multiple states. */
export enum SNSettlementStateFilter {
  /** The settlement is waiting for the acceptor to accept it. */
  ACTION_NEEDED = 'ACTION_NEEDED',
  /** The settlement has completed with success or failure or was canceled or timed out somehow. */
  COMPLETED = 'COMPLETED',
  /** The settlement is being executed. */
  EXECUTING = 'EXECUTING',
  /** Return settlements in all states that are not considered completed as defined by the COMPLETED filter. */
  NOT_COMPLETED = 'NOT_COMPLETED'
}

/** A trusted counterparty for a participant */
export type SNTrustedCounterparty = {
  __typename: 'SNTrustedCounterparty';
  /** This represents the date/time that the counterparty was added. */
  addedAt: Scalars['Timestamp']['output'];
  /** Detailed information about the counterparty. */
  counterparty: SNParticipant;
  /** Optional notes about the counterparty. */
  description: Maybe<Scalars['String']['output']>;
  /** True if the counterparty is active with the participant. False if inactivate */
  isActive: Scalars['Boolean']['output'];
  /** This represents the date/time the counterparty was last active. Defaults to added date */
  lastActivatedAt: Scalars['Timestamp']['output'];
  /**
   * The org change operation responsible of the trusted counterparty status change.
   * This is retuned for both the Add and Update (when status updating) mutations;
   * Null if the operationState is final.
   */
  operation: Maybe<Operation>;
  /** Detailed information about the participant this counterparty is for. */
  owner: SNParticipant;
  /** Should the frontend and iOS app show the AML questionnaire when withdarawing to this counterparty? */
  requiresWithdrawAML: Scalars['Boolean']['output'];
  /** The status of the trusted counterparty */
  status: SNTrustedCounterpartyStatus;
  /**
   * True if the counterparty has added the owner back as an active trusted counterparty.
   * The counterparty can only send assets to the owner in a settlement when this is true.
   */
  trustReciprocated: Scalars['Boolean']['output'];
};

/** A trusted counterparty status */
export enum SNTrustedCounterpartyStatus {
  /** The counterparty is active with the participant. */
  ACTIVE = 'ACTIVE',
  /** The counterparty is inactive with the participant. */
  INACTIVE = 'INACTIVE',
  /** The counterparty is pending completion of the activate TC operation */
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  /** The counterparty is pending completion of the create TC operation */
  PENDING_CREATION = 'PENDING_CREATION',
  /** The counterparty is pending completion of the deactivate TC operation */
  PENDING_DEACTIVATION = 'PENDING_DEACTIVATION'
}

export type SNTwoWaySettlement = Node & {
  __typename: 'SNTwoWaySettlement';
  /** This indicates the deadline for all participants to accept the settlement. */
  acceptanceDeadline: Scalars['Timestamp']['output'];
  /** The side that didn't propose the settlement and has to accept it */
  acceptor: SNSettlementSide;
  /**
   * Indicates whether automatic post-settlement holds will be applied to received
   * assets after settlement completion.
   */
  applyPostLock: Scalars['Boolean']['output'];
  /** An optional client-provided reference ID for the settlement. This memo field can be used for external tracking information. */
  clientReferenceID: Maybe<Scalars['String']['output']>;
  /** If the settlement has completed, this is when. Otherwise null. */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The time the settlement was proposed */
  createdAt: Scalars['Timestamp']['output'];
  /** Unique settlement identifier */
  id: Scalars['ID']['output'];
  /**
   * legsCreated is a list of settlement legs that were created as part of the settlement.
   * This field is only for staff users to be used in retool
   */
  legsCreated: Array<SNLeg>;
  /**
   * operationsCreated is a list of operations that were created as part of the settlement.
   * Only operations that the caller has access to see are returned.
   */
  operationsCreated: Array<Operation>;
  /** If true, the settlement requires acceptor selection. */
  pendingAcceptorReview: Scalars['Boolean']['output'];
  /** The proposer of the settlement */
  proposer: SNSettlementSide;
  /** If the settlement has started executing, this is when. Otherwise null. */
  startedExecutingAt: Maybe<Scalars['Timestamp']['output']>;
  /** The current state of the settlement */
  state: SNSettlementState;
};

/** A connection to a list of items. */
export type SNTwoWaySettlementConnection = {
  __typename: 'SNTwoWaySettlementConnection';
  /** A list of edges. */
  edges: Array<SNTwoWaySettlementEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SNTwoWaySettlementEdge = {
  __typename: 'SNTwoWaySettlementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SNTwoWaySettlement;
};

export type SNWalletAmount = {
  __typename: 'SNWalletAmount';
  /** An amount of an asset */
  amount: Amount;
  /** Network Adress of the receiving counterparty */
  counterpartyAddress: Maybe<BlockchainAddress>;
  /** The trusted destination corresponding to the counterparty address if it exists and the address is known */
  counterpartyAddressTrustedDestination: Maybe<TrustedDestination>;
  /** A wallet */
  wallet: Maybe<Wallet>;
};

/** Action to use the provided walletID for the settlement when the matcher is matched. */
export type SNWalletSelectAction = {
  __typename: 'SNWalletSelectAction';
  /** The wallet used in the automation. */
  walletUniqueID: Maybe<Scalars['String']['output']>;
};

/** sanitizeAddress response payload. Contains the canonicalized address. */
export type SanitizeAddressPayload = {
  __typename: 'SanitizeAddressPayload';
  /** address is the canonical version of an address */
  address: Scalars['String']['output'];
};

/** SaveKYCQuestionnaireSubmissionInput is the input for SaveKYCQuestionnaireSubmission. */
export type SaveKYCQuestionnaireSubmissionInput = {
  /** Action indicate the action to be taken on the submission, if it is a draft, commit or submit */
  action?: InputMaybe<KYCSubmissionAction>;
  /** Answers to the questions in the questionnaire */
  answers: Array<InputKYCQuestionAnswer>;
  /** The identifier of the KYCQuestionnaireSubmission */
  id: Scalars['ID']['input'];
  /** IsSubmission specifies if it will try to submit and validate the questionnaire data or just save */
  isSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notes contains any additional information about the submission */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** SaveKYCQuestionnaireSubmissionResponse holds the response of a SaveKYCQuestionnaireSubmission mutation */
export type SaveKYCQuestionnaireSubmissionResponse = {
  __typename: 'SaveKYCQuestionnaireSubmissionResponse';
  /** Submission holds the updated submission after saving a kyc questionnaire submission */
  submission: Maybe<KYCQuestionnaireSubmission>;
};

/**
 * Attaching the money to a settlement still awaiting payment. The whole set, not a delta: anything
 * already attached and missing from this list is voided.
 */
export type SaveSettlementMovementsInput = {
  /**
   * Every ledger row backing this settlement, as it should stand after the save. An empty list detaches
   * everything
   */
  movements: Array<SettlementMovementInput>;
  settlementId: Scalars['ID']['input'];
};

/** ScanDateIntervalResult is the result of a scanDateInterval mutation */
export type ScanDateIntervalResult = {
  __typename: 'ScanDateIntervalResult';
  /** The data provider that was used for this scan */
  dataProvider: DataProvider;
  /** The identifier of the workflow */
  workflowID: Scalars['String']['output'];
  /** The run identifier of the workflow */
  workflowRunID: Scalars['String']['output'];
};

/** The ScanProgress type contains local/canonical blockchain tip height, tip hash, and last updated time for a specific asset */
export type ScanProgress = {
  __typename: 'ScanProgress';
  /** blockHash is the hash of the low watermark */
  blockHash: Scalars['String']['output'];
  /** blockHeight is the (low watermark) height that we've scanned and are confident about (not concerned about reorg, etc.) */
  blockHeight: Scalars['String']['output'];
  /** blockchainTipHash is the hash of the tip of the local chain */
  blockchainTipHash: Scalars['String']['output'];
  /** blockchainTipHeight is the height of the tip of the local chain */
  blockchainTipHeight: Scalars['String']['output'];
  /** updatedAt is the time the blockchain scan progress was last updated */
  updatedAt: Scalars['String']['output'];
};

/** ScanningIssue contains information about an issue encountered while scanning */
export type ScanningIssue = {
  __typename: 'ScanningIssue';
  /** time when the scanning issue was acknowledged */
  acknowledgedAt: Maybe<Scalars['Time']['output']>;
  /** block height the scanning issue relates to */
  blockHeight: Scalars['String']['output'];
  /** time when the scanning issue was first created */
  createdAt: Scalars['Time']['output'];
  /** error encountered */
  error: Scalars['String']['output'];
  /** id of the scanning issue */
  id: Scalars['String']['output'];
  /** network the scanning issue relates to */
  networkID: Scalars['String']['output'];
  /** time when the scanning issue was resolved */
  resolvedAt: Maybe<Scalars['Time']['output']>;
  /** state of the scanning issue */
  state: ScanningIssueState;
};

/** ScanningIssueInput is used for saving scanning issues */
export type ScanningIssueInput = {
  /** block height the scanning issue relates to */
  blockHeight: Scalars['String']['input'];
  /** error encountered */
  error: Scalars['String']['input'];
  /** network the scanning issue relates to */
  networkID: Scalars['String']['input'];
  /** state of the scanning issue */
  state: ScanningIssueState;
};

/** The state of a scanning issue */
export enum ScanningIssueState {
  /** a scanning issue that can be skipped but has not been investigated yet */
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  /** a scanning issue that has been detected and is not being skipped */
  OPEN = 'OPEN',
  /** a scanning issue investigated by engineers and remediated or deemed to have no effect */
  RESOLVED = 'RESOLVED'
}

export type ScheduleOrganizationMigrationResult = {
  __typename: 'ScheduleOrganizationMigrationResult';
  /** Organizations already in the queue (READY) */
  alreadyQueued: Array<Scalars['String']['output']>;
  /** Organizations successfully scheduled */
  scheduled: Array<Scalars['String']['output']>;
};

export type ScheduledOrganizationMigration = {
  __typename: 'ScheduledOrganizationMigration';
  createdAt: Scalars['Timestamp']['output'];
  initiatedBy: Scalars['String']['output'];
  notifiedAt: Maybe<Scalars['Timestamp']['output']>;
  organization: Organization;
  scheduledFor: Scalars['String']['output'];
  status: OrganizationMigrationStatus;
};

/** ScheduledReport provides details on scheduled reports */
export type ScheduledReport = {
  __typename: 'ScheduledReport';
  /** Account ID */
  accountID: Maybe<Scalars['String']['output']>;
  /** The description of the report */
  description: Scalars['String']['output'];
  /** The id of the scheduled report */
  id: Scalars['Int']['output'];
  /** Organization ID */
  organizationKeyID: Scalars['String']['output'];
  /** The name of the report */
  reportName: Scalars['String']['output'];
  /** Day of month to send this report (-1 means "*") */
  scheduleDayOfMonth: Scalars['Int']['output'];
  /** Day of week to send this report (-1 means "*") */
  scheduleDayOfWeek: Scalars['Int']['output'];
  /** The hour of day to send this report */
  scheduleHour: Scalars['Int']['output'];
};

/** ScheduledReportSubscriber returns details of subscribers to reports */
export type ScheduledReportSubscriber = {
  __typename: 'ScheduledReportSubscriber';
  /** The email address of the subscriber */
  emailAddress: Scalars['String']['output'];
  /** The ID of the subscription */
  id: Scalars['Int']['output'];
  /** The name of the subscriber */
  name: Scalars['String']['output'];
  /** The report they are subscribed to */
  scheduledReport: ScheduledReport;
};

/** Defines a relationship between scopes and related quorum requirements */
export type ScopeToQuorumRequirements = {
  /** List of quorum requirements for the scope */
  quorumRequirements?: InputMaybe<Array<InputMaybe<QuorumRequirement>>>;
  /** The policy scope that the quorumRequirements apply to */
  scope: Scalars['String']['input'];
};

/** Collected search analysis information about an address, currently obtain from Bing Search */
export type SearchAnalysis = {
  __typename: 'SearchAnalysis';
  /** address is searched on search API via search service */
  address: Scalars['String']['output'];
  /** searchResultsCount is the number of search results obtained for the address from Bing Search */
  searchResultsCount: Scalars['Int']['output'];
};

/** SectionValue represents a section value of crr result */
export type SectionValue = {
  __typename: 'SectionValue';
  /** id is the name of a factor */
  id: Scalars['String']['output'];
  /** label is the description of the group */
  label: Scalars['String']['output'];
  /** value is the value for the factor */
  value: Scalars['String']['output'];
};

export type SegregatedWalletsFeeTermsDetail = {
  __typename: 'SegregatedWalletsFeeTermsDetail';
  tiers: Array<SegregatedWalletsTierDetail>;
};

export type SegregatedWalletsFeeTermsInput = {
  tiers: Array<SegregatedWalletsTierInput>;
};

export type SegregatedWalletsTierDetail = {
  __typename: 'SegregatedWalletsTierDetail';
  maxAccountCount: Maybe<Scalars['Int']['output']>;
  rateUSD: Scalars['Float']['output'];
};

export type SegregatedWalletsTierInput = {
  maxAccountCount?: InputMaybe<Scalars['Int']['input']>;
  rateUSD: Scalars['Float']['input'];
};

export type SelectDelegationActivityWalletsResponse = {
  __typename: 'SelectDelegationActivityWalletsResponse';
  /** Whether the selection was accepted. A selection that is not accepted returns an error saying why. */
  success: Scalars['Boolean']['output'];
};

export type SelectInputOption = {
  __typename: 'SelectInputOption';
  /** An explanation for why the option is disabled, if relevant. */
  disabledHint: Maybe<Scalars['String']['output']>;
  /** Whether or not the option is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Optional subtitle to show for this option */
  subtitle: Maybe<Scalars['String']['output']>;
  /** The title to show for this option */
  title: Scalars['String']['output'];
  /** The value to send back when this option is selected */
  value: Scalars['String']['output'];
};

export type SelectInputStep = StakingStep & {
  __typename: 'SelectInputStep';
  /** Value of the default option to be selected, must correspond to an option's value if provided. */
  defaultValue: Maybe<Scalars['String']['output']>;
  /** Whether or not to allow the user to edit the selection from default */
  editable: Scalars['Boolean']['output'];
  /**
   * Used to instruct the UI the name of the field that should be used to store the user's input for this step.
   * This value must be provided on all input steps when using PrepareGenericOperation
   * It can also be used to instruct the UI to send in a non-default field when using PrepareDelegation, but the string value must exactly match the GQL field name to work.
   * When this value is empty, a default value will be used by the UI based on the staking step type
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /** A hint to show under the selector */
  hint: Maybe<Scalars['String']['output']>;
  /** DO NOT QUERY */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Allows the backend to provide info banners to be shown above the step */
  infoItems: Maybe<Array<InfoItem>>;
  /** Tells the UI what label to show on the input */
  label: Scalars['String']['output'];
  /** The list of options to be shown */
  options: Array<SelectInputOption>;
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
};

/** SendKYCEventInput is used to send a KYC event. */
export type SendKYCEventInput = {
  /** The affiliate ID of the KYCProcess. */
  affiliateId: Scalars['String']['input'];
  /** The case ID of the KYCProcess. */
  caseId: Scalars['Int']['input'];
  /** The case type of the KYCProcess. */
  caseType: Scalars['String']['input'];
  /** The current status of the KYCProcess. */
  currentStatus: Scalars['String']['input'];
  /** The KYC analyst of the KYCProcess. */
  kycAnalyst: Scalars['String']['input'];
  /** The previous status of the KYCProcess. */
  previousStatus: Scalars['String']['input'];
  /** The QC analyst of the KYCProcess. */
  qcAnalyst: Scalars['String']['input'];
  /** The source type of the KYCProcess. */
  sourceType: Scalars['String']['input'];
};

/** SendKYCQuestionnaireSubmissionInput is the input for sendKYCQuestionnaireSubmission. */
export type SendKYCQuestionnaireSubmissionInput = {
  /**
   * Optional representative to send the form to. When omitted, the form is
   * resent to the representatives already linked to the submission (e.g. from
   * a previous send). The representative will be created on the parent KYC
   * profile if they don't already exist.
   */
  representative?: InputMaybe<RepresentativeInput>;
  /** The identifier of the submission to send. */
  submissionID: Scalars['ID']['input'];
};

/** ServiceFeeTerms contains the contractualized fee rates for a given billable entity */
export type ServiceFeeTerms = {
  __typename: 'ServiceFeeTerms';
  account: Maybe<AccountV2>;
  /** Top level account ID associated to the terms */
  accountID: Scalars['ID']['output'];
  /** ID of the agreement for the service fee term */
  agreementId: Scalars['String']['output'];
  /** URL of the ID of the agreement available in ironclad */
  agreementUrl: Maybe<Scalars['String']['output']>;
  /** Is auto renewal enabled */
  autoRenewalEnabled: Scalars['Boolean']['output'];
  /** The actual details of any bespoke staking fee terms */
  bespokeStakingFeeTerms: Maybe<BespokeStakingFeeTermsDetail>;
  /** Date when the fee terms were created */
  createdAt: Scalars['Date']['output'];
  /** User who created the service fee terms */
  createdBy: Maybe<Scalars['String']['output']>;
  /** Status of the service fee terms */
  currentStatus: ServiceFeeTermsStatus;
  /** The actual details of the service custody fee terms */
  custodyFeeTerms: Maybe<CustodyFeeTermsDetail>;
  /** Date after which the fess are accrued */
  feeAccrualDate: Scalars['Date']['output'];
  /** The actual details of the fiat interest fee terms */
  fiatInterestFeeTerms: Maybe<FiatInterestFeeTermsDetail>;
  /** Internal ID */
  id: Scalars['ID']['output'];
  /** Number of months after which terms are auto renewed */
  renewalTermMonths: Maybe<Scalars['Int']['output']>;
  /** Date at which the service fee terms was reviewed */
  reviewedAt: Maybe<Scalars['Date']['output']>;
  /** User who reviewed the service fee terms */
  reviewedBy: Maybe<Scalars['String']['output']>;
  /** The actual details of the segregated wallets fee terms */
  segregatedWalletsFeeTerms: Maybe<SegregatedWalletsFeeTermsDetail>;
  /** Type of service which these terms apply */
  serviceType: ServiceType;
  /** Date when the billing terms start taking effect */
  startDate: Scalars['Date']['output'];
  /** Date when the termination takes effect */
  terminationDate: Maybe<Scalars['Date']['output']>;
  /** Date at which the service fee terms was updated recently */
  updatedAt: Maybe<Scalars['Date']['output']>;
  /** User who made the recent update to the service fee terms */
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type ServiceFeeTermsConnection = {
  __typename: 'ServiceFeeTermsConnection';
  /** Edges contains a list of ServiceFeeTermsEdge objects representing a page of ServiceFeeTerms data. */
  edges: Array<ServiceFeeTermsEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

export type ServiceFeeTermsEdge = {
  __typename: 'ServiceFeeTermsEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a ServiceFeeTerms entry */
  node: ServiceFeeTerms;
};

export type ServiceFeeTermsFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  agreementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  statuses?: InputMaybe<Array<ServiceFeeTermsStatus>>;
};

export type ServiceFeeTermsPayload = {
  __typename: 'ServiceFeeTermsPayload';
  success: Scalars['Boolean']['output'];
};

/** ServiceFeeTermsStatus represents the possible states of a service fee term */
export enum ServiceFeeTermsStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  TERMINATED = 'TERMINATED',
  TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
  TERMINATION_IN_REVIEW = 'TERMINATION_IN_REVIEW'
}

export enum ServiceFeeTermsUpdateType {
  /** Used to apply changes to existing service fee terms */
  AMENDMENT = 'AMENDMENT',
  /** Used to approve service fee terms pending review */
  APPROVAL = 'APPROVAL'
}

/** ServiceType represents the possible service types for a service fee term */
export enum ServiceType {
  CUSTODY = 'CUSTODY',
  FIAT_INTEREST = 'FIAT_INTEREST',
  SEGREGATED_WALLETS = 'SEGREGATED_WALLETS',
  STAKING_V2 = 'STAKING_V2'
}

/** Result of setting an affiliate KYC profile status */
export type SetAffiliateKycProfileStatusResult = {
  __typename: 'SetAffiliateKycProfileStatusResult';
  /** The affiliate KYC profile ID */
  affiliateKycProfileID: Scalars['ID']['output'];
  /** The status */
  status: KYCStatus;
};

/** Input for setting asset tags */
export type SetAssetTagsInput = {
  /** The asset type ID to tag (e.g., "BTC", "ETH", "USDC") */
  assetTypeId: Scalars['String']['input'];
  /**
   * List of tags to set for this asset type.
   * This will replace all existing tags.
   */
  tags: Array<Scalars['String']['input']>;
};

/** Payload returned when setting asset tags */
export type SetAssetTagsPayload = {
  __typename: 'SetAssetTagsPayload';
  /** The asset type ID that was tagged */
  assetTypeId: Scalars['String']['output'];
  /** The tags that were set (current tags after the operation) */
  tags: Array<Scalars['String']['output']>;
};

/** SetCvmIntelTdxRootCaInput represents the input for setting the Intel TDX root CA certificate. */
export type SetCvmIntelTdxRootCaInput = {
  /** DER-encoded Intel TDX root CA certificate (max 4KiB) in base64 format. */
  certificate: Scalars['String']['input'];
};

/** SetCvmRootCertificatesInfoInput represents the input for setting CVM root certificates information. */
export type SetCvmRootCertificatesInfoInput = {
  /** Address signing certificate information. */
  addressSigning: CvmRootCertificateInfoInput;
  /** UEFI certificate information. */
  uefi: CvmRootCertificateInfoInput;
};

export type SetDVIngestChatAccountInput = {
  /** The enabled account ID ingested trades from this chat book into */
  accountId: Scalars['ID']['input'];
  /** Full ingest source: telegram:<chat_id> (e.g. telegram:-1004392170456) or slack:<channel_id> (e.g. slack:C0123456789) */
  ingestSource: Scalars['String']['input'];
};

/** SetIntelTdxCollateralInput represents the input needed to set Intel TDX collateral data. */
export type SetIntelTdxCollateralInput = {
  /** Intel TDX collateral data (RFC 4648 base64-encoded zstd-compressed JSON). */
  collateral: Scalars['String']['input'];
};

/** Payload response for the setOrganizationAccessPolicy mutation. */
export type SetOrganizationAccessPolicyPayload = {
  __typename: 'SetOrganizationAccessPolicyPayload';
  /** Indicates the access policy of an organization after the mutation. */
  policy: OrganizationAccessPolicy;
};

/** Result of setting an organization KYC profile status */
export type SetOrganizationKycProfileStatusResult = {
  __typename: 'SetOrganizationKycProfileStatusResult';
  /** The organization KYC profile ID */
  organizationKycProfileID: Scalars['ID']['output'];
  /** The updated status */
  status: KYCStatus;
};

export type SetSubaccountSegregationInput = {
  isSegregated: Scalars['Boolean']['input'];
  subaccountId: Scalars['ID']['input'];
};

export type SetSubaccountSegregationResult = {
  __typename: 'SetSubaccountSegregationResult';
  subaccountId: Scalars['ID']['output'];
};

/** Set trader status */
export type SetTraderInput = {
  /** Enable or disable trader */
  enable: Scalars['Boolean']['input'];
  /** Trader public key id */
  publicKeyID: Scalars['ID']['input'];
};

/** Payload response for setWalletKeyExportPreference mutation */
export type SetWalletKeyExportPreferenceResponse = {
  __typename: 'SetWalletKeyExportPreferenceResponse';
  /** Was request successful */
  success: Scalars['Boolean']['output'];
};

/** Represents the setting main type */
export type Setting = {
  __typename: 'Setting';
  /** Refers to the type of the setting */
  settingType: SettingType;
  /** Refers to the value(s) of the setting */
  value: Scalars['String']['output'];
  /** Refers to the value type of the setting */
  valueType: SettingValueType;
};

/** SettingType represents the possible settings */
export enum SettingType {
  /** Contractual notifications document delivery preference */
  DOCUMENT_DELIVERY_CONTRACTUAL_NOTIFICATIONS = 'DOCUMENT_DELIVERY_CONTRACTUAL_NOTIFICATIONS',
  /** Deposit attribution document delivery preference */
  DOCUMENT_DELIVERY_DEPOSIT_ATTRIBUTIONS = 'DOCUMENT_DELIVERY_DEPOSIT_ATTRIBUTIONS',
  /** Deposit invoice document delivery preference */
  DOCUMENT_DELIVERY_INVOICE = 'DOCUMENT_DELIVERY_INVOICE',
  /** KYC inquiry document delivery preference */
  DOCUMENT_DELIVERY_KYC_INQUIRY = 'DOCUMENT_DELIVERY_KYC_INQUIRY',
  /** Platform services update document delivery preference */
  DOCUMENT_DELIVERY_PLATFORM_SERVICES_UPDATE = 'DOCUMENT_DELIVERY_PLATFORM_SERVICES_UPDATE',
  /** Settlement Network notifications document delivery preference */
  DOCUMENT_DELIVERY_SETTLEMENT_NETWORK_NOTIFICATIONS = 'DOCUMENT_DELIVERY_SETTLEMENT_NETWORK_NOTIFICATIONS',
  /** Tax documents document delivery preference */
  DOCUMENT_DELIVERY_TAX_DOCUMENTS = 'DOCUMENT_DELIVERY_TAX_DOCUMENTS',
  /** Trade confirmations document delivery preference */
  DOCUMENT_DELIVERY_TRADE_CONFIRMATIONS = 'DOCUMENT_DELIVERY_TRADE_CONFIRMATIONS'
}

/** SettingValueType represents the possible value types for a setting */
export enum SettingValueType {
  /** A setting of the boolean type */
  BOOLEAN = 'BOOLEAN',
  /** A setting of the date type */
  DATE = 'DATE',
  /** A setting of the json type */
  JSON = 'JSON',
  /** A setting of the numeric type */
  NUMERIC = 'NUMERIC',
  /** A setting of the string type */
  STRING = 'STRING'
}

/** A client settlement */
export type Settlement = {
  __typename: 'Settlement';
  /**
   * Brokerage account, all contained trades for this settlement should belong to this
   * account
   */
  account: Maybe<TradingAccount>;
  /** Time when the settlement was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Organization to which this settlement belongs to */
  organization: Organization;
  /**
   * List of total amounts owed/to pay by asset
   * @deprecated Use tradingPositions instead
   */
  positions: Array<Amount>;
  /** Unique settlement identifier */
  settlementID: Scalars['String']['output'];
  /** List of settlement instructions */
  settlementInstructions: Array<SettlementInstructions>;
  /** Inferred from the underlying trades */
  settlementStatus: TradeStatus;
  /** Trades that belong to this settlement */
  trades: Array<Trade>;
  /** List of total amounts owed/to pay by asset */
  tradingPositions: Array<TradingAmount>;
  /** List transactions of this settlement */
  transactions: Array<SettlementTransactions>;
};

/** Settlement instructions union */
export type SettlementInstructions = SettlementInstructionsCrypto | SettlementInstructionsFiat;

/** Settlement instructions for crypto assets */
export type SettlementInstructionsCrypto = {
  __typename: 'SettlementInstructionsCrypto';
  /** Settlement address */
  address: Scalars['String']['output'];
  /** Asset type identifier */
  assetTypeID: Scalars['AssetTypeID']['output'];
};

/** Settlement instructions in fiat */
export type SettlementInstructionsFiat = {
  __typename: 'SettlementInstructionsFiat';
  /** Domestic account settlement instructions */
  domestic: Maybe<Array<SettlementInstructionsFiatEntry>>;
  /** International account settlement instructions */
  international: Maybe<Array<SettlementInstructionsFiatEntry>>;
  /** Silvergate settlement instructions */
  silverGate: Maybe<Array<SettlementInstructionsFiatEntry>>;
};

/** Generic instruction for settlement in fiat */
export type SettlementInstructionsFiatEntry = {
  __typename: 'SettlementInstructionsFiatEntry';
  /** Title/label of the instruction (e.g., Address) */
  title: Scalars['String']['output'];
  /** Values of the instruction (e.g., PCBBUS66) */
  value: Array<Scalars['String']['output']>;
};

export type SettlementMovementInput = {
  /**
   * Signed, in the ledger row's asset. It must run the same way as the settlement (not necessarily the
   * ledger row itself — that check is temporarily relaxed, see EAGLE-168 PAY/RECEIVE direction scoping).
   * Its size is free to differ, which is how a short payment is recorded. Ignored for a bucket move
   * (anything but a deposit or withdrawal), which is attached at 0
   */
  allocatedAmount: Scalars['String']['input'];
  /** A ledger entry that already exists, matched rather than created here */
  ledgerTransactionId: Scalars['ID']['input'];
  /**
   * Required together, and only where the ledger row's asset differs from the settlement's. Both are
   * supplied by the caller, since nothing here reads a mark
   */
  rate?: InputMaybe<Scalars['String']['input']>;
  rateSource?: InputMaybe<Scalars['String']['input']>;
};

/** The real money that moved for a settlement: a fiat wire or a crypto transfer. */
export type SettlementPaymentInput = {
  /**
   * Positive; its direction follows the settlement's net (a deposit when the client pays us). May be less
   * than the net, which then needs a reason
   */
  amount: Scalars['String']['input'];
  /** The custodian wallet this payment is associated with, if any */
  custodianWalletId?: InputMaybe<Scalars['ID']['input']>;
  /** Free-form description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The bank or chain reference, e.g. a Fed wire number */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

/** Holds information about a transaction in a client settlement */
export type SettlementTransaction = {
  __typename: 'SettlementTransaction';
  /** Identifier of the transaction */
  id: Scalars['ID']['output'];
  /** Transaction string */
  transaction: Scalars['String']['output'];
};

/** Holds information about the transactions in a client settlement */
export type SettlementTransactions = {
  __typename: 'SettlementTransactions';
  /** Asset type identifier */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Settlement transactions */
  transactions: Array<SettlementTransaction>;
};

/** A paginated view of settlements. */
export type SettlementView = {
  __typename: 'SettlementView';
  /** Edges containing the settlements for this page. */
  edges: Array<SettlementViewEdge>;
  /** Pagination metadata for this result set. */
  pageInfo: PageInfo;
};

/** A single settlement edge in a paginated settlements result. */
export type SettlementViewEdge = {
  __typename: 'SettlementViewEdge';
  /** Opaque cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** The settlement for this edge. */
  node: Settlement;
};

/** Input for sharing invoices by email */
export type ShareInvoicesByEmailInput = {
  /** Whether to add recipients to delivery list */
  addRecipientsToDeliveryList?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of email destinations */
  destinations: Array<InvoiceEmailDestination>;
  /** List of invoice IDs to share */
  invoiceIds: Array<Scalars['ID']['input']>;
};

/** Payload for share invoices by email mutation */
export type ShareInvoicesByEmailPayload = {
  __typename: 'ShareInvoicesByEmailPayload';
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Input for sharing tax documents by email */
export type ShareTaxDocumentsByEmailInput = {
  /** List of email destinations */
  destinations: Array<TaxDocumentEmailDestination>;
  /** List of tax document IDs to share */
  taxDocumentIds: Array<Scalars['ID']['input']>;
};

/** Payload for share tax documents by email mutation */
export type ShareTaxDocumentsByEmailPayload = {
  __typename: 'ShareTaxDocumentsByEmailPayload';
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/**
 * A group of sibling wallets within a vault that share the same wallet_sub_id and
 * address derivation component (ADC), and therefore share the same address.
 */
export type SharedAddressGroup = {
  __typename: 'SharedAddressGroup';
  /** Network IDs sharing the ADC that do not have active wallets. */
  availableNetworkIDs: Array<Scalars['ID']['output']>;
  /** Returns the NetworkInfos of the networks that share the ADC and do not have active wallets. */
  availableNetworks: Array<NetworkInfo>;
  /** Sibling wallets that have been activated. */
  siblingWallets: Array<SiblingWalletSummary>;
};

/** Summary of sibling wallets. */
export type SiblingWalletSummary = {
  __typename: 'SiblingWalletSummary';
  /** The time at which the wallet was created */
  createdAt: Scalars['String']['output'];
  /** The archival status of the wallet */
  isArchived: Scalars['Boolean']['output'];
  /** Network the wallet exists on. */
  networkInfo: NetworkInfo;
  /** Unique identifier of the wallet. */
  walletID: Scalars['ID']['output'];
  /** User-facing name of the wallet on this network. */
  walletName: Scalars['String']['output'];
};

/**
 * Signature encapsulates the signature of the data in question along with the
 * server-side fields included in the object signed. The client is expected to know how to encode
 * information it already has to produce a digest that matches the digest provided,
 * and combine that with the information provided here to verify the signature with a
 * key already known to it that is appropriate for the data.
 */
export type Signature = {
  __typename: 'Signature';
  /** Hex encoded sha256 of data */
  digest: Scalars['String']['output'];
  /** Type of the payload that was signed */
  payloadType: Scalars['String']['output'];
  /** Hex encoded signature of below fields */
  signature: Scalars['String']['output'];
  /** Nanotime the server signed this data */
  signedAt: Scalars['String']['output'];
  /** Version of signature scheme */
  version: Scalars['String']['output'];
};

/**
 * SignatureV1 contains legacy EDDSA-based signature information for an address.
 * Used for signature version 1 addresses.
 */
export type SignatureV1 = {
  __typename: 'SignatureV1';
  /** Hex encoded sha256 of data */
  digest: Scalars['String']['output'];
  /** Type of the payload that was signed */
  payloadType: Scalars['String']['output'];
  /** Hex encoded signature of below fields */
  signature: Scalars['String']['output'];
  /** Nanotime the server signed this data */
  signedAt: Scalars['String']['output'];
  /** Version of signature scheme */
  version: Scalars['String']['output'];
};

/**
 * SignatureV2 contains certificate-based signature information for an address.
 * Used for signature version 2 addresses.
 */
export type SignatureV2 = {
  __typename: 'SignatureV2';
  /**
   * X509 certificate chain used for signature verification.
   * Each certificate is a DER-encoded byte string (base64-encoded).
   */
  certChain: Array<Scalars['String']['output']>;
  /**
   * currentServerTime is the current server time in Unix nanoseconds.
   * iOS clients should use this time instead of device local time when validating
   * signature expiry for SignatureV2.
   */
  currentServerTime: Scalars['Timestamp']['output'];
  /** Base64-encoded certificate signature bytes */
  signature: Scalars['String']['output'];
  /** Base64-encoded raw payload bytes that were signed */
  signedAddressPayload: Scalars['String']['output'];
};

/** SignedAddress groups a receiving address and its signature for a deposit operation */
export type SignedAddress = {
  __typename: 'SignedAddress';
  /** addressID is the address id for this address */
  addressID: AddressID;
  /** for some assets, we have a special way to format addresses depending on the state of the network */
  formattedAddress: Maybe<Scalars['String']['output']>;
  /** receivingAddress is the address on which a deposit is to be received, populated by the blockchain service */
  receivingAddress: Scalars['String']['output'];
  /**
   * receivingAddressSignature is the legacy v1 signature for this address. Empty for HD-derived addresses;
   * clients should fall back to signatureV2 when this signature is empty.
   */
  receivingAddressSignature: Signature;
  /**
   * signatureV2 contains certificate-based signature information for HD-derived addresses.
   * Null for legacy v1 addresses (which use receivingAddressSignature instead).
   */
  signatureV2: Maybe<SignedAddressSignatureV2>;
};

/**
 * SignedAddressSignatureV2 contains certificate-based signature information for a deposit address.
 * Used for HD-wallet-derived addresses. Distinct from custody's SignatureV2 type to keep
 * the two subgraphs independent under Apollo Federation.
 */
export type SignedAddressSignatureV2 = {
  __typename: 'SignedAddressSignatureV2';
  /**
   * X509 certificate chain used for signature verification.
   * Each certificate is a DER-encoded byte string (base64-encoded).
   */
  certChain: Array<Scalars['String']['output']>;
  /** Base64-encoded certificate signature bytes */
  signature: Scalars['String']['output'];
  /** Base64-encoded raw payload bytes that were signed */
  signedAddressPayload: Scalars['String']['output'];
};

/** SignedOperationDetails is a union type of all possible forms of extra information for signed fields */
export type SignedOperationDetails = SignedOperationDetailsAccordion | SignedOperationDetailsAddress | SignedOperationDetailsAmount | SignedOperationDetailsPreviewLayout;

/** SignedOperationDetailsAccordion expresses an expandable visual element. */
export type SignedOperationDetailsAccordion = {
  __typename: 'SignedOperationDetailsAccordion';
  /** sections is the list of accordion sections to display */
  sections: Array<SignedOperationDetailsAccordionSection>;
};

/** SignedOperationDetailsAccordionSection expresses a section of an accordion. */
export type SignedOperationDetailsAccordionSection = {
  __typename: 'SignedOperationDetailsAccordionSection';
  /** condensed is the small version of the accordion section */
  condensed: SignedPayloadFieldListLayout;
  /** expanded is the expanded version of the accordion section */
  expanded: Array<SignedOperationDetailsAccordionSectionElement>;
  /** signablePayloadIndex is the index into the signablePayload that contains the data for this field */
  signablePayloadIndex: Scalars['Int']['output'];
};

/** SignedOperationDetailsAccordionSectionElement expresses an element of a section of an accordion. */
export type SignedOperationDetailsAccordionSectionElement = {
  __typename: 'SignedOperationDetailsAccordionSectionElement';
  /** layout provides additional information about the field */
  layout: SignedPayloadFieldListLayout;
  /** signablePayloadIndex is the index into the signablePayload that contains the data for this field */
  signablePayloadIndex: Scalars['Int']['output'];
};

/** SignedOperationDetailsAddress is the details for an address field that's signed */
export type SignedOperationDetailsAddress = {
  __typename: 'SignedOperationDetailsAddress';
  /** URL to the explorer for the address */
  explorerURL: Scalars['String']['output'];
};

/**
 * SignedOperationDetailsAmount is the details for an amount field
 * since the values are actually expected to be read from HSM - this only has fallbackPriceText
 */
export type SignedOperationDetailsAmount = {
  __typename: 'SignedOperationDetailsAmount';
  /** FallbackPriceText is a human readable field for laying out the price if PriceQuote isn't queried */
  fallbackPriceText: Scalars['String']['output'];
};

/** SignedOperationDetailsPreviewLayout is a preview of the contents */
export type SignedOperationDetailsPreviewLayout = {
  __typename: 'SignedOperationDetailsPreviewLayout';
  /** condensed is the small verion of the preview */
  condensed: SignedPayloadFieldListLayout;
  /** expanded is the expanded version of the preview */
  expanded: SignedPayloadFieldListLayout;
  /** subtitle is the subtitle of the preview */
  subtitle: Maybe<SignedOperationFieldText>;
  /** title is the title of the preview */
  title: SignedOperationFieldText;
};

/**
 * SignedOperationField are fields that are signed by the user, the details are filled in via the contents in SignablePayload based on the signablePayloadIndex
 * Details are null if there is no additional enrichment needed from what the native HSM has provided, however, if it does need some enrichment, detail is non-null
 */
export type SignedOperationField = {
  __typename: 'SignedOperationField';
  /** details provides additional information about the field */
  details: Maybe<SignedOperationDetails>;
  /** signablePayloadIndex is the index into the signablePayload that contains the data for this field */
  signablePayloadIndex: Scalars['Int']['output'];
};

/** SignedOperationFieldText is a pointer to text in the signable payload */
export type SignedOperationFieldText = {
  __typename: 'SignedOperationFieldText';
  /** signablePayloadIndex is the index into the signablePayload that contains the data for this field */
  signablePayloadIndex: Scalars['Int']['output'];
};

/** SignedPayloadFieldListLayout is a list of fields to display */
export type SignedPayloadFieldListLayout = {
  __typename: 'SignedPayloadFieldListLayout';
  /** fields is the list of fields to display */
  fields: Array<OperationField>;
};

/** SimpleStateDiagramItem is a StateDiagramItem sans operationState */
export type SimpleStateDiagramItem = {
  __typename: 'SimpleStateDiagramItem';
  /** children contains additional state info */
  children: Array<SimpleStateDiagramItem>;
  /** details shows additional state info if needed */
  details: Scalars['String']['output'];
  /** stateDescription is the user visible simplified description of the state */
  stateDescription: Scalars['String']['output'];
  /** stateType indicates how the state show be displayed to the user */
  stateType: StateType;
  /** time is available for all states that have been reached */
  time: Maybe<Scalars['String']['output']>;
};

export type SimplifiedEndorsement = {
  __typename: 'SimplifiedEndorsement';
  /**
   * batchID is the ID of the batch that this endorsement was part of. If this is
   * null, it means that this endorsement was not part of a batch.
   */
  batchID: Maybe<Scalars['String']['output']>;
  /**
   * For certificate-based endorsements, a human-readable rendering of the signing certificate's
   * Subject (e.g. "CN=autopengateway"). This value is self-asserted by the certificate and is NOT
   * cryptographically verified against any trust anchor — display only, do not treat as an
   * authenticated identity. Null for non-certificate-based endorsements.
   */
  certificateSubject: Maybe<Scalars['String']['output']>;
  /** createdTime is the time at which the endorsement happened */
  createdTime: Scalars['String']['output'];
  /** the decision carried by the endorsement */
  decision: OperationDecision;
  /**
   * True if this endorsement is certificate-based (autopengateway, execute.Generic/execute.Withdraw
   * only). Federated to identity-service so its Key resolver can distinguish an expected-unregistered
   * cert key from a real missing-key bug on iOS/API endorsements. @inaccessible hides it from the
   * router's public API schema; it remains in the supergraph for the @requires wiring.
   */
  isCertEndorsement: Scalars['Boolean']['output'];
  /** The key used to sign */
  key: Maybe<Key>;
  /** operation that was endorsed */
  operation: Operation;
  /** Unique identifier of the operation that was endorsed */
  operationID: Scalars['OperationID']['output'];
  /** Unique identifier of the key that signed */
  publicKeyID: Maybe<Scalars['PublicKeyID']['output']>;
  /** riskMetadata contains risk data about this endorsement */
  riskMetadata: Maybe<RiskMetadata>;
  /**
   * the user who signed
   * @deprecated query key instead because this user can also be an API key
   */
  user: Maybe<User>;
  /** absolute hostless URL to the video with the words (ex. /video/deadbeef) */
  voicePhraseURL: Maybe<Scalars['String']['output']>;
  /** absolute hostless URL to the video with the words (ex. /video/deadbeef) */
  voiceWordsURL: Maybe<Scalars['String']['output']>;
};

/** SmartContractABI is the resolved ABI for an address: the outcome and, when verified, the write functions. */
export type SmartContractABI = {
  __typename: 'SmartContractABI';
  /** explorerURL links the contract address on the network's block explorer; null when the network has none. */
  explorerURL: Maybe<Scalars['String']['output']>;
  /** functions holds the contract's write functions; populated only when status is VERIFIED. */
  functions: Array<SmartContractFunction>;
  implementationAddress: Maybe<Scalars['String']['output']>;
  isProxy: Scalars['Boolean']['output'];
  status: SmartContractABIStatus;
};

/** SmartContractABIStatus is the outcome of resolving a contract's ABI. */
export enum SmartContractABIStatus {
  /** ABI_NOT_FOUND: a contract exists on-chain but has no fetchable ABI. */
  ABI_NOT_FOUND = 'ABI_NOT_FOUND',
  /** CONTRACT_NOT_FOUND: no contract is deployed at the address. */
  CONTRACT_NOT_FOUND = 'CONTRACT_NOT_FOUND',
  /** UNSUPPORTED_NETWORK: the network does not support ABI fetch for its smart contracts. */
  UNSUPPORTED_NETWORK = 'UNSUPPORTED_NETWORK',
  /** VERIFIED: a verified ABI was found; write functions are returned. */
  VERIFIED = 'VERIFIED'
}

/** SmartContractAsset represents an asset in the smart contract simulation response. */
export type SmartContractAsset = {
  __typename: 'SmartContractAsset';
  /** assetType is the type of the asset. E.g. "ERC20" */
  assetType: Scalars['String']['output'];
  /** logoUrl is the URL of the asset logo. E.g. "https://example.com/logo.png" */
  logoUrl: Scalars['String']['output'];
  /** name is the name of the asset. E.g. "Ether" */
  name: Scalars['String']['output'];
  /** symbol is the symbol of the asset. E.g. "ETH" */
  symbol: Scalars['String']['output'];
};

/** SmartContractAssetDiff represents an asset diff in the smart contract simulation response. */
export type SmartContractAssetDiff = {
  __typename: 'SmartContractAssetDiff';
  /** asset is the smart contract asset in the diff. */
  asset: SmartContractAsset;
  /** in is the list of transactions that were transferred to an address. */
  in: Array<SmartContractTransaction>;
  /** out is the list of transactions that were transferred from an address. */
  out: Array<SmartContractTransaction>;
};

/** SmartContractDetails represents the asset diffs details in the smart contract simulation response. */
export type SmartContractDetails = {
  __typename: 'SmartContractDetails';
  /** address is the address associated with an asset diff in the smart contract simulation response. */
  address: Scalars['String']['output'];
  /** assetDiffs is the detailed list of asset diffs in the smart contract simulation response. */
  assetDiffs: Array<SmartContractAssetDiff>;
  /** contractName is the contract name associated with an asset diff address. */
  contractName: Scalars['String']['output'];
  /** nameTag is the name tag associated with an asset diff address. */
  nameTag: Scalars['String']['output'];
  /** usdDiff is the USD value of a certain asset diff in the smart contract simulation response. E.g. "1880.62" */
  usdDiff: Scalars['String']['output'];
};

/** SmartContractExposure represents an exposure in the smart contract simulation response. */
export type SmartContractExposure = {
  __typename: 'SmartContractExposure';
  /** asset is the asset associated with the exposure. */
  asset: SmartContractAsset;
  /** spenders is the list of spenders associated with the exposure. */
  spenders: Array<SmartContractSpender>;
};

/** SmartContractExposureDetails represents the exposure details in the smart contract simulation response. */
export type SmartContractExposureDetails = {
  __typename: 'SmartContractExposureDetails';
  /** address is the associated address with the exposure. */
  address: Scalars['String']['output'];
  /** contractName is the contract name of the exposure address. */
  contractName: Scalars['String']['output'];
  /** exposures is the list of exposures associated with the address. */
  exposures: Array<SmartContractExposure>;
  /** nameTag is the name tag of the exposure address. */
  nameTag: Scalars['String']['output'];
};

/** SmartContractFunction is a state-changing (write) contract method. */
export type SmartContractFunction = {
  __typename: 'SmartContractFunction';
  name: Scalars['String']['output'];
  parameters: Array<SmartContractFunctionParameter>;
  /** selector is the 4-byte method selector as 0x-prefixed hex, e.g. 0x095ea7b3. */
  selector: Scalars['String']['output'];
  /** signature is the canonical signature, e.g. approve(address,uint256). */
  signature: Scalars['String']['output'];
  stateMutability: SmartContractFunctionStateMutability;
};

export type SmartContractFunctionParameter = {
  __typename: 'SmartContractFunctionParameter';
  /** components holds the tuple/struct members, recursively; empty for scalar types. */
  components: Array<SmartContractFunctionParameter>;
  /** name is the parameter name; empty when the ABI leaves it unnamed. */
  name: Scalars['String']['output'];
  /** type is the canonical Solidity type, e.g. uint256, address[]. */
  type: Scalars['String']['output'];
};

export enum SmartContractFunctionStateMutability {
  NONPAYABLE = 'NONPAYABLE',
  PAYABLE = 'PAYABLE'
}

/** SmartContractRisk represents the risk assessment of executing a smart contract. */
export type SmartContractRisk = {
  __typename: 'SmartContractRisk';
  /** Description is a human-readable description of the risk analysis. */
  description: Scalars['String']['output'];
  /** Details are additional details about the risk analysis. */
  details: Array<Scalars['String']['output']>;
  /** RiskLevel is the risk level of executing a smart contract. */
  riskLevel: SmartContractRiskLevel;
};

/** SmartContractRiskLevel represents the risk level of interacting with a smart contract. */
export enum SmartContractRiskLevel {
  /** HIGH means the risk level is high and the smart contract is considered malicious. */
  HIGH = 'HIGH',
  /** LOW means the risk level is low and the smart contract is considered safe. */
  LOW = 'LOW',
  /** MEDIUM means the risk level is medium and the smart contract is considered somewhat risky. */
  MEDIUM = 'MEDIUM',
  /** UNAVAILABLE means the risk level could not be determined at this time due to an error. */
  UNAVAILABLE = 'UNAVAILABLE',
  /** UNDETERMINED means the risk level could not be determined at this time due lack of data. */
  UNDETERMINED = 'UNDETERMINED'
}

/** SmartContractSimulation represents the smart contract simulation response. */
export type SmartContractSimulation = {
  __typename: 'SmartContractSimulation';
  /** details represents the detailed asset diffs with address details in the smart contract simulation response. */
  details: Array<SmartContractDetails>;
  /** exposures is the list of exposures in the smart contract simulation response. */
  exposureDetails: Array<SmartContractExposureDetails>;
  /** failure is set when status is FAILED. */
  failure: Maybe<SmartContractSimulationFailure>;
  /** status says whether the simulation succeeded, failed or did not run. */
  status: SmartContractSimulationStatus;
  /** summary represents the summary of the smart contract simulation response. */
  summary: SmartContractSummary;
};

/** SmartContractSimulationFailure explains a FAILED simulation. */
export type SmartContractSimulationFailure = {
  __typename: 'SmartContractSimulationFailure';
  /** category is Blockaid's error_details.category, e.g. REVERT. */
  category: Maybe<Scalars['String']['output']>;
  /** code is Blockaid's error_details.code, e.g. GENERAL_INSUFFICIENT_FUNDS. Open set, not an enum. */
  code: Maybe<Scalars['String']['output']>;
  /** detail is Blockaid's raw error, e.g. "Reverted with reason string: 'UniswapV2Router: EXPIRED'". */
  detail: Maybe<Scalars['String']['output']>;
  /** message is the user-facing line. Insufficient funds is composed server-side, e.g. "Insufficient USDC: Available: 19.673843, Required: 1000000"; otherwise Blockaid's description, or, when there is none, its raw error with the simulator's "Reverted with reason string" quoting removed, e.g. "UniswapV2Router: EXPIRED". */
  message: Scalars['String']['output'];
};

/** SmartContractSimulationStatus is the outcome of a simulation. */
export enum SmartContractSimulationStatus {
  /** FAILED means the transaction simulated and reverts or cannot be paid for. */
  FAILED = 'FAILED',
  /** SUCCESS means the transaction simulated and goes through. */
  SUCCESS = 'SUCCESS',
  /** UNAVAILABLE means the transaction was not simulated: feature off, chain unsupported, Blockaid failed, or the scan never resolved. */
  UNAVAILABLE = 'UNAVAILABLE'
}

/** SmartContractSpender represents a spender in the smart contract simulation response. */
export type SmartContractSpender = {
  __typename: 'SmartContractSpender';
  /** address is the address of the spender. */
  address: Scalars['String']['output'];
  /** approval is the approval address field with a spender. */
  approval: Scalars['String']['output'];
  /** contractName is the contract name of the spender address. */
  contractName: Scalars['String']['output'];
  /** exposure is the list of transactions that the spender address is exposed to. */
  exposure: Array<SmartContractTransaction>;
  /** isApprovedForAll is the boolean value of whether the spender is approved for all transactions. */
  isApprovedForAll: Scalars['Boolean']['output'];
  /** nameTag is the name tag of the spender address. */
  nameTag: Scalars['String']['output'];
  /** summary is the summary of the spender details. */
  summary: Scalars['String']['output'];
  /** usdExposure is the USD value of the exposure. E.g. "1880.62" */
  usdExposure: Scalars['String']['output'];
};

/** SmartContractSummary is a summary of the smart contract simulation response. */
export type SmartContractSummary = {
  __typename: 'SmartContractSummary';
  /** assetsDiffs is the list of asset diffs in the smart contract simulation response. */
  assetsDiffs: Array<SmartContractAssetDiff>;
  /** exposures is the list of exposures in the smart contract simulation response. */
  exposures: Array<SmartContractExposure>;
  /** totalUSDDiff is the total USD diff in the smart contract simulation response. E.g. "1880.62" */
  totalUSDDiff: Scalars['String']['output'];
};

/** SmartContractTransaction represents a transaction in the smart contract simulation response. */
export type SmartContractTransaction = {
  __typename: 'SmartContractTransaction';
  /** logoUrl is the URL of the associated transaction asset E.g. "https://example.com/logo.png" */
  logoUrl: Scalars['String']['output'];
  /** tokenID is the token ID of the transaction asset. */
  tokenID: Scalars['String']['output'];
  /** usdValue is the value of the transaction in USD. E.g. "1880.62" */
  usdValue: Scalars['String']['output'];
  /** value is the numerical value of the transaction. E.g. "1.0" */
  value: Scalars['String']['output'];
};

/** Source is a withdraw or delegate source */
export type Source = {
  __typename: 'Source';
  /** addressID is the addressID of the source address */
  addressID: AddressID;
  /** amount is an amount in the standard unit for the asset type */
  amount: Scalars['String']['output'];
  /** signedAddress is the signed ID for this source address */
  signedAddress: Maybe<SignedAddress>;
};

export enum SpecialAddressType {
  /** Used to create a bootstrap account that can create other accounts */
  FLOW_BOOTSTRAP = 'FLOW_BOOTSTRAP',
  /** Used to create a node ID */
  FLOW_STAKING_NODE = 'FLOW_STAKING_NODE',
  /** Used to create a nonce account for the given assetID and sets it as the bootstrap account */
  SOLANA_BOOTSTRAP = 'SOLANA_BOOTSTRAP'
}

export enum StablecoinAction {
  BRIDGE = 'BRIDGE',
  BURN = 'BURN',
  MINT = 'MINT',
  SWAP = 'SWAP'
}

/** Latest effective reward rate for a stablecoin asset */
export type StablecoinAssetRate = {
  __typename: 'StablecoinAssetRate';
  /** UTC date the rate snapshot was taken */
  asOfDate: Scalars['Date']['output'];
  /** Asset the rate applies to */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Effective reward rate, in percent units (e.g. 3.29 = 3.29%) */
  effectiveRate: Scalars['Decimal']['output'];
  /** Percentage points subtracted from the source rate to get the effective rate */
  rateModifier: Scalars['Decimal']['output'];
  /** Reference rate the effective rate is derived from */
  rateType: StablecoinAssetRateType;
  /** Reference rate value, in percent units (e.g. 3.62 = 3.62%) */
  sourceRate: Scalars['Decimal']['output'];
};

/** Reference rate an asset's effective rate is derived from */
export enum StablecoinAssetRateType {
  /** Effective Federal Funds Rate */
  EFFR = 'EFFR',
  /** Ethena issuer rates sheet */
  ETHENA_SHEET = 'ETHENA_SHEET',
  /** Rate published by the asset's issuer, less the rate modifier */
  ISSUER_LESS = 'ISSUER_LESS'
}

/** StablecoinRewardWalletConfiguration defines the already configured wallets for stablecoin reward payouts */
export type StablecoinRewardWalletConfiguration = {
  __typename: 'StablecoinRewardWalletConfiguration';
  /** The asset type ID for the wallet configuration. */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** priority of the configuration, lower numbers are higher priority. */
  priority: Scalars['Int']['output'];
  /** The wallet configured for reward payouts for this asset. */
  walletUniqueID: Scalars['String']['output'];
};

/** StablecoinRewardWalletConfigurationInput defines the wallets for stablecoin reward payouts */
export type StablecoinRewardWalletConfigurationInput = {
  /** The asset type ID for the wallet configuration. */
  assetTypeID: Scalars['AssetTypeID']['input'];
  /** The wallet to use for reward payouts for this asset. */
  walletUniqueID: Scalars['String']['input'];
};

/** a participant's enrollment in a program */
export type StablecoinRewardsEnrollment = {
  __typename: 'StablecoinRewardsEnrollment';
  /** The participant ID */
  participantID: Scalars['ID']['output'];
  /** The program ID */
  programID: Scalars['ID']['output'];
  /** The status of the enrollment */
  status: StablecoinRewardsEnrollmentStatus;
  /** Null if the caller is not a staff user */
  tier: Maybe<Scalars['String']['output']>;
};

/** A stablecoin rewards enrollment status */
export enum StablecoinRewardsEnrollmentStatus {
  /** The participant is approved and can be enrolled in programs/start earning rewards */
  APPROVED = 'APPROVED',
  /** The participant is rejected and cannot be enrolled in programs/start earning rewards */
  REJECTED = 'REJECTED',
  /** The participant is unenrolled and not receiving rewards. At this point they cannot be reenrollmed. */
  UNENROLLED = 'UNENROLLED',
  /** waiting for a staff member to approve the participant */
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL'
}

/** A stablecoin rewards participant */
export type StablecoinRewardsParticipant = Node & {
  __typename: 'StablecoinRewardsParticipant';
  /** True if the atlas participant is in the same organization as the user, or if this is a staff user. */
  callerCanConfigureWallets: Scalars['Boolean']['output'];
  /** The programs that the participant is enrolled in */
  enrollments: Maybe<Array<StablecoinRewardsEnrollment>>;
  /** Unique participant identifier */
  id: Scalars['ID']['output'];
  /**
   * Null if the caller is not a staff user
   * Notes associated with the participant
   */
  notes: Maybe<Scalars['String']['output']>;
  /**
   * Null if callerCanConfigureWallets is false, or if the atlas participant has not been set up yet
   * the atlas participant associated with this stablecoin participant
   */
  snParticipant: Maybe<SNParticipant>;
  /**
   * the date that the participant started or will start receiving rewards
   * Null if callerCanConfigureWallets is false.
   */
  startDate: Maybe<Scalars['Timestamp']['output']>;
  /** The status of the participant */
  status: StablecoinRewardsParticipantStatus;
  /** the top level affiliate associated with this stablecoin participant */
  topLevelAffiliate: Maybe<AffiliateV2>;
  /** Unique top level affiliate identifier */
  topLevelAffiliateID: Scalars['ID']['output'];
  /** Top level affiliate name" */
  topLevelAffiliateName: Scalars['String']['output'];
  /** walletConfigurationInfo contains information about the wallet configurations for this participant. */
  walletConfigurationInfo: Maybe<StablecoinRewardsParticipantWalletConfigurationInfo>;
};

/** A connection to a list of items. */
export type StablecoinRewardsParticipantConnection = {
  __typename: 'StablecoinRewardsParticipantConnection';
  /** A list of edges. */
  edges: Array<StablecoinRewardsParticipantEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StablecoinRewardsParticipantEdge = {
  __typename: 'StablecoinRewardsParticipantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: StablecoinRewardsParticipant;
};

/** A stablecoin rewards participant status */
export enum StablecoinRewardsParticipantStatus {
  /** The participant is approved and can be enrolled in programs/start earning rewards */
  APPROVED = 'APPROVED',
  /** The participant is rejected and cannot be enrolled in programs/start earning rewards */
  REJECTED = 'REJECTED',
  /** waiting for a staff member to approve the participant */
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL'
}

/** Wallet configuration info for a stablecoin participant. */
export type StablecoinRewardsParticipantWalletConfigurationInfo = {
  __typename: 'StablecoinRewardsParticipantWalletConfigurationInfo';
  /** True if the atlas participant for this stablecoin participant is in the same organization as the user, or if this is a staff user. */
  callerCanConfigureWallets: Scalars['Boolean']['output'];
  /** completed wallet configurations for this participant */
  completedConfigurations: Array<Scalars['AssetTypeID']['output']>;
  /** completed wallet configurations for this participant including the configured wallet IDs */
  completedConfigurationsWithWallets: Maybe<Array<StablecoinRewardWalletConfiguration>>;
  /** possible wallet configurations for this participant */
  possibleConfigurations: Array<Scalars['AssetTypeID']['output']>;
};

export type StaffUpdateAccountInput = {
  accountId: Scalars['ID']['input'];
  /**
   * The new external reference, unique within the account's organization. Left
   * as it is when absent; when sent, must not be blank or start or end with
   * whitespace.
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Caller-supplied key for this one change. A retry with the same key returns
   * the first result instead of acting again. Must not be blank.
   */
  idempotencyKey: Scalars['String']['input'];
  /**
   * The new account name. Left as it is when absent; when sent, must not be blank
   * or start or end with whitespace.
   * At least one of name and externalId must be sent.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Why staff is changing the account. Required, must not be blank. */
  reason: Scalars['String']['input'];
};

export type StaffUpdateAccountResult = {
  __typename: 'StaffUpdateAccountResult';
  accountId: Scalars['ID']['output'];
};

/** StaffUser represents a staff member with their email and IAM permissions. */
export type StaffUser = {
  __typename: 'StaffUser';
  /** Email of the staff user */
  email: Scalars['String']['output'];
  /**
   * List of IAM permission actions the staff user has access to.
   * Frontend can check for specific permission actions by checking if the action is in this list.
   */
  permissions: Array<IAMPermissionAction>;
};

/** Represents an organization being added */
export type StagedOrganization = {
  __typename: 'StagedOrganization';
  /** The list of possible accounts for this organization. We can't use the Account type because it assumes that the organization exists */
  accountIDs: Array<Scalars['String']['output']>;
  /** The backup strategy for the organization */
  backupStrategy: Maybe<WalletKeyBackupStrategy>;
  /** hsmShardID tells us which HSM shard the staged organization is configured with */
  hsmShardID: Scalars['String']['output'];
  /** hsmZoneID tells us which HSM zone the staged organization is configured with */
  hsmZoneID: Scalars['String']['output'];
  /** A unique ID for the staged organization */
  id: Scalars['ID']['output'];
  /** Name of the organization */
  name: Scalars['String']['output'];
  /** operationID points to the organization creation operation when it's created */
  operationID: Maybe<Scalars['String']['output']>;
  /** Operator returns the operator for this organization. Some popular values are ANCHORAGE, and SELF but there are others. */
  operator: Scalars['String']['output'];
  /** Organization key ID */
  organizationKeyID: Maybe<Scalars['String']['output']>;
  /** The json definition of the staged org. This is more flexible than the individual fields exposed through graphql, but less safe */
  rawDefinition: Scalars['String']['output'];
  /** Number of users in the organization */
  userCount: Scalars['Int']['output'];
  /** Get the list of users in this organization */
  users: Array<StagedUser>;
  /** The wallet recovery public key of the organization. This public key will be used to encrypt wallet keys */
  walletRecoveryPublicKey: Maybe<Scalars['String']['output']>;
};

/** StagedOrganizationConnection contains a paginated list of staged organizations */
export type StagedOrganizationConnection = {
  __typename: 'StagedOrganizationConnection';
  edges: Array<StagedOrganizationEdge>;
  pageInfo: PageInfo;
};

/** A staged organization for tests, created with deterministic keys. */
export type StagedOrganizationCreateForTestingInput = {
  clientID?: InputMaybe<Scalars['String']['input']>;
  /** Base64 of the keyblob to use instead of generating one. */
  deterministicKeyblob?: InputMaybe<Scalars['String']['input']>;
  /** Enroll the users when the staged organization is created. */
  enrollUsers?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  hsmZoneID: Scalars['String']['input'];
  /** Used only when operator is SELF. Unset means KeyExportStrategyAdminKeysQuorum. */
  keyExportStrategyForPorto?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  /** The organization's users, each enrolled with a key derived from its name. */
  users: Array<StagedOrganizationTestUserInput>;
  /** Names of the vaults to create. */
  vaults?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Overrides the service's conditional-rules-at-genesis setting for this organization. Unset keeps
   * the service default.
   */
  withConditionalRules?: InputMaybe<Scalars['Boolean']['input']>;
};

/** StagedOrganizationEdge contains a staged organization and its cursor */
export type StagedOrganizationEdge = {
  __typename: 'StagedOrganizationEdge';
  cursor: Scalars['ID']['output'];
  node: StagedOrganization;
};

/** A user of a test staged organization. */
export type StagedOrganizationTestUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Represents a user being added */
export type StagedTokenInput = {
  /** Do we want to override the email? */
  emailOverride?: InputMaybe<Scalars['String']['input']>;
  /** forgetAppAssociation will remove the app association */
  forgetAppAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do we want an admin? */
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do we want to override the name? */
  nameOverride?: InputMaybe<Scalars['String']['input']>;
  /** objectID is the individualID if we are adding a new individual, or the enrollment token if we are editing an existing one */
  objectID: Scalars['String']['input'];
  /** Do we want to remove the email override? */
  removeEmailOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do we want to remove the name override? */
  removeNameOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a user that is in the process of being added to an organization */
export type StagedUser = {
  /** The algorithm for the user's public key. This should match the value in the organization change. */
  algorithm: Maybe<Scalars['String']['output']>;
  /** Email of the staged user, if known */
  email: Maybe<Scalars['String']['output']>;
  /** The only possible value for now is eciesEncryptionCofactorSHA512IVAESGCM or null */
  encryptionAlgorithm: Maybe<Scalars['String']['output']>;
  /** Set iff publicKeyID is set */
  encryptionPublicKey: Maybe<Scalars['String']['output']>;
  /**
   * Same as publicKeyID but used for encryption
   * This is set iff encryptionAlgorithm is set
   */
  encryptionPublicKeyID: Maybe<Scalars['PublicKeyID']['output']>;
  /** The enroll token assigned to this user */
  enrollToken: Scalars['String']['output'];
  /** Last login information. Will be empty if never logged in. */
  lastLogin: Maybe<Login>;
  /** Name of the staged user, if known */
  name: Maybe<Scalars['String']['output']>;
  /** Hex encoded representation of the public key, if known. If the user did not enroll yet this field will be null */
  publicKey: Maybe<Scalars['String']['output']>;
  /** Public key ID of the user, if known. If the user did not enroll yet this field will be null */
  publicKeyID: Maybe<Scalars['PublicKeyID']['output']>;
  /** The type of user that the enrollment will create in the organization */
  userType: UserType;
};

/** StakeAmountState represents an amount of a position in a given StakingPositionState. */
export type StakeAmountState = {
  __typename: 'StakeAmountState';
  /** The amount of tokens in the state */
  amount: Amount;
  /** The string name of the state */
  label: Scalars['String']['output'];
  /** The amount state */
  type: StakingPositionState;
};

/** Destination address for the staked transfer workflow. */
export type StakedTransferDestinationAddress = {
  address: Scalars['String']['input'];
  assetTypeID: Scalars['AssetTypeID']['input'];
};

/** Identifies a wallet for the staked transfer workflow. Mirrors protolib.WalletID. */
export type StakedTransferWalletID = {
  networkID: Scalars['String']['input'];
  organizationKeyID: Scalars['String']['input'];
  vaultSubID: Scalars['Int']['input'];
  walletSubID: Scalars['Int']['input'];
};

/**
 * StakingAssetAmounts contains aggregated staking info for a stakeable asset type:
 *   - Amount available to stake
 *   - Totals for each staking position state (staked, staking, unstaking, unclaimed rewards)
 */
export type StakingAssetAmounts = {
  __typename: 'StakingAssetAmounts';
  /** The total amount (of this asset type) available to stake. */
  amountAvailableToStake: Amount;
  /**
   * The Asset Type and its info.
   * If the amounts are aggregated across different asset types, this will be USD.
   */
  assetTypeInfo: AssetTypeInfo;
  /** Aggregated amounts of each staking position state, by type (STAKING, STAKED, UNSTAKING, UNCLAIMED_REWARDS, INACTIVE, etc.) */
  stakingPositions: Array<StakeAmountState>;
};

/**
 * StakingAssets represents the aggregated staking info for all assets in this account that support staking. This includes:
 * - Totals for each asset type
 * - Total USD values across all assets
 */
export type StakingAssets = {
  __typename: 'StakingAssets';
  /**
   * StakingAssetsAmounts is a list of aggregated staking info for each asset type in this account where:
   * - Staking is supported (standardized staking or Eth)
   * - The client holds a balance of the asset
   * Aggregated info includes:
   * - Amount available to stake
   * - Totals for each staking position state (staked, staking, unstaking, unclaimed rewards)
   */
  stakingAssetsAmounts: Array<StakingAssetAmounts>;
  /**
   * TotalStakingAmountUSD contains aggregated staking info over all asset types.
   * Aggregated info includes:
   * - Amount available to stake
   * - Totals for each staking position state (staked, staking, unstaking, unclaimed rewards)
   * Each total is aggregated by the asset's USD value, and the AssetTypeInfo will be in USD.
   * If "stakingAssetsAmounts" is empty, all amounts in this total should be zero.
   */
  totalStakingAmountUSD: StakingAssetAmounts;
};

export type StakingFeeInput = {
  assetId: Scalars['ID']['input'];
  externalValidatorRate: Scalars['Float']['input'];
  fullCommissionValidatorRate: Scalars['Float']['input'];
  internalValidatorRate: Scalars['Float']['input'];
};

export type StakingFeeTermsInput = {
  fees: Array<StakingFeeInput>;
};

/** Contains Staking information for an Asset */
export type StakingInfo = {
  __typename: 'StakingInfo';
  /** AutoCompoundEnabled indicates whether auto-compound is enabled for this wallet. */
  autoCompoundEnabled: Maybe<Scalars['Boolean']['output']>;
  /**
   * List of steps for the auto-compound flow
   * @deprecated use the field 'autoCompoundForm' instead
   */
  autoCompoundFlow: Maybe<Array<StakingStep>>;
  /** AutoCompoundForm is used to toggle auto-compounding via standardized staking, if supported by the asset type. It will either show an enable or disable form depending on the current state. */
  autoCompoundForm: Maybe<StandardizedStakingForm>;
  /** ClaimableRewards is the aggregated list of claimable rewards by asset type. */
  claimableRewards: Maybe<Array<Amount>>;
  /** DisclosureID is the ID of the staking disclosure that the user must have agreed to before staking. */
  disclosureID: Scalars['String']['output'];
  /**
   * A generic list of forms to show the user, the forms contain all info the UI will need to render them
   * Instead of adding new fields for new forms, they should be returned here or on the staking position.
   */
  genericForms: Array<StandardizedStakingForm>;
  /** @deprecated("use the field 'notices' in asset instead") */
  notices: Maybe<Array<Notice>>;
  /**
   * Positions returns a list of exactly ONE StakingPositionConnection. The list/plurality aspect is a design error, consumers can safely index to the 0th item.
   * StakingPositionconnection is a paginated list of staking positions that a wallet has. Each position can be individually viewed and controlled.
   */
  positions: Maybe<Array<StakingPositionConnection>>;
  /** RedeemForm is used to redeem tokens to staked positions */
  redeemForm: Maybe<StandardizedStakingForm>;
  /** StakeAmountStates contains the aggregated balances of each state for ALL of the current positions a wallet has. There will only be one state per type. */
  stakeAmountStates: Maybe<Array<StakeAmountState>>;
  /**
   * List of steps for the Stake operation
   * @deprecated use the field 'stakeForm' instead
   */
  stakeFlow: Maybe<Array<StakingStep>>;
  /** StakeForm is used to stake assets via standardized staking, if supported by the asset type. */
  stakeForm: Maybe<StandardizedStakingForm>;
  /** TotalClaimableRewards is the sum of all claimable rewards across all positions. */
  totalClaimableRewards: Maybe<Amount>;
};

/**
 * The type of GQL mutation the UI should call.
 * Please try to avoid adding new mutation types, as it breaks our standardization and requires more UI work.
 */
export enum StakingOperationType {
  GENERIC_OPERATION = 'GENERIC_OPERATION',
  NONE = 'NONE',
  PREPARE_DELEGATION = 'PREPARE_DELEGATION'
}

export type StakingPosition = {
  __typename: 'StakingPosition';
  actionForms: Array<JsonForm>;
  /** assetID is the asset that this position was staked from */
  assetID: AssetID;
  /**
   * List of steps for the Claim flow
   * @deprecated use the field 'claimForm' instead
   */
  claimFlow: Maybe<Array<StakingStep>>;
  /** ClaimRewardsForm is used for bringing accrued rewards back into the Available balance. */
  claimRewardsForm: Maybe<StandardizedStakingForm>;
  /**
   * Amount of assets available to claim
   * @deprecated use the field 'states' instead
   */
  claimableRewards: Maybe<Amount>;
  /** CollectForm is used to bring inactive stakes back into the Available balance. */
  collectForm: Maybe<StandardizedStakingForm>;
  /**
   * A generic list of forms to show the user, the forms contain all info the UI will need to render them
   * Instead of adding new fields for new forms, they should be returned here or on the staking info
   */
  genericForms: Array<StandardizedStakingForm>;
  /** id is the unique identifier of the staking position, equal to positionID */
  id: Scalars['ID']['output'];
  /**
   * The operation ID of the operation that created this position. Only provided for assets that require OperationID to initiate unstaking (eg BTC).
   * @deprecated use the field 'positionID' instead
   */
  operationID: Maybe<Scalars['String']['output']>;
  /** positionID is the unique identifier of the staking position */
  positionID: Scalars['String']['output'];
  /**
   * RedeemForm is used to redeem tokens to staked positions
   * @deprecated use the redeemForm from stakingInfo
   */
  redeemForm: Maybe<StandardizedStakingForm>;
  /**
   * A formatted string indicating how long a position must be locked before it can be unstaked.
   * Returns null if not relevant for the position.
   */
  remainingDuration: Maybe<Scalars['String']['output']>;
  /**
   * Amount of assets staked
   * @deprecated use the field 'states' instead
   */
  stakedAmount: Maybe<Amount>;
  /**
   * State for this StakingPosition
   * @deprecated use the field 'states' instead
   */
  state: StakingPositionState;
  /**
   * States is the list of states that the position is in (eg staking, staked, or unstaking).
   * Each state has an amount of assets associated with it.
   */
  states: Array<StakeAmountState>;
  /**
   * List of steps for the Unstake flow
   * @deprecated use the field 'unstakeForm' instead
   */
  unstakeFlow: Maybe<Array<StakingStep>>;
  /** UnstakeForm is used to unstake some or all of the position via standardized staking, if supported by the asset type. */
  unstakeForm: Maybe<StandardizedStakingForm>;
  /** ValidatorDestination is the validator address that the position is staked to. */
  validatorDestination: Scalars['String']['output'];
  /** ValidatorName is the pseudonym for the validator address. If it's not known, this will default to the validator address. */
  validatorName: Scalars['String']['output'];
};

/** StakingPositionConnection is needed to enable pagination for StakingPosition. */
export type StakingPositionConnection = {
  __typename: 'StakingPositionConnection';
  /** edges */
  edges: Array<StakingPositionEdge>;
  /** pageInfo */
  pageInfo: PageInfo;
};

/** StakingPositionConnection is needed to enable for StakingPosition. */
export type StakingPositionEdge = {
  __typename: 'StakingPositionEdge';
  /** cursor */
  cursor: Scalars['ID']['output'];
  /** node */
  node: Maybe<StakingPosition>;
};

/**
 * StakingPositionState represents the different states that staked funds can be in.
 * Not all protocols will have all states.
 */
export enum StakingPositionState {
  /** Assets are available to claim */
  CLAIMABLE_REWARDS = 'CLAIMABLE_REWARDS',
  /** Assets are not earning rewards but not yet returned to the wallet */
  INACTIVE_STAKE = 'INACTIVE_STAKE',
  /** Assets are restaking */
  RESTAKING = 'RESTAKING',
  /** Assets are staked */
  STAKED = 'STAKED',
  /** Assets are being staked */
  STAKING = 'STAKING',
  /** Assets are unstaking */
  UNSTAKING = 'UNSTAKING'
}

/**
 * StakingStep is an abstract step for uniform staking that each Step must extend.
 * To enable true standardization. Consumers of flows/forms should try to be able to render any combination of steps in the order they're provided.
 */
export type StakingStep = {
  /**
   * Used to instruct the UI the name of the field that should be used to store the user's input for this step.
   * This value must be provided on all input steps when using PrepareGenericOperation
   * It can also be used to instruct the UI to send in a non-default field when using PrepareDelegation, but the string value must exactly match the GQL field name to work.
   * When this value is empty, a default value will be used by the UI based on the staking step type
   * This field can be ignored for non-input steps like InfoStep
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Rules control presentation of the step. */
  rules: Maybe<Array<PresentationRule>>;
};

/** StakingStepInputType represents whether the amount input is quantifying an amount of an asset or a share. */
export enum StakingStepInputType {
  /** An asset amount input type */
  ASSET = 'ASSET',
  /** A shares amount input type */
  SHARES = 'SHARES'
}

/** StakingStepNumberType represents whether the amount input is an absolute number or a percentage. */
export enum StakingStepNumberType {
  /** An absolute number (ie. 0, 10, 420, 13.37) */
  ABSOLUTE = 'ABSOLUTE',
  /** An absolute integer number */
  ABSOLUTE_INTEGER = 'ABSOLUTE_INTEGER',
  /** A percentage number, from 0 to 100, inclusive */
  PERCENTAGE = 'PERCENTAGE'
}

/** StandardizedStakingForm contains the backend-provided config to render a staking form for a specific standardized staking action (eg stake, unstake, claim rewards, etc). */
export type StandardizedStakingForm = {
  __typename: 'StandardizedStakingForm';
  /** The label to show on the button that opens the form */
  buttonLabel: Scalars['String']['output'];
  /** DelegationType is the type of delegation to use for this staking action. */
  delegationType: Maybe<Scalars['String']['output']>;
  /** If the action is disabled for this asset/position, this field can contain the reason why to show to the user. */
  disabledHint: Maybe<Scalars['String']['output']>;
  /**
   * DisclosureID is the ID of the disclosure that the user must have agreed to before performing this action.
   * When present, takes precedence over the staking-level disclosureID for this specific form.
   */
  disclosureID: Maybe<Scalars['String']['output']>;
  /**
   * GenericOperationType is provided to BE when a generic wizard initiates a generic operation from this form
   * @deprecated Use userIntentType instead
   */
  genericOperationType: Maybe<Scalars['String']['output']>;
  /**
   * OperationType provides instructions to the UI on which mutation to call when the user completes the form.
   * As much as possible, we should use the default value of prepareDelegation.
   */
  operationType: StakingOperationType;
  /** Whether or not the resulting operation requires endorsement */
  requiresEndorsement: Scalars['Boolean']['output'];
  /**
   * The list of steps to display to the user. The steps are ordered in the way they should be displayed.
   * If the list is empty, the action is disabled for this asset/position.
   */
  steps: Maybe<Array<StakingStep>>;
  /** Title of the form and operation */
  title: Scalars['String']['output'];
  /** UserIntentType is the ubiquitous-language intent type the FE should use instead of genericOperationType. */
  userIntentType: Maybe<Scalars['String']['output']>;
};

/**
 * standardizedStakingInfo returns the standardized staking information for this asset type.
 * Defined here for use by AssetTypeInfo; home subgraph is graphqlmonolith (to be migrated).
 */
export type StandardizedStakingInfo = {
  __typename: 'StandardizedStakingInfo';
  /** Whether the asset type supports auto claim and restake flow */
  supportsAutoCompounding: Scalars['Boolean']['output'];
  /** Whether the asset type supports claim flow */
  supportsClaimingRewards: Scalars['Boolean']['output'];
  /** Whether the asset type supports the collect flow */
  supportsCollecting: Scalars['Boolean']['output'];
  /** Whether the asset type supports generic staking forms */
  supportsGenericForms: Scalars['Boolean']['output'];
  /** SupportsPorto describes if StandardizedStaking is also supported by Porto, or just ADB */
  supportsPorto: Scalars['Boolean']['output'];
  /** Whether the asset type supports the redeem flow */
  supportsRedeem: Scalars['Boolean']['output'];
  /** Whether the asset type supports stake initiation flow */
  supportsStaking: Scalars['Boolean']['output'];
  /** Whether the asset type supports unstake flow */
  supportsUnstaking: Scalars['Boolean']['output'];
};

/** Standards contains information standard collections like countries, states or cities */
export type Standards = {
  __typename: 'Standards';
  /** List of countries */
  countries: Maybe<Array<Country>>;
};

/** StandingInstruction represents a FIAT standing insctruction (trusted address) */
export type StandingInstruction = {
  __typename: 'StandingInstruction';
  /**
   * Account Number
   * @deprecated Use 'WireStandingInstruction' instead
   */
  accountNumber: Scalars['String']['output'];
  /** Affiliate ID linked to the Standing Instructions */
  affiliateID: Scalars['String']['output'];
  /** Affiliate name of the linked affiliate */
  affiliateName: Scalars['String']['output'];
  /** Date of approval of the Standing Instruction */
  approvedAt: Maybe<Scalars['Date']['output']>;
  /** User that approved the Standing Instruction */
  approvedBy: Maybe<Scalars['String']['output']>;
  /**
   * Beneficiary Address 1
   * @deprecated Use 'WireStandingInstruction' instead
   */
  beneficiaryAddress1: Maybe<Scalars['String']['output']>;
  /**
   * Beneficiary Address 2
   * @deprecated Use 'WireStandingInstruction' instead
   */
  beneficiaryAddress2: Maybe<Scalars['String']['output']>;
  /**
   * Beneficiary Address 3
   * @deprecated Use 'WireStandingInstruction' instead
   */
  beneficiaryAddress3: Maybe<Scalars['String']['output']>;
  /**
   * Beneficiary code
   * @deprecated Use 'WireStandingInstruction' instead
   */
  beneficiaryCode: Scalars['String']['output'];
  /**
   * Beneficiary Country
   * @deprecated Use 'WireStandingInstruction' instead
   */
  beneficiaryCountry: Maybe<Scalars['String']['output']>;
  /**
   * Beneficiary Name
   * @deprecated Use 'WireStandingInstruction' instead
   */
  beneficiaryName: Scalars['String']['output'];
  /** Beneficiary nickname */
  beneficiaryNickname: Scalars['String']['output'];
  /** Date of creation of the Standing Instruction */
  createdAt: Scalars['Date']['output'];
  /** User that created the Standing Instruction */
  createdBy: Scalars['String']['output'];
  /**
   * Financial Institution address 1
   * @deprecated Use 'WireStandingInstruction' instead
   */
  fiAddress1: Maybe<Scalars['String']['output']>;
  /**
   * Financial Institution address 2
   * @deprecated Use 'WireStandingInstruction' instead
   */
  fiAddress2: Maybe<Scalars['String']['output']>;
  /**
   * Financial Institution code
   * @deprecated Use 'WireStandingInstruction' instead
   */
  fiCode: Scalars['String']['output'];
  /**
   * Financial Institution country
   * @deprecated Use 'WireStandingInstruction' instead
   */
  fiCountry: Maybe<Scalars['String']['output']>;
  /**
   * Financial Institution ID
   * @deprecated Use 'WireStandingInstruction' instead
   */
  fiID: Scalars['String']['output'];
  /**
   * Financial Institution name
   * @deprecated Use 'WireStandingInstruction' instead
   */
  fiName: Scalars['String']['output'];
  /** Instructions (WireStandingInstruction or InstantTransferStandingInstruction) */
  instructions: Maybe<Instruction>;
  /**
   * Intermediate Financial Institution address 1
   * @deprecated Use 'WireStandingInstruction' instead
   */
  intermediateAddress1: Maybe<Scalars['String']['output']>;
  /**
   * Intermediate Financial Institution address 2
   * @deprecated Use 'WireStandingInstruction' instead
   */
  intermediateAddress2: Maybe<Scalars['String']['output']>;
  /**
   * intermediate Financial Institution code
   * @deprecated Use 'WireStandingInstruction' instead
   */
  intermediateCode: Maybe<Scalars['String']['output']>;
  /**
   * Intermediate Financial Institution country
   * @deprecated Use 'WireStandingInstruction' instead
   */
  intermediateCountry: Maybe<Scalars['String']['output']>;
  /**
   * Intermediate Financial Institution ID
   * @deprecated Use 'WireStandingInstruction' instead
   */
  intermediateID: Maybe<Scalars['String']['output']>;
  /**
   * Intermediate Financial Institution name
   * @deprecated Use 'WireStandingInstruction' instead
   */
  intermediateName: Maybe<Scalars['String']['output']>;
  /** Memo field */
  memo: Maybe<Scalars['String']['output']>;
  /** Organization to which the standing instruction belongs */
  organizationKeyID: Scalars['String']['output'];
  /**
   * Routing Number
   * @deprecated Use 'fiID' instead
   */
  routingNumber: Scalars['String']['output'];
  /** Unique Identifier of a Standing Instruction */
  standingInstructionID: Scalars['String']['output'];
  /** Current state of the Standing Instruction */
  state: Maybe<StandingInstructionStateType>;
  /** Last date of a change of the Standing Instruction */
  updatedAt: Scalars['Date']['output'];
  /** User that updated the Standing Instruction */
  updatedBy: Scalars['String']['output'];
};

/** StandingInstructionStateType provides existing states for a standing instruction */
export enum StandingInstructionStateType {
  /** Active, has been approved */
  ACTIVE = 'ACTIVE',
  /** Disabled */
  DISABLED = 'DISABLED',
  /** Pending, is waiting of approval */
  PENDING = 'PENDING'
}

/** Extra parameters for starknet operations */
export type StarknetExtraParams = {
  __typename: 'StarknetExtraParams';
  /** redelegateSrc is used when redelegating with the value of the source delegation pool */
  redelegateSrc: Maybe<Scalars['String']['output']>;
  /** rewardAddress is the address that will receive the rewards from the delegation */
  rewardAddress: Maybe<Scalars['String']['output']>;
};

export type StartTokenSwapInput = {
  /** BuyData is the data of the buy-side of this token swap. */
  buyData: TokenSwapDataInput;
  /**
   * ExchangeInput contains the input arguments for swapping a token on a
   * Decentralized Exchange (DEX).
   */
  exchangeInput: TokenSwapDEXInput;
  /** SellData is the data of the sell-side of this token swap. */
  sellData: TokenSwapDataInput;
  /** SellTokenWalletAddress is the wallet address that will be used to sell the token. */
  sellTokenWalletAddress?: InputMaybe<Scalars['String']['input']>;
};

/**
 * StartTokenSwapResult is the result of starting a token swap workflow.
 * The ID of the token swap record that links this swap with all the associated
 * intermediate operations is returned in the result. The ID can be used to track the
 * status of the swap, among other things.
 */
export type StartTokenSwapResult = {
  __typename: 'StartTokenSwapResult';
  /** ID is the identifier of the token swap record that was created for this swap. */
  id: Scalars['String']['output'];
};

export type StartWalletBulkCreateInput = {
  addressGenerationType: AddressGenerationType;
  /**
   * DEPRECATED: Use networkIds instead. For backward compatibility, if networkIds is not provided,
   * this field will be used to determine the single network for wallet creation.
   */
  assetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  namingScheme?: InputMaybe<NamingScheme>;
  /**
   * Array of network IDs to create wallets on. Creates wallets across multiple networks
   * with the same address (shared wallet_sub_id). If provided, takes precedence over assetTypeID.
   */
  networkIds?: InputMaybe<Array<Scalars['NetworkID']['input']>>;
  numberOfWallets: Scalars['Int']['input'];
  subaccountID?: InputMaybe<Scalars['String']['input']>;
  vaultSubID: Scalars['Int']['input'];
};

export enum StateAction {
  /** Full Liquidation - 100% of the collateral will be liquidated */
  FULL_LIQUIDATION = 'FULL_LIQUIDATION',
  /** No action */
  NONE = 'NONE',
  /** Partial Liquidation - A percentage less than 100% of the collateral will be liquidated */
  PARTIAL_LIQUIDATION = 'PARTIAL_LIQUIDATION',
  /** Ownership of the collateral assets will be transferred */
  SWEEP = 'SWEEP'
}

/** StateType indicates how the state show be displayed to the user */
export enum StateType {
  /** This is a successful end state */
  COMPLETE = 'COMPLETE',
  /** This is a failed end state */
  FAILED = 'FAILED',
  /** This state hasn't been reached yet */
  FUTURE = 'FUTURE',
  /** This is a regular past state */
  PAST = 'PAST',
  /** This is the current state unless the current state is COMPLETE or FAILED */
  PRESENT = 'PRESENT'
}

/** Statement contains information required to retrieve a statement file from GCS */
export type Statement = {
  __typename: 'Statement';
  /** Account this statement is associated with */
  account: Account;
  /** Affiliate Email */
  affiliateEmail: Maybe<Scalars['String']['output']>;
  /** Affiliate Name */
  affiliateName: Maybe<Scalars['String']['output']>;
  /** Created At */
  createdAt: Maybe<Scalars['String']['output']>;
  /** DisplayDate date document is valid to. It is unix nanos timestamp that has been stringified */
  displayDate: Scalars['String']['output'];
  /** DisplayName display name for document, derived from contents of statement record */
  displayName: Scalars['String']['output'];
  /** Specific id given domain */
  domainSpecificId: Maybe<Scalars['String']['output']>;
  /** Date of email notification */
  emailSentAt: Scalars['String']['output'];
  /** Ending date of the statement. RFC3339 format. eg "2024-02-29". Inclusive. */
  endDate: Scalars['String']['output'];
  /** Error Message */
  errMsg: Scalars['String']['output'];
  /** Extension is the file extension of this statement */
  extension: Scalars['String']['output'];
  /** Status of this statement's generation (eg, IN_PROGRESS, COMPLETED) */
  generationStatus: StatementGenerationStatus;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Link allows users to download the document through anchorage */
  link: Scalars['String']['output'];
  /** Organization this statement is associated with */
  organization: Organization;
  /** Starting date of the statement. RFC3339 format. eg "2024-02-01". */
  startDate: Scalars['String']['output'];
  /** Statement type (eg, MONTHLY_STATEMENT, BALANCE_REPORT) */
  statementKind: StatementType;
  /**
   * Statement type
   * @deprecated Use statementKind
   */
  statementType: Scalars['String']['output'];
};

/** Statement connection for pagination */
export type StatementConnection = {
  __typename: 'StatementConnection';
  /** List of edges containing statement and cursor information */
  edges: Array<StatementEdge>;
  /** Page details for the associated list of statement edges */
  pageInfo: PageInfo;
};

/** Statement edge for pagination */
export type StatementEdge = {
  __typename: 'StatementEdge';
  /** Cursor for the associated statement */
  cursor: Scalars['ID']['output'];
  /** Statement */
  node: Statement;
};

/** Statement/BalanceSheet Report/Transaction History Report generation status */
export enum StatementGenerationStatus {
  /** Statement/BalanceSheet Report/Transaction History Report generation workflow has completed successfully. */
  COMPLETED = 'COMPLETED',
  /** Statement/BalanceSheet Report/Transaction History Report generation workflow has completed with failure. */
  FAILED = 'FAILED',
  /** Statement/BalanceSheet Report/Transaction History Report generation workflow has been started. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Statement/BalanceSheet Report/Transaction History Report generation workflow has been requested (but not yet started). */
  REQUESTED = 'REQUESTED',
  /**
   * UNKNOWN is a status reserved when the service would have to panic otherwise.
   * Don't use this status if returning an error is possible.
   * Don't use this status if returning any other status is more appropriate.
   */
  UNKNOWN = 'UNKNOWN'
}

/** Field and direction to order statements query */
export type StatementOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order statements. */
  field: StatementsOrderField;
};

/** StatementType represents the statement types we produce */
export enum StatementType {
  /** Daily Balance Report */
  BALANCE_REPORT = 'BALANCE_REPORT',
  /** Daily Balance Report by Vaults */
  BALANCE_REPORT_VAULT = 'BALANCE_REPORT_VAULT',
  /** Daily Balance Report by Vault Addresses */
  BALANCE_REPORT_VAULT_ADDRESS = 'BALANCE_REPORT_VAULT_ADDRESS',
  /** Brokerage statement */
  BROKERAGE_STATEMENT = 'BROKERAGE_STATEMENT',
  /** Collateral statement */
  COLLATERAL_STATEMENT = 'COLLATERAL_STATEMENT',
  /** Dummy statement for testing */
  DUMMY_STATEMENT = 'DUMMY_STATEMENT',
  /** Monthly statement for ETFs */
  ETF_MONTHLY_STATEMENT = 'ETF_MONTHLY_STATEMENT',
  /** Lending statement */
  LENDING_STATEMENT = 'LENDING_STATEMENT',
  /** Monthly statement for fiat */
  MONTHLY_FIAT_STATEMENT = 'MONTHLY_FIAT_STATEMENT',
  /** Monthly prefunded statement */
  MONTHLY_PREFUNDED_STATEMENT = 'MONTHLY_PREFUNDED_STATEMENT',
  /** Monthly statement */
  MONTHLY_STATEMENT = 'MONTHLY_STATEMENT',
  /** Monthly statement for program customer */
  PROGRAM_CUSTOMER_MONTHLY_STATEMENT = 'PROGRAM_CUSTOMER_MONTHLY_STATEMENT',
  /** Monthly statement for RIAs */
  RIA_MONTHLY_STATEMENT = 'RIA_MONTHLY_STATEMENT',
  /** Transaction history report (aka Activities) */
  TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',
  /** deprecated - use TRANSACTION_HISTORY */
  TRANSACTION_REPORT = 'TRANSACTION_REPORT'
}

/** Fields to order statements query */
export enum StatementsOrderField {
  /** Order statements by creation date */
  CREATED_AT = 'CREATED_AT'
}

/** CreateSignedStatementURLsResult represents the result of creating signed statement URLs. */
export type StatementsV2CreateSignedStatementURLSResult = {
  __typename: 'StatementsV2CreateSignedStatementURLSResult';
  statements: Array<Maybe<StatementsV2SignedStatementURL>>;
};

/** CreateSignedStatementURLsResult represents the result of creating signed statement URLs. */
export type StatementsV2CreateSignedStatementURLsResult = {
  __typename: 'StatementsV2CreateSignedStatementURLsResult';
  statements: Array<StatementsV2SignedStatementURL>;
};

/**
 * MostRecentCorrectedStatement represents the most recently corrected statement
 * with essential identifying information and a computed days field.
 */
export type StatementsV2MostRecentCorrectedStatement = {
  __typename: 'StatementsV2MostRecentCorrectedStatement';
  accountID: Scalars['String']['output'];
  correctedAt: Scalars['Time']['output'];
  coverageTimeEnd: Maybe<Scalars['Time']['output']>;
  coverageTimeStart: Maybe<Scalars['Time']['output']>;
  /** The number of days since the statement was corrected (rounded down to whole days). */
  daysSinceCorrected: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  orgID: Scalars['String']['output'];
  vaultGroupID: Scalars['String']['output'];
};

/** PublishStatementsResult represents the result of publishing statements. */
export type StatementsV2PublishStatementsResult = {
  __typename: 'StatementsV2PublishStatementsResult';
  statementCount: Scalars['String']['output'];
};

/** Schedule represents a schedule for generating statements. */
export type StatementsV2Schedule = {
  __typename: 'StatementsV2Schedule';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  dayOfMonth: Maybe<Scalars['Int']['output']>;
  dayOfWeek: Maybe<Scalars['Int']['output']>;
  frequency: StatementsV2ScheduleFrequency;
  hour: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isDryRun: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  minute: Scalars['Int']['output'];
  publishImmediately: Scalars['Boolean']['output'];
  statementFilters: Array<StatementsV2ScheduleStatementFilter>;
  statementTypeID: Scalars['String']['output'];
  statementTypeName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** ScheduleAddResult represents the result of adding a schedule. */
export type StatementsV2ScheduleCreateResult = {
  __typename: 'StatementsV2ScheduleCreateResult';
  id: Scalars['String']['output'];
};

/** ScheduleFrequency is an enum that represents the frequency of a schedule. */
export enum StatementsV2ScheduleFrequency {
  /** DAILY represents a schedule that runs daily. */
  DAILY = 'DAILY',
  /** MONTHLY represents a schedule that runs monthly. */
  MONTHLY = 'MONTHLY',
  /** WEEKLY represents a schedule that runs weekly. */
  WEEKLY = 'WEEKLY'
}

/** ScheduleInput represents the input for creating a schedule. */
export type StatementsV2ScheduleInput = {
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  frequency: StatementsV2ScheduleFrequency;
  hour: Scalars['Int']['input'];
  isDryRun: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  minute: Scalars['Int']['input'];
  publishImmediately: Scalars['Boolean']['input'];
  statementFilters: Array<InputMaybe<StatementsV2ScheduleStatementFilterInput>>;
  statementTypeID: Scalars['String']['input'];
};

/** ScheduleStatementFilter represents a filter to apply when generating statements. */
export type StatementsV2ScheduleStatementFilter = {
  __typename: 'StatementsV2ScheduleStatementFilter';
  name: Scalars['String']['output'];
  placeholder: Maybe<StatementsV2ScheduleStatementFilterPlaceholder>;
  value: Scalars['String']['output'];
};

/** ScheduleStatementFilterInput represents the input for a schedule statement filter. */
export type StatementsV2ScheduleStatementFilterInput = {
  name: Scalars['String']['input'];
  placeholder?: InputMaybe<StatementsV2ScheduleStatementFilterPlaceholder>;
  value: Scalars['String']['input'];
};

/** ScheduleStatementFilterPlaceholder represents a placeholder for a value in a schedule statement filter. */
export enum StatementsV2ScheduleStatementFilterPlaceholder {
  ALL = 'ALL',
  CURRENT_MONTH = 'CURRENT_MONTH',
  PREVIOUS_MONTH = 'PREVIOUS_MONTH'
}

/** SignedStatementURL represents a statement with its signed URL. */
export type StatementsV2SignedStatementURL = {
  __typename: 'StatementsV2SignedStatementURL';
  signedURL: Scalars['String']['output'];
  statementID: Scalars['String']['output'];
};

/** Statement represents a statement that has been generated even if it is not yet complete or failed. */
export type StatementsV2Statement = {
  __typename: 'StatementsV2Statement';
  /**
   * The account associated with this statement.
   * Returns an Account reference that will be resolved by the gateway from graphqlmonolith.
   */
  account: Maybe<Account>;
  /** AccountID is exposed for federation resolvers to perform legacy lookups */
  accountID: Scalars['String']['output'];
  /**
   * The affiliate associated with this statement.
   * Returns an InstitutionalAffiliate reference resolved by the gateway from the KYC service.
   */
  affiliate: Maybe<InstitutionalAffiliate>;
  /**
   * The affiliate ID associated with this statement.
   * Used by federation resolvers to look up affiliate details from the KYC service.
   */
  affiliateID: Scalars['String']['output'];
  correctedAt: Maybe<Scalars['Time']['output']>;
  coverageTimeEnd: Maybe<Scalars['Time']['output']>;
  coverageTimeStart: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  displayDate: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  emailSentAt: Scalars['String']['output'];
  errMsg: Scalars['String']['output'];
  format: StatementsV2StatementFormat;
  id: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  legacyStatementID: Scalars['String']['output'];
  /**
   * The organization this statement belongs to.
   * Returns an Organization reference that will be resolved by the gateway from graphqlmonolith.
   */
  organization: Organization;
  organizationID: Scalars['String']['output'];
  signedURL: Scalars['String']['output'];
  status: StatementsV2StatementGenerationStatus;
  typeID: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  uri: Scalars['String']['output'];
};

/** StatementFilter represents a filter that can be applied to a statement. */
export type StatementsV2StatementFilter = {
  fieldName: Scalars['String']['input'];
  multiSelectValue?: InputMaybe<StatementsV2StatementFilterMultiSelectValue>;
  singleSelectValue?: InputMaybe<StatementsV2StatementFilterSingleSelectValue>;
};

/**
 * StatementFilterAvailableValues represents an available value for a specific filter.
 * This is used in responses when retrieving the possible values for filters like multi-select or single-select.
 */
export type StatementsV2StatementFilterAvailableValues = {
  __typename: 'StatementsV2StatementFilterAvailableValues';
  /** DisplayName is the human-readable display name of the value. */
  displayName: Scalars['String']['output'];
  /**
   * FieldObjectValueList is a list of field names to their corresponding values. This is used for filters that
   * require multiple fields.
   */
  fieldObjectValueList: Array<StatementsV2StatementFilterKeyValue>;
  /** FieldValue is the actual value of the filter that should be used in requests. */
  fieldValue: Scalars['String']['output'];
};

export type StatementsV2StatementFilterAvailableValuesConnection = {
  __typename: 'StatementsV2StatementFilterAvailableValuesConnection';
  /** A list of edges. */
  edges: Maybe<Array<StatementsV2StatementFilterAvailableValuesEdge>>;
  /** Information to aid in pagination. */
  pageInfo: Maybe<PageInfo>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type StatementsV2StatementFilterAvailableValuesEdge = {
  __typename: 'StatementsV2StatementFilterAvailableValuesEdge';
  /** The item at the end of the edge. */
  node: Maybe<StatementsV2StatementFilterAvailableValues>;
};

/** StatementFilterConfig defines the configuration for a specific filter applied to a statement type. */
export type StatementsV2StatementFilterConfig = {
  __typename: 'StatementsV2StatementFilterConfig';
  /** DisplayName is the human-readable name of the filter, useful for UI display. */
  displayName: Scalars['String']['output'];
  /** FieldName is the name of the field to which the filter applies (e.g., "date"). */
  fieldName: Scalars['String']['output'];
  /** Type is the type of filter (date range, single select, etc.). */
  type: StatementsV2StatementFilterType;
};

/** StatementFilterKeyValue represents a key-value pair for a filter that requires multiple fields. */
export type StatementsV2StatementFilterKeyValue = {
  __typename: 'StatementsV2StatementFilterKeyValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** StatementFilterMultiSelectValue represents the selected values for a multi-select filter. */
export type StatementsV2StatementFilterMultiSelectValue = {
  /** Values is a list of selected values to apply to the multi-select filter. */
  values: Array<Scalars['String']['input']>;
};

/** StatementFilterSingleSelectValue represents the selected value for a single-select filter. */
export type StatementsV2StatementFilterSingleSelectValue = {
  /** Value is the selected value to apply to the single-select filter. */
  value: Scalars['String']['input'];
};

/** StatementFilterType defines the different types of filters that can be applied to a statement. */
export enum StatementsV2StatementFilterType {
  /** A filter that applies to a specific date (single point in time). */
  DATE_POINT = 'DATE_POINT',
  /** A filter that applies to a range of dates (start and end). */
  DATE_RANGE = 'DATE_RANGE',
  /** A filter that allows the selection of multiple values from a set of options. */
  MULTI_SELECT = 'MULTI_SELECT',
  /** A filter that allows the selection of a single value from a set of options. */
  SINGLE_SELECT = 'SINGLE_SELECT'
}

/** StatementFormat represents the format in which a statement should be generated. */
export enum StatementsV2StatementFormat {
  PDF = 'PDF'
}

/** StatementGenerateAsyncResult represents the result of triggering a statement generation. */
export type StatementsV2StatementGenerateAsync = {
  __typename: 'StatementsV2StatementGenerateAsync';
  statementID: Scalars['String']['output'];
};

/** StatementGenerationStatus represents the status of a statement generation process. */
export enum StatementsV2StatementGenerationStatus {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  GENERATING = 'GENERATING',
  STORING = 'STORING'
}

/** StatementType represents a type of statement that the service can generate. */
export type StatementsV2StatementType = {
  __typename: 'StatementsV2StatementType';
  /** DisplayName is the human-readable name of the statement type, used for display purposes. */
  displayName: Scalars['String']['output'];
  /** ID is the unique identifier for the statement type. This ID is used in subsequent requests. */
  id: Scalars['String']['output'];
};

/** Extra parameters for stellar */
export type StellarExtraParams = {
  __typename: 'StellarExtraParams';
  /** memo to use in transaction */
  memo: Maybe<Scalars['String']['output']>;
};

/** String comparison operations. */
export type StringOps = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Subaccount represents a Subaccount under an Affiliate */
export type Subaccount = {
  __typename: 'Subaccount';
  /** Assets under the subaccount */
  assets: Array<SubaccountAsset>;
  /** Timestamp of when the subaccount was created */
  createdAt: Scalars['Time']['output'];
  /** Identifier of the subaccount */
  id: Scalars['String']['output'];
  /** Returns true if the subaccount is the Unassigned Funds Subaccount */
  isUnassignedFundsSubaccount: Scalars['Boolean']['output'];
  /** Name of the Subaccount */
  name: Scalars['String']['output'];
  /** Identifier for the Organization */
  organizationId: Scalars['String']['output'];
  /** Type of the program customer subaccount */
  pcSubaccountType: Maybe<PcSubaccountType>;
  /** USD value of the assets under the subaccount */
  postedBalance: Amount;
  /**
   * Affiliate ID of the subaccount's PRIMARY affiliate. Populated only by lookups that already
   * load affiliate data (currently Query.subaccountByID); null on other paths rather than
   * triggering an extra per-subaccount lookup.
   */
  primaryAffiliateId: Maybe<Scalars['String']['output']>;
  /** Status of the subaccount */
  subaccountStatus: Maybe<SubaccountStatus>;
  /** Returns the type of Subaccount */
  subaccountType: SubaccountType;
  /** Returns a transaction with TransactionID and SubaccountID */
  transaction: SubccountTransaction;
  /** Transactions under a Subaccount */
  transactions: Array<SubaccountTransactionEdge>;
};


/** Subaccount represents a Subaccount under an Affiliate */
export type SubaccounttransactionArgs = {
  filterTransactionID: Scalars['String']['input'];
};

/** SubaccountAffiliateCustomerFields represents an Affiliate within the Subaccount System */
export type SubaccountAffiliateCustomerFields = {
  __typename: 'SubaccountAffiliateCustomerFields';
  /** affiliateID represents the identifier of the Program Customer (Affiliate) */
  affiliateID: Scalars['String']['output'];
  /** Represents the KYC Information of the Affiliate */
  affiliateInformation: InstitutionalAffiliate;
  /** Number of subaccounts under the Affiliate */
  numberOfAccounts: Scalars['Int']['output'];
  /** Estimate of the USD value of the Assets under the Subaccounts of the Affiliate */
  postedBalance: Amount;
  /** Balance Per asset that is Withdrawable by the Affiliate */
  postedBalancePerAsset: Array<Amount>;
  /**
   * Program customer KYC profile(s) for this row. List-shaped to leave room for a
   * future 1→N mapping without a breaking change.
   */
  programCustomers: Maybe<Array<ProgramCustomerKYCProfile>>;
};

/** Represents a balance in the subaccount and the balance type */
export type SubaccountAmount = {
  __typename: 'SubaccountAmount';
  /** Amount of that Balance Per Asset */
  amount: Amount;
  /** Represents the type of Balance */
  balanceType: BalanceType;
};

/** Represents Assets held by a Subaccount */
export type SubaccountAsset = {
  __typename: 'SubaccountAsset';
  /** AssetTypeID of the asset */
  assetTypeInfo: AssetTypeInfo;
  /** Balance that can be traded */
  buyingPower: Amount;
  /** Posted balance of the Asset */
  postedBalance: Amount;
  /** Balance that can be withdrawn from the Subaccount */
  withdrawableBalance: Amount;
};

/** Represents the assets held by a subaccount */
export type SubaccountAssets = {
  __typename: 'SubaccountAssets';
  /** Break down per balance type for each asset + total amount */
  assets: Array<Maybe<AssetBalance>>;
  /** Info for all the assets the subaccount holds */
  assetsInfo: Array<AssetTypeInfo>;
  /** Subaccount value in USD */
  subaccountValueUSD: Amount;
};

/** Represents a paginated connection of SubaccountAssets */
export type SubaccountAssetsConnection = {
  __typename: 'SubaccountAssetsConnection';
  /** Edges contains a list of subaccountAssetsEdge objects representing a page of SubaccountAssets data. */
  edges: Array<subaccountAssetsEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** Represents a subaccount balance */
export type SubaccountBalance = {
  __typename: 'SubaccountBalance';
  /** Quantity */
  quantity: Quantity;
  /** Subaccount ID */
  subaccountID: Scalars['String']['output'];
  /** Timestamp of when a balance was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/** SubaccountBalanceConnection represents a page of Subaccount Balances based on the parameters of pagination used, defined by a pageInfo object. */
export type SubaccountBalanceConnection = {
  __typename: 'SubaccountBalanceConnection';
  /** Edges contains a list of SubaccountBalanceEdge objects representing a page of SubaccountBalance data. */
  edges: Array<SubaccountBalanceEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** Represents a Subaccount Balance Edge */
export type SubaccountBalanceEdge = {
  __typename: 'SubaccountBalanceEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a Subaccount Balance */
  node: SubaccountBalance;
};

export type SubaccountBeneficiary = {
  __typename: 'SubaccountBeneficiary';
  allocation: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SubaccountConnection = {
  __typename: 'SubaccountConnection';
  edges: Array<SubaccountEdge>;
  pageInfo: PageInfo;
};

export type SubaccountEdge = {
  __typename: 'SubaccountEdge';
  cursor: Scalars['String']['output'];
  node: SubaccountV2;
};

/** Typed filter for SubaccountV2 queries. */
export type SubaccountFilterInput = {
  and?: InputMaybe<Array<SubaccountFilterInput>>;
  createdAt?: InputMaybe<TimeOps>;
  id?: InputMaybe<StringOps>;
  /** Filter by segregation status. */
  isSegregated?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringOps>;
  not?: InputMaybe<SubaccountFilterInput>;
  or?: InputMaybe<Array<SubaccountFilterInput>>;
  orgID?: InputMaybe<StringOps>;
  organization?: InputMaybe<SubaccountOrganizationFilter>;
  programCustomer?: InputMaybe<SubaccountProgramCustomerFilter>;
  status?: InputMaybe<SubaccountStatusOps>;
  type?: InputMaybe<SubaccountTypeOps>;
};

/** Fields available for ordering subaccounts. */
export enum SubaccountOrderField {
  CLOSED_AT = 'CLOSED_AT',
  CREATED_AT = 'CREATED_AT',
  EXTERNAL_ID = 'EXTERNAL_ID',
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION_CREATED_AT = 'ORGANIZATION_CREATED_AT',
  ORGANIZATION_PROGRAM_CUSTOMER_ID = 'ORGANIZATION_PROGRAM_CUSTOMER_ID',
  ORGANIZATION_TYPE = 'ORGANIZATION_TYPE',
  ORG_ID = 'ORG_ID',
  STATUS = 'STATUS',
  TYPE = 'TYPE',
  UPDATED_AT = 'UPDATED_AT'
}

/** Typed ordering for SubaccountV2 queries. */
export type SubaccountOrderInput = {
  direction: OrderDirection;
  field: SubaccountOrderField;
};

export type SubaccountOrg = {
  __typename: 'SubaccountOrg';
  config: SubaccountOrgConfig;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /**
   * Whether the firm is enrolled in cash interest. A subaccount may only be
   * enrolled while its firm is enrolled; unenrollment is not gated.
   */
  isFiatInterestEnrolled: Scalars['Boolean']['output'];
  programCustomerID: Scalars['String']['output'];
  subaccounts: SubaccountConnection;
  type: SubaccountOrgType;
  updatedAt: Scalars['Time']['output'];
};


export type SubaccountOrgsubaccountsArgs = {
  filter?: InputMaybe<SubaccountFilterInput>;
  orderBy?: InputMaybe<Array<SubaccountOrderInput>>;
  page: PaginationParams;
};

export type SubaccountOrgConfig = {
  __typename: 'SubaccountOrgConfig';
  canTransferBetweenProgramCustomers: Maybe<Scalars['Boolean']['output']>;
  fundingThreshold: Maybe<Scalars['Decimal']['output']>;
  overdraftLimit: Maybe<Scalars['Decimal']['output']>;
};

export type SubaccountOrgConnection = {
  __typename: 'SubaccountOrgConnection';
  edges: Array<SubaccountOrgEdge>;
  pageInfo: PageInfo;
};

export type SubaccountOrgEdge = {
  __typename: 'SubaccountOrgEdge';
  cursor: Scalars['String']['output'];
  node: SubaccountOrg;
};

export enum SubaccountOrgType {
  RIA = 'RIA'
}

/** Organization fields accessible when filtering subaccounts through the organization edge. */
export type SubaccountOrganizationFilter = {
  affiliateID?: InputMaybe<StringOps>;
  type?: InputMaybe<OrganizationTypeOps>;
};

/** Subaccounts organizations types */
export enum SubaccountOrganizationType {
  /** Organization is an ETF issuer */
  ETF_ISSUER = 'ETF_ISSUER',
  /** Organization is a SMA */
  SMA = 'SMA'
}

export type SubaccountProgramCustomer = {
  __typename: 'SubaccountProgramCustomer';
  id: Scalars['ID']['output'];
  role: SubaccountProgramCustomerRole;
};

/** ProgramCustomer fields accessible when filtering subaccounts through the programCustomer edge. */
export type SubaccountProgramCustomerFilter = {
  id?: InputMaybe<StringOps>;
  role?: InputMaybe<ProgramCustomerRoleOps>;
};

export enum SubaccountProgramCustomerRole {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export type SubaccountProgramSigner = {
  __typename: 'SubaccountProgramSigner';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

/** Represents the different statuses of a subaccount */
export enum SubaccountStatus {
  /** The subaccount is closed */
  CLOSED = 'CLOSED',
  /** The subaccount is open */
  OPEN = 'OPEN',
  /** The subaccount is submitted */
  SUBMITTED = 'SUBMITTED'
}

/** SubaccountV2Status comparison operations. */
export type SubaccountStatusOps = {
  eq?: InputMaybe<SubaccountV2Status>;
  in?: InputMaybe<Array<SubaccountV2Status>>;
  neq?: InputMaybe<SubaccountV2Status>;
  nin?: InputMaybe<Array<SubaccountV2Status>>;
};

export enum SubaccountSubType {
  CONVERSION = 'CONVERSION',
  ROLLOVER = 'ROLLOVER'
}

/** Represents a Subaccount Transaction Edge */
export type SubaccountTransactionEdge = {
  __typename: 'SubaccountTransactionEdge';
  /** Represents a Subaccount Transaction */
  node: Maybe<SubccountTransaction>;
};

/** Represents an Entry of a Transaction */
export type SubaccountTransactionEntry = {
  __typename: 'SubaccountTransactionEntry';
  /** Identifier of the Ledger Account involved in the Transaction Entry */
  accountId: Scalars['String']['output'];
  /** Amount of the Asset */
  amount: Amount;
  /** Information related to the Asset */
  assetTypeInfo: AssetTypeInfo;
  /** Type of Balance (POSTED; PENDING; HOLD) */
  balanceType: BalanceType;
  /** Timestamp of the Subaccount Entry */
  createdAt: Scalars['Time']['output'];
  /** Identifier of the entry */
  id: Scalars['String']['output'];
  /** Metadata of the entry */
  metadata: Maybe<Scalars['String']['output']>;
};

/** Represents the different types of subaccount */
export enum SubaccountType {
  /** This subaccount is the org-level debit-face bucket holding the offsetting legs of customer collateral holds */
  COLLATERAL = 'COLLATERAL',
  /** This subaccount is used for ETF Funds */
  ETF_FUNDS = 'ETF_FUNDS',
  /** This subaccount used for the FBO Customer Fees */
  FBO_CUSTOMER_FEES = 'FBO_CUSTOMER_FEES',
  /** This subaccount is used for RIA funding allocations */
  FUNDING = 'FUNDING',
  /** This subaccount is used to keep track of Gas Fees */
  GAS_FEES = 'GAS_FEES',
  /** This subaccount is used as Payable and Receivables of an RIA */
  PAYABLES_RECEIVABLES = 'PAYABLES_RECEIVABLES',
  /** This subaccount is a Program Customer */
  PROGRAM_CUSTOMER = 'PROGRAM_CUSTOMER',
  /** This subaccount is used for unassigned Funds */
  UNASSIGNED_FUNDS = 'UNASSIGNED_FUNDS',
  /** This subaccount is used for unassigned trading-strategy funds */
  UNASSIGNED_STRATEGY_FUNDS = 'UNASSIGNED_STRATEGY_FUNDS'
}

/** SubaccountV2Type comparison operations. */
export type SubaccountTypeOps = {
  eq?: InputMaybe<SubaccountV2Type>;
  in?: InputMaybe<Array<SubaccountV2Type>>;
  neq?: InputMaybe<SubaccountV2Type>;
  nin?: InputMaybe<Array<SubaccountV2Type>>;
};

export type SubaccountV2 = {
  __typename: 'SubaccountV2';
  closedAt: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  externalID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * Whether the subaccount is enrolled in cash interest. Enrollment is gated on
   * the firm's own enrollment; unenrollment is not.
   */
  isFiatInterestEnrolled: Scalars['Boolean']['output'];
  /**
   * Whether the subaccount is segregated. Segregated subaccounts hold assets
   * separate from the program's commingled pool.
   */
  isSegregated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgID: Scalars['String']['output'];
  organization: Maybe<SubaccountOrg>;
  primaryBeneficiaries: Maybe<Array<SubaccountBeneficiary>>;
  programCustomers: Maybe<Array<SubaccountProgramCustomer>>;
  programSigners: Maybe<Array<SubaccountProgramSigner>>;
  secondaryBeneficiaries: Maybe<Array<SubaccountBeneficiary>>;
  status: SubaccountV2Status;
  subType: Maybe<SubaccountSubType>;
  type: SubaccountV2Type;
  updatedAt: Scalars['Time']['output'];
};

export enum SubaccountV2Status {
  BLOCKED = 'BLOCKED',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  SUBMITTED = 'SUBMITTED'
}

export enum SubaccountV2Type {
  CUSTODIAL = 'CUSTODIAL',
  INDIVIDUAL_TAXABLE = 'INDIVIDUAL_TAXABLE',
  INSTITUTIONAL_TAXABLE = 'INSTITUTIONAL_TAXABLE',
  IRA = 'IRA',
  JOINT = 'JOINT',
  ROTH = 'ROTH'
}

/** Represents a Subaccount Transaction */
export type SubccountTransaction = {
  __typename: 'SubccountTransaction';
  /** Flag that let us know if the Transaction allows Overdraft Balance */
  allowOverdraftBalance: Maybe<Scalars['Boolean']['output']>;
  /** Flag that let us know if the Transaction allows Pending Balance */
  allowPendingBalance: Maybe<Scalars['Boolean']['output']>;
  /** Show the current Balance for each balance type */
  amountsPerBalanceType: Array<SubaccountAmount>;
  /** Timestamp of when a transaction was created */
  createdAt: Scalars['Time']['output'];
  /** Description of a transaction */
  description: Maybe<Scalars['String']['output']>;
  /** Transaction entries */
  entries: Array<SubaccountTransactionEntry>;
  /** Identifier of the Transaction */
  id: Scalars['String']['output'];
  /** Metadata of a transaction */
  metadata: Maybe<Scalars['String']['output']>;
  /** Operation ID if this transaction involves some on-chain action */
  operationID: Maybe<Scalars['OperationID']['output']>;
  /** Status of a Transaction */
  status: TransactionStatus;
  /** Type of a Transaction */
  transactionType: TransactionType;
  /** Timestamp of a transaction was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/** SupportedExtraParams is the enum of possible extra params expected in IOS/FE */
export enum SupportedExtraParamsTypes {
  /** DestinationTag */
  DESTINATION_TAG = 'DESTINATION_TAG',
  /** Memo */
  MEMO = 'MEMO',
  /** no extra params */
  NONE = 'NONE'
}

export type SuspendControlAgreementInput = {
  controlAgreementID: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
};

export type SuspendControlAgreementResponse = {
  __typename: 'SuspendControlAgreementResponse';
  success: Scalars['Boolean']['output'];
};

export enum SweepDirection {
  /** The strategy sub-account credits the clients. */
  GAIN = 'GAIN',
  /** The clients are debited. */
  LOSS = 'LOSS'
}

export type SyncProgramCustomerRosterResult = {
  __typename: 'SyncProgramCustomerRosterResult';
  subaccountsUpdated: Scalars['Int']['output'];
};

export type SyncTaxCertificationDataToKYCInput = {
  /** The top-level affiliate/account ID this certification syncs to. */
  accountId: Scalars['String']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  countryOfCitizenship?: InputMaybe<Scalars['String']['input']>;
  countryOfIncorporation?: InputMaybe<Scalars['String']['input']>;
  disregardedEntityName?: InputMaybe<Scalars['String']['input']>;
  fatcaExemptReportingCode?: InputMaybe<Scalars['String']['input']>;
  foreignTaxIdentifyingNumber?: InputMaybe<Scalars['String']['input']>;
  /** Which TaxBit SDK form this submission came from. */
  formType: TaxCertificationFormType;
  taxExemptPayeeCode?: InputMaybe<Scalars['String']['input']>;
  taxpayerIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  usTaxpayerIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SyncTaxCertificationDataToKYCPayload = {
  __typename: 'SyncTaxCertificationDataToKYCPayload';
  success: Scalars['Boolean']['output'];
};

/** TMSConfigs contains the transaction monitoring system configurations */
export type TMSConfigs = {
  __typename: 'TMSConfigs';
  /** Time at which this TMS configuration version was created */
  createdAt: Scalars['Timestamp']['output'];
  /** TMS configuration entity type */
  entityType: TMSRuleEntityType;
  /** configs as JSON */
  tmsConfigBody: Scalars['String']['output'];
  /** Unique ID for this particular TMS configuration version */
  tmsConfigID: Scalars['String']['output'];
  /** TMS configuration version */
  tmsConfigVersion: Scalars['Int']['output'];
};

/** TMSConfigsConnection contains the edges to TMSConfigs */
export type TMSConfigsConnection = {
  __typename: 'TMSConfigsConnection';
  /** List of edges containing transaction monitoring configs */
  edges: Array<TMSConfigsEdge>;
  /** Page details for the associated list of TMSConfigEdge */
  pageInfo: PageInfo;
};

/** TMSConfigsEdge contains the TMSConfigs */
export type TMSConfigsEdge = {
  __typename: 'TMSConfigsEdge';
  /** Cursor for the TMSConfigsEdge */
  cursor: Scalars['String']['output'];
  /** TMSConfigs */
  node: TMSConfigs;
};

/** TMSRuleEntityType represents the anchorage entity type of TMS rule */
export enum TMSRuleEntityType {
  /** SINGAPORE rules for monitoring Anchorage Digital Singapore */
  SINGAPORE = 'SINGAPORE',
  /** TRUST_COMPANY rules for monitoring Anchorage Digital Bank */
  TRUST_COMPANY = 'TRUST_COMPANY'
}

/** TMSRuleType represents the type of TMS rule */
export enum TMSRuleGroup {
  /** rules monitoring the accuracy of transaction attribution data */
  ATTRIBUTION_MONITORING = 'ATTRIBUTION_MONITORING',
  /** transaction monitoring rules targeting specific behavior based on customer type */
  CUSTOMER_TYPE = 'CUSTOMER_TYPE',
  /** behavioral rules for monitoring digital asset transactions */
  DIGITAL_ASSET = 'DIGITAL_ASSET',
  /** behavioral rules for monitoring fiat transactions */
  FIAT = 'FIAT'
}

/** TMSRuleGroupMetadata contains the metadata for a TMS rule group */
export type TMSRuleGroupMetadata = {
  __typename: 'TMSRuleGroupMetadata';
  /** TMS rule group description */
  description: Scalars['String']['output'];
  /** TMS configuration entity type */
  entityType: TMSRuleEntityType;
  /** TMS rule group */
  group: TMSRuleGroup;
  /** TMS rule group label */
  label: Scalars['String']['output'];
  /** TMS rule metadata */
  rulesMetadata: Array<TMSRuleMetadata>;
};

/** TMSRuleMetadata contains the metadata for a TMS rule */
export type TMSRuleMetadata = {
  __typename: 'TMSRuleMetadata';
  /** TMS rule description */
  description: Scalars['String']['output'];
  /** TMS rule label */
  label: Scalars['String']['output'];
  /** TMS rule name */
  name: TMSRuleName;
};

/** TMSRuleID represents the name of a TMS rule */
export enum TMSRuleName {
  /** The rule identifies a customer's activity following a prolonged period without a transaction */
  DORMANT_ACCOUNT = 'DORMANT_ACCOUNT',
  /** The rule identifies the risk of a customer immediately washing funds to obscure their source of funds */
  FLOWTHROUGH_OF_FUNDS = 'FLOWTHROUGH_OF_FUNDS',
  /** The rule identifies deviations from the activity expected of Funds */
  FUND = 'FUND',
  /**
   * The rule is intended to separate customers which transact in a meaningfully
   * different way, when compared to the rest of the customer population
   */
  HIGH_VOLUME_CUSTOMERS = 'HIGH_VOLUME_CUSTOMERS',
  /** The rule identifies deviations from a customer’s historical activity */
  HISTORICAL_PROFILE_DEVIATION = 'HISTORICAL_PROFILE_DEVIATION',
  /** The rule identifies deviations from the activity expected of customer types that have low expected activity */
  LOW_ACTIVITY_CUSTOMERS = 'LOW_ACTIVITY_CUSTOMERS',
  /** The rule identifies deviations from the activity expected of Miners */
  MINING = 'MINING',
  /**
   * The rule identifies a group of customers sending funds to a potential hub
   * which could indicate hidden relationships or layering of funds
   */
  MULTIPLE_ORIGINATORS = 'MULTIPLE_ORIGINATORS',
  /** The rule identifies devidations from the activity expected of Non-Banking-Financial-Institutions */
  NBFI = 'NBFI',
  /**
   * Detects transaction activity that avoids detection of the Travel Rule
   * by breaking down larger transactions into multiple small transactions
   */
  REPORTING_EVASION = 'REPORTING_EVASION',
  /**
   * The rule identifies a customer sending funds to a number of counterparties thus
   * acting as a potential hub which could indicate hidden relationships or layering of funds
   */
  SINGLE_ORIGINATOR = 'SINGLE_ORIGINATOR'
}

export type TagFilter = {
  tags: Array<Scalars['String']['input']>;
  type?: InputMaybe<TagFilterType>;
};

export enum TagFilterType {
  BACKOFFICE = 'BACKOFFICE',
  CLIENT = 'CLIENT',
  SYSTEM = 'SYSTEM'
}

export type TagResult = {
  __typename: 'TagResult';
  name: Scalars['String']['output'];
  orgID: Maybe<Scalars['String']['output']>;
  tagType: TagType;
};

export type TagResultConnection = {
  __typename: 'TagResultConnection';
  edges: Array<TagResultEdge>;
  pageInfo: PageInfo;
};

export type TagResultEdge = {
  __typename: 'TagResultEdge';
  cursor: Scalars['String']['output'];
  node: TagResult;
};

/**
 * Field that searchTags sorts on, combined with an OrderDirection. To keep keyset cursors
 * stable, each field uses the other as a secondary tie-break: NAME breaks ties by created_at
 * DESC; CREATED_AT breaks ties by name ASC. Changing sortField or sortOrder mid-pagination
 * invalidates an existing cursor.
 */
export enum TagSortField {
  /** Sort by tag creation time. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by tag name (default). */
  NAME = 'NAME'
}

export type TagTaxTransactionInput = {
  /**
   * IRS distribution code for Form 1099-R. Required when tag is DISTRIBUTION.
   * Accepts single codes (e.g., "7", "B") and combination codes (e.g., "7B", "4G").
   */
  distributionCode?: InputMaybe<Scalars['String']['input']>;
  /** The organization key ID */
  organizationKeyId: Scalars['String']['input'];
  /** Reason for postponement or late rollover. Required when tag is POSTPONED or LATE_ROLLOVER. */
  postponedLateReason?: InputMaybe<Scalars['String']['input']>;
  /** The subaccount where the transaction occurred */
  subaccountId: Scalars['String']['input'];
  /** The Anchorage tax tag to apply */
  tag: TaxTransactionTag;
  /**
   * The tax year associated with this tag.
   * Required for contribution-type tags (CONTRIBUTION, ROLLOVER, LATE_ROLLOVER, POSTPONED, RECHARACTERIZATION).
   * Optional for other tags; ignored when not applicable.
   */
  taxYear?: InputMaybe<Scalars['Int']['input']>;
  /** The external transaction ID (deposit/withdrawal ID from custody) */
  transactionId: Scalars['String']['input'];
};

export type TagTaxTransactionPayload = {
  __typename: 'TagTaxTransactionPayload';
  /** Error message if operation failed */
  error: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export enum TagType {
  BACKOFFICE = 'BACKOFFICE',
  CLIENT = 'CLIENT',
  SYSTEM = 'SYSTEM'
}

/** A tag with the list of asset type IDs that have this tag */
export type TagWithAssetTypes = {
  __typename: 'TagWithAssetTypes';
  /** List of asset type IDs that have this tag (e.g., ["USDC", "USDT"]) */
  assetTypeIds: Array<Scalars['String']['output']>;
  /** Human-readable description of what this tag represents */
  description: Scalars['String']['output'];
  /** The tag identifier (e.g., "STABLE", "REBASING") */
  tag: Scalars['String']['output'];
};

export type TaggedEntity = {
  __typename: 'TaggedEntity';
  entityID: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
};

export type TaggedEntityConnection = {
  __typename: 'TaggedEntityConnection';
  edges: Array<TaggedEntityEdge>;
  pageInfo: PageInfo;
};

export type TaggedEntityEdge = {
  __typename: 'TaggedEntityEdge';
  cursor: Scalars['String']['output'];
  node: TaggedEntity;
};

/** Talos instance type */
export enum TalosInstance {
  /** Institutional instance */
  INSTITUTIONAL = 'INSTITUTIONAL',
  /** Whitelabel instance */
  WHITELABEL = 'WHITELABEL'
}

/** A B2B tax account: a top-level affiliate enrolled with the tax provider. */
export type TaxAccount = {
  __typename: 'TaxAccount';
  /** Top-level affiliate ID */
  accountId: Scalars['ID']['output'];
  /**
   * The account's W-form (W-9/W-8) certification status. Null when the account
   * has not submitted any tax documentation yet.
   */
  certification: Maybe<TaxCertification>;
  /** Legal entity name from KYC */
  name: Scalars['String']['output'];
};

/** Connection type for paginated tax accounts */
export type TaxAccountConnection = {
  __typename: 'TaxAccountConnection';
  /** List of tax account edges */
  edges: Array<TaxAccountEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Edge type for tax account connection */
export type TaxAccountEdge = {
  __typename: 'TaxAccountEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The tax account node */
  node: TaxAccount;
};

/** TaxBit W-form tax documentation status for one account. */
export type TaxCertification = {
  __typename: 'TaxCertification';
  /**
   * Whether the account finished filling out the form. A document PDF exists
   * only once collection is COMPLETE, independent of validity.
   */
  dataCollectionStatus: Maybe<TaxDataCollectionStatus>;
  /** When the current documentation expires */
  expirationDate: Maybe<Scalars['Time']['output']>;
  /**
   * True when the provider requires the account to resubmit documentation
   * (e.g. expiry or a change in circumstances)
   */
  needsResubmission: Maybe<Scalars['Boolean']['output']>;
  /** The provider's overall validation verdict on the submitted documentation */
  taxDocumentationStatus: Maybe<TaxDocumentationStatus>;
  /** Verdict of the IRS TIN-matching check on the submitted name + TIN */
  tinStatus: Maybe<TaxTinStatus>;
  /** When the TIN validation ran */
  tinValidationDate: Maybe<Scalars['Time']['output']>;
  /** Which W-form the account submitted */
  wFormType: Maybe<TaxWFormType>;
};

/** TaxCertificationFormType is the type of a W-form. */
export enum TaxCertificationFormType {
  W8BEN = 'W8BEN',
  W8BENE = 'W8BENE',
  W8IMY = 'W8IMY',
  W9 = 'W9'
}

/** TaxCertificationToken is a TaxBit account-owner bearer token for the tax certification SDK. */
export type TaxCertificationToken = {
  __typename: 'TaxCertificationToken';
  /** Bearer token for the TaxBit SDK. */
  bearerToken: Scalars['String']['output'];
  /** When the token expires, if TaxBit returned an expiry. */
  expiresAt: Maybe<Scalars['Time']['output']>;
};

/** TaxCertificationWForm is the TaxBit W-form status of an affiliate. */
export type TaxCertificationWForm = {
  __typename: 'TaxCertificationWForm';
  /** Whether TaxBit has collected every answer the W-form needs. */
  dataCollectionStatus: Maybe<TaxDataCollectionStatus>;
  /** When the W-form expires. */
  expirationDate: Maybe<Scalars['Time']['output']>;
  /** W-form type the affiliate submitted. */
  formType: Maybe<TaxCertificationFormType>;
  /** Whether TaxBit asks the affiliate to submit the W-form again. */
  needsResubmission: Maybe<Scalars['Boolean']['output']>;
  /** Whether TaxBit considers the submitted W-form valid. */
  taxDocumentationStatus: Maybe<TaxDocumentationStatus>;
  /** Result of TaxBit's TIN validation. */
  tinStatus: Maybe<TaxTinStatus>;
  /** When TaxBit last validated the TIN. */
  tinValidationDate: Maybe<Scalars['Time']['output']>;
};

/** TaxDataCollectionStatus is whether TaxBit has collected every W-form answer. */
export enum TaxDataCollectionStatus {
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE'
}

/** Tax Document represents a tax form (1099-DA, 1099-MISC, etc.) issued to an account */
export type TaxDocument = Node & {
  __typename: 'TaxDocument';
  accountID: Scalars['String']['output'];
  affiliate: Maybe<AffiliateV2>;
  documentType: TaxDocumentType;
  downloadLink: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issuedDate: Scalars['Time']['output'];
  status: TaxDocumentStatus;
  taxYear: Scalars['Int']['output'];
};

/** A connection to a list of TaxDocument items. */
export type TaxDocumentConnection = {
  __typename: 'TaxDocumentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TaxDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a TaxDocument connection. */
export type TaxDocumentEdge = {
  __typename: 'TaxDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TaxDocument>;
};

/** Tax document email destination */
export type TaxDocumentEmailDestination = {
  /** Email address of the recipient */
  email: Scalars['String']['input'];
  /** Name of the recipient */
  name: Scalars['String']['input'];
};

/** Ordering options for TaxDocument connections */
export type TaxDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TaxDocuments. */
  field: TaxDocumentOrderField;
};

/** Properties by which TaxDocument connections can be ordered. */
export enum TaxDocumentOrderField {
  ACCOUNT_ID = 'ACCOUNT_ID',
  DOCUMENT_TYPE = 'DOCUMENT_TYPE',
  ID = 'ID',
  ISSUED_DATE = 'ISSUED_DATE',
  STATUS = 'STATUS',
  TAX_YEAR = 'TAX_YEAR'
}

/** TaxDocumentStatus represents the lifecycle status of a tax document */
export enum TaxDocumentStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export enum TaxDocumentType {
  FORM_1099_DA = 'FORM_1099_DA',
  FORM_1099_MISC = 'FORM_1099_MISC'
}

export type TaxDocumentTypeInfo = {
  __typename: 'TaxDocumentTypeInfo';
  expectedIssueDate: Maybe<Scalars['Date']['output']>;
  type: Maybe<TaxDocumentType>;
};

/**
 * TaxDocumentWhereInput is used for filtering TaxDocument objects.
 * Input was generated by ent.
 */
export type TaxDocumentWhereInput = {
  /** account_id field predicates */
  accountID?: InputMaybe<Scalars['String']['input']>;
  accountIDContains?: InputMaybe<Scalars['String']['input']>;
  accountIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  accountIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  accountIDGT?: InputMaybe<Scalars['String']['input']>;
  accountIDGTE?: InputMaybe<Scalars['String']['input']>;
  accountIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  accountIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  accountIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  accountIDLT?: InputMaybe<Scalars['String']['input']>;
  accountIDLTE?: InputMaybe<Scalars['String']['input']>;
  accountIDNEQ?: InputMaybe<Scalars['String']['input']>;
  accountIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  and?: InputMaybe<Array<TaxDocumentWhereInput>>;
  /** document_type field predicates */
  documentType?: InputMaybe<TaxDocumentType>;
  documentTypeIn?: InputMaybe<Array<TaxDocumentType>>;
  documentTypeNEQ?: InputMaybe<TaxDocumentType>;
  documentTypeNotIn?: InputMaybe<Array<TaxDocumentType>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idContainsFold?: InputMaybe<Scalars['ID']['input']>;
  idEqualFold?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** issued_date field predicates */
  issuedDate?: InputMaybe<Scalars['Time']['input']>;
  issuedDateGT?: InputMaybe<Scalars['Time']['input']>;
  issuedDateGTE?: InputMaybe<Scalars['Time']['input']>;
  issuedDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  issuedDateLT?: InputMaybe<Scalars['Time']['input']>;
  issuedDateLTE?: InputMaybe<Scalars['Time']['input']>;
  issuedDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  issuedDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  not?: InputMaybe<TaxDocumentWhereInput>;
  or?: InputMaybe<Array<TaxDocumentWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<TaxDocumentStatus>;
  statusIn?: InputMaybe<Array<TaxDocumentStatus>>;
  statusNEQ?: InputMaybe<TaxDocumentStatus>;
  statusNotIn?: InputMaybe<Array<TaxDocumentStatus>>;
  /** tax_year field predicates */
  taxYear?: InputMaybe<Scalars['Int']['input']>;
  taxYearGT?: InputMaybe<Scalars['Int']['input']>;
  taxYearGTE?: InputMaybe<Scalars['Int']['input']>;
  taxYearIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  taxYearLT?: InputMaybe<Scalars['Int']['input']>;
  taxYearLTE?: InputMaybe<Scalars['Int']['input']>;
  taxYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  taxYearNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TaxDocumentYearInfo = {
  __typename: 'TaxDocumentYearInfo';
  year: Scalars['Int']['output'];
};

/** TaxDocumentationStatus is whether TaxBit considers a W-form valid. */
export enum TaxDocumentationStatus {
  INVALID = 'INVALID',
  VALID = 'VALID'
}

/** How operations of one Anchorage type and subtype are reported to TaxBit */
export type TaxMapping = Node & {
  __typename: 'TaxMapping';
  anchorageSubtype: Maybe<Scalars['String']['output']>;
  anchorageType: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  /** Email of the staff user who created the mapping */
  createdBy: Scalars['String']['output'];
  /** When the mapping became inactive */
  deactivatedAt: Maybe<Scalars['Time']['output']>;
  /** Email of the staff user who made the mapping inactive, by an update or a removal */
  deactivatedBy: Maybe<Scalars['String']['output']>;
  /** Reason given when the mapping was removed. Always null on a mapping replaced by an update */
  deactivationRationale: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rationale: Maybe<Scalars['String']['output']>;
  /** Mapping this one replaced, when it was created by an update */
  replacesId: Maybe<Scalars['ID']['output']>;
  /** Whether operations of this type are sent to TaxBit */
  reportable: Scalars['Boolean']['output'];
  /** System the Anchorage operation comes from: OPS_DB or CBS */
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taxbitSubtype: Maybe<Scalars['String']['output']>;
  taxbitType: Maybe<Scalars['String']['output']>;
};

/** Connection type for paginated tax mappings */
export type TaxMappingConnection = {
  __typename: 'TaxMappingConnection';
  /** List of tax mapping edges */
  edges: Array<TaxMappingEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Edge type for tax mapping connection */
export type TaxMappingEdge = {
  __typename: 'TaxMappingEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The tax mapping node */
  node: TaxMapping;
};

/**
 * Ordering options for the taxMappings query. Ties are broken by anchorage
 * type, anchorage subtype (null first), source and id, ascending.
 */
export type TaxMappingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TaxMappings. */
  field: TaxMappingOrderField;
};

/** Properties by which TaxMapping connections can be ordered. */
export enum TaxMappingOrderField {
  ANCHORAGE_TYPE = 'ANCHORAGE_TYPE',
  CREATED_AT = 'CREATED_AT',
  REPORTABLE = 'REPORTABLE'
}

export type TaxMappingPayload = {
  __typename: 'TaxMappingPayload';
  mapping: TaxMapping;
};

/** Filtering options for the taxMappings query */
export type TaxMappingsFilter = {
  /**
   * Only mappings for this Anchorage operation type (exact match). Leading and
   * trailing spaces are removed, and an empty value returns a 400 error
   */
  anchorageType?: InputMaybe<Scalars['String']['input']>;
  /** Only reportable mappings when true, only non-reportable ones when false */
  reportable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Only mappings from this source: OPS_DB or CBS. Any other value returns a 400
   * error
   */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Tax Provider Transaction represents a transaction submitted to the tax provider (TaxBit) */
export type TaxProviderTransaction = {
  __typename: 'TaxProviderTransaction';
  /**
   * Top-level affiliate associated with this transaction. Resolved via federation
   * from the cliententities service. Only populated for B2B transactions.
   */
  affiliateV2: Maybe<AffiliateV2>;
  /**
   * USD value of the transaction (only populated for deposits and withdrawals)
   * Calculated as the sum of (quantity × price) for all lots
   */
  amountUSD: Maybe<Scalars['String']['output']>;
  /** Anchorage tag for categorization */
  anchorageTag: Maybe<Scalars['String']['output']>;
  /** When this transaction was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Who created this transaction */
  createdBy: Scalars['String']['output'];
  /** External identifier for this transaction (e.g., from custody system) */
  externalID: Scalars['String']['output'];
  /** Whether the transaction has cost basis data */
  hasCostBasis: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for this tax provider transaction record */
  id: Scalars['ID']['output'];
  /** Additional metadata as JSON string (for any other fields not explicitly modeled) */
  metadata: Maybe<Scalars['String']['output']>;
  /** Organization name for the organizationKeyID */
  orgName: Maybe<Scalars['String']['output']>;
  /** Organization that owns this transaction */
  organizationKeyID: Scalars['String']['output'];
  /** Program Customer - the name of the Affiliate associated with the transaction */
  programCustomer: Maybe<Scalars['String']['output']>;
  /**
   * The primary received asset for this transaction.
   * When multiple received assets are present only the first is returned.
   */
  receivedAsset: Maybe<TaxTransactionAsset>;
  /** Whether the transaction requires cost basis data */
  requiresCostBasis: Maybe<Scalars['Boolean']['output']>;
  /** Revision number for this transaction */
  revision: Scalars['Int']['output'];
  /** Subaccount ID associated with this transaction */
  subaccountID: Scalars['String']['output'];
  /** Tax year for this transaction */
  taxYear: Maybe<Scalars['String']['output']>;
  /** TaxBit's internal ID for this transaction */
  taxbitID: Scalars['ID']['output'];
  /** TaxBit subtype classification */
  taxbitSubtype: Maybe<Scalars['String']['output']>;
  /** TaxBit type classification */
  taxbitType: Maybe<Scalars['String']['output']>;
  /** Type of tenant (RIA or B2B) */
  tenantType: TaxTenantType;
  /** The date of the transaction */
  transactionDate: Maybe<Scalars['Timestamp']['output']>;
  /** Transaction ID used to track versions */
  transactionID: Scalars['ID']['output'];
  /** Type of transaction (deposit, withdraw, trade, etc.) */
  transactionType: Scalars['String']['output'];
};

/** Connection type for paginated tax provider transactions */
export type TaxProviderTransactionConnection = {
  __typename: 'TaxProviderTransactionConnection';
  /** List of transaction edges */
  edges: Array<TaxProviderTransactionEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total count of transactions matching the filter */
  totalCount: Scalars['Int']['output'];
};

/** Edge type for tax provider transaction connection */
export type TaxProviderTransactionEdge = {
  __typename: 'TaxProviderTransactionEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The transaction node */
  node: TaxProviderTransaction;
};

/** Ordering options for the taxProviderTransactions query */
export type TaxProviderTransactionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TaxProviderTransactions. */
  field: TaxProviderTransactionOrderField;
};

/** Properties by which TaxProviderTransaction connections can be ordered. */
export enum TaxProviderTransactionOrderField {
  EXTERNAL_ID = 'EXTERNAL_ID',
  TRANSACTION_DATE = 'TRANSACTION_DATE'
}

/** Filter input for tax provider transactions query */
export type TaxProviderTransactionsFilter = {
  /** Filter by affiliate ID */
  affiliateID?: InputMaybe<Scalars['String']['input']>;
  /** Pagination: cursor for next page */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by anchorage tags
   * Pass multiple values to OR them together (e.g., ["rollover", "late_rollover"])
   * Pass null as one of the values to include transactions without a tag
   */
  anchorageTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** End date for filtering transactions */
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Filter by external ID prefix (case-sensitive prefix match) */
  externalIDStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Filter by external transaction IDs */
  externalTransactionIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by whether the transaction has cost basis */
  hasCostBasis?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pagination: number of records to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter by operation types (deposit, withdrawal, trade)
   * Pass multiple values to OR them together (e.g., [DEPOSIT, WITHDRAWAL])
   */
  operationType?: InputMaybe<Array<TaxTransactionOperationType>>;
  /** Filter by organization key ID */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the received asset type. Only set on deposits and trades. */
  receivedAssetTypeID?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether the transaction requires cost basis */
  requiresCostBasis?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the sent asset type. Only set on withdrawals and trades. */
  sentAssetTypeID?: InputMaybe<Scalars['String']['input']>;
  /** Start date for filtering transactions */
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Filter by subaccount ID */
  subaccountID?: InputMaybe<Scalars['String']['input']>;
  /** Filter by multiple subaccount IDs */
  subaccountIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by tax year */
  taxYear?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Taxbit IDs */
  taxbitIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by tenant type (RIA or B2B) */
  tenantType?: InputMaybe<TaxTenantType>;
  /** Filter by specific transaction IDs */
  transactionIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TaxReconcileTradesInput = {
  /** Customer type (RIA or B2B) */
  customerType: CustomerType;
  /** Optional filter: specific account IDs to reconcile */
  filterAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional filter: end time for trade reconciliation */
  filterEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional filter: specific order IDs to reconcile */
  filterOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional filter: start time for trade reconciliation */
  filterStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional filter: specific trade IDs to reconcile */
  filterTradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional organization ID to reconcile trades for. If not provided, reconciles for all organizations. */
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};

export type TaxReconcileTradesResult = {
  __typename: 'TaxReconcileTradesResult';
  /** Number of batches that failed during processing */
  failedBatches: Scalars['Int']['output'];
  /** Human-readable message about the reconciliation result */
  message: Scalars['String']['output'];
  /** Number of trades missing from TaxBit */
  missingTrades: Scalars['Int']['output'];
  /** Number of trades successfully processed and sent to TaxBit */
  processedTrades: Scalars['Int']['output'];
  /** Total number of pages processed */
  totalPages: Scalars['Int']['output'];
  /** Total number of trades checked */
  totalTrades: Scalars['Int']['output'];
};

/** A tax tenant */
export type TaxTenant = {
  __typename: 'TaxTenant';
  /** Taxbit's client identifier */
  clientID: Scalars['ID']['output'];
  /** Taxbit's client secret */
  clientSecret: Scalars['String']['output'];
  /** Time when the tenant was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Who created the tenant */
  createdBy: Scalars['String']['output'];
  /** Unique tenant identifier */
  id: Scalars['ID']['output'];
  /** Organization of which the tenant is a member. */
  organization: Organization;
  /** Time when the tenant was last updated */
  updatedAt: Scalars['Timestamp']['output'];
  /** Who last updated the tenant */
  updatedBy: Scalars['String']['output'];
};

/** Tenant type for tax reporting */
export enum TaxTenantType {
  /** Business to Business */
  B2B = 'B2B',
  /** Registered Investment Advisor */
  RIA = 'RIA'
}

/** TaxTinStatus is the result of TaxBit's TIN validation. */
export enum TaxTinStatus {
  ERROR = 'ERROR',
  INVALID_DATA = 'INVALID_DATA',
  MISMATCH = 'MISMATCH',
  PENDING = 'PENDING',
  TIN_NOT_ISSUED = 'TIN_NOT_ISSUED',
  VALID_EIN_MATCH = 'VALID_EIN_MATCH',
  VALID_SSN_EIN_MATCH = 'VALID_SSN_EIN_MATCH',
  VALID_SSN_MATCH = 'VALID_SSN_MATCH'
}

/**
 * Asset received in a tax transaction, aggregated by asset type.
 * Each asset type appears once; lots break down the individual cost basis entries.
 */
export type TaxTransactionAsset = {
  __typename: 'TaxTransactionAsset';
  /** Asset type identifier (e.g., BTC, ETH) */
  assetTypeID: Scalars['String']['output'];
  /** Further information regarding this asset type, resolved via federation from graphqlmonolith. */
  assetTypeInfo: Maybe<AssetTypeInfo>;
  /** Individual lots with quantity and acquisition date */
  lots: Array<TaxTransactionLot>;
  /** Total quantity across all lots for this asset */
  totalQuantity: Scalars['String']['output'];
};

/** Individual lot within a received asset (e.g., a single cost basis entry) */
export type TaxTransactionLot = {
  __typename: 'TaxTransactionLot';
  /** When this lot was originally acquired (null if unknown) */
  acquisitionDate: Maybe<Scalars['Timestamp']['output']>;
  /** USD price per unit for this lot (null if unknown) */
  price: Maybe<Scalars['String']['output']>;
  /** Quantity of the asset in this lot */
  quantity: Scalars['String']['output'];
};

/** Transaction operation type for filtering */
export enum TaxTransactionOperationType {
  /** Deposit transaction */
  DEPOSIT = 'DEPOSIT',
  /** Trade transaction */
  TRADE = 'TRADE',
  /** Withdrawal transaction */
  WITHDRAWAL = 'WITHDRAWAL'
}

/**
 * Tax transaction tags for RIA (Registered Investment Advisor) organizations.
 * These tags affect how transactions are reported for tax purposes.
 */
export enum TaxTransactionTag {
  CONTRIBUTION = 'CONTRIBUTION',
  CONVERSION = 'CONVERSION',
  DISTRIBUTION = 'DISTRIBUTION',
  LATE_ROLLOVER = 'LATE_ROLLOVER',
  POSTPONED = 'POSTPONED',
  RECHARACTERIZATION = 'RECHARACTERIZATION',
  ROLLOVER = 'ROLLOVER',
  TRANSFER_IN = 'TRANSFER_IN',
  TRANSFER_OUT = 'TRANSFER_OUT'
}

/** W-form types collected by the tax provider */
export enum TaxWFormType {
  W_8BEN = 'W_8BEN',
  W_8BEN_E = 'W_8BEN_E',
  W_8IMY = 'W_8IMY',
  W_9 = 'W_9'
}

export type TaxbitAccountOwnerTokenInput = {
  /** The top-level affiliate/account ID to scope the token to */
  accountId: Scalars['String']['input'];
};

export type TaxbitAccountOwnerTokenPayload = {
  __typename: 'TaxbitAccountOwnerTokenPayload';
  /** The TaxBit account-owner-scoped bearer token */
  token: Scalars['String']['output'];
};

/** A B2B transaction the TaxBit sync stopped sending after a permanent failure */
export type TaxbitSendFailure = {
  __typename: 'TaxbitSendFailure';
  attemptCount: Scalars['Int']['output'];
  /** TAXBIT_REJECTED or INVALID_ROW */
  errorClass: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  firstFailedAt: Scalars['Time']['output'];
  /** HTTP status TaxBit returned, when TaxBit rejected the transaction */
  httpStatus: Maybe<Scalars['Int']['output']>;
  lastError: Scalars['String']['output'];
  lastFailedAt: Scalars['Time']['output'];
};

/** A TaxBit transaction type, with the subtypes TaxBit allows for it */
export type TaxbitTransactionTypeInfo = {
  __typename: 'TaxbitTransactionTypeInfo';
  /** Subtypes allowed for this type. An empty subtype is always accepted and is not listed */
  subtypes: Array<Scalars['String']['output']>;
  /** TaxBit transaction type, as sent to TaxBit */
  type: Scalars['String']['output'];
};

/** Extra parameters for tendermint */
export type TendermintExtraParams = {
  __typename: 'TendermintExtraParams';
  /** memo to use in transaction */
  memo: Maybe<Scalars['String']['output']>;
  /** redelegateSrc is used when redelegating with the value of the source validator */
  redelegateSrc: Maybe<Scalars['String']['output']>;
};

export type TerminateControlAgreementInput = {
  controlAgreementID: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
};

export type TerminateControlAgreementResponse = {
  __typename: 'TerminateControlAgreementResponse';
  idempotencyKey: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TerminateServiceFeeTermsInput = {
  /** Agreement id associated to the terms to be terminated */
  agreementId: Scalars['ID']['input'];
  /** Date at which the service fee terms should be terminated */
  terminationDate: Scalars['Date']['input'];
};

/** TerminateWalletConnectSessionResponse */
export type TerminateWalletConnectSessionResponse = {
  __typename: 'TerminateWalletConnectSessionResponse';
  /** Was request successful */
  success: Scalars['Boolean']['output'];
};

/** KYC mode for test organization creation. */
export enum TestOrgKYCMode {
  /**
   * Minimal KYC mode - creates basic institutional client record
   * without DocuSign/forms. Allows KYC-dependent features to work.
   */
  MINIMAL = 'MINIMAL',
  /**
   * Self-custody mode - no KYC client/affiliate creation at all.
   * Equivalent to Porto/SANDBOX operators. Simplest and most reliable.
   */
  SELF_CUSTODY = 'SELF_CUSTODY'
}

/** Result of test organization creation. */
export type TestOrganizationResult = {
  __typename: 'TestOrganizationResult';
  /** Client ID if KYC mode was MINIMAL. */
  clientID: Maybe<Scalars['String']['output']>;
  /** Whether the org was newly created (false if existing org was found). */
  created: Scalars['Boolean']['output'];
  /** Enrollment tokens for each user (to complete enrollment if needed). */
  enrollmentTokens: Array<Scalars['String']['output']>;
  /** The organization key ID. */
  organizationKeyID: Scalars['String']['output'];
  /** User names in the organization. */
  userNames: Array<Scalars['String']['output']>;
  /** Vault names in the organization. */
  vaultNames: Array<Scalars['String']['output']>;
};

export enum TicketActionType {
  /** The type of the action */
  COMMUNICATION = 'COMMUNICATION',
  /** The type of the action */
  OPERATION = 'OPERATION',
  /** The type of the action */
  STATE_CHANGE = 'STATE_CHANGE',
  /** The type of the action */
  TRADE_EXECUTION = 'TRADE_EXECUTION'
}

export enum TicketCommunicationType {
  /** The type of the communication */
  EMAIL = 'EMAIL',
  /** The type of the communication */
  SLACK = 'SLACK'
}

export enum TicketStatus {
  /** The status of the collateral ticket */
  CLOSED = 'CLOSED',
  /** The status of the collateral ticket */
  OPEN = 'OPEN'
}

/** TimeInForce represents */
export enum TimeInForce {
  /** TimeInForceDay represents */
  DAY = 'DAY',
  /** TimeInForceFillAndKill represents */
  FILL_AND_KILL = 'FILL_AND_KILL',
  /** TimeInForceFillOrKill represents */
  FILL_OR_KILL = 'FILL_OR_KILL',
  /** TimeInForceGoodTillCancel represents */
  GOOD_TILL_CANCEL = 'GOOD_TILL_CANCEL',
  /** Invalid represents */
  INVALID = 'INVALID'
}

/** Time comparison operations. */
export type TimeOps = {
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * TimeRangeInput represents a time range filter for queries.
 * Used for filtering by date ranges like createdAt or coverageTimeEnd.
 */
export type TimeRangeInput = {
  /** End of the time range (inclusive). RFC3339 format. */
  end?: InputMaybe<Scalars['Time']['input']>;
  /** Start of the time range (inclusive). RFC3339 format. */
  start?: InputMaybe<Scalars['Time']['input']>;
};

/** TimestampFilterInput contains information about a timestamp value filter */
export type TimestampFilterInput = {
  /** Matches value greater than or equal */
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Matches value less than */
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type TimingRuleHistoryFilter = {
  csaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  events?: InputMaybe<Array<DVTimingEvent>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  tiers?: InputMaybe<Array<DVTimingTier>>;
};

/** TokenAmount captures the amount of a token to swap. */
export type TokenAmount = {
  __typename: 'TokenAmount';
  /** Amount is the amount of a token to be swapped. */
  amount: Maybe<Amount>;
  /** Amount is the amount of a token to be swapped, but in it's base units. */
  amountInBaseUnits: Scalars['String']['output'];
  /** Token is the token contract address of a token to be swapped. */
  tokenAddress: Scalars['String']['output'];
};

/**
 * TokenApprovalResult contains the transaction data for token approval and cancellation
 * operations.
 */
export type TokenApprovalResult = {
  __typename: 'TokenApprovalResult';
  /** ApprovalData is transaction data for performing on on-chain approval transaction. */
  approvalData: TransactionData;
  /** CancelData is transaction data for performing on on-chain cancel transaction. */
  cancelData: TransactionData;
};

/** Holder for info for token like assets */
export type TokenInfo = {
  /** The asset type id for this token */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** The unique id for this token */
  tokenID: Scalars['String']['output'];
};

/** TokenMetadata describes the scanned token in more details. */
export type TokenMetadata = {
  __typename: 'TokenMetadata';
  /** DecimalPlaces is the max-allowed number of decimal places in values of the token. */
  decimalPlaces: Scalars['String']['output'];
  /** Description is a high-level description of the token. */
  description: Scalars['String']['output'];
  /** ImageURL is the link to the image associated with the token. */
  imageUrl: Scalars['String']['output'];
  /** Name is the name of the token. */
  name: Scalars['String']['output'];
  /** Symbol is the symbol of the token. */
  symbol: Scalars['String']['output'];
};

/** TokenQuoteType determines which side of the token swap (buy vs sell) the quote should be generated for. */
export enum TokenQuoteType {
  /** FIXED_BUY requests a quote where the buy amount is fixed by the user, but the quote is for a variable sell amount. */
  FIXED_BUY = 'FIXED_BUY',
  /** FIXED_SELL requests a quote where the sell amount is fixed by the user, but the quote is for a variable buy amount. */
  FIXED_SELL = 'FIXED_SELL',
  /** UNSPECIFIED is used where no other valid token quote type is available. */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** TokenRisk is a response from Blockaid after scanning a token. */
export type TokenRisk = {
  __typename: 'TokenRisk';
  /** Address is the address of the smart contract that represents the token that was scanned. */
  address: Scalars['String']['output'];
  /** Chain is the name of the blockchain the token that was scanned belongs to (e.g. "ethereum" or "arbitrum"). */
  chain: Scalars['String']['output'];
  /** Details is the list of details describing why the scanned token received its risk level. */
  details: Array<RiskLevelDetail>;
  /**
   * MaliciousScore is the score of how malicious the token is.
   * Values range between 0 and 1.
   */
  maliciousScore: Scalars['Float']['output'];
  /**
   * Metadata is the data that describes the token in additional detail.
   * The contents of this field vary by blockchain, so review the [Scan Token]
   * API docs for additional details.
   * [Scan Token]: https://docs.blockaid.io/reference/scan-token
   */
  metadata: TokenMetadata;
  /** RiskLevel is the general indication about the token's maliciousness. */
  riskLevel: SmartContractRiskLevel;
};

/** TokenRiskInput encapsulates the parameters required to scan a token on a given network. */
export type TokenRiskInput = {
  /** Address is the address of the smart contract that represents the token to be scanned. */
  address: Scalars['String']['input'];
  /** Chain is the name of the blockchain the token to be scanned belongs to (e.g. "ethereum" or "arbitrum"). */
  chain: Scalars['String']['input'];
};

/** TokenRiskLevelDetailType is the type of feature identifies an individual risk level detail. */
export enum TokenRiskLevelDetailType {
  /** BENIGN means the risk level details indicate it is benign. */
  BENIGN = 'BENIGN',
  /** INFO means the risk level details indicate informational data. */
  INFO = 'INFO',
  /** MALICIOUS means the risk level details indicate malicious. */
  MALICIOUS = 'MALICIOUS',
  /** UNDETERMINED means the risk level detail has not been determined at this time due to lack of data. */
  UNDETERMINED = 'UNDETERMINED',
  /** WARNING means the risk level details indicate a warning. */
  WARNING = 'WARNING'
}

/** TokenSellApprovalValue specifies the token amount that should be approved for spending in the user's wallet. */
export enum TokenSellApprovalValue {
  /**
   * FIXED_TOKEN_VALUE requests a fixed amount, specified by the user, of a
   * token to be made available for spending for the token swap.
   */
  FIXED_TOKEN_VALUE = 'FIXED_TOKEN_VALUE',
  /**
   * MAX_TOKEN_VALUE requests the maximum amount of a token to be made
   * available for spending for the token swap.
   */
  MAX_TOKEN_VALUE = 'MAX_TOKEN_VALUE',
  /** UNSPECIFIED is used where no other token sell approval level is available. */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** Represents an individual token swap. */
export type TokenSwap = Node & {
  __typename: 'TokenSwap';
  /** The amount of a token that was bought in this token swap. */
  buyAmount: Amount;
  /** The details of the wallet used to buy assets (if available). */
  buyWallet: Maybe<Wallet>;
  /** The time when this token swap was first created. */
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  /** Indicates whether this token swap includes data for a approve operation. */
  hasApproveData: Scalars['Boolean']['output'];
  /** Indicates whether this token swap includes data for a cancel operation. */
  hasCancelData: Scalars['Boolean']['output'];
  /** Indicates whether this token swap includes data for a permit operation. */
  hasPermitData: Scalars['Boolean']['output'];
  /** Indicates whether this token swap includes data for a quote operation. */
  hasQuoteData: Scalars['Boolean']['output'];
  /** The unique identifier of this token swap. */
  id: Scalars['ID']['output'];
  /** The network on which this token swap occurred. */
  networkInfo: NetworkInfo;
  /** The list of operations associated with this token swap. */
  operations: Maybe<Array<Operation>>;
  /** If the swap has terminated without success, this field may contain descriptive reason. */
  reasonForTermination: Maybe<Scalars['String']['output']>;
  /** The amount of a token that was sold in this token swap. */
  sellAmount: Amount;
  /** The details of the wallet used to sell assets (if available). */
  sellWallet: Maybe<Wallet>;
  /** The current status of this token swap. */
  status: TokenSwapStatus;
  /** The ordered list of steps this token swap goes through, with a title for each. */
  stepData: Maybe<Array<TokenSwapStepData>>;
  /** The time when this token swap was last updated. */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** A connection to a list of items. */
export type TokenSwapConnection = {
  __typename: 'TokenSwapConnection';
  /** A list of edges. */
  edges: Maybe<Array<TokenSwapEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/**
 * TokenSwapDEXInput contains the name of a Decentralized Exchange (DEX) and the inputs for
 * swapping on each.
 */
export type TokenSwapDEXInput = {
  /** Exchange the Decentralized Exchange (DEX) whose input to use for performing the token swap. */
  exchange: DecentralizedExchange;
  /** JupiterExchange  contains the required fields for performing a token swap using Jupiter. */
  jupiterExchange?: InputMaybe<JupiterDEXInput>;
  /** UniswapExchange contains the required fields for performing a token swap using Uniswap. */
  uniswapExchange?: InputMaybe<UniswapDEXInput>;
};

/**
 * TokenSwapDataInput encapsulates the data required to construct the buy and sell sides of a token
 * swap.
 */
export type TokenSwapDataInput = {
  /** Amount is the amount of the input token (in it's base units) to be sent in the swap. */
  amount: Scalars['String']['input'];
  /** AssetTypeID is the asset type ID representing the token to be swapped. */
  assetTypeID: Scalars['String']['input'];
  /** WalletID is the ID of the wallet the asset type to be swapped belongs to. */
  walletID: Scalars['String']['input'];
};

/** An edge in a connection. */
export type TokenSwapEdge = {
  __typename: 'TokenSwapEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TokenSwap>;
};

/**
 * TokenSwapQuoteDataInput is the input data of the Decentralized Exchange (DEX) that should be used to retrieve
 * the quote data from.
 */
export type TokenSwapQuoteDataInput = {
  /** Exchange the Decentralized Exchange (DEX) to be used to retrieve quotes or perform a token swap. */
  exchange: DecentralizedExchange;
  /** JupiterQuoteInput is the data required to interact with the quote endpoint for the Jupiter DEX. */
  jupiterQuoteInput?: InputMaybe<JupiterQuoteInput>;
  /** UniswapQuoteInput is the data required to interact with the quote endpoint for the Uniswap DEX. */
  uniswapQuoteInput?: InputMaybe<UniswapQuoteInput>;
};

/** TokenSwapStatus is the status of a token swap operation. */
export enum TokenSwapStatus {
  /** "Spending approval" operation completed successfully. */
  APPROVE_COMPLETED = 'APPROVE_COMPLETED',
  /** "Spending approval" operation is in progress. */
  APPROVE_PENDING = 'APPROVE_PENDING',
  /**
   * CANCELED is the status of token swaps that have been canceled.
   * Cancellations can happen for any number of reasons. This is a terminal state.
   */
  CANCELED = 'CANCELED',
  /** "Cancel prior spending approval" operation completed successfully. */
  CANCEL_COMPLETED = 'CANCEL_COMPLETED',
  /** "Cancel prior spending approval" operation is in progress. */
  CANCEL_PENDING = 'CANCEL_PENDING',
  /**
   * COMPLETED is the status of token swaps that have been successfully completed.
   * This is an terminal state.
   */
  COMPLETED = 'COMPLETED',
  /**
   * EXPIRED is the status of token swaps that have expired.
   * Swap's, and each of its underlying operation's execution are both time-boxed.
   */
  EXPIRED = 'EXPIRED',
  /**
   * FAILED is the status of token swaps that have failed.
   * Failure can happen for any number of reasons. This is a terminal state.
   */
  FAILED = 'FAILED',
  /**
   * PENDING is the status token swaps that are pending a terminal state.
   * Pending token swaps have already been prepared and are now in the process of being
   * fulfilled (e.g. by Uniswap). This is an intermediate state.
   */
  PENDING = 'PENDING',
  /** "Permit2" operation completed successfully. */
  PERMIT_COMPLETED = 'PERMIT_COMPLETED',
  /** "Permit2" operation is in progress. */
  PERMIT_PENDING = 'PERMIT_PENDING',
  /**
   * PREPARED is the status of a new token swap.
   * This is the initial state of a token swap.
   */
  PREPARED = 'PREPARED',
  /**
   * REJECTED is the status of token swaps that have been rejected.
   * Swap and each of its underlying operation can be rejected by initiator or quorum user.
   */
  REJECTED = 'REJECTED',
  /**
   * SIGNING is the status of a token swap where the associated permit2 data needs
   * to be signed. This is an intermediate state.
   */
  SIGNING = 'SIGNING',
  /** Swap operation completed successfully. */
  SWAP_COMPLETED = 'SWAP_COMPLETED',
  /** Swap operation is in progress. */
  SWAP_PENDING = 'SWAP_PENDING'
}

/** An individual step in the lifecycle of a token swap. */
export type TokenSwapStepData = {
  __typename: 'TokenSwapStepData';
  /** The ID of the operation associated with this step, if that operation has been created yet. */
  operationID: Maybe<Scalars['ID']['output']>;
  /** The title of this step. */
  title: Scalars['String']['output'];
};

/**
 * TokenType a token type supported by our platform
 * Examples include ERC20, ERC721, etc.
 */
export type TokenType = {
  __typename: 'TokenType';
  /**
   * Regex to validate the on-chain identifier (contract address / coin type) for this token type.
   * Used to validate user input when adding a new asset in the Asset Xpress UI.
   */
  contractAddressValidationRegex: Scalars['String']['output'];
  /**
   * The name of the token type
   * Examples include ERC20, ERC721, ERC-1155, etc.
   */
  name: Scalars['String']['output'];
};

/** The action to perform on a tokenized asset. */
export enum TokenizationAction {
  BURN = 'BURN',
  MINT = 'MINT'
}

/** The result of getTokenizationAssetSupplyHistory. */
export type TokenizationAssetSupplyHistoryPayload = {
  __typename: 'TokenizationAssetSupplyHistoryPayload';
  /**
   * Total-supply time series, oldest first: one point per day, carrying that day's closing total
   * supply (for the current day, the value as of the latest operation so far). Days with no
   * successful operations are omitted.
   */
  points: Array<TokenizationSupplyPoint>;
};

/** The result of getTokenizationAssetTotalSupply. */
export type TokenizationAssetTotalSupplyPayload = {
  __typename: 'TokenizationAssetTotalSupplyPayload';
  /** Total supply of the asset: net minted (total mints minus total burns) across successful operations. */
  totalSupply: Scalars['String']['output'];
};

/** The custody operation ID for a single tokenization operation, once it exists. */
export type TokenizationCustodyOperationIDPayload = {
  __typename: 'TokenizationCustodyOperationIDPayload';
  /**
   * The custody operation to endorse. Null until the underlying on-chain execute operation has
   * been created by the tokenization workflow.
   */
  custodyOperationID: Maybe<Scalars['OperationID']['output']>;
  /** Current status of the tokenization workflow (not the custody operation's endorsement state). */
  tokenizationStatus: TokenizationStatus;
};

/** One page of an organization's tokenization operations, newest first. */
export type TokenizationHistory = {
  __typename: 'TokenizationHistory';
  hasNextPage: Scalars['Boolean']['output'];
  operations: Array<TokenizationOperation>;
};

/** A single mint or burn record in an organization's tokenization history. */
export type TokenizationOperation = {
  __typename: 'TokenizationOperation';
  /** Whether the operation minted or burned. */
  action: TokenizationAction;
  /** Positive decimal string, e.g. "100" or "0.01". */
  amount: Scalars['String']['output'];
  /** The tokenized asset that was minted or burned. */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /**
   * Optional free-text note from the initiator, up to 1000 characters. Null when
   * none was provided.
   */
  comment: Maybe<Scalars['String']['output']>;
  /** RFC3339 timestamp of when the operation was created. */
  createdAt: Scalars['String']['output'];
  /** Current status of the operation. */
  status: TokenizationStatus;
  /** The custody vault the wallet belongs to. */
  vaultID: Scalars['ID']['output'];
  /** The wallet the tokens were minted to or burned from. */
  walletID: Scalars['ID']['output'];
};

/** The status of a tokenization operation. */
export enum TokenizationStatus {
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

/** One point of an asset's total-supply history. */
export type TokenizationSupplyPoint = {
  __typename: 'TokenizationSupplyPoint';
  /**
   * RFC3339 timestamp of the last successful operation on this point's day, i.e. the finalization time
   * (transition to SUCCESS) of the operation whose total supply this point carries.
   */
  timestamp: Scalars['String']['output'];
  /** Total supply (net minted) as of this timestamp. */
  totalSupply: Scalars['String']['output'];
};

/** Input for a tokenization mint or burn operation. */
export type TokenizeInput = {
  /** Whether to mint or burn. */
  action: TokenizationAction;
  /** Positive decimal string, e.g. "100" or "0.01". */
  amount: Scalars['String']['input'];
  /** The tokenized asset to mint or burn. Its config determines the product and workflow. */
  assetTypeID: Scalars['AssetTypeID']['input'];
  /** Optional free-text note from the initiator, up to 1000 characters. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /**
   * Client-supplied, non-empty key that makes repeated submissions idempotent: a
   * retry with the same key returns the existing operation instead of creating a
   * new one. Required.
   */
  idempotencyKey: Scalars['String']['input'];
  /** The wallet that mints receive, or that burns are debited from. */
  walletID: Scalars['ID']['input'];
};

/** The result of a tokenization mint or burn operation. */
export type TokenizePayload = {
  __typename: 'TokenizePayload';
  /** Identifier of the created tokenization operation. */
  operationID: Scalars['OperationID']['output'];
  /** Current status of the operation. */
  status: TokenizationStatus;
};

/** Trade contains information about a trade */
export type Trade = {
  __typename: 'Trade';
  account: Maybe<TradingAccount>;
  accountID: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use `buyTradingAmount`. */
  buyAmount: Amount;
  buyTradingAmount: TradingAmount;
  currency: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `feeTradingAmount` */
  feeAmount: Maybe<Amount>;
  feeBps: Maybe<Scalars['String']['output']>;
  feeTradingAmount: Maybe<TradingAmount>;
  grossBuyAmount: Maybe<Scalars['String']['output']>;
  grossOrderPrice: Maybe<Scalars['String']['output']>;
  grossSellAmount: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Initiator of the trade. */
  initiator: Initiator;
  /** Initiator of the trade. Use this in place of `initiator` for new code. */
  initiatorV2: Actor;
  internalInfo: Maybe<TradeInternalInfo>;
  market: Scalars['String']['output'];
  marketOrderID: Maybe<Scalars['ID']['output']>;
  orderID: Maybe<Scalars['ID']['output']>;
  orderType: OrdType;
  organization: Organization;
  parentTradeID: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use `sellTradingAmount`. */
  sellAmount: Amount;
  sellTradingAmount: TradingAmount;
  settlementID: Maybe<Scalars['ID']['output']>;
  side: TradeSide;
  sourceType: TradeSource;
  states: Array<TradeState>;
  status: TradeStatus;
  timestamp: Scalars['Timestamp']['output'];
  /** ID of this trade */
  tradeID: Scalars['ID']['output'];
  tradedPrice: Scalars['String']['output'];
  /** @deprecated Use `tradedPrice` */
  tradedPriceAmount: Amount;
  tradingPair: Scalars['String']['output'];
  transactTime: Maybe<Scalars['Timestamp']['output']>;
  unitPrice: Scalars['String']['output'];
  /** @deprecated Use `unitPrice` */
  unitPriceAmount: Amount;
  userID: Scalars['PublicKeyID']['output'];
  userType: Scalars['UserKeyIDType']['output'];
  vault: Maybe<Vault>;
  /** @deprecated Use `vault`. */
  vaultID: Maybe<Scalars['ID']['output']>;
};

/** Possible trade capacities */
export enum TradeCapacity {
  AGENT_FOR_CUSTOMER = 'AGENT_FOR_CUSTOMER',
  AGENT_FOR_CUSTOMER_AND_3RD_PARTY = 'AGENT_FOR_CUSTOMER_AND_3RD_PARTY',
  OTHER = 'OTHER',
  PRINCIPAL = 'PRINCIPAL'
}

/** Trade execution report */
export type TradeExecutionReport = {
  __typename: 'TradeExecutionReport';
  /** aggressorSide represents */
  aggressorSide: Maybe<TradeSide>;
  /** amountCurrency represents */
  amountCurrency: Scalars['String']['output'];
  /** avgPx represents */
  avgPx: Scalars['String']['output'];
  /** avgPxAllIn represents */
  avgPxAllIn: Maybe<Scalars['String']['output']>;
  /** cancelSessionID represents */
  cancelSessionID: Maybe<Scalars['String']['output']>;
  /** clOrdID represents */
  clOrdID: Scalars['String']['output'];
  /** createdAt represents */
  createdAt: Scalars['Timestamp']['output'];
  /** cumAmt represents */
  cumAmt: Scalars['String']['output'];
  /** cumProviderFee represents */
  cumProviderFee: Maybe<Scalars['String']['output']>;
  /** cumQty represents */
  cumQty: Scalars['String']['output'];
  /** currency represents */
  currency: Scalars['String']['output'];
  /** cxlRejReason represents */
  cxlRejReason: Maybe<CxlRejReason>;
  /** execID represents */
  execID: Scalars['String']['output'];
  /** execType represents */
  execType: ExecType;
  /** feeCurrency represents */
  feeCurrency: Maybe<Scalars['String']['output']>;
  /** flowType represents */
  flowType: FlowType;
  /** groupID represents */
  groupID: Maybe<Scalars['String']['output']>;
  /** id represents */
  id: Scalars['String']['output'];
  /** internalSettlementID represents */
  internalSettlementID: Maybe<Scalars['String']['output']>;
  /** internalStatus represents */
  internalStatus: InternalStatus;
  /** lastAmt represents */
  lastAmt: Maybe<Scalars['String']['output']>;
  /** lastFee represents */
  lastFee: Maybe<Scalars['String']['output']>;
  /** lastFeeCurrency represents */
  lastFeeCurrency: Maybe<Scalars['String']['output']>;
  /** lastMarket represents */
  lastMarket: Maybe<Scalars['String']['output']>;
  /** lastProviderFee represents */
  lastProviderFee: Maybe<Scalars['String']['output']>;
  /** lastPx represents */
  lastPx: Maybe<Scalars['String']['output']>;
  /** lastQty represents */
  lastQty: Maybe<Scalars['String']['output']>;
  /** leavesQty represents */
  leavesQty: Scalars['String']['output'];
  /** OrdRejReason represents */
  ordRejReason: Maybe<OrdRejReason>;
  /** ordStatus represents */
  ordStatus: OrdStatus;
  /** ordType represents */
  ordType: OrdType;
  /** orderID represents */
  orderID: Scalars['String']['output'];
  /** orderQty represents */
  orderQty: Scalars['String']['output'];
  /** orderSessionID represents */
  orderSessionID: Maybe<Scalars['String']['output']>;
  /** origClOrdID represents */
  origClOrdID: Maybe<Scalars['String']['output']>;
  /** parentOrderID represents */
  parentOrderID: Scalars['String']['output'];
  /** parentRFQID represents */
  parentRFQID: Scalars['String']['output'];
  /** price represents */
  price: Maybe<Scalars['String']['output']>;
  /** providerFeeCurrency represents */
  providerFeeCurrency: Maybe<Scalars['String']['output']>;
  /** requestUser represents */
  requestUser: Scalars['String']['output'];
  /** revision represents */
  revision: Scalars['Int']['output'];
  /** side represents */
  side: TradeSide;
  /** subAccount represents */
  subAccount: Maybe<Scalars['String']['output']>;
  /** symbol represents */
  symbol: Scalars['String']['output'];
  /** textMessage represents */
  textMessage: Maybe<Scalars['String']['output']>;
  /** timeInForce represents */
  timeInForce: TimeInForce;
  /** transactTime represents */
  transactTime: Scalars['Timestamp']['output'];
};

/** Trade execution report connection for pagination */
export type TradeExecutionReportConnection = {
  __typename: 'TradeExecutionReportConnection';
  /** List of edges containing trade execution report and cursor information */
  edges: Array<TradeExecutionReportEdge>;
  /** Page details for the associated list of  trade execution report edges */
  pageInfo: PageInfo;
};

/** Trade execution report edge for pagination */
export type TradeExecutionReportEdge = {
  __typename: 'TradeExecutionReportEdge';
  /** Cursor for the associated trade execution report */
  cursor: Scalars['String']['output'];
  /** Trade execution report */
  node: TradeExecutionReport;
};

export type TradeFilter = {
  /** Filter by account IDs */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by group IDs */
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Haruko IDs */
  harukoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by specific trade IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by ingest sources */
  ingestSources?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by product IDs */
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by statuses */
  statuses?: InputMaybe<Array<DVTradeStatus>>;
};

/** TradeInternalInfo contains internal information about a trade */
export type TradeInternalInfo = {
  __typename: 'TradeInternalInfo';
  capacity: TradeCapacity;
  /** @deprecated Use `Trade.Market`. */
  market: Scalars['String']['output'];
  states: Array<TradeState>;
};

/** TradeQuoteResponse contains the result of executing a trade against a quote. */
export type TradeQuoteResponse = {
  __typename: 'TradeQuoteResponse';
  /** Human-readable error message if trade was not executed */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** True if trade was executed, false otherwise */
  executed: Scalars['Boolean']['output'];
  /** Timestamp of the most recent trade state (time of execution if executed) */
  timestamp: Scalars['Timestamp']['output'];
};

/** TradeSettings contains organization-specific trading settings */
export type TradeSettings = {
  __typename: 'TradeSettings';
  /** RFQ TTL for quotes requested by this organization (duration string, e.g. "3s") */
  RFQTTL: Scalars['String']['output'];
  /** Accept price leniency for quotes requested by this organization (decimal as string, e.g. "0.003") */
  acceptPriceLeniency: Scalars['String']['output'];
  /** Accept time leniency for quotes requested by this organization (duration string, e.g. "3s") */
  acceptTimeLeniency: Scalars['String']['output'];
  /** Prices timeout for quotes requested by this organization (duration string, e.g. "3s") */
  pricesTimeout: Scalars['String']['output'];
  /** Quote TTL for quotes requested by this organization (duration string, e.g. "3s") */
  quoteTTL: Scalars['String']['output'];
  /** Trading Entity of the organization */
  tradingEntity: Maybe<TradingEntity>;
  /**
   * Whether this organization uses the fintech flow
   * @deprecated Fintech flow has been deprecated and removed. This field always returns false.
   */
  useFintechFlow: Scalars['Boolean']['output'];
};

/** TradeSettlementTransaction contains information about a trade settlement transaction */
export type TradeSettlementTransaction = {
  __typename: 'TradeSettlementTransaction';
  /** Asset type */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Time when added */
  createdAt: Scalars['Timestamp']['output'];
  /** User who created */
  createdBy: Scalars['String']['output'];
  /** ID of this trade settlement transaction */
  id: Scalars['ID']['output'];
  /** Settlement ID */
  settlementID: Scalars['String']['output'];
  /** Transaction ID */
  transactionID: Scalars['String']['output'];
  /** Time when updated */
  updatedAt: Scalars['Timestamp']['output'];
  /** User who updated */
  updatedBy: Scalars['String']['output'];
};

/** Trade settlement transaction connection for pagination */
export type TradeSettlementTransactionConnection = {
  __typename: 'TradeSettlementTransactionConnection';
  /** List of edges containing trade settlement transaction and cursor information */
  edges: Array<TradeSettlementTransactionEdge>;
  /** Page details for the associated list of trade settlement transaction edges */
  pageInfo: PageInfo;
};

/** Trade settlement transaction edge for pagination */
export type TradeSettlementTransactionEdge = {
  __typename: 'TradeSettlementTransactionEdge';
  /** Cursor for the associated trade settlement transaction */
  cursor: Scalars['String']['output'];
  /** Trade settlement transaction */
  node: TradeSettlementTransaction;
};

/** TradeSide represents the side of a trade */
export enum TradeSide {
  /** Buying base asset type */
  BUY = 'BUY',
  /** Selling base asset type */
  SELL = 'SELL'
}

export enum TradeSideEnum {
  BUY = 'BUY',
  SELL = 'SELL'
}

/** TradeSource represents one of possible channels where the trade might have originated from */
export enum TradeSource {
  /** ADVANCED represents a trade placed through the advanced dashboard */
  ADVANCED = 'ADVANCED',
  /** API represents a trade placed through the Anchorage API */
  API = 'API',
  /** MANUAL represents a manually booked trade */
  MANUAL = 'MANUAL',
  /** UI represents a trade placed through the Anchorage UI */
  UI = 'UI',
  /** UNSPECIFIED represents an unknown source */
  UNSPECIFIED = 'UNSPECIFIED',
  /**
   * WL represents a trade placed through the white label
   * @deprecated Use ADVANCED instead
   */
  WL = 'WL'
}

/** State of a trade */
export type TradeState = {
  __typename: 'TradeState';
  createdAt: Scalars['Timestamp']['output'];
  notes: Scalars['String']['output'];
  promoter: Scalars['String']['output'];
  promoterType: PromoterType;
  status: TradeStatus;
  tradeID: Scalars['String']['output'];
};

/** TradeStatus is the different statuses that a trade can go through */
export enum TradeStatus {
  /** The trade has been allocated by the Desk */
  ALLOCATED = 'ALLOCATED',
  /** The trade was canceled by the Anchorage trading team due to client legal/financial problems */
  CANCELED = 'CANCELED',
  /** The trade was executed by the OTC desk and Anchorage is awaiting customer deposit */
  EXECUTED = 'EXECUTED',
  /** Customer has placed a trade request */
  PENDING = 'PENDING',
  /** The PENDING_ALLOCATION trade is in a dormant state in which it's waiting to be allocated */
  PENDING_ALLOCATION = 'PENDING_ALLOCATION',
  /** The trade was rejected by the OTC desk */
  REJECTED = 'REJECTED',
  /** The broker received funds and assets were sent to the customer */
  SETTLED = 'SETTLED',
  /** Anchorage has received customer deposit and is in the process of settling with the OTC desk */
  SETTLING = 'SETTLING'
}

/** TradesView will be used for showing a collection of trades */
export type TradesView = {
  __typename: 'TradesView';
  edges: Array<TradesViewEdge>;
  pageInfo: PageInfo;
};

/** TradesViewEdge implements the connections spec */
export type TradesViewEdge = {
  __typename: 'TradesViewEdge';
  cursor: Scalars['String']['output'];
  node: Trade;
};

export type TradingAccount = {
  __typename: 'TradingAccount';
  /**
   * Affiliate information, optional as this brokerage account
   * might not be linked.
   */
  account: Maybe<Account>;
  /** This account's buying power */
  buyingPower: Maybe<BuyingPower>;
  /** Entity associated with the account */
  entity: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** State of the brokerage account */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the brokerage account */
  name: Scalars['String']['output'];
  /** Organization the account belongs to */
  organization: Organization;
};

export type TradingAmount = {
  __typename: 'TradingAmount';
  /** Information about the asset */
  asset: TradingAsset;
  /** Display value for this amount */
  displayValue: Scalars['String']['output'];
  /**
   * Display value in USD for this amount
   * If the price cannot be resolved this will be null
   */
  displayValueInUSD: Maybe<Scalars['String']['output']>;
  /** The value for this amount */
  value: Scalars['String']['output'];
};

/** TradingAmountInput contains information about the amount of a trade */
export type TradingAmountInput = {
  /** Asset code, trading asset list available at tradingAssets query */
  assetCode: Scalars['String']['input'];
  /** The value for this amount */
  value: Scalars['String']['input'];
};

/**
 * TradingAmountPercentage represents the accumulated quantity of a trade
 * and its corresponding percentage. This type provides details about
 * the accumulated traded amount and the proportion it represents within
 * the total trade, such as the executed portion of a buy or sell order.
 */
export type TradingAmountPercentage = {
  __typename: 'TradingAmountPercentage';
  /** The accumulated traded quantity, including its value and associated asset. */
  amount: TradingAmount;
  /**
   * The percentage this accumulated quantity represents of the total trade,
   * expressed as a string (e.g., "25%").
   */
  percentage: Scalars['String']['output'];
};

/** Input to the mutation TradingApproveAsset */
export type TradingApproveAssetInput = {
  /** Code of the asset to be approved */
  code: Scalars['String']['input'];
};

export type TradingAsset = {
  __typename: 'TradingAsset';
  /** Code is the unique identifier for a trading asset, is not mutable */
  code: Scalars['String']['output'];
  /**
   * Code is a client facing identifier for a trading asset, can be changed
   * in the future if the asset decides to change their name
   */
  codeAbbreviation: Scalars['String']['output'];
  /**
   * Custody Code is the respective custody asset for this trading asset
   * Since we may support assets for trading that we do not for custody this
   * field is optional
   */
  custodyCode: Maybe<Scalars['AssetTypeID']['output']>;
  /** Description of the trading asset */
  description: Scalars['String']['output'];
  /** Name of the trading asset */
  name: Scalars['String']['output'];
};

/** TradingAssetPrecision contains precision information about a trading symbol */
export type TradingAssetPrecision = {
  __typename: 'TradingAssetPrecision';
  /** Base asset (LHS) of the symbol */
  base: Scalars['String']['output'];
  /** Number of decimal points supported when specifying quantity in left hand side symbol */
  baseSizeScale: Scalars['Int']['output'];
  /**
   * Minimum size for base asset in order to successfully place an order
   * @deprecated Use 'minimumOrderSizeString' instead
   */
  minimumOrderSize: Scalars['Decimal']['output'];
  /** Minimum size as a string for base asset in order to successfully place an order */
  minimumOrderSizeString: Scalars['String']['output'];
  /** Number of decimal points supported when specifying price */
  priceScale: Scalars['Int']['output'];
  /** Quote asset (RHS) of the symbol */
  quote: Scalars['String']['output'];
  /** Number of decimal points supported when specifying quantity in right hand side symbol */
  quoteSizeScale: Scalars['Int']['output'];
};

/** Input to the query TradingAssets */
export type TradingAssetsInput = {
  /** Dummy field to satisfy the input requirement */
  dummy?: InputMaybe<Scalars['String']['input']>;
};

/** Input to the mutation TradingCreateAsset */
export type TradingCreateAssetInput = {
  /** Unique identifier for the trading asset */
  code: Scalars['String']['input'];
  /** Client facing identifier for the trading asset */
  codeAbbreviation: Scalars['String']['input'];
  /** Optional field for the respective custody asset for this trading asset */
  custodyCode?: InputMaybe<Scalars['AssetTypeID']['input']>;
  /** Description of the asset */
  description: Scalars['String']['input'];
  /** Name of the asset */
  name: Scalars['String']['input'];
};

/** Input to the mutation TradingCreateExternalAsset */
export type TradingCreateExternalAssetInput = {
  /** Unique identifier of the trading asset */
  code: Scalars['String']['input'];
  /** Representation of the asset for this particular external integration */
  externalCode: Scalars['String']['input'];
  /** Unique identifier of the external integration */
  externalIntegration: Scalars['String']['input'];
};

export type TradingCreateManualOrderInput = {
  /** Trading account to book the order against */
  accountID: Scalars['ID']['input'];
  /** Amount bought */
  amountBought: TradingAmountInput;
  /** Amount sold */
  amountSold: TradingAmountInput;
  /** Currency of the quantity */
  currency: Scalars['String']['input'];
  /** Timestamp of the trade */
  executedAt: Scalars['Timestamp']['input'];
  /** Optional fee amount */
  feeAmount?: InputMaybe<TradingAmountInput>;
  /** Event type of the order. This is specifically used for A1 backfill */
  lastEventType?: InputMaybe<Scalars['String']['input']>;
  /** Order type */
  orderType: OrdType;
  /** Organization key ID for the trade */
  organizationKeyID: Scalars['String']['input'];
  /** The price for the order */
  price: Scalars['String']['input'];
  /** Side of the order */
  side: TradeSide;
  /** Symbol of the order */
  symbol: Scalars['String']['input'];
  /** Trade ID of the order created by A1 backfill. This should not be used in FE */
  tradeID?: InputMaybe<Scalars['String']['input']>;
};

/** TradingCreateSettlementFromFiltersInput is the input for creating a settlement based on filters */
export type TradingCreateSettlementFromFiltersInput = {
  /**
   * AccountID for the settlement
   * Each settlement can only be associated with a single account
   */
  accountID: Scalars['String']['input'];
  /** AfterCreatedAtInclusive is the timestamp after which the trades get selected */
  afterCreatedAtInclusive?: InputMaybe<Scalars['Timestamp']['input']>;
  /** BeforeCreatedAtExclusive is the timestamp before which the trades get selected */
  beforeCreatedAtExclusive?: InputMaybe<Scalars['Timestamp']['input']>;
  /**
   * IsPreview is an optional flag that lets the caller preview the
   * settlement that would be created with the given filters
   */
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order IDs selected for this settlement */
  orderIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * OrganizationKeyID for the settlement
   * Each settlement can only be associated with a single organization
   */
  organizationKeyID: Scalars['String']['input'];
};

/** Information about a credit discrepancy for a given org/account/asset. */
export type TradingCreditDiscrepancy = {
  __typename: 'TradingCreditDiscrepancy';
  accountID: Scalars['String']['output'];
  asset: Scalars['AssetTypeID']['output'];
  calculatedAmount: Scalars['String']['output'];
  organizationKeyID: Scalars['String']['output'];
  usedAmount: Scalars['String']['output'];
};

/** Input to the mutation TradingDeleteAsset */
export type TradingDeleteAssetInput = {
  /** Code of the asset to be deleted */
  code: Scalars['String']['input'];
};

/** Input to the mutation TradingDeleteExternalAsset */
export type TradingDeleteExternalAssetInput = {
  /** Unique identifier of the external relationship */
  id: Scalars['ID']['input'];
};

export enum TradingEntity {
  A1 = 'A1',
  ADB = 'ADB',
  ADNY = 'ADNY',
  ADS = 'ADS',
  HOLD = 'HOLD'
}

/**
 * Information about the external asset, i.e. the mapping translation between
 * the Anchorage concept of a trading asset and the external concept of a trading asset
 */
export type TradingExternalAsset = {
  __typename: 'TradingExternalAsset';
  /** Unique identifier of the trading asset (e.g. BTC) */
  code: Scalars['String']['output'];
  /** Representation of the asset for this particular external integration */
  externalCode: Scalars['String']['output'];
  /** Unique identifier of the external integration (e.g. TALOS) */
  externalIntegration: Scalars['String']['output'];
  /** Unique identifier of the external relationship (uuidV4) */
  id: Scalars['ID']['output'];
};

/** Input to the query TradingExternalAssets */
export type TradingExternalAssetsInput = {
  /** Dummy field to satisfy the input requirement */
  dummy?: InputMaybe<Scalars['String']['input']>;
};

export type TradingLedgerCancelTransactionResult = {
  __typename: 'TradingLedgerCancelTransactionResult';
  id: Scalars['ID']['output'];
  message: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type TradingLedgerCancelTransactionsInput = {
  counterpartyAccountID: Scalars['ID']['input'];
  orderIDs: Array<Scalars['ID']['input']>;
};

export type TradingLedgerCreateTransactionsInput = {
  counterpartyAccountID?: InputMaybe<Scalars['ID']['input']>;
  counterpartyKind?: InputMaybe<CounterpartyKind>;
  orderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  productType?: InputMaybe<TradingProductType>;
  transactionTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  transactionTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TradingLedgerReconcileTransactionResult = {
  __typename: 'TradingLedgerReconcileTransactionResult';
  message: Maybe<Scalars['String']['output']>;
};

export type TradingLedgerReconcileTransactionsInput = {
  counterpartyAccountID?: InputMaybe<Scalars['ID']['input']>;
  counterpartyKind?: InputMaybe<Scalars['String']['input']>;
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['DateTime']['input']>;
  orderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  transactionTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  transactionTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Response from executing a trading order */
export type TradingOrderResponse = {
  __typename: 'TradingOrderResponse';
  /** Client order ID */
  clOrderID: Scalars['String']['output'];
  /** Currency */
  currency: Scalars['String']['output'];
  /** Execution ID */
  execID: Scalars['String']['output'];
  /** Limit price (if applicable) */
  limitPrice: Maybe<Scalars['String']['output']>;
  /** Trading service order ID */
  orderID: Scalars['String']['output'];
  /** Order status */
  orderStatus: Scalars['String']['output'];
  /** Order type */
  orderType: Scalars['String']['output'];
  /** Order quantity */
  quantity: Scalars['String']['output'];
  /** Rejection reason (if order was rejected) */
  rejectReason: Maybe<Scalars['String']['output']>;
  /** Order side (BUY or SELL) */
  side: Scalars['String']['output'];
  /** Trading pair symbol */
  symbol: Scalars['String']['output'];
};

/**
 * TradingOrganization is a type to represent Organization entity in Trading service.
 * The Organization entity belongs to the organization service team and we wanted an entity in house to the trading team. Organization in Organization service is not associated with entity, but we wanted to have it associated with entity for our use case in Trading service. So we are depending on the accounts table to get all the Organization Ids and then build the data using those Ids. This is the reason we are not using the organization service directly.
 */
export type TradingOrganization = {
  __typename: 'TradingOrganization';
  /** Organization entity */
  entity: Scalars['String']['output'];
  /** Organization key ID */
  id: Scalars['ID']['output'];
  /** Organization details */
  organization: Maybe<Organization>;
};

/** Describes a trading permission */
export type TradingPermission = {
  __typename: 'TradingPermission';
  /** Organization of the trading permission */
  organization: Maybe<Organization>;
  /** Type of the permission */
  permissionType: TradingPermissionType;
  /** Value of the permission */
  permissionValue: TradingPermissionValue;
};

/** Trading permissions to be saved */
export type TradingPermissionInput = {
  /** Organization to which the permissions will be applied */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  /** Type of the permission. */
  permissionTypeFilter?: InputMaybe<TradingPermissionTypeFilter>;
  /** Value of the permission. */
  permissionValueFilter?: InputMaybe<TradingPermissionValueFilter>;
};

/** Types of trading permissions */
export enum TradingPermissionType {
  /** Advanced trading features */
  ADVANCED = 'ADVANCED',
  /** Basic trading features */
  BASIC = 'BASIC'
}

/**
 * Input-position counterpart of TradingPermissionType used in filter arguments.
 * Kept structurally separate from the output enum so the type stays single-owner
 * across subgraphs (federation cannot exact-match-couple input+output uses).
 */
export enum TradingPermissionTypeFilter {
  /** Advanced trading features */
  ADVANCED = 'ADVANCED',
  /** Basic trading features */
  BASIC = 'BASIC'
}

/** Values of the trading permissions */
export enum TradingPermissionValue {
  /** Permission is disabled */
  DISABLED = 'DISABLED',
  /** Permission is enabled */
  ENABLED = 'ENABLED'
}

/**
 * Input-position counterpart of TradingPermissionValue used in mutation input
 * fields. Kept structurally separate from the output enum so the type stays
 * single-owner across subgraphs (federation cannot exact-match-couple
 * input+output uses).
 */
export enum TradingPermissionValueFilter {
  /** Permission is disabled */
  DISABLED = 'DISABLED',
  /** Permission is enabled */
  ENABLED = 'ENABLED'
}

/** Set of trading permissions to be saved */
export type TradingPermissionsInput = {
  /**
   * List of permissions that are to be saved transactionally
   * If one operation fails, all operations will fail
   */
  permissions: Array<TradingPermissionInput>;
};

/** TradingPosition contains information about the outstanding amount of a trading position */
export type TradingPosition = {
  __typename: 'TradingPosition';
  /**
   * Outstanding amount
   * @deprecated Use `tradingAmount`.
   */
  amount: Amount;
  /** Outstanding amount */
  tradingAmount: TradingAmount;
};

export enum TradingProductType {
  PERPETUAL_SWAP = 'PERPETUAL_SWAP',
  SPOT = 'SPOT',
  SYNTHETIC = 'SYNTHETIC'
}

/** TradingSettlementPreview previews the net outstanding amounts of a settlement before it is created */
export type TradingSettlementPreview = {
  __typename: 'TradingSettlementPreview';
  /** Net outstanding amounts of the future settlement */
  positions: Array<Amount>;
};

/** TradingStatement contains the metadata and contents of a trading statement. */
export type TradingStatement = {
  __typename: 'TradingStatement';
  /** The contents of the PDF, base64-encoded. */
  pdfContents: Scalars['String']['output'];
  /** The file name of the PDF. */
  pdfName: Scalars['String']['output'];
};

export type TradingStrategyCollateralHold = {
  __typename: 'TradingStrategyCollateralHold';
  assetTypeID: Scalars['String']['output'];
  holdID: Scalars['String']['output'];
  placedAt: Scalars['Time']['output'];
  quantity: Scalars['String']['output'];
  subaccountID: Scalars['String']['output'];
};

export type TradingStrategyCollateralHoldInput = {
  assetTypeID: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  subaccountID: Scalars['String']['input'];
};

/** TradingSymbol contains information about a trading symbol */
export type TradingSymbol = {
  __typename: 'TradingSymbol';
  /**
   * Abbreviation of the symbol, this is should be used for display purposes
   * Akin to the abbreviation<->code relationship we have for assets
   * This is the external representation of the symbol comprised of abbreviations of assets
   */
  abbreviation: Scalars['String']['output'];
  /** TradingAssetPrecision is the supported size and price increment for the symbol */
  assetPrecision: Maybe<TradingAssetPrecision>;
  /** AssetTypeInfo for the left side of the symbol, this will expose both 'assetTypeID' and 'abbreviation' */
  baseAssetTypeInfo: Maybe<AssetTypeInfo>;
  /** Internal information contains fields whose contents shall only be visible to Anchorage's staff (e.g., Risk dashboard) */
  internalInfo: Maybe<TradingSymbolInternalInfo>;
  /** Informs if the symbol is currently enabled for trading */
  isEnabled: Scalars['Boolean']['output'];
  /** AssetTypeInfo for the right side of the symbol, this will expose both 'assetTypeID' and 'abbreviation' */
  quoteAssetTypeInfo: Maybe<AssetTypeInfo>;
  /**
   * The string format of a trading symbol, separated by "-"
   * This is the internal representation of the symbol comprised of codes of assets
   */
  symbol: Scalars['String']['output'];
};

/** TradingSymbolInternalInfo contains internal information about a trading symbol */
export type TradingSymbolInternalInfo = {
  __typename: 'TradingSymbolInternalInfo';
  /** Displays when the symbol was approved for trading */
  approvedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Displays who approved the symbol for trading */
  approvedBy: Maybe<Scalars['String']['output']>;
  /** Displays when the symbol was inserted into the database */
  createdAt: Scalars['Timestamp']['output'];
  /** Displays who inserted the symbol into the database */
  createdBy: Scalars['String']['output'];
  /**
   * Entity associated with the trading symbol, its internal information
   * since we have no reason to expose this information to our customers
   */
  entity: AnchorageEntityTypeOutput;
  /** UUID of the symbol */
  id: Scalars['ID']['output'];
  /** Displays when the symbol was last updated */
  updatedAt: Scalars['Timestamp']['output'];
  /** Displays who updated the symbol last */
  updatedBy: Scalars['String']['output'];
};

/** TradingTalosAccount represents a Talos account */
export type TradingTalosAccount = {
  __typename: 'TradingTalosAccount';
  /** Trading account ID of this Talos account */
  account: TradingAccount;
  /** Alias for this account on the Talos side */
  accountTalosAlias: Scalars['String']['output'];
  /** When was this account created */
  createdAt: Scalars['Timestamp']['output'];
  /** Who created this account */
  createdBy: Scalars['String']['output'];
  /** Identifier of the Talos account */
  id: Scalars['ID']['output'];
  /** Organization key ID of this Talos account */
  organization: Organization;
  /** Talos customer name */
  talosCustomer: Scalars['String']['output'];
  /** Talos customer ID */
  talosCustomerID: Scalars['String']['output'];
  /** Talos instance */
  talosInstance: Maybe<TalosInstance>;
  /** When was this account updated */
  updatedAt: Scalars['Timestamp']['output'];
  /** Who updated this account */
  updatedBy: Scalars['String']['output'];
};

/** Filter input for tradingTalosAccounts query */
export type TradingTalosAccountFilterInput = {
  /** Filter by trading account IDs */
  accountIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Talos account IDs (the 'id' field of TradingTalosAccount) */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by organization key IDs */
  organizationKeyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Talos instance */
  talosInstance?: InputMaybe<TalosInstance>;
};

/** Holds the summary for the unsettled client settlements */
export type TradingUnsettledClientBalanceSummary = {
  __typename: 'TradingUnsettledClientBalanceSummary';
  /** Holds the executed and settling balance grouped by asset */
  unsettledClientBalanceByAsset: Array<UnsettledClientBalanceByAsset>;
  /** Holds the executed and settling balance grouped by organization and asset */
  unsettledClientBalanceByOrgAsset: Array<UnsettledClientBalanceByOrgAsset>;
};

/** Input to the mutation TradingUpdateAsset */
export type TradingUpdateAssetInput = {
  /** Unique identifier for the trading asset (immutable) */
  code: Scalars['String']['input'];
  /** Client facing identifier for the trading asset (can be updated) */
  codeAbbreviation?: InputMaybe<Scalars['String']['input']>;
  /** Optional field for the respective custody asset for this trading asset */
  custodyCode?: InputMaybe<Scalars['AssetTypeID']['input']>;
  /** Description of the asset */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the asset */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a manual order */
export type TradingUpdateManualOrderInput = {
  /** Trading account to book the order against */
  accountID?: InputMaybe<Scalars['ID']['input']>;
  /** Amount bought */
  boughtAmount?: InputMaybe<TradingAmountInput>;
  /** Currency of the quantity */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Executed at time */
  executedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Total fee */
  feeAmount?: InputMaybe<TradingAmountInput>;
  /** Order ID to be updated, this is required */
  id: Scalars['ID']['input'];
  /** Order type */
  orderType?: InputMaybe<OrdType>;
  /** Update organization of the order */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  /** Average price */
  price?: InputMaybe<Scalars['String']['input']>;
  /** Side of the order */
  side?: InputMaybe<TradeSide>;
  /** Amount sold */
  soldAmount?: InputMaybe<TradingAmountInput>;
  /** Update symbol of the order */
  symbol?: InputMaybe<Scalars['String']['input']>;
};

/** TradingWhitelabelUser represents a Whitelabel user */
export type TradingWhitelabelUser = {
  __typename: 'TradingWhitelabelUser';
  /** Auth0 ID */
  auth0ID: Scalars['String']['output'];
  /** Client username */
  clientUserName: Scalars['String']['output'];
  /** Email (fake email used for Talos matching, not PII) */
  email: Scalars['String']['output'];
  /** Identifier of the Whitelabel user */
  id: Scalars['ID']['output'];
  /** Organization of this Whitelabel user */
  organization: Maybe<Organization>;
  /** Organization Talos alias */
  organizationTalosAlias: Scalars['String']['output'];
  /** User reference */
  user: Maybe<User>;
};

/** Represents a transaction */
export type Transaction = {
  __typename: 'Transaction';
  /** Flag that let us know if the Transaction allows Overdraft Balance */
  allowOverdraftBalance: Maybe<Scalars['Boolean']['output']>;
  /** Flag that let us know if the Transaction allows Pending Balance */
  allowPendingBalance: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp of when a transaction was created */
  createdAt: Maybe<Scalars['Time']['output']>;
  /** Description of a Transaction */
  description: Maybe<Scalars['String']['output']>;
  /** Metadata associated with the transaction */
  metadata: Maybe<Scalars['String']['output']>;
  /** Status of a Transaction */
  status: Maybe<TransactionStatus>;
  /** List of TransactionEntries associated with the Transaction */
  transactionEntries: Maybe<Array<Maybe<TransactionEntry>>>;
  /** Identifier of the Transaction */
  transactionID: Maybe<Scalars['String']['output']>;
  /** Type of a Transaction */
  transactionType: Maybe<TransactionType>;
  /** Timestamp of a transaction was last updated */
  updatedAt: Maybe<Scalars['Time']['output']>;
};

/** TransactionConnection represents a page of Transactions based on the parameters of pagination used, defined by a pageInfo object. */
export type TransactionConnection = {
  __typename: 'TransactionConnection';
  /** Edges contains a list of TransactionEdge objects representing a page of AddressBalance data. */
  edges: Array<TransactionEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** TransactionData encapsulates the fields to be used to perform on-chain approval or cancel transactions. */
export type TransactionData = {
  __typename: 'TransactionData';
  /**
   * ApprovedSellAmount is the quantity of ETH tokens approved for spending by the transaction,
   * denominated in wei.
   */
  approvedSellAmount: Scalars['String']['output'];
  /** BuyWalletAddress is the wallet address that will be used to buy the token. */
  buyWalletAddress: Scalars['String']['output'];
  /** CancelGasFee is the total estimated gas cost of the on-chain cancel transaction. */
  cancelGasFee: Scalars['String']['output'];
  /** GasFee is the total estimated gas cost of the on-chain approval transaction. */
  gasFee: Scalars['String']['output'];
  /** GasLimit is the maximum units of gas that will be consumed by this transaction. */
  gasLimit: Scalars['String']['output'];
  /** GasPrice is the cost per unit of gas. */
  gasPrice: Scalars['String']['output'];
  /** MaxFeePerGas is the sum of the base fee and priority fee. */
  maxFeePerGas: Scalars['String']['output'];
  /**
   * MaxPriorityFeePerGas is the maximum tip to the block builder. Adjusted based upon the
   * urgency specified in the request.
   */
  maxPriorityFeePerGas: Scalars['String']['output'];
  /** RawData is the escaped JSON for the on-chain approval or cancel transaction data. */
  rawData: Scalars['String']['output'];
  /** SellTokenChainID is the chain ID of the token being sold in the swap (e.g. Ethereum's chain ID is 1). */
  sellTokenChainID: Scalars['String']['output'];
  /** SellWalletAddress is the wallet address that will be selling the token. */
  sellWalletAddress: Scalars['String']['output'];
};

/**
 * TransactionDestination represents a single destination output in a multi-destination transaction.
 * Used for any operation that can send funds to multiple addresses in one transaction.
 * For UTXO-based chains: Excludes change outputs (change is tracked separately via ChangeAddress).
 * For account-based chains: Represents multiple transfer destinations in a single operation.
 */
export type TransactionDestination = {
  __typename: 'TransactionDestination';
  /** address is the blockchain address receiving funds */
  address: BlockchainAddress;
  /** amount is the amount being sent to this destination */
  amount: Amount;
};

/** Represents a Transaction Edge */
export type TransactionEdge = {
  __typename: 'TransactionEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a Transaction */
  node: Maybe<Transaction>;
};

/** Represents a transaction entry */
export type TransactionEntry = {
  __typename: 'TransactionEntry';
  /** Timestamp of when the TransactionEntry was created */
  createdAt: Maybe<Scalars['Time']['output']>;
  /** Identifier of the entity associated with the entry */
  entityID: Maybe<EntityID>;
  /** Identifier of the TransactionEntry */
  entryID: Maybe<Scalars['String']['output']>;
  /** Metadata associated with the TransactionEntry */
  metadata: Maybe<Scalars['String']['output']>;
  /** Quantity of the TransactionEntry */
  quantity: Maybe<Quantity>;
  /** Identifier of the Transaction that the TransactionEntry belongs to */
  transactionID: Maybe<Scalars['String']['output']>;
};

/** TransactionEntryConnection represents a page of TransactionEntries based on the parameters of pagination used, defined by a pageInfo object. */
export type TransactionEntryConnection = {
  __typename: 'TransactionEntryConnection';
  /** Edges contains a list of TransactionEntryEdge objects representing a page of TransactionEntry data. */
  edges: Array<TransactionEntryEdge>;
  /** pageInfo returns information about the page returned above. */
  pageInfo: PageInfo;
};

/** Represents a TransactionEntry Edge */
export type TransactionEntryEdge = {
  __typename: 'TransactionEntryEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a TransactionEntry */
  node: Maybe<TransactionEntry>;
};

/** Input type for creating or updating a TransactionEntry */
export type TransactionEntryInput = {
  /** Amount of the TransactionEntry */
  amount: Scalars['String']['input'];
  /** AssetTypeID */
  assetTypeID: Scalars['AssetTypeID']['input'];
  /** Balance Type */
  balanceType: Scalars['String']['input'];
  /** Identifier of the entity associated with the entry */
  entityID: EntityIDInput;
  /** The id of the entry */
  entryID?: InputMaybe<Scalars['String']['input']>;
  /** Metadata associated with the TransactionEntry */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Organization key ID */
  orgId?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionInput = {
  allowOverdraftBalance?: InputMaybe<Scalars['Boolean']['input']>;
  allowPending?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityEntries?: InputMaybe<Array<TransactionEntryInput>>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  organizationKeyId: Scalars['String']['input'];
  status: TransactionStatus;
  transactionID?: InputMaybe<Scalars['String']['input']>;
  transactionType: TransactionType;
  walletEntries?: InputMaybe<Array<WalletEntryInput>>;
};

/** Metadata keys used in transaction metadata */
export enum TransactionMetadataKey {
  /** Cubix transaction identifier */
  CUBIX_TRANSACTION_ID = 'CUBIX_TRANSACTION_ID'
}

/** The type of transaction request. */
export enum TransactionRequestType {
  /** JSONRPC is a JSON-RPC transaction request. */
  JSONRPC = 'JSONRPC'
}

/** Collected risk analysis information about an address or transaction */
export type TransactionRiskAnalysis = {
  __typename: 'TransactionRiskAnalysis';
  /** blockchainAnalyses is an array with BlockchainAnalyses */
  blockchainAnalyses: Maybe<Array<BlockchainAnalysis>>;
  /** clusterCategory is populated if there is a known categorization to the cluster in which the transaction (e.g. exchange) */
  clusterCategory: Maybe<Scalars['String']['output']>;
  /** clusterName is populated if there is a known name to the cluster in which the transaction (e.g. Poloniex.com) */
  clusterName: Maybe<Scalars['String']['output']>;
  /** counterpartyAnalyses is an array with CounterpartyAnalyses */
  counterpartyAnalyses: Maybe<Array<CounterpartyAnalysis>>;
  /** hrjAnalyses is an array with HRJAnalyses */
  hrjAnalyses: Maybe<Array<HRJAnalysis>>;
  /** score represents the risk assessment of the address */
  score: Maybe<TransactionRiskScore>;
  /** searches contains the search results count for various addresses */
  searches: Array<SearchAnalysis>;
  /** url is an URL for an external chain analysis dashboard */
  url: Maybe<Scalars['String']['output']>;
};

/** Quick determination of risk. Unless "DANGER", usually transactions still warrant further investigation */
export enum TransactionRiskScore {
  /** Transaction corresponds to a known bad cluster */
  DANGER = 'DANGER',
  /** Manual review is required for this transaction as the system was not able to determine the risk */
  MANUAL_CHECK_REQUIRED = 'MANUAL_CHECK_REQUIRED',
  /** Transaction corresponds to a known safe address cluster */
  SAFE = 'SAFE',
  /** We didn't get actionable risk information about this transaction */
  UNKNOWN = 'UNKNOWN'
}

/** Represents the status of a Transaction */
export enum TransactionStatus {
  /** Represents a Cancelled Transaction (CANCELLED) */
  CANCELED = 'CANCELED',
  /** Represents an on-going Transaction (PENDING) */
  PENDING = 'PENDING',
  /** Represents a final Transaction (POSTED) */
  POSTED = 'POSTED'
}

/** Represents the different type of transactions within the ledger */
export enum TransactionType {
  /** Represents an Advisory Fee */
  ADVISORY_FEE = 'ADVISORY_FEE',
  /** Represents a balance adjustment */
  BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT',
  /** Represents a burn operation */
  BURN = 'BURN',
  /** Represents an claim transaction */
  CLAIM = 'CLAIM',
  /** Represents a consolidate operation */
  CONSOLIDATE = 'CONSOLIDATE',
  /** Represents a Custody Fee */
  CUSTODY_FEE = 'CUSTODY_FEE',
  /** Represents a Deposit */
  DEPOSIT = 'DEPOSIT',
  /** Represents a Deposit Sweep */
  DEPOSIT_SWEEP = 'DEPOSIT_SWEEP',
  /** Represents a Fee settlement */
  FEE_SETTLEMENT = 'FEE_SETTLEMENT',
  /** Represents a Gas Fill */
  GAS_FILL = 'GAS_FILL',
  /** Represents a Managment Fee */
  MANAGEMENT_FEE = 'MANAGEMENT_FEE',
  /** Represents a Model Fee */
  MODEL_FEE = 'MODEL_FEE',
  /** Represents a pre-burn operation */
  PRE_BURN = 'PRE_BURN',
  /** Represents return of funds */
  RETURN = 'RETURN',
  /** Represents a stake operation */
  STAKE = 'STAKE',
  /** Represents a Subaccount Transfer */
  SUBACCOUNT_TRANSFER = 'SUBACCOUNT_TRANSFER',
  /** Represents a trade */
  TRADE = 'TRADE',
  /** Represents a Trade Settlement */
  TRADE_SETTLEMENT = 'TRADE_SETTLEMENT',
  /** Represents trading strategy income, such as the profit or loss of a trading strategy */
  TRADING_STRATEGY_INCOME = 'TRADING_STRATEGY_INCOME',
  /** Represents transfer */
  TRANSFER = 'TRANSFER',
  /** Represents an unstake operation */
  UNSTAKE = 'UNSTAKE',
  /** Represents a Withdrawal */
  WITHDRAWAL = 'WITHDRAWAL'
}

/** An account transfer. */
export type Transfer = {
  __typename: 'Transfer';
  assets: Array<TransferAsset>;
  clAccountId: Scalars['String']['output'];
  completedAt: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  cryptoTransferType: Scalars['String']['output'];
  dispatchMethod: Maybe<Scalars['String']['output']>;
  /** Populated only on dispatchTransfer mutations; null for all other queries. */
  dispatchResult: Maybe<DispatchTransferResult>;
  dispatchedAt: Maybe<Scalars['Time']['output']>;
  envelopeId: Maybe<Scalars['String']['output']>;
  failedReason: Maybe<Scalars['String']['output']>;
  fiatTransferType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  memocode: Scalars['String']['output'];
  sendingAccountId: Scalars['String']['output'];
  sendingAccountType: Scalars['String']['output'];
  sendingCustodianId: Scalars['String']['output'];
  settledAt: Maybe<Scalars['Time']['output']>;
  subaccountId: Scalars['String']['output'];
  transferStatus: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userProvidedCustodian: Maybe<Scalars['String']['output']>;
};

/** The request for automatic transfers between Client Custody Vaults and Anchorage Vaults */
export type TransferAccessRequest = {
  __typename: 'TransferAccessRequest';
  /** The api key details */
  apiKey: Maybe<APIKey>;
  /** The api key operation created */
  apiKeyOperation: Maybe<Operation>;
  /** The domain */
  domain: TransferAccessRequestDomain;
  /** organization */
  organization: Organization;
  /** The org key id */
  organizationKeyID: Scalars['ID']['output'];
  /** The permission group details */
  permissionGroup: Maybe<Role>;
  /** The permission group operation created */
  permissionGroupOperation: Maybe<Operation>;
  /** The status */
  status: TransferAccessRequestStatus;
  /** The transfer access request id */
  transferAccessRequestID: Scalars['ID']['output'];
};

/** Transfer Access Request Domains */
export enum TransferAccessRequestDomain {
  /** Brokerage transfer access request domain */
  BROKERAGE = 'BROKERAGE',
  /** Financing transfer access request domain */
  FINANCING = 'FINANCING',
  /** Gas station transfer access request domain */
  GAS_STATION = 'GAS_STATION',
  /** Settlement network transfer access request domain */
  SETTLEMENT_NETWORK = 'SETTLEMENT_NETWORK'
}

/** Transfer Access Request statuses */
export enum TransferAccessRequestStatus {
  /** API key creation was canceled */
  API_KEY_CANCELED = 'API_KEY_CANCELED',
  /** API key was created */
  API_KEY_COMPLETE = 'API_KEY_COMPLETE',
  /** API key is being created */
  API_KEY_PENDING = 'API_KEY_PENDING',
  /** API key was revoked */
  API_KEY_REVOKED = 'API_KEY_REVOKED',
  /** The transfer access request request has not been initiated */
  NOT_REQUESTED = 'NOT_REQUESTED',
  /** Permission group is canceled */
  PERMISSION_GROUP_CANCELED = 'PERMISSION_GROUP_CANCELED',
  /** Permission group is created */
  PERMISSION_GROUP_COMPLETE = 'PERMISSION_GROUP_COMPLETE',
  /** Permission group is deleted */
  PERMISSION_GROUP_DELETED = 'PERMISSION_GROUP_DELETED',
  /** Permission group is being created */
  PERMISSION_GROUP_PENDING = 'PERMISSION_GROUP_PENDING'
}

/** An asset included in an account transfer. */
export type TransferAsset = {
  __typename: 'TransferAsset';
  amount: Maybe<Scalars['String']['output']>;
  asset: Scalars['String']['output'];
  id: Scalars['String']['output'];
  networkId: Maybe<Scalars['String']['output']>;
  walletAddress: Maybe<Scalars['String']['output']>;
  walletId: Maybe<Scalars['String']['output']>;
};

/** Paginated list of transfers. */
export type TransferConnection = {
  __typename: 'TransferConnection';
  /** A list of edges. */
  edges: Maybe<Array<TransferEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A transfer edge in a connection. */
export type TransferEdge = {
  __typename: 'TransferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Transfer>;
};

/** A single audit log entry for an account transfer's lifecycle. */
export type TransferEvent = {
  __typename: 'TransferEvent';
  createdAt: Scalars['Time']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
  step: Scalars['String']['output'];
  transferId: Scalars['String']['output'];
};

/** Paginated list of transfer events. */
export type TransferEventConnection = {
  __typename: 'TransferEventConnection';
  /** A list of edges. */
  edges: Maybe<Array<TransferEventEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A transfer event edge in a connection. */
export type TransferEventEdge = {
  __typename: 'TransferEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TransferEvent>;
};

/** TransferOperation represents a Transfer operation */
export type TransferOperation = Operation & {
  __typename: 'TransferOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount is the Amount that is being transferred */
  amount: Amount;
  /** same as amount but using historical pricing based on the end time of the operation */
  amountAtEndTime: Amount;
  /**
   * amountWithFinalFee is equal to amount + finalFee and is defined only for withdrawals
   * in the completed state where the amount and the fee share the same asset type.
   * Refer to the resolvers `feeSharesAssetTypeWithAmount` and `operationState`.
   */
  amountWithFinalFee: Maybe<Amount>;
  /** same as amountWithFinalFee but using historical pricing based on the end time of the operation */
  amountWithFinalFeeAtEndTime: Maybe<Amount>;
  /**
   * appStatus is the app-facing state of the operation, a simplified version of operationState
   * TODO: unused field
   */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** asset id from with the authorization was made */
  assetID: AssetID;
  /** Further information regarding this asset type associated with this operation */
  assetTypeInfo: AssetTypeInfo;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * TODO: unused field
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** canonicalOperationVersion is the version of the canonical authorization that must be used to sign this authorization */
  canonicalOperationVersion: Scalars['Int']['output'];
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** confirmations returns how many confirmations the transaction associated with this authorization has received */
  confirmations: Maybe<Scalars['Int']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /**
   * deductFeeFromAmountIfSameType indicates whether the transaction fee should be deducted from the
   * send amount when the fee and amount share the same asset type.
   * When true, the fee is subtracted from the provided amount. When false or null (default), the fee
   * is added on top of the provided amount.
   */
  deductFeeFromAmountIfSameType: Maybe<Scalars['Boolean']['output']>;
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /**
   * destinationAssetID is the asset id the operation is transferring to. It will be set only
   * if the querying user is allowed to read this asset ID. For example, app/clientdashboard
   * users will receive a NULL for the destinationAssetID of a cross-org transfer. In that
   * case, see destinationVaultUniqueID
   */
  destinationAssetID: Maybe<AssetID>;
  /**
   * destinationOutputs contains all destination addresses and amounts for multi-destination operations.
   * For single-destination operations, this will contain one element matching receivingBlockchainAddress2.
   * For UTXO-based chains: Contains destination outputs only (change outputs are excluded and tracked separately).
   * For account-based chains: Contains all transfer destinations.
   * Note: Change outputs for UTXO chains are not included here as they return to the sender via a separate deposit event.
   */
  destinationOutputs: Array<TransactionDestination>;
  /** destinationProgramCustomerID is the program customer that owns the credited virtual account. Null when destinationVirtualAccountID is null, when that virtual account has no program customer, or when the transfer is not intra-org (another organization's owner is that organization's data). */
  destinationProgramCustomerID: Maybe<Scalars['String']['output']>;
  /** destinationVaultUniqueID is the unique ID of the vault this operation is transferring to. */
  destinationVaultUniqueID: Maybe<Scalars['String']['output']>;
  /** destinationVirtualAccount resolves that virtual account's display details from fiat. Null when destinationVirtualAccountID is null, when the caller may not see the operation's organization, or when the destination VA belongs to another organization (fiat's tenancy scoping). */
  destinationVirtualAccount: Maybe<VirtualAccount>;
  /** destinationVirtualAccountID is the virtual account this operation credits (internal sends only). Null otherwise. */
  destinationVirtualAccountID: Maybe<Scalars['String']['output']>;
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /**
   * endorsements is the list of endorsements for the operation
   * TODO: unused field
   */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /**
   * estimatedTotalAmount is equal to amount + maxFee and is defined only for
   * withdrawals where the amount and the fee share the same asset type.
   */
  estimatedTotalAmount: Maybe<Amount>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * extraParams are additional asset type specific parameters that were set for this transaction
   * When constructing the canonical operation for signing, the extra params go in the ExtraParams field
   * as a map from asset type id (usually, parent asset type id) to params object. The convention of extra
   * params is to omit all empty fields, and if no extra params are set for an asset type, to omit the asset
   * type from the map entirely. Note that for legacy reasons this convention
   * is the opposite of the normal CanonicalOperation convention, where no fields are ever omitted.
   */
  extraParams: Maybe<ExtraParams>;
  /**
   * feeSharesAssetTypeWithAmount is true if the fee and the amount withdrawn share
   * the same asset type. Returns false otherwise, or if the fee is not known.
   */
  feeSharesAssetTypeWithAmount: Scalars['Boolean']['output'];
  /** final transaction fee charged for the authorization, detected on the blockchain */
  finalFee: Maybe<Amount>;
  /** same as finalFee but using historical pricing based on the end time of the operation */
  finalFeeAtEndTime: Maybe<Amount>;
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /**
   * If broadcasting of the operation is taking longer than usual, "impediment" may have descriptive info about why.
   * @deprecated use Operation.OperationInfo.OperationImpediment
   */
  impediment: Maybe<Scalars['String']['output']>;
  /**
   * initiatorKey is the api key that created the operation
   * @deprecated use key from InitiatorV2
   */
  initiatorKey: APIKey;
  /** inlineFiatDestination is the beneficiary and banks of an external fiat transfer that carries them inline instead of a trusted destination */
  inlineFiatDestination: Maybe<InlineFiatDestination>;
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** Is the operation in a cancelable state? */
  isCancelable: Scalars['Boolean']['output'];
  /** Is the operation in a rejectable state? */
  isRejectable: Scalars['Boolean']['output'];
  /** max transaction fee charged for the authorization */
  maxFee: Maybe<Amount>;
  /** same as maxFee but using historical pricing based on the end time of the operation */
  maxFeeAtEndTime: Maybe<Amount>;
  /** OperationCancelation is the data about When and Who requested cancelation of the operation. */
  operationCancelation: Maybe<OperationCancelation>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to, which is the source organization (not necessarily the org using the initiatorKey)
   * @deprecated use operationInfo
   */
  organization: Maybe<Organization>;
  /**
   * paymentReferences lists the wire payment identifiers (e.g. fedwire IMAD/OMAD, SWIFT UETR/MIR)
   * associated with this transfer, when available. Populated for fiat wires only.
   */
  paymentReferences: Maybe<Array<PaymentReference>>;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /** programCustomerID is the program customer that owns the debited virtual account. Null when virtualAccountID is null or that virtual account has no program customer. */
  programCustomerID: Maybe<Scalars['String']['output']>;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** receivingBlockchainAddress is the address on which a transfer is to be received */
  receivingBlockchainAddress: BlockchainAddress;
  /** same as receivingBlockchainAddress but with additional info if using a settlement network participant */
  receivingBlockchainAddress2: BlockchainAddressWithParticipant;
  /** receivingFiatTrustedDestination is the fiat trusted destination targeted by an external fiat transfer, plus the wire fedID */
  receivingFiatTrustedDestination: Maybe<ReceivingFiatTrustedDestination>;
  /** receivingTrustedDestination is the destination on which a transfer is to be received */
  receivingTrustedDestination: Maybe<TrustedDestination>;
  /** receivingWallet is the wallet that received the transfer */
  receivingWallet: Maybe<Wallet>;
  /**
   * replayProtectionParams are the parameters to be sent to the HSM for creating and signing
   * the transactions required to effect this ExecuteOperation. The user *is not* expected
   * to review the contents of this field. However it may contain information necessary to prevent
   * replays and must be included in the payload signed by the user. Format is a hex-encoded
   * byte array.
   */
  replayProtectionParams: Maybe<Scalars['String']['output']>;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** riskAnalysis is the collected risk information for this transfer if we have any */
  riskAnalysis: Maybe<TransactionRiskAnalysis>;
  /** sendingBlockchainAddresses is a list of addresses from which a transfer is sent */
  sendingBlockchainAddresses: Array<BlockchainAddress>;
  /** sendingWallet is the wallet from which the tranfer was sent */
  sendingWallet: Wallet;
  /** signedTransaction is the blockchain transaction to be broadcast to the network */
  signedTransaction: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /**
   * sources are the originating addresses for the transaction
   * @deprecated use sendingBlockchainAddresses
   */
  sources: Array<Source>;
  /** transactionID is the blockchain transaction id once available */
  transactionID: Maybe<Scalars['String']['output']>;
  /** transactionSuccess indicates if the blockchain transaction succeeded */
  transactionSuccess: Maybe<Scalars['Boolean']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * usdValueFee is the USD value of the fee (finalFee if known, otherwise maxFee).
   * If both the finalFee and maxFee are not yet known, this field will be null
   */
  usdValueFee: Maybe<Scalars['String']['output']>;
  /**
   * usdValueWithFee is the sum in USD values of both the principal withdrawal amount and the
   * fee (finalFee if known, otherwise maxFee). If both the finalFee and maxFee are
   * not yet known, this field will be null
   */
  usdValueWithFee: Maybe<Scalars['String']['output']>;
  /** if true, the Anchorage gas station was used to pay transfer fees. */
  useGasStation: Scalars['Boolean']['output'];
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
  /** virtualAccount resolves the display details of that virtual account (owner name, account last-4) from fiat. Null when virtualAccountID is null or the caller may not see the operation's organization. */
  virtualAccount: Maybe<VirtualAccount>;
  /** virtualAccountID is the virtual account this operation debits. Null when the source is the wallet itself. */
  virtualAccountID: Maybe<Scalars['String']['output']>;
};


/** TransferOperation represents a Transfer operation */
export type TransferOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** TransferOperation represents a Transfer operation */
export type TransferOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** Represents Travel Rule Information */
export type TravelRuleInformation = {
  __typename: 'TravelRuleInformation';
  /** Indicates if travel rule information can and or will be sent automatically */
  automatic: Maybe<Scalars['Boolean']['output']>;
  /** Contains the date of incorporation being sent to Ciphertrace */
  dateIncorporation: Maybe<Scalars['String']['output']>;
  /**
   * Identity Info as a JSON String
   * Specification for Identity format: http://34.64.107.172/~vasp/wp-content/uploads/2020/05/IVMS101-interVASP-data-model-standard-issue-1-FINAL.pdf
   * PDF gathered from the working group website: https://intervasp.org/
   */
  identityPayload: Maybe<Scalars['String']['output']>;
  /** Indicates if this operation is applicable for travel rule */
  isEligible: Scalars['Boolean']['output'];
  /** Operation ID the travel rule info belongs to */
  operationID: Scalars['String']['output'];
  /** Contains the place of incorporation being sent to Ciphertrace */
  placeIncorporation: Maybe<Scalars['String']['output']>;
  /** Status of TravelRule transmission */
  status: Maybe<TravelRuleStatus>;
  /** Contains Vasp Info */
  travelRuleVaspInfo: Maybe<Array<TravelRuleVaspInfo>>;
};

/** Represents the status of the Travel Rule request */
export enum TravelRuleStatus {
  /** Travel Rule transmission failed */
  API_FAILURE = 'API_FAILURE',
  /** Travel Rule transmission is pending */
  PENDING = 'PENDING',
  /** Travel Rule info was transmitted manually */
  SENT_MANUALLY = 'SENT_MANUALLY',
  /** Travel Rule info was transmitted automatically */
  SENT_VIA_API = 'SENT_VIA_API'
}

/** Contains Vasp information */
export type TravelRuleVaspInfo = {
  __typename: 'TravelRuleVaspInfo';
  /** Indicates that Travel Rule information can be sent via API to this VASP */
  autoSendPossible: Maybe<Scalars['Boolean']['output']>;
  /** Source of the Vasp Information */
  network: Scalars['String']['output'];
  /** Link to the networks portal site */
  portalLink: Maybe<Scalars['String']['output']>;
  /** Name of the Vasp */
  vaspName: Maybe<Scalars['String']['output']>;
};

export type TriggerFillBasedTaxReportInput = {
  /** Cutoff time for trade filtering */
  cutoffTime: Scalars['DateTime']['input'];
  /**
   * Organization ID to process tax reporting for.
   * If empty/null, processes ALL organizations.
   */
  organizationKeyID?: InputMaybe<Scalars['ID']['input']>;
  /** Start time for trade filtering */
  startTime: Scalars['DateTime']['input'];
};

export type TriggerFillBasedTaxReportResult = {
  __typename: 'TriggerFillBasedTaxReportResult';
  /** Human-readable message about the trigger result */
  message: Scalars['String']['output'];
  /** Temporal run ID for tracking the specific execution */
  runID: Scalars['String']['output'];
  /** Temporal workflow ID for tracking the execution */
  workflowID: Scalars['String']['output'];
};

/**
 * Input for triggerHandleStakedTransferWorkflow. Field semantics match the gRPC
 * TriggerHandleStakedTransferWorkflowRequest.
 */
export type TriggerHandleStakedTransferWorkflowInput = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  /**
   * Required. Persisted on the transfer record and part of the derived transfer ID; resend the same
   * value to retry.
   */
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  destAddress?: InputMaybe<StakedTransferDestinationAddress>;
  /** Identifier of the destination staked position. */
  destinationStakingPositionID: Scalars['String']['input'];
  destinationWalletID: StakedTransferWalletID;
  /** Opaque unique ID of the source staking position. */
  sourcePositionID: Scalars['String']['input'];
  sourceWalletID: StakedTransferWalletID;
};

/** Result of triggerHandleStakedTransferWorkflow. */
export type TriggerHandleStakedTransferWorkflowPayload = {
  __typename: 'TriggerHandleStakedTransferWorkflowPayload';
  /** Identifier of the staked position transfer. */
  stakedTransferID: Scalars['String']['output'];
};

export type TriggerStrategyFundSweepInput = {
  /**
   * The pool to split across the org's client sub-accounts: positive, floored to
   * USDC precision.
   */
  amount: Scalars['Decimal']['input'];
  direction: SweepDirection;
  orgId: Scalars['ID']['input'];
};

export type TriggerStrategyFundSweepResult = {
  __typename: 'TriggerStrategyFundSweepResult';
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type TriggerSubaccountTrueUpInput = {
  orgId: Scalars['ID']['input'];
  subaccountId: Scalars['ID']['input'];
};

export type TriggerSubaccountTrueUpResult = {
  __typename: 'TriggerSubaccountTrueUpResult';
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

/** TODO: add description */
export type TriggerWebhookInput = {
  /** TODO: add description */
  payload: Scalars['String']['input'];
  /** TODO: add description */
  topic: Scalars['String']['input'];
  /** TODO: add description */
  type: Scalars['String']['input'];
};

export type TrueUpSkip = {
  __typename: 'TrueUpSkip';
  assetTypeId: Scalars['String']['output'];
  subaccountId: Scalars['ID']['output'];
};

export type TrueUpSkipInput = {
  /**
   * Canonical asset type ID (e.g. "BTC", "SOL_TD"). The pair (subaccount, asset) is
   * the skip granularity — other assets on the subaccount still true up.
   */
  assetTypeId: Scalars['String']['input'];
  subaccountId: Scalars['ID']['input'];
};

export type TrueUpSkipResult = {
  __typename: 'TrueUpSkipResult';
  assetTypeId: Scalars['String']['output'];
  subaccountId: Scalars['ID']['output'];
};

/** Anchorage's VASP available in TRUST Bulletin Board */
export enum TrustVASP {
  /** Anchorage Digital Bank */
  ADB = 'ADB',
  /** Anchorage Digital Singapore */
  ADS = 'ADS'
}

/** TrustedDestination represents a trusted destination for crypto assets */
export type TrustedDestination = {
  __typename: 'TrustedDestination';
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /**
   * assetTypeID is the type of asset that this destination points to
   * @deprecated Use assetTypeInfo
   */
  assetTypeID: Scalars['AssetTypeID']['output'];
  /** Further information regarding this asset type */
  assetTypeInfo: AssetTypeInfo;
  /**
   * blockchainAddress returns the BlockchainAddress entity for this trusted destination,
   * enabling federation-based resolution of address risk metadata (e.g. poisoning risk).
   * This field always returns an address and fails with an error when one cannot
   * be derived, including for destinations that do not have a specific on-chain address.
   */
  blockchainAddress: BlockchainAddress;
  /** Holds true if the destination is being deleted */
  deletionPending: Scalars['Boolean']['output'];
  /** Description of the trusted address */
  description: Scalars['String']['output'];
  /** The address */
  destination: Scalars['String']['output'];
  /** ID of the trusted destination */
  destinationID: DestinationID;
  /**
   * isAtNetworkLevel denotes whether the trusted destination is used as network level or asset level
   * true: network level, false: asset level
   */
  isAtNetworkLevel: Scalars['Boolean']['output'];
  /** Name of the trusted address */
  name: Scalars['String']['output'];
  /** ExtraParams for for trusted destinations, depending on the asset being used */
  trustedDestinationExtraParams: Maybe<TrustedDestinationExtraParams>;
};

/** A connection to a list of trusted destinations */
export type TrustedDestinationConnection = {
  __typename: 'TrustedDestinationConnection';
  /** edges is a list of TrustedDestinationEdge objects representing a page of trustedDestinations data. Implements the connections spec for pagination */
  edges: Array<TrustedDestinationEdge>;
  /** pageInfo returns information about the page returned above. Implements the connections spec for pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection, representing a TrustedDestination instance */
export type TrustedDestinationEdge = {
  __typename: 'TrustedDestinationEdge';
  /** cursor implements the connections spec for pagination */
  cursor: Scalars['ID']['output'];
  /** node implements the connections spec for pagination */
  node: TrustedDestination;
};

/** TrustedDestinationExtraParams is the type that represents a trusted destination extra parameters */
export type TrustedDestinationExtraParams = {
  __typename: 'TrustedDestinationExtraParams';
  /** memo is the destination tag/memo required by the asset for transactions */
  memo: Maybe<Scalars['String']['output']>;
};

/** Represents a trusted smart contract for assets. */
export type TrustedSmartContract = {
  __typename: 'TrustedSmartContract';
  /** Address string of the trusted smart contract */
  address: Scalars['String']['output'];
  /**
   * assetTypeInfo is the asset type this smart contract is for.
   * @deprecated Use networkInfo
   */
  assetTypeInfo: AssetTypeInfo;
  /** UnixTime when the Trusted Smart Contract was created, in nanosecond. */
  createdAt: Scalars['String']['output'];
  /** Description of the trusted smart contract */
  description: Scalars['String']['output'];
  /** Name of the trusted smart contract */
  name: Scalars['String']['output'];
  /** networkInfo is the network this smart contract is for. */
  networkInfo: NetworkInfo;
  /** ID of the trusted smart contract */
  trustedSmartContractID: TrustedSmartContractID;
  /**
   * SubIDs of the vaults in which the smart contract is considered "trusted".
   * @deprecated Use vaults
   */
  vaultSubIDs: Array<Scalars['String']['output']>;
  /** the vaults in which the smart contract is considered "trusted". */
  vaults: Array<Vault>;
};

/** A connection to a list of items. */
export type TrustedSmartContractConnection = {
  __typename: 'TrustedSmartContractConnection';
  /** A list of edges. */
  edges: Maybe<Array<TrustedSmartContractEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TrustedSmartContractEdge = {
  __typename: 'TrustedSmartContractEdge';
  /** A CursorType for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TrustedSmartContract>;
};

/** TrustedSmartContractID is the ID that uniquely identifies a trusted smart contract (across orgs). */
export type TrustedSmartContractID = {
  __typename: 'TrustedSmartContractID';
  /** organizationKeyID is the ID of the organization this vault is in */
  organizationKeyID: Scalars['String']['output'];
  /** trustedSmartContractSubID is the ID that uniquely identifies a trusted smart contract within a given organization. */
  trustedSmartContractSubID: Scalars['String']['output'];
};

export type TrustedSmartContractMethodArgs = {
  __typename: 'TrustedSmartContractMethodArgs';
  /** Key of the select parameter the component fills with the contract. */
  contract: Scalars['String']['output'];
  /** Key of the multi-select parameter the component fills with the methods. */
  methods: Scalars['String']['output'];
};

/**
 * Why a smart contract is trusted. UNSPECIFIED is every contract a client added; the other values mark
 * contracts Anchorage registered automatically for its own flows.
 */
export enum TrustedSmartContractPurpose {
  /** Alluvial Orchestrator owner contract, registered by Anchorage. */
  ALLUVIAL_ORCHESTRATOR_OWNER = 'ALLUVIAL_ORCHESTRATOR_OWNER',
  /** Alluvial Orchestrator staker contract, registered by Anchorage. */
  ALLUVIAL_ORCHESTRATOR_STAKER = 'ALLUVIAL_ORCHESTRATOR_STAKER',
  /** Aztec staking ATP contract, registered by Anchorage. */
  AZTEC_STAKING_ATP = 'AZTEC_STAKING_ATP',
  /** Aztec per-delegation staking split contract, auto-associated by Anchorage at stake time. */
  AZTEC_STAKING_SPLIT_CONTRACT = 'AZTEC_STAKING_SPLIT_CONTRACT',
  /** Aztec staker contract configured by the ATP, registered by Anchorage. */
  AZTEC_STAKING_STAKER = 'AZTEC_STAKING_STAKER',
  /** EigenLayer EigenPod contract, registered by Anchorage when the pod is deployed. */
  EIGENPOD = 'EIGENPOD',
  /** Added by the client for no specific purpose. Every contract a client adds carries this value. */
  UNSPECIFIED = 'UNSPECIFIED',
  /** USHP primary-market vault contract, registered by Anchorage. */
  USHP_PRIMARY_VAULT = 'USHP_PRIMARY_VAULT',
  /** USHP staking vault contract, registered by Anchorage. */
  USHP_STAKING_VAULT = 'USHP_STAKING_VAULT',
  /**
   * Zama KMS Rewarder contract. No longer used for new registrations; kept so existing entries stay valid.
   * @deprecated Retained for existing entries only.
   */
  ZAMA_KMS_REWARDER = 'ZAMA_KMS_REWARDER'
}

/** By which field to sort TrustedSmartContract's. */
export enum TrustedSmartContractSortingField {
  /** Sort by the name of trusted smart contracts. */
  NAME = 'NAME'
}

/** Trusted Sources represents a trusted source that can me used to make a deposit attribution */
export type TrustedSource = {
  __typename: 'TrustedSource';
  /** createdAt is the timestamp of creation of this record */
  createdAt: Scalars['Timestamp']['output'];
  /** createdBy is the email of the user who created this record */
  createdBy: Scalars['String']['output'];
  /** Reason why the trusted source was disabled */
  disabledReason: Maybe<TrustedSourceDisableReason>;
  /** Trusted source identifier */
  id: Scalars['String']['output'];
  /** Network from the respective source address */
  network: Scalars['String']['output'];
  /** Organization identifier */
  organizationID: Scalars['String']['output'];
  /** Country of the trusted source originator */
  originatorCountry: Scalars['String']['output'];
  /** Name of the trusted source originator */
  originatorName: Scalars['String']['output'];
  /** Source address to consider as trusted */
  sourceAddress: Scalars['String']['output'];
  /** Status associated with the trusted source */
  status: TrustedSourceStatus;
  /** updatedAt is the timestamp of the latest update of this record */
  updatedAt: Scalars['Timestamp']['output'];
  /** updatedBy is the email of the user who last updated this record */
  updatedBy: Scalars['String']['output'];
  /** Country of the trusted source vasp in case the originator does not control the wallet. */
  vaspCountry: Maybe<Scalars['String']['output']>;
  /** Name of the trusted source vasp in case the originator does not control the wallet */
  vaspName: Maybe<Scalars['String']['output']>;
  /** Type of wallet associated with the trusted source */
  walletType: TrustedSourceWalletType;
};

/** Trusted Sources pagination connection. */
export type TrustedSourceConnection = {
  __typename: 'TrustedSourceConnection';
  /** List of edges containing trusted sources and cursor information */
  edges: Array<TrustedSourceEdge>;
  /** Page details for the trusted sources. */
  pageInfo: PageInfo;
};

/** A connection to a list of items. */
export type TrustedSourceConnectionV2 = {
  __typename: 'TrustedSourceConnectionV2';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TrustedSourceEdgeV2>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Trusted Sources Freeze Reason */
export enum TrustedSourceDisableReason {
  /** Frozen due to being in compliance review */
  COMPLIANCE_REVIEW = 'COMPLIANCE_REVIEW',
  /** Frozen due to detecting a confliting attribution */
  CONFLICTING_ATTRIBUTION = 'CONFLICTING_ATTRIBUTION',
  /** Frozen due to detecting a incoherent attribution */
  INCOHERENT_ATTRIBUTION = 'INCOHERENT_ATTRIBUTION',
  /** Frozen due to being an omnibus account */
  OMNIBUS_ACCOUNT = 'OMNIBUS_ACCOUNT'
}

/** Trusted Sources edge connection. */
export type TrustedSourceEdge = {
  __typename: 'TrustedSourceEdge';
  /** Cursor for the trusted sources. */
  cursor: Scalars['String']['output'];
  /** Latest trusted sources. */
  node: TrustedSource;
};

/** An edge in a connection. */
export type TrustedSourceEdgeV2 = {
  __typename: 'TrustedSourceEdgeV2';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TrustedSourceV2>;
};

/** Ordering options for TrustedSource connections */
export type TrustedSourceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TrustedSources. */
  field: TrustedSourceOrderField;
};

/** Properties by which TrustedSource connections can be ordered. */
export enum TrustedSourceOrderField {
  CREATED_AT = 'CREATED_AT',
  NETWORK = 'NETWORK',
  ORIGINATOR_COUNTRY = 'ORIGINATOR_COUNTRY',
  ORIGINATOR_NAME = 'ORIGINATOR_NAME',
  UPDATED_AT = 'UPDATED_AT'
}

/** TrustedSourceOrigin is enum for the field origin */
export enum TrustedSourceOrigin {
  CLIENT = 'CLIENT',
  STAFF = 'STAFF',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** TrustedSourceReason is enum for the field reason */
export enum TrustedSourceReason {
  COMPLIANCE_REVIEW = 'COMPLIANCE_REVIEW',
  CONFLICTING_ATTRIBUTION = 'CONFLICTING_ATTRIBUTION',
  INCOHERENT_ATTRIBUTION = 'INCOHERENT_ATTRIBUTION',
  OMNIBUS_ACCOUNT = 'OMNIBUS_ACCOUNT'
}

/** Trusted Sources Status */
export enum TrustedSourceStatus {
  /** Disabled */
  DISABLED = 'DISABLED',
  /** Enable */
  ENABLED = 'ENABLED'
}

/** TrustedSourceStatusEnt is enum for the field trusted_source_status */
export enum TrustedSourceStatusEnt {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type TrustedSourceV2 = Node & {
  __typename: 'TrustedSourceV2';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  network: Scalars['String']['output'];
  organizationID: Scalars['String']['output'];
  origin: TrustedSourceOrigin;
  originatorCountry: Scalars['String']['output'];
  originatorName: Scalars['String']['output'];
  reason: Maybe<TrustedSourceReason>;
  sourceAddress: Scalars['String']['output'];
  trustedSourceStatus: TrustedSourceStatusEnt;
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  walletType: Scalars['String']['output'];
};

export enum TrustedSourceWalletType {
  /** CUSTODIAL represents a wallet where the owner does not have complete control over the wallet as they do not have the private key, a third party does. */
  CUSTODIAL = 'CUSTODIAL',
  /** SELF_HOSTED represents a wallet where the owner has complete control over the wallet as they have the private key. */
  SELF_HOSTED = 'SELF_HOSTED'
}

/**
 * TrustedSourceWhereInput is used for filtering TrustedSource objects.
 * Input was generated by ent.
 */
export type TrustedSourceWhereInput = {
  and?: InputMaybe<Array<TrustedSourceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByContainsFold?: InputMaybe<Scalars['String']['input']>;
  createdByEqualFold?: InputMaybe<Scalars['String']['input']>;
  createdByGT?: InputMaybe<Scalars['String']['input']>;
  createdByGTE?: InputMaybe<Scalars['String']['input']>;
  createdByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createdByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByLT?: InputMaybe<Scalars['String']['input']>;
  createdByLTE?: InputMaybe<Scalars['String']['input']>;
  createdByNEQ?: InputMaybe<Scalars['String']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['Int']['input']>;
  idGT?: InputMaybe<Scalars['Int']['input']>;
  idGTE?: InputMaybe<Scalars['Int']['input']>;
  idIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  idLT?: InputMaybe<Scalars['Int']['input']>;
  idLTE?: InputMaybe<Scalars['Int']['input']>;
  idNEQ?: InputMaybe<Scalars['Int']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** network field predicates */
  network?: InputMaybe<Scalars['String']['input']>;
  networkContains?: InputMaybe<Scalars['String']['input']>;
  networkContainsFold?: InputMaybe<Scalars['String']['input']>;
  networkEqualFold?: InputMaybe<Scalars['String']['input']>;
  networkGT?: InputMaybe<Scalars['String']['input']>;
  networkGTE?: InputMaybe<Scalars['String']['input']>;
  networkHasPrefix?: InputMaybe<Scalars['String']['input']>;
  networkHasSuffix?: InputMaybe<Scalars['String']['input']>;
  networkIn?: InputMaybe<Array<Scalars['String']['input']>>;
  networkLT?: InputMaybe<Scalars['String']['input']>;
  networkLTE?: InputMaybe<Scalars['String']['input']>;
  networkNEQ?: InputMaybe<Scalars['String']['input']>;
  networkNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<TrustedSourceWhereInput>;
  or?: InputMaybe<Array<TrustedSourceWhereInput>>;
  /** organization_id field predicates */
  organizationID?: InputMaybe<Scalars['String']['input']>;
  organizationIDContains?: InputMaybe<Scalars['String']['input']>;
  organizationIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  organizationIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  organizationIDGT?: InputMaybe<Scalars['String']['input']>;
  organizationIDGTE?: InputMaybe<Scalars['String']['input']>;
  organizationIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  organizationIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  organizationIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIDLT?: InputMaybe<Scalars['String']['input']>;
  organizationIDLTE?: InputMaybe<Scalars['String']['input']>;
  organizationIDNEQ?: InputMaybe<Scalars['String']['input']>;
  organizationIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** origin field predicates */
  origin?: InputMaybe<TrustedSourceOrigin>;
  originIn?: InputMaybe<Array<TrustedSourceOrigin>>;
  originNEQ?: InputMaybe<TrustedSourceOrigin>;
  originNotIn?: InputMaybe<Array<TrustedSourceOrigin>>;
  /** originator_country field predicates */
  originatorCountry?: InputMaybe<Scalars['String']['input']>;
  originatorCountryContains?: InputMaybe<Scalars['String']['input']>;
  originatorCountryContainsFold?: InputMaybe<Scalars['String']['input']>;
  originatorCountryEqualFold?: InputMaybe<Scalars['String']['input']>;
  originatorCountryGT?: InputMaybe<Scalars['String']['input']>;
  originatorCountryGTE?: InputMaybe<Scalars['String']['input']>;
  originatorCountryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  originatorCountryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  originatorCountryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  originatorCountryLT?: InputMaybe<Scalars['String']['input']>;
  originatorCountryLTE?: InputMaybe<Scalars['String']['input']>;
  originatorCountryNEQ?: InputMaybe<Scalars['String']['input']>;
  originatorCountryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** originator_name field predicates */
  originatorName?: InputMaybe<Scalars['String']['input']>;
  originatorNameContains?: InputMaybe<Scalars['String']['input']>;
  originatorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  originatorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  originatorNameGT?: InputMaybe<Scalars['String']['input']>;
  originatorNameGTE?: InputMaybe<Scalars['String']['input']>;
  originatorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  originatorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  originatorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  originatorNameLT?: InputMaybe<Scalars['String']['input']>;
  originatorNameLTE?: InputMaybe<Scalars['String']['input']>;
  originatorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  originatorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** reason field predicates */
  reason?: InputMaybe<TrustedSourceReason>;
  reasonIn?: InputMaybe<Array<TrustedSourceReason>>;
  reasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reasonNEQ?: InputMaybe<TrustedSourceReason>;
  reasonNotIn?: InputMaybe<Array<TrustedSourceReason>>;
  reasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** source_address field predicates */
  sourceAddress?: InputMaybe<Scalars['String']['input']>;
  sourceAddressContains?: InputMaybe<Scalars['String']['input']>;
  sourceAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  sourceAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  sourceAddressGT?: InputMaybe<Scalars['String']['input']>;
  sourceAddressGTE?: InputMaybe<Scalars['String']['input']>;
  sourceAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sourceAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sourceAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceAddressLT?: InputMaybe<Scalars['String']['input']>;
  sourceAddressLTE?: InputMaybe<Scalars['String']['input']>;
  sourceAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  sourceAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** trusted_source_status field predicates */
  trustedSourceStatus?: InputMaybe<TrustedSourceStatusEnt>;
  trustedSourceStatusIn?: InputMaybe<Array<TrustedSourceStatusEnt>>;
  trustedSourceStatusNEQ?: InputMaybe<TrustedSourceStatusEnt>;
  trustedSourceStatusNotIn?: InputMaybe<Array<TrustedSourceStatusEnt>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  updatedByContains?: InputMaybe<Scalars['String']['input']>;
  updatedByContainsFold?: InputMaybe<Scalars['String']['input']>;
  updatedByEqualFold?: InputMaybe<Scalars['String']['input']>;
  updatedByGT?: InputMaybe<Scalars['String']['input']>;
  updatedByGTE?: InputMaybe<Scalars['String']['input']>;
  updatedByHasPrefix?: InputMaybe<Scalars['String']['input']>;
  updatedByHasSuffix?: InputMaybe<Scalars['String']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['String']['input']>;
  updatedByLTE?: InputMaybe<Scalars['String']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['String']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** vasp_country field predicates */
  vaspCountry?: InputMaybe<Scalars['String']['input']>;
  vaspCountryContains?: InputMaybe<Scalars['String']['input']>;
  vaspCountryContainsFold?: InputMaybe<Scalars['String']['input']>;
  vaspCountryEqualFold?: InputMaybe<Scalars['String']['input']>;
  vaspCountryGT?: InputMaybe<Scalars['String']['input']>;
  vaspCountryGTE?: InputMaybe<Scalars['String']['input']>;
  vaspCountryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vaspCountryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vaspCountryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vaspCountryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vaspCountryLT?: InputMaybe<Scalars['String']['input']>;
  vaspCountryLTE?: InputMaybe<Scalars['String']['input']>;
  vaspCountryNEQ?: InputMaybe<Scalars['String']['input']>;
  vaspCountryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vaspCountryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** vasp_name field predicates */
  vaspName?: InputMaybe<Scalars['String']['input']>;
  vaspNameContains?: InputMaybe<Scalars['String']['input']>;
  vaspNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  vaspNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  vaspNameGT?: InputMaybe<Scalars['String']['input']>;
  vaspNameGTE?: InputMaybe<Scalars['String']['input']>;
  vaspNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vaspNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vaspNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vaspNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vaspNameLT?: InputMaybe<Scalars['String']['input']>;
  vaspNameLTE?: InputMaybe<Scalars['String']['input']>;
  vaspNameNEQ?: InputMaybe<Scalars['String']['input']>;
  vaspNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vaspNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** wallet_type field predicates */
  walletType?: InputMaybe<Scalars['String']['input']>;
  walletTypeContains?: InputMaybe<Scalars['String']['input']>;
  walletTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  walletTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  walletTypeGT?: InputMaybe<Scalars['String']['input']>;
  walletTypeGTE?: InputMaybe<Scalars['String']['input']>;
  walletTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  walletTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  walletTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  walletTypeLT?: InputMaybe<Scalars['String']['input']>;
  walletTypeLTE?: InputMaybe<Scalars['String']['input']>;
  walletTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  walletTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * TurnkeyBinaryConfig is the read counterpart of TurnkeyBinaryConfigInput. Hashes are
 * hex-encoded, so a config read here can be passed straight back to
 * prepareTurnkeyBinaryConfigChange to remove it.
 */
export type TurnkeyBinaryConfig = {
  __typename: 'TurnkeyBinaryConfig';
  /**
   * Turnkey deployment UUID, matches enclaveApp in the attestation envelope
   * (e.g., "4954c244-7e44-4967-b188-436ae7ef3b84").
   */
  appId: Scalars['String']['output'];
  /**
   * SHA-256 of the Turnkey pivot binary, taken from the QoS manifest
   * envelope (hex-encoded, 32 bytes).
   */
  pivotBinaryHash: Scalars['String']['output'];
  /** Hardware-attested QoS enclave measurements. */
  qosEnclave: QosEnclave;
};

/** TurnkeyBinaryConfigInput represents the approved measurement values for a Turnkey deployment. */
export type TurnkeyBinaryConfigInput = {
  /**
   * Turnkey deployment UUID, matches enclaveApp in the attestation envelope
   * (e.g., "4954c244-7e44-4967-b188-436ae7ef3b84").
   */
  appId: Scalars['String']['input'];
  /**
   * SHA-256 of the Turnkey pivot binary, taken from the QoS manifest
   * envelope (hex-encoded, 32 bytes).
   */
  pivotBinaryHash: Scalars['String']['input'];
  /** Hardware-attested QoS enclave measurements. */
  qosEnclave: QosEnclaveInput;
};

/**
 * TurnkeyBinaryConfigsForService holds every approved config for one deployment/service.
 * A service can have more than one approved config at a time (e.g. during a rolling
 * deployment, where old and new measurements are both valid).
 */
export type TurnkeyBinaryConfigsForService = {
  __typename: 'TurnkeyBinaryConfigsForService';
  /** The deployment/service name identifier (e.g., "turnkey-signer"). */
  serviceName: Scalars['String']['output'];
  /**
   * The approved configs for this service, in the order they are stored in the
   * organization.
   */
  turnkeyBinaryConfigs: Array<TurnkeyBinaryConfig>;
};

/** UI screen enum for filtering legal terms */
export enum UIScreen {
  ALL = 'ALL',
  ENROLL = 'ENROLL',
  LOGIN = 'LOGIN'
}

export enum UnassignedDepositAttributionAction {
  ATTRIBUTE = 'ATTRIBUTE',
  REJECT_ATTRIBUTION = 'REJECT_ATTRIBUTION'
}

/** UnencodedInput describes a contract call the server encodes. Shared by createContractCallOperation and scanPreTransaction. */
export type UnencodedInput = {
  /** arguments holds the positional argument values: scalars as strings, arrays as lists, tuples as objects keyed by component name. */
  arguments: Scalars['JSON']['input'];
  /** contractAddress is the address of the contract being called. */
  contractAddress: Scalars['String']['input'];
  /** functionSignature is the canonical signature, e.g. approve(address,uint256), as returned by smartContractABI. */
  functionSignature: Scalars['String']['input'];
  /** value is the wei value for payable functions as a decimal string; defaults to 0. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UnfreezeAccountInput = {
  accountId: Scalars['ID']['input'];
  /**
   * Caller-supplied key for this one unfreeze. A retry with the same key returns
   * the first result instead of acting again. Must not be empty.
   */
  idempotencyKey: Scalars['String']['input'];
  /** Why compliance is removing its freeze. Required, must not be blank. */
  reason: Scalars['String']['input'];
};

export type UnfreezeAccountResult = {
  __typename: 'UnfreezeAccountResult';
  accountId: Scalars['ID']['output'];
};

/** A unique device is a device that has been used to login to the system. */
export type UniqueDevice = Node & {
  __typename: 'UniqueDevice';
  /** Public keys represented as a string that are enrolled in this device */
  enrolledPublicKeys: Array<Scalars['String']['output']>;
  /** Returns user enrollments. */
  enrollments: UserConnection;
  /**
   * True if the device has a device key and may be consider as unique as we
   * can guarantee.
   */
  hasDeviceKey: Scalars['Boolean']['output'];
  /**
   * Device key ID of the unique device. In cases where the device does not have
   * a proper device key ID, this ID will be the same as the userKeyID.
   */
  id: Scalars['ID']['output'];
  /** Login metadata */
  loginMetadata: LoginMetadata;
  /** Device status */
  status: DeviceStatus;
  /** User key ID of the user that last used this device */
  userKeyID: Scalars['ID']['output'];
};


/** A unique device is a device that has been used to login to the system. */
export type UniqueDeviceenrollmentsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Unique device connection used to paginate through the unique devices */
export type UniqueDeviceConnection = {
  __typename: 'UniqueDeviceConnection';
  /** A list of edges. */
  edges: Maybe<Array<UniqueDeviceEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

/** Unique device edge used to paginate through the unique devices */
export type UniqueDeviceEdge = {
  __typename: 'UniqueDeviceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge */
  node: Maybe<UniqueDevice>;
};

/** A filter to be used against UniqueDevice fields. */
export type UniqueDeviceWhereInput = {
  /** ids field predicates */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** UniswapClassicQuote represents an individual quote from Uniswap's Classic protocol pool. */
export type UniswapClassicQuote = {
  __typename: 'UniswapClassicQuote';
  /** BuyTokenAmount token and amount to be bought in the token swap. */
  buyTokenAmount: TokenAmount;
  /** BuyWalletAddress is the address of the wallet which will receive the bought token. */
  buyWalletAddress: Scalars['String']['output'];
  /** ExchangeRate is the amount of the sell token that can be purchased relative 1 buy token. */
  exchangeRate: TokenAmount;
  /** GasFeeUSDC is the fee total estimated cost of the transaction denominated in USDC. */
  gasFeeUSDC: Scalars['String']['output'];
  /**
   * MaximumSlippage is the maximum amount the price can change between the time the Blockchain
   * transaction is submitted and the time it is executed.
   */
  maximumSlippage: Scalars['String']['output'];
  /**
   * PartnerFee is the fee the partner takes for performing the transaction.
   * (e.g. If Uniswap is performing the swap, then this is the fee Uniswap is owed).
   */
  partnerFee: Scalars['String']['output'];
  /** PermitData is the escaped JSON object of the permit2 data that must be signed to allow the token swap. */
  permitData: Scalars['String']['output'];
  /**
   * PriceImpactPercent is the impact the swap has on the market price of the Uniswap pool of tokens.
   * The value is between 0-100 percent.
   */
  priceImpactPercent: Scalars['String']['output'];
  /** QuoteAmountsDisplay is the string to be displayed with buy/sell amount and assettype. */
  quoteAmountsDisplay: Scalars['String']['output'];
  /** QuoteData is the escaped JSON object of the quote response that must be sent in the swap request. */
  quoteData: Scalars['String']['output'];
  /** RequestID is a unique identifier of the quote request that resulted in this response. */
  requestID: Scalars['String']['output'];
  /** Routing is the selected routing the token swap will go through if executed (e.g. CLASSIC). */
  routing: Scalars['String']['output'];
  /** SellTokenAmount token and amount to be sold in the token swap. */
  sellTokenAmount: TokenAmount;
  /** SellWalletAddress is the address of the wallet which will sell the token. */
  sellWalletAddress: Scalars['String']['output'];
};

/**
 * UniswapDEXInput contains the required fields for performing a token swap using Uniswap
 * Decentralized Exchange (DEX).
 */
export type UniswapDEXInput = {
  /** ApproveData is the escaped JSON for the on-chain approval transaction data. */
  approveData: Scalars['String']['input'];
  /** CancelData is the escaped JSON for the on-chain cancel transaction data. */
  cancelData: Scalars['String']['input'];
  /**
   * Deadline is the unix timestamp, in nanoseconds, at which the order will be reverted if not
   * filled (e.g. 1748553168374659132).
   */
  deadline: Scalars['String']['input'];
  /** PermitData is the escaped JSON object of the permit2 data that must be signed to allow the token swap. */
  permitData: Scalars['String']['input'];
  /**
   * QuoteData is the escaped JSON object of the selected quote that will be used to perform the
   * swap.
   */
  quoteData: Scalars['String']['input'];
};

/** UniswapQuoteInput contains fields specifically for retrieving quote data from the Uniswap DEX. */
export type UniswapQuoteInput = {
  amount: AmountInput;
  buyTokenAddress: Scalars['String']['input'];
  buyTokenAssetTypeID: Scalars['String']['input'];
  buyTokenChainID: Scalars['String']['input'];
  maximumSlippage: Scalars['Float']['input'];
  permitAmount: PermitAmount;
  protocolPools: Array<ProtocolPool>;
  quoteType: TokenQuoteType;
  sellTokenAddress: Scalars['String']['input'];
  sellTokenAssetTypeID: Scalars['String']['input'];
  sellTokenChainID: Scalars['String']['input'];
  sellTokenWalletAddress: Scalars['String']['input'];
};

/** UniswapXQuoteV2 represents an individual quote from the UniswapX v2 protocol pool. */
export type UniswapXQuoteV2 = {
  __typename: 'UniswapXQuoteV2';
  /** OrderID is a unique ID for the token swap order that's used to track the order's status. */
  orderID: Scalars['String']['output'];
  /** PermitData is the escaped JSON object of the permit2 data that must be signed to allow the token swap. */
  permitData: Scalars['String']['output'];
  /** RequestID a unique identifier of the quote request that resulted in this response. */
  requestID: Scalars['String']['output'];
  /** Routing is the selected routing the token swap will go through if executed (e.g. DUTCH_V2). */
  routing: Scalars['String']['output'];
};

/**
 * UnknownActor is used to convey that the initiator of an operation/action
 * is unknown or there is not a more specific actor type to use.
 */
export type UnknownActor = Actor & {
  __typename: 'UnknownActor';
  /** Basic information about the actor. */
  actorInfo: ActorInfo;
};

/** UnlockOperation represents an Unlock operation */
export type UnlockOperation = Operation & {
  __typename: 'UnlockOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount is the Amount that is being locked up */
  amount: Amount;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** asset id from with the authorization was made */
  assetID: AssetID;
  /** Further information regarding this asset type associated with this operation */
  assetTypeInfo: AssetTypeInfo;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** canonicalOperationVersion is the version of the canonical authorization that must be used to sign this authorization */
  canonicalOperationVersion: Scalars['Int']['output'];
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** confirmations returns how many confirmations the transaction associated with this authorization has received */
  confirmations: Maybe<Scalars['Int']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * extraParams are additional asset type specific parameters that were set for this transaction
   * When constructing the canonical operation for signing, the extra params go in the ExtraParams field
   * as a map from asset type id (usually, parent asset type id) to params object. The convention of extra
   * params is to omit all empty fields, and if no extra params are set for an asset type, to omit the asset
   * type from the map entirely. Note that for legacy reasons this convention
   * is the opposite of the normal CanonicalOperation convention, where no fields are ever omitted.
   */
  extraParams: Maybe<ExtraParams>;
  /** final transaction fee charged for the authorization, detected on the blockchain */
  finalFee: Maybe<Amount>;
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** max transaction fee charged for the authorization */
  maxFee: Maybe<Amount>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /**
   * replayProtectionParams are the parameters to be sent to the HSM for creating and signing
   * the transactions required to effect this ExecuteOperation. The user *is not* expected
   * to review the contents of this field. However it may contain information necessary to prevent
   * replays and must be included in the payload signed by the user. Format is a hex-encoded
   * byte array.
   */
  replayProtectionParams: Maybe<Scalars['String']['output']>;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** sendingBlockchainAddresses is a list of addresses from which an unlock operation is sent */
  sendingBlockchainAddresses: Array<BlockchainAddress>;
  /** signedTransaction is the blockchain transaction to be broadcast to the network */
  signedTransaction: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /**
   * sources are the originating addresses for the authorization
   * @deprecated use sendingBlockchainAddresses
   */
  sources: Array<Source>;
  /** transactionID is the blockchain transaction id once available */
  transactionID: Maybe<Scalars['String']['output']>;
  /** transactionSuccess indicates if the blockchain transaction succeeded */
  transactionSuccess: Maybe<Scalars['Boolean']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * usdValueFee is the USD value of the fee (finalFee if known, otherwise maxFee).
   * If both the finalFee and maxFee are not yet known, this field will be null
   */
  usdValueFee: Maybe<Scalars['String']['output']>;
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
};


/** UnlockOperation represents an Unlock operation */
export type UnlockOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** UnlockOperation represents an Unlock operation */
export type UnlockOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** Account information for unsettled balance entries */
export type UnsettledBalanceAccount = {
  __typename: 'UnsettledBalanceAccount';
  /** Trading account ID */
  id: Scalars['ID']['output'];
  /** Trading account name */
  name: Maybe<Scalars['String']['output']>;
};

/** UnsettledClientBalance is a current dealer/asset balance */
export type UnsettledClientBalance = {
  __typename: 'UnsettledClientBalance';
  /** Asset of the balance */
  asset: TradingAsset;
  /** Aggregate funding readiness of the balance group. */
  fundingStatus: Maybe<BalanceFundingStatus>;
  /** Organization that holds the balance */
  organization: Maybe<Organization>;
  /** Pending amount with asset and side */
  pending: PaymentAmount;
  /** Total amount with asset and side */
  total: PaymentAmount;
  /** Type of the balance */
  type: ClientSettlementType;
  /** Uninitiated amount with asset and side */
  uninitiated: PaymentAmount;
};

/** Holds the balance for each unsettled asset */
export type UnsettledClientBalanceByAsset = {
  __typename: 'UnsettledClientBalanceByAsset';
  /** Executed unsettled balance */
  executedBalance: TradingAmount;
  /** Settling unsettled balance */
  settlingBalance: TradingAmount;
  /** Total unsettled balance */
  totalBalance: TradingAmount;
};

/** Holds the balance for one entry/combination of organization and asset */
export type UnsettledClientBalanceByOrgAsset = {
  __typename: 'UnsettledClientBalanceByOrgAsset';
  /** Account */
  account: Maybe<UnsettledBalanceAccount>;
  /** Executed unsettled balance */
  executedBalance: TradingAmount;
  /** Oldest balance timestamp */
  oldestBalance: Scalars['Timestamp']['output'];
  /** Organization of the balance */
  organization: Maybe<Organization>;
  /** Settling unsettled balance */
  settlingBalance: TradingAmount;
  /** Total unsettled balance */
  totalBalance: TradingAmount;
};

/** Unsettled client balance edge for pagination */
export type UnsettledClientBalanceEdge = {
  __typename: 'UnsettledClientBalanceEdge';
  /** Cursor for the associated unsettled client balance */
  cursor: Scalars['String']['output'];
  /** Settlements */
  node: UnsettledClientBalance;
};

/** Unsettled client balances connection for pagination */
export type UnsettledClientBalancesConnection = {
  __typename: 'UnsettledClientBalancesConnection';
  /** List of edges containing unsettled client balances and cursor information */
  edges: Array<UnsettledClientBalanceEdge>;
  /** Fee balances */
  feeBalances: Maybe<Array<UnsettledClientFeeBalance>>;
  /** Page details for the associated list of payment flow edges */
  pageInfo: PageInfo;
};

/** Filter for query unsettled client balances */
export type UnsettledClientBalancesFilters = {
  /** Filter by AssetType */
  filterAssetTypeID?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  /**
   * Filter by Anchorage's order identifier
   * @deprecated use filterTradingEntities; removed once the backoffice has moved (BRO-9646)
   */
  filterEntities?: InputMaybe<Array<AnchorageEntityType>>;
  /** Filter by aggregate funding readiness. */
  filterFundingStatus?: InputMaybe<Array<BalanceFundingStatus>>;
  /** Filter by Org Key ID */
  filterOrganizationKeyID?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by trading entity. Cannot be combined with filterEntities. */
  filterTradingEntities?: InputMaybe<Array<TradingEntity>>;
};

/**
 * Wrapper around UnsettledClientBalance that includes information
 * specific to fees, like its unique identifier
 */
export type UnsettledClientFeeBalance = {
  __typename: 'UnsettledClientFeeBalance';
  /** Information about the balance and its state */
  balance: UnsettledClientBalance;
  /** Unique identifier for this fee balance */
  feeTransactionID: Scalars['String']['output'];
};

/** UnsettledDealerBalance is a current dealer/asset balance */
export type UnsettledDealerBalance = {
  __typename: 'UnsettledDealerBalance';
  /**
   * Amount contains the volume and asset this balance refers to
   * @deprecated Now is pending settling and total
   */
  amount: Amount;
  /**
   * Counterparty (i.e. dealer)
   * @deprecated Use tradingCounterparty instead
   */
  counterparty: Scalars['String']['output'];
  /** Entity of the payment flow ('HOLD', 'SINGAPORE', 'A1', etc.) */
  entity: Scalars['String']['output'];
  /** Pending amount with asset and side */
  pending: UnsettledDealerBalanceAmount;
  /** Settling amount with asset and side */
  settling: UnsettledDealerBalanceAmount;
  /** Side refers to whether it's a receivable (BUY) or a payable (SELL) */
  side: TradeSide;
  /** Total amount with asset and side */
  total: UnsettledDealerBalanceAmount;
  /** TotalPayments that make up the current balance */
  totalPayments: Scalars['Int']['output'];
  /**
   * CounterpartyWithErr object related to this unsettled balance.
   * This field is automatically resolved based on the counterparty
   */
  tradingCounterparty: Maybe<CounterpartyWithErr>;
};

/** UnsettledDealerBalanceAmount is a balance amount */
export type UnsettledDealerBalanceAmount = {
  __typename: 'UnsettledDealerBalanceAmount';
  /**
   * Amount contains the volume and asset this balance refers to
   * @deprecated Use tradingAmount instead
   */
  amount: Amount;
  /** Side refers to whether it's a receivable (BUY) or a payable (SELL) */
  side: TradeSide;
  /** TradingAmount contains the quantity and asset this balance refers to */
  tradingAmount: TradingAmount;
};

/** Unsettled dealer balance edge for pagination */
export type UnsettledDealerBalanceEdge = {
  __typename: 'UnsettledDealerBalanceEdge';
  /** Cursor for the associated unsettled dealer balance */
  cursor: Scalars['String']['output'];
  /** Settlements */
  node: UnsettledDealerBalance;
};

/** Unsettled dealer balances connection for pagination */
export type UnsettledDealerBalancesConnection = {
  __typename: 'UnsettledDealerBalancesConnection';
  /** List of edges containing unsettled dealer balances and cursor information */
  edges: Array<UnsettledDealerBalanceEdge>;
  /** Page details for the associated list of payment flow edges */
  pageInfo: PageInfo;
};

/** UnsignedOperationDetails is a union type of all possible forms of extra information for unsigned fields */
export type UnsignedOperationDetails = UnsignedOperationDetailsAddress | UnsignedOperationDetailsAmount | UnsignedOperationDetailsDelta | UnsignedOperationDetailsDivider | UnsignedOperationDetailsHighlight | UnsignedOperationDetailsText | UnsignedOperationDetailsTransaction;

/**
 * UnsignedOperationDetailsAddress is the details for an address field that's not signed
 * this could be an address that's contextual like a voting address or intermediate address
 */
export type UnsignedOperationDetailsAddress = {
  __typename: 'UnsignedOperationDetailsAddress';
  /** address to display */
  address: Scalars['String']['output'];
  /** URL to the explorer for the address */
  explorerURL: Scalars['String']['output'];
};

/**
 * UnsignedOperationDetailsAmount is the details for an amount field
 * Note that this is a far simpler amount type than our existing graphql amount
 * we determined the details weren't pertinent to this screen and we can make it far simpler
 */
export type UnsignedOperationDetailsAmount = {
  __typename: 'UnsignedOperationDetailsAmount';
  /** abbreviation is the abbreviation for the currency */
  abbreviation: Scalars['String']['output'];
  /** amount is the amount to display */
  amount: Scalars['String']['output'];
  /** FallbackPriceText is a human readable field for laying out the price if PriceQuote isn't queried */
  fallbackPriceText: Scalars['String']['output'];
};

/** UnsignedOperationDetailsDelta expresses an unsigned delta of changes. */
export type UnsignedOperationDetailsDelta = {
  __typename: 'UnsignedOperationDetailsDelta';
  /** sections is the list of delta sections to display */
  sections: Array<UnsignedOperationDetailsDeltaSection>;
};

/**
 * UnsignedOperationDetailsDeltaList is a list of changes in the payload.
 * This is used to group and display changes in a structured way, such as
 * additions, removals, or neutral changes.
 */
export type UnsignedOperationDetailsDeltaList = {
  __typename: 'UnsignedOperationDetailsDeltaList';
  /** groups is the list of groups of items in the list */
  groups: Array<UnsignedOperationDetailsDeltaListGroup>;
  /** title is the title of the list of changes */
  title: UnsignedOperationDetailsText;
  /**
   * type is the type of the list of changes, indicating whether the list is
   * being added, removed, or is neutral
   */
  type: UnsignedOperationDetailsDeltaListType;
};

/** UnsignedOperationDetailsDeltaListGroup is a group of items in a list of changes. */
export type UnsignedOperationDetailsDeltaListGroup = {
  __typename: 'UnsignedOperationDetailsDeltaListGroup';
  /** items is the list of text items in the group */
  items: Array<UnsignedOperationDetailsText>;
  /**
   * layout is the layout of the items in the group. Determines whether
   * the items in the list group should be rendered inline or stacked.
   */
  layout: UnsignedOperationDetailsDeltaListGroupLayout;
  /** title is the title of the group of items */
  title: Maybe<UnsignedOperationDetailsText>;
};

/**
 * UnsignedOperationDetailsDeltaListGroupLayout indicates how items in a group
 * should be rendered.
 */
export enum UnsignedOperationDetailsDeltaListGroupLayout {
  /** Items in this group should be rendered inline, separated by commas. */
  INLINE = 'INLINE',
  /** Items in this group should be rendered in a stack, one per row. */
  STACKED = 'STACKED'
}

/**
 * UnsignedOperationDetailsDeltaListType indicates the type of changes in the list.
 * This is used to determine how the list should be rendered in the app.
 */
export enum UnsignedOperationDetailsDeltaListType {
  /** The list is being added. */
  ADDED = 'ADDED',
  /** The list is unchanged, or is undergoing changes other than adding or removing. */
  NEUTRAL = 'NEUTRAL',
  /** The list is being removed. */
  REMOVED = 'REMOVED'
}

/**
 * UnsignedOperationDetailsDeltaSection is a section of changes in the payload.
 * This is used to display grouped changes by a common theme or context.
 */
export type UnsignedOperationDetailsDeltaSection = {
  __typename: 'UnsignedOperationDetailsDeltaSection';
  /** lists is the list of fields to display */
  lists: Array<UnsignedOperationDetailsDeltaList>;
  /** title is the optional title of the section */
  title: Maybe<UnsignedOperationDetailsText>;
};

/** UnsignedOperationDetailsDivider is a divider between fields. */
export type UnsignedOperationDetailsDivider = {
  __typename: 'UnsignedOperationDetailsDivider';
  /** style is the style of the divider. */
  style: UnsignedOperationDetailsDividerStyle;
};

/** UnsignedOperationDetailsDividerStyle indicates the style of the divider. */
export enum UnsignedOperationDetailsDividerStyle {
  /** A thin divider. */
  THIN = 'THIN'
}

/** UnsignedOperationDetailsHighlight expresses an unsigned highlight of changes. */
export type UnsignedOperationDetailsHighlight = {
  __typename: 'UnsignedOperationDetailsHighlight';
  /** badge is the descriptive title of the highlight */
  badge: Maybe<UnsignedOperationDetailsText>;
  /** content is the content of the highlight */
  content: UnsignedOperationDetailsHighlightContent;
  /** description is the description of the highlight */
  description: Maybe<UnsignedOperationDetailsText>;
};

/** UnsignedOperationDetailsHighlightContent is a list of changes in the highlight. */
export type UnsignedOperationDetailsHighlightContent = {
  __typename: 'UnsignedOperationDetailsHighlightContent';
  /** elements is the list of text items with a render type in the highlight. */
  elements: Array<UnsignedOperationDetailsHighlightElement>;
};

/**
 * UnsignedOperationDetailsHighlightElement indicates how items in a highlight
 * should be rendered.
 */
export type UnsignedOperationDetailsHighlightElement = {
  __typename: 'UnsignedOperationDetailsHighlightElement';
  /** text is the value of the element */
  text: UnsignedOperationDetailsText;
  /**
   * type is the type of the change, indicating whether the change is
   * being added, removed, or is neutral
   */
  type: UnsignedOperationDetailsHighlightElementType;
};

/**
 * UnsignedOperationDetailsHighlightElementType indicates how elements in a highlight
 * should be rendered.
 */
export enum UnsignedOperationDetailsHighlightElementType {
  /** The element is being added. */
  ADDED = 'ADDED',
  /** The element is unchanged. */
  NEUTRAL = 'NEUTRAL',
  /** The element is being removed. */
  REMOVED = 'REMOVED'
}

/** UnsignedOperationDetailsText is the details for a text field */
export type UnsignedOperationDetailsText = {
  __typename: 'UnsignedOperationDetailsText';
  /** detail is the text to display in addition or instead of the fallbacktext */
  detail: Scalars['String']['output'];
};

/** UnsignedOperationDetailsTransaction expresses the details of a transaction like the id and explorer url */
export type UnsignedOperationDetailsTransaction = {
  __typename: 'UnsignedOperationDetailsTransaction';
  /** explorerURL is the url to the explorer for the transaction */
  explorerURL: Scalars['String']['output'];
  /** id is the transaction id */
  id: Scalars['String']['output'];
};

/**
 * UnsignedOperationField is filled in by the backend and is not signed by the user
 * The app is always expected to call label and fallbackText but details may be null
 */
export type UnsignedOperationField = {
  __typename: 'UnsignedOperationField';
  /** details provides additional information about the field */
  details: Maybe<UnsignedOperationDetails>;
  /** For use when the app doesn't support the specific type yet. */
  fallbackText: Scalars['String']['output'];
  /** label is string to describe the field */
  label: Scalars['String']['output'];
};

/** UnsupportedAssetAmount is similar to Amount but for unsupported assets which can't resolve normal types. */
export type UnsupportedAssetAmount = _commonAmount & {
  __typename: 'UnsupportedAssetAmount';
  /** The asset id for this amount */
  assetID: Scalars['String']['output'];
  /** Further information regarding this asset type */
  assetTypeInfo: EEAssetTypeInfo;
  /**
   * The value for this amount formatted for display to a user, in the US format.
   * Includes commas, dollar sign for USD, but no unit type for non-USD amounts.
   */
  displayValue: Scalars['String']['output'];
  /**
   * The USD value for this amount formatted for display to a user, including commas
   * and the preceding dollar sign. Ex: $1,234.56
   */
  displayValueInUSD: Scalars['String']['output'];
  /**
   * The value for this amount, rounded to 4 decimal places without trailing zeros,
   * in the US format.
   * Includes commas, dollar sign for USD, but no unit type for non-USD amounts.
   */
  displayValueShort: Scalars['String']['output'];
  /** Id for token like assets */
  tokenID: Maybe<Scalars['String']['output']>;
  /** The value for this amount */
  value: Scalars['String']['output'];
  /** The value in USD at the current exchange rate */
  valueInUSD: Scalars['String']['output'];
};

/** UnsupportedAssetAssetTypeInfo is similar to AssetTypeInfo but for unsupported assets which can't resolve normal types. */
export type UnsupportedAssetAssetTypeInfo = _commonAssetTypeInfo & {
  __typename: 'UnsupportedAssetAssetTypeInfo';
  /** Abbreviation of the asset type */
  abbreviation: Scalars['String']['output'];
  /** The ID of the asset type */
  assetID: Scalars['String']['output'];
  /** The max amount we can expect to withdraw for fees, used for checking balances prior to making a transfer and erroring sooner */
  feeThreshold: EEAmount;
  /**
   * iconURL returns the url for fetching the icon for this asset.
   * If the type is SVG, the size is ignored.
   * Icons are square.
   * The size is in pixels.
   */
  iconURL: Scalars['String']['output'];
  /** The number of decimal places allowed for this asset type */
  maxPrecision: Scalars['String']['output'];
  /** Name of the asset type */
  name: Scalars['String']['output'];
  /** NetworkInfo returns information about the blockchain network on which units of this assetTypeID are transacted - nullable in case asset type does not have a network */
  networkInfo: Maybe<EENetworkInfo>;
  /** Value of the asset type (as a raw decimal value) */
  value: Scalars['String']['output'];
};


/** UnsupportedAssetAssetTypeInfo is similar to AssetTypeInfo but for unsupported assets which can't resolve normal types. */
export type UnsupportedAssetAssetTypeInfoiconURLArgs = {
  iconType?: IconType;
  size?: Scalars['Int']['input'];
};

/** UnsupportedAssetNetworkInfo is similar to NetworkInfo but for unsupported assets which can't resolve normal types. */
export type UnsupportedAssetNetworkInfo = _commonNetworkInfo & {
  __typename: 'UnsupportedAssetNetworkInfo';
  /** id is the unique identifier of the network, equal to networkID */
  id: Scalars['ID']['output'];
  /** Returns the name of the Network in the form of a string */
  name: Scalars['String']['output'];
  /** Returns the ID of the Network */
  networkID: Scalars['ID']['output'];
};

export type UntagTaxTransactionInput = {
  /** The organization key ID */
  organizationKeyId: Scalars['String']['input'];
  /** The subaccount where the transaction occurred */
  subaccountId: Scalars['String']['input'];
  /** The external transaction ID (deposit/withdrawal ID from custody) */
  transactionId: Scalars['String']['input'];
};

export type UntagTaxTransactionPayload = {
  __typename: 'UntagTaxTransactionPayload';
  /** Error message if operation failed */
  error: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Update a brokerage account */
export type UpdateAccountInput = {
  /** Enable or disable trading for the given ID */
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Brokerage account ID */
  id: Scalars['ID']['input'];
  /** Trading account credit limits */
  limits?: InputMaybe<Array<AmountInput>>;
  /** Set the brokerage account name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Update account result */
export type UpdateAccountResult = {
  __typename: 'UpdateAccountResult';
  /** updated identifier */
  id: Scalars['String']['output'];
  /** error message */
  message: Maybe<Scalars['String']['output']>;
};

/** Result of updating an affiliate KYC profile name */
export type UpdateAffiliateKycProfileNameResult = {
  __typename: 'UpdateAffiliateKycProfileNameResult';
  /** The affiliate KYC profile ID */
  affiliateKycProfileID: Scalars['ID']['output'];
  /** The updated name */
  name: Scalars['String']['output'];
};

export type UpdateAssetInput = {
  /** Optional metadata for the asset */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** The name of the asset */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The symbol of the asset */
  symbol?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAssetSupportInput represents the input needed to update the support for a given asset
 * like an ERC-20 or Solana SPL token.
 */
export type UpdateAssetSupportInput = {
  /**
   * Optional asset abbreviation that will be updated.
   * Example: "MKR" as a short form of the token name
   */
  abbrev?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of the asset that is being updated.
   * Example: "MKR" the Maker assetTypeID
   */
  assetTypeID: Scalars['String']['input'];
  /**
   * Optional asset decimals that will be updated.
   * Example: "18" indicating MKR's divisibility
   */
  decimals?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional asset name that will be updated.
   * Example: "Maker"
   */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateAtlasParticipantResult type represents the result of updating the atlas participant associated with a participant. */
export type UpdateAtlasParticipantForStablecoinRewardsResult = {
  __typename: 'UpdateAtlasParticipantForStablecoinRewardsResult';
  /** Unique identifier for the updated participant */
  participantID: Scalars['ID']['output'];
};

export type UpdateCSAInput = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  ironcladUrl?: InputMaybe<Scalars['String']['input']>;
  isdaAgreementId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  pricingSource?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Time']['input'];
  type: DVCSAType;
  valuationAgent: DVPartyType;
  variableImApplies?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCSAMarginTermsInput = {
  currency: Scalars['ID']['input'];
  mta: Scalars['String']['input'];
  party: Scalars['String']['input'];
  rounding?: InputMaybe<Scalars['Int']['input']>;
  thresholdAmount?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCollateralRuleInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  concentrationLimitPercent?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  valuationPercentage?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a control agreement's documentID */
export type UpdateControlAgreementDocumentIDInput = {
  /** The control agreement ID to update */
  controlAgreementID: Scalars['ID']['input'];
  /** The new document ID value (can be null to clear) */
  documentID?: InputMaybe<Scalars['ID']['input']>;
};

/** Response after updating a control agreement's documentID */
export type UpdateControlAgreementDocumentIDResponse = {
  __typename: 'UpdateControlAgreementDocumentIDResponse';
  /** The updated control agreement */
  controlAgreement: GDFControlAgreement;
};

export type UpdateCounterpartyAccountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  /**
   * metadata is a json map of account metadata
   * For A1_DERIVATIVES accounts, add elwood related fields with keys
   * as defined in tradingdataprovider.CounterpartyAccountMetadataKey
   */
  metadata?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a counterparty */
export type UpdateCounterpartyInput = {
  /** New activity status of the counterparty */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** New display name of the counterparty */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** JSON Metadata for the counterparty */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** New name of the counterparty */
  name?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the parent counterparty */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCounterpartyMasterCopyInput = {
  accountControlAgreementExecuted?: InputMaybe<Scalars['String']['input']>;
  accountControlAgreementRequired?: InputMaybe<Scalars['Boolean']['input']>;
  anchorageEntity?: InputMaybe<Scalars['String']['input']>;
  annexAQuestionnaireReceivedDate?: InputMaybe<Scalars['Date']['input']>;
  approverDate?: InputMaybe<Scalars['Date']['input']>;
  approverName?: InputMaybe<Scalars['String']['input']>;
  bilateralAgreementExecutedDate?: InputMaybe<Scalars['Date']['input']>;
  countryOfIncorporation?: InputMaybe<Scalars['String']['input']>;
  creditQuestionnaireReceivedDate?: InputMaybe<Scalars['Date']['input']>;
  crossBorderMarginClassification?: InputMaybe<Scalars['String']['input']>;
  csaRequired?: InputMaybe<Scalars['Boolean']['input']>;
  designatedEvaluationAgent?: InputMaybe<Scalars['String']['input']>;
  dfComplianceRoute?: InputMaybe<Scalars['String']['input']>;
  dfProtocolAdherenceIdP1?: InputMaybe<Scalars['String']['input']>;
  dfProtocolAdherenceIdP2?: InputMaybe<Scalars['String']['input']>;
  dfProtocolReconciliation?: InputMaybe<Scalars['String']['input']>;
  disclosurePackAccessGranted?: InputMaybe<Scalars['Boolean']['input']>;
  ecpCategory?: InputMaybe<Scalars['String']['input']>;
  ecpEvidenceDocReference?: InputMaybe<Scalars['String']['input']>;
  ecpVerificationResult?: InputMaybe<Scalars['String']['input']>;
  endUserExceptionFilingRoute?: InputMaybe<Scalars['String']['input']>;
  endUserExceptionStandingElection?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionSubstitutedCompliance?: InputMaybe<Scalars['String']['input']>;
  exemptionType?: InputMaybe<Scalars['String']['input']>;
  fcsSubsidiaryOfUsParent?: InputMaybe<Scalars['Boolean']['input']>;
  federalEntity?: InputMaybe<Scalars['Boolean']['input']>;
  feuDetermination?: InputMaybe<Scalars['String']['input']>;
  financialCompanyTitleIi?: InputMaybe<Scalars['Boolean']['input']>;
  financialEntityStatus?: InputMaybe<Scalars['Boolean']['input']>;
  goodToTrade?: InputMaybe<Scalars['Boolean']['input']>;
  goodToTradeDate?: InputMaybe<Scalars['Date']['input']>;
  guaranteedByUsPerson?: InputMaybe<Scalars['Boolean']['input']>;
  guarantorAddress?: InputMaybe<Scalars['String']['input']>;
  guarantorExists?: InputMaybe<Scalars['Boolean']['input']>;
  guarantorLei?: InputMaybe<Scalars['String']['input']>;
  guarantorName?: InputMaybe<Scalars['String']['input']>;
  imSegregationAccountReference?: InputMaybe<Scalars['String']['input']>;
  imSegregationCustodian?: InputMaybe<Scalars['String']['input']>;
  imSegregationElection?: InputMaybe<Scalars['Boolean']['input']>;
  initialMarginCsaExecuted?: InputMaybe<Scalars['String']['input']>;
  institutionalSuitabilitySafeHarborBasis?: InputMaybe<Scalars['String']['input']>;
  insuredDepositoryInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  internalCounterpartyId?: InputMaybe<Scalars['String']['input']>;
  isdaMasterAgreementExecuted?: InputMaybe<Scalars['Boolean']['input']>;
  isdaScheduleExecuted?: InputMaybe<Scalars['Boolean']['input']>;
  kycCustomerTypePrimary?: InputMaybe<Scalars['String']['input']>;
  kycCustomerTypeSecondary?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  lei?: InputMaybe<Scalars['String']['input']>;
  marginExemptionElections?: InputMaybe<Scalars['String']['input']>;
  marginRegime?: InputMaybe<Scalars['String']['input']>;
  materialSwapsExposure?: InputMaybe<Scalars['Boolean']['input']>;
  mseRiderAsOfDate?: InputMaybe<Scalars['Date']['input']>;
  mseRiderStatus?: InputMaybe<Scalars['String']['input']>;
  mseStatus?: InputMaybe<Scalars['String']['input']>;
  nonFeuRepresentation?: InputMaybe<Scalars['Boolean']['input']>;
  nonUsMarginRegimeInScope?: InputMaybe<Scalars['Boolean']['input']>;
  noticesEmail?: InputMaybe<Scalars['String']['input']>;
  notificationsDisclosuresEmail?: InputMaybe<Scalars['String']['input']>;
  portfolioDataEmail?: InputMaybe<Scalars['String']['input']>;
  portfolioReconciliationMethod?: InputMaybe<Scalars['String']['input']>;
  ppobLocation?: InputMaybe<Scalars['String']['input']>;
  preparerDate?: InputMaybe<Scalars['Date']['input']>;
  preparerName?: InputMaybe<Scalars['String']['input']>;
  principalAgentCapacity?: InputMaybe<Scalars['String']['input']>;
  reconcileAgainstSdrDataAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  reportingPartyAgreementDate?: InputMaybe<Scalars['Date']['input']>;
  reportingPartyAgreementDocReference?: InputMaybe<Scalars['String']['input']>;
  reportingPartyAgreementMethod?: InputMaybe<Scalars['String']['input']>;
  reportingPartyNegotiationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reportingPartyOutcome?: InputMaybe<Scalars['String']['input']>;
  riskValuationDisputeResolution?: InputMaybe<Scalars['String']['input']>;
  riskValuationEmail?: InputMaybe<Scalars['String']['input']>;
  sdlPartsReturned?: InputMaybe<Scalars['String']['input']>;
  sdlReceivedDate?: InputMaybe<Scalars['Date']['input']>;
  sdlSentDate?: InputMaybe<Scalars['Date']['input']>;
  sdlSignatoryName?: InputMaybe<Scalars['String']['input']>;
  sdlSignatoryTitle?: InputMaybe<Scalars['String']['input']>;
  specialEntityReview?: InputMaybe<Scalars['String']['input']>;
  thirdPartyControlPerson?: InputMaybe<Scalars['String']['input']>;
  tradeReportingEngineUpdatedDate?: InputMaybe<Scalars['Date']['input']>;
  tradingAuthorizationDocReference?: InputMaybe<Scalars['String']['input']>;
  tradingAuthorizationStatus?: InputMaybe<Scalars['String']['input']>;
  tradingSupervisorCountries?: InputMaybe<Scalars['String']['input']>;
  tradingSupervisors?: InputMaybe<Scalars['String']['input']>;
  ultimateUsParentName?: InputMaybe<Scalars['String']['input']>;
  usPersonConduit?: InputMaybe<Scalars['Boolean']['input']>;
  usPersonFinal?: InputMaybe<Scalars['String']['input']>;
  usPersonStatus?: InputMaybe<Scalars['String']['input']>;
  variationMarginCsaExecuted?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing custodian. */
export type UpdateCustodianInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  microtransaction?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requireWetSignature?: InputMaybe<Scalars['Boolean']['input']>;
  /** Replaces the custodian's transfer types when set. Omit to keep the current ones. */
  transferTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDVAccountInput = {
  /**
   * Sets this account's automation cutoff date. One-way: once true, cannot be set back to false. The
   * entity-level flag remains the overall enablement gate for obligation/ledger automation; setting
   * this true does not itself enable automation for the account, it supplies the cutoff date a
   * historical (pre-automation) write is checked against, so a trade whose own due date predates it
   * is blocked rather than silently backdated.
   */
  automateObligationsAndLedgerEntries?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Clears harukoTripartyVenueId. A nullable Int input cannot distinguish "unset" from
   * "unchanged", so this flag is separate; when both are set, harukoTripartyVenueId wins.
   */
  clearHarukoTripartyVenueId?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contact email addresses */
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ignored. */
  counterpartyId?: InputMaybe<Scalars['ID']['input']>;
  /** Counterparty master copy this account is linked to. Pass an empty string to clear the link. */
  counterpartyMasterCopyId?: InputMaybe<Scalars['ID']['input']>;
  /** The counterparty name */
  counterpartyName?: InputMaybe<Scalars['String']['input']>;
  /** The country code (ISO 3166-1 alpha-2) */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Fixing source pre-filled on trades ingested for this account: CME, DERIBIT or ANCHORAGE. Requires a BASE or QUOTE defaultSettlementType. Omit to keep the current value; pass an empty string to clear it. */
  defaultFixingSource?: InputMaybe<Scalars['String']['input']>;
  /** Stages trades ingested for this account as post-priced when true. Omit to keep the current value. */
  defaultPostPriced?: InputMaybe<Scalars['Boolean']['input']>;
  /** Premium timing pre-filled on trades ingested for this account: UPFRONT or AT_EXPIRY. Requires defaultPremiumCurrencyType. Omit to keep the current value; pass an empty string to clear it. */
  defaultPremiumCurrencyTimingType?: InputMaybe<Scalars['String']['input']>;
  /** Premium currency type pre-filled on trades ingested for this account: BASE or QUOTE. Omit to keep the current value; pass an empty string to clear it. */
  defaultPremiumCurrencyType?: InputMaybe<Scalars['String']['input']>;
  /** Settlement type pre-filled on trades ingested for this account: PHYSICAL, BASE or QUOTE. BASE and QUOTE require defaultFixingSource. Omit to keep the current value; pass an empty string to clear it. */
  defaultSettlementType?: InputMaybe<Scalars['String']['input']>;
  /** Whether the account is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Entity ID - the trading entity (A1 Derivatives, Swap Dealer, HedgeCo) this account faces */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** Haruko Mask */
  harukoMask?: InputMaybe<Scalars['String']['input']>;
  /** Haruko triparty venue ID, distinct from harukoVenueId */
  harukoTripartyVenueId?: InputMaybe<Scalars['Int']['input']>;
  /** Haruko Venue ID */
  harukoVenueId?: InputMaybe<Scalars['Int']['input']>;
  /** Stops all reporting of this account to ICE (Part 45 EOD and live trade reports) when true. Omit to keep the current value. */
  iceReportingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legal Entity Identifier */
  legalEntityIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Date of master confirmation */
  masterConfirmationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Optional metadata for the account */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** The name of the account */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name to report to the SDR. Pass an empty string to clear it and go back to reporting the account name. */
  sdrReportingName?: InputMaybe<Scalars['String']['input']>;
  /** Who is updating the account */
  updatedBy: Scalars['String']['input'];
};

export type UpdateDVEntityInput = {
  /** The name of the entity */
  entityName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the entity is a CFTC financial entity, sent as Counterparty 1 financial entity in its SDR reports */
  financialEntityStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Haruko venue account this entity's trades are booked under */
  harukoVenueId?: InputMaybe<Scalars['Int']['input']>;
  /** ICE company batch id this entity's SDR reports are submitted under */
  iceCompanyBatchId?: InputMaybe<Scalars['String']['input']>;
  /** Legal Entity Identifier (LEI) */
  lei?: InputMaybe<Scalars['String']['input']>;
  /** Legacy, no longer read: automation depends only on the account's automateObligationsAndLedgerEntries. */
  settlementAutomationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** UpdateDefaultBankForOrgResponse type represents the response for updating default bank for organization */
export type UpdateDefaultBankForOrgResponse = {
  __typename: 'UpdateDefaultBankForOrgResponse';
  /** The bank name that was set */
  bankName: BankName;
  /** The organization ID */
  organizationKeyID: Scalars['String']['output'];
};

export type UpdateDefaultStakingFeeTermsInput = {
  fees: Array<StakingFeeInput>;
};

export type UpdateDefaultStakingFeeTermsPayload = {
  __typename: 'UpdateDefaultStakingFeeTermsPayload';
  success: Scalars['Boolean']['output'];
};

/**
 * UpdateDepositAttributionSpamThresholdInput is used for update DepositAttributionSpamThreshold object.
 * Input was generated by ent.
 */
export type UpdateDepositAttributionSpamThresholdInput = {
  autoAttribute?: InputMaybe<Scalars['Boolean']['input']>;
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  threshold?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateDerivsEntityBankAccountInput = {
  /** 4 to 17 digits. */
  accountNumber: Scalars['String']['input'];
  bank: DerivsBank;
  bankadapterAccountId?: InputMaybe<Scalars['String']['input']>;
  entity: DerivsEntity;
  id: Scalars['ID']['input'];
  orgId: Scalars['String']['input'];
  partyAddress: DerivsPartyAddressInput;
  partyName: Scalars['String']['input'];
  /** Exactly 9 digits. */
  routingNumber: Scalars['String']['input'];
};

export type UpdateDerivsEntityWalletInput = {
  asset: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  /** The custody OrganizationKeyID of the API key that owns the wallet. */
  orgId: Scalars['String']['input'];
  walletId: Scalars['String']['input'];
};

export type UpdateDerivsEntityWalletPayload = {
  __typename: 'UpdateDerivsEntityWalletPayload';
  entityWallet: DerivsEntityWallet;
};

export type UpdateDerivsTrustedDestinationInput = {
  /** Exactly 4 digits. */
  accountLast4: Scalars['String']['input'];
  /** The id of a fiat Trusted Destination the LABS custody organization can see. */
  custodyTrustedDestinationId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Input for updating an existing DocuSign workflow configuration. */
export type UpdateDocuSignWorkflowInput = {
  custodianId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExposureResult = {
  __typename: 'UpdateExposureResult';
  success: Scalars['Boolean']['output'];
};

/** UpdateIAMRoleUsersInput is used for batch updating users roles. */
export type UpdateIAMRoleUsersInput = {
  addUserIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  removeUserIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceIDs: Array<Scalars['String']['input']>;
  roleID: Scalars['String']['input'];
};

/**
 * UpdateKYCConfigInput is used for update KYCConfig object.
 * Input was generated by ent.
 */
export type UpdateKYCConfigInput = {
  clearOrganizationKeyID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTermsAndConditionsDocusignTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  relianceModel?: InputMaybe<KYCConfigRelianceModel>;
  termsAndConditionsDocusignTemplate?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsModel?: InputMaybe<KYCConfigTermsAndConditionsModel>;
};

/**
 * UpdateKYCProcessTriggerInput is used for update KYCProcessTrigger object.
 * Input was generated by ent.
 */
export type UpdateKYCProcessTriggerInput = {
  /** The actions to be executed when the trigger is fired. */
  actions?: InputMaybe<Array<KYCProcessTriggerActionInput>>;
  /** Type of the affiliate */
  affiliateType?: InputMaybe<Scalars['String']['input']>;
  /** Type of anchorage entity */
  anchorageEntityType?: InputMaybe<Scalars['String']['input']>;
  /** The conditions to be validated when the trigger is fired. */
  conditions?: InputMaybe<Array<KYCProcessTriggerConditionInput>>;
  /** The current state of the Jira case. */
  currentJiraState?: InputMaybe<Scalars['String']['input']>;
  /** The type of the Jira case. */
  jiraCaseType?: InputMaybe<Scalars['String']['input']>;
  /** The previous state of the Jira case. */
  previousJiraState?: InputMaybe<Scalars['String']['input']>;
  /** Priority of the process trigger */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateKYCQuestionInput is used for update KYCQuestion object.
 * Input was generated by ent.
 */
export type UpdateKYCQuestionInput = {
  /** The categories of the questionnaire */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Customer types this question applies to. Replaces the entire list when provided. */
  customerTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The information type of the questionnaire */
  informationType?: InputMaybe<Scalars['String']['input']>;
  /** Name of the questionnaire */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The question definition of the questionnaire */
  questionDefinition?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateKYCQuestionnaireInput is used for update KYCQuestionnaire object.
 * Input was generated by ent.
 */
export type UpdateKYCQuestionnaireInput = {
  /** The questionnaire element body, it's a JSON string of KYCQuestionnaireElement type */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The categories of the questionnaire */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Number to days after which the questionnaire expires */
  expirationDays?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the questionnaire */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of the questionnaire */
  questionnaireType?: InputMaybe<KYCQuestionnaireType>;
  /** The URL associated with the questionnaire */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateKYCQuestionnaireSubmissionInput is the input for UpdateKYCQuestionnaireSubmission. */
export type UpdateKYCQuestionnaireSubmissionInput = {
  /** The case ID associated with the submission. */
  caseID?: InputMaybe<Scalars['String']['input']>;
  /** When true, clears the persisted caseID. Cannot be set together with caseID. */
  clearCaseID?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When true, clears the persisted questionnaireID, reverting the submission to a
   * custom (template-less) RFI draft. The prior body is not carried over — a
   * selectedQuestions list supplied in the same call becomes the new custom
   * selection; omitting it starts from an empty draft. Cannot be set together
   * with questionnaireID.
   */
  clearQuestionnaireID?: InputMaybe<Scalars['Boolean']['input']>;
  /** The description of the submission. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the submission. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Free-form custom message stored on the submission. For RFI submissions, a non-empty value
   * renders as an "Introduction → Message → Message from Anchorage Digital" intro panel
   * at the top of the body.
   */
  notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * The per-question notes.
   * @deprecated Use selectedQuestions instead.
   */
  questionNotes?: InputMaybe<Array<KYCQuestionnaireSubmissionQuestionNoteInput>>;
  /** The identifier of the KYCQuestionnaire. */
  questionnaireID?: InputMaybe<Scalars['ID']['input']>;
  /** The representative to associate with the submission. */
  representative?: InputMaybe<RepresentativeInput>;
  /**
   * The selected question IDs.
   * @deprecated Use selectedQuestions instead.
   */
  selectedQuestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The questions to include in the rebuilt body, each optionally annotated with a note.
   * Replaces the entire question set; pass the full list each time. Ignored when
   * reassigning to a different questionnaireID — the new template's own body is
   * always used from scratch rather than a prior picker selection.
   */
  selectedQuestions?: InputMaybe<Array<KYCQuestionnaireSubmissionSelectedQuestionInput>>;
  /** The identifier of the submission to update. */
  submissionID: Scalars['ID']['input'];
};

export type UpdateLoanResult = {
  __typename: 'UpdateLoanResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateNettingSetInput = {
  baseAssetId?: InputMaybe<Scalars['ID']['input']>;
  collateralizationCategory?: InputMaybe<DVCollateralizationCategory>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['String']['input']>;
  restrictToAssetId?: InputMaybe<Scalars['ID']['input']>;
  terminationAssetId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNettingSetParamsInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  mta?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['String']['input']>;
  rounding?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  thresholdAmount?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNettingSetRuleInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  mta?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['String']['input']>;
  rounding?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  thresholdAmount?: InputMaybe<Scalars['String']['input']>;
  valuationPercentage?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateOrgPoliciesOperation represents an operation where multiple organization policies are updated */
export type UpdateOrgPoliciesOperation = Operation & {
  __typename: 'UpdateOrgPoliciesOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** iamChanges represents the JSON encoded IAM changes that will be applied with this operation. */
  iamChanges: Maybe<Scalars['OperationIAMChanges']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy required in order to satisfy this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /** Policy Container updates being applied by this operation */
  policyContainerUpdate: Maybe<PolicyContainerUpdate>;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** roleChanges represents the IAM role changes that will be applied with this operation. */
  roleChanges: Maybe<IAMRoleChanges>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * Policies being updated by this operation
   * @deprecated use policyContainerUpdate
   */
  updatedPolicies: Array<PolicyUpdate>;
};


/** UpdateOrgPoliciesOperation represents an operation where multiple organization policies are updated */
export type UpdateOrgPoliciesOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** UpdateOrgPoliciesOperation represents an operation where multiple organization policies are updated */
export type UpdateOrgPoliciesOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** Result of updating an organization KYC profile name */
export type UpdateOrganizationKycProfileNameResult = {
  __typename: 'UpdateOrganizationKycProfileNameResult';
  /** The updated name */
  name: Scalars['String']['output'];
  /** The organization KYC profile ID */
  organizationKycProfileID: Scalars['ID']['output'];
};

export type UpdatePolicyV2Input = {
  clientID: Scalars['ID']['input'];
  defaultRule?: InputMaybe<RuleInput>;
  keyAccesses?: InputMaybe<KeyAccessDeltaInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policyID: Scalars['ID']['input'];
  /**
   * Resources the policy applies to. Null/omitted means no change to existing
   * assignments and is valid for any policy. Empty ([]) is rejected — it has no
   * meaningful semantics on an update. Pass a non-empty list to assign or
   * reassign (this mutation cannot remove resources; that happens only via the
   * disable-vault operation).
   */
  resourceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  specificRules?: InputMaybe<RuleDeltaInput>;
};

/** UpdatePrimaryBankForWalletResponse type represents the response for updating primary bank for wallet */
export type UpdatePrimaryBankForWalletResponse = {
  __typename: 'UpdatePrimaryBankForWalletResponse';
  /** The bank name that was set */
  bankName: BankName;
  /** The wallet ID */
  walletID: Scalars['String']['output'];
};

/** Input for updating the primary dispatch method of a custodian. */
export type UpdatePrimaryDispatchMethodInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  custodianId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  /** The base asset ID */
  baseId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional metadata for the product */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** The exercise style of the option */
  optionExerciseStyle?: InputMaybe<OptionExerciseStyle>;
  /** The type of option (call/put) */
  optionType?: InputMaybe<OptionType>;
  /** The type of financial product */
  productType?: InputMaybe<ProductType>;
  /** The quote asset ID */
  quoteId?: InputMaybe<Scalars['ID']['input']>;
};

/** UpdateRelatedPartyAndRelationshipsInput is used to update a related party's information. */
export type UpdateRelatedPartyAndRelationshipsInput = {
  /** The affiliate KYC profile ID */
  affiliateKYCProfileID: Scalars['ID']['input'];
  /** Email address */
  email: Scalars['String']['input'];
  /** Additional PII entries */
  entries?: InputMaybe<Array<InputIndividualInformation>>;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Job title (required for control persons and other) */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** KYC roles for this relationship */
  kycRoles: Array<KYCRoleType>;
  /** KYC screening audit information */
  kycScreening?: InputMaybe<KYCScreeningInput>;
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Middle name (can be empty string if none) */
  middleName: Scalars['String']['input'];
  /** Ownership percentage (required for beneficial owners, 0-100%) */
  ownershipPercentage?: InputMaybe<Scalars['String']['input']>;
  /** The related party KYC profile ID to update */
  relatedPartyKYCProfileID: Scalars['ID']['input'];
  /**
   * The representative for form submission. Preferred over the deprecated
   * representativeEmail/representativeName fields.
   */
  representative?: InputMaybe<RepresentativeInput>;
  /**
   * Representative email for form submission
   * @deprecated Use the representative input instead.
   */
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  /**
   * Representative name for form submission
   * @deprecated Use the representative input instead.
   */
  representativeName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateRelatedPartyKycProfileInput is used to update a related party's information.
 * Note: relatedPartyType cannot be changed after creation.
 */
export type UpdateRelatedPartyKycProfileInput = {
  /** The affiliate KYC profile ID this relationship is associated with */
  affiliateKYCProfileID: Scalars['ID']['input'];
  /** Country code (e.g., 'US', 'GB') */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Additional profile information as key-value pairs */
  entries?: InputMaybe<Array<InputInfoType>>;
  /** First name (for individuals, used to construct fullName if provided) */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the related party (optional, can be updated) */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** KYC roles for this relationship */
  kycRoles?: InputMaybe<Array<KYCRoleType>>;
  /** KYC screening audit information */
  kycScreening?: InputMaybe<KYCScreeningInput>;
  /** Last name (for individuals, used to construct fullName if provided) */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Middle name (for individuals, can be empty string if none) */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership percentage (0-100%) */
  ownershipPercentage?: InputMaybe<Scalars['String']['input']>;
  /** The related party KYC profile ID to update */
  relatedPartyKYCProfileID: Scalars['ID']['input'];
  /**
   * The representative for form submission. Preferred over the deprecated
   * representativeEmail/representativeName fields.
   */
  representative?: InputMaybe<RepresentativeInput>;
  /**
   * Representative email for form submission
   * @deprecated Use the representative input instead.
   */
  representativeEmail?: InputMaybe<Scalars['String']['input']>;
  /**
   * Representative name for form submission
   * @deprecated Use the representative input instead.
   */
  representativeName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional status override. When provided, sets the profile status directly
   * instead of calculating it based on KYC requirements.
   */
  status?: InputMaybe<KYCStatus>;
};

/**
 * UpdateReportScheduleInput is used for update ReportSchedule object.
 * Input was generated by ent.
 */
export type UpdateReportScheduleInput = {
  /** dataFilters will replace all existing data filters for the report schedule. */
  dataFilters?: InputMaybe<Array<ReportFilterInput>>;
  /** 1-31. Use 0 to indicate null. Must be set to other than 0 when schedule is not daily. For non-daily reports, represents the day of week or month on which the report will be triggered */
  daysAfterNonDailyScheduleTypeToTrigger?: InputMaybe<Scalars['Int']['input']>;
  /**
   * emailDestinationConfigs will replace all existing email destinations for the report schedule,
   * each with an optional deliveryFileName; null leaves them unchanged and [] removes them all. An
   * alternative to emailDestinations; a request may set one of the two, not both.
   */
  emailDestinationConfigs?: InputMaybe<Array<CreateReportScheduleEmailDestinationInput>>;
  /**
   * emailDestinations will replace all existing email destinations for the report schedule with plain
   * addresses delivered under the default attachment file name; null leaves them unchanged and [] removes
   * them all. Use emailDestinationConfigs instead to set a deliveryFileName per destination; a request
   * may set one of the two, not both.
   */
  emailDestinations?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 0-23 */
  hourOfDay?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** organizationID should only be set by staff users. */
  organizationID?: InputMaybe<Scalars['String']['input']>;
  reportScheduleID: Scalars['ID']['input'];
  /** sftpDestinations should only be set by staff users. */
  sftpDestinations?: InputMaybe<Array<InputMaybe<CreateReportScheduleSftpDestinationInput>>>;
  /**
   * swiftDestinations will replace all existing SWIFT destinations for the report schedule.
   * Semantics are:
   * swiftDestinations: null // valid - Will not update swift dests
   * swiftDestinations: [] // valid - Remove all swift dests
   * swiftDestinations: [SWIFT_DESTINATION_UNSPECIFIED] // valid - remove all
   * swiftDestinations: [SWIFT_DESTINATION_UNSPECIFIED, SWIFT_DESTINATION_BLACKROCK] // valid - remove all
   * swiftDestinations: [SWIFT_DESTINATION_BLACKROCK, SWIFT_DESTINATION_UNSPECIFIED] // error - invalid list
   * swiftDestinations: [SWIFT_DESTINATION_BLACKROCK, null] // error - null not allowed
   */
  swiftDestinations?: InputMaybe<Array<ReportScheduleSwiftDestinationSwiftDestination>>;
};

/**
 * A partial update of a report type definition, where an absent field is left
 * alone, an explicit null clears the two clearable fields, and an empty string is
 * always a validation error rather than a clear.
 */
export type UpdateReportTypeDefinitionInput = {
  bqDataset?: InputMaybe<Scalars['String']['input']>;
  /**
   * Re-point the type at another BigQuery source, which reads the new view before
   * the write and stores what it read.
   */
  bqProject?: InputMaybe<Scalars['String']['input']>;
  bqView?: InputMaybe<Scalars['String']['input']>;
  /** Free-text description, cleared by an explicit null. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human label, which cannot be blanked. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * False is the soft delete and is refused while enabled schedules reference the
   * type, and the false-to-true transition is refused while a stored header or
   * filter names a column the snapshot no longer has.
   */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The report type to patch. */
  id: Scalars['ID']['input'];
  /**
   * Keep the legacy CSV header row: each emitted header's display name becomes its
   * header cell. Turn it on only for a type that replaces or shadows a legacy type.
   * While it is on, every display name must match ^[A-Za-z][A-Za-z0-9_]{0,62}$,
   * emitted display names must be unique ignoring case, and editing a display name
   * changes the header a client receives.
   */
  legacyHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The STRING column the generated query scopes rows by, cleared by an explicit
   * null only when the merged row's orgUserPermission is
   * REPORT_TYPE_PERMISSION_NO_ACCESS -- after which re-scoping is legal but inert
   * for organization users, because that permission can never come back.
   */
  orgColumnName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Access level for organization (non-staff) users, where
   * REPORT_TYPE_PERMISSION_NO_ACCESS is permanent: a type organizations could not
   * read has been generating files scoped to none of them, so access is never
   * granted back.
   */
  orgUserPermission?: InputMaybe<ReportTypeDefinitionOrgUserPermission>;
  /** Rendering format, which an immutable backing leaves no legal value to move to. */
  outputFormat?: InputMaybe<ReportTypeDefinitionOutputFormat>;
  /** Team accountable for this report type's alerts, which cannot be cleared. */
  owningTeam?: InputMaybe<ReportTypeDefinitionOwningTeam>;
  /** Access level for staff users, which cannot be cleared. */
  staffUserPermission?: InputMaybe<ReportTypeDefinitionStaffUserPermission>;
};

export type UpdateServiceFeeTermsInput = {
  /** Top level account id associated to the terms */
  accountIds: Array<Scalars['ID']['input']>;
  /** Agreement id associated to the terms */
  agreementId: Scalars['ID']['input'];
  /** Url to the agreement document for the service fee term */
  agreementUrl: Scalars['String']['input'];
  /** Defines if the terms renew automatically after the renewal term */
  autoRenewalEnabled: Scalars['Boolean']['input'];
  bespokeStakingTerms?: InputMaybe<StakingFeeTermsInput>;
  /** The actual details of the service fee terms (structure depends on the service type) */
  custodyTerms?: InputMaybe<CustodyFeeTermsDetailInput>;
  /** Date after which the fess are accrued */
  feeAccrualDate: Scalars['Date']['input'];
  /** Number of months after which the terms renew for a similar period */
  renewalTermMonths?: InputMaybe<Scalars['Int']['input']>;
  segregatedWalletsTerms?: InputMaybe<SegregatedWalletsFeeTermsInput>;
  /** Date when the billing terms start taking effect */
  startDate: Scalars['Date']['input'];
  /** Type of update to be applied to the service fee terms */
  updateType: ServiceFeeTermsUpdateType;
};

/** UpdateParticipantNotesResult type represents the result of updating the notes associated with a participant. */
export type UpdateStablecoinRewardsParticipantNotesResult = {
  __typename: 'UpdateStablecoinRewardsParticipantNotesResult';
  /** Unique identifier for the updated participant */
  participantID: Scalars['ID']['output'];
};

/** UpdateParticipantStartDateResult type represents the result of updating the start date associated with a participant. */
export type UpdateStablecoinRewardsParticipantStartDateResult = {
  __typename: 'UpdateStablecoinRewardsParticipantStartDateResult';
  /** Unique identifier for the updated participant */
  participantID: Scalars['ID']['output'];
};

/** UpdateProgramNotesResult type represents the result of updating the notes associated with a program. */
export type UpdateStablecoinRewardsProgramNotesResult = {
  __typename: 'UpdateStablecoinRewardsProgramNotesResult';
  /** Unique identifier for the updated program */
  programID: Scalars['ID']['output'];
};

/**
 * The full content of the new version. Every field replaces the value on the current version, so an omitted taxbitType,
 * taxbitSubtype or rationale is null on the new version
 */
export type UpdateTaxMappingInput = {
  /** Id of the active mapping to update */
  mappingId: Scalars['ID']['input'];
  rationale?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether operations of this type are sent to TaxBit. A reportable mapping requires taxbitType; a non-reportable
   * mapping must leave taxbitType and taxbitSubtype empty
   */
  reportable: Scalars['Boolean']['input'];
  taxbitSubtype?: InputMaybe<Scalars['String']['input']>;
  taxbitType?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateTenantInput */
export type UpdateTenantInput = {
  /** Taxbit's client identifier */
  clientID: Scalars['String']['input'];
  /** Taxbit's client secret */
  clientSecret: Scalars['String']['input'];
  /** Organization ID associated to the tenant */
  organizationKeyID: Scalars['String']['input'];
  /** Unique tenant identifier */
  tenantID: Scalars['String']['input'];
};

/** UpdateTierForEnrollmentResult type represents the result of updating the tier for an enrollment. */
export type UpdateTierForStablecoinRewardsEnrollmentResult = {
  __typename: 'UpdateTierForStablecoinRewardsEnrollmentResult';
  /** Unique identifier for the participant */
  participantID: Scalars['ID']['output'];
  /** Unique identifier for the program */
  programID: Scalars['ID']['output'];
};

export type UpdateTradeInput = {
  /** Barrier level -- required for EKO/EKI options, must be absent otherwise */
  barrier?: InputMaybe<Scalars['String']['input']>;
  /** Expiration time if applicable */
  expiration?: InputMaybe<Scalars['Time']['input']>;
  /** Premium per base unit */
  premiumPerBaseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Quantity closed out in base asset */
  quantityClosedOutBase?: InputMaybe<Scalars['String']['input']>;
  /** Current processing status of the trade */
  status?: InputMaybe<DVTradeStatus>;
  /** Strike price for the trade */
  strike?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing Talos account */
export type UpdateTradingTalosAccountInput = {
  /** Trading account ID for this Talos account */
  accountID?: InputMaybe<Scalars['String']['input']>;
  /** Alias for this account on the Talos side */
  accountTalosAlias?: InputMaybe<Scalars['String']['input']>;
  /** Organization key ID for this Talos account */
  organizationKeyID?: InputMaybe<Scalars['String']['input']>;
  /** Talos customer name */
  talosCustomer?: InputMaybe<Scalars['String']['input']>;
  /** Talos customer ID */
  talosCustomerID?: InputMaybe<Scalars['String']['input']>;
  /** Talos instance */
  talosInstance?: InputMaybe<TalosInstance>;
};

/** Input for updating a transfer asset. */
export type UpdateTransferAssetInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  eventMessage: Scalars['String']['input'];
  id: Scalars['String']['input'];
  networkId?: InputMaybe<Scalars['String']['input']>;
  walletAddress?: InputMaybe<Scalars['String']['input']>;
  walletId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing account transfer. */
export type UpdateTransferInput = {
  clTransferId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  dispatchedAt?: InputMaybe<Scalars['Time']['input']>;
  envelopeId?: InputMaybe<Scalars['String']['input']>;
  eventMessage: Scalars['String']['input'];
  failedReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  sendingCustodianId?: InputMaybe<Scalars['String']['input']>;
  settledAt?: InputMaybe<Scalars['Time']['input']>;
  transferStatus?: InputMaybe<Scalars['String']['input']>;
  vaultId?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateVaultPoliciesOperation represents an operation where multiple vault policies are updated */
export type UpdateVaultPoliciesOperation = Operation & {
  __typename: 'UpdateVaultPoliciesOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** iamChanges represents the JSON encoded IAM changes that will be applied with this operation. */
  iamChanges: Maybe<Scalars['OperationIAMChanges']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** the expected digest of the new organization after applying this change */
  newOrganizationDigest: Scalars['String']['output'];
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy required in order to satisfy this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** roleChanges represents the IAM role changes that will be applied with this operation. */
  roleChanges: Maybe<IAMRoleChanges>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * Policies being updated by this operation
   * @deprecated use vaultPolicyContainerUpdate
   */
  updatedPolicies: Array<VaultPolicyUpdate>;
  /** The vault being updated */
  vault: Vault;
  /** Vault Policy Container updates being applied by this operation */
  vaultPolicyContainerUpdate: Maybe<VaultPolicyContainerUpdate>;
};


/** UpdateVaultPoliciesOperation represents an operation where multiple vault policies are updated */
export type UpdateVaultPoliciesOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** UpdateVaultPoliciesOperation represents an operation where multiple vault policies are updated */
export type UpdateVaultPoliciesOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** UpdateVirtualAccountAddressResponse represents the response for updating a virtual account's address. */
export type UpdateVirtualAccountAddressResponse = {
  __typename: 'UpdateVirtualAccountAddressResponse';
  /** The updated address */
  address: VirtualAccountAddress;
  /** The time the address was updated */
  updatedAt: Scalars['Timestamp']['output'];
};

export type UpdateWalletScreeningAllowlistEntryInput = {
  address: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** Upload pair of folder and filenames */
export type UploadAlertCaseFiles = {
  /** Filename of document */
  documentName: Scalars['String']['input'];
  /** Folder name */
  folderID: Scalars['String']['input'];
};

/** Input for uploading a cost-basis CSV */
export type UploadCostBasisCSVInput = {
  /** CSV file content */
  fileContent: Scalars['String']['input'];
  /** The organization key ID that owns this upload */
  organizationKeyId: Scalars['String']['input'];
};

/** Payload for the uploadCostBasisCSV mutation */
export type UploadCostBasisCSVPayload = {
  __typename: 'UploadCostBasisCSVPayload';
  /** Error message if the upload was rejected */
  error: Maybe<Scalars['String']['output']>;
  /** The ID of the created job (present on success) */
  jobId: Maybe<Scalars['String']['output']>;
  /** Whether the upload was accepted successfully */
  success: Scalars['Boolean']['output'];
};

/** A file to be uploaded for delivery to a client destination */
export type UploadFile = {
  /** File content (e.g. CSV data) */
  content: Scalars['String']['input'];
  /** File type (e.g. "csv") */
  fileType: Scalars['String']['input'];
  /** File name including extension (e.g. "bitwise_trade_recap_2025-01-15.csv") */
  name: Scalars['String']['input'];
};

/** Response pair of filename and corresponding signed URL */
export type UploadSignedUrl = {
  __typename: 'UploadSignedUrl';
  /** Filename */
  filename: Scalars['String']['output'];
  /** Signed URL */
  signedUrl: Scalars['String']['output'];
};

export enum UsageEntityType {
  ACCOUNT = 'ACCOUNT',
  ORGANIZATION = 'ORGANIZATION'
}

/**
 * A unit of usage that a fee type can be measured against (e.g. AUC, staking rewards).
 * Backed by a backend enum; `id` is the stable code, `name` is the display label.
 */
export type UsageUnit = {
  __typename: 'UsageUnit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** User is deprecated - use UserV2 or UserKey instead. */
export type User = Node & {
  __typename: 'User';
  /** Timestamp of when the user was added to the organization with nanosecond precision */
  addedTime: Maybe<Scalars['String']['output']>;
  /** email is the user's email */
  email: Scalars['String']['output'];
  /** master control key encrypted to the iOS device's encryptionPublicKey */
  encryptedControlMasterPrivateKey: Maybe<Scalars['String']['output']>;
  /**
   * encryptionPublicKey is the iOS secure enclave key for this iOS device for receiving encrypted data such as wallet key backups.
   * This is encoded according to anchorcrypto.ECDSAPubKeyToSecureEnclaveBase64URL
   * See the Porto spec for more details
   * https://www.notion.so/anchorage/Porto-Control-key-key-export-features-d9b433d754234d60a75884007b859477#d301e6fe204646388799bf38cacc592c
   */
  encryptionPublicKey: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements that the user has made */
  endorsements: Array<SimplifiedEndorsement>;
  /**
   * Indicates if this user has lost its device
   * @deprecated Use deviceStatus
   */
  hasLostDevice: Scalars['Boolean']['output'];
  /** id is the id of the user's public key. This id is not stable */
  id: Scalars['ID']['output'];
  /** Indicates whether the user is a trader */
  isTrader: Scalars['Boolean']['output'];
  /**
   * Indicates the last known device status
   * Note that since this value is computed it may not reflect the real-time status.
   */
  lastDeviceStatus: DeviceStatus;
  /** Last login information. Risk metadata will be empty if the user never logged in */
  lastLogin: Login;
  /** name is the user's name */
  name: Scalars['String']['output'];
  /** The organization this user is within, if any */
  organization: Maybe<Organization>;
  /** The natural person this user is within an organization */
  person: Maybe<Person>;
  /** The policies that are applied to the user. */
  policies: ReadPolicyConnection;
  /** publicKeyID is the id of the user's public key */
  publicKeyID: Scalars['PublicKeyID']['output'];
  roles: IAMUserRoleConnection;
  /** secureName is the user's cryptographically protected name */
  secureName: Scalars['String']['output'];
  /** userID is the stable and unique user's identifier */
  userID: Scalars['ID']['output'];
  /** Description of why a user cannot be removed or null if the user can be removed */
  userRemovalPossibleDescription: Maybe<Scalars['String']['output']>;
  /** Indicates the type of the user */
  userType: UserType;
  /**
   * The encrypted shares of the wallet recovery key asscociated with this user, if any.
   * This only applies for Porto orgs with the WALLET_RECOVERY_KEY strategy.
   */
  walletRecoveryKeyShares: Maybe<Array<Scalars['String']['output']>>;
};


/** User is deprecated - use UserV2 or UserKey instead. */
export type UserendorsementsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  uniqueEndorsements?: InputMaybe<Scalars['Boolean']['input']>;
};


/** User is deprecated - use UserV2 or UserKey instead. */
export type UserpoliciesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** User is deprecated - use UserV2 or UserKey instead. */
export type UserrolesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IAMRoleOrder>;
  where?: InputMaybe<IAMRoleWhereInput>;
};

/** A connection to a list of users. */
export type UserConnection = {
  __typename: 'UserConnection';
  /** A list of edges. */
  edges: Maybe<Array<UserEdge>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection, representing a User instance */
export type UserEdge = {
  __typename: 'UserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge */
  node: Maybe<User>;
};

/**
 * UserKey represents a key that is used in interactive sessions driven by a
 * human being.
 */
export type UserKey = Actor & Key & Node & {
  __typename: 'UserKey';
  /** Actor information. */
  actorInfo: ActorInfo;
  /** Email used during enrollment of this key. */
  email: Scalars['String']['output'];
  /** endorsements is the list of endorsements that the user has made */
  endorsements: Array<SimplifiedEndorsement>;
  /**
   * The enrollment token associated with this key. Staff-only: it is a bearer
   * credential that is only useful to engineers debugging enrollment.
   */
  enrollToken: Maybe<Scalars['String']['output']>;
  /** Unique identifier of this user key. */
  id: Scalars['ID']['output'];
  /** Key details. */
  keyInfo: KeyInfo;
  /** Details about the last login of this user key. */
  lastLogin: Maybe<Login>;
  /** The policies that are applied to the user. */
  policies: ReadPolicyConnection;
  /**
   * The quorum memberships of this key. Membership in a quorum can be used to
   * derive the legacy user type:
   * - If the key is a member of at least organization quorum, then the key has the
   *   legacy user type of `administrator`.
   * - If the key is a member of only vault quorums, then the key has the legacy
   *   user type of `member`.
   * - If the key is not a member of any quorum, then the key has the legacy user
   *   type of `view-only`.
   */
  quorumMembershipTypes: Array<UserKeyQuorumMembershipType>;
  /**
   * SYSTEM USE ONLY. Provides overrides for add and replace user operations.
   * If you're working on a frontend, use `quorumMembershipTypes` instead.
   */
  quorumMembershipTypesOverride: Maybe<Array<UserKeyQuorumMembershipType>>;
  /** Returns more info about the user the key belongs to */
  user: UserV2;
  /**
   * The encrypted shares of the wallet recovery key assigned to this key, if any.
   * Shares are encrypted to this key's encryption public key, so only its holder
   * can decrypt them. This only applies for Porto orgs with the
   * WALLET_RECOVERY_KEY strategy.
   */
  walletRecoveryKeyShares: Maybe<Array<Scalars['String']['output']>>;
};


/**
 * UserKey represents a key that is used in interactive sessions driven by a
 * human being.
 */
export type UserKeyendorsementsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  uniqueEndorsements?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * UserKey represents a key that is used in interactive sessions driven by a
 * human being.
 */
export type UserKeypoliciesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * This type enumerates the different types of quorum membership that a key can
 * have.
 */
export enum UserKeyQuorumMembershipType {
  /** The key is a member of at least one organization-level quorum. */
  ORGANIZATION = 'ORGANIZATION',
  /** The key is a member of at least one vault-level quorum. */
  VAULT = 'VAULT'
}

/** A filter to be used against the policies returned by `UserV2.policiesV2`. */
export type UserPoliciesV2WhereInput = {
  /**
   * Restrict results to a single resource type (Admin or Vault). Omit to
   * return both.
   */
  resourceType?: InputMaybe<PolicyResourceType>;
};

/** UserSettings holds the per-user trading notification settings. */
export type UserSettings = {
  __typename: 'UserSettings';
  /** When true, a notification with a daily trading summary is sent. */
  tradeDailyDigestEnabled: Scalars['Boolean']['output'];
  /** When true, a notification is sent for each trade that is executed. */
  tradeNotificationPerTransactionEnabled: Scalars['Boolean']['output'];
  /** Timestamp (nanoseconds) when these settings were last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  /** The public key ID of the user the settings belong to. */
  userKeyID: Scalars['String']['output'];
};

/** UserSortField are the options for sorting a list of users. */
export enum UserSortField {
  /** NAME sorts by the users' display names */
  NAME = 'NAME'
}

/** UserStatus represents the overall status of a user. */
export enum UserStatus {
  /** User has at least one key that can be used to login/perform actions. */
  ACTIVE = 'ACTIVE',
  /**
   * User was marked as blocked by Anchorage and no key can be used to login/perform
   * actions. This state is reversible and the user might be unblocked by Anchorage
   * or removed by other members of the organization.
   */
  BLOCKED = 'BLOCKED',
  /**
   * User has at least one key that can be used to login/perform actions, but it
   * hasn't been used in the last 30 days.
   */
  INACTIVE = 'INACTIVE',
  /** User does not have keys that can be used to login/perform actions. */
  INOPERATIVE = 'INOPERATIVE'
}

/** Represents the type of a User */
export enum UserType {
  /** User who belongs to one or more Organization's quorums/policies */
  ADMIN = 'ADMIN',
  /** User who belongs to the brokereage desk team */
  BROKERAGE_DESK = 'BROKERAGE_DESK',
  /** User who belongs to one or Vault quorums/policie */
  MEMBER = 'MEMBER',
  /** This user object is not a user */
  NOT_A_USER = 'NOT_A_USER',
  /** This user key was removed. */
  REMOVED = 'REMOVED',
  /** User who doesn't belong to any quorum/policy */
  VIEW_ONLY = 'VIEW_ONLY'
}

/** A user of Anchorage. */
export type UserV2 = Actor & Node & {
  __typename: 'UserV2';
  /** Actor information. */
  actorInfo: ActorInfo;
  /**
   * Number of admin policy rules (default and/or specific) this user is
   * actually a quorum or subquorum member of. Unlike `policiesV2`, this does
   * NOT also count role-binding-only membership: a user who can only sign via
   * a role binding, without being in any rule's quorum, counts 0 here.
   */
  adminPolicyRuleCount: Scalars['Int']['output'];
  /** The timestamp when the user was created, represented as a Unix timestamp in nanoseconds. */
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  /** Email of the user. */
  email: Maybe<Scalars['String']['output']>;
  /** Unique user identifier. */
  id: Scalars['ID']['output'];
  /**
   * Returns true if the user has permission to trade using the web dashboard.
   * This is a temporary addition, until it is ported to a user permission.
   */
  isTrader: Scalars['Boolean']['output'];
  /** List of keys that are owned by this user. */
  keys: KeyConnection;
  /** Details about the last login of this user. */
  lastLogin: Maybe<Login>;
  /** Name of the user. */
  name: Scalars['String']['output'];
  /** Organization where this user is enrolled. */
  organization: Maybe<Organization>;
  /** Person associated with this user. */
  person: Maybe<Person>;
  /** Phone number of the user. */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** The policies that are applied to the user. */
  policies: ReadPolicyConnection;
  /**
   * Policies that this user is a member of (both Admin and Vault policies).
   * Only valid if the organization is migrated to grouped containers.
   * Results are ordered by resource type (Admin policy first, then Vault),
   * desc resource count, asc policy name, and finally asc policy ID.
   */
  policiesV2: PolicyV2Connection;
  /**
   * Policies (Admin and/or Vault) this user is a quorum/subquorum member of,
   * in the same shape as `policiesV2`, so the existing policy parser needs
   * no changes to consume it. Each policy's `specificRules` is filtered
   * server-side to just the specific rules this user is a member of;
   * `defaultRule` is always the policy's actual default rule, unfiltered,
   * matching the frontend's existing per-user filtering behavior. Same
   * quorum-only membership predicate as `adminPolicyRuleCount` /
   * `vaultPolicyRuleCount` — one shared predicate feeds all three fields.
   * Unlike `policiesV2`, role-binding-only membership does not include a
   * policy here.
   */
  policyMemberships: PolicyV2Connection;
  roles: IAMUserRoleConnection;
  /** User status. */
  status: UserStatus;
  /**
   * Number of vault policy rules (default and/or specific) this user is
   * actually a quorum or subquorum member of. Same quorum-only semantics as
   * `adminPolicyRuleCount`.
   */
  vaultPolicyRuleCount: Scalars['Int']['output'];
  /**
   * The encrypted shares of the wallet recovery key asscociated with this user, if any.
   * This only applies for Porto orgs with the WALLET_RECOVERY_KEY strategy.
   * @deprecated Shares are assigned to keys, not users. Use UserKey.walletRecoveryKeyShares instead.
   */
  walletRecoveryKeyShares: Maybe<Array<Scalars['String']['output']>>;
};


/** A user of Anchorage. */
export type UserV2keysArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<KeyWhereInput>;
};


/** A user of Anchorage. */
export type UserV2policiesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user of Anchorage. */
export type UserV2policiesV2Args = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPoliciesV2WhereInput>;
};


/** A user of Anchorage. */
export type UserV2policyMembershipsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resourceType?: InputMaybe<PolicyResourceType>;
};


/** A user of Anchorage. */
export type UserV2rolesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IAMRoleOrder>;
  where?: InputMaybe<IAMRoleWhereInput>;
};

/** A connection to a list of users. */
export type UserV2Connection = {
  __typename: 'UserV2Connection';
  /** A list of edges. */
  edges: Array<UserV2Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a user connection. */
export type UserV2Edge = {
  __typename: 'UserV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: UserV2;
};

/** Filtering options for Users V2 returned from the connection. */
export type UserV2WhereInput = {
  /** Filter by user IDs. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by key IDs. */
  keyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by a case-insensitive substring match on the user's name. */
  nameContainsTerm?: InputMaybe<Scalars['String']['input']>;
};

/** One unspent UTXO (one deposit event). */
export type UtxoExclusionEntry = {
  __typename: 'UtxoExclusionEntry';
  /** The pooled address holding this UTXO. */
  address: Scalars['String']['output'];
  amount: Amount;
  /** When the deposit completed. */
  endTime: Scalars['Time']['output'];
  state: UtxoExclusionState;
  txid: Scalars['String']['output'];
  vout: Scalars['Int']['output'];
};

/** UtxoExclusionLock is the wallet's exclusion-controls lock. */
export type UtxoExclusionLock = {
  __typename: 'UtxoExclusionLock';
  /** The execute holding the lock, for the "View transaction" action. Null when locked is false. */
  blockingOperationID: Maybe<Scalars['ID']['output']>;
  locked: Scalars['Boolean']['output'];
};

/** UtxoExclusionOutcome is the outcome of an add or remove for one UTXO. */
export type UtxoExclusionOutcome = {
  __typename: 'UtxoExclusionOutcome';
  outcome: UtxoExclusionOutcomeType;
  /** reason is why the UTXO was skipped, e.g. "already has a SPAM hold". Null when the UTXO changed. */
  reason: Maybe<Scalars['String']['output']>;
  txid: Scalars['String']['output'];
  vout: Scalars['Int']['output'];
};

/** UtxoExclusionOutcomeType is what happened to a single UTXO in an add or remove. */
export enum UtxoExclusionOutcomeType {
  /** EXCLUDED means the UTXO now carries the exclusion hold. */
  EXCLUDED = 'EXCLUDED',
  /** INCLUDED means the exclusion hold was cleared and the UTXO is spendable again. */
  INCLUDED = 'INCLUDED',
  /** SKIPPED means the UTXO was left unchanged (for example it already had a different hold). */
  SKIPPED = 'SKIPPED'
}

/** UtxoExclusionResult reports the per-UTXO outcome of an add or remove, one entry per UTXO passed. */
export type UtxoExclusionResult = {
  __typename: 'UtxoExclusionResult';
  results: Array<UtxoExclusionOutcome>;
};

export enum UtxoExclusionState {
  /** A client UTXO exclusion holds it out of coin selection. */
  EXCLUDED = 'EXCLUDED',
  /** No exclusion hold; coin selection may spend it. */
  INCLUDED = 'INCLUDED'
}

/** UtxoExclusionStateFilter narrows a UTXO list to one inclusion state. */
export enum UtxoExclusionStateFilter {
  ALL = 'ALL',
  EXCLUDED = 'EXCLUDED',
  INCLUDED = 'INCLUDED'
}

/** UtxoInput names one UTXO by its txid and vout. */
export type UtxoInput = {
  txid: Scalars['String']['input'];
  vout: Scalars['Int']['input'];
};

export type ValidatorConsolidationTarget = {
  __typename: 'ValidatorConsolidationTarget';
  /** The organization owning the target Validator. Null when the organization is unknown, which forces risk review (see Delegate.RequiresRiskReview). */
  organizationKeyID: Maybe<Scalars['String']['output']>;
  /** The Public Key of the target Validator into which the StakingPositionID will consolidate. Used in the context of staking for certain chains, such as Ethereum. */
  validator: Scalars['String']['output'];
};

/** ValidatorDetail is a generic interface for validator detail */
export type ValidatorDetail = CeloValidatorGroupDetail | NonAddressValidatorDetail | OasisValidatorDetail;

/**
 * ValidatorInputStep is step that allows the user to pick a validator address.
 * This step can be augmented with "favourites", or "recently used".
 */
export type ValidatorInputStep = StakingStep & {
  __typename: 'ValidatorInputStep';
  /** A regex for the UI to validate the input address in real time. */
  addressRegex: Scalars['String']['output'];
  /** The error message to show when the addressRegex fails. */
  addressRegexError: Scalars['String']['output'];
  /** Of all knownValidators, which one should be the "default" (aka "chosen") in UI drop-down. */
  defaultKnownValidator: Maybe<DelegationAddress>;
  /**
   * Some assets use different terminology for the "validator" name, this field should help customize
   * labels shown on the app.
   *
   * TODO: do not use - will panic.
   * @deprecated use the field 'label' instead
   */
  description: Scalars['String']['output'];
  /** Editable should disable the input if false. */
  editable: Scalars['Boolean']['output'];
  /**
   * Used to instruct the UI the name of the field that should be used to store the user's input for this step.
   * This value must be provided on all input steps when using PrepareGenericOperation
   * It can also be used to instruct the UI to send in a non-default field when using PrepareDelegation, but the string value must exactly match the GQL field name to work.
   * When this value is empty, a default value will be used by the UI based on the staking step type
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /**
   * Ignore this field
   *
   * TODO: do not use - will panic.
   */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Allows the backend to provide info banners to be shown above the step */
  infoItems: Maybe<Array<InfoItem>>;
  /**
   * This includes some of the known validators. They are either Anchorage or 3rd-party validator.
   * The list is sorted by Anchorage validators first, 3rd-party validators second.
   */
  knownValidators: Maybe<Array<DelegationAddress>>;
  /** The label shown on the UI next to the input field. */
  label: Scalars['String']['output'];
  /**
   * The text shown in the input field before the user types anything. If this
   * field is null, the input field should be empty.
   */
  placeholderText: Maybe<Scalars['String']['output']>;
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
};

/** A single VASP identifier on an outbound record. */
export type VaspIdentifier = {
  __typename: 'VaspIdentifier';
  /** Whether Travel Rule info can be auto-sent to this VASP. */
  autoSendPossible: Scalars['Boolean']['output'];
  /** VASP name. */
  name: Scalars['String']['output'];
  /** Source that reported the VASP (TRUST, TRM, Client, Ciphertrace). */
  source: Scalars['String']['output'];
};

export type Vault = IAMResource & Node & {
  __typename: 'Vault';
  /** The account this vault is assigned to. */
  account: Account;
  /**
   * List of assets associated with this vault. May be filtered by asset type (optional) and if is non fungible (optional)
   * @deprecated use the paginated wallets resolver and access assets only within the context of a wallet
   */
  assets: Array<Asset>;
  /** A paginated list of Addresses in this vault. Filters can be combined to narrow results. */
  balancesByAddress: AddressBalanceConnection;
  /** Number of withdrawals done on this vault */
  completedWithdrawalsCount: Scalars['Int']['output'];
  /** Timestamp of when the vault was created with nanosecond precision */
  createdAt: Scalars['String']['output'];
  /** 24h price change across this vault's holdings, as a percent-scale string: "2.31" means +2.31%. */
  dayChange: Scalars['String']['output'];
  /** Description of the vault */
  description: Scalars['String']['output'];
  /**
   * FiatWallet returns wallet, if wallet doesn't exist it creates one
   * @deprecated use the fiatWalletCreateIfAbsent resolver to create a wallet if it doesn't exist or to get an existing wallet
   */
  fiatWallet: WalletEdge;
  /** fiatWalletCreateIfAbsent returns wallet, if wallet doesn't exist it creates one if requested */
  fiatWalletCreateIfAbsent: Maybe<WalletEdge>;
  iam: IAM;
  /** The ID of the Vault object */
  id: Scalars['ID']['output'];
  /** Name of the vault */
  name: Scalars['String']['output'];
  /** Gets the operation by id */
  operation: Maybe<Operation>;
  /**
   * Get the list of operations in this vault
   * first and after implement the connections spec
   */
  operations: OperationConnection;
  /** organization gets the organization sub resolver */
  organization: Organization;
  /**
   * Policies for all actions
   * @deprecated Legacy PolicyMaps. Use 'readPolicies'
   */
  policies: Array<Policy>;
  /**
   * Policy for the provided action
   * @deprecated Legacy PolicyMaps. Use 'readPolicies'
   */
  policy: Maybe<Policy>;
  /** Information about policy containers on the resource. */
  policyInfo: Maybe<PolicyInfo>;
  /**
   * The policy associated with the vault. Only valid after the org is migrated to
   * grouped containers.
   */
  policyV2: PolicyV2;
  portfolio: Portfolio;
  /** Non-signable representation of the policies applicable to this vault */
  readPolicies: ReadPolicyConnection;
  /** The ACTIVE vault-level restriction, if any. */
  restriction: Maybe<RestrictionRecord>;
  /** Indicates the state of the vault */
  state: VaultState;
  /** Unique ID of the vault */
  uniqueID: Scalars['String']['output'];
  /** userAccesses returns a paginated list of user/access relations for the Vault. */
  userAccesses: Maybe<IAMUserAccessConnection>;
  /** Get the list of users in the vault policies */
  users: Array<User>;
  /** All accounts this vault has been assigned to, with association timestamps. */
  vaultAccounts: Array<VaultAccount>;
  /** ID of a vault within an organization */
  vaultID: VaultID;
  version: Maybe<Scalars['String']['output']>;
  /** True iff the current viewer can operate (e.g. withdraw) on this vault, not just see it. */
  viewerCanOperate: Scalars['Boolean']['output'];
  /** This is non-null if the backup needs to happen before a wallet can be created for the given network */
  walletKeyBackupBeforeWalletCreation: Maybe<WalletKeyBackup>;
  /** The number of ACTIVE wallet-level restrictions in the vault; null when it cannot be read. */
  walletRestrictionsCount: Maybe<Scalars['Int']['output']>;
  /**
   * Returns a paginated list of all Wallets in this vault.
   * Only one of searchByName or filterByAssetTypeNetworkIDs can be used at a time.
   * This API will soon replace "wallets".
   *
   * NOTE: these quantity filters will be silently ignored iff the org is Porto:
   * - filterMinQuantity, filterMaxQuantity, quantityRangeIsInclusive.
   * - filterByNonZeroBalance.
   *
   * NOTE: filterByBackupReceived is silently ignored iff the org does NOT require wallet key backup acknowledgement.
   */
  wallets: WalletConnection;
};


export type VaultassetsArgs = {
  assetType?: InputMaybe<Scalars['AssetTypeID']['input']>;
  filterIsNonFungible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VaultbalancesByAddressArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterByAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterByUtxoExclusionState?: InputMaybe<PooledAddressExclusionState>;
  filterByWalletIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchByAddress?: InputMaybe<Scalars['String']['input']>;
};


export type VaultfiatWalletArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
};


export type VaultfiatWalletCreateIfAbsentArgs = {
  assetTypeID: Scalars['AssetTypeID']['input'];
  createIfAbsent: Scalars['Boolean']['input'];
};


export type VaultoperationArgs = {
  operationID: Scalars['String']['input'];
};


export type VaultoperationsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filterActions?: InputMaybe<Array<OperationAction>>;
  filterAssetSubID?: InputMaybe<Scalars['String']['input']>;
  filterAssetTypeID?: InputMaybe<Scalars['AssetTypeID']['input']>;
  filterAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterCreatedSince?: InputMaybe<Scalars['String']['input']>;
  filterCreatedUntil?: InputMaybe<Scalars['String']['input']>;
  filterProgramCustomerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterRequiresDecision?: InputMaybe<Scalars['Boolean']['input']>;
  filterStates?: InputMaybe<Array<OperationState>>;
  filterVirtualAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterWalletIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeChange?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<OperationSortFields>;
};


export type VaultpolicyArgs = {
  action: PolicyActionType;
};


export type VaultreadPoliciesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type VaultuserAccessesArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IAMUserAccessWhereInput>;
};


export type VaultwalletKeyBackupBeforeWalletCreationArgs = {
  networkID: Scalars['String']['input'];
};


export type VaultwalletsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  excludeFIAT?: InputMaybe<Scalars['Boolean']['input']>;
  filterByAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterByAssetTypeNetworkIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterByBackupReceived?: InputMaybe<Scalars['Boolean']['input']>;
  filterByIsArchived?: InputMaybe<Scalars['Boolean']['input']>;
  filterByNetworkIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterByNonZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  filterByWalletIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByWalletsWithOneOfAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  filterMaxQuantity?: InputMaybe<Scalars['String']['input']>;
  filterMinQuantity?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  quantityRangeIsInclusive?: Scalars['Boolean']['input'];
  searchByName?: InputMaybe<Scalars['String']['input']>;
  searchByNameOrNetworkOrAddress?: InputMaybe<Scalars['String']['input']>;
  sortDESC?: Scalars['Boolean']['input'];
  sortField?: WalletSortField;
};

/** Associates a vault with an account at a point in time. */
export type VaultAccount = {
  __typename: 'VaultAccount';
  /** The account that the vault was assigned to at one time */
  account: Account;
  /** The vault in question */
  vault: Vault;
  /** The time the vault was associated with the account */
  vaultAssociatedAt: Scalars['Timestamp']['output'];
};

/** VaultConnection contains a paginated list of Vaults - implements the connections spec for pagination */
export type VaultConnection = {
  __typename: 'VaultConnection';
  /** edges is a list of VaultEdge objects representing a page of vaults data. Implements the connections spec for pagination. */
  edges: Array<VaultEdge>;
  /** pageInfo returns information about the page returned above. Implements the connections spec for pagination. */
  pageInfo: PageInfo;
};

/** VaultEdge contains a vault and the cursor representing the same vault. Implements the connections spec for pagination. */
export type VaultEdge = {
  __typename: 'VaultEdge';
  /** cursor implements the connections spec for pagination */
  cursor: Scalars['ID']['output'];
  /** node implements the connections spec for pagination */
  node: Vault;
};

/** VaultID is the ID of a vault within an organization */
export type VaultID = {
  __typename: 'VaultID';
  /** organizationKeyID is the ID of the organization this vault is in */
  organizationKeyID: Scalars['String']['output'];
  /** vault resolves the vault corresponding to this VaultID */
  vault: Vault;
  /** vaultSubID is the ID of the vault within the organization */
  vaultSubID: Scalars['String']['output'];
};

/** Describes a policy for a specific vault and action */
export type VaultPolicy = {
  __typename: 'VaultPolicy';
  /** The policy associated with this vault */
  policy: Policy;
  /** The vault this policy refers to */
  vault: Vault;
};

/** VaultPolicyContainerUpdate is the collection of updates being applied to the vaults policy containers */
export type VaultPolicyContainerUpdate = {
  __typename: 'VaultPolicyContainerUpdate';
  /** fragmentBindingUpdates is the fragment changes that will be applied to the policy */
  fragmentBindingUpdates: Maybe<Array<VaultPolicyFragmentBindingUpdate>>;
  /** roleBindingUpdates is the role binding changes that will be applied to the policy */
  roleBindingUpdates: Maybe<Array<VaultPolicyRoleBindingUpdate>>;
};

/** VaultPolicyFragmentBindingUpdate is an update that will be applied to a single fragment on a vault. */
export type VaultPolicyFragmentBindingUpdate = {
  __typename: 'VaultPolicyFragmentBindingUpdate';
  /** originalBinding is the fragment binding prior to update. This will not be present for newly added fragment bindings. */
  originalBinding: Maybe<PolicyFragmentBinding>;
  /** updatedBinding is the fragment binding prior to update. This will not be present for fragment bindings being deleted. */
  updatedBinding: Maybe<PolicyFragmentBinding>;
  /** ID of a vault within an organization */
  vaultID: VaultID;
};

/**
 * Holds information about the action of a vault that cannot be safistied due
 * to the respective list of users.
 *
 * This is tightly coupled with users' device health.
 */
export type VaultPolicyQuorumSummary = {
  __typename: 'VaultPolicyQuorumSummary';
  /** The action that cannot be satisfied due to unsatisfiable policy. */
  action: PolicyActionType;
  /** The human readable display name of the policy. */
  displayName: Scalars['String']['output'];
  /** Status of this quorum given current user devices' health */
  status: Maybe<PolicyStatus>;
  /** Users that are used to compute the quorum. */
  users: Array<User>;
  /** The vault this summary refers to. */
  vault: Vault;
};


/**
 * Holds information about the action of a vault that cannot be safistied due
 * to the respective list of users.
 *
 * This is tightly coupled with users' device health.
 */
export type VaultPolicyQuorumSummaryusersArgs = {
  sortField?: InputMaybe<UserSortField>;
};

/** VaultPolicyRoleBindingUpdate is an update that will be applied to a single role binding fragment on a vault. */
export type VaultPolicyRoleBindingUpdate = {
  __typename: 'VaultPolicyRoleBindingUpdate';
  /** originalBinding is the role binding prior to update. This will not be present for newly added role bindings. */
  originalBinding: Maybe<PolicyRoleBinding>;
  /** updatedBinding is the binding after update. This will not be present for bindings being deleted. */
  updatedBinding: Maybe<PolicyRoleBinding>;
  /** ID of a vault within an organization */
  vaultID: VaultID;
};

/** VaultPolicyUpdate represents a policy change on a specific vault */
export type VaultPolicyUpdate = {
  __typename: 'VaultPolicyUpdate';
  /** Original policy */
  originalPolicy: VaultPolicy;
  /** new initiators list for the policy */
  updatedInitiateOnlyUsers: Array<User>;
  /** quorums are the list of quorums for this policy */
  updatedQuorums: Array<Quorum>;
  /**
   * new list of required users.
   * this list is not cryptographically protected
   * @deprecated use updatedRequiredUsersQuorums instead
   */
  updatedRequiredUsers: Array<User>;
  /**
   * updatedRequiredUsersQuorums are the softly required user quorums for this policy update.
   * If there are no updatedRequiredUsersQuorums an empty list will be returned.
   */
  updatedRequiredUsersQuorums: Array<RequiredUsersQuorum>;
};


/** VaultPolicyUpdate represents a policy change on a specific vault */
export type VaultPolicyUpdateupdatedInitiateOnlyUsersArgs = {
  sortField?: InputMaybe<UserSortField>;
};


/** VaultPolicyUpdate represents a policy change on a specific vault */
export type VaultPolicyUpdateupdatedRequiredUsersArgs = {
  sortField?: InputMaybe<UserSortField>;
};

/** Enum for vault sorting fields */
export enum VaultSortField {
  VAULT_SUB_ID = 'VAULT_SUB_ID'
}

/** Possible vault states */
export enum VaultState {
  /** The vault is disabled and holds no funds. */
  DISABLED_WITHOUT_ASSETS = 'DISABLED_WITHOUT_ASSETS',
  /** The vault is disabled but holds funds. */
  DISABLED_WITH_ASSETS = 'DISABLED_WITH_ASSETS',
  /** The vault is enabled. It may or may not hold funds. */
  ENABLED = 'ENABLED',
  /**
   * The vault is enabled but holds no funds
   * @deprecated Use ENABLED
   */
  ENABLED_WITHOUT_ASSETS = 'ENABLED_WITHOUT_ASSETS',
  /**
   * The vault is enabled and holds funds.
   * @deprecated Use ENABLED
   */
  ENABLED_WITH_ASSETS = 'ENABLED_WITH_ASSETS'
}

/** A filter to be used against Vault fields. */
export type VaultWhereInput = {
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Payload response for getVerifiedABI mutation */
export type VerifiedAbiResponse = {
  __typename: 'VerifiedAbiResponse';
  /** ABI retrieved from the provider */
  abi: Scalars['String']['output'];
  /** contract address */
  address: Scalars['String']['output'];
  /** if proxy, implementation address of the contract */
  implementationAddress: Scalars['String']['output'];
  /** Contract Name */
  name: Scalars['String']['output'];
  /** Is the contract a proxy contract */
  proxy: Scalars['Boolean']['output'];
  /** if proxy, the standard used for the proxy contract pattern */
  standard: Scalars['String']['output'];
  /** status of the request (as returned by the provider) */
  status: Scalars['String']['output'];
  /**
   * status of the request (as returned by the provider)
   * @deprecated Use status instead
   */
  success: Scalars['Boolean']['output'];
};

/** VestingInfo contains info for claiming vested funds */
export type VestingInfo = {
  __typename: 'VestingInfo';
  /** autoClaimVestedSchedule is the vesting schedule */
  autoClaimVestedSchedule: VestingSchedule;
  /** contractAddress is the address of the contract holding the locked funds */
  contractAddress: Scalars['String']['output'];
  /** lastClaimVested is the last time a claim vested operation was performed, automatic or manually */
  lastClaimVested: Maybe<Scalars['String']['output']>;
  /** unvestedDescription is an optional description of the unvested balance, e.g. number of blocks or time left to fully unvest */
  unvestedDescription: Maybe<Scalars['String']['output']>;
};

/** VestingSchedule sets fuzzy time periods for when an auto vesting transaction should happen. */
export enum VestingSchedule {
  /** DAILY tries to complete a transaction daily. */
  DAILY = 'DAILY',
  /** END_OF_MONTH tries to complete a transaction at the end of the month. */
  END_OF_MONTH = 'END_OF_MONTH',
  /** NONE denotes a vesting contract without an auto schedule. This must be done manually. */
  NONE = 'NONE',
  /** START_OF_WEEK tries to complete a transaction at the start of week. */
  START_OF_WEEK = 'START_OF_WEEK',
  /** START_OF_WEEK_AND_END_OF_MONTH tries to complete a transaction once at the start of week and end of month. */
  START_OF_WEEK_AND_END_OF_MONTH = 'START_OF_WEEK_AND_END_OF_MONTH'
}

/** VestingWallet provides details of a wallet in an offchain vesting schedule */
export type VestingWallet = {
  __typename: 'VestingWallet';
  /** Total amount to vest on the wallet */
  totalAmount: Amount;
  /** Amount vested so far on the wallet */
  vestedAmount: Amount;
  /** Holds for vesting on the wallet */
  vestingHolds: Array<Hold>;
  /** Wallet containing vesting amounts */
  wallet: Wallet;
};

/**
 * A customer-facing virtual account on a fiat wallet. Resolved by fiat for any subgraph that references it by id.
 * Carries no user-type restriction: the referencing field already authorized the caller. An organization user
 * resolves only its own organization's virtual accounts, and a staff user only those of organizations whose
 * operator it holds. Any other id, or one that does not exist, resolves to null.
 */
export type VirtualAccount = {
  __typename: 'VirtualAccount';
  /** Last four characters of the number that identifies the virtual account at its bank: the customer identifier at Customers Bank, where every virtual account shares one deposit account, otherwise its own bank account number. Null while settling or when the bank lookup fails. */
  accountNumberLast4: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Owner's display name as rendered on the deposit instruction. Null while the account is still settling or when the lookup fails. */
  ownerName: Maybe<Scalars['String']['output']>;
  /** Program customer that owns the virtual account. */
  programCustomerID: Scalars['ID']['output'];
};

/**
 * VirtualAccountAddress is the physical address on file for a wallet's virtual account at an
 * MT-backed bank (BNY, SCB, JPM).
 */
export type VirtualAccountAddress = {
  __typename: 'VirtualAccountAddress';
  /** Country code */
  country: Scalars['String']['output'];
  /** Street address line 1 */
  line1: Scalars['String']['output'];
  /** Street address line 2 (optional) */
  line2: Maybe<Scalars['String']['output']>;
  /** City or locality */
  locality: Scalars['String']['output'];
  /** Postal code or ZIP code */
  postalCode: Scalars['String']['output'];
  /** State or region */
  region: Scalars['String']['output'];
};

/** VirtualAccountConnection is a page of a wallet's virtual accounts */
export type VirtualAccountConnection = {
  __typename: 'VirtualAccountConnection';
  /** edges implements the connections spec for pagination */
  edges: Array<VirtualAccountEdge>;
  /** pageInfo implements the connections spec for pagination */
  pageInfo: PageInfo;
};

/** VirtualAccountEdge contains a virtual account and its cursor */
export type VirtualAccountEdge = {
  __typename: 'VirtualAccountEdge';
  /** cursor implements the connections spec for pagination */
  cursor: Scalars['ID']['output'];
  /** node implements the connections spec for pagination */
  node: WalletVirtualAccount;
};

/** A program customer that owns virtual accounts */
export type VirtualAccountOwner = {
  __typename: 'VirtualAccountOwner';
  /** Name of the program customer */
  name: Scalars['String']['output'];
  /** ID of the program customer */
  programCustomerID: Scalars['ID']['output'];
  /** Whether the program customer is a person or a business */
  type: VirtualAccountOwnerType;
};

/** VirtualAccountOwnerConnection is a page of the program customers that own a wallet's virtual accounts */
export type VirtualAccountOwnerConnection = {
  __typename: 'VirtualAccountOwnerConnection';
  /** edges implements the connections spec for pagination */
  edges: Array<VirtualAccountOwnerEdge>;
  /** pageInfo implements the connections spec for pagination */
  pageInfo: PageInfo;
};

/** VirtualAccountOwnerEdge contains a virtual account owner and its cursor */
export type VirtualAccountOwnerEdge = {
  __typename: 'VirtualAccountOwnerEdge';
  /** cursor implements the connections spec for pagination */
  cursor: Scalars['ID']['output'];
  /** node implements the connections spec for pagination */
  node: VirtualAccountOwner;
};

/** VirtualAccountOwnerType is the kind of program customer that owns a virtual account */
export enum VirtualAccountOwnerType {
  BUSINESS = 'BUSINESS',
  INDIVIDUAL = 'INDIVIDUAL'
}

/** VirtualAccountStatus is the lifecycle state of a virtual account */
export enum VirtualAccountStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED'
}

/** VisibleForPurpose indicate if the balance should be visible for given purpose. */
export enum VisibleForPurpose {
  /** This gives a overview of the account balances. Used currently by the valult page in the app. */
  OVERVIEW = 'OVERVIEW'
}

/** VoiceBiometricsStatus is the result from the voice biometrics API */
export enum VoiceBiometricsStatus {
  /** ACCEPTED means the voice passed authentication */
  ACCEPTED = 'ACCEPTED',
  /**
   * ENROLLED means there was not enough data to authenticate the voice so the sample was used
   * for training and the voice should be checked
   */
  ENROLLED = 'ENROLLED',
  /** ENROLLMENT_PAUSED means the voice service is not accepting new users at the moment and could not authenticate */
  ENROLLMENT_PAUSED = 'ENROLLMENT_PAUSED',
  /** ERRORED means the voice data was not able to be checked and requires attention */
  ERRORED = 'ERRORED',
  /** FAILED means the voice failed authentication and requires attention */
  FAILED = 'FAILED'
}

export type VoidObligationInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  obligationId: Scalars['ID']['input'];
  /** The record of why the obligation was retired */
  reason: Scalars['String']['input'];
};

/**
 * VoteDetails is a union type of all possible forms of extra vote information
 * DEPRECATED: Governance voting is no longer supported. Kept for backward compatibility with historical operations.
 */
export type VoteDetails = CeloProposalDetails | MakerPollDetails | MakerVoteDetails;

export type VoteMakerCheckerRequestInput = {
  decision: DVVoteDecision;
  /** Required when rejecting */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** VoteOperation represents a Vote operation */
export type VoteOperation = Operation & {
  __typename: 'VoteOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** asset id from with the authorization was made */
  assetID: AssetID;
  /** Further information regarding this asset type associated with this operation */
  assetTypeInfo: AssetTypeInfo;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** canonicalOperationVersion is the version of the canonical authorization that must be used to sign this authorization */
  canonicalOperationVersion: Scalars['Int']['output'];
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** confirmations returns how many confirmations the transaction associated with this authorization has received */
  confirmations: Maybe<Scalars['Int']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** details returns non-generic information on the vote operation (MKR ballot, proposal support, etc) */
  details: Maybe<VoteDetails>;
  /** the type of vote, such as polling. used for display purposes, as opposed to the voteType in extraParams used for operation creation */
  displayVoteType: VoteType;
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * extraParams are additional asset type specific parameters that were set for this transaction
   * When constructing the canonical operation for signing, the extra params go in the ExtraParams field
   * as a map from asset type id (usually, parent asset type id) to params object. The convention of extra
   * params is to omit all empty fields, and if no extra params are set for an asset type, to omit the asset
   * type from the map entirely. Note that for legacy reasons this convention
   * is the opposite of the normal CanonicalOperation convention, where no fields are ever omitted.
   */
  extraParams: Maybe<ExtraParams>;
  /** final transaction fee charged for the authorization, detected on the blockchain */
  finalFee: Maybe<Amount>;
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /**
   * Returns the Maker governance executive vote ballot active when this operation was created, if one exists.
   * DEPRECATED: Maker governance is no longer supported. Returns null for backward compatibility.
   * @deprecated Maker governance is no longer supported
   */
  makerBallot: Maybe<MakerGovernanceBallot>;
  /**
   * Returns the Maker governance poll this operation voted on, if one exists.
   * DEPRECATED: Maker governance is no longer supported. Returns null for backward compatibility.
   * @deprecated Maker governance is no longer supported
   */
  makerPoll: Maybe<MakerPoll>;
  /** max transaction fee charged for the authorization */
  maxFee: Maybe<Amount>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /**
   * replayProtectionParams are the parameters to be sent to the HSM for creating and signing
   * the transactions required to effect this ExecuteOperation. The user *is not* expected
   * to review the contents of this field. However it may contain information necessary to prevent
   * replays and must be included in the payload signed by the user. Format is a hex-encoded
   * byte array.
   */
  replayProtectionParams: Maybe<Scalars['String']['output']>;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** sendingBlockchainAddresses is a list of addresses from which a vote operation is sent */
  sendingBlockchainAddresses: Array<BlockchainAddress>;
  /** signedTransaction is the blockchain transaction to be broadcast to the network */
  signedTransaction: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /**
   * sources are the originating addresses for the authorization
   * @deprecated use sendingBlockchainAddresses
   */
  sources: Array<Source>;
  /** transactionID is the blockchain transaction id once available */
  transactionID: Maybe<Scalars['String']['output']>;
  /** transactionSuccess indicates if the blockchain transaction succeeded */
  transactionSuccess: Maybe<Scalars['Boolean']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * usdValueFee is the USD value of the fee (finalFee if known, otherwise maxFee).
   * If both the finalFee and maxFee are not yet known, this field will be null
   */
  usdValueFee: Maybe<Scalars['String']['output']>;
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
  /** voteYeas returns the list of addresses representing proposals the client is voting "Yea" on */
  voteYeas: Array<Scalars['String']['output']>;
  /** the weight of the vote, nillable to be generic */
  votingPower: Maybe<Amount>;
};


/** VoteOperation represents a Vote operation */
export type VoteOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** VoteOperation represents a Vote operation */
export type VoteOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** VoteOption is the generic enum for governance votes */
export enum VoteOption {
  /** Abstain from vote */
  ABSTAIN = 'ABSTAIN',
  /** Vote no */
  NO = 'NO',
  /** Vote yes */
  YES = 'YES'
}

/**
 * VoteTotal is retained for backward compatibility with older iOS clients.
 * Celo governance has been removed. Safe to delete once the minimum supported
 * iOS version is v2.111.0.
 */
export type VoteTotal = {
  __typename: 'VoteTotal';
  abstain: Amount;
  no: Amount;
  yes: Amount;
};

/** VoteType differentiates between the various types of votes possible */
export enum VoteType {
  /** A vote directly results in the change in behavior of a token. Used by Maker */
  EXECUTIVE = 'EXECUTIVE',
  /** A poll has no direct effect on the behavior of a token. Used by Maker */
  POLL = 'POLL',
  /** A referendum vote is for Celo governance */
  REFERENDUM = 'REFERENDUM'
}

export type Wallet = Node & {
  __typename: 'Wallet';
  /** The type of addresses that are generated for this wallet. */
  addressGenerationType: Maybe<AddressGenerationType>;
  /**
   * List of "the canonical text representation of the address" for each of this wallet's addresses.
   *
   * These values *should* match:
   *   - NumberOfAddresses
   *   - length of Addresses()
   *   - length of BlockchainAddresses()
   * @deprecated use blockchainAddresses instead
   */
  addresses: Array<Scalars['String']['output']>;
  /**
   * allowedAssets returns a list of allowed assets for this wallet.
   * This is primarily used for Stellar and Ripple IOU assets where assets must be allowed
   * (e.g. a Stellar trustline or a Ripple trust line) before receiving assets.
   */
  allowedAssets: Maybe<Array<AllowedAsset>>;
  /** If the wallet is archived, who archived it: USER, SYSTEM, or ANCHORAGE_ADMIN */
  archivedBy: Maybe<ArchivedByType>;
  /** List of assets associated with this wallet. May be filtered by asset types (optional) */
  assets: Array<Asset>;
  /** Whether the wallet's key backup has been received (acknowledged downloaded). */
  backupReceived: Scalars['Boolean']['output'];
  /**
   * Returns a list of balances of all asset types with balance > 0 within this wallet
   * When filterByAssetTypeIDs is set, returns a list of balances with asset types in filterByAssetTypeIDs and balance > 0
   * @deprecated use assets instead
   */
  balances: Array<Amount>;
  /**
   * List of addresses in this wallet Each item contains "the canonical text representation of the address" and more.
   *
   * These values *should* match:
   *   - NumberOfAddresses
   *   - length of Addresses()
   *   - length of BlockchainAddresses()
   */
  blockchainAddresses: Array<BlockchainAddress>;
  /** An ongoing withdrawal that is blocking new withdrawals from this wallet */
  conflictingWithdraw: Maybe<Operation>;
  /** The time at which the wallet was created */
  createdAt: Scalars['String']['output'];
  /**
   * DepositAddress returns an address to be used for deposits into this wallet.
   * For a list of all addresses, use "BlockchainAddresses".
   * Wallet for Account-based assets only has one address.
   * Wallet for UTXO-based assets may have multiple addresses, and the one (1) marked "used" (2) with highest addressSubID should be returned.
   * Value would be empty/not present if the asset type is FIAT - use walletDepositInstructions instead.
   * @deprecated use walletDepositInstructions instead
   */
  depositAddress: BlockchainAddress;
  /**
   * It attempts to create a new address in given wallet.
   *
   * It is NOOP for ADx.
   * For Porto (aka MustAckWalletKeyBackups=true), these APIs work together to "Generate New Address" :
   *   - AckWalletKeyDownload
   *   - DepositAddressCreate
   *   - GetWalletKeyBackupOrCreateNewAddress (aka WalletKeyBackupBeforeAddressCreation)
   *
   * Porto should only use this path to "create new address" because it allows user to receive, and save,
   * wallet key backup - a requirement before they should be allowed to use the address.
   *
   * DepositAddressCreate and GetWalletKeyBackupOrCreateNewAddress serve similar purpose, but
   * - DepositAddressCreate                      only works for, and should only be with, ADx.
   * - GetWalletKeyBackupOrCreateNewAddress only works for, and should only be with, Porto.
   *
   * It will try to find an address (1) already created by HSM but (2) not yet given to client.
   *   - if     found: returns key backup - FE+iOS should call "AckWalletKeyDownload" before returning Success to user.
   *   - if not found: will queue a request for HSM to create one, and return a user-err - FE+iOS should tell user to
   *     try to same action at a later time.
   *
   * Returns nil if
   * - given wallet's network's "native asset" isn't UTXOBased
   * - Backup isn't required (eg, for non-Porto)
   * - Backup isn't present in the database
   * - Backup hasn't been acknowledged by client as "received"
   *
   * Returns UserVisibleError if
   * - Found no address that's visible to client, and not-taken.
   *
   * This resolver is closely related to the requirement for Address Key Backup prior to an Address being used.
   * Hence it's only applicable to Porto (ADx doesn't require key backup.)
   *
   * See https://anchorinc.slack.com/archives/C07SHN2REF7/p1729522597305459?thread_ts=1729308686.605639&cid=C07SHN2REF7)
   * for more details, but here is how it is supposed to work.
   *
   * There are two flows that can trigger Address Creation:
   * - when user creates a Wallet
   * - when user creates a Pooled Address (UTXO-only: Account-based can only have one address per Wallet)
   *
   * The following description is for Wallet Creation - the same logic/requirement applies to Address Creation
   * (except, no prompt for user to type wallet name).
   *
   * For ADx:
   *   - Shows a screen to type the name of the wallet and then calls "WalletCreate" API.
   *
   * For Porto:
   *   - Queries for WalletKeyBackupBeforeWalletCreation|GetWalletKeyBackupOrCreateNewAddress
   *     -- To know if a backup is required in order to create the next wallet|address
   *   - Queries for walletKeyExportPreference
   *     -- To know what backup method is configured for the org (manual download / via email)
   *   - Calls "AckWalletKeyDownload" API
   *     -- For manual downloads, to let BE know that the user has finished backing up the PDF
   *   - Shows a screen to type the name of the wallet and then calls "WalletCreate" API.
   *
   * See also:
   * - WalletKeyBackupBeforeWalletCreation
   * - WalletKeyBackupBeforeWithdraw
   */
  getWalletKeyBackupOrCreateNewAddress: Maybe<WalletKeyBackup>;
  /** The ID of the Wallet object */
  id: Scalars['ID']['output'];
  interestConfigurationInfo: Maybe<InterestWalletConfigurationInfo>;
  /**
   * isArchived indicates if the wallet has been archived.
   * Archived wallets, by default, will appear in wallet listing APIs (though,
   * caller can override the default filter to get just archived wallets.)
   */
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** The newest restriction of the wallet of any status, if any. */
  lastRestriction: Maybe<RestrictionRecord>;
  /** Name of the Wallet */
  name: Scalars['String']['output'];
  /**
   * namedBalances represent portions of the balance of a wallet that is being used or held for a specific purpose.
   * Set debug to true to enable more logging.
   * @deprecated use assets instead
   */
  namedBalances: Array<NamedBalance>;
  /** networkInfo returns info about which network the wallet is for */
  networkInfo: NetworkInfo;
  /**
   * The number of addresses in this wallet present in the addresses list
   *
   * These values *should* match:
   *   - NumberOfAddresses
   *   - length of Addresses()
   *   - length of BlockchainAddresses()
   */
  numberOfAddresses: Scalars['Int']['output'];
  /** The number of open virtual accounts on this wallet. Zero when the caller cannot see the wallet's vault. */
  numberOfVirtualAccounts: Scalars['Int']['output'];
  /** recommendedBalanceForFee returns the amount of funds recommended to keep in this wallet to cover fees for one transaction. Will return a null value if you already have sufficient balance. */
  recommendedBalanceForFee: Maybe<Amount>;
  /** The ACTIVE restriction of the wallet, if any. */
  restriction: Maybe<RestrictionRecord>;
  /**
   * The shared address group this wallet belongs to — its siblings on other networks
   * and the networks within the same ADC where it can still be activated.
   */
  sharedAddressGroup: Maybe<SharedAddressGroup>;
  /**
   * Whether the wallet's UTXO exclusion controls are locked by a transaction in flight: any execute on
   * the wallet outside the final states, queued and prepared included, together with the operation
   * holding the lock. Null for a wallet on a non-UTXO network, when FO_UTXO_EXCLUSION is off for the
   * organization, and when either cutover flag is off for the organization, where
   * setWalletUtxoExclusion refuses; the client renders the controls enabled in every null case.
   */
  utxoExclusionLock: Maybe<UtxoExclusionLock>;
  /** Vault containing this wallet */
  vault: Vault;
  /**
   * Program customers that own an open virtual account on this wallet, ordered by programCustomerID.
   * searchByName keeps the owners whose name contains it, ignoring case. Empty when the caller cannot see the wallet's vault.
   */
  virtualAccountOwners: VirtualAccountOwnerConnection;
  /**
   * Virtual accounts on this wallet, in a stable order. Closed accounts are listed only when includeClosed is true.
   * filterProgramCustomerIDs takes at most one ID. Empty when the caller cannot see the wallet's vault.
   */
  virtualAccounts: VirtualAccountConnection;
  /** Wallet Deposit Instructions */
  walletDepositInstructions: WalletDepositInstructions;
  /**
   * If this returns a backup, the frontend has to call ackWalletKeyDownload before creating addresses in this wallet
   * @deprecated use getWalletKeyBackupOrCreateNewAddress instead
   */
  walletKeyBackupBeforeAddressCreation: Maybe<WalletKeyBackup>;
  /** If this returns a backup, the frontend has to call ackWalletKeyDownload before withdrawing in this wallet */
  walletKeyBackupBeforeWithdraw: Maybe<WalletKeyBackup>;
  /**
   * List of keys for the wallet
   * This is helpful for debugging, but we probably shouldn't query it in UIs because it's not paginated
   */
  walletKeys: Array<WalletKey>;
  /** walletSubID is an internal ID, exposed for testing purposes. Don't query this in UIs. */
  walletSubID: Scalars['Int']['output'];
  /** Whether a withdrawal can be made or not due to conflicting operations in progress */
  withdrawPossible: Maybe<Scalars['Boolean']['output']>;
};


export type WalletassetsArgs = {
  filterByAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
};


export type WalletbalancesArgs = {
  filterByAssetTypeIDs?: InputMaybe<Array<InputMaybe<Scalars['AssetTypeID']['input']>>>;
};


export type WalletnamedBalancesArgs = {
  debug?: Scalars['Boolean']['input'];
  filterByAssetTypeIDs?: InputMaybe<Array<Scalars['AssetTypeID']['input']>>;
  visibleForPurpose?: InputMaybe<VisibleForPurpose>;
};


export type WalletvirtualAccountOwnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchByName?: InputMaybe<Scalars['String']['input']>;
};


export type WalletvirtualAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterProgramCustomerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Status response for a wallet activation batch job. */
export type WalletActivationBatchJobResponse = {
  __typename: 'WalletActivationBatchJobResponse';
  /** Current status of the activation workflow */
  status: WalletActivationBatchStatus;
  /**
   * IDs of the wallets created by this job.
   * Only populated when status is COMPLETE and the job was started via the V2 workflow path (networkIds input).
   * Returns null for V1 workflows (assetTypeID input) and for any status other than COMPLETE.
   */
  walletsCreated: Maybe<Array<Scalars['ID']['output']>>;
  /** Temporal workflow ID */
  workflowID: Scalars['ID']['output'];
};

/** Response payload for startWalletActivationBatch mutation. */
export type WalletActivationBatchResponse = {
  __typename: 'WalletActivationBatchResponse';
  /** Temporal workflow ID for tracking activation progress */
  workflowID: Scalars['ID']['output'];
};

/** Status of a wallet activation batch workflow. */
export enum WalletActivationBatchStatus {
  CANCELLED = 'CANCELLED',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  UNKNOWN = 'UNKNOWN'
}

/** WalletAmount pairs the wallet holding assets with the corresponding asset amount for an activity item. */
export type WalletAmount = {
  __typename: 'WalletAmount';
  /** The asset amount associated with this wallet for this activity. */
  amount: Amount;
  /**
   * The wallet holding the assets. The GQL monolith resolves full wallet details from the ID.
   * Null when the caller does not own the wallet: amounts are visible but wallet identity is not.
   */
  wallet: Maybe<Wallet>;
};

/** An amount of an asset for a given wallet. Originally used in the context of settlements, but can be used in other contexts. */
export type WalletAmountInput = {
  /** An amount of an asset */
  amount: AmountInput;
  /** The wallet ID */
  walletID: Scalars['ID']['input'];
};

export type WalletBulkCreateJobResponse = {
  __typename: 'WalletBulkCreateJobResponse';
  /**
   * Whether the wallet key backup for this job was handled through the EMAIL
   * delivery channel, i.e. the backup PDF was emailed to the client.
   * Returns null for any status other than COMPLETE.
   * Returns false for wallet activations, because only wallet creations send
   * backup emails.
   * Returns false for non-Porto orgs.
   */
  emailSent: Maybe<Scalars['Boolean']['output']>;
  status: WalletBulkCreateStatus;
  /**
   * Returns the wallet key backups for wallets that were created and not
   * backed up
   * NULL in the following cases:
   *  - The bulk creation job is not finished
   *  - The org is not a Porto org
   *  - All wallets created were already backed up
   * Porto orgs cannot bulk-create wallets yet, so this currently holds at most
   * one backup. It is a list so it can carry one backup per created wallet once
   * Porto bulk creation ships.
   */
  walletKeyBackups: Maybe<Array<WalletKeyBackup>>;
  /**
   * IDs of the wallets created by this job.
   * Only populated when status is COMPLETE and the job was started via the V2 workflow path (networkIds input).
   * Returns null for V1 workflows (assetTypeID input) and for any status other than COMPLETE.
   */
  walletsCreated: Maybe<Array<Scalars['ID']['output']>>;
  workflowID: Scalars['ID']['output'];
};

export type WalletBulkCreateResponse = {
  __typename: 'WalletBulkCreateResponse';
  workflowID: Scalars['ID']['output'];
};

export enum WalletBulkCreateStatus {
  CANCELLED = 'CANCELLED',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  UNKNOWN = 'UNKNOWN'
}

/** Response to a request to approve a WalletConnect session. */
export type WalletConnectApproveSessionResponse = {
  __typename: 'WalletConnectApproveSessionResponse';
  /** True if the request was successful, false otherwise. */
  success: Scalars['Boolean']['output'];
};

/** Response to a request to initialize a WalletConnect session. */
export type WalletConnectInitializeSessionResponse = {
  __typename: 'WalletConnectInitializeSessionResponse';
  /** Session details. */
  session: WalletConnectSession;
  /** True if the request was successful, false otherwise. */
  success: Scalars['Boolean']['output'];
};

/** Response to a request to reject a WalletConnect session. */
export type WalletConnectRejectSessionResponse = {
  __typename: 'WalletConnectRejectSessionResponse';
  /** True if the request was successful, false otherwise. */
  success: Scalars['Boolean']['output'];
};

/** WalletConnectSession */
export type WalletConnectSession = Node & {
  __typename: 'WalletConnectSession';
  /** dApp */
  dApp: DApp;
  /** establishedAt */
  establishedAt: Scalars['Timestamp']['output'];
  /** id identifies the connection/session */
  id: Scalars['ID']['output'];
  /** connection/session status */
  status: WalletConnectSessionStatus;
  /** terminatedAt */
  terminatedAt: Maybe<Scalars['Timestamp']['output']>;
  /**
   * user
   * @deprecated Use userV2 instead
   */
  user: User;
  /** user id */
  userID: Scalars['ID']['output'];
  /** userV2 */
  userV2: UserV2;
  /** wallet */
  wallet: Wallet;
};

/** WalletConnectSessionConnection contains a paginated list of WalletConnectSession's - implements the connections spec for pagination */
export type WalletConnectSessionConnection = {
  __typename: 'WalletConnectSessionConnection';
  /** edges returns a list of WalletConnectSessionEdge objects representing a page of WalletConnectSession data. implements the connections spec for pagination */
  edges: Array<WalletConnectSessionEdge>;
  /** pageInfo returns information about the page returned above. implements the connections spec for pagination */
  pageInfo: PageInfo;
};

/** WalletConnectSessionEdge contains a WalletConnectSession and the cursor representing the same WalletConnectSession - implements the connections spec for pagination */
export type WalletConnectSessionEdge = {
  __typename: 'WalletConnectSessionEdge';
  /** Cursor implements the connections spec for pagination */
  cursor: Scalars['ID']['output'];
  /** node implements the connections spec for pagination */
  node: WalletConnectSession;
};

/**
 * WalletConnectSessionSortField defines the fields to sort a list of WalletConnectSession's by.
 * The enums must each match (case-insensitive) a column in the `walletconnect_dapp_connections` table.
 */
export enum WalletConnectSessionSortField {
  /** ESTABLISHED_AT uses `walletconnect_dapp_connections` table's `established_at` for sorting. */
  ESTABLISHED_AT = 'ESTABLISHED_AT'
}

/** WalletConnect connection/session statuses */
export enum WalletConnectSessionStatus {
  /** connection/session is established */
  ESTABLISHED = 'ESTABLISHED',
  /** connection/session is pending approval */
  PENDING = 'PENDING',
  /** connection/session is terminated */
  TERMINATED = 'TERMINATED',
  /** connection/session is terminating */
  TERMINATING = 'TERMINATING'
}

/** WalletConnection contains a paginated list of Wallets - implements the connections spec for pagination */
export type WalletConnection = {
  __typename: 'WalletConnection';
  /** edges returns a list of WalletEdge objects representing a page of wallets data. implements the connections spec for pagination */
  edges: Array<WalletEdge>;
  /** pageInfo returns information about the page returned above. implements the connections spec for pagination */
  pageInfo: PageInfo;
};

/** Wallet Deposit Instructions */
export type WalletDepositInstructions = BlockchainAddress | DepositInstructions;

/** WalletEdge contains a wallet and the cursor representing the same wallet - implements the connections spec for pagination */
export type WalletEdge = {
  __typename: 'WalletEdge';
  /** Cursor implements the connections spec for pagination */
  cursor: Scalars['ID']['output'];
  /** node implements the connections spec for pagination */
  node: Wallet;
};

/** Represents a wallet entry */
export type WalletEntryInput = {
  /** Amount of the wallet entry */
  amount: Scalars['String']['input'];
  /** AssetTypeID */
  assetTypeID: Scalars['AssetTypeID']['input'];
  /** Balance Type */
  balanceType: Scalars['String']['input'];
  /** Identifier of the wallet entry */
  entryID?: InputMaybe<Scalars['String']['input']>;
  /** Metadata associated with the wallet entry */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** WalletID */
  walletID: WalletInput;
};

/** WalletFilterData contains filter info that can be used to filter on wallet lists. */
export type WalletFilterData = {
  __typename: 'WalletFilterData';
  /**
   * dustThreshold is a numeric number. An asset quantity less than this amount is considered "dust" - ie, not spendable.
   * Note that this value is currently not parameterized on anything such as network, asset, org, etc.
   * That means all networs, asset types, orgs etc. will have the same "dust threshold amount".
   */
  dustThreshold: Scalars['String']['output'];
};

export type WalletInput = {
  /** The network to update the wallet for */
  networkID: Scalars['String']['input'];
  /** Organization key ID */
  organizationKeyID: Scalars['String']['input'];
  /** Vault sub ID */
  vaultSubID: Scalars['Int']['input'];
  /** The wallet sub ID (aka asset sub id) */
  walletSubID: Scalars['Int']['input'];
};

export type WalletKey = {
  __typename: 'WalletKey';
  /** If backup data exists, it's available here */
  backup: Maybe<WalletKeyBackup>;
  /** The path to be used to derive the control child private key to allow this key to be used m/1/2/3 */
  controlKeyDerivationPath: Maybe<Scalars['String']['output']>;
  /** WalletKeyID */
  id: Scalars['ID']['output'];
  /** For Porto orgs, this is true if the backup hasn't been acknowledged through the ackWalletKeyDownload mutation since last time it was re-generated */
  mustAckWalletKeyDownload: Scalars['Boolean']['output'];
  /** The organizationKeyID the info is for */
  orgKeyID: Scalars['ID']['output'];
  /** The wallet ID */
  walletID: Scalars['ID']['output'];
};

/** WalletKeyBackup represents the data associated with a wallet backup. The most important part for the frontend is the URL. The rest is mostly there to make debugging easier. */
export type WalletKeyBackup = {
  __typename: 'WalletKeyBackup';
  /** Used to get the content of the PDF to */
  backupPDFDownloadURL: Scalars['String']['output'];
  /** There may be one or more of these. Only set if the backup strategy is ADMIN_KEYS_QUORUM */
  backupShares: Array<WalletKeyBackupShare>;
  /** Encrypted wallet key. Only set if the backup strategy is WALLET_RECOVERY_KEY */
  shareableEncryptedKey: Maybe<Scalars['String']['output']>;
  /** walletKey backlink */
  walletKey: WalletKey;
};

/** WalletKeyBackupShare holds enough information to allow a user to export all backups for the address */
export type WalletKeyBackupShare = {
  __typename: 'WalletKeyBackupShare';
  /** The share is encrypted to the user's encryptionPublicKey */
  encryptedShare: Scalars['String']['output'];
  /** This is the iOS devices that can decrypt the backup */
  user: User;
};

/** WalletKeyBackupStrategy can be either unset or one of the values below */
export enum WalletKeyBackupStrategy {
  /** ADMIN_KEYS_QUORUM is described in the Porto spec https://www.notion.so/anchorage/Porto-Control-key-key-export-features-d9b433d754234d60a75884007b859477 */
  ADMIN_KEYS_QUORUM = 'ADMIN_KEYS_QUORUM',
  /**
   * WALLET_RECOVERY_KEY strategy, encrypts all wallet keys with a key that's exportable.
   * This allows users to manage their own keys.
   */
  WALLET_RECOVERY_KEY = 'WALLET_RECOVERY_KEY'
}

/** Wallet key PDF export channels */
export enum WalletKeyExportChannel {
  /** local download - browser download(web) / share tab(IOS) */
  DOWNLOAD = 'DOWNLOAD',
  /** email delivery */
  EMAIL = 'EMAIL',
  /** unknown export channel */
  UNKNOWN = 'UNKNOWN'
}

/** WalletKeyExportDownload records information related to local download */
export type WalletKeyExportDownload = WalletKeyExportPreference & {
  __typename: 'WalletKeyExportDownload';
  /** WalletKeyExportChannel.DOWNLOAD */
  deliveryChannel: WalletKeyExportChannel;
};

/** WalletKeyExportEmail records information related to email delivery */
export type WalletKeyExportEmail = WalletKeyExportPreference & {
  __typename: 'WalletKeyExportEmail';
  /** WalletKeyExportChannel.EMAIL */
  deliveryChannel: WalletKeyExportChannel;
  /** The destination email the wallet key will be sent over */
  email: Scalars['String']['output'];
};

/** WalletKeyExportPreference denotes preference how users want their keys to be exported */
export type WalletKeyExportPreference = {
  /** deliveryChannel represents the export channel */
  deliveryChannel: WalletKeyExportChannel;
};

/** WalletKeyExportResult represents the result of the export */
export type WalletKeyExportResult = {
  __typename: 'WalletKeyExportResult';
  /** preference represents the export preference under this result */
  preference: WalletKeyExportPreference;
  /** status represents the export status under this preference */
  success: Scalars['Boolean']['output'];
};

/** WalletKeyExportUnknown records information related to unknown export channel */
export type WalletKeyExportUnknown = WalletKeyExportPreference & {
  __typename: 'WalletKeyExportUnknown';
  /** WalletKeyExportChannel.UNKNOWN */
  deliveryChannel: WalletKeyExportChannel;
};

/** WalletRecoveryKeyShareInfo contains the (user, key share) pair. */
export type WalletRecoveryKeyShareInfo = {
  __typename: 'WalletRecoveryKeyShareInfo';
  /** The timestamp which the key share was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The timestamp which the key share was exported. Nil if the assigned user never exported the share. */
  exportedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The share data string. */
  share: Scalars['String']['output'];
  /** The user assigned to this share. */
  userKey: UserKey;
};

/** Payload response for wallet mutations. */
export type WalletResponsePayload = {
  __typename: 'WalletResponsePayload';
  /** State of the wallet after the mutation */
  wallet: Wallet;
};

/** A staff-curated wallet screening allowlist entry. */
export type WalletScreeningAllowlistEntry = {
  __typename: 'WalletScreeningAllowlistEntry';
  address: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Time']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

/** A paginated set of wallet screening allowlist entries. */
export type WalletScreeningAllowlistEntryConnection = {
  __typename: 'WalletScreeningAllowlistEntryConnection';
  edges: Array<WalletScreeningAllowlistEntryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of entries in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in the wallet screening allowlist connection. */
export type WalletScreeningAllowlistEntryEdge = {
  __typename: 'WalletScreeningAllowlistEntryEdge';
  cursor: Scalars['String']['output'];
  node: WalletScreeningAllowlistEntry;
};

/** WalletSelectorExternalOption is an item in the list of external wallets to be shown in the WalletSelectorStep. */
export type WalletSelectorExternalOption = {
  __typename: 'WalletSelectorExternalOption';
  /** The address object */
  address: BlockchainAddress;
  /** The address name */
  name: Scalars['String']['output'];
};

/** WalletSelectorOption is an item in the list of wallets to be shown in the WalletSelectorStep. */
export type WalletSelectorOption = {
  __typename: 'WalletSelectorOption';
  /** ContingentValue, if present, is the value of a different form input that must match this value for the UI to render this option as enabled */
  contingentValue: Maybe<Scalars['String']['output']>;
  /** An explanation for why the option is disabled, if relevant. */
  disabledHint: Maybe<Scalars['String']['output']>;
  /** Whether or not the option is enabled */
  enabled: Scalars['Boolean']['output'];
  /** The wallet object itself */
  wallet: Wallet;
};

/** WalletSelectorStep represents a step to ask the user to choose a wallet whose ID will be an input to the mutation. */
export type WalletSelectorStep = StakingStep & {
  __typename: 'WalletSelectorStep';
  /** The list of external wallets to be shown */
  externalOptions: Maybe<Array<WalletSelectorExternalOption>>;
  /**
   * Used to instruct the UI the name of the field that should be used to store the user's input for this step.
   * This value must be provided on all input steps when using PrepareGenericOperation
   * It can also be used to instruct the UI to send in a non-default field when using PrepareDelegation, but the string value must exactly match the GQL field name to work.
   * When this value is empty, a default value will be used by the UI based on the staking step type
   */
  fieldName: Maybe<Scalars['String']['output']>;
  /** A hint to show under the selector */
  hint: Maybe<Scalars['String']['output']>;
  /** Ignore this field */
  ignoreMe: Maybe<Scalars['Boolean']['output']>;
  /** Allows the backend to provide info banners to be shown above the step */
  infoItems: Maybe<Array<InfoItem>>;
  /** The text shown in the options list if there are no options */
  noResultsText: Maybe<Scalars['String']['output']>;
  /** The list of wallets to be shown */
  options: Array<WalletSelectorOption>;
  /** Rules that change presentation of the step */
  rules: Maybe<Array<PresentationRule>>;
  /** The title of the step */
  title: Scalars['String']['output'];
};

/**
 * WalletSettlementInstruction holds information about the default wallet settlement
 * instruction per asset and organization. In a first instance this will only be used
 * to populate the settlement instructions for Anchorage Client Settlement FBO Org
 */
export type WalletSettlementInstruction = {
  __typename: 'WalletSettlementInstruction';
  /** Information about the asset for which this instruction is set for */
  asset: AssetTypeInfo;
  /** Displays when the intruction was inserted into the database */
  createdAt: Scalars['Timestamp']['output'];
  /** Displays who inserted the instruction into the database */
  createdBy: Scalars['String']['output'];
  /** Id of the settlement instructions, should be used when deleting, its unique */
  id: Scalars['String']['output'];
  /** Displays when the instruction was last updated */
  updatedAt: Scalars['Timestamp']['output'];
  /** Displays who updated the instruction last */
  updatedBy: Scalars['String']['output'];
  /** Information about the wallet that is set as source and destination instruction */
  wallet: Wallet;
};

/** WalletSortField provides options for sorting wallets */
export enum WalletSortField {
  /**
   * BALANCE_IN_USD is the balance of the wallet in USD.
   * NOTE: this is not yet implemented in backend.
   */
  BALANCE_IN_USD = 'BALANCE_IN_USD',
  /** CREATED_AT sorts wallets by (in this order): created at timestamp, network ID, asset type ID, wallet name, asset sub ID. */
  CREATED_AT = 'CREATED_AT',
  /** NAME sorts wallets by (in this order): wallet name, network ID, asset type ID, asset sub ID. */
  NAME = 'NAME',
  /** NETWORK sorts wallets by (in this order): network ID, wallet name, asset sub ID, wallet unique ID */
  NETWORK = 'NETWORK',
  /**
   * QUANTITY sorts wallet by (in this order): token quantity, network ID, asset type ID, wallet name, asset sub ID.
   * If a wallet contains multiple asset types, only asset with max quantity in the wallet is used for sorting.
   */
  QUANTITY = 'QUANTITY'
}

/**
 * WalletTypeOverride forces the HD-vs-legacy format of a wallet or address,
 * overriding the decision normally driven by the HD-wallets feature flag.
 *
 * This is an E2E-test-only mechanism: passing a non-null value is rejected outside
 * non-production environments. It lets tests create wallets/addresses that are
 * explicitly HD or LEGACY (e.g. for backwards-compatibility coverage or
 * mixed-format UTXO wallets) and keeps working after the feature flag is removed.
 */
export enum WalletTypeOverride {
  /**
   * Force an HD-derived wallet/address, bypassing the feature-flag check. The
   * network must support HD and the vault must have a provisioned xPub, else the
   * request fails.
   */
  HD = 'HD',
  /** Force a legacy (org-derived) wallet/address even when HD is supported. */
  LEGACY = 'LEGACY'
}

/** WalletUtxoExclusionInput names the wallet and the targets to toggle. */
export type WalletUtxoExclusionInput = {
  /**
   * addressSubIDs names whole pooled addresses; each expands to its eligible UTXOs at write
   * time. Mutually exclusive with utxos.
   */
  addressSubIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** utxos names individual UTXOs by txid:vout. Mutually exclusive with addressSubIDs. */
  utxos?: InputMaybe<Array<UtxoInput>>;
  walletID: Scalars['ID']['input'];
};

/** A virtual account on a fiat wallet: a deposit route the wallet's organization gives one program customer. */
export type WalletVirtualAccount = {
  __typename: 'WalletVirtualAccount';
  /** The time the virtual account was closed. Null while it is open. */
  closedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Where to send funds to reach this virtual account. Null while the bank is still provisioning it or while fiat could not render it; retry later. */
  depositInstructions: Maybe<DepositInstructions>;
  /** ID of the virtual account */
  id: Scalars['ID']['output'];
  /** The program customer that owns the virtual account. Null when kyc has no virtual account profile for it. */
  owner: Maybe<VirtualAccountOwner>;
  /** ID of the program customer that owns the virtual account */
  programCustomerID: Scalars['ID']['output'];
  /** Whether the virtual account is open or closed */
  status: VirtualAccountStatus;
  /** ID of the wallet the virtual account belongs to */
  walletID: Scalars['ID']['output'];
};

export type WebhookEndpoint = Node & {
  __typename: 'WebhookEndpoint';
  createdAt: Scalars['Time']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notifications: WebhookNotificationConnection;
  operator: Scalars['String']['output'];
  orgID: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
  subscriptions: WebhookSubscriptionConnection;
  updatedAt: Maybe<Scalars['Time']['output']>;
  url: Scalars['String']['output'];
};


export type WebhookEndpointnotificationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WebhookNotificationWhereInput>;
};


export type WebhookEndpointsubscriptionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WebhookSubscriptionWhereInput>;
};

/** A connection to a list of items. */
export type WebhookEndpointConnection = {
  __typename: 'WebhookEndpointConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WebhookEndpointEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebhookEndpointEdge = {
  __typename: 'WebhookEndpointEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<WebhookEndpoint>;
};

/**
 * WebhookEndpointWhereInput is used for filtering WebhookEndpoint objects.
 * Input was generated by ent.
 */
export type WebhookEndpointWhereInput = {
  and?: InputMaybe<Array<WebhookEndpointWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** notifications edge predicates */
  hasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationsWith?: InputMaybe<Array<WebhookNotificationWhereInput>>;
  /** subscriptions edge predicates */
  hasSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubscriptionsWith?: InputMaybe<Array<WebhookSubscriptionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WebhookEndpointWhereInput>;
  /** operator field predicates */
  operator?: InputMaybe<Scalars['String']['input']>;
  operatorContains?: InputMaybe<Scalars['String']['input']>;
  operatorContainsFold?: InputMaybe<Scalars['String']['input']>;
  operatorEqualFold?: InputMaybe<Scalars['String']['input']>;
  operatorGT?: InputMaybe<Scalars['String']['input']>;
  operatorGTE?: InputMaybe<Scalars['String']['input']>;
  operatorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  operatorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  operatorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  operatorLT?: InputMaybe<Scalars['String']['input']>;
  operatorLTE?: InputMaybe<Scalars['String']['input']>;
  operatorNEQ?: InputMaybe<Scalars['String']['input']>;
  operatorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<WebhookEndpointWhereInput>>;
  /** org_id field predicates */
  orgID?: InputMaybe<Scalars['String']['input']>;
  orgIDContains?: InputMaybe<Scalars['String']['input']>;
  orgIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  orgIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  orgIDGT?: InputMaybe<Scalars['String']['input']>;
  orgIDGTE?: InputMaybe<Scalars['String']['input']>;
  orgIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  orgIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  orgIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  orgIDLT?: InputMaybe<Scalars['String']['input']>;
  orgIDLTE?: InputMaybe<Scalars['String']['input']>;
  orgIDNEQ?: InputMaybe<Scalars['String']['input']>;
  orgIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** public_key field predicates */
  publicKey?: InputMaybe<Scalars['String']['input']>;
  publicKeyContains?: InputMaybe<Scalars['String']['input']>;
  publicKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyGT?: InputMaybe<Scalars['String']['input']>;
  publicKeyGTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  publicKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  publicKeyLT?: InputMaybe<Scalars['String']['input']>;
  publicKeyLTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  publicKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WebhookEvent = Node & {
  __typename: 'WebhookEvent';
  createdAt: Scalars['Time']['output'];
  eventType: Maybe<WebhookEventType>;
  id: Scalars['ID']['output'];
  idempotentID: Scalars['String']['output'];
  notifications: WebhookNotificationConnection;
  payload: Scalars['String']['output'];
};


export type WebhookEventnotificationsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WebhookNotificationWhereInput>;
};

/** A connection to a list of items. */
export type WebhookEventConnection = {
  __typename: 'WebhookEventConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WebhookEventEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebhookEventEdge = {
  __typename: 'WebhookEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<WebhookEvent>;
};

export type WebhookEventType = Node & {
  __typename: 'WebhookEventType';
  createdAt: Scalars['Time']['output'];
  /** TODO: add description */
  description: Maybe<Scalars['String']['output']>;
  events: WebhookEventConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operator: Scalars['String']['output'];
  orgID: Scalars['String']['output'];
  subscriptions: WebhookSubscriptionConnection;
  topic: Scalars['String']['output'];
};


export type WebhookEventTypeeventsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WebhookEventWhereInput>;
};


export type WebhookEventTypesubscriptionsArgs = {
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WebhookSubscriptionWhereInput>;
};

/** A connection to a list of items. */
export type WebhookEventTypeConnection = {
  __typename: 'WebhookEventTypeConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WebhookEventTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebhookEventTypeEdge = {
  __typename: 'WebhookEventTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<WebhookEventType>;
};

/**
 * WebhookEventTypeWhereInput is used for filtering WebhookEventType objects.
 * Input was generated by ent.
 */
export type WebhookEventTypeWhereInput = {
  and?: InputMaybe<Array<WebhookEventTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** events edge predicates */
  hasEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventsWith?: InputMaybe<Array<WebhookEventWhereInput>>;
  /** subscriptions edge predicates */
  hasSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubscriptionsWith?: InputMaybe<Array<WebhookSubscriptionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<WebhookEventTypeWhereInput>;
  /** operator field predicates */
  operator?: InputMaybe<Scalars['String']['input']>;
  operatorContains?: InputMaybe<Scalars['String']['input']>;
  operatorContainsFold?: InputMaybe<Scalars['String']['input']>;
  operatorEqualFold?: InputMaybe<Scalars['String']['input']>;
  operatorGT?: InputMaybe<Scalars['String']['input']>;
  operatorGTE?: InputMaybe<Scalars['String']['input']>;
  operatorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  operatorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  operatorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  operatorLT?: InputMaybe<Scalars['String']['input']>;
  operatorLTE?: InputMaybe<Scalars['String']['input']>;
  operatorNEQ?: InputMaybe<Scalars['String']['input']>;
  operatorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<WebhookEventTypeWhereInput>>;
  /** org_id field predicates */
  orgID?: InputMaybe<Scalars['String']['input']>;
  orgIDContains?: InputMaybe<Scalars['String']['input']>;
  orgIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  orgIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  orgIDGT?: InputMaybe<Scalars['String']['input']>;
  orgIDGTE?: InputMaybe<Scalars['String']['input']>;
  orgIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  orgIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  orgIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  orgIDLT?: InputMaybe<Scalars['String']['input']>;
  orgIDLTE?: InputMaybe<Scalars['String']['input']>;
  orgIDNEQ?: InputMaybe<Scalars['String']['input']>;
  orgIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** topic field predicates */
  topic?: InputMaybe<Scalars['String']['input']>;
  topicContains?: InputMaybe<Scalars['String']['input']>;
  topicContainsFold?: InputMaybe<Scalars['String']['input']>;
  topicEqualFold?: InputMaybe<Scalars['String']['input']>;
  topicGT?: InputMaybe<Scalars['String']['input']>;
  topicGTE?: InputMaybe<Scalars['String']['input']>;
  topicHasPrefix?: InputMaybe<Scalars['String']['input']>;
  topicHasSuffix?: InputMaybe<Scalars['String']['input']>;
  topicIn?: InputMaybe<Array<Scalars['String']['input']>>;
  topicLT?: InputMaybe<Scalars['String']['input']>;
  topicLTE?: InputMaybe<Scalars['String']['input']>;
  topicNEQ?: InputMaybe<Scalars['String']['input']>;
  topicNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * WebhookEventWhereInput is used for filtering WebhookEvent objects.
 * Input was generated by ent.
 */
export type WebhookEventWhereInput = {
  and?: InputMaybe<Array<WebhookEventWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** event_type edge predicates */
  hasEventTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventTypesWith?: InputMaybe<Array<WebhookEventTypeWhereInput>>;
  /** notifications edge predicates */
  hasNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotificationsWith?: InputMaybe<Array<WebhookNotificationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** idempotent_id field predicates */
  idempotentID?: InputMaybe<Scalars['String']['input']>;
  idempotentIDContains?: InputMaybe<Scalars['String']['input']>;
  idempotentIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  idempotentIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  idempotentIDGT?: InputMaybe<Scalars['String']['input']>;
  idempotentIDGTE?: InputMaybe<Scalars['String']['input']>;
  idempotentIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  idempotentIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  idempotentIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotentIDLT?: InputMaybe<Scalars['String']['input']>;
  idempotentIDLTE?: InputMaybe<Scalars['String']['input']>;
  idempotentIDNEQ?: InputMaybe<Scalars['String']['input']>;
  idempotentIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<WebhookEventWhereInput>;
  or?: InputMaybe<Array<WebhookEventWhereInput>>;
  /** payload field predicates */
  payload?: InputMaybe<Scalars['String']['input']>;
  payloadContains?: InputMaybe<Scalars['String']['input']>;
  payloadContainsFold?: InputMaybe<Scalars['String']['input']>;
  payloadEqualFold?: InputMaybe<Scalars['String']['input']>;
  payloadGT?: InputMaybe<Scalars['String']['input']>;
  payloadGTE?: InputMaybe<Scalars['String']['input']>;
  payloadHasPrefix?: InputMaybe<Scalars['String']['input']>;
  payloadHasSuffix?: InputMaybe<Scalars['String']['input']>;
  payloadIn?: InputMaybe<Array<Scalars['String']['input']>>;
  payloadLT?: InputMaybe<Scalars['String']['input']>;
  payloadLTE?: InputMaybe<Scalars['String']['input']>;
  payloadNEQ?: InputMaybe<Scalars['String']['input']>;
  payloadNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WebhookNotification = Node & {
  __typename: 'WebhookNotification';
  attemptCount: Scalars['Int']['output'];
  batchID: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  endpoint: Maybe<WebhookEndpoint>;
  event: Maybe<WebhookEvent>;
  id: Scalars['ID']['output'];
  sendAfter: Scalars['Time']['output'];
  sendingStatus: WebhookNotificationNotificationStatus;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type WebhookNotificationConnection = {
  __typename: 'WebhookNotificationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WebhookNotificationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebhookNotificationEdge = {
  __typename: 'WebhookNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<WebhookNotification>;
};

/** WebhookNotificationNotificationStatus is enum for the field sending_status */
export enum WebhookNotificationNotificationStatus {
  CANCELED = 'CANCELED',
  QUEUED = 'QUEUED',
  SENDING = 'SENDING',
  SENT = 'SENT',
  UNSPECIFIED = 'UNSPECIFIED'
}

/**
 * WebhookNotificationWhereInput is used for filtering WebhookNotification objects.
 * Input was generated by ent.
 */
export type WebhookNotificationWhereInput = {
  and?: InputMaybe<Array<WebhookNotificationWhereInput>>;
  /** attempt_count field predicates */
  attemptCount?: InputMaybe<Scalars['Int']['input']>;
  attemptCountGT?: InputMaybe<Scalars['Int']['input']>;
  attemptCountGTE?: InputMaybe<Scalars['Int']['input']>;
  attemptCountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  attemptCountLT?: InputMaybe<Scalars['Int']['input']>;
  attemptCountLTE?: InputMaybe<Scalars['Int']['input']>;
  attemptCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  attemptCountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** batch_id field predicates */
  batchID?: InputMaybe<Scalars['String']['input']>;
  batchIDContains?: InputMaybe<Scalars['String']['input']>;
  batchIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  batchIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  batchIDGT?: InputMaybe<Scalars['String']['input']>;
  batchIDGTE?: InputMaybe<Scalars['String']['input']>;
  batchIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  batchIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  batchIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  batchIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  batchIDLT?: InputMaybe<Scalars['String']['input']>;
  batchIDLTE?: InputMaybe<Scalars['String']['input']>;
  batchIDNEQ?: InputMaybe<Scalars['String']['input']>;
  batchIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  batchIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** endpoint edge predicates */
  hasEndpoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasEndpointsWith?: InputMaybe<Array<WebhookEndpointWhereInput>>;
  /** event edge predicates */
  hasEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventsWith?: InputMaybe<Array<WebhookEventWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WebhookNotificationWhereInput>;
  or?: InputMaybe<Array<WebhookNotificationWhereInput>>;
  /** send_after field predicates */
  sendAfter?: InputMaybe<Scalars['Time']['input']>;
  sendAfterGT?: InputMaybe<Scalars['Time']['input']>;
  sendAfterGTE?: InputMaybe<Scalars['Time']['input']>;
  sendAfterIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  sendAfterLT?: InputMaybe<Scalars['Time']['input']>;
  sendAfterLTE?: InputMaybe<Scalars['Time']['input']>;
  sendAfterNEQ?: InputMaybe<Scalars['Time']['input']>;
  sendAfterNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** sending_status field predicates */
  sendingStatus?: InputMaybe<WebhookNotificationNotificationStatus>;
  sendingStatusIn?: InputMaybe<Array<WebhookNotificationNotificationStatus>>;
  sendingStatusNEQ?: InputMaybe<WebhookNotificationNotificationStatus>;
  sendingStatusNotIn?: InputMaybe<Array<WebhookNotificationNotificationStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type WebhookSubscription = Node & {
  __typename: 'WebhookSubscription';
  createdAt: Scalars['Time']['output'];
  endpoint: Maybe<WebhookEndpoint>;
  eventType: Maybe<WebhookEventType>;
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WebhookSubscriptionConnection = {
  __typename: 'WebhookSubscriptionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WebhookSubscriptionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebhookSubscriptionEdge = {
  __typename: 'WebhookSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['CursorType']['output'];
  /** The item at the end of the edge. */
  node: Maybe<WebhookSubscription>;
};

/**
 * WebhookSubscriptionWhereInput is used for filtering WebhookSubscription objects.
 * Input was generated by ent.
 */
export type WebhookSubscriptionWhereInput = {
  and?: InputMaybe<Array<WebhookSubscriptionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** endpoint edge predicates */
  hasEndpoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasEndpointsWith?: InputMaybe<Array<WebhookEndpointWhereInput>>;
  /** event_type edge predicates */
  hasEventTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventTypesWith?: InputMaybe<Array<WebhookEventTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WebhookSubscriptionWhereInput>;
  or?: InputMaybe<Array<WebhookSubscriptionWhereInput>>;
};

/** TODO: add description */
export type WebhookValidationKey = {
  __typename: 'WebhookValidationKey';
  /** TODO: add description */
  long: Scalars['String']['output'];
  /** TODO: add description */
  short: Scalars['String']['output'];
};

/** WidgetInteraction indicates the action a user took on a widget */
export enum WidgetInteraction {
  /** A confirmed action has the CTA button clicked on. */
  CONFIRMED = 'CONFIRMED',
  /** A dismissed action was suppressed */
  DISMISSED = 'DISMISSED'
}

/** WidgetType indicates how the front-end should render this widget (e.g. banner, modal) */
export enum WidgetType {
  /** A horizontal banner. Banners cannot be suppressed. */
  HORIZONTAL_BANNER = 'HORIZONTAL_BANNER',
  /** A modal widget takes the full screen and can turn into a carousel */
  MODAL = 'MODAL'
}

/** WireData contains information about a wire transfer and if any standing instructions are associated with it. */
export type WireData = {
  __typename: 'WireData';
  /** Account number of the wire transfer */
  accountNumber: Scalars['String']['output'];
  /** Bank name of the wire transfer */
  bankName: Scalars['String']['output'];
  /** Wire Transfer ID */
  fedID: Scalars['String']['output'];
  /** Memo present in the wire */
  memo: Maybe<Scalars['String']['output']>;
  /** Name of the originator name */
  name: Scalars['String']['output'];
  /** paymentReferences lists the payment identifiers (e.g. fedwire IMAD/OMAD, SWIFT UETR/MIR) */
  paymentReferences: Maybe<Array<PaymentReference>>;
};

/** Represents a returned outbound wire */
export type WireReturnOperation = Operation & {
  __typename: 'WireReturnOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** accountID is the internal bank account this return is tracked under */
  accountID: Scalars['String']['output'];
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount is the restore amount */
  amount: Amount;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /** description is the human readable description the initiator wrote at the time when they created the operation. Can be used to provide more context to the operation. */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** linkedOperationID is the id of the outbound wire operation this return unwinds, once known. Null until it is linked. */
  linkedOperationID: Maybe<Scalars['String']['output']>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /** programCustomerID is the program customer that owns the credited virtual account. Null when the return was not attributed to one. */
  programCustomerID: Maybe<Scalars['String']['output']>;
  /** reason is the bank's free-text reason for the return, when one was given */
  reason: Scalars['String']['output'];
  /** reference is the bank's reference for the return */
  reference: Scalars['String']['output'];
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** virtualAccount resolves the display details of the credited virtual account (owner name, account last-4) from fiat. Null when virtualAccountID is null or the caller may not see the operation's organization. */
  virtualAccount: Maybe<VirtualAccount>;
  /** virtualAccountID is the virtual account this return credited. Null when the return was not attributed to one. */
  virtualAccountID: Maybe<Scalars['String']['output']>;
  /** The wallet associated with this operation */
  wallet: Wallet;
};


/** Represents a returned outbound wire */
export type WireReturnOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** WireStandingInstruction represents a wire standing insctruction (trusted address) */
export type WireStandingInstruction = {
  __typename: 'WireStandingInstruction';
  /** Account Number */
  accountNumber: Scalars['String']['output'];
  /** Beneficiary Address 1 */
  beneficiaryAddress1: Maybe<Scalars['String']['output']>;
  /** Beneficiary Address 2 */
  beneficiaryAddress2: Maybe<Scalars['String']['output']>;
  /** Beneficiary Address 3 */
  beneficiaryAddress3: Maybe<Scalars['String']['output']>;
  /** Beneficiary code */
  beneficiaryCode: Scalars['String']['output'];
  /** Beneficiary Country */
  beneficiaryCountry: Maybe<Scalars['String']['output']>;
  /** Beneficiary Name */
  beneficiaryName: Scalars['String']['output'];
  /** Financial Institution address 1 */
  fiAddress1: Maybe<Scalars['String']['output']>;
  /** Financial Institution address 2 */
  fiAddress2: Maybe<Scalars['String']['output']>;
  /** Financial Institution code */
  fiCode: Scalars['String']['output'];
  /** Financial Institution country */
  fiCountry: Maybe<Scalars['String']['output']>;
  /** Financial Institution ID */
  fiID: Scalars['String']['output'];
  /** Financial Institution name */
  fiName: Scalars['String']['output'];
  /** Intermediate Financial Institution address 1 */
  intermediateAddress1: Maybe<Scalars['String']['output']>;
  /** Intermediate Financial Institution address 2 */
  intermediateAddress2: Maybe<Scalars['String']['output']>;
  /** intermediate Financial Institution code */
  intermediateCode: Maybe<Scalars['String']['output']>;
  /** Intermediate Financial Institution country */
  intermediateCountry: Maybe<Scalars['String']['output']>;
  /** Intermediate Financial Institution ID */
  intermediateID: Maybe<Scalars['String']['output']>;
  /** Intermediate Financial Institution name */
  intermediateName: Maybe<Scalars['String']['output']>;
};

/** WithdrawOperation represents a withdraw operation */
export type WithdrawOperation = Operation & {
  __typename: 'WithdrawOperation';
  /** account that this operation is associated with. Only applicable to vault operations (ex. Withdraw) */
  account: Maybe<Account>;
  /** action is the action that the operation performs, which is generally the same as the operation type */
  action: OperationAction;
  /** amlRecord returns the associated AML record */
  amlRecord: Maybe<AMLRecord>;
  /** amount of the asset being withdrawn */
  amount: Amount;
  /** same as amount but using historical pricing based on the end time of the operation */
  amountAtEndTime: Amount;
  /**
   * amountWithFinalFee is equal to amount + finalFee and is defined only for withdrawals
   * in the completed state where the amount and the fee share the same asset type.
   * Refer to the resolvers `feeSharesAssetTypeWithAmount` and `operationState`.
   */
  amountWithFinalFee: Maybe<Amount>;
  /** same as amountWithFinalFee but using historical pricing based on the end time of the operation */
  amountWithFinalFeeAtEndTime: Maybe<Amount>;
  /** appStatus is the app-facing state of the operation, a simplified version of operationState */
  appStatus: AppStatus;
  /** The asset associated with this operation */
  asset: Asset;
  /** asset id from with the withdrawal was made */
  assetID: AssetID;
  /** Further information regarding this asset type associated with this operation */
  assetTypeInfo: AssetTypeInfo;
  /**
   * Actions available on this operation
   * @deprecated use operationInfo
   */
  availableOperationDecisions: Array<OperationDecision>;
  /**
   * Returns the bio challenge required to pass in order to endorse this operation
   * @deprecated use operationInfo
   */
  bioChallenge: BioChallenge;
  /** canonicalOperationVersion is the version of the canonical withdrawal that must be used to sign this withdrawal */
  canonicalOperationVersion: Scalars['Int']['output'];
  /** clientID returns the id that the client specified, if any, when creating this operation */
  clientID: Maybe<Scalars['String']['output']>;
  /** clientOperationComments is a list of client comments for this operation */
  clientOperationComments: Array<OperationComment>;
  /** confirmations returns how many confirmations the transaction associated with this withdrawal has received */
  confirmations: Maybe<Scalars['Int']['output']>;
  /** createdAt is the time when the operation was initiated */
  createdAt: Scalars['String']['output'];
  /**
   * deductFeeFromAmountIfSameType indicates whether the transaction fee should be deducted from the
   * send amount when the fee and amount share the same asset type.
   * When true, the fee is subtracted from the provided amount. When false or null (default), the fee
   * is added on top of the provided amount.
   */
  deductFeeFromAmountIfSameType: Maybe<Scalars['Boolean']['output']>;
  /** description is the human readable description the initiator wrote at the time when they created the operation */
  description: Scalars['String']['output'];
  /** descriptionEditable indicates whether the description can be edited */
  descriptionEditable: Scalars['Boolean']['output'];
  /**
   * destinationOutputs contains all destination addresses and amounts for multi-destination operations.
   * For single-destination operations, this will contain one element matching receivingBlockchainAddress2.
   * For UTXO-based chains: Contains destination outputs only (change outputs are excluded and tracked separately).
   * For account-based chains: Contains all transfer destinations.
   * Note: Change outputs for UTXO chains are not included here as they return to the sender via a separate deposit event.
   */
  destinationOutputs: Array<TransactionDestination>;
  /** destinationProgramCustomerID is the program customer that owns the credited virtual account. Null when destinationVirtualAccountID is null or that virtual account has no program customer. */
  destinationProgramCustomerID: Maybe<Scalars['String']['output']>;
  /** destinationVirtualAccount resolves that virtual account's display details from fiat. Null when destinationVirtualAccountID is null, when the caller may not see the operation's organization, or when the destination VA belongs to another organization (fiat's tenancy scoping). */
  destinationVirtualAccount: Maybe<VirtualAccount>;
  /** destinationVirtualAccountID is the virtual account this operation credits (internal sends only). Null otherwise. */
  destinationVirtualAccountID: Maybe<Scalars['String']['output']>;
  /** endTime, if non-null is when the operation was completed */
  endTime: Maybe<Scalars['String']['output']>;
  /** endorsements is the list of endorsements for the operation */
  endorsements: Array<SimplifiedEndorsement>;
  /** enforcedPolicy contains all the fragment bindings enforced to this operation */
  enforcedPolicy: Array<PolicyFragmentBinding>;
  /**
   * estimatedTotalAmount is equal to amount + maxFee and is defined only for
   * withdrawals where the amount and the fee share the same asset type.
   */
  estimatedTotalAmount: Maybe<Amount>;
  /** expiration is some measure of when the operation can't be completed any more (TBD) */
  expiration: Scalars['String']['output'];
  /**
   * extraParams are additional asset type specific parameters that were set for this transaction
   * When constructing the canonical operation for signing, the extra params go in the ExtraParams field
   * as a map from asset type id (usually, parent asset type id) to params object. The convention of extra
   * params is to omit all empty fields, and if no extra params are set for an asset type, to omit the asset
   * type from the map entirely. Note that for legacy reasons this convention
   * is the opposite of the normal CanonicalOperation convention, where no fields are ever omitted.
   */
  extraParams: Maybe<ExtraParams>;
  /**
   * feeSharesAssetTypeWithAmount is true if the fee and the amount withdrawn share
   * the same asset type. Returns false otherwise, or if the fee is not known.
   */
  feeSharesAssetTypeWithAmount: Scalars['Boolean']['output'];
  /** final transaction fee charged on top of amount withdrawn, detected on the blockchain */
  finalFee: Maybe<Amount>;
  /** same as finalFee but using historical pricing based on the end time of the operation */
  finalFeeAtEndTime: Maybe<Amount>;
  /**
   * generation is the organization generation this operation was created against
   * @deprecated use operationInfo
   */
  generation: Scalars['Int']['output'];
  /** hasDistress indicates if at least one endorsement has a distress signal */
  hasDistress: Maybe<Scalars['Boolean']['output']>;
  /** id is the unique identifier of the operation, equal to operationID */
  id: Scalars['ID']['output'];
  /**
   * If broadcasting of the operation is taking longer than usual, "impediment" may have descriptive info about why.
   * @deprecated use Operation.OperationInfo.OperationImpediment
   */
  impediment: Maybe<Scalars['String']['output']>;
  /** isAppStatusFinal is true when appStatus is one that indicates the operation has reached a terminal/final state */
  isAppStatusFinal: Scalars['Boolean']['output'];
  /** Is the operation in a state that allows cancelation? */
  isCancelable: Scalars['Boolean']['output'];
  /** Is the operation in a state that allows rejection? */
  isRejectable: Scalars['Boolean']['output'];
  /** max transaction fee charged on top of amount withdrawn */
  maxFee: Maybe<Amount>;
  /** same as maxFee but using historical pricing based on the end time of the operation */
  maxFeeAtEndTime: Maybe<Amount>;
  /** OperationCancelation is the data about When and Who requested cancelation of the operation,. */
  operationCancelation: Maybe<OperationCancelation>;
  /** operationID is the id of the operation */
  operationID: Scalars['String']['output'];
  /** operationInfo is a replacement for the Operation interface in order to deduplicate implementations and re-definitions of the same resolvers for each operation type */
  operationInfo: CommonOperationInfo;
  /** operationState is the current state of the operation as it moves through our system */
  operationState: OperationState;
  /**
   * Organization that this operation belongs to
   * @deprecated use operationInfo
   */
  organization: Organization;
  /**
   * paymentReferences lists the wire payment identifiers (e.g. fedwire IMAD/OMAD, SWIFT UETR/MIR)
   * associated with this withdrawal, when available. Populated for fiat wires only.
   */
  paymentReferences: Maybe<Array<PaymentReference>>;
  /**
   * policy that applies to this operation
   * @deprecated Legacy PolicyMaps. Use 'readPolicy'
   */
  policy: Policy;
  /** programCustomerID is the program customer that owns the debited virtual account. Null when virtualAccountID is null or that virtual account has no program customer. */
  programCustomerID: Maybe<Scalars['String']['output']>;
  /**
   * rawTransaction is the blockchain transaction that must be verified and signed by users
   * @deprecated use rawTransactions for withdrawal v1 signatures
   */
  rawTransaction: Maybe<Scalars['String']['output']>;
  /** rawTransactions are the blockchain transactions that must be signed by users */
  rawTransactions: Array<Scalars['String']['output']>;
  /**
   * readPolicy is the non-signable representation of the policy that applies to this operation
   * @deprecated use operationInfo
   */
  readPolicy: ReadPolicy;
  /**
   * receivingAddress is the address on which a deposit is to be received
   * @deprecated use receivingBlockchainAddress
   */
  receivingAddress: Scalars['String']['output'];
  /** receivingAddressInfo contains any additional info we know about this address (whitelisted, name, etc) */
  receivingAddressInfo: Maybe<ReceivingAddressInfo>;
  /**
   * receivingBlockchainAddress is the address on which a deposit is to be received
   * @deprecated use receivingBlockchainAddress2
   */
  receivingBlockchainAddress: BlockchainAddress;
  /** same as receivingBlockchainAddress but with additional info if using a settlement network participant */
  receivingBlockchainAddress2: BlockchainAddressWithParticipant;
  /** ReceivingFiatTrustedDestination is the trusted destination and fedID */
  receivingFiatTrustedDestination: Maybe<ReceivingFiatTrustedDestination>;
  /**
   * ReceivingStandingInstruction is the standing instruction and fedID
   * @deprecated use receivingFiatTrustedDestination
   */
  receivingStandingInstruction: Maybe<ReceivingStandingInstruction>;
  /** receivingWallet is the wallet that the withdrawal is going to (only present for internal withdrawal) */
  receivingWallet: Maybe<Wallet>;
  /**
   * replayProtectionParams are the parameters to be sent to the HSM for creating and signing
   * the transactions required to effect this WithdrawOperation. The user *is not* expected
   * to review the contents of this field. However it may contain information necessary to prevent
   * replays and must be included in the payload signed by the user. Each element is a hex-encoded
   * byte array.
   */
  replayProtectionParams: Maybe<Scalars['String']['output']>;
  /** Indicates if the current user is required to provide a decision for this operation. */
  requiresDecision: Scalars['Boolean']['output'];
  /** riskAnalysis is the collected risk information for this withdrawal if we have any */
  riskAnalysis: Maybe<TransactionRiskAnalysis>;
  /** sendingBlockchainAddresses are the originating addresses for the withdraw. Fiat assets will have an empty array */
  sendingBlockchainAddresses: Array<BlockchainAddress>;
  /** sendingWallet is the wallet that the withdrawal is coming from */
  sendingWallet: Wallet;
  /** signedTransaction is the blockchain transaction to be broadcast to the network */
  signedTransaction: Maybe<Scalars['String']['output']>;
  /**
   * simpleOperationStateDiagram removes `anchorage review` items if the operation was rejected, and collapses consecutive states
   * with the same state description
   */
  simpleOperationStateDiagram: Array<SimpleStateDiagramItem>;
  /**
   * SLALeft returns how much of the SLA for the operation is left with nanosecond precision
   * The SLA is based on when the operation was created and the clock starts when it enters risk recon for the first time
   * If it hasn't entered risk pending yet, we return nil
   * If it has already expired, we return a negative number
   */
  slaLeft: Maybe<Scalars['String']['output']>;
  /**
   * sources are the originating addresses for the withdraw
   * @deprecated use sendingBlockchainAddresses
   */
  sources: Array<Source>;
  /** transactionID is the blockchain transaction id once available */
  transactionID: Maybe<Scalars['String']['output']>;
  /** transactionSuccess indicates if the blockchain transaction succeeded */
  transactionSuccess: Maybe<Scalars['Boolean']['output']>;
  /** updatedAt is the time the operation was last modified; null when unavailable */
  updatedAt: Maybe<Scalars['String']['output']>;
  /**
   * usdValueWithFee is the sum in USD values of both the principal withdrawal amount and the
   * fee (finalFee if known, otherwise maxFee). If both the finalFee and maxFee are
   * not yet known, this field will be null
   */
  usdValueWithFee: Maybe<Scalars['String']['output']>;
  /** useGasStation if true, the Anchorage gas station was used to pay withdraw fees. */
  useGasStation: Scalars['Boolean']['output'];
  /** viewTransactionLink is the link to get more info about the transaction from a third party */
  viewTransactionLink: Maybe<Scalars['String']['output']>;
  /** virtualAccount resolves the display details of that virtual account (owner name, account last-4) from fiat. Null when virtualAccountID is null or the caller may not see the operation's organization. */
  virtualAccount: Maybe<VirtualAccount>;
  /** virtualAccountID is the virtual account this operation debits. Null when the source is the wallet itself. */
  virtualAccountID: Maybe<Scalars['String']['output']>;
  /**
   * wireConfirmationPDFDownloadURL is the URL to download a PDF confirmation of this wire
   * withdrawal. Null unless this is a complete fiat withdrawal with a buildable URL.
   */
  wireConfirmationPDFDownloadURL: Maybe<Scalars['String']['output']>;
};


/** WithdrawOperation represents a withdraw operation */
export type WithdrawOperationbioChallengeArgs = {
  decision: OperationDecision;
  endorsementBatchID?: InputMaybe<Scalars['String']['input']>;
};


/** WithdrawOperation represents a withdraw operation */
export type WithdrawOperationendorsementsArgs = {
  decision?: InputMaybe<OperationDecision>;
};

/** WorkflowID identifies a Temporal workflow */
export type WorkflowID = {
  __typename: 'WorkflowID';
  /** The identifier of the workflow */
  workflowID: Scalars['String']['output'];
  /** The run identifier of the workflow */
  workflowRunID: Scalars['String']['output'];
};

/** One whole governed parameter set. Every field but imHaircuts is required. */
export type WriteDvVarParametersInput = {
  /**
   * The cut taken on IM collateral per asset. Required on a PFE write, with an
   * entry for BTC, ETH and the base asset of every pair in scope. Refused on a
   * VAR write.
   */
  imHaircuts?: InputMaybe<Array<DvImHaircutInput>>;
  lookbackSteps: Scalars['Int']['input'];
  minObservations: Scalars['Int']['input'];
  model: DvRiskModel;
  /** The asset pairs in scope, as BASE/TERM. */
  pairs: Array<Scalars['String']['input']>;
  parameterisation: Scalars['String']['input'];
  /** Confidence levels as fractions in (0,1), decimal strings. */
  percentiles: Array<Scalars['String']['input']>;
  pnlAsset: Scalars['String']['input'];
  returnKind: Scalars['String']['input'];
  timeStep: Scalars['String']['input'];
  /**
   * The label a Model Owner and Market Risk approval refers to. Unique within
   * the model.
   */
  version: Scalars['String']['input'];
};

/**
 * _commonAmount contains fields common to Amount and UnsupportedAssetAmount types.
 *
 * The interface is meant to ensure that both types implement as many of the same fields as possible.
 */
export type _commonAmount = {
  displayValue: Scalars['String']['output'];
  displayValueInUSD: Scalars['String']['output'];
  displayValueShort: Scalars['String']['output'];
  value: Scalars['String']['output'];
  valueInUSD: Scalars['String']['output'];
};

/**
 * _commonAssetTypeInfo contains fields common to UnsupportedAssetAssetTypeInfo and AssetTypeInfo types.
 *
 * The interface is meant to ensure that both types implement as many of the same fields as possible.
 */
export type _commonAssetTypeInfo = {
  abbreviation: Scalars['String']['output'];
  iconURL: Scalars['String']['output'];
  maxPrecision: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/**
 * _commonAssetTypeInfo contains fields common to UnsupportedAssetAssetTypeInfo and AssetTypeInfo types.
 *
 * The interface is meant to ensure that both types implement as many of the same fields as possible.
 */
export type _commonAssetTypeInfoiconURLArgs = {
  iconType?: IconType;
  size?: Scalars['Int']['input'];
};

/**
 * _commonNetworkInfo contains fields common to UnsupportedAssetNetworkInfo and NetworkInfo types.
 *
 * The interface is meant to ensure that both types implement as many of the same fields as possible.
 */
export type _commonNetworkInfo = {
  name: Scalars['String']['output'];
  networkID: Scalars['ID']['output'];
};

/** Type of collateral management alert */
export enum cmAlertType {
  ACCELERATED_MARGIN_CALL = 'ACCELERATED_MARGIN_CALL',
  CRITICAL = 'CRITICAL',
  CRITICAL_WARNING = 'CRITICAL_WARNING',
  CURE_PERIOD_EXPIRED = 'CURE_PERIOD_EXPIRED',
  DEFAULTED = 'DEFAULTED',
  HEALTHY = 'HEALTHY',
  MARGIN_CALL = 'MARGIN_CALL',
  MARGIN_CALL_WARNING = 'MARGIN_CALL_WARNING',
  MARGIN_RETURN = 'MARGIN_RETURN',
  MARGIN_RETURN_REQUESTED = 'MARGIN_RETURN_REQUESTED'
}

/** inputVaultID is the ID of a vault within an organization */
export type inputVaultID = {
  /** organizationKeyID is the ID of the organization this vault is in */
  organizationKeyID: Scalars['String']['input'];
  /** vaultSubID is the ID of the vault within the organization */
  vaultSubID: Scalars['String']['input'];
};

export type join__ContextArgument = {
  context: Scalars['String']['input'];
  name: Scalars['String']['input'];
  selection: Scalars['join__FieldValue']['input'];
  type: Scalars['String']['input'];
};

export enum join__Graph {
  ACCOUNTING = 'ACCOUNTING',
  ADDRESSRISK = 'ADDRESSRISK',
  ASSETREGISTRY = 'ASSETREGISTRY',
  AUTHORIZATION = 'AUTHORIZATION',
  BILLING = 'BILLING',
  BLOCKCHAIN = 'BLOCKCHAIN',
  BROKERTRANSFER = 'BROKERTRANSFER',
  CLIENTENTITIES = 'CLIENTENTITIES',
  COLLATERALMANAGEMENT = 'COLLATERALMANAGEMENT',
  COMPLIANCEALERTS = 'COMPLIANCEALERTS',
  CUSTODY = 'CUSTODY',
  CUSTODYOPERATIONS = 'CUSTODYOPERATIONS',
  DAPPINTEGRATION = 'DAPPINTEGRATION',
  DEPOSITATTRIBUTION = 'DEPOSITATTRIBUTION',
  EXTERNALACCOUNTS = 'EXTERNALACCOUNTS',
  FIAT = 'FIAT',
  GENERALDELEGATION = 'GENERALDELEGATION',
  GRAPHQLMONOLITH = 'GRAPHQLMONOLITH',
  IDENTITY = 'IDENTITY',
  INTEREST = 'INTEREST',
  IRADOCTRANSFER = 'IRADOCTRANSFER',
  KYC = 'KYC',
  LEDGER = 'LEDGER',
  LEGALTERMS = 'LEGALTERMS',
  MINTBURN = 'MINTBURN',
  NOTIFICATION = 'NOTIFICATION',
  NXT_GRAPH = 'NXT_GRAPH',
  ORGANIZATION = 'ORGANIZATION',
  OTCDERIVATIVES = 'OTCDERIVATIVES',
  OTCDERIVATIVESREPORTING = 'OTCDERIVATIVESREPORTING',
  PRICE = 'PRICE',
  QUORUMLIVENESS = 'QUORUMLIVENESS',
  REPORTING = 'REPORTING',
  RESTRICTIONS = 'RESTRICTIONS',
  RISKRECON = 'RISKRECON',
  RISKREVIEW = 'RISKREVIEW',
  RISKSMARTCONTRACTS = 'RISKSMARTCONTRACTS',
  SCREENING = 'SCREENING',
  SETTLEMENTNETWORK = 'SETTLEMENTNETWORK',
  STABLECOINREWARDS = 'STABLECOINREWARDS',
  STATEMENTS = 'STATEMENTS',
  TAX = 'TAX',
  TRADING = 'TRADING',
  TRADING_TRANSFER_ORCHESTRATOR = 'TRADING_TRANSFER_ORCHESTRATOR',
  WEALTHORCHESTRATOR = 'WEALTHORCHESTRATOR'
}

export enum link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  EXECUTION = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  SECURITY = 'SECURITY'
}

export type subaccountAssetsEdge = {
  __typename: 'subaccountAssetsEdge';
  /** Cursor implements the connections spec */
  cursor: Scalars['ID']['output'];
  /** Represents a SubaccountAssets */
  node: SubaccountAssets;
};

export type tradingGetOrderExecutionReportsInput = {
  afterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  beforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Filter orders without a corresponding client-initiated order. */
  filterMissingParentOrderID?: InputMaybe<Scalars['Boolean']['input']>;
  filterOrderIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  filterSymbol?: InputMaybe<Array<Scalars['String']['input']>>;
  ordStatus?: InputMaybe<Array<OrdStatus>>;
  transactTimeAfterTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  transactTimeBeforeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AffiliatesPendingAttributionsQueryVariables = Exact<{
  affiliateName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  sortField?: InputMaybe<InstitutionalAffiliateSortFields>;
  sortDESC?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AffiliatesPendingAttributionsQuery = { institutionalAffiliates: { __typename: 'InstitutionalAffiliateConnection', pageInfo: { __typename: 'PageInfo', totalResults: number | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string, endCursor: string }, edges: Array<{ __typename: 'InstitutionalAffiliateEdge', cursor: string, node: { __typename: 'InstitutionalAffiliate', affiliateID: string, name: string, crrScoreOutcome: CRRScoreOutcome | null, clientID: string, accounts: Array<{ __typename: 'Account', totalBalance: { __typename: 'Amount', valueInUSD: string }, organization: { __typename: 'Organization', name: string, organizationKeyID: string }, organizations: Array<{ __typename: 'Organization', name: string, organizationKeyID: string }> }>, entities: Array<{ __typename: 'AnchorageEntity', name: string }>, affiliateDepositAttributions: { __typename: 'DepositAttributionConnectionV2', pageInfo: { __typename: 'PageInfo', totalResults: number | null } } } }> } };

export type AffiliatesPendingAttributionsDenaliQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['CursorType']['input']>;
  before?: InputMaybe<Scalars['CursorType']['input']>;
  orderBy?: InputMaybe<KYCProfileOrder>;
}>;


export type AffiliatesPendingAttributionsDenaliQuery = { kyc: { __typename: 'KYC', affiliateKYCProfiles: { __typename: 'AffiliateKYCProfileConnection', pageInfo: { __typename: 'PageInfo', totalResults: number | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string, endCursor: string }, edges: Array<{ __typename: 'AffiliateKYCProfileEdge', cursor: string, node: { __typename: 'AffiliateKYCProfile', id: string, name: string, crrScoreOutcome: CRRScoreOutcome | null, anchorageEntity: { __typename: 'AnchorageEntity', name: string } | null, organizationKYCProfiles: { __typename: 'OrganizationKYCProfileConnection', edges: Array<{ __typename: 'OrganizationKYCProfileEdge', node: { __typename: 'OrganizationKYCProfile', id: string, name: string } }> }, affiliateDepositAttributions: { __typename: 'DepositAttributionConnectionV2', pageInfo: { __typename: 'PageInfo', totalResults: number | null } } } }> } } | null };

export type PendingDepositAttributionsCountCardQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingDepositAttributionsCountCardQuery = { getDepositAttributionsCount: number };

export type UnattributedDepositsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnattributedDepositsQuery = { depositAttributionsV2: { __typename: 'DepositAttributionConnectionV2', pageInfo: { __typename: 'PageInfo', totalResults: number | null }, edges: Array<{ __typename: 'DepositAttributionEdgeV2', node: { __typename: 'DepositAttributionV2', operation: { __typename: 'DepositEventOperation', receivingWallet: { __typename: 'Wallet', vault: { __typename: 'Vault', vaultID: { __typename: 'VaultID', vaultSubID: string } } } | null } } | null } | null> | null } };


export const AffiliatesPendingAttributionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AffiliatesPendingAttributions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"affiliateName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InstitutionalAffiliateSortFields"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDESC"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"institutionalAffiliates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"affiliateName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"affiliateName"}}},{"kind":"Argument","name":{"kind":"Name","value":"pendingDepositAttributions"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortField"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortField"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDESC"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDESC"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affiliateID"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"crrScoreOutcome"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueInUSD"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationKeyID"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationKeyID"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientID"}},{"kind":"Field","name":{"kind":"Name","value":"affiliateDepositAttributions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributionStatusIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AffiliatesPendingAttributionsQuery, AffiliatesPendingAttributionsQueryVariables>;
export const AffiliatesPendingAttributionsDenaliDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AffiliatesPendingAttributionsDenali"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CursorType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CursorType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"KYCProfileOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kyc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affiliateKYCProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"crrScoreOutcome"}},{"kind":"Field","name":{"kind":"Name","value":"anchorageEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationKYCProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"affiliateDepositAttributions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributionStatusIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AffiliatesPendingAttributionsDenaliQuery, AffiliatesPendingAttributionsDenaliQueryVariables>;
export const PendingDepositAttributionsCountCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PendingDepositAttributionsCountCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDepositAttributionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"statusIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING"}]}}]}]}}]} as unknown as DocumentNode<PendingDepositAttributionsCountCardQuery, PendingDepositAttributionsCountCardQueryVariables>;
export const UnattributedDepositsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnattributedDeposits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositAttributionsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributionStatusIn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receivingWallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vaultID"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vaultSubID"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnattributedDepositsQuery, UnattributedDepositsQueryVariables>;
/* eslint-disable */
// @generated

/**
 * THIS FILE IS AUTO GENERATED BY
 * source/js/anchorage/libs/graphql/scripts/generate-graphql-enums-ts.js
 *
 * DO NOT MODIFY DIRECTLY.
 */



/* _commonAmount contains fields common to Amount and UnsupportedAssetAmount types.

The interface is meant to ensure that both types implement as many of the same fields as possible. */
export enum _commonAmountImplementations {
Amount = 'Amount',
/* UnsupportedAssetAmount is similar to Amount but for unsupported assets which can't resolve normal types. */
UnsupportedAssetAmount = 'UnsupportedAssetAmount',
};

/* _commonAssetTypeInfo contains fields common to UnsupportedAssetAssetTypeInfo and AssetTypeInfo types.

The interface is meant to ensure that both types implement as many of the same fields as possible. */
export enum _commonAssetTypeInfoImplementations {
/* Additional information about an asset type */
AssetTypeInfo = 'AssetTypeInfo',
/* UnsupportedAssetAssetTypeInfo is similar to AssetTypeInfo but for unsupported assets which can't resolve normal types. */
UnsupportedAssetAssetTypeInfo = 'UnsupportedAssetAssetTypeInfo',
};

/* _commonNetworkInfo contains fields common to UnsupportedAssetNetworkInfo and NetworkInfo types.

The interface is meant to ensure that both types implement as many of the same fields as possible. */
export enum _commonNetworkInfoImplementations {
/* NetworkInfo contains information about the blockchain network on which assets are traded */
NetworkInfo = 'NetworkInfo',
/* UnsupportedAssetNetworkInfo is similar to NetworkInfo but for unsupported assets which can't resolve normal types. */
UnsupportedAssetNetworkInfo = 'UnsupportedAssetNetworkInfo',
};

/* The Actor interface should be implemented by entities that can change some
state in our platform, initiate operations or actions (e.g., organization change,
transactions, trades, etc). */
export enum ActorImplementations {
/* This type is used to convey that the actor (i.e., initiator) of an
operation/action is an Anchorage employee or process. */
AnchorageActor = 'AnchorageActor',
/* Details about an API key. */
APIKeyV2 = 'APIKeyV2',
/* UnknownActor is used to convey that the initiator of an operation/action
is unknown or there is not a more specific actor type to use. */
UnknownActor = 'UnknownActor',
/* UserKey represents a key that is used in interactive sessions driven by a
human being. */
UserKey = 'UserKey',
/* A user of Anchorage. */
UserV2 = 'UserV2',
};

/* ButtonType represents a type for buttons shown in StakingSteps, all button types must extend this one. */
export enum ButtonImplementations {
/* BooleanButton indicates that the button should be rendered as a boolean switch. */
BooleanButton = 'BooleanButton',
};

/* Simple interface for an error with a message. */
export enum ErrorMessageImplementations {
/* Error occurred when API key has outstanding holds. */
OutstandingHoldsError = 'OutstandingHoldsError',
};

/* IAMMember is a member for a role */
export enum IAMMemberImplementations {
/* Represents a user as a member of a role */
IAMMemberUser = 'IAMMemberUser',
};

/* IAMResource is a resource where we have IAM controls */
export enum IAMResourceImplementations {
Organization = 'Organization',
Vault = 'Vault',
};

/* Key is a interface that shall be implemented by all types that derive/augment
keys. */
export enum KeyImplementations {
/* Details about an API key. */
APIKeyV2 = 'APIKeyV2',
/* UserKey represents a key that is used in interactive sessions driven by a
human being. */
UserKey = 'UserKey',
};

/* KYCProfile interface defines common fields for all KYC profile types.
Implemented by OrganizationKYCProfile, AffiliateKYCProfile, AccountKYCProfile, and RelatedPartyKYCProfile. */
export enum KYCProfileImplementations {
/* AffiliateKYCProfile represents KYC profile data for an affiliate entity */
AffiliateKYCProfile = 'AffiliateKYCProfile',
/* OrganizationKYCProfile represents KYC profile data for an organization entity */
OrganizationKYCProfile = 'OrganizationKYCProfile',
/* RelatedPartyKYCProfile represents KYC profile data for a related party (person or business) */
RelatedPartyKYCProfile = 'RelatedPartyKYCProfile',
};

/* KYCProfileRelation interface defines relationship data common to all KYC profile relations */
export enum KYCProfileRelationImplementations {
/* AffiliateKYCProfileRelation represents the relationship between a related party and an affiliate
This type contains both the affiliate KYC profile and the metadata about their relationship */
AffiliateKYCProfileRelation = 'AffiliateKYCProfileRelation',
/* KYCProfileRelationAuditRole contains the role details for a relationship audit entry.
Implements the existing KYCProfileRelation interface to reuse standard role fields. */
KYCProfileRelationAuditRole = 'KYCProfileRelationAuditRole',
/* RelatedPartyKYCProfileRelation represents the relationship between a client/affiliate and a related party
This type contains both the related party KYC profile and the metadata about their relationship */
RelatedPartyKYCProfileRelation = 'RelatedPartyKYCProfileRelation',
};

/* Node interface defined for objects with a Globally Unique ID. Implemented as defined in the Shopify GraphQL Tutorial, among other places. Reference link: https://github.com/Shopify/graphql-design-tutorial/blob/master/TUTORIAL.md */
export enum NodeImplementations {
AccountConstraint = 'AccountConstraint',
AccountConstraintGroup = 'AccountConstraintGroup',
AccountConstraintState = 'AccountConstraintState',
AccountOrganizations = 'AccountOrganizations',
AccountV2 = 'AccountV2',
/* AddressBalance represents a single balance of a particular assetType held by a particular blockchainAddress */
AddressBalance = 'AddressBalance',
AffiliateAnchorageRelationship = 'AffiliateAnchorageRelationship',
/* A top level affiliate */
AffiliateV2 = 'AffiliateV2',
AnchorageLegalEntity = 'AnchorageLegalEntity',
/* Details about an API key. */
APIKeyV2 = 'APIKeyV2',
/* BlockchainAddress contains information about an Address */
BlockchainAddress = 'BlockchainAddress',
/* Properties of a client order */
ClientOrder = 'ClientOrder',
/* ClientPaymentFlow is a payment flow */
ClientPaymentFlow = 'ClientPaymentFlow',
/* Client settlement */
ClientSettlement = 'ClientSettlement',
CounterpartyScreeningEntry = 'CounterpartyScreeningEntry',
/* CRRScoreDetails contains information related to CRR */
CRRScoreDetails = 'CRRScoreDetails',
DepositAttributionSpamThreshold = 'DepositAttributionSpamThreshold',
/* DepositAttributionV2 represents the process of collecting information about the originator of a deposit */
DepositAttributionV2 = 'DepositAttributionV2',
/* External account. */
ExternalAccount = 'ExternalAccount',
/* An external account location (i.e. bank or institution). */
ExternalAccountLocation = 'ExternalAccountLocation',
/* Transaction on an external account */
ExternalAccountTransaction = 'ExternalAccountTransaction',
ExternalScreeningRequest = 'ExternalScreeningRequest',
GlobalTrustedSource = 'GlobalTrustedSource',
IAMCategory = 'IAMCategory',
/* Represents a user as a member of a role */
IAMMemberUser = 'IAMMemberUser',
IAMPermission = 'IAMPermission',
IAMRole = 'IAMRole',
/* IAMUserAccess represents a user-access relation. */
IAMUserAccess = 'IAMUserAccess',
IAMUserRole = 'IAMUserRole',
/* IndividualAffiliateRelationshipAudit contains information related to an individual affiliate relationship audit */
IndividualAffiliateRelationshipAudit = 'IndividualAffiliateRelationshipAudit',
/* Key represents information about a cryptographic key/key pair. */
KeyInfo = 'KeyInfo',
KYCConfig = 'KYCConfig',
/* KYCProcess is the ent schema for the KYCProcess entity. */
KYCProcess = 'KYCProcess',
/* KYCProcessTrigger is used for configuring the KYC Process Triggers. */
KYCProcessTrigger = 'KYCProcessTrigger',
KYCQuestion = 'KYCQuestion',
/* KYCQuestionnaire is for the KYCQuestionnaire entity. */
KYCQuestionnaire = 'KYCQuestionnaire',
/* KYCQuestionnaireSubmission is for the KYCQuestionnaireSubmission entity. */
KYCQuestionnaireSubmission = 'KYCQuestionnaireSubmission',
/* KYCScreeningRequest represents a KYC screening request entity */
KYCScreeningRequest = 'KYCScreeningRequest',
/* A mint or burn conversion. */
MintBurnConversion = 'MintBurnConversion',
NxtTfcAccount = 'NxtTfcAccount',
NxtTfcCycle = 'NxtTfcCycle',
NxtTfcPosition = 'NxtTfcPosition',
OrganizationModule = 'OrganizationModule',
/* PaymentFlow is a payment flow */
PaymentFlow = 'PaymentFlow',
/* Natural person with a unique government identifier */
Person = 'Person',
/* A scoped policy fragment that may be met in order to perform the scoped action. */
PolicyFragmentBinding = 'PolicyFragmentBinding',
PolicyQuorum = 'PolicyQuorum',
/* ReadPolicy type represents a policy designed exclusively for read operations.
It simplifies the view of policy representations, focusing on read-specific attributes.
It cannot be used for signing purposes. */
ReadPolicy = 'ReadPolicy',
/* ReadQuorum type represents a quorum optimized for read queries.
It cannot be used for signing purposes. */
ReadQuorum = 'ReadQuorum',
Report = 'Report',
ReportDataFilter = 'ReportDataFilter',
ReportDataFilterValue = 'ReportDataFilterValue',
ReportFile = 'ReportFile',
ReportFileEmailDelivery = 'ReportFileEmailDelivery',
ReportFileSftpDelivery = 'ReportFileSftpDelivery',
ReportFileSwiftDelivery = 'ReportFileSwiftDelivery',
ReportFileValidation = 'ReportFileValidation',
ReportFileVerification = 'ReportFileVerification',
ReportSchedule = 'ReportSchedule',
ReportScheduleDataFilter = 'ReportScheduleDataFilter',
ReportScheduleDataFilterValue = 'ReportScheduleDataFilterValue',
ReportScheduleEmailDestination = 'ReportScheduleEmailDestination',
ReportScheduleFileFormats = 'ReportScheduleFileFormats',
ReportScheduleMainFilter = 'ReportScheduleMainFilter',
ReportScheduleSftpDestination = 'ReportScheduleSftpDestination',
ReportScheduleSwiftDestination = 'ReportScheduleSwiftDestination',
ReportTypeDefinition = 'ReportTypeDefinition',
ReportTypeFilterDefinition = 'ReportTypeFilterDefinition',
ReportTypeHeader = 'ReportTypeHeader',
ReportTypeValidation = 'ReportTypeValidation',
/* A participant in the settlement network */
SNParticipant = 'SNParticipant',
SNTwoWaySettlement = 'SNTwoWaySettlement',
/* A stablecoin rewards participant */
StablecoinRewardsParticipant = 'StablecoinRewardsParticipant',
/* Tax Document represents a tax form (1099-DA, 1099-MISC, etc.) issued to an account */
TaxDocument = 'TaxDocument',
/* How operations of one Anchorage type and subtype are reported to TaxBit */
TaxMapping = 'TaxMapping',
/* Represents an individual token swap. */
TokenSwap = 'TokenSwap',
TrustedSourceV2 = 'TrustedSourceV2',
/* A unique device is a device that has been used to login to the system. */
UniqueDevice = 'UniqueDevice',
/* User is deprecated - use UserV2 or UserKey instead. */
User = 'User',
/* UserKey represents a key that is used in interactive sessions driven by a
human being. */
UserKey = 'UserKey',
/* A user of Anchorage. */
UserV2 = 'UserV2',
Vault = 'Vault',
Wallet = 'Wallet',
/* WalletConnectSession */
WalletConnectSession = 'WalletConnectSession',
WebhookEndpoint = 'WebhookEndpoint',
WebhookEvent = 'WebhookEvent',
WebhookEventType = 'WebhookEventType',
WebhookNotification = 'WebhookNotification',
WebhookSubscription = 'WebhookSubscription',
};

/* Operation is the interface for operations. The full interface is owned by the
graphqlmonolith/custody; this subgraph declares the minimal key field so its
mutations can return operations that the router resolves elsewhere. */
export enum OperationImplementations {
/* AddOrganizationOperation represents an operation that bootstraps a brand new organization */
AddOrganizationOperation = 'AddOrganizationOperation',
/* AddTrustedDestinationOperation represents an operation where a user is added to the organization */
AddTrustedDestinationOperation = 'AddTrustedDestinationOperation',
/* AddUserAndPoliciesOperation represents an operation where a user is added to the organization
and its policies */
AddUserAndPoliciesOperation = 'AddUserAndPoliciesOperation',
/* AuthorizeSpenderOperation represents an AuthorizeSpender operation */
AuthorizeSpenderOperation = 'AuthorizeSpenderOperation',
/* Represents a balance adjustment */
BalanceAdjustmentOperation = 'BalanceAdjustmentOperation',
/* ChangeRoleOperation represents an operation to create, update, or delete a role in an organization */
ChangeRoleOperation = 'ChangeRoleOperation',
/* CreateVaultOperation represents an operation where a vault is added to the organization */
CreateVaultOperation = 'CreateVaultOperation',
/* Represents an ACH Debit In: an Anchorage-originated pull from a linked bank account that credits a wallet once the bank settles it */
DebitInOperation = 'DebitInOperation',
/* Represents a return for an Anchorage-originated Debit In pull: Anchorage is ODFI and receives it back, unwinding the original credit */
DebitInReturnOperation = 'DebitInReturnOperation',
/* Represents an ACH Debit Out: a counterparty pulling funds from an Anchorage wallet */
DebitOutOperation = 'DebitOutOperation',
/* Represents a return for a counterparty-originated Debit Out pull: Anchorage is RDFI and files it back to BNY */
DebitOutReturnOperation = 'DebitOutReturnOperation',
/* DelegateOperation represents a delegate operation */
DelegateOperation = 'DelegateOperation',
/* Represents a deposit event */
DepositEventOperation = 'DepositEventOperation',
/* DepositOperation represents a deposit operation */
DepositOperation = 'DepositOperation',
/* DisableVaultOperation represents an operation where a vault is disabled */
DisableVaultOperation = 'DisableVaultOperation',
/* GenericOperation represents a GenericOperation */
GenericOperation = 'GenericOperation',
/* GenericOrgChangeOperation is a generic operation that can be used to perform arbitrary operations on an organization */
GenericOrgChangeOperation = 'GenericOrgChangeOperation',
/* LockOperation represents a Lock operation */
LockOperation = 'LockOperation',
/* OffChainOperation represents an OffChainOperation */
OffChainOperation = 'OffChainOperation',
/* OneOffOperation represents a one-off operation (for example: Edgeware Signaling) */
OneOffOperation = 'OneOffOperation',
/* RemoveTrustedDestinationOperation represents an operation where a user is added to the organization */
RemoveTrustedDestinationOperation = 'RemoveTrustedDestinationOperation',
/* RemoveUserAndPoliciesOperation represents an operation where a user is removed from the organization
and all its policies */
RemoveUserAndPoliciesOperation = 'RemoveUserAndPoliciesOperation',
/* ReplaceUserOperation represents an operation where a user is replaced by another one */
ReplaceUserOperation = 'ReplaceUserOperation',
/* TransferOperation represents a Transfer operation */
TransferOperation = 'TransferOperation',
/* UnlockOperation represents an Unlock operation */
UnlockOperation = 'UnlockOperation',
/* UpdateOrgPoliciesOperation represents an operation where multiple organization policies are updated */
UpdateOrgPoliciesOperation = 'UpdateOrgPoliciesOperation',
/* UpdateVaultPoliciesOperation represents an operation where multiple vault policies are updated */
UpdateVaultPoliciesOperation = 'UpdateVaultPoliciesOperation',
/* VoteOperation represents a Vote operation */
VoteOperation = 'VoteOperation',
/* Represents a returned outbound wire */
WireReturnOperation = 'WireReturnOperation',
/* WithdrawOperation represents a withdraw operation */
WithdrawOperation = 'WithdrawOperation',
};

/* PolicyAction defines an action that can be taken as part of a policy. */
export enum PolicyActionImplementations {
/* QuorumAction defines an action that requires a quorum to be met. */
QuorumAction = 'QuorumAction',
RuleAction = 'RuleAction',
};

/* PresentationRule represents the most basic rule that other rules must extend. */
export enum PresentationRuleImplementations {
/* PresentationRuleDontShowAgain indicates that the step should be skipped by the UI if the UI's local state indicates that the current user has previously checked the box when previously displayed a staking form containing this rule with the same flagIdentifier. */
PresentationRuleDontShowAgain = 'PresentationRuleDontShowAgain',
/* PresentationRuleJustOnceAny indicates that the step should be skipped by the UI if the UI local state indicates that the current user has previously completed any staking form containing this rule with the same flagIdentifier. */
PresentationRuleJustOnce = 'PresentationRuleJustOnce',
};

/* Represents a rule that can be applied to a policy action. */
export enum RuleImplementations {
/* A policy rule with conditions and a polymorphic outcome. */
PolicyRuleV2 = 'PolicyRuleV2',
/* Represents a quorum-based rule. */
QuorumRule = 'QuorumRule',
};

export enum RuleConditionParameterImplementations {
RuleConditionMultiSelectParameter = 'RuleConditionMultiSelectParameter',
RuleConditionNumberParameter = 'RuleConditionNumberParameter',
RuleConditionSelectParameter = 'RuleConditionSelectParameter',
RuleConditionTextParameter = 'RuleConditionTextParameter',
};

/* Represents a user that is in the process of being added to an organization */
export enum StagedUserImplementations {
/* Represents a user that is in the process of being added to an organization */
APIStagedUser = 'APIStagedUser',
/* Represents a user that is in the process of being added to an organization */
AppStagedUser = 'AppStagedUser',
};

/* StakingStep is an abstract step for uniform staking that each Step must extend.
To enable true standardization. Consumers of flows/forms should try to be able to render any combination of steps in the order they're provided. */
export enum StakingStepImplementations {
/* AddressInputStep is a step that allows the user to input a plain blockchain address.

IMPORTANT: This step only currently supports generic operations (prepareGenericOperation) where
the address will be embedded in a JSON payload with a custom field name. It should NOT
be used with prepareDelegation forms, which have a fixed schema. For validator addresses
in prepareDelegation forms, use ValidatorInputStep instead (which maps to the 'destination'
parameter). */
AddressInputStep = 'AddressInputStep',
/* AmountInputStep allows the user to input an arbitrary amount following some type rules.
Number types are typically absolute asset amounts, but can also represent percentages or shares. */
AmountInputStep = 'AmountInputStep',
/* AmountListStep allows the user to see multiple amounts on one screen without being able to edit them. */
AmountListStep = 'AmountListStep',
/* AutoCompoundStep represents a step to ask a user if they want to enable auto-compounding for the positions in this asset. */
AutoCompoundStep = 'AutoCompoundStep',
/* DurationInputStep allows the user to input a duration value. */
DurationInputStep = 'DurationInputStep',
/* InfoStep is a step that allows the backend to display information to the user. */
InfoStep = 'InfoStep',
/* PercentageInputStep allows the user to input a percentage value. */
PercentageInputStep = 'PercentageInputStep',
SelectInputStep = 'SelectInputStep',
/* ValidatorInputStep is step that allows the user to pick a validator address.
This step can be augmented with "favourites", or "recently used". */
ValidatorInputStep = 'ValidatorInputStep',
/* WalletSelectorStep represents a step to ask the user to choose a wallet whose ID will be an input to the mutation. */
WalletSelectorStep = 'WalletSelectorStep',
};

/* Holder for info for token like assets */
export enum TokenInfoImplementations {
/* Token info for an NFT like token */
NftTokenInfo = 'NftTokenInfo',
};

/* WalletKeyExportPreference denotes preference how users want their keys to be exported */
export enum WalletKeyExportPreferenceImplementations {
/* WalletKeyExportDownload records information related to local download */
WalletKeyExportDownload = 'WalletKeyExportDownload',
/* WalletKeyExportEmail records information related to email delivery */
WalletKeyExportEmail = 'WalletKeyExportEmail',
/* WalletKeyExportUnknown records information related to unknown export channel */
WalletKeyExportUnknown = 'WalletKeyExportUnknown',
};


export enum EEAmountUnionTypes  {
Amount = 'Amount',
UnsupportedAssetAmount = 'UnsupportedAssetAmount',
};

export enum EEAssetTypeInfoUnionTypes  {
AssetTypeInfo = 'AssetTypeInfo',
UnsupportedAssetAssetTypeInfo = 'UnsupportedAssetAssetTypeInfo',
};

export enum EENetworkInfoUnionTypes  {
NetworkInfo = 'NetworkInfo',
UnsupportedAssetNetworkInfo = 'UnsupportedAssetNetworkInfo',
};

export enum FiatTrustedDestinationIntructionUnionTypes  {
FiatTrustedDestinationACHPullAuthorization = 'FiatTrustedDestinationACHPullAuthorization',
FiatTrustedDestinationACHPush = 'FiatTrustedDestinationACHPush',
FiatTrustedDestinationInstantTransfer = 'FiatTrustedDestinationInstantTransfer',
FiatTrustedDestinationWire = 'FiatTrustedDestinationWire',
};

/* Operation initiator */
export enum InitiatorUnionTypes  {
APIKey = 'APIKey',
User = 'User',
};

/* Instruction represents the instructions for a standing instruction */
export enum InstructionUnionTypes  {
InstantTransferStandingInstruction = 'InstantTransferStandingInstruction',
WireStandingInstruction = 'WireStandingInstruction',
};

/* OperationField is the union of all the fields shown to the user in the iOS app
This is expressed as a union because some fields are signed and some are not
if the field is a signed field, the app is expected to lookup the content from SignablePayload whereas UnsignedOperationField contains the content directly */
export enum OperationFieldUnionTypes  {
SignedOperationField = 'SignedOperationField',
UnsignedOperationField = 'UnsignedOperationField',
};

/* The fragment that may be met in order to perform the scoped action. */
export enum PolicyFragmentUnionTypes  {
PolicyStructuredFragment = 'PolicyStructuredFragment',
};

/* PolicyResource represents the resource that the policy is applied to. */
export enum PolicyResourceUnionTypes  {
Organization = 'Organization',
Vault = 'Vault',
};

/* Result of a policy write. Branches on whether resources are assigned:
- PolicyV2: returned when the policy is unassigned (resourceIDs empty)
  and the write applied directly.
- PendingPolicyChange: returned when the policy is assigned to one or
  more resources (resourceIDs non-empty) and the change requires quorum
  approval — wraps the produced Operation. */
export enum PolicyV2WriteResultUnionTypes  {
PendingPolicyChange = 'PendingPolicyChange',
PolicyV2 = 'PolicyV2',
};

/* The result of a quote request that captures the individual formats that
individual quotes can take. */
export enum QuoteResultUnionTypes  {
JupiterQuote = 'JupiterQuote',
UniswapClassicQuote = 'UniswapClassicQuote',
UniswapXQuoteV2 = 'UniswapXQuoteV2',
};

/* Resource represents a resource (e.g. Organization, Vault) */
export enum ResourceUnionTypes  {
Organization = 'Organization',
Vault = 'Vault',
};

/* RolePermissionDestinationDetail details an allowed destination for a permission as used by the user interface. */
export enum RolePermissionDestinationDetailUnionTypes  {
AMLBlockchainAddress = 'AMLBlockchainAddress',
TrustedDestination = 'TrustedDestination',
};

export enum RuleConditionComponentArgsUnionTypes  {
TrustedSmartContractMethodArgs = 'TrustedSmartContractMethodArgs',
};

/* One icon source per option. A client that recognizes no member shows no icon. */
export enum RuleConditionParameterOptionIconUnionTypes  {
RuleConditionProductIcon = 'RuleConditionProductIcon',
RuleConditionRemoteIcon = 'RuleConditionRemoteIcon',
};

export enum RuleConditionSentenceElementContentUnionTypes  {
RuleConditionSentenceLiteralElementContent = 'RuleConditionSentenceLiteralElementContent',
RuleConditionSentenceOperatorElementContent = 'RuleConditionSentenceOperatorElementContent',
RuleConditionSentenceParameterElementContent = 'RuleConditionSentenceParameterElementContent',
RuleConditionSentenceTypeElementContent = 'RuleConditionSentenceTypeElementContent',
};

export enum RuleOutcomeUnionTypes  {
BlockOutcome = 'BlockOutcome',
QuorumOutcome = 'QuorumOutcome',
};

/* Settlement instructions union */
export enum SettlementInstructionsUnionTypes  {
SettlementInstructionsCrypto = 'SettlementInstructionsCrypto',
SettlementInstructionsFiat = 'SettlementInstructionsFiat',
};

/* SignedOperationDetails is a union type of all possible forms of extra information for signed fields */
export enum SignedOperationDetailsUnionTypes  {
SignedOperationDetailsAccordion = 'SignedOperationDetailsAccordion',
SignedOperationDetailsAddress = 'SignedOperationDetailsAddress',
SignedOperationDetailsAmount = 'SignedOperationDetailsAmount',
SignedOperationDetailsPreviewLayout = 'SignedOperationDetailsPreviewLayout',
};

/* Action is the action to be taken when the matcher is matched. */
export enum SNActionUnionTypes  {
SNWalletSelectAction = 'SNWalletSelectAction',
};

/* Matcher is the conditions used to determine if the automation should be applied. */
export enum SNMatcherUnionTypes  {
SNCounterPartyAssetMatcher = 'SNCounterPartyAssetMatcher',
};

/* UnsignedOperationDetails is a union type of all possible forms of extra information for unsigned fields */
export enum UnsignedOperationDetailsUnionTypes  {
UnsignedOperationDetailsAddress = 'UnsignedOperationDetailsAddress',
UnsignedOperationDetailsAmount = 'UnsignedOperationDetailsAmount',
UnsignedOperationDetailsDelta = 'UnsignedOperationDetailsDelta',
UnsignedOperationDetailsDivider = 'UnsignedOperationDetailsDivider',
UnsignedOperationDetailsHighlight = 'UnsignedOperationDetailsHighlight',
UnsignedOperationDetailsText = 'UnsignedOperationDetailsText',
UnsignedOperationDetailsTransaction = 'UnsignedOperationDetailsTransaction',
};

/* ValidatorDetail is a generic interface for validator detail */
export enum ValidatorDetailUnionTypes  {
CeloValidatorGroupDetail = 'CeloValidatorGroupDetail',
NonAddressValidatorDetail = 'NonAddressValidatorDetail',
OasisValidatorDetail = 'OasisValidatorDetail',
};

/* VoteDetails is a union type of all possible forms of extra vote information
DEPRECATED: Governance voting is no longer supported. Kept for backward compatibility with historical operations. */
export enum VoteDetailsUnionTypes  {
CeloProposalDetails = 'CeloProposalDetails',
MakerPollDetails = 'MakerPollDetails',
MakerVoteDetails = 'MakerVoteDetails',
};

/* Wallet Deposit Instructions */
export enum WalletDepositInstructionsUnionTypes  {
BlockchainAddress = 'BlockchainAddress',
DepositInstructions = 'DepositInstructions',
};